var quotes = {};
quotes['age'] = [
  {
    "author": "Jonathan Sacks",
    "category": "age",
    "id": 687,
    "text": "Religion is the best antidote to the individualism of the consumer age. The idea that society can do without it flies in the face of history and, now, evolutionary biology."
  },
  {
    "author": "Willa Cather",
    "category": "age",
    "id": 605,
    "text": "Most of the basic material a writer works with is acquired before the age of fifteen."
  },
  {
    "author": "Haile Gebrselassie",
    "category": "age",
    "id": 714,
    "text": "Age for me is just a number."
  },
  {
    "author": "Jonathan Swift",
    "category": "age",
    "id": 370,
    "text": "No man was ever so completely skilled in the conduct of life, as not to receive new information from age and experience."
  },
  {
    "author": "Paulo Coelho",
    "category": "age",
    "id": 190,
    "text": "Publishing is in a kind of Jurassic age."
  },
  {
    "author": "Rowan D. Williams",
    "category": "age",
    "id": 993,
    "text": "In a spiritually sensitive culture, then, it might well be that age is something to be admired or envied."
  },
  {
    "author": "Thomas Carlyle",
    "category": "age",
    "id": 204,
    "text": "It were a real increase of human happiness, could all young men from the age of nineteen be covered under barrels, or rendered otherwise invisible and there left to follow their lawful studies and callings, till they emerged, sadder and wiser, at the age of twenty-five."
  },
  {
    "author": "George Burns",
    "category": "age",
    "id": 290,
    "text": "Nice to be here? At my age it's nice to be anywhere."
  },
  {
    "author": "Michael Stipe",
    "category": "age",
    "id": 857,
    "text": "I've always felt that sexuality is a really slippery thing. In this day and age, it tends to get categorized and labeled, and I think labels are for food. Canned food."
  },
  {
    "author": "Dee Dee Myers",
    "category": "age",
    "id": 595,
    "text": "Study after study confirms that even when you control for variables like profession, education, hours worked, age, marital status, and children, men still are compensated substantially more - even in professions, like nursing, dominated by women. No wonder there's a gender gap."
  },
  {
    "author": "Miuccia Prada",
    "category": "age",
    "id": 719,
    "text": "I hate the idea that you shouldn't wear something just because you're a certain age."
  },
  {
    "author": "Marlee Matlin",
    "category": "age",
    "id": 897,
    "text": "When it comes down to it, it's about who you know, and who's a fan. It's about whether you're the right age, whether you're hot or not, whether the studio is into you or not."
  },
  {
    "author": "Gary Vaynerchuk",
    "category": "age",
    "id": 830,
    "text": "From age 16, I lived and breathed wine. I read every magazine and book about wine."
  },
  {
    "author": "John Burroughs",
    "category": "age",
    "id": 152,
    "text": "To me - old age is always ten years older than I am."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "age",
    "id": 218,
    "text": "Once I planned to write a book of poems entirely about the things in my pocket. But I found it would be too long and the age of the great epics is past."
  },
  {
    "author": "Amos Bronson Alcott",
    "category": "age",
    "id": 69,
    "text": "To keep the heart unwrinkled, to be hopeful, kindly, cheerful, reverent that is to triumph over old age."
  },
  {
    "author": "Edward Weston",
    "category": "age",
    "id": 462,
    "text": "Photography suits the temper of this age - of active bodies and minds. It is a perfect medium for one whose mind is teeming with ideas, imagery, for a prolific worker who would be slowed down by painting or sculpting, for one who sees quickly and acts decisively, accurately."
  },
  {
    "author": "Anthony Horowitz",
    "category": "age",
    "id": 958,
    "text": "I vividly remember being 14. That was the age when I started to get happy: I started being a writer and stopped being a loser."
  },
  {
    "author": "Voltaire",
    "category": "age",
    "id": 27,
    "text": "What most persons consider as virtue, after the age of 40 is simply a loss of energy."
  },
  {
    "author": "David Herbert Lawrence",
    "category": "age",
    "id": 386,
    "text": "Ours is an excessively conscious age. We know so much, we feel so little."
  },
  {
    "author": "Julia Stiles",
    "category": "age",
    "id": 681,
    "text": "I think women get caught up too much in having a plan - 'I'm going to get married at this age I'm going to have a kid at this age' - and then they just try to find a guy who will fit into that picture. I don't want my life to be based on that."
  },
  {
    "author": "W. Somerset Maugham",
    "category": "age",
    "id": 257,
    "text": "Old age has its pleasures, which, though different, are not less than the pleasures of youth."
  },
  {
    "author": "Roger Moore",
    "category": "age",
    "id": 861,
    "text": "I nearly died of double bronchial pneumonia at the age of five."
  },
  {
    "author": "Tori Amos",
    "category": "age",
    "id": 456,
    "text": "You'd think that in this age, especially in the 21st century - especially with all the technology and all the discoveries that we've made - that we would figure out how to tackle abuse."
  },
  {
    "author": "Olivia Munn",
    "category": "age",
    "id": 224,
    "text": "I think women should start to embrace their age. What's the alternative to getting older? You die. I can't change the day I was born. But I can take care of my skin, my body, my mind, and try to live my life and be happy."
  },
  {
    "author": "Rodney Dangerfield",
    "category": "age",
    "id": 143,
    "text": "I'm at the age where food has taken the place of sex in my life. In fact, I've just had a mirror put over my kitchen table."
  },
  {
    "author": "Euripides",
    "category": "age",
    "id": 53,
    "text": "Youth is the best time to be rich, and the best time to be poor."
  },
  {
    "author": "Emily Dickinson",
    "category": "age",
    "id": 50,
    "text": "Old age comes on suddenly, and not gradually as is thought."
  },
  {
    "author": "John Cusack",
    "category": "age",
    "id": 628,
    "text": "There's also some element of coming of age during the Reagan administration, which everybody has painted as some glorious time in America, but I remember as being a very, very dark time. There was apocalypse in the air the punk rock movement made sense."
  },
  {
    "author": "Thomas Frank",
    "category": "age",
    "id": 599,
    "text": "We have become a society that can't self-correct, that can't address its obvious problems, that can't pull out of its nosedive. And so to our list of disasters let us add this fourth entry: we have entered an age of folly that - for all our Facebooking and the twittling tweedle-dee-tweets of the twitterati - we can't wake up from."
  },
  {
    "author": "Joan Jett",
    "category": "age",
    "id": 518,
    "text": "We were really grown up for our age and it was an incredible special band."
  },
  {
    "author": "Bill Cosby",
    "category": "age",
    "id": 14,
    "text": "Like everyone else who makes the mistake of getting older, I begin each day with coffee and obituaries."
  },
  {
    "author": "Janice Dickinson",
    "category": "age",
    "id": 464,
    "text": "I wish I'd gotten sober at a younger age."
  },
  {
    "author": "Tiger Woods",
    "category": "age",
    "id": 452,
    "text": "I'm not as far along as Jack Nicklaus was at this age, but I'm trying."
  },
  {
    "author": "Henry Ford",
    "category": "age",
    "id": 2,
    "text": "Anyone who stops learning is old, whether at twenty or eighty. Anyone who keeps learning stays young. The greatest thing in life is to keep your mind young."
  },
  {
    "author": "Pete Townshend",
    "category": "age",
    "id": 554,
    "text": "We tried not to age, but time had its rage."
  },
  {
    "author": "Liv Tyler",
    "category": "age",
    "id": 235,
    "text": "I cried on my 18th birthday. I thought 17 was such a nice age. You're young enough to get away with things, but you're old enough, too."
  },
  {
    "author": "Russell Means",
    "category": "age",
    "id": 558,
    "text": "I'd like to talk about free markets. Information in the computer age is the last genuine free market left on earth except those free markets where indigenous people are still surviving. And that's basically becoming limited."
  },
  {
    "author": "Mira Nair",
    "category": "age",
    "id": 843,
    "text": "It's only at this age that I can say the word 'art' without flinching."
  },
  {
    "author": "Jon Hamm",
    "category": "age",
    "id": 781,
    "text": "Losing both parents at a young age gave me a sense that you can't really control life - so you'd better live it while it's here. I stopped believing in a storybook existence a long time ago. All you can do is push in a direction and see what comes of it."
  },
  {
    "author": "J. J. Abrams",
    "category": "age",
    "id": 692,
    "text": "We live in an age of instant knowledge. And there's almost a sense of entitlement to that."
  },
  {
    "author": "Lisa Leslie",
    "category": "age",
    "id": 581,
    "text": "Everyone talks about age, but it's not about age. It's about work ethic. Winning never gets old."
  },
  {
    "author": "Chinua Achebe",
    "category": "age",
    "id": 334,
    "text": "I don't care about age very much."
  },
  {
    "author": "Norman Douglas",
    "category": "age",
    "id": 931,
    "text": "You can construct the character of a man and his age not only from what he does and says, but from what he fails to say and do."
  },
  {
    "author": "Delta Goodrem",
    "category": "age",
    "id": 946,
    "text": "The second album was emotionally exhausting and my life felt like it had become very serious at a very young age."
  },
  {
    "author": "Logan P. Smith",
    "category": "age",
    "id": 88,
    "text": "The denunciation of the young is a necessary part of the hygiene of older people, and greatly assists the circulation of the blood."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "age",
    "id": 219,
    "text": "The harvest of old age is the recollection and abundance of blessing previously secured."
  },
  {
    "author": "Daniel Craig",
    "category": "age",
    "id": 635,
    "text": "The idea of regretting not doing this seemed insane to me. Sitting in the corner at a bar at age 60, saying: 'I could've been Bond. Buy me a drink.' That's the saddest place I could be. At least now at 60 I can say: 'I was Bond. Now buy me a drink.'"
  },
  {
    "author": "Charlie Sheen",
    "category": "age",
    "id": 142,
    "text": "I've got volumes on how not to behave. I've got more information now than a guy should have at my age."
  },
  {
    "author": "Iain Duncan Smith",
    "category": "age",
    "id": 696,
    "text": "Work is transformative. It gives you a greater chance of a greater income. You can affect your life while you're of working age, so you have scope and opportunity. Pensioners do not."
  },
  {
    "author": "Jean-Jacques Rousseau",
    "category": "age",
    "id": 381,
    "text": "O love, if I regret the age when one savors you, it is not for the hour of pleasure, but for the one that follows it."
  },
  {
    "author": "Jamie Lee Curtis",
    "category": "age",
    "id": 834,
    "text": "I've been going through photos of my mother, looking back on her life and trying to put it into context. Very few people age gracefully enough to be photographed through their aging."
  },
  {
    "author": "John Legend",
    "category": "age",
    "id": 976,
    "text": "Anybody under the age of forty knows hip-hop, gospel and R&ampB pretty well, and it's all a part of what we consider to be 'black music.' There is a natural synergy between the three."
  },
  {
    "author": "Charlotte Bronte",
    "category": "age",
    "id": 593,
    "text": "Memory in youth is active and easily impressible in old age it is comparatively callous to new impressions, but still retains vividly those of earlier years."
  },
  {
    "author": "Russell Baker",
    "category": "age",
    "id": 338,
    "text": "Children rarely want to know who their parents were before they were parents, and when age finally stirs their curiosity, there is no parent left to tell them."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "age",
    "id": 357,
    "text": "The excess of our youth are checks written against our age and they are payable with interest thirty years later."
  },
  {
    "author": "Puff Daddy",
    "category": "age",
    "id": 770,
    "text": "At an early age, I started my own paper route. Once I saw how you could service people and do a good job and get paid for it, I just wanted to be the best I could be in whatever I did."
  },
  {
    "author": "Mark Twain",
    "category": "age",
    "id": 116,
    "text": "Life would be infinitely happier if we could only be born at the age of eighty and gradually approach eighteen."
  },
  {
    "author": "Ellie Goulding",
    "category": "age",
    "id": 679,
    "text": "I'd like to look like Madonna when I'm her age. I also look at athletes and love their bodies. I've always wanted to be muscly, not skinny. A lot of women yo-yo around, but I'm always aware if I'm getting a bit out of shape. I never look at the scales but I can just tell. It goes on my tum and bum."
  },
  {
    "author": "David Mamet",
    "category": "age",
    "id": 646,
    "text": "Old age and treachery will always beat youth and exuberance."
  },
  {
    "author": "Malcolm Muggeridge",
    "category": "age",
    "id": 627,
    "text": "One of the many pleasures of old age is giving things up."
  },
  {
    "author": "Julie Walters",
    "category": "age",
    "id": 978,
    "text": "It's getting better generally, daily, especially in TV, for women in acting and age and looks count less. As more women come into the business. Change of any sort takes a long time to happen."
  },
  {
    "author": "Kim Cattrall",
    "category": "age",
    "id": 622,
    "text": "I prefer younger men. In some ways, they are much more open to a woman being stronger and independent then some of the men my age."
  },
  {
    "author": "Gore Vidal",
    "category": "age",
    "id": 302,
    "text": "Litigation takes the place of sex at middle age."
  },
  {
    "author": "Billy Joel",
    "category": "age",
    "id": 507,
    "text": "In an age of incompetence, I've been able to last in this crazy business. I actually know how to play my ax and write a song. That's my job."
  },
  {
    "author": "E. Joseph Cossman",
    "category": "age",
    "id": 914,
    "text": "Middle age is when your broad mind and narrow waist begin to change places."
  },
  {
    "author": "Liz Phair",
    "category": "age",
    "id": 725,
    "text": "I wear clothes that most people in the Midwest would probably deem inappropriate at my age. And I rock a bikini all summer long. I know that it's not normal, but I just don't care. I live once."
  },
  {
    "author": "Anna Kendrick",
    "category": "age",
    "id": 920,
    "text": "My parents got married late and they had kids late, so I never felt a social or cultural thing to be married or pregnant or a homeowner by a certain age."
  },
  {
    "author": "Horace Walpole",
    "category": "age",
    "id": 543,
    "text": "I avoid talking before the youth of the age as I would dancing before them: for if one's tongue don't move in the steps of the day, and thinks to please by its old graces, it is only an object of ridicule."
  },
  {
    "author": "Don Marquis",
    "category": "age",
    "id": 540,
    "text": "Of middle age the best that can be said is that a middle-aged person has likely learned how to have a little fun in spite of his troubles."
  },
  {
    "author": "Ben Barnes",
    "category": "age",
    "id": 967,
    "text": "When I was at school, I was in choirs more than anything else, from a very young age, about 9 years old. And then I started taking drum lessons."
  },
  {
    "author": "Edward Koch",
    "category": "age",
    "id": 691,
    "text": "I was born at the age of twelve on a Metro-Goldwyn-Mayer lot."
  },
  {
    "author": "Martha Gellhorn",
    "category": "age",
    "id": 367,
    "text": "Why do people talk of the horrors of old age? It's great. I feel like a fine old car with the parts gradually wearing out, but I'm not complaining,... Those who find growing old terrible are people who haven't done what they wanted with their lives."
  },
  {
    "author": "Bertrand Russell",
    "category": "age",
    "id": 211,
    "text": "Admiration of the proletariat, like that of dams, power stations, and aeroplanes, is part of the ideology of the machine age."
  },
  {
    "author": "Abdul Kalam",
    "category": "age",
    "id": 215,
    "text": "My view is that at a younger age your optimism is more and you have more imagination etc. You have less bias."
  },
  {
    "author": "George Foreman",
    "category": "age",
    "id": 845,
    "text": "I hope to have one more boxing match at the age of 55. Given that demographic at the age of 55 to 65, you've got to make a statement with your life. Otherwise, you are just existing."
  },
  {
    "author": "David Mitchell",
    "category": "age",
    "id": 839,
    "text": "In the 1970s and 1980s there was so little decent fiction for young people, but we're now in a golden age that shows no sign of fading. Philip Pullman, J. K. Rowling, Lemony Snicket are only three of the best known among a good number of equals."
  },
  {
    "author": "Jimmy Buffett",
    "category": "age",
    "id": 406,
    "text": "I'm inspired by people who keep on rolling, no matter their age."
  },
  {
    "author": "William Butler Yeats",
    "category": "age",
    "id": 264,
    "text": "I am of a healthy long lived race, and our minds improve with age."
  },
  {
    "author": "Lydia M. Child",
    "category": "age",
    "id": 981,
    "text": "Childhood itself is scarcely more lovely than a cheerful, kindly, sunshiny old age."
  },
  {
    "author": "Eddie Vedder",
    "category": "age",
    "id": 760,
    "text": "I was living on the wrong side of the tracks in Evanston, Illinois, in a home for boys. We had these Jackson 5 records. I really related to their voices - they were about my age, but they were doing it."
  },
  {
    "author": "Luis Bunuel",
    "category": "age",
    "id": 144,
    "text": "Age is something that doesn't matter, unless you are a cheese."
  },
  {
    "author": "Aung San Suu Kyi",
    "category": "age",
    "id": 648,
    "text": "Even one voice can be heard loudly all over the world in this day and age."
  },
  {
    "author": "Jarvis Cocker",
    "category": "age",
    "id": 842,
    "text": "I always thought that I might retire from any form of sexuality by the age of 40 and just become a dignified older person."
  },
  {
    "author": "William James",
    "category": "age",
    "id": 185,
    "text": "It is well for the world that in most of us, by the age of thirty, the character has set like plaster, and will never soften again."
  },
  {
    "author": "W. Somerset Maugham",
    "category": "age",
    "id": 306,
    "text": "Old age is ready to undertake tasks that youth shirked because they would take too long."
  },
  {
    "author": "Pablo Picasso",
    "category": "age",
    "id": 193,
    "text": "Youth has no age."
  },
  {
    "author": "Courteney Cox",
    "category": "age",
    "id": 846,
    "text": "I think it's hard, the fact that there's a certain age that we can't have kids anymore."
  },
  {
    "author": "Arthur Smith",
    "category": "age",
    "id": 889,
    "text": "I am 54 and age is slowly writing itself on my face."
  },
  {
    "author": "Doris Lessing",
    "category": "age",
    "id": 48,
    "text": "The great secret that all old people share is that you really haven't changed in seventy or eighty years. Your body changes, but you don't change at all. And that, of course, causes great confusion."
  },
  {
    "author": "Emeril Lagasse",
    "category": "age",
    "id": 437,
    "text": "My inspiration was my mom. She's a great cook, and she still cooks, and we still banter back and forth about cooking. Growing up in a mostly Portuguese community, food was important and the family table was extremely important. At a very young age I understood that."
  },
  {
    "author": "Heather Mills",
    "category": "age",
    "id": 873,
    "text": "I don't mind my age."
  },
  {
    "author": "Lois Wyse",
    "category": "age",
    "id": 361,
    "text": "Age becomes reality when you hear someone refer to that attractive young woman standing next to the woman in the green dress, and you find that you're the one in the green dress."
  },
  {
    "author": "Cameron Diaz",
    "category": "age",
    "id": 710,
    "text": "I can't wait to be that age and hanging out with a bunch of people hanging out all day playing golf and going to the beach, all my own age. We'd be laughing and having a good time and getting loopy on our prescription drugs. Driving golf carts around. I can't wait."
  },
  {
    "author": "Agatha Christie",
    "category": "age",
    "id": 11,
    "text": "An archaeologist is the best husband a woman can have. The older she gets the more interested he is in her."
  },
  {
    "author": "Aphra Behn",
    "category": "age",
    "id": 168,
    "text": "Each moment of a happy lover's hour is worth an age of dull and common life."
  },
  {
    "author": "William J. Clinton",
    "category": "age",
    "id": 584,
    "text": "I came of age believing that, no matter what happened, I would always be able to support myself."
  },
  {
    "author": "Queen Latifah",
    "category": "age",
    "id": 545,
    "text": "I was taught from a young age that many people would treat me as a second-class citizen because I was African-American and because I was female."
  },
  {
    "author": "William Shakespeare",
    "category": "age",
    "id": 122,
    "text": "A man loves the meat in his youth that he cannot endure in his age."
  },
  {
    "author": "Bennett Cerf",
    "category": "age",
    "id": 469,
    "text": "Middle age is when your old classmates are so grey and wrinkled and bald they don't recognize you."
  }
]

quotes['alone'] = [
  {
    "author": "Lily Tomlin",
    "category": "alone",
    "id": 1061,
    "text": "Remember we're all in this alone."
  },
  {
    "author": "Thomas B. Macaulay",
    "category": "alone",
    "id": 1683,
    "text": "The object of oratory alone in not truth, but persuasion."
  },
  {
    "author": "Nigel Farage",
    "category": "alone",
    "id": 1580,
    "text": "Perhaps our own opposition to even the level of European integration we have now, let alone any more, is well known."
  },
  {
    "author": "Namie Amuro",
    "category": "alone",
    "id": 1766,
    "text": "Now, on nights that I can't sleep, I play video games alone until the morning."
  },
  {
    "author": "Nora Ephron",
    "category": "alone",
    "id": 1041,
    "text": "The desire to get married, which - I regret to say, I believe is basic and primal in women - is followed almost immediately by an equally basic and primal urge - which is to be single again."
  },
  {
    "author": "Bobby Scott",
    "category": "alone",
    "id": 1852,
    "text": "Each year over 2,500 commercial vessels enter the Port of Hampton Roads alone, so adequate funding for port security is a significant issue for those of us who live in Richmond and Hampton Roads."
  },
  {
    "author": "Gustav Klimt",
    "category": "alone",
    "id": 1658,
    "text": "Whoever wants to know something about me - as an artist which alone is significant - they should look attentively at my pictures and there seek to recognise what I am and what I want."
  },
  {
    "author": "Jules Verne",
    "category": "alone",
    "id": 1380,
    "text": "We were alone. Where, I could not say, hardly imagine. All was black, and such a dense black that, after some minutes, my eyes had not been able to discern even the faintest glimmer."
  },
  {
    "author": "Martha Beck",
    "category": "alone",
    "id": 1063,
    "text": "Absolutely lonely people have few personal interactions of any kind."
  },
  {
    "author": "Sam Houston",
    "category": "alone",
    "id": 1811,
    "text": "I am aware that in presenting myself as the advocate of the Indians and their rights, I shall stand very much alone."
  },
  {
    "author": "Sophie Swetchine",
    "category": "alone",
    "id": 1946,
    "text": "Strength alone knows conflict, weakness is born vanquished."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "alone",
    "id": 1100,
    "text": "I am free because I know that I alone am morally responsible for everything I do. I am free, no matter what rules surround me. If I find them tolerable, I tolerate them if I find them too obnoxious, I break them. I am free because I know that I alone am morally responsible for everything I do."
  },
  {
    "author": "Susan Rice",
    "category": "alone",
    "id": 1892,
    "text": "The U.S. cannot go it alone simply when it is convenient."
  },
  {
    "author": "Daniel Greenberg",
    "category": "alone",
    "id": 1894,
    "text": "But, if you observe children learning in their first few years of life, you can see that they can and do learn on their own - we leave them alone to crawl, walk, talk, and gain control over their bodies. It happens without much help from parents."
  },
  {
    "author": "Ferdinand Marcos",
    "category": "alone",
    "id": 1151,
    "text": "Leadership is the other side of the coin of loneliness, and he who is a leader must always act alone. And acting alone, accept everything alone."
  },
  {
    "author": "Christian Lous Lange",
    "category": "alone",
    "id": 1245,
    "text": "All species capable of grasping this fact manage better in the struggle for existence than those which rely upon their own strength alone: the wolf, which hunts in a pack, has a greater chance of survival than the lion, which hunts alone."
  },
  {
    "author": "Olivier Martinez",
    "category": "alone",
    "id": 1443,
    "text": "And what's more I've got no need for anyone to tell me how to do it. I am not interested. You act how you want to and leave me alone to do my own thing."
  },
  {
    "author": "Thomas Carlyle",
    "category": "alone",
    "id": 1197,
    "text": "Work alone is noble."
  },
  {
    "author": "Nicole Richie",
    "category": "alone",
    "id": 1668,
    "text": "As for style, there is something about the way musicians dress-they seem to be able to create their own world within their fashion alone."
  },
  {
    "author": "Calvin Coolidge",
    "category": "alone",
    "id": 1097,
    "text": "Nothing in this world can take the place of persistence. Talent will not nothing is more common than unsuccessful people with talent. Genius will not unrewarded genius is almost a proverb. Education will not the world is full of educated failures. Persistence and determination alone are omnipotent."
  },
  {
    "author": "Andre Rieu",
    "category": "alone",
    "id": 1949,
    "text": "It is my personality alone that has brought back the waltz and made it a global craze."
  },
  {
    "author": "Theodor Herzl",
    "category": "alone",
    "id": 1934,
    "text": "What We want is to make it possible for our unfortunate people to live a life of industry for it is by steady work alone that we hope for our physical and moral rehabilitation. For this reason above all we have undertaken to rally our people around our ideal."
  },
  {
    "author": "Anne Hathaway",
    "category": "alone",
    "id": 1014,
    "text": "Loneliness is my least favorite thing about life. The thing that I'm most worried about is just being alone without anybody to care for or someone who will care for me."
  },
  {
    "author": "Carre Otis",
    "category": "alone",
    "id": 1721,
    "text": "I delight in my family obligations, but they leave little time for breaks let alone quick trips across the country."
  },
  {
    "author": "Johann Kaspar Lavater",
    "category": "alone",
    "id": 1760,
    "text": "Trust him not with your secrets, who, when left alone in your room, turns over your papers."
  },
  {
    "author": "Thornton Wilder",
    "category": "alone",
    "id": 1433,
    "text": "But there comes a moment in everybody's life when he must decide whether he'll live among the human beings or not - a fool among fools or a fool alone."
  },
  {
    "author": "Henry Cabot Lodge",
    "category": "alone",
    "id": 1851,
    "text": "Our ideal is to make her ever stronger and better and finer, because in that way alone, as we believe, can she be of the greatest service to the world's peace and to the welfare of mankind."
  },
  {
    "author": "Scott Baio",
    "category": "alone",
    "id": 1983,
    "text": "If I lived alone, Mom'd never sleep because she wouldn't know I was okay."
  },
  {
    "author": "Anna Letitia Barbauld",
    "category": "alone",
    "id": 1477,
    "text": "When one by one our ties are torn, and friend from friend is snatched forlorn when man is left alone to mourn, oh! then how sweet it is to die!"
  },
  {
    "author": "Eva Herzigova",
    "category": "alone",
    "id": 1932,
    "text": "I love photo sessions. I'm alone, I'm the queen, everyone's taking care of me."
  },
  {
    "author": "William Gurnall",
    "category": "alone",
    "id": 1793,
    "text": "The devil had as good have let Paul alone, for he no sooner comes into prison but he falls a preaching, at which the gates of Satan's prison fly open, and poor sinners come forth."
  },
  {
    "author": "Tecumseh",
    "category": "alone",
    "id": 1046,
    "text": "Always give a word or sign of salute when meeting or passing a friend, or even a stranger, if in a lonely place."
  },
  {
    "author": "Jean de la Bruyere",
    "category": "alone",
    "id": 1073,
    "text": "All of our unhappiness comes from our inability to be alone."
  },
  {
    "author": "Joseph Gordon-Levitt",
    "category": "alone",
    "id": 1594,
    "text": "Making checklists of things you're looking for in a person is the numero uno thing you can do to guarantee you'll be alone forever."
  },
  {
    "author": "David Cameron",
    "category": "alone",
    "id": 1412,
    "text": "I have no time for those who say there is no way Scotland could go it alone. I know first-hand the contribution Scotland and Scots make to Britain's success - so for me there's no question about whether Scotland could be an independent nation."
  },
  {
    "author": "Leonard Peltier",
    "category": "alone",
    "id": 1305,
    "text": "A political prisoner is someone who is out fighting for his or her people's rights and freedom and is imprisoned for that alone."
  },
  {
    "author": "Tori Spelling",
    "category": "alone",
    "id": 1359,
    "text": "Sometimes, when I'm alone, I put on six inch heels and wear nothing else and dance around in front of the mirror and do my little stripper dance."
  },
  {
    "author": "V. S. Naipaul",
    "category": "alone",
    "id": 1541,
    "text": "The writer is all alone."
  },
  {
    "author": "Marya Mannes",
    "category": "alone",
    "id": 1850,
    "text": "For every five well-adjusted and smoothly functioning Americans, there are two who never had the chance to discover themselves. It may well be because they have never been alone with themselves."
  },
  {
    "author": "Eddie Van Halen",
    "category": "alone",
    "id": 1576,
    "text": "I'm not a rock star. Sure I am, to a certain extent because of the situation, but when kids ask me how it feels to be a rock star, I say leave me alone, I'm not a rock star. I'm not in it for the fame, I'm in it because I like to play."
  },
  {
    "author": "Michelangelo",
    "category": "alone",
    "id": 1326,
    "text": "I cannot live under pressures from patrons, let alone paint."
  },
  {
    "author": "Judith Krantz",
    "category": "alone",
    "id": 1924,
    "text": "On the one hand, shopping is dependable: You can do it alone, if you lose your heart to something that is wrong for you, you can return it it's instant gratification and yet something you buy may well last for years."
  },
  {
    "author": "Chris Hemsworth",
    "category": "alone",
    "id": 1622,
    "text": "I'm not into watching stuff I did last week, let alone three or four years ago."
  },
  {
    "author": "Daniel Day-Lewis",
    "category": "alone",
    "id": 1430,
    "text": "Where I come from, it was a heresy to say you wanted to be in movies, leave alone American movies."
  },
  {
    "author": "William Blackstone",
    "category": "alone",
    "id": 1711,
    "text": "Men was formed for society, and is neither capable of living alone, nor has the courage to do it."
  },
  {
    "author": "Arnold Rothstein",
    "category": "alone",
    "id": 1065,
    "text": "Don't go away. I don't want to be alone. I can't stand being alone."
  },
  {
    "author": "Demetri Martin",
    "category": "alone",
    "id": 1368,
    "text": "I think it's interesting that 'cologne' rhymes with 'alone.'"
  },
  {
    "author": "Elizabeth Berkley",
    "category": "alone",
    "id": 1887,
    "text": "Having gone through so many of the personal things I've gone through, its about creating an (online) space for girls to be heard. I don't profess to have all the answers. But Ask Elizabeth is a space where girls are not alone."
  },
  {
    "author": "Jodi Picoult",
    "category": "alone",
    "id": 1647,
    "text": "I know that books I have written will still resonate in 50 years - particularly 'My Sister's Keeper.' It has sold three million copies in the States alone. I strongly feel that, as a novelist, you have a platform and the ability to change people's minds."
  },
  {
    "author": "Orville Redenbacher",
    "category": "alone",
    "id": 1960,
    "text": "It proved easier to buy the farm to get the mineral rights than to buy the coal rights alone."
  },
  {
    "author": "Wallace Stevens",
    "category": "alone",
    "id": 1509,
    "text": "It is the unknown that excites the ardor of scholars, who, in the known alone, would shrivel up with boredom."
  },
  {
    "author": "William O. Douglas",
    "category": "alone",
    "id": 1592,
    "text": "The right to be let alone is indeed the beginning of all freedoms."
  },
  {
    "author": "Harry Emerson Fosdick",
    "category": "alone",
    "id": 1728,
    "text": "Picture yourself vividly as winning, and that alone will contribute immeasurably to success."
  },
  {
    "author": "David Hume",
    "category": "alone",
    "id": 1424,
    "text": "Belief is nothing but a more vivid, lively, forcible, firm, steady conception of an object, than what the imagination alone is ever able to attain."
  },
  {
    "author": "Robert Browning",
    "category": "alone",
    "id": 1504,
    "text": "Finds progress, man's distinctive mark alone, Not God's, and not the beast's God is, they are, Man partly is, and wholly hopes to be."
  },
  {
    "author": "J. J. Abrams",
    "category": "alone",
    "id": 1626,
    "text": "I try to push ideas away, and the ones that will not leave me alone are the ones that ultimately end up happening."
  },
  {
    "author": "Steve Martin",
    "category": "alone",
    "id": 1303,
    "text": "Throughout my whole life, as a performer, I've never played with a band. I've always played alone, so I was never required to stay in rhythm or anything. So it was a real different experience for me to start playing with a band. There were so many basic things for me to learn."
  },
  {
    "author": "Hubert H. Humphrey",
    "category": "alone",
    "id": 1188,
    "text": "This, then, is the test we must set for ourselves not to march alone but to march in such a way that others will wish to join us."
  },
  {
    "author": "Hilaire Belloc",
    "category": "alone",
    "id": 1744,
    "text": "Is there no Latin word for Tea? Upon my soul, if I had known that I would have let the vulgar stuff alone."
  },
  {
    "author": "Adam Levine",
    "category": "alone",
    "id": 1600,
    "text": "I'm fiercely independent, but I'm also terrified of being alone."
  },
  {
    "author": "Martin Luther",
    "category": "alone",
    "id": 1132,
    "text": "God writes the Gospel not in the Bible alone, but also on trees, and in the flowers and clouds and stars."
  },
  {
    "author": "Bede Griffiths",
    "category": "alone",
    "id": 1938,
    "text": "I think the Mother is gradually revealing itself to me and taking over. But it is not the Mother alone. It is the Mother and the Father, the male and the female, sort of gradually having their marriage."
  },
  {
    "author": "Charles Stanley",
    "category": "alone",
    "id": 1171,
    "text": "Too many Christians have a commitment of convenience. They'll stay faithful as long as it's safe and doesn't involve risk, rejection, or criticism. Instead of standing alone in the face of challenge or temptation, they check to see which way their friends are going."
  },
  {
    "author": "Susan Wojcicki",
    "category": "alone",
    "id": 1875,
    "text": "I have tried to be a leader. I have tried in my role of being one of the first women at Google, let alone the first woman to have a baby, to really try to set the tone that this is a great place to work for diversity reasons."
  },
  {
    "author": "Oscar Levant",
    "category": "alone",
    "id": 1476,
    "text": "Schizophrenia beats dining alone."
  },
  {
    "author": "Scipio Africanus",
    "category": "alone",
    "id": 1616,
    "text": "I'm never less at leisure than when at leisure, or less alone than when alone."
  },
  {
    "author": "Octavio Paz",
    "category": "alone",
    "id": 1062,
    "text": "Solitude is the profoundest fact of the human condition. Man is the only being who knows he is alone."
  },
  {
    "author": "Hamad bin Isa Al Khalifa",
    "category": "alone",
    "id": 1868,
    "text": "By being friends with all, we are not alone."
  },
  {
    "author": "Liza Minnelli",
    "category": "alone",
    "id": 1701,
    "text": "What good is sitting all alone in your room?"
  },
  {
    "author": "Wayne Coyne",
    "category": "alone",
    "id": 1274,
    "text": "Music is amazing. There's some metaphysical comfort where it allows you to be isolated and alone while telling you that you are not alone... truly, the only cure for sadness is to share it with someone else."
  },
  {
    "author": "Phyllis McGinley",
    "category": "alone",
    "id": 1860,
    "text": "Sisters are always drying their hair. Locked into rooms, alone, they pose at the mirror, shoulders bare, trying this way and that their hair, or fly importunate down the stair to answer the telephone."
  },
  {
    "author": "K. D. Lang",
    "category": "alone",
    "id": 1813,
    "text": "You have to respect your audience. Without them, you're essentially standing alone, singing to yourself."
  },
  {
    "author": "Charles Lindbergh",
    "category": "alone",
    "id": 1064,
    "text": "Is he alone who has courage on his right hand and faith on his left hand?"
  },
  {
    "author": "Jack Nicholson",
    "category": "alone",
    "id": 1275,
    "text": "Early on, if I was alone two three nights in a row, I'd start writing poems about suicide."
  },
  {
    "author": "Arthur Erickson",
    "category": "alone",
    "id": 1512,
    "text": "With production alone as the goal, industry in North America was dominated by the assembly line, standardization for mass consumption."
  },
  {
    "author": "Jean-Paul Sartre",
    "category": "alone",
    "id": 1019,
    "text": "If you are lonely when you're alone, you are in bad company."
  },
  {
    "author": "Kenny Chesney",
    "category": "alone",
    "id": 1715,
    "text": "You'd think I'd have been happiest in my life playing music in front of 50,000 people at Gillette Stadium. But let me tell you, it's an odd feeling to feel alone in the spotlight."
  },
  {
    "author": "Joichi Ito",
    "category": "alone",
    "id": 1958,
    "text": "I talked about the barriers created by monopolies. I said that it was the role of government to break up these monopolies and that we couldn't do it alone."
  },
  {
    "author": "Spencer Bachus",
    "category": "alone",
    "id": 1822,
    "text": "Shockingly, a University of Pennsylvania study says the number of young people addicted to gambling - largely due to increased exposure to the Internet and Internet gambling - grew by an alarming 20 percent between 2004 and 2005 alone."
  },
  {
    "author": "Anthony Holden",
    "category": "alone",
    "id": 1839,
    "text": "I mean Buckingham Palace has never hired a professional public relations outfit let alone a Madison Avenue type and they would throw up their hands in horror at the very idea."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "alone",
    "id": 1195,
    "text": "All conservatism is based upon the idea that if you leave things alone you leave them as they are. But you do not. If you leave a thing alone you leave it to a torrent of change."
  },
  {
    "author": "Paul Kane",
    "category": "alone",
    "id": 1393,
    "text": "The most terrifying thing I can think of is being alone - and I mean utterly alone, like no one else in the world alone - at night. That's the nucleus of the first story in my collection and it's also where the title came from for the book."
  },
  {
    "author": "Danny DeVito",
    "category": "alone",
    "id": 1828,
    "text": "I don't know. I think it's funny! I think it's funny! I go, what? It's so absurd. I'm alone."
  },
  {
    "author": "Maria Mitchell",
    "category": "alone",
    "id": 1633,
    "text": "I was a little doubtful about the propriety of going to the Mammoth Cave without a gentleman escort, but if two ladies travel alone they must have the courage of men."
  },
  {
    "author": "Winona Ryder",
    "category": "alone",
    "id": 1481,
    "text": "Weird people follow you in the streets, you can't sit alone in a restaurant or a cafe and read a book in peace, and I think everybody values those moments of being alone."
  },
  {
    "author": "Pope John XXIII",
    "category": "alone",
    "id": 1256,
    "text": "The true and solid peace of nations consists not in equality of arms, but in mutual trust alone."
  },
  {
    "author": "Bell Hooks",
    "category": "alone",
    "id": 1488,
    "text": "I thought about how we need to make children feel that there are times in their lives when they need to be alone and quiet and to be able to accept their aloneness."
  },
  {
    "author": "Helen Keller",
    "category": "alone",
    "id": 1000,
    "text": "Alone we can do so little together we can do so much."
  },
  {
    "author": "Pamela Stephenson",
    "category": "alone",
    "id": 1710,
    "text": "So many people suffer from abuse, and suffer alone."
  },
  {
    "author": "Alonzo Mourning",
    "category": "alone",
    "id": 1815,
    "text": "There's nobody else on the face of this earth that's playing a sport at a highest level... with a transplant. That alone continues to inspire me, because I realize throughout the whole world the struggles that people are going through. I need to inspire them the best way I can."
  },
  {
    "author": "Charles Eastman",
    "category": "alone",
    "id": 1925,
    "text": "That is, we believed, the supreme duty of the parent, who only was permitted to claim in some degree the priestly office and function, since it is his creative and protecting power which alone approaches the solemn function of Deity."
  },
  {
    "author": "Thomas Browne",
    "category": "alone",
    "id": 1071,
    "text": "Be able to be alone. Lose not the advantage of solitude, and the society of thyself."
  },
  {
    "author": "Whitney Houston",
    "category": "alone",
    "id": 1189,
    "text": "When I decided to be a singer, my mother warned me I'd be alone a lot. Basically we all are. Loneliness comes with life."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "alone",
    "id": 1216,
    "text": "It is great folly to wish to be wise all alone."
  },
  {
    "author": "Alanis Morissette",
    "category": "alone",
    "id": 1371,
    "text": "When I was producing on my own, I was doing it in order to - in a very patriarchal entertainment industry, let alone planet - very much hell-bent on trying to prove to myself, if nothing else, that I could do it as a woman."
  },
  {
    "author": "Paul Theroux",
    "category": "alone",
    "id": 1637,
    "text": "It's only when you're alone that you realize where you are. You have nothing to fall back on except your own resources."
  },
  {
    "author": "Hank Azaria",
    "category": "alone",
    "id": 1801,
    "text": "In my cranky old age, I actually prefer recording alone now, on 'The Simpsons,' for example, because I find that the director can just focus on what I'm doing and I can do a lot of variations. A lot of times, when I record with a group, I'll stay after class for another hour or two."
  },
  {
    "author": "Edward Sapir",
    "category": "alone",
    "id": 1879,
    "text": "Human beings do not live in the objective world alone, nor alone in the world of social activity as ordinarily understood, but are very much at the mercy of the particular language which has become the medium of expression for their society."
  },
  {
    "author": "Max Muller",
    "category": "alone",
    "id": 1316,
    "text": "And then when all around grows dark, when we feel utterly alone, when all men right and left pass us by and know us not, a forgotten feeling rises in the breast."
  },
  {
    "author": "Itzhak Perlman",
    "category": "alone",
    "id": 1951,
    "text": "For people who are really talented, what you don't say becomes extremely important. You have to judge what to say and what to leave alone so you can let the talent develop."
  }
]

quotes['amazing'] = [
  {
    "author": "Chris Frantz",
    "category": "amazing",
    "id": 2829,
    "text": "I remember going for the first time to a place called The Roxy in New York because you can see people breakdancing there. That's the only reason I went! It's amazing, kids are still doing that."
  },
  {
    "author": "Trey Anastasio",
    "category": "amazing",
    "id": 2419,
    "text": "It was amazing and inspiring to see so many people come together through music to aid the great state of Vermont."
  },
  {
    "author": "Alison Sweeney",
    "category": "amazing",
    "id": 2246,
    "text": "Spinning has been such an amazing part of my exercise. I love the music, the energy, and the sweat. It's a tough class, which makes me feel like I've really accomplished something. It's a great way to burn fat and lean out the body. An all-around win!"
  },
  {
    "author": "Shay Mitchell",
    "category": "amazing",
    "id": 2349,
    "text": "After I finished high school I went to Hong Kong and Thailand and spent some time there. Just to get that whole experience of being out of the bubble that I was in from high school in Vancouver, to be able to travel around and be on your own was an amazing experience."
  },
  {
    "author": "Ian Mckellen",
    "category": "amazing",
    "id": 2535,
    "text": "When we'd suggested doing it, the Theatre Royal management had said, 'Nobody wants to see Waiting for Godot.' As it happened, every single ticket was booked for every single performance, and this confirmation that our judgment was right was sweet. Audiences came to us from all over the world. It was amazing."
  },
  {
    "author": "Suzanne Collins",
    "category": "amazing",
    "id": 2907,
    "text": "It's amazing to see things that are suggested in the book fully developed and so brilliantly realized through the artistry of the designers."
  },
  {
    "author": "Mark Zuckerberg",
    "category": "amazing",
    "id": 2071,
    "text": "I mean, we've built a lot of products that we think are good, and will help people share photos and share videos and write messages to each other. But it's really all about how people are spreading Facebook around the world in all these different countries. And that's what's so amazing about the scale that it's at today."
  },
  {
    "author": "Lea Michele",
    "category": "amazing",
    "id": 2266,
    "text": "I'm overjoyed and beyond honored to be a part of the L'Oreal Paris family. I'm such a fan of L'Oreal Paris not just for all of their amazing products, but for what they stand for."
  },
  {
    "author": "Majel Barrett",
    "category": "amazing",
    "id": 2877,
    "text": "You go through at least the first two years of Star Trek and you find some amazing stuff. Everything that was going on Gene put into the series. He just put strange costumes on the actors and painted them funny colours and left the same situation in."
  },
  {
    "author": "Sara Paxton",
    "category": "amazing",
    "id": 2623,
    "text": "I love watching amazing actors and actresses that you can't take your eyes off of because everything they are doing - even if it is just twiddling their thumbs or scratching their eye - it's just interesting."
  },
  {
    "author": "Adam Derek Scott",
    "category": "amazing",
    "id": 2935,
    "text": "It is amazing that it is my destiny to be the first Aussie to win the Masters."
  },
  {
    "author": "Daniel Craig",
    "category": "amazing",
    "id": 2025,
    "text": "As a kid, I kind of spent my life being amazed by being tricked. I love being tricked. I still love it today."
  },
  {
    "author": "Toby Jones",
    "category": "amazing",
    "id": 2479,
    "text": "If you ever have the good fortune to meet Tippi Hedren, she's an amazing woman. You can't quite believe she is the age she is."
  },
  {
    "author": "Leona Lewis",
    "category": "amazing",
    "id": 2240,
    "text": "I get such lovely gifts from fans... amazing pictures, handmade jewellery. I'm very lucky!"
  },
  {
    "author": "Ritchie Blackmore",
    "category": "amazing",
    "id": 2182,
    "text": "Stevie Ray Vaughan was very intense. Maybe that's what caught everybody's attention. As a player, he didn't do anything amazing."
  },
  {
    "author": "Kiefer Sutherland",
    "category": "amazing",
    "id": 2208,
    "text": "Youth is an amazing thing: I think back on when we did The Lost Boys, and I didn't think I could do anything wrong."
  },
  {
    "author": "Yahoo Serious",
    "category": "amazing",
    "id": 2504,
    "text": "If government and media and all of us in the Australian tribe got together, and the rock industry, we'd just be the greatest cultural force the world has ever seen - we're such an amazing race."
  },
  {
    "author": "Thierry Henry",
    "category": "amazing",
    "id": 2280,
    "text": "In football you always get judged on your last game. Whoever you are, or how amazing you are, it's the last game that everyone has seen."
  },
  {
    "author": "Carrie Underwood",
    "category": "amazing",
    "id": 2152,
    "text": "I love being around my friends and my family and spending time with my husband. I like being normal and recharging my batteries, and I feel like I have the coolest job in the world where I get to get on stage and perform and get to do a lot of really amazing things."
  },
  {
    "author": "Chris Hughes",
    "category": "amazing",
    "id": 2510,
    "text": "People are doing amazing things right now on the Web."
  },
  {
    "author": "Curtis Stone",
    "category": "amazing",
    "id": 2297,
    "text": "For 'Around the World in 80 Plates' we got to travel all over, having what was like a cross between a culinary competition and races. And in each country we had a chef Ambassador. We went to London, Barcelona, Bologna, Hong Kong, Thailand, Morocco... It was amazing."
  },
  {
    "author": "David Copperfield",
    "category": "amazing",
    "id": 2366,
    "text": "I discovered something amazing, which has caused a lot of controversy - the fountain of youth. I have to keep it a secret!"
  },
  {
    "author": "Stefano Langone",
    "category": "amazing",
    "id": 2676,
    "text": "A million words were going through my head and honestly I didn't say one of them. I wanted to let it sit, simmer, you know I wanted to soak it all in - the moment was amazing."
  },
  {
    "author": "Debra Winger",
    "category": "amazing",
    "id": 2188,
    "text": "It's such an amazing thing to be loved for who you are."
  },
  {
    "author": "Heidi Klum",
    "category": "amazing",
    "id": 2102,
    "text": "Well, I was already so happy being chosen to do the issue itself, that when I got on the cover, it was even more of a surprise and even more amazing to me."
  },
  {
    "author": "Scott Foley",
    "category": "amazing",
    "id": 2938,
    "text": "The best part is it's a dream come true. I've always wanted to be a working actor, and the good part of it... it's all good! I work long hours, but it's amazing. They pay me. That's amazing! I get to kiss Keri Russell, and that ain't too bad."
  },
  {
    "author": "Joaquin Phoenix",
    "category": "amazing",
    "id": 2233,
    "text": "It's an amazing feeling to go into a studio and really be alone."
  },
  {
    "author": "Angela Sarafyan",
    "category": "amazing",
    "id": 2952,
    "text": "I think Gina Rowlands is an amazing actress."
  },
  {
    "author": "Robert Mondavi",
    "category": "amazing",
    "id": 2041,
    "text": "There are a lot of people with a lot of money, and I'm amazed they don't understand what a great pleasure it can be to give."
  },
  {
    "author": "Seal",
    "category": "amazing",
    "id": 2547,
    "text": "I do like athletes as they have amazing self-discipline."
  },
  {
    "author": "Lewis Thomas",
    "category": "amazing",
    "id": 2199,
    "text": "A lot of people fear death because they think that so overwhelming an experience has to be painful, but I've seen quite a few deaths, and, with one exception, I've never known anyone to undergo anything like agony. That's amazing when you think about it. I mean, how complicated the mechanism is that's being taken apart."
  },
  {
    "author": "Robert Wyatt",
    "category": "amazing",
    "id": 2213,
    "text": "I don't know how many thoughts we have a second, but it's quite an amazing number, and just to pin down the appropriate sequence of those, all you really need is a pencil and a piece of paper."
  },
  {
    "author": "Ben Stein",
    "category": "amazing",
    "id": 2150,
    "text": "The people who did the collateralized mortgage obligations, sold them to pension funds, then sold them short, then bought credit default swap insurance on them, are just amazing. They are a law unto themselves."
  },
  {
    "author": "Tom Wopat",
    "category": "amazing",
    "id": 2812,
    "text": "When you're doing the traditional musicals, singing songs that are 40 and 50 years old, you realize there's a reason why those musicals are hits. These are amazing songs!"
  },
  {
    "author": "Lena Dunham",
    "category": "amazing",
    "id": 2156,
    "text": "I'd love to write something for a male protagonist. That's sort of the next frontier for me. I think it'd be really amazing to write the kind of parts that I love for women but for a guy."
  },
  {
    "author": "Katey Sagal",
    "category": "amazing",
    "id": 2274,
    "text": "I work with all these amazing voice actors that do a kajillion voices."
  },
  {
    "author": "Krista Allen",
    "category": "amazing",
    "id": 2842,
    "text": "Men are amazing. I love the way they are. They're consistently little boys, and they need to be nurtured and loved. But at the same time, they need to feel like men."
  },
  {
    "author": "Nancy McKeon",
    "category": "amazing",
    "id": 2906,
    "text": "Personally I had the opportunity to go on several ride alongs with the LA County Sheriff's Department with some amazing detectives, who were invaluable to me."
  },
  {
    "author": "Sally Kellerman",
    "category": "amazing",
    "id": 2736,
    "text": "Well, it was the beginning of my film career. It was amazing to me that I got nominated for an Academy Award."
  },
  {
    "author": "Gerard Butler",
    "category": "amazing",
    "id": 2502,
    "text": "I knew I'd just done one of the most amazing things that I will ever get a chance to do. Just to be part of a musical that's not your background and to pull it off and to think that we've done something that's really special."
  },
  {
    "author": "Linda McCartney",
    "category": "amazing",
    "id": 2369,
    "text": "We are really on top of one another at the moment and I think it is amazing how we stay so close. Maybe that's the test. Why not totally put yourself together, rather than always wonder whether you actually like each other?"
  },
  {
    "author": "Brian Molko",
    "category": "amazing",
    "id": 2333,
    "text": "I'm tired of being around men all the time. I'm going to start a band called Skirt with three girls and I'll play the guitar and sing backing vocals in drag. I went window shopping when I was in New York, saw a lot of amazing dresses."
  },
  {
    "author": "Rob Sheffield",
    "category": "amazing",
    "id": 2291,
    "text": "It's kind of amazing how popular 'Grey's Anatomy' is. What other show can boast such an annoyingly sincere cast of doctors, sniveling through such perfunctory love triangles?"
  },
  {
    "author": "Michael Rady",
    "category": "amazing",
    "id": 2951,
    "text": "It's amazing... to enjoy the results of your labor."
  },
  {
    "author": "Jolene Blalock",
    "category": "amazing",
    "id": 2367,
    "text": "Surfing is such an amazing concept. You're taking on Nature with a little stick and saying, 'I'm gonna ride you!' And a lot of times Nature says, 'No you're not!' and crashes you to the bottom."
  },
  {
    "author": "Gael Garcia Bernal",
    "category": "amazing",
    "id": 2409,
    "text": "Recently I've been doing risottos. Some of them have been amazing. Some of them, not all of them."
  },
  {
    "author": "Andy Serkis",
    "category": "amazing",
    "id": 2340,
    "text": "My dad was working abroad, in Iraq, and he was a doctor. We used to go and visit him, in Baghdad, off and on. For the first ten years of my life, we used to go backwards and forwards to Baghdad, so that was quite amazing. I spent a lot of time traveling around the Middle East."
  },
  {
    "author": "Brad Paisley",
    "category": "amazing",
    "id": 2441,
    "text": "I jetset around and play these songs and get to hang with some pretty amazing people, then I go home to a really great farm, though actually it's a disaster area of a farm at the moment. But it's certainly a blast. I wouldn't trade lives with anyone right now."
  },
  {
    "author": "Peta Wilson",
    "category": "amazing",
    "id": 2917,
    "text": "I'm crazy about my father, he's an amazing man, a real adventurer. He took us with him to travel all over the world. We were in places that were so remote, that white people hardly ever reach them."
  },
  {
    "author": "Lisa Kudrow",
    "category": "amazing",
    "id": 2639,
    "text": "Christina Ricci is amazing, the most professional actor I think I've ever met. You can be chatting with her and when they call action, she's right there."
  },
  {
    "author": "James Bovard",
    "category": "amazing",
    "id": 2261,
    "text": "It is amazing to think after all that has happened in this country in the last few years, the last few decades, that so many people have this blind faith that government is our friend and therefore, so we don't need protections against it."
  },
  {
    "author": "Arthur Godfrey",
    "category": "amazing",
    "id": 2732,
    "text": "I liked the way they treated the first, second, and third place finishers equally. It was an amazing year. I only entered two song contests this year I won one and placed second in the other. And I entered each of them a day or two before the deadline."
  },
  {
    "author": "Shay Mitchell",
    "category": "amazing",
    "id": 2350,
    "text": "I was dating my first boyfriend in high school for a long time, and we broke up before prom. I hadn't met anyone else that I really wanted to go with, and my friends have always been amazing. So I went with my friends and got a million photos with them!"
  },
  {
    "author": "Natalie Gulbis",
    "category": "amazing",
    "id": 2555,
    "text": "Pebble Beach. It is tough and the lay out is amazing."
  },
  {
    "author": "Ritchie Blackmore",
    "category": "amazing",
    "id": 2126,
    "text": "I was impressed by Hendrix. His attitude was brilliant. Even the way he walked was amazing."
  },
  {
    "author": "Jennifer Morrison",
    "category": "amazing",
    "id": 2495,
    "text": "I'm on an Isabel Marant kick. She does an amazing job of making things that are everyday-wearable but also special and a little bit different. I definitely like that she has a '70s western vibe. There's something that's very fun and vintage in what she's doing."
  },
  {
    "author": "Dido Armstrong",
    "category": "amazing",
    "id": 2666,
    "text": "It's actually amazing because you go so far into another side of your brain when you're studying something completely different, and I loved it."
  },
  {
    "author": "Tristan Wilds",
    "category": "amazing",
    "id": 2920,
    "text": "'True Blood' is amazing. I have to give a shout out to 'Melrose Place' because I do watch. I love 'Entourage.' One of my favorite shows back in the day was 'Friday Night Lights.'"
  },
  {
    "author": "Ashlee Simpson",
    "category": "amazing",
    "id": 2571,
    "text": "I have amazing people around me. I couldn't be in a better place. I'm grateful for my life and where I'm at. I never thought I could be in the position that I'm in."
  },
  {
    "author": "Stephen Hunter",
    "category": "amazing",
    "id": 2494,
    "text": "If you have only 95 minutes of material, make an only 95-minute movie. Amazing how often that's forgotten."
  },
  {
    "author": "Carmen Electra",
    "category": "amazing",
    "id": 2338,
    "text": "My mom was amazing. She believed in me and we were best friends."
  },
  {
    "author": "Graham Swift",
    "category": "amazing",
    "id": 2517,
    "text": "The real art is not to come up with extraordinary clever words but to make ordinary simple words do extraordinary things. To use the language that we all use and to make amazing things occur."
  },
  {
    "author": "Joichi Ito",
    "category": "amazing",
    "id": 2544,
    "text": "Google is in an amazing position to be the target of tons of lawsuits that will set precedent for many important things for us on the Internet."
  },
  {
    "author": "Bo Derek",
    "category": "amazing",
    "id": 2767,
    "text": "'10' was amazing! I had no career before '10' and then all of a sudden I was able to do pretty much whatever I was able to do in the business."
  },
  {
    "author": "Gloria Steinem",
    "category": "amazing",
    "id": 2073,
    "text": "Childbirth is more admirable than conquest, more amazing than self-defense, and as courageous as either one."
  },
  {
    "author": "Berenice Marlohe",
    "category": "amazing",
    "id": 2909,
    "text": "And Shanghai is amazing. I'm a fan of science fiction so when you're there in the night with all the lights and all this modernity, it's like a set in a movie."
  },
  {
    "author": "David Attenborough",
    "category": "amazing",
    "id": 2018,
    "text": "People must feel that the natural world is important and valuable and beautiful and wonderful and an amazement and a pleasure."
  },
  {
    "author": "Jerry Rice",
    "category": "amazing",
    "id": 2684,
    "text": "Montana and I had a chemistry that was unbelievable. When I first came into the league he told me I added five years to his career, and I just think we complimented each other very well and were able to do some amazing things out on the football field."
  },
  {
    "author": "Anna Paquin",
    "category": "amazing",
    "id": 2386,
    "text": "I think it's an amazing quality to be able to roll with the punches and not be totally ruined as a person because life's been rough for you. That's a really admirable way to go through your life."
  },
  {
    "author": "Birdy",
    "category": "amazing",
    "id": 2863,
    "text": "I got a phone call from Fearne Cotton. It was amazing! I literally couldn't believe it. It was so cool. It was the night before I was going on her show to sing on the 'Live Lounge.' She was so lovely."
  },
  {
    "author": "Andrew Shue",
    "category": "amazing",
    "id": 2083,
    "text": "I have amazing friends who have led inspirational lives."
  },
  {
    "author": "Kaley Cuoco",
    "category": "amazing",
    "id": 2856,
    "text": "John was the smartest and most amazing comedian I've ever worked with. I think more than teaching me about acting or comedy, he taught me about life and the love of people and respect of people."
  },
  {
    "author": "Vanessa Hudgens",
    "category": "amazing",
    "id": 2216,
    "text": "Exercise is amazing, from the inside out. I feel so alive and have more energy."
  },
  {
    "author": "Suze Orman",
    "category": "amazing",
    "id": 2100,
    "text": "Money is such an amazing teacher: What you choose to do with your money shows whether you are truly powerful or powerless."
  },
  {
    "author": "Saskia de Brauw",
    "category": "amazing",
    "id": 2880,
    "text": "The travel, the amazing work I have had the chance to do, the meetings with different people are all very inspiring and give me lots of positive energy."
  },
  {
    "author": "Emerson Fittipaldi",
    "category": "amazing",
    "id": 2735,
    "text": "The racing driver's mind has to have the ability to have amazing anticipation, coordination, and reflex. Because of the speed the car goes."
  },
  {
    "author": "Thomas Frank",
    "category": "amazing",
    "id": 2140,
    "text": "Back in the days when the market was a kind of secular god and all the world thrilled to behold the amazing powers of private capital, the idea of privatizing highways and airports and other bits of our transportation infrastructure made a certain kind of sense."
  },
  {
    "author": "Stephenie Meyer",
    "category": "amazing",
    "id": 2469,
    "text": "With 'The Host,' I think the actors could be really big names. That would be cool. I'd love to see Robert Redford put on a beard and be Jeb he would be amazing... Matt Damon has some very Jared-esque qualities, and then Casey Affleck as Ian and Ben Affleck as Kyle. Imagine the interplay."
  },
  {
    "author": "Leo Tolstoy",
    "category": "amazing",
    "id": 2065,
    "text": "It is amazing how complete is the delusion that beauty is goodness."
  },
  {
    "author": "Christy Turlington",
    "category": "amazing",
    "id": 2205,
    "text": "People always think that if you eat anything as a model, it's amazing. I used to tease them and say, you know I'm going to throw up afterwards."
  },
  {
    "author": "Frank Miller",
    "category": "amazing",
    "id": 2362,
    "text": "When you think of what Americans accomplished, building these amazing cities and all the good it's done in the world, it's kind of disheartening to hear so much hatred of America, not just from abroad, but internally."
  },
  {
    "author": "Robert Lanza",
    "category": "amazing",
    "id": 2039,
    "text": "Amazingly when you add life and consciousness to the equation you can actually explain some of the biggest puzzles of science."
  },
  {
    "author": "Craig Charles",
    "category": "amazing",
    "id": 2769,
    "text": "What's amazing is that I'm recognized all over the world through 'Red Dwarf.' British fans are exceptional, but the American fans are something else. Some of them fly 500 miles to stand in line for three hours, just to meet me, then when they do they collapse. It makes you feel like a rock star!"
  },
  {
    "author": "Evanna Lynch",
    "category": "amazing",
    "id": 2816,
    "text": "Well just meeting J. K. Rowling was amazing because she created all this world. And all the fans, we all get so obsessed with it and then you met the one person who made it all up. It was just so amazing. And I was just so amazed that that she wrote this book and all of the films have happened."
  },
  {
    "author": "Nikki Reed",
    "category": "amazing",
    "id": 2533,
    "text": "Before 'Twilight,' occasionally I would get the 'Hey are you that girl from that movie?' but no one knew my first and last name. The fans of the saga are amazing, and it's very flattering."
  },
  {
    "author": "Marlon Wayans",
    "category": "amazing",
    "id": 2433,
    "text": "Let me tell you, Barack Obama is the most down dude in the world, but he's so smart so articulate, such an amazing speaker such a passionate man. He's humble."
  },
  {
    "author": "Judy Woodruff",
    "category": "amazing",
    "id": 2795,
    "text": "If you spend enough time in or around Washington, you'll meet amazing people who work for the government."
  },
  {
    "author": "Chaske Spencer",
    "category": "amazing",
    "id": 2724,
    "text": "It's just amazing to do something that's part of a pop culture phenomenon."
  },
  {
    "author": "Allen Leech",
    "category": "amazing",
    "id": 2947,
    "text": "Maggie Smith is an amazing woman, and not as serious in real life."
  },
  {
    "author": "Nikki Reed",
    "category": "amazing",
    "id": 2534,
    "text": "My mom can't defend herself to the world. She is such an amazing woman, with such an open heart. It's a real hard line, and I crossed it. I took everyone's life story and assumed it would be a great thing to put on screen. I was being selfish and I feel so horrible about it. I feel so guilty."
  },
  {
    "author": "Allison Williams",
    "category": "amazing",
    "id": 2704,
    "text": "I auditioned for 'Girls' the fall after I graduated from Yale. The show has been amazing - as close to perfect as it gets!"
  },
  {
    "author": "Jourdan Dunn",
    "category": "amazing",
    "id": 2509,
    "text": "The unconditional love for you child, it's truly amazing."
  },
  {
    "author": "Mayim Bialik",
    "category": "amazing",
    "id": 2328,
    "text": "I'm one of those people that thinks the Internet is amazing, and I can't believe it exists."
  },
  {
    "author": "Holly Madison",
    "category": "amazing",
    "id": 2248,
    "text": "Truthfully, being pregnant is changing me as a person. Each day is part of this amazing journey that has completely shifted the focus of my life and made me reevaluate my personal and professional goals."
  },
  {
    "author": "Tim O'Reilly",
    "category": "amazing",
    "id": 2817,
    "text": "The network is opening up some amazing possibilities for us to reinvent content, reinvent collaboration."
  },
  {
    "author": "Kirsty Coventry",
    "category": "amazing",
    "id": 2921,
    "text": "Everyone at home is so supportive. People recognise me, say how proud they are of me. It's awesome to hear, it's amazing to know I can touch so many people in a positive way."
  },
  {
    "author": "Prince William",
    "category": "amazing",
    "id": 2210,
    "text": "I hope I'm not a tourist attraction - I'm sure that they come here really because St. Andrews is just amazing, a beautiful place."
  },
  {
    "author": "Guy Clark",
    "category": "amazing",
    "id": 2790,
    "text": "It was really amazing. I mean, he'd never mentioned that he played in the symphony, like serious violin playing, not fiddle playing. And he just blew us away."
  },
  {
    "author": "Ted Allen",
    "category": "amazing",
    "id": 2221,
    "text": "I really have a great deal of humility in that department, and a great deal of respect for people who spend their lives learning how to make these amazing preparations."
  },
  {
    "author": "Jeremy Irvine",
    "category": "amazing",
    "id": 2709,
    "text": "You can be the best actor in the world, but if you don't have that one lucky moment, it kind of doesn't matter. There are a lot of amazing actors who will never get the chance to prove themselves because they won't have that one lucky moment."
  }
]

quotes['anger'] = [
  {
    "author": "Berkeley Breathed",
    "category": "anger",
    "id": 3197,
    "text": "That's the conundrum of cartoon stripping, as opposed to political cartoons. When your anger is the driving force of your drawing hand, failure follows. The anger is OK, but it has to serve the interests of the heart, frankly."
  },
  {
    "author": "Joan Lunden",
    "category": "anger",
    "id": 3024,
    "text": "Holding on to anger, resentment and hurt only gives you tense muscles, a headache and a sore jaw from clenching your teeth. Forgiveness gives you back the laughter and the lightness in your life."
  },
  {
    "author": "Jacqueline Bisset",
    "category": "anger",
    "id": 3134,
    "text": "At the time, 1980, people regarded actresses involved with production with a certain amount of fear, resentment and anger."
  },
  {
    "author": "Eddie Bernice Johnson",
    "category": "anger",
    "id": 3224,
    "text": "Our second phase was to develop a school curriculum that teaches tolerance, respect for differences, conflict resolution, anger management, and other attributes of peace."
  },
  {
    "author": "Nagarjuna",
    "category": "anger",
    "id": 3084,
    "text": "Although you may spend your life killing, You will not exhaust all your foes. But if you quell your own anger, your real enemy will be slain."
  },
  {
    "author": "Chen Ning Yang",
    "category": "anger",
    "id": 3274,
    "text": "In the final analysis, the incident is seen as originating from an emotional expression of the frustration and anger of the proud people of China who had been subject to ever increasing oppression from without and decadent corruption from within."
  },
  {
    "author": "Buddha",
    "category": "anger",
    "id": 2962,
    "text": "In a controversy the instant we feel anger we have already ceased striving for the truth, and have begun striving for ourselves."
  },
  {
    "author": "Lincoln Chafee",
    "category": "anger",
    "id": 3234,
    "text": "Anger's not a good emotion."
  },
  {
    "author": "Dalai Lama",
    "category": "anger",
    "id": 3021,
    "text": "Generally speaking, if a human being never shows anger, then I think something's wrong. He's not right in the brain."
  },
  {
    "author": "Pete Townshend",
    "category": "anger",
    "id": 3111,
    "text": "I have to say that anger is the blanket that comes around me, and that blunts and blurs my sense of proportion."
  },
  {
    "author": "Bill Alexander",
    "category": "anger",
    "id": 3273,
    "text": "The anger in the Brigade against those who fought the Republic in the rear was sharpened by reports of weapons, even tanks, being kept from the front and hidden for treacherous purposes."
  },
  {
    "author": "Carl Hiaasen",
    "category": "anger",
    "id": 3154,
    "text": "My humour has always come from anger, but I have to make sure I don't just get angry and jump on a soapbox."
  },
  {
    "author": "Marcus Aurelius",
    "category": "anger",
    "id": 2984,
    "text": "How much more grievous are the consequences of anger than the causes of it."
  },
  {
    "author": "Christopher Darden",
    "category": "anger",
    "id": 3214,
    "text": "I did not think that I was angry, but clearly anger was reflected in my writing. I did not think that I had been affected emotionally, but it was clear from my writing that I was still very emotional about the trial some six months after it ended."
  },
  {
    "author": "Shelley Berman",
    "category": "anger",
    "id": 3193,
    "text": "As a culture I see us as presently deprived of subtleties. The music is loud, the anger is elevated, sex seems lacking in sweetness and privacy."
  },
  {
    "author": "Confucius",
    "category": "anger",
    "id": 3028,
    "text": "Speak the truth, do not yield to anger give, if thou art asked for little by these three steps thou wilt go near the gods."
  },
  {
    "author": "Rodney King",
    "category": "anger",
    "id": 3069,
    "text": "As far as having peace within myself, the one way I can do that is forgiving the people who have done wrong to me. It causes more stress to build up anger. Peace is more productive."
  },
  {
    "author": "Thomas Fuller",
    "category": "anger",
    "id": 3005,
    "text": "Anger is one of the sinews of the soul."
  },
  {
    "author": "Horace",
    "category": "anger",
    "id": 3065,
    "text": "The one who cannot restrain their anger will wish undone, what their temper and irritation prompted them to do."
  },
  {
    "author": "Drew Barrymore",
    "category": "anger",
    "id": 3096,
    "text": "My therapist says I still haven't got in touch with my anger. Maybe one day I'm going to explode. But I'm still really happy. I know it looks like a strange and painful upbringing - all those experiences led me to the paths that I'm on now."
  },
  {
    "author": "Thomas a Kempis",
    "category": "anger",
    "id": 2988,
    "text": "Be not angry that you cannot make others as you wish them to be, since you cannot make yourself as you wish to be."
  },
  {
    "author": "William Congreve",
    "category": "anger",
    "id": 3004,
    "text": "Never go to bed angry, stay up and fight."
  },
  {
    "author": "Theresa May",
    "category": "anger",
    "id": 3151,
    "text": "I'm not someone who feels anger on particular issues."
  },
  {
    "author": "Roberta Flack",
    "category": "anger",
    "id": 3263,
    "text": "My hope is that out of all the anger and seeming hostility that we hear in some of today's music will come some sort of coalition that will become politically involved."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "anger",
    "id": 3067,
    "text": "People are always angry at America. They're absolutely certain that America either caused their problems or is deliberately not fixing their problems. But the anger is always directed at America and never at Americans."
  },
  {
    "author": "Publilius Syrus",
    "category": "anger",
    "id": 3113,
    "text": "The bare recollection of anger kindles anger."
  },
  {
    "author": "Obie Trice",
    "category": "anger",
    "id": 3220,
    "text": "The Anger Management Tour was another beautiful thing. I loved that tour."
  },
  {
    "author": "Chris Hayes",
    "category": "anger",
    "id": 3259,
    "text": "I think people should be angry at things that are worthy of anger. Injustice is outrageous and deserves outrage."
  },
  {
    "author": "Edgar Rice Burroghs",
    "category": "anger",
    "id": 3138,
    "text": "Anger and hate against one we love steels our hearts, but contempt or pity leaves us silent and ashamed."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "anger",
    "id": 3050,
    "text": "Anger is like those ruins which smash themselves on what they fall."
  },
  {
    "author": "Caleb Carr",
    "category": "anger",
    "id": 3194,
    "text": "I was a pretty angry kid, and I got into military history largely as a way to vent my own anger. As I got older it narrowed down to a more specific focus on individual violence. I'm just trying to understand where it came from."
  },
  {
    "author": "Gary Oldman",
    "category": "anger",
    "id": 3131,
    "text": "My passion and energy get mistaken for anger."
  },
  {
    "author": "George William Curtis",
    "category": "anger",
    "id": 3128,
    "text": "Anger is an expensive luxury in which only men of certain income can indulge."
  },
  {
    "author": "Charles Bronson",
    "category": "anger",
    "id": 3063,
    "text": "The fear really hits you. That's what you feel first. And then it's the anger and frustration. Part of the problem is how little we understand about the ultimate betrayal of the body when it rebels against itself."
  },
  {
    "author": "George Jean Nathan",
    "category": "anger",
    "id": 3003,
    "text": "No man can think clearly when his fists are clenched."
  },
  {
    "author": "Mark Twain",
    "category": "anger",
    "id": 2966,
    "text": "When angry, count to four when very angry, swear."
  },
  {
    "author": "Sherman Alexie",
    "category": "anger",
    "id": 3168,
    "text": "In high school I dated a white woman. She would come to visit me on the rez. And her dad, who was very racist, didn't like that at all. And he told her one time, 'You shouldn't go on the rez if you're white because Indians have a lot of anger in their heart.'"
  },
  {
    "author": "Bodhidharma",
    "category": "anger",
    "id": 3039,
    "text": "The ignorant mind, with its infinite afflictions, passions, and evils, is rooted in the three poisons. Greed, anger, and delusion."
  },
  {
    "author": "John Robinson",
    "category": "anger",
    "id": 3265,
    "text": "With Stacy, it was interesting because you know he was within all this chaos, all these different lives that were so broken and so much anger and so much frustration and their skating came out of that, their different styles came out of that."
  },
  {
    "author": "Tony Greig",
    "category": "anger",
    "id": 3242,
    "text": "Us investigators who went out into the field were faced on occasion with a lot of anger, by people saying why has it taken you five or six year to come and see me?"
  },
  {
    "author": "Horace",
    "category": "anger",
    "id": 2992,
    "text": "Anger is a short madness."
  },
  {
    "author": "Bruce Nauman",
    "category": "anger",
    "id": 3198,
    "text": "Generalised anger and frustration is something that gets you in the studio, and gets you to work - though it's not necessarily evident in anything that's finished."
  },
  {
    "author": "John Dryden",
    "category": "anger",
    "id": 3076,
    "text": "Anger will never disappear so long as thoughts of resentment are cherished in the mind. Anger will disappear just as soon as thoughts of resentment are forgotten."
  },
  {
    "author": "Christopher Morley",
    "category": "anger",
    "id": 2972,
    "text": "A man who has never made a woman angry is a failure in life."
  },
  {
    "author": "Emmitt Smith",
    "category": "anger",
    "id": 3159,
    "text": "I've learned that football sometimes was an outlet. It was a way for me to release anger, release frustration."
  },
  {
    "author": "John Buchanan",
    "category": "anger",
    "id": 3285,
    "text": "I love each and every one of you but, like my own family, you thrill, you frustrate, you anger."
  },
  {
    "author": "Robert Green Ingersoll",
    "category": "anger",
    "id": 2990,
    "text": "Anger is a wind which blows out the lamp of the mind."
  },
  {
    "author": "Albert Brooks",
    "category": "anger",
    "id": 3171,
    "text": "All improv turns into anger. All comedy improv basically turns into anger, because that's all people know how to do when they're improvising. If you notice shows that are improvising are generally people yelling at each other."
  },
  {
    "author": "Eduard Shevardnadze",
    "category": "anger",
    "id": 3200,
    "text": "But on second thought, after I decreed the state of emergency, I came to the conclusion that that was impossible to achieve without bloodshed because the street protesters were full of anger and nearly out of control. This is why I thought we needed to find another way out."
  },
  {
    "author": "Edmund S. Muskie",
    "category": "anger",
    "id": 3280,
    "text": "In the heat of our campaigns, we have all become accustomed to a little anger and exaggeration. Yet, on the whole, our political process has served us well."
  },
  {
    "author": "Paul McCartney",
    "category": "anger",
    "id": 3092,
    "text": "George wrote Taxman, and I played guitar on it. He wrote it in anger at finding out what the taxman did. He had never known before then what could happen to your money."
  },
  {
    "author": "Edward Albert",
    "category": "anger",
    "id": 3207,
    "text": "Fear is the only true enemy, born of ignorance and the parent of anger and hate."
  },
  {
    "author": "Benjamin Franklin",
    "category": "anger",
    "id": 3027,
    "text": "Anger is never without a reason, but seldom with a good one."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "anger",
    "id": 3026,
    "text": "We should meet abuse by forbearance. Human nature is so constituted that if we take absolutely no notice of anger or abuse, the person indulging in it will soon weary of it and stop."
  },
  {
    "author": "Thomas Jefferson",
    "category": "anger",
    "id": 2967,
    "text": "When angry count to ten before you speak. If very angry, count to one hundred."
  },
  {
    "author": "Alanis Morissette",
    "category": "anger",
    "id": 3052,
    "text": "We're taught to be ashamed of confusion, anger, fear and sadness, and to me they're of equal value to happiness, excitement and inspiration."
  },
  {
    "author": "Frank Luntz",
    "category": "anger",
    "id": 3185,
    "text": "There are people still in the Republican Party that I believe practice the communication of anger, of disappointment, of regret, of pain, of sorrow, of suffering. That's not what the American people want to hear."
  },
  {
    "author": "Kathy Griffin",
    "category": "anger",
    "id": 3135,
    "text": "The great thing about celebrity culture is that they can't seem to stop themselves from displaying their ridiculous behaviour. I feel it's my job as a serious investigative journalist to witness all kinds of behaviour and then report back to the audience through the prism of my own anger and bitterness."
  },
  {
    "author": "Benjamin Franklin",
    "category": "anger",
    "id": 2969,
    "text": "Whatever is begun in anger ends in shame."
  },
  {
    "author": "Howard Staunton",
    "category": "anger",
    "id": 3227,
    "text": "If either player abandon the game by quitting the table in anger, or in an otherwise offensive manner or by momentarily resigning the game or refuses to abide by the decision of the Umpire, the game must be scored against him."
  },
  {
    "author": "Matthew Prior",
    "category": "anger",
    "id": 3108,
    "text": "Fantastic tyrant of the amorous heart. How hard thy yoke, how cruel thy dart. Those escape your anger who refuse your sway, and those are punished most, who most obey."
  },
  {
    "author": "Thomas Fuller",
    "category": "anger",
    "id": 3002,
    "text": "There is nothing that so much gratifies an ill tongue as when it finds an angry heart."
  },
  {
    "author": "Jerry Seinfeld",
    "category": "anger",
    "id": 3100,
    "text": "Well, all comedy starts with anger. You get angry, and its never for a good reason, right? You know its not a good reason. And then you try and work it from there."
  },
  {
    "author": "Terry Brooks",
    "category": "anger",
    "id": 3038,
    "text": "Hurt leads to bitterness, bitterness to anger, travel too far that road and the way is lost."
  },
  {
    "author": "Lord Halifax",
    "category": "anger",
    "id": 3282,
    "text": "Anger is seldom without argument but seldom with a good one."
  },
  {
    "author": "William Butler Yeats",
    "category": "anger",
    "id": 3000,
    "text": "One should not lose one's temper unless one is certain of getting more and more angry to the end."
  },
  {
    "author": "Dick Dale",
    "category": "anger",
    "id": 3150,
    "text": "I don't play pyrotechnic scales. I play about frustration, patience, anger. Music is an extension of my soul."
  },
  {
    "author": "Boris Trajkovski",
    "category": "anger",
    "id": 3210,
    "text": "I am ready to accept all accusations, allegations, anger - but I have to succeed."
  },
  {
    "author": "Jay Alan Sekulow",
    "category": "anger",
    "id": 3213,
    "text": "What if you threw a protest and no one showed up? The lack of angst and anger and emotion is a big positive."
  },
  {
    "author": "Confucius",
    "category": "anger",
    "id": 2971,
    "text": "When anger rises, think of the consequences."
  },
  {
    "author": "Tryon Edwards",
    "category": "anger",
    "id": 3179,
    "text": "To rule one's anger is well to prevent it is better."
  },
  {
    "author": "Buddha",
    "category": "anger",
    "id": 3018,
    "text": "You will not be punished for your anger, you will be punished by your anger."
  },
  {
    "author": "Mackenzie Phillips",
    "category": "anger",
    "id": 3221,
    "text": "I've always turned my anger inwards towards self-destruction."
  },
  {
    "author": "Wilson Mizner",
    "category": "anger",
    "id": 3091,
    "text": "All anger is not sinful, because some degree of it, and on some occasions, is inevitable. But it becomes sinful and contradicts the rule of Scripture when it is conceived upon slight and inadequate provocation, and when it continues long."
  },
  {
    "author": "Bernadine Dohrn",
    "category": "anger",
    "id": 3244,
    "text": "I was shocked at the anger toward me."
  },
  {
    "author": "Monica Lewinsky",
    "category": "anger",
    "id": 3072,
    "text": "I'd be lying if I said I wasn't angry some days. But I really have worked hard to put a lot of the anger and disappointment in the past."
  },
  {
    "author": "Agnes Obel",
    "category": "anger",
    "id": 3281,
    "text": "I don't have the feeling of being motivated by anger, revenge or frustration."
  },
  {
    "author": "Richard M. Nixon",
    "category": "anger",
    "id": 3062,
    "text": "You must never be satisfied with losing. You must get angry, terribly angry, about losing. But the mark of the good loser is that he takes his anger out on himself and not his victorious opponents or on his teammates."
  },
  {
    "author": "Baltasar Gracian",
    "category": "anger",
    "id": 2997,
    "text": "Never do anything when you are in a temper, for you will do everything wrong."
  },
  {
    "author": "Wilfred Burchett",
    "category": "anger",
    "id": 3245,
    "text": "My anger with the US was not at first, that they had used that weapon - although that anger came later."
  },
  {
    "author": "Ellie Goulding",
    "category": "anger",
    "id": 3146,
    "text": "It's usually a big kind of vent of frustration or anger or sadness that puts me in the right frame of mind to write. It's such a cliche to say that artists write when they're down, but it's true for me. It's a relief to get out what's eating away at my heart or my soul or my head."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "anger",
    "id": 3057,
    "text": "Hatred is inveterate anger."
  },
  {
    "author": "Hannah More",
    "category": "anger",
    "id": 3019,
    "text": "Forgiveness is the economy of the heart... forgiveness saves the expense of anger, the cost of hatred, the waste of spirits."
  },
  {
    "author": "Vince Cable",
    "category": "anger",
    "id": 3164,
    "text": "On banks, I make no apology for attacking spivs and gamblers who did more harm to the British economy than Bob Crow could achieve in his wildest Trotskyite fantasies, while paying themselves outrageous bonuses underwritten by the taxpayer. There is much public anger about banks and it is well deserved."
  },
  {
    "author": "Chaz Bono",
    "category": "anger",
    "id": 3202,
    "text": "Deep down, my mom had long suspected I was gay... Much of her anger and hurt came from her sense of betrayal that she was the last to be told."
  },
  {
    "author": "M. Kathleen Casey",
    "category": "anger",
    "id": 3231,
    "text": "Anger may be kindled in the noblest breasts: but in these slow droppings of an unforgiving temper never takes the shape of consistency of enduring hatred."
  },
  {
    "author": "Samuel L. Jackson",
    "category": "anger",
    "id": 3054,
    "text": "I'm not as angry as I used to be. But I can get in touch with that anger pretty quickly if I feel my space is being invaded or somebody is not treating me with the respect that I think I want."
  },
  {
    "author": "Chris Hayes",
    "category": "anger",
    "id": 3260,
    "text": "Successful prime-time television of any genre produces some kind of emotional reaction in the viewers. There are a lot of different emotions to tap into. The emotion of the reward of discovery, the feeling of righteous anger, the feelings of pathos and sadness, or sentimentality of being moved by something."
  },
  {
    "author": "Paula Cole",
    "category": "anger",
    "id": 3126,
    "text": "For me music is a vehicle to bring our pain to the surface, getting it back to that humble and tender spot where, with luck, it can lose its anger and become compassion again."
  },
  {
    "author": "Barbara de Angelis",
    "category": "anger",
    "id": 3055,
    "text": "The more anger towards the past you carry in your heart, the less capable you are of loving in the present."
  },
  {
    "author": "Courteney Cox",
    "category": "anger",
    "id": 3086,
    "text": "A lot of my humor does come from anger. It's like, you're not gonna pull one over on me - which is pretty much my motto anyways."
  },
  {
    "author": "Yoko Ono",
    "category": "anger",
    "id": 3048,
    "text": "Experiencing sadness and anger can make you feel more creative, and by being creative, you can get beyond your pain or negativity."
  },
  {
    "author": "John Ruskin",
    "category": "anger",
    "id": 3001,
    "text": "He that would be angry and sin not, must not be angry with anything but sin."
  },
  {
    "author": "Carmen Miranda",
    "category": "anger",
    "id": 3232,
    "text": "I've chosen my wedding ring large and heavy to continue forever. But exactly because of that all the time that Dave and I have an argument I feel it like handcuffs, and on anger time I throw it in a basket. Poor Dave, he bought me three wedding rings already!"
  },
  {
    "author": "Alan Bleasdale",
    "category": "anger",
    "id": 3279,
    "text": "There is not in nature, a thing that makes man so deformed, so beastly, as doth intemperate anger."
  },
  {
    "author": "Caleb Carr",
    "category": "anger",
    "id": 3195,
    "text": "I get in trouble when I say things like, 'I'm attracted to violence.' I was a pretty angry kid, and I got into military history largely as a way to vent my own anger. As I got older it narrowed down to a more specific focus on individual violence. I'm just trying to understand where it came from."
  },
  {
    "author": "Dominic Cooper",
    "category": "anger",
    "id": 3201,
    "text": "I suppose there's an anger in all of us. Some hidden rage that you keep at bay."
  },
  {
    "author": "Lisa Marie Presley",
    "category": "anger",
    "id": 3192,
    "text": "I do like to write nasty songs. It's a useful weapon to have, and it's cathartic as well, because I create art out of anger, something positive out of something negative."
  },
  {
    "author": "Ford Frick",
    "category": "anger",
    "id": 3217,
    "text": "Keep your temper. A decision made in anger is never sound."
  },
  {
    "author": "Calvin Harris",
    "category": "anger",
    "id": 3264,
    "text": "I'm not angry, I'm not an angry person, but I do sometimes like playing with the perception of anger, as in pretending that I'm more angry than I actually am, and sometimes it works quite well."
  }
]

quotes['anniversary'] = [
  {
    "author": "Adrian Belew",
    "category": "anniversary",
    "id": 3345,
    "text": "I didn't make my first solo record until 1981 so I don't have any 60's or 70's recordings but I am working on a large boxed set called DUST to be released next year, the 20th anniversary of my first solo record."
  },
  {
    "author": "Bill Cosby",
    "category": "anniversary",
    "id": 3292,
    "text": "The heart of marriage is memories and if the two of you happen to have the same ones and can savor your reruns, then your marriage is a gift from the gods."
  },
  {
    "author": "Barbra Streisand",
    "category": "anniversary",
    "id": 3300,
    "text": "Why does a woman work ten years to change a man's habits and then complain that he's not the man she married?"
  },
  {
    "author": "Benjamin Franklin",
    "category": "anniversary",
    "id": 3289,
    "text": "Marriage is the most natural state of man, and... the state in which you will find solid happiness."
  },
  {
    "author": "Don Shula",
    "category": "anniversary",
    "id": 3329,
    "text": "And this year is going to be the 25th anniversary of the 17-0 team, the only undefeated season."
  },
  {
    "author": "Don Sherwood",
    "category": "anniversary",
    "id": 3355,
    "text": "The 150th anniversary of Penn State will highlight what is important and good about this distinguished institution and the fine people and research that it produces."
  },
  {
    "author": "Garrett Hedlund",
    "category": "anniversary",
    "id": 3332,
    "text": "See, the 'On the Road' that came out in 1957 was censored. A lot of the honesty of it, the bitter honesty, is in the original scroll version that came out in 2007 on the 50-year anniversary. Back then, there was so much post-Second World War fear that was imposed on everybody - 'You must live life this way' - and these guys were bored."
  },
  {
    "author": "Barack Obama",
    "category": "anniversary",
    "id": 3326,
    "text": "So while an incredible amount of progress has been made, on this fifth anniversary, I wanted to come here and tell the people of this city directly: My administration is going to stand with you - and fight alongside you - until the job is done. Until New Orleans is all the way back, all the way."
  },
  {
    "author": "Pope John Paul II",
    "category": "anniversary",
    "id": 3298,
    "text": "You will reciprocally promise love, loyalty and matrimonial honesty. We only want for you this day that these words constitute the principle of your entire life and that with the help of divine grace you will observe these solemn vows that today, before God, you formulate."
  },
  {
    "author": "Honore de Balzac",
    "category": "anniversary",
    "id": 3302,
    "text": "One should believe in marriage as in the immortality of the soul."
  },
  {
    "author": "Pope John Paul II",
    "category": "anniversary",
    "id": 3295,
    "text": "Marriage is an act of will that signifies and involves a mutual gift, which unites the spouses and binds them to their eventual souls, with whom they make up a sole family - a domestic church."
  },
  {
    "author": "Brad Paisley",
    "category": "anniversary",
    "id": 3312,
    "text": "That there's no more important decision in life than who you marry."
  },
  {
    "author": "Anne Bancroft",
    "category": "anniversary",
    "id": 3319,
    "text": "So I think you have to marry for the right reasons, and marry the right person."
  },
  {
    "author": "Michael McCaul",
    "category": "anniversary",
    "id": 3324,
    "text": "Last week, the House of Representatives passed a resolution honoring the victims and heroes of September 11th. As we commemorate the anniversary of 9-11, we must also remember that the threat is still very real today."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "anniversary",
    "id": 3328,
    "text": "I have for some time urged that a nuclear abolition summit to mark the effective end of the nuclear era be convened in Hiroshima and Nagasaki on the 70th anniversary of the bombings of those cities, with the participation of national leaders and representatives of global civil society."
  },
  {
    "author": "Rodney Atkins",
    "category": "anniversary",
    "id": 3339,
    "text": "I am so excited this year getting to play the 85th Anniversary Macy's Thanksgiving Day Parade. Everyone knows on Thanksgiving morning to get up, turn on the TV and watch the parade, so to be an actual participant is going to be fun and I'm looking forward to it. I am gonna have to put on my deer hunting gear, though, to stay warm!"
  },
  {
    "author": "Jackie Joyner-Kersee",
    "category": "anniversary",
    "id": 3330,
    "text": "The London games mark the 24th anniversary of my winning two golds and setting the world record in the heptathlon. Someone is going to want it records are made to be broken - it's only a matter of time. I hope mine will outlive me."
  },
  {
    "author": "Julia Child",
    "category": "anniversary",
    "id": 3297,
    "text": "The secret of a happy marriage is finding the right person. You know they're right if you love to be with them all the time."
  },
  {
    "author": "Adam Schiff",
    "category": "anniversary",
    "id": 3318,
    "text": "Each year on the anniversary of Martin Luther King Jr.'s birth, America has the opportunity to reflect on our nation's progress towards the realization of his dream."
  },
  {
    "author": "Jim Ramstad",
    "category": "anniversary",
    "id": 3334,
    "text": "On this important anniversary, we must remember that while we have come a long way in eliminating barriers, critical work remains to ensure all Americans can live up to their full potential."
  },
  {
    "author": "Mitt Romney",
    "category": "anniversary",
    "id": 3293,
    "text": "Mom and Dad were married 64 years. And if you wondered what their secret was, you could have asked the local florist - because every day Dad gave Mom a rose, which he put on her bedside table. That's how she found out what happened on the day my father died - she went looking for him because that morning, there was no rose."
  },
  {
    "author": "E. W. Howe",
    "category": "anniversary",
    "id": 3308,
    "text": "Never tell a secret to a bride or a groom wait until they have been married longer."
  },
  {
    "author": "Patrice Leconte",
    "category": "anniversary",
    "id": 3311,
    "text": "Married people from my generation are like an endangered species!"
  },
  {
    "author": "Marilyn Monroe",
    "category": "anniversary",
    "id": 3291,
    "text": "Experts on romance say for a happy marriage there has to be more than a passionate love. For a lasting union, they insist, there must be a genuine liking for each other. Which, in my book, is a good definition for friendship."
  },
  {
    "author": "Alvin Lee",
    "category": "anniversary",
    "id": 3333,
    "text": "The chances of a reunion now are less likely. I was thinking of having a 40th anniversary of the band, but now they are really another band, so it's all a bit weird."
  },
  {
    "author": "Doug Larson",
    "category": "anniversary",
    "id": 3286,
    "text": "More marriages might survive if the partners realized that sometimes the better comes after the worse."
  },
  {
    "author": "H. L. Mencken",
    "category": "anniversary",
    "id": 3294,
    "text": "Strike an average between what a woman thinks of her husband a month before she marries him and what she thinks of him a year afterward, and you will have the truth about him."
  },
  {
    "author": "Katherine Jenkins",
    "category": "anniversary",
    "id": 3310,
    "text": "If you love somebody, you love them. My parents had a 25-year age gap between them and my mum was the breadwinner, my dad the house husband. I'm a strong believer that a good relationship can work, whatever the situation."
  },
  {
    "author": "Jon Porter",
    "category": "anniversary",
    "id": 3338,
    "text": "Presently, the Commission for Commemorating 350 Years of American Jewish History has been brought about to encourage and sponsor a variety of historical activities that advance our understanding of the American Jewish experience as it marks this milestone anniversary."
  },
  {
    "author": "John Hawley",
    "category": "anniversary",
    "id": 3325,
    "text": "Since I wrote to you last we have got our chapel beautifully lighted with gas and have had our anniversary."
  },
  {
    "author": "Phil Lesh",
    "category": "anniversary",
    "id": 3346,
    "text": "Actually, the year anniversary of what you just heard, my son Grahame and I are going to be in a play together, and I'm acting for the first time in front of an audience that doesn't consist of a high school drama class."
  },
  {
    "author": "Ali Larter",
    "category": "anniversary",
    "id": 3321,
    "text": "But to sustain a marriage for 50 years, you have to get real a little bit and find someone who is understanding and who you can grow with. My mom always says, 'Marry the man who loves you a millimeter more.'"
  },
  {
    "author": "Elliot Richardson",
    "category": "anniversary",
    "id": 3344,
    "text": "This anniversary serves to help remind the American people that, in the wake of one of the greatest political scandals and misuse of power in our history as a nation, scandal produced important reforms that served this nation well for two decades."
  },
  {
    "author": "Boris Pasternak",
    "category": "anniversary",
    "id": 3315,
    "text": "Love is not weakness. It is strong. Only the sacrament of marriage can contain it."
  },
  {
    "author": "Mac Thornberry",
    "category": "anniversary",
    "id": 3323,
    "text": "The day before the anniversary of D-Day, we lost a man who was equaled by few and surpassed by none as a leader in the cause of freedom: Ronald Reagan."
  },
  {
    "author": "Martin Luther",
    "category": "anniversary",
    "id": 3288,
    "text": "There is no more lovely, friendly and charming relationship, communion or company than a good marriage."
  },
  {
    "author": "A. P. Herbert",
    "category": "anniversary",
    "id": 3301,
    "text": "The concept of two people living together for 25 years without a serious dispute suggests a lack of spirit only to be admired in sheep."
  },
  {
    "author": "Graeme Murphy",
    "category": "anniversary",
    "id": 3335,
    "text": "And currently, there are four to five new works in the pipeline for upcoming celebrations such as the Sydney 2000 Olympics, Australian Federation, my 50th Birthday, and Sydney Dance Company's 25th Anniversary."
  },
  {
    "author": "Paul Sweeney",
    "category": "anniversary",
    "id": 3296,
    "text": "A wedding anniversary is the celebration of love, trust, partnership, tolerance and tenacity. The order varies for any given year."
  },
  {
    "author": "Chris Daughtry",
    "category": "anniversary",
    "id": 3314,
    "text": "You marry somebody you love everything about them. You grow to learn about them. You never learn everything."
  },
  {
    "author": "Jim Carrey",
    "category": "anniversary",
    "id": 3303,
    "text": "A lot of good love can happen in ten years."
  },
  {
    "author": "Melanie Chisholm",
    "category": "anniversary",
    "id": 3350,
    "text": "I feel there should have been some recognition of the Spice Girls at this year's 25th anniversary. We flew the flag for Britain around the globe in the 1990s and we achieved a hell of a lot."
  },
  {
    "author": "George Bernard Shaw",
    "category": "anniversary",
    "id": 3290,
    "text": "Marriage is an alliance entered into by a man who can't sleep with the window shut, and a woman who can't sleep with the window open."
  },
  {
    "author": "Zane Grey",
    "category": "anniversary",
    "id": 3317,
    "text": "Love grows more tremendously full, swift, poignant, as the years multiply."
  },
  {
    "author": "Linda Evangelista",
    "category": "anniversary",
    "id": 3349,
    "text": "I did that Dior Couture 60th anniversary show in July. It took so long to get ready, I think I would have rather been watching."
  },
  {
    "author": "Mara Liasson",
    "category": "anniversary",
    "id": 3354,
    "text": "Both the Obama and Romney campaigns said they pulled all their political ads today in observance of the September 11th anniversary. But politics wasn't very far offstage. The Obama campaign sees foreign policy as an advantage this year."
  },
  {
    "author": "Simone Signoret",
    "category": "anniversary",
    "id": 3304,
    "text": "Chains do not hold a marriage together. It is threads, hundreds of tiny threads, which sew people together through the years."
  },
  {
    "author": "Jamie Lee Curtis",
    "category": "anniversary",
    "id": 3316,
    "text": "My mother and stepfather were married 43 years, so I have watched a long marriage. I feel like I had a very good role model for that. And, you know, it's just a number."
  },
  {
    "author": "Blake Shelton",
    "category": "anniversary",
    "id": 3309,
    "text": "I think you have to be willing to take a bullet for somebody if you're going to stand up there, take your vows, and be married to them for the rest of your life."
  },
  {
    "author": "Trey Anastasio",
    "category": "anniversary",
    "id": 3327,
    "text": "I've been sober for two-and-a-half years, My children are happy. In August, my wife and I will celebrate our fifteenth wedding anniversary. My band is back together with a sold-out tour."
  },
  {
    "author": "Henny Youngman",
    "category": "anniversary",
    "id": 3307,
    "text": "I've been in love with the same woman for forty-one years. If my wife finds out, she'll kill me."
  },
  {
    "author": "Kenny Marchant",
    "category": "anniversary",
    "id": 3347,
    "text": "This year, as we celebrate the 230th anniversary of America's independence, please remember the symbols that are sacred to this country. Fly Old Glory high and show your respect and admiration for this great nation and the values we hold dear."
  },
  {
    "author": "Felix Adler",
    "category": "anniversary",
    "id": 3337,
    "text": "Perhaps a hundred people assembled one evening, May 15, 1876, at the time when the country was celebrating the hundredth anniversary of its political independence."
  },
  {
    "author": "Uta Hagen",
    "category": "anniversary",
    "id": 3322,
    "text": "We had a relationship that lasted 44 years. Herbert and I lived together 10 years before we were married. He always gave me a little heart for whatever anniversary."
  },
  {
    "author": "Rosa DeLauro",
    "category": "anniversary",
    "id": 3353,
    "text": "1 month ago the American people stopped to remember the third anniversary of the beginning of the Iraq war. We thought first and foremost of the selflessness, patriotism and heroism by our troops, our National Guard and Reserves."
  },
  {
    "author": "Henry Lawson",
    "category": "anniversary",
    "id": 3342,
    "text": "It is a matter of public shame that while we have now commemorated our hundredth anniversary, not one in every ten children attending Public schools throughout the colonies is acquainted with a single historical fact about Australia."
  },
  {
    "author": "AnnaLynne McCord",
    "category": "anniversary",
    "id": 3352,
    "text": "My last trip to New Orleans was for the fifth anniversary of Katrina, and I had the awesome opportunity to bring my family down. We all worked on a house together and met some of the families."
  },
  {
    "author": "Jonathan Swift",
    "category": "anniversary",
    "id": 3305,
    "text": "Under this window in stormy weather I marry this man and woman together Let none but Him who rules the thunder Put this man and woman asunder."
  },
  {
    "author": "Peter De Vries",
    "category": "anniversary",
    "id": 3306,
    "text": "The bonds of matrimony are like any other bonds - they mature slowly."
  },
  {
    "author": "Eydie Gorme",
    "category": "anniversary",
    "id": 3351,
    "text": "It was very hard for all of us. It's still very hard. The anniversary of his death just passed, and every single one of his friends, still, after all these years... it's unbelievable."
  },
  {
    "author": "Leonard Boswell",
    "category": "anniversary",
    "id": 3343,
    "text": "As the third anniversary of the September 11th attacks draws near we must ensure our nation is prepared to handle the continued threat of violence and terrorism on our country."
  },
  {
    "author": "Buck Owens",
    "category": "anniversary",
    "id": 3340,
    "text": "I was always very grateful to 'em and am grateful to 'em now. I went back a couple of years ago and did their 20th anniversary show. But the longer I stayed on Hee Haw, the worse things got for me musically."
  },
  {
    "author": "William O. Douglas",
    "category": "anniversary",
    "id": 3313,
    "text": "Marriage is a coming together for better or for worse, hopefully enduring, and intimate to the degree of being sacred."
  },
  {
    "author": "Robert Kirkman",
    "category": "anniversary",
    "id": 3341,
    "text": "June 2005 is the five year anniversary of the debut of Battle Pope."
  },
  {
    "author": "Henny Youngman",
    "category": "anniversary",
    "id": 3299,
    "text": "Some people ask the secret of our long marriage. We take time to go to a restaurant two times a week. A little candlelight, dinner, soft music and dancing. She goes Tuesdays, I go Fridays."
  },
  {
    "author": "Tom Lantos",
    "category": "anniversary",
    "id": 3348,
    "text": "On July 18, we will mark the 12th anniversary of the senseless loss of 85 lives in the bombing of the Jewish Cultural Center in Buenos Aires, Argentina."
  },
  {
    "author": "Todd Tiahrt",
    "category": "anniversary",
    "id": 3320,
    "text": "Next month, I will celebrate my 30th anniversary of marriage with my beautiful bride, Vicki. Our marriage has been a blessing. I have gained even more respect for the institution over the past 3 decades and will defend it against attack."
  },
  {
    "author": "Graham Nash",
    "category": "anniversary",
    "id": 3331,
    "text": "We can't forget what happened on May 4th, 1970, when four students gave up their lives because they had the American constitutional right of peaceful protest. They gave up their lives. And to sing that song in that spot on that anniversary was very emotional for us."
  },
  {
    "author": "W. Somerset Maugham",
    "category": "anniversary",
    "id": 3287,
    "text": "We are not the same persons this year as last nor are those we love. It is a happy chance if we, changing, continue to love a changed person."
  },
  {
    "author": "Solomon Ortiz",
    "category": "anniversary",
    "id": 3336,
    "text": "Mr. Speaker, I rise today to recognize the Peace Corps as it reached its 45th anniversary on March 1, 2006."
  }
]

quotes['architecture'] = [
  {
    "author": "Samuel Butler",
    "category": "architecture",
    "id": 3442,
    "text": "Every man's work, whether it be literature, or music or pictures or architecture or anything else, is always a portrait of himself."
  },
  {
    "author": "Tadao Ando",
    "category": "architecture",
    "id": 3469,
    "text": "When you look at Japanese traditional architecture, you have to look at Japanese culture and its relationship with nature. You can actually live in a harmonious, close contact with nature - this very unique to Japan."
  },
  {
    "author": "Antonio Gaudi",
    "category": "architecture",
    "id": 3417,
    "text": "Color in certain places has the great value of making the outlines and structural planes seem more energetic."
  },
  {
    "author": "Marc Newson",
    "category": "architecture",
    "id": 3557,
    "text": "People kind of tend to mystify design and architecture by suggesting you need to train."
  },
  {
    "author": "Arne Jacobsen",
    "category": "architecture",
    "id": 3403,
    "text": "Proportions are what makes the old Greek temples classic in their beauty. They are like huge blocks, from which the air has been literally hewn out between the columns."
  },
  {
    "author": "Thomas a Kempis",
    "category": "architecture",
    "id": 3394,
    "text": "The loftier the building, the deeper must the foundation be laid."
  },
  {
    "author": "William Bennett",
    "category": "architecture",
    "id": 3463,
    "text": "All real education is the architecture of the soul."
  },
  {
    "author": "Louis Kahn",
    "category": "architecture",
    "id": 3529,
    "text": "Every time a student walks past a really urgent, expressive piece of architecture that belongs to his college, it can help reassure him that he does have that mind, does have that soul."
  },
  {
    "author": "Alex Winter",
    "category": "architecture",
    "id": 3573,
    "text": "I take a lot from everywhere. I take from music, architecture, novels, and plays. Anywhere that hits you."
  },
  {
    "author": "Henry David Thoreau",
    "category": "architecture",
    "id": 3431,
    "text": "They can do without architecture who have no olives nor wines in the cellar."
  },
  {
    "author": "Philip Johnson",
    "category": "architecture",
    "id": 3367,
    "text": "Architecture is the art of how to waste space."
  },
  {
    "author": "Julia Morgan",
    "category": "architecture",
    "id": 3424,
    "text": "My buildings will be my legacy... they will speak for me long after I'm gone."
  },
  {
    "author": "Walter Gropius",
    "category": "architecture",
    "id": 3445,
    "text": "Architecture begins where engineering ends."
  },
  {
    "author": "Arthur Erickson",
    "category": "architecture",
    "id": 3467,
    "text": "Today's developer is a poor substitute for the committed entrepreneur of the last century for whom the work of architecture represented a chance to celebrate the worth of his enterprise."
  },
  {
    "author": "Joel Coen",
    "category": "architecture",
    "id": 3552,
    "text": "The architecture of a story can be a little bit different if it's a true story."
  },
  {
    "author": "Tadao Ando",
    "category": "architecture",
    "id": 3526,
    "text": "Spiritual space is lost in gaining convenience. I saw the need to create a mixture of Japanese spiritual culture and modern western architecture."
  },
  {
    "author": "Tadao Ando",
    "category": "architecture",
    "id": 3523,
    "text": "Italy is full of historical buildings. And Europe holds a great history of philosophy from Greece until today. I read all those books and see these buildings, and I think of where I stand when I design my architecture."
  },
  {
    "author": "Kenzo Tange",
    "category": "architecture",
    "id": 3624,
    "text": "Technological considerations are of great importance to architecture and cities in the informational society."
  },
  {
    "author": "John Ruskin",
    "category": "architecture",
    "id": 3448,
    "text": "It is impossible, as impossible as to raise the dead, to restore anything that has ever been great or beautiful in architecture. That which I have insisted upon as the life of the whole, that spirit which is given only by the hand and eye of the workman, can never be recalled."
  },
  {
    "author": "Harry Seidler",
    "category": "architecture",
    "id": 3415,
    "text": "The Romans were not inventors of the supporting arch, but its extended use in vaults and intersecting barrel shapes and domes is theirs."
  },
  {
    "author": "Christopher Wren",
    "category": "architecture",
    "id": 3638,
    "text": "Architecture aims at Eternity."
  },
  {
    "author": "Michael Graves",
    "category": "architecture",
    "id": 3628,
    "text": "I see architecture not as Gropius did, as a moral venture, as truth, but as invention, in the same way that poetry or music or painting is invention."
  },
  {
    "author": "Charles Eames",
    "category": "architecture",
    "id": 3499,
    "text": "In architecture the idea degenerated. Design allows a more direct and pleasurable route."
  },
  {
    "author": "Ian Hamilton Finlay",
    "category": "architecture",
    "id": 3604,
    "text": "The same sort of thing happened in my dispute with the National Trust book: Follies: A National Trust Guide, which implied that the only pleasure you can get from Folly architecture is by calling the architect mad, and by laughing at the architecture."
  },
  {
    "author": "Arthur Erickson",
    "category": "architecture",
    "id": 3479,
    "text": "The way of architecture is the quiet voice that underlies it and has guided it from the beginning."
  },
  {
    "author": "Adam Carolla",
    "category": "architecture",
    "id": 3491,
    "text": "In my early 20s I was so miserable doing construction, I wanted something that paid money. I liked nice stuff. I liked cars and architecture, and things that cost money. I wanted to not swing a hammer, and make money... and not do stuff that was dirty. I attempted to get into comedy. I started to do stand-up, but I wasn't very good at it."
  },
  {
    "author": "James Rouse",
    "category": "architecture",
    "id": 3420,
    "text": "For many years, I have lived uncomfortably with the belief that most planning and architectural design suffers for lack of real and basic purpose. The ultimate purpose, it seems to me, must be the improvement of mankind."
  },
  {
    "author": "Le Corbusier",
    "category": "architecture",
    "id": 3375,
    "text": "Architecture is the learned game, correct and magnificent, of forms assembled in the light."
  },
  {
    "author": "Stephen Gardiner",
    "category": "architecture",
    "id": 3515,
    "text": "The English light is so very subtle, so very soft and misty, that the architecture responded with great delicacy of detail."
  },
  {
    "author": "Caroline Wozniacki",
    "category": "architecture",
    "id": 3508,
    "text": "I'd like to do a lot of things - whether in design or architecture or business."
  },
  {
    "author": "Oren Peli",
    "category": "architecture",
    "id": 3574,
    "text": "I've never owned an Apple product. I like the fact that PCs are open architecture and not locked down like Apple products. I feel that Macs are also unjustifiably overpriced."
  },
  {
    "author": "Helmut Jahn",
    "category": "architecture",
    "id": 3506,
    "text": "The American attitude towards efficiency and execution should always underlie architecture."
  },
  {
    "author": "Tim Gunn",
    "category": "architecture",
    "id": 3543,
    "text": "I don't know why I've always been so captivated by architecture."
  },
  {
    "author": "Stephen Gardiner",
    "category": "architecture",
    "id": 3513,
    "text": "Victorian architecture in the United States was copied straight from England."
  },
  {
    "author": "Daniel Burnham",
    "category": "architecture",
    "id": 3383,
    "text": "Make big plans aim high in hope and work, remembering that a noble, logical diagram once recorded will not die."
  },
  {
    "author": "Bernard Levin",
    "category": "architecture",
    "id": 3636,
    "text": "What has happened to architecture since the second world war that the only passers-by who can contemplate it without pain are those equipped with a white stick and a dog?"
  },
  {
    "author": "Joseph Kosinski",
    "category": "architecture",
    "id": 3602,
    "text": "I went to school for engineering, I studied jazz. So I always had this kind of creative side and technical side, and I thought architecture might be the way to combine them, so I went to architecture school in New York."
  },
  {
    "author": "Ralph Erskine",
    "category": "architecture",
    "id": 3608,
    "text": "The job of buildings is to improve human relations: architecture must ease them, not make them worse."
  },
  {
    "author": "Walter Russell Mead",
    "category": "architecture",
    "id": 3616,
    "text": "You look at the steamboat, the railroad, the car, the airplane - not all of these were invented in the Anglo-American world, but they were popularized and extended by it. They were made possible by the financial architecture, the capital intensive operations invented and developed by the Anglo-Americans."
  },
  {
    "author": "John Irving",
    "category": "architecture",
    "id": 3503,
    "text": "The building of the architecture of a novel - the craft of it - is something I never tire of."
  },
  {
    "author": "Rem Koolhaas",
    "category": "architecture",
    "id": 3555,
    "text": "Escape from the architecture ghetto is one of the major drivers and has been from the very beginning."
  },
  {
    "author": "Audre Lorde",
    "category": "architecture",
    "id": 3461,
    "text": "Poetry is not only dream and vision it is the skeleton architecture of our lives. It lays the foundations for a future of change, a bridge across our fears of what has never been before."
  },
  {
    "author": "Malcolm Wallop",
    "category": "architecture",
    "id": 3598,
    "text": "Doctrines provide an architecture for both Republican and Democrat presidents to carry out policies."
  },
  {
    "author": "Friedrich von Schelling",
    "category": "architecture",
    "id": 3533,
    "text": "Architecture in general is frozen music."
  },
  {
    "author": "Helmut Jahn",
    "category": "architecture",
    "id": 3505,
    "text": "It's my goal to make a building as immaterial as possible. Architecture is a very material thing. It takes a lot of resources, so why not eliminate what you don't need as long as you're able to achieve the same result?"
  },
  {
    "author": "Minoru Yamasaki",
    "category": "architecture",
    "id": 3510,
    "text": "Japanese architecture is very much copied in this country and in Europe."
  },
  {
    "author": "Joseph Kosinski",
    "category": "architecture",
    "id": 3601,
    "text": "Once I got out of architecture school I decided not to be an architect, I just started my own little design studio."
  },
  {
    "author": "Michael Mandelbaum",
    "category": "architecture",
    "id": 3551,
    "text": "If architecture is, as is sometimes said, music set in concrete, then football and basketball may be said to be creativity embodied in team sports."
  },
  {
    "author": "David Byrne",
    "category": "architecture",
    "id": 3466,
    "text": "Architecture theory is very interesting."
  },
  {
    "author": "Richard Meier",
    "category": "architecture",
    "id": 3640,
    "text": "Any work of architecture that has with it some discussion, some polemic, I think is good. It shows that people are interested, people are involved."
  },
  {
    "author": "Jim Woodring",
    "category": "architecture",
    "id": 3599,
    "text": "That Moorish architecture is all over the place, of course. It affects me everywhere I see it, as it does so many people. But Brand Library was a special place to me, and I know I've paid homage to it many times in my drawings."
  },
  {
    "author": "Luis Barragan",
    "category": "architecture",
    "id": 3366,
    "text": "I don't divide architecture, landscape and gardening to me they are one."
  },
  {
    "author": "Michael Graves",
    "category": "architecture",
    "id": 3629,
    "text": "The dialogue of architecture has been centered too long around the idea of truth."
  },
  {
    "author": "Robert Smithson",
    "category": "architecture",
    "id": 3534,
    "text": "Painting, sculpture and architecture are finished, but the art habit continues."
  },
  {
    "author": "Philip Warren Anderson",
    "category": "architecture",
    "id": 3618,
    "text": "I acquired an admiration for Japanese culture, art, and architecture, and learned of the existence of the game of GO, which I still play."
  },
  {
    "author": "Minoru Yamasaki",
    "category": "architecture",
    "id": 3511,
    "text": "If you examine this, I think that you will find that it's the mechanics of Japanese architecture that have been thought of as the direct influence upon our architecture."
  },
  {
    "author": "Bruce Jackson",
    "category": "architecture",
    "id": 3535,
    "text": "Bridges are perhaps the most invisible form of public architecture."
  },
  {
    "author": "Jean Nouvel",
    "category": "architecture",
    "id": 3633,
    "text": "I think architecture has to be a gift."
  },
  {
    "author": "Frank Stella",
    "category": "architecture",
    "id": 3614,
    "text": "Architecture can't fully represent the chaos and turmoil that are part of the human personality, but you need to put some of that turmoil into the architecture, or it isn't real."
  },
  {
    "author": "Ayn Rand",
    "category": "architecture",
    "id": 3358,
    "text": "I don't build in order to have clients. I have clients in order to build."
  },
  {
    "author": "Goldwin Smith",
    "category": "architecture",
    "id": 3567,
    "text": "Every one who has a heart, however ignorant of architecture he may be, feels the transcendent beauty and poetry of the mediaeval churches."
  },
  {
    "author": "James Maslow",
    "category": "architecture",
    "id": 3615,
    "text": "I would like to attend college in the future when I have time. I have always been interested in architecture, so perhaps I would pursue a degree in that or business."
  },
  {
    "author": "Kenzo Tange",
    "category": "architecture",
    "id": 3623,
    "text": "There is a powerful need for symbolism, and that means the architecture must have something that appeals to the human heart. There is a powerful need for symbolism, and that means the architecture must have something that appeals to the human heart."
  },
  {
    "author": "Thom Mayne",
    "category": "architecture",
    "id": 3545,
    "text": "But I absolutely believe that architecture is a social activity that has to do with some sort of communication or places of interaction, and that to change the environment is to change behaviour."
  },
  {
    "author": "John Baldacci",
    "category": "architecture",
    "id": 3620,
    "text": "There is a lot of interest in the arts, music, theatre, filmmaking, engineering, architecture and software design. I think we have now transitioned the modern-day version of the entrepreneur into the creative economy."
  },
  {
    "author": "Adolf Loos",
    "category": "architecture",
    "id": 3384,
    "text": "Architecture arouses sentiments in man. The architect's task therefore, is to make those sentiments more precise."
  },
  {
    "author": "John Portman",
    "category": "architecture",
    "id": 3422,
    "text": "Buildings should serve people, not the other way around."
  },
  {
    "author": "Antonio Gaudi",
    "category": "architecture",
    "id": 3373,
    "text": "Those who look for the laws of Nature as a support for their new works collaborate with the creator."
  },
  {
    "author": "Maya Lin",
    "category": "architecture",
    "id": 3485,
    "text": "I probably spent the first 20 years of my life wanting to be as American as possible. Through my 20s, and into my 30s, I began to become aware of how so much of my art and architecture has a decidedly Eastern character."
  },
  {
    "author": "Ai Weiwei",
    "category": "architecture",
    "id": 3502,
    "text": "I see the Beijing National Stadium as an architectural project. I accepted Herzog and De Meuron's invitation to collaborate on the design, and our proposal won the competition. From beginning to end, I stayed with the project. I am committed to fostering relationships between a city and its architecture."
  },
  {
    "author": "Tony Scott",
    "category": "architecture",
    "id": 3554,
    "text": "We think of enterprise architecture as the process we use for fully describing and mapping business functionality and business requirements and relating them to information systems requirements."
  },
  {
    "author": "Ayn Rand",
    "category": "architecture",
    "id": 3359,
    "text": "A building has integrity just like a man. And just as seldom."
  },
  {
    "author": "Rem Koolhaas",
    "category": "architecture",
    "id": 3497,
    "text": "Any architectural project we do takes at least four or five years, so increasingly there is a discrepancy between the acceleration of culture and the continuing slowness of architecture."
  },
  {
    "author": "Oksana Baiul",
    "category": "architecture",
    "id": 3581,
    "text": "One of my favorite vacation places is Miami, because of the people, the water and the beach - of course - and the architecture on Miami Beach is so wonderful."
  },
  {
    "author": "Maya Lin",
    "category": "architecture",
    "id": 3488,
    "text": "In art or architecture your project is only done when you say it's done. If you want to rip it apart at the eleventh hour and start all over again, you never finish. I was one of those crazy creatures."
  },
  {
    "author": "Stephen Sprouse",
    "category": "architecture",
    "id": 3613,
    "text": "But after the time there I'd had it with fashion again, so I left to go to architecture school in a summer course at Harvard, which didn't last very long."
  },
  {
    "author": "David Allan Coe",
    "category": "architecture",
    "id": 3390,
    "text": "It is not the beauty of a building you should look at its the construction of the foundation that will stand the test of time."
  },
  {
    "author": "Constantin Brancusi",
    "category": "architecture",
    "id": 3546,
    "text": "Architecture is inhabited sculpture."
  },
  {
    "author": "Oscar Niemeyer",
    "category": "architecture",
    "id": 3588,
    "text": "Architecture is invention."
  },
  {
    "author": "Philip Johnson",
    "category": "architecture",
    "id": 3391,
    "text": "I hate vacations. If you can build buildings, why sit on the beach?"
  },
  {
    "author": "Martin Puryear",
    "category": "architecture",
    "id": 3419,
    "text": "At a certain point, I just put the building and the art impulse together. I decided that building was a legitimate way to make sculpture."
  },
  {
    "author": "Le Corbusier",
    "category": "architecture",
    "id": 3371,
    "text": "A house is a machine for living in."
  },
  {
    "author": "Brad Pitt",
    "category": "architecture",
    "id": 3492,
    "text": "I'm drawn to furniture design as complete architecture on a minor scale."
  },
  {
    "author": "Maya Lin",
    "category": "architecture",
    "id": 3490,
    "text": "Art is very tricky because it's what you do for yourself. It's much harder for me to make those works than the monuments or the architecture."
  },
  {
    "author": "Catherine Deneuve",
    "category": "architecture",
    "id": 3470,
    "text": "I would have liked maybe to be in architecture or painting, something connected to the fine arts."
  },
  {
    "author": "Thom Mayne",
    "category": "architecture",
    "id": 3412,
    "text": "My buildings don't speak in words but by means of their own spaciousness."
  },
  {
    "author": "Gustav Stickley",
    "category": "architecture",
    "id": 3637,
    "text": "First, there is the bare beauty of the logs themselves with their long lines and firm curves. Then there is the open charm felt of the structural features which are not hidden under plaster and ornament, but are clearly revealed, a charm felt in Japanese architecture."
  },
  {
    "author": "Nancy Banks Smith",
    "category": "architecture",
    "id": 3596,
    "text": "In my experience, if you have to keep the lavatory door shut by extending your left leg, it's modern architecture."
  },
  {
    "author": "Saul Steinberg",
    "category": "architecture",
    "id": 3421,
    "text": "The frightening thought that what you draw may become a building makes for reasoned lines."
  },
  {
    "author": "Richard Rogers",
    "category": "architecture",
    "id": 3530,
    "text": "I believe very strongly, and have fought since many years ago - at least over 30 years ago - to get architecture not just within schools, but architecture talked about under history, geography, science, technology, art."
  },
  {
    "author": "Martin Mull",
    "category": "architecture",
    "id": 3571,
    "text": "Writing about music is like dancing about architecture."
  },
  {
    "author": "Minoru Yamasaki",
    "category": "architecture",
    "id": 3509,
    "text": "So what we have tried to do in our later buildings is to try to be completely consistent, as a painter is consistent or as a sculptor is consistent. Architecture also must be very consistent."
  },
  {
    "author": "Louis Kahn",
    "category": "architecture",
    "id": 3381,
    "text": "Architecture is the reaching out for the truth."
  },
  {
    "author": "Arne Jacobsen",
    "category": "architecture",
    "id": 3549,
    "text": "If architecture had nothing to do with art, it would be astonishingly easy to build houses, but the architect's task - his most difficult task - is always that of selecting."
  },
  {
    "author": "Federico Garcia Lorca",
    "category": "architecture",
    "id": 3544,
    "text": "The two elements the traveler first captures in the big city are extra human architecture and furious rhythm. Geometry and anguish."
  },
  {
    "author": "Herbert Simon",
    "category": "architecture",
    "id": 3460,
    "text": "Engineering, medicine, business, architecture and painting are concerned not with the necessary but with the contingent - not with how things are but with how they might be - in short, with design."
  },
  {
    "author": "John Portman",
    "category": "architecture",
    "id": 3423,
    "text": "Architects in the past have tended to concentrate their attention on the building as a static object. I believe dynamics are more important: the dynamics of people, their interaction with spaces and environmental condition."
  },
  {
    "author": "Louis Kahn",
    "category": "architecture",
    "id": 3472,
    "text": "Consider the momentous event in architecture when the wall parted and the column became."
  },
  {
    "author": "Oscar Niemeyer",
    "category": "architecture",
    "id": 3540,
    "text": "I search for surprise in my architecture. A work of art should cause the emotion of newness."
  },
  {
    "author": "Bob Barr",
    "category": "architecture",
    "id": 3553,
    "text": "Chicago is known for good steaks, expensive stores and beautiful architecture. Unfortunately, the Windy City also enjoys a reputation for corrupt politics, violent crime, and some of the strictest gun control laws anywhere in the country."
  }
]

quotes['art'] = [
  {
    "author": "Brian Eno",
    "category": "art",
    "id": 4453,
    "text": "At the beginning of the 20th century, the ambition of the great painters was to make paintings that were like music, which was then considered as the noblest art."
  },
  {
    "author": "A. Bartlett Giamatti",
    "category": "art",
    "id": 4238,
    "text": "Teachers believe they have a gift for giving it drives them with the same irrepressible drive that drives others to create a work of art or a market or a building."
  },
  {
    "author": "Henri Matisse",
    "category": "art",
    "id": 3981,
    "text": "What I dream of is an art of balance, of purity and serenity devoid of troubling or depressing subject matter - a soothing, calming influence on the mind, rather like a good armchair which provides relaxation from physical fatigue."
  },
  {
    "author": "Terry Pratchett",
    "category": "art",
    "id": 4394,
    "text": "In the first book of my Discworld series, published more than 26 years ago, I introduced Death as a character there was nothing particularly new about this - death has featured in art and literature since medieval times, and for centuries we have had a fascination with the Grim Reaper."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4303,
    "text": "Many museums are drawing audiences with art that is ostensibly more entertaining than stuff that just sits and invites contemplation. Interactivity, gizmos, eating, hanging out, things that make noise - all are now the norm, often edging out much else."
  },
  {
    "author": "Denis Waitley",
    "category": "art",
    "id": 4024,
    "text": "Winners have the ability to step back from the canvas of their lives like an artist gaining perspective. They make their lives a work of art - an individual masterpiece."
  },
  {
    "author": "Frank Lloyd Wright",
    "category": "art",
    "id": 4048,
    "text": "The mother art is architecture. Without an architecture of our own we have no soul of our own civilization."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4280,
    "text": "I like that the art world isn't regulated."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4333,
    "text": "'Untitled' is a time machine that can transport you to 1992, an edgy moment when the art world was crumbling, money was scarce, and artists like Tiravanija were in the nascent stages of combining Happenings, performance art, John Cage, Joseph Beuys, and the do-it-yourself ethos of punk. Meanwhile, a new art world was coming into being."
  },
  {
    "author": "Arthur Balfour",
    "category": "art",
    "id": 4585,
    "text": "He has only half learned the art of reading who has not added to it the more refined art of skipping and skimming."
  },
  {
    "author": "John Donne",
    "category": "art",
    "id": 4123,
    "text": "Death be not proud, though some have called thee Mighty and dreadful, for thou art not so. For, those, whom thou think'st thou dost overthrow. Die not, poor death, nor yet canst thou kill me."
  },
  {
    "author": "Edward Steichen",
    "category": "art",
    "id": 3791,
    "text": "Every other artist begins with a blank canvas, a piece of paper the photographer begins with the finished product."
  },
  {
    "author": "Arthur Erickson",
    "category": "art",
    "id": 3798,
    "text": "Vitality is radiated from exceptional art and architecture."
  },
  {
    "author": "Henri Matisse",
    "category": "art",
    "id": 3762,
    "text": "I don't paint things. I only paint the difference between things."
  },
  {
    "author": "Charles Baudelaire",
    "category": "art",
    "id": 4124,
    "text": "Evil is committed without effort, naturally, fatally goodness is always the product of some art."
  },
  {
    "author": "Ben Okri",
    "category": "art",
    "id": 4637,
    "text": "Magic becomes art when it has nothing to hide."
  },
  {
    "author": "John Donne",
    "category": "art",
    "id": 4471,
    "text": "Art is the most passionate orgy within man's grasp."
  },
  {
    "author": "John Ruskin",
    "category": "art",
    "id": 3706,
    "text": "Art is not a study of positive reality, it is the seeking for ideal truth."
  },
  {
    "author": "William Morris",
    "category": "art",
    "id": 4449,
    "text": "History has remembered the kings and warriors, because they destroyed art has remembered the people, because they created."
  },
  {
    "author": "Federico Fellini",
    "category": "art",
    "id": 3759,
    "text": "All art is autobiographical. The pearl is the oyster's autobiography."
  },
  {
    "author": "Henri Matisse",
    "category": "art",
    "id": 3777,
    "text": "Drawing is like making an expressive gesture with the advantage of permanence."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "art",
    "id": 3850,
    "text": "Love of beauty is taste. The creation of beauty is art."
  },
  {
    "author": "Kemal Ataturk",
    "category": "art",
    "id": 4388,
    "text": "A nation devoid of art and artists cannot have a full existence."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "art",
    "id": 3691,
    "text": "The mediator of the inexpressible is the work of art."
  },
  {
    "author": "Honore de Balzac",
    "category": "art",
    "id": 4026,
    "text": "The art of motherhood involves much silent, unobtrusive self-denial, an hourly devotion which finds no detail too minute."
  },
  {
    "author": "Honore de Balzac",
    "category": "art",
    "id": 4035,
    "text": "What is art? Nature concentrated."
  },
  {
    "author": "William Hazlitt",
    "category": "art",
    "id": 4090,
    "text": "Life is the art of being well deceived and in order that the deception may succeed it must be habitual and uninterrupted."
  },
  {
    "author": "C. S. Lewis",
    "category": "art",
    "id": 3844,
    "text": "Friendship is unnecessary, like philosophy, like art... It has no survival value rather it is one of those things that give value to survival."
  },
  {
    "author": "W. H. Auden",
    "category": "art",
    "id": 4499,
    "text": "It's a sad fact about our culture that a poet can earn much more money writing or talking about his art than he can by practicing it."
  },
  {
    "author": "Samuel Butler",
    "category": "art",
    "id": 3737,
    "text": "The history of art is the history of revivals."
  },
  {
    "author": "Herman Melville",
    "category": "art",
    "id": 4212,
    "text": "To know how to grow old is the master work of wisdom, and one of the most difficult chapters in the great art of living."
  },
  {
    "author": "Nathaniel Hawthorne",
    "category": "art",
    "id": 4075,
    "text": "Religion and art spring from the same root and are close kin. Economics and art are strangers."
  },
  {
    "author": "Beatrice Wood",
    "category": "art",
    "id": 4491,
    "text": "And I have exposed myself to art so that my work has something beyond just the usual potter."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4290,
    "text": "The price of a work of art has nothing to do with what the work of art is, can do, or is worth on an existential, alchemical level."
  },
  {
    "author": "Austin O'Malley",
    "category": "art",
    "id": 4466,
    "text": "Reason clears and plants the wilderness of the imagination to harvest the wheat of art."
  },
  {
    "author": "Jane Campion",
    "category": "art",
    "id": 4635,
    "text": "I did this Super-8 film at art school called 'Tissues,' this black comedy about a family whose father has been arrested for child molestation. I was absolutely thrilled by every inch of it, and would throw my projector in the back of my car and show it to anybody who would watch it."
  },
  {
    "author": "Robert Carlyle",
    "category": "art",
    "id": 4639,
    "text": "My first love is art, and I see a lot of things in an artistic way."
  },
  {
    "author": "Edmund Burke",
    "category": "art",
    "id": 4021,
    "text": "Poetry is the art of substantiating shadows, and of lending existence to nothing."
  },
  {
    "author": "Max Beerbohm",
    "category": "art",
    "id": 4497,
    "text": "When hospitality becomes an art it loses its very soul."
  },
  {
    "author": "Octavio Paz",
    "category": "art",
    "id": 3817,
    "text": "Art is an invention of aesthetics, which in turn is an invention of philosophers... What we call art is a game."
  },
  {
    "author": "Henry Rollins",
    "category": "art",
    "id": 3995,
    "text": "Being an artist is dragging your innermost feelings out, giving a piece of yourself, no matter in which art form, in which medium."
  },
  {
    "author": "William Blake",
    "category": "art",
    "id": 4001,
    "text": "Art can never exist without naked beauty displayed."
  },
  {
    "author": "Rene Magritte",
    "category": "art",
    "id": 4573,
    "text": "Art evokes the mystery without which the world would not exist."
  },
  {
    "author": "Helen Rowland",
    "category": "art",
    "id": 4443,
    "text": "A Bachelor of Arts is one who makes love to a lot of women, and yet has the art to remain a bachelor."
  },
  {
    "author": "Robert Delaunay",
    "category": "art",
    "id": 3813,
    "text": "Vision is the true creative rhythm."
  },
  {
    "author": "Steve Martin",
    "category": "art",
    "id": 4170,
    "text": "There's a lot of thought in art. People get to talk about important things. There's a lot of sex, you know, in art. There's a lot of naked women and men, and there's intrigue, there's fakery. It's a real microcosm of the larger world."
  },
  {
    "author": "Paul Valery",
    "category": "art",
    "id": 4367,
    "text": "Politics is the art of preventing people from busying themselves with what is their own business."
  },
  {
    "author": "Robert Mapplethorpe",
    "category": "art",
    "id": 3773,
    "text": "When I work, and in my art, I hold hands with God."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "art",
    "id": 3668,
    "text": "Art is the proper task of life."
  },
  {
    "author": "Georgia O'Keeffe",
    "category": "art",
    "id": 3677,
    "text": "I found I could say things with color and shapes that I couldn't say any other way - things I had no words for."
  },
  {
    "author": "Walter Benjamin",
    "category": "art",
    "id": 4572,
    "text": "The art of storytelling is reaching its end because the epic side of truth, wisdom, is dying out."
  },
  {
    "author": "Charles Morgan",
    "category": "art",
    "id": 4590,
    "text": "The art of living does not consist in preserving and clinging to a particular mode of happiness, but in allowing happiness to change its form without being disappointed by the change happiness, like a child, must be allowed to grow up."
  },
  {
    "author": "Michel Foucault",
    "category": "art",
    "id": 4241,
    "text": "What strikes me is the fact that in our society, art has become something which is only related to objects, and not to individuals, or to life."
  },
  {
    "author": "Golda Meir",
    "category": "art",
    "id": 4398,
    "text": "The public history of modern art is the story of conventional people not knowing what they are dealing with."
  },
  {
    "author": "Ellen Key",
    "category": "art",
    "id": 3831,
    "text": "The more horrifying this world becomes, the more art becomes abstract."
  },
  {
    "author": "Rebecca West",
    "category": "art",
    "id": 4259,
    "text": "Any authentic work of art must start an argument between the artist and his audience."
  },
  {
    "author": "Theodore Bikel",
    "category": "art",
    "id": 4640,
    "text": "In my world, history comes down to language and art. No one cares much about what battles were fought, who won them and who lost them - unless there is a painting, a play, a song or a poem that speaks of the event."
  },
  {
    "author": "Billy Idol",
    "category": "art",
    "id": 4629,
    "text": "Rock isn't art, it's the way ordinary people talk."
  },
  {
    "author": "Anatole France",
    "category": "art",
    "id": 4020,
    "text": "The whole art of teaching is only the art of awakening the natural curiosity of young minds for the purpose of satisfying it afterwards."
  },
  {
    "author": "Samuel Johnson",
    "category": "art",
    "id": 4062,
    "text": "Poetry is the art of uniting pleasure with truth."
  },
  {
    "author": "Philip Johnson",
    "category": "art",
    "id": 4099,
    "text": "Architecture is the art of how to waste space."
  },
  {
    "author": "Oscar Wilde",
    "category": "art",
    "id": 3861,
    "text": "All art is quite useless."
  },
  {
    "author": "George Jean Nathan",
    "category": "art",
    "id": 4058,
    "text": "To speak of morals in art is to speak of legislature in sex. Art is the sex of the imagination."
  },
  {
    "author": "Thomas Edward Brown",
    "category": "art",
    "id": 4584,
    "text": "Every man should follow the bent of his nature in art and letters, always provided that he does not offend against the rules of morality and good taste."
  },
  {
    "author": "Quentin Tarantino",
    "category": "art",
    "id": 4169,
    "text": "I like it when somebody tells me a story, and I actually really feel that that's becoming like a lost art in American cinema."
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "art",
    "id": 3727,
    "text": "Life is painting a picture, not doing a sum."
  },
  {
    "author": "Steve Martin",
    "category": "art",
    "id": 4171,
    "text": "You want to be a bit compulsive in your art or craft or whatever you do."
  },
  {
    "author": "Groucho Marx",
    "category": "art",
    "id": 3849,
    "text": "Politics is the art of looking for trouble, finding it everywhere, diagnosing it incorrectly and applying the wrong remedies."
  },
  {
    "author": "Edward Hopper",
    "category": "art",
    "id": 4224,
    "text": "The trend in some of the contemporary movements in art, but by no means all, seems to deny this ideal and to me appears to lead to a purely decorative conception of painting."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4293,
    "text": "Wolfgang Tillman's stunning large-scale pictures, being shown for the first time, were so offhand I failed to see them as art."
  },
  {
    "author": "Emir Kusturica",
    "category": "art",
    "id": 4560,
    "text": "What you have now is a Hollywood that is pure poison. Hollywood was a central place in the history of art in the 20th century: it was human idealism preserved. And then, like any great place, it collapsed, and it collapsed into the most awful machinery in the world."
  },
  {
    "author": "Marshall McLuhan",
    "category": "art",
    "id": 4484,
    "text": "I think of art, at its most significant, as a DEW line, a Distant Early Warning system that can always be relied on to tell the old culture what is beginning to happen to it."
  },
  {
    "author": "Edgar Allan Poe",
    "category": "art",
    "id": 3891,
    "text": "Were I called on to define, very briefly, the term Art, I should call it 'the reproduction of what the Senses perceive in Nature through the veil of the soul.' The mere imitation, however accurate, of what is in Nature, entitles no man to the sacred name of 'Artist.'"
  },
  {
    "author": "Danica McKellar",
    "category": "art",
    "id": 4261,
    "text": "One of the most amazing things about mathematics is the people who do math aren't usually interested in application, because mathematics itself is truly a beautiful art form. It's structures and patterns, and that's what we love, and that's what we get off on."
  },
  {
    "author": "William Bernbach",
    "category": "art",
    "id": 4265,
    "text": "Advertising is fundamentally persuasion and persuasion happens to be not a science, but an art."
  },
  {
    "author": "Leo Tolstoy",
    "category": "art",
    "id": 3712,
    "text": "To say that a work of art is good, but incomprehensible to the majority of men, is the same as saying of some kind of food that it is very good but that most people can't eat it."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4331,
    "text": "A canon is antithetical to everything the New York art world has been about for the past 40 years, during which we went from being the center of the art world to being one of many centers."
  },
  {
    "author": "Wilson Mizner",
    "category": "art",
    "id": 4233,
    "text": "It is not in life, but in art that self-fulfillment is to be found."
  },
  {
    "author": "George Bernard Shaw",
    "category": "art",
    "id": 3901,
    "text": "She had lost the art of conversation but not, unfortunately, the power of speech."
  },
  {
    "author": "E. M. Forster",
    "category": "art",
    "id": 4039,
    "text": "History develops, art stands still."
  },
  {
    "author": "Cesare Pavese",
    "category": "art",
    "id": 4257,
    "text": "The art of living is the art of knowing how to believe lies."
  },
  {
    "author": "Frederic Chopin",
    "category": "art",
    "id": 4143,
    "text": "Simplicity is the final achievement. After one has played a vast quantity of notes and more notes, it is simplicity that emerges as the crowning reward of art."
  },
  {
    "author": "Jean Anouilh",
    "category": "art",
    "id": 4514,
    "text": "Life is very nice, but it lacks form. It's the aim of art to give it some."
  },
  {
    "author": "Confucius",
    "category": "art",
    "id": 3872,
    "text": "Speak the truth, do not yield to anger give, if thou art asked for little by these three steps thou wilt go near the gods."
  },
  {
    "author": "Norah Jones",
    "category": "art",
    "id": 4522,
    "text": "Success and the art of making music are two different things for me."
  },
  {
    "author": "Charlie Sheen",
    "category": "art",
    "id": 3909,
    "text": "We're going to shoot one Polaroid per show. I'm going to sign this before it even develops because I know that once it develops with my signature on it, it's worth a fortune. I'll make this a work of magic warlock art."
  },
  {
    "author": "Lenny Bruce",
    "category": "art",
    "id": 4095,
    "text": "The only honest art form is laughter, comedy. You can't fake it... try to fake three laughs in an hour - ha ha ha ha ha - they'll take you away, man. You can't."
  },
  {
    "author": "Auguste Rodin",
    "category": "art",
    "id": 4433,
    "text": "Art is contemplation. It is the pleasure of the mind which searches into nature and which there divines the spirit of which nature herself is animated."
  },
  {
    "author": "Robert Redford",
    "category": "art",
    "id": 4474,
    "text": "It's an honor putting art above politics. Politics can be seductive in terms of things reductive to the soul."
  },
  {
    "author": "John Ruskin",
    "category": "art",
    "id": 4019,
    "text": "Great nations write their autobiographies in three manuscripts - the book of their deeds, the book of their words and the book of their art."
  },
  {
    "author": "Walt Disney",
    "category": "art",
    "id": 3931,
    "text": "I never called my work an 'art'. It's part of show business, the business of building entertainment."
  },
  {
    "author": "W. H. Auden",
    "category": "art",
    "id": 4500,
    "text": "Art is our chief means of breaking bread with the dead."
  },
  {
    "author": "David Rockefeller",
    "category": "art",
    "id": 4592,
    "text": "I think of art as the highest level of creativity. To me, it is one of the greatest sources of enjoyment."
  },
  {
    "author": "Camille Paglia",
    "category": "art",
    "id": 4543,
    "text": "The 1990s, after the reign of terror of academic vandalism, will be a decade of restoration: restoration of meaning, value, beauty, pleasure, and emotion to art and restoration of art to its audience."
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4273,
    "text": "The art gods cooked up something special for James Ensor."
  },
  {
    "author": "David Foster Wallace",
    "category": "art",
    "id": 4552,
    "text": "The problem is that once the rules of art are debunked, and once the unpleasant realities the irony diagnoses are revealed and diagnosed, 'then' what do we do?"
  },
  {
    "author": "Jerry Saltz",
    "category": "art",
    "id": 4328,
    "text": "A saboteur in the house of art and a comedienne in the house of art theory, Lawler has spent three decades documenting the secret life of art. Functioning as a kind of one-woman CSI unit, she has photographed pictures and objects in collectors' homes, in galleries, on the walls of auction houses, and off the walls, in museum storage."
  },
  {
    "author": "Nicolas Chamfort",
    "category": "art",
    "id": 4611,
    "text": "The art of the parenthesis is one of the greatest secrets of eloquence in Society."
  },
  {
    "author": "Aristotle",
    "category": "art",
    "id": 3854,
    "text": "Those who educate children well are more to be honored than they who produce them for these only gave them life, those the art of living well."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "art",
    "id": 3662,
    "text": "A picture is worth a thousand words."
  }
]

quotes['attitude'] = [
  {
    "author": "Thomas Jefferson",
    "category": "attitude",
    "id": 4646,
    "text": "Nothing can stop the man with the right mental attitude from achieving his goal nothing on earth can help the man with the wrong mental attitude."
  },
  {
    "author": "Simon Cowell",
    "category": "attitude",
    "id": 4668,
    "text": "My attitude is, if someone's going to criticize me, tell me to my face."
  },
  {
    "author": "William Lyon Mackenzie King",
    "category": "attitude",
    "id": 4936,
    "text": "Regardless of what one's attitude towards prohibition may be, temperance is something against which, at a time of war, no reasonable protest can be made."
  },
  {
    "author": "Paul Valery",
    "category": "attitude",
    "id": 4769,
    "text": "Our judgments judge us, and nothing reveals us, exposes our weaknesses, more ingeniously than the attitude of pronouncing upon our fellows."
  },
  {
    "author": "Joel Osteen",
    "category": "attitude",
    "id": 4643,
    "text": "Choosing to be positive and having a grateful attitude is going to determine how you're going to live your life."
  },
  {
    "author": "Angus Young",
    "category": "attitude",
    "id": 4798,
    "text": "Yes, we're still five little people with a noisy attitude."
  },
  {
    "author": "Joseph Ratzinger",
    "category": "attitude",
    "id": 4903,
    "text": "Having a clear faith, based on the creed of the church is often labeled today as fundamentalism. Whereas relativism, which is letting oneself be tossed and swept along by every wind of teaching, look like the only attitude acceptable to today's standards."
  },
  {
    "author": "Benny Green",
    "category": "attitude",
    "id": 5021,
    "text": "Any time I need to get a serious attitude adjustment, I put on one of their records, and there are examples there for all time to keep us honest and keep us reaching they'll never be eclipsed."
  },
  {
    "author": "Ludwig Wittgenstein",
    "category": "attitude",
    "id": 4794,
    "text": "Not every religion has to have St. Augustine's attitude to sex. Why even in our culture marriages are celebrated in a church, everyone present knows what is going to happen that night, but that doesn't prevent it being a religious ceremony."
  },
  {
    "author": "Koo Stark",
    "category": "attitude",
    "id": 5096,
    "text": "I was entirely natural and in many ways I have the same attitude now. I don't mourn the loss of my youth because I believe you should enjoy what you have while you have it."
  },
  {
    "author": "Jeffrey Archer",
    "category": "attitude",
    "id": 4896,
    "text": "I think my attitude to human beings has changed since leaving prison."
  },
  {
    "author": "Mick Mars",
    "category": "attitude",
    "id": 5113,
    "text": "When I drank, I had a very different attitude towards my playing. It was sloppier but I kind of liked it that way. It was like the alcohol was telling my mind what to do."
  },
  {
    "author": "Billy Graham",
    "category": "attitude",
    "id": 4725,
    "text": "If a person gets his attitude toward money straight, it will help straighten out almost every other area in his life."
  },
  {
    "author": "Candace Bushnell",
    "category": "attitude",
    "id": 4925,
    "text": "The key to life is your attitude. Whether you're single or married or have kids or don't have kids, it's how you look at your life, what you make of it. It's about making the best of your life wherever you are in life."
  },
  {
    "author": "Michael Chang",
    "category": "attitude",
    "id": 4945,
    "text": "I feel like I have as good a shot as anybody out there and I have gotten close in the past, so why not have the attitude that I can come out and play great tennis and maybe even win this tournament."
  },
  {
    "author": "Jessica Brown Findlay",
    "category": "attitude",
    "id": 4953,
    "text": "I just really think every job I do, I get this gypsy attitude to money."
  },
  {
    "author": "Christian Louboutin",
    "category": "attitude",
    "id": 4887,
    "text": "I mean, the shoe - there is a music to it, there is attitude, there is sound, it's a movement. Clothes - it's a different story. There are a million things I'd rather do before designing clothes: directing, landscaping."
  },
  {
    "author": "Pim Fortuyn",
    "category": "attitude",
    "id": 5128,
    "text": "Muslims have a very bad attitude to homosexuality, they're very intolerant."
  },
  {
    "author": "Michael Kinsley",
    "category": "attitude",
    "id": 5042,
    "text": "In 1977, at least, he wished to have people believe that he shared and was proud of an attitude toward women that is not acceptable in a politician. In 2003, all he has said is that he doesn't remember the interview."
  },
  {
    "author": "Tobey Maguire",
    "category": "attitude",
    "id": 5046,
    "text": "I just try to try to keep an attitude that I don't know what I'm doing. Not to the point where I'm beating myself up, but I just go in thinking that I have a lot to learn. And I hope I still have that attitude 30 years from now."
  },
  {
    "author": "Theodor Herzl",
    "category": "attitude",
    "id": 4969,
    "text": "It goes without saying that the Jewish people can have no other goal than Palestine and that, whatever the fate of the proposition may be, our attitude toward the land of our fathers is and shall remain unchangeable."
  },
  {
    "author": "Vic Snyder",
    "category": "attitude",
    "id": 5123,
    "text": "If you eat something and get fat, you should be responsible for it. I think that is the attitude of the great majority of Americans, that you should be responsible for what you eat."
  },
  {
    "author": "Frank Press",
    "category": "attitude",
    "id": 5017,
    "text": "My attitude toward graduate students was different, I must say. I used graduate students as colleagues: I gave them the best problems to work on, and I encouraged them."
  },
  {
    "author": "Nick Clooney",
    "category": "attitude",
    "id": 4973,
    "text": "It is impossible to exaggerate the wide, and widening, gulf between the American attitude on the Iraq war and the view from our friends across the Atlantic."
  },
  {
    "author": "Loretta Lynn",
    "category": "attitude",
    "id": 4775,
    "text": "My attitude toward men who mess around is simple: If you find 'em, kill 'em."
  },
  {
    "author": "Edward Heath",
    "category": "attitude",
    "id": 5027,
    "text": "Abhorrence of apartheid is a moral attitude, not a policy."
  },
  {
    "author": "George H. Mead",
    "category": "attitude",
    "id": 4959,
    "text": "To so enter into it in nature and art that the enjoyed meanings of life may become a part of living is the attitude of aesthetic appreciation."
  },
  {
    "author": "William Minto",
    "category": "attitude",
    "id": 5134,
    "text": "An attitude of philosophic doubt, of suspended judgment, is repugnant to the natural man. Belief is an independent joy to him."
  },
  {
    "author": "Michael Ramsey",
    "category": "attitude",
    "id": 5052,
    "text": "Reason is an action of the mind knowledge is a possession of the mind but faith is an attitude of the person. It means you are prepared to stake yourself on something being so."
  },
  {
    "author": "Carson Daly",
    "category": "attitude",
    "id": 4975,
    "text": "I hope 'The Voice' has a fifteen-year run, don't get me wrong. But I come from nothing, and maybe it's the Irish in me, but my attitude is always like, 'They'll figure me out soon.'"
  },
  {
    "author": "Todd Phillips",
    "category": "attitude",
    "id": 4955,
    "text": "There's a punk-rock attitude, clearly, to 'Hated.' There's even a punk-rock attitude to 'The Hangover,' I think. We start the movie with a Glenn Danzig song."
  },
  {
    "author": "Walter Scott",
    "category": "attitude",
    "id": 4751,
    "text": "Success or failure in business is caused more by the mental attitude even than by mental capacities."
  },
  {
    "author": "Youssou N'Dour",
    "category": "attitude",
    "id": 4980,
    "text": "In the West, you have always associated the Islamic faith 100 percent with Arab culture. This in itself is a fundamentalist attitude and it is mistaken."
  },
  {
    "author": "Dar Williams",
    "category": "attitude",
    "id": 4989,
    "text": "If you're looking for can-do, earthy-crunchy attitude then you've got to go to Wisconsin."
  },
  {
    "author": "Boris Spassky",
    "category": "attitude",
    "id": 4920,
    "text": "The place of chess in the society is closely related to the attitude of young people towards our game."
  },
  {
    "author": "Clifford D. Simak",
    "category": "attitude",
    "id": 5057,
    "text": "What do you mean by faith? Is faith enough for Man? Should he be satisfied with faith alone? Is there no way of finding out the truth? Is the attitude of faith, of believing in something for which there can be no more than philosophic proof, the true mark of a Christian?"
  },
  {
    "author": "Arthur Erickson",
    "category": "attitude",
    "id": 4818,
    "text": "Part of our western outlook stems from the scientific attitude and its method of isolating the parts of a phenomenon in order to analyze them."
  },
  {
    "author": "Gary Locke",
    "category": "attitude",
    "id": 4943,
    "text": "The U.S. tries to provide immigrants who grow up here with a world-class education and imbue them with the can-do attitude that has long defined American innovation."
  },
  {
    "author": "Terry Semel",
    "category": "attitude",
    "id": 5097,
    "text": "Our new attitude is how can we put you in front of our customer."
  },
  {
    "author": "Tom Stoppard",
    "category": "attitude",
    "id": 4708,
    "text": "A healthy attitude is contagious but don't wait to catch it from others. Be a carrier."
  },
  {
    "author": "Jo Ann Emerson",
    "category": "attitude",
    "id": 5101,
    "text": "America won the Cold War by protecting our strategic resources from the threat of foreign control. We must bring the same attitude to our trade relationship with China."
  },
  {
    "author": "Taylor Hackford",
    "category": "attitude",
    "id": 4972,
    "text": "I really believe you can predict when someone has a great attitude, a real well of talent."
  },
  {
    "author": "Larisa Oleynik",
    "category": "attitude",
    "id": 5003,
    "text": "I don't know that I have any role models now that are fixed. Definitely my mom - she's the coolest. She's worked really hard her whole life and I just think she's got a great attitude. Moms just know so much it's so silly."
  },
  {
    "author": "W. Clement Stone",
    "category": "attitude",
    "id": 4732,
    "text": "Sales are contingent upon the attitude of the salesman - not the attitude of the prospect."
  },
  {
    "author": "Dale Murphy",
    "category": "attitude",
    "id": 5018,
    "text": "Tommie Aaron taught me how to have a good attitude, to be easy going and not get uptight."
  },
  {
    "author": "Milan Kundera",
    "category": "attitude",
    "id": 4783,
    "text": "Mankind's true moral test, its fundamental test (which lies deeply buried from view), consists of its attitude towards those who are at its mercy: animals. And in this respect mankind has suffered a fundamental debacle, a debacle so fundamental that all others stem from it."
  },
  {
    "author": "Joseph Brodsky",
    "category": "attitude",
    "id": 4870,
    "text": "For a writer only one form of patriotism exists: his attitude toward language."
  },
  {
    "author": "Harold S. Geneen",
    "category": "attitude",
    "id": 4724,
    "text": "Leadership is practiced not so much in words as in attitude and in actions."
  },
  {
    "author": "Diane von Furstenberg",
    "category": "attitude",
    "id": 4684,
    "text": "Attitude is everything."
  },
  {
    "author": "Oscar Wilde",
    "category": "attitude",
    "id": 4653,
    "text": "Morality is simply the attitude we adopt towards people whom we personally dislike."
  },
  {
    "author": "August Wilson",
    "category": "attitude",
    "id": 4981,
    "text": "Jazz in itself is not struggling. That is, the music itself is not struggling... It's the attitude that's in trouble. My plays insist that we should not forget or toss away our history."
  },
  {
    "author": "Christian Louboutin",
    "category": "attitude",
    "id": 4927,
    "text": "When a woman puts on a heel, she has a different posture, a different attitude. She really stands up and has a consciousness of her body."
  },
  {
    "author": "Allen Klein",
    "category": "attitude",
    "id": 4824,
    "text": "You may not be able to change a situation, but with humor you can change your attitude about it."
  },
  {
    "author": "Bart Starr",
    "category": "attitude",
    "id": 5108,
    "text": "Athletic competition clearly defines the unique power of our attitude."
  },
  {
    "author": "Damian Lewis",
    "category": "attitude",
    "id": 4854,
    "text": "I've always had a 'Work hard, play hard' attitude to life - I still do - but sometimes you get involved in something that needs a calm, methodical approach."
  },
  {
    "author": "Steve Buscemi",
    "category": "attitude",
    "id": 4962,
    "text": "Bob Altman had this relaxed but serious attitude. Everybody loved him. I wanted him to adopt me."
  },
  {
    "author": "Michael Haneke",
    "category": "attitude",
    "id": 4876,
    "text": "Films for TV have to be much closer to the book, mainly because the objective with a TV movie that translates literature is to get the audience, after seeing this version, to pick up the book and read it themselves. My attitude is that TV can never really be any form of art, because it serves audience expectations."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "attitude",
    "id": 4661,
    "text": "The reactionary is always willing to take a progressive attitude on any issue that is dead."
  },
  {
    "author": "Viktor E. Frankl",
    "category": "attitude",
    "id": 4718,
    "text": "The last of human freedoms - the ability to chose one's attitude in a given set of circumstances."
  },
  {
    "author": "J. Donald Walters",
    "category": "attitude",
    "id": 4681,
    "text": "Happiness is an attitude of mind, born of the simple determination to be happy under all outward circumstances."
  },
  {
    "author": "William J. Brennan, Jr.",
    "category": "attitude",
    "id": 4693,
    "text": "There are no menial jobs, only menial attitudes."
  },
  {
    "author": "Adam Savage",
    "category": "attitude",
    "id": 4784,
    "text": "It's sort of a mental attitude about critical thinking and curiosity. It's about mindset of looking at the world in a playful and curious and creative way."
  },
  {
    "author": "Eliza Dushku",
    "category": "attitude",
    "id": 4934,
    "text": "There is definitely something sexy about a girl with an attitude and a pair of leather pants."
  },
  {
    "author": "Lou Ferrigno",
    "category": "attitude",
    "id": 4689,
    "text": "The attitude is very important. Because, your behavior radiates how you feel."
  },
  {
    "author": "Paul Twitchell",
    "category": "attitude",
    "id": 5102,
    "text": "Our spiritual attitude is determined by our conception of our relation to infinite spirit."
  },
  {
    "author": "Steven Biko",
    "category": "attitude",
    "id": 4735,
    "text": "Black Consciousness is an attitude of the mind and a way of life, the most positive call to emanate from the black world for a long time."
  },
  {
    "author": "Harold Pinter",
    "category": "attitude",
    "id": 4826,
    "text": "Iraq is just a symbol of the attitude of western democracies to the rest of the world."
  },
  {
    "author": "Lita Ford",
    "category": "attitude",
    "id": 5006,
    "text": "It's better for me to play with guys because Rock 'n' Roll has such an aggressive attitude."
  },
  {
    "author": "Pat Riley",
    "category": "attitude",
    "id": 4705,
    "text": "If you have a positive attitude and constantly strive to give your best effort, eventually you will overcome your immediate problems and find you are ready for greater challenges."
  },
  {
    "author": "Clarence Thomas",
    "category": "attitude",
    "id": 4847,
    "text": "Oh, I don't think Tom Sowell would tell anybody to join the administration. That's not his style. But I think his attitude has always been if it had to be done he'd prefer me to do it than somebody else."
  },
  {
    "author": "John Grierson",
    "category": "attitude",
    "id": 4954,
    "text": "My personal view is that such total planning by the state is an absolute good and not simply a relative good... I do not myself think of the attitude I take as deriving from Marx - though this undoubtedly will be suggested - but from Fichte and Hegel."
  },
  {
    "author": "Diane Wakoski",
    "category": "attitude",
    "id": 4996,
    "text": "I think one of the things that language poets are very involved with is getting away from conventional ideas of beauty, because those ideas contain a certain attitude toward women, certain attitudes toward sex, certain attitudes toward race, etc."
  },
  {
    "author": "Aung San Suu Kyi",
    "category": "attitude",
    "id": 4842,
    "text": "My attitude is, do as much as I can while I'm free. And if I'm arrested I'll still do as much as I can."
  },
  {
    "author": "Michael Clarke Duncan",
    "category": "attitude",
    "id": 4928,
    "text": "Whenever I'm having a bad day and have an attitude, I stay home. I keep it at home."
  },
  {
    "author": "Raymond Chandler",
    "category": "attitude",
    "id": 4662,
    "text": "Ability is what you're capable of doing. Motivation determines what you do. Attitude determines how well you do it."
  },
  {
    "author": "Nicos Anastasiades",
    "category": "attitude",
    "id": 5117,
    "text": "The attitude of the people proves that not only do we want to, but that we can succeed in pulling our country out of the difficult position it finds itself in. The banking system of our country will survive and grow."
  },
  {
    "author": "Boomer Esiason",
    "category": "attitude",
    "id": 4909,
    "text": "I have played on many teams throughout my career, and I know when a team has the tools, and the right positive attitude towards winning."
  },
  {
    "author": "Brian Tracy",
    "category": "attitude",
    "id": 4706,
    "text": "You cannot control what happens to you, but you can control your attitude toward what happens to you, and in that, you will be mastering change rather than allowing it to master you."
  },
  {
    "author": "Raymond Chandler",
    "category": "attitude",
    "id": 4758,
    "text": "The minute you try to talk business with him he takes the attitude that he is a gentleman and a scholar, and the moment you try to approach him on the level of his moral integrity he starts to talk business."
  },
  {
    "author": "Dick Cheney",
    "category": "attitude",
    "id": 4848,
    "text": "The Senator from Massachusetts has given us ample grounds to doubt the judgment and the attitude he brings to bear on vital issues of national security."
  },
  {
    "author": "Elizabeth Edwards",
    "category": "attitude",
    "id": 4733,
    "text": "A positive attitude is not going to save you. What it's going to do is, everyday, between now and the day you die, whether that's a short time from now or a long time from now, that every day, you're going to actually live."
  },
  {
    "author": "Imelda Staunton",
    "category": "attitude",
    "id": 5024,
    "text": "Having a child makes you strong and gives you chutzpah. It relaxed my attitude to the job my center of focus shifted, which I think is very helpful, because even if you're not a very indulgent actor you spend a lot of time thinking about yourself. I don't think that is particularly healthy."
  },
  {
    "author": "Khalil Gibran",
    "category": "attitude",
    "id": 4698,
    "text": "Your living is determined not so much by what life brings to you as by the attitude you bring to life not so much by what happens to you as by the way your mind looks at what happens."
  },
  {
    "author": "Juliette Lewis",
    "category": "attitude",
    "id": 4964,
    "text": "Fame can be just so annoying because people are so critical of you. You can't just say, 'hi'. You say hi and people whisper' man did you see the way she said hi? What an attitude."
  },
  {
    "author": "Jack White",
    "category": "attitude",
    "id": 4780,
    "text": "I keep guitars that are, you know, the neck's a little bit bent and it's a little bit out of tune. I want to work and battle it and conquer it and make it express whatever attitude I have at that moment. I want it to be a struggle."
  },
  {
    "author": "Walter Pater",
    "category": "attitude",
    "id": 4917,
    "text": "Not to discriminate every moment some passionate attitude in those about us, and in the very brilliancy of their gifts some tragic dividing on their ways, is, on this short day of frost and sun, to sleep before evening."
  },
  {
    "author": "John McCarthy",
    "category": "attitude",
    "id": 4915,
    "text": "If a person can be said to have the wrong attitude, there is no need to pay attention to his arguments."
  },
  {
    "author": "William Griffith Wilson",
    "category": "attitude",
    "id": 5122,
    "text": "We will see that our new attitude toward liquor has been given to us without any thought or effort on our part. It just comes! That is the miracle of it."
  },
  {
    "author": "Vivienne Westwood",
    "category": "attitude",
    "id": 4808,
    "text": "Britishness is just a way of putting things together and a certain don't care attitude about clothes. You don't care, you just do it and it looks great."
  },
  {
    "author": "Sara Blakely",
    "category": "attitude",
    "id": 4817,
    "text": "I think failure is nothing more than life's way of nudging you that you are off course. My attitude to failure is not attached to outcome, but in not trying. It is liberating. Most people attach failure to something not working out or how people perceive you. This way, it is about answering to yourself."
  },
  {
    "author": "Nia Long",
    "category": "attitude",
    "id": 5007,
    "text": "I think Nina Simone has had an amazing journey. She was spicy and she had attitude and she didn't care, she wanted her money in a paper bag and don't mess with me and I've been doing some research on that so."
  },
  {
    "author": "Asa Gray",
    "category": "attitude",
    "id": 4809,
    "text": "It remains to consider what attitude thoughtful men and Christian believers should take respecting them, and how they stand related to beliefs of another order."
  },
  {
    "author": "Salman Khan",
    "category": "attitude",
    "id": 4992,
    "text": "People are patronizing the theatres with renewed enthusiasm - there is an entire picnic-like attitude when families go out to see movies, which is a very good sign. They want to see larger-than-life characters on the big screen and not just watch movies on television or on DVDs."
  },
  {
    "author": "Phillip Noyce",
    "category": "attitude",
    "id": 5061,
    "text": "After working for years in Hollywood where the actors have taken over, it was a real relief to get down there and not only have some children, but also have some actors that had no attitude."
  },
  {
    "author": "Lita Ford",
    "category": "attitude",
    "id": 4930,
    "text": "I need that aggressive attitude to play my music and more men have that attitude than women."
  },
  {
    "author": "Pope Benedict XVI",
    "category": "attitude",
    "id": 4739,
    "text": "Having a clear faith, based on the creed of the church is often labeled today as fundamentalism. Whereas relativism, which is letting oneself be tossed and swept along by every wind of teaching, look like the only attitude acceptable to today's standards."
  },
  {
    "author": "Thom Mayne",
    "category": "attitude",
    "id": 5044,
    "text": "So at a time in which the media give the public everything it wants and desires, maybe art should adopt a much more aggressive attitude towards the public. I myself am very much inclined to take this position."
  },
  {
    "author": "Charles R. Swindoll",
    "category": "attitude",
    "id": 4712,
    "text": "We cannot change our past. We can not change the fact that people act in a certain way. We can not change the inevitable. The only thing we can do is play on the one string we have, and that is our attitude."
  },
  {
    "author": "James Welch",
    "category": "attitude",
    "id": 5075,
    "text": "The townspeople outside the reservations had a very superior attitude toward Indians, which was kind of funny, because they weren't very wealthy they were on the fringes of society themselves."
  },
  {
    "author": "Jason Bateman",
    "category": "attitude",
    "id": 4939,
    "text": "People have often asked if I'm gay because I don't go out of my way to spit and scratch and give people attitude."
  }
]

quotes['beauty'] = [
  {
    "author": "Eliza Farnham",
    "category": "beauty",
    "id": 5528,
    "text": "The human face is the organic seat of beauty. It is the register of value in development, a record of Experience, whose legitimate office is to perfect the life, a legible language to those who will study it, of the majestic mistress, the soul."
  },
  {
    "author": "Bernard Berenson",
    "category": "beauty",
    "id": 5240,
    "text": "When everything else physical and mental seems to diminish, the appreciation of beauty is on the increase."
  },
  {
    "author": "Delta Burke",
    "category": "beauty",
    "id": 5806,
    "text": "Blanche talks about aging, and why should she be considered poor, because physical beauty is transitory and fading and she has such richness of the soul. I think that speech is so beautiful, and so telling and so true."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "beauty",
    "id": 5477,
    "text": "Beauty is that which is simultaneously attractive and sublime."
  },
  {
    "author": "L. Wolfe Gilbert",
    "category": "beauty",
    "id": 6104,
    "text": "Those who find beauty in all of nature will find themselves at one with the secrets of life itself."
  },
  {
    "author": "Dante Alighieri",
    "category": "beauty",
    "id": 5200,
    "text": "Heat cannot be separated from fire, or beauty from The Eternal."
  },
  {
    "author": "Tom Wolfe",
    "category": "beauty",
    "id": 5753,
    "text": "This is the artist, then, life's hungry man, the glutton of eternity, beauty's miser, glory's slave."
  },
  {
    "author": "John Wooden",
    "category": "beauty",
    "id": 5297,
    "text": "I think permitting the game to become too physical takes away a little bit of the beauty."
  },
  {
    "author": "James Weldon Johnson",
    "category": "beauty",
    "id": 5832,
    "text": "I thought of Paris as a beauty spot on the face of the earth, and of London as a big freckle."
  },
  {
    "author": "Anne Frank",
    "category": "beauty",
    "id": 5169,
    "text": "I don't think of all the misery but of the beauty that still remains."
  },
  {
    "author": "Hans Urs von Balthasar",
    "category": "beauty",
    "id": 5813,
    "text": "It is, finally, a word is untimely in three different senses, and bearing it as one's treasure will not win one anyone's favours one rather risks finding oneself outside everyone's camp... Beauty is the word that shall be our first."
  },
  {
    "author": "Sydney J. Harris",
    "category": "beauty",
    "id": 5554,
    "text": "The beauty of 'spacing' children many years apart lies in the fact that parents have time to learn the mistakes that were made with the older ones - which permits them to make exactly the opposite mistakes with the younger ones."
  },
  {
    "author": "Milan Kundera",
    "category": "beauty",
    "id": 5231,
    "text": "How goodness heightens beauty!"
  },
  {
    "author": "Aldous Huxley",
    "category": "beauty",
    "id": 5303,
    "text": "It was one of those evenings when men feel that truth, goodness and beauty are one. In the morning, when they commit their discovery to paper, when others read it written there, it looks wholly ridiculous."
  },
  {
    "author": "Victoria Justice",
    "category": "beauty",
    "id": 5712,
    "text": "It's nice to just embrace the natural beauty within you."
  },
  {
    "author": "William C. Bryant",
    "category": "beauty",
    "id": 5881,
    "text": "A sculptor wields The chisel, and the stricken marble grows To beauty."
  },
  {
    "author": "John Keats",
    "category": "beauty",
    "id": 5390,
    "text": "Praise or blame has but a momentary effect on the man whose love of beauty in the abstract makes him a severe critic on his own works."
  },
  {
    "author": "America Ferrera",
    "category": "beauty",
    "id": 5855,
    "text": "I just wanted to see every single musical I could. The very first one I saw was 'Beauty and the Beast,' the only one I could get tickets for, and then 'Les Miserables' and then 'Chicago.'"
  },
  {
    "author": "Nina Dobrev",
    "category": "beauty",
    "id": 5633,
    "text": "I was kind of a jock in school. Beauty wasn't something I spent a lot of time on."
  },
  {
    "author": "John Zimmerman",
    "category": "beauty",
    "id": 5542,
    "text": "Beauty is often worse than wine intoxicating both the holder and beholder."
  },
  {
    "author": "Vivienne Westwood",
    "category": "beauty",
    "id": 5537,
    "text": "My beauty secret is absolutely no sun."
  },
  {
    "author": "John Keats",
    "category": "beauty",
    "id": 5401,
    "text": "With a great poet the sense of Beauty overcomes every other consideration, or rather obliterates all consideration."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "beauty",
    "id": 5148,
    "text": "The soul that sees beauty may sometimes walk alone."
  },
  {
    "author": "Xenophon",
    "category": "beauty",
    "id": 5512,
    "text": "A horse is a thing of beauty... none will tire of looking at him as long as he displays himself in his splendor."
  },
  {
    "author": "Selma Blair",
    "category": "beauty",
    "id": 5747,
    "text": "I'm flatchested, I'm short, I'm brunette, I have droopy eyes, and so people have a hard time casting me as a 'beauty.'"
  },
  {
    "author": "Herbie Hancock",
    "category": "beauty",
    "id": 5762,
    "text": "I think there's a great beauty to having problems. That's one of the ways we learn."
  },
  {
    "author": "Pablo Picasso",
    "category": "beauty",
    "id": 5307,
    "text": "Art is not the application of a canon of beauty but what the instinct and the brain can conceive beyond any canon. When we love a woman we don't start measuring her limbs."
  },
  {
    "author": "Marston Morse",
    "category": "beauty",
    "id": 6093,
    "text": "Mathematics are the result of mysterious powers which no one understands, and which the unconscious recognition of beauty must play an important part. Out of an infinity of designs a mathematician chooses one pattern for beauty's sake and pulls it down to earth."
  },
  {
    "author": "James De La Vega",
    "category": "beauty",
    "id": 6035,
    "text": "Beauty magazines make my girlfriend feel ugly."
  },
  {
    "author": "Jude Law",
    "category": "beauty",
    "id": 5705,
    "text": "I'm only wanted by directors for the image I give off, and it makes me angry. I always wanted to be an actor and not a beauty pageant winner."
  },
  {
    "author": "Baruch Spinoza",
    "category": "beauty",
    "id": 5563,
    "text": "I would warn you that I do not attribute to nature either beauty or deformity, order or confusion. Only in relation to our imagination can things be called beautiful or ugly, well-ordered or confused."
  },
  {
    "author": "Pam Grier",
    "category": "beauty",
    "id": 5831,
    "text": "This whole beauty thing is something I've never comprehended."
  },
  {
    "author": "Jerry Saltz",
    "category": "beauty",
    "id": 5450,
    "text": "I love Rauschenberg. I love that he created a turning point in visual history, that he redefined the idea of beauty, that he combined painting, sculpture, photography, and everyday life with such gall, and that he was interested in, as he put it, 'the ability to conceive failure as progress.'"
  },
  {
    "author": "Derek Walcott",
    "category": "beauty",
    "id": 6005,
    "text": "Visual surprise is natural in the Caribbean it comes with the landscape, and faced with its beauty, the sigh of History dissolves."
  },
  {
    "author": "Gwyneth Paltrow",
    "category": "beauty",
    "id": 5646,
    "text": "Beauty, to me is about being comfortable in your own skin."
  },
  {
    "author": "Roberto Cavalli",
    "category": "beauty",
    "id": 5586,
    "text": "I really admire a woman for her intelligence, her personality. Beauty is not enough."
  },
  {
    "author": "Eleanor Roosevelt",
    "category": "beauty",
    "id": 5248,
    "text": "The future belongs to those who believe in the beauty of their dreams."
  },
  {
    "author": "Christo",
    "category": "beauty",
    "id": 5834,
    "text": "And for me, the real world involves everything: risk, danger, beauty, energy, all we meet with in the real world."
  },
  {
    "author": "Samuel Daniel",
    "category": "beauty",
    "id": 6030,
    "text": "Beauty, sweet love, is like the morning dew, Whose short refresh upon tender green, Cheers for a time, but till the sun doth show And straight is gone, as it had never been."
  },
  {
    "author": "James Dean",
    "category": "beauty",
    "id": 5342,
    "text": "I also became close to nature, and am now able to appreciate the beauty with which this world is endowed."
  },
  {
    "author": "Paul Gauguin",
    "category": "beauty",
    "id": 5643,
    "text": "Art requires philosophy, just as philosophy requires art. Otherwise, what would become of beauty?"
  },
  {
    "author": "John Keats",
    "category": "beauty",
    "id": 5283,
    "text": "'Beauty is truth, truth beauty,' - that is all ye know on earth, and all ye need to know."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "beauty",
    "id": 5324,
    "text": "Love is the attempt to form a friendship inspired by beauty."
  },
  {
    "author": "David Amram",
    "category": "beauty",
    "id": 5934,
    "text": "We had common interests in the beauty of the French language. We both had a tremendous love of jazz. We shared dreams of getting married and having a family, living in the country, leading an idyllic life."
  },
  {
    "author": "Miuccia Prada",
    "category": "beauty",
    "id": 5616,
    "text": "Now, I'm not saying I'm fashionable, but there are sociological interests that matter to me, things that are theoretical, political, intellectual and also concerned with vanity and beauty that we all think about but that I try to mix up and translate into fashion."
  },
  {
    "author": "June Jordan",
    "category": "beauty",
    "id": 5694,
    "text": "There are two ways to worry words. One is hoping for the greatest possible beauty in what is created. The other is to tell the truth."
  },
  {
    "author": "Florenz Ziegfeld",
    "category": "beauty",
    "id": 6000,
    "text": "Beauty, of course, is the most important requirement and the paramount asset of the applicant."
  },
  {
    "author": "Priscilla Presley",
    "category": "beauty",
    "id": 5220,
    "text": "Inner beauty should be the most important part of improving one's self."
  },
  {
    "author": "Edwin Way Teale",
    "category": "beauty",
    "id": 5599,
    "text": "For the mind disturbed, the still beauty of dawn is nature's finest balm."
  },
  {
    "author": "Andre Gide",
    "category": "beauty",
    "id": 5358,
    "text": "Through loyalty to the past, our mind refuses to realize that tomorrow's joy is possible only if today's makes way for it that each wave owes the beauty of its line only to the withdrawal of the preceding one."
  },
  {
    "author": "Nigel Barker",
    "category": "beauty",
    "id": 6086,
    "text": "I have a book out called 'The Beauty Equation' and it discusses how off track we have gone in considering beauty."
  },
  {
    "author": "Susie Orbach",
    "category": "beauty",
    "id": 5864,
    "text": "Beauty has been democratised. No longer the preserve of movie stars and models but available to all. But while the invitation to beauty is welcomed, it has become not so much an option as an imperative."
  },
  {
    "author": "Jean Paul",
    "category": "beauty",
    "id": 5454,
    "text": "Beauty attracts us men but if, like an armed magnet it is pointed, beside, with gold and silver, it attracts with tenfold power."
  },
  {
    "author": "Bar Refaeli",
    "category": "beauty",
    "id": 5998,
    "text": "My mum is my beauty icon, because she represents what I think beauty is."
  },
  {
    "author": "William Temple",
    "category": "beauty",
    "id": 5769,
    "text": "You may keep your beauty and your health, unless you destroy them yourself, or discourage them to stay with you, by using them ill."
  },
  {
    "author": "Gustav Stickley",
    "category": "beauty",
    "id": 6080,
    "text": "First, there is the bare beauty of the logs themselves with their long lines and firm curves. Then there is the open charm felt of the structural features which are not hidden under plaster and ornament, but are clearly revealed, a charm felt in Japanese architecture."
  },
  {
    "author": "Craig Ferguson",
    "category": "beauty",
    "id": 5660,
    "text": "It's the beauty and curse of doing a daily show. Some days you've got nothing to talk about and other days Dick Cheney shoots his lawyer in the face and everyone is happy."
  },
  {
    "author": "Christina Aguilera",
    "category": "beauty",
    "id": 5470,
    "text": "Blues and soul and jazz music has so much pain, so much beauty of raw emotion and passion."
  },
  {
    "author": "Ovid",
    "category": "beauty",
    "id": 5192,
    "text": "Beauty is a fragile gift."
  },
  {
    "author": "Rem Koolhaas",
    "category": "beauty",
    "id": 5838,
    "text": "We say we want to create beauty, identity, quality, singularity. And yet, maybe in truth these cities that we have are desired. Maybe their very characterlessness provides the best context for living."
  },
  {
    "author": "Tadao Ando",
    "category": "beauty",
    "id": 5243,
    "text": "You can't really say what is beautiful about a place, but the image of the place will remain vividly with you."
  },
  {
    "author": "Linda Evangelista",
    "category": "beauty",
    "id": 5966,
    "text": "I have to hit the gym. I have beauty appointments. I have to work toward my next job and maintaining my image, just like an athlete."
  },
  {
    "author": "Joan Collins",
    "category": "beauty",
    "id": 5650,
    "text": "And I think of that again as I've written in several of my beauty books, a lot of health comes from the proper eating habits, which are something that - you know, I come from a generation that wasn't - didn't have a lot of food."
  },
  {
    "author": "Isidore Ducasse Lautreamont",
    "category": "beauty",
    "id": 5835,
    "text": "Throughout the centuries, man has considered himself beautiful. I rather suppose that man only believes in his own beauty out of pride that he is not really beautiful and he suspects this himself for why does he look on the face of his fellow-man with such scorn?"
  },
  {
    "author": "Julia Roberts",
    "category": "beauty",
    "id": 5453,
    "text": "During the 80s and 90s, we all became consumed with ourselves. In the 21st century, we've come back to simpler times. People are struggling economically and this has forced them to scale back the material aspects of their lives and realise the beauty of finding the simple joy in being with the people we love."
  },
  {
    "author": "Dita Von Teese",
    "category": "beauty",
    "id": 5801,
    "text": "I really believe that beauty comes from health - sensible eating and exercise."
  },
  {
    "author": "Henry James",
    "category": "beauty",
    "id": 5374,
    "text": "It is art that makes life, makes interest, makes importance... and I know of no substitute whatever for the force and beauty of its process."
  },
  {
    "author": "Imelda Marcos",
    "category": "beauty",
    "id": 5547,
    "text": "It is shallow people who think beauty is frivolous or excessive. If you are bringing beauty and god, you are enriching the country. Rice feeds the body, books feed the mind, beauty feeds the soul. It is one thing I can really be proud of and stand tall in the world."
  },
  {
    "author": "Chaim Potok",
    "category": "beauty",
    "id": 5665,
    "text": "Every man who has shown the world the way to beauty, to true culture, has been a rebel, a 'universal' without patriotism, without home, who has found his people everywhere."
  },
  {
    "author": "Washington Irving",
    "category": "beauty",
    "id": 5439,
    "text": "After all, it is the divinity within that makes the divinity without and I have been more fascinated by a woman of talent and intelligence, though deficient in personal charms, than I have been by the most regular beauty."
  },
  {
    "author": "Pablo Neruda",
    "category": "beauty",
    "id": 5310,
    "text": "The books that help you most are those which make you think that most. The hardest way of learning is that of easy reading but a great book that comes from a great thinker is a ship of thought, deep freighted with truth and beauty."
  },
  {
    "author": "Annie Lennox",
    "category": "beauty",
    "id": 5523,
    "text": "When I look at the majority of my own songs they really came from my own sense of personal confusion or need to express some pain or beauty - they were coming from a universal and personal place."
  },
  {
    "author": "Dan Hawkins",
    "category": "beauty",
    "id": 5965,
    "text": "You can muck around with different guitars for certain bits, but you have to have your own sound. That's your benchmark, that's your sound. I also play a Black Beauty. It sounds amazing."
  },
  {
    "author": "Joseph Joubert",
    "category": "beauty",
    "id": 5415,
    "text": "Grace is in garments, in movements, in manners beauty in the nude, and in forms. This is true of bodies but when we speak of feelings, beauty is in their spirituality, and grace in their moderation."
  },
  {
    "author": "Lauren Conrad",
    "category": "beauty",
    "id": 5603,
    "text": "I've actually spent a lot of time researching beauty products, how they are produced and how they are sold."
  },
  {
    "author": "Zachary Levi",
    "category": "beauty",
    "id": 5877,
    "text": "Being nerdy just means being passionate about something, including everyone - the coolest people on Earth are passionate and therefore nerdy about something whatever it is, whether it's sports, or gaming, or technology, or fashion, or beauty, or food, or whatever."
  },
  {
    "author": "Benjamin Britten",
    "category": "beauty",
    "id": 5265,
    "text": "It is cruel, you know, that music should be so beautiful. It has the beauty of loneliness of pain: of strength and freedom. The beauty of disappointment and never-satisfied love. The cruel beauty of nature and everlasting beauty of monotony."
  },
  {
    "author": "Audrey Hepburn",
    "category": "beauty",
    "id": 5251,
    "text": "The beauty of a woman must be seen from in her eyes, because that is the doorway to her heart, the place where love resides."
  },
  {
    "author": "Cat Stevens",
    "category": "beauty",
    "id": 5460,
    "text": "This is the beauty of the Qur'an: it asks you to reflect and reason, and not to worship the sun or moon but the One who has created everything. The Qur'an asks man to reflect upon the sun and moon and God's creation in general."
  },
  {
    "author": "Rachel Bilson",
    "category": "beauty",
    "id": 5765,
    "text": "I think beauty comes from within, and society paints a ridiculous picture."
  },
  {
    "author": "Melanie Fiona",
    "category": "beauty",
    "id": 5890,
    "text": "I'm a drugstore beauty girl, I love going to the drugstore and buying makeup."
  },
  {
    "author": "Beyonce Knowles",
    "category": "beauty",
    "id": 5715,
    "text": "If I weren't performing, I'd be a beauty editor or a therapist. I love creativity, but I also love to help others. My mother was a hairstylist, and they listen to everyone's problems - like a beauty therapist!"
  },
  {
    "author": "Katherine Heigl",
    "category": "beauty",
    "id": 5564,
    "text": "I'm really proud of myself because I've pared my beauty regimen down to a cream blush and berry-tinted lip balm, which has saved me so much time."
  },
  {
    "author": "Karen Thompson Walker",
    "category": "beauty",
    "id": 5886,
    "text": "Sometimes I think I might not have written 'The Age of Miracles' if I hadn't grown up in California, if I hadn't been exposed to its very particular blend of beauty and disaster, of danger and denial."
  },
  {
    "author": "Camille Paglia",
    "category": "beauty",
    "id": 5209,
    "text": "Beauty is our weapon against nature by it we make objects, giving them limit, symmetry, proportion. Beauty halts and freezes the melting flux of nature."
  },
  {
    "author": "Adam Carolla",
    "category": "beauty",
    "id": 5614,
    "text": "The very definition of 'beauty' is outside."
  },
  {
    "author": "Miley Cyrus",
    "category": "beauty",
    "id": 5397,
    "text": "I don't want to be perfect, but I do want to be a role model. My mom always tells me that imperfections equal beauty. All of us are imperfect."
  },
  {
    "author": "Alfred de Vigny",
    "category": "beauty",
    "id": 5909,
    "text": "Art ought never to be considered except in its relations with its ideal beauty."
  },
  {
    "author": "Mariel Hemingway",
    "category": "beauty",
    "id": 5783,
    "text": "I felt I had to share Idaho with my friend from New York because he'd shared New York with me, so I was going to share the beauty of nature with a man who went to museums and clubs late at night. But there was nothing to do where I lived at night."
  },
  {
    "author": "Leighton Meester",
    "category": "beauty",
    "id": 5658,
    "text": "I really like to be able to have variety and to try different things - that's the beauty of fashion."
  },
  {
    "author": "Victoria Legrand",
    "category": "beauty",
    "id": 6011,
    "text": "I like to find the beauty in the ugly. When I'm in a thrift store, I gravitate toward pieces I know I'll wear a ton, and insane pieces that I'm sure most people would consider gross. But I find them inspiring. Our van is currently stocked with some of my random findings from this tour. Maybe I'll call my aesthetic 'van fashion.'"
  },
  {
    "author": "Maria Montessori",
    "category": "beauty",
    "id": 5372,
    "text": "We especially need imagination in science. It is not all mathematics, nor all logic, but it is somewhat beauty and poetry."
  },
  {
    "author": "Vladimir Kramnik",
    "category": "beauty",
    "id": 5677,
    "text": "For me art and chess are closely related, both are forms in which the self finds beauty and expression."
  },
  {
    "author": "Dimebag Darrell",
    "category": "beauty",
    "id": 5354,
    "text": "When I tried to play something and screwed up, I'd hear some other note that would come into play. Then I started trying different things to find the beauty in it."
  },
  {
    "author": "Virginia Woolf",
    "category": "beauty",
    "id": 5367,
    "text": "The beauty of the world, which is so soon to perish, has two edges, one of laughter, one of anguish, cutting the heart asunder."
  },
  {
    "author": "Helena Christensen",
    "category": "beauty",
    "id": 5781,
    "text": "There will always be a desire for something new, fresh and innovative, as well as a yearning and respect for timeless elegance and beauty."
  },
  {
    "author": "Valentino Garavani",
    "category": "beauty",
    "id": 5880,
    "text": "I love my beauty. It's not my fault."
  },
  {
    "author": "James Russell Lowell",
    "category": "beauty",
    "id": 5376,
    "text": "Poetry is something to make us wiser and better, by continually revealing those types of beauty and truth, which God has set in all men's souls."
  },
  {
    "author": "Milan Kundera",
    "category": "beauty",
    "id": 5234,
    "text": "Without realizing it, the individual composes his life according to the laws of beauty even in times of greatest distress."
  },
  {
    "author": "Jonathan Ive",
    "category": "beauty",
    "id": 5924,
    "text": "There is beauty when something works and it works intuitively."
  }
]

quotes['best'] = [
  {
    "author": "Will Rogers",
    "category": "best",
    "id": 6336,
    "text": "The worst thing that happens to you may be the best thing for you if you don't let it get the best of you."
  },
  {
    "author": "Warren Farrell",
    "category": "best",
    "id": 6689,
    "text": "Throughout my life I have always been amazed that people couldn't listen to other people, that they couldn't hear their best intent, that there seemed to be an enormous need to demonize."
  },
  {
    "author": "Diablo Cody",
    "category": "best",
    "id": 7094,
    "text": "Speaking of Twitter, I don't even know if I composed a blog entry in 2009, as I was too busy parceling my every thought into cute 140-character sound bites. I used to only worry about being pithy for a living now some of my best lines are wasted on a free app!"
  },
  {
    "author": "Leland Stanford",
    "category": "best",
    "id": 6839,
    "text": "A man's sentiments are generally just and right, while it is second selfish thought which makes him trim and adopt some other view. The best reforms are worked out when sentiment operates, as it does in women, with the indignation of righteousness."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "best",
    "id": 6412,
    "text": "Which government is the best? The one that teaches us to govern ourselves."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "best",
    "id": 6577,
    "text": "The best security for civilization is the dwelling, and upon properly appointed and becoming dwellings depends, more than anything else, the improvement of mankind."
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "best",
    "id": 6906,
    "text": "I won't accept anything less than the best a player's capable of doing... and he has the right to expect the best that I can do for him and the team!"
  },
  {
    "author": "Brian Clough",
    "category": "best",
    "id": 6958,
    "text": "I wouldn't say I was the best manager in the business. But I was in the top one."
  },
  {
    "author": "Morgan Freeman",
    "category": "best",
    "id": 6936,
    "text": "Let me be the first to tell you, drinking alcohol is the worst thing to do in cold weather. Hot soup is the best because the process of digesting food helps to warm you up."
  },
  {
    "author": "William Makepeace Thackeray",
    "category": "best",
    "id": 6800,
    "text": "It is best to love wisely, no doubt but to love foolishly is better than not to be able to love at all."
  },
  {
    "author": "William Ellery Channing",
    "category": "best",
    "id": 6891,
    "text": "The best books for a man are not always those which the wise recommend, but often those which meet the peculiar wants, the natural thirst of his mind, and therefore awaken interest and rivet thought."
  },
  {
    "author": "H. Jackson Brown, Jr.",
    "category": "best",
    "id": 6406,
    "text": "The best preparation for tomorrow is doing your best today."
  },
  {
    "author": "Deepak Chopra",
    "category": "best",
    "id": 6547,
    "text": "The intention to live as long as possible isn't one of the mind's best intentions, because quantity isn't the same as quality."
  },
  {
    "author": "Grenville Kleiser",
    "category": "best",
    "id": 6297,
    "text": "Good humor is a tonic for mind and body. It is the best antidote for anxiety and depression. It is a business asset. It attracts and keeps friends. It lightens human burdens. It is the direct route to serenity and contentment."
  },
  {
    "author": "Richard M. Nixon",
    "category": "best",
    "id": 6332,
    "text": "Remember, always give your best. Never get discouraged. Never be petty. Always remember, others may hate you. But those who hate you don't win unless you hate them. And then you destroy yourself."
  },
  {
    "author": "George Eliot",
    "category": "best",
    "id": 6595,
    "text": "For what is love itself, for the one we love best? An enfolding of immeasurable cares which yet are better than any joys outside our love."
  },
  {
    "author": "William Butler Yeats",
    "category": "best",
    "id": 6482,
    "text": "People who lean on logic and philosophy and rational exposition end by starving the best part of the mind."
  },
  {
    "author": "John Ruskin",
    "category": "best",
    "id": 6628,
    "text": "Nearly all the powerful people of this age are unbelievers, the best of them in doubt and misery, the most in plodding hesitation, doing as well as they can, what practical work lies at hand."
  },
  {
    "author": "Roger Federer",
    "category": "best",
    "id": 6798,
    "text": "When you do something best in life, you don't really want to give that up - and for me it's tennis."
  },
  {
    "author": "Lee Iacocca",
    "category": "best",
    "id": 7056,
    "text": "There are times when even the best manager is like the little boy with the big dog, waiting to see where the dog wants to go so he can take him there."
  },
  {
    "author": "Wentworth Miller",
    "category": "best",
    "id": 6946,
    "text": "I have very high expectations of myself. I'm a very competitive person but competitive with myself. I want to be the best that I can be and if that means that I'm eventually better than everyone else then so be it."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "best",
    "id": 6333,
    "text": "The pursuit, even of the best things, ought to be calm and tranquil."
  },
  {
    "author": "Harry Emerson Fosdick",
    "category": "best",
    "id": 6610,
    "text": "He who knows no hardships will know no hardihood. He who faces no calamity will need no courage. Mysterious though it is, the characteristics in human nature which we love best grow in a soil with a strong mixture of troubles."
  },
  {
    "author": "Dean Martin",
    "category": "best",
    "id": 6279,
    "text": "I feel sorry for people who don't drink. They wake up in the morning and that's the best they're going to feel all day."
  },
  {
    "author": "Barbara Feldon",
    "category": "best",
    "id": 6895,
    "text": "I'm not saying that there's anything better than mated bliss at its best, but I'm saying that living alone is as good in its own way. But we haven't quite given ourselves permission to recognize that."
  },
  {
    "author": "Ivana Trump",
    "category": "best",
    "id": 6722,
    "text": "Gorgeous hair is the best revenge."
  },
  {
    "author": "Thomas Sowell",
    "category": "best",
    "id": 6541,
    "text": "Wishful thinking is not idealism. It is self-indulgence at best and self-exaltation at worst. In either case, it is usually at the expense of others. In other words, it is the opposite of idealism."
  },
  {
    "author": "Alben W. Barkley",
    "category": "best",
    "id": 6976,
    "text": "The best audience is intelligent, well-educated and a little drunk."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "best",
    "id": 6745,
    "text": "There are two way of establishing a reputation, one to be praised by honest people and the other to be accused by rogues. It is best, however, to secure the first one, because it will always be accompanied by the latter."
  },
  {
    "author": "Tiger Woods",
    "category": "best",
    "id": 6762,
    "text": "All that really matters is I have two beautiful kids, and I'm trying to be the best dad I can possibly be, and that's the most important thing of all."
  },
  {
    "author": "Anne M. Mulcahy",
    "category": "best",
    "id": 6613,
    "text": "Employees are a company's greatest asset - they're your competitive advantage. You want to attract and retain the best provide them with encouragement, stimulus, and make them feel that they are an integral part of the company's mission."
  },
  {
    "author": "Sam Ewing",
    "category": "best",
    "id": 6676,
    "text": "Success has a simple formula: do your best, and people may like it."
  },
  {
    "author": "Winston Churchill",
    "category": "best",
    "id": 6225,
    "text": "Short words are best and the old words when short are best of all."
  },
  {
    "author": "Josh Billings",
    "category": "best",
    "id": 6862,
    "text": "The best medicine I know for rheumatism is to thank the Lord that it ain't gout."
  },
  {
    "author": "Bryant H. McGill",
    "category": "best",
    "id": 6686,
    "text": "Courtesy is a silver lining around the dark clouds of civilization it is the best part of refinement and in many ways, an art of heroic beauty in the vast gallery of man's cruelty and baseness."
  },
  {
    "author": "James Cash Penney",
    "category": "best",
    "id": 6912,
    "text": "The best teamwork comes from men who are working independently toward one goal in unison."
  },
  {
    "author": "Francis Bacon",
    "category": "best",
    "id": 6604,
    "text": "Certainly the best works, and of greatest merit for the public, have proceeded from the unmarried, or childless men."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "best",
    "id": 6491,
    "text": "The deferring of anger is the best antidote to anger."
  },
  {
    "author": "William Hazlitt",
    "category": "best",
    "id": 6784,
    "text": "A grave blockhead should always go about with a lively one - they show one another off to the best advantage."
  },
  {
    "author": "Andrew Carnegie",
    "category": "best",
    "id": 7015,
    "text": "You must capture and keep the heart of the original and supremely able man before his brain can do its best."
  },
  {
    "author": "Barack Obama",
    "category": "best",
    "id": 6360,
    "text": "In fact, the best thing we could do on taxes for all Americans is to simplify the individual tax code. This will be a tough job, but members of both parties have expressed an interest in doing this, and I am prepared to join them."
  },
  {
    "author": "H. G. Wells",
    "category": "best",
    "id": 6778,
    "text": "In politics, strangely enough, the best way to play your cards is to lay them face upwards on the table."
  },
  {
    "author": "John F. Kennedy",
    "category": "best",
    "id": 6255,
    "text": "We have the power to make this the best generation of mankind in the history of the world or to make it the last."
  },
  {
    "author": "Moliere",
    "category": "best",
    "id": 6212,
    "text": "The trees that are slow to grow bear the best fruit."
  },
  {
    "author": "David Icke",
    "category": "best",
    "id": 6461,
    "text": "The best way of removing negativity is to laugh and be joyous."
  },
  {
    "author": "Denis Waitley",
    "category": "best",
    "id": 6565,
    "text": "You must be worthy of the best, but not more worthy than the rest."
  },
  {
    "author": "Henry Van Dyke",
    "category": "best",
    "id": 7033,
    "text": "Culture is the habit of being pleased with the best and knowing why."
  },
  {
    "author": "William Temple",
    "category": "best",
    "id": 7071,
    "text": "Man's wisdom is his best friend folly his worst enemy."
  },
  {
    "author": "Chuck Palahniuk",
    "category": "best",
    "id": 6598,
    "text": "Some of the best ideas I get seem to happen when I'm doing mindless manual labor or exercise. I'm not sure how that happens, but it leaves me free for remarkable ideas to occur."
  },
  {
    "author": "Orison Swett Marden",
    "category": "best",
    "id": 6535,
    "text": "The size of your accomplishments, the quality of your achievement, will depend very largely on how big a man you see in yourself, what sort of image you get of your possible self, yourself at your best."
  },
  {
    "author": "Aristotle",
    "category": "best",
    "id": 6280,
    "text": "Education is the best provision for old age."
  },
  {
    "author": "Arnold Rothstein",
    "category": "best",
    "id": 7004,
    "text": "If a man is dumb, someone is going to get the best of him, so why not you? If you don't, you're as dumb as he is."
  },
  {
    "author": "Heraclitus",
    "category": "best",
    "id": 6838,
    "text": "The best people renounce all for one goal, the eternal fame of mortals but most people stuff themselves like cattle."
  },
  {
    "author": "Barack Obama",
    "category": "best",
    "id": 6365,
    "text": "We can choose a future where we export more products and outsource fewer jobs. After a decade that was defined by what we bought and borrowed, we're getting back to basics, and doing what America has always done best: We're making things again."
  },
  {
    "author": "Tony Snow",
    "category": "best",
    "id": 6588,
    "text": "Voting is a right best exercised by people who have taken time to learn about the issues."
  },
  {
    "author": "Harry Connick, Jr.",
    "category": "best",
    "id": 6941,
    "text": "I've been all over the world. I love New York, I love Paris, San Francisco, so many places. But there's no place like New Orleans. It's got the best food. It's got the best music. It's got the best people. It's got the most fun stuff to do."
  },
  {
    "author": "E. O. Wilson",
    "category": "best",
    "id": 6254,
    "text": "You are capable of more than you know. Choose a goal that seems right for you and strive to be the best, however hard the path. Aim high. Behave honorably. Prepare to be alone at times, and to endure failure. Persist! The world needs all you can give."
  },
  {
    "author": "Denis Diderot",
    "category": "best",
    "id": 6753,
    "text": "The best doctor is the one you run to and can't find."
  },
  {
    "author": "George Halas",
    "category": "best",
    "id": 6156,
    "text": "Nobody who ever gave his best regretted it."
  },
  {
    "author": "Lyndon B. Johnson",
    "category": "best",
    "id": 6145,
    "text": "I will do my best. That is all I can do. I ask for your help - and God's."
  },
  {
    "author": "Pam Brown",
    "category": "best",
    "id": 7029,
    "text": "If your sister is in a tearing hurry to go out and cannot catch your eye, she's wearing your best sweater."
  },
  {
    "author": "Samuel Smiles",
    "category": "best",
    "id": 7038,
    "text": "Progress however, of the best kind, is comparatively slow. Great results cannot be achieved at once and we must be satisfied to advance in life as we walk, step by step."
  },
  {
    "author": "Gore Vidal",
    "category": "best",
    "id": 6611,
    "text": "In writing and politicking, it's best not to think about it, just do it."
  },
  {
    "author": "Bill Veeck",
    "category": "best",
    "id": 6922,
    "text": "Baseball is almost the only orderly thing in a very unorderly world. If you get three strikes, even the best lawyer in the world can't get you off."
  },
  {
    "author": "Napoleon Hill",
    "category": "best",
    "id": 6383,
    "text": "The best way to sell yourself to others is first to sell the others to yourself."
  },
  {
    "author": "Maria Sharapova",
    "category": "best",
    "id": 6717,
    "text": "When you look good, you feel good. Confidence with what you're wearing is very important. If you feel good, you will always perform your best without worrying about anything."
  },
  {
    "author": "Lil Wayne",
    "category": "best",
    "id": 6707,
    "text": "I just always expect the best because I'm a competitor and if I'm competing, then obviously I'm trying to be better in everything."
  },
  {
    "author": "Thomas Hughes",
    "category": "best",
    "id": 7016,
    "text": "Blessed are they who have the gift of making friends, for it is one of God's best gifts. It involves many things, but above all, the power of going out of one's self, and appreciating whatever is noble and loving in another."
  },
  {
    "author": "Shaun White",
    "category": "best",
    "id": 6777,
    "text": "You know the best thing about competition? There's this whole strategy game, and when it all works out its like solving that hard math equation. You finally get the answer and you're so happy."
  },
  {
    "author": "George Allen, Sr.",
    "category": "best",
    "id": 6521,
    "text": "Work hard, stay positive, and get up early. It's the best part of the day."
  },
  {
    "author": "Orison Swett Marden",
    "category": "best",
    "id": 6426,
    "text": "There is an infinite difference between a little wrong and just right, between fairly good and the best, between mediocrity and superiority."
  },
  {
    "author": "Andy Stern",
    "category": "best",
    "id": 6680,
    "text": "The union movement has been the best middle class job creating program that America has ever had, and it doesn't cost the government a dime."
  },
  {
    "author": "Rosalynn Carter",
    "category": "best",
    "id": 6430,
    "text": "You must accept that you might fail then, if you do your best and still don't win, at least you can be satisfied that you've tried. If you don't accept failure as a possibility, you don't set high goals, you don't branch out, you don't try - you don't take the risk."
  },
  {
    "author": "Selena Gomez",
    "category": "best",
    "id": 6662,
    "text": "I'm human, I'm not perfect. I make mistakes all the time, but I guess my job is to keep those mistakes to myself, which I'm already fine doing and just try to be the best I can be for those kids."
  },
  {
    "author": "Jane Austen",
    "category": "best",
    "id": 6632,
    "text": "We do not look in our great cities for our best morality."
  },
  {
    "author": "Sivananda",
    "category": "best",
    "id": 6665,
    "text": "There is no end of craving. Hence contentment alone is the best way to happiness. Therefore, acquire contentment."
  },
  {
    "author": "Robert Frost",
    "category": "best",
    "id": 6217,
    "text": "The best way out is always through."
  },
  {
    "author": "Kim Kardashian",
    "category": "best",
    "id": 6819,
    "text": "If I look at the message I'm portraying, I think it definitely is be who you are, but be your best you."
  },
  {
    "author": "Walt Whitman",
    "category": "best",
    "id": 6458,
    "text": "Now I see the secret of making the best person: it is to grow in the open air and to eat and sleep with the earth."
  },
  {
    "author": "Clint Eastwood",
    "category": "best",
    "id": 6363,
    "text": "I just think it is important that you realize , that you're the best in the world. Whether you are a Democrat or Republican or whether you're libertarian or whatever, you are the best. And we should not ever forget that. And when somebody does not do the job, we got to let them go."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "best",
    "id": 6110,
    "text": "In any moment of decision, the best thing you can do is the right thing, the next best thing is the wrong thing, and the worst thing you can do is nothing."
  },
  {
    "author": "Drew Barrymore",
    "category": "best",
    "id": 6992,
    "text": "I'm so in control of my life, you shouldn't dislike anything I do-because I'm not only in the best place I've ever been, but it keeps getting better and better."
  },
  {
    "author": "Konrad von Gesner",
    "category": "best",
    "id": 6420,
    "text": "Best of all is it to preserve everything in a pure, still heart, and let there be for every pulse a thanksgiving, and for every breath a song."
  },
  {
    "author": "Terri Clark",
    "category": "best",
    "id": 6807,
    "text": "The best thing to do is stare it in the face and move on. We have to face our fears and plow through. I think taking chances takes a lot more courage than staying stagnant and doing what's safe and comfortable."
  },
  {
    "author": "J. K. Rowling",
    "category": "best",
    "id": 6874,
    "text": "The best of us must sometimes eat our words."
  },
  {
    "author": "Steve Jobs",
    "category": "best",
    "id": 6223,
    "text": "Sometimes when you innovate, you make mistakes. It is best to admit them quickly, and get on with improving your other innovations."
  },
  {
    "author": "Jim Elliot",
    "category": "best",
    "id": 6169,
    "text": "God always gives His best to those who leave the choice with him."
  },
  {
    "author": "Steve Jobs",
    "category": "best",
    "id": 6350,
    "text": "We hire people who want to make the best things in the world."
  },
  {
    "author": "Larry Bird",
    "category": "best",
    "id": 7100,
    "text": "Once you are labeled 'the best' you want to stay up there, and you can't do it by loafing around."
  },
  {
    "author": "Clarence Thomas",
    "category": "best",
    "id": 6739,
    "text": "Good manners will open doors that the best education cannot."
  },
  {
    "author": "Alfred Hitchcock",
    "category": "best",
    "id": 7075,
    "text": "Disney has the best casting. If he doesn't like an actor he just tears him up."
  },
  {
    "author": "Theodor Adorno",
    "category": "best",
    "id": 6929,
    "text": "The splinter in your eye is the best magnifying-glass."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "best",
    "id": 6168,
    "text": "Write it on your heart that every day is the best day in the year."
  },
  {
    "author": "Alan Kay",
    "category": "best",
    "id": 6411,
    "text": "The best way to predict the future is to invent it."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "best",
    "id": 6474,
    "text": "Genius always gives its best at first prudence, at last."
  },
  {
    "author": "Ambrose Bierce",
    "category": "best",
    "id": 6139,
    "text": "The best thing to do with the best things in life is to give them up."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "best",
    "id": 6556,
    "text": "We should often blush for our very best actions, if the world did but see all the motives upon which they were done."
  },
  {
    "author": "Brandy Norwood",
    "category": "best",
    "id": 6982,
    "text": "I've been gone for a long time. I really want to give the fans something that they deserve to have. So, I'm working really hard on this. I really want to make it the best work I've done so far."
  },
  {
    "author": "Napoleon Hill",
    "category": "best",
    "id": 6328,
    "text": "It is literally true that you can succeed best and quickest by helping others to succeed."
  },
  {
    "author": "Orison Swett Marden",
    "category": "best",
    "id": 6532,
    "text": "The best thing about giving of ourselves is that what we get is always better than what we give. The reaction is greater than the action."
  }
]

quotes['birthday'] = [
  {
    "author": "Phylicia Rashad",
    "category": "birthday",
    "id": 7248,
    "text": "Any time women come together with a collective intention, it's a powerful thing. Whether it's sitting down making a quilt, in a kitchen preparing a meal, in a club reading the same book, or around the table playing cards, or planning a birthday party, when women come together with a collective intention, magic happens."
  },
  {
    "author": "Shawn Levy",
    "category": "birthday",
    "id": 7270,
    "text": "Even when I was a kid, I had a good thing with kids. To this day, if I go to a birthday party with one of my kids, I swear to you, I am so much happier hanging out with my kids and their friends than talking to the grown-ups."
  },
  {
    "author": "Puff Daddy",
    "category": "birthday",
    "id": 7213,
    "text": "I have had fans make me the big picture collages of the photo books I have had fans send me birthday cakes... sing to me on my voicemail. I have had fans flash me. I have had older fans give me their bras and underwear onstage."
  },
  {
    "author": "Keith Thibodeaux",
    "category": "birthday",
    "id": 7280,
    "text": "Lucy took care of me on the set, and made sure that none of the crew cussed around me. She also had birthday parties for me and made sure that they were well attended."
  },
  {
    "author": "Bindi Irwin",
    "category": "birthday",
    "id": 7267,
    "text": "I love having my birthday at Australia Zoo."
  },
  {
    "author": "Sloane Crosley",
    "category": "birthday",
    "id": 7206,
    "text": "The Queen of Crafts herself, Martha Stewart, and I have the same birthday. I prefer to think it's the glue-gun wielding, perfect-tart-producing Martha and not the copper pan-throwing, jail-going Martha. But I suppose if I am going to share a calendar square with some of Martha, I have to share it with all of Martha."
  },
  {
    "author": "Blair Underwood",
    "category": "birthday",
    "id": 7241,
    "text": "My son had his eighth birthday recently and we had a chance to borrow the film and show it to all of his friends that was at his birthday party and they loved it. I was a little nervous. I said they might not even like it, and say his daddy's movie is wack, but they loved it."
  },
  {
    "author": "Brittany Snow",
    "category": "birthday",
    "id": 7242,
    "text": "I grew up doing all that stuff because I was obsessed with the '50s. I had sock hops for birthday parties. So I've always done The Twist and stuff. It was pretty natural and, with my parents doing it all the time, I'd just copy them. Not very pretty."
  },
  {
    "author": "Kelly Clarkson",
    "category": "birthday",
    "id": 7188,
    "text": "I just had my 30th birthday and we went turkey shooting. It's what I wanted to do, so we went."
  },
  {
    "author": "Cody Horn",
    "category": "birthday",
    "id": 7283,
    "text": "And I was very shy as a kid if you sang me 'Happy Birthday,' I would cry. Quite shy. So the idea of being an actor, much less a model, was just out of this world."
  },
  {
    "author": "Walter Cronkite",
    "category": "birthday",
    "id": 7234,
    "text": "I want to say that probably 24 hours after I told CBS that I was stepping down at my 65th birthday, I was already regretting it. And I regretted it every day since."
  },
  {
    "author": "Larry David",
    "category": "birthday",
    "id": 7185,
    "text": "I gave a funny speech at my wife's birthday party, and I'm thinking, 'Hey, I've still got it.'"
  },
  {
    "author": "Connie Britton",
    "category": "birthday",
    "id": 7272,
    "text": "For my birthday this year, my girlfriends - who knew I'd just inherited my dad's turntable - gave me a carton of albums like 'Blue Kentucky Girl,' by Emmylou Harris, and 'Off the Wall,' by Michael Jackson. It's all stuff we grew up with. I mean, you can't have a music collection without Prince's 'Purple Rain' - it just can't be done!"
  },
  {
    "author": "Robert Staughton Lynd",
    "category": "birthday",
    "id": 7144,
    "text": "Most of us can remember a time when a birthday - especially if it was one's own - brightened the world as if a second sun has risen."
  },
  {
    "author": "Evan Rachel Wood",
    "category": "birthday",
    "id": 7259,
    "text": "I'll never forget my 24th birthday when my tooth got punched out. And for a second I was like, it would be really hilarious if I sold it on eBay. But I can't, that's just too creepy. I don't think I can go there."
  },
  {
    "author": "Rene Russo",
    "category": "birthday",
    "id": 7189,
    "text": "Every day, every birthday candle I blow out, every penny I throw over my shoulder in a wishing well, every time my daughter says, 'Let's make a wish on a star,' there's one thing I wish for: wisdom."
  },
  {
    "author": "Art Buchwald",
    "category": "birthday",
    "id": 7168,
    "text": "This is a wonderful way to celebrate an 80th birthday... I wanted to be 65 again, but they wouldn't let me - Homeland Security."
  },
  {
    "author": "Ed Koch",
    "category": "birthday",
    "id": 7219,
    "text": "Citizens, thank you for all your birthday wishes. I am 88 years old today and still lucky to live in the greatest city in the world."
  },
  {
    "author": "John Oates",
    "category": "birthday",
    "id": 7134,
    "text": "If you look over the years, the styles have changed - the clothes, the hair, the production, the approach to the songs. The icing to the cake has changed flavors. But if you really look at the cake itself, it's really the same."
  },
  {
    "author": "Kurt Vonnegut",
    "category": "birthday",
    "id": 7131,
    "text": "About astrology and palmistry: they are good because they make people vivid and full of possibilities. They are communism at its best. Everybody has a birthday and almost everybody has a palm."
  },
  {
    "author": "Bobby Sherman",
    "category": "birthday",
    "id": 7256,
    "text": "One I built when I was a kid, and it was a real miniature of Disneyland. I fell in love with the park when I went there with my parents on my 12th birthday."
  },
  {
    "author": "Celine Dion",
    "category": "birthday",
    "id": 7152,
    "text": "I often buy myself presents. Sometimes I will spend $100,000 in one day in a posh boutique."
  },
  {
    "author": "Golda Meir",
    "category": "birthday",
    "id": 7146,
    "text": "Being seventy is not a sin."
  },
  {
    "author": "Jill Clayburgh",
    "category": "birthday",
    "id": 7265,
    "text": "I wasn't very good about juggling family and my career. I was interested in who was coming to the children's birthday party, what my son was writing. I was thinking about Legos."
  },
  {
    "author": "Flip Wilson",
    "category": "birthday",
    "id": 7197,
    "text": "My happiest memory of childhood was my first birthday in reform school. This teacher took an interest in me. In fact, he gave me the first birthday presents I ever got: a box of Cracker Jacks and a can of ABC shoe polish."
  },
  {
    "author": "Mary Antin",
    "category": "birthday",
    "id": 7276,
    "text": "On a royal birthday every house must fly a flag, or the owner would be dragged to a police station and be fined twenty-five rubles."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "birthday",
    "id": 7119,
    "text": "A gift consists not in what is done or given, but in the intention of the giver or doer."
  },
  {
    "author": "Bindi Irwin",
    "category": "birthday",
    "id": 7268,
    "text": "If there's one thing I really want for my birthday, that is for the mining company not to mine my daddy's reserve."
  },
  {
    "author": "Jesse Plemons",
    "category": "birthday",
    "id": 7284,
    "text": "I sing a little bit. I got a guitar for my 16th birthday."
  },
  {
    "author": "Audrey Hepburn",
    "category": "birthday",
    "id": 7173,
    "text": "Success is like reaching an important birthday and finding you're exactly the same."
  },
  {
    "author": "Plautus",
    "category": "birthday",
    "id": 7130,
    "text": "Let us celebrate the occasion with wine and sweet words."
  },
  {
    "author": "Lisa Loeb",
    "category": "birthday",
    "id": 7151,
    "text": "When someone asks if you'd like cake or pie, why not say you want cake and pie?"
  },
  {
    "author": "Gene Tierney",
    "category": "birthday",
    "id": 7200,
    "text": "I had been offered a Hollywood contract before my 18th birthday. It gave me the spark I needed."
  },
  {
    "author": "Julianna Margulies",
    "category": "birthday",
    "id": 7217,
    "text": "The reason I met my husband was because I remembered a friend's birthday. The moral of the story is: Remember people's birthdays."
  },
  {
    "author": "O. J. Simpson",
    "category": "birthday",
    "id": 7252,
    "text": "Nicole will come up in conversations where it's in a part of the conversation. Or we may be somewhere and I would tell some story about their mother and I. You know, we always honor her birthday."
  },
  {
    "author": "Steven Wright",
    "category": "birthday",
    "id": 7116,
    "text": "I remember when the candle shop burned down. Everyone stood around singing 'Happy Birthday.'"
  },
  {
    "author": "Matthew Macfadyen",
    "category": "birthday",
    "id": 7232,
    "text": "I was quite a shy child. I would get terribly nervous and throw up before my birthday party. And then I would be fine. I feel the same now. I get nervous, then it's fine."
  },
  {
    "author": "E. Joseph Cossman",
    "category": "birthday",
    "id": 7147,
    "text": "The best way to remember your wife's birthday is to remember it once."
  },
  {
    "author": "Molly Sims",
    "category": "birthday",
    "id": 7251,
    "text": "My mom FedExes a red velvet cake she makes from scratch to me every birthday."
  },
  {
    "author": "Michael Weatherly",
    "category": "birthday",
    "id": 7249,
    "text": "I started running around my 30th birthday. I wanted to lose weight I didn't anticipate the serenity. Being in motion, suddenly my body was busy and so my head could work out some issues I had swept under a carpet of wine and cheese. Good therapy, that's a good run."
  },
  {
    "author": "Thayer David",
    "category": "birthday",
    "id": 7279,
    "text": "With a recent birthday, I've been acting now for twenty years."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "birthday",
    "id": 7193,
    "text": "When I was a kid, for my birthday every year, my mother made me pasta bechamel, which is rigatoni with a white cream sauce."
  },
  {
    "author": "Mike Wallace",
    "category": "birthday",
    "id": 7209,
    "text": "As I approach my 88th birthday, it's become apparent to me that my eyes and ears, among other appurtenances, aren't quite what they used to be. The prospect of long flights to wherever in search of whatever are not quite as appealing."
  },
  {
    "author": "Steven Wright",
    "category": "birthday",
    "id": 7120,
    "text": "For my birthday I got a humidifier and a de-humidifier... I put them in the same room and let them fight it out."
  },
  {
    "author": "Amanda Seyfried",
    "category": "birthday",
    "id": 7180,
    "text": "I'm most comfortable in my birthday suit."
  },
  {
    "author": "Sloane Crosley",
    "category": "birthday",
    "id": 7204,
    "text": "Since graduation, I have measured time in 4-by-5-inch pieces of paper, four days on the left and three on the right. Every social engagement, interview, reading, flight, doctor's appointment, birthday and dry-cleaning reminder has been handwritten between metal loops."
  },
  {
    "author": "Mikhail Baryshnikov",
    "category": "birthday",
    "id": 7192,
    "text": "I like to go to anybody else's birthday, and if I'm invited I'm a good guest. But I never celebrate my birthdays. I really don't care."
  },
  {
    "author": "Bob Hope",
    "category": "birthday",
    "id": 7121,
    "text": "You know you're getting old when the candles cost more than the cake."
  },
  {
    "author": "Navjot Singh Sidhu",
    "category": "birthday",
    "id": 7157,
    "text": "We'll take the cake with the red cherry on top."
  },
  {
    "author": "Margaret Cho",
    "category": "birthday",
    "id": 7199,
    "text": "Interventions are really emotionally exhausting and I would never ever want to have one. In the same way, I would never want to have a surprise birthday party. That would be horrible."
  },
  {
    "author": "Paulina Porizkova",
    "category": "birthday",
    "id": 7244,
    "text": "My first recognition of age setting in was exactly on my 36th birthday. I have no idea why, on this day of all days, I looked in the mirror and realized my face no longer looked young."
  },
  {
    "author": "Kristin Kreuk",
    "category": "birthday",
    "id": 7273,
    "text": "When I was in elementary school, I used to write letters to myself. I'd write letters and go 'Dear Kristen-at-16-years-old, happy birthday. I hope you're doing something.'"
  },
  {
    "author": "Sue Townsend",
    "category": "birthday",
    "id": 7275,
    "text": "I married two weeks after my 18th birthday, far too young, and by the time I was 23 I was a single mother of three small children, Sean, Daniel and Victoria, living in a prefab house."
  },
  {
    "author": "Mitch Hedberg",
    "category": "birthday",
    "id": 7123,
    "text": "I wanted to buy a candle holder, but the store didn't have one. So I got a cake."
  },
  {
    "author": "Voltaire",
    "category": "birthday",
    "id": 7107,
    "text": "God gave us the gift of life it is up to us to give ourselves the gift of living well."
  },
  {
    "author": "David Horowitz",
    "category": "birthday",
    "id": 7198,
    "text": "If we celebrate Martin Luther King Jr.'s birthday at a time of presidential inaugurals, this is thanks to Ronald Reagan who created the holiday, and not to the Democratic Congress of the Carter years, which rejected it."
  },
  {
    "author": "Yoko Ono",
    "category": "birthday",
    "id": 7156,
    "text": "When I turned 60, it didn't bother me at all."
  },
  {
    "author": "Annie Dillard",
    "category": "birthday",
    "id": 7201,
    "text": "It is ironic that the one thing that all religions recognize as separating us from our creator, our very self-consciousness, is also the one thing that divides us from our fellow creatures. It was a bitter birthday present from evolution."
  },
  {
    "author": "David Bailey",
    "category": "birthday",
    "id": 7190,
    "text": "I left school on my 15th birthday."
  },
  {
    "author": "Sloane Crosley",
    "category": "birthday",
    "id": 7205,
    "text": "I'm a summer baby, so I usually have my birthday as a good summer memory."
  },
  {
    "author": "Robert Frost",
    "category": "birthday",
    "id": 7171,
    "text": "A diplomat is a man who always remembers a woman's birthday but never remembers her age."
  },
  {
    "author": "Graeme Murphy",
    "category": "birthday",
    "id": 7231,
    "text": "And currently, there are four to five new works in the pipeline for upcoming celebrations such as the Sydney 2000 Olympics, Australian Federation, my 50th Birthday, and Sydney Dance Company's 25th Anniversary."
  },
  {
    "author": "Stevie Nicks",
    "category": "birthday",
    "id": 7176,
    "text": "It was my 16th birthday - my mom and dad gave me my Goya classical guitar that day. I sat down, wrote this song, and I just knew that that was the only thing I could ever really do - write songs and sing them to people."
  },
  {
    "author": "Charles Lamb",
    "category": "birthday",
    "id": 7143,
    "text": "New Year's Day is every man's birthday."
  },
  {
    "author": "Jesse Jackson",
    "category": "birthday",
    "id": 7145,
    "text": "Your children need your presence more than your presents."
  },
  {
    "author": "Jennifer Lopez",
    "category": "birthday",
    "id": 7178,
    "text": "You know, maybe I was just born in the wrong time, but I love all things romantic. Puffy understands that. For my last birthday, he covered my hotel room floor with rose petals and had flowers and candles all over the room."
  },
  {
    "author": "Walter Lord",
    "category": "birthday",
    "id": 7281,
    "text": "Brilliantly lit from stem to stern, she looked like a sagging birthday cake."
  },
  {
    "author": "Lisa Loeb",
    "category": "birthday",
    "id": 7225,
    "text": "With my daughter, we do arts and crafts, we read a lot, we listen to music, and we cut the strings off balloons and bounce them around after birthday parties."
  },
  {
    "author": "Lewis Carroll",
    "category": "birthday",
    "id": 7126,
    "text": "There are three hundred and sixty-four days when you might get un-birthday presents, and only one for birthday presents, you know."
  },
  {
    "author": "Goran Ivanisevic",
    "category": "birthday",
    "id": 7271,
    "text": "At her birthday, my seven-year-old daughter will say that she wants these big cakes and certain expensive toys as presents, and I can't say no to her. It would just break my heart. But when I was little, for birthdays we just played outside and we were happy if we got any cake."
  },
  {
    "author": "Susan Orlean",
    "category": "birthday",
    "id": 7187,
    "text": "I want a chainsaw very badly, because I think cutting down a tree would be unbelievably satisfying. I have asked for a chainsaw for my birthday, but I think I'll probably be given jewelry instead."
  },
  {
    "author": "Mindy Kaling",
    "category": "birthday",
    "id": 7194,
    "text": "Anybody can have a birthday. It requires nothing. Murderers have birthdays. It's the opposite of anything that I believe in. And I don't like at work where you stop everything to sing 'Happy Birthday' to someone. I feel like that's for children."
  },
  {
    "author": "Otis Blackwell",
    "category": "birthday",
    "id": 7282,
    "text": "I used to go down every year for the remembrance of Elvis' birthday. Memphis State College invited me to sit in the auditorium and speak to the people for one of those Elvis days."
  },
  {
    "author": "Joe Barton",
    "category": "birthday",
    "id": 7269,
    "text": "The American flag is an enduring symbol of liberty, democracy, and justice. It is fitting that the House act to protect it as we approach our nation's birthday, and as our men and women in uniform rally behind it in Iraq's battlefields."
  },
  {
    "author": "Chris Brown",
    "category": "birthday",
    "id": 7195,
    "text": "My best kiss was on stage. Kelly Rowland from Destiny's Child gave me a really nice soft kiss on my lips during a performance on my birthday. It was amazing."
  },
  {
    "author": "C. S. Lewis",
    "category": "birthday",
    "id": 7114,
    "text": "Thirty was so strange for me. I've really had to come to terms with the fact that I am now a walking and talking adult."
  },
  {
    "author": "Thomas Menino",
    "category": "birthday",
    "id": 7245,
    "text": "And for the city's birthday, we will host events in every neighborhood of the city, inviting all of our residents to share in the celebration of Boston's great epic - the story of neighbors who support one another where it matters most."
  },
  {
    "author": "Matthew Sweet",
    "category": "birthday",
    "id": 7253,
    "text": "I went to a rare live Van Dyke show and met him there. And then he came to a show of mine and we spoke back stage. The third time was at Brian Wilson's birthday party."
  },
  {
    "author": "Samuel Johnson",
    "category": "birthday",
    "id": 7133,
    "text": "The return of my birthday, if I remember it, fills me with thoughts which it seems to be the general care of humanity to escape."
  },
  {
    "author": "Sammy Hagar",
    "category": "birthday",
    "id": 7112,
    "text": "Every year on your birthday, you get a chance to start new."
  },
  {
    "author": "Joe DiMaggio",
    "category": "birthday",
    "id": 7183,
    "text": "You always get a special kick on opening day, no matter how many you go through. You look forward to it like a birthday party when you're a kid. You think something wonderful is going to happen."
  },
  {
    "author": "Jackson Browne",
    "category": "birthday",
    "id": 7238,
    "text": "I told my father I wanted to play the banjo, and so he saved the money and got ready to give me a banjo for my next birthday, and between that time and my birthday, I lost interest in the banjo and was playing guitar."
  },
  {
    "author": "David Sedaris",
    "category": "birthday",
    "id": 7181,
    "text": "It's odd the things that people remember. Parents will arrange a birthday party, certain it will stick in your mind forever. You'll have a nice time, then two years later you'll be like, 'There was a pony there? Really? And a clown with one leg?'"
  },
  {
    "author": "Lionel Blue",
    "category": "birthday",
    "id": 7155,
    "text": "To my surprise, my 70s are nicer than my 60s and my 60s than my 50s, and I wouldn't wish my teens and 20s on my enemies."
  },
  {
    "author": "Susan Orlean",
    "category": "birthday",
    "id": 7186,
    "text": "My ace in the hole as a human being used to be my capacity for remembering birthdays. I worked at it. Whenever I made a new friend, I made a point of finding out his or her birthday early on, and I would record it in my Filofax calendar."
  },
  {
    "author": "Gabriel Byrne",
    "category": "birthday",
    "id": 7117,
    "text": "Presents don't really mean much to me. I don't want to sound mawkish, but - it was the realization that I have a great many people in my life who really love me, and who I really love."
  },
  {
    "author": "Samantha Bee",
    "category": "birthday",
    "id": 7246,
    "text": "I hate birthdays. I thought that I only hated my own birthday, and then I realized that I hate my children's birthdays too."
  },
  {
    "author": "Stephanie Cutter",
    "category": "birthday",
    "id": 7274,
    "text": "My brother got a .22 for his 12th birthday I got a .22. He got a hunting knife I got a hunting knife."
  },
  {
    "author": "Sam Levenson",
    "category": "birthday",
    "id": 7128,
    "text": "It was on my fifth birthday that Papa put his hand on my shoulder and said, 'Remember, my son, if you ever need a helping hand, you'll find one at the end of your arm.'"
  },
  {
    "author": "Chloe Moretz",
    "category": "birthday",
    "id": 7228,
    "text": "My mom won't let me buy high-fashion stuff unless it's TK Maxx or a birthday occasion."
  },
  {
    "author": "Marie Antoinette",
    "category": "birthday",
    "id": 7141,
    "text": "Let them eat cake."
  },
  {
    "author": "Kevin Smith",
    "category": "birthday",
    "id": 7216,
    "text": "I saw Richard Linklater's film 'Slacker' for my twenty-first birthday. That was the moment when it all seemed possible. This guy gave me hope."
  },
  {
    "author": "Jesse McCartney",
    "category": "birthday",
    "id": 7266,
    "text": "All I watch is the Food Network. I took a cheesemaking class a few weeks ago, and I told my family and friends to only get me kitchen stuff on my birthday. I'm into every kind of cookbook and anything by Anthony Bourdain. I'd love to own a restaurant if I could find the right chef."
  },
  {
    "author": "Ruth Warrick",
    "category": "birthday",
    "id": 7169,
    "text": "I do like to shock and surprise people. When it's all in good fun, of course."
  },
  {
    "author": "Jean Paul",
    "category": "birthday",
    "id": 7137,
    "text": "Our birthdays are feathers in the broad wing of time."
  },
  {
    "author": "Annette Funicello",
    "category": "birthday",
    "id": 7165,
    "text": "In 1993 my birthday present was a star on Hollywood's Walk of Fame."
  },
  {
    "author": "Christina Hendricks",
    "category": "birthday",
    "id": 7258,
    "text": "We were probably the last people in the country to get a VCR and we didn't have cable. There wasn't any admiration of glamour, no, 'I want to look like them or have that lifestyle', because everyone in my town had the same lifestyle. So I didn't think, 'Ooh, a movie star's birthday!' I just thought, 'What?'"
  },
  {
    "author": "Stevie Nicks",
    "category": "birthday",
    "id": 7214,
    "text": "The day before my 16th birthday I got my guitar."
  },
  {
    "author": "Gloria Stuart",
    "category": "birthday",
    "id": 7167,
    "text": "When I was little I thought, isn't it nice that everybody celebrates on my birthday? Because it's July 4th."
  },
  {
    "author": "Catherine Bell",
    "category": "birthday",
    "id": 7154,
    "text": "The main prank that we play with props is for people's birthdays. The special effects people will put a little explosive in the cake so it blows up in their face - that's always fun to play on a guest star, or one of the trainees or someone who's new."
  }
]

quotes['business'] = [
  {
    "author": "Tom Colicchio",
    "category": "business",
    "id": 8132,
    "text": "I started cooking in kitchens right out of high school, and I was lucky to work with a lot of great people, but I had no idea it would turn into this. Of course no one should go into this business because they want to be the next Emeril."
  },
  {
    "author": "Samuel Adams",
    "category": "business",
    "id": 7725,
    "text": "We cannot make events. Our business is wisely to improve them."
  },
  {
    "author": "Harold S. Geneen",
    "category": "business",
    "id": 7335,
    "text": "In the business world, everyone is paid in two coins: cash and experience. Take the experience first the cash will come later."
  },
  {
    "author": "Steve Jobs",
    "category": "business",
    "id": 7294,
    "text": "Sometimes when you innovate, you make mistakes. It is best to admit them quickly, and get on with improving your other innovations."
  },
  {
    "author": "Carlos Ghosn",
    "category": "business",
    "id": 8035,
    "text": "Business is tough you need tough guys."
  },
  {
    "author": "Abraham Lincoln",
    "category": "business",
    "id": 7445,
    "text": "Discourage litigation. Persuade your neighbors to compromise whenever you can. As a peacemaker the lawyer has superior opportunity of being a good man. There will still be business enough."
  },
  {
    "author": "Ezra Pound",
    "category": "business",
    "id": 7722,
    "text": "When two men in business always agree, one of them is unnecessary."
  },
  {
    "author": "Harold S. Geneen",
    "category": "business",
    "id": 8276,
    "text": "You can't run a business or anything else on a theory."
  },
  {
    "author": "Jodie Foster",
    "category": "business",
    "id": 8192,
    "text": "But the reason I became, why I wanted to be in the business was because there was Midnight Cowboy."
  },
  {
    "author": "Dale Carnegie",
    "category": "business",
    "id": 7530,
    "text": "You can close more business in two months by becoming interested in other people than you can in two years by trying to get people interested in you."
  },
  {
    "author": "Maureen O'Hara",
    "category": "business",
    "id": 8124,
    "text": "There's a terrible truth for many women in the picture business: Aging typically takes its toll and means fewer and less desirable roles."
  },
  {
    "author": "B. C. Forbes",
    "category": "business",
    "id": 7418,
    "text": "Real riches are the riches possessed inside."
  },
  {
    "author": "Charles W. Eliot",
    "category": "business",
    "id": 8164,
    "text": "All business proceeds on beliefs, or judgements of probabilities, and not on certainties."
  },
  {
    "author": "Walter Lippmann",
    "category": "business",
    "id": 7385,
    "text": "The genius of a good leader is to leave behind him a situation which common sense, without the grace of genius, can deal with successfully."
  },
  {
    "author": "Bill Vaughan",
    "category": "business",
    "id": 7860,
    "text": "Now that women are jockeys, baseball umpires, atomic scientists, and business executives, maybe someday they can master parallel parking."
  },
  {
    "author": "Clement Mok",
    "category": "business",
    "id": 8128,
    "text": "Design, in its broadest sense, is the enabler of the digital era - it's a process that creates order out of chaos, that renders technology usable to business. Design means being good, not just looking good."
  },
  {
    "author": "Fran Lebowitz",
    "category": "business",
    "id": 7618,
    "text": "Contrary to popular opinion, the hustle is not a new dance step - it is an old business procedure."
  },
  {
    "author": "Theresa May",
    "category": "business",
    "id": 8009,
    "text": "Today I can announce a raft of reforms that we estimate could save over 2.5 million police hours every year. That's the equivalent of more than 1,200 police officer posts. These reforms are a watershed moment in policing. They show that we really mean business in busting bureaucracy."
  },
  {
    "author": "Daniel Craig",
    "category": "business",
    "id": 7993,
    "text": "I genuinely believe that if you want to get in the film business, get in the film business."
  },
  {
    "author": "Peter Drucker",
    "category": "business",
    "id": 7326,
    "text": "Most of what we call management consists of making it difficult for people to get their work done."
  },
  {
    "author": "Donald Trump",
    "category": "business",
    "id": 7583,
    "text": "So we really need jobs now. We have to take jobs away from other countries because other countries are taking our jobs. There is practically not a country that does business with the United States that isn't making - let's call it a very big profit. I mean China is going to make $300 billion on us at least this year."
  },
  {
    "author": "Clara Barton",
    "category": "business",
    "id": 8025,
    "text": "Everybody's business is nobody's business, and nobody's business is my business."
  },
  {
    "author": "Billie Jean King",
    "category": "business",
    "id": 8037,
    "text": "When they take surveys of women in business, of the Fortune 500, the successful women, 80% of them, say they were in sports as a young woman."
  },
  {
    "author": "Lord Byron",
    "category": "business",
    "id": 7631,
    "text": "If we must have a tyrant, let him at least be a gentleman who has been bred to the business, and let us fall by the axe and not by the butcher's cleaver."
  },
  {
    "author": "Henry Louis Gates",
    "category": "business",
    "id": 7847,
    "text": "The sad truth is that without complex business partnerships between African elites and European traders and commercial agents, the slave trade to the New World would have been impossible, at least on the scale it occurred."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "business",
    "id": 7556,
    "text": "War is the business of barbarians."
  },
  {
    "author": "Tupac Shakur",
    "category": "business",
    "id": 7485,
    "text": "I worked hard all my life as far as this music business. I dreamed of the day when I could go to New York and feel comfortable and they could come out here and be comfortable."
  },
  {
    "author": "Carroll O'Connor",
    "category": "business",
    "id": 7559,
    "text": "Both my brothers became physicians and I, of course, wandered into a business where the undisciplined are welcome."
  },
  {
    "author": "An Wang",
    "category": "business",
    "id": 8064,
    "text": "You have to have your heart in the business and the business in your heart."
  },
  {
    "author": "Jack Welch",
    "category": "business",
    "id": 7336,
    "text": "An organization's ability to learn, and translate that learning into action rapidly, is the ultimate competitive advantage."
  },
  {
    "author": "Dale Carnegie",
    "category": "business",
    "id": 7288,
    "text": "Most of the important things in the world have been accomplished by people who have kept on trying when there seemed to be no hope at all."
  },
  {
    "author": "Loretta Young",
    "category": "business",
    "id": 7931,
    "text": "As an actress, emotions are my business, my stock-in-trade. As such, I've dealt with them nearly all my life."
  },
  {
    "author": "James Dyson",
    "category": "business",
    "id": 8245,
    "text": "I don't do something necessarily to make a big profit or because it's a logical business decision."
  },
  {
    "author": "Jeff Bezos",
    "category": "business",
    "id": 8248,
    "text": "If you don't understand the details of your business you are going to fail."
  },
  {
    "author": "Alan Alda",
    "category": "business",
    "id": 7909,
    "text": "You wouldn't want to be called a sell-out by selling a product. Selling out was frowned on, whereas now you can major in it at business school."
  },
  {
    "author": "Charles Kettering",
    "category": "business",
    "id": 7363,
    "text": "High achievement always takes place in the framework of high expectation."
  },
  {
    "author": "Tupac Shakur",
    "category": "business",
    "id": 7477,
    "text": "There's nobody in the business strong enough to scare me."
  },
  {
    "author": "Elton John",
    "category": "business",
    "id": 8140,
    "text": "The whole point of being in this business and being blessed and being successful is that you're able to do things for your friends or your family, which means that they can have something special in their lives, too."
  },
  {
    "author": "Tony Blair",
    "category": "business",
    "id": 7983,
    "text": "My view is that you still, in order to win from the Labour perspective, have to have a strong alliance with business as well as the unions. You have got to be very much in the centre ground on things like public sector reform."
  },
  {
    "author": "Daniel Day-Lewis",
    "category": "business",
    "id": 7769,
    "text": "When I've gone back to work, it's always with that sense of inevitability. That may be a complete delusion, but it's the one that I need to get out of bed and go about my business. That sense that I can't avoid this thing. I better just get on with it."
  },
  {
    "author": "Warren Buffett",
    "category": "business",
    "id": 7496,
    "text": "In the business world, the rearview mirror is always clearer than the windshield."
  },
  {
    "author": "Marco Rubio",
    "category": "business",
    "id": 7781,
    "text": "Americans chose a free enterprise system designed to provide a quality of opportunity, not compel a quality of results. And that is why this is only place in the world where you can open up a business in the spare bedroom of your home."
  },
  {
    "author": "Margaret Thatcher",
    "category": "business",
    "id": 7557,
    "text": "I like Mr. Gorbachev, we can do business together."
  },
  {
    "author": "Jack Welch",
    "category": "business",
    "id": 7364,
    "text": "Willingness to change is a strength, even if it means plunging part of the company into total confusion for a while."
  },
  {
    "author": "Mehmet Oz",
    "category": "business",
    "id": 8222,
    "text": "In my business, if I get too close to you and you die, it hurts me. And so you develop a natural inclination not to be close to the patient, so that if things don't work out ideally, you can still get up the next day and care for the next patient."
  },
  {
    "author": "Ice T",
    "category": "business",
    "id": 8215,
    "text": "When you start a business, go for the lowest hanging fruit."
  },
  {
    "author": "Lenny Bruce",
    "category": "business",
    "id": 7739,
    "text": "When you're eight years old nothing is your business."
  },
  {
    "author": "Rod Blagojevich",
    "category": "business",
    "id": 7671,
    "text": "A successful economic development strategy must focus on improving the skills of the area's workforce, reducing the cost of doing business and making available the resources business needs to compete and thrive in today's global economy."
  },
  {
    "author": "Grace Paley",
    "category": "business",
    "id": 7984,
    "text": "The word career is a divisive word. It's a word that divides the normal life from business or professional life."
  },
  {
    "author": "Carroll O'Connor",
    "category": "business",
    "id": 7561,
    "text": "One irreducible residual of 38 years in the business is the number of lasting, loving friendships I have made."
  },
  {
    "author": "Simon Mainwaring",
    "category": "business",
    "id": 7795,
    "text": "Not since the digital revolution in the early '90s has technology placed such a comprehensive burden on business, employees and individuals to reinvent their business plans, services and products, and themselves to keep pace with the changing marketplace."
  },
  {
    "author": "Dave Eggers",
    "category": "business",
    "id": 8282,
    "text": "McSweeney's as a publishing company is built on a business model that only works when we sell physical books. So we try to put a lot of effort into the design and production of the book-as-object."
  },
  {
    "author": "Ambrose Bierce",
    "category": "business",
    "id": 7348,
    "text": "The gambling known as business looks with austere disfavor upon the business known as gambling."
  },
  {
    "author": "Dave Chappelle",
    "category": "business",
    "id": 8038,
    "text": "I want to tell my jokes. I want to have time with my children. I want to entertain people. And at one point, I'll walk away from show business. But I don't want to walk away empty-handed."
  },
  {
    "author": "Harvey S. Firestone",
    "category": "business",
    "id": 7963,
    "text": "Our company is built on people - those who work for us, and those we do business with."
  },
  {
    "author": "Ron Perlman",
    "category": "business",
    "id": 8196,
    "text": "I think there are a lot of technocrats in the business who would much rather work with just wheels and gears and machinery. Those things interest them more than humanity and I wish them the best of luck."
  },
  {
    "author": "James Taylor",
    "category": "business",
    "id": 8111,
    "text": "I'm glad about what's happening to the music business. This last crop of people we had in the 90s, who are going away now, they didn't like music. They didn't trust musicians. They wanted something else from it."
  },
  {
    "author": "Hedy Lamarr",
    "category": "business",
    "id": 7736,
    "text": "It is easier for women to succeed in business, the arts, and politics in America than in Europe."
  },
  {
    "author": "Stendhal",
    "category": "business",
    "id": 7645,
    "text": "Love has always been the most important business in my life, I should say the only one."
  },
  {
    "author": "Robert Frost",
    "category": "business",
    "id": 7476,
    "text": "Modern poets talk against business, poor things, but all of us write for money. Beginners are subjected to trial by market."
  },
  {
    "author": "Carly Fiorina",
    "category": "business",
    "id": 7913,
    "text": "Had anyone told me that I was going to have a career in business, I would have said, 'No way.'"
  },
  {
    "author": "John Sununu",
    "category": "business",
    "id": 8145,
    "text": "The Internet creates as well as destroys. Social networks, search advertising, and cloud computing are multibillion dollar industries that didn't exist 10 years ago. They are products of the same force that has rendered the Postal Service's core business obsolete."
  },
  {
    "author": "Chloe Sevigny",
    "category": "business",
    "id": 7613,
    "text": "It's like you always have to put on a happy face, be the phony baloney, and I'm so not that. I never was that I'll never be that. That is part of the business that I don't like. Maybe that will always keep me an outsider, I don't know. But that's fine."
  },
  {
    "author": "Hillary Clinton",
    "category": "business",
    "id": 7543,
    "text": "I believe that the rights of women and girls is the unfinished business of the 21st century."
  },
  {
    "author": "Colin Powell",
    "category": "business",
    "id": 7304,
    "text": "Don't let your ego get too close to your position, so that if your position gets shot down, your ego doesn't go with it."
  },
  {
    "author": "Donny Osmond",
    "category": "business",
    "id": 8284,
    "text": "Of course this is Vegas and it is the melting pot for all over the world, but people from all over the world know Donny and Marie. It is amazing. I have been in the business a long time to realize careers can be fleeting. Five years is a long career nowadays for some people, and here we are still going strong after 40 years."
  },
  {
    "author": "Anne Burrell",
    "category": "business",
    "id": 8126,
    "text": "I started in the restaurant business at the age of 19 as a waitress. I loved the atmosphere and the camaraderie of the restaurant business. I loved not having to go to an office. I loved making people happy."
  },
  {
    "author": "Kate Moss",
    "category": "business",
    "id": 7900,
    "text": "I want to apologize to all of the people I have let down because of my behavior which has reflected badly on my family, friends, co-workers, business associates and others."
  },
  {
    "author": "Charles Dickens",
    "category": "business",
    "id": 7591,
    "text": "Most men are individuals no longer so far as their business, its activities, or its moralities are concerned. They are not units but fractions."
  },
  {
    "author": "Mitt Romney",
    "category": "business",
    "id": 7538,
    "text": "Washington has to become an ally of business, not the opposition of business."
  },
  {
    "author": "Blake Lively",
    "category": "business",
    "id": 7970,
    "text": "My whole family's been in the business. My whole family is crazy."
  },
  {
    "author": "William James",
    "category": "business",
    "id": 7548,
    "text": "The god whom science recognizes must be a God of universal laws exclusively, a God who does a wholesale, not a retail business. He cannot accommodate his processes to the convenience of individuals."
  },
  {
    "author": "Herbert Simon",
    "category": "business",
    "id": 7733,
    "text": "Engineering, medicine, business, architecture and painting are concerned not with the necessary but with the contingent - not with how things are but with how they might be - in short, with design."
  },
  {
    "author": "Nelson Piquet",
    "category": "business",
    "id": 7807,
    "text": "After hurting myself like that, I could not go back immediately to racing. I was in no condition, mentally or physically. That helped me to strengthen myself to go through the hard times that were ahead with my business, and to be successful."
  },
  {
    "author": "Loretta Lynn",
    "category": "business",
    "id": 8078,
    "text": "A woman's two cents worth is worth two cents in the music business."
  },
  {
    "author": "Alvin Toffler",
    "category": "business",
    "id": 7425,
    "text": "To think that the new economy is over is like somebody in London in 1830 saying the entire industrial revolution is over because some textile manufacturers in Manchester went broke."
  },
  {
    "author": "Elisabeth Rohm",
    "category": "business",
    "id": 8081,
    "text": "The business is a very tricky obstacle course, and you should be very clear about work begetting work. If you're not working, you're not interesting."
  },
  {
    "author": "Christopher Walken",
    "category": "business",
    "id": 8053,
    "text": "I think the fact that I was raised in show business, in New York City, in the '50s, that's affected my personality to the point that I'm a little different."
  },
  {
    "author": "Chris Christie",
    "category": "business",
    "id": 8079,
    "text": "If anybody ran a business like that they would be out of business quickly, and Barack Obama's leadership is driving this business, the United States of America, toward a fiscal cliff."
  },
  {
    "author": "Lauren Conrad",
    "category": "business",
    "id": 8108,
    "text": "There's not a business or a master plan as far as I'm concerned. I take it week by week, and I don't think you ever expect to be able to do the next thing."
  },
  {
    "author": "Baltasar Gracian",
    "category": "business",
    "id": 7723,
    "text": "To be at ease is better than to be at business. Nothing really belongs to us but time, which even he has who has nothing else."
  },
  {
    "author": "Daniel Craig",
    "category": "business",
    "id": 7992,
    "text": "Suits are looked at more now as a business thing which is kind of a shame. If you're not wearing it just for work, you should try and trick it up a bit."
  },
  {
    "author": "Michelle Obama",
    "category": "business",
    "id": 7702,
    "text": "I'm not asking any of you to make drastic changes to every single one of your recipes or to totally change the way you do business. But what I am asking is that you consider reformulating your menu in pragmatic and incremental ways to create healthier versions of the foods that we all love."
  },
  {
    "author": "Steve Martin",
    "category": "business",
    "id": 7660,
    "text": "When I was in college, I was debating to try my hand at show business, or to become a professor. I just thought of the risk of not going into show business and always wondering if I would've had a chance. Because that's where my real heart was."
  },
  {
    "author": "Barry Goldwater",
    "category": "business",
    "id": 7590,
    "text": "I think any man in business would be foolish to fool around with his secretary. If it's somebody else's secretary, fine."
  },
  {
    "author": "Calvin Klein",
    "category": "business",
    "id": 7895,
    "text": "When I started the business, I hardly went home. I became very driven about work and about my career."
  },
  {
    "author": "Curt Schilling",
    "category": "business",
    "id": 8153,
    "text": "I've always wanted to be the best in the world as a baseball player, so when I started to think about opening a business, it was with that mindset."
  },
  {
    "author": "Michael Sheen",
    "category": "business",
    "id": 8233,
    "text": "Although my family - parents and sister - all work in the personnel management business, their real passion is performing, amateur operatic societies and so on."
  },
  {
    "author": "Doug Coupland",
    "category": "business",
    "id": 7700,
    "text": "The real killers in the business world aren't the ones who aim for the top, it's the ones who aim for two notches below the top."
  },
  {
    "author": "Richard Chamberlain",
    "category": "business",
    "id": 7666,
    "text": "'Handsome' means many things to many people. If people consider me handsome, I feel flattered - and have my parents to thank for it. Realistically, it doesn't hurt to be good-looking, especially in this business."
  },
  {
    "author": "Barbara Corcoran",
    "category": "business",
    "id": 8119,
    "text": "My husband had a very strong identity and was successful in his life. Thank God for that. There's no way I can control him. I wouldn't stay married to him if I felt I could. I can readily take my business personality into the home. But he forces me to be a partner rather than the boss."
  },
  {
    "author": "Katie Price",
    "category": "business",
    "id": 8156,
    "text": "If you want to stay in the business then you've got to be a bit shrewd, haven't you?"
  },
  {
    "author": "Will Rogers",
    "category": "business",
    "id": 7505,
    "text": "The movies are the only business where you can go out front and applaud yourself."
  },
  {
    "author": "Charlie Kaufman",
    "category": "business",
    "id": 8146,
    "text": "If you create something that is asking for people to respond as they're going to respond, you have to allow them to respond as they're going to respond. Some of the people are going to be uninterested and some people are going to be mad for some reason, which is their business. That's just the way the world is."
  },
  {
    "author": "Margaret J. Wheatley",
    "category": "business",
    "id": 7877,
    "text": "I think we have to notice that the business processes we use right now for thinking and planning and budgeting and strategy are all delivered on very tight agendas."
  },
  {
    "author": "Michael Jackson",
    "category": "business",
    "id": 7513,
    "text": "I love my family very much. I wish I could see them a little more often than I do. But we understand because we're a show business family and we all work."
  },
  {
    "author": "Tom Colicchio",
    "category": "business",
    "id": 8130,
    "text": "A couple of months ago, I was down in Florida for the Food and Wine Festival. And this journalist grabbed me and said, 'How does it feel to be a TV guy? You're no longer in the restaurant business.' And I laughed. I asked him, 'How long do you think it takes me to do a season?' He said, 'Well, 200 days.' And I was like, '200 days? Try 20!'"
  },
  {
    "author": "Lee Iacocca",
    "category": "business",
    "id": 7633,
    "text": "In the end, all business operations can be reduced to three words: people, product, and profits."
  },
  {
    "author": "Danica McKellar",
    "category": "business",
    "id": 7905,
    "text": "Teenage girls these days are more and more getting lured into thinking they should dumb themselves down, and that's going to attract the wrong kind of guy, and it's serious. It's serious business."
  },
  {
    "author": "Stanislaw Lem",
    "category": "business",
    "id": 7398,
    "text": "Cannibals prefer those who have no spines."
  }
]

quotes['car'] = [
  {
    "author": "Mindy Kaling",
    "category": "car",
    "id": 8385,
    "text": "I think a lot of writers, male and female, write as if their parents were killed in a car accident when they were 2, and they have no one to hold accountable. And unfortunately, I don't have that. I have parents who I care about what they think."
  },
  {
    "author": "J. G. Ballard",
    "category": "car",
    "id": 8491,
    "text": "The American Dream has run out of gas. The car has stopped. It no longer supplies the world with its images, its dreams, its fantasies. No more. It's over. It supplies the world with its nightmares now: the Kennedy assassination, Watergate, Vietnam."
  },
  {
    "author": "Michelle Rodriguez",
    "category": "car",
    "id": 8731,
    "text": "Going to car racing school was phenomenal."
  },
  {
    "author": "T-Pain",
    "category": "car",
    "id": 8734,
    "text": "My first car was an '84 Ford Taurus. It caught on fire from me trying to change the fuel pump, so that wasn't good at all. Dried leaves on the ground while I was trying to change the fuel pump. Don't do that. Do it on concrete."
  },
  {
    "author": "Michael Behe",
    "category": "car",
    "id": 8747,
    "text": "A man from a primitive culture who sees an automobile might guess that it was powered by the wind or by an antelope hidden under the car, but when he opens up the hood and sees the engine he immediately realizes that it was designed."
  },
  {
    "author": "Walter Mosley",
    "category": "car",
    "id": 8811,
    "text": "I think that people don't know how to do anything anymore. My father was a janitor. He could take a car apart and put it back together. He could build a house in the back yard. Today, if you ask people what they know, they say, 'I know how to hire someone.'"
  },
  {
    "author": "Kevin Bacon",
    "category": "car",
    "id": 8570,
    "text": "I'd really like to get the girl, shoot the gun, drive the car, have fun. I even have these kind of action dreams, where I'm the action guy."
  },
  {
    "author": "Criss Angel",
    "category": "car",
    "id": 8650,
    "text": "I have mentally overcome situations most of you would be terrified to ever attempt: heights, fire, needles, spiders, snakes, angry monkeys, being shot, being hit by a car, going blind - you name it, I have been in a situation where I have had to mentally overcome my inherent fears to do my job."
  },
  {
    "author": "Jordana Brewster",
    "category": "car",
    "id": 8759,
    "text": "People spend so much time in their cars, and it's a legal way to have fun by speeding a little bit or testing yourself a little bit, and you get to invest in your car. For some people, it becomes their baby."
  },
  {
    "author": "Emerson Fittipaldi",
    "category": "car",
    "id": 8887,
    "text": "The racing driver's mind has to have the ability to have amazing anticipation, coordination, and reflex. Because of the speed the car goes."
  },
  {
    "author": "Burton Cummings",
    "category": "car",
    "id": 8981,
    "text": "When I'm in the car and somebody comes on the radio singing the high notes, I try to sing along."
  },
  {
    "author": "Kristin Davis",
    "category": "car",
    "id": 8652,
    "text": "I drank a lot when I was a teenager and I don't drink any more, because that's when I thought, you know, I'm gonna end up a car wreck."
  },
  {
    "author": "Amber Heard",
    "category": "car",
    "id": 8615,
    "text": "I grew up in Texas, and people love their American-made muscle cars there. I grew up around people who loved cars and took care of cars and my dad's a big car nut, so I learned a little bit about cars - how to love them, most importantly. I think that from the time I could remember, I've always envisioned myself in a vintage muscle car."
  },
  {
    "author": "Sebastian Vettel",
    "category": "car",
    "id": 8633,
    "text": "We always kept believing in ourselves and our team and the car."
  },
  {
    "author": "Shia LaBeouf",
    "category": "car",
    "id": 8415,
    "text": "My first car, I got it in an auction at my temple. It was an '86 Volvo that I got for 500 bucks, and then wound up throwing $10,000 into the stereo system and put TVs in the foot rests. It was the most ridiculous Volvo you'd ever seen, but I had never had money before and I was out of my mind."
  },
  {
    "author": "Guy Fieri",
    "category": "car",
    "id": 8819,
    "text": "There are races and then there are races. And without a doubt, the Indy 500 is the race that I've always wanted to attend. And now, to be driving the Corvette Pace Car... this is going to be unbelievable."
  },
  {
    "author": "Adlai Stevenson",
    "category": "car",
    "id": 8546,
    "text": "Freedom is not an ideal, it is not even a protection, if it means nothing more than freedom to stagnate, to live without dreams, to have no greater aim than a second car and another television set."
  },
  {
    "author": "Jacob Lusk",
    "category": "car",
    "id": 8993,
    "text": "I prefer to sing in the shower vs. the car. The shower is just steam, you know, its just you, and nature, and no clothing. You know, there's nothing separating you. It's just you, and the voice - you, and the water."
  },
  {
    "author": "James Hillman",
    "category": "car",
    "id": 8552,
    "text": "The culture is going into a psychological depression. We are concerned about our place in the world, about being competitive: Will my children have as much as I have? Will I ever own my own home? How can I pay for a new car? Are immigrants taking away my white world?"
  },
  {
    "author": "Lindsay Lohan",
    "category": "car",
    "id": 8477,
    "text": "I want to be remembered for the work that I've done, rather than the car accidents that I've gotten into, the men that I've not dated - or the man that I have."
  },
  {
    "author": "Linwood Barclay",
    "category": "car",
    "id": 8935,
    "text": "Switching over to a hybrid car is one of those right things, but, unfairly or not, it still has a reputation among car enthusiasts as something you have to pedal really fast when you're on the ramp merging into traffic on the 401."
  },
  {
    "author": "John Mellencamp",
    "category": "car",
    "id": 8701,
    "text": "You cannot expect the guy who drove the car into the ditch to navigate it out of the ditch. You have to put a new driver in the seat. I'm not saying the new driver is going to be any better, but we need a new driver. Kerry is the only choice."
  },
  {
    "author": "Robbie Williams",
    "category": "car",
    "id": 8778,
    "text": "The thing about drugs and sex is that you lose all your inhibitions. I've had sex in trains, planes, wine bars... and quite a few car parks!"
  },
  {
    "author": "David R. Ellis",
    "category": "car",
    "id": 8812,
    "text": "I mean, you have a general tone of it but it's pretty much you get to come in and you're going to flip this car and it's going to blow up and you're going to come out on fire and you go oh, that's cool, and then you get paid a lot of money."
  },
  {
    "author": "Brock Yates",
    "category": "car",
    "id": 8336,
    "text": "The automobile, both a cause and an effect of this decentralization, is ideally suited for our vast landscape and our generally confused and contrary commuting patterns."
  },
  {
    "author": "Earl Wilson",
    "category": "car",
    "id": 8584,
    "text": "Home, nowadays, is a place where part of the family waits till the rest of the family brings the car back."
  },
  {
    "author": "Carrie Brownstein",
    "category": "car",
    "id": 8682,
    "text": "I am a horrible visual artist. I can't fix a car, sew, knit, cook, etc. Statistically, there is more I don't do than do."
  },
  {
    "author": "Jackie Stewart",
    "category": "car",
    "id": 8860,
    "text": "We were racing at circuits where there were no crash barriers in front of the pits, and fuel was lying about in churns in the pit lane. A car could easily crash into the pits at any time. It was ridiculous."
  },
  {
    "author": "Robin Quivers",
    "category": "car",
    "id": 8941,
    "text": "It's sad that women characters have lost so much ground in popular movies. Didn't 'Thelma and Louise' prove that women want to see women doing things on film? Thelma and Louise were in a classic car they were being chased by cops they shot up a truck - and women loved it."
  },
  {
    "author": "Murray Walker",
    "category": "car",
    "id": 8464,
    "text": "And that just shows you how important the car is in Formula One Racing."
  },
  {
    "author": "Richard Hammond",
    "category": "car",
    "id": 8849,
    "text": "It's not just the kid who's spent every penny from his job to upgrade his car to tell the world he cares about sports cars, it's also the person driving around in a fuel-conscious hybrid electric car, because it's more a message to the world than an effective means of saving fuel, to be quite honest."
  },
  {
    "author": "Sterling Marlin",
    "category": "car",
    "id": 8978,
    "text": "I think we'll be in pretty good shape. We've got the same car we ran in all the speedway races since 2001, and it's been a real good car for us. It's led every race we've been in."
  },
  {
    "author": "Andy Milonakis",
    "category": "car",
    "id": 8891,
    "text": "I don't want to rap about my car. How generic is that? Be creative."
  },
  {
    "author": "Kate Smith",
    "category": "car",
    "id": 8677,
    "text": "As soon as I began to earn what might be called fairly large sums, I bought a car and began to explore the country around New York."
  },
  {
    "author": "Nick Mason",
    "category": "car",
    "id": 8913,
    "text": "I went to watch my father at Silverstone in the early 1950s, and I've still got the car he was in."
  },
  {
    "author": "Chris Messina",
    "category": "car",
    "id": 8918,
    "text": "What's monotonous about being an actor and often makes me want to throw in the towel or drive a car off a bridge is the auditioning - the waiting around."
  },
  {
    "author": "Grover Norquist",
    "category": "car",
    "id": 8593,
    "text": "I read murder mysteries. I exercise 40 minutes a day. I watch videotapes while I exercise. I listen to audiotapes when I am in my car. And I try to stay in three different centuries."
  },
  {
    "author": "Danica Patrick",
    "category": "car",
    "id": 8541,
    "text": "On Memorial Day, I was out floating on Lake Norman and came across Denny Hamlin. We struck up a conversation, and one of the first things we were talking about was how much it helped him when he started racing the Cup car and how much it helped his Nationwide program."
  },
  {
    "author": "Anne Lamott",
    "category": "car",
    "id": 8441,
    "text": "I like the desert for short periods of time, from inside a car, with the windows rolled up, and the doors locked. I prefer beach resorts with room service."
  },
  {
    "author": "Jonathan Winters",
    "category": "car",
    "id": 8844,
    "text": "I was always an observer, even as a child. I could be satisfied to sit in a car for 3 hours and just look at the street go by while my mother went shopping."
  },
  {
    "author": "Michael Frayn",
    "category": "car",
    "id": 9028,
    "text": "A man sits in his car at the traffic lights, waiting for them to go green."
  },
  {
    "author": "Jean Claude Van Damme",
    "category": "car",
    "id": 8556,
    "text": "I like structure - like driving: go past the school on the street, stay on the right side, no hitting the car, go in right, you'll see a big church, stop and take a left, and you'll have it. By doing this I'm giving a structure of life, a path of light, and showing what happens between me and me, which is something very beautiful."
  },
  {
    "author": "Eric Cantona",
    "category": "car",
    "id": 8445,
    "text": "I have a car but it's not important."
  },
  {
    "author": "Tom Felton",
    "category": "car",
    "id": 8407,
    "text": "It's shocking to say, but the cinema is quite a while away from me, and I haven't got a car yet."
  },
  {
    "author": "Steven Adler",
    "category": "car",
    "id": 8862,
    "text": "My health is wonderful. I work out. I'm working. Playing music. I have a beautiful wife, a nice home, a nice car, I got money in the bank. I got three beautiful dogs that love me. Like I said, I'm blessed. I survived."
  },
  {
    "author": "James Hansen",
    "category": "car",
    "id": 8717,
    "text": "Consider the perverse effect cap and trade has on altruistic actions. Say you decide to buy a small, high-efficiency car. That reduces your emissions, but not your country's. Instead it allows somebody else to buy a bigger S.U.V. - because the total emissions are set by the cap."
  },
  {
    "author": "Kid Rock",
    "category": "car",
    "id": 8486,
    "text": "I didn't come from a trailer park. I grew up middle class and my dad had money and my mom made my lunch. I got a car when I was sixteen. I'm proud of that."
  },
  {
    "author": "Chris Pratt",
    "category": "car",
    "id": 8610,
    "text": "Television is such an evolving medium. When you're doing a TV show, it's not like you just shoot for six weeks and you're in an editing room with all of your footage. It's like a guitar or a car, you have to fine tune things. You stop doing what's not working, you work on what is working and you add things that do work."
  },
  {
    "author": "Lewis Mumford",
    "category": "car",
    "id": 8453,
    "text": "Forget the damned motor car and build the cities for lovers and friends."
  },
  {
    "author": "Edie Brickell",
    "category": "car",
    "id": 8670,
    "text": "A lot of the songs start with an image. I was sitting there playing the guitar and I pictured this old, dirty green car, with the window rolled down, in the hot, hot, hot Texas heat, and this beautiful woman I knew when I was a kid sitting behind the wheel, looking out at me."
  },
  {
    "author": "Jessica Savitch",
    "category": "car",
    "id": 8432,
    "text": "By far my most perilous assignment was covering a tank car explosion."
  },
  {
    "author": "Patty Hearst",
    "category": "car",
    "id": 8724,
    "text": "You know, sitting in the car when they got back in and - first of all, it was relief. I was not - there were two get away cars or switch cars they were called. And, you know, the group tended to include everyone."
  },
  {
    "author": "Juan Manuel Fangio",
    "category": "car",
    "id": 8808,
    "text": "The driver of a racing car is a component. When I first began, I used to grip the steering wheel firmly, and I changed gear so hard that I damaged my hand."
  },
  {
    "author": "Etta James",
    "category": "car",
    "id": 8567,
    "text": "Johnny Guitar... just one of my favorite singers of all time. I met him when we were both on the road with Johnny Otis in the '50s when I was a teenager. We traveled the country in a car together.I would hear him sing every night."
  },
  {
    "author": "Erma Bombeck",
    "category": "car",
    "id": 8355,
    "text": "Marriage has no guarantees. If that's what you're looking for, go live with a car battery."
  },
  {
    "author": "Lee Konitz",
    "category": "car",
    "id": 8802,
    "text": "I just completed a tour in Europe. I played every night. This requires traveling some days for six hours in a van or a train or a car. After six weeks of that, I checked into the hotel and just fell apart."
  },
  {
    "author": "Sean William Scott",
    "category": "car",
    "id": 8983,
    "text": "So the first thing that I thought about was, 'How is this car going to handle?' But then after I'd been driving with it and practicing with it and I accomplished that, then I just kind of sat back."
  },
  {
    "author": "Herb Alpert",
    "category": "car",
    "id": 8773,
    "text": "When I finish an album and I find myself listening to it in the car, because it makes me feel a certain way, that's the time to try to let other people know about it."
  },
  {
    "author": "Roger Staubach",
    "category": "car",
    "id": 8494,
    "text": "At a car dealership, the person who sells the car is the hero, and also gets the commission. But if the mechanics don't service that car well, the customer won't return."
  },
  {
    "author": "Whitney Cummings",
    "category": "car",
    "id": 9004,
    "text": "There was a time in L.A. when I drove to 7-Eleven to go grocery shopping, and I locked my keys in my car, which wasn't insured. My wallet was in there, and I couldn't call AAA, because I only had $7 in my bank account. It was one of those moments where I was like, 'O.K., I literally have nothing right now.'"
  },
  {
    "author": "Jesse Jackson",
    "category": "car",
    "id": 8452,
    "text": "Many kids come out of college, they have a credit card and a diploma. They don't know how to buy a house or a car or health insurance or life insurance. They do not know basic microeconomics."
  },
  {
    "author": "Herschel Walker",
    "category": "car",
    "id": 8790,
    "text": "I was a little different. I still say I'm a little different, because success to me is not having the most money, or having the biggest car or the biggest house."
  },
  {
    "author": "Timothy West",
    "category": "car",
    "id": 8468,
    "text": "The newly decorated theatres produced things like car parks and restaurants, so you could have a good night out, quite cheaply without all that bother of having to go somewhere else."
  },
  {
    "author": "Haley Reinhart",
    "category": "car",
    "id": 8902,
    "text": "I definitely I prefer to sing in the car. I don't sing in the shower, maybe its because that's the one time I don't need to talk to anyone so I should just shut up, otherwise I'm just, you know, jibber jabber."
  },
  {
    "author": "Erma Bombeck",
    "category": "car",
    "id": 8354,
    "text": "Never lend your car to anyone to whom you have given birth."
  },
  {
    "author": "Dylan McDermott",
    "category": "car",
    "id": 8719,
    "text": "It's like, no matter what I do, I always feel like I'm five years old, and I end up in the back of my father's car looking out the window, and nothing has changed in 25 years."
  },
  {
    "author": "Mark Hoppus",
    "category": "car",
    "id": 8665,
    "text": "I lived in small town out in the desert and my friend used to steal his mom's car in the middle of the night. He'd drive over to my house, I'd sneak out and we'd go out to the desert and just burn things down."
  },
  {
    "author": "John Moody",
    "category": "car",
    "id": 8828,
    "text": "In the United States three new methods of transportation made their appearance at almost the same time - the steamboat, the canal boat, and the rail car."
  },
  {
    "author": "Ashley Greene",
    "category": "car",
    "id": 8537,
    "text": "I'm lucky because my dad taught me to be frugal and save. And that's important because I want to know that I don't have to take an acting job for two or three years if I don't want to and that I'll still be able to make my house and car payments and buy food for my dogs."
  },
  {
    "author": "Colin Farrell",
    "category": "car",
    "id": 8498,
    "text": "Anything that's different from your own realm of experience as a human being, whether it's driving a car or a boat, or using guns, anything that separates you from yourself and leads you more towards this character's existence is a big help."
  },
  {
    "author": "Dale Earnhardt",
    "category": "car",
    "id": 8396,
    "text": "I don't want to argue with my wife about her car - or my driving."
  },
  {
    "author": "Tom Waits",
    "category": "car",
    "id": 8492,
    "text": "You know what I really love? The CD players in a car. How when you put the CD right up by the slot, it actually takes it out of your hand, like it's hungry. It pulls it in, and you feel like it wants more silver discs."
  },
  {
    "author": "Sebastian Junger",
    "category": "car",
    "id": 8742,
    "text": "The negative effects of combat were nightmares, and I'd get jumpy around certain noises and stuff, but you'd have that after a car accident or a bad divorce. Life's filled with trauma. You don't need to go to war to find it it's going to find you. We all deal with it, and the effects go away after awhile. At least they did for me."
  },
  {
    "author": "Nancy Cartwright",
    "category": "car",
    "id": 8964,
    "text": "Since September 11, security has been increased everywhere, and we have new IDs to get on to the Fox lot. I drove to the security gate, but realized I'd left my ID in my other car. I just broke into that voice - 'Hey, man, I'm Bart Simpson. Who else sounds like this?' The guard waved me through."
  },
  {
    "author": "Edward de Bono",
    "category": "car",
    "id": 8388,
    "text": "Many highly intelligent people are poor thinkers. Many people of average intelligence are skilled thinkers. The power of a car is separate from the way the car is driven."
  },
  {
    "author": "Marlee Matlin",
    "category": "car",
    "id": 8550,
    "text": "It was my father who instilled the 'never say no' attitude I carry around with me today, and who instilled in me a sense of wonder, always taking us on adventures in the car, never telling us the destination."
  },
  {
    "author": "Susan Smith",
    "category": "car",
    "id": 9046,
    "text": "I wanted to end my life so bad and was in my car ready to go down that ramp into the water, and I did go part way, but I stopped. I went again and stopped. I then got out of the car and stood by the car a nervous wreck."
  },
  {
    "author": "Denis Norden",
    "category": "car",
    "id": 8977,
    "text": "There's an unseen force which lets birds know when you've just washed your car."
  },
  {
    "author": "ASAP Rocky",
    "category": "car",
    "id": 8622,
    "text": "I take cabs if I need to get somewhere or I take car service. I don't drive, I wouldn't mind riding a bike... People think that because you become an entertainer you gotta have this rock star thug image. I'm an artist, man. I'm going to live like an artist."
  },
  {
    "author": "Will Durst",
    "category": "car",
    "id": 8962,
    "text": "I hate the outdoors. To me the outdoors is where the car is."
  },
  {
    "author": "David Mitchell",
    "category": "car",
    "id": 8583,
    "text": "A life can get knocked into a new orbit by a car crash, a lottery win or just a bleary-eyed consultant giving bad news in a calm voice."
  },
  {
    "author": "Tori Amos",
    "category": "car",
    "id": 8416,
    "text": "I remember driving to North Carolina when I was a little girl in a snowstorm to get down to my mom's family in the Carolinas. There were chains on the car - it was the late sixties - and we were just singing in the car. Christmas carols."
  },
  {
    "author": "Holly Madison",
    "category": "car",
    "id": 8668,
    "text": "In L.A., I don't really want to go out because traffic sucks so bad. I'm sorry, I'm not going to spend five hours a day in my car, so you have to choose where you live very carefully."
  },
  {
    "author": "Dan Lipinski",
    "category": "car",
    "id": 8400,
    "text": "The hydrogen powered car, with its high fuel mileage and zero emission rate, is just one example of the products under development that will help increase our energy independence."
  },
  {
    "author": "Amy Sherman-Palladino",
    "category": "car",
    "id": 8901,
    "text": "I grew up where my parents would literally shove me in the car rather than have to say hello to a neighbor."
  },
  {
    "author": "Joe Scarborough",
    "category": "car",
    "id": 8746,
    "text": "When I'm in town on Sundays, I sometimes go down to the Central Bar in the East Village to watch English football. But my natural inclination now is to get in the car with my wife and kids and get out of town."
  },
  {
    "author": "Marshall McLuhan",
    "category": "car",
    "id": 8421,
    "text": "The car has become the carapace, the protective and aggressive shell, of urban and suburban man."
  },
  {
    "author": "Nadia Giosia",
    "category": "car",
    "id": 8777,
    "text": "I'm addicted to laughing. I go to see a lot of comedy shows. I'm addicted to playing really loud and obnoxious rock music in my car. I'm addicted to beautiful clothes and shoes. I just love gorgeous stuff and work hard to acquire pretty things, shiny things. I'm addicted to shiny things!"
  },
  {
    "author": "Michael D. Barnes",
    "category": "car",
    "id": 8899,
    "text": "Should we have background checks, waiting periods? To drive a car you have to pass a test that shows you know how to drive your car safely, you should have to do the same thing with guns."
  },
  {
    "author": "Dolly Parton",
    "category": "car",
    "id": 8386,
    "text": "I'm gonna be making records anyway, even if I had to sell 'em out of the trunk of my car. I'm that kind of musician and singer."
  },
  {
    "author": "Gerald McRaney",
    "category": "car",
    "id": 8969,
    "text": "We're one of the forces that causes actors to fasten seat belts before they take off chasing the bad guy in the car... or removes some of the cigarette smoking on television."
  },
  {
    "author": "Sam Mendes",
    "category": "car",
    "id": 8693,
    "text": "I've made movies that cost less than one car chase."
  },
  {
    "author": "Amber Heard",
    "category": "car",
    "id": 8614,
    "text": "My very best friend died in a car accident when I was 16 years old. That was the hardest blow emotionally that I have ever had to endure. Suddenly, you realize tomorrow might not come. Now I live by the motto, 'Today is what I have.'"
  },
  {
    "author": "Dr. Dre",
    "category": "car",
    "id": 8555,
    "text": "Before now, I've always taken my mixes out to the car and listened to them in the parking lot. I still do that, but more so now I'm listening to it on the Beat box, and I think people should give it at least a listen and check it out and see what it is."
  },
  {
    "author": "Trish Stratus",
    "category": "car",
    "id": 8868,
    "text": "As far as luxury goes, about the only thing I do is... I go first class all the way. I live on the road, so when I'm out there, I'm getting the nice hotel suite, I'm getting the luxury car, I'm eating the good food, and I make sure I take care of myself on the road."
  },
  {
    "author": "Casey Abrams",
    "category": "car",
    "id": 8943,
    "text": "I'm a car singer, in fact sometimes I pretend to take my dog out for a walk, and I'll just drive him around and start singin'."
  },
  {
    "author": "Coolio",
    "category": "car",
    "id": 8748,
    "text": "Because I'm a young black man driving a really nice, expensive car, I sometimes get harassed when I'm rolling through a ghetto neighbourhood."
  },
  {
    "author": "Olivia Munn",
    "category": "car",
    "id": 8684,
    "text": "A geek isn't the skinny kid with a pocket protector and acne. There can be computer geeks, video game geeks, car geeks, military geeks, and sports geeks. Being a geek just means that you're passionate about something."
  },
  {
    "author": "Tom Hunter",
    "category": "car",
    "id": 9015,
    "text": "But once you have satisfied your material needs, which I think every wealth creator should - the house, the car, the plane, the boat - what comes next?"
  },
  {
    "author": "Peter Tork",
    "category": "car",
    "id": 8764,
    "text": "I never listen to music in the house, I listen to music in the car."
  }
]

quotes['change'] = [
  {
    "author": "Vernon Howard",
    "category": "change",
    "id": 9131,
    "text": "To change what you get you must change who you are."
  },
  {
    "author": "Confucius",
    "category": "change",
    "id": 9078,
    "text": "They must often change, who would be constant in happiness or wisdom."
  },
  {
    "author": "Andy Grove",
    "category": "change",
    "id": 9874,
    "text": "There is at least one point in the history of any company when you have to change dramatically to rise to the next level of performance. Miss that moment - and you start to decline."
  },
  {
    "author": "Alan Alda",
    "category": "change",
    "id": 9546,
    "text": "Never Have Your Dog Stuffed is really advice to myself, a reminder to myself not to avoid change or uncertainty, but to go with it, to surf into change."
  },
  {
    "author": "M. Scott Peck",
    "category": "change",
    "id": 9276,
    "text": "The whole course of human history may depend on a change of heart in one solitary and even humble individual - for it is in the solitary mind and soul of the individual that the battle between good and evil is waged and ultimately won or lost."
  },
  {
    "author": "Bob Dylan",
    "category": "change",
    "id": 9262,
    "text": "There is nothing so stable as change."
  },
  {
    "author": "Monica Lewinsky",
    "category": "change",
    "id": 10000,
    "text": "So I think it's - what was important to me is that I found that I can't change the fact that people already have made an opinion about me. But I don't think that should stop me from trying to correct some of the misperceptions that are out there."
  },
  {
    "author": "Michael Caine",
    "category": "change",
    "id": 9627,
    "text": "The difference between a movie star and a movie actor is this - a movie star will say, 'How can I change the script to suit me?' and a movie actor will say. 'How can I change me to suit the script?'"
  },
  {
    "author": "Alice Walker",
    "category": "change",
    "id": 9453,
    "text": "We should learn to accept that change is truly the only thing that's going on always, and learn to ride with it and enjoy it."
  },
  {
    "author": "Mario Batali",
    "category": "change",
    "id": 9999,
    "text": "Finishing food is about the tiny touches. In the last seconds you can change everything."
  },
  {
    "author": "Eleanor Clift",
    "category": "change",
    "id": 9165,
    "text": "People want change but not too much change. Finding that balance is tricky for every politician."
  },
  {
    "author": "Cal Thomas",
    "category": "change",
    "id": 9449,
    "text": "In a free society, government reflects the soul of its people. If people want change at the top, they will have to live in different ways. Our major social problems are not the cause of our decadence. They are a reflection of it."
  },
  {
    "author": "Andre Gide",
    "category": "change",
    "id": 9465,
    "text": "Work and struggle and never accept an evil that you can change."
  },
  {
    "author": "Atal Bihari Vajpayee",
    "category": "change",
    "id": 9441,
    "text": "You can change friends but not neighbours."
  },
  {
    "author": "Gwen Stefani",
    "category": "change",
    "id": 9942,
    "text": "When you first have a baby your life doesn't change. I mean, you have a little less sleep and you drag these cuddly things around you and it's just amazing. But you still get to be you. Once they get to, like, five, six and school and it starts to get, like, 'Wow, they got real problems. They're my responsibility.' Oh my God. That is overwhelming."
  },
  {
    "author": "Philip Wylie",
    "category": "change",
    "id": 9698,
    "text": "One good teacher in a lifetime may sometimes change a delinquent into a solid citizen."
  },
  {
    "author": "Tiger Woods",
    "category": "change",
    "id": 9614,
    "text": "There's no sense in going to a tournament if you don't believe that you can win it. And that is the belief I have always had. And that is not going to change."
  },
  {
    "author": "Stephen Hawking",
    "category": "change",
    "id": 9202,
    "text": "I have noticed even people who claim everything is predestined, and that we can do nothing to change it, look before they cross the road."
  },
  {
    "author": "Fareed Zakaria",
    "category": "change",
    "id": 9467,
    "text": "Americans have so far put up with inequality because they felt they could change their status. They didn't mind others being rich, as long as they had a path to move up as well. The American Dream is all about social mobility in a sense - the idea that anyone can make it."
  },
  {
    "author": "Muhammad Ali",
    "category": "change",
    "id": 9216,
    "text": "Wars of nations are fought to change maps. But wars of poverty are fought to map change."
  },
  {
    "author": "Alfred North Whitehead",
    "category": "change",
    "id": 9860,
    "text": "The art of progress is to preserve order amid change and to preserve change amid order."
  },
  {
    "author": "Chris Martin",
    "category": "change",
    "id": 9870,
    "text": "Celebrity culture has gone crazy, and I think the reason is that real news is just not bearable, and it also seems impossible to change anything."
  },
  {
    "author": "Jacques Delors",
    "category": "change",
    "id": 9826,
    "text": "We have to struggle against the conservatives from all sides, not only the right-wingers, but also the left-wing conservatives who don't want to change anything."
  },
  {
    "author": "David Cameron",
    "category": "change",
    "id": 9716,
    "text": "We have the character of an island nation: independent, forthright, passionate in defence of our sovereignty. We can no more change this British sensibility than we can drain the English Channel. And because of this sensibility, we come to the European Union with a frame of mind that is more practical than emotional."
  },
  {
    "author": "Elizabeth Edwards",
    "category": "change",
    "id": 9736,
    "text": "Maybe we all change over time."
  },
  {
    "author": "William Hague",
    "category": "change",
    "id": 9838,
    "text": "I believe we should reframe our response to climate change as an imperative for growth rather than merely being a way of being green or meeting environmental commitments."
  },
  {
    "author": "W. Edwards Deming",
    "category": "change",
    "id": 9469,
    "text": "It is not necessary to change. Survival is not mandatory."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "change",
    "id": 9368,
    "text": "That last day does not bring extinction to us, but change of place."
  },
  {
    "author": "Van Morrison",
    "category": "change",
    "id": 9495,
    "text": "You can't stay the same. If you're a musician and a singer, you have to change, that's the way it works."
  },
  {
    "author": "Mitt Romney",
    "category": "change",
    "id": 9301,
    "text": "This is the America that I love. This is a great people. We can do anything. We can achieve anything. We've got a government that has gotten in the way of the American people. We're going to change that in November."
  },
  {
    "author": "Eleanor Roosevelt",
    "category": "change",
    "id": 9206,
    "text": "You can't move so fast that you try to change the mores faster than people can accept it. That doesn't mean you do nothing, but it means that you do the things that need to be done according to priority."
  },
  {
    "author": "Harrison Ford",
    "category": "change",
    "id": 9089,
    "text": "We all have big changes in our lives that are more or less a second chance."
  },
  {
    "author": "Plato",
    "category": "change",
    "id": 9258,
    "text": "Excess generally causes reaction, and produces a change in the opposite direction, whether it be in the seasons, or in individuals, or in governments."
  },
  {
    "author": "Robert Kennedy",
    "category": "change",
    "id": 9278,
    "text": "If any man claims the Negro should be content... let him say he would willingly change the color of his skin and go to live in the Negro section of a large city. Then and only then has he a right to such a claim."
  },
  {
    "author": "William Hague",
    "category": "change",
    "id": 9836,
    "text": "Unless there is meaningful change in Syria and an end to the crackdown, President Assad and those around him will find themselves isolated internationally and discredited within Syria."
  },
  {
    "author": "Alvin Toffler",
    "category": "change",
    "id": 9120,
    "text": "Future shock is the shattering stress and disorientation that we induce in individuals by subjecting them to too much change in too short a time."
  },
  {
    "author": "Albert Ellis",
    "category": "change",
    "id": 9419,
    "text": "We teach people that they upset themselves. We can't change the past, so we change how people are thinking, feeling and behaving today."
  },
  {
    "author": "Marilu Henner",
    "category": "change",
    "id": 9563,
    "text": "Like it or not, the world evolves, priorities change and so do you."
  },
  {
    "author": "Daniel Keys Moran",
    "category": "change",
    "id": 9997,
    "text": "You want to balance the budget in this country? We change the salary structure for Congress and the President. Every year they don't balance the budget, we don't pay them."
  },
  {
    "author": "John Dingell",
    "category": "change",
    "id": 9830,
    "text": "If we're going to change the laws, let's change them in ways which makes it easier to catch criminals, and yet at the same time protect the Second Amendment rights of our law-abiding citizens."
  },
  {
    "author": "Bono",
    "category": "change",
    "id": 9351,
    "text": "As a rock star, I have two instincts, I want to have fun, and I want to change the world. I have a chance to do both."
  },
  {
    "author": "Henry Rollins",
    "category": "change",
    "id": 9424,
    "text": "I want to change things for the better, just like everybody else."
  },
  {
    "author": "Ian Botham",
    "category": "change",
    "id": 9158,
    "text": "If you can change three lives in 10, three lives in a hundred, that's got to be good, hasn't it?"
  },
  {
    "author": "Pearl S. Buck",
    "category": "change",
    "id": 9561,
    "text": "A good marriage is one which allows for change and growth in the individuals and in the way they express their love."
  },
  {
    "author": "Robert Rodriguez",
    "category": "change",
    "id": 9866,
    "text": "When you go off in the world and make your life, and you come back to your home town, and you find your old high-school friends driving in the same circles, doing the same things, that's what Hollywood's like. It's a little block, little town. It doesn't really grow or change."
  },
  {
    "author": "Peter Drucker",
    "category": "change",
    "id": 9316,
    "text": "The entrepreneur always searches for change, responds to it, and exploits it as an opportunity."
  },
  {
    "author": "Barbara Bush",
    "category": "change",
    "id": 9582,
    "text": "The personal things should be left out of platforms at conventions. You can argue yourself blue in the face, and you're not going to change each other's minds. It's a waste of your time and my time."
  },
  {
    "author": "Ivor Novello",
    "category": "change",
    "id": 9566,
    "text": "A visit to a cinema is a little outing in itself. It breaks the monotony of an afternoon or evening it gives a change from the surroundings of home, however pleasant."
  },
  {
    "author": "David Herbert Lawrence",
    "category": "change",
    "id": 9443,
    "text": "Ethics and equity and the principles of justice do not change with the calendar."
  },
  {
    "author": "Maxine Waters",
    "category": "change",
    "id": 9889,
    "text": "This nation has always struggled with how it was going to deal with poor people and people of color. Every few years you will see some great change in the way that they approach this. We've had the war on poverty that never really got into waging a real war on poverty."
  },
  {
    "author": "W. Clement Stone",
    "category": "change",
    "id": 9117,
    "text": "All I want to do is change the world."
  },
  {
    "author": "Jeremy Renner",
    "category": "change",
    "id": 9800,
    "text": "People find themselves in ruts all the time. You're in a complacent lifestyle where you work 9 to 5 and then you add a mortgage and kids. You feel trapped, but guess what, brother? You constructed that life. If you're OK with it, there's nothing wrong with that. But if you've got unease, then you've got to make a change."
  },
  {
    "author": "Woody Guthrie",
    "category": "change",
    "id": 9619,
    "text": "Life has got a habit of not standing hitched. You got to ride it like you find it. You got to change with it. If a day goes by that don't change some of your old notions for new ones, that is just about like trying to milk a dead cow."
  },
  {
    "author": "Barbara Sher",
    "category": "change",
    "id": 9153,
    "text": "Change is not only likely, it's inevitable."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "change",
    "id": 9372,
    "text": "Characters do not change. Opinions alter, but characters are only developed."
  },
  {
    "author": "Heraclitus",
    "category": "change",
    "id": 9513,
    "text": "Nothing endures but change."
  },
  {
    "author": "Gilda Radner",
    "category": "change",
    "id": 9523,
    "text": "I think clothes should make you feel safe. I like clothes you want to go to sleep in. I sometimes stand in front of a mirror and change a million times because I know I really want to wear my nightgown."
  },
  {
    "author": "Jim Rohn",
    "category": "change",
    "id": 9197,
    "text": "If you don't like how things are, change it! You're not a tree."
  },
  {
    "author": "Jonathan Safran Foer",
    "category": "change",
    "id": 9872,
    "text": "I first became a vegetarian when I was nine, in response to an argument made by a radical babysitter. My great change - which lasted a couple of weeks - was based on the very simple instinct that it's wrong to kill animals for food."
  },
  {
    "author": "Niccolo Machiavelli",
    "category": "change",
    "id": 9104,
    "text": "One change always leaves the way open for the establishment of others."
  },
  {
    "author": "Paul Ryan",
    "category": "change",
    "id": 9562,
    "text": "Hope and change? We're not doing that anymore. They're doing attack and blame. And so, I just think people are going to see through this. They want real leadership. They want us to get this country on the right track."
  },
  {
    "author": "Elizabeth Warren",
    "category": "change",
    "id": 9842,
    "text": "I get heartfelt thanks from all kinds of people. Today I heard from a waitress in Georgia who has lost her job and is trying to figure out how her local bank can change the terms on her credit card, and I heard from a physicist at a major research university who wants to explain a better theory of financial stress tests."
  },
  {
    "author": "Herodotus",
    "category": "change",
    "id": 9896,
    "text": "Illness strikes men when they are exposed to change."
  },
  {
    "author": "Clint Eastwood",
    "category": "change",
    "id": 9246,
    "text": "Sometimes if you want to see a change for the better, you have to take things into your own hands."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "change",
    "id": 9403,
    "text": "There are plenty of problems in the world, and doubtless climate change - or whatever the currently voguish phrase for it all is - certainly is one of them. But it's low on my list."
  },
  {
    "author": "Linda Ellerbee",
    "category": "change",
    "id": 10023,
    "text": "Styles, like everything else, change. Style doesn't."
  },
  {
    "author": "Jim Rohn",
    "category": "change",
    "id": 9215,
    "text": "Character isn't something you were born with and can't change, like your fingerprints. It's something you weren't born with and must take responsibility for forming."
  },
  {
    "author": "Vanessa Hudgens",
    "category": "change",
    "id": 9445,
    "text": "If people don't like me for whatever I do, for being me, then that's too bad. I don't want to change to be something that I'm not for other people to like me."
  },
  {
    "author": "Gianni Versace",
    "category": "change",
    "id": 9161,
    "text": "I try to contrast life today is full of contrast... We have to change."
  },
  {
    "author": "Jennifer Jason Leigh",
    "category": "change",
    "id": 9772,
    "text": "I'm a typical middle child. I'm the mediator. The one that makes everything OK, puts their own needs aside to make sure everybody's happy. It's hard to change your nature, even with years and years of therapy."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "change",
    "id": 9371,
    "text": "Heat of blood makes young people change their inclinations often, and habit makes old ones keep to theirs a great while."
  },
  {
    "author": "William S. Burroughs",
    "category": "change",
    "id": 9284,
    "text": "Artists to my mind are the real architects of change, and not the political legislators who implement change after the fact."
  },
  {
    "author": "Alan Rickman",
    "category": "change",
    "id": 9701,
    "text": "I mean, language fascinates me anyway, and different words have different energies and you can change the whole drive of a sentence."
  },
  {
    "author": "Aristotle",
    "category": "change",
    "id": 9222,
    "text": "But if nothing but soul, or in soul mind, is qualified to count, it is impossible for there to be time unless there is soul, but only that of which time is an attribute, i.e. if change can exist without soul."
  },
  {
    "author": "John Podhoretz",
    "category": "change",
    "id": 9725,
    "text": "All non-incumbent campaigns promise hope and change, but Obama took the promise to a new level of absurdity. He suggested that a vote for him would literally transform the Earth."
  },
  {
    "author": "Robert Plant",
    "category": "change",
    "id": 9605,
    "text": "I have to try and change the landscape, whatever it is."
  },
  {
    "author": "Nikki Giovanni",
    "category": "change",
    "id": 9697,
    "text": "Everything will change. The only question is growing up or decaying."
  },
  {
    "author": "Eminem",
    "category": "change",
    "id": 9224,
    "text": "People can try to reinvent themselves. I don't think you can really change who you are, though, because who you are is pretty much where you came from and what you've done up to now."
  },
  {
    "author": "Ursula K. Le Guin",
    "category": "change",
    "id": 9687,
    "text": "We are volcanoes. When we women offer our experience as our truth, as human truth, all the maps change. There are new mountains."
  },
  {
    "author": "Aldous Huxley",
    "category": "change",
    "id": 9304,
    "text": "I wanted to change the world. But I have found that the only thing one can be sure of changing is oneself."
  },
  {
    "author": "Confucius",
    "category": "change",
    "id": 9072,
    "text": "Only the wisest and stupidest of men never change."
  },
  {
    "author": "Sebastian Vettel",
    "category": "change",
    "id": 9506,
    "text": "I don't care what other people think as long as I am happy. The day I die or retire, I have blown all my chances because I don't have the chance any more to change my image as an F1 driver."
  },
  {
    "author": "Barbara Deming",
    "category": "change",
    "id": 9599,
    "text": "Vengeance is not the point change is. But the trouble is that in most people's minds the thought of victory and the thought of punishing the enemy coincide."
  },
  {
    "author": "Lech Walesa",
    "category": "change",
    "id": 9934,
    "text": "The politicians always told us that the Cold War stand-off could only change by way of nuclear war. None of them believed that such systemic change was possible."
  },
  {
    "author": "Suze Orman",
    "category": "change",
    "id": 9689,
    "text": "Rather than saying, 'My checking account is a wreck,' change it to 'I will learn how to track my spending and balance my checkbook.'"
  },
  {
    "author": "Joyce Meyer",
    "category": "change",
    "id": 9477,
    "text": "Teachers can change lives with just the right mix of chalk and challenges."
  },
  {
    "author": "Richard Wagner",
    "category": "change",
    "id": 9680,
    "text": "Even if I know I shall never change the masses, never transform anything permanent, all I ask is that the good things also have their place, their refuge."
  },
  {
    "author": "Ice T",
    "category": "change",
    "id": 9900,
    "text": "Redemption just means you just make a change in your life and you try to do right, versus what you were doing, which was wrong."
  },
  {
    "author": "Rashida Jones",
    "category": "change",
    "id": 9833,
    "text": "I have to say, you know, I've seen so many people go through the cycle and become famous and not famous anymore and, you know, want - have their priorities change and want different things."
  },
  {
    "author": "Peter Schuyler",
    "category": "change",
    "id": 9519,
    "text": "Until we totally change the way we elect our leaders, until we remove private money from public campaigns, lying will be the de facto method of governance in this country."
  },
  {
    "author": "Al Gore",
    "category": "change",
    "id": 9595,
    "text": "As I have said for many years throughout this land, we're borrowing money from China to buy oil from the Persian Gulf to burn it in ways that destroy the future of human civilization. Every bit of that has to change."
  },
  {
    "author": "Barack Obama",
    "category": "change",
    "id": 9286,
    "text": "Of course, there is no question that Libya - and the world - will be better off with Gaddafi out of power. I, along with many other world leaders, have embraced that goal, and will actively pursue it through non-military means. But broadening our military mission to include regime change would be a mistake."
  },
  {
    "author": "Paul Ryan",
    "category": "change",
    "id": 9408,
    "text": "Millions of young Americans have graduated from college during the Obama presidency, ready to use their gifts and get moving in life. Half of them can't find the work they studied for, or any work at all. So here's the question: Without a change in leadership, why would the next four years be any different from the last four years?"
  },
  {
    "author": "Marco Rubio",
    "category": "change",
    "id": 9544,
    "text": "Under Barack Obama, the only 'Change' is that 'Hope' has been hard to find. Now millions of Americans are insecure about their future. But instead of inspiring us by reminding us of what makes us special, he divides us against each other. He tells Americans they're worse off because others are better off. That people got rich by making others poor."
  },
  {
    "author": "Steven Spielberg",
    "category": "change",
    "id": 9430,
    "text": "You know, I don't really do that much looking inside me when I'm working on a project. Whatever I am becomes what that film is. But I change you change."
  },
  {
    "author": "Vivienne Westwood",
    "category": "change",
    "id": 9709,
    "text": "Our economic system, run for profit and waste and based primarily on the extractive industries, is the cause of climate change. We have wasted the earth's treasure and we can no longer exploit it cheaply."
  },
  {
    "author": "Shania Twain",
    "category": "change",
    "id": 9626,
    "text": "I spent a lot of my life holding back my cries, and I want to change that because it's not good for me."
  },
  {
    "author": "Jeff Goodell",
    "category": "change",
    "id": 9915,
    "text": "Maybe more climate activists will think about the climate change not as an international problem to be resolved in an air-conditioned meeting hall, but as a guerilla war to be fought in the streets."
  },
  {
    "author": "Robert Conklin",
    "category": "change",
    "id": 9567,
    "text": "Resistance is thought transformed into feeling. Change the thought that creates the resistance, and there is no more resistance."
  },
  {
    "author": "Alan Watts",
    "category": "change",
    "id": 9074,
    "text": "The only way to make sense out of change is to plunge into it, move with it, and join the dance."
  }
]

quotes['communication'] = [
  {
    "author": "Mark Twain",
    "category": "communication",
    "id": 10041,
    "text": "A man's character may be learned from the adjectives which he habitually uses in conversation."
  },
  {
    "author": "Oliver Evans",
    "category": "communication",
    "id": 10320,
    "text": "It frequently happens that two persons, reasoning right on a mechanical subject, think alike and invent the same thing without any communication with each other."
  },
  {
    "author": "Rockwell Kent",
    "category": "communication",
    "id": 10321,
    "text": "Art must unquestionably have a social value that is, as a potential means of communication it must be addressed, and in comprehensible terms, to the understanding of mankind."
  },
  {
    "author": "Mira Nair",
    "category": "communication",
    "id": 10201,
    "text": "We have to realize only in communication, in real knowledge, in real reaching out, can there be an understanding that there's humanity everywhere, and that's what I'm trying to do."
  },
  {
    "author": "Walt Disney",
    "category": "communication",
    "id": 10052,
    "text": "Of all of our inventions for mass communication, pictures still speak the most universally understood language."
  },
  {
    "author": "Frank Luntz",
    "category": "communication",
    "id": 10184,
    "text": "Ideology and communication more often than not run into each other rather than complement each other. Principle and communication work together. Ideology and communication often work apart."
  },
  {
    "author": "Georges Simenon",
    "category": "communication",
    "id": 10292,
    "text": "The fact that we are I don't know how many millions of people, yet communication, complete communication, is completely impossible between two of those people, is to me one of the biggest tragic themes in the world."
  },
  {
    "author": "Jada Pinkett Smith",
    "category": "communication",
    "id": 10075,
    "text": "My belief is that communication is the best way to create strong relationships."
  },
  {
    "author": "Steven Bochco",
    "category": "communication",
    "id": 10245,
    "text": "Being a good television screenwriter requires an understanding of the way film accelerates the communication of words."
  },
  {
    "author": "F. Scott Fitzgerald",
    "category": "communication",
    "id": 10062,
    "text": "Genius is the ability to put into effect what is on your mind."
  },
  {
    "author": "Henry Cuellar",
    "category": "communication",
    "id": 10301,
    "text": "We intend to keep the lines of communication open with the Defense Department so we can help our border law enforcement agencies navigate the equipment application process."
  },
  {
    "author": "Jim Rohn",
    "category": "communication",
    "id": 10047,
    "text": "Take advantage of every opportunity to practice your communication skills so that when important occasions arise, you will have the gift, the style, the sharpness, the clarity, and the emotions to affect other people."
  },
  {
    "author": "Dick Wolf",
    "category": "communication",
    "id": 10096,
    "text": "I try to just communicate what I want done as clearly and simply as possible."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "communication",
    "id": 10120,
    "text": "The strong man is the one who is able to intercept at will the communication between the senses and the mind."
  },
  {
    "author": "Marshall McLuhan",
    "category": "communication",
    "id": 10139,
    "text": "Societies have always been shaped more by the nature of the media by which men communicate than by the content of the communication."
  },
  {
    "author": "Erik Qualman",
    "category": "communication",
    "id": 10172,
    "text": "You're talking about a younger generation, Generation Y, whose interpersonal communication skills are different from Generation X. The younger generation is more comfortable saying something through a digital mechanism than even face to face."
  },
  {
    "author": "Townsend Harris",
    "category": "communication",
    "id": 10263,
    "text": "The nations of the West hope that by means of steam communication all the world will become as one family."
  },
  {
    "author": "Zachary Quinto",
    "category": "communication",
    "id": 10238,
    "text": "I find that communication as an actor and person is an important part of who I am. And I'm really drawn into the psychology of those dynamics."
  },
  {
    "author": "Jim Evans",
    "category": "communication",
    "id": 10195,
    "text": "As a whole, the managers today are different in temperament. Most have very good communication skills and are more understanding of the umpire's job. That doesn't mean they are better managers. It just means that I perceive today's managers a bit differently."
  },
  {
    "author": "Jack Welch",
    "category": "communication",
    "id": 10071,
    "text": "Number one, cash is king... number two, communicate... number three, buy or bury the competition."
  },
  {
    "author": "Theo de Raadt",
    "category": "communication",
    "id": 10310,
    "text": "I work on OpenBSD fulltime, as the project leader. I set some directions, increase communication between the developers, and try to be involved in nearly every aspect of the base system."
  },
  {
    "author": "Lee Scott",
    "category": "communication",
    "id": 10255,
    "text": "People aren't going to talk about it except me and that is communication and the visits I have personally had in our meetings with our store managers saying if you do these things you will be terminated, period."
  },
  {
    "author": "Robert Delaunay",
    "category": "communication",
    "id": 10211,
    "text": "This communication alone, by the comparison of the antagonisms, rivalries, movements which give birth to decisive moments, permits the evolution of the soul, whereby a man realizes himself on earth. It is impossible to be concerned with anything else in art."
  },
  {
    "author": "George Allen",
    "category": "communication",
    "id": 10302,
    "text": "It is vital that the United States maintains open lines of communication with our allies. We must assure them of our commitment to eradicating global terrorism wherever it may reside or wherever it's given haven."
  },
  {
    "author": "Evelyn Glennie",
    "category": "communication",
    "id": 10147,
    "text": "Music is about communication... it isn't just something that maybe physically sounds good or orally sounds interesting it's something far, far deeper than that."
  },
  {
    "author": "Preet Bharara",
    "category": "communication",
    "id": 10281,
    "text": "Significant officials at publicly traded companies are casually and cavalierly engaged in insider trading. Because insider trading has as one of its elements communication, it doesn't take rocket science to realize it's nice to have the communication on tape."
  },
  {
    "author": "T. S. Eliot",
    "category": "communication",
    "id": 10061,
    "text": "The communication of the dead is tongued with fire beyond the language of the living."
  },
  {
    "author": "Kenny G",
    "category": "communication",
    "id": 10223,
    "text": "I mean, what is music anyway? It's a form of communication - at least for me it is. And that's why I play the kind of music that I think - that I hope - can communicate with people."
  },
  {
    "author": "John Davidson",
    "category": "communication",
    "id": 10311,
    "text": "My approach is so simple every song I sing, every story I tell, every move I make, must move the audience to laughter, tears, or inspiration. Otherwise, why do it? It's the communication."
  },
  {
    "author": "Yoko Ono",
    "category": "communication",
    "id": 10166,
    "text": "People make music to get a reaction. Music is communication."
  },
  {
    "author": "Desiderius Erasmus",
    "category": "communication",
    "id": 10072,
    "text": "The desire to write grows with writing."
  },
  {
    "author": "Yo-Yo Ma",
    "category": "communication",
    "id": 10196,
    "text": "The thing that I've always been slightly frustrated with, was that the idea of a CD is kind of confined to a material possession that you can put on a shelf. And the idea of music, for me, is always about both the communication and the sharing of content. And so the interactive part is missing."
  },
  {
    "author": "Ansel Adams",
    "category": "communication",
    "id": 10056,
    "text": "Photography is more than a medium for factual communication of ideas. It is a creative art."
  },
  {
    "author": "David Bohm",
    "category": "communication",
    "id": 10221,
    "text": "Yet, in spite of this world-wide system of linkages, there is, at this very moment, a general feeling that communication is breaking down everywhere, on an unparalleled scale."
  },
  {
    "author": "Joshua Foer",
    "category": "communication",
    "id": 10200,
    "text": "No one who set out to design a form of communication would ever end up with anything like English, Mandarin, or any of the more than six thousand languages spoken today."
  },
  {
    "author": "Frank Luntz",
    "category": "communication",
    "id": 10183,
    "text": "I don't understand why people whose entire lives or their corporate success depends on communication, and yet they are led on occasion by CEOs who cannot talk their way out of a paper bag and don't care to."
  },
  {
    "author": "Annie Leibovitz",
    "category": "communication",
    "id": 10158,
    "text": "There must be a reason why photographers are not very good at verbal communication. I think we get lazy."
  },
  {
    "author": "Tom Wolfe",
    "category": "communication",
    "id": 10088,
    "text": "There are some people who have the quality of richness and joy in them and they communicate it to everything they touch. It is first of all a physical quality then it is a quality of the spirit."
  },
  {
    "author": "Erin Gray",
    "category": "communication",
    "id": 10284,
    "text": "My mother and I always had full adult communication."
  },
  {
    "author": "Leonard Bernstein",
    "category": "communication",
    "id": 10159,
    "text": "Technique is communication: the two words are synonymous in conductors."
  },
  {
    "author": "Tony Goldwyn",
    "category": "communication",
    "id": 10290,
    "text": "My two daughters live on Facebook, and social media is their mode of communication."
  },
  {
    "author": "Lou Rawls",
    "category": "communication",
    "id": 10315,
    "text": "Music is the greatest communication in the world. Even if people don't understand the language that you're singing in, they still know good music when they hear it."
  },
  {
    "author": "Marc Andreessen",
    "category": "communication",
    "id": 10152,
    "text": "And once you get instantaneous communication with everybody, you have economic activity that's far more advanced, far more liquid, far more distributed than ever before."
  },
  {
    "author": "Karen Black",
    "category": "communication",
    "id": 10296,
    "text": "Illiteracy is rampant. People are out of communication."
  },
  {
    "author": "Jared Diamond",
    "category": "communication",
    "id": 10202,
    "text": "I've worked very hard in this book to keep the lines of communication open. I don't want to turn someone away from this information for partisan political reasons."
  },
  {
    "author": "Epictetus",
    "category": "communication",
    "id": 10053,
    "text": "First learn the meaning of what you say, and then speak."
  },
  {
    "author": "William Friedkin",
    "category": "communication",
    "id": 10304,
    "text": "The first work of the director is to set a mood so that the actor's work can take place, so that the actor can create. And in order to do that, you have to communicate, communicate with the actors. And direction is about communication on all levels."
  },
  {
    "author": "Thom Mayne",
    "category": "communication",
    "id": 10227,
    "text": "But I absolutely believe that architecture is a social activity that has to do with some sort of communication or places of interaction, and that to change the environment is to change behaviour."
  },
  {
    "author": "La Monte Young",
    "category": "communication",
    "id": 10114,
    "text": "If listeners aren't carried away to Heaven, I'm failing."
  },
  {
    "author": "Alexander Kluge",
    "category": "communication",
    "id": 10298,
    "text": "As soon as you judge communication a little more rigorously, there is a possibility that the message will not be democratized. I have to say what I believe to be right. I have to spread out the statement among all the means of expression available to us at present."
  },
  {
    "author": "Thor Heyerdahl",
    "category": "communication",
    "id": 10186,
    "text": "Civilization grew in the beginning from the minute that we had communication - particularly communication by sea that enabled people to get inspiration and ideas from each other and to exchange basic raw materials."
  },
  {
    "author": "Marc Garneau",
    "category": "communication",
    "id": 10279,
    "text": "Canada's a huge country, so to be able to unite the country through communication satellite technology or to be able to observe it through remote sensing technology from space is a natural fit for a country like Canada."
  },
  {
    "author": "Lee Grant",
    "category": "communication",
    "id": 10293,
    "text": "People break down after a couple of hours. All the defenses go down, and there's a kind of communication that if I spent 20 years in a living room with one of these people, I would never, never know as much about them as I do in that one day."
  },
  {
    "author": "Baltasar Gracian",
    "category": "communication",
    "id": 10076,
    "text": "He that communicates his secret to another makes himself that other's slave."
  },
  {
    "author": "Lesley Garrett",
    "category": "communication",
    "id": 10219,
    "text": "That was when I realised that music is the most profound, magical form of communication there is."
  },
  {
    "author": "Dick Wolf",
    "category": "communication",
    "id": 10176,
    "text": "People recognize certain things, like 'D' means 'this dialogue stinks.' We're dealing with shows that are written here, shot in New York and posted back here. Accurate communication is a necessity."
  },
  {
    "author": "David Bohm",
    "category": "communication",
    "id": 10189,
    "text": "During the past few decades, modern technology, with radio, TV, air travel, and satellites, has woven a network of communication which puts each part of the world in to almost instant contact with all the other parts."
  },
  {
    "author": "Leo Rosten",
    "category": "communication",
    "id": 10086,
    "text": "Extremists think 'communication' means agreeing with them."
  },
  {
    "author": "Frank Ocean",
    "category": "communication",
    "id": 10217,
    "text": "I feel like I was writing as I was learning to talk. Writing was always a go-to form of communication. And I knew I could sing from being in tune with the radio."
  },
  {
    "author": "Mac Davis",
    "category": "communication",
    "id": 10275,
    "text": "I didn't have a lot of communication with Elvis. You had to go through a barricade to get to Elvis. It was people hanging on every word, and I felt very uncomfortable a lot of times."
  },
  {
    "author": "Elaine MacDonald",
    "category": "communication",
    "id": 10278,
    "text": "If you improve a teacher's self-esteem, confidence, communication skills or stress levels, you improve that teacher's overall effectiveness across the curriculum."
  },
  {
    "author": "Erykah Badu",
    "category": "communication",
    "id": 10167,
    "text": "What does music mean to me? I don't think I would really be much without it, without it coming through me. It's my means of communication, my means of growth, my means of transportation from one point in my life to another."
  },
  {
    "author": "Lou Gerstner",
    "category": "communication",
    "id": 10294,
    "text": "It's about communication. It's about honesty. It's about treating people in the organization as deserving to know the facts. You don't try to give them half the story. You don't try to hide the story. You treat them as - as true equals, and you communicate and you communicate and communicate."
  },
  {
    "author": "Michael Tilson Thomas",
    "category": "communication",
    "id": 10254,
    "text": "But if I can be convinced and then through the work that we do together, the orchestra can really be convinced of the big sweep of that communication that the piece suggests, then the audience will get it and it will be a good experience for all of us."
  },
  {
    "author": "Amy Klobuchar",
    "category": "communication",
    "id": 10237,
    "text": "Who would know but ten years ago that kids would be texting each other all the time, that that would be one of their main forms of communication. And so many times, these kids know more about the technology than their parents. And so many times, we're putting kids in very adult situations and expecting them to behave like they're 40 years old."
  },
  {
    "author": "Lao Tzu",
    "category": "communication",
    "id": 10042,
    "text": "Truthful words are not beautiful beautiful words are not truthful. Good words are not persuasive persuasive words are not good."
  },
  {
    "author": "Deborah Tannen",
    "category": "communication",
    "id": 10122,
    "text": "Communication is a continual balancing act, juggling the conflicting needs for intimacy and independence. To survive in the world, we have to act in concert with others, but to survive as ourselves, rather than simply as cogs in a wheel, we have to act alone."
  },
  {
    "author": "Naomi Judd",
    "category": "communication",
    "id": 10243,
    "text": "It's so important for those living with chronic pain to establish good communication with both their healthcare professionals and caregivers. Clear communication about pain is vital to receiving proper diagnosis and effective treatment."
  },
  {
    "author": "Warren Rudman",
    "category": "communication",
    "id": 10289,
    "text": "The other thing about FEMA, my understanding is that it was supposed to move into the Department of Homeland Security... and be what it was, but also having a lot of lateral communication with all those others involved in that issue of homeland security."
  },
  {
    "author": "Ruth St. Denis",
    "category": "communication",
    "id": 10092,
    "text": "I see dance being used as communication between body and soul, to express what it too deep to find for words."
  },
  {
    "author": "Amy Klobuchar",
    "category": "communication",
    "id": 10236,
    "text": "Who would know but ten years ago that kids would be texting each other all the time, that that would be one of their main forms of communication."
  },
  {
    "author": "Bo Bennett",
    "category": "communication",
    "id": 10130,
    "text": "Communication is about being effective, not always about being proper."
  },
  {
    "author": "Alan Greenspan",
    "category": "communication",
    "id": 10150,
    "text": "To succeed, you will soon learn, as I did, the importance of a solid foundation in the basics of education - literacy, both verbal and numerical, and communication skills."
  },
  {
    "author": "Patti Smith",
    "category": "communication",
    "id": 10162,
    "text": "The new artists coming through were very materialistic and Hollywood, not so engaged in communication."
  },
  {
    "author": "Henri Frederic Amiel",
    "category": "communication",
    "id": 10085,
    "text": "Pure truth cannot be assimilated by the crowd it must be communicated by contagion."
  },
  {
    "author": "Rollo May",
    "category": "communication",
    "id": 10064,
    "text": "Communication leads to community, that is, to understanding, intimacy and mutual valuing."
  },
  {
    "author": "Christopher Morley",
    "category": "communication",
    "id": 10080,
    "text": "There is only one rule for being a good talker - learn to listen."
  },
  {
    "author": "John Powell",
    "category": "communication",
    "id": 10091,
    "text": "Communication works for those who work at it."
  },
  {
    "author": "Jarvis Cocker",
    "category": "communication",
    "id": 10169,
    "text": "I speak onstage to try to establish some method of communication. The songs are supposed to be a way of communicating. But speech and drinks and sometimes chocolates are also a way of communicating."
  },
  {
    "author": "Paul A. Volcker",
    "category": "communication",
    "id": 10297,
    "text": "The speed of communication, the speed of information transfer, the cheapness of communication, the ease of moving things around the world are a difference in kind as well as degree."
  },
  {
    "author": "Edward R. Murrow",
    "category": "communication",
    "id": 10079,
    "text": "The speed of communications is wondrous to behold. It is also true that speed can multiply the distribution of information that we know to be untrue."
  },
  {
    "author": "Bob Parsons",
    "category": "communication",
    "id": 10288,
    "text": "The Internet has changed everything. We expect to know everything instantly. If you don't understand digital communication, you're at a disadvantage."
  },
  {
    "author": "Robert Anton Wilson",
    "category": "communication",
    "id": 10128,
    "text": "A monopoly on the means of communication may define a ruling elite more precisely than the celebrated Marxian formula of monopoly in the means of production."
  },
  {
    "author": "Lyndon B. Johnson",
    "category": "communication",
    "id": 10135,
    "text": "Our most tragic error may have been our inability to establish a rapport and a confidence with the press and television with the communication media. I don't think the press has understood me."
  },
  {
    "author": "Guy Fieri",
    "category": "communication",
    "id": 10144,
    "text": "My stay-married secret would probably be exercising good communication, not when you have to but all the time. I think if you do that, you kinda just cleanse the situations, so there's not build up. I think that's probably the best way to do it."
  },
  {
    "author": "Hideki Tojo",
    "category": "communication",
    "id": 10250,
    "text": "However, even during the preparations for action, we laid our plans in such a manner that should there be progress through diplomatic negotiation, we would be well prepared to cancel operations at the latest moment that communication technology would have permitted."
  },
  {
    "author": "John Sweeney",
    "category": "communication",
    "id": 10286,
    "text": "The church acknowledges some Scientologists choose to sever communications with family members who leave. The church says it is a fundamental human right to cease communication with someone. It adds disconnection is used against expelled members and those who attack the church."
  },
  {
    "author": "Alton Brown",
    "category": "communication",
    "id": 10148,
    "text": "I like television. I still believe that television is the most powerful form of communication on Earth - I just hate what is being done with it."
  },
  {
    "author": "Cherrie Moraga",
    "category": "communication",
    "id": 10322,
    "text": "In 1984, I turned to theater in the hopes of finding a more direct form of communication between me and my people."
  },
  {
    "author": "Emma Thompson",
    "category": "communication",
    "id": 10046,
    "text": "Any problem, big or small, within a family, always seems to start with bad communication. Someone isn't listening."
  },
  {
    "author": "Anne Archer",
    "category": "communication",
    "id": 10316,
    "text": "Communication is very important. And the arts do that, whether it's film or theater."
  },
  {
    "author": "Lois Capps",
    "category": "communication",
    "id": 10133,
    "text": "Nurses serve their patients in the most important capacities. We know that they serve as our first lines of communication when something goes wrong or when we are concerned about health."
  },
  {
    "author": "Charles Sturt",
    "category": "communication",
    "id": 10232,
    "text": "Now it is evident that a little insight into the customs of every people is necessary to insure a kindly communication this, joined with patience and kindness, will seldom fail with the natives of the interior."
  },
  {
    "author": "James Levine",
    "category": "communication",
    "id": 10216,
    "text": "It has to be able to play at the maximum expression and communication in every style, and the only way you can do that is - like Verdi said - working with a file, every day, little by little, until the orchestra's collective qualities emerge."
  },
  {
    "author": "Ralph Ellison",
    "category": "communication",
    "id": 10204,
    "text": "By and large, the critics and readers gave me an affirmed sense of my identity as a writer. You might know this within yourself, but to have it affirmed by others is of utmost importance. Writing is, after all, a form of communication."
  },
  {
    "author": "Oliver Joseph Lodge",
    "category": "communication",
    "id": 10287,
    "text": "We know that communication must be hampered, and its form largely determined, by the unconscious but inevitable influence of a transmitting mechanism, whether that be of a merely mechanical or of a physiological character."
  },
  {
    "author": "Jane Goodall",
    "category": "communication",
    "id": 10175,
    "text": "I thought my life was mapped out. Research, living in the forest, teaching and writing. But in '86 I went to a conference and realised the chimpanzees were disappearing. I had worldwide recognition and a gift of communication. I had to use them."
  },
  {
    "author": "Patrick J. Kennedy",
    "category": "communication",
    "id": 10234,
    "text": "On the other hand, the American public possesses a great resilience and strength, and good risk communication strategies can tap into and even amplify those assets."
  },
  {
    "author": "Kenneth L. Pike",
    "category": "communication",
    "id": 10101,
    "text": "Without a possibility of change in meanings human communication could not perform its present functions."
  },
  {
    "author": "John Shimkus",
    "category": "communication",
    "id": 10280,
    "text": "States are looking for low-cost solutions that will enable better communication, while avoiding the danger in which the chain of command breaks down in emergencies. We do not want everyone talking to everyone else all the time."
  }
]

quotes['computers'] = [
  {
    "author": "Sam Wyly",
    "category": "computers",
    "id": 10563,
    "text": "Originally, I was in both software and in online computing. The first innovation really was sort of at that time that we're marrying the telephone and the computer so that people wouldn't have to drive to the computer center. We didn't have $1,000 computers."
  },
  {
    "author": "Berkeley Breathed",
    "category": "computers",
    "id": 10503,
    "text": "It was a huge challenge to learn digital painting well enough so that computers don't pop into mind when one sees one."
  },
  {
    "author": "Bruce Schneier",
    "category": "computers",
    "id": 10398,
    "text": "I am regularly asked what the average Internet user can do to ensure his security. My first answer is usually 'Nothing you're screwed'."
  },
  {
    "author": "Tony Visconti",
    "category": "computers",
    "id": 10378,
    "text": "Computers have virtually replaced tape recorders."
  },
  {
    "author": "Edward Tufte",
    "category": "computers",
    "id": 10375,
    "text": "If you like overheads, you'll love PowerPoint."
  },
  {
    "author": "Garrett Hedlund",
    "category": "computers",
    "id": 10474,
    "text": "I was a 'Duck Hunt' and 'Mario' guy, and stuff like that. I was never technologically driven. I never had all the cool, new toys. I was the youngest child, I wasn't the only child, so I wasn't spoiled as a kid. And, we were on the farm, so we didn't have a lot. Also, with computers, I'm not very good with them. I just check my email."
  },
  {
    "author": "Hayao Miyazaki",
    "category": "computers",
    "id": 10517,
    "text": "It seems like everything that we see perceived in the brain before we actually use our own eyes, that everything we see is coming through computers or machines and then is being input in our brain cells. So that really worries me."
  },
  {
    "author": "Carrie-Anne Moss",
    "category": "computers",
    "id": 10469,
    "text": "I'm a very simple person. I don't use computers."
  },
  {
    "author": "Dee Brown",
    "category": "computers",
    "id": 10415,
    "text": "I've tried word processors, but I think I'm too old a dog to use one."
  },
  {
    "author": "Louis C. K.",
    "category": "computers",
    "id": 10436,
    "text": "I have a crazy amount of different jobs, so the way I manage that is to not do more than one at a time. It's like old computers that had small memory chips, they would do something called swapping, where they would fill the memory with one task, do it and get it out."
  },
  {
    "author": "Erykah Badu",
    "category": "computers",
    "id": 10354,
    "text": "Man, I don't want to have nothing to do with computers. I don't want the government in my business."
  },
  {
    "author": "Stephen Root",
    "category": "computers",
    "id": 10541,
    "text": "People are on their computers more than watching TV, because you can only watch voyeur TV, which is basically what reality shows are, for so long."
  },
  {
    "author": "Greg Egan",
    "category": "computers",
    "id": 10557,
    "text": "Diaspora starts about a thousand years from now. Most of human civilisation has moved inside computers essentially, a major branch of our descendants consists of conscious software."
  },
  {
    "author": "Charles Keating",
    "category": "computers",
    "id": 10562,
    "text": "Computers rather frighten me, because I never did learn to type, so the whole thing seems extraordinarily complicated to me."
  },
  {
    "author": "Mike Davidson",
    "category": "computers",
    "id": 10543,
    "text": "If I was designing a web site for elementary school children, I might have a much higher percentage of older computers with outdated browsers since keeping up with browser and hardware technology has not traditionally been a strong point of most elementary schools."
  },
  {
    "author": "Sherman Austin",
    "category": "computers",
    "id": 10565,
    "text": "When they were done downloading all the information off each hard drive, they took all the computers, all the literature, and loaded everything into a big white truck and left."
  },
  {
    "author": "Jon Porter",
    "category": "computers",
    "id": 10513,
    "text": "We have an epidemic of sexual predators following our children, whether it be on the computers, whether it be in our public parks, whether it be in the workplace, or even our schools."
  },
  {
    "author": "Jack Welch",
    "category": "computers",
    "id": 10349,
    "text": "I was afraid of the internet... because I couldn't type."
  },
  {
    "author": "Thabo Mbeki",
    "category": "computers",
    "id": 10351,
    "text": "Many of our own people here in this country do not ask about computers, telephones and television sets. They ask - when will we get a road to our village."
  },
  {
    "author": "Mark Rylance",
    "category": "computers",
    "id": 10556,
    "text": "Well, my wife always says to me, and I think it's true, it's very difficult for us to understand the Elizabethan understanding and enjoyment and perception of form as it is to say... it would be for them to understand computers or going to the moon or something."
  },
  {
    "author": "Eugene Jarvis",
    "category": "computers",
    "id": 10387,
    "text": "The only legitimate use of a computer is to play games."
  },
  {
    "author": "Robert Orben",
    "category": "computers",
    "id": 10342,
    "text": "To err is human - and to blame it on a computer is even more so."
  },
  {
    "author": "Bill Gates",
    "category": "computers",
    "id": 10327,
    "text": "I think it's fair to say that personal computers have become the most empowering tool we've ever created. They're tools of communication, they're tools of creativity, and they can be shaped by their user."
  },
  {
    "author": "Charles Foster Bass",
    "category": "computers",
    "id": 10524,
    "text": "China has legally purchased high performance computers, advanced machine tools, and semiconductor-manufacturing equipment from several American companies."
  },
  {
    "author": "Jef Raskin",
    "category": "computers",
    "id": 10406,
    "text": "Right now, computers, which are supposed to be our servant, are oppressing us."
  },
  {
    "author": "Vinton Cerf",
    "category": "computers",
    "id": 10486,
    "text": "I'm projecting somewhere between 100 million and 200 million computers on the Net by the end of December 2000, and about 300 million users by that same time."
  },
  {
    "author": "Jared Leto",
    "category": "computers",
    "id": 10485,
    "text": "I take computers practically apart and put them back together. I have a supercomputer I built over the years out of different computers."
  },
  {
    "author": "Christopher Plummer",
    "category": "computers",
    "id": 10404,
    "text": "I'm too old-fashioned to use a computer. I'm too old-fashioned to use a quill."
  },
  {
    "author": "Jonathan Shapiro",
    "category": "computers",
    "id": 10392,
    "text": "Gee, I am a complete Luddite when it comes to computers, I can barely log on!"
  },
  {
    "author": "John Hawkes",
    "category": "computers",
    "id": 10462,
    "text": "The only thing I do on a computer is play Texas Hold 'Em, really. Obviously my cell phone is a computer. My car is a computer. I'm on computers every day without actively seeking them out."
  },
  {
    "author": "Michel Hazanavicius",
    "category": "computers",
    "id": 10491,
    "text": "I think we are at the very beginning of high changes, not only in terms of digital film, but in the way the movies will be screened, whether they'll be screened on phones, on computers - on everything."
  },
  {
    "author": "J. G. Ballard",
    "category": "computers",
    "id": 10437,
    "text": "Electronic aids, particularly domestic computers, will help the inner migration, the opting out of reality. Reality is no longer going to be the stuff out there, but the stuff inside your head. It's going to be commercial and nasty at the same time."
  },
  {
    "author": "Fareed Zakaria",
    "category": "computers",
    "id": 10454,
    "text": "The technological revolution at home makes it much easier for computers to do our work."
  },
  {
    "author": "Roy H. Williams",
    "category": "computers",
    "id": 10458,
    "text": "It appears that the media filters we carry in our heads are like computers: they've been forced to get faster in order to keep up with the demands our high-speed society puts on them."
  },
  {
    "author": "Herbert Simon",
    "category": "computers",
    "id": 10512,
    "text": "I don't care how big and fast computers are, they're not as big and fast as the world."
  },
  {
    "author": "Nicholas Negroponte",
    "category": "computers",
    "id": 10389,
    "text": "Even in the developing parts of the world, kids take to computers like fish to water."
  },
  {
    "author": "Justin Long",
    "category": "computers",
    "id": 10464,
    "text": "I look like a geeky hacker, but I don't know anything about computers."
  },
  {
    "author": "James Dyson",
    "category": "computers",
    "id": 10449,
    "text": "Today, computers are almost second nature to most of us."
  },
  {
    "author": "Scott Weiland",
    "category": "computers",
    "id": 10484,
    "text": "A lot of journalists like to suck up to celebrities, and then as soon as they're a safe distance away at their computers, they take shots. But that's the way society has become, especially in pop culture."
  },
  {
    "author": "James Iha",
    "category": "computers",
    "id": 10514,
    "text": "Well, we didn't have our original drummer on our last record. And most of that album was not played as a band in the studio. It was mostly the world of computers and overdubs. There was very few things played live or worked out as a band."
  },
  {
    "author": "Brian Eno",
    "category": "computers",
    "id": 10346,
    "text": "The basis of computer work is predicated on the idea that only the brain makes decisions and only the index finger does the work."
  },
  {
    "author": "Adam Osborne",
    "category": "computers",
    "id": 10400,
    "text": "The future lies in designing and selling computers that people don't realize are computers at all."
  },
  {
    "author": "William Landay",
    "category": "computers",
    "id": 10566,
    "text": "I am interested in computers and technology, and art, photography, and design."
  },
  {
    "author": "Jack White",
    "category": "computers",
    "id": 10433,
    "text": "That's what happens nowadays with people working on computers. They can so easily fix things with their mouse and take out all the, 'Oh, somebody coughed in the background we need to take that out' - or somebody hit a bad note. Those are all the best moments."
  },
  {
    "author": "Nicholas Negroponte",
    "category": "computers",
    "id": 10355,
    "text": "Computing is not about computers any more. It is about living."
  },
  {
    "author": "Steve Wozniak",
    "category": "computers",
    "id": 10477,
    "text": "My whole life had been designing computers I could never build."
  },
  {
    "author": "Jackie Chan",
    "category": "computers",
    "id": 10431,
    "text": "Don't try to be like Jackie. There is only one Jackie. Study computers instead."
  },
  {
    "author": "Lech Walesa",
    "category": "computers",
    "id": 10444,
    "text": "I use many different gadgets connected with computers I use PCs, laptops and a Palm Pilot. I also use the Internet to visit websites, especially within Polish-language Internet. I usually go to political discussion groups and sites - of course, as I use my real name, people never believe that they are chatting with me!"
  },
  {
    "author": "Mike Royko",
    "category": "computers",
    "id": 10352,
    "text": "It's been my policy to view the Internet not as an 'information highway,' but as an electronic asylum filled with babbling loonies."
  },
  {
    "author": "Jerry Brown",
    "category": "computers",
    "id": 10533,
    "text": "I like computers. I like the Internet. It's a tool that can be used. But don't be misled into thinking that these technologies are anything other than aspects of a degenerate economic system."
  },
  {
    "author": "Norman Ralph Augustine",
    "category": "computers",
    "id": 10368,
    "text": "One of the most feared expressions in modern times is 'The computer is down.'"
  },
  {
    "author": "Paul Davies",
    "category": "computers",
    "id": 10489,
    "text": "Man-made computers are limited in their performance by finite processing speed and memory. So, too, the cosmic computer is limited in power by its age and the finite speed of light."
  },
  {
    "author": "Ray Kurzweil",
    "category": "computers",
    "id": 10403,
    "text": "Supercomputers will achieve one human brain capacity by 2010, and personal computers will do so by about 2020."
  },
  {
    "author": "Peter Drucker",
    "category": "computers",
    "id": 10333,
    "text": "The new information technology... Internet and e-mail... have practically eliminated the physical costs of communications."
  },
  {
    "author": "David Smith",
    "category": "computers",
    "id": 10587,
    "text": "The big question society will have to answer is whether it wants computers thinking like humans."
  },
  {
    "author": "Linus Torvalds",
    "category": "computers",
    "id": 10365,
    "text": "Shareware tends to combine the worst of commercial software with the worst of free software."
  },
  {
    "author": "Dave Barry",
    "category": "computers",
    "id": 10344,
    "text": "I am not the only person who uses his computer mainly for the purpose of diddling with his computer."
  },
  {
    "author": "Roberta Williams",
    "category": "computers",
    "id": 10511,
    "text": "Computers have become more friendly, understandable, and lots of years and thought have been put into developing software to convince people that they want and need a computer."
  },
  {
    "author": "Emilio Estevez",
    "category": "computers",
    "id": 10480,
    "text": "We've lost touch and allowed technology to take precedence over organic nature. But let's not forget that those microchips in our computers came from elements of the earth."
  },
  {
    "author": "Daniel Greenberg",
    "category": "computers",
    "id": 10546,
    "text": "Kids are finding out about the potential for discovery online from other sources many of them have computers at home, for instance, or their friends have them."
  },
  {
    "author": "Isaac Asimov",
    "category": "computers",
    "id": 10332,
    "text": "Part of the inhumanity of the computer is that, once it is competently programmed and working smoothly, it is completely honest."
  },
  {
    "author": "Timothy Murphy",
    "category": "computers",
    "id": 10527,
    "text": "While the recent addition of the National Guard providing a support role manning computers and cameras has allowed more Border Patrol agents to work the field, more agents are still needed."
  },
  {
    "author": "Yael Naim",
    "category": "computers",
    "id": 10588,
    "text": "Today, computers help us making the music. It's really a tool."
  },
  {
    "author": "Bob Taft",
    "category": "computers",
    "id": 10399,
    "text": "Yet in this global economy, no jobs are safe. High-speed Internet connections and low-cost, skilled labor overseas are an explosive combination."
  },
  {
    "author": "Elayne Boosler",
    "category": "computers",
    "id": 10340,
    "text": "I am thankful the most important key in history was invented. It's not the key to your house, your car, your boat, your safety deposit box, your bike lock or your private community. It's the key to order, sanity, and peace of mind. The key is 'Delete.'"
  },
  {
    "author": "Ian MacKaye",
    "category": "computers",
    "id": 10473,
    "text": "I'm really anti-option, so computers have been my nightmare with recording. I don't want endless tracks I want less tracks. I want decisions to be made."
  },
  {
    "author": "Jack Kilby",
    "category": "computers",
    "id": 10537,
    "text": "Well, the big products in electronics in the '50s were radio and television. The first big computers were just beginning to come in and represented the most logical market for us to work in."
  },
  {
    "author": "David Arquette",
    "category": "computers",
    "id": 10483,
    "text": "Kids today are smarter than we ever were. And they've got computers, too, which is awesome. They're scary to me."
  },
  {
    "author": "Jo Ann Davis",
    "category": "computers",
    "id": 10575,
    "text": "Equipped with cell phones, beepers, and handheld computers, the 'conspicuously industrious' blur the line between home and office by working anytime, anywhere."
  },
  {
    "author": "Cliff Stearns",
    "category": "computers",
    "id": 10516,
    "text": "I continue to meet people who have had their Web pages hijacked, their browsers corrupted, in some cases, their children exposed to inappropriate material from these dangerous programs hidden in their family computers."
  },
  {
    "author": "Bruce Schneier",
    "category": "computers",
    "id": 10551,
    "text": "People don't understand computers. Computers are magical boxes that do things. People believe what computers tell them."
  },
  {
    "author": "Roy Romer",
    "category": "computers",
    "id": 10553,
    "text": "Interactive computers and software will, I think, provide a less costly method of doing some kinds of inquiry, in knowledge acquisition and even reasoning and interaction."
  },
  {
    "author": "Milton Glaser",
    "category": "computers",
    "id": 10584,
    "text": "Computers are to design as microwaves are to cooking."
  },
  {
    "author": "Josh Holloway",
    "category": "computers",
    "id": 10544,
    "text": "I have three brothers and they're all into computers. They're all intellects. My mother would pay me a quarter a page to read a book and I couldn't make 50 cents. I just couldn't do it."
  },
  {
    "author": "Steve Wozniak",
    "category": "computers",
    "id": 10373,
    "text": "What I was proud of was that I used very few parts to build a computer that could actually speak words on a screen and type words on a keyboard and run a programming language that could play games. And I did all this myself."
  },
  {
    "author": "Adlai Stevenson",
    "category": "computers",
    "id": 10493,
    "text": "To me, there is something superbly symbolic in the fact that an astronaut, sent up as assistant to a series of computers, found that he worked more accurately and more intelligently than they. Inside the capsule, man is still in charge."
  },
  {
    "author": "Emo Philips",
    "category": "computers",
    "id": 10323,
    "text": "A computer once beat me at chess, but it was no match for me at kick boxing."
  },
  {
    "author": "Andy Rooney",
    "category": "computers",
    "id": 10335,
    "text": "Computers may save time but they sure waste a lot of paper. About 98 percent of everything printed out by a computer is garbage that no one ever reads."
  },
  {
    "author": "Lennart Nilsson",
    "category": "computers",
    "id": 10569,
    "text": "And my real enemy is not to hold the specimen sterile, but it's the lighting. The light is our real enemy. So we have to work with very very poor lighting. But we can increase the light with computers."
  },
  {
    "author": "Katherine Jenkins",
    "category": "computers",
    "id": 10448,
    "text": "Beatbullying's 'The Big March 2012' is such a brilliant campaign and I am very proud to be a part of it. I have been a victim of cyber bullying myself and I know firsthand just how hurtful it can be. People think that they can hide behind computers and send nasty and hurtful comments to people, and this is wrong."
  },
  {
    "author": "Dixie Carter",
    "category": "computers",
    "id": 10567,
    "text": "Learning can take place in the backyard if there is a human being there who cares about the child. Before learning computers, children should learn to read first. They should sit around the dinner table and hear what their parents have to say and think."
  },
  {
    "author": "Jack Vance",
    "category": "computers",
    "id": 10515,
    "text": "But I'm so slow on it because I find it terribly hard writing blind on computers. The computer speaks to me, but it's just so slow, I'm so terribly slow using it."
  },
  {
    "author": "Sumner Redstone",
    "category": "computers",
    "id": 10402,
    "text": "The Internet is a powerful way to make lots of money... But we are not going to buy Yahoo!"
  },
  {
    "author": "Marc Andreessen",
    "category": "computers",
    "id": 10439,
    "text": "Technology is like water it wants to find its level. So if you hook up your computer to a billion other computers, it just makes sense that a tremendous share of the resources you want to use - not only text or media but processing power too - will be located remotely."
  },
  {
    "author": "Bill Budge",
    "category": "computers",
    "id": 10386,
    "text": "I started on an Apple II, which I had bought at the very end of 1978 for half of my annual income. I made $4,500 a year, and I spent half of it on the computer."
  },
  {
    "author": "Tim Berners-Lee",
    "category": "computers",
    "id": 10456,
    "text": "The Semantic Web is not a separate Web but an extension of the current one, in which information is given well-defined meaning, better enabling computers and people to work in cooperation."
  },
  {
    "author": "James Hilton",
    "category": "computers",
    "id": 10414,
    "text": "If net neutrality goes away, it will fundamentally change everything about the Internet."
  },
  {
    "author": "Lech Walesa",
    "category": "computers",
    "id": 10443,
    "text": "You have riches and freedom here but I feel no sense of faith or direction. You have so many computers, why don't you use them in the search for love?"
  },
  {
    "author": "Jason Schwartzman",
    "category": "computers",
    "id": 10472,
    "text": "There's all these ways to instantly communicate - cars, computers, telephone and transportation - and even with all that, it's so hard to find people and have an honest communication with them."
  },
  {
    "author": "Rick Boucher",
    "category": "computers",
    "id": 10585,
    "text": "I actually use a computer a lot. I have three computers that I use on a regular basis - one is on my desk top in my Washington office, another is at home, and I have my laptop that I use when I'm travelling."
  },
  {
    "author": "Jim Clark",
    "category": "computers",
    "id": 10395,
    "text": "The Internet is not just one thing, it's a collection of things - of numerous communications networks that all speak the same digital language."
  },
  {
    "author": "Ken Olsen",
    "category": "computers",
    "id": 10390,
    "text": "There is no reason for any individual to have a computer in his home."
  },
  {
    "author": "Peter Drucker",
    "category": "computers",
    "id": 10338,
    "text": "The computer is a moron."
  },
  {
    "author": "Ray Comfort",
    "category": "computers",
    "id": 10451,
    "text": "In the past, missionaries have traveled to far countries with the message of the gospel - with great hardship and often with the loss of life. In contrast, we can reach millions instantly from the comfort of our homes by merely hitting the 'send' button on our computers, or with iPads, or phones."
  },
  {
    "author": "John Warnock",
    "category": "computers",
    "id": 10408,
    "text": "What I try to do is factor in how people use computers, what people's problems are, and how these technologies can get applied to those problems. Then I try to direct the various product groups to act on this information."
  },
  {
    "author": "Philip Emeagwali",
    "category": "computers",
    "id": 10461,
    "text": "Our lives sometimes depend on computers performing as predicted."
  },
  {
    "author": "Richard P. Feynman",
    "category": "computers",
    "id": 10425,
    "text": "There is a computer disease that anybody who works with computers knows about. It's a very serious disease and it interferes completely with the work. The trouble with computers is that you 'play' with them!"
  },
  {
    "author": "James Fallows",
    "category": "computers",
    "id": 10525,
    "text": "Over the eons I've been a fan of, and sucker for, each latest automated system to 'simplify' and 'bring order to' my life. Very early on this led me to the beautiful-and-doomed Lotus Agenda for my DOS computers, and Actioneer for the early Palm."
  },
  {
    "author": "Magnus Carlsen",
    "category": "computers",
    "id": 10536,
    "text": "I've never been much of a computer guy at least in terms of playing with computers. Actually until I was about 11 I didn't use a computer for preparing for games at all. I was playing a bit online, was using the chess club mainly. Now, obviously, the computer is an important tool for me preparing for my games."
  },
  {
    "author": "Steve Jobs",
    "category": "computers",
    "id": 10421,
    "text": "This is what customers pay us for - to sweat all these details so it's easy and pleasant for them to use our computers. We're supposed to be really good at this. That doesn't mean we don't listen to customers, but it's hard for them to tell you what they want when they've never seen anything remotely like it."
  }
]

quotes['cool'] = [
  {
    "author": "Daryl Hall",
    "category": "cool",
    "id": 11269,
    "text": "I definitely dislike pomposity and artifice. I hope that I'm not that. Once I write a song, it belongs to the world, and the way people perceive it, it's cool."
  },
  {
    "author": "Martina McBride",
    "category": "cool",
    "id": 10895,
    "text": "That's the hardest thing about being a mom. You want to be cool, and you want them to like you all the time, but you can't always have that. You're gonna have times where you have to say no, and you won't be the most popular person in the house."
  },
  {
    "author": "Paul Feig",
    "category": "cool",
    "id": 10879,
    "text": "Period costume films are fun to discover, but they're not relatable. It's more, 'Wow, that's cool - did it really look like that back then?' Whereas with a comedy, you're like, 'Yeah, that's me, that's my friends.' No matter what, I want people to relate."
  },
  {
    "author": "Evan Glodell",
    "category": "cool",
    "id": 11379,
    "text": "I went to engineering school, which I thought was what I wanted to do, for about two weeks. We had an orientation class and we met this guy where he worked and stuff and it was cool, but I was like, 'There is no way this is going to be my life.'"
  },
  {
    "author": "Paul Feig",
    "category": "cool",
    "id": 10877,
    "text": "I always hated high-school shows and high-school movies, because they were always about the cool kids. It was always about dating and sex, and all the popular kids, and the good-looking kids. And the nerds were super-nerdy cartoons, with tape on their glasses. I never saw 'my people' portrayed accurately."
  },
  {
    "author": "Sondre Lerche",
    "category": "cool",
    "id": 11358,
    "text": "I work with really cool people, and so far I haven't been approached in any embarrassing manner when it comes to image."
  },
  {
    "author": "Theo James",
    "category": "cool",
    "id": 11384,
    "text": "I saw 'Captain America' in 3D. It's cool. I liked the beginning. It's a really good setup."
  },
  {
    "author": "Jim Sturgess",
    "category": "cool",
    "id": 11470,
    "text": "Definitely River Phoenix is somebody that I thought, 'This guy is very cool.' I wanted to be like him when I was a kid."
  },
  {
    "author": "Will Wright",
    "category": "cool",
    "id": 11199,
    "text": "In an online community, there's this kind of social economy between the community members. Some people have status because they make cool skins or that's a good website that's visited a lot, but there's no real gameplay there."
  },
  {
    "author": "Minka Kelly",
    "category": "cool",
    "id": 11349,
    "text": "I'm confident - confident in my skin, and I'm cool with my flaws and all that stuff."
  },
  {
    "author": "Taylor Swift",
    "category": "cool",
    "id": 10603,
    "text": "All of my favorite people - people I really trust - none of them were cool in their younger years."
  },
  {
    "author": "Lea Michele",
    "category": "cool",
    "id": 10848,
    "text": "I was in choir in school. I kind of just did it. I already knew I wanted to sing. My music program in my school wasn't really great - people didn't really want to be part of the choir, they didn't want to do the plays and stuff like that. It definitely wasn't the cool thing to do."
  },
  {
    "author": "Lou Gehrig",
    "category": "cool",
    "id": 10833,
    "text": "The ballplayer who loses his head, who can't keep his cool, is worse than no ballplayer at all."
  },
  {
    "author": "Mac Davis",
    "category": "cool",
    "id": 11267,
    "text": "If it was just me and Elvis one on one, which only happened once or twice in the times that I did see him, it was a really comfortable. He was a cool guy. Easy laugh, nice guy."
  },
  {
    "author": "Peter Buck",
    "category": "cool",
    "id": 11273,
    "text": "Almost all the fans I meet are pretty cool people. They're intelligent and tend to think about things a bit more than your average rock'n'roll fans: sensible people I wouldn't mind having a drink with."
  },
  {
    "author": "Jenna Elfman",
    "category": "cool",
    "id": 11150,
    "text": "There's a power in women being women. There's a role for men, but we don't have to be men, because we're women. I think that representing that on television is a cool thing."
  },
  {
    "author": "Albert Brooks",
    "category": "cool",
    "id": 10929,
    "text": "Even though my father was a radio comedian, it wasn't cool to say, at a young age, 'I want to be a comedian.'"
  },
  {
    "author": "Jay-Z",
    "category": "cool",
    "id": 10917,
    "text": "Growing up, politics never trickled down to the areas we come from. But people from Obama's camp, and Obama himself, reached out to me and asked for my help on the campaign. We've sat and had dinner, and we've spoken on the phone. He's a very sharp guy. Very charming. Very cool."
  },
  {
    "author": "Katy Perry",
    "category": "cool",
    "id": 10682,
    "text": "I grew up not really having anything, so the idea that I can take care of my family and my friends now is a really cool bonus."
  },
  {
    "author": "Walton Goggins",
    "category": "cool",
    "id": 11281,
    "text": "I think I'm much too earnest to be as cool as 'Boyd Crowder'."
  },
  {
    "author": "James Hetfield",
    "category": "cool",
    "id": 10962,
    "text": "We do this basically for ourselves. People appreciate it, which is cool, but I think they appreciate that we're doing it for ourselves. We're doing it our way, and how people like it is not up to us. We like it."
  },
  {
    "author": "Julian Casablancas",
    "category": "cool",
    "id": 11059,
    "text": "If the choice is between doing something supercool and having no one hear it and doing something equally cool and tricking people into putting it on the radio, I don't think the second option is some big sellout."
  },
  {
    "author": "Niklas Zennstrom",
    "category": "cool",
    "id": 10942,
    "text": "As an investor, what we're not looking for is 'oh this is a cool app,' it's 'is this something that can become a big business?' You need to find those that can become real businesses."
  },
  {
    "author": "Dawn Fraser",
    "category": "cool",
    "id": 11185,
    "text": "It's a beautiful thing, diving into the cool crisp water and then just sort of being able to pull your body through the water and the water opening up for you."
  },
  {
    "author": "Adrianne Palicki",
    "category": "cool",
    "id": 11434,
    "text": "Ninjas are so cool!"
  },
  {
    "author": "Darrell Royal",
    "category": "cool",
    "id": 10948,
    "text": "I don't count on the boy who waits till October, when it's cool and fun, then decides he wants to play."
  },
  {
    "author": "Fred Durst",
    "category": "cool",
    "id": 10779,
    "text": "When you're a kid, you see your parents reading the newspaper and you're like, 'God, why are they reading the newspaper?' When you're young, you're not reading the newspaper. But there comes a time in your life when the newspaper's cool."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "cool",
    "id": 10783,
    "text": "These days it's cool to be ethnic and to be different, but when I was a kid, it was not cool - at all. My friends would come over and my mom would make crepes with eggs, stuffed with mozzarella cheese, tomatoes and spinach. And they'd be like, 'What is this?'"
  },
  {
    "author": "Stone Gossard",
    "category": "cool",
    "id": 11161,
    "text": "I like rhythmic things that butt up against each other in a cool kind of way."
  },
  {
    "author": "Robert Conrad",
    "category": "cool",
    "id": 11418,
    "text": "Will Smith is young, he's cool and my kids have his CDs."
  },
  {
    "author": "Mos Def",
    "category": "cool",
    "id": 10834,
    "text": "I know what it feels like to have the door slammed firmly in my face, so I'm cool with that."
  },
  {
    "author": "Diablo Cody",
    "category": "cool",
    "id": 10727,
    "text": "I want Maggie Gyllenhaal. I don't know why. I don't think she necessarily looks like me or acts like me, I just think she's a cool actress and she could play me, so there you go."
  },
  {
    "author": "Darius Rucker",
    "category": "cool",
    "id": 11260,
    "text": "We got to do a few things with President Clinton. To be invited to Washington again to play with Ashanti and all those other cool people there in front of President Bush and the rest of the world feels awesome. I'm really looking forward to going."
  },
  {
    "author": "Chad Smith",
    "category": "cool",
    "id": 10709,
    "text": "Playing well with others is important - not being too flashy, just keeping good time and of course coming up with cool beats. A good snare drum, kick drum, high hat. Just getting good at the hand feet coordination."
  },
  {
    "author": "Jessica Brown Findlay",
    "category": "cool",
    "id": 11041,
    "text": "My style icons would be people like Brigitte Bardot and old Hollywood actresses who always look so stunning, cool and chic. I like classic and timeless looks."
  },
  {
    "author": "Richard M. Nixon",
    "category": "cool",
    "id": 10604,
    "text": "I can take it. The tougher it gets, the cooler I get."
  },
  {
    "author": "Evanna Lynch",
    "category": "cool",
    "id": 11343,
    "text": "Sometimes, the other characters are too normal and then you start to be brought back to reality but then Luna shows up and she is just so funny and cool and honest and slightly mad and she's all that matters. She is 100% true. She puts on no shows, because she is so comfortable with herself."
  },
  {
    "author": "Gary Allan",
    "category": "cool",
    "id": 10958,
    "text": "I've had fans come and knock on my door. I'm usually polite, but I'm usually very direct and say, 'It's not cool that you come here uninvited.'"
  },
  {
    "author": "Birdy",
    "category": "cool",
    "id": 11377,
    "text": "I got a phone call from Fearne Cotton. It was amazing! I literally couldn't believe it. It was so cool. It was the night before I was going on her show to sing on the 'Live Lounge.' She was so lovely."
  },
  {
    "author": "Marc Newson",
    "category": "cool",
    "id": 10623,
    "text": "To create well I have to be in a good mood, happy and cool."
  },
  {
    "author": "Kingman Brewster, Jr.",
    "category": "cool",
    "id": 11365,
    "text": "Maybe you are the 'cool' generation If coolness means a capacity to stay calm and use your head in the service of ends passionately believed in, then it has my admiration."
  },
  {
    "author": "Jackson Browne",
    "category": "cool",
    "id": 11090,
    "text": "Now, guitar was pretty cool. Everybody knew something on the guitar. So I wanted to play guitar, but I told my dad if he wanted me to keep studying something, I'd like to study piano."
  },
  {
    "author": "Catherine Keener",
    "category": "cool",
    "id": 11309,
    "text": "If you work in casting, it's sort of not cool to want to act. A lot of people think that casting directors are frustrated actors, but it wasn't true with any of the casting people I knew."
  },
  {
    "author": "Tone Loc",
    "category": "cool",
    "id": 11458,
    "text": "But Freedom Strike was actually quite cool."
  },
  {
    "author": "Josh Hutcherson",
    "category": "cool",
    "id": 10853,
    "text": "It's cool to play a vampire and be a part of this new, hot genre."
  },
  {
    "author": "Grey DeLisle",
    "category": "cool",
    "id": 11440,
    "text": "My favorite thing is when cartoon fans show up to my live gigs! They are always the most kick-butt audience members 'cause they're not trying to act all cool like a lot of the music fans do!"
  },
  {
    "author": "Ricky Schroder",
    "category": "cool",
    "id": 11111,
    "text": "I have been a huge nerd to my kids. I haven't done the cool movies that they like. With '24,' I gained a lot of respect. '24' is now, it's hip, it's their generation."
  },
  {
    "author": "Beth Ditto",
    "category": "cool",
    "id": 10826,
    "text": "All this fashion stuff - who's cool now - is just a bigger version of the cool kids versus the nerds."
  },
  {
    "author": "Gerald McRaney",
    "category": "cool",
    "id": 11390,
    "text": "Again, like I said, we're not trying to censor anyone. If you think drugs are cool, fine. Make that movie. We are not going to stop you, or try to stop you, but we would encourage other people to be a bit more responsible about their portrayal of drug usage."
  },
  {
    "author": "Britney Spears",
    "category": "cool",
    "id": 10787,
    "text": "Justin Timberlake is everything, and what more could you want in a person? He's funny. He's cute. He's great. He just understands. I get him and he gets me, and that's cool."
  },
  {
    "author": "Ron Perlman",
    "category": "cool",
    "id": 10869,
    "text": "The thing that's cool about the recording booth is that it's so perfunctory, so cut-to-the-chase."
  },
  {
    "author": "Shia LaBeouf",
    "category": "cool",
    "id": 10686,
    "text": "They're very, uh, you know, I don't come from the suburbs and a jolly, Disney type of lifestyle. I come from something totally different. And they're cool and bare minimum so it's not always a money issue for me."
  },
  {
    "author": "Edward Burns",
    "category": "cool",
    "id": 11063,
    "text": "I mean the cool thing about the movies is that you get to try on these different personalities and different styles."
  },
  {
    "author": "Stephenie Meyer",
    "category": "cool",
    "id": 11032,
    "text": "With 'The Host,' I think the actors could be really big names. That would be cool. I'd love to see Robert Redford put on a beard and be Jeb he would be amazing... Matt Damon has some very Jared-esque qualities, and then Casey Affleck as Ian and Ben Affleck as Kyle. Imagine the interplay."
  },
  {
    "author": "Ashley Greene",
    "category": "cool",
    "id": 10843,
    "text": "Yeah, I get to fight in 'Eclipse.' My trainer is teaching me MMA right now. So. Cool."
  },
  {
    "author": "Rosalind Wiseman",
    "category": "cool",
    "id": 11242,
    "text": "See, at a certain point it becomes cool to be boy crazy. That happens in sixth grade, and it gives you so much social status, particularly in an all-girls school, if you can go up and talk to boys."
  },
  {
    "author": "Sly Stone",
    "category": "cool",
    "id": 11186,
    "text": "Sunday school don't make you cool forever."
  },
  {
    "author": "Paula Abdul",
    "category": "cool",
    "id": 10919,
    "text": "The cool part of being an entertainer is getting the opportunity to get your feet wet in all areas."
  },
  {
    "author": "Jon Hamm",
    "category": "cool",
    "id": 11025,
    "text": "Acting is sort of an extension of childhood. You get to play all of these roles and have so much fun. Playing an athlete would be so cool. Or where you get to shoot guns, ride horses. I wouldn't turn down any of that."
  },
  {
    "author": "William Kempe",
    "category": "cool",
    "id": 11449,
    "text": "I used to do this as a kid. And now they're paying me for it, which is cool."
  },
  {
    "author": "Brian Ferneyhough",
    "category": "cool",
    "id": 10900,
    "text": "When I left Europe in 1987 I did so with the thought that my relevance as a composition teacher would benefit from a certain cool distance to certain tendencies I had been observing for several years with increasing disquiet."
  },
  {
    "author": "Jim Carrey",
    "category": "cool",
    "id": 10596,
    "text": "Morgan Freeman is so class. He's so cool. He's so scary."
  },
  {
    "author": "Bruce Jenner",
    "category": "cool",
    "id": 11133,
    "text": "Our mission for younger people is to do our best to make exercise cool, hip - the thing to do."
  },
  {
    "author": "Alice Englert",
    "category": "cool",
    "id": 11039,
    "text": "Being in love is not cool!"
  },
  {
    "author": "Curtis Stone",
    "category": "cool",
    "id": 10888,
    "text": "When I see my staff take a step back because I've lost my cool about something food-related, I say never apologise for your standards. If someone doesn't meet them, then you should explain that and that you want it changed. I want my staff to be like that, too."
  },
  {
    "author": "Gerard De Nerval",
    "category": "cool",
    "id": 10953,
    "text": "When the soul drifts uncertainly between life and the dream, between the mind's disorder and the return to cool reflection, it is in religious thought that we should seek consolation."
  },
  {
    "author": "Lily Collins",
    "category": "cool",
    "id": 11027,
    "text": "My mother used to take me to flea markets in my stroller, and I would just rummage through the piles. You've got to dig through the overstuffed racks that everyone else just walks by. It's the only way to find the cool stuff."
  },
  {
    "author": "Paul Wesley",
    "category": "cool",
    "id": 11432,
    "text": "I wasn't some weird loner in school, but I definitely wasn't invited to any of the cool parties."
  },
  {
    "author": "Joshua Homme",
    "category": "cool",
    "id": 11170,
    "text": "I'm always looking for cool stuff to do because that's what we're supposed to do, ya know?"
  },
  {
    "author": "Naima Adedapo",
    "category": "cool",
    "id": 11354,
    "text": "I wouldn't compare myself to any past Idol contestant, because I don't feel like I am like any of them. Maybe stories are cool but my story is different from most people's story. I don't like to compare myself to other people, I like to just be me."
  },
  {
    "author": "Edwin Hubbel Chapin",
    "category": "cool",
    "id": 11091,
    "text": "The downright fanatic is nearer to the heart of things than the cool and slippery disputant."
  },
  {
    "author": "Jon Heder",
    "category": "cool",
    "id": 11305,
    "text": "I'm not that into reading. If I'm gonna read, I'm gonna read some cool sci-fi book or something, not some stupid self-help book."
  },
  {
    "author": "Russell Simmons",
    "category": "cool",
    "id": 10631,
    "text": "You know, the diversity that America has is so special. It's starting to really become a cool thing for young people."
  },
  {
    "author": "William Henry Hudson",
    "category": "cool",
    "id": 11459,
    "text": "Now that we are cool, he said, and regret that we hurt each other, I am not sorry that it happened."
  },
  {
    "author": "Erykah Badu",
    "category": "cool",
    "id": 10819,
    "text": "I have the ability to sing with emotion and feeling, but if you say I sound like Billie Holiday, that's cool. Let's look at who Billie was: she was this person, this singer, this beautiful diva who could move the audience with the slightest gesture of her hand."
  },
  {
    "author": "Jason Biggs",
    "category": "cool",
    "id": 10636,
    "text": "A girl came up to me in a bar and said she wanted to be my apple pie. I wish I'd said something cool, but I was stunned."
  },
  {
    "author": "Ron Livingston",
    "category": "cool",
    "id": 11178,
    "text": "It's kinda cool seeing people having real fights with people they really know."
  },
  {
    "author": "Shirley Manson",
    "category": "cool",
    "id": 10737,
    "text": "You have to watch all sides of your advancement, you have to make sure people's bodies and minds are healthy and their morale is cool before you can really go out and play great music."
  },
  {
    "author": "Drake",
    "category": "cool",
    "id": 10898,
    "text": "Me and my dad are friends. We're cool. I'll never be disappointed again, because I don't expect anything anymore from him. I just let him exist, and that's how we get along."
  },
  {
    "author": "Dominic Monaghan",
    "category": "cool",
    "id": 10845,
    "text": "The term 'geek' for me is like you having a passion, interest in something that is unabashed and you don't care if people think it's not cool. You think it's cool and that's your thing."
  },
  {
    "author": "Bill Gates",
    "category": "cool",
    "id": 10593,
    "text": "It's really kind of cool to have solar panels on your roof."
  },
  {
    "author": "Tom Hardy",
    "category": "cool",
    "id": 11141,
    "text": "Fame and stuff like that is all very cool, but at the end of the day, we're all human beings. Although what I do is incredibly surreal and fun and amazing and I'm really grateful for it, I don't believe my own press release, do you know what I mean?"
  },
  {
    "author": "Jerry Doyle",
    "category": "cool",
    "id": 11376,
    "text": "I was 35 years old and in a position to take a shot at whatever I wanted to try. The Air Force said I was too old to fly fighter jets. I thought about becoming a fishing boat captain, before deciding that acting seemed pretty cool."
  },
  {
    "author": "Maria Sharapova",
    "category": "cool",
    "id": 10702,
    "text": "I think it's so cool to be tall. Even when I'm not wearing heels people tell me I'm tall and I always take it as a complement. The good thing is I can always see everybody in the room."
  },
  {
    "author": "Mia Wasikowska",
    "category": "cool",
    "id": 10896,
    "text": "Traveling to Russia and Germany and being able to see the world at a young age was really cool for me, and I really liked that."
  },
  {
    "author": "Elia Kazan",
    "category": "cool",
    "id": 10829,
    "text": "Whatever hysteria exists is inflamed by mystery, suspicion and secrecy. Hard and exact facts will cool it."
  },
  {
    "author": "Conan O'Brien",
    "category": "cool",
    "id": 10698,
    "text": "Keep cool my babies."
  },
  {
    "author": "Anthony Mackie",
    "category": "cool",
    "id": 11121,
    "text": "Do you want to be an actor, or do you want to be a celebrity? I made that decision when I went to Juilliard. I wanted to be an actor. So, if I get the opportunity to be an actor and do some cool, fun and interesting projects, I'm going to do that."
  },
  {
    "author": "Demetri Martin",
    "category": "cool",
    "id": 10666,
    "text": "I think it would be cool if you were writing a ransom note on your computer, if the paper clip popped up and said, 'Looks like you're writing a ransom note. Need help? You should use more forceful language, you'll get more money.'"
  },
  {
    "author": "Shay Mitchell",
    "category": "cool",
    "id": 10938,
    "text": "I'm a fan of designers and clothes that look beautiful, but more importantly, make me feel beautiful and confident. It's why I've always loved Stella McCartney, and more recently, Prabal Gurung. Their pieces are cool, yet timeless, and the fits are effortlessly flattering."
  },
  {
    "author": "Michael K. Williams",
    "category": "cool",
    "id": 11190,
    "text": "Doing something that warrants the attention of the President of the United States is super cool."
  },
  {
    "author": "Randy Johnson",
    "category": "cool",
    "id": 11307,
    "text": "I would think flying would be pretty cool. You would be able to fly away from all your enemies and get where you're going much faster. But being invisible? You probably wouldn't use that for the good of man."
  },
  {
    "author": "Tony Dungy",
    "category": "cool",
    "id": 10607,
    "text": "People look at me and see a calm, cool guy on the sidelines and I want them to know that my Christian faith affects my coaching and everything I do."
  },
  {
    "author": "Kaley Cuoco",
    "category": "cool",
    "id": 11374,
    "text": "My whole family actually, but my parents. I had such a normal and amazing childhood. I've been so lucky. My parents are cool and normal. They don't talk about the business and I still have stuff to do at their house."
  },
  {
    "author": "Paul Giamatti",
    "category": "cool",
    "id": 11057,
    "text": "Am I really cool? You're telling me I'm cool? Well, that's good to hear."
  },
  {
    "author": "Ike Turner",
    "category": "cool",
    "id": 11252,
    "text": "They used to say it was bad for Indians to drink, but it's bad for anybody. When they drink they lose their cool, a lot of us. Like when we played with Sonny Boy, I would never get paid, you know. He would drink up all the money."
  },
  {
    "author": "Kevin Mitnick",
    "category": "cool",
    "id": 10717,
    "text": "As a young boy, I was taught in high school that hacking was cool."
  },
  {
    "author": "Matthew Vaughn",
    "category": "cool",
    "id": 11166,
    "text": "I think movies glamorize violence, in the sense that they make it in a way that it's either cool or funny."
  },
  {
    "author": "Rob Corddry",
    "category": "cool",
    "id": 11078,
    "text": "I just want to do cool stuff."
  },
  {
    "author": "Zack Snyder",
    "category": "cool",
    "id": 11089,
    "text": "People always come up to me now and say, 'Watchmen' is the best superhero movie ever made.' I'm always saying 'That's super cool. That's nice of you to say.' But it happens now, more and more and more than it did when it first came out."
  }
]

quotes['courage'] = [
  {
    "author": "James Hillman",
    "category": "courage",
    "id": 11844,
    "text": "The older people that one admires seem to be fearless. They go right out into the world. It's astounding. Maybe they can't see or they can't hear, but they walk out into the street and take life as it comes. They're models of courage, in a strange way."
  },
  {
    "author": "William Alexander",
    "category": "courage",
    "id": 11637,
    "text": "Earth teach me to forget myself as melted snow forgets its life. Earth teach me resignation as the leaves which die in the fall. Earth teach me courage as the tree which stands all alone. Earth teach me regeneration as the seed which rises in the spring."
  },
  {
    "author": "Isabel Allende",
    "category": "courage",
    "id": 11826,
    "text": "In times of conflict, war, poverty or religious fundamentalism, women and children are the first and most numerous victims. Women need all their courage today."
  },
  {
    "author": "Kenneth L. Pike",
    "category": "courage",
    "id": 11899,
    "text": "Courage to continue comes from deeper sources than outward results."
  },
  {
    "author": "Prescott Bush",
    "category": "courage",
    "id": 12006,
    "text": "It is our conduct, our patriotism and belief in our American way of life, our courage that will win the final battle."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "courage",
    "id": 11607,
    "text": "Courage is almost a contradiction in terms. It means a strong desire to live taking the form of readiness to die."
  },
  {
    "author": "Grace Paley",
    "category": "courage",
    "id": 11774,
    "text": "Let us go forth with fear and courage and rage to save the world."
  },
  {
    "author": "E. F. Schumacher",
    "category": "courage",
    "id": 11522,
    "text": "Any intelligent fool can make things bigger and more complex... It takes a touch of genius - and a lot of courage to move in the opposite direction."
  },
  {
    "author": "E. M. Forster",
    "category": "courage",
    "id": 11660,
    "text": "Either life entails courage, or it ceases to be life."
  },
  {
    "author": "Ruth Gordon",
    "category": "courage",
    "id": 11951,
    "text": "Courage is very important. Like a muscle, it is strengthened by use."
  },
  {
    "author": "Nicholas M. Butler",
    "category": "courage",
    "id": 12067,
    "text": "Necessity does the work of courage."
  },
  {
    "author": "John Wayne",
    "category": "courage",
    "id": 11486,
    "text": "Courage is being scared to death... and saddling up anyway."
  },
  {
    "author": "Ray Comfort",
    "category": "courage",
    "id": 11907,
    "text": "It takes both courage and talent to stand up in front of fellow human beings and make them crack a smile, and at the same time keep it clean."
  },
  {
    "author": "Delmore Schwartz",
    "category": "courage",
    "id": 11952,
    "text": "Love is the most difficult and dangerous form of courage. Courage is the most desperate, admirable and noble kind of love."
  },
  {
    "author": "William Wells Brown",
    "category": "courage",
    "id": 12076,
    "text": "People don't follow titles, they follow courage."
  },
  {
    "author": "Mo Yan",
    "category": "courage",
    "id": 12015,
    "text": "I know what real courage is, and I understand true compassion."
  },
  {
    "author": "Suze Orman",
    "category": "courage",
    "id": 11737,
    "text": "In all realms of life it takes courage to stretch your limits, express your power, and fulfill your potential... it's no different in the financial realm."
  },
  {
    "author": "C. S. Lewis",
    "category": "courage",
    "id": 11485,
    "text": "Courage is not simply one of the virtues, but the form of every virtue at the testing point."
  },
  {
    "author": "Jim DeMint",
    "category": "courage",
    "id": 11815,
    "text": "I want to find the candidates who understand the principles of American exceptionalism and have the character, the courage, and the confidence to actually lead the greatest nation in the world."
  },
  {
    "author": "Marilyn Hacker",
    "category": "courage",
    "id": 11925,
    "text": "I started to send my work to journals when I was 26, which was just a question of when I got the courage up. They were mostly journals I had been reading for the previous six or seven years."
  },
  {
    "author": "Romeo LeBlanc",
    "category": "courage",
    "id": 12072,
    "text": "If I am to be known for anything, I would like it to be for encouraging Canadians, for knowing a little bit about their daily, extraordinary courage. And for wanting that courage to be recognized."
  },
  {
    "author": "Carl Lewis",
    "category": "courage",
    "id": 11543,
    "text": "The trials on the road to world harmony are no greater than the courage of those who accept the challenge."
  },
  {
    "author": "Benjamin Banneker",
    "category": "courage",
    "id": 11961,
    "text": "Presumption should never make us neglect that which appears easy to us, nor despair make us lose courage at the sight of difficulties."
  },
  {
    "author": "Jean Anouilh",
    "category": "courage",
    "id": 11823,
    "text": "Men create real miracles when they use their God-given courage and intelligence."
  },
  {
    "author": "Winston Churchill",
    "category": "courage",
    "id": 11545,
    "text": "Success is not final, failure is not fatal: it is the courage to continue that counts."
  },
  {
    "author": "Thomas Szasz",
    "category": "courage",
    "id": 11539,
    "text": "Clear thinking requires courage rather than intelligence."
  },
  {
    "author": "Edward Albert",
    "category": "courage",
    "id": 12038,
    "text": "Courage is just fear, plus prayers, plus understanding."
  },
  {
    "author": "Barry Lopez",
    "category": "courage",
    "id": 12073,
    "text": "We simply do not understand our place in the universe and have not the courage to admit it."
  },
  {
    "author": "Channing Pollock",
    "category": "courage",
    "id": 11962,
    "text": "No man in the world has more courage than the man who can stop after eating one peanut."
  },
  {
    "author": "Anais Nin",
    "category": "courage",
    "id": 11501,
    "text": "Life shrinks or expands in proportion to one's courage."
  },
  {
    "author": "Vincent Van Gogh",
    "category": "courage",
    "id": 11514,
    "text": "What would life be if we had no courage to attempt anything?"
  },
  {
    "author": "Alexandre Vinet",
    "category": "courage",
    "id": 12084,
    "text": "Resignation is the courage of Christian sorrow."
  },
  {
    "author": "Marvin Olasky",
    "category": "courage",
    "id": 11820,
    "text": "On sensitive issues, talk isn't cheap - it takes real courage to pry open topics nailed shut."
  },
  {
    "author": "Jonas Salk",
    "category": "courage",
    "id": 11730,
    "text": "Hope lies in dreams, in imagination, and in the courage of those who dare to make dreams into reality."
  },
  {
    "author": "Victor Hugo",
    "category": "courage",
    "id": 11498,
    "text": "Have courage for the great sorrows of life and patience for the small ones and when you have laboriously accomplished your daily task, go to sleep in peace."
  },
  {
    "author": "Prescott Bush",
    "category": "courage",
    "id": 12080,
    "text": "I emphasize... that the Harrimans showed great courage and loyalty and confidence in us, because three or four of us were really running the business, the day to day business."
  },
  {
    "author": "Catherine Deneuve",
    "category": "courage",
    "id": 11754,
    "text": "I have no physical courage, I've asked for a double."
  },
  {
    "author": "Oscar Wilde",
    "category": "courage",
    "id": 11564,
    "text": "Do you really think it is weakness that yields to temptation? I tell you that there are terrible temptations which it requires strength, strength and courage to yield to."
  },
  {
    "author": "Vittorio Alfieri",
    "category": "courage",
    "id": 12036,
    "text": "Ofttimes the test of courage becomes rather to live than to die."
  },
  {
    "author": "Edward Gibbon",
    "category": "courage",
    "id": 11766,
    "text": "The courage of a soldier is found to be the cheapest and most common quality of human nature."
  },
  {
    "author": "Archilochus",
    "category": "courage",
    "id": 12008,
    "text": "Let who will boast their courage in the field, I find but little safety from my shield, Nature's, not honour's law we must obey: This made me cast my useless shield away."
  },
  {
    "author": "Thucydides",
    "category": "courage",
    "id": 11528,
    "text": "The secret to happiness is freedom... And the secret to freedom is courage."
  },
  {
    "author": "Lech Walesa",
    "category": "courage",
    "id": 11794,
    "text": "Lying at the root of the social agreements of 1980 are the courage, sense of responsibility, and the solidarity of the working people. Both sides have then recognized that an accord must be reached if bloodshed is to be prevented."
  },
  {
    "author": "Georg C. Lichtenberg",
    "category": "courage",
    "id": 11781,
    "text": "Never undertake anything for which you wouldn't have the courage to ask the blessings of heaven."
  },
  {
    "author": "Desmond Tutu",
    "category": "courage",
    "id": 11696,
    "text": "Peace comes when you talk to the guy you most hate. And that's where the courage of a leader comes, because when you sit down with your enemy, you as a leader must already have very considerable confidence from your own constituency."
  },
  {
    "author": "Andre Norton",
    "category": "courage",
    "id": 11771,
    "text": "As for courage and will - we cannot measure how much of each lies within us, we can only trust there will be sufficient to carry through trials which may lie ahead."
  },
  {
    "author": "Maya Angelou",
    "category": "courage",
    "id": 11550,
    "text": "My great hope is to laugh as much as I cry to get my work done and try to love somebody and have the courage to accept the love in return."
  },
  {
    "author": "Thomas Hardy",
    "category": "courage",
    "id": 11759,
    "text": "Patience, that blending of moral courage with physical timidity."
  },
  {
    "author": "Doug Coupland",
    "category": "courage",
    "id": 11615,
    "text": "If human beings had genuine courage, they'd wear their costumes every day of the year, not just on Halloween."
  },
  {
    "author": "Carol P. Christ",
    "category": "courage",
    "id": 11976,
    "text": "Throughout the years, many Christian women have told me of their great respect for the bravery and courage evident in my work, perhaps even gesturing to their own Isis earrings or a Nile River Goddess pendants."
  },
  {
    "author": "Ed Koch",
    "category": "courage",
    "id": 11878,
    "text": "No, I am not a homosexual. If I were a homosexual, I would hope I would have the courage to say so. What's cruel is that you are forcing me to say I am not a homosexual. This means you are putting homosexuals down. I don't want to do that."
  },
  {
    "author": "Henri Matisse",
    "category": "courage",
    "id": 11688,
    "text": "Creativity takes courage."
  },
  {
    "author": "Aristotle",
    "category": "courage",
    "id": 11568,
    "text": "Courage is the first of human qualities because it is the quality which guarantees the others."
  },
  {
    "author": "Thomas S. Monson",
    "category": "courage",
    "id": 11572,
    "text": "The principles of living greatly include the capacity to face trouble with courage, disappointment with cheerfulness, and trial with humility."
  },
  {
    "author": "Tori Amos",
    "category": "courage",
    "id": 11613,
    "text": "Healing takes courage, and we all have courage, even if we have to dig a little to find it."
  },
  {
    "author": "Major Taylor",
    "category": "courage",
    "id": 11909,
    "text": "These rules may seem simple enough, but it will require great morale and physical courage to adhere to them. But if carried out in the strict sense of the word it will surely lead to a greater success than could otherwise be attained."
  },
  {
    "author": "George S. Patton",
    "category": "courage",
    "id": 11606,
    "text": "Untutored courage is useless in the face of educated bullets."
  },
  {
    "author": "Guy Laliberte",
    "category": "courage",
    "id": 11958,
    "text": "We had every problems starting a big top could have. The tent fell down on the first day. We had problems getting people into the shows. It was only with the courage and arrogance of youth that we survived."
  },
  {
    "author": "Chris Bell",
    "category": "courage",
    "id": 11967,
    "text": "I think that people need to have the courage of their convictions and not be trying to fool people into thinking that they've changed overnight."
  },
  {
    "author": "W. Clement Stone",
    "category": "courage",
    "id": 11491,
    "text": "Have the courage to say no. Have the courage to face the truth. Do the right thing because it is right. These are the magic keys to living your life with integrity."
  },
  {
    "author": "Erich Fromm",
    "category": "courage",
    "id": 11513,
    "text": "Creativity requires the courage to let go of certainties."
  },
  {
    "author": "Alan Autry",
    "category": "courage",
    "id": 11912,
    "text": "Leadership requires the courage to make decisions that will benefit the next generation."
  },
  {
    "author": "Hans Urs von Balthasar",
    "category": "courage",
    "id": 11833,
    "text": "Our situation today shows that beauty demands for itself at least as much courage and decision as do truth and goodness, and she will not allow herself to be separated and banned from her two sisters without taking them along with herself in an act of mysterious vengeance."
  },
  {
    "author": "Nikki Haley",
    "category": "courage",
    "id": 11934,
    "text": "The people of South Carolina support conservatives who are trying to push real change, and the people of South Carolina expect their presidential candidates to back them up when they show courage."
  },
  {
    "author": "Torquato Tasso",
    "category": "courage",
    "id": 11933,
    "text": "Grave was the man in years, in looks, in word, his locks were grey, yet was his courage green."
  },
  {
    "author": "Lao Tzu",
    "category": "courage",
    "id": 11544,
    "text": "Being deeply loved by someone gives you strength, while loving someone deeply gives you courage."
  },
  {
    "author": "King Abdullah II",
    "category": "courage",
    "id": 11812,
    "text": "Prime Minister Sharon, Prime Minister Abbas, I urge you today to end the designs of those who seek destruction, annihilation and occupation, and I urge you to have the will and the courage to begin to realize our dreams of peace, prosperity and coexistence."
  },
  {
    "author": "Major Taylor",
    "category": "courage",
    "id": 11978,
    "text": "I pray they will carry on in spite of that dreadful monster prejudice, and with patience, courage, fortitude and perseverance achieve success for themselves."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "courage",
    "id": 11518,
    "text": "It requires more courage to suffer than to die."
  },
  {
    "author": "Al Gore",
    "category": "courage",
    "id": 11729,
    "text": "While President Bush likes to project an image of strength and courage, the real truth is that in the presence of his large financial contributors, he is a moral coward."
  },
  {
    "author": "Joseph Addison",
    "category": "courage",
    "id": 11693,
    "text": "Courage that grows from constitution often forsakes a man when he has occasion for it courage which arises from a sense of duty acts in a uniform manner."
  },
  {
    "author": "Timothy Dalton",
    "category": "courage",
    "id": 11846,
    "text": "Real courage is knowing what faces you and knowing how to face it."
  },
  {
    "author": "John F. Kennedy",
    "category": "courage",
    "id": 11566,
    "text": "The courage of life is often a less dramatic spectacle than the courage of a final moment but it is no less a magnificent mixture of triumph and tragedy."
  },
  {
    "author": "Kevin Rudd",
    "category": "courage",
    "id": 11884,
    "text": "Australia is a nation of compassion. Courage and compassion. And the third of these great values: resilience."
  },
  {
    "author": "e. e. cummings",
    "category": "courage",
    "id": 11565,
    "text": "It takes courage to grow up and become who you really are."
  },
  {
    "author": "Juan Ruiz",
    "category": "courage",
    "id": 11888,
    "text": "Love makes a subtle man out of a crude one, it gives eloquence to the mute, it gives courage the cowardly and makes the idle quick and sharp."
  },
  {
    "author": "Thomas Fuller",
    "category": "courage",
    "id": 11672,
    "text": "The more wit the less courage."
  },
  {
    "author": "Henri Frederic Amiel",
    "category": "courage",
    "id": 11735,
    "text": "To live we must conquer incessantly, we must have the courage to be happy."
  },
  {
    "author": "Billy Graham",
    "category": "courage",
    "id": 11508,
    "text": "Courage is contagious. When a brave man takes a stand, the spines of others are often stiffened."
  },
  {
    "author": "Reinhold Niebuhr",
    "category": "courage",
    "id": 11690,
    "text": "If we survive danger it steels our courage more than anything else."
  },
  {
    "author": "Bill Hybels",
    "category": "courage",
    "id": 11939,
    "text": "It takes a great deal of courage to follow another person's lead."
  },
  {
    "author": "Mark Twain",
    "category": "courage",
    "id": 11483,
    "text": "Courage is resistance to fear, mastery of fear, not absence of fear."
  },
  {
    "author": "John F. Kerry",
    "category": "courage",
    "id": 11930,
    "text": "I saw courage both in the Vietnam War and in the struggle to stop it. I learned that patriotism includes protest, not just military service."
  },
  {
    "author": "Lao Tzu",
    "category": "courage",
    "id": 11500,
    "text": "From caring comes courage."
  },
  {
    "author": "Sarojini Naidu",
    "category": "courage",
    "id": 11831,
    "text": "We want deeper sincerity of motive, a greater courage in speech and earnestness in action."
  },
  {
    "author": "Vittorio Alfieri",
    "category": "courage",
    "id": 11873,
    "text": "Often the test of courage is not to die but to live."
  },
  {
    "author": "Jean Baudrillard",
    "category": "courage",
    "id": 11773,
    "text": "Cowardice and courage are never without a measure of affectation. Nor is love. Feelings are never true. They play with their mirrors."
  },
  {
    "author": "Alan Cohen",
    "category": "courage",
    "id": 11496,
    "text": "It takes a lot of courage to release the familiar and seemingly secure, to embrace the new. But there is no real security in what is no longer meaningful. There is more security in the adventurous and exciting, for in movement there is life, and in change there is power."
  },
  {
    "author": "Virginia Woolf",
    "category": "courage",
    "id": 11665,
    "text": "This soul, or life within us, by no means agrees with the life outside us. If one has the courage to ask her what she thinks, she is always saying the very opposite to what other people say."
  },
  {
    "author": "William Hazlitt",
    "category": "courage",
    "id": 11697,
    "text": "We are very much what others think of us. The reception our observations meet with gives us courage to proceed, or damps our efforts."
  },
  {
    "author": "Bertrand Russell",
    "category": "courage",
    "id": 11611,
    "text": "Many a man will have the courage to die gallantly, but will not have the courage to say, or even to think, that the cause for which he is asked to die is an unworthy one."
  },
  {
    "author": "Katherine Anne Porter",
    "category": "courage",
    "id": 12022,
    "text": "One of the marks of a gift is to have the courage of it."
  },
  {
    "author": "Giacomo Casanova",
    "category": "courage",
    "id": 11533,
    "text": "It is only necessary to have courage, for strength without self-confidence is useless."
  },
  {
    "author": "Ovid",
    "category": "courage",
    "id": 11714,
    "text": "Courage conquers all things: it even gives strength to the body."
  },
  {
    "author": "John Petit-Senn",
    "category": "courage",
    "id": 11851,
    "text": "True courage is like a kite a contrary wind raises it higher."
  },
  {
    "author": "Rahm Emanuel",
    "category": "courage",
    "id": 11822,
    "text": "Today, because of President Obama's courage, kids can stay on their parent's plan until they are 26. Insurers cannot kick you off your policy because you have hit your limit. They will not be able to deny you because you have a pre-existing condition."
  },
  {
    "author": "Elizabeth Taylor",
    "category": "courage",
    "id": 11602,
    "text": "I've been through it all, baby, I'm mother courage."
  },
  {
    "author": "Emile Hirsch",
    "category": "courage",
    "id": 11896,
    "text": "Maybe you will be afraid and maybe you will fail, but the courage to take risks in any part of your life is, I feel, a very worthwhile way to live."
  },
  {
    "author": "Bruce Lee",
    "category": "courage",
    "id": 11549,
    "text": "Mistakes are always forgivable, if one has the courage to admit them."
  },
  {
    "author": "Logan P. Smith",
    "category": "courage",
    "id": 11796,
    "text": "What is more mortifying than to feel that you have missed the plum for want of courage to shake the tree?"
  }
]

quotes['dad'] = [
  {
    "author": "Jeff Bridges",
    "category": "dad",
    "id": 12272,
    "text": "For me, growing up, the downside of it was that as a kid you don't want to stand out. You don't want to have a famous father let alone get a job because of your famous father, you know? But I'm a product of nepotism. That's how I got my foot in the door, through my dad."
  },
  {
    "author": "Lisa Guerrero",
    "category": "dad",
    "id": 12850,
    "text": "I grew up watching Monday Night Football with Howard Cosell and the other guys with my dad."
  },
  {
    "author": "Junior Seau",
    "category": "dad",
    "id": 12599,
    "text": "I wanted to perform well for my mom and dad, because in high school, I didn't have a job. My brothers, they worked at Pizza Hut or places like that, but sports, that was my way of giving back."
  },
  {
    "author": "Emily Mortimer",
    "category": "dad",
    "id": 12479,
    "text": "My dad had this philosophy that if you tell children they're beautiful and wonderful then they believe it, and they will be. So I never thought I was unattractive. But I was never one of the girls at school who had lots of boyfriends."
  },
  {
    "author": "Andre Agassi",
    "category": "dad",
    "id": 12620,
    "text": "You know my dad pushed me to believe that I was going to be the best. I just never thought of life without tennis, even looking forward."
  },
  {
    "author": "Mike Singletary",
    "category": "dad",
    "id": 12564,
    "text": "If a dad does his job, we don't need prisons, we don't need jails. That's what I saw growing up."
  },
  {
    "author": "Mike Shinoda",
    "category": "dad",
    "id": 12696,
    "text": "My dad remembers being in school with my uncle, and the teacher would say outright to the class that the Japanese were second-class citizens and shouldn't be trusted."
  },
  {
    "author": "Rich Lowry",
    "category": "dad",
    "id": 12998,
    "text": "When my dad was badly weakened by the flu and my mom wanted to call an ambulance to take him to the emergency room, he wouldn't go unless he could shave first and change into a nice shirt and a pair of slacks."
  },
  {
    "author": "Anna Lee",
    "category": "dad",
    "id": 12188,
    "text": "My father was an Episcopalian minister, and I've always been comforted by the power of prayer."
  },
  {
    "author": "Jeremy Sisto",
    "category": "dad",
    "id": 13052,
    "text": "I'm a dad now and whatever I'm doing in life I usually put a lot of effort into it - usually too much effort, so it kind of comes off ridiculous at times."
  },
  {
    "author": "Gary Vaynerchuk",
    "category": "dad",
    "id": 12469,
    "text": "People who build family businesses are not classically trained. They have to deal with an enormous amount of politics. You think corporate politics are tough? Go work for your dad or your mom."
  },
  {
    "author": "Dick Clark",
    "category": "dad",
    "id": 12126,
    "text": "Humor is always based on a modicum of truth. Have you ever heard a joke about a father-in-law?"
  },
  {
    "author": "Bear Grylls",
    "category": "dad",
    "id": 12496,
    "text": "I loved climbing because of the freedom, and having time and space. I remember coming off Everest for the last time, thinking of Dad and wishing that he could have seen what I saw. He would have loved it."
  },
  {
    "author": "Melanie Fiona",
    "category": "dad",
    "id": 12865,
    "text": "My dad still calls me and makes sure I'm taking my vitamins."
  },
  {
    "author": "Joe Manganiello",
    "category": "dad",
    "id": 12899,
    "text": "Also, to be honest, my dad wanted me to be an athlete. And I think all sons want to prove something to their dad. So now, aged 35, I want to see what I can achieve physically."
  },
  {
    "author": "Ann Richards",
    "category": "dad",
    "id": 12658,
    "text": "I have always had the feeling I could do anything and my dad told me I could. I was in college before I found out he might be wrong."
  },
  {
    "author": "Shakira",
    "category": "dad",
    "id": 12630,
    "text": "I think my dad is the only Arabic descendent who is an unsuccessful businessman."
  },
  {
    "author": "Bubba Watson",
    "category": "dad",
    "id": 12604,
    "text": "My dad's not here, but he's watching in heaven."
  },
  {
    "author": "Gloria Swanson",
    "category": "dad",
    "id": 12159,
    "text": "As Daddy said, life is 95 percent anticipation."
  },
  {
    "author": "Jeb Bush",
    "category": "dad",
    "id": 12480,
    "text": "It's a complex relationship when your dad happened to be president and you are president and then you have all the amateur psychology that goes on when people try to speculate about motivations."
  },
  {
    "author": "Rachel McAdams",
    "category": "dad",
    "id": 12371,
    "text": "I sort of always had an inkling towards some kind of an art form. I grew up in a very small town, and I just figure-skated. My dad played hockey and I was surrounded by sports, but it wasn't quite doing it for me. I wasn't totally fulfilled, and I did a lot of skating."
  },
  {
    "author": "William Shatner",
    "category": "dad",
    "id": 12257,
    "text": "My dad was good with actions."
  },
  {
    "author": "Johnny Knoxville",
    "category": "dad",
    "id": 12619,
    "text": "I'm the fun dad, I am also the disciplinarian."
  },
  {
    "author": "Dave Mustaine",
    "category": "dad",
    "id": 12569,
    "text": "I was always the new kid in school, I'm the kid from a broken family, I'm the kid who had no dad showing up at the father-son stuff, I'm the kid that was using food stamps at the grocery store."
  },
  {
    "author": "Bob Balaban",
    "category": "dad",
    "id": 12955,
    "text": "My dad was born in Chicago in 1908... his parents came from Russia. They settled in Chicago, where they lived in a little tiny grocery store with eight or nine children - in the backroom all together - and my grandmother got the idea to go into the movie business."
  },
  {
    "author": "James Belushi",
    "category": "dad",
    "id": 13005,
    "text": "I don't know if there is a gene for comedy, but my dad was a very funny man. He just didn't know it. He was a naturally funny character, and when my brother and I would laugh at things he said and did, he would say, 'What do you think is so funny?'"
  },
  {
    "author": "Shirley Manson",
    "category": "dad",
    "id": 12414,
    "text": "I was always embarrassed because my dad wore a suit and my mother wore flat pumps and a cozy jumper while my friends' parents were punks or hippies."
  },
  {
    "author": "Jaron Lanier",
    "category": "dad",
    "id": 12522,
    "text": "My dad has sometimes felt that I grew up a little lacking in sufficient eccentricity - in the sense that I'm willing to live as an adult in a house with walls that are parallel to each other, that sort of thing."
  },
  {
    "author": "Eric San",
    "category": "dad",
    "id": 12967,
    "text": "If you met my dad, I think a lot of things would be put to rest. Because my pops is a pretty silly guy. But, Coldcut, they're based in the U.K. I'm a big fan of jazz music, so American music has had a big influence on what I listen to."
  },
  {
    "author": "Bubba Watson",
    "category": "dad",
    "id": 12807,
    "text": "My dad taught me to be a leader or a follower, and he said follower ain't fun. So I want to be the leader of Bubba Watson."
  },
  {
    "author": "Billie Joe Armstrong",
    "category": "dad",
    "id": 12132,
    "text": "I'm a father. It isn't just my life any more. I don't want my kid finding bottles in the house or seeing his father completely smashed."
  },
  {
    "author": "Dennis Wilson",
    "category": "dad",
    "id": 12488,
    "text": "The one thing that kept our family together was the music. The only thing that our family would share emotionally was to have our dad cry over something the kids did with music."
  },
  {
    "author": "Cameron Diaz",
    "category": "dad",
    "id": 12362,
    "text": "I have to remind my dad, 'Journalists - no matter how many cigars they smoke with you - are not your friends, so don't talk to them.'"
  },
  {
    "author": "Kim Weston",
    "category": "dad",
    "id": 12705,
    "text": "I didn't want to travel. I didn't want to leave my family. I heard all these stories from Dad about not having Edward around when he was young, and I didn't want that to happen."
  },
  {
    "author": "Marlon Wayans",
    "category": "dad",
    "id": 12648,
    "text": "I'm the most inappropriate dad. I curse in front of my kids and their friends. I let my kids watch R-rated movies. I'll walk by the movie theater and say, 'Let's go see that,' and my kids will say, 'No, it's rated R. It's not appropriate for kids.' I'm like Uncle Dad. We have fun. I don't live with them, but I drive over four days a week."
  },
  {
    "author": "Curtis Stone",
    "category": "dad",
    "id": 12517,
    "text": "Now that I'm a dad, I'm practicing what I call 'one- handed cooking,' because I've got something more important in my other arm. I'm whipping up lots of frittatas and omelets."
  },
  {
    "author": "Dusty Baker",
    "category": "dad",
    "id": 13056,
    "text": "I love my daughter, but she had me on couscous and fixed me pastas and made me eat oatmeal every morning and what else, turkey burgers, turkey bacon, and that kind of stuff. So she wants her dad to live a long time, and I do, too."
  },
  {
    "author": "Nick Cannon",
    "category": "dad",
    "id": 12184,
    "text": "So my father was a person who never lied to me. If I had a question, he answered it. I knew a lot of things at a young age because I was intrigued."
  },
  {
    "author": "William Shatner",
    "category": "dad",
    "id": 12258,
    "text": "My dad died of a stroke."
  },
  {
    "author": "Edward Burns",
    "category": "dad",
    "id": 12747,
    "text": "Well, for one thing, you know my dad was a cop."
  },
  {
    "author": "Scott McCloud",
    "category": "dad",
    "id": 13078,
    "text": "My dad was an inventor, and I think I've always had a rosy view of technology, or at least its potential."
  },
  {
    "author": "John Boehner",
    "category": "dad",
    "id": 12473,
    "text": "My dad and my uncles owned a bar outside of Cincinnati. I worked there growing up, mopping floors, waiting tables."
  },
  {
    "author": "Glen Hansard",
    "category": "dad",
    "id": 12763,
    "text": "My dad was quiet, angry, shut down. So my thing is: I express everything that's there. I want to get it all out."
  },
  {
    "author": "Ben Barnes",
    "category": "dad",
    "id": 12635,
    "text": "My mum was raised Jewish, my dad is very scientifically minded, and my school was vaguely Christian. We sang hymns in school. I liked the hymns bit, but apart from that, I can take it or leave it. So I had lots of different influences when I was younger."
  },
  {
    "author": "Simon Newcomb",
    "category": "dad",
    "id": 12174,
    "text": "My father was the most rational and the most dispassionate of men."
  },
  {
    "author": "Lewis Black",
    "category": "dad",
    "id": 12302,
    "text": "A father and two sons run Adelphia. It's a cable company. And they took from that company a billion dollars. A billion. Three people - three people took a billion dollars. What were they gonna do, start their own space program? 'Let's send the monkey to Mars, Dad!'"
  },
  {
    "author": "Tony Scott",
    "category": "dad",
    "id": 12725,
    "text": "Dad was a very gentle, sweet man."
  },
  {
    "author": "Eric Stoltz",
    "category": "dad",
    "id": 12643,
    "text": "My parents moved to American Samoa when I was three or four years old. My dad was principal of a high school there. It was idyllic for a kid. I had a whole island for a backyard. I lived there until I was eight years old and we moved to Santa Barbara."
  },
  {
    "author": "Camryn Manheim",
    "category": "dad",
    "id": 12172,
    "text": "One of my earliest memories is of my father carrying me in one arm with a picket sign in the other."
  },
  {
    "author": "George Eliot",
    "category": "dad",
    "id": 12107,
    "text": "All the learnin' my father paid for was a bit o' birch at one end and an alphabet at the other."
  },
  {
    "author": "Dhani Harrison",
    "category": "dad",
    "id": 12749,
    "text": "I did rebel. I was the rebel in my family, because my dad wanted me to go and just travel with him."
  },
  {
    "author": "Julie Burchill",
    "category": "dad",
    "id": 12406,
    "text": "My dad didn't drive - the only dad I knew who didn't."
  },
  {
    "author": "Jamie Oliver",
    "category": "dad",
    "id": 12556,
    "text": "My first outdoor cooking memories are full of erratic British summers, Dad swearing at a barbecue that he couldn't put together, and eventually eating charred sausages, feeling brilliant."
  },
  {
    "author": "Herbert Kaufman",
    "category": "dad",
    "id": 12192,
    "text": "Rich men's sons are seldom rich men's fathers."
  },
  {
    "author": "Lauren Graham",
    "category": "dad",
    "id": 12687,
    "text": "Like my dad, I have a Christmas party most years. I like to celebrate and see as many people as possible."
  },
  {
    "author": "Ron Perlman",
    "category": "dad",
    "id": 12501,
    "text": "So much of my aesthetic was formed by my dad."
  },
  {
    "author": "Carlos Santana",
    "category": "dad",
    "id": 12315,
    "text": "My dad's a beautiful man, but like a lot of Mexican men, or men in general, a lot of men have a problem with the balance of masculinity and femininity - intuition and compassion and tenderness - and get overboard with the macho thing. It took him a while to become more, I would say, conscious, evolved."
  },
  {
    "author": "John Ciardi",
    "category": "dad",
    "id": 12104,
    "text": "Every parent is at some time the father of the unreturned prodigal, with nothing to do but keep his house open to hope."
  },
  {
    "author": "Wayne Rooney",
    "category": "dad",
    "id": 12497,
    "text": "Becoming a dad means you have to be a role model for your son and be someone he can look up to."
  },
  {
    "author": "T-Pain",
    "category": "dad",
    "id": 12771,
    "text": "My dad always told me that anyone's voice is just another instrument added to the music."
  },
  {
    "author": "Marcia Cross",
    "category": "dad",
    "id": 12926,
    "text": "I would ask my dad what he did, and he'd say, 'I listen to people's problems.' In some way what he did for a living is in my genes."
  },
  {
    "author": "Jared Harris",
    "category": "dad",
    "id": 12996,
    "text": "I wasn't aware of my dad being an actor when I was young. I remember there was an Australian children's entertainer on television called Ralph Harris and when I'd say my father was an actor, kids would say, you know, 'oh, is he Ralph Harris?' And I had to say no and then they would lose interest."
  },
  {
    "author": "Roman Coppola",
    "category": "dad",
    "id": 12867,
    "text": "Recently, I was in Bernalda, my dad's ancestral home town in Italy. He has just refurbished a palazzo and turned it into a hotel, so we had my sister's wedding there. It was beautiful."
  },
  {
    "author": "Derek Jeter",
    "category": "dad",
    "id": 12868,
    "text": "My dad had been shortstop when he was in college, and you know, when you're a kid, you want to be just like your dad."
  },
  {
    "author": "Jamie Redknapp",
    "category": "dad",
    "id": 12731,
    "text": "My dad knows the business, and he tells me I've got to do what's best for me."
  },
  {
    "author": "Leona Lewis",
    "category": "dad",
    "id": 12455,
    "text": "I do love a bit of fashion. I grew up around a lot of it as my mum and dad had clothing stores so my mum was always designing a lot, and I definitely had that as an influence."
  },
  {
    "author": "Tony Visconti",
    "category": "dad",
    "id": 12694,
    "text": "My dad's sense of humor was direct and sometimes surreal - his quick wit is well known amongst our family and friends. He raised me on Spike Jones records and W.C. Fields movies, and his sense of humor fell somewhere in between."
  },
  {
    "author": "Slash",
    "category": "dad",
    "id": 12840,
    "text": "My dad is a huge rock and roll lead guitar fan. I didn't even really know that until recently. Everything has to have a guitar solo in it."
  },
  {
    "author": "Giancarlo Esposito",
    "category": "dad",
    "id": 12657,
    "text": "People who have not done their research on me do not know that I am European, born in Copenhagen, Denmark to an Italian father from Napoli and a mother from Alabama who was singing opera and went to Europe, met my dad, fell in love, and then moved back to Rome, where I was raised, between Rome and Hamburg."
  },
  {
    "author": "Jim Carrey",
    "category": "dad",
    "id": 12224,
    "text": "My dad was like a stage mother he always pushed me to do what I wanted."
  },
  {
    "author": "Jon Lovitz",
    "category": "dad",
    "id": 12847,
    "text": "My dad would always say, 'What can you do to make the world a better place?' Well, I can make people laugh."
  },
  {
    "author": "Dean Norris",
    "category": "dad",
    "id": 12944,
    "text": "My dad's era believed that there was something noble in being a good guy - the kind of guy that lived straight and narrow, told the truth, and stood up for what he believed was right."
  },
  {
    "author": "Will Estes",
    "category": "dad",
    "id": 12916,
    "text": "That's a tough question I've been acting since I was 10. My dad was an entrepreneur, so I guess something along those lines. I wouldn't want a 9-5 job."
  },
  {
    "author": "Criss Angel",
    "category": "dad",
    "id": 12632,
    "text": "I had an amazing childhood, lots of love. But my dad worked his tail off, getting up at 4 in the morning and going off at 5, 6 o'clock, yet he always had time to spend with his kids and his wife."
  },
  {
    "author": "Dominic West",
    "category": "dad",
    "id": 13036,
    "text": "My mum's parents were from Ireland, my dad's mum was American-Irish."
  },
  {
    "author": "Fred Allen",
    "category": "dad",
    "id": 12133,
    "text": "My father never raised his hand to any one of his children, except in self-defense."
  },
  {
    "author": "Pope John XXIII",
    "category": "dad",
    "id": 12089,
    "text": "It is easier for a father to have children than for children to have a real father."
  },
  {
    "author": "Anthony Kiedis",
    "category": "dad",
    "id": 12507,
    "text": "I know my dad is a big Internet freak, and he's been known to be a Wikileaker."
  },
  {
    "author": "Hoda Kotb",
    "category": "dad",
    "id": 12862,
    "text": "So I go to my first book signing, and these two girls came up and gave me a piece of paper: '10 reasons you should date our dad. He climbed Mount Kilimanjaro. He's a lawyer.' He didn't know what was going on. He didn't even know me. They called him, and he came down and asked me out that day. Now I'm dating their dad!"
  },
  {
    "author": "David Duchovny",
    "category": "dad",
    "id": 12303,
    "text": "One of the scary things is that, when you're a kid, you look at your dad as the man who has no fear. When you're an adult, you realize your father had fear, and that you have it, too."
  },
  {
    "author": "Matt Damon",
    "category": "dad",
    "id": 12608,
    "text": "My parents divorced when I was young but I was brought up in two really loving households. I didn't have a contentious relationship with my mom or dad."
  },
  {
    "author": "Vince Gill",
    "category": "dad",
    "id": 12809,
    "text": "The real beauty of it - key to my life was playing key chords on a banjo. For somebody else it may be a golf club that mom and dad put in their hands or a baseball or ballet lessons. Real gift to give to me and put it in writing."
  },
  {
    "author": "Chris Pine",
    "category": "dad",
    "id": 13032,
    "text": "My grandmother was an actress too. In the thirties and forties she was under contract with Universal Studios. Crazy credits, lots of them. My dad was also under contract with Universal Studios. And my first film was shot on the same stage they both worked on at Universal."
  },
  {
    "author": "Josh Duhamel",
    "category": "dad",
    "id": 12818,
    "text": "I've always wanted to be a dad. I just can't wait to have a little rug rat running around. I used to want five or six kids, but maybe I've become too self-absorbed over the years. I think two would be perfect."
  },
  {
    "author": "Dionne Warwick",
    "category": "dad",
    "id": 12162,
    "text": "Do you know that other than my father, I've never had a man take care of me?"
  },
  {
    "author": "Kim Weston",
    "category": "dad",
    "id": 12704,
    "text": "Growing up, I didn't give my grandfather's photography a second thought. I wasn't involved in his work, except that I helped my dad print his negatives."
  },
  {
    "author": "Arne Duncan",
    "category": "dad",
    "id": 12961,
    "text": "There was nothing more important I could do than be supportive as a dad."
  },
  {
    "author": "Billy Sherwood",
    "category": "dad",
    "id": 12831,
    "text": "So I was always around music and my dad was in his own way a progressive jazzer, a big band jazzer guy."
  },
  {
    "author": "Hoda Kotb",
    "category": "dad",
    "id": 12861,
    "text": "From time to time, I'll look back through the personal journals I've scribbled in throughout my life, the keepers of my raw thoughts and emotions. The words poured forth after my dad died, when I went through a divorce, and after I was diagnosed with breast cancer. There are so many what-ifs scribbled on those pages."
  },
  {
    "author": "Nate Ruess",
    "category": "dad",
    "id": 12581,
    "text": "My dad dragged me to a Bruce Springsteen concert as a kid. It was my first concert, but I fell asleep in the middle. My second concert was Weezer on the 'Pinkerton' tour, and 'Pinkerton' is the reason why I'm doing this."
  },
  {
    "author": "Gary Oldman",
    "category": "dad",
    "id": 12368,
    "text": "And of course I've got kids of my own now, and they love me being in the Harry Potter films. I'm now part of a phenomenon. You become incredibly cool to your kids, and you get a young fan base. So you became the cool dad at school. You're suddenly hip."
  },
  {
    "author": "Hugh Jackman",
    "category": "dad",
    "id": 12275,
    "text": "One afternoon when I was 9, my dad told me I'd be skipping school the next day. Then we drove 12 hours from Melbourne to Sydney for the Centenary Test, a once-in-a-lifetime commemorative cricket match. It was great fun - especially for a kid who was a massive sports fan."
  },
  {
    "author": "Tom Hiddleston",
    "category": "dad",
    "id": 12294,
    "text": "Joanna points her camera at a section of society unused to having cameras pointed at it. But I don't know about categorizing them in terms of class I'm a bit wary of that. My dad is the son of a shipbuilder."
  },
  {
    "author": "Ernie Harwell",
    "category": "dad",
    "id": 12562,
    "text": "I have great faith that Heaven's there and I'll see my brothers and my mom and dad when I get there."
  },
  {
    "author": "Bill Gates",
    "category": "dad",
    "id": 12212,
    "text": "Me and my dad are the biggest promoters of an estate tax in the US. It's not a popular position."
  },
  {
    "author": "Joe Lando",
    "category": "dad",
    "id": 12895,
    "text": "My dad is a really honest, hardworking, straight guy."
  },
  {
    "author": "Chris O'Donnell",
    "category": "dad",
    "id": 12513,
    "text": "I think it's easiest to teach by example. My dad didn't tell us to work hard we just saw how hard he worked. I know I have shortcomings - like a short fuse - but I've learned you can't come home from a long day of work and snap at the kids."
  },
  {
    "author": "Ralph Nader",
    "category": "dad",
    "id": 12307,
    "text": "I once said to my father, when I was a boy, 'Dad we need a third political party.' He said to me, 'I'll settle for a second.'"
  },
  {
    "author": "Geoffrey Rush",
    "category": "dad",
    "id": 12499,
    "text": "Within our culture, every school has a swimming pool. We lived on the coast. People swam in the surf. It's a very sporty nation and at that particular time anyone who had an artistic bent was very much an outsider. So if you liked reading or ideas or playing the piano then your dad viewed you as a sissy, basically."
  },
  {
    "author": "Ron White",
    "category": "dad",
    "id": 12217,
    "text": "When I was about 12 years old back in Houston, my Dad used to take us to the driving range."
  }
]

quotes['dating'] = [
  {
    "author": "Louis C. K.",
    "category": "dating",
    "id": 13175,
    "text": "When I was first divorced, I started dating younger women, and it was really exciting. But after a while I was like, 'This is just dumb.'"
  },
  {
    "author": "Zac Efron",
    "category": "dating",
    "id": 13202,
    "text": "Dating is kind of hard. Like dinner or something like that. Like a forced awkward situation is very strange. Especially for me, for some reason."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "dating",
    "id": 13206,
    "text": "I don't know why anyone would want to ask an actor for dating advice. We are not the poster children for healthy relationships."
  },
  {
    "author": "Jared Padalecki",
    "category": "dating",
    "id": 13258,
    "text": "I'm a fan of horrors. I love the ones that make you jump. My girlfriend hates it. I've been dating her for one-and-a-half years and I'm crazy about her, but she's terrified of horror films. Not the cute 'Will you hold me?' way, but she's weeping. With 'House of Wax,' we'll be sleeping and I'll go to the bathroom and she's sitting up waiting for me."
  },
  {
    "author": "Demi Lovato",
    "category": "dating",
    "id": 13172,
    "text": "It's a big responsibility dating me. Because I come with a little bit of baggage, you know?"
  },
  {
    "author": "Brooke Burke",
    "category": "dating",
    "id": 13209,
    "text": "Dating is really hard because everyone puts on a front. It's really difficult to see who is who, so it is important to be yourself."
  },
  {
    "author": "Jason Lee",
    "category": "dating",
    "id": 13237,
    "text": "Celebrities say they date other celebrities because they have the same job. But I think they just like dating famous people. Celebrities attract each other, like cattle."
  },
  {
    "author": "Graham Norton",
    "category": "dating",
    "id": 13212,
    "text": "I'm often dating people, but I don't say it because you sort of know it won't last long."
  },
  {
    "author": "Lauren Conrad",
    "category": "dating",
    "id": 13191,
    "text": "Dating is all about the chase. It's fun!"
  },
  {
    "author": "Steve Albini",
    "category": "dating",
    "id": 13243,
    "text": "The woman I am currently crazy about was a vegetarian for a year until I started dating her. As is the case with most vegetarians, she had never eaten properly prepared meat, only commercially packaged or otherwise abused flesh."
  },
  {
    "author": "Rebecca Romijn",
    "category": "dating",
    "id": 13229,
    "text": "Are you kidding? I'm a terrible cook, but John is a really great one. Literally, I never cook. The whole time we were dating, I prepared two officially romantic meals. Both of them were such disasters that he begs me never to go into the kitchen again."
  },
  {
    "author": "Francesca Annis",
    "category": "dating",
    "id": 13105,
    "text": "However successful you are, there is no substitute for a close relationship. We all need them."
  },
  {
    "author": "Kelly Osbourne",
    "category": "dating",
    "id": 13135,
    "text": "I was dating this guy and we would spend all day text messaging each other. And he thought that he could tell that he liked me more because he actually spelt the word 'YOU' and I just put the letter 'U'."
  },
  {
    "author": "Bill Condon",
    "category": "dating",
    "id": 13223,
    "text": "Like many of you, I've always been slightly obsessed with vampires, dating back to the prime-time series 'Dark Shadows,' which I followed avidly as a kid."
  },
  {
    "author": "Ben Kingsley",
    "category": "dating",
    "id": 13134,
    "text": "If your best friend has stolen your girlfriend, it does become life and death."
  },
  {
    "author": "Lena Dunham",
    "category": "dating",
    "id": 13186,
    "text": "I'm not great at dating, but I need to do it to relax."
  },
  {
    "author": "Bridget Hall",
    "category": "dating",
    "id": 13213,
    "text": "It's just me and my 6-month-old puppy. I am not dating anyone."
  },
  {
    "author": "Rita Rudner",
    "category": "dating",
    "id": 13120,
    "text": "My boyfriend and I broke up. He wanted to get married and I didn't want him to."
  },
  {
    "author": "Mitch Hedberg",
    "category": "dating",
    "id": 13091,
    "text": "I don't have a girlfriend. But I do know a woman who'd be mad at me for saying that."
  },
  {
    "author": "Kristen Stewart",
    "category": "dating",
    "id": 13182,
    "text": "I wouldn't tell you anything about anybody I cared about because it becomes entertainment for other people, and it sort of just cheapens everything in your life. I would never tell you if I was dating anybody."
  },
  {
    "author": "Scott Adams",
    "category": "dating",
    "id": 13102,
    "text": "Nothing defines humans better than their willingness to do irrational things in the pursuit of phenomenally unlikely payoffs. This is the principle behind lotteries, dating, and religion."
  },
  {
    "author": "Daisy Fuentes",
    "category": "dating",
    "id": 13176,
    "text": "You are not alone with a guy until you are a proper age. You don't go to certain levels with men until you are married or you have a certain relationship."
  },
  {
    "author": "Hoda Kotb",
    "category": "dating",
    "id": 13236,
    "text": "So I go to my first book signing, and these two girls came up and gave me a piece of paper: '10 reasons you should date our dad. He climbed Mount Kilimanjaro. He's a lawyer.' He didn't know what was going on. He didn't even know me. They called him, and he came down and asked me out that day. Now I'm dating their dad!"
  },
  {
    "author": "Moon Unit Zappa",
    "category": "dating",
    "id": 13219,
    "text": "We had two rules growing up in my house: If you're going to take a shower, do it with whomever you're dating so you don't waste water and if you buy one for yourself, buy six, because everybody's going to want one."
  },
  {
    "author": "Christina Aguilera",
    "category": "dating",
    "id": 13109,
    "text": "Right now I'm pretty single... My career is my boyfriend."
  },
  {
    "author": "Patti Stanger",
    "category": "dating",
    "id": 13201,
    "text": "The rich are different. Their wants are very high maintenance. They'll pick eye color and hair color, all the way down to what she does for a living, what school she went to. Their list can be extremely long. But at the end of the day, dating is dating, because they're human beings."
  },
  {
    "author": "Meg Cabot",
    "category": "dating",
    "id": 13270,
    "text": "My original inspiration was my mom: a few years after the death of my dad, she started dating one my teachers!"
  },
  {
    "author": "Rachel Dratch",
    "category": "dating",
    "id": 13231,
    "text": "I have no wisdom to share on dating."
  },
  {
    "author": "Stockard Channing",
    "category": "dating",
    "id": 13254,
    "text": "You're talking to someone who has been married to various people for the last 40 years of her life. Dating is not really something familiar. I've never really been a dater."
  },
  {
    "author": "Lauren Conrad",
    "category": "dating",
    "id": 13190,
    "text": "I don't have the best dating track record."
  },
  {
    "author": "Neil LaBute",
    "category": "dating",
    "id": 13158,
    "text": "Relationships in general make people a bit nervous. It's about trust. Do I trust you enough to go there?"
  },
  {
    "author": "Martha Beck",
    "category": "dating",
    "id": 13173,
    "text": "Good-looking individuals are treated better than homely ones in virtually every social situation, from dating to trial by jury."
  },
  {
    "author": "Julie Bowen",
    "category": "dating",
    "id": 13216,
    "text": "I've had a little bad, bad media luck the new year. Well, apparently I'm dating Bill Clinton, which makes me nervous. I didn't know, though."
  },
  {
    "author": "Tim Berners-Lee",
    "category": "dating",
    "id": 13215,
    "text": "The Google algorithm was a significant development. I've had thank-you emails from people whose lives have been saved by information on a medical website or who have found the love of their life on a dating website."
  },
  {
    "author": "Davidson Black",
    "category": "dating",
    "id": 13279,
    "text": "The Peking man was a thinking being, standing erect, dating to the beginning of the Ice Age."
  },
  {
    "author": "Judith Krantz",
    "category": "dating",
    "id": 13277,
    "text": "I got that experience through dating dozens of men for six years after college, getting an entry level magazine job at 21, working in the fiction department at Good Housekeeping and then working as a fashion editor there as well as writing many articles for the magazine."
  },
  {
    "author": "John Stamos",
    "category": "dating",
    "id": 13217,
    "text": "I also find it interesting that a lot of people in their 30s are not married and don't have kids. There are a lot of people in this age bracket that are out there dating and trying to find love. And I never thought that at my age I would be."
  },
  {
    "author": "Roy Blount, Jr.",
    "category": "dating",
    "id": 13248,
    "text": "I heard on public radio recently, there's a thing called Weed Dating. Singles get together in a garden and weed and then they take turns, they keep matching up with other people. Two people will weed down one row and switch over with two other people. It's in Vermont. I don't think I'd be very good at Weed Dating."
  },
  {
    "author": "Anna Kournikova",
    "category": "dating",
    "id": 13141,
    "text": "I have a lot of boyfriends, I want you to write that. Every country I visit, I have a different boyfriend. And I kiss them all."
  },
  {
    "author": "Rachelle Lefevre",
    "category": "dating",
    "id": 13261,
    "text": "Dating and getting attention from boys was something that came later to me."
  },
  {
    "author": "Chris Pine",
    "category": "dating",
    "id": 13264,
    "text": "I do like dating cynics - they tend to be incredibly funny."
  },
  {
    "author": "Chris Pine",
    "category": "dating",
    "id": 13265,
    "text": "Work takes up a lot of my brain space. So when I work, it's one thing. I don't have a lot of time to think about dating."
  },
  {
    "author": "Holly Madison",
    "category": "dating",
    "id": 13197,
    "text": "I've had two romances since moving to Las Vegas. One was with somebody 12 years older than me, and the other was the same age, and neither worked out. I know people still think of me as one of Hugh Hefner's girlfriends, and he of course was much older than me, but that was a whole different lifestyle and a different kind of dating."
  },
  {
    "author": "Ashley Tisdale",
    "category": "dating",
    "id": 13188,
    "text": "I give dating advice on a regular basis. It's not that I'm any expert, but it's always nice to share that with your friends."
  },
  {
    "author": "Ashley Rickards",
    "category": "dating",
    "id": 13272,
    "text": "Frankly, the reason I joined MENSA is because I was dating a guy at the time who spoke five languages and could solve a Rubik's Cube literally with his eyes closed because it's just an algorithm."
  },
  {
    "author": "Loretta Young",
    "category": "dating",
    "id": 13178,
    "text": "I can't imagine dating a boy, meeting him only outside the home. What's a home and family for if it's not the center of one's life?"
  },
  {
    "author": "Carrie Ann Inaba",
    "category": "dating",
    "id": 13238,
    "text": "I've always gone out with much younger guys. But I rushed into relationships before really getting to know the person. What would come up as a warning sign within the first two weeks of dating would usually be the exact reason the relationship would end!"
  },
  {
    "author": "Matt Czuchry",
    "category": "dating",
    "id": 13268,
    "text": "I'm enjoying dating. I'm single, though, I'm not in a relationship."
  },
  {
    "author": "James Levine",
    "category": "dating",
    "id": 13155,
    "text": "It was just that we had this phenomenal honeymoon relationship that just kept on going."
  },
  {
    "author": "Bill Keller",
    "category": "dating",
    "id": 13230,
    "text": "I don't have dating tips."
  },
  {
    "author": "Jack Nicholson",
    "category": "dating",
    "id": 13115,
    "text": "Well, a girlfriend once told me never to fight with anybody you don't love."
  },
  {
    "author": "Orson Welles",
    "category": "dating",
    "id": 13108,
    "text": "Personally, I don't like a girlfriend to have a husband. If she'll fool her husband, I figure she'll fool me."
  },
  {
    "author": "Leonardo DiCaprio",
    "category": "dating",
    "id": 13130,
    "text": "I've never been Romeo who meets a girl and falls for her immediately. It's been a much slower process for me each time I've gone into a relationship."
  },
  {
    "author": "Leonardo DiCaprio",
    "category": "dating",
    "id": 13168,
    "text": "I prefer ordinary girls - you know, college students, waitresses, that sort of thing. Most of the girls I go out with are just good friends. Just because I go out to the cinema with a girl, it doesn't mean we are dating."
  },
  {
    "author": "Kristin Cavallari",
    "category": "dating",
    "id": 13228,
    "text": "I'm very open to dating and finding a guy."
  },
  {
    "author": "Lauren Conrad",
    "category": "dating",
    "id": 13192,
    "text": "Dating in Los Angeles can be hard, which makes it all the better when you meet a really nice guy."
  },
  {
    "author": "Zosia Mamet",
    "category": "dating",
    "id": 13242,
    "text": "I think feminism's a bit misinterpreted. It was about casting off all gender roles. There's nothing wrong with a man holding a door open for a girl. But we sort of threw away all the rules, so everybody's confused. And dating becomes a sloppy, uncomfortable, unpleasant thing."
  },
  {
    "author": "Joe Rogan",
    "category": "dating",
    "id": 13116,
    "text": "If you can lie, you can act, and if you can lie to crazy girlfriends, you can act under pressure."
  },
  {
    "author": "Cory Monteith",
    "category": "dating",
    "id": 13224,
    "text": "I like the idea of dating, but I'm not dating anyone exclusively, particularly right now. It's hard to be in a relationship unless you're ready to go public with it. So it's a lot easier for me to not be in a relationship. I really don't want that part of my life to be tabloid fodder."
  },
  {
    "author": "Doug Coupland",
    "category": "dating",
    "id": 13167,
    "text": "Workshops and seminars are basically financial speed dating for clueless people."
  },
  {
    "author": "Gloria Allred",
    "category": "dating",
    "id": 13232,
    "text": "I'm not interested in dating. I like being with my own best friend, me. Certain women, particularly older women, cannot believe I like going to a social event by myself. But I do."
  },
  {
    "author": "Betty Dodson",
    "category": "dating",
    "id": 13139,
    "text": "We are constantly protecting the male ego, and it's a disservice to men. If a man has any sensitivity or intelligence, he wants to get the straight scoop from his girlfriend."
  },
  {
    "author": "Demi Lovato",
    "category": "dating",
    "id": 13177,
    "text": "I'm honest about the journey I've been on, so I definitely don't take dating lightly anymore."
  },
  {
    "author": "Rosario Dawson",
    "category": "dating",
    "id": 13249,
    "text": "It was funny actually because that was still during the time we were dating. He would get all these calls because supposedly before we broke up, we had already broken up in the trades, in the rags or whatever."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "dating",
    "id": 13103,
    "text": "It seems essential, in relationships and all tasks, that we concentrate only on what is most significant and important."
  },
  {
    "author": "Jackee Harry",
    "category": "dating",
    "id": 13244,
    "text": "I don't mind dating younger men now."
  },
  {
    "author": "Keanu Reeves",
    "category": "dating",
    "id": 13090,
    "text": "Falling in love and having a relationship are two different things."
  },
  {
    "author": "Vanessa Hudgens",
    "category": "dating",
    "id": 13183,
    "text": "I'm not very experienced with boys or the whole dating thingy."
  },
  {
    "author": "Alicia Silverstone",
    "category": "dating",
    "id": 13138,
    "text": "My boyfriend calls me 'princess', but I think of myself more along the lines of 'monkey' and 'retard'."
  },
  {
    "author": "Marianne Faithfull",
    "category": "dating",
    "id": 13144,
    "text": "Maybe the most that you can expect from a relationship that goes bad is to come out of it with a few good songs."
  },
  {
    "author": "Rachel Bilson",
    "category": "dating",
    "id": 13218,
    "text": "Dating co-stars is natural. When you're working with someone, it's habit."
  },
  {
    "author": "Britney Spears",
    "category": "dating",
    "id": 13125,
    "text": "I don't understand the whole dating thing. I know right off the bat if I'm interested in someone, and I don't want them to waste their money on me and take me out to eat if I know I'm not interested in that person."
  },
  {
    "author": "Chris Messina",
    "category": "dating",
    "id": 13259,
    "text": "Yeah, I think everybody has the crises of questioning themselves at some point or other in their lives. Is this where I should live? The job I should have? The girl I should be dating? Is this the friend I should have?"
  },
  {
    "author": "Tyson Gay",
    "category": "dating",
    "id": 13263,
    "text": "My daughter's mother and I are no longer dating, and the people I'm most likely to date are those around me, who are athletes."
  },
  {
    "author": "Lucy Liu",
    "category": "dating",
    "id": 13126,
    "text": "Everything I buy is vintage and smells funny. Maybe that's why I don't have a boyfriend."
  },
  {
    "author": "Jennifer Aniston",
    "category": "dating",
    "id": 13112,
    "text": "You know when I feel inwardly beautiful? When I am with my girlfriends and we are having a 'goddess circle'."
  },
  {
    "author": "Paul Feig",
    "category": "dating",
    "id": 13208,
    "text": "I always hated high-school shows and high-school movies, because they were always about the cool kids. It was always about dating and sex, and all the popular kids, and the good-looking kids. And the nerds were super-nerdy cartoons, with tape on their glasses. I never saw 'my people' portrayed accurately."
  },
  {
    "author": "Megan Fox",
    "category": "dating",
    "id": 13097,
    "text": "I like the bad-boy types. Generally the guy I'm attracted to is the guy in the club with all the tattoos and nail polish. He's usually the lead singer in a punk band and plays guitar. But my serious boyfriends are relatively clean-cut, nice guys. So it's strange."
  },
  {
    "author": "Minnie Driver",
    "category": "dating",
    "id": 13148,
    "text": "Last year my boyfriend gave me a painting - a very personal one. I really prefer personal gifts or ones made by someone for me. Except diamonds. That's the exception to the rule."
  },
  {
    "author": "Jimmy Fallon",
    "category": "dating",
    "id": 13123,
    "text": "If you're a sports fan you realize that when you meet somebody, like a girlfriend, they kind of have to root for your team. They don't have a choice."
  },
  {
    "author": "Neil LaBute",
    "category": "dating",
    "id": 13156,
    "text": "In a relationship you have to open yourself up."
  },
  {
    "author": "Dana Delany",
    "category": "dating",
    "id": 13267,
    "text": "I've been dating younger men since my 20s, When I was 29, I dated someone 21... younger men are just more fun. I like their energy. I've always been kind of young for my age."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "dating",
    "id": 13205,
    "text": "I'm so an all-or-nothing person in dating, always. I'm big on not wasting time. And so, yeah, if something's not working, it's time to not hold people back."
  },
  {
    "author": "Orson Welles",
    "category": "dating",
    "id": 13094,
    "text": "If there hadn't been women we'd still be squatting in a cave eating raw meat, because we made civilization in order to impress our girlfriends."
  },
  {
    "author": "Adam Sandler",
    "category": "dating",
    "id": 13119,
    "text": "I'm 31 now. I think I'm beginning to understand what life is, what romance is, and what a relationship means."
  },
  {
    "author": "Priscilla Presley",
    "category": "dating",
    "id": 13234,
    "text": "You know, I had my mother and my father convincing me that he would be going back to Hollywood and he'd be back with the actresses and dating them and that he wasn't serious about me at all. So I had him saying one thing to me and my parents telling me something else."
  },
  {
    "author": "Shia LaBeouf",
    "category": "dating",
    "id": 13171,
    "text": "I want my audience to know me for my work, not because of who I'm dating or what drugs I'm on or what club I went to."
  },
  {
    "author": "Kristin Chenoweth",
    "category": "dating",
    "id": 13226,
    "text": "I'm finally dating. It's fun."
  },
  {
    "author": "Dax Shepard",
    "category": "dating",
    "id": 13240,
    "text": "It's ironic, really. Guys should be excited that I got Kristen Bell. If Brad Pitt gets Kristen Bell, it's like, 'Well, of course he did.' With me, it should be, 'Oh good, a normal-looking guy got her. Maybe I'll get me a Kristen Bell.' But guys hate my guts for always dating women I have no right to be with."
  },
  {
    "author": "Ben Savage",
    "category": "dating",
    "id": 13271,
    "text": "I think a nice romantic dinner should be saved for when you and the girl you're dating or seeing have something special and it's a more special occasion."
  },
  {
    "author": "Jerry O'Connell",
    "category": "dating",
    "id": 13253,
    "text": "I highly suggest marriage to all my friends who are dating."
  },
  {
    "author": "Daphne Zuniga",
    "category": "dating",
    "id": 13159,
    "text": "I started dating older men, and I would fall in love with them. I thought they could teach me about life."
  },
  {
    "author": "Jason Schwartzman",
    "category": "dating",
    "id": 13118,
    "text": "I don't know the first real thing about the dating game. I don't know how to talk to a specific person and connect. I just think you have to go to person by person and do the best you can with people in general."
  },
  {
    "author": "Orlando Bloom",
    "category": "dating",
    "id": 13101,
    "text": "I'm quite sensitive to women. I saw how my sister got treated by boyfriends. I read this thing that said when you are in a relationship with a woman, imagine how you would feel if you were her father. That's been my approach, for the most part."
  },
  {
    "author": "Keith Sweat",
    "category": "dating",
    "id": 13092,
    "text": "You can't stop loving or wanting to love because when its right it's the best thing in the world. When you're in a relationship and its good, even if nothing else in your life is right, you feel like your whole world is complete."
  },
  {
    "author": "Jennifer Love Hewitt",
    "category": "dating",
    "id": 13160,
    "text": "I think more dating stuff is scheduling. It's needing people who understand your work schedule."
  },
  {
    "author": "Candice Bergen",
    "category": "dating",
    "id": 13137,
    "text": "I didn't have a financial need, and I wasn't very gifted at relationships. I probably was more like what we think of boys as being: hard to pin down and wary of commitment."
  },
  {
    "author": "Wayne Dyer",
    "category": "dating",
    "id": 13093,
    "text": "Real magic in relationships means an absence of judgment of others."
  },
  {
    "author": "Toni Braxton",
    "category": "dating",
    "id": 13235,
    "text": "Dating is different when you get older. You're not as trusting, or as eager to get back out there and expose yourself to someone."
  },
  {
    "author": "Jay London",
    "category": "dating",
    "id": 13146,
    "text": "My girlfriend bought me a down jacket, she said it fit my personality."
  }
]

quotes['death'] = [
  {
    "author": "Francois Rabelais",
    "category": "death",
    "id": 13900,
    "text": "Science without conscience is the death of the soul."
  },
  {
    "author": "Lewis Thomas",
    "category": "death",
    "id": 14023,
    "text": "A lot of people fear death because they think that so overwhelming an experience has to be painful, but I've seen quite a few deaths, and, with one exception, I've never known anyone to undergo anything like agony. That's amazing when you think about it. I mean, how complicated the mechanism is that's being taken apart."
  },
  {
    "author": "Billy Graham",
    "category": "death",
    "id": 13524,
    "text": "I look forward to death with great anticipation, to meeting God face to face."
  },
  {
    "author": "Martha Beck",
    "category": "death",
    "id": 13862,
    "text": "No one else can take risks for us, or face our losses on our behalf, or give us self-esteem. No one can spare us from life's slings and arrows, and when death comes, we meet it alone."
  },
  {
    "author": "Deepak Chopra",
    "category": "death",
    "id": 13528,
    "text": "We are not victims of aging, sickness and death. These are part of scenery, not the seer, who is immune to any form of change. This seer is the spirit, the expression of eternal being."
  },
  {
    "author": "William Butler Yeats",
    "category": "death",
    "id": 13586,
    "text": "I balanced all, brought all to mind, the years to come seemed waste of breath, a waste of breath the years behind, in balance with this life, this death."
  },
  {
    "author": "Miguel de Unamuno",
    "category": "death",
    "id": 13347,
    "text": "Man dies of cold, not of darkness."
  },
  {
    "author": "Rainn Wilson",
    "category": "death",
    "id": 14135,
    "text": "I really wanted to do something positive on the Internet. I wanted to try to get young people talking about, thinking about, life's big questions-make it cool and OK to wonder about the heart, the soul and free will and God and death and big topics like that, big human topics."
  },
  {
    "author": "Plato",
    "category": "death",
    "id": 13435,
    "text": "No evil can happen to a good man, either in life or after death."
  },
  {
    "author": "Miguel Angel Ruiz",
    "category": "death",
    "id": 13724,
    "text": "Death is not the biggest fear we have our biggest fear is taking the risk to be alive - the risk to be alive and express what we really are."
  },
  {
    "author": "A. N. Wilson",
    "category": "death",
    "id": 14066,
    "text": "I might be deceiving myself but I do not think that I do have an inordinate fear of death."
  },
  {
    "author": "Alexei Sayle",
    "category": "death",
    "id": 14218,
    "text": "I've accentuated the look over the years. As a comic, you try something and if it works you go with it and grind it to death."
  },
  {
    "author": "Robert Benchley",
    "category": "death",
    "id": 13683,
    "text": "A real hangover is nothing to try out family remedies on. The only cure for a real hangover is death."
  },
  {
    "author": "Brian Eno",
    "category": "death",
    "id": 13814,
    "text": "Everybody is entertained to death."
  },
  {
    "author": "Martin Scorsese",
    "category": "death",
    "id": 13807,
    "text": "Death comes in a flash, and that's the truth of it, the person's gone in less than 24 frames of film."
  },
  {
    "author": "Martin Short",
    "category": "death",
    "id": 14203,
    "text": "I have sometimes imagined my own death and brought myself to tears."
  },
  {
    "author": "Jim Morrison",
    "category": "death",
    "id": 13367,
    "text": "People fear death even more than pain. It's strange that they fear death. Life hurts a lot more than death. At the point of death, the pain is over. Yeah, I guess it is a friend."
  },
  {
    "author": "John Galsworthy",
    "category": "death",
    "id": 13626,
    "text": "Love has no age, no limit and no death."
  },
  {
    "author": "Herodotus",
    "category": "death",
    "id": 13925,
    "text": "Death is a delightful hiding place for weary men."
  },
  {
    "author": "Carl Hiaasen",
    "category": "death",
    "id": 14183,
    "text": "Nobody with an IQ higher than emergency-room temperature could ever believe that 'death panels' would be appointed to nudge the elderly toward euthanasia. Yet for idle entertainment, it's hard to beat Sarah Palin's ignorant nattering on the subject."
  },
  {
    "author": "Red Skelton",
    "category": "death",
    "id": 13856,
    "text": "His death was the first time that Ed Wynn ever made anyone sad."
  },
  {
    "author": "Buddha",
    "category": "death",
    "id": 13370,
    "text": "Without health life is not life it is only a state of langour and suffering - an image of death."
  },
  {
    "author": "Woody Allen",
    "category": "death",
    "id": 13481,
    "text": "There are worse things in life than death. Have you ever spent an evening with an insurance salesman?"
  },
  {
    "author": "Lewis Mumford",
    "category": "death",
    "id": 13948,
    "text": "Without fullness of experience, length of days is nothing. When fullness of life has been achieved, shortness of days is nothing. That is perhaps why the young have usually so little fear of death they live by intensities that the elderly have forgotten."
  },
  {
    "author": "Julius Caesar",
    "category": "death",
    "id": 13662,
    "text": "Which death is preferably to every other? 'The unexpected'."
  },
  {
    "author": "Brendan Behan",
    "category": "death",
    "id": 13744,
    "text": "When I came back to Dublin I was courtmartialed in my absence and sentenced to death in my absence, so I said they could shoot me in my absence."
  },
  {
    "author": "Elisabeth Kubler-Ross",
    "category": "death",
    "id": 13309,
    "text": "Those who have the strength and the love to sit with a dying patient in the silence that goes beyond words will know that this moment is neither frightening nor painful, but a peaceful cessation of the functioning of the body."
  },
  {
    "author": "Seneca",
    "category": "death",
    "id": 13795,
    "text": "Just as I shall select my ship when I am about to go on a voyage, or my house when I propose to take a residence, so I shall choose my death when I am about to depart from life."
  },
  {
    "author": "Emma Thompson",
    "category": "death",
    "id": 13580,
    "text": "But when I lose my temper, I find it difficult to forgive myself. I feel I've failed. I can be calm in a crisis, in the face of death or things that hurt badly. I don't get hysterical, which may be masochistic of me."
  },
  {
    "author": "Daniel Boone",
    "category": "death",
    "id": 14171,
    "text": "We were then in a dangerous, helpless situation, exposed daily to perils and death amongst savages and wild beasts, not a white man in the country but ourselves."
  },
  {
    "author": "Samuel Butler",
    "category": "death",
    "id": 13600,
    "text": "If life must not be taken too seriously, then so neither must death."
  },
  {
    "author": "Florence Welch",
    "category": "death",
    "id": 14094,
    "text": "I try to write lyrics so that they won't age, which sort of leaves you with the big subjects like death and love and sex and violence."
  },
  {
    "author": "Buddha",
    "category": "death",
    "id": 13281,
    "text": "To be idle is a short road to death and to be diligent is a way of life foolish people are idle, wise people are diligent."
  },
  {
    "author": "Isaac Bashevis Singer",
    "category": "death",
    "id": 13661,
    "text": "The very essence of literature is the war between emotion and intellect, between life and death. When literature becomes too intellectual - when it begins to ignore the passions, the emotions - it becomes sterile, silly, and actually without substance."
  },
  {
    "author": "Stendhal",
    "category": "death",
    "id": 13605,
    "text": "True love makes the thought of death frequent, easy, without terrors it merely becomes the standard of comparison, the price one would pay for many things."
  },
  {
    "author": "Alveda King",
    "category": "death",
    "id": 14211,
    "text": "People need jobs, people need happy and successful lives there should be marriage between one man and one woman, there should the value of person from conception until natural death."
  },
  {
    "author": "Pope Benedict XVI",
    "category": "death",
    "id": 13664,
    "text": "Not all moral issues have the same moral weight as abortion and euthanasia. There may be legitimate diversity of opinion even among Catholics about waging war and applying the death penalty, but not... with regard to abortion and euthanasia."
  },
  {
    "author": "Jose Ortega y Gasset",
    "category": "death",
    "id": 13746,
    "text": "An 'unemployed' existence is a worse negation of life than death itself."
  },
  {
    "author": "Voltaire",
    "category": "death",
    "id": 13453,
    "text": "The safest course is to do nothing against one's conscience. With this secret, we can enjoy life and have no fear from death."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "death",
    "id": 13569,
    "text": "Old age is a tyrant, who forbids, under pain of death, the pleasures of youth."
  },
  {
    "author": "Robert Smith",
    "category": "death",
    "id": 14225,
    "text": "I don't think of death in a romantic way anymore."
  },
  {
    "author": "Christopher Fry",
    "category": "death",
    "id": 14233,
    "text": "Between our birth and death we may touch understanding, As a moth brushes a window with its wing."
  },
  {
    "author": "Angela Davis",
    "category": "death",
    "id": 13901,
    "text": "Had it not been for slavery, the death penalty would have likely been abolished in America. Slavery became a haven for the death penalty."
  },
  {
    "author": "Nelson Mandela",
    "category": "death",
    "id": 13384,
    "text": "There is no easy walk to freedom anywhere, and many of us will have to pass through the valley of the shadow of death again and again before we reach the mountaintop of our desires."
  },
  {
    "author": "Rush Limbaugh",
    "category": "death",
    "id": 13604,
    "text": "The message that President Obama delivered in his speech at Notre Dame was: morality is immoral. Pro-life is the extremist position, not a moral position. Yet we should compromise and work to reduce abortions. Where's the compromise between life and death - and why work to reduce the number of them occurring if there's nothing wrong with them?"
  },
  {
    "author": "Anais Nin",
    "category": "death",
    "id": 13386,
    "text": "Life is a process of becoming, a combination of states we have to go through. Where people fail is that they wish to elect a state and remain in it. This is a kind of death."
  },
  {
    "author": "Taylor Caldwell",
    "category": "death",
    "id": 14151,
    "text": "Though I am a Catholic, a professing one, I have serious doubts about the survival of the human personality after death."
  },
  {
    "author": "Edna Ferber",
    "category": "death",
    "id": 13970,
    "text": "Life can't defeat a writer who is in love with writing, for life itself is a writer's lover until death."
  },
  {
    "author": "Emily Dickinson",
    "category": "death",
    "id": 13508,
    "text": "Love is anterior to life, posterior to death, initial of creation, and the exponent of breath."
  },
  {
    "author": "Pearl S. Buck",
    "category": "death",
    "id": 13803,
    "text": "Life without idealism is empty indeed. We just hope or starve to death."
  },
  {
    "author": "Fiona Shaw",
    "category": "death",
    "id": 14275,
    "text": "I'm not on the run from anything and I'm not at all clear about what I'm running towards. But as some great writer put it, I want to be certain that when I arrive at death, I'm totally exhausted."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "death",
    "id": 13544,
    "text": "There are, as is known, insects that die in the moment of fertilization. So it is with all joy: life's highest, most splendid moment of enjoyment is accompanied by death."
  },
  {
    "author": "Douglas Horton",
    "category": "death",
    "id": 14038,
    "text": "Death is feared as birth is forgotten."
  },
  {
    "author": "Johnny Cash",
    "category": "death",
    "id": 13597,
    "text": "My father was a man of love. He always loved me to death. He worked hard in the fields, but my father never hit me. Never. I don't ever remember a really cross, unkind word from my father."
  },
  {
    "author": "John Keats",
    "category": "death",
    "id": 13571,
    "text": "I have two luxuries to brood over in my walks, your loveliness and the hour of my death. O that I could have possession of them both in the same minute."
  },
  {
    "author": "Nicolas Chamfort",
    "category": "death",
    "id": 13923,
    "text": "Living is a sickness to which sleep provides relief every sixteen hours. It's a palliative. The remedy is death."
  },
  {
    "author": "Oliver Reed",
    "category": "death",
    "id": 13881,
    "text": "At the New York Athletic Club they serve amazing food. People go there, get healthy, and then eat themselves to death - which is, I suppose, the right way to do it."
  },
  {
    "author": "Jeff Goodell",
    "category": "death",
    "id": 14169,
    "text": "One of the big questions in the climate change debate: Are humans any smarter than frogs in a pot? If you put a frog in a pot and slowly turn up the heat, it won't jump out. Instead, it will enjoy the nice warm bath until it is cooked to death. We humans seem to be doing pretty much the same thing."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "death",
    "id": 14011,
    "text": "Lidia Bastianich, sorry, but kind of boring. I mean, I love Lidia, but you can fall asleep watching her. And Mario Batali? I love Mario to death... but he's not romantic or sensual. Those are the things I bring to the table."
  },
  {
    "author": "Rabindranath Tagore",
    "category": "death",
    "id": 13447,
    "text": "Death is not extinguishing the light it is only putting out the lamp because the dawn has come."
  },
  {
    "author": "Arlo Guthrie",
    "category": "death",
    "id": 13361,
    "text": "The death of what's dead is the birth of what's living."
  },
  {
    "author": "Stanislav Grof",
    "category": "death",
    "id": 14138,
    "text": "For any culture which is primarily concerned with meaning, the study of death - the only certainty that life holds for us - must be central, for an understanding of death is the key to liberation in life."
  },
  {
    "author": "Lord Byron",
    "category": "death",
    "id": 13545,
    "text": "Death, so called, is a thing which makes men weep, And yet a third of life is passed in sleep."
  },
  {
    "author": "John Elway",
    "category": "death",
    "id": 14207,
    "text": "I'm watching the Weather Channel more than I've ever watched it. I'm scared to death it's going to rain."
  },
  {
    "author": "Dave Barry",
    "category": "death",
    "id": 13697,
    "text": "The leading cause of death among fashion models is falling through street grates."
  },
  {
    "author": "Francis Bacon",
    "category": "death",
    "id": 13608,
    "text": "I do not believe that any man fears to be dead, but only the stroke of death."
  },
  {
    "author": "Tryon Edwards",
    "category": "death",
    "id": 14131,
    "text": "We weep over the graves of infants and the little ones taken from us by death but an early grave may be the shortest way to heaven."
  },
  {
    "author": "Eamon de Valera",
    "category": "death",
    "id": 14223,
    "text": "When we have done our best, we can, as a united people, take whatever may befall with calm courage and confidence that this old nation will survive and if death should come to many of us, death is not the end."
  },
  {
    "author": "Gloria Swanson",
    "category": "death",
    "id": 13885,
    "text": "Life and death. They are somehow sweetly and beautifully mixed, but I don't know how."
  },
  {
    "author": "Jim Morrison",
    "category": "death",
    "id": 13385,
    "text": "Death makes angels of us all and gives us wings where we had shoulders smooth as ravens claws."
  },
  {
    "author": "Curt Schilling",
    "category": "death",
    "id": 14044,
    "text": "Before I pitch any game, from spring training to Game 7 of the World Series, I'm scared to death."
  },
  {
    "author": "David Gerrold",
    "category": "death",
    "id": 13290,
    "text": "Life is hard. Then you die. Then they throw dirt in your face. Then the worms eat you. Be grateful it happens in that order."
  },
  {
    "author": "G. Gordon Liddy",
    "category": "death",
    "id": 14252,
    "text": "Defeat the fear of death and you welcome the death of fear."
  },
  {
    "author": "Alfred Russel Wallace",
    "category": "death",
    "id": 14006,
    "text": "In my solitude I have pondered much on the incomprehensible subjects of space, eternity, life and death."
  },
  {
    "author": "Edvard Munch",
    "category": "death",
    "id": 14167,
    "text": "Sickness, insanity and death were the angels that surrounded my cradle and they have followed me throughout my life."
  },
  {
    "author": "Wendell Berry",
    "category": "death",
    "id": 13929,
    "text": "It is a horrible fact that we can read in the daily paper, without interrupting our breakfast, numerical reckonings of death and destruction that ought to break our hearts or scare us out of our wits."
  },
  {
    "author": "Carter Burwell",
    "category": "death",
    "id": 13346,
    "text": "Death is always around the corner, but often our society gives it inordinate help."
  },
  {
    "author": "Suge Knight",
    "category": "death",
    "id": 14137,
    "text": "Of all the artists on Death Row, none of them went bankrupt."
  },
  {
    "author": "Deepak Chopra",
    "category": "death",
    "id": 13707,
    "text": "The fear of death comes from limited awareness."
  },
  {
    "author": "Anne Frank",
    "category": "death",
    "id": 13405,
    "text": "In spite of everything I still believe that people are really good at heart. I simply can't build up my hopes on a foundation consisting of confusion, misery and death."
  },
  {
    "author": "George Saunders",
    "category": "death",
    "id": 14041,
    "text": "If death is in the room, it's pretty interesting. But I would also say that I'm interested in getting myself to believe that it's going to happen to me. I'm interested in it, because if you're not, you're nuts. It's really de facto what we're here to find out about."
  },
  {
    "author": "John Keats",
    "category": "death",
    "id": 13573,
    "text": "Land and sea, weakness and decline are great separators, but death is the great divorcer for ever."
  },
  {
    "author": "Anna Akhmatova",
    "category": "death",
    "id": 13350,
    "text": "It was a time when only the dead smiled, happy in their peace."
  },
  {
    "author": "Manolo Blahnik",
    "category": "death",
    "id": 14240,
    "text": "I just don't get death at all. Yes, it's there. But I don't get it."
  },
  {
    "author": "Lawrence Ferlinghetti",
    "category": "death",
    "id": 13992,
    "text": "Constantly risking absurdity and death whenever he performs above the heads of his audience, the poet, like an acrobat, climbs on rhyme to a high wire of his own making."
  },
  {
    "author": "Sophocles",
    "category": "death",
    "id": 13691,
    "text": "Not even old age knows how to love death."
  },
  {
    "author": "Damien Hirst",
    "category": "death",
    "id": 14086,
    "text": "I was taught to confront things you can't avoid. Death is one of those things. To live in a society where you're trying not to look at it is stupid because looking at death throws us back into life with more vigour and energy. The fact that flowers don't last for ever makes them beautiful."
  },
  {
    "author": "Earl Wilson",
    "category": "death",
    "id": 13963,
    "text": "Courage is the art of being the only one who knows you're scared to death."
  },
  {
    "author": "Samuel Butler",
    "category": "death",
    "id": 13612,
    "text": "Death is only a larger kind of going abroad."
  },
  {
    "author": "Jack Kevorkian",
    "category": "death",
    "id": 14176,
    "text": "I will admit, like Socrates and Aristotle and Plato and some other philosophers, that there are instances where the death penalty would seem appropriate."
  },
  {
    "author": "Stanislav Grof",
    "category": "death",
    "id": 14145,
    "text": "Research challenges the materialistic understanding of death, according to which biological death represents the final end of existence and of all conscious activity."
  },
  {
    "author": "George Lincoln Rockwell",
    "category": "death",
    "id": 14016,
    "text": "We march and fight, to death or on to victory. Our might is right, no traitors shall prevail. Our hearts are steeled against the fiery gates of hell. No shot or shell, can still our mighty song."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "death",
    "id": 13552,
    "text": "On neither the sun, nor death, can a man look fixedly."
  },
  {
    "author": "Walt Whitman",
    "category": "death",
    "id": 13543,
    "text": "And I will show that nothing can happen more beautiful than death."
  },
  {
    "author": "Bernhard Langer",
    "category": "death",
    "id": 14088,
    "text": "It's not life or death it's a game and at the end of the game there is going to be a winner and a loser."
  },
  {
    "author": "Albert Camus",
    "category": "death",
    "id": 13446,
    "text": "We get into the habit of living before acquiring the habit of thinking. In that race which daily hastens us towards death, the body maintains its irreparable lead."
  },
  {
    "author": "Dwight L. Moody",
    "category": "death",
    "id": 13576,
    "text": "Death may be the King of terrors... but Jesus is the King of kings!"
  },
  {
    "author": "Chuck Palahniuk",
    "category": "death",
    "id": 13485,
    "text": "If death meant just leaving the stage long enough to change costume and come back as a new character, would you slow down? Or speed up?"
  },
  {
    "author": "Mark Twain",
    "category": "death",
    "id": 13376,
    "text": "Do the thing you fear most and the death of fear is certain."
  },
  {
    "author": "Henry Miller",
    "category": "death",
    "id": 13642,
    "text": "In the attempt to defeat death man has been inevitably obliged to defeat life, for the two are inextricably related. Life moves on to death, and to deny one is to deny the other."
  }
]

quotes['design'] = [
  {
    "author": "Michael Arad",
    "category": "design",
    "id": 14603,
    "text": "How do you design it so that people can form a space of their own, and feel quiet and contemplative?"
  },
  {
    "author": "Tadao Ando",
    "category": "design",
    "id": 14457,
    "text": "The level of detail and craft is something that's inscribed within the original design concept. And so when I begin to draw, I know what kind of detailing I want the building to have."
  },
  {
    "author": "Kate Moss",
    "category": "design",
    "id": 14389,
    "text": "I'm not really a fashion designer. I just love clothes. I've never been to design school. I can't sketch. I can't cut patterns and things. I can shorten things. I can make a dress out of a scarf."
  },
  {
    "author": "Harry Seidler",
    "category": "design",
    "id": 14319,
    "text": "Good design doesn't date."
  },
  {
    "author": "Michael Dell",
    "category": "design",
    "id": 14694,
    "text": "The interesting thing is when we design and architect a server, we don't design it for Windows or Linux, we design it for both. We don't really care, as long as we're selling the one the customer wants."
  },
  {
    "author": "Edward Tufte",
    "category": "design",
    "id": 14590,
    "text": "I do believe that there are some universal cognitive tasks that are deep and profound - indeed, so deep and profound that it is worthwhile to understand them in order to design our displays in accord with those tasks."
  },
  {
    "author": "Gabriel Basso",
    "category": "design",
    "id": 14722,
    "text": "I'm an artist. So if acting doesn't work out, which I hope it does, I'm probably going to go into graphic design or something like that."
  },
  {
    "author": "Jil Sander",
    "category": "design",
    "id": 14608,
    "text": "I think there is always a need for pure design. With pure design, you don't need so much decoration."
  },
  {
    "author": "Steve Madden",
    "category": "design",
    "id": 14686,
    "text": "My strengths as a businessman lie in the design and sale of women's shoes, and I have never been comfortable with complicated or technical legal or business documents."
  },
  {
    "author": "Jim Rohn",
    "category": "design",
    "id": 14338,
    "text": "Happiness is not something you postpone for the future it is something you design for the present."
  },
  {
    "author": "Marc Ostrofsky",
    "category": "design",
    "id": 14564,
    "text": "Traditional horizontal search engines cannot always identify the target audience, niche or vertical industry of a page or site. Vertical search engines address this issue by the nature of their design. They identify sites according to more specific criteria and sometimes even by human input."
  },
  {
    "author": "Vera Wang",
    "category": "design",
    "id": 14392,
    "text": "All those years of skating and dancing have carried over. I can't design anything without thinking of how a woman's body will look and move when she's wearing it."
  },
  {
    "author": "Barbara Kruger",
    "category": "design",
    "id": 14517,
    "text": "Although my art work was heavily informed by my design work on a formal and visual level, as regards meaning and content the two practices parted ways."
  },
  {
    "author": "Adam Ferguson",
    "category": "design",
    "id": 14699,
    "text": "Every step and every movement of the multitude, even in what are termed enlightened ages, are made with equal blindness to the future and nations stumble upon establishments, which are indeed the result of human action, but not the execution of any human design."
  },
  {
    "author": "Tadao Ando",
    "category": "design",
    "id": 14489,
    "text": "All those involved in the construction of an architectural design, from the architect to the builder, have an attachment to the architecture, although it's difficult to quantify the attachment."
  },
  {
    "author": "David Bromstad",
    "category": "design",
    "id": 14710,
    "text": "'Design Star' was incredible, and I didn't think it could get any better, and then 'Color Splash' happened."
  },
  {
    "author": "Brad Pitt",
    "category": "design",
    "id": 14447,
    "text": "I'm drawn to furniture design as complete architecture on a minor scale."
  },
  {
    "author": "Carlos Ghosn",
    "category": "design",
    "id": 14412,
    "text": "Design is important, it's an important dimension in the car. It's not the only one."
  },
  {
    "author": "John Anderson",
    "category": "design",
    "id": 14655,
    "text": "But my point is that you design something in the end that precludes any unhealthy trading practices that are not going to serve your environmental or your economic objectives but now is not the time to do it."
  },
  {
    "author": "Steve Wozniak",
    "category": "design",
    "id": 14494,
    "text": "It would be nice to design a real briefcase - you open it up and it's your computer but it also stores your books."
  },
  {
    "author": "Christy Turlington",
    "category": "design",
    "id": 14297,
    "text": "Sacred spaces can be created in any environment."
  },
  {
    "author": "Gianni Versace",
    "category": "design",
    "id": 14316,
    "text": "I like the body. I like to design everything to do with the body."
  },
  {
    "author": "Freeman Dyson",
    "category": "design",
    "id": 14354,
    "text": "A good scientist is a person with original ideas. A good engineer is a person who makes a design that works with as few original ideas as possible. There are no prima donnas in engineering."
  },
  {
    "author": "Jim Henson",
    "category": "design",
    "id": 14384,
    "text": "We thought it would be fun to try to design a show that would work well internationally and so that' s what we're intending to do with Fraggle Rock, and we are indeed now selling it around the world."
  },
  {
    "author": "Jeff Hawkins",
    "category": "design",
    "id": 14653,
    "text": "I do two things. I design mobile computers and I study brains."
  },
  {
    "author": "Issey Miyake",
    "category": "design",
    "id": 14308,
    "text": "Design is not for philosophy it's for life."
  },
  {
    "author": "Charles Stanley",
    "category": "design",
    "id": 14349,
    "text": "In giving us children, God places us in a position of both leadership and service. He calls us to give up our lives for someone else's sake - to abandon our own desires and put our child's interests first. Yet, according to His perfect design, it is through this selflessness that we can become truly fulfilled."
  },
  {
    "author": "Ed Westwick",
    "category": "design",
    "id": 14568,
    "text": "I think gardens are fantastic, and I'd love to draw and design and stuff like that. I love just planting flowers during the summer. There's something very humble about it, and natural and beautiful."
  },
  {
    "author": "Donald Wills Douglas",
    "category": "design",
    "id": 14697,
    "text": "When you design it, think how you would feel if you had to fly it! Safety first!"
  },
  {
    "author": "Jaron Lanier",
    "category": "design",
    "id": 14465,
    "text": "The wisdom of crowds works when the crowd is choosing the price of an ox, when there's a single numeric average. But if it's a design or something that matters, the decision is made by committee, and that's crap. You want people and groups who are able to think thoughts before they share."
  },
  {
    "author": "Jil Sander",
    "category": "design",
    "id": 14607,
    "text": "Initially, it was the unpractical in fashion that brought me to design my own line. I felt that it was much more attractive to cut clothes with respect for the living, three-dimensional body rather than to cover the body with decorative ideas."
  },
  {
    "author": "Charles Eames",
    "category": "design",
    "id": 14444,
    "text": "The details are not the details. They make the design."
  },
  {
    "author": "James Dyson",
    "category": "design",
    "id": 14438,
    "text": "I don't design down to a price."
  },
  {
    "author": "Steve Madden",
    "category": "design",
    "id": 14685,
    "text": "I could design an $800 shoe line it's easy. You use the best materials and you can make beautiful shoes. It's easier than making great shoes for $90."
  },
  {
    "author": "Tim Gunn",
    "category": "design",
    "id": 14516,
    "text": "With fashion, you really need to understand the aspects of construction. Not just design on an iPad."
  },
  {
    "author": "Liz Phair",
    "category": "design",
    "id": 14425,
    "text": "I mean, I think about it, but I don't design my record to get a certain public response."
  },
  {
    "author": "Mike McCready",
    "category": "design",
    "id": 14627,
    "text": "It was by design that we mostly used pictures that you could not necessarily see what was going on, and that didn't really focus in on the band, but instead focused in on a theme."
  },
  {
    "author": "Ellen DeGeneres",
    "category": "design",
    "id": 14362,
    "text": "Designing is my hobby. If I didn't do what I do for a living - at some point when I don't do this for a living - I'll probably just do design work. I love finding really special pieces of furniture."
  },
  {
    "author": "Rudy Giuliani",
    "category": "design",
    "id": 14469,
    "text": "There is no city in America that has reduced crime as much as we have in the last three years. This is not the product of accident. This is the product of design."
  },
  {
    "author": "Debi Thomas",
    "category": "design",
    "id": 14600,
    "text": "So I went for engineering, specifically product design, which I enjoyed."
  },
  {
    "author": "Robert Collier",
    "category": "design",
    "id": 14307,
    "text": "Every contrivance of man, every tool, every instrument, every utensil, every article designed for use, of each and every kind, evolved from a very simple beginnings."
  },
  {
    "author": "Douglas Trumbull",
    "category": "design",
    "id": 14666,
    "text": "My particular aesthetic of light and color and design wouldn't change as a result of working with computer graphics rather than with slit scan or miniatures."
  },
  {
    "author": "Peter Stuyvesant",
    "category": "design",
    "id": 14660,
    "text": "The design of those commissioners, frigates and warlike force is directed rather against Long Island and these your Honors' possessions, than to the imagined reform of New England."
  },
  {
    "author": "Donald Norman",
    "category": "design",
    "id": 14322,
    "text": "In my opinion, no single design is apt to be optimal for everyone."
  },
  {
    "author": "Harry Bertoia",
    "category": "design",
    "id": 14292,
    "text": "The urge for good design is the same as the urge to go on living."
  },
  {
    "author": "Dhani Harrison",
    "category": "design",
    "id": 14536,
    "text": "If you were the first person ever to design an application for the iPhone and you patented it, you would be very, very better off than we are right now, you know? But you've got to be the first one to do it. So I figured that Led Zeppelin or the Stones were going to do it unless we just got on to it. So I got cracking with the guys from Apple."
  },
  {
    "author": "Charles Foster Bass",
    "category": "design",
    "id": 14571,
    "text": "The United States government first learned of the diversion of the W-88 nuclear warhead design in late 1995."
  },
  {
    "author": "Fred Davis",
    "category": "design",
    "id": 14714,
    "text": "Whenever I design any variant, or when anybody sends me one, I always say if at all possible within the context of the game don't have two home supply centers touching each other."
  },
  {
    "author": "Ron Lewis",
    "category": "design",
    "id": 14541,
    "text": "We must carefully consider card security solutions, such as adding photographs or machine-readable electronic strips, so to prevent further breaches of individual privacy that could result from changes to the design of Social Security Cards."
  },
  {
    "author": "Edward Tufte",
    "category": "design",
    "id": 14589,
    "text": "Beautiful Evidence is about the theory and practice of analytical design."
  },
  {
    "author": "Michael Arad",
    "category": "design",
    "id": 14601,
    "text": "When I started this project, I was a young architect. I was very apprehensive about any changes to the design. Whether I wanted to or not, I learned that you can accept some changes to its form without compromising its intent. But it's a leap of faith that I didn't want to make initially - to put it mildly."
  },
  {
    "author": "Wally Lamb",
    "category": "design",
    "id": 14648,
    "text": "The roundness of life's design may be a sign that there is a presence beyond ourselves."
  },
  {
    "author": "Douglas Wilson",
    "category": "design",
    "id": 14585,
    "text": "Being in the design industry, I've tended to meet more people who are affected by HIV and AIDS."
  },
  {
    "author": "Mike Davidson",
    "category": "design",
    "id": 14330,
    "text": "I don't start with a design objective, I start with a communication objective. I feel my project is successful if it communicates what it is supposed to communicate."
  },
  {
    "author": "Dhani Harrison",
    "category": "design",
    "id": 14535,
    "text": "Websites are kind of useless. There's so much great web content and design out there, but the ways in which they are being experienced are not being maximized."
  },
  {
    "author": "James Dyson",
    "category": "design",
    "id": 14442,
    "text": "Design and technology should be the subject where mathematical brainboxes and science whizzkids turn their bright ideas into useful products."
  },
  {
    "author": "Adolf Galland",
    "category": "design",
    "id": 14591,
    "text": "I would like to mention that I have flown the 262 first in May '43. At this time, the aircraft was completely secret. I first knew of the existence of this aircraft only early in '42 - even in my position. This aircraft didn't have any priority in design or production."
  },
  {
    "author": "Jamie Dimon",
    "category": "design",
    "id": 14563,
    "text": "You can design a mortgage system that is different without a Fannie and Freddie, but there are principles you have to have, to have a good system."
  },
  {
    "author": "John Redwood",
    "category": "design",
    "id": 14628,
    "text": "There is not necessarily a good reason why a regulator should have to be involved in product design and marketing for rich and sophisticated investors. We recommend that such investors should be able to sign a piece of paper, which allows them to go ahead and buy unregulated products at their own risk."
  },
  {
    "author": "Don Bluth",
    "category": "design",
    "id": 14520,
    "text": "I have never seen a game's graphics look so sharp and clean. The sound design for the game is also unique on the Xbox. The memory on this system allowed us to provide the user with 5.1 Dolby surround sound for home theatre owners."
  },
  {
    "author": "Calvin Klein",
    "category": "design",
    "id": 14396,
    "text": "People who run a ready-to-wear company are businessmen rather than production or design people."
  },
  {
    "author": "John Adams",
    "category": "design",
    "id": 14352,
    "text": "I always consider the settlement of America with reverence and wonder, as the opening of a grand scene and design in providence, for the illumination of the ignorant and the emancipation of the slavish part of mankind all over the earth."
  },
  {
    "author": "Paul Rand",
    "category": "design",
    "id": 14287,
    "text": "Design is the method of putting form and content together. Design, just as art, has multiple definitions there is no single definition. Design can be art. Design can be aesthetics. Design is so simple, that's why it is so complicated."
  },
  {
    "author": "Jaron Lanier",
    "category": "design",
    "id": 14466,
    "text": "The basic problem is that web 2.0 tools are not supportive of democracy by design. They are tools designed to gather spy-agency-like data in a seductive way, first and foremost, but as a side effect they tend to provide software support for mob-like phenomena."
  },
  {
    "author": "Drew Barrymore",
    "category": "design",
    "id": 14377,
    "text": "I'm a total control freak and love to participate in the design of every single aspect of life."
  },
  {
    "author": "Martin Fleischmann",
    "category": "design",
    "id": 14615,
    "text": "I have had this view of the optimization of the electrode design for a long time. Historically we went through various phases in the work and eventually worked on large sheets - very large sheets - of palladium."
  },
  {
    "author": "Stephen Gardiner",
    "category": "design",
    "id": 14303,
    "text": "Good buildings come from good people, ad all problems are solved by good design."
  },
  {
    "author": "Charles J. Givens",
    "category": "design",
    "id": 14312,
    "text": "To design the future effectively, you must first let go of your past."
  },
  {
    "author": "Jason Reitman",
    "category": "design",
    "id": 14418,
    "text": "Can you design a Rorschach test that's going to make everyone feel something every time - and that looks like a Rorschach test? It's easy to show a picture of a kitten or a car accident. The question is, how abstract can you get and still get the audience to feel something when they don't know what's happening to them?"
  },
  {
    "author": "Norm Dicks",
    "category": "design",
    "id": 14629,
    "text": "Last year, Congress gave the Department of Defense the authority to design a new civilian personnel system for its employees as part of the defense authorization bill."
  },
  {
    "author": "Valentino Garavani",
    "category": "design",
    "id": 14497,
    "text": "I am always locked in my design studio."
  },
  {
    "author": "Geoffrey Beene",
    "category": "design",
    "id": 14332,
    "text": "Design is an unknown."
  },
  {
    "author": "Mikhail Kalashnikov",
    "category": "design",
    "id": 14387,
    "text": "I tried a dozen different modifications that were rejected. But they all served as a path to the final design."
  },
  {
    "author": "Robert Shea",
    "category": "design",
    "id": 14558,
    "text": "Just as predatory animals follow a similar general design and behave in similar ways, so organizations, especially those in competition with one another, must follow certain design principles if they are to succeed and prevail."
  },
  {
    "author": "Tony Campolo",
    "category": "design",
    "id": 14401,
    "text": "While a case can be made for intelligent design, I can't figure out why some Christians are so thrilled about that possibility. First of all, it doesn't prove there's a God. If anything, intelligent design lends support to some form of pantheism that defines God as immanent within nature."
  },
  {
    "author": "Genevieve Gorder",
    "category": "design",
    "id": 14324,
    "text": "So, to really execute design in its highest form and making people feel joy, that's a great reward."
  },
  {
    "author": "Stephen Gardiner",
    "category": "design",
    "id": 14487,
    "text": "French architecture always manages to combine the most magnificent underlying themes of architecture like Roman design, it looks to the community."
  },
  {
    "author": "Niklaus Wirth",
    "category": "design",
    "id": 14314,
    "text": "A good designer must rely on experience, on precise, logic thinking and on pedantic exactness. No magic will do."
  },
  {
    "author": "Charles Eames",
    "category": "design",
    "id": 14443,
    "text": "Design is a plan for arranging elements in such a way as best to accomplish a particular purpose."
  },
  {
    "author": "Fergie",
    "category": "design",
    "id": 14460,
    "text": "Luckily I don't have to buy shoes anymore, because I design them! I'm off tour, so I can dive in and create the shoes that I want for my line. But okay, I did buy a pair of vintage combat boots because they were so beaten up - I had to have them."
  },
  {
    "author": "Yukihiro Matsumoto",
    "category": "design",
    "id": 14670,
    "text": "Actually, I didn't make the claim that Ruby follows the principle of least surprise. Someone felt the design of Ruby follows that philosophy, so they started saying that. I didn't bring that up, actually."
  },
  {
    "author": "Donna Karan",
    "category": "design",
    "id": 14490,
    "text": "Design is a constant challenge to balance comfort with luxe, the practical with the desirable."
  },
  {
    "author": "Len Wein",
    "category": "design",
    "id": 14436,
    "text": "I became an art major, took every art class my school had to offer. In college, I majored in Advertising Art and Design."
  },
  {
    "author": "Ayumi Hamasaki",
    "category": "design",
    "id": 14635,
    "text": "I don't set goals. Like, that's what I want to be doing however many years from now. I do what I love to do at the moment. If I wake up tomorrow and decide I want to dance, that's what I'd do. Or design clothes."
  },
  {
    "author": "Brad Pitt",
    "category": "design",
    "id": 14446,
    "text": "I'd like to design something like a city or a museum. I want to do something hands on rather than just play golf which is the sport of the religious right."
  },
  {
    "author": "Joe Jonas",
    "category": "design",
    "id": 14519,
    "text": "I had a faux-hawk for a while and I used to buzz the sides and design it. It was really bad."
  },
  {
    "author": "Marc Newson",
    "category": "design",
    "id": 14533,
    "text": "So if I want to buy a light in a shop and I don't find a light that I like, I think to myself what would I like? What would I like to buy? Then I started to imagine and design it for myself a lot of the time."
  },
  {
    "author": "Diana Ross",
    "category": "design",
    "id": 14481,
    "text": "I majored in fashion design in school, and I have always wanted to design my own line of clothing, jewelry, and stuff like that so this was just a step for me in that direction."
  },
  {
    "author": "Caroline Wozniacki",
    "category": "design",
    "id": 14478,
    "text": "I'd like to do a lot of things - whether in design or architecture or business."
  },
  {
    "author": "Les Brown",
    "category": "design",
    "id": 14366,
    "text": "We must look for ways to be an active force in our own lives. We must take charge of our own destinies, design a life of substance and truly begin to live our dreams."
  },
  {
    "author": "David Brainerd",
    "category": "design",
    "id": 14521,
    "text": "I have a secret thought from some things I have observed, that God may perhaps design you for some singular service in the world."
  },
  {
    "author": "John Romero",
    "category": "design",
    "id": 14641,
    "text": "You have to design and program differently. Combat action in an MMO is so different to combat in a first-person shooter."
  },
  {
    "author": "B. F. Skinner",
    "category": "design",
    "id": 14359,
    "text": "I did not direct my life. I didn't design it. I never made decisions. Things always came up and made them for me. That's what life is."
  },
  {
    "author": "Donald Norman",
    "category": "design",
    "id": 14544,
    "text": "It is relatively easy to design for the perfect cases, when everything goes right, or when all the information required is available in proper format."
  },
  {
    "author": "Steve Wozniak",
    "category": "design",
    "id": 14495,
    "text": "If I designed a computer with 200 chips, I tried to design it with 150. And then I would try to design it with 100. I just tried to find every trick I could in life to design things real tiny."
  },
  {
    "author": "Charles Foster Bass",
    "category": "design",
    "id": 14570,
    "text": "In its report, the Cox Committee concludes that China is using stolen U.S. design information to speed up its deployment of a new nuclear missile force."
  },
  {
    "author": "Roberto Cavalli",
    "category": "design",
    "id": 14435,
    "text": "Leopard is an animal design, and my designs come from nature."
  },
  {
    "author": "Ai Weiwei",
    "category": "design",
    "id": 14473,
    "text": "Everyone wants an iPhone, but it would be impossible to design an iPhone in China because it's not a product it's an understanding of human nature."
  },
  {
    "author": "Marc Jacobs",
    "category": "design",
    "id": 14426,
    "text": "Marc Jacobs is full of creative people and Louis Vuitton is again a name on the door, a name that has existed for many years but I'm a collaborator there and I bring in other people, other artists and I work with a great creative design team."
  },
  {
    "author": "Camille Paglia",
    "category": "design",
    "id": 14385,
    "text": "Over the past 20 years, I have noticed that the most flexible, dynamic, inquisitive minds among my students have been industrial design majors. Industrial designers are bracingly free of ideology and cant. The industrial designer is trained to be a clear-eyed observer of the commercial world - which, like it or not, is modern reality."
  }
]

quotes['diet'] = [
  {
    "author": "Mike Moreno",
    "category": "diet",
    "id": 14980,
    "text": "'The 17 Day Diet' keeps your body and metabolism guessing. I call this 'body confusion.'"
  },
  {
    "author": "Halle Berry",
    "category": "diet",
    "id": 14832,
    "text": "I always had to diet. I'm diabetic, so it's a lifestyle for me anyway just to stay healthy and not end up in the hospital."
  },
  {
    "author": "William Banting",
    "category": "diet",
    "id": 14780,
    "text": "I am now in that happy comfortable state that I do not hesitate to indulge in any fancy in regard to diet, but watch the consequences, and do not continue any course which adds to weight or bulk and consequent discomfort."
  },
  {
    "author": "Rebecca Romijn",
    "category": "diet",
    "id": 14909,
    "text": "Breastfeeding is the very best diet I've been on."
  },
  {
    "author": "Mae West",
    "category": "diet",
    "id": 14725,
    "text": "I never worry about diets. The only carrots that interest me are the number you get in a diamond."
  },
  {
    "author": "Arthur Baer",
    "category": "diet",
    "id": 14954,
    "text": "She used to diet on any kind of food she could lay her hands on."
  },
  {
    "author": "Brett Hoebel",
    "category": "diet",
    "id": 14976,
    "text": "If I could give one tip for people - it's not an exercise or nutrition regimen. It's to walk your talk and believe in yourself, because at the end of the day, the dumbbell and diet don't get you in shape. It's your accountability to your word."
  },
  {
    "author": "Gina Gershon",
    "category": "diet",
    "id": 14771,
    "text": "Feeding is a very important ritual for me. I don't trust people who don't like to eat."
  },
  {
    "author": "Lisa Edelstein",
    "category": "diet",
    "id": 14916,
    "text": "If you eat a lot of starchy foods, introduce a vegetable once a week, then twice a week, and then three times a week. Slowly fill your diet with new flavors. By the time you're ready to let go of whatever it is you want to let go of, you've got a full menu."
  },
  {
    "author": "Morgan Spurlock",
    "category": "diet",
    "id": 14867,
    "text": "I was starting to become impotent through this diet and couldn't perform. How many people who are taking the little blue pill, if they started to change what they are eating most of the time, could change the way their sex life is?"
  },
  {
    "author": "Alison Sweeney",
    "category": "diet",
    "id": 14840,
    "text": "Our pets rely on us entirely for their nutrition. So if you're making your own judgments, that could lead to a mistake. At the same time, we have more control over our pet's diet than we do with our children or with ourselves, so your vet can tell you what is appropriate for your dog and you can assign them that."
  },
  {
    "author": "Jonathan Swift",
    "category": "diet",
    "id": 14798,
    "text": "The best doctors in the world are Doctor Diet, Doctor Quiet, and Doctor Merryman."
  },
  {
    "author": "Gene Tierney",
    "category": "diet",
    "id": 14749,
    "text": "I followed the same diet for 20 years, eliminating starches, living on salads, lean meat, and small portions."
  },
  {
    "author": "Oliver Reed",
    "category": "diet",
    "id": 14804,
    "text": "I'm only drinking white wine because I'm on a diet and I don't eat."
  },
  {
    "author": "Sean Astin",
    "category": "diet",
    "id": 14948,
    "text": "My diet is always terrible, unfortunately. I don't know moderation."
  },
  {
    "author": "Robert Atkins",
    "category": "diet",
    "id": 14928,
    "text": "Fruit is definitely on the maintenance diet. It's on the lifestyle diet."
  },
  {
    "author": "Robert Atkins",
    "category": "diet",
    "id": 14933,
    "text": "You take the healthiest diet in the world, if you gave those people vitamins, they would be twice as healthy. So vitamins are valuable."
  },
  {
    "author": "Rachael Ray",
    "category": "diet",
    "id": 14851,
    "text": "I've never been a huge sweets eater, and I've always loved a Mediterranean diet. We eat a lot of dark leafy greens, and a couple meals each week are meat-free. We enjoy eating a balanced diet."
  },
  {
    "author": "Lily Aldridge",
    "category": "diet",
    "id": 14967,
    "text": "I'm eating a lot of organic proteins and vegetables! Maintaining a healthy, balanced diet is my No. 1 priority because I'm nursing my daughter."
  },
  {
    "author": "Roger Moore",
    "category": "diet",
    "id": 14846,
    "text": "Sometimes I've had to put myself on a diet."
  },
  {
    "author": "Lana Del Rey",
    "category": "diet",
    "id": 14925,
    "text": "In New York I pretty much live in diners - I order French Fries, Diet Coke floats and lots of coffee."
  },
  {
    "author": "Arsene Wenger",
    "category": "diet",
    "id": 14860,
    "text": "Their diet is basically boiled vegetables, fish and rice. No fat, no sugar. You notice when you live there that there are no fat people."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "diet",
    "id": 14787,
    "text": "Bodybuilding is much like any other sport. To be successful, you must dedicate yourself 100% to your training, diet and mental approach."
  },
  {
    "author": "Mark Hyman",
    "category": "diet",
    "id": 14892,
    "text": "You can't exercise your way out of a bad diet."
  },
  {
    "author": "Fritz Sauckel",
    "category": "diet",
    "id": 14902,
    "text": "The Diet was dissolved by a Reich Government decree."
  },
  {
    "author": "Ingrid Newkirk",
    "category": "diet",
    "id": 14887,
    "text": "Perhaps one of the most important things you can do for human beings is wean them off an animal-based diet. It hardens the arteries and runs up our health-care costs. The last thing a poor person can afford is a heart attack or cancer or a stroke. And that's all linked to a meat-based diet. I think animal liberation is human liberation."
  },
  {
    "author": "Joey Lauren Adams",
    "category": "diet",
    "id": 14946,
    "text": "A bonus: You don't have to diet to direct."
  },
  {
    "author": "Brooke Burke",
    "category": "diet",
    "id": 14859,
    "text": "I've tried just about every crazy diet you can imagine."
  },
  {
    "author": "Elizabeth Hurley",
    "category": "diet",
    "id": 14868,
    "text": "Getting as much sleep as possible and following a healthy diet will stop you from feeling run-down if, like me, you're super-stressed."
  },
  {
    "author": "Bill Toomey",
    "category": "diet",
    "id": 14754,
    "text": "As I mentioned previously, the tools that allow for optimum health are diet and exercise."
  },
  {
    "author": "Bear Grylls",
    "category": "diet",
    "id": 14849,
    "text": "As for my diet, I try to eat lean, clean and healthy - nothing too surprising. And I avoid too much meat or dairy because they slow you down."
  },
  {
    "author": "Carol Vorderman",
    "category": "diet",
    "id": 14866,
    "text": "The first couple of days on the detox diet aren't pleasant."
  },
  {
    "author": "Mariah Carey",
    "category": "diet",
    "id": 14841,
    "text": "Since having the babies, I realize that 90 percent of losing weight is my diet."
  },
  {
    "author": "Alanis Morissette",
    "category": "diet",
    "id": 14791,
    "text": "I still indulge in a glass of wine or chocolate - treats are mandatory. Without deviating from the day-to-day healthy diet once in a while, it wouldn't be sustainable for me, and that's what I wanted: an approach to eating to last my entire life."
  },
  {
    "author": "Lev Grossman",
    "category": "diet",
    "id": 14856,
    "text": "I've drunk Amazon's free Diet Coke. Nothing makes more sense to me than a company trying to make bookselling into a profitable business. I'm not anti-Amazon, and I'm not pro-publishers either. I'm pro-books."
  },
  {
    "author": "A. J. Jacobs",
    "category": "diet",
    "id": 14966,
    "text": "My goal? To test out every diet and exercise regimen on planet earth and figure out which work best. I sweated, I cooked, I learned to pole dance. In the end, I lost weight, lowered my cholesterol and doubled my energy level. I feel better than I ever have."
  },
  {
    "author": "Fran Drescher",
    "category": "diet",
    "id": 14769,
    "text": "I have been dairy free for several years, and I started because I felt it was going to reduce my allergies, which it did, and help me lose weight, which it did."
  },
  {
    "author": "Alanis Morissette",
    "category": "diet",
    "id": 14801,
    "text": "For four to six months at a time, I would barely eat. I lived on a diet of Melba toast, carrots, and black coffee."
  },
  {
    "author": "Molly Sims",
    "category": "diet",
    "id": 14935,
    "text": "I think I've done every crazy diet there was in the beginning, but it's weird: I'm thinner now than I was when I was modeling. I don't obsess about it."
  },
  {
    "author": "David Suzuki",
    "category": "diet",
    "id": 14808,
    "text": "The medical literature tells us that the most effective ways to reduce the risk of heart disease, cancer, stroke, diabetes, Alzheimer's, and many more problems are through healthy diet and exercise. Our bodies have evolved to move, yet we now use the energy in oil instead of muscles to do our work."
  },
  {
    "author": "Kathy Freston",
    "category": "diet",
    "id": 14942,
    "text": "Though I'm vegan and advocate that others eat a plant-based diet, I know that many people aren't quite ready to take that step in whole."
  },
  {
    "author": "Samuel Hoffenstein",
    "category": "diet",
    "id": 14982,
    "text": "My soul is dark with stormy riot: directly traced over to diet."
  },
  {
    "author": "Katie Holmes",
    "category": "diet",
    "id": 14927,
    "text": "I'm not strictly vegetarian, but meat doesn't play a big part in my diet."
  },
  {
    "author": "Eva Herzigova",
    "category": "diet",
    "id": 14765,
    "text": "I'm lucky, I don't like sweets, not even chocolate."
  },
  {
    "author": "Paul Walker",
    "category": "diet",
    "id": 14879,
    "text": "My mom was always really healthy and cautious about her diet, so I'm not a big sugar guy."
  },
  {
    "author": "Emilie de Ravin",
    "category": "diet",
    "id": 14973,
    "text": "Love is such an objective thing. I mean, I can say I love my family, or I love my Diet Coke. So I guess, in different ways, yeah, I do believe in love."
  },
  {
    "author": "Lisa Snowdon",
    "category": "diet",
    "id": 14952,
    "text": "Sex keeps me in shape. I don't diet, I eat what I like. I love Mars bars and I smoke and drink. But I love running off in the middle of the day to make love. It really burns up calories."
  },
  {
    "author": "Ben Harper",
    "category": "diet",
    "id": 14874,
    "text": "I grew up with a heavy diet of gospel, folk, and blues because those are kind of the cornerstones of traditional American music."
  },
  {
    "author": "Jim Davis",
    "category": "diet",
    "id": 14726,
    "text": "Vegetables are a must on a diet. I suggest carrot cake, zucchini bread, and pumpkin pie."
  },
  {
    "author": "Jennifer Ellison",
    "category": "diet",
    "id": 14908,
    "text": "I don't do faddy diets any more. I once did a no-carbs diet a few years ago but it made me depressed. I couldn't be doing with that!"
  },
  {
    "author": "Paula Deen",
    "category": "diet",
    "id": 14817,
    "text": "You don't want to make a steady diet of just lettuce. You don't want to make a steady diet of fried chicken."
  },
  {
    "author": "Barbara Cartland",
    "category": "diet",
    "id": 14943,
    "text": "The right diet directs sexual energy into the parts that matter."
  },
  {
    "author": "Pierre Dukan",
    "category": "diet",
    "id": 14950,
    "text": "When followed correctly, the Dukan Diet is both a safe and effective method of weight loss."
  },
  {
    "author": "Mark Bittman",
    "category": "diet",
    "id": 14970,
    "text": "Let me pose you a question. Can farm-raised salmon be organic when its feed has nothing to do with its natural diet, even if the feed itself is supposedly organic, and the fish themselves are packed tightly in pens, swimming in their own filth?"
  },
  {
    "author": "Fran Lebowitz",
    "category": "diet",
    "id": 14788,
    "text": "Food is an important part of a balanced diet."
  },
  {
    "author": "Lindsey Shaw",
    "category": "diet",
    "id": 14971,
    "text": "I am involved in Greenpeace. And I just recently completely switched my diet over to near-veganism. So you try to do little things that you can. I recycle every single day. Every single thing in my house that can be recycled is."
  },
  {
    "author": "Mindy Kaling",
    "category": "diet",
    "id": 14819,
    "text": "We always think of a diet with a big groan. But I think diets are fun. I think it is an American pastime for a lot of women."
  },
  {
    "author": "Daniel D. Palmer",
    "category": "diet",
    "id": 14961,
    "text": "The best physicians are Dr. Diet, Dr. Quiet, and Dr. Merryman."
  },
  {
    "author": "Tori Spelling",
    "category": "diet",
    "id": 14848,
    "text": "I would eat healthy at times and pig out at times. But I never had to go on a strict diet plan."
  },
  {
    "author": "Jim Talent",
    "category": "diet",
    "id": 14761,
    "text": "Each of us should take personal responsibility for our diet, and our children's diet, and the government's role should be to make certain it provides the best information possible to help people stay healthy."
  },
  {
    "author": "Renee Olstead",
    "category": "diet",
    "id": 14974,
    "text": "The more I read and watched about the meat industry, the more determined I became to keep meat out of my diet. The things I saw in slaughterhouse exposes made me feel sick and I refused to just ignore what I now knew."
  },
  {
    "author": "Katherine Jenkins",
    "category": "diet",
    "id": 14829,
    "text": "I am fussy, about my diet and straining my voice. I know, sounds a bit over the top. But I'm not as bad as I used to be. These days I don't drink alcohol for five days before a show - very dehydrating for the vocal cords, and all that acid reflux. I used to ban it for a fortnight. Nightmare."
  },
  {
    "author": "Sophie Ellis Bextor",
    "category": "diet",
    "id": 14760,
    "text": "I used to be hung up on my figure, but it's a waste of time. I don't believe in diets. Have four pints one night, be healthy the next."
  },
  {
    "author": "Fritz Sauckel",
    "category": "diet",
    "id": 14900,
    "text": "I was elected to the Diet in the same way as at every parliamentary election."
  },
  {
    "author": "Mark E. Hyman",
    "category": "diet",
    "id": 14955,
    "text": "While pimples are not as simple as too much milk or sugar in your diet, both have a significant impact. Nutritional deficiencies as well as excesses can worsen acne."
  },
  {
    "author": "Joan Collins",
    "category": "diet",
    "id": 14752,
    "text": "I don't believe in dieting."
  },
  {
    "author": "Salma Hayek",
    "category": "diet",
    "id": 14793,
    "text": "If I go on a diet and work out, I'm always in a bad mood. I'd rather be a little heavier but nice."
  },
  {
    "author": "Calvin Trillin",
    "category": "diet",
    "id": 14736,
    "text": "Health food makes me sick."
  },
  {
    "author": "Bobby Flay",
    "category": "diet",
    "id": 14837,
    "text": "I can't be on the cheeseburger diet all the time."
  },
  {
    "author": "Rube Goldberg",
    "category": "diet",
    "id": 14962,
    "text": "Uh, I just had an operation last March which was rather serious and I'm recuperating now. I'm on a very bland diet. But, uh, I'm lucky, I was just lucky, that's all."
  },
  {
    "author": "Gro Harlem Brundtland",
    "category": "diet",
    "id": 14763,
    "text": "A safe and nutritionally adequate diet is a basic individual right and an essential condition for sustainable development, especially in developing countries."
  },
  {
    "author": "Tony Parsons",
    "category": "diet",
    "id": 14896,
    "text": "I box for four hours a week and my diet is pretty healthy."
  },
  {
    "author": "Bruce Barton",
    "category": "diet",
    "id": 14744,
    "text": "Cereal eating is almost a marker for a healthy lifestyle. It sets you up for the day, so you don't overeat."
  },
  {
    "author": "Michelle Obama",
    "category": "diet",
    "id": 14730,
    "text": "And let's be clear: It's not enough just to limit ads for foods that aren't healthy. It's also going to be critical to increase marketing for foods that are healthy."
  },
  {
    "author": "Josh Hutcherson",
    "category": "diet",
    "id": 14812,
    "text": "I put on fifteen pounds of muscle, so that was a lot of eating chicken and a high protein, low-carb diet. Also a lot of heavy lifting and a very different kind of training with an ex-navy SEAL guy who wanted to kill me every time I got with him. In a good way."
  },
  {
    "author": "George Wendt",
    "category": "diet",
    "id": 14978,
    "text": "I dream about 'Cheers.' Like when you go on a diet and you dream of pizza. I always think of those wonderful years. I loved working on it."
  },
  {
    "author": "Suzanne Somers",
    "category": "diet",
    "id": 14767,
    "text": "I started dieting. I dieted, dieted, dieted and tried all the diets and I would lose and then I would go back to normal eating and would put it on and then some."
  },
  {
    "author": "Hank Stram",
    "category": "diet",
    "id": 14782,
    "text": "You can't be fat and fast, too so lift, run, diet and work."
  },
  {
    "author": "Jim Goad",
    "category": "diet",
    "id": 14975,
    "text": "The vegan diet is obviously lacking whatever essential nutrient it is that makes people likeable."
  },
  {
    "author": "Della Reese",
    "category": "diet",
    "id": 14918,
    "text": "My doctor explained that exercise and diet changes might help and that I also might need a medication."
  },
  {
    "author": "Jennifer Ellison",
    "category": "diet",
    "id": 14907,
    "text": "I don't find it a struggle to maintain a healthy diet now as my palate has changed. I don't crave rich food."
  },
  {
    "author": "Erma Bombeck",
    "category": "diet",
    "id": 14785,
    "text": "A friend doesn't go on a diet because you are fat."
  },
  {
    "author": "Mike Ditka",
    "category": "diet",
    "id": 14739,
    "text": "So, when it comes to eating healthy, it's just doing the right thing. And it's not something you have to do 365 days a year, but I think it's something you have to do 25 days a month. Let's put it that way."
  },
  {
    "author": "Mark E. Hyman",
    "category": "diet",
    "id": 14956,
    "text": "Our typical Western diet is full of inflammatory fats - saturated fats, trans fats, too many omega-6, inflammatory, processed vegetable oils like soy and corn oils. These increase IGF-1 and stimulate pimple follicles."
  },
  {
    "author": "Linford Christie",
    "category": "diet",
    "id": 14729,
    "text": "Adopting a new healthier lifestyle can involve changing diet to include more fresh fruit and vegetables as well as increasing levels of exercise."
  },
  {
    "author": "Nick Carter",
    "category": "diet",
    "id": 14934,
    "text": "I freak out if I go a little too long without being in the gym. For a long time it was all about getting the weight off because I was 240 pounds at my heaviest, and now I'm around 175, so the majority of that weight loss was due to diet and exercise."
  },
  {
    "author": "Maimonides",
    "category": "diet",
    "id": 14728,
    "text": "No disease that can be treated by diet should be treated with any other means."
  },
  {
    "author": "Alton Brown",
    "category": "diet",
    "id": 14826,
    "text": "A balanced diet may be the best medicine. I was eating too much good eats. But people consider that part of your job, you know? Eat. And I do!"
  },
  {
    "author": "Michelle Forbes",
    "category": "diet",
    "id": 14944,
    "text": "I thought a vegan diet would be too difficult, being on the road so much, but it's been far easier than I thought."
  },
  {
    "author": "Kenneth H. Cooper",
    "category": "diet",
    "id": 14735,
    "text": "There are six components of wellness: proper weight and diet, proper exercise, breaking the smoking habit, control of alcohol, stress management and periodic exams."
  },
  {
    "author": "Joel Robuchon",
    "category": "diet",
    "id": 14922,
    "text": "I've never followed a vegan or vegetarian diet in the past, but I think I could do it. It would not be easy. I have worked with nutritionists who have said a vegan diet is not necessarily all positive for your health, because you need nutrients you only find in meats. I believe in a balanced diet."
  },
  {
    "author": "Jennie Garth",
    "category": "diet",
    "id": 14897,
    "text": "My biggest regret is putting my body through fad diets - Atkins, cleanses, the hCG diet."
  },
  {
    "author": "Mike Huckabee",
    "category": "diet",
    "id": 14854,
    "text": "I did every diet: Atkins. Cabbage-soup diet. Dean Ornish. But I couldn't live the rest of my life like a rabbit."
  },
  {
    "author": "Patti Stanger",
    "category": "diet",
    "id": 14843,
    "text": "I had to find a diet that would kick me back into dating shape, because I know that I can't date at size 8. I have to date at size 2. And it's just a fact of nature. Go get your injections and your chemical peels. You gotta look good to attract a man."
  },
  {
    "author": "Steve Burton",
    "category": "diet",
    "id": 14939,
    "text": "We have the opportunity to provide the first FDA reviewed and approved over-the-counter option that can help people lose weight and make changes to their lifestyle and diet."
  },
  {
    "author": "Cat Cora",
    "category": "diet",
    "id": 14831,
    "text": "Right now I'd love to be sitting on a Greek island somewhere because of being Greek American, eating great octopus salad and some fantastic lamb. Or sipping a little ouzo. I think the Mediterranean diet is one of the healthiest... Lots of nuts, vegetables, fruits, fresh fish, lean meats, yogurt."
  },
  {
    "author": "Gwen Stefani",
    "category": "diet",
    "id": 14825,
    "text": "I try not to be but I'm super-neurotic about diet. I'm neurotic about trying not to be neurotic! I'm like every other girl. I have to try really hard my whole life to try to be fit. And I'm super-vain. And I want to wear cute clothes."
  },
  {
    "author": "Leona Lewis",
    "category": "diet",
    "id": 14839,
    "text": "I try not to diet because it never really works for me, if I tell myself I can't eat something then I tend to want to eat everything in sight."
  },
  {
    "author": "Chris Noth",
    "category": "diet",
    "id": 14923,
    "text": "We talk about, you know, diet and that we shouldn't give our kids big things and obesity and fast food. Well, you know there are people who don't have that problem because they're not getting any food! We have so many deep problems and issues facing humanity."
  },
  {
    "author": "Ron White",
    "category": "diet",
    "id": 14789,
    "text": "There were years when I was a beer and tequila guy, then I got real fat. And then I found that you could actually go on a diet and drink scotch. Then I got hooked on scotch, and if you get hooked on scotch, then everything else just tastes wrong."
  }
]

quotes['dreams'] = [
  {
    "author": "Mitt Romney",
    "category": "dreams",
    "id": 15125,
    "text": "Business and growing jobs is about taking risk, sometimes failing, sometimes succeeding, but always striving. It is about dreams. Usually, it doesn't work out exactly as you might have imagined. Steve Jobs was fired at Apple. He came back and changed the world."
  },
  {
    "author": "Alice Englert",
    "category": "dreams",
    "id": 15515,
    "text": "What's interesting is, for myself, when I become really attracted to somebody, I find them in my dreams... conversations, nothing more."
  },
  {
    "author": "Jean Paul Gaultier",
    "category": "dreams",
    "id": 15331,
    "text": "I don't like dreams or reality. I like when dreams become reality because that is my life."
  },
  {
    "author": "Lenny Kravitz",
    "category": "dreams",
    "id": 15293,
    "text": "I've woken up from dreams and the whole song is there. I'm listening to it in my dreams. I consciously have to wake myself up and get a tape recorder because I hear it like a record."
  },
  {
    "author": "Jourdan Dunn",
    "category": "dreams",
    "id": 15528,
    "text": "Happiness is making your dreams come true."
  },
  {
    "author": "Mitch Hedberg",
    "category": "dreams",
    "id": 14993,
    "text": "I'm sick of following my dreams. I'm just going to ask them where they're goin', and hook up with them later."
  },
  {
    "author": "Christopher Reeve",
    "category": "dreams",
    "id": 15242,
    "text": "At first, dreams seem impossible, then improbable, and eventually inevitable."
  },
  {
    "author": "Adlai Stevenson",
    "category": "dreams",
    "id": 15400,
    "text": "Freedom is not an ideal, it is not even a protection, if it means nothing more than freedom to stagnate, to live without dreams, to have no greater aim than a second car and another television set."
  },
  {
    "author": "Channing Tatum",
    "category": "dreams",
    "id": 15389,
    "text": "You have the dreams that you want, and then you have to do other jobs until you can get to that dream."
  },
  {
    "author": "John Malkovich",
    "category": "dreams",
    "id": 15315,
    "text": "Sigmund Freud said we act out our own dreams, but if you are only an actor you are not acting out your own dream. You are simply participating in someone else's dream."
  },
  {
    "author": "Tim Berners-Lee",
    "category": "dreams",
    "id": 15143,
    "text": "Anyone who has lost track of time when using a computer knows the propensity to dream, the urge to make dreams come true and the tendency to miss lunch."
  },
  {
    "author": "Herbert Kaufman",
    "category": "dreams",
    "id": 15087,
    "text": "Only things the dreamers make live on. They are the eternal conquerors."
  },
  {
    "author": "Novak Djokovic",
    "category": "dreams",
    "id": 15386,
    "text": "Those born into poverty or on the margins of society require our extra support to realize their dreams."
  },
  {
    "author": "Gerard De Nerval",
    "category": "dreams",
    "id": 15685,
    "text": "Our dreams are a second life. I have never been able to penetrate without a shudder those ivory or horned gates which separate us from the invisible world."
  },
  {
    "author": "Mary Wollstonecraft Shelley",
    "category": "dreams",
    "id": 15537,
    "text": "My dreams were at once more fantastic and agreeable than my writings."
  },
  {
    "author": "Donald G. Mitchell",
    "category": "dreams",
    "id": 15534,
    "text": "Youth is in a grand flush, like the hot days of ending summer and pleasant dreams thrall your spirit, like the smoky atmosphere that bathes the landscape of an August day."
  },
  {
    "author": "Rudolph Valentino",
    "category": "dreams",
    "id": 15352,
    "text": "Women are not in love with me but with the picture of me on the screen. I am merely the canvas on which women paint their dreams."
  },
  {
    "author": "Robert Griffin III",
    "category": "dreams",
    "id": 15448,
    "text": "Whoever I can go out every week and motivate to do better and to try to go after their dreams, I'm up for that."
  },
  {
    "author": "Lance Bass",
    "category": "dreams",
    "id": 15460,
    "text": "I think everyone dreams of that nice romantic wedding."
  },
  {
    "author": "Robert Fulghum",
    "category": "dreams",
    "id": 15096,
    "text": "I believe that imagination is stronger than knowledge. That myth is more potent than history. That dreams are more powerful than facts. That hope always triumphs over experience. That laughter is the only cure for grief. And I believe that love is stronger than death."
  },
  {
    "author": "Stefano Gabbana",
    "category": "dreams",
    "id": 15657,
    "text": "Dreams can still come true you need a great deal of energy and determination, and a little bit of luck."
  },
  {
    "author": "Colin Powell",
    "category": "dreams",
    "id": 14990,
    "text": "A dream doesn't become reality through magic it takes sweat, determination and hard work."
  },
  {
    "author": "Michel de Montaigne",
    "category": "dreams",
    "id": 15051,
    "text": "Those who have compared our life to a dream were right... we were sleeping wake, and waking sleep."
  },
  {
    "author": "Lenny Wilkens",
    "category": "dreams",
    "id": 15086,
    "text": "We should never discourage young people from dreaming dreams."
  },
  {
    "author": "Joseph Conrad",
    "category": "dreams",
    "id": 15056,
    "text": "Perhaps life is just that... a dream and a fear."
  },
  {
    "author": "Sigmund Freud",
    "category": "dreams",
    "id": 15148,
    "text": "Obviously one must hold oneself responsible for the evil impulses of one's dreams. In what other way can one deal with them? Unless the content of the dream rightly understood is inspired by alien spirits, it is part of my own being."
  },
  {
    "author": "Eric Lindros",
    "category": "dreams",
    "id": 15421,
    "text": "You have to dream dreams to live dreams."
  },
  {
    "author": "Kevin Costner",
    "category": "dreams",
    "id": 15338,
    "text": "I'm a big fan of dreams. Unfortunately, dreams are our first casualty in life - people seem to give them up, quicker than anything, for a 'reality.'"
  },
  {
    "author": "Peter Diamandis",
    "category": "dreams",
    "id": 15579,
    "text": "My childhood dreams were focused on being part of the effort to make humanity a multiplanetary species."
  },
  {
    "author": "David Herbert Lawrence",
    "category": "dreams",
    "id": 15203,
    "text": "I can never decide whether my dreams are the result of my thoughts, or my thoughts the result of my dreams."
  },
  {
    "author": "Henry Reed",
    "category": "dreams",
    "id": 15459,
    "text": "I published in 1978 a report on dreams in the Journal of Clinical Psychology. It was the first study of its kind to demonstrate that it is possible for people to make constructive use of their dreams to improve their lives."
  },
  {
    "author": "Brandy Norwood",
    "category": "dreams",
    "id": 15357,
    "text": "One day it just hit me. This is it. You are not in love. So either stay in it because you have a child or be brave and find the man of your dreams and marry him for real."
  },
  {
    "author": "Tommy Hilfiger",
    "category": "dreams",
    "id": 15526,
    "text": "'The Cut' is going to give someone the opportunity of a lifetime and help that person achieve his or her dreams."
  },
  {
    "author": "Lucas Grabeel",
    "category": "dreams",
    "id": 15701,
    "text": "As far as my dreams go, all I want to do is be a working actor, and I happily achieved that."
  },
  {
    "author": "Erich Fromm",
    "category": "dreams",
    "id": 15132,
    "text": "Both dreams and myths are important communications from ourselves to ourselves. If we do not understand the language in which they are written, we miss a great deal of what we know and tell ourselves in those hours when we are not busy manipulating the outside world."
  },
  {
    "author": "William Graham Sumner",
    "category": "dreams",
    "id": 15362,
    "text": "Men never cling to their dreams with such tenacity as at the moment when they are losing faith in them, and know it, but do not dare yet to confess it to themselves."
  },
  {
    "author": "Cam Gigandet",
    "category": "dreams",
    "id": 15635,
    "text": "I was so lucky to have parents who supported me, 100%, with whatever I was doing, both financially and emotionally. Having that they made my life so much easier. Instead of becoming a bartender and trying to survive while trying to pursue your dreams, I didn't have to worry about that aspect. I could just pursue my dreams."
  },
  {
    "author": "Gus Kahn",
    "category": "dreams",
    "id": 15780,
    "text": "I'll see you in my dreams."
  },
  {
    "author": "Chin-Ning Chu",
    "category": "dreams",
    "id": 15254,
    "text": "A successful life is one that is lived through understanding and pursuing one's own path, not chasing after the dreams of others."
  },
  {
    "author": "Elizabeth Bishop",
    "category": "dreams",
    "id": 15755,
    "text": "The armored cars of dreams, contrived to let us do so many a dangerous thing."
  },
  {
    "author": "David Brooks",
    "category": "dreams",
    "id": 15590,
    "text": "America is not just a democracy, it represents a certain culture of competitive mobility and personality aspirations, politics is not merely a clash of interests, but a clash of dreams."
  },
  {
    "author": "Henry Reed",
    "category": "dreams",
    "id": 15407,
    "text": "Dreams have always expanded our understanding of reality by challenging our boundaries of the real, of the possible."
  },
  {
    "author": "Kirsty Coventry",
    "category": "dreams",
    "id": 15742,
    "text": "People have to remain positive and believe in those dreams. It's really important."
  },
  {
    "author": "Edward G. Bulwer-Lytton",
    "category": "dreams",
    "id": 15052,
    "text": "Dream manfully and nobly, and thy dreams shall be prophets."
  },
  {
    "author": "Joe Montana",
    "category": "dreams",
    "id": 15250,
    "text": "Winners, I am convinced, imagine their dreams first. They want it with all their heart and expect it to come true. There is, I believe, no other way to live."
  },
  {
    "author": "Martha Reeves",
    "category": "dreams",
    "id": 15593,
    "text": "I worshipped Berry Gordy for the creative dreams he had made come true."
  },
  {
    "author": "Scott Patterson",
    "category": "dreams",
    "id": 15719,
    "text": "I think L.A.'s terrific. You fly an hour and a half and you're in the mountains in three feet of powder. I also think it's a much better city if you're working as an actor. If you're not working and you don't see your dreams coming true, there can be a lot of heartache."
  },
  {
    "author": "Adelaide Anne Procter",
    "category": "dreams",
    "id": 15745,
    "text": "Dreams grow holy put in action."
  },
  {
    "author": "Marco Rubio",
    "category": "dreams",
    "id": 15267,
    "text": "We're special because dreams that are impossible anywhere else, come true here. That's not just my story. That's your story. That's our story."
  },
  {
    "author": "Sue Monk Kidd",
    "category": "dreams",
    "id": 15683,
    "text": "Gradually it occurred to me that we spend a great deal of life asleep and that dreams are little narratives, little stories. I thought, 'Who's choreographing this stuff?'"
  },
  {
    "author": "Jack Johnson",
    "category": "dreams",
    "id": 15570,
    "text": "Don't let your dreams be dreams."
  },
  {
    "author": "Bob Dylan",
    "category": "dreams",
    "id": 15110,
    "text": "I'll let you be in my dreams if I can be in yours."
  },
  {
    "author": "Gilda Radner",
    "category": "dreams",
    "id": 15220,
    "text": "Dreams are like paper, they tear so easily."
  },
  {
    "author": "Karl Malone",
    "category": "dreams",
    "id": 15424,
    "text": "Sometimes, you follow your dreams. I say to the young people, 'If you have a dream, chase it.'"
  },
  {
    "author": "Martha Reeves",
    "category": "dreams",
    "id": 15592,
    "text": "I still marvel at how God turns dreams into reality."
  },
  {
    "author": "Sigmund Freud",
    "category": "dreams",
    "id": 15021,
    "text": "The interpretation of dreams is the royal road to a knowledge of the unconscious activities of the mind."
  },
  {
    "author": "Jesse Jackson",
    "category": "dreams",
    "id": 15351,
    "text": "We've removed the ceiling above our dreams. There are no more impossible dreams."
  },
  {
    "author": "Bianca Jagger",
    "category": "dreams",
    "id": 15432,
    "text": "In Nicaragua, liberty, equality and the rule of law were the stuff of dreams. But in Paris I discovered the value of those words."
  },
  {
    "author": "Ashley Tisdale",
    "category": "dreams",
    "id": 15345,
    "text": "I'm living out my dreams and I love what I do."
  },
  {
    "author": "Harry Chapin",
    "category": "dreams",
    "id": 15411,
    "text": "Good dreams don't come cheap, you've got to pay for them and If you just dream when you're asleep this is no way for them to come alive... to survive."
  },
  {
    "author": "A. B. Yehoshua",
    "category": "dreams",
    "id": 15700,
    "text": "One of the dreams of Zionism was to be a bridge. Instead, we are creating exclusion between the East and the West instead of creating bridges we are contributing to the conflict between East and West by our stupid desire to have more."
  },
  {
    "author": "William Gibson",
    "category": "dreams",
    "id": 15359,
    "text": "Dreaming in public is an important part of our job description, as science writers, but there are bad dreams as well as good dreams. We're dreamers, you see, but we're also realists, of a sort."
  },
  {
    "author": "Julio Cortazar",
    "category": "dreams",
    "id": 15335,
    "text": "Only in dreams, in poetry, in play do we sometimes arrive at what we were before we were this thing that, who knows, we are."
  },
  {
    "author": "Candice Bergen",
    "category": "dreams",
    "id": 15535,
    "text": "Dreams are, by definition, cursed with short life spans."
  },
  {
    "author": "Margaret Fuller",
    "category": "dreams",
    "id": 15071,
    "text": "Only the dreamer shall understand realities, though in truth his dreaming must be not out of proportion to his waking."
  },
  {
    "author": "Marya Mannes",
    "category": "dreams",
    "id": 15268,
    "text": "The curse of the romantic is a greed for dreams, an intensity of expectation that, in the end, diminishes the reality."
  },
  {
    "author": "Henry David Thoreau",
    "category": "dreams",
    "id": 14995,
    "text": "If one advances confidently in the direction of his dreams, and endeavors to live the life which he has imagined, he will meet with success unexpected in common hours."
  },
  {
    "author": "Olive Schreiner",
    "category": "dreams",
    "id": 15717,
    "text": "Our fathers had their dreams we have ours the generation that follows will have its own. Without dreams and phantoms man cannot exist."
  },
  {
    "author": "Karen Armstrong",
    "category": "dreams",
    "id": 15393,
    "text": "When violence becomes imbedded in a region, then this affects everything. It affects your dreams, your fantasies and relationships, and your religion becomes violent, too."
  },
  {
    "author": "Gary Ryan Blair",
    "category": "dreams",
    "id": 15508,
    "text": "Your mind, while blessed with permanent memory, is cursed with lousy recall. Written goals provide clarity. By documenting your dreams, you must think about the process of achieving them."
  },
  {
    "author": "Bill McCartney",
    "category": "dreams",
    "id": 15330,
    "text": "Big dreams create the magic that stir men's souls to greatness."
  },
  {
    "author": "Roy Keane",
    "category": "dreams",
    "id": 15686,
    "text": "Hopefully kids will look at me and see that your dreams can come true."
  },
  {
    "author": "Jesse Owens",
    "category": "dreams",
    "id": 14999,
    "text": "We all have dreams. But in order to make dreams come into reality, it takes an awful lot of determination, dedication, self-discipline, and effort."
  },
  {
    "author": "Mary McAleese",
    "category": "dreams",
    "id": 15603,
    "text": "People with disabilities have abilities too and that is what this course is all about - making sure those abilities blossom and shine so that all the dreams you have can come true."
  },
  {
    "author": "Jimmy Carter",
    "category": "dreams",
    "id": 15162,
    "text": "We become not a melting pot but a beautiful mosaic. Different people, different beliefs, different yearnings, different hopes, different dreams."
  },
  {
    "author": "Sally Kirkland",
    "category": "dreams",
    "id": 15560,
    "text": "So, I think that Marilyn, what she gave the world, and in many ways Kennedy too, was that they had dreams and they didn't allow anybody to take away their dreams."
  },
  {
    "author": "Booker T. Washington",
    "category": "dreams",
    "id": 15153,
    "text": "If you can't read, it's going to be hard to realize dreams."
  },
  {
    "author": "Steve Carell",
    "category": "dreams",
    "id": 15744,
    "text": "In my wildest dreams I never thought - well, I never thought I'd work."
  },
  {
    "author": "James Dean",
    "category": "dreams",
    "id": 14988,
    "text": "Dream as if you'll live forever. Live as if you'll die today."
  },
  {
    "author": "Napoleon Hill",
    "category": "dreams",
    "id": 15122,
    "text": "Man, alone, has the power to transform his thoughts into physical reality man, alone, can dream and make his dreams come true."
  },
  {
    "author": "Alex Pettyfer",
    "category": "dreams",
    "id": 15601,
    "text": "I'm very ambitious. I live in reality but I have dreams I want to fulfill - I want to be a director, and I've already started my own production company. But I also have a measure of success that I keep to myself. It's something very personal to me."
  },
  {
    "author": "Joan Didion",
    "category": "dreams",
    "id": 15067,
    "text": "Was it only by dreaming or writing that I could find out what I thought?"
  },
  {
    "author": "Roger Clemens",
    "category": "dreams",
    "id": 15578,
    "text": "College baseball, I love it. I love to work with the younger kids who are trying to live out their dreams, if in fact that's what they plan on doing after college to take the next step."
  },
  {
    "author": "Les Brown",
    "category": "dreams",
    "id": 15000,
    "text": "If you take responsibility for yourself you will develop a hunger to accomplish your dreams."
  },
  {
    "author": "Robert H. Schuller",
    "category": "dreams",
    "id": 15135,
    "text": "High achievers spot rich opportunities swiftly, make big decisions quickly and move into action immediately. Follow these principles and you can make your dreams come true."
  },
  {
    "author": "Julie Walters",
    "category": "dreams",
    "id": 15412,
    "text": "I was always someone who lived in the future all the time, it was always the next thing - dreams of escape."
  },
  {
    "author": "Danica Patrick",
    "category": "dreams",
    "id": 15396,
    "text": "I've never been bashful to say that I'm not really interested in Formula One. When I lived in England, it's all I wanted to do and I thought that anything else would somehow be a compromise to my dreams. But then when I came back to the States, I realised how much I loved being back in the States."
  },
  {
    "author": "Brian Eno",
    "category": "dreams",
    "id": 15262,
    "text": "I've had quite a lot of luck with dreams. I've often awoken in the night with a phrase or even a whole song in my head."
  },
  {
    "author": "Trey Anastasio",
    "category": "dreams",
    "id": 15417,
    "text": "Things have gone beyond my wildest expectations and dreams, and I feel like I've been given so many blessings in my life, between my friendship with the guys in the band, our wonderful audience, being able to play this music, and then my family."
  },
  {
    "author": "Jack Johnson",
    "category": "dreams",
    "id": 15463,
    "text": "Our dreams are made of real things, like a shoebox full of photographs."
  },
  {
    "author": "Pam Brown",
    "category": "dreams",
    "id": 15193,
    "text": "A horse is the projection of peoples' dreams about themselves - strong, powerful, beautiful - and it has the capability of giving us escape from our mundane existence."
  },
  {
    "author": "Sara Teasdale",
    "category": "dreams",
    "id": 15468,
    "text": "Though I know he loves me, tonight my heart is sad his kiss was not so wonderful as all the dreams I had."
  },
  {
    "author": "Gabrielle Reece",
    "category": "dreams",
    "id": 15501,
    "text": "I can't sing but I can understand wanting to keep a balance, trying to pursue dreams, while creating a stable environment for my children."
  },
  {
    "author": "Ella Maillart",
    "category": "dreams",
    "id": 15437,
    "text": "The usual channels of university studies or secretarial work did not appeal to me. I cherished difficult dreams through confidence in myself."
  },
  {
    "author": "Thomas Menino",
    "category": "dreams",
    "id": 15586,
    "text": "Here's what I see all across this great city - people working together to make Boston a better place to live and to raise children, to grow and pursue dreams."
  },
  {
    "author": "Paul Gauguin",
    "category": "dreams",
    "id": 15259,
    "text": "Life being what it is, one dreams of revenge."
  },
  {
    "author": "Azar Nafisi",
    "category": "dreams",
    "id": 15543,
    "text": "When I first left Iran at the age of 13, Iran had become such a shining star - it was the point to which all my desires and dreams returned."
  },
  {
    "author": "Aziz Ansari",
    "category": "dreams",
    "id": 15258,
    "text": "Do It Under the Influence Yourself! That's what we're shooting for! Get drunk and make your dreams come true."
  },
  {
    "author": "Thomas S. Monson",
    "category": "dreams",
    "id": 15300,
    "text": "We must not let our passions destroy our dreams."
  },
  {
    "author": "Katy Perry",
    "category": "dreams",
    "id": 15191,
    "text": "There are a lot of things that are personally uncomfortable to show, especially me without makeup and completely bloated or crying. But I've realized that it's time for me to show my audience that you don't have to be perfect to achieve your dreams. Because nobody relates to being perfect."
  }
]

quotes['education'] = [
  {
    "author": "Russ Feingold",
    "category": "education",
    "id": 16728,
    "text": "I believe in local control of education."
  },
  {
    "author": "Kent McCord",
    "category": "education",
    "id": 16777,
    "text": "I feel that education needs an overhaul - courses are obsolete and grades are on the way out."
  },
  {
    "author": "Roland Joffe",
    "category": "education",
    "id": 16524,
    "text": "Making the City Of Joy gave me the best political education of my life. It became a wrestling match between an Englishman who had gradually ceased to be a Marxist, and a culture that was becoming more Marxist by the day."
  },
  {
    "author": "Josh Gad",
    "category": "education",
    "id": 16701,
    "text": "I went to drama school for four years at Carnegie Mellon, conservatory training before television comedy. I was doing Shakespeare and Chekov plays. It's about delivering on the promise of a $100,000 education and taking the shackles off and trying the hand at my craft. I'm thrilled with what I've seen so far."
  },
  {
    "author": "Derek Bok",
    "category": "education",
    "id": 16097,
    "text": "If you think education is expensive, try ignorance."
  },
  {
    "author": "Steve Case",
    "category": "education",
    "id": 16599,
    "text": "I do think that a general liberal arts education is very important, particularly in an uncertain changing world."
  },
  {
    "author": "Kathleen Blanco",
    "category": "education",
    "id": 16439,
    "text": "Think about it: Every educated person is not rich, but almost every education person has a job and a way out of poverty. So education is a fundamental solution to poverty."
  },
  {
    "author": "Alvin Toffler",
    "category": "education",
    "id": 15820,
    "text": "The illiterate of the future will not be the person who cannot read. It will be the person who does not know how to learn."
  },
  {
    "author": "Michelle Obama",
    "category": "education",
    "id": 16064,
    "text": "See, that's why Barack's running: to end the war in Iraq responsibly - to build an economy that lifts every family, to make sure health care is available for every American - and to make sure that every child in this nation has a world-class education all the way from preschool to college."
  },
  {
    "author": "Blanche Lincoln",
    "category": "education",
    "id": 16598,
    "text": "Unless we make education a priority, an entire generation of Americans could miss out on the American dream."
  },
  {
    "author": "Jennifer Granholm",
    "category": "education",
    "id": 16357,
    "text": "To compete in a global economy, our students must continue their education beyond high school. To make this expectation a reality, we must give students the tools they need to succeed, including the opportunity to take a college entrance exam."
  },
  {
    "author": "Jim Rohn",
    "category": "education",
    "id": 15914,
    "text": "If someone is going down the wrong road, he doesn't need motivation to speed him up. What he needs is education to turn him around."
  },
  {
    "author": "Michelle Obama",
    "category": "education",
    "id": 15928,
    "text": "The truth is, in order to get things like universal health care and a revamped education system, then someone is going to have to give up a piece of their pie so that someone else can have more."
  },
  {
    "author": "Charles Babbage",
    "category": "education",
    "id": 16348,
    "text": "It is therefore not unreasonable to suppose that some portion of the neglect of science in England, may be attributed to the system of education we pursue."
  },
  {
    "author": "Billy Joel",
    "category": "education",
    "id": 16180,
    "text": "When I was a young musician, the only option available to pursue secondary education in music was to attend a classical conservatory."
  },
  {
    "author": "Polly Toynbee",
    "category": "education",
    "id": 16487,
    "text": "But instead of standing up for reason, our government is handing education over to the world of faith."
  },
  {
    "author": "Rainn Wilson",
    "category": "education",
    "id": 16380,
    "text": "And I do believe that the way to change a society, to uplift people - not just their spirit, but to uplift their society and economic base - is through education."
  },
  {
    "author": "Barack Obama",
    "category": "education",
    "id": 15941,
    "text": "We can't get to the $4 trillion in savings that we need by just cutting the 12 percent of the budget that pays for things like medical research and education funding and food inspectors and the weather service. And we can't just do it by making seniors pay more for Medicare."
  },
  {
    "author": "Michael Jackson",
    "category": "education",
    "id": 15935,
    "text": "The greatest education in the world is watching the masters at work."
  },
  {
    "author": "Joseph Lancaster",
    "category": "education",
    "id": 16758,
    "text": "I am persuaded, that if any attempt is made to improve the education of the poor, and such an unmanly spirit should guide the resolution of a society or committee for that purpose, it would render the design abortive."
  },
  {
    "author": "Jimmy Smits",
    "category": "education",
    "id": 16593,
    "text": "I am a firm believer in education and have worked very hard to tell young Latinos that they must go to college and that, if possible, they should pursue an advanced degree. I am convinced that education is the great equalizer."
  },
  {
    "author": "John Maynard Keynes",
    "category": "education",
    "id": 16077,
    "text": "Education: the inculcation of the incomprehensible into the indifferent by the incompetent."
  },
  {
    "author": "Ambrose Bierce",
    "category": "education",
    "id": 15833,
    "text": "Learning, n. The kind of ignorance distinguishing the studious."
  },
  {
    "author": "David Horowitz",
    "category": "education",
    "id": 16619,
    "text": "A university is not a political party, and an education is not an indoctrination."
  },
  {
    "author": "Lawrence Welk",
    "category": "education",
    "id": 16190,
    "text": "Dreams do come true, even for someone who couldn't speak English and never had a music lesson or much of an education."
  },
  {
    "author": "Ellen Ochoa",
    "category": "education",
    "id": 16586,
    "text": "I think of it as a good opportunity to let, in particular, school kids know that this job and other interesting jobs in science and engineering are open to anyone who works hard in school and gets a good education and studies math and science. And that it's not just for a select group of people."
  },
  {
    "author": "Christine Gregoire",
    "category": "education",
    "id": 16337,
    "text": "Education can lift individuals out of poverty and into rewarding careers."
  },
  {
    "author": "Bobby Vinton",
    "category": "education",
    "id": 16678,
    "text": "Session musicians kind of respected me because what I was talking about made sense. That all came from an education. Believe me, education does you more good. Maybe that's the reason I've been around so long."
  },
  {
    "author": "Ernie Fletcher",
    "category": "education",
    "id": 16456,
    "text": "Education is our greatest opportunity to give an irrevocable gift to the next generation."
  },
  {
    "author": "Robert M. Hutchins",
    "category": "education",
    "id": 15843,
    "text": "The object of education is to prepare the young to educate themselves throughout their lives."
  },
  {
    "author": "Jon Huntsman, Jr.",
    "category": "education",
    "id": 16484,
    "text": "Economic prosperity and quality education for our children are inexorably linked."
  },
  {
    "author": "Nicole Polizzi",
    "category": "education",
    "id": 16461,
    "text": "I have an education, I went to college, you know?"
  },
  {
    "author": "Caroline Kennedy Schlossberg",
    "category": "education",
    "id": 15872,
    "text": "To the extent that we are all educated and informed, we will be more equipped to deal with the gut issues that tend to divide us."
  },
  {
    "author": "Jenny Eclair",
    "category": "education",
    "id": 16423,
    "text": "I'm very jealous of my daughter's education. She's been inspired by her teachers, and nobody inspired me as a teenager."
  },
  {
    "author": "Carl Sagan",
    "category": "education",
    "id": 15824,
    "text": "I am often amazed at how much more capability and enthusiasm for science there is among elementary school youngsters than among college students."
  },
  {
    "author": "Harri Holkeri",
    "category": "education",
    "id": 16692,
    "text": "If there is something I would like to do as President of the General Assembly, it is to place more emphasis on the issue of education, which enables a better life for women."
  },
  {
    "author": "William Bennett",
    "category": "education",
    "id": 16126,
    "text": "All real education is the architecture of the soul."
  },
  {
    "author": "Malcolm Forbes",
    "category": "education",
    "id": 15817,
    "text": "Education's purpose is to replace an empty mind with an open one."
  },
  {
    "author": "Marvin Hamlisch",
    "category": "education",
    "id": 16539,
    "text": "There have been studies that clearly state that children who are exposed to arts education at a young age will in fact do markedly better in their SAT tests."
  },
  {
    "author": "Horace",
    "category": "education",
    "id": 16015,
    "text": "Knowledge without education is but armed injustice."
  },
  {
    "author": "Salman Khan",
    "category": "education",
    "id": 16736,
    "text": "What you have in most education software is that they're catering to the decision-maker who makes the budget allocations, and that decision-maker has a lot of check boxes. Does it do this? Check. Does it do that? Check. They could care less about the end user experience."
  },
  {
    "author": "Ron Silver",
    "category": "education",
    "id": 16646,
    "text": "I've seen people with a tremendous amount of educational background in the field not turn out to be terribly good actors, and I've seen people with no education in the field turn out to be people that I admire quite a bit."
  },
  {
    "author": "Kareem Abdul-Jabbar",
    "category": "education",
    "id": 16153,
    "text": "I have to say I have an incredible musical education because of my father."
  },
  {
    "author": "Michael Morpurgo",
    "category": "education",
    "id": 16444,
    "text": "A lot of children, like I did, move away from words because of the fear - which is something you have to take out of education: the fear of worrying about what marks you'll get, detention, worrying about letting people down, your parents, teachers."
  },
  {
    "author": "Rabindranath Tagore",
    "category": "education",
    "id": 15808,
    "text": "Don't limit a child to your own learning, for he was born in another time."
  },
  {
    "author": "Samuel Richardson",
    "category": "education",
    "id": 16193,
    "text": "The difference in the education of men and women must give the former great advantages over the latter, even where geniuses are equal."
  },
  {
    "author": "Naguib Mahfouz",
    "category": "education",
    "id": 16326,
    "text": "As the tension eases, we must look in the direction of agriculture, industry and education as our final goals, and toward democracy under Mr Mubarak."
  },
  {
    "author": "Lisa Loeb",
    "category": "education",
    "id": 16504,
    "text": "I think we were raised in a nice Texas Jewish family where education was the most important thing, and close behind that was the arts. It was emphasized and expected that we'd play piano."
  },
  {
    "author": "Amanda Burton",
    "category": "education",
    "id": 16738,
    "text": "But I didn't really enjoy my secondary education that much, probably because I am a very physical person and don't enjoy sitting at a desk all day. I just dragged myself through GCSE and A Levels, so it suited me very much to go on to drama school, which was very active."
  },
  {
    "author": "David Rockefeller",
    "category": "education",
    "id": 16219,
    "text": "I am a passionate traveler, and from the time I was a child, travel formed me as much as my formal education."
  },
  {
    "author": "Bobby Scott",
    "category": "education",
    "id": 16560,
    "text": "Unfortunately, the elimination of incentives such as parole, good time credits and funding for college courses, means that fewer inmates participate in and excel in literacy, education, treatment and other development programs."
  },
  {
    "author": "Zhuang Zi",
    "category": "education",
    "id": 16448,
    "text": "Rewards and punishments are the lowest form of education."
  },
  {
    "author": "William Jennings Bryan",
    "category": "education",
    "id": 16116,
    "text": "If we have to give up either religion or education, we should give up education."
  },
  {
    "author": "Joseph Lancaster",
    "category": "education",
    "id": 16757,
    "text": "May this plain statement of facts prevail on the friends of the rising generation to interpose for their welfare that the education of children may no longer be to parent and master a lottery, in which the prizes bear no proportion to the enormous number of blanks."
  },
  {
    "author": "Arne Duncan",
    "category": "education",
    "id": 16752,
    "text": "A postsecondary education is the ticket to economic success in America."
  },
  {
    "author": "John Dewey",
    "category": "education",
    "id": 15802,
    "text": "Education is not preparation for life education is life itself."
  },
  {
    "author": "Evel Knievel",
    "category": "education",
    "id": 16314,
    "text": "I think through education, belief in God, and good engineering, our children become a lot better at what they're doing than we did, and that starts with the very first sign of life on the face of this earth."
  },
  {
    "author": "Trevor Nunn",
    "category": "education",
    "id": 16554,
    "text": "The first big break was winning a scholarship to go to Cambridge University. I was very lucky, because my parents couldn't have afforded a university education for me. Without a scholarship I couldn't possibly have gone."
  },
  {
    "author": "Seth Graham-Smith",
    "category": "education",
    "id": 16175,
    "text": "Abraham Lincoln comes from nothing, has no education, no money, lives in the middle of nowhere on the frontier. And despite the fact that he suffers one tragedy and one setback after another, through sheer force of will, he becomes something extraordinary: not only the president but the person who almost single-handedly united the country."
  },
  {
    "author": "Alan Perlis",
    "category": "education",
    "id": 16645,
    "text": "It goes against the grain of modern education to teach students to program. What fun is there to making plans, acquiring discipline, organizing thoughts, devoting attention to detail, and learning to be self critical."
  },
  {
    "author": "James Dyson",
    "category": "education",
    "id": 16323,
    "text": "Arbitrary benchmarks cheat kids out of a fulfilling education."
  },
  {
    "author": "Mayer Hawthorne",
    "category": "education",
    "id": 16509,
    "text": "I was really fortunate growing up to have a broad musical education. My parents listened to all kinds of music, rock, soul, Motown, jazz, Frank Sinatra, everything."
  },
  {
    "author": "Jacques Barzun",
    "category": "education",
    "id": 16555,
    "text": "Except among those whose education has been in the minimalist style, it is understood that hasty moral judgments about the past are a form of injustice."
  },
  {
    "author": "Lucy Powell",
    "category": "education",
    "id": 16335,
    "text": "The Tories and the Lib Dems talk about social mobility, but, short of winning the lottery, the only way to guarantee young people from all backgrounds the opportunity to do better and to raise aspirations is through education."
  },
  {
    "author": "Matt Damon",
    "category": "education",
    "id": 16493,
    "text": "My mother is a professor of early childhood education. When I was two she would say she knew I was going to be an actor."
  },
  {
    "author": "Aldo Leopold",
    "category": "education",
    "id": 16393,
    "text": "Is education possibly a process of trading awareness for things of lesser worth? The goose who trades his is soon a pile of feathers."
  },
  {
    "author": "Nancy Astor",
    "category": "education",
    "id": 16730,
    "text": "Real education should educate us out of self into something far finer into a selflessness which links us with all humanity."
  },
  {
    "author": "Kris Allen",
    "category": "education",
    "id": 16669,
    "text": "I'm a huge fan of music in schools and music education because that's how I grew up."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "education",
    "id": 16296,
    "text": "Likewise, education can direct people toward good or evil ends. When education is based on a fundamentally distorted worldview, the results are horrific."
  },
  {
    "author": "A. A. Milne",
    "category": "education",
    "id": 15837,
    "text": "To the uneducated, an A is just three sticks."
  },
  {
    "author": "Kofi Annan",
    "category": "education",
    "id": 16050,
    "text": "Education is a human right with immense power to transform. On its foundation rest the cornerstones of freedom, democracy and sustainable human development."
  },
  {
    "author": "Maynard James Keenan",
    "category": "education",
    "id": 15852,
    "text": "If the education of our kids comes from radio, television, newspapers - if that's where they get most of their knowledge from, and not from the schools, then the powers that be are definitely in charge, because they own all those outlets."
  },
  {
    "author": "Giacomo Casanova",
    "category": "education",
    "id": 16147,
    "text": "Heart and head are the constituent parts of character temperament has almost nothing to do with it, and, therefore, character is dependent upon education, and is susceptible of being corrected and improved."
  },
  {
    "author": "Henry Adams",
    "category": "education",
    "id": 16245,
    "text": "Knowledge of human nature is the beginning and end of political education."
  },
  {
    "author": "William John Wills",
    "category": "education",
    "id": 16523,
    "text": "At any rate, girls are differently situated. Having no need of deep scientific knowledge, their education is confined more to the ordinary things of the world, the study of the fine arts, and of the manners and dispositions of people."
  },
  {
    "author": "Michael N. Castle",
    "category": "education",
    "id": 16566,
    "text": "By climbing a steeper road, the value and appreciation Delaware State students took and continue to take from their education and their experiences is just as great, if not greater, than students attending ivy league schools."
  },
  {
    "author": "William J. Clinton",
    "category": "education",
    "id": 16091,
    "text": "It turns out that advancing equal opportunity and economic empowerment is both morally right and good economics, because discrimination, poverty and ignorance restrict growth, while investments in education, infrastructure and scientific and technological research increase it, creating more good jobs and new wealth for all of us."
  },
  {
    "author": "Walt Disney",
    "category": "education",
    "id": 15809,
    "text": "I would rather entertain and hope that people learned something than educate people and hope they were entertained."
  },
  {
    "author": "Kinky Friedman",
    "category": "education",
    "id": 16184,
    "text": "We're first on executions. We're 49th in funding public education. We're in a race with Mississippi for the bottom, and we're winning."
  },
  {
    "author": "Angela Davis",
    "category": "education",
    "id": 16258,
    "text": "Poor people, people of color - especially are much more likely to be found in prison than in institutions of higher education."
  },
  {
    "author": "Aleister Crowley",
    "category": "education",
    "id": 15986,
    "text": "To read a newspaper is to refrain from reading something worth while. The first discipline of education must therefore be to refuse resolutely to feed the mind with canned chatter."
  },
  {
    "author": "Caroline Kennedy",
    "category": "education",
    "id": 16256,
    "text": "Education was the most important value in our home when I was growing up. People don't always realize that my parents shared a sense of intellectual curiosity and a love of reading and of history."
  },
  {
    "author": "Bernie Sanders",
    "category": "education",
    "id": 16405,
    "text": "You go to Scandinavia, and you will find that people have a much higher standard of living, in terms of education, health care and decent paying jobs."
  },
  {
    "author": "Desiderius Erasmus",
    "category": "education",
    "id": 15853,
    "text": "Your library is your paradise."
  },
  {
    "author": "Sally Kirkland",
    "category": "education",
    "id": 16694,
    "text": "I'm on Governor Gray Davis' California Alliance Towards Education to bring the arts back to high schools."
  },
  {
    "author": "Nancy Pelosi",
    "category": "education",
    "id": 16306,
    "text": "Furthermore, we believe that health care reform, again I said at the beginning of my remarks, that we sent the three pillars that the President's economic stabilization and job creation initiatives were education and innovation - innovation begins in the classroom - clean energy and climate, addressing the climate issues in an innovative way to keep us number one and competitive in the world with the new technology, and the third, first among equals I may say, is health care, health insurance reform."
  },
  {
    "author": "John Conyers",
    "category": "education",
    "id": 16718,
    "text": "The Republicans have chosen to neglect young Americans who need assistance with the costs of higher education."
  },
  {
    "author": "Loni Anderson",
    "category": "education",
    "id": 16620,
    "text": "I've been working with the National Lung Health Education Program to raise awareness about Chronic Obstructive Pulmonary Disease."
  },
  {
    "author": "Harvey S. Firestone",
    "category": "education",
    "id": 15864,
    "text": "It is only as we develop others that we permanently succeed."
  },
  {
    "author": "will.i.am",
    "category": "education",
    "id": 16281,
    "text": "As we develop and get quicker with technology in America, it's like we're downgrading if you look at the investment in education... that's the thing that worries me."
  },
  {
    "author": "Alexander Wang",
    "category": "education",
    "id": 16557,
    "text": "I was in fashion school, my brother has a law background, and my sister-in-law had worked in production, but none of us had a proper fashion business education."
  },
  {
    "author": "John Ruskin",
    "category": "education",
    "id": 16003,
    "text": "Modern education has devoted itself to the teaching of impudence, and then we complain that we can no longer control our mobs."
  },
  {
    "author": "Nikki Haley",
    "category": "education",
    "id": 16622,
    "text": "There is no war on women. Women are doing well. But women are thoughtful. And what we in the Republican Party and across the country, Republican, Independents and Democrat women say is we're more thoughtful than a label. We care about jobs and the economy and healthcare and education. We care about a lot of different things."
  },
  {
    "author": "Ron Lewis",
    "category": "education",
    "id": 16313,
    "text": "Ensuring quality higher education is one of the most important things we can do for future generations."
  },
  {
    "author": "Dominic Cooper",
    "category": "education",
    "id": 16658,
    "text": "The people in Iraq lived essentially good lives. They had brilliant health and education systems. Saddam actually created an incredible infrastructure in a very difficult country, but they were a Mafia family. If you said anything against that regime or that family you would be killed instantly."
  },
  {
    "author": "Mark Twain",
    "category": "education",
    "id": 15897,
    "text": "Education consists mainly of what we have unlearned."
  },
  {
    "author": "Harry S. Truman",
    "category": "education",
    "id": 15990,
    "text": "Upon books the collective education of the race depends they are the sole instruments of registering, perpetuating and transmitting thought."
  },
  {
    "author": "Steven Spielberg",
    "category": "education",
    "id": 16074,
    "text": "Documentaries are the first line of education, and the second line of education is dramatization, such as 'The Pacific'."
  },
  {
    "author": "Arne Duncan",
    "category": "education",
    "id": 16750,
    "text": "Teachers say their schools of education did not adequately prepare them for the classroom. They would have welcomed more mentoring and feedback in their early years."
  },
  {
    "author": "B. F. Skinner",
    "category": "education",
    "id": 15840,
    "text": "Education is what survives when what has been learned has been forgotten."
  }
]

quotes['environmental'] = [
  {
    "author": "Barry Commoner",
    "category": "environmental",
    "id": 16832,
    "text": "Earth Day 1970 was irrefutable evidence that the American people understood the environmental threat and wanted action to resolve it."
  },
  {
    "author": "James Buchan",
    "category": "environmental",
    "id": 16884,
    "text": "Nature is not simply a technical or economical resource, and human beings are not mere numbers. To suggest that one can somehow align all the squabbling institutions of science, environmental management, government and diplomacy in an alliance of convenience to regulate the global climate seems to me optimistic."
  },
  {
    "author": "Jacob Bronowski",
    "category": "environmental",
    "id": 16800,
    "text": "You will die but the carbon will not its career does not end with you. It will return to the soil, and there a plant may take it up again in time, sending it once more on a cycle of plant and animal life."
  },
  {
    "author": "Maurice Strong",
    "category": "environmental",
    "id": 16908,
    "text": "A shift is necessary toward lifestyles less geared to environmental damaging consumption patterns."
  },
  {
    "author": "Ted Danson",
    "category": "environmental",
    "id": 16978,
    "text": "Address these environmental issues and you will address every issue known to man. And we keep dabbling in things that aren't really that important in the long term."
  },
  {
    "author": "Samuel Wilson",
    "category": "environmental",
    "id": 16992,
    "text": "Moreover, environmental health at the local level has become narrowly focused, very much defined around regulations and the attendant regulatory debates."
  },
  {
    "author": "Edward James Olmos",
    "category": "environmental",
    "id": 16922,
    "text": "There are nuclear weapons in China, Iran, Korea and Pakistan. It wouldn't take much to send a couple of warheads off on this planet somewhere that would cause a lot of environmental damage, then if you have got someone who wants to retaliate you have real problems."
  },
  {
    "author": "Maurice Strong",
    "category": "environmental",
    "id": 16912,
    "text": "Ted Turner is still a leader. And he sets a great example. His ability financially has been reduced, but his influence and his example still is an important asset to the whole environmental movement."
  },
  {
    "author": "Jeffrey Kluger",
    "category": "environmental",
    "id": 16890,
    "text": "Toxins love to get you while you're young. Lead, mercury, secondhand smoke and sundry other environmental nasties do a lot more damage when tissue is immature, vulnerable and growing than when it's mature and comparatively fixed."
  },
  {
    "author": "Ted Turner",
    "category": "environmental",
    "id": 16815,
    "text": "I think Captain Cousteau might be the father of the environmental movement."
  },
  {
    "author": "Pat Buckley",
    "category": "environmental",
    "id": 16819,
    "text": "I can find God in nature, in animals, in birds and the environment."
  },
  {
    "author": "Corey Feldman",
    "category": "environmental",
    "id": 16923,
    "text": "I'd say that animal rights and environmental issues have always been at the forefront of my mind."
  },
  {
    "author": "Daryl Hannah",
    "category": "environmental",
    "id": 16955,
    "text": "And I know that the younger generation is doing things that are so ingenious. And for them it's not a matter of a political belief or an environmental stance. It's really just common sense."
  },
  {
    "author": "Jello Biafra",
    "category": "environmental",
    "id": 16918,
    "text": "I don't think it's too hippie to want to clean up the planet so you don't wind up dying of some kind of cancer when you're 45 years old. It enrages me that these big cancer-research organizations can't be bothered to man the front lines of environmental protest."
  },
  {
    "author": "Jane D. Hull",
    "category": "environmental",
    "id": 16965,
    "text": "Despite Arizona's remarkable growth in recent years, we have met the current federal health standards for ozone pollution and the Environmental Protection Agency recently approved our dust control plan."
  },
  {
    "author": "Vivienne Westwood",
    "category": "environmental",
    "id": 16873,
    "text": "I always thought we had an environmental problem, but I hadn't realized how urgent it was. James Lovelock writes that by the end of this century there will be one billion people left."
  },
  {
    "author": "Roger Tory Peterson",
    "category": "environmental",
    "id": 16839,
    "text": "I consider myself to have been the bridge between the shotgun and the binoculars in bird watching. Before I came along, the primary way to observe birds was to shoot them and stuff them."
  },
  {
    "author": "David Suzuki",
    "category": "environmental",
    "id": 16879,
    "text": "Over and over, we hear politicians say they can't spend our tax dollars on environmental protection when the economy is so fragile."
  },
  {
    "author": "Matt Gonzalez",
    "category": "environmental",
    "id": 16951,
    "text": "A fascinating challenge facing today's environmental movement is how to best approach the reversal of past decisions that altered once-pristine environmental spaces for the sake of urgent man-made needs."
  },
  {
    "author": "Galen Rowell",
    "category": "environmental",
    "id": 16933,
    "text": "These days, most nature photographers are deeply committed to the environmental message."
  },
  {
    "author": "John Muir",
    "category": "environmental",
    "id": 16785,
    "text": "God has cared for these trees, saved them from drought, disease, avalanches, and a thousand tempests and floods. But he cannot save them from fools."
  },
  {
    "author": "Beverly Sills",
    "category": "environmental",
    "id": 16877,
    "text": "A primary function of art and thought is to liberate the individual from the tyranny of his culture in the environmental sense and to permit him to stand beyond it in an autonomy of perception and judgment."
  },
  {
    "author": "Hans Blix",
    "category": "environmental",
    "id": 16943,
    "text": "Like I said, I'm more worried long term about the environmental issues then the use of arms."
  },
  {
    "author": "Dan Lipinski",
    "category": "environmental",
    "id": 16920,
    "text": "Hydrogen holds great promise to meet many of our future energy needs, and it addresses national security and our environmental concerns. Hydrogen is the simplest, most abundant element in the universe."
  },
  {
    "author": "Jeff Goodell",
    "category": "environmental",
    "id": 16902,
    "text": "Have we failed to slow global warming pollution in part because climate and environmental activists have been too polite and well behaved?"
  },
  {
    "author": "John Portman",
    "category": "environmental",
    "id": 17021,
    "text": "Architects in the past have tended to concentrate their attention on the building as a static object. I believe dynamics are more important: the dynamics of people, their interaction with spaces and environmental condition."
  },
  {
    "author": "Vivienne Westwood",
    "category": "environmental",
    "id": 16870,
    "text": "Economists treat economics as if it is a pure science divorced from the facts of life. The result of this false accountancy is a willful confusion under cover of which industry wreaks its havoc scot-free and ignores the environmental cost."
  },
  {
    "author": "Barry Commoner",
    "category": "environmental",
    "id": 16824,
    "text": "Environmental concern is now firmly embedded in public life: in education, medicine and law in journalism, literature and art."
  },
  {
    "author": "Jeremy Rifkin",
    "category": "environmental",
    "id": 16903,
    "text": "In this country, the health concerns and the environmental concerns are as deep as in Europe. All the surveys show that. But here, we didn't have the cultural dimension. This is a fast-food culture."
  },
  {
    "author": "Gale Norton",
    "category": "environmental",
    "id": 16849,
    "text": "Why has it seemed that the only way to protect the environment is with heavy-handed government regulation?"
  },
  {
    "author": "Roger Tory Peterson",
    "category": "environmental",
    "id": 16795,
    "text": "Birds are indicators of the environment. If they are in trouble, we know we'll soon be in trouble."
  },
  {
    "author": "Frank Murkowski",
    "category": "environmental",
    "id": 16856,
    "text": "I firmly believe that we can have a healthy environment and a sustainable timber industry."
  },
  {
    "author": "Clive Anderson",
    "category": "environmental",
    "id": 16956,
    "text": "On the environmental front there's concern about global warming and high levels of carbon dioxide, and trees take in CO2 and store carbon."
  },
  {
    "author": "Gro Harlem Brundtland",
    "category": "environmental",
    "id": 16917,
    "text": "You cannot achieve environmental security and human development without addressing the basic issues of health and nutrition."
  },
  {
    "author": "Aisha Tyler",
    "category": "environmental",
    "id": 16954,
    "text": "I thought I was gonna be an attorney, so I went to Dartmouth and I was a government major and I minored in environmental policy, and I didn't do anything academically around the arts."
  },
  {
    "author": "Donella Meadows",
    "category": "environmental",
    "id": 16823,
    "text": "You may be able to fool the voters, but not the atmosphere."
  },
  {
    "author": "Albert Einstein",
    "category": "environmental",
    "id": 16781,
    "text": "The environment is everything that isn't me."
  },
  {
    "author": "Bernard Sanders",
    "category": "environmental",
    "id": 17003,
    "text": "I think it makes people in the Pentagon kind of nervous to know that chemical agents and environmental factors could cause so much damage in terms of what may happen in the future."
  },
  {
    "author": "Luther Burbank",
    "category": "environmental",
    "id": 16803,
    "text": "I see humanity now as one vast plant, needing for its highest fulfillment only love, the natural blessings of the great outdoors, and intelligent crossing and selection."
  },
  {
    "author": "Richard Rogers",
    "category": "environmental",
    "id": 16817,
    "text": "The only way forward, if we are going to improve the quality of the environment, is to get everybody involved."
  },
  {
    "author": "Ron Wyden",
    "category": "environmental",
    "id": 16891,
    "text": "If China is helping its domestic industries charge an artificially low price for solar panels and other environmental goods, then China is violating international trade rules that it agreed to when it became a member of the World Trade Organization."
  },
  {
    "author": "Jared Diamond",
    "category": "environmental",
    "id": 16934,
    "text": "I decided that now is the time to start doing the things that really interest me and I find important. It was in the 10 years of the MacArthur grant that I began working on my first book... and I began putting more work into environmental history."
  },
  {
    "author": "Mackenzie Crook",
    "category": "environmental",
    "id": 17013,
    "text": "I like the outdoors and the natural world. Environmental issues."
  },
  {
    "author": "John Hickenlooper",
    "category": "environmental",
    "id": 16967,
    "text": "I assume we will have figured out a way to efficiently utilize solar energy and tied that to an efficient way to use nuclear energy in such a way that it doesn't pose a serious environmental issue."
  },
  {
    "author": "Gro Harlem Brundtland",
    "category": "environmental",
    "id": 16946,
    "text": "More than ever before, there is a global understanding that long-term social, economic, and environmental development would be impossible without healthy families, communities, and countries."
  },
  {
    "author": "Maggie Q",
    "category": "environmental",
    "id": 16947,
    "text": "There's so many issues tied to the meat industry. I mean, social, environmental, humanitarian - all of them. I know that when I'm eating that I'm not hurting the planet, I'm not hurting other people on this planet, I'm not hurting animals... and I'm not hurting nature."
  },
  {
    "author": "Joseph Wood Krutch",
    "category": "environmental",
    "id": 16796,
    "text": "If we do not permit the earth to produce beauty and joy, it will in the end not produce food, either."
  },
  {
    "author": "Ronald Reagan",
    "category": "environmental",
    "id": 16857,
    "text": "If the federal government had been around when the Creator was putting His hand to this state, Indiana wouldn't be here. It'd still be waiting for an environmental impact statement."
  },
  {
    "author": "Jay Inslee",
    "category": "environmental",
    "id": 16887,
    "text": "We had some major successes and we did so because the country embraced the spirit of Earth Day and embraced this concept that we have to have forward-looking, visionary environmental policy and energy policy in this country."
  },
  {
    "author": "Maurice Strong",
    "category": "environmental",
    "id": 16909,
    "text": "I am on the board of corporations who contribute both to environmental problems and their solutions. And I am on the NGO side: the Earth Council and other organizations."
  },
  {
    "author": "Sue Kelly",
    "category": "environmental",
    "id": 16971,
    "text": "My efforts in Congress are guided by the belief that environmental preservation and restoration are a critical part of the legacy we leave to future generations."
  },
  {
    "author": "David R. Brower",
    "category": "environmental",
    "id": 16826,
    "text": "It seems that every time mankind is given a lot of energy, we go out and wreck something with it."
  },
  {
    "author": "Will Durant",
    "category": "environmental",
    "id": 16862,
    "text": "Moral codes adjust themselves to environmental conditions."
  },
  {
    "author": "Jim Jeffords",
    "category": "environmental",
    "id": 17016,
    "text": "Since the day he came into office, President Bush has worked to gut more than 34 years of hard work by weakening many of our Nation's standing environmental laws, some of which were signed into law by his father."
  },
  {
    "author": "Judd Gregg",
    "category": "environmental",
    "id": 16966,
    "text": "I've always been a strong supporter of environmental protection and initiatives in that area. But I'm willing to set priorities. If we have to make reductions in one place, we'll have to-in order to increase another place, I'm willing to do that."
  },
  {
    "author": "James Fallows",
    "category": "environmental",
    "id": 16969,
    "text": "There's no longer any surprise in noting that China has grave environmental problems."
  },
  {
    "author": "Vince Cable",
    "category": "environmental",
    "id": 16895,
    "text": "I am going to confront the old-fashioned negative thinking which says that all government needs to do to generate growth is cut worker and environmental protections, cut taxes on the rich and stroke 'fat cats' until they purr with pleasure. I'm completely repudiating the idea that government has to get out of the way."
  },
  {
    "author": "Maurice Strong",
    "category": "environmental",
    "id": 16910,
    "text": "I've developed a huge regard for Toyota for its environmental awareness, for its immense commitment to research and development in this field, and for its leadership in developing hybrids which others are now following."
  },
  {
    "author": "Richard Lugar",
    "category": "environmental",
    "id": 16985,
    "text": "Ethanol is a premier, high performance fuel. It has tremendous environmental benefits and is a key component to energy independence for our country."
  },
  {
    "author": "Jacques Yves Cousteau",
    "category": "environmental",
    "id": 16860,
    "text": "The real cure for our environmental problems is to understand that our job is to salvage Mother Nature. We are facing a formidable enemy in this field. It is the hunters... and to convince them to leave their guns on the wall is going to be very difficult."
  },
  {
    "author": "Paul Hawken",
    "category": "environmental",
    "id": 16941,
    "text": "I think an old style of addressing environmental problems is ebbing, but the rise of the so-called conservative, political movement in this country is not a trend towards the future but a reaction to this very broad shift that we are undergoing."
  },
  {
    "author": "Keith Olbermann",
    "category": "environmental",
    "id": 16998,
    "text": "At Current, television is all we do - that's our business. We don't have amusement parks I have to worry about, we don't have environmental cases against us, we don't have a series of outdoor-advertising companies."
  },
  {
    "author": "Thomas R. Cech",
    "category": "environmental",
    "id": 17019,
    "text": "There should be more attention paid to scientific research in the ecology area, and I think that such attention to proper environmental concerns would make the public feel much better about it."
  },
  {
    "author": "Wangari Maathai",
    "category": "environmental",
    "id": 16886,
    "text": "In Kenya women are the first victims of environmental degradation, because they are the ones who walk for hours looking for water, who fetch firewood, who provide food for their families."
  },
  {
    "author": "Dan Lipinski",
    "category": "environmental",
    "id": 16921,
    "text": "By cutting critical domestic programs such as education, health, environmental protection, and veterans' services, this budget reveals misplaced priorities."
  },
  {
    "author": "Barry Commoner",
    "category": "environmental",
    "id": 16897,
    "text": "The environmental crisis arises from a fundamental fault: our systems of production - in industry, agriculture, energy and transportation - essential as they are, make people sick and die."
  },
  {
    "author": "Richard Trumka",
    "category": "environmental",
    "id": 17008,
    "text": "Time after time we're told corporations should have freedom from pesky job safety regulations, environmental protections and labor standards - giving working people the freedom to be crushed in collapsing mines, choke on filthy air and get paid too little to live on."
  },
  {
    "author": "Melissa Bean",
    "category": "environmental",
    "id": 16841,
    "text": "Under the Environmental Protection Agency's Energy Star Program, homes are independently verified to be measurably more energy efficient than average houses."
  },
  {
    "author": "William Bartram",
    "category": "environmental",
    "id": 16833,
    "text": "If we bestow but a very little attention to the economy of the animal creation, we shall find manifest examples of premeditation, perseverance, resolution, and consumate artifice, in order to effect their purpose."
  },
  {
    "author": "Christopher Dodd",
    "category": "environmental",
    "id": 16844,
    "text": "We learned that economic growth and environmental protection can and should go hand in hand."
  },
  {
    "author": "Brian Mulroney",
    "category": "environmental",
    "id": 16821,
    "text": "I think the government has to reposition environment on top of their national and international priorities."
  },
  {
    "author": "Garrett Hardin",
    "category": "environmental",
    "id": 16814,
    "text": "In a finite world this means that the per capita share of the world's goods must steadily decrease."
  },
  {
    "author": "Bill Nye",
    "category": "environmental",
    "id": 16979,
    "text": "Climate change is happening, humans are causing it, and I think this is perhaps the most serious environmental issue facing us."
  },
  {
    "author": "Jeremy Rifkin",
    "category": "environmental",
    "id": 16904,
    "text": "The position I took at the time was that we hadn't really examined any of the potential environmental consequences of introducing genetically modified organisms."
  },
  {
    "author": "Adam Schiff",
    "category": "environmental",
    "id": 16953,
    "text": "Unless action is taken soon - unless we can display the same vision of that earlier period - we will lose the treasure of California's open space and environmental beauty."
  },
  {
    "author": "Alexandra Paul",
    "category": "environmental",
    "id": 16835,
    "text": "For me, going vegan was an ethical and environmental decision. I'm doing the right thing by the animals."
  },
  {
    "author": "Mac Thornberry",
    "category": "environmental",
    "id": 16983,
    "text": "We should restore a proper balance in environmental regulation and energy production that is based on common sense, not political agendas."
  },
  {
    "author": "Aldo Leopold",
    "category": "environmental",
    "id": 16816,
    "text": "Harmony with land is like harmony with a friend you cannot cherish his right hand and chop off his left."
  },
  {
    "author": "Gaylord Nelson",
    "category": "environmental",
    "id": 17012,
    "text": "Loads of chemicals and hazardous wastes have been introduced into the atmosphere that didn't even exist in 1948. The environmental condition of the planet is far worse than it was 42 years ago."
  },
  {
    "author": "Michael Burgess",
    "category": "environmental",
    "id": 16843,
    "text": "Nuclear power will help provide the electricity that our growing economy needs without increasing emissions. This is truly an environmentally responsible source of energy."
  },
  {
    "author": "Godfrey Reggio",
    "category": "environmental",
    "id": 16959,
    "text": "So to hope to be able to have peace, to be able to have justice and environmental balance, are consequences of our behavior, not just our intentions."
  },
  {
    "author": "Gaylord Nelson",
    "category": "environmental",
    "id": 17010,
    "text": "In the state of Wisconsin it's mandated that teachers in the social sciences and hard sciences have to start giving environmental education by the first grade, through high school."
  },
  {
    "author": "Ethan Hawke",
    "category": "environmental",
    "id": 16907,
    "text": "At every turn, when humanity is asked the question, 'Do you want temporary economic gain or long-term environmental loss, which one do you prefer,' we invariably choose the money."
  },
  {
    "author": "Nina Fedoroff",
    "category": "environmental",
    "id": 16984,
    "text": "If there are more and more environmental refugees, they are going to end up on your doorstep too."
  },
  {
    "author": "Anita Roddick",
    "category": "environmental",
    "id": 16944,
    "text": "The Body Shop Foundation is run by our staff and supports social activism and environmental activism. We don't tend to support big agencies."
  },
  {
    "author": "Samuel Wilson",
    "category": "environmental",
    "id": 16991,
    "text": "The infrastructure for linking environmental health and public health is not working as well as it should."
  },
  {
    "author": "John Muir",
    "category": "environmental",
    "id": 16783,
    "text": "Keep close to Nature's heart... and break clear away, once in awhile, and climb a mountain or spend a week in the woods. Wash your spirit clean."
  },
  {
    "author": "Jim Jeffords",
    "category": "environmental",
    "id": 17017,
    "text": "This Bush administration has a growing credibility gap, maybe even a credibility chasm, on environmental policy. The President has lost the trust of the American people when it comes to the environment."
  },
  {
    "author": "Andrew Weil",
    "category": "environmental",
    "id": 16896,
    "text": "We need to accept the seemingly obvious fact that a toxic environment can make people sick and that no amount of medical intervention can protect us. The health care community must become a powerful political lobby for environmental policy and legislation."
  },
  {
    "author": "Simon Mainwaring",
    "category": "environmental",
    "id": 16867,
    "text": "When people align around shared political, social, economic or environmental values, and take collective action, thinking and behavior that compromises the lives of millions of people around the world can truly change."
  },
  {
    "author": "Garrett Hardin",
    "category": "environmental",
    "id": 16806,
    "text": "Why are ecologists and environmentalists so feared and hated? This is because in part what they have to say is new to the general public, and the new is always alarming."
  },
  {
    "author": "David Frum",
    "category": "environmental",
    "id": 16913,
    "text": "Why should we not expect self-designated environmental leaders to practice what they preach?"
  },
  {
    "author": "Preston Manning",
    "category": "environmental",
    "id": 17005,
    "text": "There are more effective ways of tackling environmental problems including global warming, proliferation of plastics, urban sprawl, and the loss of biodiversity than by treaties, top-down regulations, and other approaches offered by big governments and their dependents."
  },
  {
    "author": "Al Gore",
    "category": "environmental",
    "id": 16822,
    "text": "Our world faces a true planetary emergency. I know the phrase sounds shrill, and I know it's a challenge to the moral imagination."
  },
  {
    "author": "Norm Dicks",
    "category": "environmental",
    "id": 16840,
    "text": "The Endangered Species Act is the strongest and most effective tool we have to repair the environmental harm that is causing a species to decline."
  },
  {
    "author": "Roger Tory Peterson",
    "category": "environmental",
    "id": 16820,
    "text": "Not all is doom and gloom. We are beginning to understand the natural world and are gaining a reverence for life - all life."
  },
  {
    "author": "Jim Clyburn",
    "category": "environmental",
    "id": 16973,
    "text": "But reducing harmful emissions, abating our dependence on foreign oil and developing alternative renewable energy sources have benefits that go beyond environmental health, they improve personal health, enhance national security and encourage our nation's economic viability."
  },
  {
    "author": "Henry David Thoreau",
    "category": "environmental",
    "id": 16784,
    "text": "Thank God men cannot fly, and lay waste the sky as well as the earth."
  },
  {
    "author": "Bonnie Wright",
    "category": "environmental",
    "id": 16999,
    "text": "It is extremely important to me that the social and environmental issues associated with the production of fashion clothing are addressed."
  },
  {
    "author": "Barry Commoner",
    "category": "environmental",
    "id": 16898,
    "text": "The most meaningful engine of change, powerful enough to confront corporate power, may be not so much environmental quality, as the economic development and growth associated with the effort to improve it."
  }
]

quotes['equality'] = [
  {
    "author": "Leland Stanford",
    "category": "equality",
    "id": 17221,
    "text": "The rights of one sex, political and otherwise, are the same as those of the other sex, and this equality of rights ought to be fully recognized."
  },
  {
    "author": "John Hope",
    "category": "equality",
    "id": 17295,
    "text": "If money, education, and honesty will not bring to me as much privilege, as much equality as they bring to any American citizen, then they are to me a curse, and not a blessing."
  },
  {
    "author": "Francois Hollande",
    "category": "equality",
    "id": 17165,
    "text": "Each country has a soul, and France's soul is equality."
  },
  {
    "author": "Laura Chinchilla",
    "category": "equality",
    "id": 17287,
    "text": "The Internet is the hope of an integrated world without frontiers, a common world without controlling owners, a world of opportunities and equality. This is a utopia that we have been dreaming about and is a world in which each and every one of us are protagonists of a destiny that we have in our hands."
  },
  {
    "author": "Joan Jett",
    "category": "equality",
    "id": 17138,
    "text": "The media says that equality for women has arrived, but if you look around, you still don't see girls playing guitars and having success with it."
  },
  {
    "author": "Jeane Kirkpatrick",
    "category": "equality",
    "id": 17169,
    "text": "Democracy not only requires equality but also an unshakable conviction in the value of each person, who is then equal."
  },
  {
    "author": "Alexis de Tocqueville",
    "category": "equality",
    "id": 17088,
    "text": "Democracy and socialism have nothing in common but one word, equality. But notice the difference: while democracy seeks equality in liberty, socialism seeks equality in restraint and servitude."
  },
  {
    "author": "David Cameron",
    "category": "equality",
    "id": 17103,
    "text": "Half a century ago, the amazing courage of Rosa Parks, the visionary leadership of Martin Luther King, and the inspirational actions of the civil rights movement led politicians to write equality into the law and make real the promise of America for all her citizens."
  },
  {
    "author": "Frances Wright",
    "category": "equality",
    "id": 17046,
    "text": "Equality is the soul of liberty there is, in fact, no liberty without it."
  },
  {
    "author": "Bell Hooks",
    "category": "equality",
    "id": 17150,
    "text": "What's really sad is that so many young women between the ages of 16 and 25 are ignorant and they already believe that women get the same pay as men. They don't even really understand that equality hasn't happened with the pay force."
  },
  {
    "author": "Pope John XXIII",
    "category": "equality",
    "id": 17107,
    "text": "The true and solid peace of nations consists not in equality of arms, but in mutual trust alone."
  },
  {
    "author": "Simone Weil",
    "category": "equality",
    "id": 17109,
    "text": "Humanism was not wrong in thinking that truth, beauty, liberty, and equality are of infinite value, but in thinking that man can get them for himself without grace."
  },
  {
    "author": "Paul Dirac",
    "category": "equality",
    "id": 17177,
    "text": "I should like to suggest to you that the cause of all the economic troubles is that we have an economic system which tries to maintain an equality of value between two things, which it would be better to recognise from the beginning as of unequal value."
  },
  {
    "author": "Mary Wollstonecraft",
    "category": "equality",
    "id": 17067,
    "text": "Virtue can only flourish among equals."
  },
  {
    "author": "Allen West",
    "category": "equality",
    "id": 17127,
    "text": "Take your message of equality of achievement, take your message of economic dependency, take your message of enslaving the entrepreneurial will and spirit of the American people somewhere else."
  },
  {
    "author": "Adlai E. Stevenson",
    "category": "equality",
    "id": 17134,
    "text": "We must recover the element of quality in our traditional pursuit of equality. We must not, in opening our schools to everyone, confuse the idea that all should have equal chance with the notion that all have equal endowments."
  },
  {
    "author": "Harlan Stone",
    "category": "equality",
    "id": 17296,
    "text": "Distinctions between citizens solely because of their ancestry are by their very nature odious to a free people whose institutions are founded upon the doctrine of equality."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "equality",
    "id": 17025,
    "text": "The sweltering summer of the Negro's legitimate discontent will not pass until there is an invigorating autumn of freedom and equality."
  },
  {
    "author": "Nancy Pelosi",
    "category": "equality",
    "id": 17162,
    "text": "For 25 years, it has been my privilege to represent the city of San Francisco and the great state of California to work to strengthen our vibrant middle class to secure opportunity and equality."
  },
  {
    "author": "Rowan D. Williams",
    "category": "equality",
    "id": 17182,
    "text": "Friendship is something that creates equality and mutuality, not a reward for finding equality or a way of intensifying existing mutuality."
  },
  {
    "author": "Brian Cox",
    "category": "equality",
    "id": 17232,
    "text": "Feudal societies don't create great cinema we have great theatre. The egalitarian societies create great cinema. The Americans, the French. Because equality is sort of what the cinema deals with. It deals with stories which don't fall into 'Everybody in their place and who's who,' and all that. But the theatre's full of that."
  },
  {
    "author": "Geoff Hoon",
    "category": "equality",
    "id": 17275,
    "text": "I joined the Labour party because I believed in equality, in freedom of speech and in tolerance, compassion and understanding for people, irrespective of their background and views. In whatever I decide to do in the future I will hold to those principles."
  },
  {
    "author": "Francis Wright",
    "category": "equality",
    "id": 17236,
    "text": "It will appear evident upon attentive consideration that equality of intellectual and physical advantages is the only sure foundation of liberty, and that such equality may best, and perhaps only, be obtained by a union of interests and cooperation in labor."
  },
  {
    "author": "Max Nordau",
    "category": "equality",
    "id": 17205,
    "text": "Civilization is built on a number of ultimate principles... respect for human life, the punishment of crimes against property and persons, the equality of all good citizens before the law... or, in a word justice."
  },
  {
    "author": "Benjamin Tucker",
    "category": "equality",
    "id": 17248,
    "text": "Such security is equal liberty. But it is not necessarily equality in the use of the earth."
  },
  {
    "author": "Steven Pinker",
    "category": "equality",
    "id": 17215,
    "text": "As many political writers have pointed out, commitment to political equality is not an empirical claim that people are clones."
  },
  {
    "author": "Hideki Tojo",
    "category": "equality",
    "id": 17247,
    "text": "I would point out that Japan's proposal at the Versailles Peace Conference on the principle of racial equality was rejected by delegates such as those from Britain and the United States."
  },
  {
    "author": "Sonia Sotomayor",
    "category": "equality",
    "id": 17131,
    "text": "Until we get equality in education, we won't have an equal society."
  },
  {
    "author": "Agnes Macphail",
    "category": "equality",
    "id": 17073,
    "text": "I want for myself what I want for other women, absolute equality."
  },
  {
    "author": "Barack Obama",
    "category": "equality",
    "id": 17094,
    "text": "With patient and firm determination, I am going to press on for jobs. I'm going to press on for equality. I'm going to press on for the sake of our children. I'm going to press on for the sake of all those families who are struggling right now. I don't have time to feel sorry for myself. I don't have time to complain. I am going to press on."
  },
  {
    "author": "Plato",
    "category": "equality",
    "id": 17095,
    "text": "Then not only custom, but also nature affirms that to do is more disgraceful than to suffer injustice, and that justice is equality."
  },
  {
    "author": "Pierre de Coubertin",
    "category": "equality",
    "id": 17225,
    "text": "All sports must be treated on the basis of equality."
  },
  {
    "author": "Mercy Otis Warren",
    "category": "equality",
    "id": 17081,
    "text": "Democratic principles are the result of equality of condition."
  },
  {
    "author": "Kareem Abdul-Jabbar",
    "category": "equality",
    "id": 17140,
    "text": "Jackie Robinson, as an athlete and as someone who was trying to make a stand for equality, he was exemplary."
  },
  {
    "author": "Hilary Rosen",
    "category": "equality",
    "id": 17262,
    "text": "As a partner in a firm full of women who work outside of the home as well as stay at home mothers, all with plenty of children, gender equality is not a talking point for me. It is an issue I live every day."
  },
  {
    "author": "Carolyn Maloney",
    "category": "equality",
    "id": 17284,
    "text": "The only way to ensure equality for women is to clearly declare it in our Constitution."
  },
  {
    "author": "Will Rogers",
    "category": "equality",
    "id": 17032,
    "text": "We will never have true civilization until we have learned to recognize the rights of others."
  },
  {
    "author": "Jennifer Aniston",
    "category": "equality",
    "id": 17125,
    "text": "OK, in all seriousness, I would say I couldn't be in a relationship without equality, generosity, integrity, spirit, kindness and humor. And awesomeness."
  },
  {
    "author": "Rudyard Kipling",
    "category": "equality",
    "id": 17043,
    "text": "All the people like us are we, and everyone else is They."
  },
  {
    "author": "Kathleen Parker",
    "category": "equality",
    "id": 17264,
    "text": "Earlier feminists were almost universally pro-choice and have dominated political debate until now. Having access to abortion was viewed as the only way women could have full equality with men, who, until recently, couldn't get pregnant."
  },
  {
    "author": "Vladimir Kramnik",
    "category": "equality",
    "id": 17224,
    "text": "Okay, when you start to fight for equality, like Anand did in 1995, you could end up losing game 10, like he did, without putting up any kind of fight."
  },
  {
    "author": "Frances Wright",
    "category": "equality",
    "id": 17226,
    "text": "How are men to be secured in any rights without instruction how to be secured in the equal exercise of those rights without equality of instruction? By instruction understand me to mean knowledge - just knowledge not talent, not genius, not inventive mental powers."
  },
  {
    "author": "Salmon P. Chase",
    "category": "equality",
    "id": 17076,
    "text": "All men are born equally free."
  },
  {
    "author": "Robert Bork",
    "category": "equality",
    "id": 17152,
    "text": "The purpose that brought the fourteenth amendment into being was equality before the law, and equality, not separation, was written into the law."
  },
  {
    "author": "Theodore Bikel",
    "category": "equality",
    "id": 17164,
    "text": "I am a universalist, passionately devoted to the cause of equality within the human family."
  },
  {
    "author": "Toni Morrison",
    "category": "equality",
    "id": 17065,
    "text": "Women's rights is not only an abstraction, a cause it is also a personal affair. It is not only about us it is also about me and you. Just the two of us."
  },
  {
    "author": "Catharine MacKinnon",
    "category": "equality",
    "id": 17253,
    "text": "In a society in which equality is a fact, not merely a word, words of racial or sexual assault and humiliation will be nonsense syllables."
  },
  {
    "author": "Bono",
    "category": "equality",
    "id": 17116,
    "text": "You see, Africa makes a fool of our idea of justice. It makes a farce of our idea of equality. It mocks our pieties. It doubts our concern. It questions our commitment. Because there is no way we can look at what's happening in Africa, and if we're honest, conclude that it would ever be allowed to happen anywhere else."
  },
  {
    "author": "Thomas Mann",
    "category": "equality",
    "id": 17151,
    "text": "It is a strange fact that freedom and equality, the two basic ideas of democracy, are to some extent contradictory. Logically considered, freedom and equality are mutually exclusive, just as society and the individual are mutually exclusive."
  },
  {
    "author": "Tran Duc Luong",
    "category": "equality",
    "id": 17292,
    "text": "Humanistic values of equality and equal rights for all nations and individuals as crystallized in the principles of the United Nations Charter are mankind's great achievements in the 20th century."
  },
  {
    "author": "Rick Warren",
    "category": "equality",
    "id": 17126,
    "text": "I happen to agree with many of the liberal emphasis on compassion, justice and equality. I just disagree that it's the government's role to provide everything."
  },
  {
    "author": "Marlo Thomas",
    "category": "equality",
    "id": 17074,
    "text": "In the 1960s we were fighting to be recognized as equals in the marketplace, in marriage, in education and on the playing field. It was a very exciting, rebellious time."
  },
  {
    "author": "John O. Brennan",
    "category": "equality",
    "id": 17230,
    "text": "Where terrorists offer injustice, disorder and destruction, the United States and its allies stand for freedom, fairness, equality, hope, and opportunity."
  },
  {
    "author": "Johann Lamont",
    "category": "equality",
    "id": 17260,
    "text": "Scotland is my country, the nation that shaped me, that taught me my values. A nation whose achievements inspired and inspire me, a community whose failings drive me - drive my overwhelming desire to fight for social justice and equality."
  },
  {
    "author": "Pratibha Patil",
    "category": "equality",
    "id": 17271,
    "text": "Women have talent and intelligence but, due to social constraints and prejudices, it is still a long distance away from the goal of gender equality."
  },
  {
    "author": "Aristotle",
    "category": "equality",
    "id": 17029,
    "text": "If liberty and equality, as is thought by some, are chiefly to be found in democracy, they will be best attained when all persons alike share in government to the utmost."
  },
  {
    "author": "Elizabeth Moss",
    "category": "equality",
    "id": 17276,
    "text": "Obviously, my life and my job in 2010 is very different from Peggy's experience in the 1960s. I exist in a world that enjoys more equality between men and women. But I don't take any of that into my performance. I just want to play the character as who she is as an individual - scene to scene."
  },
  {
    "author": "Martha Plimpton",
    "category": "equality",
    "id": 17139,
    "text": "The word 'equality' shows up too much in our founding documents for anyone to pretend it's not the American way."
  },
  {
    "author": "Ruth Bader Ginsburg",
    "category": "equality",
    "id": 17263,
    "text": "I said on the equality side of it, that it is essential to a woman's equality with man that she be the decision-maker, that her choice be controlling."
  },
  {
    "author": "Robert Kennedy",
    "category": "equality",
    "id": 17037,
    "text": "If any man claims the Negro should be content... let him say he would willingly change the color of his skin and go to live in the Negro section of a large city. Then and only then has he a right to such a claim."
  },
  {
    "author": "Christine Gregoire",
    "category": "equality",
    "id": 17075,
    "text": "I want to work on respecting individuals' dignity. Equal rights, that's where my heart is. That means equal rights and benefits, and that's what we need."
  },
  {
    "author": "Anne Campbell",
    "category": "equality",
    "id": 17210,
    "text": "Elections are also about the future - the pledges that we are making for this country. For those who care about equality and fairness in the UK, and beyond, Labour really is the only choice."
  },
  {
    "author": "Ken Livingstone",
    "category": "equality",
    "id": 17261,
    "text": "There needs to be radical development in equality law to create the environment to allow women to stay in work."
  },
  {
    "author": "Robert Reich",
    "category": "equality",
    "id": 17220,
    "text": "The liberal ideal is that everyone should have fair access and fair opportunity. This is not equality of result. It's equality of opportunity. There's a fundamental difference."
  },
  {
    "author": "Michelle Bachelet",
    "category": "equality",
    "id": 17203,
    "text": "U.N. Women was created due to the acknowledgement that gender equality and women's empowerment was still, despite progress, far from what it should be. Transforming political will and decisions, such as the Member States creating U.N. Women, into concrete steps towards gender equality and women's empowerment, I think is one of the main challenges."
  },
  {
    "author": "Zachary Quinto",
    "category": "equality",
    "id": 17141,
    "text": "Our society needs to recognize the unstoppable momentum toward unequivocal civil equality for every gay, lesbian, bisexual and transgendered citizen of this country."
  },
  {
    "author": "Kofi Annan",
    "category": "equality",
    "id": 17102,
    "text": "Gender equality is more than a goal in itself. It is a precondition for meeting the challenge of reducing poverty, promoting sustainable development and building good governance."
  },
  {
    "author": "Samuel Alito",
    "category": "equality",
    "id": 17066,
    "text": "Private religious speech can't be discriminated against. It has to be treated equally with secular speech."
  },
  {
    "author": "Robert Toombs",
    "category": "equality",
    "id": 17255,
    "text": "Give us equality of enjoyment, equal right to expansion - it is as necessary to our prosperity as yours."
  },
  {
    "author": "Carl Schurz",
    "category": "equality",
    "id": 17041,
    "text": "From the equality of rights springs identity of our highest interests you cannot subvert your neighbor's rights without striking a dangerous blow at your own."
  },
  {
    "author": "Bernadette Devlin",
    "category": "equality",
    "id": 17136,
    "text": "Among the best traitors Ireland has ever had, Mother Church ranks at the very top, a massive obstacle in the path to equality and freedom. She has been a force for conservatism... to ward off threats to her own security and influence."
  },
  {
    "author": "Mao Zedong",
    "category": "equality",
    "id": 17146,
    "text": "Genuine equality between the sexes can only be realized in the process of the socialist transformation of society as a whole."
  },
  {
    "author": "Gerry Adams",
    "category": "equality",
    "id": 17194,
    "text": "The unionists also for their part, want to minimise the potential for change, not only on the equality agenda but on the issues of sovereignty and ending the union."
  },
  {
    "author": "Slobodan Milosevic",
    "category": "equality",
    "id": 17299,
    "text": "Equality means nothing unless incorporated into the institutions."
  },
  {
    "author": "Tom Robbins",
    "category": "equality",
    "id": 17064,
    "text": "Equality is not in regarding different things similarly, equality is in regarding different things differently."
  },
  {
    "author": "Thomas Paine",
    "category": "equality",
    "id": 17093,
    "text": "I believe in the equality of man and I believe that religious duties consist in doing justice, loving mercy, and endeavoring to make our fellow-creatures happy."
  },
  {
    "author": "Samuel Johnson",
    "category": "equality",
    "id": 17052,
    "text": "It is better that some should be unhappy rather than that none should be happy, which would be the case in a general state of equality."
  },
  {
    "author": "Muhammad Ali Jinnah",
    "category": "equality",
    "id": 17055,
    "text": "No struggle can ever succeed without women participating side by side with men."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "equality",
    "id": 17022,
    "text": "I have a dream that my four little children will one day live in a nation where they will not be judged by the color of their skin, but by the content of their character."
  },
  {
    "author": "Irving Kristol",
    "category": "equality",
    "id": 17056,
    "text": "Democracy does not guarantee equality of conditions - it only guarantees equality of opportunity."
  },
  {
    "author": "Ed Miliband",
    "category": "equality",
    "id": 17259,
    "text": "And think of how we challenged the idea of a male dominated Parliament with All-Women shortlists and made the cause of gender equality central to our government. We were right to do so."
  },
  {
    "author": "Stephen Lewis",
    "category": "equality",
    "id": 17190,
    "text": "Unless there is recognition that women are most vulnerable... and you do something about social and cultural equality for women, you're never going to defeat this pandemic."
  },
  {
    "author": "Mario Vargas Llosa",
    "category": "equality",
    "id": 17167,
    "text": "Prosperity or egalitarianism - you have to choose. I favor freedom - you never achieve real equality anyway: you simply sacrifice prosperity for an illusion."
  },
  {
    "author": "James Bovard",
    "category": "equality",
    "id": 17187,
    "text": "The vision that the founding fathers had of rule of law and equality before the law and no one above the law, that is a very viable vision, but instead of that, we have quasi mob rule."
  },
  {
    "author": "Joe Baca",
    "category": "equality",
    "id": 17179,
    "text": "It is crucial that members of Congress cast votes that are supportive of the values upon which our nation was founded: equality, freedom, and opportunity for all people."
  },
  {
    "author": "Charles Rangel",
    "category": "equality",
    "id": 17191,
    "text": "The Klan had used fear, intimidation and murder to brutally oppress over African-Americans who sought justice and equality and it sought to respond to the young workers of the civil rights movement in Mississippi in the same way."
  },
  {
    "author": "George Smathers",
    "category": "equality",
    "id": 17185,
    "text": "I don't believe in social equality, and they know it."
  },
  {
    "author": "Johanna Siguroardottir",
    "category": "equality",
    "id": 17293,
    "text": "The Nordic countries are leading the way on women's equality, recognizing women as equal citizens rather than commodities for sale."
  },
  {
    "author": "Philip James Bailey",
    "category": "equality",
    "id": 17149,
    "text": "The sole equality on earth is death."
  },
  {
    "author": "Jose Luis Rodriguez Zapatero",
    "category": "equality",
    "id": 17159,
    "text": "The more equality women have, the fairer, more civilized and tolerant society will be. Sexual equality is a lot more effective against terrorism than military strength."
  },
  {
    "author": "Harry Bridges",
    "category": "equality",
    "id": 17154,
    "text": "There will always be a place for us somewhere, somehow, as long as we see to it that working people fight for everything they have, everything they hope to get, for dignity, equality, democracy, to oppose war and to bring to the world a better life."
  },
  {
    "author": "Arthur Hugh Clough",
    "category": "equality",
    "id": 17290,
    "text": "The highest political buzz word is not liberty, equality, fraternity or solidarity it is service."
  },
  {
    "author": "Mikhail Bakunin",
    "category": "equality",
    "id": 17113,
    "text": "From the naturalistic point of view, all men are equal. There are only two exceptions to this rule of naturalistic equality: geniuses and idiots."
  },
  {
    "author": "Raoul Vaneigem",
    "category": "equality",
    "id": 17244,
    "text": "In the kingdom of consumption the citizen is king. A democratic monarchy: equality before consumption, fraternity in consumption, and freedom through consumption."
  },
  {
    "author": "David Allan Coe",
    "category": "equality",
    "id": 17045,
    "text": "All men are created equal, it is only men themselves who place themselves above equality."
  },
  {
    "author": "Emanuel Celler",
    "category": "equality",
    "id": 17239,
    "text": "On the one hand we publicly pronounce the equality of all peoples on the other hand, in our immigration laws, we embrace in practice these very theories we abhor and verbally condemn."
  },
  {
    "author": "Mike Honda",
    "category": "equality",
    "id": 17070,
    "text": "Equal pay isn't just a women's issue when women get equal pay, their family incomes rise and the whole family benefits."
  },
  {
    "author": "Vidal Sassoon",
    "category": "equality",
    "id": 17158,
    "text": "I believe in the equality of man and I believe that religious duties consist in doing justice, loving mercy, and endeavoring to make our fellow-creatures happy."
  },
  {
    "author": "Ellen Pompeo",
    "category": "equality",
    "id": 17233,
    "text": "There's a remarkable amount of sexism on TV. When male characters are flawed, they're interesting, deep and complex. But when female characters are flawed, they're just a mess. It's good to put more flawed but interesting female characters out there because it promotes equality."
  },
  {
    "author": "Imelda Staunton",
    "category": "equality",
    "id": 17219,
    "text": "Looking back, there is nothing wrong with that peace, love and equality that the hippies espoused. In many ways, we have regressed because they were into organic food, back to nature, make love not war, be good to all men, share and share alike - which is what many are talking about now."
  }
]

quotes['experience'] = [
  {
    "author": "Jack Kevorkian",
    "category": "experience",
    "id": 18199,
    "text": "My ultimate aim is to make euthanasia a positive experience."
  },
  {
    "author": "Daniel J. Boorstin",
    "category": "experience",
    "id": 17612,
    "text": "The traveler was active he went strenuously in search of people, of adventure, of experience. The tourist is passive he expects interesting things to happen to him. He goes 'sight-seeing.'"
  },
  {
    "author": "Emily Procter",
    "category": "experience",
    "id": 18238,
    "text": "It's really fun at night, because I can see the baby kicking. I can feel the knee or the foot. The baby is starting to get heavy, and it's a really incredible feeling. I'm so grateful I get to experience this."
  },
  {
    "author": "Rebecca West",
    "category": "experience",
    "id": 17869,
    "text": "There is no wider gulf in the universe than yawns between those on the hither and thither side of vital experience."
  },
  {
    "author": "Kathryn Bigelow",
    "category": "experience",
    "id": 18216,
    "text": "When he brought it to me four years ago, Rodney King had just arrived, I was involved in the clean-up of L.A. and I guess it was part of my experience."
  },
  {
    "author": "Tom Stoppard",
    "category": "experience",
    "id": 17622,
    "text": "I write out of my intellectual experience."
  },
  {
    "author": "Lord Chesterfield",
    "category": "experience",
    "id": 17669,
    "text": "I find, by experience, that the mind and the body are more than married, for they are most intimately united and when one suffers, the other sympathizes."
  },
  {
    "author": "Harlan Coben",
    "category": "experience",
    "id": 17931,
    "text": "No characters in 'Stay Close,' including the leads, are black and white. I want them to be grey. I think that makes for a much more interesting reading experience, something that will stay with you a little bit longer."
  },
  {
    "author": "Keanu Reeves",
    "category": "experience",
    "id": 17735,
    "text": "I mean, if you didn't get it or if you didn't feel like you enjoyed it, sometimes that experience can change."
  },
  {
    "author": "Greg Anderson",
    "category": "experience",
    "id": 17533,
    "text": "Let us be about setting high standards for life, love, creativity, and wisdom. If our expectations in these areas are low, we are not likely to experience wellness. Setting high standards makes every day and every decade worth looking forward to."
  },
  {
    "author": "Jane Campion",
    "category": "experience",
    "id": 18132,
    "text": "With 'Bright Star' and with 'The Piano,' too, I felt a kind of sadness about it being in such a different era, because of my lack of experience with the era. And one of the ways I'd get over it is to remind myself that every film, even if it's contemporary, creates its own world."
  },
  {
    "author": "Tracey Emin",
    "category": "experience",
    "id": 17950,
    "text": "What is truth? Truth doesn't really exist. Who is going to judge whether my experience of an incident is more valid than yours? No one can be trusted to be the judge of that."
  },
  {
    "author": "Denis Waitley",
    "category": "experience",
    "id": 17506,
    "text": "Never become so much of an expert that you stop gaining expertise. View life as a continuous learning experience."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "experience",
    "id": 17314,
    "text": "The years teach much which the days never know."
  },
  {
    "author": "Diane Arbus",
    "category": "experience",
    "id": 17525,
    "text": "Most people go through life dreading they'll have a traumatic experience. Freaks were born with their trauma. They've already passed their test in life. They're aristocrats."
  },
  {
    "author": "Isabelle Adjani",
    "category": "experience",
    "id": 18182,
    "text": "There are people who never experience that, who remain closed until death, from fear of change."
  },
  {
    "author": "Richard Dawkins",
    "category": "experience",
    "id": 17545,
    "text": "But perhaps the rest of us could have separate classes in science appreciation, the wonder of science, scientific ways of thinking, and the history of scientific ideas, rather than laboratory experience."
  },
  {
    "author": "Celine Dion",
    "category": "experience",
    "id": 18287,
    "text": "I will perform My Heart Will Go On for the rest of my life and it will always remain a very emotional experience for me."
  },
  {
    "author": "Richard Cecil",
    "category": "experience",
    "id": 18195,
    "text": "God's way of answering the Christian's prayer for more patience, experience, hope and love often is to put him into the furnace of affliction."
  },
  {
    "author": "Emma Watson",
    "category": "experience",
    "id": 17628,
    "text": "But it's a journey and the sad thing is you only learn from experience, so as much as someone can tell you things, you have to go out there and make your own mistakes in order to learn."
  },
  {
    "author": "Margaret J. Wheatley",
    "category": "experience",
    "id": 17741,
    "text": "We experience problem-solving sessions as war zones, we view competing ideas as enemies, and we use problems as weapons to blame and defeat opposition forces. No wonder we can't come up with real lasting solutions!"
  },
  {
    "author": "Rachael Ray",
    "category": "experience",
    "id": 18137,
    "text": "Whatever it is you want to do, take a job in that field. You will learn by experience and, slow and steady, you'll get it done!"
  },
  {
    "author": "Trey Anastasio",
    "category": "experience",
    "id": 18240,
    "text": "I've always loved the experience of working together with other people toward an artistic goal."
  },
  {
    "author": "Heinrich Heine",
    "category": "experience",
    "id": 17336,
    "text": "Experience is a good school. But the fees are high."
  },
  {
    "author": "Paul Walker",
    "category": "experience",
    "id": 17680,
    "text": "Surfing soothes me, it's always been a kind of Zen experience for me. The ocean is so magnificent, peaceful, and awesome. The rest of the world disappears for me when I'm on a wave."
  },
  {
    "author": "Abigail Van Buren",
    "category": "experience",
    "id": 17325,
    "text": "If we could sell our experiences for what they cost us, we'd all be millionaires."
  },
  {
    "author": "Eric Bana",
    "category": "experience",
    "id": 17783,
    "text": "I've always been attracted to cars, and driving is a completely measurable experience: if you qualify last on the grid, you're the slowest, and if you qualify first on the grid, you're the fastest. So no one can say you're slow if you're fast and no one can say you're fast if you're slow."
  },
  {
    "author": "Muhammad Iqbal",
    "category": "experience",
    "id": 17751,
    "text": "Another way of judging the value of a prophet's religious experience, therefore, would be to examine the type of manhood that he has created, and the cultural world that has sprung out of the spirit of his message."
  },
  {
    "author": "Wilbur Smith",
    "category": "experience",
    "id": 18235,
    "text": "I have been blessed in many ways, and one of those is to have been born in Africa, for me a great treasure house of stories. I have been researching it since my infancy reading about it, talking to men and women who have spent their lives in this land, living it as I have and loving it as I do. I write almost entirely from my own experience."
  },
  {
    "author": "J. Paul Getty",
    "category": "experience",
    "id": 17518,
    "text": "In times of rapid change, experience could be your worst enemy."
  },
  {
    "author": "Bill Watterson",
    "category": "experience",
    "id": 17640,
    "text": "Talking with you is sort of the conversational equivalent of an out of body experience."
  },
  {
    "author": "Willie Stargell",
    "category": "experience",
    "id": 18123,
    "text": "I eventually became proud of my strikeouts, because each one represented another learning experience."
  },
  {
    "author": "Joyce Meyer",
    "category": "experience",
    "id": 17483,
    "text": "I know from personal experience how damaging it can be to live with bitterness and unforgiveness. I like to say it's like taking poison and hoping your enemy will die. And it really is that harmful to us to live this way."
  },
  {
    "author": "Edward Witten",
    "category": "experience",
    "id": 17747,
    "text": "As for the forces, electromagnetism and gravity we experience in everyday life. But the weak and strong forces are beyond our ordinary experience. So in physics, lots of the basic building blocks take 20th- or perhaps 21st-century equipment to explore."
  },
  {
    "author": "Deepak Chopra",
    "category": "experience",
    "id": 17534,
    "text": "The physical world, including our bodies, is a response of the observer. We create our bodies as we create the experience of our world."
  },
  {
    "author": "Lewis Mumford",
    "category": "experience",
    "id": 17841,
    "text": "Without fullness of experience, length of days is nothing. When fullness of life has been achieved, shortness of days is nothing. That is perhaps why the young have usually so little fear of death they live by intensities that the elderly have forgotten."
  },
  {
    "author": "Mike Krzyzewski",
    "category": "experience",
    "id": 17928,
    "text": "Fun is to experience things you would not have been able to experience in any other setting."
  },
  {
    "author": "Arthur Miller",
    "category": "experience",
    "id": 17849,
    "text": "The problem was to sustain at any cost the feeling you had in the theater that you were watching a real person, yes, but an intense condensation of his experience, not simply a realistic series of episodes."
  },
  {
    "author": "Oprah Winfrey",
    "category": "experience",
    "id": 17401,
    "text": "I am a woman in process. I'm just trying like everybody else. I try to take every conflict, every experience, and learn from it. Life is never dull."
  },
  {
    "author": "Lenny Kravitz",
    "category": "experience",
    "id": 17895,
    "text": "I always try to keep the circumstances in my life fresh. I like to change the physical environment I live in, change the people around me and try to experience things for the first time. I think that keeps one on their toes, creatively and spiritually."
  },
  {
    "author": "William Osler",
    "category": "experience",
    "id": 17347,
    "text": "The value of experience is not in seeing much, but in seeing wisely."
  },
  {
    "author": "Michelle Bachelet",
    "category": "experience",
    "id": 18075,
    "text": "My father respected and admired my mother and was a person who was always standing by my side, encouraging me to do more and believed in my capacity. So in that sense, my own experience was very good in becoming an empowered woman. From early on, I carried that strong message: 'You can do it.' So I never had any doubt that women can do a lot."
  },
  {
    "author": "Ernie Harwell",
    "category": "experience",
    "id": 18083,
    "text": "Baseball is a rookie, his experience no bigger than the lump in his throat as he begins fulfillment of his dream."
  },
  {
    "author": "David Copperfield",
    "category": "experience",
    "id": 18188,
    "text": "Magicians lose the opportunity to experience a sense of wonder."
  },
  {
    "author": "Jonathan Swift",
    "category": "experience",
    "id": 17616,
    "text": "No man was ever so completely skilled in the conduct of life, as not to receive new information from age and experience."
  },
  {
    "author": "Brian Tracy",
    "category": "experience",
    "id": 17565,
    "text": "Whatever you dwell on in the conscious grows in your experience."
  },
  {
    "author": "Mary Baker Eddy",
    "category": "experience",
    "id": 17863,
    "text": "Disease is an experience of a so-called mortal mind. It is fear made manifest on the body."
  },
  {
    "author": "Bertrand Russell",
    "category": "experience",
    "id": 17492,
    "text": "In the revolt against idealism, the ambiguities of the word experience have been perceived, with the result that realists have more and more avoided the word."
  },
  {
    "author": "Dan Savage",
    "category": "experience",
    "id": 17922,
    "text": "The bullied straight kid goes home to a shoulder to cry on and support and can talk freely about his experience at school and why he's being bullied. I couldn't go home and open up to my parents."
  },
  {
    "author": "Billy Joel",
    "category": "experience",
    "id": 17595,
    "text": "Historically, musicians know what it is like to be outside the norm - walking the high wire without a safety net. Our experience is not so different from those who march to the beat of different drummers."
  },
  {
    "author": "Emil Zatopek",
    "category": "experience",
    "id": 17465,
    "text": "If you want to run, run a mile. If you want to experience a different life, run a marathon."
  },
  {
    "author": "Alan Dershowitz",
    "category": "experience",
    "id": 18022,
    "text": "I learn from experience."
  },
  {
    "author": "Alphonse de Lamartine",
    "category": "experience",
    "id": 17356,
    "text": "Experience is the only prophecy of wise men."
  },
  {
    "author": "Bob Geldof",
    "category": "experience",
    "id": 17575,
    "text": "But if somebody dies, if something happens to you, there is a normal process of depression, it is part of being human, and some people view it as a learning experience etc."
  },
  {
    "author": "Friedrich Schiller",
    "category": "experience",
    "id": 17650,
    "text": "The key to education is the experience of beauty."
  },
  {
    "author": "Michael Sheen",
    "category": "experience",
    "id": 18012,
    "text": "Stories have always been the things that entertain me and make me feel happy and sad and move me and give me the experience of being able to live many lives in one lifetime. It's the best thing about being alive."
  },
  {
    "author": "George Osborne",
    "category": "experience",
    "id": 18226,
    "text": "I had the closest thing I have ever had to an out-of-body experience lying in bed one morning. I turned on the 'Today' programme and item four on the news was: 'The shadow chancellor has ruled himself out of the leadership.' I lay there thinking that's interesting, then I realised it was me."
  },
  {
    "author": "Jared Leto",
    "category": "experience",
    "id": 17880,
    "text": "Music is subjective to everyone's unique experience."
  },
  {
    "author": "Louise L. Hay",
    "category": "experience",
    "id": 17348,
    "text": "We are each responsible for all of our experiences."
  },
  {
    "author": "Michael Sheen",
    "category": "experience",
    "id": 18014,
    "text": "I find increasingly that the more extreme are the things going on in your life, the more cultural reference points fail you. More mythical reference points actually help, and you realise that's what myths are for. It's for human beings to process their experience in extremis."
  },
  {
    "author": "Ralph Marston",
    "category": "experience",
    "id": 17315,
    "text": "Excellence is not a skill. It is an attitude."
  },
  {
    "author": "Muhammad Iqbal",
    "category": "experience",
    "id": 17752,
    "text": "The possibility of a scientific treatment of history means a wider experience, a greater maturity of practical reason, and finally a fuller realization of certain basic ideas regarding the nature of life and time."
  },
  {
    "author": "Andrea Arnold",
    "category": "experience",
    "id": 18191,
    "text": "My films don't give you an easy ride. I can see that. The sense I get is that people have quite a physical experience with them. They feel afterwards that they've really been through something."
  },
  {
    "author": "George Eliot",
    "category": "experience",
    "id": 17521,
    "text": "But human experience is usually paradoxical, that means incongruous with the phrases of current talk or even current philosophy."
  },
  {
    "author": "Patrick Henry",
    "category": "experience",
    "id": 17416,
    "text": "I have but one lamp by which my feet are guided, and that is the lamp of experience."
  },
  {
    "author": "Susan Orlean",
    "category": "experience",
    "id": 17737,
    "text": "Living in a rural setting exposes you to so many marvelous things - the natural world and the particular texture of small-town life, and the exhilarating experience of open space."
  },
  {
    "author": "Ai Weiwei",
    "category": "experience",
    "id": 17945,
    "text": "The American experience influenced my understanding of individuality, basic human rights, freedom of expression and the rights and responsibilities of citizens."
  },
  {
    "author": "Jennifer Granholm",
    "category": "experience",
    "id": 17951,
    "text": "America is an idea. And it's the solemn responsibility of each 'temporary' president to protect and nurture that noblest of all ideas - with integrity. This man, Mitt Romney, has shown - not through his experience, but through his actions and words - that he is unqualified to carry out that responsibility."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "experience",
    "id": 17500,
    "text": "The wisdom of the wise and the experience of the ages are perpetuated by quotations."
  },
  {
    "author": "Muhammad Iqbal",
    "category": "experience",
    "id": 17683,
    "text": "But inner experience is only one source of human knowledge."
  },
  {
    "author": "Hannah Arendt",
    "category": "experience",
    "id": 17672,
    "text": "Poets are the only people to whom love is not only a crucial, but an indispensable experience, which entitles them to mistake it for a universal one."
  },
  {
    "author": "Desiderius Erasmus",
    "category": "experience",
    "id": 17633,
    "text": "War is delightful to those who have had no experience of it."
  },
  {
    "author": "Cat Stevens",
    "category": "experience",
    "id": 17674,
    "text": "In those days a concert was a personal experience. I wanted to be as close as possible to the audience, and of course big stadiums didn't enable you to do that. It wasn't my style."
  },
  {
    "author": "Quincy Jones",
    "category": "experience",
    "id": 18252,
    "text": "If you started in New York you were dealing with the biggest guys in the world. You're dealing with Charlie Parker and all the big bands and everything. We got more experience working in Seattle."
  },
  {
    "author": "Franklin P. Adams",
    "category": "experience",
    "id": 17564,
    "text": "The trouble with this country is that there are too many politicians who believe, with a conviction based on experience, that you can fool all of the people all of the time."
  },
  {
    "author": "Navjot Singh Sidhu",
    "category": "experience",
    "id": 17652,
    "text": "Experience is like a comb that life gives you when you are bald."
  },
  {
    "author": "Mia Hamm",
    "category": "experience",
    "id": 17648,
    "text": "I got to experience soccer at the highest level at a young age I decided I wanted to be part of that for as long as possible."
  },
  {
    "author": "Salvador Dali",
    "category": "experience",
    "id": 17466,
    "text": "Each morning when I awake, I experience again a supreme pleasure - that of being Salvador Dali."
  },
  {
    "author": "Eleanor Roosevelt",
    "category": "experience",
    "id": 17397,
    "text": "My experience has been that work is almost the best way to pull oneself out of the depths."
  },
  {
    "author": "T. D. Jakes",
    "category": "experience",
    "id": 18147,
    "text": "I raised five children. They all have different personalities. All of them have different issues, different levels of success. That was a learning experience for me."
  },
  {
    "author": "Gabrielle Union",
    "category": "experience",
    "id": 18007,
    "text": "I like directors who have worked as actors. They know the experience."
  },
  {
    "author": "Denis Waitley",
    "category": "experience",
    "id": 17477,
    "text": "The essence of life is finding something you really love and then making the daily experience worthwhile."
  },
  {
    "author": "Walter Benjamin",
    "category": "experience",
    "id": 17590,
    "text": "Memory is not an instrument for exploring the past but its theatre. It is the medium of past experience, as the ground is the medium in which dead cities lie interred."
  },
  {
    "author": "Vin Diesel",
    "category": "experience",
    "id": 17923,
    "text": "When you go to the movies with your whole family, it's a different experience. For some reason, it's something that you're all doing together and you take away something special in that."
  },
  {
    "author": "Robert Wyatt",
    "category": "experience",
    "id": 17886,
    "text": "Love is blind. My politics has been, too. I think you can fall in love with ideas, and you can fall in love with people. It's a very subjective experience. And I'm loyal to that experience."
  },
  {
    "author": "Sara Blakely",
    "category": "experience",
    "id": 18025,
    "text": "I started thinking about joy. Everything in our society is so purposeful. Let's bring joy back to the experience."
  },
  {
    "author": "Martin Scorsese",
    "category": "experience",
    "id": 17675,
    "text": "Any film, or to me any creative endeavour, no matter who you're working with, is, in many cases, a wonderful experience."
  },
  {
    "author": "James Taylor",
    "category": "experience",
    "id": 17942,
    "text": "Performing is a profound experience, at least for me. It's not as if I sit down and play 'Fire and Rain' by myself, just to hear it again. But to offer it up... the energy that it somehow summons live takes me right back, and I do get a reconnection to the emotions."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "experience",
    "id": 17475,
    "text": "When people speak to you about a preventive war, you tell them to go and fight it. After my experience, I have come to hate war."
  },
  {
    "author": "Gus Van Sant",
    "category": "experience",
    "id": 17858,
    "text": "With 'Good Will Hunting,' Miramax made certain the recruited audience wasn't expecting to laugh at Robin Williams like they normally do. From my limited experience, you can really blow test screenings by conducting them in the wrong way."
  },
  {
    "author": "Joseph Roux",
    "category": "experience",
    "id": 17358,
    "text": "Experience comprises illusions lost, rather than wisdom gained."
  },
  {
    "author": "Ang Lee",
    "category": "experience",
    "id": 17742,
    "text": "I think each movie-making process is a very exhausting and satisfying and fulfilling experience for me."
  },
  {
    "author": "Ralph Fiennes",
    "category": "experience",
    "id": 17808,
    "text": "Being an actor means asking people to look at you. I guess I accept that. But it's a profession in which the job is to show another world and other people. You may access it through bits of yourself, and your imagination and experience, but actually, in the end, you're not playing yourself."
  },
  {
    "author": "Rainer Maria Rilke",
    "category": "experience",
    "id": 17493,
    "text": "The deepest experience of the creator is feminine, for it is experience of receiving and bearing."
  },
  {
    "author": "Joyce Meyer",
    "category": "experience",
    "id": 17606,
    "text": "There are some hurts that we experience that can be forgiven but we won't forget them."
  },
  {
    "author": "Robert Fulghum",
    "category": "experience",
    "id": 17400,
    "text": "I believe that imagination is stronger than knowledge. That myth is more potent than history. That dreams are more powerful than facts. That hope always triumphs over experience. That laughter is the only cure for grief. And I believe that love is stronger than death."
  },
  {
    "author": "Milton Berle",
    "category": "experience",
    "id": 17480,
    "text": "Experience is what you have after you've forgotten her name."
  },
  {
    "author": "Mark Zandi",
    "category": "experience",
    "id": 18237,
    "text": "Past experience with fiscal austerity at home and overseas strongly suggests that it is best for the economy's long-run performance to restrain government spending rather than raise taxes."
  },
  {
    "author": "Lena Dunham",
    "category": "experience",
    "id": 17853,
    "text": "If you're writing, you're starting in private. It can really be this amazing, private, freeing experience. Forget that it's for other people - that comes in later."
  },
  {
    "author": "Shelley Winters",
    "category": "experience",
    "id": 17856,
    "text": "I think on-stage nudity is disgusting, shameful and damaging to all things American. But if I were 22 with a great body, it would be artistic, tasteful, patriotic and a progressive religious experience."
  }
]

quotes['failure'] = [
  {
    "author": "Samuel Smiles",
    "category": "failure",
    "id": 18594,
    "text": "It is a mistake to suppose that men succeed through success they much oftener succeed through failures. Precept, study, advice, and example could never have taught them so well as failure has done."
  },
  {
    "author": "Jon Ronson",
    "category": "failure",
    "id": 18872,
    "text": "Success is always less funny than failure."
  },
  {
    "author": "James Russell Lowell",
    "category": "failure",
    "id": 18506,
    "text": "Greatly begin. Though thou have time, but for a line, be that sublime. Not failure, but low aim is crime."
  },
  {
    "author": "Phyllis Schlafly",
    "category": "failure",
    "id": 18811,
    "text": "Feminism is doomed to failure because it is based on an attempt to repeal and restructure human nature."
  },
  {
    "author": "Alice Foote MacDougall",
    "category": "failure",
    "id": 18980,
    "text": "I simply don't believe in failure. In itself, it doesn't exist. We create it. We make ourselves fail."
  },
  {
    "author": "Michael Fassbender",
    "category": "failure",
    "id": 18772,
    "text": "We feel a lot of pressure about looking silly or appearing weak, whatever that means, or being a failure. You have to keep in your head: what's the worst that can happen?"
  },
  {
    "author": "Benjamin E. Mays",
    "category": "failure",
    "id": 18577,
    "text": "Not failure, but low aim is sin."
  },
  {
    "author": "Elbert Hubbard",
    "category": "failure",
    "id": 18447,
    "text": "The line between failure and success is so fine that we scarcely know when we pass it: so fine that we are often on the line and do not know it."
  },
  {
    "author": "Hank Aaron",
    "category": "failure",
    "id": 18578,
    "text": "Failure is a part of success."
  },
  {
    "author": "David Limbaugh",
    "category": "failure",
    "id": 18819,
    "text": "Some of the reasons John McCain lost in 2008 were his lackluster campaign, his refusal to showcase Obama's extreme liberalism and, thus, his failure to demonstrate why he would make a better president than Obama."
  },
  {
    "author": "Molly Ringwald",
    "category": "failure",
    "id": 18859,
    "text": "I wish I had been more prepared, both for success and for failure, when I was younger."
  },
  {
    "author": "Orison Swett Marden",
    "category": "failure",
    "id": 18340,
    "text": "Achievement is not always success, while reputed failure often is. It is honest endeavor, persistent effort to do the best possible under any and all circumstances."
  },
  {
    "author": "Oscar Wilde",
    "category": "failure",
    "id": 18311,
    "text": "Ambition is the last refuge of the failure."
  },
  {
    "author": "Graham Greene",
    "category": "failure",
    "id": 18632,
    "text": "Success is more dangerous than failure, the ripples break over a wider coastline."
  },
  {
    "author": "Alexander Wang",
    "category": "failure",
    "id": 18765,
    "text": "I think everyone shares a fear of failure - that you're only as good as your most recent collection. That's definitely a fear, but it's a fear that fuels me, that makes me want to work harder, that makes me take on more challenges."
  },
  {
    "author": "Jane Rule",
    "category": "failure",
    "id": 18777,
    "text": "I believe only in art and failure."
  },
  {
    "author": "Mark Edwards",
    "category": "failure",
    "id": 18928,
    "text": "To me, all war is failure for humanity, though it often is a bounty for commerce."
  },
  {
    "author": "Bryant H. McGill",
    "category": "failure",
    "id": 18477,
    "text": "While it is important for people to see your promise you must also remember that hope is the keeper of both happiness and disappointment, the father of both progress and failure."
  },
  {
    "author": "Joseph Barber Lightfoot",
    "category": "failure",
    "id": 18759,
    "text": "We do not realise that we are children of eternity. If we did, then success would be no success, and failure would be no failure to us."
  },
  {
    "author": "Orlando Bloom",
    "category": "failure",
    "id": 18562,
    "text": "Failure is simply the non-presence of success. But a fiasco is a disaster of mythic proportions."
  },
  {
    "author": "Herbert Samuel",
    "category": "failure",
    "id": 18635,
    "text": "It takes two to make a marriage a success and only one to make it a failure."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "failure",
    "id": 18300,
    "text": "Far better is it to dare mighty things, to win glorious triumphs, even though checkered by failure... than to rank with those poor spirits who neither enjoy nor suffer much, because they live in a gray twilight that knows not victory nor defeat."
  },
  {
    "author": "Zig Ziglar",
    "category": "failure",
    "id": 18327,
    "text": "Failure is a detour, not a dead-end street."
  },
  {
    "author": "Doug Coupland",
    "category": "failure",
    "id": 18539,
    "text": "Sometimes failure isn't an opportunity in disguise, it's just you."
  },
  {
    "author": "Ethan Hawke",
    "category": "failure",
    "id": 18704,
    "text": "The biggest problem in my life is trying to be the kind of man that I want to be, the father that I want to be, and how to process the failure of my marriage."
  },
  {
    "author": "Corey Hart",
    "category": "failure",
    "id": 18911,
    "text": "I think you can learn as much from success as you can from failure."
  },
  {
    "author": "Max Beerbohm",
    "category": "failure",
    "id": 18557,
    "text": "There is much to be said for failure. It is much more interesting than success."
  },
  {
    "author": "Michael Malone",
    "category": "failure",
    "id": 19002,
    "text": "I think the greatest taboos in America are faith and failure."
  },
  {
    "author": "Jennifer Lawrence",
    "category": "failure",
    "id": 18685,
    "text": "Even as far back as when I started acting at 14, I know I've never considered failure."
  },
  {
    "author": "Og Mandino",
    "category": "failure",
    "id": 18433,
    "text": "Failure will never overtake me if my determination to succeed is strong enough."
  },
  {
    "author": "Shahrukh Khan",
    "category": "failure",
    "id": 18519,
    "text": "Success is not a good teacher, failure makes you humble."
  },
  {
    "author": "William Whewell",
    "category": "failure",
    "id": 18352,
    "text": "Every failure is a step to success."
  },
  {
    "author": "William Howard Taft",
    "category": "failure",
    "id": 18641,
    "text": "Failure to accord credit to anyone for what he may have done is a great weakness in any man."
  },
  {
    "author": "Elizabeth Pena",
    "category": "failure",
    "id": 18960,
    "text": "When I got Jacob's Latter, I was nervous because I felt I wasn't allowed to fail. I felt that they were waiting for one little failure and that would prove them right and I'd be,'out of there.'"
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "failure",
    "id": 18588,
    "text": "In politics, what begins in fear usually ends in failure."
  },
  {
    "author": "Ben Stiller",
    "category": "failure",
    "id": 18787,
    "text": "The failure of The Cable Guy impacted my career. I had to start writing and acting again."
  },
  {
    "author": "Doc Hastings",
    "category": "failure",
    "id": 18763,
    "text": "As efforts to fix this failure at the Veterans Administration continue, I also intend to persist in demanding answers and action on the establishment of a new clinic to serve the veterans in North Central Washington."
  },
  {
    "author": "Alexandre Dumas",
    "category": "failure",
    "id": 18370,
    "text": "A person who doubts himself is like a man who would enlist in the ranks of his enemies and bear arms against himself. He makes his failure certain by himself being the first person to be convinced of it."
  },
  {
    "author": "Rick Pitino",
    "category": "failure",
    "id": 18909,
    "text": "Failure is good. It's fertilizer. Everything I've learned about coaching, I've learned from making mistakes."
  },
  {
    "author": "William Irwin Thompson",
    "category": "failure",
    "id": 18897,
    "text": "Catastrophes are often stimulated by the failure to feel the emergence of a domain, and so what cannot be felt in the imagination is experienced as embodied sensation in the catastrophe."
  },
  {
    "author": "Tom Cochrane",
    "category": "failure",
    "id": 18451,
    "text": "Tragedy in life normally comes with betrayal and compromise, and trading on your integrity and not having dignity in life. That's really where failure comes."
  },
  {
    "author": "Sarah McLachlan",
    "category": "failure",
    "id": 18681,
    "text": "Coming to terms with the fact that my marriage was a failure was devastating and very difficult."
  },
  {
    "author": "Jim Palmer",
    "category": "failure",
    "id": 18409,
    "text": "Losing is no disgrace if you've given your best."
  },
  {
    "author": "Al Gore",
    "category": "failure",
    "id": 18637,
    "text": "If we don't succeed, we run the risk of failure."
  },
  {
    "author": "Henry Ford",
    "category": "failure",
    "id": 18418,
    "text": "Failure is simply the opportunity to begin again, this time more intelligently."
  },
  {
    "author": "Dave Matthews",
    "category": "failure",
    "id": 18682,
    "text": "I fear that our true motivation is about oil and our own flailing economy about the failure to destroy Al Qaeda and about revenge."
  },
  {
    "author": "Glenn Beck",
    "category": "failure",
    "id": 18604,
    "text": "Without failure there is no sweetness in success. There's no understanding of it."
  },
  {
    "author": "Oprah Winfrey",
    "category": "failure",
    "id": 18435,
    "text": "Think like a queen. A queen is not afraid to fail. Failure is another steppingstone to greatness."
  },
  {
    "author": "Tommy Lasorda",
    "category": "failure",
    "id": 18592,
    "text": "About the only problem with success is that it does not teach you how to deal with failure."
  },
  {
    "author": "Allen Tate",
    "category": "failure",
    "id": 18828,
    "text": "So the poet, who wants to be something that he cannot be, and is a failure in plain life, makes up fictitious versions of his predicament that are interesting even to other persons because nobody is a perfect automobile salesman."
  },
  {
    "author": "Scott Brown",
    "category": "failure",
    "id": 18970,
    "text": "I've criticized President Bush for his failure to use his veto pen. There's plenty of blame to go around. The question is how to solve problems. It's not bailouts. What made America great? Free markets, free enterprise, manufacturing, job creation. That's how we're gonna do it, not by enlarging government."
  },
  {
    "author": "Mike Murdock",
    "category": "failure",
    "id": 18391,
    "text": "Failure to prepare is preparing to fail."
  },
  {
    "author": "Michael Ramsey",
    "category": "failure",
    "id": 19001,
    "text": "Ken Lay has, does and will continue to accept responsibility for the fall of Enron. He was the man at the controls. But failure is not a crime."
  },
  {
    "author": "Charles M. Schwab",
    "category": "failure",
    "id": 18401,
    "text": "I have probably purchased fifty 'hot tips' in my career, maybe even more. When I put them all together, I know I am a net loser."
  },
  {
    "author": "Michael Baden",
    "category": "failure",
    "id": 18832,
    "text": "I saw why people died and how they died. I saw gunshot wounds and liver failure. It was a good learning experience, so I came regularly on weekends and holidays."
  },
  {
    "author": "Claude Monet",
    "category": "failure",
    "id": 18395,
    "text": "My life has been nothing but a failure."
  },
  {
    "author": "S. I. Hayakawa",
    "category": "failure",
    "id": 18402,
    "text": "Notice the difference between what happens when a man says to himself, I have failed three times, and what happens when he says, I am a failure."
  },
  {
    "author": "Brett Ratner",
    "category": "failure",
    "id": 18757,
    "text": "When you're fearless, you take more risks because you're less conscious of failure or what can go wrong."
  },
  {
    "author": "Daniel Inouye",
    "category": "failure",
    "id": 18943,
    "text": "Mr. Gonzales' failure to respond to questions legitimately posed to him by the Senate raises grave doubts in my mind as to his fitness to serve the people of the United States as their Attorney General."
  },
  {
    "author": "Andy Murray",
    "category": "failure",
    "id": 18715,
    "text": "In tennis, it is not the opponent you fear, it is the failure itself, knowing how near you were but just out of reach."
  },
  {
    "author": "William James",
    "category": "failure",
    "id": 18465,
    "text": "There is but one cause of human failure. And that is man's lack of faith in his true Self."
  },
  {
    "author": "Benjamin Franklin",
    "category": "failure",
    "id": 18306,
    "text": "Do not fear mistakes. You will know failure. Continue to reach out."
  },
  {
    "author": "Napoleon Hill",
    "category": "failure",
    "id": 18309,
    "text": "Before success comes in any man's life, he's sure to meet with much temporary defeat and, perhaps some failures. When defeat overtakes a man, the easiest and the most logical thing to do is to quit. That's exactly what the majority of men do."
  },
  {
    "author": "Jesse Jackson",
    "category": "failure",
    "id": 18633,
    "text": "Success needs no explanation. Failure does not have one that matters."
  },
  {
    "author": "Tony Richardson",
    "category": "failure",
    "id": 19007,
    "text": "Failure is not fatal victory is not success."
  },
  {
    "author": "Rodney Alexander",
    "category": "failure",
    "id": 18979,
    "text": "I knew that there were several, among African-American leaders, who had been put out by me because of my failure or reluctance to endorse Sen. Kerry."
  },
  {
    "author": "Michael Mandelbaum",
    "category": "failure",
    "id": 18785,
    "text": "The great thing about baseball is the causality is easy to determine and it always falls on the shoulders of one person. So there is absolute responsibility. That's why baseball is psychologically the cruelest sport and why it really requires psychological resources to play baseball - because you have to learn to live with failure."
  },
  {
    "author": "Michel de Montaigne",
    "category": "failure",
    "id": 18365,
    "text": "There are some defeats more triumphant than victories."
  },
  {
    "author": "Ty Cobb",
    "category": "failure",
    "id": 18866,
    "text": "Don't come home a failure."
  },
  {
    "author": "Robert Half",
    "category": "failure",
    "id": 18475,
    "text": "Laziness is a secret ingredient that goes into failure. But it's only kept a secret from the person who fails."
  },
  {
    "author": "Mike Mills",
    "category": "failure",
    "id": 18751,
    "text": "Sadness is a super important thing not to be ashamed about but to include in our lives. One of the bigger problems with sadness or depression is there's so much shame around it. If you have it you're a failure. You are felt as being very unattractive."
  },
  {
    "author": "George Eliot",
    "category": "failure",
    "id": 18484,
    "text": "I'm proof against that word failure. I've seen behind it. The only failure a man ought to fear is failure of cleaving to the purpose he sees to be best."
  },
  {
    "author": "Oliver Hudson",
    "category": "failure",
    "id": 18874,
    "text": "His advice to me is basically to just love what you do and don't let the fear of failure stop you."
  },
  {
    "author": "James Allen",
    "category": "failure",
    "id": 18494,
    "text": "To begin to think with purpose, is to enter the ranks of those strong ones who only recognize failure as one of the pathways to attainment."
  },
  {
    "author": "George Bernard Shaw",
    "category": "failure",
    "id": 18442,
    "text": "My reputation grows with every failure."
  },
  {
    "author": "Paul Feig",
    "category": "failure",
    "id": 18694,
    "text": "I'm kind of a failure. I mean, I'll be honest. I'm successful in that I'm getting to work on great stuff, but I think I'm a failure in all the personal stuff that is most important to me."
  },
  {
    "author": "Elbert Hubbard",
    "category": "failure",
    "id": 18445,
    "text": "Optimism is a kind of heart stimulant - the digitalis of failure."
  },
  {
    "author": "Lyndon B. Johnson",
    "category": "failure",
    "id": 18460,
    "text": "The guns and the bombs, the rockets and the warships, are all symbols of human failure."
  },
  {
    "author": "Kevin Smith",
    "category": "failure",
    "id": 18703,
    "text": "There's something to be said for failing. It's not the failure you feel, it's the failure that people project when something disappoints. You're back to ground zero, where there's no expectations, and that's where I like to be."
  },
  {
    "author": "Alexander Payne",
    "category": "failure",
    "id": 18695,
    "text": "I get asked, 'How can you have such failures in your films?' Well, what else is life about? There's some sense of constant failure in something. Humor gives you a distance from it."
  },
  {
    "author": "Samuel Beckett",
    "category": "failure",
    "id": 18348,
    "text": "Go on failing. Go on. Only next time, try to fail better."
  },
  {
    "author": "Frederic William Farrar",
    "category": "failure",
    "id": 18959,
    "text": "There is only one real failure in life that is possible, and that is, not to be true to the best one knows."
  },
  {
    "author": "Herbert Kaufman",
    "category": "failure",
    "id": 18513,
    "text": "Failure is only postponed success as long as courage 'coaches' ambition. The habit of persistence is the habit of victory."
  },
  {
    "author": "Barack Obama",
    "category": "failure",
    "id": 18429,
    "text": "The fact that we are here today to debate raising America's debt limit is a sign of leadership failure. America has a debt problem and a failure of leadership. Americans deserve better. I, therefore, intend to oppose the effort to increase America's debt."
  },
  {
    "author": "George Clooney",
    "category": "failure",
    "id": 18616,
    "text": "The only failure is not to try."
  },
  {
    "author": "Shane Leslie",
    "category": "failure",
    "id": 18988,
    "text": "We are equally glad and surprised at Winston's return to office. It shows that he was built for success that he should have declined to withdraw and sulk over a superficial failure."
  },
  {
    "author": "George Eliot",
    "category": "failure",
    "id": 18355,
    "text": "The only failure one should fear, is not hugging to the purpose they see as best."
  },
  {
    "author": "Frederick William Robertson",
    "category": "failure",
    "id": 18769,
    "text": "In God's world, for those who are in earnest, there is no failure. No work truly done, no word earnestly spoken, no sacrifice freely made, was ever made in vain."
  },
  {
    "author": "Malcolm Mclaren",
    "category": "failure",
    "id": 18880,
    "text": "Art school had taught me it was far better to be a flamboyant failure than any kind of benign success."
  },
  {
    "author": "Paulo Coelho",
    "category": "failure",
    "id": 18343,
    "text": "I think you can have 10,000 explanations for failure, but no good explanation for success."
  },
  {
    "author": "Charlie Sheen",
    "category": "failure",
    "id": 18432,
    "text": "As kids we're not taught how to deal with success we're taught how to deal with failure. If at first you don't succeed, try, try again. If at first you succeed, then what?"
  },
  {
    "author": "Mickey Rooney",
    "category": "failure",
    "id": 18396,
    "text": "You always pass failure on your way to success."
  },
  {
    "author": "John Sherman Cooper",
    "category": "failure",
    "id": 18888,
    "text": "I think he Oswald felt he was a failure and for the United States and for President Kennedy and all of us. He knew he was a failure at everything he tried, frustrated, with a very sad life, but he was a Marxist."
  },
  {
    "author": "Don Johnson",
    "category": "failure",
    "id": 18708,
    "text": "People in the business will stay with you through drugs and alcohol and divorces and insanity and everything else, but you have a failure, pal, and they don't want to know nothing about you!"
  },
  {
    "author": "Lucille Ball",
    "category": "failure",
    "id": 18461,
    "text": "I hate failure and that divorce was a Number One failure in my eyes. It was the worst period of my life. Neither Desi nor I have been the same since, physically or mentally."
  },
  {
    "author": "Jeff Tweedy",
    "category": "failure",
    "id": 18865,
    "text": "I think somehow you need to get to a certain point in your life where the notion of failure is absurd."
  },
  {
    "author": "Henry Knox",
    "category": "failure",
    "id": 18942,
    "text": "Something is wanting, and something must be done, or we shall be involved in all the horror of failure, and civil war without a prospect of its termination."
  },
  {
    "author": "Ruben Hinojosa",
    "category": "failure",
    "id": 18851,
    "text": "If we do not get No Child Left Behind right for Limited English Proficient students, the law will be a failure for most schools in the 15th Congressional District, and for many across the nation."
  },
  {
    "author": "Michael Crawford",
    "category": "failure",
    "id": 18986,
    "text": "Divorce is never a pleasant experience. You look upon it as a failure. But I learned to be a different person once we broke up. Sometimes you learn more from failure than you do from success."
  },
  {
    "author": "Laurence J. Peter",
    "category": "failure",
    "id": 18377,
    "text": "The great question is not whether you have failed, but whether you are content with failure."
  }
]

quotes['faith'] = [
  {
    "author": "Vera Farmiga",
    "category": "faith",
    "id": 19557,
    "text": "Honestly, I think a good film is spiritual, regardless of whether its subject is faith."
  },
  {
    "author": "Mike Huckabee",
    "category": "faith",
    "id": 19616,
    "text": "The best way is to say that as a Christian for me the essence of Christian faith is that you treat others as if you wish to be treated."
  },
  {
    "author": "Karl Barth",
    "category": "faith",
    "id": 19598,
    "text": "Faith is never identical with piety."
  },
  {
    "author": "Eric Hoffer",
    "category": "faith",
    "id": 19346,
    "text": "To know a person's religion we need not listen to his profession of faith but must find his brand of intolerance."
  },
  {
    "author": "Dinesh D'Souza",
    "category": "faith",
    "id": 19821,
    "text": "Christianity has always embraced both reason and faith."
  },
  {
    "author": "Jonathan Sacks",
    "category": "faith",
    "id": 19530,
    "text": "Jews survived all the defeats, expulsions, persecutions and pogroms, the centuries in which they were regarded as a pariah people, even the Holocaust itself, because they never gave up the faith that one day they would be free to live as Jews without fear."
  },
  {
    "author": "Walter Lang",
    "category": "faith",
    "id": 19803,
    "text": "In Christ the original image of God is restored, by faith in this world and by sight in the world to come."
  },
  {
    "author": "Orson Pratt",
    "category": "faith",
    "id": 19117,
    "text": "It was seldom that I attended any religious meetings, as my parents had not much faith in and were never so unfortunate as to unite themselves with any of the religious sects."
  },
  {
    "author": "Dorothy Day",
    "category": "faith",
    "id": 19977,
    "text": "It is easier to have faith that God will support each House of Hospitality and Farming Commune and supply our needs in the way of food and money to pay bills, than it is to keep a strong, hearty, living faith in each individual around us - to see Christ in him."
  },
  {
    "author": "Garth Brooks",
    "category": "faith",
    "id": 19665,
    "text": "Stand straight, walk proud, have a little faith."
  },
  {
    "author": "Lawrence Wright",
    "category": "faith",
    "id": 19975,
    "text": "There are many countries where you can only believe more or you can believe less. But in the United States we have this incredible smorgasbord, and it really interests me why people are drawn to one faith rather than another, especially to a system of belief that to an outsider seems absurd or dangerous."
  },
  {
    "author": "Rafael Nadal",
    "category": "faith",
    "id": 19834,
    "text": "I always wanted to be honest with myself and to those who have had faith in me."
  },
  {
    "author": "William Ralph Inge",
    "category": "faith",
    "id": 19444,
    "text": "True faith is belief in the reality of absolute values."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "faith",
    "id": 19325,
    "text": "That willing suspension of disbelief for the moment, which constitutes poetic faith."
  },
  {
    "author": "Adam Schiff",
    "category": "faith",
    "id": 19829,
    "text": "Notwithstanding these setbacks, the dream of a beautiful American orchestra goes on, and I share Dr. King's faith that each year we move inexorably closer to a magnificent opening night."
  },
  {
    "author": "J. C. Watts",
    "category": "faith",
    "id": 19485,
    "text": "I think you grow wherever God plants you. I hope I'm growing as a person of faith, as a Christian. That should be our number one objective this journey of life. That all starts with a personal intimate relationship with Christ and then being in prayer every single day about all of those things - being tenacious about it."
  },
  {
    "author": "Ben Stein",
    "category": "faith",
    "id": 19286,
    "text": "Faith is not believing that God can. It is knowing that God will."
  },
  {
    "author": "Tori Amos",
    "category": "faith",
    "id": 19404,
    "text": "I don't know if the average person really has faith in Washington anymore."
  },
  {
    "author": "Allyson Felix",
    "category": "faith",
    "id": 19670,
    "text": "My faith inspires me so much. It is the very reason that I run. I feel that my running is completely a gift from God and it is my responsibility to use it to glorify him."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "faith",
    "id": 19022,
    "text": "If patience is worth anything, it must endure to the end of time. And a living faith will last in the midst of the blackest storm."
  },
  {
    "author": "Bear Grylls",
    "category": "faith",
    "id": 19602,
    "text": "I always had a really natural faith as a kid. Where I knew God existed and it felt very free and pretty wild and natural, and it wasn't religious."
  },
  {
    "author": "Jerry Costello",
    "category": "faith",
    "id": 19872,
    "text": "Through these adversities, Israel has endured with continued strength, conviction, and faith."
  },
  {
    "author": "Ricky Martin",
    "category": "faith",
    "id": 19791,
    "text": "Buddhism has a very beautiful teaching that says the worst thing you can do to your soul is to tell someone their faith is wrong."
  },
  {
    "author": "Sherwood Eddy",
    "category": "faith",
    "id": 19120,
    "text": "Faith is not contrary to reason."
  },
  {
    "author": "Joseph Ratzinger",
    "category": "faith",
    "id": 19667,
    "text": "Having a clear faith, based on the creed of the church is often labeled today as fundamentalism. Whereas relativism, which is letting oneself be tossed and swept along by every wind of teaching, look like the only attitude acceptable to today's standards."
  },
  {
    "author": "Ramakrishna",
    "category": "faith",
    "id": 19249,
    "text": "If you desire to be pure, have firm faith, and slowly go on with your devotional practices without wasting your energy in useless scriptural discussions and arguments. Your little brain will otherwise be muddled."
  },
  {
    "author": "Julianna Baggott",
    "category": "faith",
    "id": 19882,
    "text": "Red Sox fans have been pushed to the brink over the years, but that's how faith grows stronger."
  },
  {
    "author": "Khalil Gibran",
    "category": "faith",
    "id": 19021,
    "text": "Faith is a knowledge within the heart, beyond the reach of proof."
  },
  {
    "author": "Thomas S. Monson",
    "category": "faith",
    "id": 19265,
    "text": "Faith and doubt cannot exist in the same mind at the same time, for one will dispel the other."
  },
  {
    "author": "Freya Stark",
    "category": "faith",
    "id": 19891,
    "text": "If we are strong, and have faith in life and its richness of surprises, and hold the rudder steadily in our hands. I am sure we will sail into quiet and pleasent waters for our old age."
  },
  {
    "author": "Michael Arad",
    "category": "faith",
    "id": 19936,
    "text": "When I started this project, I was a young architect. I was very apprehensive about any changes to the design. Whether I wanted to or not, I learned that you can accept some changes to its form without compromising its intent. But it's a leap of faith that I didn't want to make initially - to put it mildly."
  },
  {
    "author": "Edward Norton",
    "category": "faith",
    "id": 19545,
    "text": "I have this embedded faith in the process through which films of a certain type get discovered on longer timelines."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "faith",
    "id": 19240,
    "text": "Only our individual faith in freedom can keep us free."
  },
  {
    "author": "William James",
    "category": "faith",
    "id": 19221,
    "text": "It is only by risking our persons from one hour to another that we live at all. And often enough our faith beforehand in an uncertified result is the only thing that makes the result come true."
  },
  {
    "author": "Michael Chang",
    "category": "faith",
    "id": 19594,
    "text": "I still have a belief and a faith that some great things are still going to happen in my career. If I didn't believe that, it makes no sense for me to be out there, and on top of that, I know this is a period of time that God wants me to persevere through."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "faith",
    "id": 19125,
    "text": "You must not lose faith in humanity. Humanity is an ocean if a few drops of the ocean are dirty, the ocean does not become dirty."
  },
  {
    "author": "J. C. Watts",
    "category": "faith",
    "id": 19420,
    "text": "The measure of a man is not how great his faith is, but how great his love is. We must not let government programs disconnect our souls from each other."
  },
  {
    "author": "David Wilkerson",
    "category": "faith",
    "id": 19597,
    "text": "Our ministry is supported entirely by faith, through the missions gifts of readers who receive my messages every three weeks. We seldom mention money, and we never burden supporters."
  },
  {
    "author": "Robin Wright Penn",
    "category": "faith",
    "id": 19773,
    "text": "Hollywood is a suction for your confidence or your faith or your togetherness. Just walking on the street you can feel it."
  },
  {
    "author": "Ernie Harwell",
    "category": "faith",
    "id": 19662,
    "text": "I have great faith that Heaven's there and I'll see my brothers and my mom and dad when I get there."
  },
  {
    "author": "Hans Urs von Balthasar",
    "category": "faith",
    "id": 19777,
    "text": "Whoever removes the Cross and its interpretation by the New Testament from the center, in order to replace it, for example, with the social commitment of Jesus to the oppressed as a new center, no longer stands in continuity with the apostolic faith."
  },
  {
    "author": "Sloane Crosley",
    "category": "faith",
    "id": 19561,
    "text": "I have a disproportionate amount of faith in the goodness of the world and that everything will actually work out okay."
  },
  {
    "author": "Stanley Baldwin",
    "category": "faith",
    "id": 19425,
    "text": "I am one of those who would rather sink with faith than swim without it."
  },
  {
    "author": "Joey Skaggs",
    "category": "faith",
    "id": 19986,
    "text": "It would make life much easier if I could have total faith and not question everything all the time, but I can't do it and I won't do it."
  },
  {
    "author": "Geraldine Brooks",
    "category": "faith",
    "id": 19720,
    "text": "My mother's family were full-on Irish Catholics - faith in an elaborate old fashioned, highly conservative and madly baroque style. I sort of fell out of the tribe over women's rights and social justice issues when I was just 13 years old."
  },
  {
    "author": "Sharron Angle",
    "category": "faith",
    "id": 19681,
    "text": "You know, this is a war of ideology, a war of thoughts and of faith. And we need people to really stand for faith and trust, not hope and change."
  },
  {
    "author": "E. O. Wilson",
    "category": "faith",
    "id": 19292,
    "text": "By any reasonable measure of achievement, the faith of the Enlightenment thinkers in science was justified."
  },
  {
    "author": "E. O. Wilson",
    "category": "faith",
    "id": 19261,
    "text": "Blind faith, no matter how passionately expressed, will not suffice. Science for its part will test relentlessly every assumption about the human condition."
  },
  {
    "author": "Charles Simeon",
    "category": "faith",
    "id": 19755,
    "text": "You often feel that your prayers scarcely reach the ceiling but, oh, get into this humble spirit by considering how good the Lord is, and how evil you all are, and then prayer will mount on wings of faith to heaven."
  },
  {
    "author": "Gustave Flaubert",
    "category": "faith",
    "id": 19369,
    "text": "Art requires neither complaisance nor politeness nothing but faith, faith and freedom."
  },
  {
    "author": "Robert Browning",
    "category": "faith",
    "id": 19107,
    "text": "Love, hope, fear, faith - these make humanity These are its sign and note and character."
  },
  {
    "author": "Timothy Radcliffe",
    "category": "faith",
    "id": 19699,
    "text": "The unutterable violence of the Holocaust shook our confidence in the possibility of telling any story of faith at all."
  },
  {
    "author": "Charles Hodge",
    "category": "faith",
    "id": 19833,
    "text": "If all Church power vests in the clergy, then the people are practically bound to passive obedience in all matters of faith and practice for all right of private judgment is then denied."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "faith",
    "id": 19152,
    "text": "Unwearied ceaseless effort is the price that must be paid for turning faith into a rich infallible experience."
  },
  {
    "author": "John Foster Dulles",
    "category": "faith",
    "id": 19445,
    "text": "The world will never have lasting peace so long as men reserve for war the finest human qualities. Peace, no less than war, requires idealism and self-sacrifice and a righteous and dynamic faith."
  },
  {
    "author": "Tony Campolo",
    "category": "faith",
    "id": 19474,
    "text": "It's a new day for the Democrats when it comes to matters of faith, and the younger Evangelicals are aware of this and many of them are moving into the Democratic camp."
  },
  {
    "author": "Pratibha Patil",
    "category": "faith",
    "id": 19935,
    "text": "Often, we are quick to find blame with others but yet are unable to give constructive responses. There seems to be a tendency to doubt almost everything. Do we not have faith in our own people's strengths and in our institutions? Can we afford distrust amongst ourselves?"
  },
  {
    "author": "Elizabeth Goudge",
    "category": "faith",
    "id": 19999,
    "text": "Faith given back to us after a night of doubt is a stronger thing, and far more valuable to us than faith that has never been tested."
  },
  {
    "author": "Eric Liu",
    "category": "faith",
    "id": 19608,
    "text": "True fans of the Constitution, like true fans of the national pastime, acknowledge the critical role of human judgment in making tough calls. We don't expect flawless interpretation. We expect good faith. We demand honesty."
  },
  {
    "author": "Cyril Connolly",
    "category": "faith",
    "id": 19447,
    "text": "Those of us who were brought up as Christians and have lost our faith have retained the sense of sin without the saving belief in redemption. This poisons our thought and so paralyses us in action."
  },
  {
    "author": "Steve Buyer",
    "category": "faith",
    "id": 19905,
    "text": "Our nation has kept faith with its veterans. Funding for veterans healthcare and benefits is strong, and has increased more than 75 percent in the last decade."
  },
  {
    "author": "Francis Quarles",
    "category": "faith",
    "id": 19451,
    "text": "Flatter not thyself in thy faith in God if thou hast not charity for thy neighbor."
  },
  {
    "author": "George Fox",
    "category": "faith",
    "id": 19904,
    "text": "Why should any man have power over any other man's faith, seeing Christ Himself is the author of it?"
  },
  {
    "author": "Walter Kaufmann",
    "category": "faith",
    "id": 19957,
    "text": "Faith means intense, usually confident, belief that is not based on evidence sufficient to command assent from every reasonable person."
  },
  {
    "author": "Benjamin Franklin",
    "category": "faith",
    "id": 19045,
    "text": "In the affairs of this world, men are saved not by faith, but by the want of it."
  },
  {
    "author": "Julie Bowen",
    "category": "faith",
    "id": 19522,
    "text": "It's a war of attrition. If you have patience and a modicum of faith in yourself your chances are not too bad."
  },
  {
    "author": "Patsy Cline",
    "category": "faith",
    "id": 19871,
    "text": "I would never have gone anywhere if it hadn't been for Mother's faith and support."
  },
  {
    "author": "Christian Nestell Bovee",
    "category": "faith",
    "id": 19385,
    "text": "They are the weakest, however strong, who have no faith in themselves or their own powers."
  },
  {
    "author": "Smokey Robinson",
    "category": "faith",
    "id": 19815,
    "text": "I've been speaking at churches for years, as well as juvenile jails, rehabs and hospitals, and I always talk about my faith. That is a declaration of my relationship with God."
  },
  {
    "author": "Wayne Newton",
    "category": "faith",
    "id": 20004,
    "text": "I've always had great faith in people."
  },
  {
    "author": "Alice Cooper",
    "category": "faith",
    "id": 19558,
    "text": "We got on his label, and the Bizarre organization is just going up and up. So we have faith."
  },
  {
    "author": "Vera Farmiga",
    "category": "faith",
    "id": 19555,
    "text": "I think that films about faith made for faith-based communities have a certain tactic."
  },
  {
    "author": "Georg Simmel",
    "category": "faith",
    "id": 19802,
    "text": "In the latter case life rests upon a thousand presuppositions which the individual can never trace back to their origins, and verify but which he must accept upon faith and belief."
  },
  {
    "author": "Yo-Yo Ma",
    "category": "faith",
    "id": 19199,
    "text": "Things can fall apart, or threaten to, for many reasons, and then there's got to be a leap of faith. Ultimately, when you're at the edge, you have to go forward or backward if you go forward, you have to jump together."
  },
  {
    "author": "Joseph Smith, Jr.",
    "category": "faith",
    "id": 19096,
    "text": "A man filled with the love of God is not content with blessing his family alone, but ranges through the whole world, anxious to bless the whole human race."
  },
  {
    "author": "John Donne",
    "category": "faith",
    "id": 19095,
    "text": "Reason is our soul's left hand, faith her right."
  },
  {
    "author": "Vivienne Westwood",
    "category": "faith",
    "id": 19464,
    "text": "I don't have faith in young people any more. I don't waste time trying to communicate with them."
  },
  {
    "author": "Thomas S. Monson",
    "category": "faith",
    "id": 19390,
    "text": "Should doubt knock at your doorway, just say to those skeptical, disturbing, rebellious thoughts, I propose to stay with my faith, with the faith of my people."
  },
  {
    "author": "Christopher Dawson",
    "category": "faith",
    "id": 19779,
    "text": "And so, today, if the state can no longer appeal to the old moral principles that belong to the Christian tradition, it will be forced to create a new official faith and new moral principles which will be binding on its citizens."
  },
  {
    "author": "Muhammad Ali",
    "category": "faith",
    "id": 19137,
    "text": "It's lack of faith that makes people afraid of meeting challenges, and I believed in myself."
  },
  {
    "author": "Alphonsus Liguori",
    "category": "faith",
    "id": 19081,
    "text": "Ask those who love Him with a sincere love, and they will tell you that they find no greater or prompter relief amid the troubles of their life than in loving conversation with their Divine Friend."
  },
  {
    "author": "Dwight L. Moody",
    "category": "faith",
    "id": 19077,
    "text": "God never made a promise that was too good to be true."
  },
  {
    "author": "Samuel Butler",
    "category": "faith",
    "id": 19282,
    "text": "What is faith but a kind of betting or speculation after all? It should be, I bet that my Redeemer liveth."
  },
  {
    "author": "Louisa May Alcott",
    "category": "faith",
    "id": 19328,
    "text": "Happy is the son whose faith in his mother remains unchallenged."
  },
  {
    "author": "Walter Kaufmann",
    "category": "faith",
    "id": 19472,
    "text": "To try to fashion something from suffering, to relish our triumphs, and to endure defeats without resentment: all that is compatible with the faith of a heretic."
  },
  {
    "author": "Thomas Aquinas",
    "category": "faith",
    "id": 19330,
    "text": "Hold firmly that our faith is identical with that of the ancients. Deny this, and you dissolve the unity of the Church."
  },
  {
    "author": "Leonard Cohen",
    "category": "faith",
    "id": 19340,
    "text": "Let judges secretly despair of justice: their verdicts will be more acute. Let generals secretly despair of triumph killing will be defamed. Let priests secretly despair of faith: their compassion will be true."
  },
  {
    "author": "Rick Wakeman",
    "category": "faith",
    "id": 19442,
    "text": "My faith is very private to me. It plays an important part in my life, but I do not try and throw my beliefs at others. I have tremendous respect for all faiths and beliefs, but have a deep concern that religion and faith are currently a long way apart from each other."
  },
  {
    "author": "Alan Watts",
    "category": "faith",
    "id": 19170,
    "text": "But the attitude of faith is to let go, and become open to truth, whatever it might turn out to be."
  },
  {
    "author": "Abraham Kuyper",
    "category": "faith",
    "id": 19767,
    "text": "When the principles that run against your deepest convictions begin to win the day, then the battle is your calling, and peace has become sin. You must at the price of dearest peace lay your convictions bare before friend and enemy with all the fire of your faith."
  },
  {
    "author": "Henry Adams",
    "category": "faith",
    "id": 19509,
    "text": "I have written too much history to have faith in it and if anyone thinks I'm wrong, I am inclined to agree with him."
  },
  {
    "author": "Thomas A. Edison",
    "category": "faith",
    "id": 19184,
    "text": "Be courageous. I have seen many depressions in business. Always America has emerged from these stronger and more prosperous. Be brave as your fathers before you. Have faith! Go forward!"
  },
  {
    "author": "Miguel de Unamuno",
    "category": "faith",
    "id": 19431,
    "text": "Life is doubt, and faith without doubt is nothing but death."
  },
  {
    "author": "Mason Cooley",
    "category": "faith",
    "id": 19291,
    "text": "Bad faith likes discourse on friendship and loyalty."
  },
  {
    "author": "Stephen Collins",
    "category": "faith",
    "id": 19942,
    "text": "You need to develop, somehow, a huge amount of faith and confidence in yourself, because there's a lot of rejection throughout an actor's life and you have to believe in yourself more than anyone else."
  },
  {
    "author": "Jim Wallis",
    "category": "faith",
    "id": 19494,
    "text": "The media seems to think only abortion and gay marriage are religious issues. Poverty is a moral issue, it's a faith issue, it's a religious issue."
  },
  {
    "author": "Barack Obama",
    "category": "faith",
    "id": 19143,
    "text": "My family, frankly, they weren't folks who went to church every week. My mother was one of the most spiritual people I knew but she didn't raise me in the church, so I came to my Christian faith later in life and it was because the precepts of Jesus Christ spoke to me in terms of the kind of life that I would want to lead."
  },
  {
    "author": "Taylor Swift",
    "category": "faith",
    "id": 19374,
    "text": "Faith Hill is a big role model."
  },
  {
    "author": "Jim Caviezel",
    "category": "faith",
    "id": 19671,
    "text": "My faith doesn't go over real well in Hollywood."
  },
  {
    "author": "Desmond Morris",
    "category": "faith",
    "id": 19115,
    "text": "No matter how old we become, we can still call them 'Holy Mother' and 'Father' and put a child-like trust in them."
  }
]

quotes['family'] = [
  {
    "author": "T. Boone Pickens",
    "category": "family",
    "id": 20903,
    "text": "I'm a Republican. I don't want to go to heaven and have to face my family up there and tell them I voted for a Democrat."
  },
  {
    "author": "Heidi Klum",
    "category": "family",
    "id": 20368,
    "text": "I love when I go out and I have my hair and makeup done, but I also like it when I'm just with the family because that's real."
  },
  {
    "author": "David Ogden Stiers",
    "category": "family",
    "id": 20011,
    "text": "Family means no one gets left behind or forgotten."
  },
  {
    "author": "Isabel Allende",
    "category": "family",
    "id": 20343,
    "text": "I was born in ancient times, at the end of the world, in a patriarchal Catholic and conservative family. No wonder that by age five I was a raging feminist - although the term had not reached Chile yet, so nobody knew what the heck was wrong with me."
  },
  {
    "author": "Haniel Long",
    "category": "family",
    "id": 20168,
    "text": "So much of what is best in us is bound up in our love of family, that it remains the measure of our stability because it measures our sense of loyalty. All other pacts of love or fear derive from it and are modeled upon it."
  },
  {
    "author": "Bobby Darin",
    "category": "family",
    "id": 20027,
    "text": "My family comes first. Maybe that's what makes me different from other guys."
  },
  {
    "author": "Barbara Bush",
    "category": "family",
    "id": 20422,
    "text": "Family and friends and faith are the most important things in your life and you should be building friendships."
  },
  {
    "author": "Orlando Bloom",
    "category": "family",
    "id": 20893,
    "text": "Movies like that aren't about the visual effects and explosions. They're human stories about family, about life, about death."
  },
  {
    "author": "Willard Scott",
    "category": "family",
    "id": 20170,
    "text": "Positive feelings come from being honest about yourself and accepting your personality, and physical characteristics, warts and all and, from belonging to a family that accepts you without question."
  },
  {
    "author": "Jason Reitman",
    "category": "family",
    "id": 20773,
    "text": "Selfishness, narcissism, being uncomfortable in your own skin, not feeling connected to the world around you, feeling dislocated from family and youth, having a strange relationship with your childhood - all those things feel really true to me."
  },
  {
    "author": "Janet Jackson",
    "category": "family",
    "id": 20648,
    "text": "I think it's been a little difficult at times for the audience, because they've told me they see me as a family member. So to see your little sister sing about sex... I think they are pretty used to it now."
  },
  {
    "author": "Iain Duncan Smith",
    "category": "family",
    "id": 20503,
    "text": "For families across the UK who are income-poor, but more than that, whose lives are blighted by worklessness, educational failure, family breakdown, problem debt and poor health, as well as other problems, giving them an extra pound - say through increased benefits - will not address the reason they find themselves in difficulty in the first place."
  },
  {
    "author": "Al Sharpton",
    "category": "family",
    "id": 20353,
    "text": "I was raised by a single mother who made a way for me. She used to scrub floors as a domestic worker, put a cleaning rag in her pocketbook and ride the subways in Brooklyn so I would have food on the table. But she taught me as I walked her to the subway that life is about not where you start, but where you're going. That's family values."
  },
  {
    "author": "Ayelet Waldman",
    "category": "family",
    "id": 20659,
    "text": "Personally, I think four is the perfect number of children for our particular family. Four is enough to create the frenzied cacophony that my husband and I find so joyful."
  },
  {
    "author": "Christopher Lasch",
    "category": "family",
    "id": 20720,
    "text": "The left sees nothing but bigotry and superstition in the popular defense of the family or in popular attitudes regarding abortion, crime, busing, and the school curriculum."
  },
  {
    "author": "David Sedaris",
    "category": "family",
    "id": 20407,
    "text": "My family isn't really all that different from anyone else's. Well, maybe they're a bit more entertaining."
  },
  {
    "author": "Clare Boothe Luce",
    "category": "family",
    "id": 20586,
    "text": "Women know what men have long forgotten. The ultimate economic and spiritual unit of any civilization is still the family."
  },
  {
    "author": "Leighton Meester",
    "category": "family",
    "id": 20800,
    "text": "When I do get free time, I spend a lot of it at home with my family and my close friends and I think that's what keeps me happy, healthy, grounded, and totally in check."
  },
  {
    "author": "Sienna Miller",
    "category": "family",
    "id": 20583,
    "text": "I am very lucky, I have a very tight group of friends and a very supportive family, and to this date no-one has ever sold a story on me."
  },
  {
    "author": "Sarah Jessica Parker",
    "category": "family",
    "id": 20987,
    "text": "I'm very, very concerned about the Bush presidency. I'm worried about the kinds of cuts in domestic programs that mean something to a lot of people, including members of my family, who depend on certain things from the government."
  },
  {
    "author": "Robert H. Schuller",
    "category": "family",
    "id": 20246,
    "text": "My family and I would never receive royalties on the revenue that my materials brought into the church materials that were created on our own personal time."
  },
  {
    "author": "Barbara Bush",
    "category": "family",
    "id": 20049,
    "text": "I think togetherness is a very important ingredient to family life."
  },
  {
    "author": "Gus Van Sant",
    "category": "family",
    "id": 20827,
    "text": "There is a common theme, though, in the stories I have told, which are usually associations of characters or families that are formed outside of a family circle."
  },
  {
    "author": "Dee Dee Myers",
    "category": "family",
    "id": 20275,
    "text": "As women slowly gain power, their values and priorities are reshaping the agenda. A multitude of studies show that when women control the family funds, they generally spend more on health, nutrition, and education - and less on alcohol and cigarettes."
  },
  {
    "author": "Dana Carvey",
    "category": "family",
    "id": 20499,
    "text": "I know it's a cliche, but the whole family is just whacked. I mean, we're all out of our minds. They're the funniest, most eccentric bizarre people I've ever met, my siblings."
  },
  {
    "author": "Anthony Anderson",
    "category": "family",
    "id": 20114,
    "text": "I realized my family was funny, because nobody ever wanted to leave our house."
  },
  {
    "author": "David Mamet",
    "category": "family",
    "id": 20736,
    "text": "My idea of perfect happiness is a healthy family, peace between nations, and all the critics die."
  },
  {
    "author": "Barbara Ehrenreich",
    "category": "family",
    "id": 20242,
    "text": "At best the family teaches the finest things human beings can learn from one another generosity and love. But it is also, all too often, where we learn nasty things like hate, rage and shame."
  },
  {
    "author": "Elizabeth Edwards",
    "category": "family",
    "id": 20573,
    "text": "Growing up in an Italian family, you use a harsh tone and 10 minutes later everybody forgets about it."
  },
  {
    "author": "Madonna Ciccone",
    "category": "family",
    "id": 20922,
    "text": "On the one hand, the idea of marriage and the sort of traditional family life repulses me. But on the other hand, I long for it, you know what I mean? I'm constantly in conflict with things. And it is because of my past and my upbringing and the journey that I've been on."
  },
  {
    "author": "Hulagu Khan",
    "category": "family",
    "id": 20646,
    "text": "If you wish to spare yourself and your venerable family, give heed to my advice with the ear of intelligence. If you do not, you will see what God has willed."
  },
  {
    "author": "Stephen Covey",
    "category": "family",
    "id": 20352,
    "text": "But with the steady disintegration of the family in modern society over the last century, the role of the school in bridging the gap has become vital!"
  },
  {
    "author": "Nastassja Kinski",
    "category": "family",
    "id": 20133,
    "text": "I have these visions of myself being thirty, thirty-five, forty having a family."
  },
  {
    "author": "Laura Schlessinger",
    "category": "family",
    "id": 20948,
    "text": "My mother isolated herself from all family and friends for some 20 years. And never met her grandchild, my son."
  },
  {
    "author": "Desmond Tutu",
    "category": "family",
    "id": 20309,
    "text": "In God's family, there are no outsiders, no enemies."
  },
  {
    "author": "Giuliana Rancic",
    "category": "family",
    "id": 20728,
    "text": "A rumor that followed me forever was that my family was in the mafia. For years I had to live with it. They'd call me the mafia princess, so I rolled with it for the rest of high school. People even joke about it today."
  },
  {
    "author": "Eliot Spitzer",
    "category": "family",
    "id": 20758,
    "text": "From those to whom much is given, much is expected. I have been given much - the love of my family, the faith and trust of the people of New York, and the chance to lead this state. I am deeply sorry that I did not live up to what was expected of me."
  },
  {
    "author": "Joseph Joubert",
    "category": "family",
    "id": 20308,
    "text": "Love and fear. Everything the father of a family says must inspire one or the other."
  },
  {
    "author": "Henry Louis Gates",
    "category": "family",
    "id": 20525,
    "text": "If you share a common ancestor with somebody, you're related to them. It doesn't mean that you're going to invite them to the family reunion, but it means that you share DNA."
  },
  {
    "author": "Abbe Pierre",
    "category": "family",
    "id": 20134,
    "text": "My family background was deeply Christian."
  },
  {
    "author": "Gary Oldman",
    "category": "family",
    "id": 20636,
    "text": "Interesting things come your way but as you get older, your lifestyle changes. I don't want to travel I don't want to be in a hotel room away from my family."
  },
  {
    "author": "Betty White",
    "category": "family",
    "id": 20798,
    "text": "It's a little known fact that one in three family pets gets lost during its lifetime, and approximately 9 million pets enter shelters each year. That's why it's a wonderful thing to get your pet microchipped and registered with your contact information because then they can be located and the owners can track where their pets are."
  },
  {
    "author": "George Carlin",
    "category": "family",
    "id": 20161,
    "text": "The other night I ate at a real nice family restaurant. Every table had an argument going."
  },
  {
    "author": "Patrick Warburton",
    "category": "family",
    "id": 20106,
    "text": "I have a family to support. And I'm not always going to be doing exactly what I want to do."
  },
  {
    "author": "Bobby Jindal",
    "category": "family",
    "id": 20179,
    "text": "On Thanksgiving I will stop to give thanks that my family is safe and healthy, especially because I realize that, following the tragedies of this year, it is all too real a possibility that they might not have been."
  },
  {
    "author": "Tiger Woods",
    "category": "family",
    "id": 20447,
    "text": "I hurt my wife, my kids, my mother, my wife's family, my friends, my foundation and kids all around the world who admired me."
  },
  {
    "author": "Shaun White",
    "category": "family",
    "id": 20516,
    "text": "I know my family and I would always go up to the mountains just for fun. We always skied. Then, all of a sudden, my brother started snow boarding. Older brother thing, I had to do what he was doing. So I started snow boarding."
  },
  {
    "author": "Jackie Chan",
    "category": "family",
    "id": 20597,
    "text": "I think the family movie is very important to everybody right now."
  },
  {
    "author": "Jeff Foxworthy",
    "category": "family",
    "id": 20672,
    "text": "My wife is so analytical with raising kids, and I am not. My feeling is if they turn out good, then that means I was a good daddy and put a lot of effort into it. If they turn out bad, it means they took after her side of the family."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "family",
    "id": 20693,
    "text": "I'm not an anarchist, but I believe that people don't want the royal family - the so-called royal family."
  },
  {
    "author": "B. B. King",
    "category": "family",
    "id": 20594,
    "text": "Growing up, I was taught that a man has to defend his family. When the wolf is trying to get in, you gotta stand in the doorway."
  },
  {
    "author": "Dwight L. Moody",
    "category": "family",
    "id": 20205,
    "text": "A man ought to live so that everybody knows he is a Christian... and most of all, his family ought to know."
  },
  {
    "author": "Patty Duke",
    "category": "family",
    "id": 20070,
    "text": "I never did quite fit the glamour mode. It is life with my husband and family that is my high now."
  },
  {
    "author": "Reba McEntire",
    "category": "family",
    "id": 20749,
    "text": "My family, you know, are all still, you know, very close. We're all still very close. Mom and Daddy are still alive. So, what more can you ask for? Your kids are healthy."
  },
  {
    "author": "Drew Barrymore",
    "category": "family",
    "id": 20404,
    "text": "When I did 'E.T.,' it sort of solidified the only family I know are these film crews. These gypsies. These filmmakers. That was the solidification and the clicking revelations of 'This is what I want to do with my life and this is where I'm going to survive.'"
  },
  {
    "author": "Star Jones",
    "category": "family",
    "id": 20818,
    "text": "We fight a lot, you know, but that's family. We may be dysfunctional but we're still family."
  },
  {
    "author": "Henry David Thoreau",
    "category": "family",
    "id": 20163,
    "text": "All men are children, and of one family. The same tale sends them all to bed, and wakes them in the morning."
  },
  {
    "author": "Joe DiMaggio",
    "category": "family",
    "id": 20553,
    "text": "A ball player has to be kept hungry to become a big leaguer. That's why no boy from a rich family has ever made the big leagues."
  },
  {
    "author": "Katy Perry",
    "category": "family",
    "id": 20468,
    "text": "My dad would give me $10, which is a lot of money when you're 9, to sing at church, on tables at restaurants, at family functions, just about anywhere."
  },
  {
    "author": "John Sununu",
    "category": "family",
    "id": 20866,
    "text": "The voters are going to decide in November who is going to fix their personal family dismay over not having jobs in America. They are going to pick Mitt Romney."
  },
  {
    "author": "Francesca Annis",
    "category": "family",
    "id": 20550,
    "text": "I'm often asked if I regret not going to Hollywood. I'm glad I didn't go, because if I had I wouldn't have my extended family, which is the fabric of my life. Only recently have I realised how special and unusual it is."
  },
  {
    "author": "Nick Carter",
    "category": "family",
    "id": 20924,
    "text": "I don't believe in being mean to anyone. I'm a really peaceful person. That's something I get from my family."
  },
  {
    "author": "Saul Alinsky",
    "category": "family",
    "id": 20803,
    "text": "A racially integrated community is a chronological term timed from the entrance of the first black family to the exit of the last white family."
  },
  {
    "author": "John le Carre",
    "category": "family",
    "id": 20981,
    "text": "You have no idea how humiliating it was, as a boy, to suddenly have all your clothes, your toys, snatched by the bailiff. I mean we were a middle-class family, it's not as if it was happening up and down the street. It made me ashamed, I felt dirty."
  },
  {
    "author": "Jackie Kennedy",
    "category": "family",
    "id": 20045,
    "text": "The children have been a wonderful gift to me, and I'm thankful to have once again seen our world through their eyes. They restore my faith in the family's future."
  },
  {
    "author": "Jim Bunning",
    "category": "family",
    "id": 20708,
    "text": "A loving family provides the foundation children need to succeed, and strong families with a man and a woman - bonded together for life - always have been, and always will be, the key to such families."
  },
  {
    "author": "Liam Neeson",
    "category": "family",
    "id": 20466,
    "text": "I have to make it my job to be careful with my family."
  },
  {
    "author": "Alanis Morissette",
    "category": "family",
    "id": 20297,
    "text": "Getting married and starting a family has been a lifelong goal and one that I have persevered through different paths up to it!"
  },
  {
    "author": "Jennifer Aniston",
    "category": "family",
    "id": 20345,
    "text": "I realised how paranoid and guarded and not trusting - walled-in - I had become. Not consciously so, but just this armour that I kind of have, protective armour. It's not for my friends or family, but for being.outside in the world, always on guard."
  },
  {
    "author": "George Clooney",
    "category": "family",
    "id": 20118,
    "text": "I love children and I get along with them great. It's just that I believe if you're going to be a parent, there has to be something inside you that says, 'I want a family.' I don't feel that sense of urgency."
  },
  {
    "author": "Patrick Henry",
    "category": "family",
    "id": 20214,
    "text": "I have now disposed of all my property to my family. There is one thing more I wish I could give them, and that is the Christian religion."
  },
  {
    "author": "Richard Bach",
    "category": "family",
    "id": 20039,
    "text": "Rarely do members of the same family grow up under the same roof."
  },
  {
    "author": "Antonin Scalia",
    "category": "family",
    "id": 20508,
    "text": "In a big family the first child is kind of like the first pancake. If it's not perfect, that's okay, there are a lot more coming along."
  },
  {
    "author": "Barbra Streisand",
    "category": "family",
    "id": 20591,
    "text": "We have a president who stole the presidency through family ties, arrogance and intimidation, employing Republican operatives to exercise the tactics of voter fraud by disenfranchising thousands of blacks, elderly Jews and other minorities."
  },
  {
    "author": "Kit Bond",
    "category": "family",
    "id": 20831,
    "text": "According to the Small Business Administration, more than 70 percent of all family businesses do not survive through the second generation, and 8 percent do not make it to a third."
  },
  {
    "author": "Jeffrey Kluger",
    "category": "family",
    "id": 20934,
    "text": "There's a sort of sibling moratorium when you're establishing yourself as an adult. So much of your energy has to be focused on other things like work and kids. But when people become more settled, siblings tend to regroup because now you're building a new extended family."
  },
  {
    "author": "Gary Oldman",
    "category": "family",
    "id": 20363,
    "text": "Growing up in a particular neighborhood, growing up in a working-class family, not having much money, all of those things fire you and can give you an edge, can give you an anger."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "family",
    "id": 20808,
    "text": "My family, although they're very large on both my parents' sides, they don't know much about their family tree. Occasionally, they try to dig, but they can't get very far, and it's baffling. In Dublin, it seems that so many public records were wiped out it's proven to be very difficult, so I know very little."
  },
  {
    "author": "Charles Stanley",
    "category": "family",
    "id": 20278,
    "text": "The moment someone chooses to trust in Jesus Christ, his sins are wiped away, and he is adopted into God's family. That individual is set apart as a child of God, with a sacred purpose."
  },
  {
    "author": "Stevie Wonder",
    "category": "family",
    "id": 20963,
    "text": "My father really was not the dominant person who raised the family, it was my mother who raised the family."
  },
  {
    "author": "David Hockney",
    "category": "family",
    "id": 20480,
    "text": "I think my father would have liked to have been an artist, actually. But I think he didn't quite have perhaps the drive or, I don't know, I mean he had a family to bring up I suppose."
  },
  {
    "author": "Kristen Stewart",
    "category": "family",
    "id": 20628,
    "text": "I have a great family by the way, but you need to find people who can pull something out from you that might be otherwise unseen."
  },
  {
    "author": "Jonathan Safran Foer",
    "category": "family",
    "id": 20599,
    "text": "I'm less worried about accomplishment - as younger people always can't help but be - and more concerned with spending my time well, spending time with my family, and reading, learning things."
  },
  {
    "author": "Rob Sheffield",
    "category": "family",
    "id": 20692,
    "text": "'American Horror' is the debasement of the suburban family, the way a lonely kid would have imagined it in the Seventies."
  },
  {
    "author": "Adriana Lima",
    "category": "family",
    "id": 20389,
    "text": "I'm a teenager, but I'm independent - I have my own apartment, I have my own life. And I think I have learned more than any of those teenagers have in school. I learned to be responsible, leaving my family and coming here alone."
  },
  {
    "author": "Kareem Abdul-Jabbar",
    "category": "family",
    "id": 20498,
    "text": "I want to do as little as possible when I finish playing ball - just spend a lot more time with my family."
  },
  {
    "author": "Henri Frederic Amiel",
    "category": "family",
    "id": 20367,
    "text": "Woman is the salvation or the destruction of the family. She carries its destiny in the folds of her mantle."
  },
  {
    "author": "Emeril Lagasse",
    "category": "family",
    "id": 20743,
    "text": "We'll be going to the fish market and a farmer's market this afternoon to get what we need to make and eat dinner as a family. I'm trying to expose my kids to going to a farmers market or the fish market and learning what that's all about."
  },
  {
    "author": "Desmond Tutu",
    "category": "family",
    "id": 20291,
    "text": "God's dream is that you and I and all of us will realize that we are family, that we are made for togetherness, for goodness, and for compassion."
  },
  {
    "author": "Harlan Coben",
    "category": "family",
    "id": 20804,
    "text": "Frankly I'm fairly boring or fairly busy. Between writing and family, I have little time for anything else."
  },
  {
    "author": "Gus Van Sant",
    "category": "family",
    "id": 20829,
    "text": "My family moved a lot as a kid. We started in Colorado, where I lived for five years. We moved to Chicago for two years, to San Francisco for one year, Connecticut for seven, Oregon for a couple years, and then I went to school."
  },
  {
    "author": "Iain Duncan Smith",
    "category": "family",
    "id": 20845,
    "text": "By measuring the proportion of children living with the same parents from birth and whether their parents report a good quality relationship we are driving home the message that social programmes should promote family stability and avert breakdown."
  },
  {
    "author": "Drew Barrymore",
    "category": "family",
    "id": 20401,
    "text": "Being a Barrymore didn't help me, other than giving me a great sense of pride and a strange spiritual sense that I felt OK about having the passion to act. It made sense because my whole family had done it and it helped rationalise it for me."
  },
  {
    "author": "Anita Baker",
    "category": "family",
    "id": 20085,
    "text": "You leave home to seek your fortune and, when you get it, you go home and share it with your family."
  },
  {
    "author": "Tupac Shakur",
    "category": "family",
    "id": 20184,
    "text": "With all my fans I got a family again."
  },
  {
    "author": "Tyler Perry",
    "category": "family",
    "id": 20810,
    "text": "I'm not sure why no one wants to admit there's a viable audience out there that believes in God and wants to see a movie with their family. The demand is there. The supply is not."
  },
  {
    "author": "Jennifer Aniston",
    "category": "family",
    "id": 20227,
    "text": "Where would you be without friends? The people to pick you up when you need lifting? We come from homes far from perfect, so you end up almost parent and sibling to your friends - your own chosen family. There's nothing like a really loyal, dependable, good friend. Nothing."
  },
  {
    "author": "Virginia Satir",
    "category": "family",
    "id": 20151,
    "text": "Feelings of worth can flourish only in an atmosphere where individual differences are appreciated, mistakes are tolerated, communication is open, and rules are flexible - the kind of atmosphere that is found in a nurturing family."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "family",
    "id": 20691,
    "text": "The monarchy is foremost a business, and it's important to them that the British public continue to finance the excessive luxurious lifestyles of the now quite enormous, wasteful and useless 'royal' family. I find it very sad."
  },
  {
    "author": "Al Sharpton",
    "category": "family",
    "id": 20900,
    "text": "The dream was not to put one black family in the White House, the dream was to make everything equal in everybody's house."
  }
]

quotes['famous'] = [
  {
    "author": "Henry Flynt",
    "category": "famous",
    "id": 21613,
    "text": "When I came to New York, I began to meet the people who became the most famous artists of our time. I was insecure about my own level of ability, I didn't know whether I could compete with these people and, at the same time. I was wondering what is this anyway?"
  },
  {
    "author": "Vanessa Paradis",
    "category": "famous",
    "id": 21267,
    "text": "People don't get through to the essence of you right away - it's always the famous 'girl' or the famous 'girlfriend'. I'd rather be known for myself."
  },
  {
    "author": "Catherine Keener",
    "category": "famous",
    "id": 21599,
    "text": "These days there are a lot of people who just want to be famous. I think that comes from a naive place, because those people generally don't know what it's like."
  },
  {
    "author": "Rashida Jones",
    "category": "famous",
    "id": 21159,
    "text": "I have to say, you know, I've seen so many people go through the cycle and become famous and not famous anymore and, you know, want - have their priorities change and want different things."
  },
  {
    "author": "Patrick Rothfuss",
    "category": "famous",
    "id": 21531,
    "text": "I never set out to become 'famous.' I mean, when you're 14 you think 'I'm gonna become a writer and people will want my autograph and that'll be cool,' but you grow up and you learn that's just not how the world works. I resigned myself to the fact that I would probably never be published and if I did it probably wouldn't be a big deal."
  },
  {
    "author": "Jeff Foxworthy",
    "category": "famous",
    "id": 21029,
    "text": "Nothing in life prepares you to be famous."
  },
  {
    "author": "Manolo Blahnik",
    "category": "famous",
    "id": 21303,
    "text": "I never wanted to be the most famous, the most beautiful, the most extravagant."
  },
  {
    "author": "Jane Pauley",
    "category": "famous",
    "id": 21222,
    "text": "I would like to prove that on TV, everyday lives can be as compelling as the life-styles of the rich and famous. Especially lives that we catch at extraordinary moments."
  },
  {
    "author": "Cee Lo Green",
    "category": "famous",
    "id": 21530,
    "text": "I think I'll always be famous. I just hope I don't become infamous."
  },
  {
    "author": "Daniel H. Wilson",
    "category": "famous",
    "id": 21388,
    "text": "The poster boy for our superabled future is Oscar Pistorius, an increasingly famous South African sprinter who happens to have had both of his legs amputated below the knee. Using upside down question mark-shaped carbon fiber sprinting prosthetics, called Cheetah blades, Mr. Pistorius can challenge the fastest sprinters in the world."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "famous",
    "id": 21068,
    "text": "Wood burns because it has the proper stuff in it and a man becomes famous because he has the proper stuff in him."
  },
  {
    "author": "Joey McIntyre",
    "category": "famous",
    "id": 21659,
    "text": "I love meeting famous people. I'm even happy just looking at them."
  },
  {
    "author": "Andy Warhol",
    "category": "famous",
    "id": 21072,
    "text": "I'm bored with that line. I never use it anymore. My new line is 'In 15 minutes everybody will be famous.'"
  },
  {
    "author": "Carnie Wilson",
    "category": "famous",
    "id": 21218,
    "text": "Becoming famous is a strange thing in your own right."
  },
  {
    "author": "Jean Claude Van Damme",
    "category": "famous",
    "id": 21268,
    "text": "What is a movie star? It is an illusion. It was everything I ever wanted to be, but it became a kind of shell, non? It was what made me famous and got me women. But it wasn't real."
  },
  {
    "author": "Corey Feldman",
    "category": "famous",
    "id": 21323,
    "text": "My discrepancy with children in the industry is that they are made famous before they know who they are as human beings."
  },
  {
    "author": "Fran Drescher",
    "category": "famous",
    "id": 21439,
    "text": "Being famous gets me good concert tickets, good tables in restaurants, good seats at sporting events and that's really about it."
  },
  {
    "author": "Vince Gill",
    "category": "famous",
    "id": 21452,
    "text": "I do not like being famous. I like being normal."
  },
  {
    "author": "Ellen Burstyn",
    "category": "famous",
    "id": 21450,
    "text": "I did my famous cabbage soup diet, so I was able to do it."
  },
  {
    "author": "Jewel",
    "category": "famous",
    "id": 21300,
    "text": "Some people want fame, popularity and huge sales. I've always hoped to have a really long career. So I've tried to make each of my creative decisions and business decisions to allow for longevity. As a side effect I got really famous and really big. I didn't realize the two could go together."
  },
  {
    "author": "Geri Halliwell",
    "category": "famous",
    "id": 21414,
    "text": "There's always going to be that pressure when you're in front of the camera. When you're famous it's just an extreme version of reality and there's a pressure to look a certain way."
  },
  {
    "author": "Steve Burns",
    "category": "famous",
    "id": 21518,
    "text": "I'm officially near-famous. If you've got four year old kids and you've got cable, then you've got no choice but to know who I am. But if you're one of my peers - a 26-year old guy who lives in Manhattan - you have no idea who I am. I'm only famous if you're four."
  },
  {
    "author": "Kelsey Grammer",
    "category": "famous",
    "id": 21636,
    "text": "I became an actor, and because I had success as an actor, I became famous. I was acting for quite a while before I got famous television made me famous. I guess that it's television that is responsible for everybody's desire to be famous."
  },
  {
    "author": "Kin Hubbard",
    "category": "famous",
    "id": 21077,
    "text": "After a fellow gets famous it doesn't take long for someone to bob up that used to sit by him in school."
  },
  {
    "author": "Jon Carroll",
    "category": "famous",
    "id": 21702,
    "text": "I think the thing to remember, though, the next time you hear someone who is really certain that he is on the side of the angels, is that the idea of angels was created by human beings, who are famous for being frequently untrustworthy and occasional."
  },
  {
    "author": "Heather Morris",
    "category": "famous",
    "id": 21568,
    "text": "I've wanted to perform my entire life. I found a paper I wrote in kindergarten class about what I wanted to be when I grew up - and I wrote 'a famous singer!'"
  },
  {
    "author": "Jon Landau",
    "category": "famous",
    "id": 21342,
    "text": "What makes the Stones' arrogance so divine is that we all believe that long ago and far away they weren't rich and famous but poor and struggling, just like us."
  },
  {
    "author": "Russell Brand",
    "category": "famous",
    "id": 21239,
    "text": "When I was growing up, I thought I'd be a lot happier if I was famous and successful and if I had money."
  },
  {
    "author": "Adele",
    "category": "famous",
    "id": 21087,
    "text": "Mum loves me being famous! She is so excited and proud, as she had me so young and couldn't support me, so I am living her dream, it's sweeter for both of us. It's her 40th birthday soon and I'm going to buy her 40 presents."
  },
  {
    "author": "Ricki Lake",
    "category": "famous",
    "id": 21515,
    "text": "For somebody famous, it's weird anyway to meet someone, because they have a preconceived notion of who you are."
  },
  {
    "author": "Moliere",
    "category": "famous",
    "id": 21084,
    "text": "Some of the most famous books are the least worth reading. Their fame was due to their having done something that needed to be doing in their day. The work is done and the virtue of the book has expired."
  },
  {
    "author": "Matthew Morrison",
    "category": "famous",
    "id": 21365,
    "text": "Once you're famous you can't go back."
  },
  {
    "author": "Kevin Pietersen",
    "category": "famous",
    "id": 21333,
    "text": "I married a pretty famous girl, and when we drive through town there's usually a car following us, when I walk out of my front door in Chelsea there's six guys waiting for me."
  },
  {
    "author": "Lady Gaga",
    "category": "famous",
    "id": 21073,
    "text": "I don't like Los Angeles. The people are awful and terribly shallow, and everybody wants to be famous but nobody wants to play the game. I'm from New York. I will kill to get what I need."
  },
  {
    "author": "Tom Sizemore",
    "category": "famous",
    "id": 21426,
    "text": "Although I get so much fan mail from Great Britain, tell me, am I more famous there than Michael Madsen?"
  },
  {
    "author": "Barbra Streisand",
    "category": "famous",
    "id": 21165,
    "text": "Why am I so famous? What am I doing right? What are the others doing wrong?"
  },
  {
    "author": "Alberto Korda",
    "category": "famous",
    "id": 21701,
    "text": "I still forgive him, because by doing what he did, he made it famous."
  },
  {
    "author": "Chloe Moretz",
    "category": "famous",
    "id": 21374,
    "text": "I follow the most random people on Twitter. I follow famous people like Khloe Kardashian, who surprisingly makes really funny tweets all the time."
  },
  {
    "author": "Nicole Scherzinger",
    "category": "famous",
    "id": 21383,
    "text": "I was a shy kid, but somehow I knew I would make it as a performer. I'd always be telling my mum that I was going to be a famous singer. In my school yearbooks I would write, 'Remember me when I'm famous.' I knew I had a gift."
  },
  {
    "author": "Christopher Hampton",
    "category": "famous",
    "id": 21440,
    "text": "To seduce a woman famous for strict morals, religious fervor and the happiness of her marriage: what could possibly be more prestigious?"
  },
  {
    "author": "Katherine Jenkins",
    "category": "famous",
    "id": 21212,
    "text": "I've only ever wanted to be a singer I never wanted to be famous."
  },
  {
    "author": "Maureen Dowd",
    "category": "famous",
    "id": 21040,
    "text": "Celebrity distorts democracy by giving the rich, beautiful, and famous more authority than they deserve."
  },
  {
    "author": "Silvia Colloca",
    "category": "famous",
    "id": 21686,
    "text": "Italian girls are famous for being snobby and expecting men to make the first move. In America, if I don't make eye contact, the guys won't come over and talk. American girls just go for it. You men are spoiled."
  },
  {
    "author": "Katie Price",
    "category": "famous",
    "id": 21331,
    "text": "When I was younger, I used to say, One day I'll be famous."
  },
  {
    "author": "Johnny Knoxville",
    "category": "famous",
    "id": 21351,
    "text": "A lot of stand-up comedy guys, when they get a little famous, just give up their stand-up career, and it cancels out the thing that set them apart."
  },
  {
    "author": "Shania Twain",
    "category": "famous",
    "id": 21122,
    "text": "I certainly don't think you need to be famous to want to leave a legacy, but when you are famous, it's even more likely that your child will get the wrong perspective on your life if you die prematurely."
  },
  {
    "author": "Sean Lennon",
    "category": "famous",
    "id": 21461,
    "text": "Being famous is having the power to really implement positive change in the world, and it gives you the power to do what you want. I'm really grateful for it because I can play music and people will listen."
  },
  {
    "author": "Tammin Sursok",
    "category": "famous",
    "id": 21681,
    "text": "In Australia, there is a very famous show called 'Home and Away.' I was cast on that at 15. The day I started filming, my life changed."
  },
  {
    "author": "Rupert Grint",
    "category": "famous",
    "id": 21286,
    "text": "Being famous is wicked. But it's better to be normal."
  },
  {
    "author": "Joe Rogan",
    "category": "famous",
    "id": 21278,
    "text": "I really feel like it's a travesty to make a child famous. I really do."
  },
  {
    "author": "Matt Damon",
    "category": "famous",
    "id": 21211,
    "text": "There are people who appear in the magazines and I don't know who they are. I've never seen anything they've done and their careers are over already. They're famous for maybe 10 minutes. Real careers, I think, take a long time to unfold."
  },
  {
    "author": "Kurtis Blow",
    "category": "famous",
    "id": 21196,
    "text": "The Bronx is famous for two things. Hip-hop, and 26 world championships."
  },
  {
    "author": "Francis I",
    "category": "famous",
    "id": 21693,
    "text": "Persons famous in the arts partake of the immortality of princes, and are upon a footing with them."
  },
  {
    "author": "Juliette Binoche",
    "category": "famous",
    "id": 21241,
    "text": "Being a famous actress may give you a sense of being important, but believe me, it's just an illusion."
  },
  {
    "author": "Madonna Ciccone",
    "category": "famous",
    "id": 21260,
    "text": "I think in the end, when you're famous, people like to narrow you down to a few personality traits. I think I've just become this ambitious, say-whatever's-on-her-mind, intimidating person. And that's part of my personality, but it's certainly not anywhere near the whole thing."
  },
  {
    "author": "Seth Rogen",
    "category": "famous",
    "id": 21294,
    "text": "I remember, when I was an up-and-coming comic, how annoyed I would be when the famous guys would show up and just take everyone's spots."
  },
  {
    "author": "Jiddu Krishnamurti",
    "category": "famous",
    "id": 21011,
    "text": "We all want to be famous people, and the moment we want to be something we are no longer free."
  },
  {
    "author": "Alan Alda",
    "category": "famous",
    "id": 21026,
    "text": "It isn't necessary to be rich and famous to be happy. It's only necessary to be rich."
  },
  {
    "author": "Andrew Coyle Bradley",
    "category": "famous",
    "id": 21565,
    "text": "In approaching our subject it will be best, without attempting to shorten the path by referring to famous theories of the drama, to start directly from the facts, and to collect from them gradually an idea of Shakespearean Tragedy."
  },
  {
    "author": "Jason Lee",
    "category": "famous",
    "id": 21485,
    "text": "Celebrities say they date other celebrities because they have the same job. But I think they just like dating famous people. Celebrities attract each other, like cattle."
  },
  {
    "author": "Paul Biya",
    "category": "famous",
    "id": 21695,
    "text": "Slowly but surely, we are acquiring that famous culture of democracy, which is our objective."
  },
  {
    "author": "Idris Elba",
    "category": "famous",
    "id": 21276,
    "text": "It was deeply important for me to understand where Mandela came from. Because we know where he was going, and that's a famous story, but who was he? Where did he come from? What was his upbringing?"
  },
  {
    "author": "Jean-Jacques Rousseau",
    "category": "famous",
    "id": 21019,
    "text": "How many famous and high-spirited heroes have lived a day too long?"
  },
  {
    "author": "Corey Feldman",
    "category": "famous",
    "id": 21322,
    "text": "I literally was famous before I knew my own name."
  },
  {
    "author": "Will Arnett",
    "category": "famous",
    "id": 21548,
    "text": "Well, yeah. At a certain point, you've got to be really honest with yourself. Like, 'Why am I doing this? What are my motivations?' Like, if you get into it because you want to be famous? Then you've got a long row to hoe. But if you really feel like it's a labour of love and it's something you're actually legitimately good at, then it's not that hard to keep plugging away."
  },
  {
    "author": "Adam Brody",
    "category": "famous",
    "id": 21512,
    "text": "I am super-proud to have a sort of famous character in my background that if you're a certain age, he was probably a part of your youth. I think that's pretty cool."
  },
  {
    "author": "Nicholas Sparks",
    "category": "famous",
    "id": 21287,
    "text": "None of my characters are rich or famous, and the situations they find themselves in could happen to anyone."
  },
  {
    "author": "Andy Warhol",
    "category": "famous",
    "id": 21076,
    "text": "In the future everyone will be famous for 15 minutes."
  },
  {
    "author": "Jason Lee",
    "category": "famous",
    "id": 21658,
    "text": "I wasn't a kid who moved out from Iowa with aspirations of becoming a famous star - I was intrigued by the idea of filmmaking and by the idea of what it would be like to play a character in a movie."
  },
  {
    "author": "Utada Hikaru",
    "category": "famous",
    "id": 21465,
    "text": "I can never really enjoy being famous."
  },
  {
    "author": "Holly Madison",
    "category": "famous",
    "id": 21370,
    "text": "I was always obsessed with being famous. I had Marilyn Monroe paper dolls as a child, and I was always obsessed with her. I've just been really driven in that direction, and none of my friends were. So, I don't know what put that bug in me at a young age."
  },
  {
    "author": "Scott Patterson",
    "category": "famous",
    "id": 21653,
    "text": "Popstars really draws you in. It's fascinating. It's interesting to watch people thrown together in that kind of a situation. Even if the egos weren't involved and they weren't trying to be world famous. It's the Real World, only better."
  },
  {
    "author": "Richard Lewis",
    "category": "famous",
    "id": 21671,
    "text": "I love being famous. It validates that I have something to say."
  },
  {
    "author": "Christopher Parker",
    "category": "famous",
    "id": 21501,
    "text": "I get to meet fantastic people, and I get to go through so many emotions. For me, I have a craving for that. When I'm acting, I feel great. It's not to be famous."
  },
  {
    "author": "Jesse Owens",
    "category": "famous",
    "id": 21037,
    "text": "For a time, at least, I was the most famous person in the entire world."
  },
  {
    "author": "Mae Whitman",
    "category": "famous",
    "id": 21704,
    "text": "People should recognize who you are and how you can act rather then how famous you are."
  },
  {
    "author": "Ani DiFranco",
    "category": "famous",
    "id": 21024,
    "text": "I'd rather be able to face myself in the bathroom mirror than be rich and famous."
  },
  {
    "author": "Charlotte Church",
    "category": "famous",
    "id": 21540,
    "text": "I love singing - singing is what I'm famous for doing. Now it's turned into things I am famous for doing - like having rows with my mum or about my boyfriend, so it does get irritating."
  },
  {
    "author": "Martin Yan",
    "category": "famous",
    "id": 21350,
    "text": "I think being famous is more of a hindrance, a constraint, than just letting yourself be free."
  },
  {
    "author": "Jessica Cutler",
    "category": "famous",
    "id": 21619,
    "text": "Some people with blogs are never going to get famous, and they've been doing it for, like, over a year. I feel bad for them."
  },
  {
    "author": "Nick Clooney",
    "category": "famous",
    "id": 21428,
    "text": "One of the pleasant duties of America's most famous announcers during the relatively short swing era of the big bands was to host late-night remotes from some of the most famous ballrooms throughout the country."
  },
  {
    "author": "Charles Williams",
    "category": "famous",
    "id": 21431,
    "text": "The famous saying 'God is love', it is generally assumed, means that God is like our immediate emotional indulgence, not that the meaning of love ought to have something of the 'otherness' and terror of God."
  },
  {
    "author": "Charles Barkley",
    "category": "famous",
    "id": 21123,
    "text": "One thing about being famous is the people around you, you pay all their bills so they very rarely disagree with you because they want you to pick up the check."
  },
  {
    "author": "Sinead O'Connor",
    "category": "famous",
    "id": 21051,
    "text": "I seek no longer to be a 'famous' person, and instead I wish to live a 'normal' life."
  },
  {
    "author": "Sharon Stone",
    "category": "famous",
    "id": 21256,
    "text": "There are a lot of good things about being famous but there are a few not so good things too."
  },
  {
    "author": "Brett Somers",
    "category": "famous",
    "id": 21394,
    "text": "You know, I'm a television personality. It's not like I'm a famous hooker or something!"
  },
  {
    "author": "Megan Fox",
    "category": "famous",
    "id": 21124,
    "text": "People just assume that if you're famous, you're in Hollywood."
  },
  {
    "author": "Andy Warhol",
    "category": "famous",
    "id": 21075,
    "text": "My idea of a good picture is one that's in focus and of a famous person."
  },
  {
    "author": "Julian Clary",
    "category": "famous",
    "id": 21474,
    "text": "The whole business of getting famous was good fun, but it was a long time ago."
  },
  {
    "author": "Eddie Van Halen",
    "category": "famous",
    "id": 21193,
    "text": "I never dreamt of being a musician for my livelihood. I certainly never would have wanted to be in the business that I'm in, meaning the fame and the glory, the glitter, the rock star, the famous part."
  },
  {
    "author": "Nikki Cox",
    "category": "famous",
    "id": 21572,
    "text": "You're asking the wrong girl about fame. I'm hardly famous. I wouldn't want to trade places with anyone else."
  },
  {
    "author": "Pericles",
    "category": "famous",
    "id": 21022,
    "text": "For famous men have the whole earth as their memorial."
  },
  {
    "author": "Frank Black",
    "category": "famous",
    "id": 21466,
    "text": "It's sour grapes, I admit, I want to be more famous so people are examining my work couplet by couplet, you know what I mean? That's the level where I want to go."
  },
  {
    "author": "Sherry Stringfield",
    "category": "famous",
    "id": 21573,
    "text": "Why does anybody want to be famous? You know what's important to me? Having lunch! Pasta! Seeing my friends! Is that so crazy?"
  },
  {
    "author": "Voltaire",
    "category": "famous",
    "id": 21010,
    "text": "What a heavy burden is a name that has become too famous."
  },
  {
    "author": "Joan Armatrading",
    "category": "famous",
    "id": 21521,
    "text": "You don't have to be rich and famous. You just have to be an ordinary person, doing extraordinary things. I'd like more people to know that it's there. Women's achievements still aren't recognised enough in many areas."
  },
  {
    "author": "Jack Hanna",
    "category": "famous",
    "id": 21635,
    "text": "I had a very famous trainer tell me once, 'You can usually train a wild animal but never tame a wild animal, ever.' They are always going to be wild, no matter what anybody says."
  },
  {
    "author": "Cullen Hightower",
    "category": "famous",
    "id": 21614,
    "text": "People seldom become famous for what they say until after they are famous for what they've done."
  },
  {
    "author": "Alicia Silverstone",
    "category": "famous",
    "id": 21391,
    "text": "I'd die if I was Madonna. I'd die. God, what a horrible way to live. And Michael Jackson! To be so famous and to feel so isolated. I feel so bad for them. I don't know how it feels, and I hope it never happens to me."
  },
  {
    "author": "Elizabeth Hurley",
    "category": "famous",
    "id": 21327,
    "text": "I certainly don't want a child of mine to be famous, or anyone I was very close to who isn't yet... It's the worst thing to be trapped in your house not be able to leave."
  }
]

quotes['fear'] = [
  {
    "author": "Abu Bakr",
    "category": "fear",
    "id": 22316,
    "text": "When you advise any person you should be guided by the fear of God."
  },
  {
    "author": "Samuel Ullman",
    "category": "fear",
    "id": 22250,
    "text": "Years may wrinkle the skin, but to give up enthusiasm wrinkles the soul. Worry, fear, self-distrust bows the heart and turns the spirit back to dust."
  },
  {
    "author": "Paulo Coelho",
    "category": "fear",
    "id": 21837,
    "text": "Tell your heart that the fear of suffering is worse than the suffering itself. And no heart has ever suffered when it goes in search of its dream."
  },
  {
    "author": "Lucius Accius",
    "category": "fear",
    "id": 22416,
    "text": "Let them hate so long as they fear."
  },
  {
    "author": "David Brainerd",
    "category": "fear",
    "id": 22406,
    "text": "I fear God never showed mercy to one so vile as I."
  },
  {
    "author": "Brad Henry",
    "category": "fear",
    "id": 22151,
    "text": "No one should have to choose between medicine and other necessities. No one should have to use the emergency room every time a child gets sick. And no one should have to live in constant fear that a medical problem will become a financial crisis."
  },
  {
    "author": "K. D. Lang",
    "category": "fear",
    "id": 22701,
    "text": "I think masculinity is bravado against the mystery of the universe of women. It's just a fear of not knowing what women have that's so powerful. It's this shield they put up to try to get closer."
  },
  {
    "author": "Anne Lamott",
    "category": "fear",
    "id": 22290,
    "text": "My coming to faith did not start with a leap but rather a series of staggers from what seemed like one safe place to another. Like lily pads, round and green, these places summoned and then held me up while I grew. Each prepared me for the next leaf on which I would land, and in this way I moved across the swamp of doubt and fear."
  },
  {
    "author": "Ernest Gaines",
    "category": "fear",
    "id": 21773,
    "text": "The mark of fear is not easily removed."
  },
  {
    "author": "Huey Newton",
    "category": "fear",
    "id": 22242,
    "text": "There's no reason for the establishment to fear me. But it has every right to fear the people collectively - I am one with the people."
  },
  {
    "author": "Bertrand Russell",
    "category": "fear",
    "id": 21861,
    "text": "To fear love is to fear life, and those who fear life are already three parts dead."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "fear",
    "id": 21960,
    "text": "There are only two forces that unite men - fear and interest."
  },
  {
    "author": "Laura Marling",
    "category": "fear",
    "id": 22613,
    "text": "I've been quite fascinated by the relative insignificance of human existence, the shortness of life. We might as well be a letter in a word in a sentence on a page in a book in a library in a city in one country in this enormous universe! And that kind of fear and insignificance has kept me awake at night."
  },
  {
    "author": "Gerald Jampolsky",
    "category": "fear",
    "id": 22181,
    "text": "Love is the total absence of fear. Love asks no questions. Its natural state is one of extension and expansion, not comparison and measurement."
  },
  {
    "author": "Nicolaus Copernicus",
    "category": "fear",
    "id": 22379,
    "text": "Not a few other very eminent and scholarly men made the same request, urging that I should no longer through fear refuse to give out my work for the common benefit of students of Mathematics."
  },
  {
    "author": "Charles Stanley",
    "category": "fear",
    "id": 21920,
    "text": "God will never direct us to be prideful, arrogant and unforgiving, immoral or slothful or full of fear. We step into these things because we are insensitive to the leadership of the Holy Spirit within us."
  },
  {
    "author": "Simone Weil",
    "category": "fear",
    "id": 22061,
    "text": "As soon as men know that they can kill without fear of punishment or blame, they kill or at least they encourage killers with approving smiles."
  },
  {
    "author": "David Walliams",
    "category": "fear",
    "id": 22516,
    "text": "I don't have a fear factor. Well, not much of one. And I'm willing to risk quite a lot - as a comedian, you're always risking a lot. You're risking failure, especially if you're improvising and going on TV shows trying to make comedy out of thin air. That is quite a risky business."
  },
  {
    "author": "Clarence Darrow",
    "category": "fear",
    "id": 22150,
    "text": "The origin of the absurd idea of immortal life is easy to discover it is kept alive by hope and fear, by childish faith, and by cowardice."
  },
  {
    "author": "Ricky Williams",
    "category": "fear",
    "id": 22404,
    "text": "Well, I am now convinced there is no kind of fear or anxiety anyone has to live with."
  },
  {
    "author": "Florence Nightingale",
    "category": "fear",
    "id": 22047,
    "text": "How very little can be done under the spirit of fear."
  },
  {
    "author": "Steve Irwin",
    "category": "fear",
    "id": 22385,
    "text": "So fear helps me from making mistakes, but I make lot of mistakes."
  },
  {
    "author": "A. N. Wilson",
    "category": "fear",
    "id": 22435,
    "text": "Fear of death has never played a large part in my consciousness - perhaps unimaginative of me."
  },
  {
    "author": "Shimon Peres",
    "category": "fear",
    "id": 22430,
    "text": "I call on the Iranian people: it is not too late to replace the corrupt regime and return to your glorious Persian heritage, a heritage of culture and values and not of bombs and missiles... How can a nation allow a regime to instill fear, take away the people's freedom and shock the young generation that seeks its way out of the dictatorial Iran."
  },
  {
    "author": "Bertrand Russell",
    "category": "fear",
    "id": 21924,
    "text": "Boredom is... a vital problem for the moralist, since half the sins of mankind are caused by the fear of it."
  },
  {
    "author": "Kristen Stewart",
    "category": "fear",
    "id": 22314,
    "text": "I think I'm a bit less inhibited, and not thinking too much before speaking. It's not about being shameful, I'm just a bit more unabashedly myself because of this thing, and it probably started at age 15. I can be around people and say what I think without fear."
  },
  {
    "author": "Anthony Horowitz",
    "category": "fear",
    "id": 22646,
    "text": "My greatest fear is disappointing the reader, so each book has to be better than the one before."
  },
  {
    "author": "John C. Maxwell",
    "category": "fear",
    "id": 21936,
    "text": "The greatest mistake we make is living in constant fear that we will make one."
  },
  {
    "author": "Anthony J. D'Angelo",
    "category": "fear",
    "id": 22192,
    "text": "Don't fear change - embrace it."
  },
  {
    "author": "David Joseph Schwartz",
    "category": "fear",
    "id": 21756,
    "text": "Do what you fear and fear disappears."
  },
  {
    "author": "Robert Kiyosaki",
    "category": "fear",
    "id": 22155,
    "text": "So the Marine Corps really did teach me to conquer fear, and then to go for higher causes, higher purposes."
  },
  {
    "author": "William Jennings Bryan",
    "category": "fear",
    "id": 22014,
    "text": "The way to develop self-confidence is to do the thing you fear and get a record of successful experiences behind you."
  },
  {
    "author": "George W. Bush",
    "category": "fear",
    "id": 22111,
    "text": "The terrorists are fighting freedom with all their cunning and cruelty because freedom is their greatest fear - and they should be afraid, because freedom is on the march."
  },
  {
    "author": "Criss Angel",
    "category": "fear",
    "id": 22692,
    "text": "I think that the problem is that people fear so many things and they don't live life to its fullest. And for me as an artist, if God should want me to come this Wednesday to the end of my life, so be it."
  },
  {
    "author": "Sandra Day O'Connor",
    "category": "fear",
    "id": 22243,
    "text": "It is a measure of the framers' fear that a passing majority might find it expedient to compromise 4th Amendment values that these values were embodied in the Constitution itself."
  },
  {
    "author": "George Washington Carver",
    "category": "fear",
    "id": 21910,
    "text": "Fear of something is at the root of hate for others, and hate within will eventually destroy the hater."
  },
  {
    "author": "Natan Sharansky",
    "category": "fear",
    "id": 22680,
    "text": "In contrast, fear societies are societies in which dissent is banned."
  },
  {
    "author": "Mariska Hargitay",
    "category": "fear",
    "id": 22582,
    "text": "I am grateful that I didn't let fear get the best of me. It only holds you back from possibilities and greatness."
  },
  {
    "author": "Russell Baker",
    "category": "fear",
    "id": 22358,
    "text": "Roosevelt's declaration that Americans had 'nothing to fear but fear itself' was a glorious piece of inspirational rhetoric and just as gloriously wrong."
  },
  {
    "author": "Joaquin Phoenix",
    "category": "fear",
    "id": 22454,
    "text": "I always have the fear that, if I don't commit 100 percent to my work, then it's gonna suffer."
  },
  {
    "author": "Ian Rush",
    "category": "fear",
    "id": 21777,
    "text": "And the things that we fear are a weapon to be held against us."
  },
  {
    "author": "William Hazlitt",
    "category": "fear",
    "id": 22096,
    "text": "Satirists gain the applause of others through fear, not through love."
  },
  {
    "author": "Lewis Mumford",
    "category": "fear",
    "id": 22341,
    "text": "Without fullness of experience, length of days is nothing. When fullness of life has been achieved, shortness of days is nothing. That is perhaps why the young have usually so little fear of death they live by intensities that the elderly have forgotten."
  },
  {
    "author": "George S. Patton",
    "category": "fear",
    "id": 21945,
    "text": "There is a time to take counsel of your fears, and there is a time to never listen to any fear."
  },
  {
    "author": "Andrea Jung",
    "category": "fear",
    "id": 22514,
    "text": "President Obama's 100-day plan is pretty impressive. I think it's a Wow 100-plus days. The administration is not operating from fear, it is trying to drive change for the future, and that's a good thing."
  },
  {
    "author": "Stanislav Grof",
    "category": "fear",
    "id": 22503,
    "text": "The elimination of the fear of death transforms the individual's way of being in the world."
  },
  {
    "author": "Michelle Pfeiffer",
    "category": "fear",
    "id": 22638,
    "text": "I was kind of surprised to learn how controlling I am. I never thought of myself in that way. I think the root of the control issues is usually fear, because you want to know what's going to be happening at any given moment."
  },
  {
    "author": "Harry S. Truman",
    "category": "fear",
    "id": 22025,
    "text": "We shall never be able to remove suspicion and fear as potential causes of war until communication is permitted to flow, free and open, across international boundaries."
  },
  {
    "author": "Otto von Bismarck",
    "category": "fear",
    "id": 22334,
    "text": "An appeal to fear never finds an echo in German hearts."
  },
  {
    "author": "Bo Bennett",
    "category": "fear",
    "id": 22031,
    "text": "While we are focusing on fear, worry, or hate, it is not possible for us to be experiencing happiness, enthusiasm or love."
  },
  {
    "author": "Indra Devi",
    "category": "fear",
    "id": 22627,
    "text": "Yoga is a way to freedom. By its constant practice, we can free ourselves from fear, anguish and loneliness."
  },
  {
    "author": "Cyril Connolly",
    "category": "fear",
    "id": 22411,
    "text": "As repressed sadists are supposed to become policemen or butchers so those with an irrational fear of life become publishers."
  },
  {
    "author": "Eleanor Roosevelt",
    "category": "fear",
    "id": 21824,
    "text": "I believe that anyone can conquer fear by doing the things he fears to do, provided he keeps doing them until he gets a record of successful experience behind him."
  },
  {
    "author": "Douglas Horton",
    "category": "fear",
    "id": 22201,
    "text": "Action cures fear, inaction creates terror."
  },
  {
    "author": "Stevie Nicks",
    "category": "fear",
    "id": 22441,
    "text": "If you have stage fright, it never goes away. But then I wonder: is the key to that magical performance because of the fear?"
  },
  {
    "author": "William Tecumseh Sherman",
    "category": "fear",
    "id": 22115,
    "text": "My aim, then, was to whip the rebels, to humble their pride, to follow them to their inmost recesses, and make them fear and dread us. Fear is the beginning of wisdom."
  },
  {
    "author": "Harry S. Truman",
    "category": "fear",
    "id": 21934,
    "text": "America was not built on fear. America was built on courage, on imagination and an unbeatable determination to do the job at hand."
  },
  {
    "author": "Babe Ruth",
    "category": "fear",
    "id": 21819,
    "text": "Don't let the fear of striking out hold you back."
  },
  {
    "author": "Alexander Wang",
    "category": "fear",
    "id": 22644,
    "text": "I think everyone shares a fear of failure - that you're only as good as your most recent collection. That's definitely a fear, but it's a fear that fuels me, that makes me want to work harder, that makes me take on more challenges."
  },
  {
    "author": "Robert Crais",
    "category": "fear",
    "id": 22676,
    "text": "What they smell isn't the emotion of fear. What dogs can smell is the changes in a person's skin that suggest fear to the dog, anxiety, the way your skin sweats, the amount of uric acid that suddenly pours out of your pores."
  },
  {
    "author": "Tertullian",
    "category": "fear",
    "id": 22221,
    "text": "Fear is the foundation of safety."
  },
  {
    "author": "Melissa Rosenberg",
    "category": "fear",
    "id": 22597,
    "text": "Studios, because they are investing a great deal of money in movies, they want a guarantee that when they hire somebody that person can deliver for them. Everything is fear based, so they pigeonhole people. But I've written everything, from Westerns to sci-fi to dramedy, I've done it all."
  },
  {
    "author": "Katharine Butler Hathaway",
    "category": "fear",
    "id": 21785,
    "text": "If you let your fear of consequence prevent you from following your deepest instinct, your life will be safe, expedient and thin."
  },
  {
    "author": "Kesha",
    "category": "fear",
    "id": 22298,
    "text": "I try to get in quiet time and book time, but really, the only time I ever get that is when I'm on an airplane - I have a fear of flying, but I actually love flying because it's the only time I can sleep, and it's the only time I get to read."
  },
  {
    "author": "Carly Simon",
    "category": "fear",
    "id": 22678,
    "text": "I remember being onstage once when I didn't have fear: I got so scared I didn't have fear that it brought on an anxiety attack."
  },
  {
    "author": "Lou Brock",
    "category": "fear",
    "id": 21781,
    "text": "Show me a guy who's afraid to look bad, and I'll show you a guy you can beat every time."
  },
  {
    "author": "Marie Curie",
    "category": "fear",
    "id": 21832,
    "text": "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more, so that we may fear less."
  },
  {
    "author": "Dave Matthews",
    "category": "fear",
    "id": 22478,
    "text": "I fear that our true motivation is about oil and our own flailing economy about the failure to destroy Al Qaeda and about revenge."
  },
  {
    "author": "Algernon Charles Swinburne",
    "category": "fear",
    "id": 22543,
    "text": "Hope thou not much, and fear thou not at all."
  },
  {
    "author": "Dustin Hoffman",
    "category": "fear",
    "id": 21772,
    "text": "One thing about being successful is that I stopped being afraid of dying. Once you're a star you're dead already. You're embalmed."
  },
  {
    "author": "Calvin Klein",
    "category": "fear",
    "id": 22266,
    "text": "I won't allow myself to have tremendous fear."
  },
  {
    "author": "Jeffrey Kluger",
    "category": "fear",
    "id": 22427,
    "text": "At the root of the shy temperament is a deep fear of social judgment, one so severe it can sometimes be crippling. Introverted people don't worry unduly about whether they'll be found wanting, they just find too much socializing exhausting and would prefer either to be alone or in the company of a select few people."
  },
  {
    "author": "Sonia Johnson",
    "category": "fear",
    "id": 21774,
    "text": "What we have most to fear is failure of the heart."
  },
  {
    "author": "Lady Gaga",
    "category": "fear",
    "id": 22159,
    "text": "I just want my family to be safe. Because I am sometimes polarizing, I fear for their safety."
  },
  {
    "author": "Zora Neale Hurston",
    "category": "fear",
    "id": 22119,
    "text": "Grab the broom of anger and drive off the beast of fear."
  },
  {
    "author": "Stanislav Grof",
    "category": "fear",
    "id": 22423,
    "text": "Coming to terms with the fear of death is conducive to healing, positive personality transformation, and consciousness evolution."
  },
  {
    "author": "Sara Blakely",
    "category": "fear",
    "id": 22381,
    "text": "I took a Fear of Flying class, and I always missed the class, because I was always flying."
  },
  {
    "author": "Milan Kundera",
    "category": "fear",
    "id": 22268,
    "text": "Mysticism and exaggeration go together. A mystic must not fear ridicule if he is to push all the way to the limits of humility or the limits of delight."
  },
  {
    "author": "David Mamet",
    "category": "fear",
    "id": 22357,
    "text": "My greatest fear is that the audience will beat me to the punch line."
  },
  {
    "author": "Brooke Burke",
    "category": "fear",
    "id": 22523,
    "text": "Hey, we all have our fear. Mine is bugs and lobsters!"
  },
  {
    "author": "Dan Rather",
    "category": "fear",
    "id": 22354,
    "text": "Fear rules almost every newsroom in the country."
  },
  {
    "author": "David Duchovny",
    "category": "fear",
    "id": 22281,
    "text": "Fame does lead to money, which I don't have a close relationship with. I'm the kind of guy who never sees the money - it all goes somewhere else. I don't understand it, I don't like to deal with it. I have a fear of not having it, because I grew up without it."
  },
  {
    "author": "Damien Hirst",
    "category": "fear",
    "id": 22245,
    "text": "I have always been aware that you have to get people listening before you can change their minds. Any artist's big fear is being ignored, so if you get debate, that's great."
  },
  {
    "author": "Leona Lewis",
    "category": "fear",
    "id": 22459,
    "text": "Fear and pain and suffering is not OK for any being to feel intentionally at the hands of us."
  },
  {
    "author": "John Mayer",
    "category": "fear",
    "id": 22280,
    "text": "You cannot avoid war in life, you cannot avoid the fear of terrorism, you cannot avoid those things now, they are a part of everyday demeanor."
  },
  {
    "author": "Publilius Syrus",
    "category": "fear",
    "id": 22172,
    "text": "Audacity augments courage hesitation, fear."
  },
  {
    "author": "Bertolt Brecht",
    "category": "fear",
    "id": 21998,
    "text": "Do not fear death so much but rather the inadequate life."
  },
  {
    "author": "Marvin Gaye",
    "category": "fear",
    "id": 22419,
    "text": "Most fear stems from sin to limit one's sins, one must assuredly limit one's fear, thereby bringing more peace to one's spirit."
  },
  {
    "author": "Robert Anton Wilson",
    "category": "fear",
    "id": 22217,
    "text": "The abandoned infant's cry is rage, not fear."
  },
  {
    "author": "Tom Brady",
    "category": "fear",
    "id": 22564,
    "text": "I don't want to wake up and be bored. That's probably my greatest fear is to have nothing to do. What better job is there than to play quarterback for an NFL team, and certainly one that I've been on for a long time and had success with? I don't plan on giving it up any time soon."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "fear",
    "id": 21814,
    "text": "Power is of two kinds. One is obtained by the fear of punishment and the other by acts of love. Power based on love is a thousand times more effective and permanent then the one derived from fear of punishment."
  },
  {
    "author": "Marianne Williamson",
    "category": "fear",
    "id": 21891,
    "text": "As we let our light shine, we unconsciously give other people permission to do the same. As we are liberated from our own fear, our presence actually liberates others."
  },
  {
    "author": "Nicholas Hoult",
    "category": "fear",
    "id": 22705,
    "text": "I think interviews can be fine. It's just there's this terrible fear of coming off wrongly or saying something that gets taken out of context."
  },
  {
    "author": "Ray Comfort",
    "category": "fear",
    "id": 22540,
    "text": "When men don't fear God, they give themselves to evil."
  },
  {
    "author": "Jack Nicholson",
    "category": "fear",
    "id": 22263,
    "text": "A star on a movie set is like a time bomb. That bomb has got to be defused so people can approach it without fear."
  },
  {
    "author": "Willie Aames",
    "category": "fear",
    "id": 22537,
    "text": "They did interviews with my wife and daughter-they were genuinely in fear of me having a heart attack, working 20 hours a day, eating fast food."
  },
  {
    "author": "Bashar al-Assad",
    "category": "fear",
    "id": 22542,
    "text": "Worry does not mean fear, but readiness for the confrontation."
  },
  {
    "author": "Ben Jonson",
    "category": "fear",
    "id": 22271,
    "text": "There is no greater hell than to be a prisoner of fear."
  },
  {
    "author": "Herb Kelleher",
    "category": "fear",
    "id": 22235,
    "text": "A company is stronger if it is bound by love rather than by fear."
  },
  {
    "author": "Warren Farrell",
    "category": "fear",
    "id": 22400,
    "text": "A man's primary fantasy is access to a variety of attractive women without the fear of rejection."
  }
]

quotes['finance'] = [
  {
    "author": "Mathias Rust",
    "category": "finance",
    "id": 22862,
    "text": "I now work for a finance company in Luxembourg with projects in South America and the Caribbean."
  },
  {
    "author": "Ehud Barak",
    "category": "finance",
    "id": 22858,
    "text": "I delivered lectures, and I was also a consultant for international companies in finance, both private equity and big venture capital funds."
  },
  {
    "author": "Russell Baker",
    "category": "finance",
    "id": 22790,
    "text": "There is a growing literature about the multitude of journalism's problems, but most of it is concerned with the editorial side of the business, possibly because most people competent to write about journalism are not comfortable writing about finance."
  },
  {
    "author": "Jeffrey Sachs",
    "category": "finance",
    "id": 22757,
    "text": "We've taken the view that if the rest of the world would democratize and create market economies, that would spread the benefits of prosperity around the world, and that it would enhance our own prosperity, and our own stability and security, as well."
  },
  {
    "author": "Scott Cook",
    "category": "finance",
    "id": 22759,
    "text": "Thirty to 40 years ago, most financial decisions were fairly simple."
  },
  {
    "author": "William Greider",
    "category": "finance",
    "id": 22838,
    "text": "In the deregulated realm of US banking and finance, crime does occasionally pay for its foul deeds, not in prison time but by making modest rebates to the victims."
  },
  {
    "author": "Wolfgang Schauble",
    "category": "finance",
    "id": 22846,
    "text": "In the long term, Germany didn't need a finance minister who was absent during important negotiations in the European Council. But the chancellor strongly encouraged me to stay. And everything did work out for the best in the end."
  },
  {
    "author": "Adam Smith",
    "category": "finance",
    "id": 22735,
    "text": "All money is a matter of belief."
  },
  {
    "author": "Evan Davis",
    "category": "finance",
    "id": 22791,
    "text": "We all know that Americans love their statistics - in sport, obviously. And in finance too."
  },
  {
    "author": "Andy Sawford",
    "category": "finance",
    "id": 22883,
    "text": "The government is also looking at further benefits including enhanced capital allowances the use of Tax Incremental Finance and extra help from UK Trade and Investment on inward investment and trade opportunities."
  },
  {
    "author": "Clarence Day",
    "category": "finance",
    "id": 22736,
    "text": "A moderate addiction to money may not always be hurtful but when taken in excess it is nearly always bad for the health."
  },
  {
    "author": "Mikhail Khodorkovsky",
    "category": "finance",
    "id": 22865,
    "text": "Large companies cannot finance political parties as their shareholders and employees have different political views."
  },
  {
    "author": "Robert Graves",
    "category": "finance",
    "id": 22802,
    "text": "What we now call 'finance' is, I hold, an intellectual perversion of what began as warm human love."
  },
  {
    "author": "Alan Greenspan",
    "category": "finance",
    "id": 22728,
    "text": "Any informed borrower is simply less vulnerable to fraud and abuse."
  },
  {
    "author": "Peter Schuyler",
    "category": "finance",
    "id": 22870,
    "text": "To be fair, lying is part and parcel of public life. Every politician has lied about something because they are owned by the special interest groups that finance their elections."
  },
  {
    "author": "Alexander John Ellis",
    "category": "finance",
    "id": 22777,
    "text": "Rounding to the nearest cent is sufficiently accurate for practical purposes."
  },
  {
    "author": "Benjamin Franklin",
    "category": "finance",
    "id": 22709,
    "text": "Your net worth to the world is usually determined by what remains after your bad habits are subtracted from your good ones."
  },
  {
    "author": "Zack Space",
    "category": "finance",
    "id": 22886,
    "text": "It starts with campaign finance reform."
  },
  {
    "author": "Henry Ford",
    "category": "finance",
    "id": 22708,
    "text": "It is well enough that people of the nation do not understand our banking and monetary system, for if they did, I believe there would be a revolution before tomorrow morning."
  },
  {
    "author": "Rick Santorum",
    "category": "finance",
    "id": 22813,
    "text": "I believe in capitalism for everybody, not necessarily high finance but capitalism that works for the working men and women of this country who are out there paddling alone in America right now."
  },
  {
    "author": "Andrew Card",
    "category": "finance",
    "id": 22875,
    "text": "Well, paycheck protection is an important ingredient for a successful campaign finance reform measure."
  },
  {
    "author": "Arlie Russell Hochschild",
    "category": "finance",
    "id": 22864,
    "text": "The more anxious, isolated and time-deprived we are, the more likely we are to turn to paid personal services. To finance these extra services, we work longer hours. This leaves less time to spend with family, friends and neighbors we become less likely to call on them for help, and they on us."
  },
  {
    "author": "John Barrymore",
    "category": "finance",
    "id": 22780,
    "text": "If it isn't the sheriff, it's the finance company I've got more attachments on me than a vacuum cleaner."
  },
  {
    "author": "Sarah Jessica Parker",
    "category": "finance",
    "id": 22797,
    "text": "One of the things that's great about New York is that it is not a one-industry town. It has education, academia, the service industry, arts, publishing, theater, politics, fashion, finance, as well as movie-making."
  },
  {
    "author": "Francois Hollande",
    "category": "finance",
    "id": 22794,
    "text": "My real adversary has no name, no face, no party. It will never be elected, yet it governs - the adversary is the world of finance."
  },
  {
    "author": "Joely Richardson",
    "category": "finance",
    "id": 22856,
    "text": "Everyone knows in the industry that when these great roles come up, every two years, there's a huge number of people up for them. I'm not one of those top five females that can personally finance any film."
  },
  {
    "author": "Hjalmar Schacht",
    "category": "finance",
    "id": 22765,
    "text": "The economy is a very sensitive organism."
  },
  {
    "author": "Frank Gaffney",
    "category": "finance",
    "id": 22829,
    "text": "Sharia has become an increasingly significant force in American capitalism, thanks to the embrace by Wall Street and the U.S. government of so-called Sharia-Compliant Finance. Indeed, this country's taxpayers now own the largest purveyor of sharia-compliant insurance products in the world: AIG."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "finance",
    "id": 22727,
    "text": "Wealth, in even the most improbable cases, manages to convey the aspect of intelligence."
  },
  {
    "author": "Debbie Stabenow",
    "category": "finance",
    "id": 22815,
    "text": "As Michigan's voice on the Senate Finance Committee and Senate Energy and Natural Resources Committee, I will continue working to make sure the next generation of advanced technologies and alternative fuel vehicles are made right here in America."
  },
  {
    "author": "Ben Nelson",
    "category": "finance",
    "id": 22863,
    "text": "I certainly want campaign finance reform. I just wish this would do it in a way that would stand up to a constitutional challenge."
  },
  {
    "author": "John D. Rockefeller",
    "category": "finance",
    "id": 22733,
    "text": "Do you know the only thing that gives me pleasure? It's to see my dividends coming in."
  },
  {
    "author": "Shimon Peres",
    "category": "finance",
    "id": 22793,
    "text": "I worked with a group of people who argued day and night - professors, officials, the Minister of Finance - but there were decisions that I had to make."
  },
  {
    "author": "Jeroen Dijsselbloem",
    "category": "finance",
    "id": 22884,
    "text": "If I finance a bank and I know if the bank will get in trouble, I will be hit and I will lose money, I will put a price on that."
  },
  {
    "author": "Helen Fielding",
    "category": "finance",
    "id": 22854,
    "text": "I was writing an earnest novel about cruises in the Caribbean and I just started writing 'Bridget Jones' to get some money, to finance this earnest work, and then I chucked it out."
  },
  {
    "author": "Jeffrey Sachs",
    "category": "finance",
    "id": 22742,
    "text": "We had a booming stock market in 1929 and then went into the world's greatest depression. We have a booming stock market in 1999. Will the bubble somehow burst, and then we enter depression? Well, some things are not different."
  },
  {
    "author": "John Hurt",
    "category": "finance",
    "id": 22859,
    "text": "I turn up in Los Angeles every now and then, so I can get some big money films in order to finance my smaller money films."
  },
  {
    "author": "William J. Clinton",
    "category": "finance",
    "id": 22785,
    "text": "Where are the jobs going to come from?Small business, manufacturing and clean energy. Where's the money to finance them? The banks and the corporations in America today have lots of money that they can invest right now."
  },
  {
    "author": "Carol Moseley Braun",
    "category": "finance",
    "id": 22817,
    "text": "The reason that minorities and women don't have a better shot at getting elected to the Senate or to statewide office is because the campaign finance rules are so skewed as to make it very difficult for non-traditional candidates to raise the money necessary to get elected."
  },
  {
    "author": "Yahoo Serious",
    "category": "finance",
    "id": 22822,
    "text": "Now both my films have been number one at the Australian box office and it took about two years just to get the finance for this film, so if it's hard for me then God help everyone else."
  },
  {
    "author": "Mark Rydell",
    "category": "finance",
    "id": 22860,
    "text": "It's very difficult to break into motion pictures, but it's oddly easier for directors today because of independent films and cable, who have inherited for the most part those films of substance that the studios are reluctant to finance."
  },
  {
    "author": "Renny Harlin",
    "category": "finance",
    "id": 22827,
    "text": "There were a lot of people dreaming about making films, and they would finance maybe 6 films a year. Because they were funded by the government, the films sort-of had to deal with serious social issues - and, as a result, nobody went to see those films."
  },
  {
    "author": "Ruth Handler",
    "category": "finance",
    "id": 22772,
    "text": "I wasn't a financial pro, and I paid the price."
  },
  {
    "author": "Charles Spurgeon",
    "category": "finance",
    "id": 22730,
    "text": "It's not the having, it's the getting."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "finance",
    "id": 22732,
    "text": "Wealth is not without its advantages and the case to the contrary, although it has often been made, has never proved widely persuasive."
  },
  {
    "author": "Greer Garson",
    "category": "finance",
    "id": 22747,
    "text": "Starting out to make money is the greatest mistake in life. Do what you feel you have a flair for doing, and if you are good enough at it, the money will come."
  },
  {
    "author": "Suze Orman",
    "category": "finance",
    "id": 22714,
    "text": "A big part of financial freedom is having your heart and mind free from worry about the what-ifs of life."
  },
  {
    "author": "Honore de Balzac",
    "category": "finance",
    "id": 22782,
    "text": "Finance, like time, devours its own children."
  },
  {
    "author": "Martin Feldstein",
    "category": "finance",
    "id": 22758,
    "text": "The only way that we can reduce our financial dependence on the inflow of funds from the rest of the world is to reduce our trade deficit."
  },
  {
    "author": "Merton Miller",
    "category": "finance",
    "id": 22851,
    "text": "I had some of the students in my finance class actually do some empirical work on capital structures, to see if we could find any obvious patterns in the data, but we couldn't see any."
  },
  {
    "author": "Hillary Clinton",
    "category": "finance",
    "id": 22779,
    "text": "Every nation has to either be with us, or against us. Those who harbor terrorists, or who finance them, are going to pay a price."
  },
  {
    "author": "John D. Rockefeller",
    "category": "finance",
    "id": 22725,
    "text": "The way to make money is to buy when blood is running in the streets."
  },
  {
    "author": "Paul M. Glaser",
    "category": "finance",
    "id": 22876,
    "text": "I've been writing a lot, I've a few projects I'm trying to finance, I do some acting, I do some directing... Apart from that, if I could get lower that a ten handicap on my golf game I'd be thrilled."
  },
  {
    "author": "Andrew Motion",
    "category": "finance",
    "id": 22812,
    "text": "I like eating out. I like buying beautiful paintings and being surrounded by beautiful things. I have to finance that life. I can barely afford a pension scheme because I don't make enough money."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "finance",
    "id": 22789,
    "text": "The monarchy is foremost a business, and it's important to them that the British public continue to finance the excessive luxurious lifestyles of the now quite enormous, wasteful and useless 'royal' family. I find it very sad."
  },
  {
    "author": "Tadao Ando",
    "category": "finance",
    "id": 22808,
    "text": "But now, more and more, its society is concerned with economy and finance."
  },
  {
    "author": "Jacques Delors",
    "category": "finance",
    "id": 22751,
    "text": "The problem of how we finance the welfare state should not obscure a separate issue: if each person thinks he has an inalienable right to welfare, no matter what happens to the world, that's not equity, it's just creating a society where you can't ask anything of people."
  },
  {
    "author": "Timothy Geithner",
    "category": "finance",
    "id": 22820,
    "text": "And I think it's a prudent, responsible way, given the scale of the emergency, the scale of the damage still facing America, that we finance these additional support for the unemployed as well as the support for small business. We think there's a good case for doing it now. We want to do it in an overall fiscally responsible way."
  },
  {
    "author": "Friedrich List",
    "category": "finance",
    "id": 22771,
    "text": "It is bad policy to regulate everything... where things may better regulate themselves and can be better promoted by private exertions but it is no less bad policy to let those things alone which can only be promoted by interfering social power."
  },
  {
    "author": "Lee Iacocca",
    "category": "finance",
    "id": 22738,
    "text": "We at Chrysler borrow money the old-fashioned way. We pay it back."
  },
  {
    "author": "Andrew Carnegie",
    "category": "finance",
    "id": 22740,
    "text": "The way to become rich is to put all your eggs in one basket and then watch that basket."
  },
  {
    "author": "William Petty",
    "category": "finance",
    "id": 22766,
    "text": "Money is the best rule of commerce."
  },
  {
    "author": "Timothy Geithner",
    "category": "finance",
    "id": 22810,
    "text": "I personally believe that there's going to be a good case for the government preserving some type of guarantee to make sure that people have the ability to borrow to finance a house even in a very damaging recession. I think there's going to be a good case for that."
  },
  {
    "author": "Robert McChesney",
    "category": "finance",
    "id": 22825,
    "text": "The number one lobby that opposes campaign finance reform in the United States is the National Association of Broadcasters."
  },
  {
    "author": "John Rawls",
    "category": "finance",
    "id": 22843,
    "text": "In constant pursuit of money to finance campaigns, the political system is simply unable to function. Its deliberative powers are paralyzed."
  },
  {
    "author": "James L. Buckley",
    "category": "finance",
    "id": 22847,
    "text": "What distinguishes the campaign finance issue from just about every other one being debated these days is that the two sides do not divide along conventional liberal/ conservative lines."
  },
  {
    "author": "Andrew Tobias",
    "category": "finance",
    "id": 22877,
    "text": "Nobody wants campaign finance reform more than me. It would save me a fortune."
  },
  {
    "author": "Mark Zandi",
    "category": "finance",
    "id": 22805,
    "text": "The FHA's success provides strong evidence that government can and should play a role in the nation's mortgage finance system. It also demonstrates that although government intervention in the economy during the Great Recession was messy, things would have been a lot messier without it."
  },
  {
    "author": "Evo Morales",
    "category": "finance",
    "id": 22811,
    "text": "I have a lot of trouble understanding all the detail of finance and administration - but if you combine intellectual and professional capacity with a social conscience, you can change things: countries, structures, economic models, colonial states."
  },
  {
    "author": "David Bowie",
    "category": "finance",
    "id": 22784,
    "text": "I'm looking for backing for an unauthorized auto-biography that I am writing. Hopefully, this will sell in such huge numbers that I will be able to sue myself for an extraordinary amount of money and finance the film version in which I will play everybody."
  },
  {
    "author": "James Chanos",
    "category": "finance",
    "id": 22833,
    "text": "I've learned there's a big difference between a long-focused value investor and a good short-seller. That difference is psychological and I think it falls into the realm of behavioral finance."
  },
  {
    "author": "Alfred Marshall",
    "category": "finance",
    "id": 22764,
    "text": "The price of every thing rises and falls from time to time and place to place and with every such change the purchasing power of money changes so far as that thing goes."
  },
  {
    "author": "Marcy Kaptur",
    "category": "finance",
    "id": 22853,
    "text": "We came from a family where we ran our own small business. Our dad made his own products. We made our own sausages, our own meatloafs, our own pickles. Dad had to do everything himself. He had to figure out how to finance his business."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "finance",
    "id": 22718,
    "text": "Under capitalism, man exploits man. Under communism, it's just the opposite."
  },
  {
    "author": "Gray Davis",
    "category": "finance",
    "id": 22844,
    "text": "We'll have a public power authority, which will also have the ability to build power or finance power. And more importantly, we'll have more power than our economy provides. All of that will give us leverage we don't have today."
  },
  {
    "author": "Alistair Darling",
    "category": "finance",
    "id": 22885,
    "text": "Our goal is to make finance the servant, not the master, of the real economy."
  },
  {
    "author": "Bernard Baruch",
    "category": "finance",
    "id": 22752,
    "text": "I made my money by selling too soon."
  },
  {
    "author": "Alice Rivlin",
    "category": "finance",
    "id": 22774,
    "text": "The job of the Central Bank is to worry."
  },
  {
    "author": "Vince Cable",
    "category": "finance",
    "id": 22801,
    "text": "Small- and medium-sized businesses need access to a diverse range of finance options, including non-bank lending. These new forms of finance are still small in scale today but they should, over time, bring additional choice and greater competition to the lending market."
  },
  {
    "author": "John Maynard Keynes",
    "category": "finance",
    "id": 22746,
    "text": "The avoidance of taxes is the only intellectual pursuit that still carries any reward."
  },
  {
    "author": "Sherrod Brown",
    "category": "finance",
    "id": 22842,
    "text": "We were told this war would be over in a matter of weeks, and that the Iraqis would be able to finance it with oil sales. We were promised it was not a mission of nation building."
  },
  {
    "author": "Bille August",
    "category": "finance",
    "id": 22873,
    "text": "I wanted to make Jerusalem as feature film. But we couldn't finance it only through theatrical release, we couldn't get all the money we needed. We had to get some money from television. So we said, ok, let's do it both ways. So we did it in four parts."
  },
  {
    "author": "Jim Rohn",
    "category": "finance",
    "id": 22711,
    "text": "Part of your heritage in this society is the opportunity to become financially independent."
  },
  {
    "author": "Merton Miller",
    "category": "finance",
    "id": 22852,
    "text": "Arbitrage proof has since been widely used throughout finance and economics."
  },
  {
    "author": "Mark Burnett",
    "category": "finance",
    "id": 22814,
    "text": "'Survivor' wouldn't have happened had I not gone out there and helped CBS to sell sponsors to finance the first one. Part of my thinking on 'Survivor' was that it should have rewards that are corporate brands. A Big Mac, one thimble-full of Coca-Cola."
  },
  {
    "author": "Richard Armitage",
    "category": "finance",
    "id": 22879,
    "text": "The war we are fighting today against terrorism is a multifaceted fight. We have to use every tool in our toolkit to wage this war - diplomacy, finance, intelligence, law enforcement, and of course, military power - and we are developing new tools as we go along."
  },
  {
    "author": "Donald Trump",
    "category": "finance",
    "id": 22716,
    "text": "Money was never a big motivation for me, except as a way to keep score. The real excitement is playing the game."
  },
  {
    "author": "Rodrigo Rato",
    "category": "finance",
    "id": 22866,
    "text": "Masood Ahmed brings to the position of director of external relations extensive experience gained in a range of senior positions in international finance and development."
  },
  {
    "author": "Thomas Carper",
    "category": "finance",
    "id": 22767,
    "text": "Thirteen thousand dollars a year is not enough to raise a family. That's not enough to pay your bills and save for their future. That's barely enough to provide for even the most basic needs."
  },
  {
    "author": "John Patrick",
    "category": "finance",
    "id": 22880,
    "text": "Many dotcoms recruited people from existing companies who were quite experienced in finance, marketing, distribution and other disciplines but not necessarily experienced in the Web culture."
  },
  {
    "author": "Irving Fisher",
    "category": "finance",
    "id": 22770,
    "text": "The rate of interest acts as a link between income-value and capital-value."
  },
  {
    "author": "Hillary Clinton",
    "category": "finance",
    "id": 22778,
    "text": "In almost every profession - whether it's law or journalism, finance or medicine or academia or running a small business - people rely on confidential communications to do their jobs. We count on the space of trust that confidentiality provides. When someone breaches that trust, we are all worse off for it."
  },
  {
    "author": "Alfred Marshall",
    "category": "finance",
    "id": 22763,
    "text": "Capital is that part of wealth which is devoted to obtaining further wealth."
  },
  {
    "author": "Martin Feldstein",
    "category": "finance",
    "id": 22819,
    "text": "But because we in the United States finance our current account deficit by borrowing in our own currency, we can move to a more competitive dollar without the adverse effects that followed currency declines in other countries."
  },
  {
    "author": "Elena Kagan",
    "category": "finance",
    "id": 22855,
    "text": "In fact, corporate and union moneys go overwhelmingly to incumbents, so limiting that money, as Congress did in the campaign finance law, may be the single most self-denying thing that Congress has ever done."
  },
  {
    "author": "Jean-Paul Sartre",
    "category": "finance",
    "id": 22722,
    "text": "The poor don't know that their function in life is to exercise our generosity."
  },
  {
    "author": "Regis Philbin",
    "category": "finance",
    "id": 22755,
    "text": "I'm involved in the stock market, which is fun and, sometimes, very painful."
  },
  {
    "author": "Honore de Balzac",
    "category": "finance",
    "id": 22719,
    "text": "I do not regard a broker as a member of the human race."
  },
  {
    "author": "Will Rogers",
    "category": "finance",
    "id": 22712,
    "text": "Don't gamble take all your savings and buy some good stock and hold it till it goes up, then sell it. If it don't go up, don't buy it."
  },
  {
    "author": "William Temple",
    "category": "finance",
    "id": 22756,
    "text": "The only way for a rich man to be healthy is by exercise and abstinence, to live as if he were poor."
  }
]

quotes['fitness'] = [
  {
    "author": "Samantha Stosur",
    "category": "fitness",
    "id": 23032,
    "text": "Flexibility is crucial to my fitness. Incorporating a good warm-up and cool-down into every session decreases my chances of injury. I use both dynamic and static stretching in my training. I've starting doing a few yoga sessions which incorporates muscle strength and flexibility."
  },
  {
    "author": "Denis Waitley",
    "category": "fitness",
    "id": 22898,
    "text": "Time and health are two precious assets that we don't recognize and appreciate until they have been depleted."
  },
  {
    "author": "George A. Sheehan",
    "category": "fitness",
    "id": 22923,
    "text": "Exercise is done against one's wishes and maintained only because the alternative is worse."
  },
  {
    "author": "Rafer Johnson",
    "category": "fitness",
    "id": 23026,
    "text": "The main thing is that it's nice to see these young people - 9 to 14 years old - take the opportunity to get more involved in their health and fitness. We need more kids to be more active."
  },
  {
    "author": "Lance Armstrong",
    "category": "fitness",
    "id": 22975,
    "text": "Obviously, I come from one background, and the people that design fitness equipment have been doing it for years and years, and they know what works and doesn't work."
  },
  {
    "author": "Lena Dunham",
    "category": "fitness",
    "id": 22979,
    "text": "My weight fluctuates depending on my mood and my current devotion to my fitness routine."
  },
  {
    "author": "Fred Perry",
    "category": "fitness",
    "id": 22908,
    "text": "Tactics, fitness, stroke ability, adaptability, experience, and sportsmanship are all necessary for winning."
  },
  {
    "author": "E. T. Bell",
    "category": "fitness",
    "id": 23043,
    "text": "Guided only by their feeling for symmetry, simplicity, and generality, and an indefinable sense of the fitness of things, creative mathematicians now, as in the past, are inspired by the art of mathematics rather than by any prospect of ultimate usefulness."
  },
  {
    "author": "Plato",
    "category": "fitness",
    "id": 22897,
    "text": "Attention to health is life's greatest hindrance."
  },
  {
    "author": "Lee Haney",
    "category": "fitness",
    "id": 22895,
    "text": "Exercise to stimulate, not to annihilate. The world wasn't formed in a day, and neither were we. Set small goals and build upon them."
  },
  {
    "author": "Jurgen Klinsmann",
    "category": "fitness",
    "id": 22934,
    "text": "Personally, I need a high level of physical fitness in order to feel at ease."
  },
  {
    "author": "Tim DeKay",
    "category": "fitness",
    "id": 23044,
    "text": "For a good workout, I go to At One Fitness in North Hollywood, where my trainer, Jon Allsop, puts me through it all. I like it because it's a small gym and I've known the people for a long time. Jon will have me do cross-training where I'll lift weights, jump rope, throw around a medicine ball and I never get to stop."
  },
  {
    "author": "Jonah Lomu",
    "category": "fitness",
    "id": 22951,
    "text": "It's been a long road back to health and fitness for me. I am just glad to have been given the opportunity to do what I love most."
  },
  {
    "author": "Stone Gossard",
    "category": "fitness",
    "id": 22943,
    "text": "I think if you exercise, your state of mind - my state of mind - is usually more at ease, ready for more mental challenges. Once I get the physical stuff out of the way it always seems like I have more calmness and better self-esteem."
  },
  {
    "author": "Amy Irving",
    "category": "fitness",
    "id": 22967,
    "text": "And you know, the baby boomers are getting older, and those off the rack clothes are just not fitting right any longer, and so, tailor-made suits are coming back into fashion."
  },
  {
    "author": "Cobi Jones",
    "category": "fitness",
    "id": 23020,
    "text": "Overall, I think I'm in pretty good shape, but I'm not really someone that is gung-ho or a fitness fanatic."
  },
  {
    "author": "Marquis de Sade",
    "category": "fitness",
    "id": 22918,
    "text": "Your body is the church where Nature asks to be reverenced."
  },
  {
    "author": "Mary Decker",
    "category": "fitness",
    "id": 22988,
    "text": "I can jog, but I can't run. That's hard for me. I like the fact that I can jog for fitness, but to me there's a huge difference between jogging and running."
  },
  {
    "author": "Joely Fisher",
    "category": "fitness",
    "id": 22945,
    "text": "It's challenging, but you have to at least try to eat right and exercise."
  },
  {
    "author": "Kenneth H. Cooper",
    "category": "fitness",
    "id": 22931,
    "text": "The reason I exercise is for the quality of life I enjoy."
  },
  {
    "author": "Jillian Michaels",
    "category": "fitness",
    "id": 23041,
    "text": "For years, I always thought it was hilarious that I was this fitness guru, because fitness was just a tool I utilized to help people improve their confidence. For me, it's never been about fitness. It's always been about helping to empower people."
  },
  {
    "author": "Jenson Button",
    "category": "fitness",
    "id": 22997,
    "text": "Resting for me is fitness training."
  },
  {
    "author": "George William Curtis",
    "category": "fitness",
    "id": 22939,
    "text": "Happiness lies first of all in health."
  },
  {
    "author": "Gabrielle Reece",
    "category": "fitness",
    "id": 23016,
    "text": "With both kids, I started working out again at 16 days postpartum, but I treated myself with kindness, doing mild workouts, because my fitness level was lower."
  },
  {
    "author": "Eva Green",
    "category": "fitness",
    "id": 22949,
    "text": "I'm French, so I'm quite lazy about exercising, and I smoke. But I do love going for a run in the morning with my dog. That's all."
  },
  {
    "author": "Paula Abdul",
    "category": "fitness",
    "id": 22917,
    "text": "Find fitness with fun dancing. It is fun and makes you forget about the dreaded exercise."
  },
  {
    "author": "Matthew Rhys",
    "category": "fitness",
    "id": 23006,
    "text": "I'm 33 now and I seem to have hit a fitness plane. Shifting the wobbly bits isn't as easy as it used to be."
  },
  {
    "author": "Paul Dudley White",
    "category": "fitness",
    "id": 22900,
    "text": "A vigorous five-mile walk will do more good for an unhappy but otherwise healthy adult than all the medicine and psychology in the world."
  },
  {
    "author": "Catherine Bell",
    "category": "fitness",
    "id": 22950,
    "text": "When I do get time, I like to hike and I take lots of vitamins and powders to keep healthy."
  },
  {
    "author": "Courtney Thorne Smith",
    "category": "fitness",
    "id": 22964,
    "text": "You need to eat normally and healthfully, and you need to exercise. I'm so passionate about this because I think people spend their lives not happy in their bodies."
  },
  {
    "author": "Viggo Mortensen",
    "category": "fitness",
    "id": 22968,
    "text": "Like most people I can be lazy, so it's nice to have a goal or deadline or reason to work out. I feel better when I get to exercise, or when I'm outdoors. I like to hike, swim and run, and I love to play soccer."
  },
  {
    "author": "Michael Phelps",
    "category": "fitness",
    "id": 22919,
    "text": "Swimming is normal for me. I'm relaxed. I'm comfortable, and I know my surroundings. It's my home."
  },
  {
    "author": "Donna Dixon",
    "category": "fitness",
    "id": 22972,
    "text": "I love Nautilus and stretching. The results are immediate, and that gives me the motivation to continue."
  },
  {
    "author": "Frank Bruno",
    "category": "fitness",
    "id": 23008,
    "text": "I try and maintain a little bit of fitness, man."
  },
  {
    "author": "Brock Yates",
    "category": "fitness",
    "id": 22935,
    "text": "Don't get me wrong, I think bikes are terrific. I own several of my own, including a trendy mountain style, and ride them for pleasure and light exercise."
  },
  {
    "author": "Daniela Pestova",
    "category": "fitness",
    "id": 22969,
    "text": "For exercise, I now run with my chocolate Lab puppy, Oscar."
  },
  {
    "author": "Jackie Joyner-Kersee",
    "category": "fitness",
    "id": 22989,
    "text": "Teaching kids about health and fitness is important to me. It's about being fit for life."
  },
  {
    "author": "Samuel Johnson",
    "category": "fitness",
    "id": 22906,
    "text": "Exercise is labor without weariness."
  },
  {
    "author": "William Ames",
    "category": "fitness",
    "id": 23017,
    "text": "The goodness of a thing created is the perfection of its fitness for the use which it serves. Now that use is either particular or universal."
  },
  {
    "author": "Alan Thicke",
    "category": "fitness",
    "id": 22981,
    "text": "Family involvement is a valuable thing and playing together actively can be the '90s version of it. Instead of just watching, you can do it together... something we don't spend enough time on. We can motivate and excite each other about fitness."
  },
  {
    "author": "Alan Thicke",
    "category": "fitness",
    "id": 22912,
    "text": "Fitness needs to be perceived as fun and games or we subconsciously avoid it."
  },
  {
    "author": "George Bernard Shaw",
    "category": "fitness",
    "id": 22973,
    "text": "Parentage is a very important profession, but no test of fitness for it is ever imposed in the interest of the children."
  },
  {
    "author": "Elaine MacDonald",
    "category": "fitness",
    "id": 22990,
    "text": "A life coach does for the rest of your life what a personal trainer does for your health and fitness."
  },
  {
    "author": "Cheryl Tiegs",
    "category": "fitness",
    "id": 22925,
    "text": "It's very important to have the right clothing to exercise in. If you throw on an old T-shirt or sweats, it's not inspiring for your workout."
  },
  {
    "author": "Lady Gaga",
    "category": "fitness",
    "id": 22909,
    "text": "I do yoga, I do Bikram and I run, and I eat really healthy."
  },
  {
    "author": "John F. Kennedy",
    "category": "fitness",
    "id": 22887,
    "text": "Physical fitness is not only one of the most important keys to a healthy body, it is the basis of dynamic and creative intellectual activity."
  },
  {
    "author": "James Thomson",
    "category": "fitness",
    "id": 22948,
    "text": "Health is the vital principle of bliss, and exercise, of health."
  },
  {
    "author": "Andriy Shevchenko",
    "category": "fitness",
    "id": 23028,
    "text": "My fitness is good. I hope to improve it even further during training."
  },
  {
    "author": "Lauren Conrad",
    "category": "fitness",
    "id": 22987,
    "text": "Fitness is a luxury when you are busy!"
  },
  {
    "author": "Franklin P. Adams",
    "category": "fitness",
    "id": 22911,
    "text": "Health is the thing that makes you feel that now is the best time of the year."
  },
  {
    "author": "Peggy Fleming",
    "category": "fitness",
    "id": 22921,
    "text": "I think exercise tests us in so many ways, our skills, our hearts, our ability to bounce back after setbacks. This is the inner beauty of sports and competition, and it can serve us all well as adult athletes."
  },
  {
    "author": "Jayne Mansfield",
    "category": "fitness",
    "id": 22942,
    "text": "You gotta have a body."
  },
  {
    "author": "Graeme Le Saux",
    "category": "fitness",
    "id": 23039,
    "text": "I've had one very bad ankle injury but otherwise I've been incredibly lucky with my fitness. I've worked hard at it and I've always been fit even compared to other players. That sustains you through various parts of your career, but I am 36."
  },
  {
    "author": "Nigel Mansell",
    "category": "fitness",
    "id": 23046,
    "text": "Fitness will be a major factor in the first race and I think that will play into the hands of drivers who have been racing recently, rather than people like me who haven't raced properly for a decade. I'am not one of the favourites to start with."
  },
  {
    "author": "Sasha Cohen",
    "category": "fitness",
    "id": 22940,
    "text": "A year ago I had a back injury and followed a good nutrition program to help speed up my recovery. I focused on exercise and staying healthy in order to get back out on the ice."
  },
  {
    "author": "Bill Vaughan",
    "category": "fitness",
    "id": 22924,
    "text": "Muscles come and go flab lasts."
  },
  {
    "author": "Hugh Blair",
    "category": "fitness",
    "id": 22933,
    "text": "Exercise is the chief source of improvement in our faculties."
  },
  {
    "author": "Heather O'Reilly",
    "category": "fitness",
    "id": 23054,
    "text": "At least for soccer players, it comes down to a blend of two types of fitness - your base endurance, which comes from longer distance running, and your speed, which comes from sprint-based workouts."
  },
  {
    "author": "Graeme Le Saux",
    "category": "fitness",
    "id": 22960,
    "text": "Training is such a vital part of preparation for a game, you really do train to play. It tops up your ability, like sharpening a carving knife. You can get away with not doing it for a while, as long as you have reached a certain standard of fitness."
  },
  {
    "author": "Alan Thicke",
    "category": "fitness",
    "id": 22982,
    "text": "As a father, my first priority is to help my sons set and attain personal goals so they will develop self-confidence and individual strength. Engaging in regular fitness activities with my children helps me fulfill those responsibilities."
  },
  {
    "author": "Alison Sweeney",
    "category": "fitness",
    "id": 22994,
    "text": "What's wrong with extreme dieting and hard-core fitness plans is that they don't take into account the rest of your life."
  },
  {
    "author": "Jim Rohn",
    "category": "fitness",
    "id": 22889,
    "text": "Take care of your body. It's the only place you have to live."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "fitness",
    "id": 22888,
    "text": "It is health that is real wealth and not pieces of gold and silver."
  },
  {
    "author": "Graham Taylor",
    "category": "fitness",
    "id": 23053,
    "text": "Shearer could be at 100 per cent fitness, but not peak fitness."
  },
  {
    "author": "Gene Tunney",
    "category": "fitness",
    "id": 22957,
    "text": "To enjoy the glow of good health, you must exercise."
  },
  {
    "author": "Deborah Bull",
    "category": "fitness",
    "id": 22958,
    "text": "It's not about weight, it's about fitness, and one component of being fit is to have relatively low body fat, because fat is not very efficient, whereas muscle is."
  },
  {
    "author": "Booboo Stewart",
    "category": "fitness",
    "id": 23055,
    "text": "My mom was a professional fitness competitor, so I go into the gym with her. I train with my dad and mother. It's embarrassing, because she's really strong."
  },
  {
    "author": "Thomas Jefferson",
    "category": "fitness",
    "id": 22891,
    "text": "Walking is the best possible exercise. Habituate yourself to walk very fast."
  },
  {
    "author": "Ruben Studdard",
    "category": "fitness",
    "id": 22998,
    "text": "I'm not in the best shape, but I want to prove to myself I can do something that seems insurmountable and inspire others by showing them no matter where they are in their fitness goals, they can do it, too."
  },
  {
    "author": "Richard M. Daley",
    "category": "fitness",
    "id": 23014,
    "text": "The spirit of the Olympic movement is great for young people because it teaches them about the training and discipline required to compete. Even if they don't make the teams, they can rededicate their lives to the art of sport, discipline, and physical fitness."
  },
  {
    "author": "Andriy Shevchenko",
    "category": "fitness",
    "id": 23052,
    "text": "I would like to thank everyone who supported me to be fit for the Euros. I had some fitness problems before the tournament, but I am here now!"
  },
  {
    "author": "Candice Swanepoel",
    "category": "fitness",
    "id": 23025,
    "text": "I feel if I'm healthy and happy, I look good. With a good mixture of fitness and healthy food I always feel great!"
  },
  {
    "author": "Kim Alexis",
    "category": "fitness",
    "id": 22930,
    "text": "I would rather exercise than read a newspaper."
  },
  {
    "author": "Sting",
    "category": "fitness",
    "id": 22922,
    "text": "I have been through various fitness regimes. I used to run about five miles a day and I did aerobics for a while."
  },
  {
    "author": "Tipper Gore",
    "category": "fitness",
    "id": 23023,
    "text": "I have long recognized a link between fitness and mental health and I think we need to encourage young people to take part in sports and team activities because we know it has such positive results."
  },
  {
    "author": "Marcia Cross",
    "category": "fitness",
    "id": 23013,
    "text": "I don't want to lose my fitness. I'm 45. I have two babies. I've got a long way to go and I want to keep in tiptop shape. There's no magic bullet."
  },
  {
    "author": "David Ginola",
    "category": "fitness",
    "id": 23036,
    "text": "I have found a flat on Merseyside and am settling down here. If I can keep playing and get back to full match fitness, I know I have a lot to offer still."
  },
  {
    "author": "Charles Babbage",
    "category": "fitness",
    "id": 22996,
    "text": "The public character of every public servant is legitimate subject of discussion, and his fitness or unfitness for office may be fairly canvassed by any person."
  },
  {
    "author": "Jillian Michaels",
    "category": "fitness",
    "id": 23021,
    "text": "I've always believed fitness is an entry point to help you build that happier, healthier life. When your health is strong, you're capable of taking risks. You'll feel more confident to ask for the promotion. You'll have more energy to be a better mom. You'll feel more deserving of love."
  },
  {
    "author": "Gregor Mendel",
    "category": "fitness",
    "id": 23033,
    "text": "The value and utility of any experiment are determined by the fitness of the material to the purpose for which it is used, and thus in the case before us it cannot be immaterial what plants are subjected to experiment and in what manner such experiment is conducted."
  },
  {
    "author": "Warren Cuccurullo",
    "category": "fitness",
    "id": 22936,
    "text": "Once you are over 30, 35 years old, I think everyone should get down to the gym and start moving again."
  },
  {
    "author": "Lance Armstrong",
    "category": "fitness",
    "id": 22974,
    "text": "For whatever reason, maybe it's because of my story, but people associate Livestrong with exercise and physical fitness, health and lifestyle choices like that."
  },
  {
    "author": "Kenneth H. Cooper",
    "category": "fitness",
    "id": 23037,
    "text": "Now I say that if you run more than 15 miles a week, it's for something other than aerobic fitness. Once you pass 15 miles, you do not see much further improvement."
  },
  {
    "author": "Richard Gough",
    "category": "fitness",
    "id": 23047,
    "text": "I have always maintained a high level of fitness, and that is why I am still able to handle the demands of playing in the Premiership. People have always commented on my fitness, and it's something I pride myself on."
  },
  {
    "author": "Oscar Pistorius",
    "category": "fitness",
    "id": 23027,
    "text": "I have run two Olympic 'A' standard times over the past 12 months and with the time I ran at the African Championships last week I know my speed and fitness are constantly improving so that I will peak in time for the Olympics."
  },
  {
    "author": "Andre Maurois",
    "category": "fitness",
    "id": 22978,
    "text": "The most important quality in a leader is that of being acknowledged as such. All leaders whose fitness is questioned are clearly lacking in force."
  },
  {
    "author": "Shawn Johnson",
    "category": "fitness",
    "id": 22985,
    "text": "I'm doing four hours of gymnastics training a day, six days a week and then an extra two to three hours in a fitness center as well."
  },
  {
    "author": "Grete Waitz",
    "category": "fitness",
    "id": 22966,
    "text": "In terms of fitness and battling through cancer, exercise helps you stay strong physically and mentally."
  },
  {
    "author": "Rafer Johnson",
    "category": "fitness",
    "id": 23051,
    "text": "I also meet with city officials, representatives from governors' offices, really anyone in that sort of position who has shown an interest in youth fitness, to let them know why this sort of program is so important. I give the same message when I speak at conferences."
  },
  {
    "author": "Anne Wilson Schaef",
    "category": "fitness",
    "id": 22929,
    "text": "Looking after my health today gives me a better hope for tomorrow."
  },
  {
    "author": "Kiana Tom",
    "category": "fitness",
    "id": 23005,
    "text": "They both go together you can't be in front of the camera hosting a fitness television show in front of 75 million households and not have trained 6 days per week year round - in a bikini no less."
  },
  {
    "author": "Knute Nelson",
    "category": "fitness",
    "id": 22947,
    "text": "In the midst of these hard times it is our good health and good sleep that are enjoyable."
  },
  {
    "author": "Richard Simmons",
    "category": "fitness",
    "id": 22991,
    "text": "Our children are obese, either have or being threatened by diabetes, high blood pressure, high cholesterol, and not socially adjusting properly to others because of a lack of fitness."
  },
  {
    "author": "Richard Cobden",
    "category": "fitness",
    "id": 23029,
    "text": "I have been particularly struck with the overwhelming evidence which is given as to the fitness of the natives of India for high offices and employments."
  },
  {
    "author": "Kenneth H. Cooper",
    "category": "fitness",
    "id": 22946,
    "text": "So I've broadened the fitness concept to make it one of moderation and balance."
  },
  {
    "author": "Judy Johnson",
    "category": "fitness",
    "id": 23058,
    "text": "My Daddy liked physical fitness and wanted me to be a prizefighter."
  },
  {
    "author": "Joan Rivers",
    "category": "fitness",
    "id": 22904,
    "text": "The first time I see a jogger smiling, I'll consider it."
  },
  {
    "author": "Joey Adams",
    "category": "fitness",
    "id": 22920,
    "text": "If it weren't for the fact that the TV set and the refrigerator are so far apart, some of us wouldn't get any exercise at all."
  },
  {
    "author": "Jamie Redknapp",
    "category": "fitness",
    "id": 23019,
    "text": "I'm enjoying myself this year and for once I'm not chasing my fitness."
  },
  {
    "author": "Peter Shilton",
    "category": "fitness",
    "id": 22965,
    "text": "I'm still very professional about my fitness. I stay in trim as I always did."
  }
]

quotes['food'] = [
  {
    "author": "Margaret Mead",
    "category": "food",
    "id": 23216,
    "text": "A city is a place where there is no need to wait for next week to get the answer to a question, to taste the food of any country, to find new voices to listen to and familiar ones to listen to again."
  },
  {
    "author": "Salma Hayek",
    "category": "food",
    "id": 23390,
    "text": "Everybody has a weakness. Mine is food."
  },
  {
    "author": "Johnny Depp",
    "category": "food",
    "id": 23193,
    "text": "The term 'serious actor' is kind of an oxymoron, isn't it? Like 'Republican party' or 'airplane food.'"
  },
  {
    "author": "Mary Wollstonecraft Shelley",
    "category": "food",
    "id": 23728,
    "text": "The agony of my feelings allowed me no respite no incident occurred from which my rage and misery could not extract its food."
  },
  {
    "author": "Martin Yan",
    "category": "food",
    "id": 23749,
    "text": "I don't like to waste anything. Any food left over from the night before is always eaten the next day."
  },
  {
    "author": "Sandra Oh",
    "category": "food",
    "id": 23800,
    "text": "And on a Canadian set, everybody is equal. You get paid the same. You live together in barracks. You have a communal kitchen. You buy and cook your own food."
  },
  {
    "author": "Paul Lynde",
    "category": "food",
    "id": 23104,
    "text": "Sandwiches are wonderful. You don't need a spoon or a plate!"
  },
  {
    "author": "Mario Batali",
    "category": "food",
    "id": 23260,
    "text": "The passion of the Italian or the Italian-American population is endless for food and lore and everything about it."
  },
  {
    "author": "Eva Gabor",
    "category": "food",
    "id": 23648,
    "text": "The average housewife goes to the restaurant to relax and enjoy the food. But when Eva walks in, she becomes the center of attention."
  },
  {
    "author": "Lucy Powell",
    "category": "food",
    "id": 23353,
    "text": "Some argue that now isn't the time to push the green agenda - that all efforts should be on preventing a serious recession. That is a false choice. It fails to recognise that climate change and our carbon reliance is part of problem - high fuel prices and food shortages due to poor crop yields compound today's financial difficulties."
  },
  {
    "author": "Ted Allen",
    "category": "food",
    "id": 23466,
    "text": "In recent years, I've been writing because I'm fortunate enough to work in the world of food television, to travel and taste and learn about cooking from the best chefs in the business."
  },
  {
    "author": "Peter De Vries",
    "category": "food",
    "id": 23095,
    "text": "Gluttony is an emotional escape, a sign something is eating us."
  },
  {
    "author": "Rodney Atkins",
    "category": "food",
    "id": 23968,
    "text": "I grew up playing music and enjoying good food, friends and family in my own backyard."
  },
  {
    "author": "George Orwell",
    "category": "food",
    "id": 23082,
    "text": "We may find in the long run that tinned food is a deadlier weapon than the machine-gun."
  },
  {
    "author": "David Duchovny",
    "category": "food",
    "id": 23322,
    "text": "You're raising a kid and you give it food and shelter and, most importantly, you give it the feeling that it's special. I think people react to celebrities like that - I mean, they treat celebrities like children."
  },
  {
    "author": "Gloria Swanson",
    "category": "food",
    "id": 23371,
    "text": "I became a fanatic about healthy food in 1944."
  },
  {
    "author": "William Bartram",
    "category": "food",
    "id": 23949,
    "text": "Animal substance seems to be the first food of all birds, even the granivorous tribes."
  },
  {
    "author": "Mario Batali",
    "category": "food",
    "id": 23484,
    "text": "Unlike curing cancer or heart disease, we already know how to beat hunger: food."
  },
  {
    "author": "Percy Bysshe Shelley",
    "category": "food",
    "id": 23269,
    "text": "In a drama of the highest order there is little food for censure or hatred it teaches rather self-knowledge and self-respect."
  },
  {
    "author": "W. C. Fields",
    "category": "food",
    "id": 23173,
    "text": "I cook with wine, sometimes I even add it to the food."
  },
  {
    "author": "Shailene Woodley",
    "category": "food",
    "id": 23813,
    "text": "I think there's a lot of work to be done with our societies. My biggest passions are the environment and health. And when I say 'health' I mean the secrets behind health and our food system."
  },
  {
    "author": "Alton Brown",
    "category": "food",
    "id": 23444,
    "text": "I kept thinking, 'Somebody has to make a food show that is actually educational and entertaining at the same time... a show that got down to the 'why things happen.' Plus, I hated my job - I didn't think it was very worthwhile."
  },
  {
    "author": "Michael Symon",
    "category": "food",
    "id": 23666,
    "text": "Recipes are important but only to a point. What's more important than recipes is how we think about food, and a good cookbook should open up a new way of doing just that."
  },
  {
    "author": "Monica Seles",
    "category": "food",
    "id": 23978,
    "text": "I think for me, food was a way for me to deal with emotional trouble."
  },
  {
    "author": "Muhammad Yunus",
    "category": "food",
    "id": 23807,
    "text": "What we are trying to do is to create a social business in Bangladesh, a joint venture to create restaurants for common people. Good, healthy food at affordable prices so that people don't have to opt for food that is unhealthy and unhygienic."
  },
  {
    "author": "Tia Mowry",
    "category": "food",
    "id": 24050,
    "text": "After my pregnancy, I discovered I have an allergy to yeast. Problem is, all the food I love has yeast in it. So I have to relearn how to cook."
  },
  {
    "author": "Baz Luhrmann",
    "category": "food",
    "id": 23809,
    "text": "The food in Sydney is an Asian Pacific cuisine. It's eclectic but above all it's fresh, inventive and creative and that's what I love about it."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "food",
    "id": 23374,
    "text": "Listen - of course money changes everything, but so does sunlight, and so does food: These are powerful but neutral energy sources, neither inherently good nor evil but shaped only by the way we use them."
  },
  {
    "author": "Gabrielle Reece",
    "category": "food",
    "id": 23840,
    "text": "Eating and food are a wonderful part of our life's experience, and half of us are walking around dreading having to figure out what to put in our mouths."
  },
  {
    "author": "Tom Lehrer",
    "category": "food",
    "id": 23844,
    "text": "When you get to fifty-two food becomes more important than sex."
  },
  {
    "author": "Frank A. Clark",
    "category": "food",
    "id": 23140,
    "text": "Maybe a person's time would be as well spent raising food as raising money to buy food."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "food",
    "id": 23314,
    "text": "My grandfather's family used to own a pasta factory in Naples and they would go door-to-door selling their pasta. So his love of food came from his parents, which was then passed down to my mother and then again to me."
  },
  {
    "author": "Anne McCaffrey",
    "category": "food",
    "id": 23957,
    "text": "What I used to do between writing fits was feed my kids, ride my horse and go shopping for cat and dog food."
  },
  {
    "author": "Ron Ben-Israel",
    "category": "food",
    "id": 23851,
    "text": "The most successful person is the one who is most inspired. That is true in food and in life."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "food",
    "id": 23415,
    "text": "Attitudes toward food have completely changed."
  },
  {
    "author": "Amos Lee",
    "category": "food",
    "id": 24027,
    "text": "Understanding where your food comes from, trying to bolster local farmers and local economies and having a better connection to the food around you and the people around you, only good can come of that. I love to be involved with things like that."
  },
  {
    "author": "Tom Vilsack",
    "category": "food",
    "id": 23422,
    "text": "The lack of access to proper nutrition is not only fueling obesity, it is leading to food insecurity and hunger among our children."
  },
  {
    "author": "Molly Ringwald",
    "category": "food",
    "id": 23977,
    "text": "I like to say, jazz music is kind of like my musical equivalent of comfort food. You know, it's always where I go back to when I just want to feel sort of grounded."
  },
  {
    "author": "Kenny Loggins",
    "category": "food",
    "id": 23753,
    "text": "My quest these days is to find my long lost inner child, but I'm afraid if I do, I'll end up with food in my hair and way too in love with the cats."
  },
  {
    "author": "Curtis Stone",
    "category": "food",
    "id": 23595,
    "text": "In my travels, I also noticed that kids in Thailand like spicy food, and kids in India love curry. I'm hoping to introduce my son, Hudson, to lots of veggies and spices when he's young. I say that before he's started on solid foods, so it could be easier in theory than practice!"
  },
  {
    "author": "Rachael Ray",
    "category": "food",
    "id": 23561,
    "text": "When you're out grocery shopping for your family, maybe you can put a can of cat or dog food in your cart and bring it to an animal relief center."
  },
  {
    "author": "Norman Borlaug",
    "category": "food",
    "id": 23950,
    "text": "Man's survival, from the time of Adam and Eve until the invention of agriculture, must have been precarious because of his inability to ensure his food supply."
  },
  {
    "author": "Gael Garcia Bernal",
    "category": "food",
    "id": 23773,
    "text": "I think the water dictates how food will taste in a country. In England the apples taste unlike apples grown in any other place. England is an island, there's a lot of salt in the air and in the water. I think that has something to do with it."
  },
  {
    "author": "Michael Symon",
    "category": "food",
    "id": 23665,
    "text": "I love doing demonstrations. I think to be a great chef you have to be a great teacher. I love doing classes with people who love food and enjoy food, bringing them all around one table so to speak."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "food",
    "id": 23228,
    "text": "I do the same exercises I did 50 years ago and they still work. I eat the same food I ate 50 years ago and it still works."
  },
  {
    "author": "Bill Gates",
    "category": "food",
    "id": 23204,
    "text": "We should all grow our own food and do our own waste processing, we really should."
  },
  {
    "author": "Janet Jackson",
    "category": "food",
    "id": 23443,
    "text": "Food has always brought me comfort and the bingeing is triggered when I'm in a space that is not positive."
  },
  {
    "author": "William Westmoreland",
    "category": "food",
    "id": 23902,
    "text": "We had the best food any battlefield ever had."
  },
  {
    "author": "Todd Akin",
    "category": "food",
    "id": 23956,
    "text": "Now an embryo may seem like some scientific or laboratory term, but in fact the embryo contains the unique information that defines a person. All you add is food and climate control, and some time, and the embryo becomes you or me."
  },
  {
    "author": "Christina Aguilera",
    "category": "food",
    "id": 23287,
    "text": "We take food for granted, but it isn't a luxury for many people."
  },
  {
    "author": "Nana Mouskouri",
    "category": "food",
    "id": 23907,
    "text": "My friends gave me the first songs which was the first food in my soul for me."
  },
  {
    "author": "Diane von Furstenberg",
    "category": "food",
    "id": 23161,
    "text": "Italy will always have the best food."
  },
  {
    "author": "Jamie Oliver",
    "category": "food",
    "id": 23642,
    "text": "It's very clear that there's a lot of double standards going on. Should there be a 30mph speed limit? Of course there bloody should. And certainly with kids and school food, kids need to be nannied for sure. So give them a bloody good meal at school."
  },
  {
    "author": "Garrett Hedlund",
    "category": "food",
    "id": 23737,
    "text": "Especially for me, growing up in such a small town in the middle of nowhere, the desire to be away was incredible. I wanted to see new lands, meet new people from the city, and meet people that were in much less fortunate situations than I was, so that I could be more appreciative of my present. At least I had food on the table."
  },
  {
    "author": "Bob Woodward",
    "category": "food",
    "id": 23396,
    "text": "I think people are smart enough to sort it out. They know when they're watching one of these food fight shows where journalists sit around and yell and scream at each other, versus serious issue reporting."
  },
  {
    "author": "Nicole Appleton",
    "category": "food",
    "id": 23618,
    "text": "It's my first presenting role so I'll be nervous, but it's going to be great fun. I can't wait to sample the food and meet the celebrities. Hopefully I can inject some of my own glamour."
  },
  {
    "author": "Giancarlo Esposito",
    "category": "food",
    "id": 23808,
    "text": "I'm not too into fast food, but you know if I was, it would be chicken."
  },
  {
    "author": "Daryl Hannah",
    "category": "food",
    "id": 23152,
    "text": "That's a big goal of mine, to try and grow as much of my own food as possible."
  },
  {
    "author": "Emilio Estevez",
    "category": "food",
    "id": 23739,
    "text": "I'm not a Luddite, but I'm outside more than I'm on my computer. We have a micro-farm - it's a step up from a garden. We have a pretty extensive vineyard. We grow about 60 percent of our own food, make our own wine, have chickens for eggs."
  },
  {
    "author": "Tom Colicchio",
    "category": "food",
    "id": 23691,
    "text": "Asian food is very easy to like because it hits your mouth very differently than European food does. In European food, there may be two things to hit - maybe sweet and salty, maybe salty-savory, but Asian kind of works around, plus you have that distinct flavor that's usually working in Asian food."
  },
  {
    "author": "Bethenny Frankel",
    "category": "food",
    "id": 23651,
    "text": "Food is not your best friend or enemy."
  },
  {
    "author": "Rachel McAdams",
    "category": "food",
    "id": 23436,
    "text": "I think one thing that kids who grow up on farms really have going for them is they have exposure to death and birth in a totally different way. I think it takes away a little bit of the mystery and a little bit of the fear, and I do wish I had that. And I wish I was able to grow my own food."
  },
  {
    "author": "Paul Prudhomme",
    "category": "food",
    "id": 23860,
    "text": "We trust something in a grocery store and assume it's good. We don't learn about the most precious thing in life-the food we put in our body. Educate yourself!"
  },
  {
    "author": "Beth Anderson",
    "category": "food",
    "id": 23696,
    "text": "Everything is just better in California - the wine, the food, fruits and vegetables, the comforts of living. Even the instrumentalists are generous and curious. Everything is wonderful."
  },
  {
    "author": "Liv Tyler",
    "category": "food",
    "id": 23832,
    "text": "Life excites me-just little, normal, everyday things. Getting out of bed. Getting dressed. Making food. I find it all exciting."
  },
  {
    "author": "Jonathan Safran Foer",
    "category": "food",
    "id": 23357,
    "text": "I know lots and lots and lots of vegetarians who think it's perfectly all right to kill animals for food to eat, but don't do it because they think all the ways in which it's done are wrong."
  },
  {
    "author": "Danny Bonaduce",
    "category": "food",
    "id": 24035,
    "text": "As it has been told to me, my Dad had some kind of deal with Dick Clark. But when we got here, that fell through. So we were out here with no job, no furniture, no food."
  },
  {
    "author": "John Walters",
    "category": "food",
    "id": 23143,
    "text": "The only think I like better than talking about Food is eating."
  },
  {
    "author": "David Suzuki",
    "category": "food",
    "id": 23295,
    "text": "We must pay greater attention to keeping our bodies and minds healthy and able to heal. Yet we are making it difficult for our defences to work. We allow things to be sold that should not be called food. Many have no nutritive value and lead to obesity, salt imbalance, and allergies."
  },
  {
    "author": "George Will",
    "category": "food",
    "id": 23534,
    "text": "A society that thinks the choice between ways of living is just a choice between equally eligible 'lifestyles' turns universities into academic cafeterias offering junk food for the mind."
  },
  {
    "author": "Ice Cube",
    "category": "food",
    "id": 23433,
    "text": "I'm trying to cut down a little on eating, on sodium, keep my blood pressure down, which is tough. Because I love food! I do, but it's unfair how everything that's bad for you tastes so good, and all the good stuff, veggies and green things, doesn't match up."
  },
  {
    "author": "Joe Manchin",
    "category": "food",
    "id": 23720,
    "text": "We have reduced sales tax on food. Now we want it eliminated."
  },
  {
    "author": "Bobby Flay",
    "category": "food",
    "id": 23515,
    "text": "Nobody believed the 'Food Network' could last. Even I was short sighted and thought to myself, 24 hours of food on TV? They'll run out of things to talk about in four days! But that wasn't true. 'Food Network' continues to get better and evolve."
  },
  {
    "author": "Helen Rowland",
    "category": "food",
    "id": 23294,
    "text": "Ever since Eve started it all by offering Adam the apple, woman's punishment has been to supply a man with food then suffer the consequences when it disagrees with him."
  },
  {
    "author": "Katarina Witt",
    "category": "food",
    "id": 23854,
    "text": "Sometimes I even now feel like a stranger in my country. But I knew there would be problems because I had seen the world as a skater. And now? A lot of people in eastern Germany have lost jobs, rents went up, food costs went up, unemployment went to 20 percent. Freedom is good, but it is not easy."
  },
  {
    "author": "Amanda Seyfried",
    "category": "food",
    "id": 23350,
    "text": "Well, it's very easy for me to gain weight, but even though I tried not eating for a week when I was really young, I couldn't do it any longer because I liked my food too much."
  },
  {
    "author": "Margaret Fuller",
    "category": "food",
    "id": 23661,
    "text": "Be what you would seem to be - or, if you'd like it put more simply - a house is no home unless it contains food and fire for the mind as well as the body."
  },
  {
    "author": "Lea Michele",
    "category": "food",
    "id": 23535,
    "text": "I love to cook so much. I like to cook everything. I really like to eat my food."
  },
  {
    "author": "Andrew Weil",
    "category": "food",
    "id": 23580,
    "text": "It does kids no favors, and sets them up for a potential lifetime of poor health and social embarrassment, to excuse them from family meals of real food. Everyone benefits from healthy eating, but it is particularly crucial at the beginning of life."
  },
  {
    "author": "Marilu Henner",
    "category": "food",
    "id": 23393,
    "text": "Research has shown that even small amounts of processed food alter the chemical balance in our brain and cause negative mood swings along with noticeable dips ill energy."
  },
  {
    "author": "Padma Lakshmi",
    "category": "food",
    "id": 23459,
    "text": "People always comment about my clothes. They don't think a fashionable woman can love food and be knowledgeable and actually cook."
  },
  {
    "author": "Leigh Hunt",
    "category": "food",
    "id": 23162,
    "text": "If you are ever at a loss to support a flagging conversation, introduce the subject of eating."
  },
  {
    "author": "Michael J. Fox",
    "category": "food",
    "id": 23268,
    "text": "If I don't get food in my mouth, I'm still happy. If my pants are round my ankles, as long as I don't get arrested for indecent exposure, I'm happy. I'm worried about keeping my hair, not how it's combed."
  },
  {
    "author": "Cat Cora",
    "category": "food",
    "id": 23488,
    "text": "When I was growing up in Mississippi - it was good Southern food... but I also grew up with a Greek family when other kids were eating fried okra, we were eating steamed artichokes. So I think it played a big part in my healthy cooking."
  },
  {
    "author": "Mario Batali",
    "category": "food",
    "id": 23485,
    "text": "I was at a party, and some squiggly looking dude with a bow tie came up and said, 'How'd you like to be on TV?' Turns out he was the programming guy at the Food Network. They had me come into the office, and I did a 'Ready, Set, Cook' with Emeril Lagasse, I believe."
  },
  {
    "author": "Emeril Lagasse",
    "category": "food",
    "id": 23378,
    "text": "I've always done food that can work in a set time frame. The message I'm trying to get across is, it doesn't have to take three days to do this. With planning, you can do a lot and really have quality food every day."
  },
  {
    "author": "Jamie Oliver",
    "category": "food",
    "id": 23091,
    "text": "What I've enjoyed most, though, is meeting people who have a real interest in food and sharing ideas with them. Good food is a global thing and I find that there is always something new and amazing to learn - I love it!"
  },
  {
    "author": "A. J. Liebling",
    "category": "food",
    "id": 23798,
    "text": "The primary requisite for writing well about food is a good appetite. Without this, it is impossible to accumulate, within the allotted span, enough experience of eating to have anything worth setting down."
  },
  {
    "author": "Joel Robuchon",
    "category": "food",
    "id": 24044,
    "text": "Taste is developed by the diversity of the products one can sample. I think our children today may be missing an education about food. We must teach them to know their cuisine and to know the equilibrium of nourishment. That is very important for health."
  },
  {
    "author": "Dolly Parton",
    "category": "food",
    "id": 23251,
    "text": "I was always a junk food person, still am."
  },
  {
    "author": "Reese Witherspoon",
    "category": "food",
    "id": 23804,
    "text": "I love to cook comfort food. I'll make fish and vegetables or meat and vegetables and potatoes or rice. The ritual of it is fun for me, and the creativity of it."
  },
  {
    "author": "Eric Ripert",
    "category": "food",
    "id": 23820,
    "text": "There is great food in Vegas."
  },
  {
    "author": "Gwyneth Paltrow",
    "category": "food",
    "id": 23392,
    "text": "What I've learned is I want to enjoy my life, and food is a big part of it."
  },
  {
    "author": "Tom Colicchio",
    "category": "food",
    "id": 23688,
    "text": "As a chef, I had started working with groups like Share Our Strength and various local food banks in New York, raising money for hunger-related issues. And not only me, but the entire restaurant industry has been very focused on this issue."
  },
  {
    "author": "Bobby Flay",
    "category": "food",
    "id": 23355,
    "text": "My contribution I hope is to get people to eat full-flavored food. If I could come away with that alone, that would be a fantastic accomplishment. I'm also very proud of being a very American chef."
  },
  {
    "author": "William Shakespeare",
    "category": "food",
    "id": 23170,
    "text": "If music be the food of love, play on."
  },
  {
    "author": "Leo Tolstoy",
    "category": "food",
    "id": 23211,
    "text": "To say that a work of art is good, but incomprehensible to the majority of men, is the same as saying of some kind of food that it is very good but that most people can't eat it."
  },
  {
    "author": "Cat Cora",
    "category": "food",
    "id": 23495,
    "text": "I think about food all the time. It's my passion it's my profession. But some people think about food all the time because they're hungry. We can put an end to this if we join forces and lend a hand."
  },
  {
    "author": "Jerry Saltz",
    "category": "food",
    "id": 23264,
    "text": "The secret of food lies in memory - of thinking and then knowing what the taste of cinnamon or steak is."
  },
  {
    "author": "Francis Ford Coppola",
    "category": "food",
    "id": 23341,
    "text": "We were raised in an Italian-American household, although we didn't speak Italian in the house. We were very proud of being Italian, and had Italian music, ate Italian food."
  }
]

quotes['forgiveness'] = [
  {
    "author": "Lewis B. Smedes",
    "category": "forgiveness",
    "id": 24095,
    "text": "It takes one person to forgive, it takes two people to be reunited."
  },
  {
    "author": "Billy Ray Cyrus",
    "category": "forgiveness",
    "id": 24177,
    "text": "Well, I've never left my faith - but have I made a lot of mistakes? But was I fortunate that I was brought up in that Pentecostal church, where I heard about God's love and God's forgiveness."
  },
  {
    "author": "William Blake",
    "category": "forgiveness",
    "id": 24133,
    "text": "The glory of Christianity is to conquer by forgiveness."
  },
  {
    "author": "Jennifer O'Neill",
    "category": "forgiveness",
    "id": 24186,
    "text": "Forgiveness isn't about condoning what has happened to you or someone else's actions against you."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "forgiveness",
    "id": 24056,
    "text": "Darkness cannot drive out darkness only light can do that. Hate cannot drive out hate only love can do that."
  },
  {
    "author": "Hannah Arendt",
    "category": "forgiveness",
    "id": 24103,
    "text": "Forgiveness is the key to action and freedom."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "forgiveness",
    "id": 24065,
    "text": "I can forgive, but I cannot forget, is only another way of saying, I will not forgive. Forgiveness ought to be like a cancelled note - torn in two, and burned up, so that it never can be shown against one."
  },
  {
    "author": "Bell Hooks",
    "category": "forgiveness",
    "id": 24137,
    "text": "For me, forgiveness and compassion are always linked: how do we hold people accountable for wrongdoing and yet at the same time remain in touch with their humanity enough to believe in their capacity to be transformed?"
  },
  {
    "author": "Marianne Williamson",
    "category": "forgiveness",
    "id": 24082,
    "text": "The practice of forgiveness is our most important contribution to the healing of the world."
  },
  {
    "author": "Edward Albert",
    "category": "forgiveness",
    "id": 24169,
    "text": "On a level of simple personal survival, understanding and forgiveness are crucial... whether in an intimate personal relationship or on a global level."
  },
  {
    "author": "Josh McDowell",
    "category": "forgiveness",
    "id": 24160,
    "text": "If Jesus Christ was who He claimed to be, and He did die on a cross at a point of time in history, then, for all history past and all history future it is relevant because that is the very focal point for forgiveness and redemption."
  },
  {
    "author": "Gerald Jampolsky",
    "category": "forgiveness",
    "id": 24077,
    "text": "Forgiveness means letting go of the past."
  },
  {
    "author": "Alexander Chase",
    "category": "forgiveness",
    "id": 24115,
    "text": "To understand is to forgive, even oneself."
  },
  {
    "author": "Billy Graham",
    "category": "forgiveness",
    "id": 24088,
    "text": "Man has two great spiritual needs. One is for forgiveness. The other is for goodness."
  },
  {
    "author": "Nicole Kidman",
    "category": "forgiveness",
    "id": 24141,
    "text": "You've just got to have a sense of respect for the person you have children with. Anger doesn't help anybody. Ultimately you have to say forgiveness is important, and honoring what you had together is important. But it's easy to say and harder to do."
  },
  {
    "author": "Bryant H. McGill",
    "category": "forgiveness",
    "id": 24109,
    "text": "The ability to forgive is one of man's greatest achievements."
  },
  {
    "author": "William P. Leahy",
    "category": "forgiveness",
    "id": 24196,
    "text": "I would say the hierarchy has made terrible errors in judgment and it has to seek forgiveness by its members."
  },
  {
    "author": "Scott Adams",
    "category": "forgiveness",
    "id": 24134,
    "text": "Nothing inspires forgiveness quite like revenge."
  },
  {
    "author": "T. D. Jakes",
    "category": "forgiveness",
    "id": 24181,
    "text": "I think it is important that we rebuild an atmosphere of forgiveness and civility in every aspect of our lives."
  },
  {
    "author": "Sue Monk Kidd",
    "category": "forgiveness",
    "id": 24201,
    "text": "I learned a long time ago that some people would rather die than forgive. It's a strange truth, but forgiveness is a painful and difficult process. It's not something that happens overnight. It's an evolution of the heart."
  },
  {
    "author": "Julian Clary",
    "category": "forgiveness",
    "id": 24194,
    "text": "I'm currently in an interesting correspondence with a nun about forgiveness."
  },
  {
    "author": "Carlos Santana",
    "category": "forgiveness",
    "id": 24152,
    "text": "I realized that it's all really one, that John Lennon was correct. We utilize the music to bring down the walls of Berlin, to bring up the force of compassion and forgiveness and kindness between Palestines, Hebrews. Bring down the walls here in San Diego, Tijuana, Cuba."
  },
  {
    "author": "William Brewster",
    "category": "forgiveness",
    "id": 24198,
    "text": "I discipline churchgoers with godly lessons and sharp words if they do not change their ways. My goal is to open their hearts so that they seek forgiveness."
  },
  {
    "author": "Jane Austen",
    "category": "forgiveness",
    "id": 24094,
    "text": "Selfishness must always be forgiven you know, because there is no hope of a cure."
  },
  {
    "author": "Billy Graham",
    "category": "forgiveness",
    "id": 24135,
    "text": "Every year during their High Holy Days, the Jewish community reminds us all of our need for repentance and forgiveness."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "forgiveness",
    "id": 24057,
    "text": "The weak can never forgive. Forgiveness is the attribute of the strong."
  },
  {
    "author": "Madeleine L'Engle",
    "category": "forgiveness",
    "id": 24143,
    "text": "In the evening of life we shall be judged on love, and not one of us is going to come off very well, and were it not for my absolute faith in the loving forgiveness of my Lord I could not call on him to come."
  },
  {
    "author": "Kevyn Aucoin",
    "category": "forgiveness",
    "id": 24156,
    "text": "Soon I realized that if beauty equalled forgiveness, I was never going to be forgiven."
  },
  {
    "author": "Bruce Lee",
    "category": "forgiveness",
    "id": 24059,
    "text": "Mistakes are always forgivable, if one has the courage to admit them."
  },
  {
    "author": "Chaim Herzog",
    "category": "forgiveness",
    "id": 24112,
    "text": "I do not bring forgiveness with me, nor forgetfulness. The only ones who can forgive are dead the living have no right to forget."
  },
  {
    "author": "Mario Batali",
    "category": "forgiveness",
    "id": 24174,
    "text": "I like cast iron coated with enamel for longevity and forgiveness if I happen to take my eyes off the prize while pouring Chianti."
  },
  {
    "author": "F. Scott Fitzgerald",
    "category": "forgiveness",
    "id": 24075,
    "text": "Forgotten is forgiven."
  },
  {
    "author": "Bill Cosby",
    "category": "forgiveness",
    "id": 24068,
    "text": "People can be more forgiving than you can imagine. But you have to forgive yourself. Let go of what's bitter and move on."
  },
  {
    "author": "Grace Hopper",
    "category": "forgiveness",
    "id": 24111,
    "text": "It is often easier to ask for forgiveness than to ask for permission."
  },
  {
    "author": "Lee Tergesen",
    "category": "forgiveness",
    "id": 24193,
    "text": "I would say that playing this character has caused me to think about a lot of things. He's always questioning himself and trying to get back to something he lost touch with and trying to find forgiveness. Everybody struggles with these things to some extent in their life."
  },
  {
    "author": "John Rowland",
    "category": "forgiveness",
    "id": 24183,
    "text": "I ask the people of Connecticut for their forgiveness, I should have paid more attention to people around me and people that I trusted but I am sorry for my actions and take full responsibility."
  },
  {
    "author": "Indira Gandhi",
    "category": "forgiveness",
    "id": 24066,
    "text": "Forgiveness is a virtue of the brave."
  },
  {
    "author": "Janine Turner",
    "category": "forgiveness",
    "id": 24165,
    "text": "My desire is to stand up and brush myself off when I make mistakes and ask for forgiveness."
  },
  {
    "author": "Jean Paul",
    "category": "forgiveness",
    "id": 24102,
    "text": "Humanity is never so beautiful as when praying for forgiveness, or else forgiving another."
  },
  {
    "author": "Gerald Jampolsky",
    "category": "forgiveness",
    "id": 24126,
    "text": "When I am able to resist the temptation to judge others, I can see them as teachers of forgiveness in my life, reminding me that I can only have peace of mind when I forgive rather than judge."
  },
  {
    "author": "T. D. Jakes",
    "category": "forgiveness",
    "id": 24150,
    "text": "We think that forgiveness is weakness, but it's absolutely not it takes a very strong person to forgive."
  },
  {
    "author": "Andrea Thompson",
    "category": "forgiveness",
    "id": 24168,
    "text": "I think we learn the most from imperfect relationships - things like forgiveness and compassion."
  },
  {
    "author": "Harlan Coben",
    "category": "forgiveness",
    "id": 24172,
    "text": "'Caught' is a novel of forgiveness, and the past and the present - who should be and who shouldn't be forgiven. None of my books are ever just about thrills, or it won't work."
  },
  {
    "author": "Alice Duer Miller",
    "category": "forgiveness",
    "id": 24100,
    "text": "Genuine forgiveness does not deny anger but faces it head-on."
  },
  {
    "author": "Heinrich Heine",
    "category": "forgiveness",
    "id": 24104,
    "text": "God will forgive me. It's his job."
  },
  {
    "author": "Catherine the Great",
    "category": "forgiveness",
    "id": 24117,
    "text": "I shall be an autocrat, that's my trade and the good Lord will forgive me, that's his."
  },
  {
    "author": "John F. Kennedy",
    "category": "forgiveness",
    "id": 24058,
    "text": "Forgive your enemies, but never forget their names."
  },
  {
    "author": "Jennifer O'Neill",
    "category": "forgiveness",
    "id": 24166,
    "text": "Forgiveness really is so misunderstood, as well as the power it can release in an individual."
  },
  {
    "author": "Kate Atkinson",
    "category": "forgiveness",
    "id": 24190,
    "text": "I'm a lapsed Quaker. I don't go to meetings any more. But I'm very drawn to Catholicism - all that glitter. I'd love to be a Catholic. I think it would be fantastic - faith, forgiveness, absolution, extreme unction - all these wonderful words. I don't think anyone who was ever born a Catholic hasn't died a Catholic, no matter how lapsed they are."
  },
  {
    "author": "Martin Luther",
    "category": "forgiveness",
    "id": 24124,
    "text": "Forgiveness is God's command."
  },
  {
    "author": "Robert Fripp",
    "category": "forgiveness",
    "id": 24076,
    "text": "A mistake is always forgivable, rarely excusable and always unacceptable."
  },
  {
    "author": "Elbert Hubbard",
    "category": "forgiveness",
    "id": 24087,
    "text": "The ineffable joy of forgiving and being forgiven forms an ecstasy that might well arouse the envy of the gods."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "forgiveness",
    "id": 24081,
    "text": "If there is something to pardon in everything, there is also something to condemn."
  },
  {
    "author": "Lewis B. Smedes",
    "category": "forgiveness",
    "id": 24074,
    "text": "To forgive is to set a prisoner free and discover that the prisoner was you."
  },
  {
    "author": "Norm Dicks",
    "category": "forgiveness",
    "id": 24199,
    "text": "These subsidies from four European governments, which include aircraft launch assistance, capital injections, debt forgiveness, have enabled Airbus to develop and range market airliners well below cost."
  },
  {
    "author": "Abdul Qadeer Khan",
    "category": "forgiveness",
    "id": 24149,
    "text": "I have to ask Allah's forgiveness and not get angry, because they come to me out of love, and it's not fitting that I should turn to them in hatred."
  },
  {
    "author": "John Dryden",
    "category": "forgiveness",
    "id": 24158,
    "text": "Forgiveness to the injured does belong but they ne'er pardon who have done wrong."
  },
  {
    "author": "Norman Cousins",
    "category": "forgiveness",
    "id": 24110,
    "text": "Life is an adventure in forgiveness."
  },
  {
    "author": "Jayson Blair",
    "category": "forgiveness",
    "id": 24189,
    "text": "I am making amends and seeking forgiveness. My only hope is that some good can come out of my situation."
  },
  {
    "author": "Cheryl Hines",
    "category": "forgiveness",
    "id": 24192,
    "text": "The things the writers have me doing on 'Suburgatory' are insane. I think they think it's easier to ask for forgiveness than permission."
  },
  {
    "author": "Mary Chesnut",
    "category": "forgiveness",
    "id": 24171,
    "text": "Forgiveness is indifference. Forgiveness is impossible while love lasts."
  },
  {
    "author": "Les Brown",
    "category": "forgiveness",
    "id": 24090,
    "text": "Forgive yourself for your faults and your mistakes and move on."
  },
  {
    "author": "Suzanne Somers",
    "category": "forgiveness",
    "id": 24089,
    "text": "Forgiveness is a gift you give yourself."
  },
  {
    "author": "Scott Stapp",
    "category": "forgiveness",
    "id": 24197,
    "text": "I think everything worked out the way it was supposed to. Mark's happier. I'm sober. There are still phone calls to be made, people I need to say something to. But everyone from Creed who I've offended or hurt, I ask for their forgiveness."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "forgiveness",
    "id": 24130,
    "text": "God pardons like a mother, who kisses the offense into everlasting forgiveness."
  },
  {
    "author": "Robert Rainy",
    "category": "forgiveness",
    "id": 24200,
    "text": "The principle that certain sins should not receive the Church's testimony of forgiveness was probably no novelty at all, but had been applied in various churches perhaps, however, with no strict consistency."
  },
  {
    "author": "Gerald Jampolsky",
    "category": "forgiveness",
    "id": 24131,
    "text": "Inner peace can be reached only when we practice forgiveness. Forgiveness is letting go of the past, and is therefore the means for correcting our misperceptions."
  },
  {
    "author": "Marianne Williamson",
    "category": "forgiveness",
    "id": 24145,
    "text": "The first step in forgiveness is the willingness to forgive."
  },
  {
    "author": "George MacDonald",
    "category": "forgiveness",
    "id": 24114,
    "text": "Forgiveness is the giving, and so the receiving, of life."
  },
  {
    "author": "Ben Affleck",
    "category": "forgiveness",
    "id": 24164,
    "text": "I find forgiveness to be really healthy."
  },
  {
    "author": "Jim Bakker",
    "category": "forgiveness",
    "id": 24184,
    "text": "God's forgiveness is the only thing. And, well, I take full responsibility for the adultery. It was my fault and, you know, no matter what went on, the man has to take responsibility and I do."
  },
  {
    "author": "Desmond Tutu",
    "category": "forgiveness",
    "id": 24099,
    "text": "Without forgiveness, there's no future."
  },
  {
    "author": "T. D. Jakes",
    "category": "forgiveness",
    "id": 24148,
    "text": "Forgiveness is about empowering yourself, rather than empowering your past."
  },
  {
    "author": "Peter Ustinov",
    "category": "forgiveness",
    "id": 24122,
    "text": "Love is an act of endless forgiveness, a tender look which becomes a habit."
  },
  {
    "author": "Mark Twain",
    "category": "forgiveness",
    "id": 24061,
    "text": "Forgiveness is the fragrance that the violet sheds on the heel that has crushed it."
  },
  {
    "author": "Joe Nichols",
    "category": "forgiveness",
    "id": 24179,
    "text": "The Dalai Lama's entire being is about peace and harmony, forgiveness and self-discipline. Those are qualities to be admired. I am really looking forward to meeting His Holiness."
  },
  {
    "author": "Reinhold Niebuhr",
    "category": "forgiveness",
    "id": 24069,
    "text": "Forgiveness is the final form of love."
  },
  {
    "author": "Ugo Betti",
    "category": "forgiveness",
    "id": 24188,
    "text": "There is no forgiveness in nature."
  },
  {
    "author": "Laura Schlessinger",
    "category": "forgiveness",
    "id": 24178,
    "text": "On the Day of Atonement, Jews are commanded to seek forgiveness from the people we have hurt."
  },
  {
    "author": "Thomas Fuller",
    "category": "forgiveness",
    "id": 24067,
    "text": "He that cannot forgive others breaks the bridge over which he must pass himself for every man has need to be forgiven."
  },
  {
    "author": "Keira Knightley",
    "category": "forgiveness",
    "id": 24142,
    "text": "If only I wasn't an atheist, I could get away with anything. You'd just ask for forgiveness and then you'd be forgiven. It sounds much better than having to live with guilt."
  },
  {
    "author": "Edward G. Bulwer-Lytton",
    "category": "forgiveness",
    "id": 24127,
    "text": "Anger ventilated often hurries towards forgiveness anger concealed often hardens into revenge."
  },
  {
    "author": "Louis-Ferdinand Celine",
    "category": "forgiveness",
    "id": 24202,
    "text": "One can't relive one's life. Forgiveness is not what's difficult one's always too ready to forgive. And it does no good, that's obvious."
  },
  {
    "author": "Virginia Foxx",
    "category": "forgiveness",
    "id": 24191,
    "text": "China's idea of fair trade is government subsidies of its textile and apparel exports to the United States, currency manipulation, and forgiveness of loans by its government banks."
  },
  {
    "author": "Karl Barth",
    "category": "forgiveness",
    "id": 24163,
    "text": "It is always the case that when the Christian looks back, he is looking at the forgiveness of sins."
  },
  {
    "author": "Lewis B. Smedes",
    "category": "forgiveness",
    "id": 24063,
    "text": "You will know that forgiveness has begun when you recall those who hurt you and feel the power to wish them well."
  },
  {
    "author": "Bernard Meltzer",
    "category": "forgiveness",
    "id": 24064,
    "text": "When you forgive, you in no way change the past - but you sure do change the future."
  },
  {
    "author": "Desmond Tutu",
    "category": "forgiveness",
    "id": 24144,
    "text": "Because forgiveness is like this: a room can be dank because you have closed the windows, you've closed the curtains. But the sun is shining outside, and the air is fresh outside. In order to get that fresh air, you have to get up and open the window and draw the curtains apart."
  },
  {
    "author": "Nancy Grace",
    "category": "forgiveness",
    "id": 24185,
    "text": "Well, of course I think people can be forgiven. But our justice system is not set up to dispense forgiveness. You can go to the local priest for that."
  },
  {
    "author": "Sherri Shepherd",
    "category": "forgiveness",
    "id": 24182,
    "text": "I believe in Jesus Christ as my Lord and savior. I believe that Jesus died for my sins, and rose again, and that's my belief. I still don't know what 'Christian' means. I'm a follower of Christ, but I keep making a whole bunch of mistakes. And I thank God for forgiveness."
  },
  {
    "author": "Jessamyn West",
    "category": "forgiveness",
    "id": 24113,
    "text": "It is very east to forgive others their mistakes it takes more grit and gumption to forgive them for having witnessed your own."
  },
  {
    "author": "Jean-Francois Cope",
    "category": "forgiveness",
    "id": 24195,
    "text": "I invite everyone to chose forgiveness rather than division, teamwork over personal ambition."
  },
  {
    "author": "Joan Lunden",
    "category": "forgiveness",
    "id": 24119,
    "text": "Holding on to anger, resentment and hurt only gives you tense muscles, a headache and a sore jaw from clenching your teeth. Forgiveness gives you back the laughter and the lightness in your life."
  },
  {
    "author": "Mackenzie Phillips",
    "category": "forgiveness",
    "id": 24205,
    "text": "Forgiveness is not to give the other person peace. Forgiveness is for you. Take that opportunity."
  },
  {
    "author": "Marianne Williamson",
    "category": "forgiveness",
    "id": 24140,
    "text": "I deepen my experience of God through prayer, meditation, and forgiveness."
  },
  {
    "author": "Desmond Tutu",
    "category": "forgiveness",
    "id": 24147,
    "text": "Before Nelson Mandela was arrested in 1962, he was an angry, relatively young man. He founded the ANC's military wing. When he was released, he surprised everyone because he was talking about reconciliation and forgiveness and not about revenge."
  },
  {
    "author": "Jewel",
    "category": "forgiveness",
    "id": 24176,
    "text": "Forgiveness is the needle that knows how to mend."
  },
  {
    "author": "Emo Philips",
    "category": "forgiveness",
    "id": 24071,
    "text": "When I was a kid I used to pray every night for a new bicycle. Then I realised that the Lord doesn't work that way so I stole one and asked Him to forgive me."
  },
  {
    "author": "William Arthur Ward",
    "category": "forgiveness",
    "id": 24084,
    "text": "Forgiveness is a funny thing. It warms the heart and cools the sting."
  },
  {
    "author": "Publilius Syrus",
    "category": "forgiveness",
    "id": 24106,
    "text": "How unhappy is he who cannot forgive himself."
  }
]

quotes['freedom'] = [
  {
    "author": "Willa Cather",
    "category": "freedom",
    "id": 24762,
    "text": "The condition every art requires is, not so much freedom from restriction, as freedom from adulteration and from the intrusion of foreign matter."
  },
  {
    "author": "Willie Nelson",
    "category": "freedom",
    "id": 24585,
    "text": "Freedom is control in your own life."
  },
  {
    "author": "Jean Claude Van Damme",
    "category": "freedom",
    "id": 24635,
    "text": "But on average, I go to the gym about four or five times a week. Today, I'm so experienced in training - I'm actually listening to my body now. My body needs freedom. When I train I create serenity and I produce oxygen in my blood. It helps me to think better and relax. By training, you accentuate the problem."
  },
  {
    "author": "Charles Horton Cooley",
    "category": "freedom",
    "id": 24877,
    "text": "Every general increase of freedom is accompanied by some degeneracy, attributable to the same causes as the freedom."
  },
  {
    "author": "Tim Pawlenty",
    "category": "freedom",
    "id": 24457,
    "text": "History has taught us over and over again that freedom is not free. When push comes to shove, the ultimate protectors of freedom and liberty are the brave men and women in our armed forces. Throughout our history, they've answered the call in bravery and sacrifice."
  },
  {
    "author": "Ronald Reagan",
    "category": "freedom",
    "id": 24280,
    "text": "Freedom is never more than one generation away from extinction. We didn't pass it to our children in the bloodstream. It must be fought for, protected, and handed on for them to do the same."
  },
  {
    "author": "Esther Dyson",
    "category": "freedom",
    "id": 24785,
    "text": "But there is a corollary to freedom and that's personal responsibility, and the real challenge is how you generate that personal responsibility without imposing it."
  },
  {
    "author": "Michael J. Fox",
    "category": "freedom",
    "id": 24587,
    "text": "I have no choice about whether or not I have Parkinson's. I have nothing but choices about how I react to it. In those choices, there's freedom to do a lot of things in areas that I wouldn't have otherwise found myself in."
  },
  {
    "author": "Demetri Martin",
    "category": "freedom",
    "id": 24615,
    "text": "But I found that disappointing people is a good thing, because disapproval is freedom."
  },
  {
    "author": "Desmond Tutu",
    "category": "freedom",
    "id": 24583,
    "text": "Exclusion is never the way forward on our shared paths to freedom and justice."
  },
  {
    "author": "Constance Baker Motley",
    "category": "freedom",
    "id": 25076,
    "text": "The legal difference between the sit-ins and the Freedom Riders was significant."
  },
  {
    "author": "Anna Quindlen",
    "category": "freedom",
    "id": 24257,
    "text": "Children should have enough freedom to be themselves - once they've learned the rules."
  },
  {
    "author": "George Orwell",
    "category": "freedom",
    "id": 24421,
    "text": "Freedom is the freedom to say that two plus two make four. If that is granted, all else follows."
  },
  {
    "author": "Vince McMahon",
    "category": "freedom",
    "id": 24976,
    "text": "In America it's live by the sword of freedom of expression and be will to die by it as well."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "freedom",
    "id": 24375,
    "text": "He only earns his freedom and his life Who takes them every day by storm."
  },
  {
    "author": "Paul Giamatti",
    "category": "freedom",
    "id": 25166,
    "text": "I was the youngest child and got a lot more freedom than my brother and sister. I used to wander, doing my own thing under the radar, but I didn't get in bad, bad trouble."
  },
  {
    "author": "Gerry Adams",
    "category": "freedom",
    "id": 24971,
    "text": "Your determination, selflessness and courage have brought the freedom struggle towards its fulfilment."
  },
  {
    "author": "Winston Churchill",
    "category": "freedom",
    "id": 24285,
    "text": "All the great things are simple, and many can be expressed in a single word: freedom, justice, honor, duty, mercy, hope."
  },
  {
    "author": "Emma Watson",
    "category": "freedom",
    "id": 24738,
    "text": "I'm a multidimensional person and that's the freedom of fashion: that you're able to reinvent yourself through how you dress and how you cut your hair or whatever."
  },
  {
    "author": "Stockwell Day",
    "category": "freedom",
    "id": 24251,
    "text": "I believe in freedom of speech, but I believe we should also have the right to comment on freedom of speech."
  },
  {
    "author": "Demi Moore",
    "category": "freedom",
    "id": 24941,
    "text": "Not caring more about what other people think than what you think. That's freedom."
  },
  {
    "author": "Anna Quindlen",
    "category": "freedom",
    "id": 24771,
    "text": "I will never understand people who think that the way to show their righteous opposition to sexual freedom is to write letters full of filthy words."
  },
  {
    "author": "Kofi Annan",
    "category": "freedom",
    "id": 24809,
    "text": "If one is going to err, one should err on the side of liberty and freedom."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "freedom",
    "id": 24301,
    "text": "True individual freedom cannot exist without economic security and independence. People who are hungry and out of a job are the stuff of which dictatorships are made."
  },
  {
    "author": "Merle Haggard",
    "category": "freedom",
    "id": 24660,
    "text": "In 1960, when I came out of prison as an ex-convict, I had more freedom under parolee supervision than there's available... in America right now."
  },
  {
    "author": "Hannah Arendt",
    "category": "freedom",
    "id": 24706,
    "text": "Man cannot be free if he does not know that he is subject to necessity, because his freedom is always won in his never wholly successful attempts to liberate himself from necessity."
  },
  {
    "author": "Baruch Spinoza",
    "category": "freedom",
    "id": 24255,
    "text": "Freedom is absolutely necessary for the progress in science and the liberal arts."
  },
  {
    "author": "Barack Obama",
    "category": "freedom",
    "id": 24368,
    "text": "For more than four decades, the Libyan people have been ruled by a tyrant - Moammar Gaddafi. He has denied his people freedom, exploited their wealth, murdered opponents at home and abroad, and terrorized innocent people around the world - including Americans who were killed by Libyan agents."
  },
  {
    "author": "Lisa Loeb",
    "category": "freedom",
    "id": 25122,
    "text": "I always wanted to make a children's album because you have the freedom to explore so many wonderful topics and sounds."
  },
  {
    "author": "Yahya Jammeh",
    "category": "freedom",
    "id": 24828,
    "text": "Any one who wants to live in peace and freedom will be to live by toil, demonstration of high levels of discipline and tolerance for one another."
  },
  {
    "author": "Richard M. Nixon",
    "category": "freedom",
    "id": 24468,
    "text": "Americans admire a people who can scratch a desert and produce a garden. The Israelis have shown qualities that Americans identify with: guts, patriotism, idealism, a passion for freedom. I have seen it. I know. I believe that."
  },
  {
    "author": "Mario Vargas Llosa",
    "category": "freedom",
    "id": 24931,
    "text": "Prosperity or egalitarianism - you have to choose. I favor freedom - you never achieve real equality anyway: you simply sacrifice prosperity for an illusion."
  },
  {
    "author": "Eminem",
    "category": "freedom",
    "id": 24330,
    "text": "I think my first album opened a lot of doors for me to push the freedom of speech to the limit."
  },
  {
    "author": "Diane Kruger",
    "category": "freedom",
    "id": 24791,
    "text": "Her beauty didn't do her any good and she couldn't use it in any positive way or manipulative way. I just hope that people will look and see and believe in that hope of love, that hope of freedom, even if it was just for a limited time."
  },
  {
    "author": "Charlie Dent",
    "category": "freedom",
    "id": 24690,
    "text": "We in the United States should be all the more thankful for the freedom and religious tolerance we enjoy. And we should always remember the lessons learned from the Holocaust, in hopes we stay vigilant against such inhumanity now and in the future."
  },
  {
    "author": "Delphine de Girardin",
    "category": "freedom",
    "id": 25204,
    "text": "Men must stop being jealous of their power and generously allow freedom and responsibility to others. The reward is harmonious families and society."
  },
  {
    "author": "Phil Lynott",
    "category": "freedom",
    "id": 24846,
    "text": "I tasted freedom and I really liked it."
  },
  {
    "author": "Jim Morrison",
    "category": "freedom",
    "id": 24318,
    "text": "I'm interested in anything about revolt, disorder, chaos, especially activity that appears to have no meaning. It seems to me to be the road toward freedom."
  },
  {
    "author": "Rupert Grint",
    "category": "freedom",
    "id": 25162,
    "text": "In terms of filming, yes, it really does feel over now. There's a real sense of freedom now. It's a good time to finish, I think. As much as I'm going to miss it I'm ready to move on and do different things."
  },
  {
    "author": "Ivan Turgenev",
    "category": "freedom",
    "id": 24847,
    "text": "In the end, nature is inexorable: it has no reason to hurry and, sooner or later, it takes what belongs to it. Unconsciously and inflexibly obedient to its own laws, it doesn't know art, just as it doesn't know freedom, just as it doesn't know goodness."
  },
  {
    "author": "Aldous Huxley",
    "category": "freedom",
    "id": 24410,
    "text": "The worst enemy of life, freedom and the common decencies is total anarchy their second worst enemy is total efficiency."
  },
  {
    "author": "Will Durant",
    "category": "freedom",
    "id": 24672,
    "text": "Civilization is the order and freedom is promoting cultural activity."
  },
  {
    "author": "Hugo Black",
    "category": "freedom",
    "id": 24875,
    "text": "Criticism of government finds sanctuary in several portions of the 1st Amendment. It is part of the right of free speech. It embraces freedom of the press."
  },
  {
    "author": "Norman Thomas",
    "category": "freedom",
    "id": 24860,
    "text": "To us Americans much has been given of us much is required. With all our faults and mistakes, it is our strength in support of the freedom our forefathers loved which has saved mankind from subjection to totalitarian power."
  },
  {
    "author": "Bryant H. McGill",
    "category": "freedom",
    "id": 24594,
    "text": "It is better to lose everything you have to keep the balance of justice level, than to live a life of petty privilege devoid of true freedom."
  },
  {
    "author": "James McGreevey",
    "category": "freedom",
    "id": 24916,
    "text": "The arc of American history almost inevitably moves toward freedom. Whether it's Lincoln and the Emancipation Proclamation, the expansion of women's rights or, now, gay rights, I think there is an almost-inevitable march toward greater civil liberties."
  },
  {
    "author": "Greg Walden",
    "category": "freedom",
    "id": 25152,
    "text": "A man of strength and wisdom, John Paul became an inspiration to generations of both Catholics and non-Catholics throughout the world by encouraging freedom, promoting peace and respecting all faiths."
  },
  {
    "author": "Tiffeny Milbrett",
    "category": "freedom",
    "id": 25176,
    "text": "I am somebody who... - I'm not saying I'm perfect, but I need that freedom, that ability to make mistakes out there. Because there's a fine line between making a mistake or being brilliant."
  },
  {
    "author": "Thomas Mann",
    "category": "freedom",
    "id": 24786,
    "text": "It is a strange fact that freedom and equality, the two basic ideas of democracy, are to some extent contradictory. Logically considered, freedom and equality are mutually exclusive, just as society and the individual are mutually exclusive."
  },
  {
    "author": "John W. Gardner",
    "category": "freedom",
    "id": 24508,
    "text": "America's greatness has been the greatness of a free people who shared certain moral commitments. Freedom without moral commitment is aimless and promptly self-destructive."
  },
  {
    "author": "Dan Quayle",
    "category": "freedom",
    "id": 24249,
    "text": "I believe we are on an irreversible trend toward more freedom and democracy - but that could change."
  },
  {
    "author": "Jean-Paul Sartre",
    "category": "freedom",
    "id": 24218,
    "text": "Freedom is what you do with what's been done to you."
  },
  {
    "author": "William Falconer",
    "category": "freedom",
    "id": 24824,
    "text": "Freedom from care and anxiety of mind is a blessing, which I apprehend such people enjoy in higher perfection than most others, and is of the utmost consequence."
  },
  {
    "author": "Thomas Moore",
    "category": "freedom",
    "id": 24831,
    "text": "Bastard Freedom waves Her fustian flag in mockery over slaves."
  },
  {
    "author": "Johnny Depp",
    "category": "freedom",
    "id": 24383,
    "text": "There are necessary evils. Money is an important thing in terms of representing freedom in our world. And now I have a daughter to think about. It's really the first time I've thought about the future and what it could be."
  },
  {
    "author": "Dave Brubeck",
    "category": "freedom",
    "id": 25095,
    "text": "Jazz is about freedom within discipline. Usually a dictatorship like in Russia and Germany will prevent jazz from being played because it just seemed to represent freedom, democracy and the United States."
  },
  {
    "author": "Rollo May",
    "category": "freedom",
    "id": 24816,
    "text": "Human freedom involves our capacity to pause, to choose the one response toward which we wish to throw our weight."
  },
  {
    "author": "Thornton Wilder",
    "category": "freedom",
    "id": 24420,
    "text": "The more decisions that you are forced to make alone, the more you are aware of your freedom to choose."
  },
  {
    "author": "Brian Eno",
    "category": "freedom",
    "id": 24653,
    "text": "I felt extremely uncomfortable as the focal point, in the spotlight. I really like the behind the scenes role, because all my freedom is there."
  },
  {
    "author": "Steve Winwood",
    "category": "freedom",
    "id": 25070,
    "text": "It could be my British need for discipline that makes me admire the American appetite for freedom and passion."
  },
  {
    "author": "Bernadette Devlin",
    "category": "freedom",
    "id": 24668,
    "text": "Among the best traitors Ireland has ever had, Mother Church ranks at the very top, a massive obstacle in the path to equality and freedom. She has been a force for conservatism... to ward off threats to her own security and influence."
  },
  {
    "author": "Miuccia Prada",
    "category": "freedom",
    "id": 24864,
    "text": "I wanted to try to push some freedom into the men's clothes."
  },
  {
    "author": "Jim Morrison",
    "category": "freedom",
    "id": 24314,
    "text": "I am interested in anything about revolt, disorder, chaos-especially activity that seems to have no meaning. It seems to me to be the road toward freedom... Rather than starting inside, I start outside and reach the mental through the physical."
  },
  {
    "author": "Simone de Beauvoir",
    "category": "freedom",
    "id": 24366,
    "text": "I wish that every human life might be pure transparent freedom."
  },
  {
    "author": "Natan Sharansky",
    "category": "freedom",
    "id": 25143,
    "text": "Believe me, the drug of freedom is universally potent."
  },
  {
    "author": "Jane Siberry",
    "category": "freedom",
    "id": 25102,
    "text": "Maybe a part of me recognized how right the improvising spirit of jazz is. Not the sounds, but the freedom to work with musicians who work that way. It felt very natural to me, but I think there's a way to do it without it being a jazz record."
  },
  {
    "author": "Robert M. Gates",
    "category": "freedom",
    "id": 25112,
    "text": "I have always that there ought to be some kind of mandatory national service, not necessarily in the military but to show everybody that freedom isn't free, that everybody has an obligation to the nation as a community."
  },
  {
    "author": "Peter Ustinov",
    "category": "freedom",
    "id": 24248,
    "text": "In America, through pressure of conformity, there is freedom of choice, but nothing to choose from."
  },
  {
    "author": "Alexis de Tocqueville",
    "category": "freedom",
    "id": 24484,
    "text": "No protracted war can fail to endanger the freedom of a democratic country."
  },
  {
    "author": "Joss Stone",
    "category": "freedom",
    "id": 25195,
    "text": "To me, music has to be about freedom. It's the most important thing in my life."
  },
  {
    "author": "Ice Cube",
    "category": "freedom",
    "id": 24811,
    "text": "Music is where I have the most creative freedom, but I love producing. To me, that's kind of where all the action is. You get a chance to have your hands in every aspect of a film. From picking a director, sometimes picking a writer, to the actors, the wardrobe, set design, editing, music, and marketing."
  },
  {
    "author": "Friedrich August von Hayek",
    "category": "freedom",
    "id": 24552,
    "text": "Freedom granted only when it is known beforehand that its effects will be beneficial is not freedom."
  },
  {
    "author": "Jay Weatherill",
    "category": "freedom",
    "id": 25157,
    "text": "People want the freedom. They want to be able to shop. If you don't like the shop trading hours and you're a shop owner, you don't have to open."
  },
  {
    "author": "Kylie Minogue",
    "category": "freedom",
    "id": 25058,
    "text": "With one man, there was a freedom and liberation. That was with Michael Hutchence, my partner in life."
  },
  {
    "author": "Rick Perry",
    "category": "freedom",
    "id": 24693,
    "text": "We know there is no such thing as freedom without the risk of failure."
  },
  {
    "author": "Howard Zinn",
    "category": "freedom",
    "id": 24748,
    "text": "One certain effect of war is to diminish freedom of expression."
  },
  {
    "author": "Tom Wolfe",
    "category": "freedom",
    "id": 25108,
    "text": "The attitude is we live and let live. This is actually an amazing change in values in a rather short time and it's an example of freedom from religion."
  },
  {
    "author": "Oliver Tambo",
    "category": "freedom",
    "id": 24370,
    "text": "The fight for freedom must go on until it is won until our country is free and happy and peaceful as part of the community of man, we cannot rest."
  },
  {
    "author": "Ron Paul",
    "category": "freedom",
    "id": 24401,
    "text": "Back a hundred years ago, especially around Woodrow Wilson, what happened in this country is we took freedom and we chopped it into pieces."
  },
  {
    "author": "Roy Scheider",
    "category": "freedom",
    "id": 25156,
    "text": "Freedom is a muscle... you have to exercise it."
  },
  {
    "author": "Mikhail Bakunin",
    "category": "freedom",
    "id": 24942,
    "text": "The freedom of all is essential to my freedom."
  },
  {
    "author": "Indra Devi",
    "category": "freedom",
    "id": 25089,
    "text": "Yoga is a way to freedom. By its constant practice, we can free ourselves from fear, anguish and loneliness."
  },
  {
    "author": "Brigham Young",
    "category": "freedom",
    "id": 24550,
    "text": "True independence and freedom can only exist in doing what's right."
  },
  {
    "author": "Jennifer Garner",
    "category": "freedom",
    "id": 24921,
    "text": "I'm privileged, because I have a lot of freedom. I want to use it to make as warm and normal a life as I can for our daughters."
  },
  {
    "author": "Garrett Hardin",
    "category": "freedom",
    "id": 24729,
    "text": "Freedom in a commons brings ruin to all."
  },
  {
    "author": "Oriana Fallaci",
    "category": "freedom",
    "id": 25029,
    "text": "The increased presence of Muslims in Italy and in Europe is directly proportional to our loss of freedom."
  },
  {
    "author": "Frederick Douglass",
    "category": "freedom",
    "id": 24316,
    "text": "I am a Republican, a black, dyed in the wool Republican, and I never intend to belong to any other party than the party of freedom and progress."
  },
  {
    "author": "Bernard Baruch",
    "category": "freedom",
    "id": 24869,
    "text": "The greatest blessing of our democracy is freedom. But in the last analysis, our only freedom is the freedom to discipline ourselves."
  },
  {
    "author": "Angela Davis",
    "category": "freedom",
    "id": 24823,
    "text": "We know the road to freedom has always been stalked by death."
  },
  {
    "author": "Ian MacKaye",
    "category": "freedom",
    "id": 25093,
    "text": "With Napster and the sharing of music, of course, there are going to be people who exploit it. Greed has no end. But there's a lot of good that could happen. We shouldn't let the economic concerns of the major labels infringe on our freedom to share music."
  },
  {
    "author": "Desmond Tutu",
    "category": "freedom",
    "id": 24563,
    "text": "The price of freedom is eternal vigilance."
  },
  {
    "author": "Andrea Dworkin",
    "category": "freedom",
    "id": 24680,
    "text": "As long as there is rape... there is not going to be any peace or justice or equality or freedom. You are not going to become what you want to become or who you want to become. You are not going to live in the world you want to live in."
  },
  {
    "author": "Nelson Mandela",
    "category": "freedom",
    "id": 24335,
    "text": "Let freedom reign. The sun never set on so glorious a human achievement."
  },
  {
    "author": "Howard Nemerov",
    "category": "freedom",
    "id": 24952,
    "text": "I never abandoned either forms or freedom. I imagine that most of what could be called free verse is in my first book. I got through that fairly early."
  },
  {
    "author": "Anna Julia Cooper",
    "category": "freedom",
    "id": 24701,
    "text": "The cause of freedom is not the cause of a race or a sect, a party or a class-it is the cause of human kind, the very birthright of humanity."
  },
  {
    "author": "Michael Korda",
    "category": "freedom",
    "id": 24526,
    "text": "The freedom to fail is vital if you're going to succeed. Most successful people fail from time to time, and it is a measure of their strength that failure merely propels them into some new attempt at success."
  },
  {
    "author": "Mitt Romney",
    "category": "freedom",
    "id": 24404,
    "text": "The words spoken by the leader of the free world can expand the frontiers of freedom or shrink them. When Ronald Reagan called on Gorbachev to 'tear down this wall,' a surge of confidence rose that would ultimately breach the bounds of the evil empire."
  },
  {
    "author": "George Will",
    "category": "freedom",
    "id": 24939,
    "text": "I suppose there's a melancholy tone at the back of the American mind, a sense of something lost. And it's the lost world of Thomas Jefferson. It is the lost sense of innocence that we could live with a very minimal state, with a vast sense of space in which to work out freedom."
  },
  {
    "author": "Thomas Paine",
    "category": "freedom",
    "id": 24371,
    "text": "Those who expect to reap the blessings of freedom must, like men, undergo the fatigue of supporting it."
  },
  {
    "author": "Michael Phelps",
    "category": "freedom",
    "id": 24832,
    "text": "I think to be - for me to be an American is - you know, it's one of the greatest things in the world for - you know, for me just because I've been able to grow up with everything. The freedom. You know, in my eyes this is the greatest country in the world."
  }
]

quotes['friendship'] = [
  {
    "author": "Charles Lamb",
    "category": "friendship",
    "id": 25437,
    "text": "Tis the privilege of friendship to talk nonsense, and have her nonsense respected."
  },
  {
    "author": "Max Jacob",
    "category": "friendship",
    "id": 25567,
    "text": "Friendship is inexplicable, it should not be explained if one doesn't want to kill it."
  },
  {
    "author": "Marie de France",
    "category": "friendship",
    "id": 25423,
    "text": "If one of two lovers is loyal, and the other jealous and false, how may their friendship last, for Love is slain!"
  },
  {
    "author": "Ulysses S. Grant",
    "category": "friendship",
    "id": 25238,
    "text": "The friend in my adversity I shall always cherish most. I can better trust those who helped to relieve the gloom of my dark hours than those who are so ready to enjoy with me the sunshine of my prosperity."
  },
  {
    "author": "John D. Rockefeller",
    "category": "friendship",
    "id": 25251,
    "text": "A friendship founded on business is better than a business founded on friendship."
  },
  {
    "author": "Marcelene Cox",
    "category": "friendship",
    "id": 25554,
    "text": "One sure way to lose another woman's friendship is to try to improve her flower arrangements."
  },
  {
    "author": "Zora Neale Hurston",
    "category": "friendship",
    "id": 25334,
    "text": "It seems to me that trying to live without friends is like milking a bear to get cream for your morning coffee. It is a whole lot of trouble, and then not worth much after you get it."
  },
  {
    "author": "Jean Cocteau",
    "category": "friendship",
    "id": 25470,
    "text": "I have lost my seven best friends, which is to say God has had mercy on me seven times without realizing it. He lent a friendship, took it from me, sent me another."
  },
  {
    "author": "Judy Holliday",
    "category": "friendship",
    "id": 25294,
    "text": "Lovers have a right to betray you... friends don't."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "friendship",
    "id": 25405,
    "text": "Sympathy constitutes friendship but in love there is a sort of antipathy, or opposing passion. Each strives to be the other, and both together make up one whole."
  },
  {
    "author": "E. W. Howe",
    "category": "friendship",
    "id": 25514,
    "text": "It may be a cold, clammy thing to say, but those that treat friendship the same as any other selfishness seem to get the most out of it."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "friendship",
    "id": 25462,
    "text": "Friendship, of itself a holy tie, is made more sacred by adversity."
  },
  {
    "author": "Honore de Balzac",
    "category": "friendship",
    "id": 25331,
    "text": "Nothing so fortifies a friendship as a belief on the part of one friend that he is superior to the other."
  },
  {
    "author": "Henry Adams",
    "category": "friendship",
    "id": 25330,
    "text": "Friends are born, not made."
  },
  {
    "author": "Georg Brandes",
    "category": "friendship",
    "id": 25570,
    "text": "My first experiences of academic friendship made me smile in after years when I looked back on them. But my circle of acquaintances had gradually grown so large that it was only natural new friendships should grow out of it."
  },
  {
    "author": "Carmen Sylva",
    "category": "friendship",
    "id": 25518,
    "text": "Friendship based solely upon gratitude is like a photograph with time it fades."
  },
  {
    "author": "James F. Byrnes",
    "category": "friendship",
    "id": 25507,
    "text": "Friendship without self-interest is one of the rare and beautiful things of life."
  },
  {
    "author": "George Santayana",
    "category": "friendship",
    "id": 25447,
    "text": "Friendship is almost always the union of a part of one mind with the part of another people are friends in spots."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "friendship",
    "id": 25343,
    "text": "It is not a lack of love, but a lack of friendship that makes unhappy marriages."
  },
  {
    "author": "Dag Hammarskjold",
    "category": "friendship",
    "id": 25308,
    "text": "Friendship needs no words - it is solitude delivered from the anguish of loneliness."
  },
  {
    "author": "William Hazlitt",
    "category": "friendship",
    "id": 25411,
    "text": "Even in the common affairs of life, in love, friendship, and marriage, how little security have we when we trust our happiness in the hands of others!"
  },
  {
    "author": "Robert Blair",
    "category": "friendship",
    "id": 25538,
    "text": "Friendship! Mysterious cement of the soul, Sweet'ner of life, and solder of society."
  },
  {
    "author": "Lord Byron",
    "category": "friendship",
    "id": 25398,
    "text": "Friendship is Love without his wings!"
  },
  {
    "author": "Bradley Chicho",
    "category": "friendship",
    "id": 25612,
    "text": "The joys of friendship inert the heart and fizzy home bouncing jubilantly with laughter-buttered love."
  },
  {
    "author": "Francesco Guicciardini",
    "category": "friendship",
    "id": 25322,
    "text": "Since there is nothing so well worth having as friends, never lose a chance to make them."
  },
  {
    "author": "Aristotle",
    "category": "friendship",
    "id": 25228,
    "text": "Friendship is a single soul dwelling in two bodies."
  },
  {
    "author": "Thomas Jefferson",
    "category": "friendship",
    "id": 25229,
    "text": "But friendship is precious, not only in the shade, but in the sunshine of life, and thanks to a benevolent arrangement the greater part of life is sunshine."
  },
  {
    "author": "Jonathan Edwards",
    "category": "friendship",
    "id": 25527,
    "text": "Sincere friendship towards God, in all who believe him to be properly an intelligent, willing being, does most apparently, directly, and strongly incline to prayer and it no less disposes the heart strongly to desire to have our infinitely glorious."
  },
  {
    "author": "William Blake",
    "category": "friendship",
    "id": 25409,
    "text": "Opposition is true friendship."
  },
  {
    "author": "Edward Young",
    "category": "friendship",
    "id": 25480,
    "text": "Friendship's the wine of life: but friendship new... is neither strong nor pure."
  },
  {
    "author": "Sidonie Gabrielle Colette",
    "category": "friendship",
    "id": 25473,
    "text": "It is wise to apply the oil of refined politeness to the mechanism of friendship."
  },
  {
    "author": "Pope Benedict XVI",
    "category": "friendship",
    "id": 25563,
    "text": "Today, I, too, wish to reaffirm that I intend to continue on the path toward improved relations and friendship with the Jewish people, following the decisive lead given by John Paul II."
  },
  {
    "author": "Oscar Wilde",
    "category": "friendship",
    "id": 25262,
    "text": "Laughter is not at all a bad beginning for a friendship, and it is far the best ending for one."
  },
  {
    "author": "Eamon de Valera",
    "category": "friendship",
    "id": 25589,
    "text": "The part which American friendship played in helping us to win the freedom we enjoy in this part of Ireland has been gratefully recognized and acknowledged by our people."
  },
  {
    "author": "Sallust",
    "category": "friendship",
    "id": 25506,
    "text": "The firmest friendship is based on an identity of likes and dislikes."
  },
  {
    "author": "Greg Bear",
    "category": "friendship",
    "id": 25621,
    "text": "Ray Bradbury is, for many reasons, the most influential writer in my life. Throughout our long friendship, Ray supplied not only his terrific stories but a grand model of what a writer could be, should be, and yet rarely is: brilliant and charming and accessible, willing to tolerate and to teach, happy to inspire but also to be inspired."
  },
  {
    "author": "Khalil Gibran",
    "category": "friendship",
    "id": 25281,
    "text": "Let there be no purpose in friendship save the deepening of the spirit."
  },
  {
    "author": "Andrew Sullivan",
    "category": "friendship",
    "id": 25577,
    "text": "What gay culture is before it is anything else, before it is a culture of desire or a culture of subversion or a culture of pain, is a culture of friendship."
  },
  {
    "author": "Saint Teresa of Avila",
    "category": "friendship",
    "id": 25455,
    "text": "For prayer is nothing else than being on terms of friendship with God."
  },
  {
    "author": "Stendhal",
    "category": "friendship",
    "id": 25445,
    "text": "Friendship has its illusions no less than love."
  },
  {
    "author": "Elbert Hubbard",
    "category": "friendship",
    "id": 25250,
    "text": "The friend is the man who knows all about you, and still likes you."
  },
  {
    "author": "Jose Ramos-Horta",
    "category": "friendship",
    "id": 25525,
    "text": "The second one, the joint Truth and Friendship Commission, which we started now with Indonesia, that is the one that has been criticized its terms of reference call for providing amnesty for those who cooperate in telling the truth. It does not lead to prosecution."
  },
  {
    "author": "E. W. Howe",
    "category": "friendship",
    "id": 25335,
    "text": "When a friend is in trouble, don't annoy him by asking if there is anything you can do. Think up something appropriate and do it."
  },
  {
    "author": "Pierre Teilhard de Chardin",
    "category": "friendship",
    "id": 25271,
    "text": "The world is round so that friendship may encircle it."
  },
  {
    "author": "Euripides",
    "category": "friendship",
    "id": 25325,
    "text": "Life has no blessing like a prudent friend."
  },
  {
    "author": "Christopher Knight",
    "category": "friendship",
    "id": 25620,
    "text": "To some it may be a thrill to be known, to me it's a thrill to start a friendship even up."
  },
  {
    "author": "Saint Francis de Sales",
    "category": "friendship",
    "id": 25293,
    "text": "A quarrel between friends, when made up, adds a new tie to friendship."
  },
  {
    "author": "Adam Sandler",
    "category": "friendship",
    "id": 25454,
    "text": "Sixth grade was a big time, in my childhood, of hoops and friendship, and coming up with funny things."
  },
  {
    "author": "Tom Lehrer",
    "category": "friendship",
    "id": 25566,
    "text": "My last public performance for money was in 1967. For free, it was 1972, with the exception of two little one-shot, one-song things. But that's just for friends, out of friendship for the people involved, and also because it was fun."
  },
  {
    "author": "Armistead Maupin",
    "category": "friendship",
    "id": 25578,
    "text": "The film itself involves a New York City radio storyteller, Gabriel Noone, who strikes up a friendship with one of his fans, an abused 14-year-old teenager who is suffering from AIDS, who does not have much longer to live."
  },
  {
    "author": "Helen Keller",
    "category": "friendship",
    "id": 25244,
    "text": "So long as the memory of certain beloved friends lives in my heart, I shall say that life is good."
  },
  {
    "author": "Voltaire",
    "category": "friendship",
    "id": 25387,
    "text": "Friendship is the marriage of the soul, and this marriage is liable to divorce."
  },
  {
    "author": "Emil Zatopek",
    "category": "friendship",
    "id": 25513,
    "text": "Great is the victory, but the friendship of all is greater."
  },
  {
    "author": "Henry Adams",
    "category": "friendship",
    "id": 25434,
    "text": "One friend in a lifetime is much, two are many, three are hardly possible. Friendship needs a certain parallelism of life, a community of thought, a rivalry of aim."
  },
  {
    "author": "Jena Malone",
    "category": "friendship",
    "id": 25484,
    "text": "A lot of the powerful religious leaders, from Jesus to Buddha to Tibetan monks, they're really talking about the same things: love and acceptable, and the value of friendship, and respecting yourself so you can respect others."
  },
  {
    "author": "Truman Capote",
    "category": "friendship",
    "id": 25392,
    "text": "Friendship is a pretty full-time occupation if you really are friendly with somebody. You can't have too many friends because then you're just not really friends."
  },
  {
    "author": "Anita Brookner",
    "category": "friendship",
    "id": 25486,
    "text": "Accountability in friendship is the equivalent of love without strategy."
  },
  {
    "author": "Alfred A. Montapert",
    "category": "friendship",
    "id": 25361,
    "text": "All lasting business is built on friendship."
  },
  {
    "author": "Anne Lamott",
    "category": "friendship",
    "id": 25421,
    "text": "My parents, and librarians along the way, taught me about the space between words about the margins, where so many juicy moments of life and spirit and friendship could be found. In a library, you could find miracles and truth and you might find something that would make you laugh so hard that you get shushed, in the friendliest way."
  },
  {
    "author": "Anna Deavere Smith",
    "category": "friendship",
    "id": 25511,
    "text": "Friendship is a wildly underrated medication."
  },
  {
    "author": "Virginia Woolf",
    "category": "friendship",
    "id": 25313,
    "text": "Some people go to priests others to poetry I to my friends."
  },
  {
    "author": "William Wycherley",
    "category": "friendship",
    "id": 25560,
    "text": "Good fellowship and friendship are lasting, rational and manly pleasures."
  },
  {
    "author": "Ella Wheeler Wilcox",
    "category": "friendship",
    "id": 25452,
    "text": "All love that has not friendship for its base, is like a mansion built upon the sand."
  },
  {
    "author": "Jennifer Beals",
    "category": "friendship",
    "id": 25594,
    "text": "It became very clear to the director that it would be foolish not to use our friendship. I had tried to talk to him about it because all the relationships in the film are so, not negative, but antagonistic. There's not a lot of love going around."
  },
  {
    "author": "Laurence J. Peter",
    "category": "friendship",
    "id": 25263,
    "text": "You can always tell a real friend: when you've made a fool of yourself he doesn't feel you've done a permanent job."
  },
  {
    "author": "Cornelia Otis Skinner",
    "category": "friendship",
    "id": 25634,
    "text": "To cement a new friendship, especially between foreigners or persons of a different social world, a spark with which both were secretly charged must fly from person to person, and cut across the accidents of place and time."
  },
  {
    "author": "Sallust",
    "category": "friendship",
    "id": 25498,
    "text": "All who consult on doubtful matters, should be void of hatred, friendship, anger, and pity."
  },
  {
    "author": "Lisa See",
    "category": "friendship",
    "id": 25404,
    "text": "People come in and out of our lives, and the true test of friendship is whether you can pick back up right where you left off the last time you saw each other."
  },
  {
    "author": "June Jordan",
    "category": "friendship",
    "id": 25574,
    "text": "But, based on my friendship with Evie as young mothers, I started going on freedom rides in 1966."
  },
  {
    "author": "Giotto di Bondone",
    "category": "friendship",
    "id": 25284,
    "text": "The sincere friends of this world are as ship lights in the stormiest of nights."
  },
  {
    "author": "Atifete Jahjaga",
    "category": "friendship",
    "id": 25633,
    "text": "The ideal of all Kosovo is membership in the E.U. and a permanent friendship with the United States. I believe and I am convinced our dreams will come true."
  },
  {
    "author": "Aristotle",
    "category": "friendship",
    "id": 25364,
    "text": "Perfect friendship is the friendship of men who are good, and alike in excellence for these wish well alike to each other qua good, and they are good in themselves."
  },
  {
    "author": "Henry David Thoreau",
    "category": "friendship",
    "id": 25371,
    "text": "I had three chairs in my house one for solitude, two for friendship, three for society."
  },
  {
    "author": "Katherine Mansfield",
    "category": "friendship",
    "id": 25296,
    "text": "I always felt that the great high privilege, relief and comfort of friendship was that one had to explain nothing."
  },
  {
    "author": "Confucius",
    "category": "friendship",
    "id": 25283,
    "text": "Never contract friendship with a man that is not better than thyself."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "friendship",
    "id": 25291,
    "text": "A true friend is the greatest of all blessings, and that which we take the least care of all to acquire."
  },
  {
    "author": "Stefanie Powers",
    "category": "friendship",
    "id": 25609,
    "text": "I don't need to go onto Facebook and pretend to have friends I've never even met. To my mind, that kind of destroys the meaning of the word 'friend.' I take exception to that. Because I value and respect friendship."
  },
  {
    "author": "Aristotle",
    "category": "friendship",
    "id": 25227,
    "text": "A friend to all is a friend to none."
  },
  {
    "author": "Dave Blood",
    "category": "friendship",
    "id": 25562,
    "text": "We became friends as we became a band. Our friendship evolved as the band evolved. It had its ups and downs, but it was mostly ups for the four of us. We got along well almost all of the time. Hey! We liked each other and we still do."
  },
  {
    "author": "William Penn",
    "category": "friendship",
    "id": 25226,
    "text": "A true friend freely, advises justly, assists readily, adventures boldly, takes all patiently, defends courageously, and continues a friend unchangeably."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "friendship",
    "id": 25266,
    "text": "Love is blind friendship closes its eyes."
  },
  {
    "author": "Robin Morgan",
    "category": "friendship",
    "id": 25509,
    "text": "Friendship is mutual blackmail elevated to the level of love."
  },
  {
    "author": "Enrique Iglesias",
    "category": "friendship",
    "id": 25488,
    "text": "My inspiration are the woman, friendship, and loneliness."
  },
  {
    "author": "Emily Bronte",
    "category": "friendship",
    "id": 25487,
    "text": "Love is like the wild rose-briar Friendship like the holly-tree. The holly is dark when the rose-briar blooms, but which will bloom most constantly?"
  },
  {
    "author": "Albert Camus",
    "category": "friendship",
    "id": 25377,
    "text": "How can sincerity be a condition of friendship? A taste for truth at any cost is a passion which spares nothing."
  },
  {
    "author": "Thomas Moore",
    "category": "friendship",
    "id": 25356,
    "text": "A friendship that like love is warm A love like friendship, steady."
  },
  {
    "author": "Henri Nouwen",
    "category": "friendship",
    "id": 25210,
    "text": "When we honestly ask ourselves which person in our lives means the most to us, we often find that it is those who, instead of giving advice, solutions, or cures, have chosen rather to share our pain and touch our wounds with a warm and tender hand."
  },
  {
    "author": "George Herbert",
    "category": "friendship",
    "id": 25485,
    "text": "Read as you taste fruit or savor wine, or enjoy friendship, love or life."
  },
  {
    "author": "Edward Gibbon",
    "category": "friendship",
    "id": 25448,
    "text": "I understand by this passion the union of desire, friendship, and tenderness, which is inflamed by a single female, which prefers her to the rest of her sex, and which seeks her possession as the supreme or the sole happiness of our being."
  },
  {
    "author": "Charles Peguy",
    "category": "friendship",
    "id": 25489,
    "text": "Love is rarer than genius itself. And friendship is rarer than love."
  },
  {
    "author": "Robert Hall",
    "category": "friendship",
    "id": 25212,
    "text": "A friend should be one in whose understanding and virtue we can equally confide, and whose opinion we can value at once for its justness and its sincerity."
  },
  {
    "author": "Jean de la Bruyere",
    "category": "friendship",
    "id": 25481,
    "text": "Time makes friendship stronger, but love weaker."
  },
  {
    "author": "John Evelyn",
    "category": "friendship",
    "id": 25519,
    "text": "Friendship is the golden thread that ties the heart of all the world."
  },
  {
    "author": "Aristotle",
    "category": "friendship",
    "id": 25242,
    "text": "My best friend is the man who in wishing me well wishes it for my sake."
  },
  {
    "author": "Clifton Paul Fadiman",
    "category": "friendship",
    "id": 25500,
    "text": "One measure of friendship consists not in the number of things friends can discuss, but in the number of things they need no longer mention."
  },
  {
    "author": "Barack Obama",
    "category": "friendship",
    "id": 25307,
    "text": "To avoid being mistaken for a sellout, I chose my friends carefully. The more politically active black students. The foreign students. The Chicanos. The Marxist professors and structural feminists and punk-rock performance poets."
  },
  {
    "author": "Oscar Wilde",
    "category": "friendship",
    "id": 25223,
    "text": "True friends stab you in the front."
  },
  {
    "author": "Ali A. Saleh",
    "category": "friendship",
    "id": 25614,
    "text": "French Yemeni relations are strong and good, they are relations depending on friendship and cooperation my relationship with the president Chiraq are old and real."
  },
  {
    "author": "John Frusciante",
    "category": "friendship",
    "id": 25557,
    "text": "For me my friendship with Omar Rodriguez from Mars Volta that friendship really means a lot to me because he's another creative person who works as hard as I do."
  },
  {
    "author": "Gotthold Ephraim Lessing",
    "category": "friendship",
    "id": 25533,
    "text": "The most deadly fruit is borne by the hatred which one grafts on an extinguished friendship."
  }
]

quotes['funny'] = [
  {
    "author": "Harold Ramis",
    "category": "funny",
    "id": 26518,
    "text": "Acting is all about big hair and funny props... All the great actors knew it. Olivier knew it, Brando knew it."
  },
  {
    "author": "Craig Ferguson",
    "category": "funny",
    "id": 26233,
    "text": "I don't know now if I'm funny. I just keep talking and hope that I hit something that's funny."
  },
  {
    "author": "Michel Hazanavicius",
    "category": "funny",
    "id": 26538,
    "text": "I watched a lot of silent directors who were absolutely great like John Ford and Fritz Lang, Tod Browning, and also some very modern directors like The Coen Brothers. The directors take the freedom within their own movies to be melodramatic or funny when they chose to be. They do whatever they want and they don't care about the genre."
  },
  {
    "author": "Gabrielle Reece",
    "category": "funny",
    "id": 26557,
    "text": "Funny, how moms can tell you what to do no matter how old or big you are."
  },
  {
    "author": "Leighton Meester",
    "category": "funny",
    "id": 26160,
    "text": "In this world, everyone wants to know everything about you, and I think that's funny."
  },
  {
    "author": "Demetri Martin",
    "category": "funny",
    "id": 25836,
    "text": "If you can't tell a spoon from a ladle, then you're fat!"
  },
  {
    "author": "Marlon Wayans",
    "category": "funny",
    "id": 26498,
    "text": "I don't think of myself as a comedian, but as an artist, a scientist and chemist who just happens to be funny. I started doing stand-up to add another level to my game. I feel that I'm a young rookie with a veteran's skill."
  },
  {
    "author": "Emo Philips",
    "category": "funny",
    "id": 25816,
    "text": "I was the kid next door's imaginary friend."
  },
  {
    "author": "Jordin Sparks",
    "category": "funny",
    "id": 26212,
    "text": "Sometimes I feel like there are people just waiting for me to fall. The funny thing is, I can't give them anything. I have just never been a partier, even in school."
  },
  {
    "author": "Scarlett Johansson",
    "category": "funny",
    "id": 26384,
    "text": "It's a required part of your film history to know who Woody is. His movies are so wonderful, and not just funny but so insightful about human behavior."
  },
  {
    "author": "Nigella Lawson",
    "category": "funny",
    "id": 26335,
    "text": "Also, in a funny way, if you have been happily married there are no unresolved areas, nothing to prove to yourself after the other dies."
  },
  {
    "author": "Woody Allen",
    "category": "funny",
    "id": 25812,
    "text": "I failed to make the chess team because of my height."
  },
  {
    "author": "Idina Menzel",
    "category": "funny",
    "id": 26502,
    "text": "I would love to play 'Funny Girl' or 'Evita,' but I idolize the women who have played those parts. I don't know if there needs to be another version of those shows."
  },
  {
    "author": "Zach Galifianakis",
    "category": "funny",
    "id": 26561,
    "text": "We all know how funny Morrissey is. Actually, you know what? I say that sarcastically. His songs are some of the funniest songs I've ever heard in my life. I mean, really. I mean, not that the 'Girlfriend in a Coma' is, like, really funny."
  },
  {
    "author": "Liam Neeson",
    "category": "funny",
    "id": 26062,
    "text": "It's funny, but you get to a time in your life when you think you have all the friends you will ever have."
  },
  {
    "author": "Francesca Annis",
    "category": "funny",
    "id": 26074,
    "text": "The funny thing is I'm not bothered or sad about being on my own - after all I've never had a husband."
  },
  {
    "author": "Bryan Cranston",
    "category": "funny",
    "id": 26139,
    "text": "It's funny, I do try to maintain health. I started doing Bikram yoga which is that hothouse yoga, the 105 degrees yoga for 90 minutes. It's great, you purge out all the sweat and you're drinking water."
  },
  {
    "author": "Leslie Fiedler",
    "category": "funny",
    "id": 26085,
    "text": "Hemingway seems to be in a funny position. People nowadays can't identify with him closely as a member of their own generation, and he isn't yet historical."
  },
  {
    "author": "Michael Morpurgo",
    "category": "funny",
    "id": 26380,
    "text": "Animals are sentient, intelligent, perceptive, funny and entertaining. We owe them a duty of care as we do to children."
  },
  {
    "author": "Bette Davis",
    "category": "funny",
    "id": 25811,
    "text": "I'd luv to kiss ya, but I just washed my hair."
  },
  {
    "author": "Steve Jobs",
    "category": "funny",
    "id": 25941,
    "text": "Design is a funny word. Some people think design means how it looks. But of course, if you dig deeper, it's really how it works."
  },
  {
    "author": "W. Clement Stone",
    "category": "funny",
    "id": 25773,
    "text": "What contemptible scoundrel has stolen the cork to my lunch?"
  },
  {
    "author": "George Burns",
    "category": "funny",
    "id": 25850,
    "text": "If you live to be one hundred, you've got it made. Very few people die past that age."
  },
  {
    "author": "Uma Thurman",
    "category": "funny",
    "id": 26511,
    "text": "I was not particularly bright, I wasn't very athletic, I was a little too tall, odd, funny looking, I was just really weird as a kid."
  },
  {
    "author": "Reese Witherspoon",
    "category": "funny",
    "id": 26509,
    "text": "It's funny that it all becomes about clothes. It's bizarre. You work your butt off and then you win an award and it's all about your dress. You can't get away from it."
  },
  {
    "author": "Robert Orben",
    "category": "funny",
    "id": 25810,
    "text": "Never raise your hand to your children - it leaves your midsection unprotected."
  },
  {
    "author": "Paul Lynde",
    "category": "funny",
    "id": 26347,
    "text": "Politicians... talk in generalities and lies, and I think they've caused all our grief. They're so awful, they're really funny. I hate thinking this because my dad loved politics."
  },
  {
    "author": "Busy Philipps",
    "category": "funny",
    "id": 26490,
    "text": "I actually feel like, for a lot of my career, I wasn't able to show my comedic range. I did a lot of dramas and dramedies. I was on 'E.R.' That's not generally thought of as a funny show."
  },
  {
    "author": "Charlie Kaufman",
    "category": "funny",
    "id": 26184,
    "text": "As a writer, or as a filmmaker, you have to present yourself, and part of what yourself is is what you're interested in, or what you think is funny, or what you think is sad, or what you think is horrible."
  },
  {
    "author": "Jeff Ross",
    "category": "funny",
    "id": 26629,
    "text": "I've actually tried to roast somebody that I don't like, and it doesn't go well. Either they're a bad sport or I'm not as funny as I could be."
  },
  {
    "author": "Elayne Boosler",
    "category": "funny",
    "id": 25657,
    "text": "I have six locks on my door all in a row. When I go out, I lock every other one. I figure no matter how long somebody stands there picking the locks, they are always locking three."
  },
  {
    "author": "Chevy Chase",
    "category": "funny",
    "id": 25926,
    "text": "Parrots make great pets. They have more personality than goldfish."
  },
  {
    "author": "Tippi Hedren",
    "category": "funny",
    "id": 26326,
    "text": "Hitchcock had a charm about him. He was very funny at times. He was incredibly brilliant in his field of suspense."
  },
  {
    "author": "Mike Myers",
    "category": "funny",
    "id": 25866,
    "text": "My theory is that all of Scottish cuisine is based on a dare."
  },
  {
    "author": "Wallace Shawn",
    "category": "funny",
    "id": 26372,
    "text": "I don't happen to have a sense of humor personally, so I don't know what's funny about a character... This happens to be a feature of my life generally."
  },
  {
    "author": "Trey Parker",
    "category": "funny",
    "id": 26236,
    "text": "No, writing musicals is the hardest thing in the world. And it was really funny, because I remember when the South Park movie came out, there were some critics that said, 'Well it's obvious that in order to get it to be 90 minutes they filled some time with music.'"
  },
  {
    "author": "Rufus Sewell",
    "category": "funny",
    "id": 26546,
    "text": "Billy is a funny, cheeky, lovely boy and I love being with him. Parenthood is terrifying though. I can barely walk past a building without panicking that it's going to collapse on his head."
  },
  {
    "author": "Lalu Prasad Yadav",
    "category": "funny",
    "id": 25985,
    "text": "I know some people say I can be funny. But there is always a deeper meaning to what I say. I am a socialist at heart and have the interests of the poor in mind. When people see how I manage to work my way out of tough situations, it gives them hope in their own life."
  },
  {
    "author": "Dr. Seuss",
    "category": "funny",
    "id": 25938,
    "text": "From there to here, and here to there, funny things are everywhere."
  },
  {
    "author": "Jimmy Fallon",
    "category": "funny",
    "id": 26241,
    "text": "I'm on so late I'm definitely the last seconds of anyone's attention. So I just want to give them something dumb to laugh at, so they go, 'That's funny,' then fall asleep."
  },
  {
    "author": "Steven Wright",
    "category": "funny",
    "id": 25662,
    "text": "A lot of people are afraid of heights. Not me, I'm afraid of widths."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "funny",
    "id": 25980,
    "text": "As I get older, all sorts of things become less funny. Once one has children, any cruelty involving children becomes far less amusing than when one was at the mercy of one's friends' and relatives' children."
  },
  {
    "author": "Mark Ruffalo",
    "category": "funny",
    "id": 26409,
    "text": "People say funny things all the time during really serious moments in life."
  },
  {
    "author": "Rick Baker",
    "category": "funny",
    "id": 26579,
    "text": "It's funny: I've been very successful and done a lot of films, and I don't really have an agent - I don't really pursue jobs, I let people come to me."
  },
  {
    "author": "Shaquille O'Neal",
    "category": "funny",
    "id": 26201,
    "text": "I'm an unorthodox type of guy, a funny guy - at least I think I'm funny. And one of the things I like to do is come up with nicknames for myself."
  },
  {
    "author": "Steve Martin",
    "category": "funny",
    "id": 25989,
    "text": "Chaos in the midst of chaos isn't funny, but chaos in the midst of order is."
  },
  {
    "author": "Olivia Munn",
    "category": "funny",
    "id": 26529,
    "text": "I think it's always funny when somebody thinks you're going to do something super sexy and then you don't."
  },
  {
    "author": "Stephen Dorff",
    "category": "funny",
    "id": 26609,
    "text": "I liked getting the best villain award. I thought that was funny."
  },
  {
    "author": "Jerry Seinfeld",
    "category": "funny",
    "id": 25663,
    "text": "A two-year-old is kind of like having a blender, but you don't have a top for it."
  },
  {
    "author": "Fran Drescher",
    "category": "funny",
    "id": 26608,
    "text": "And remember, it's also very funny, because side by side with grief lies joy."
  },
  {
    "author": "Larry David",
    "category": "funny",
    "id": 26043,
    "text": "I think we're all good and bad, but good's not funny. Bad is funny. Suppress the good and let the bad out, and then you can be funny."
  },
  {
    "author": "Mike Judge",
    "category": "funny",
    "id": 26534,
    "text": "Stealing, you'll go far in life. Actually, there is something funny about getting away with it."
  },
  {
    "author": "Gordon Ramsay",
    "category": "funny",
    "id": 26188,
    "text": "I grew up in a funny way."
  },
  {
    "author": "Esther Williams",
    "category": "funny",
    "id": 26512,
    "text": "I think it's so funny when people think they can't control a movie star. They can. We're just women, you know."
  },
  {
    "author": "Joey Lauren Adams",
    "category": "funny",
    "id": 26638,
    "text": "The last person they expected to connect with a screenplay was the comedic, blonde actress with the funny voice."
  },
  {
    "author": "George Burns",
    "category": "funny",
    "id": 25865,
    "text": "I spent a year in that town, one Sunday."
  },
  {
    "author": "Larry David",
    "category": "funny",
    "id": 26037,
    "text": "If you tell the truth about how you're feeling, it becomes funny."
  },
  {
    "author": "Chuck Palahniuk",
    "category": "funny",
    "id": 25969,
    "text": "It's funny how you never think about the women you've had. It's always the ones who get away that you can't forget."
  },
  {
    "author": "David Mitchell",
    "category": "funny",
    "id": 26378,
    "text": "Sometimes, comics will make the observation that it's not jokes that are funny, it's characters that are funny. And isn't that true! That's why I always kill jokes. I'm terrible at them, because I get the joke right, but I can't get the character right, and it just goes down like a lead balloon."
  },
  {
    "author": "Ronald Reagan",
    "category": "funny",
    "id": 25699,
    "text": "Before I refuse to take your questions, I have an opening statement."
  },
  {
    "author": "Alanis Morissette",
    "category": "funny",
    "id": 25829,
    "text": "We'll love you just the way you are if you're perfect."
  },
  {
    "author": "Tobias Wolff",
    "category": "funny",
    "id": 26343,
    "text": "Memory is funny. Once you hit a vein the problem is not how to remember but how to control the flow."
  },
  {
    "author": "Lynda Barry",
    "category": "funny",
    "id": 26243,
    "text": "I listen like mad to any conversation taking place next to me just trying to hear why this is funny. Women's restrooms are especially great. I wash my hands twice waiting for people to come in and start talking."
  },
  {
    "author": "Rainn Wilson",
    "category": "funny",
    "id": 26279,
    "text": "I think we're the only jokeless show on television. I mean really, we have no setups and no punch lines. It's not a joke show. There are funny lines and funny moments but again the comedy is born of the human experience and awkward pauses are a great part of what it is to be human."
  },
  {
    "author": "Anna Torv",
    "category": "funny",
    "id": 26407,
    "text": "Everybody's funny if you love them."
  },
  {
    "author": "Charlie Sheen",
    "category": "funny",
    "id": 25945,
    "text": "But you can't focus on things that matter if all you've been is asleep for forty years. Funny how sleep rhymes with sheep. You know."
  },
  {
    "author": "Mercedes McCambridge",
    "category": "funny",
    "id": 25931,
    "text": "I'd never been in play long enough for the flowers to die in the dressing room."
  },
  {
    "author": "Roland Joffe",
    "category": "funny",
    "id": 26476,
    "text": "I'm not a very serious person. You know how they say that clowns are very funny in public and are really sad at home? I'm really kind of stupid at home and more serious in public."
  },
  {
    "author": "Courteney Cox",
    "category": "funny",
    "id": 26247,
    "text": "When I was a kid I didn't feel like I fit in because - this is really silly and I probably shouldn't say it, but, I didn't think anything was funny. So I used to go home and literally cry to my mom and my step-dad at the time and I didn't think anything was funny. I couldn't laugh."
  },
  {
    "author": "David Sedaris",
    "category": "funny",
    "id": 26175,
    "text": "I love things made out of animals. It's just so funny to think of someone saying, 'I need a letter opener. I guess I'll have to kill a deer."
  },
  {
    "author": "Bill Maher",
    "category": "funny",
    "id": 25803,
    "text": "Everything that used to be a sin is now a disease."
  },
  {
    "author": "Tommy Chong",
    "category": "funny",
    "id": 26148,
    "text": "The funny thing is, Dennis Miller got me back into comedy."
  },
  {
    "author": "Don Rickles",
    "category": "funny",
    "id": 26385,
    "text": "I have no idea what I'm going to say when I stand up to give a toast. But I do know that anything I say I find funny."
  },
  {
    "author": "Michael Bergin",
    "category": "funny",
    "id": 26555,
    "text": "I wasn't even 20 at the time, but it taught me something about drugs. They can take a good man, a warm, funny, loving family man, and turn him into a loser and worse."
  },
  {
    "author": "Jackie Mason",
    "category": "funny",
    "id": 26307,
    "text": "I don't believe that anybody has come to a conclusion on why something is funny. It's funny because it's ridiculous and it's ridiculous for different reasons at different times."
  },
  {
    "author": "Lea Michele",
    "category": "funny",
    "id": 26255,
    "text": "I want to be in 'Funny Girl.' And I want Ryan Murphy to direct it."
  },
  {
    "author": "George Orwell",
    "category": "funny",
    "id": 25967,
    "text": "Whatever is funny is subversive, every joke is ultimately a custard pie... a dirty joke is a sort of mental rebellion."
  },
  {
    "author": "Charisma Carpenter",
    "category": "funny",
    "id": 26611,
    "text": "This is funny because I just had a job over the summer for VH1, a project I did called Strange Frequency where I got to play a Goth rock band singer."
  },
  {
    "author": "Mark Twain",
    "category": "funny",
    "id": 25652,
    "text": "Get your facts first, then you can distort them as you please."
  },
  {
    "author": "Anthony Holden",
    "category": "funny",
    "id": 26507,
    "text": "What was funny if you were there is that we were all immensely sophisticated people who knew exactly what she was going to say and we're chatting away, nice to see you."
  },
  {
    "author": "Bill Cosby",
    "category": "funny",
    "id": 25729,
    "text": "Fatherhood is pretending the present you love most is soap-on-a-rope."
  },
  {
    "author": "Will Rogers",
    "category": "funny",
    "id": 25758,
    "text": "I never expected to see the day when girls would get sunburned in the places they now do."
  },
  {
    "author": "Fred Allen",
    "category": "funny",
    "id": 25845,
    "text": "The first time I sang in the church choir two hundred people changed their religion."
  },
  {
    "author": "Richard Russo",
    "category": "funny",
    "id": 26336,
    "text": "People often ask me how I make things funny. I don't make things funny."
  },
  {
    "author": "Tina Yothers",
    "category": "funny",
    "id": 26521,
    "text": "They did that little thing on South Park, and they mentioned my name and had a character of me judging a Halloween contest. It was really funny.That made me the coolest aunt on earth."
  },
  {
    "author": "Conan O'Brien",
    "category": "funny",
    "id": 26051,
    "text": "The nightmare is you spend the rest of your life being funny at parties and then people say, 'Why didn't you do that when you were on television?'"
  },
  {
    "author": "Kristen Stewart",
    "category": "funny",
    "id": 26097,
    "text": "It's a funny thing: You want so badly for people to see what you do - you're proud of it - and I like the effect that movies have on people. But the attention can also make me uncomfortable."
  },
  {
    "author": "Vera Farmiga",
    "category": "funny",
    "id": 26204,
    "text": "I don't have a caustic sense of humor. What I find funny, that humor comes from a much gentler place."
  },
  {
    "author": "Zac Efron",
    "category": "funny",
    "id": 26029,
    "text": "One time I went into a restroom and a girl followed me in. I signed an autograph for her in the sink. It was pretty funny because she was in a guy's restroom and she wasn't embarrassed at all."
  },
  {
    "author": "Calvin Trillin",
    "category": "funny",
    "id": 26076,
    "text": "I actually think of being funny as an odd turn of mind, like a mild disability, some weird way of looking at the world that you can't get rid of."
  },
  {
    "author": "Albert Einstein",
    "category": "funny",
    "id": 25659,
    "text": "If the facts don't fit the theory, change the facts."
  },
  {
    "author": "Kevin James",
    "category": "funny",
    "id": 26338,
    "text": "For some reason and I don't know why, but I don't think that I'm funny in California. So I always want to do my movies east somewhere."
  },
  {
    "author": "Jean Baudrillard",
    "category": "funny",
    "id": 25981,
    "text": "There is nothing funny about Halloween. This sarcastic festival reflects, rather, an infernal demand for revenge by children on the adult world."
  },
  {
    "author": "Joe Jonas",
    "category": "funny",
    "id": 26567,
    "text": "I'm a big fan of certain new acts. I love any genre of music, and I think it's really great to see that there are new artists coming through. It's kinda funny to think that I'm like the old man on campus now. But I'm really happy for groups like One Direction. I think they're really good guys."
  },
  {
    "author": "Hedy Lamarr",
    "category": "funny",
    "id": 25660,
    "text": "Any girl can be glamorous. All you have to do is stand still and look stupid."
  },
  {
    "author": "Christopher Walken",
    "category": "funny",
    "id": 26104,
    "text": "Some people can do things and get away with it. Comics are famously like that. Why is it that some guys can say the most horrible things and it's not offensive, it's funny?"
  },
  {
    "author": "Bob Hope",
    "category": "funny",
    "id": 25757,
    "text": "I love to go to Washington - if only to be near my money."
  },
  {
    "author": "Les Dawson",
    "category": "funny",
    "id": 25869,
    "text": "I used to sell furniture for a living. The trouble was, it was my own."
  },
  {
    "author": "Angie Dickinson",
    "category": "funny",
    "id": 25920,
    "text": "My mother was against me being an actress - until I introduced her to Frank Sinatra."
  },
  {
    "author": "Tori Spelling",
    "category": "funny",
    "id": 26256,
    "text": "It would be pretty funny to see a Beverly Hills white girl with mad rap skills."
  }
]

quotes['future'] = [
  {
    "author": "Lewis Thomas",
    "category": "future",
    "id": 27276,
    "text": "At this early stage in our evolution, now through our infancy and into our childhood and then, with luck, our growing up, what our species needs most of all, right now, is simply a future."
  },
  {
    "author": "James Wolcott",
    "category": "future",
    "id": 27208,
    "text": "As we divest ourselves of once familiar physical objects - digitize and dematerialize - we approach a 'Star Trek' future in which everything can be accessed from the fourth dimension with a few clicks or terse audibles."
  },
  {
    "author": "Bob Marley",
    "category": "future",
    "id": 26651,
    "text": "In this bright future you can't forget your past."
  },
  {
    "author": "David Suzuki",
    "category": "future",
    "id": 27158,
    "text": "We must reinvent a future free of blinders so that we can choose from real options."
  },
  {
    "author": "Ambrose Bierce",
    "category": "future",
    "id": 26745,
    "text": "Future. That period of time in which our affairs prosper, our friends are true and our happiness is assured."
  },
  {
    "author": "J. G. Ballard",
    "category": "future",
    "id": 27320,
    "text": "I came to live in Shepperton in 1960. I thought: the future isn't in the metropolitan areas of London. I want to go out to the new suburbs, near the film studios. This was the England I wanted to write about, because this was the new world that was emerging."
  },
  {
    "author": "Newt Gingrich",
    "category": "future",
    "id": 27044,
    "text": "My theme is going to be: Together we can win the future. The right policies lead to the right results. And I'm going to argue that President Obama will lose the future because the wrong policies lead to the wrong results."
  },
  {
    "author": "Ridley Scott",
    "category": "future",
    "id": 27402,
    "text": "Blade Runner appears regularly, two or three times a year in various shapes and forms of science fiction. It set the pace for what is essentially urban science fiction, urban future and it's why I've never re-visited that area because I feel I've done it."
  },
  {
    "author": "Orhan Pamuk",
    "category": "future",
    "id": 27423,
    "text": "I see Turkey's future as being in Europe, as one of many prosperous, tolerant, democratic countries."
  },
  {
    "author": "Fidel Castro",
    "category": "future",
    "id": 26883,
    "text": "A revolution is a struggle to the death between the future and the past."
  },
  {
    "author": "Hannah Arendt",
    "category": "future",
    "id": 27118,
    "text": "Promises are the uniquely human way of ordering the future, making it predictable and reliable to the extent that this is humanly possible."
  },
  {
    "author": "Evelyn Glennie",
    "category": "future",
    "id": 27449,
    "text": "And as I grew older, I then auditioned for the Royal Academy of Music in London, and they said, well, no, we won't accept you, because we haven't a clue - you know - of the future of a so-called 'deaf' musician. And I just couldn't quite accept that."
  },
  {
    "author": "Emile M. Cioran",
    "category": "future",
    "id": 27062,
    "text": "To act is to anchor in an imminent future, so imminent it becomes almost tangible to act is to feel you are consubstantial with that future."
  },
  {
    "author": "Hans Kung",
    "category": "future",
    "id": 27631,
    "text": "All historical experience demonstrates the following: Our earth cannot be changed unless in the not too distant future an alteration in the consciousness of individuals is achieved."
  },
  {
    "author": "Edmund Burke",
    "category": "future",
    "id": 26785,
    "text": "You can never plan the future by the past."
  },
  {
    "author": "Fareed Zakaria",
    "category": "future",
    "id": 27346,
    "text": "Having your fiscal house in order and having a more manageable macro-economic future is going to be very useful in creating growth."
  },
  {
    "author": "Dave Navarro",
    "category": "future",
    "id": 27612,
    "text": "There have been times when I felt suicidal and I would stop my head from going in that direction of negativity because I thought there'd be something I'd miss that was funny in the future. If there's a chance I'm going to laugh tomorrow then want to live to experience that."
  },
  {
    "author": "James Thurber",
    "category": "future",
    "id": 27024,
    "text": "The past is an old armchair in the attic, the present an ominous ticking sound, and the future is anybody's guess."
  },
  {
    "author": "Abraham Lincoln",
    "category": "future",
    "id": 26741,
    "text": "The best thing about the future is that it comes one day at a time."
  },
  {
    "author": "Jean Rostand",
    "category": "future",
    "id": 27271,
    "text": "There are certain moments when we might wish the future were built by men of the past."
  },
  {
    "author": "Azar Nafisi",
    "category": "future",
    "id": 27576,
    "text": "You need imagination in order to imagine a future that doesn't exist."
  },
  {
    "author": "Euripides",
    "category": "future",
    "id": 26893,
    "text": "Whoso neglects learning in his youth, loses the past and is dead for the future."
  },
  {
    "author": "Martin Sheen",
    "category": "future",
    "id": 27445,
    "text": "Future generations are not going to ask us what political party were you in. They are going to ask what did you do about it, when you knew the glaciers were melting."
  },
  {
    "author": "George Burns",
    "category": "future",
    "id": 26705,
    "text": "I look to the future because that's where I'm going to spend the rest of my life."
  },
  {
    "author": "Mark Kennedy",
    "category": "future",
    "id": 27581,
    "text": "This enemy of peace in the world today is unlike any we have seen in the past, and our military is learning from, and building on, previous successes while carrying peace and freedom into the future."
  },
  {
    "author": "Charlie Dent",
    "category": "future",
    "id": 27088,
    "text": "We in the United States should be all the more thankful for the freedom and religious tolerance we enjoy. And we should always remember the lessons learned from the Holocaust, in hopes we stay vigilant against such inhumanity now and in the future."
  },
  {
    "author": "Courteney Cox",
    "category": "future",
    "id": 27352,
    "text": "I'm a big laser believer - I really think they are the wave of the future."
  },
  {
    "author": "Jo Nesbo",
    "category": "future",
    "id": 27548,
    "text": "I've been watching more American TV because of all the great TV series that have come out in the last five to 10 years. I'm a 'Sopranos' fan, I'm a 'Wire' fan, I'm a 'Mad Men' fan. I'm a 'Deadwood' fan. It makes me optimistic for the future of storytelling on TV that producers are willing to take that kind of jump."
  },
  {
    "author": "Eric Ries",
    "category": "future",
    "id": 27595,
    "text": "Customers don't know what they want. There's plenty of good psychology research that shows that people are not able to accurately predict how they would behave in the future. So asking them, 'Would you buy my product if it had these three features?' or 'How would you react if we changed our product this way?' is a waste of time. They don't know."
  },
  {
    "author": "Victor Hugo",
    "category": "future",
    "id": 26850,
    "text": "What is history? An echo of the past in the future a reflex from the future on the past."
  },
  {
    "author": "Ian Mcewan",
    "category": "future",
    "id": 27433,
    "text": "By concentrating on what is good in people, by appealing to their idealism and their sense of justice, and by asking them to put their faith in the future, socialists put themselves at a severe disadvantage."
  },
  {
    "author": "Adam Carolla",
    "category": "future",
    "id": 27283,
    "text": "I could definitely see myself making a serious movie or a drama in the future."
  },
  {
    "author": "John Podhoretz",
    "category": "future",
    "id": 27135,
    "text": "While negativity is politically useful, it is also demoralizing unless it is accompanied - and to some extent overshadowed - by elevated and inspiring ideas about the American future."
  },
  {
    "author": "Katherine Harris",
    "category": "future",
    "id": 27464,
    "text": "As long as I do a good job, I believe the future is going to take care of itself, but actually I like very much being in elected office and there is no consideration about doing anything different until I can be assured that we are going to have the best voting systems in the country."
  },
  {
    "author": "Fred Durst",
    "category": "future",
    "id": 27248,
    "text": "I stopped predicting the future a long time ago."
  },
  {
    "author": "William James",
    "category": "future",
    "id": 26679,
    "text": "If you believe that feeling bad or worrying long enough will change a past or future event, then you are residing on another planet with a different reality system."
  },
  {
    "author": "Mike Murdock",
    "category": "future",
    "id": 26708,
    "text": "The secret of your future is hidden in your daily routine."
  },
  {
    "author": "Michelangelo Antonioni",
    "category": "future",
    "id": 27169,
    "text": "I am neither a sociologist nor a politician. All I can do is imagine for myself what the future will be like."
  },
  {
    "author": "Giacomo Casanova",
    "category": "future",
    "id": 27211,
    "text": "For my future I have no concern, and as a true philosopher, I never would have any, for I know not what it may be: as a Christian, on the other hand, faith must believe without discussion, and the stronger it is, the more it keeps silent."
  },
  {
    "author": "Gianni Versace",
    "category": "future",
    "id": 27430,
    "text": "I am not interested in the past, except as the road to the future."
  },
  {
    "author": "Gustave Flaubert",
    "category": "future",
    "id": 27006,
    "text": "The future is the worst thing about the present."
  },
  {
    "author": "Tim Berners-Lee",
    "category": "future",
    "id": 27514,
    "text": "The Web as I envisaged it, we have not seen it yet. The future is still so much bigger than the past."
  },
  {
    "author": "Jack Welch",
    "category": "future",
    "id": 27104,
    "text": "If GE's strategy of investment in China is wrong, it represents a loss of a billion dollars, perhaps a couple of billion dollars. If it is right, it is the future of this company for the next century."
  },
  {
    "author": "Marco Rubio",
    "category": "future",
    "id": 26996,
    "text": "Under Barack Obama, the only 'Change' is that 'Hope' has been hard to find. Now millions of Americans are insecure about their future. But instead of inspiring us by reminding us of what makes us special, he divides us against each other. He tells Americans they're worse off because others are better off. That people got rich by making others poor."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "future",
    "id": 26768,
    "text": "With the past, I have nothing to do nor with the future. I live now."
  },
  {
    "author": "Erwin Rommel",
    "category": "future",
    "id": 27214,
    "text": "The future battle on the ground will be preceded by battle in the air. This will determine which of the contestants has to suffer operational and tactical disadvantages and be forced throughout the battle into adoption compromise solutions."
  },
  {
    "author": "Jane Fonda",
    "category": "future",
    "id": 27302,
    "text": "It's about time we make the well-being of our young people more important than ideology and politics. As a country, we benefit from investing in their future by investing in teen pregnancy prevention."
  },
  {
    "author": "J. Robert Oppenheimer",
    "category": "future",
    "id": 26986,
    "text": "The atomic bomb made the prospect of future war unendurable. It has led us up those last few steps to the mountain pass and beyond there is a different country."
  },
  {
    "author": "Lee Trevino",
    "category": "future",
    "id": 27408,
    "text": "When you're poor, you know nothing about the future, you know nothing about the world, nothing that goes on outside 300 yards around you."
  },
  {
    "author": "Jonathan Sacks",
    "category": "future",
    "id": 27256,
    "text": "In an ecology of love, people can relate in trust and face the future without fear. They do not need to play it safe. They can take uncertainty in their stride."
  },
  {
    "author": "William J. Clinton",
    "category": "future",
    "id": 26895,
    "text": "Democrats think the country works better with a strong middle class, real opportunities for poor people to work their way into it and a relentless focus on the future, with business and government working together to promote growth and broadly shared prosperity. We think 'we're all in this together' is a better philosophy than 'you're on your own.'"
  },
  {
    "author": "Scott Walker",
    "category": "future",
    "id": 27467,
    "text": "What makes America amazing is that there have always been men and women of courage who were willing to think more about the future of their children and grandchildren than they did about their own political careers."
  },
  {
    "author": "Steven Wright",
    "category": "future",
    "id": 26815,
    "text": "I was a peripheral visionary. I could see the future, but only way off to the side."
  },
  {
    "author": "Simon Cowell",
    "category": "future",
    "id": 27598,
    "text": "Whether they run a record company or a grocery store, every boss will tell you you're in big trouble if you're borrowing more than you can ever afford to pay back. Delaying the pain for future generations is suicidal. We've got to start getting the deficit down right now, not next year."
  },
  {
    "author": "Scott Walker",
    "category": "future",
    "id": 27466,
    "text": "I'd like now and into the future to play a bigger role not only in Wisconsin and the Midwest, but nationally. I'd like to have an impact."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "future",
    "id": 26831,
    "text": "Neither a wise man nor a brave man lies down on the tracks of history to wait for the train of the future to run over him."
  },
  {
    "author": "George Byron",
    "category": "future",
    "id": 27502,
    "text": "I shall soon be six-and-twenty. Is there anything in the future that can possibly console us for not being always twenty-five?"
  },
  {
    "author": "Patti Stanger",
    "category": "future",
    "id": 27354,
    "text": "A ring means a commitment. But more than that, it means that you've talked about your shared future and have decided together on a shared vision of it."
  },
  {
    "author": "David Antin",
    "category": "future",
    "id": 27626,
    "text": "The self is an oral society in which the present is constantly running a dialogue with the past and the future inside of one skin."
  },
  {
    "author": "Margaret Cho",
    "category": "future",
    "id": 27244,
    "text": "Comedy was the key to everything. I grew up fast and controlled my future by bringing it on faster than it naturally unfolded. I cheated myself out of a childhood but then got a running headstart into adulthood that no one else could keep up with."
  },
  {
    "author": "Heath Ledger",
    "category": "future",
    "id": 27250,
    "text": "I don't have that much forward planning about what I want to do next, or in the future."
  },
  {
    "author": "Buffalo Bill",
    "category": "future",
    "id": 27132,
    "text": "Frontiersmen good and bad, gunmen as well as inspired prophets of the future, have been my camp companions. Thus, I know the country of which I am about to write as few men now living have known it."
  },
  {
    "author": "Tom Stoppard",
    "category": "future",
    "id": 26983,
    "text": "I think that the present is worth attention, one shouldn't sacrifice it to future conceptions of, of this future or that future."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "future",
    "id": 26770,
    "text": "All sciences are now under the obligation to prepare the ground for the future task of the philosopher, which is to solve the problem of value, to determine the true hierarchy of values."
  },
  {
    "author": "Lewis Thomas",
    "category": "future",
    "id": 27277,
    "text": "The future is too interesting and dangerous to be entrusted to any predictable, reliable agency. We need all the fallibility we can get. Most of all, we need to preserve the absolute unpredictability and total improbability of our connected minds. That way we can keep open all the options, as we have in the past."
  },
  {
    "author": "Ron Wyden",
    "category": "future",
    "id": 27326,
    "text": "Rather than waiting for future trials to determine rules that will impact every citizen, Congress should step in and write a law that takes every American's rights into consideration."
  },
  {
    "author": "Irving Babbitt",
    "category": "future",
    "id": 27028,
    "text": "A person who has sympathy for mankind in the lump, faith in its future progress, and desire to serve the great cause of this progress, should be called not a humanist, but a humanitarian, and his creed may be designated as humanitarianism."
  },
  {
    "author": "Woodrow Wilson",
    "category": "future",
    "id": 27027,
    "text": "The question of armaments, whether on land or sea, is the most immediately and intensely practical question connected with the future fortunes of nations and of mankind."
  },
  {
    "author": "C. S. Lewis",
    "category": "future",
    "id": 26755,
    "text": "The future is something which everyone reaches at the rate of 60 minutes an hour, whatever he does, whoever he is."
  },
  {
    "author": "Zora Neale Hurston",
    "category": "future",
    "id": 26962,
    "text": "The present was an egg laid by the past that had the future inside its shell."
  },
  {
    "author": "Gregory Bateson",
    "category": "future",
    "id": 27173,
    "text": "We do not know enough about how the present will lead into the future."
  },
  {
    "author": "Nate Silver",
    "category": "future",
    "id": 27269,
    "text": "When you try to predict future E.R.A.'s with past E.R.A.'s, you're making a mistake."
  },
  {
    "author": "Damien Hirst",
    "category": "future",
    "id": 27243,
    "text": "But I think it's more that when you're young, you're invincible, you're immortal - or at least you think you are. The possibilities are limitless, you're inventing the future. Then you get older and suddenly you have a history. It's fixed. You can't change anything. I find that a bit disturbing, to be honest."
  },
  {
    "author": "Jim Bishop",
    "category": "future",
    "id": 27233,
    "text": "It is difficult to live in the present, ridiculous to live in the future and impossible to live in the past. Nothing is as far away as one minute ago."
  },
  {
    "author": "Charles Kettering",
    "category": "future",
    "id": 27124,
    "text": "I object to people running down the future. I am going to live all the rest of my life there."
  },
  {
    "author": "Henry Norris Russell",
    "category": "future",
    "id": 26802,
    "text": "Just what future the Designer of the universe has provided for the souls of men I do not know, I cannot prove. But I find that the whole order of Nature confirms my confidence that, if it is not like our noblest hopes and dreams, it will transcend them."
  },
  {
    "author": "David Mitchell",
    "category": "future",
    "id": 27486,
    "text": "As long as our civilisation keeps trundling along generally forwards, then there is the possibility of a future where ethnicity is merely an interesting badge, not a uniform you can't take off."
  },
  {
    "author": "Mike Royko",
    "category": "future",
    "id": 27432,
    "text": "The subject of criminal rehabilitation was debated recently in City Hall. It's an appropriate place for this kind of discussion because the city has always employed so many ex-cons and future cons."
  },
  {
    "author": "Sun Myung Moon",
    "category": "future",
    "id": 27560,
    "text": "My mission is a cosmic mission. My concern is for all of humanity, and not only this present world, but the world hereafter. My mission penetrates the past, present, and future, and encompasses all humanity."
  },
  {
    "author": "Prince William",
    "category": "future",
    "id": 27288,
    "text": "No one is going to try to fill my mother's shoes, what she did was fantastic. It's about making your own future and your own destiny and Kate will do a very good job of that."
  },
  {
    "author": "Javier Bardem",
    "category": "future",
    "id": 27341,
    "text": "You want to do your job well so that people in the future say, 'OK, he's not bad, let's hire him.'"
  },
  {
    "author": "V. S. Naipaul",
    "category": "future",
    "id": 27219,
    "text": "Africa has no future."
  },
  {
    "author": "Thom Yorke",
    "category": "future",
    "id": 26890,
    "text": "One of the interesting things here is that the people who should be shaping the future are politicians. But the political framework itself is so dead and closed that people look to other sources, like artists, because art and music allow people a certain freedom."
  },
  {
    "author": "Barbara Mandrell",
    "category": "future",
    "id": 27419,
    "text": "I don't know what the future holds, but I know that God holds tomorrow, so it is exciting. Even when I have hard things happen, He loves me so big, so much. I come through it and I grow from it, because He has got me."
  },
  {
    "author": "Thomas Starr King",
    "category": "future",
    "id": 27347,
    "text": "It is strange. I see all the privileges and greatness of the future. It already looks grand, beautiful. Tell them I went lovingly, trustfully, peacefully."
  },
  {
    "author": "Victor Hugo",
    "category": "future",
    "id": 26697,
    "text": "There is nothing like a dream to create the future."
  },
  {
    "author": "Dave Barry",
    "category": "future",
    "id": 26963,
    "text": "The Internet: transforming society and shaping the future through chat."
  },
  {
    "author": "Lewis Thomas",
    "category": "future",
    "id": 27275,
    "text": "Doctors, dressed up in one professional costume or another, have been in busy practice since the earliest records of every culture on earth. It is hard to think of a more dependable or enduring occupation, harder still to imagine any future events leading to its extinction."
  },
  {
    "author": "Jonathan Kozol",
    "category": "future",
    "id": 27260,
    "text": "Instead of seeing these children for the blessings that they are, we are measuring them only by the standard of whether they will be future deficits or assets for our nation's competitive needs."
  },
  {
    "author": "Blanka Vlasic",
    "category": "future",
    "id": 26931,
    "text": "Sometimes your disappointments make you a stronger person for the future."
  },
  {
    "author": "Peter Singer",
    "category": "future",
    "id": 27177,
    "text": "I honestly don't know, but if America continues to refuse to reduce its greenhouse gas emissions, I see a bleak future not only for American society, but for the world as a whole. This is a global problem that is not going away, and the United States is an obstacle to solving it."
  },
  {
    "author": "Plato",
    "category": "future",
    "id": 26791,
    "text": "The direction in which education starts a man will determine his future in life."
  },
  {
    "author": "Peter Ustinov",
    "category": "future",
    "id": 27059,
    "text": "I'm convinced there's a small room in the attic of the Foreign Office where future diplomats are taught to stammer."
  },
  {
    "author": "Christian Lous Lange",
    "category": "future",
    "id": 27591,
    "text": "Propaganda must appeal to mankind's better judgment and to the necessary belief in a better future. For this belief, the valley of the shadow of death is but a war station on the road to the blessed summit."
  },
  {
    "author": "Buddha",
    "category": "future",
    "id": 26733,
    "text": "Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment."
  },
  {
    "author": "Harriet Beecher Stowe",
    "category": "future",
    "id": 26724,
    "text": "The past, the present and the future are really one: they are today."
  },
  {
    "author": "Jean Baudrillard",
    "category": "future",
    "id": 27148,
    "text": "To love someone is to isolate him from the world, wipe out every trace of him, dispossess him of his shadow, drag him into a murderous future. It is to circle around the other like a dead star and absorb him into a black light."
  },
  {
    "author": "Ralph Nader",
    "category": "future",
    "id": 27109,
    "text": "Up against the corporate government, voters find themselves asked to choose between look-alike candidates from two parties vying to see who takes the marching orders from their campaign paymasters and their future employers. The money of vested interest nullifies genuine voter choice and trust."
  },
  {
    "author": "Ellie Goulding",
    "category": "future",
    "id": 27240,
    "text": "I feel like I write songs for the future or something. Not in an arrogant way, but I feel like maybe my songs were, like, before their time or something."
  },
  {
    "author": "Wayne Dyer",
    "category": "future",
    "id": 26654,
    "text": "Stop acting as if life is a rehearsal. Live this day as if it were your last. The past is over and gone. The future is not guaranteed."
  }
]

quotes['gardening'] = [
  {
    "author": "Martha Smith",
    "category": "gardening",
    "id": 27676,
    "text": "I do some of my best thinking while pulling weeds."
  },
  {
    "author": "Oscar de la Renta",
    "category": "gardening",
    "id": 27661,
    "text": "Gardening is how I relax. It's another form of creating and playing with colors."
  },
  {
    "author": "May Sarton",
    "category": "gardening",
    "id": 27657,
    "text": "Everything that slows us down and forces patience, everything that sets us back into the slow circles of nature, is a help. Gardening is an instrument of grace."
  },
  {
    "author": "Douglas Wilson",
    "category": "gardening",
    "id": 27686,
    "text": "Use plants to bring life."
  },
  {
    "author": "Susan Hampshire",
    "category": "gardening",
    "id": 27710,
    "text": "My hobby is gardening, I love it, it's my main hobby. I like being at home and I'm very happy being in my house, I love cooking."
  },
  {
    "author": "Ken Thompson",
    "category": "gardening",
    "id": 27711,
    "text": "I have to keep up with the scientific literature as part of my job, but increasingly I found myself reading things that weren't really relevant to my academic work, but were relevant to gardening."
  },
  {
    "author": "Andrew Weil",
    "category": "gardening",
    "id": 27705,
    "text": "My passion for gardening may strike some as selfish, or merely an act of resignation in the face of overwhelming problems that beset the world. It is neither. I have found that each garden is just what Voltaire proposed in Candide: a microcosm of a just and beautiful society."
  },
  {
    "author": "Stephen Gardiner",
    "category": "gardening",
    "id": 27684,
    "text": "The garden, by design, is concerned with both the interior and the land beyond the garden."
  },
  {
    "author": "Gates McFadden",
    "category": "gardening",
    "id": 27719,
    "text": "I love a lot of things, and I'm pretty much obsessive about most things I do, whether it be gardening, or architecture, or music. I'd be an obsessive hairdresser."
  },
  {
    "author": "David Hobson",
    "category": "gardening",
    "id": 27658,
    "text": "I grow plants for many reasons: to please my eye or to please my soul, to challenge the elements or to challenge my patience, for novelty or for nostalgia, but mostly for the joy in seeing them grow."
  },
  {
    "author": "Emanuel Steward",
    "category": "gardening",
    "id": 27721,
    "text": "My favorite hobby is being alone. I like to be alone. I also like dancing, fishing, playing poker sometimes and vegetable gardening - corn, tomatoes, cucumbers, I have a big garden every year."
  },
  {
    "author": "J. M. Roberts",
    "category": "gardening",
    "id": 27723,
    "text": "Overall, the anarchy was the most creative of all periods of Japanese culture for in it there appeared the greatest landscape painting, the culmination of the skill of landscape gardening and the arts of flower arrangement, and the No drama."
  },
  {
    "author": "William Kent",
    "category": "gardening",
    "id": 27697,
    "text": "Garden as though you will live forever."
  },
  {
    "author": "Marcelene Cox",
    "category": "gardening",
    "id": 27674,
    "text": "Weather means more when you have a garden. There's nothing like listening to a shower and thinking how it is soaking in around your green beans."
  },
  {
    "author": "D. Elton Trueblood",
    "category": "gardening",
    "id": 27659,
    "text": "A man has made at least a start on discovering the meaning of human life when he plants shade trees under which he knows full well he will never sit."
  },
  {
    "author": "Luther Burbank",
    "category": "gardening",
    "id": 27682,
    "text": "The secret of improved plant breeding, apart from scientific knowledge, is love."
  },
  {
    "author": "Adam Ant",
    "category": "gardening",
    "id": 27709,
    "text": "I got a little house in East L.A. and did the gardening. I was doing some acting here and there, doing my own thing... getting back to reality."
  },
  {
    "author": "Roberto Burle Marx",
    "category": "gardening",
    "id": 27664,
    "text": "A garden is a complex of aesthetic and plastic intentions and the plant is, to a landscape artist, not only a plant - rare, unusual, ordinary or doomed to disappearance - but it is also a color, a shape, a volume or an arabesque in itself."
  },
  {
    "author": "William Cowper",
    "category": "gardening",
    "id": 27660,
    "text": "Who loves a garden loves a greenhouse too."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "gardening",
    "id": 27646,
    "text": "It is a golden maxim to cultivate the garden for the nose, and the eyes will take care of themselves."
  },
  {
    "author": "Juliet Mills",
    "category": "gardening",
    "id": 27722,
    "text": "My hobbies are cooking and gardening, especially growing orchids. I love soccer, my husband and I support a British team called Chelsea, and I also enjoy tennis. We have 3 cats."
  },
  {
    "author": "George Eliot",
    "category": "gardening",
    "id": 27653,
    "text": "It will never rain roses: when we want to have more roses we must plant more trees."
  },
  {
    "author": "Margaret Atwood",
    "category": "gardening",
    "id": 27678,
    "text": "Gardening is not a rational act."
  },
  {
    "author": "Alfred Austin",
    "category": "gardening",
    "id": 27666,
    "text": "The glory of gardening: hands in the dirt, head in the sun, heart with nature. To nurture a garden is to feed not just on the body, but the soul."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "gardening",
    "id": 27639,
    "text": "If you have a garden and a library, you have everything you need."
  },
  {
    "author": "Walt Disney",
    "category": "gardening",
    "id": 27645,
    "text": "I don't like formal gardens. I like wild nature. It's just the wilderness instinct in me, I guess."
  },
  {
    "author": "Rudyard Kipling",
    "category": "gardening",
    "id": 27654,
    "text": "Gardens are not made by singing 'Oh, how beautiful,' and sitting in the shade."
  },
  {
    "author": "Luis Barragan",
    "category": "gardening",
    "id": 27700,
    "text": "I don't divide architecture, landscape and gardening to me they are one."
  },
  {
    "author": "Jeremy Northam",
    "category": "gardening",
    "id": 27716,
    "text": "The space and light up there in Norfolk is wonderfully peaceful. I find myself doing funny things like gardening, and cooking, which I rarely do in London."
  },
  {
    "author": "Liberty Hyde Bailey",
    "category": "gardening",
    "id": 27689,
    "text": "A person cannot love a plant after he has pruned it, then he has either done a poor job or is devoid of emotion."
  },
  {
    "author": "Charles Dudley Warner",
    "category": "gardening",
    "id": 27687,
    "text": "What a man needs in gardening is a cast-iron back, with a hinge in it."
  },
  {
    "author": "Michael Pollan",
    "category": "gardening",
    "id": 27685,
    "text": "The garden suggests there might be a place where we can meet nature halfway."
  },
  {
    "author": "Kenneth Robert Livingstone",
    "category": "gardening",
    "id": 27708,
    "text": "I do the gardening."
  },
  {
    "author": "Voltaire",
    "category": "gardening",
    "id": 27644,
    "text": "We must cultivate our own garden. When man was put in the garden of Eden he was put there so that he should work, which proves that man was not born to rest."
  },
  {
    "author": "B. C. Forbes",
    "category": "gardening",
    "id": 27669,
    "text": "It is only the farmer who faithfully plants seeds in the Spring, who reaps a harvest in the Autumn."
  },
  {
    "author": "Gertrude Jekyll",
    "category": "gardening",
    "id": 27656,
    "text": "A garden is a grand teacher. It teaches patience and careful watchfulness it teaches industry and thrift above all it teaches entire trust."
  },
  {
    "author": "Tina Charles",
    "category": "gardening",
    "id": 27724,
    "text": "Rock 'n' Roll, no roses or gardening."
  },
  {
    "author": "Robert Smithson",
    "category": "gardening",
    "id": 27688,
    "text": "When a finished work of 20th century sculpture is placed in an 18th century garden, it is absorbed by the ideal representation of the past, thus reinforcing political and social values that are no longer with us."
  },
  {
    "author": "Alexander Smith",
    "category": "gardening",
    "id": 27675,
    "text": "How deeply seated in the human heart is the liking for gardens and gardening."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "gardening",
    "id": 27640,
    "text": "What is a weed? A plant whose virtues have never been discovered."
  },
  {
    "author": "William Kent",
    "category": "gardening",
    "id": 27673,
    "text": "All gardening is landscape painting."
  },
  {
    "author": "Thomas Moore",
    "category": "gardening",
    "id": 27672,
    "text": "Plants that wake when others sleep. Timid jasmine buds that keep their fragrance to themselves all day, but when the sunlight dies away let the delicious secret out to every breeze that roams about."
  },
  {
    "author": "Les Brown",
    "category": "gardening",
    "id": 27650,
    "text": "Someone's sitting in the shade today because someone planted a tree a long time ago."
  },
  {
    "author": "John Harrison",
    "category": "gardening",
    "id": 27695,
    "text": "If you build up the soil with organic material, the plants will do just fine."
  },
  {
    "author": "George Cadbury",
    "category": "gardening",
    "id": 27670,
    "text": "But if each man could have his own house, a large garden to cultivate and healthy surroundings - then, I thought, there will be for them a better opportunity of a happy family life."
  },
  {
    "author": "Alfred Austin",
    "category": "gardening",
    "id": 27662,
    "text": "Show me your garden and I shall tell you what you are."
  },
  {
    "author": "Steven Cojocaru",
    "category": "gardening",
    "id": 27712,
    "text": "I don't hold that everybody has to love fashion. Some people like gardening."
  },
  {
    "author": "Alfred Austin",
    "category": "gardening",
    "id": 27701,
    "text": "There is no gardening without humility. Nature is constantly sending even its oldest scholars to the bottom of the class for some egregious blunder."
  },
  {
    "author": "Zora Neale Hurston",
    "category": "gardening",
    "id": 27667,
    "text": "Trees and plants always look like the people they live with, somehow."
  },
  {
    "author": "Gary Miller",
    "category": "gardening",
    "id": 27717,
    "text": "Many talk about a guest worker program. I think most reasonable people believe that a guest worker program in the farming industry, perhaps in the gardening and landscape industries, is reasonable."
  },
  {
    "author": "Roy Blount, Jr.",
    "category": "gardening",
    "id": 27718,
    "text": "Somebody informed me recently that the key to every art, from writing to gardening to sculpture, is creativity. I beg to differ."
  },
  {
    "author": "Orison Swett Marden",
    "category": "gardening",
    "id": 27649,
    "text": "It is like the seed put in the soil - the more one sows, the greater the harvest."
  },
  {
    "author": "Caecilius Statius",
    "category": "gardening",
    "id": 27638,
    "text": "He plants trees to benefit another generation."
  },
  {
    "author": "Penelope Keith",
    "category": "gardening",
    "id": 27681,
    "text": "I plant a lot of trees. I am a great believer in planting things for future generations. I loathe the now culture where you just live for today."
  },
  {
    "author": "Sean Bean",
    "category": "gardening",
    "id": 27720,
    "text": "I put quite a few trees in last autumn. A lot of silver birch and a couple of native trees - just generally doing gardening, putting plants in and hedges in. It takes quite a lot of time and I love it."
  },
  {
    "author": "Martin Heidegger",
    "category": "gardening",
    "id": 27671,
    "text": "To dwell is to garden."
  },
  {
    "author": "Clive Anderson",
    "category": "gardening",
    "id": 27714,
    "text": "Gardening has just sort of grown on me. I find it therapeutic. And I like smelly things."
  },
  {
    "author": "May Sarton",
    "category": "gardening",
    "id": 27679,
    "text": "Help us to be ever faithful gardeners of the spirit, who know that without darkness nothing comes to birth, and without light nothing flowers."
  },
  {
    "author": "Thomas Fuller",
    "category": "gardening",
    "id": 27652,
    "text": "A good garden may have some weeds."
  },
  {
    "author": "Simon Baker",
    "category": "gardening",
    "id": 27713,
    "text": "I'm pretty good at gardening. It consumes my time, and it feels like I'm doing something constructive."
  },
  {
    "author": "Carolyn Murphy",
    "category": "gardening",
    "id": 27715,
    "text": "I'm not surfing much anymore, but I love hiking and gardening, and I'm always wearing a hat and sunblock."
  },
  {
    "author": "Andrew Weil",
    "category": "gardening",
    "id": 27706,
    "text": "In the world at large, people are rewarded or punished in ways that are often utterly random. In the garden, cause and effect, labor and reward, are re-coupled. Gardening makes sense in a senseless world. By extension, then, the more gardens in the world, the more justice, the more sense is created."
  },
  {
    "author": "Andrew Weil",
    "category": "gardening",
    "id": 27707,
    "text": "Gardening is not trivial. If you believe that it is, closely examine why you feel that way. You may discover that this attitude has been forced upon you by mass media and the crass culture it creates and maintains. The fact is, gardening is just the opposite - it is, or should be, a central, basic expression of human life."
  },
  {
    "author": "Andrew Weil",
    "category": "gardening",
    "id": 27704,
    "text": "I am a particular fan of integrative exercise - that is, exercise that occurs in the course of doing some productive activity such as gardening, bicycling to work, doing home improvement projects and so on."
  },
  {
    "author": "Liberty Hyde Bailey",
    "category": "gardening",
    "id": 27647,
    "text": "A garden requires patient labor and attention. Plants do not grow merely to satisfy ambitions or to fulfill good intentions. They thrive because someone expended effort on them."
  },
  {
    "author": "Dogen Zenji",
    "category": "gardening",
    "id": 27694,
    "text": "Working with plants, trees, fences and walls, if they practice sincerely they will attain enlightenment."
  },
  {
    "author": "Doug Larson",
    "category": "gardening",
    "id": 27648,
    "text": "A weed is a plant that has mastered every survival skill except for learning how to grow in rows."
  },
  {
    "author": "Roy Rogers",
    "category": "gardening",
    "id": 27668,
    "text": "What's a butterfly garden without butterflies?"
  },
  {
    "author": "Phyllis Theroux",
    "category": "gardening",
    "id": 27680,
    "text": "I think this is what hooks one to gardening: it is the closest one can come to being present at creation."
  },
  {
    "author": "Gertrude Jekyll",
    "category": "gardening",
    "id": 27665,
    "text": "The love of gardening is a seed once sown that never dies."
  },
  {
    "author": "Luther Burbank",
    "category": "gardening",
    "id": 27643,
    "text": "Flowers always make people better, happier, and more helpful they are sunshine, food and medicine for the soul."
  },
  {
    "author": "Michael Fish",
    "category": "gardening",
    "id": 27698,
    "text": "I am sure that if you plant the trees back again, it will do nothing but good."
  },
  {
    "author": "Luis Barragan",
    "category": "gardening",
    "id": 27690,
    "text": "A garden must combine the poetic and he mysterious with a feeling of serenity and joy."
  },
  {
    "author": "Dixie Lee Ray",
    "category": "gardening",
    "id": 27692,
    "text": "Well tended garden is better than a neglected wood lot."
  },
  {
    "author": "Francis Bacon",
    "category": "gardening",
    "id": 27655,
    "text": "God Almighty first planted a garden. And indeed, it is the purest of human pleasures."
  },
  {
    "author": "Carolus Linnaeus",
    "category": "gardening",
    "id": 27693,
    "text": "If a tree dies, plant another in its place."
  },
  {
    "author": "Alice Walker",
    "category": "gardening",
    "id": 27651,
    "text": "In search of my mother's garden, I found my own."
  },
  {
    "author": "George Bernard Shaw",
    "category": "gardening",
    "id": 27642,
    "text": "The best place to find God is in a garden. You can dig for him there."
  },
  {
    "author": "Dorothy Malone",
    "category": "gardening",
    "id": 27696,
    "text": "I loved to get all dusty and ride horses and plant potatoes and cotton."
  },
  {
    "author": "Jean Anouilh",
    "category": "gardening",
    "id": 27683,
    "text": "Some men like to make a little garden out of life and walk down a path."
  },
  {
    "author": "Luther Burbank",
    "category": "gardening",
    "id": 27677,
    "text": "If we had paid no more attention to our plants than we have to our children, we would now be living in a jungle of weed."
  },
  {
    "author": "Eric Morecambe",
    "category": "gardening",
    "id": 27663,
    "text": "My neighbour asked if he could use my lawnmower and I told him of course he could, so long as he didn't take it out of my garden."
  },
  {
    "author": "Elton John",
    "category": "gardening",
    "id": 27702,
    "text": "I loathe gardening, but I love gardens, and I have two beautiful gardens. I can not bear gardening, but I love gardens."
  },
  {
    "author": "H. Jackson Brown, Jr.",
    "category": "gardening",
    "id": 27641,
    "text": "Remember that children, marriages, and flower gardens reflect the kind of care they get."
  },
  {
    "author": "Jane Pauley",
    "category": "gardening",
    "id": 27703,
    "text": "I've come to recognize what I call my 'inside interests.' Telling stories. And helping people tell their stories is a sort of interpersonal gardening. My work at NBC News was to report the news, but in hindsight, I often tried to look for some insight to share that might spark a moment of recognition in a viewer."
  },
  {
    "author": "Suzy Bogguss",
    "category": "gardening",
    "id": 27691,
    "text": "I love decorating my home. I'm a gardener too, so that's usually something I have to play catch up with."
  },
  {
    "author": "Francis Cabot Lowell",
    "category": "gardening",
    "id": 27699,
    "text": "One lifetime is never enough to accomplish one's horticultural goals. If a garden is a site for the imagination, how can we be very far from the beginning?"
  }
]

quotes['god'] = [
  {
    "author": "Beverly Sills",
    "category": "god",
    "id": 28681,
    "text": "My dear brothers, take note of this: Everyone should be quick to listen, slow to speak and slow to become angry, for man's anger does not bring about the righteous life that God desires."
  },
  {
    "author": "Robert Green Ingersoll",
    "category": "god",
    "id": 28568,
    "text": "An honest God is the noblest work of man."
  },
  {
    "author": "Confucius",
    "category": "god",
    "id": 27954,
    "text": "Heaven means to be one with God."
  },
  {
    "author": "Kanye West",
    "category": "god",
    "id": 28629,
    "text": "I am God's vessel. But my greatest pain in life is that I will never be able to see myself perform live."
  },
  {
    "author": "Jesus Christ",
    "category": "god",
    "id": 28475,
    "text": "Every knee will bend before me, and every tongue shall give glory to God."
  },
  {
    "author": "Elisabeth Kubler-Ross",
    "category": "god",
    "id": 28244,
    "text": "Live, so you do not have to look back and say: 'God, how I have wasted my life.'"
  },
  {
    "author": "Lord Byron",
    "category": "god",
    "id": 28569,
    "text": "Out of chaos God made a world, and out of high passions comes a people."
  },
  {
    "author": "Jerry Seinfeld",
    "category": "god",
    "id": 28536,
    "text": "Where lipstick is concerned, the important thing is not color, but to accept God's final word on where your lips end."
  },
  {
    "author": "Dwight L. Moody",
    "category": "god",
    "id": 28211,
    "text": "God never made a promise that was too good to be true."
  },
  {
    "author": "Voltaire",
    "category": "god",
    "id": 28080,
    "text": "If there were no God, it would be necessary to invent him."
  },
  {
    "author": "Billy Sunday",
    "category": "god",
    "id": 28625,
    "text": "God Almighty never intended that the devil should triumph over the Church. He never intended that the saloons should walk rough-shod over Christianity."
  },
  {
    "author": "Anatole France",
    "category": "god",
    "id": 28668,
    "text": "Chance is perhaps the pseudonym of God when he did not want to sign."
  },
  {
    "author": "Saint Teresa of Avila",
    "category": "god",
    "id": 28191,
    "text": "We can only learn to know ourselves and do what we can - namely, surrender our will and fulfill God's will in us."
  },
  {
    "author": "John Lennon",
    "category": "god",
    "id": 27963,
    "text": "And God help Bruce Springsteen when they decide he's no longer God... They'll turn on him, and I hope he survives it."
  },
  {
    "author": "Kanye West",
    "category": "god",
    "id": 28439,
    "text": "They say you can rap about anything except for Jesus, that means guns, sex, lies, video tapes, but if I talk about God my record won't get played Huh?"
  },
  {
    "author": "C. S. Lewis",
    "category": "god",
    "id": 27827,
    "text": "There are two kinds of people: those who say to God, 'Thy will be done,' and those to whom God says, 'All right, then, have it your way.'"
  },
  {
    "author": "Fyodor Dostoevsky",
    "category": "god",
    "id": 28028,
    "text": "Beauty is mysterious as well as terrible. God and devil are fighting there, and the battlefield is the heart of man."
  },
  {
    "author": "William Jennings Bryan",
    "category": "god",
    "id": 28339,
    "text": "The parents have a right to say that no teacher paid by their money shall rob their children of faith in God and send them back to their homes skeptical, or infidels, or agnostics, or atheists."
  },
  {
    "author": "Mohamed Al-Fayed",
    "category": "god",
    "id": 28337,
    "text": "The most important thing is God's blessing and if you believe in God and you believe in yourself, you have nothing to worry about."
  },
  {
    "author": "C. S. Lewis",
    "category": "god",
    "id": 27873,
    "text": "Can a mortal ask questions which God finds unanswerable? Quite easily, I should think. All nonsense questions are unanswerable."
  },
  {
    "author": "Chuck Palahniuk",
    "category": "god",
    "id": 28393,
    "text": "Maybe it's our sins that give God consolation when he finally has to give us cancer."
  },
  {
    "author": "Ziggy Marley",
    "category": "god",
    "id": 28529,
    "text": "God is like the sun. When the sun shines, it shines for everyone. God is for everyone."
  },
  {
    "author": "Saint Teresa of Avila",
    "category": "god",
    "id": 28535,
    "text": "God gave us faculties for our use each of them will receive its proper reward. Then do not let us try to charm them to sleep, but permit them to do their work until divinely called to something higher."
  },
  {
    "author": "Willie Nelson",
    "category": "god",
    "id": 28161,
    "text": "I think people need to be educated to the fact that marijuana is not a drug. Marijuana is an herb and a flower. God put it here. If He put it here and He wants it to grow, what gives the government the right to say that God is wrong?"
  },
  {
    "author": "Anne Lamott",
    "category": "god",
    "id": 28010,
    "text": "You can safely assume that you've created God in your own image when it turns out that God hates all the same people you do."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "god",
    "id": 28317,
    "text": "If I can put one touch of rosy sunset into the life of any man or woman, I shall feel that I have worked with God."
  },
  {
    "author": "Alexander Pope",
    "category": "god",
    "id": 28539,
    "text": "All are but parts of one stupendous whole, Whose body Nature is, and God the soul."
  },
  {
    "author": "Erma Bombeck",
    "category": "god",
    "id": 27802,
    "text": "When I stand before God at the end of my life, I would hope that I would not have a single bit of talent left, and could say, 'I used everything you gave me'."
  },
  {
    "author": "Nick Rahall",
    "category": "god",
    "id": 28685,
    "text": "As a people of faith, we know that prayer is a powerful instrument. And as one Nation under God, we know that many times our most powerful tool is prayer."
  },
  {
    "author": "Marianne Williamson",
    "category": "god",
    "id": 27965,
    "text": "Dear God, Please send to me the spirit of Your peace. Then send, dear Lord, the spirit of peace from me to all the world. Amen."
  },
  {
    "author": "Albert Barnes",
    "category": "god",
    "id": 28553,
    "text": "It does not require great learning to be a Christian and be convinced of the truth of the Bible. It requires only an honest heart and a willingness to obey God."
  },
  {
    "author": "Robert Anton Wilson",
    "category": "god",
    "id": 28371,
    "text": "Every war results from the struggle for markets and spheres of influence, and every war is sold to the public by professional liars and totally sincere religious maniacs, as a Holy Crusade to save God and Goodness from Satan and Evil."
  },
  {
    "author": "Albert Camus",
    "category": "god",
    "id": 28022,
    "text": "We turn toward God only to obtain the impossible."
  },
  {
    "author": "Johannes Tauler",
    "category": "god",
    "id": 27787,
    "text": "God in His wisdom has decided that He will reward no works but His own."
  },
  {
    "author": "Robert Kennedy",
    "category": "god",
    "id": 27989,
    "text": "But suppose God is black? What if we go to Heaven and we, all our lives, have treated the Negro as an inferior, and God is there, and we look up and He is not white? What then is our response?"
  },
  {
    "author": "Kelly Clarkson",
    "category": "god",
    "id": 27849,
    "text": "God will never give you anything you can't handle, so don't stress."
  },
  {
    "author": "Swami Vivekananda",
    "category": "god",
    "id": 27818,
    "text": "You cannot believe in God until you believe in yourself."
  },
  {
    "author": "Augustus Hare",
    "category": "god",
    "id": 28322,
    "text": "Love, it has been said, flows downward. The love of parents for their children has always been far more powerful than that of children for their parents and who among the sons of men ever loved God with a thousandth part of the love which God has manifested to us?"
  },
  {
    "author": "Lauryn Hill",
    "category": "god",
    "id": 28570,
    "text": "Everything we do should be a result of our gratitude for what God has done for us."
  },
  {
    "author": "Khalil Gibran",
    "category": "god",
    "id": 27918,
    "text": "The person you consider ignorant and insignificant is the one who came from God, that he might learn bliss from grief and knowledge from gloom."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "god",
    "id": 27973,
    "text": "There cannot be a God because if there were one, I could not believe that I was not He."
  },
  {
    "author": "Reinhold Niebuhr",
    "category": "god",
    "id": 28109,
    "text": "God, give us grace to accept with serenity the things that cannot be changed, courage to change the things which should be changed and the wisdom to distinguish the one from the other."
  },
  {
    "author": "Martin Luther",
    "category": "god",
    "id": 28079,
    "text": "Music is the art of the prophets and the gift of God."
  },
  {
    "author": "Blaise Pascal",
    "category": "god",
    "id": 28284,
    "text": "Faith is different from proof the latter is human, the former is a Gift from God."
  },
  {
    "author": "Orson Welles",
    "category": "god",
    "id": 28389,
    "text": "I don't pray because I don't want to bore God."
  },
  {
    "author": "Tony Dungy",
    "category": "god",
    "id": 27783,
    "text": "I've said all along that God is in control."
  },
  {
    "author": "Voltaire",
    "category": "god",
    "id": 27996,
    "text": "All men are born with a nose and ten fingers, but no one was born with a knowledge of God."
  },
  {
    "author": "Charles Stanley",
    "category": "god",
    "id": 28649,
    "text": "When we learn from experience, the scars of sin can lead us to restoration and a renewed intimacy with God."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "god",
    "id": 27957,
    "text": "A subject for a great poet would be God's boredom after the seventh day of creation."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "god",
    "id": 27737,
    "text": "God is, even though the whole world deny him. Truth stands, even if there be no public support. It is self-sustained."
  },
  {
    "author": "Thomas Jefferson",
    "category": "god",
    "id": 27845,
    "text": "Question with boldness even the existence of a God because, if there be one, he must more approve of the homage of reason, than that of blind-folded fear."
  },
  {
    "author": "Erma Bombeck",
    "category": "god",
    "id": 28083,
    "text": "God created man, but I could do better."
  },
  {
    "author": "Mary Daly",
    "category": "god",
    "id": 28550,
    "text": "It is the creative potential itself in human beings that is the image of God."
  },
  {
    "author": "Stevie Wonder",
    "category": "god",
    "id": 27766,
    "text": "God gave me life to continue to do things that I would never have done."
  },
  {
    "author": "John Cleese",
    "category": "god",
    "id": 28704,
    "text": "If God did not intend for us to eat animals, then why did he make them out of meat?"
  },
  {
    "author": "Robert Anton Wilson",
    "category": "god",
    "id": 28563,
    "text": "Pregnancy is a kind of miracle. Especially so in that it proves that a man and woman can conspire to force God to create a new soul."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "god",
    "id": 28103,
    "text": "Flowers are the sweetest things God ever made and forgot to put a soul into."
  },
  {
    "author": "Marianne Williamson",
    "category": "god",
    "id": 28441,
    "text": "Love knows how to form itself. God will do his work if we do ours. Our job is to prepare ourselves for love. When we do, love finds us every time."
  },
  {
    "author": "Barack Obama",
    "category": "god",
    "id": 27879,
    "text": "And I will do everything that I can as long as I am President of the United States to remind the American people that we are one nation under God, and we may call that God different names but we remain one nation."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "god",
    "id": 27902,
    "text": "God sometimes does try to the uttermost those whom he wishes to bless."
  },
  {
    "author": "Leo Tolstoy",
    "category": "god",
    "id": 28093,
    "text": "In the name of God, stop a moment, cease your work, look around you."
  },
  {
    "author": "Arthur Peacocke",
    "category": "god",
    "id": 27797,
    "text": "God is creating at every moment of the world's existence in and through the perpetually endowed creativity of the very stuff of the world."
  },
  {
    "author": "Mark Twain",
    "category": "god",
    "id": 27803,
    "text": "Only one thing is impossible for God: To find any sense in any copyright law on the planet."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "god",
    "id": 27733,
    "text": "God, as Truth, has been for me a treasure beyond price. May He be so to every one of us."
  },
  {
    "author": "Aeschylus",
    "category": "god",
    "id": 28654,
    "text": "God's most lordly gift to man is decency of mind."
  },
  {
    "author": "Aristotle",
    "category": "god",
    "id": 27939,
    "text": "Whosoever is delighted in solitude is either a wild beast or a god."
  },
  {
    "author": "Saint Patrick",
    "category": "god",
    "id": 28449,
    "text": "If I be worthy, I live for my God to teach the heathen, even though they may despise me."
  },
  {
    "author": "Richard Branson",
    "category": "god",
    "id": 28221,
    "text": "My general attitude to life is to enjoy every minute of every day. I never do anything with a feeling of, 'Oh God, I've got to do this today.'"
  },
  {
    "author": "Henry Ward Beecher",
    "category": "god",
    "id": 28179,
    "text": "God asks no man whether he will accept life. That is not the choice. You must take it. The only choice is how."
  },
  {
    "author": "Douglas MacArthur",
    "category": "god",
    "id": 28623,
    "text": "Like the old soldier of the ballad, I now close my military career and just fade away, an old soldier who tried to do his duty as God gave him the light to see that duty. Goodbye."
  },
  {
    "author": "Edwin Louis Cole",
    "category": "god",
    "id": 28528,
    "text": "God never ends anything on a negative God always ends on a positive."
  },
  {
    "author": "Robert Green Ingersoll",
    "category": "god",
    "id": 28594,
    "text": "Few nations have been so poor as to have but one god. Gods were made so easily, and the raw material cost so little, that generally the god market was fairly glutted and heaven crammed with these phantoms."
  },
  {
    "author": "Ayn Rand",
    "category": "god",
    "id": 28053,
    "text": "God... a being whose only definition is that he is beyond man's power to conceive."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "god",
    "id": 27926,
    "text": "God enters by a private door into every individual."
  },
  {
    "author": "Johann Sebastian Bach",
    "category": "god",
    "id": 28487,
    "text": "The aim and final end of all music should be none other than the glory of God and the refreshment of the soul."
  },
  {
    "author": "Aldous Huxley",
    "category": "god",
    "id": 28146,
    "text": "Uncontrolled, the hunger and thirst after God may become an obstacle, cutting off the soul from what it desires. If a man would travel far along the mystic road, he must learn to desire God intensely but in stillness, passively and yet with all his heart and mind and strength."
  },
  {
    "author": "Joseph Campbell",
    "category": "god",
    "id": 27888,
    "text": "God is a metaphor for that which transcends all levels of intellectual thought. It's as simple as that."
  },
  {
    "author": "Saint Augustine",
    "category": "god",
    "id": 27935,
    "text": "Pray as though everything depended on God. Work as though everything depended on you."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "god",
    "id": 27944,
    "text": "I cannot believe in a God who wants to be praised all the time."
  },
  {
    "author": "Alan Dershowitz",
    "category": "god",
    "id": 28298,
    "text": "You know, it's ironic to me that Christians want to keep the Ten Commandments in our schools, because Christianity has abrogated four of the Ten Commandments. For example, the Sabbath day according to the Ten Commandments is Saturday, not Sunday. And the reason is because God rested, not because Jesus was resurrected."
  },
  {
    "author": "Benjamin Franklin",
    "category": "god",
    "id": 27877,
    "text": "Rebellion against tyrants is obedience to God."
  },
  {
    "author": "Martin Luther",
    "category": "god",
    "id": 28119,
    "text": "The God of this world is riches, pleasure and pride."
  },
  {
    "author": "Abu Bakar Bashir",
    "category": "god",
    "id": 28601,
    "text": "Look at the Afghans, during the time of the Soviet invasion. They were among the poorest Muslims in the world, yet they were sustained by their faith in God, and God alone."
  },
  {
    "author": "John Wooden",
    "category": "god",
    "id": 27844,
    "text": "Talent is God given. Be humble. Fame is man-given. Be grateful. Conceit is self-given. Be careful."
  },
  {
    "author": "John F. Kennedy",
    "category": "god",
    "id": 27843,
    "text": "Geography has made us neighbors. History has made us friends. Economics has made us partners, and necessity has made us allies. Those whom God has so joined together, let no man put asunder."
  },
  {
    "author": "Russell M. Nelson",
    "category": "god",
    "id": 28576,
    "text": "We were born to die and we die to live. As seedlings of God, we barely blossom on earth we fully flower in heaven."
  },
  {
    "author": "Stephen King",
    "category": "god",
    "id": 27932,
    "text": "When his life was ruined, his family killed, his farm destroyed, Job knelt down on the ground and yelled up to the heavens, 'Why god? Why me?' and the thundering voice of God answered, 'There's just something about you that pisses me off.'"
  },
  {
    "author": "Alfred Lord Tennyson",
    "category": "god",
    "id": 28577,
    "text": "God's finger touched him, and he slept."
  },
  {
    "author": "Farrah Fawcett",
    "category": "god",
    "id": 28278,
    "text": "God gave women intuition and femininity. Used properly, the combination easily jumbles the brain of any man I've ever met."
  },
  {
    "author": "Bill Maher",
    "category": "god",
    "id": 27924,
    "text": "Suicide is man's way of telling God, 'You can't fire me - I quit.'"
  },
  {
    "author": "Lawrence Welk",
    "category": "god",
    "id": 27729,
    "text": "Never trust anyone completely but God. Love people, but put your full trust only in God."
  },
  {
    "author": "William Butler Yeats",
    "category": "god",
    "id": 28485,
    "text": "The years like great black oxen tread the world, and God, the herdsman goads them on behind, and I am broken by their passing feet."
  },
  {
    "author": "Angelina Jolie",
    "category": "god",
    "id": 28169,
    "text": "Oh, God, I struggle with low self-esteem all the time! I think everyone does. I have so much wrong with me, it's unbelievable!"
  },
  {
    "author": "Albert Camus",
    "category": "god",
    "id": 27810,
    "text": "I would rather live my life as if there is a God and die to find out there isn't, than live my life as if there isn't and die to find out there is."
  },
  {
    "author": "Lucy Maud Montgomery",
    "category": "god",
    "id": 28077,
    "text": "In this world you've just got to hope for the best and prepare for the worst and take whatever God sends."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "god",
    "id": 28269,
    "text": "Next to God we are nothing. To God we are Everything."
  },
  {
    "author": "Mel Brooks",
    "category": "god",
    "id": 28469,
    "text": "If God wanted us to fly, He would have given us tickets."
  },
  {
    "author": "John Calvin",
    "category": "god",
    "id": 28387,
    "text": "Man's mind is like a store of idolatry and superstition so much so that if a man believes his own mind it is certain that he will forsake God and forge some idol in his own brain."
  },
  {
    "author": "Francis Bacon",
    "category": "god",
    "id": 28332,
    "text": "God Almighty first planted a garden. And indeed, it is the purest of human pleasures."
  },
  {
    "author": "Thomas Jefferson",
    "category": "god",
    "id": 27871,
    "text": "It does me no injury for my neighbor to say there are twenty gods or no God."
  }
]

quotes['good'] = [
  {
    "author": "Ben Stein",
    "category": "good",
    "id": 29648,
    "text": "Screaming at children over their grades, especially to the point of the child's tears, is child abuse, pure and simple. It's not funny and it's not good parenting. It is a crushing, scarring, disastrous experience for the child. It isn't the least bit funny."
  },
  {
    "author": "Mark Twain",
    "category": "good",
    "id": 28871,
    "text": "There are several good protections against temptation, but the surest is cowardice."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "good",
    "id": 29256,
    "text": "It seems to never occur to fools that merit and good fortune are closely united."
  },
  {
    "author": "Will Rogers",
    "category": "good",
    "id": 29163,
    "text": "It's a good thing we don't get all the government we pay for."
  },
  {
    "author": "Edmund Burke",
    "category": "good",
    "id": 28722,
    "text": "The only thing necessary for the triumph of evil is for good men to do nothing."
  },
  {
    "author": "Pope John XXIII",
    "category": "good",
    "id": 29649,
    "text": "A peaceful man does more good than a learned one."
  },
  {
    "author": "Muhammad Ali",
    "category": "good",
    "id": 28941,
    "text": "Silence is golden when you can't think of a good answer."
  },
  {
    "author": "Xun Zi",
    "category": "good",
    "id": 29149,
    "text": "A person is born with feelings of envy and hate. If he gives way to them, they will lead him to violence and crime, and any sense of loyalty and good faith will be abandoned."
  },
  {
    "author": "Voltaire",
    "category": "good",
    "id": 29231,
    "text": "All styles are good except the tiresome kind."
  },
  {
    "author": "Plato",
    "category": "good",
    "id": 29194,
    "text": "Truth is the beginning of every good to the gods, and of every good to man."
  },
  {
    "author": "Emma Bunton",
    "category": "good",
    "id": 28772,
    "text": "Be sweet, be good, and honest always."
  },
  {
    "author": "Mike Tyson",
    "category": "good",
    "id": 29418,
    "text": "Mr. Arthur Ashe, he was good. I read some of his books. He knew about everything, but he was real quiet and didn't talk much. I never met him."
  },
  {
    "author": "Michael Jackson",
    "category": "good",
    "id": 29211,
    "text": "People write negatives things, cause they feel that's what sells. Good news to them, doesn't sell."
  },
  {
    "author": "Ernest Hemingway",
    "category": "good",
    "id": 29133,
    "text": "What is moral is what you feel good after, and what is immoral is what you feel bad after."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "good",
    "id": 29272,
    "text": "In art the best is good enough."
  },
  {
    "author": "Benjamin Franklin",
    "category": "good",
    "id": 28948,
    "text": "Diligence is the mother of good luck."
  },
  {
    "author": "Kin Hubbard",
    "category": "good",
    "id": 29559,
    "text": "Of all the home remedies, a good wife is best."
  },
  {
    "author": "Richard P. Feynman",
    "category": "good",
    "id": 29480,
    "text": "Scientific views end in awe and mystery, lost at the edge in uncertainty, but they appear to be so deep and so impressive that the theory that it is all arranged as a stage for God to watch man's struggle for good and evil seems inadequate."
  },
  {
    "author": "Lindsay Lohan",
    "category": "good",
    "id": 29348,
    "text": "Say 'no' more than 'yes,' and just make sure you surround yourself with good people."
  },
  {
    "author": "Oscar Wilde",
    "category": "good",
    "id": 28937,
    "text": "In modern life nothing produces such an effect as a good platitude. It makes the whole world kin."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "good",
    "id": 28989,
    "text": "I have thought a sufficient measure of civilization is the influence of good women."
  },
  {
    "author": "Charles Stanley",
    "category": "good",
    "id": 29625,
    "text": "Every test, every trial, every heartache that's been significant, I can turn it over and see how God has turned it into good no matter what."
  },
  {
    "author": "Maria Sharapova",
    "category": "good",
    "id": 29677,
    "text": "When you look good, you feel good. Confidence with what you're wearing is very important. If you feel good, you will always perform your best without worrying about anything."
  },
  {
    "author": "Jesse Jackson",
    "category": "good",
    "id": 29337,
    "text": "A man must be willing to die for justice. Death is an inescapable reality and men die daily, but good deeds live forever."
  },
  {
    "author": "Winston Churchill",
    "category": "good",
    "id": 28881,
    "text": "It is a good thing for an uneducated man to read books of quotations."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "good",
    "id": 29683,
    "text": "Because of its tremendous solemnity death is the light in which great passions, both good and bad, become transparent, no longer limited by outward appearences."
  },
  {
    "author": "Bodhidharma",
    "category": "good",
    "id": 29568,
    "text": "A Buddha is someone who finds freedom in good fortune and bad."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "good",
    "id": 29020,
    "text": "I do not know what the spirit of a philosopher could more wish to be than a good dancer. For the dance is his ideal, also his fine art, finally also the only kind of piety he knows, his 'divine service.'"
  },
  {
    "author": "Oscar Wilde",
    "category": "good",
    "id": 28917,
    "text": "Arguments are extremely vulgar, for everyone in good society holds exactly the same opinion."
  },
  {
    "author": "Hannah Arendt",
    "category": "good",
    "id": 29320,
    "text": "The sad truth is that most evil is done by people who never make up their minds to be good or evil."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "good",
    "id": 29309,
    "text": "A book is good company. It is full of conversation without loquacity. It comes to your longing with full instruction, but pursues you never."
  },
  {
    "author": "Henry Ford",
    "category": "good",
    "id": 29168,
    "text": "A market is never saturated with a good product, but it is very quickly saturated with a bad one."
  },
  {
    "author": "George Orwell",
    "category": "good",
    "id": 29479,
    "text": "Four legs good, two legs bad."
  },
  {
    "author": "Benjamin Franklin",
    "category": "good",
    "id": 28915,
    "text": "Your net worth to the world is usually determined by what remains after your bad habits are subtracted from your good ones."
  },
  {
    "author": "Aristotle",
    "category": "good",
    "id": 29011,
    "text": "Therefore, the good of man must be the end of the science of politics."
  },
  {
    "author": "Winston Churchill",
    "category": "good",
    "id": 28855,
    "text": "There is no such thing as a good tax."
  },
  {
    "author": "Maya Angelou",
    "category": "good",
    "id": 28837,
    "text": "Any book that helps a child to form a habit of reading, to make reading one of his deep and continuing needs, is good for him."
  },
  {
    "author": "Victor Hugo",
    "category": "good",
    "id": 29412,
    "text": "Amnesty is as good for those who give it as for those who receive it. It has the admirable quality of bestowing mercy on both sides."
  },
  {
    "author": "Thomas Jefferson",
    "category": "good",
    "id": 28885,
    "text": "I believe that every human mind feels pleasure in doing good to another."
  },
  {
    "author": "Sophocles",
    "category": "good",
    "id": 29672,
    "text": "To be doing good deeds is man's most glorious task."
  },
  {
    "author": "Clint Eastwood",
    "category": "good",
    "id": 29324,
    "text": "If I'd had good discipline, I might have gone into music."
  },
  {
    "author": "Marcus Aurelius",
    "category": "good",
    "id": 29247,
    "text": "Tomorrow is nothing, today is too late the good lived yesterday."
  },
  {
    "author": "David Rockefeller",
    "category": "good",
    "id": 28880,
    "text": "I am convinced that material things can contribute a lot to making one's life pleasant, but, basically, if you do not have very good friends and relatives who matter to you, life will be really empty and sad and material things cease to be important."
  },
  {
    "author": "Henry David Thoreau",
    "category": "good",
    "id": 29084,
    "text": "I have seen how the foundations of the world are laid, and I have not the least doubt that it will stand a good while."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "good",
    "id": 29206,
    "text": "I think we consider too much the good luck of the early bird and not enough the bad luck of the early worm."
  },
  {
    "author": "Joni Mitchell",
    "category": "good",
    "id": 29562,
    "text": "You could write a song about some kind of emotional problem you are having, but it would not be a good song, in my eyes, until it went through a period of sensitivity to a moment of clarity. Without that moment of clarity to contribute to the song, it's just complaining."
  },
  {
    "author": "Wayne Gretzky",
    "category": "good",
    "id": 29010,
    "text": "A good hockey player plays where the puck is. A great hockey player plays where the puck is going to be."
  },
  {
    "author": "John Ruskin",
    "category": "good",
    "id": 29711,
    "text": "Do not think of your faults, still less of other's faults look for what is good and strong, and try to imitate it. Your faults will drop off, like dead leaves, when their time comes."
  },
  {
    "author": "Socrates",
    "category": "good",
    "id": 29062,
    "text": "The way to gain a good reputation is to endeavor to be what you desire to appear."
  },
  {
    "author": "Tony Dungy",
    "category": "good",
    "id": 29371,
    "text": "The secret to success is good leadership, and good leadership is all about making the lives of your team members or workers better."
  },
  {
    "author": "Deepak Chopra",
    "category": "good",
    "id": 29700,
    "text": "But the real secret to lifelong good health is actually the opposite: Let your body take care of you."
  },
  {
    "author": "Joan Rivers",
    "category": "good",
    "id": 29005,
    "text": "Don't follow any advice, no matter how good, until you feel as deeply in your spirit as you think in your mind that the counsel is wise."
  },
  {
    "author": "Ted Nugent",
    "category": "good",
    "id": 29512,
    "text": "I'm not in the leftist controlled Rock and Roll Hall of Fame because of my political views, primarily my lifelong militant support of the NRA, the Second Amendment, and my belief that the only good bad guy is a dead bad guy."
  },
  {
    "author": "Elizabeth Warren",
    "category": "good",
    "id": 29483,
    "text": "You built a factory out there, good for you. But I want to be clear. You moved your goods to market on the roads that the rest of us paid for. You hired workers that the rest of us paid to educate. You were safe in your factory because of police forces and fire forces that the rest of us paid for."
  },
  {
    "author": "Jesus Christ",
    "category": "good",
    "id": 28737,
    "text": "But I say to you, Love your enemies and pray for those who persecute you, so that you may be sons of your Father who is in heaven for he makes his sun rise on the evil and on the good, and sends rain on the just and on the unjust."
  },
  {
    "author": "Daniel Boone",
    "category": "good",
    "id": 29237,
    "text": "All you need for happiness is a good gun, a good horse, and a good wife."
  },
  {
    "author": "Barbara Corcoran",
    "category": "good",
    "id": 29517,
    "text": "A whopping 89 percent of buyers start their home search online. How your house looks online is the modern equivalent of 'curb appeal.' Rent a wide-angle lens and good lighting, get rid of your clutter and post at least eight great photos to win the beauty contest."
  },
  {
    "author": "Yogi Berra",
    "category": "good",
    "id": 29013,
    "text": "Little League baseball is a very good thing because it keeps the parents off the streets."
  },
  {
    "author": "Karl Rove",
    "category": "good",
    "id": 29386,
    "text": "As people do better, they start voting like Republicans - unless they have too much education and vote Democratic, which proves there can be too much of a good thing."
  },
  {
    "author": "Fred Brooks",
    "category": "good",
    "id": 29535,
    "text": "Good judgment comes from experience and experience comes from bad judgment."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "good",
    "id": 29393,
    "text": "Our forces saved the remnants of the Jewish people of Europe for a new life and a new hope in the reborn land of Israel. Along with all men of good will, I salute the young state and wish it well."
  },
  {
    "author": "Patti Smith",
    "category": "good",
    "id": 29662,
    "text": "The idea of redemption is always good news, even if it means sacrifice or some difficult times."
  },
  {
    "author": "John Florio",
    "category": "good",
    "id": 29676,
    "text": "A good husband makes a good wife."
  },
  {
    "author": "Marcel Marceau",
    "category": "good",
    "id": 28758,
    "text": "It's good to shut up sometimes."
  },
  {
    "author": "George Burns",
    "category": "good",
    "id": 29346,
    "text": "Happiness? A good cigar, a good meal, a good cigar and a good woman - or a bad woman it depends on how much happiness you can handle."
  },
  {
    "author": "Dave Matthews",
    "category": "good",
    "id": 29684,
    "text": "A friend is always good to have, but a lover's kiss is better than angels raining down on me."
  },
  {
    "author": "Benjamin Franklin",
    "category": "good",
    "id": 28830,
    "text": "He that is good for making excuses is seldom good for anything else."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "good",
    "id": 29343,
    "text": "Feeling good about government is like looking on the bright side of any catastrophe. When you quit looking on the bright side, the catastrophe is still there."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "good",
    "id": 29188,
    "text": "Our business in life is not to succeed, but to continue to fail in good spirits."
  },
  {
    "author": "Salvador Dali",
    "category": "good",
    "id": 29504,
    "text": "In order to acquire a growing and lasting respect in society, it is a good thing, if you possess great talent, to give, early in your youth, a very hard kick to the right shin of the society that you love. After that, be a snob."
  },
  {
    "author": "Bill Hicks",
    "category": "good",
    "id": 29295,
    "text": "If you don't think drugs have done good things for us, then take all of your records, tapes and CD's and burn them."
  },
  {
    "author": "Bertrand Russell",
    "category": "good",
    "id": 29655,
    "text": "Man is a credulous animal, and must believe something in the absence of good grounds for belief, he will be satisfied with bad ones."
  },
  {
    "author": "Dalai Lama",
    "category": "good",
    "id": 28859,
    "text": "The important thing is that men should have a purpose in life. It should be something useful, something good."
  },
  {
    "author": "Albert Einstein",
    "category": "good",
    "id": 28810,
    "text": "I do not believe in the God of theology who rewards good and punishes evil."
  },
  {
    "author": "Rabindranath Tagore",
    "category": "good",
    "id": 29233,
    "text": "He who is too busy doing good finds no time to be good."
  },
  {
    "author": "Albert Schweitzer",
    "category": "good",
    "id": 29341,
    "text": "By having a reverence for life, we enter into a spiritual relation with the world By practicing reverence for life we become good, deep, and alive."
  },
  {
    "author": "Bertrand Russell",
    "category": "good",
    "id": 29466,
    "text": "The infliction of cruelty with a good conscience is a delight to moralists. That is why they invented Hell."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "good",
    "id": 28868,
    "text": "The good news is that, according to the Obama administration, the rich will pay for everything. The bad news is that, according to the Obama administration, you're rich."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "good",
    "id": 29033,
    "text": "Many a man fails as an original thinker simply because his memory it too good."
  },
  {
    "author": "Charles Spurgeon",
    "category": "good",
    "id": 28976,
    "text": "A good character is the best tombstone. Those who loved you and were helped by you will remember you when forget-me-nots have withered. Carve your name on hearts, not on marble."
  },
  {
    "author": "Mike Tyson",
    "category": "good",
    "id": 29218,
    "text": "I intend to fight and I want to win. But my priorities are basically to be a good Brother and a strong one, and to try to be a good father one day."
  },
  {
    "author": "Socrates",
    "category": "good",
    "id": 28847,
    "text": "My advice to you is get married: if you find a good wife you'll be happy if not, you'll become a philosopher."
  },
  {
    "author": "Hermann Hesse",
    "category": "good",
    "id": 29276,
    "text": "I have always believed, and I still believe, that whatever good or bad fortune may come our way we can always give it meaning and transform it into something of value."
  },
  {
    "author": "Casey Stengel",
    "category": "good",
    "id": 29444,
    "text": "Finding good players is easy. Getting them to play as a team is another story."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "good",
    "id": 29438,
    "text": "Always read something that will make you look good if you die in the middle of it."
  },
  {
    "author": "Zig Ziglar",
    "category": "good",
    "id": 29040,
    "text": "Honesty and integrity are absolutely essential for success in life - all areas of life. The really good news is that anyone can develop both honesty and integrity."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "good",
    "id": 28996,
    "text": "All credibility, all good conscience, all evidence of truth come only from the senses."
  },
  {
    "author": "John Sununu",
    "category": "good",
    "id": 29699,
    "text": "For most Americans, Friday afternoons are filled with positive anticipation of the weekend. In Washington, it's where government officials dump stories they want to bury. Good news gets dropped on Monday so bureaucrats can talk about it all week."
  },
  {
    "author": "Steven Wright",
    "category": "good",
    "id": 28873,
    "text": "I intend to live forever. So far, so good."
  },
  {
    "author": "Karl Marx",
    "category": "good",
    "id": 29548,
    "text": "Greek philosophy seems to have met with something with which a good tragedy is not supposed to meet, namely, a dull ending."
  },
  {
    "author": "Steve Jobs",
    "category": "good",
    "id": 29014,
    "text": "Technology is nothing. What's important is that you have a faith in people, that they're basically good and smart, and if you give them tools, they'll do wonderful things with them."
  },
  {
    "author": "Rick Perry",
    "category": "good",
    "id": 29416,
    "text": "The God we serve does not seek out the perfect, but instead uses our imperfections and our shortcomings for his greater good. I am humbled by my own limitations. But where I am weak, He is strong."
  },
  {
    "author": "Emo Philips",
    "category": "good",
    "id": 29601,
    "text": "You don't appreciate a lot of stuff in school until you get older. Little things like being spanked every day by a middle-aged woman: Stuff you pay good money for in later life."
  },
  {
    "author": "Buddha",
    "category": "good",
    "id": 28794,
    "text": "To keep the body in good health is a duty... otherwise we shall not be able to keep our mind strong and clear."
  },
  {
    "author": "Charlie Sheen",
    "category": "good",
    "id": 29055,
    "text": "Here's the good news. If I realize that I'm insane, then I'm okay with it. I'm not dangerous insane."
  },
  {
    "author": "John Cusack",
    "category": "good",
    "id": 29595,
    "text": "There are some good people. But a good chunk of them will lie for no reason at all - it'll be ten o'clock and they'll tell you it's nine. You're looking at the clock and you can't even fathom why they're lying. They just lie because that's what they do."
  },
  {
    "author": "Mitt Romney",
    "category": "good",
    "id": 29361,
    "text": "Men and women of every faith and good people with none at all sincerely strive to do right and lead a purpose-driven life."
  },
  {
    "author": "Maria Sharapova",
    "category": "good",
    "id": 29409,
    "text": "It's easy to impress me. I don't need a fancy party to be happy. Just good friends, good food, and good laughs. I'm happy. I'm satisfied. I'm content."
  },
  {
    "author": "Mitt Romney",
    "category": "good",
    "id": 29363,
    "text": "Julia progresses from cradle to grave, showing how government makes every good thing in her life possible. The weak economy, high unemployment, falling wages, rising gas prices, the national debt, the insolvency of entitlements - all these are fictionally assumed away in a cartoon that is produced by a president who wants us to forget about them."
  },
  {
    "author": "Benjamin Franklin",
    "category": "good",
    "id": 28967,
    "text": "There is no kind of dishonesty into which otherwise good people more easily and frequently fall than that of defrauding the government."
  }
]

quotes['government'] = [
  {
    "author": "Jay Weatherill",
    "category": "government",
    "id": 30669,
    "text": "We are all in this together. We want to have, I suppose, a single point of entry so that anyone coming near a disability service can get a very complete picture. Government needs to understand that picture, and we need to be able to offer somebody a one-stop shop."
  },
  {
    "author": "Martin Feldstein",
    "category": "government",
    "id": 30168,
    "text": "Increased government spending can provide a temporary stimulus to demand and output but in the longer run higher levels of government spending crowd out private investment or require higher taxes that weaken growth by reducing incentives to save, invest, innovate, and work."
  },
  {
    "author": "Glenn Beck",
    "category": "government",
    "id": 30267,
    "text": "'Hello my name is the Republican Party and I got a problem. I'm addicted to spending and big government.' I'd like one of them just to stand up and say that."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "government",
    "id": 29754,
    "text": "To rule is easy, to govern difficult."
  },
  {
    "author": "Marco Rubio",
    "category": "government",
    "id": 30252,
    "text": "And I can tell you that history will back up what I'm about to say and that is that there is no government run by conservatives, Republicans, put whoever you want there, if you give government the opportunity to spend more money than it has, it will do it. It will do it every time."
  },
  {
    "author": "Milton Friedman",
    "category": "government",
    "id": 30061,
    "text": "The most important ways in which I think the Internet will affect the big issue is that it will make it more difficult for government to collect taxes."
  },
  {
    "author": "Dalton Trumbo",
    "category": "government",
    "id": 30266,
    "text": "Dishonesty in government is the business of every citizen. It is not enough to do your own job. There's no particular virtue in that. Democracy isn't a gift. It's a responsibility."
  },
  {
    "author": "James Madison",
    "category": "government",
    "id": 30024,
    "text": "A popular government without popular information or the means of acquiring it, is but a prologue to a farce, or a tragedy, or perhaps both."
  },
  {
    "author": "Andrew Jackson",
    "category": "government",
    "id": 30070,
    "text": "Money is power, and in that government which pays all the public officers of the states will all political power be substantially concentrated."
  },
  {
    "author": "Mitt Romney",
    "category": "government",
    "id": 29927,
    "text": "We believe in individual initiative, personal responsibility, opportunity, freedom, small government, the Constitution. These principles, these American principles are key to getting our economy back to being successful and leading the world."
  },
  {
    "author": "Lyn Nofziger",
    "category": "government",
    "id": 30682,
    "text": "I think the American people have become more reliant upon government and less reliant upon themselves and that they now tend to put security ahead of freedom, but I think freedom is the most important aspect of our lives."
  },
  {
    "author": "Bob Woodward",
    "category": "government",
    "id": 30519,
    "text": "A reporter's ability to keep the bond of confidentiality often enables him to learn the hidden or secret aspects of government."
  },
  {
    "author": "Alan Dershowitz",
    "category": "government",
    "id": 30427,
    "text": "Great research universities must insist on independence from government and on the exercise of academic freedom."
  },
  {
    "author": "Tony Blair",
    "category": "government",
    "id": 30450,
    "text": "Power without principle is barren, but principle without power is futile. This is a party of government, and I will lead it as a party of government."
  },
  {
    "author": "Jimmy Carter",
    "category": "government",
    "id": 30228,
    "text": "It's very difficult for the American people to believe that our government, one of the richest on Earth, is also one of the stingiest on Earth."
  },
  {
    "author": "Albert Einstein",
    "category": "government",
    "id": 29813,
    "text": "Nothing is more destructive of respect for the government and the law of the land than passing laws which cannot be enforced."
  },
  {
    "author": "Glenn Beck",
    "category": "government",
    "id": 30329,
    "text": "Every time the government grows we lose more of who we are."
  },
  {
    "author": "Glenn Beck",
    "category": "government",
    "id": 30131,
    "text": "We should reject big government and look inside ourselves for all the things that built this country into what it was."
  },
  {
    "author": "Rupert Murdoch",
    "category": "government",
    "id": 30559,
    "text": "The UK desperately needs less government and freer markets."
  },
  {
    "author": "Will Rogers",
    "category": "government",
    "id": 29871,
    "text": "I don't make jokes. I just watch the government and report the facts."
  },
  {
    "author": "Daniel Webster",
    "category": "government",
    "id": 30113,
    "text": "The people's government, made for the people, made by the people, and answerable to the people."
  },
  {
    "author": "Tom Colicchio",
    "category": "government",
    "id": 30613,
    "text": "We're adults. We're the ones who should teach the kids what's good to eat. I don't think the government should ever regulate what we eat at home, but we're feeding them in school with tax dollars. Quite frankly, if my tax dollars are being spent to feed kids, I'd rather feed them better food."
  },
  {
    "author": "Rick Perry",
    "category": "government",
    "id": 30137,
    "text": "As Americans, we don't see the role of government as guaranteeing outcomes, but allowing free men and women to flourish based on their own vision, their hard work and their personal responsibility."
  },
  {
    "author": "Stephen Harper",
    "category": "government",
    "id": 30366,
    "text": "The government can only be brought down because it alienates several parties in the House."
  },
  {
    "author": "James Q. Wilson",
    "category": "government",
    "id": 29794,
    "text": "But no one has yet succeeded in reducing the size or scope of the federal government."
  },
  {
    "author": "George W. Bush",
    "category": "government",
    "id": 30136,
    "text": "People forget... that we structured it so that the government, or the people, would be repaid with a really good rate of return. And as it turns out, that aspect of TARP, that's what happened."
  },
  {
    "author": "George Washington",
    "category": "government",
    "id": 29888,
    "text": "It may be laid down as a primary position, and the basis of our system, that every Citizen who enjoys the protection of a Free Government, owes not only a proportion of his property, but even of his personal services to the defense of it."
  },
  {
    "author": "Rupert Murdoch",
    "category": "government",
    "id": 30557,
    "text": "I'm not a knee-jerk conservative. I passionately believe in free markets and less government, but not to the point of being a libertarian."
  },
  {
    "author": "Sharron Angle",
    "category": "government",
    "id": 30062,
    "text": "And that's really what's happening in this country is a violation of the First Commandment. We have become a country entrenched in idolatry, and that idolatry is the dependency upon our government. We're supposed to depend upon God for our protection and our provision and for our daily bread, not for our government."
  },
  {
    "author": "Rush Limbaugh",
    "category": "government",
    "id": 30013,
    "text": "You know why there's a Second Amendment? In case the government fails to follow the first one."
  },
  {
    "author": "Thomas Jefferson",
    "category": "government",
    "id": 29823,
    "text": "The care of human life and happiness, and not their destruction, is the first and only object of good government."
  },
  {
    "author": "Ron Paul",
    "category": "government",
    "id": 29889,
    "text": "I am just absolutely convinced that the best formula for giving us peace and preserving the American way of life is freedom, limited government, and minding our own business overseas."
  },
  {
    "author": "Ronald Reagan",
    "category": "government",
    "id": 29854,
    "text": "One way to make sure crime doesn't pay would be to let the government run it."
  },
  {
    "author": "Alexander Pope",
    "category": "government",
    "id": 30028,
    "text": "For Forms of Government let fools contest whatever is best administered is best."
  },
  {
    "author": "David Mamet",
    "category": "government",
    "id": 30487,
    "text": "The Founders recognized that Government is quite literally a necessary evil, that there must be opposition, between its various branches, and between political parties, for these are the only ways to temper the individual's greed for power and the electorates' desires for peace by submission to coercion or blandishment."
  },
  {
    "author": "Rick Warren",
    "category": "government",
    "id": 30171,
    "text": "I happen to agree with many of the liberal emphasis on compassion, justice and equality. I just disagree that it's the government's role to provide everything."
  },
  {
    "author": "Hubert H. Humphrey",
    "category": "government",
    "id": 29852,
    "text": "It was once said that the moral test of government is how that government treats those who are in the dawn of life, the children those who are in the twilight of life, the elderly and those who are in the shadows of life, the sick, the needy and the handicapped."
  },
  {
    "author": "Bill Maher",
    "category": "government",
    "id": 29929,
    "text": "Freedom isn't free. It shouldn't be a bragging point that 'Oh, I don't get involved in politics,' as if that makes someone cleaner. No, that makes you derelict of duty in a republic. Liars and panderers in government would have a much harder time of it if so many people didn't insist on their right to remain ignorant and blindly agreeable."
  },
  {
    "author": "Noah Webster",
    "category": "government",
    "id": 30247,
    "text": "In my view, the Christian religion is the most important and one of the first things in which all children, under a free government ought to be instructed."
  },
  {
    "author": "John Stuart Mill",
    "category": "government",
    "id": 30161,
    "text": "The most cogent reason for restricting the interference of government is the great evil of adding unnecessarily to its power."
  },
  {
    "author": "Tim Pawlenty",
    "category": "government",
    "id": 30555,
    "text": "The only thing growing faster than the federal government's deficit is Chris Matthews' man-crush on Barack Obama."
  },
  {
    "author": "Marco Rubio",
    "category": "government",
    "id": 30092,
    "text": "We don't need new taxes. We need new taxpayers, people that are gainfully employed, making money and paying into the tax system. And then we need a government that has the discipline to take that additional revenue and use it to pay down the debt and never grow it again."
  },
  {
    "author": "Paul Harvey",
    "category": "government",
    "id": 30037,
    "text": "Ever occur to you why some of us can be this much concerned with animals suffering? Because government is not. Why not? Animals don't vote."
  },
  {
    "author": "George Bernard Shaw",
    "category": "government",
    "id": 29890,
    "text": "The art of government is the organisation of idolatry."
  },
  {
    "author": "Eliot Spitzer",
    "category": "government",
    "id": 30501,
    "text": "Power must be used, but it must be tempered by soul-searching and the recognition of our human capacity for error. That is the maxim that should inform our approach to every challenge, from reforming state government to engaging in foreign affairs."
  },
  {
    "author": "Arthur C. Brooks",
    "category": "government",
    "id": 30269,
    "text": "There is nothing inherently fair about equalizing incomes. If the government penalizes you for working harder than somebody else, that is unfair. If you save your money but retire with the same pension as a free-spending neighbor, that is also unfair."
  },
  {
    "author": "Stephen Harper",
    "category": "government",
    "id": 30368,
    "text": "Canadians know that the promise of a recession didn't happen because of anything we did here. If you look at all the causes of the recession, problems in mortgage markets, the problems in the banking sector, the problems in government finance in countries like Greece, none of those problems were in present Canada."
  },
  {
    "author": "Abraham Lincoln",
    "category": "government",
    "id": 29725,
    "text": "No man is good enough to govern another man without the other's consent."
  },
  {
    "author": "Gerry Adams",
    "category": "government",
    "id": 30627,
    "text": "For over 30 years, the IRA showed that the British government could not rule Ireland on its own terms."
  },
  {
    "author": "Ronald Reagan",
    "category": "government",
    "id": 29815,
    "text": "The problem is not that people are taxed too little, the problem is that government spends too much."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "government",
    "id": 29918,
    "text": "The only sure bulwark of continuing liberty is a government strong enough to protect the interests of the people, and a people strong enough and well enough informed to maintain its sovereign control over the goverment."
  },
  {
    "author": "Lord Acton",
    "category": "government",
    "id": 30346,
    "text": "Machiavelli's teaching would hardly have stood the test of Parliamentary government, for public discussion demands at least the profession of good faith."
  },
  {
    "author": "Jesse Ventura",
    "category": "government",
    "id": 30698,
    "text": "Love is by far bigger than the government can ever be."
  },
  {
    "author": "Thomas Frank",
    "category": "government",
    "id": 30404,
    "text": "Our laws governing lobbying and campaign contributions have struck the right balance between the wishes of the people and those of private industry, so why are we so quick to doubt that the same great results can be achieved by putting the government's justice-dealing branch on the same market-based course?"
  },
  {
    "author": "John Adams",
    "category": "government",
    "id": 29988,
    "text": "A government of laws, and not of men."
  },
  {
    "author": "Lawrence Summers",
    "category": "government",
    "id": 30511,
    "text": "You can't have a situation in which companies proceed on a permanent basis relying only on cash from the government."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "government",
    "id": 29926,
    "text": "Not only our future economic soundness but the very soundness of our democratic institutions depends on the determination of our government to give employment to idle men."
  },
  {
    "author": "Voltaire",
    "category": "government",
    "id": 29867,
    "text": "In general, the art of government consists of taking as much money as possible from one class of citizens to give to another."
  },
  {
    "author": "William J. Clinton",
    "category": "government",
    "id": 30084,
    "text": "The new rage is to say that the government is the cause of all our problems, and if only we had no government, we'd have no problems. I can tell you, that contradicts evidence, history, and common sense."
  },
  {
    "author": "H. L. Mencken",
    "category": "government",
    "id": 29951,
    "text": "Every decent man is ashamed of the government he lives under."
  },
  {
    "author": "Sarah Palin",
    "category": "government",
    "id": 30483,
    "text": "Common sense tells us that the government's attempts to solve large problems more often create new ones. Common sense also tells us that a top-down, one-size-fits-all plan will not improve the workings of a nationwide health-care system that accounts for one-sixth of our economy."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "government",
    "id": 29919,
    "text": "I am sometimes a fox and sometimes a lion. The whole secret of government lies in knowing when to be the one or the other."
  },
  {
    "author": "William J. Brennan, Jr.",
    "category": "government",
    "id": 30452,
    "text": "The Framers of the Bill of Rights did not purport to 'create' rights. Rather, they designed the Bill of Rights to prohibit our Government from infringing rights and liberties presumed to be preexisting."
  },
  {
    "author": "George W. Bush",
    "category": "government",
    "id": 30030,
    "text": "Any government that supports, protects or harbours terrorists is complicit in the murder of the innocent and equally guilty of terrorist crimes."
  },
  {
    "author": "Frank Lloyd Wright",
    "category": "government",
    "id": 30132,
    "text": "Maybe we can show government how to operate better as a result of better architecture. Eventually, I think Chicago will be the most beautiful great city left in the world."
  },
  {
    "author": "Madeleine Albright",
    "category": "government",
    "id": 30288,
    "text": "I wasn't a normal professor. I had worked in government. I hadn't written nine zillion books. I was a hands-on professor."
  },
  {
    "author": "Chief Joseph",
    "category": "government",
    "id": 30085,
    "text": "I only ask of the government to be treated as all other men are treated."
  },
  {
    "author": "Thabo Mbeki",
    "category": "government",
    "id": 30191,
    "text": "I don't imagine Heads of Government would ever be able to say I'm not an economist therefore I can't take decisions on matters of the economy I'm not a soldier I can't take decisions on matters of defence I'm not an educationist so I can't take decisions about education."
  },
  {
    "author": "Claire McCaskill",
    "category": "government",
    "id": 30159,
    "text": "I think there are certain folks in Missouri that don't trust government. And they haven't trusted government for a long time."
  },
  {
    "author": "Andrew Jackson",
    "category": "government",
    "id": 30021,
    "text": "As long as our government is administered for the good of the people, and is regulated by their will as long as it secures to us the rights of persons and of property, liberty of conscience and of the press, it will be worth defending."
  },
  {
    "author": "Jon Meacham",
    "category": "government",
    "id": 30446,
    "text": "The fact is that America has been at her most prosperous when government and the private sector have been not at war, but in a wary, if often underplayed, alliance. History is unmistakable on this point."
  },
  {
    "author": "Milton Friedman",
    "category": "government",
    "id": 29762,
    "text": "Governments never learn. Only people learn."
  },
  {
    "author": "Barack Obama",
    "category": "government",
    "id": 29878,
    "text": "If the people cannot trust their government to do the job for which it exists - to protect them and to promote their common welfare - all else is lost."
  },
  {
    "author": "Lucy Powell",
    "category": "government",
    "id": 30715,
    "text": "It's become unfashionable to celebrate political achievement, and Labour achievement even less so. And it's positively uncouth to be proud of something that this Labour government is doing. So, slam me for saying so, but I'm really proud of the NHS."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "government",
    "id": 30020,
    "text": "Whatever it is that the government does, sensible Americans would prefer that the government does it to somebody else. This is the idea behind foreign policy."
  },
  {
    "author": "Stephen Harper",
    "category": "government",
    "id": 30459,
    "text": "The Leader of the Opposition's constitutional obligation - the obligation to Parliament - it's the reason we did the merger! - is to make sure Canadians have an alternative for government."
  },
  {
    "author": "Larry Ellison",
    "category": "government",
    "id": 29777,
    "text": "A corporation's primary goal is to make money. Government's primary role is to take a big chunk of that money and give it to others."
  },
  {
    "author": "Andrew Cuomo",
    "category": "government",
    "id": 30606,
    "text": "I was elected to come to an incredibly dysfunctional capital and make the government work better, and that's what I'm doing."
  },
  {
    "author": "William Ellery Channing",
    "category": "government",
    "id": 30270,
    "text": "The office of government is not to confer happiness, but to give men the opportunity to work out happiness for themselves."
  },
  {
    "author": "James Russell Lowell",
    "category": "government",
    "id": 30097,
    "text": "Democracy is the form of government that gives every man the right to be his own oppressor."
  },
  {
    "author": "Stephen Fry",
    "category": "government",
    "id": 30232,
    "text": "As someone who worked hard for a Labour victory in the 90s, do I regret it? Not really. It was bound to happen. And it'll happen with the next government, and the one after it. Because all governments serve us. They serve the filth."
  },
  {
    "author": "Muqtada al Sadr",
    "category": "government",
    "id": 30681,
    "text": "If it does not serve the Iraqi people, there are only political means that must be followed to reform the government - a new government that we must give a chance to prove that it is there to serve the people."
  },
  {
    "author": "James Madison",
    "category": "government",
    "id": 30098,
    "text": "A pure democracy is a society consisting of a small number of citizens, who assemble and administer the government in person."
  },
  {
    "author": "Muqtada al Sadr",
    "category": "government",
    "id": 30687,
    "text": "I don't want the chair of the government because it will be controlled by the U.S. and I don't want to be controlled by the U.S."
  },
  {
    "author": "Thomas Jefferson",
    "category": "government",
    "id": 29801,
    "text": "My reading of history convinces me that most bad government results from too much government."
  },
  {
    "author": "Ibrahim Babangida",
    "category": "government",
    "id": 30304,
    "text": "The average Nigerian person has come to reconcile himself with the fact that his or her social progress remain essentially in his or her hands in collaboration with other fellow Nigerians and not merely relying on what government alone could provide for him or her."
  },
  {
    "author": "William F. Buckley, Jr.",
    "category": "government",
    "id": 29879,
    "text": "I'd rather entrust the government of the United States to the first 400 people listed in the Boston telephone directory than to the faculty of Harvard University."
  },
  {
    "author": "Martin Sheen",
    "category": "government",
    "id": 30533,
    "text": "I honestly do not know if civil disobedience has any effect on the government. I can promise you it has a great effect on the person who chooses to do it."
  },
  {
    "author": "Robert Anton Wilson",
    "category": "government",
    "id": 30163,
    "text": "You know, I have found a new way to get high and stay spaced out for hours on end, and the government can't stop me... It's called senility."
  },
  {
    "author": "Frank Lloyd Wright",
    "category": "government",
    "id": 29883,
    "text": "A free America... means just this: individual freedom for all, rich or poor, or else this system of government we call democracy is only an expedient to enslave man to the machine and make him like it."
  },
  {
    "author": "Stephen Harper",
    "category": "government",
    "id": 30466,
    "text": "I forget what the relevant American rate is, but I can tell you that our goal is to have a combined federal-provincial corporate tax rate of no more than 25 percent. We're on target to do that by 2012. We will have significantly - by a significant margin the lowest corporate tax rates in the G-7, and that's our - our government's objective."
  },
  {
    "author": "Dirk Kempthorne",
    "category": "government",
    "id": 29788,
    "text": "Government alone cannot solve the problems we deal with in our correctional facilities, treatment centers, homeless shelters and crisis centers - we need our faith-based and community partners."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "government",
    "id": 30077,
    "text": "When the people become involved in their government, government becomes more accountable, and our society is stronger, more compassionate, and better prepared for the challenges of the future."
  },
  {
    "author": "Dale Dauten",
    "category": "government",
    "id": 29789,
    "text": "Bureaucracy gives birth to itself and then expects maternity benefits."
  },
  {
    "author": "Ron Paul",
    "category": "government",
    "id": 29975,
    "text": "I had the privilege of practicing medicine in the early '60s, before we had any government. It worked rather well, and there was nobody on the street suffering with no medical care."
  },
  {
    "author": "Thomas Jefferson",
    "category": "government",
    "id": 29831,
    "text": "Were it left to me to decide whether we should have a government without newspapers, or newspapers without a government, I should not hesitate a moment to prefer the latter."
  },
  {
    "author": "Harold Pinter",
    "category": "government",
    "id": 30495,
    "text": "Most of the press is in league with government, or with the status quo."
  },
  {
    "author": "J. C. Watts",
    "category": "government",
    "id": 30120,
    "text": "Republicans and Democrats have used accounting gimmicks and competing government analyses to deceive the public into believing that 2 + 2 = 6. If our leaders cannot agree on the numbers, if 'facts' are fictional, how can they possibly have a substantive debate on solutions?"
  },
  {
    "author": "Hillary Clinton",
    "category": "government",
    "id": 30002,
    "text": "Both the American people and nations that censor the internet should understand that our government is committed to helping promote internet freedom."
  },
  {
    "author": "Lucy Powell",
    "category": "government",
    "id": 30709,
    "text": "These are tough times and under this Tory-led government many people in Manchester are suffering and getting left behind. If elected I will use all my energy, skills, experience and knowledge to stand up for our communities and get things done for the better."
  }
]

quotes['graduation'] = [
  {
    "author": "Kenneth G. Wilson",
    "category": "graduation",
    "id": 30795,
    "text": "My father was on the faculty in the Chemistry Department of Harvard University my mother had one year of graduate work in physics before her marriage."
  },
  {
    "author": "Sara Paretsky",
    "category": "graduation",
    "id": 30757,
    "text": "I went to college at the University of Kansas, where I got a degree in political science."
  },
  {
    "author": "Ted Nelson",
    "category": "graduation",
    "id": 30777,
    "text": "In my second year in graduate school, I took a computer course and that was like lightening striking."
  },
  {
    "author": "Gordon Brown",
    "category": "graduation",
    "id": 30783,
    "text": "Each year India and China produce four million graduates compared with just over 250,000 in Britain."
  },
  {
    "author": "Patina Miller",
    "category": "graduation",
    "id": 30828,
    "text": "All my graduation money went to paying for bartending classes so I could have a side gig. I bartended for two months before I was supposed to move to New York and then two months later I got the job as an understudy in 'Sister Act' and haven't looked back since."
  },
  {
    "author": "Andrew Shue",
    "category": "graduation",
    "id": 30729,
    "text": "Life is the most exciting opportunity we have. But we have one shot. You graduate from college once, and that's it. You're going out of that nest. And you have to find that courage that's deep, deep, deep in there. Every step of the way."
  },
  {
    "author": "Joe Baca",
    "category": "graduation",
    "id": 30738,
    "text": "Catholic school graduates exhibit a wide variety of qualities that will not only help them in their careers but also in their family and community lives."
  },
  {
    "author": "M. H. Abrams",
    "category": "graduation",
    "id": 30792,
    "text": "When I was a graduate student, the leading spirits at Harvard were interested in the history of ideas."
  },
  {
    "author": "Marc Garneau",
    "category": "graduation",
    "id": 30781,
    "text": "I went to military college in Canada and graduated as an officer in the Navy but also as an engineer."
  },
  {
    "author": "Fiona Apple",
    "category": "graduation",
    "id": 30746,
    "text": "I got all my work done to graduate in two months and then they were like, I'm sorry, you have to take driver's ed. I just kind of went, Oh, forget it."
  },
  {
    "author": "R. Lee Ermey",
    "category": "graduation",
    "id": 30740,
    "text": "We had times in '66 and '67 when we would pick up a platoon of privates out of the receiving barracks the week before we even graduated the platoon that we were on!"
  },
  {
    "author": "Sloane Crosley",
    "category": "graduation",
    "id": 30810,
    "text": "Since graduation, I have measured time in 4-by-5-inch pieces of paper, four days on the left and three on the right. Every social engagement, interview, reading, flight, doctor's appointment, birthday and dry-cleaning reminder has been handwritten between metal loops."
  },
  {
    "author": "Tobias Wolff",
    "category": "graduation",
    "id": 30771,
    "text": "I teach one semester a year, and this year I'm just teaching one course during that semester, a writing workshop for older students in their late 20s and early 30s, people in our graduate program who are already working on a manuscript and trying to bring it to completion."
  },
  {
    "author": "Jim Clyburn",
    "category": "graduation",
    "id": 30772,
    "text": "I have no problems with private schools. I graduated from one and so did my mother. Private schools are useful and we often use public funds to pay for their infrastructures and other common needs."
  },
  {
    "author": "John F. Kennedy",
    "category": "graduation",
    "id": 30720,
    "text": "It might be said now that I have the best of both worlds. A Harvard education and a Yale degree."
  },
  {
    "author": "Simon Newcomb",
    "category": "graduation",
    "id": 30764,
    "text": "In 1858 I received the degree of D. S. from the Lawrence Scientific School, and thereafter remained on the rolls of the university as a resident graduate."
  },
  {
    "author": "Jim Jarmusch",
    "category": "graduation",
    "id": 30758,
    "text": "I didn't get my degree at NYU I got it later, they gave me an honourary one."
  },
  {
    "author": "Tony Hillerman",
    "category": "graduation",
    "id": 30797,
    "text": "The essays in The Great Taos Bank Robbery were my project to win a Master of Arts degree in English when I quit being a newspaper editor and went back to college."
  },
  {
    "author": "Herb Ritts",
    "category": "graduation",
    "id": 30779,
    "text": "Even though I didn't get a business degree, I enjoyed learning about economics."
  },
  {
    "author": "Bobby Scott",
    "category": "graduation",
    "id": 30743,
    "text": "It is virtually impossible to compete in today's global economy without a college degree."
  },
  {
    "author": "Fred Allen",
    "category": "graduation",
    "id": 30726,
    "text": "I learned law so well, the day I graduated I sued the college, won the case, and got my tuition back."
  },
  {
    "author": "Scott Hamilton",
    "category": "graduation",
    "id": 30747,
    "text": "I graduated a the top of my class in the '84 Olympic Games I won a gold medal."
  },
  {
    "author": "G. M. Trevelyan",
    "category": "graduation",
    "id": 30786,
    "text": "One half who graduate from college never read another book."
  },
  {
    "author": "Irvine Welsh",
    "category": "graduation",
    "id": 30750,
    "text": "I think young writers should get other degrees first, social sciences, arts degrees or even business degrees. What you learn is research skills, a necessity because a lot of writing is about trying to find information."
  },
  {
    "author": "Norman Cousins",
    "category": "graduation",
    "id": 30727,
    "text": "It makes little difference how many university courses or degrees a person may own. If he cannot use words to move an idea from one point to another, his education is incomplete."
  },
  {
    "author": "R. Lee Ermey",
    "category": "graduation",
    "id": 30735,
    "text": "Even though I disagree with many of the changes, when I see the privates graduate at the end of the day, when they walk off that drill field at the end of the ceremony, they are still fine privates outstanding, well motivated privates."
  },
  {
    "author": "Richard King",
    "category": "graduation",
    "id": 30742,
    "text": "I'm not impressed by someone's degree... I'm impressed by them making movies."
  },
  {
    "author": "Bobby Heenan",
    "category": "graduation",
    "id": 30782,
    "text": "North Dakota State. What do you have to do there to graduate? Milk a cow with your left hand?"
  },
  {
    "author": "Carol Burnett",
    "category": "graduation",
    "id": 30741,
    "text": "We don't stop going to school when we graduate."
  },
  {
    "author": "Ed O'Neill",
    "category": "graduation",
    "id": 30793,
    "text": "In the summer we graduated we flipped out completely, drinking beer, cruising in our cars and beating up each other. It was a crazy summer. That's when I started to be interested in girls."
  },
  {
    "author": "Frank Murphy",
    "category": "graduation",
    "id": 30798,
    "text": "The economy in the Valley will need to grow if students want to come back and work with their specialized degrees. We need to develop more to create more opportunities."
  },
  {
    "author": "Jim Evans",
    "category": "graduation",
    "id": 30761,
    "text": "My main objective is to prepare candidates for professional baseball however, the majority of our graduates will go home as much better qualified amateurs."
  },
  {
    "author": "Claire Danes",
    "category": "graduation",
    "id": 30763,
    "text": "I took three years off. I differentiated myself from the industry. Found my identity - sort of... I haven't graduated yet. I'm not legitimately educated yet, but maybe one day."
  },
  {
    "author": "H. G. Wells",
    "category": "graduation",
    "id": 30807,
    "text": "We are living in 1937, and our universities, I suggest, are not half-way out of the fifteenth century. We have made hardly any changes in our conception of university organization, education, graduation, for a century - for several centuries."
  },
  {
    "author": "John Keegan",
    "category": "graduation",
    "id": 30749,
    "text": "I don't look to find an educated person in the ranks of university graduates, necessarily. Some of the most educated people I know have never been near a university."
  },
  {
    "author": "Ruben Hinojosa",
    "category": "graduation",
    "id": 30819,
    "text": "While I do commend the Administration on its commitment and focus on high school reform, I believe that we must focus on graduation as the key accountability measure."
  },
  {
    "author": "T. S. Eliot",
    "category": "graduation",
    "id": 30724,
    "text": "Knowledge is invariably a matter of degree: you cannot put your finger upon even the simplest datum and say this we know."
  },
  {
    "author": "Ruben Hinojosa",
    "category": "graduation",
    "id": 30773,
    "text": "Our record number of teenagers must become our record number of high school and college graduates and our record number of teachers, scientists, doctors, lawyers, and skilled professionals."
  },
  {
    "author": "David Eddings",
    "category": "graduation",
    "id": 30790,
    "text": "I wrote a novel for my degree, and I'm very happy I didn't submit that to a publisher. I sympathize with my professors who had to read it."
  },
  {
    "author": "R. Lee Ermey",
    "category": "graduation",
    "id": 30809,
    "text": "I disagree with a lot of those changes, however at the end of the day - I go down to recruit graduation at least once or twice a year."
  },
  {
    "author": "Tim Duncan",
    "category": "graduation",
    "id": 30815,
    "text": "I have the loving support of my girlfriend who still attends Wake Forest and is nearing graduation. She helps me cope with the everyday rigors of being an NBA player."
  },
  {
    "author": "Clive James",
    "category": "graduation",
    "id": 30745,
    "text": "Everyone has a right to a university degree in America, even if it's in Hamburger Technology."
  },
  {
    "author": "Kenneth G. Wilson",
    "category": "graduation",
    "id": 30796,
    "text": "My graduate studies were carried out at the California Institute of Technology."
  },
  {
    "author": "Elizabeth Blackwell",
    "category": "graduation",
    "id": 30802,
    "text": "The idea of winning a doctor's degree gradually assumed the aspect of a great moral struggle, and the moral fight possessed immense attraction for me."
  },
  {
    "author": "Francis Ford Coppola",
    "category": "graduation",
    "id": 30737,
    "text": "When I was going for my graduate degree, I decided I was going to make a feature film as my thesis. That's what I was famous for-that I had my thesis film be a feature film, which was 'You're a Big Boy Now.'"
  },
  {
    "author": "Ted Nelson",
    "category": "graduation",
    "id": 30778,
    "text": "So in my uncertainty, I went to graduate school and there it all happened."
  },
  {
    "author": "Jerry Moran",
    "category": "graduation",
    "id": 30824,
    "text": "One of the most difficult speeches to prepare is an address to a graduation class, which is why I don't often do them."
  },
  {
    "author": "Daniel J. Evans",
    "category": "graduation",
    "id": 30788,
    "text": "I think I finally chose the graduate degree in engineering primarily because it only took one year and law school took three years, and I felt the pressure of being a little behind - although I was just 22."
  },
  {
    "author": "Jimmy Carter",
    "category": "graduation",
    "id": 30733,
    "text": "In this outward and physical ceremony we attest once again to the inner and spiritual strength of our Nation. As my high school teacher, Miss Julia Coleman, used to say: 'We must adjust to changing times and still hold to unchanging principles.'"
  },
  {
    "author": "Emma Bonino",
    "category": "graduation",
    "id": 30760,
    "text": "The knowledge of languages was very useful. I have a university degree in foreign languages and literature."
  },
  {
    "author": "Elisabeth Kubler-Ross",
    "category": "graduation",
    "id": 30805,
    "text": "I've told my children that when I die, to release balloons in the sky to celebrate that I graduated. For me, death is a graduation."
  },
  {
    "author": "Ken Buck",
    "category": "graduation",
    "id": 30804,
    "text": "I think women as well as men are concerned about jobs and the economy and spending and, and other issues. They're concerned that when their kids graduate from college they have an economy and they have a future in this country and they, they have the same opportunity that we've had and our grandparents have had."
  },
  {
    "author": "Parker Stevenson",
    "category": "graduation",
    "id": 30765,
    "text": "I could be happy doing something like architecture. It would involve another couple of years of graduate school, but that's what I studied in college. That's what I always wanted to do."
  },
  {
    "author": "Douglas Wilson",
    "category": "graduation",
    "id": 30770,
    "text": "Yeah, I spent about 20 years in a dorm room. It took me a while to graduate."
  },
  {
    "author": "Shannon Lucid",
    "category": "graduation",
    "id": 30800,
    "text": "I was really desperate. I don't know if you can remember back that far, but when I went to graduate school they didn't want females in graduate school. They were very open about it. They didn't mince their words. But then I got in and I got my degree."
  },
  {
    "author": "Katherine Dunham",
    "category": "graduation",
    "id": 30748,
    "text": "I have actually five honorary degrees."
  },
  {
    "author": "Alexis Herman",
    "category": "graduation",
    "id": 30789,
    "text": "Really, the potential for, first of all, any college graduate today is enormously good. These are good times for anyone with a college degree today, particularly African Americans. With a college degree today, you really breach the unemployment rate."
  },
  {
    "author": "Frederick Reines",
    "category": "graduation",
    "id": 30784,
    "text": "I received my undergraduate degree in engineering in 1939 and a Master of Science degree in mathematical physics in 1941 at Steven Institute of Technology."
  },
  {
    "author": "Maureen Forrester",
    "category": "graduation",
    "id": 30818,
    "text": "I thought I should go to New York because it was the place to go to study. I went and tried to get an application from the Juilliard School but they wouldn't even give me one because I didn't have my high school graduation."
  },
  {
    "author": "Clay Aiken",
    "category": "graduation",
    "id": 30753,
    "text": "I did get a degree in special education."
  },
  {
    "author": "Alan Dundes",
    "category": "graduation",
    "id": 30776,
    "text": "If a student takes the whole series of my folklore courses including the graduate seminars, he or she should learn something about fieldwork, something about bibliography, something about how to carry out library research, and something about how to publish that research."
  },
  {
    "author": "Olivia Wilde",
    "category": "graduation",
    "id": 30822,
    "text": "I fell in love with theater there, and after graduation I moved to Los Angeles to pursue acting."
  },
  {
    "author": "Julie Taymor",
    "category": "graduation",
    "id": 30821,
    "text": "Americans in particular are myopic. They're not traveling as much. When you were a college student, the next thing you would do on graduation was to take a year off and travel. That's what I did. I went to Indonesia."
  },
  {
    "author": "Ruth Ann Minner",
    "category": "graduation",
    "id": 30801,
    "text": "Our promise to our children should be this: if you do well in school, we will pay for you to obtain a college degree."
  },
  {
    "author": "Christine Gregoire",
    "category": "graduation",
    "id": 30769,
    "text": "When nearly a third of our high school students do not graduate on time with their peers, we have work to do. We must design our middle and high schools so that no student gets lost in the crowd and disconnected from his or her own potential."
  },
  {
    "author": "Patrick J. Kennedy",
    "category": "graduation",
    "id": 30751,
    "text": "For students today, only 10 percent of children from working-class families graduate from college by the age of 24 as compared to 58 percent of upper-middle-class and wealthy families."
  },
  {
    "author": "Robert M. Hutchins",
    "category": "graduation",
    "id": 30768,
    "text": "The college graduate is presented with a sheepskin to cover his intellectual nakedness."
  },
  {
    "author": "Janelle Monae",
    "category": "graduation",
    "id": 30814,
    "text": "People in my family and camp who grew up listening to rap music love 'We Are Young.' I've heard it play at weddings. I've heard it in graduation parties. It's a big idea and big song."
  },
  {
    "author": "Renee Olstead",
    "category": "graduation",
    "id": 30829,
    "text": "If you're picking your best friend based on what kind of clothes she wears or how popular she is, chances are you aren't going to stay in touch after graduation."
  },
  {
    "author": "Robert Orben",
    "category": "graduation",
    "id": 30722,
    "text": "A graduation ceremony is an event where the commencement speaker tells thousands of students dressed in identical caps and gowns that 'individuality' is the key to success."
  },
  {
    "author": "Henny Youngman",
    "category": "graduation",
    "id": 30731,
    "text": "This man used to go to school with his dog. Then they were separated. His dog graduated!"
  },
  {
    "author": "Alexandra Guarnaschelli",
    "category": "graduation",
    "id": 30826,
    "text": "I woke up on May 15, 1991, the day of my Barnard graduation, and I said to myself, 'By the end of today you will decide what you want to do with the rest of your life.'"
  },
  {
    "author": "Mark Kennedy",
    "category": "graduation",
    "id": 30766,
    "text": "I was the first boy in the Kennedy family to graduate from college."
  },
  {
    "author": "Hamilton Jordan",
    "category": "graduation",
    "id": 30806,
    "text": "I went to my son's graduation this weekend, and I heard a great quote I've never heard before from Albert Einstein. It was that the greatest danger to the world is not the bad people but it's the good people who don't speak out."
  },
  {
    "author": "Conan O'Brien",
    "category": "graduation",
    "id": 30736,
    "text": "Earlier today, Arnold Schwarzenegger criticized the California school system, calling it disastrous. Arnold says California's schools are so bad that its graduates are willing to vote for me."
  },
  {
    "author": "Erma Bombeck",
    "category": "graduation",
    "id": 30723,
    "text": "Never go to your high school reunion pregnant or they will think that is all you have done since you graduated."
  },
  {
    "author": "Gloria Stuart",
    "category": "graduation",
    "id": 30754,
    "text": "When I graduated from Santa Monica High in 1927, I was voted the girl most likely to succeed. I didn't realize it would take so long."
  },
  {
    "author": "Ruby Wax",
    "category": "graduation",
    "id": 30756,
    "text": "College atheletes used to get a degree in bringing your pencil."
  },
  {
    "author": "Leigh Steinberg",
    "category": "graduation",
    "id": 30739,
    "text": "It is soooooo necessary to get the basic skills, because by the time you graduate, undergraduate or graduate, that field would have totally changed from your first day of school."
  },
  {
    "author": "Daniel J. Evans",
    "category": "graduation",
    "id": 30787,
    "text": "I did graduate with a bachelor's degree in civil engineering in 1948."
  },
  {
    "author": "Will McDonough",
    "category": "graduation",
    "id": 30820,
    "text": "I received $100 per week when I started working at the Globe after graduation."
  },
  {
    "author": "Moira Kelly",
    "category": "graduation",
    "id": 30813,
    "text": "A few months after graduation I was working in films. It took off pretty quick."
  },
  {
    "author": "Marian Wright Edelman",
    "category": "graduation",
    "id": 30734,
    "text": "Being considerate of others will take your children further in life than any college degree."
  },
  {
    "author": "Daniel Greenberg",
    "category": "graduation",
    "id": 30759,
    "text": "Some go on to trade schools or get further training for jobs they are interested in. Some go into the arts, some are craftsmen, some take a little time out to travel, and some start their own businesses. But our graduates find and work at what they want to do."
  },
  {
    "author": "Peter Gallagher",
    "category": "graduation",
    "id": 30780,
    "text": "I was about to get a degree in economics when I accepted that I'd be a lousy businessman, and if I didn't give acting a try I'd regret it for the rest of my life."
  },
  {
    "author": "Miguel de Cervantes",
    "category": "graduation",
    "id": 30728,
    "text": "For a man to attain to an eminent degree in learning costs him time, watching, hunger, nakedness, dizziness in the head, weakness in the stomach, and other inconveniences."
  },
  {
    "author": "Martha Reeves",
    "category": "graduation",
    "id": 30817,
    "text": "The morning after my high-school graduation found me up early job hunting. The dream of college I put on the back burner."
  },
  {
    "author": "Dick Cheney",
    "category": "graduation",
    "id": 30808,
    "text": "From kindergarten to graduation, I went to public schools, and I know that they are a key to being sure that every child has a chance to succeed and to rise in the world."
  },
  {
    "author": "Laurie Anderson",
    "category": "graduation",
    "id": 30752,
    "text": "At the School of Visual Arts in New York, you can get your degree in Net art, which is really a fantastic way of thinking of theater in new ways."
  },
  {
    "author": "Dianna Agron",
    "category": "graduation",
    "id": 30816,
    "text": "I was on the yearbook staff, so I would take out film cameras and Nikons and take photos around school and at sporting events and things like that. We had a darkroom as well. I just loved it. I also saved up for a video camera to video my friends and cut and paste the videos together and I gave them to all of my friends for graduation."
  },
  {
    "author": "Al McGuire",
    "category": "graduation",
    "id": 30785,
    "text": "Remember, half the doctors in this country graduated in the bottom half of their class."
  },
  {
    "author": "Lee Pace",
    "category": "graduation",
    "id": 30827,
    "text": "A month before graduation I got an off-Broadway job. Then I did some commercials, including one for MCI. You can only see half of me, but it paid well. Thank God for commercials."
  },
  {
    "author": "Faith Hill",
    "category": "graduation",
    "id": 30767,
    "text": "Everybody wants you to do good things, but in a small town you pretty much graduate and get married. Mostly you marry, have children and go to their football games."
  },
  {
    "author": "Christina Aguilera",
    "category": "graduation",
    "id": 30730,
    "text": "I always wanted to have my own album released before I graduated from high school."
  },
  {
    "author": "Robert Sternberg",
    "category": "graduation",
    "id": 30774,
    "text": "ACT and SAT each have their own parts of the country. The GRE has its lock on graduate admissions. And so, one could blame the companies, but really, economically, they have no incentive to change things very much because they're getting the business."
  },
  {
    "author": "Jillian Bach",
    "category": "graduation",
    "id": 30803,
    "text": "My personal advice is to go to school first and get a liberal arts education, and then if you want to pursue acting, go to graduate school."
  },
  {
    "author": "Elbert Hubbard",
    "category": "graduation",
    "id": 30721,
    "text": "God will not look you over for medals degrees or diplomas, but for scars."
  },
  {
    "author": "James Green Somerville",
    "category": "graduation",
    "id": 30794,
    "text": "I dropped out of school for a semester, transferred to another college, switched to an art major, graduated, got married, and for a while worked as a graphic designer."
  },
  {
    "author": "Carol P. Christ",
    "category": "graduation",
    "id": 30744,
    "text": "I first became interested in women and religion when I was one of the few women doing graduate work in Religious Studies at Yale University in the late 1960's."
  },
  {
    "author": "James D'arcy",
    "category": "graduation",
    "id": 30823,
    "text": "It was only when I finished the course and left my graduation diploma on the bus that I realised I'd become an actor."
  }
]

quotes['great'] = [
  {
    "author": "Ambrose Bierce",
    "category": "great",
    "id": 31410,
    "text": "Irreligion - the principal one of the great faiths of the world."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "great",
    "id": 31014,
    "text": "Great men or men of great gifts you shall easily find, but symmetrical men never."
  },
  {
    "author": "Walt Whitman",
    "category": "great",
    "id": 31496,
    "text": "Produce great men, the rest follows."
  },
  {
    "author": "Edmund Burke",
    "category": "great",
    "id": 31396,
    "text": "Justice is itself the great standing policy of civil society and any eminent departure from it, under any circumstances, lies under the suspicion of being no policy at all."
  },
  {
    "author": "Mitt Romney",
    "category": "great",
    "id": 31229,
    "text": "That business we started with 10 people has now grown into a great American success story."
  },
  {
    "author": "Michael Jordan",
    "category": "great",
    "id": 31023,
    "text": "For a competitive junkie like me, golf is a great solution because it smacks you in the face every time you think you have accomplished something. That to me has taken over a lot of the energy and competitiveness for basketball."
  },
  {
    "author": "Joseph Addison",
    "category": "great",
    "id": 31558,
    "text": "A cloudy day or a little sunshine have as great an influence on many constitutions as the most recent blessings or misfortunes."
  },
  {
    "author": "Sachin Tendulkar",
    "category": "great",
    "id": 31778,
    "text": "And that is the reason why this victory is great, because different players have made contributions to the win."
  },
  {
    "author": "Willa Cather",
    "category": "great",
    "id": 31091,
    "text": "Where there is great love, there are always wishes."
  },
  {
    "author": "Louisa May Alcott",
    "category": "great",
    "id": 31343,
    "text": "You have a good many little gifts and virtues, but there is no need of parading them, for conceit spoils the finest genius. There is not much danger that real talent or goodness will be overlooked long, and the great charm of all power is modesty."
  },
  {
    "author": "Voltaire",
    "category": "great",
    "id": 31144,
    "text": "One great use of words is to hide our thoughts."
  },
  {
    "author": "Thomas Carlyle",
    "category": "great",
    "id": 31376,
    "text": "I grow daily to honour facts more and more, and theory less and less. A fact, it seems to me, is a great thing a sentence printed, if not by God, then at least by the Devil."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "great",
    "id": 31792,
    "text": "I am a big believer in education, because when I grew up in Austria - when I grew up in Austria I had a great education. I had great teachers."
  },
  {
    "author": "Cat Stevens",
    "category": "great",
    "id": 31422,
    "text": "In a World where people are surrounded by darkness, ignorance and fear, it is a sign of hope to be celebrating Islam's message of peace and light, and the last great Messenger, born and chosen to deliver them to all mankind."
  },
  {
    "author": "Lao Tzu",
    "category": "great",
    "id": 30922,
    "text": "Do the difficult things while they are easy and do the great things while they are small. A journey of a thousand miles must begin with a single step."
  },
  {
    "author": "Campbell Scott",
    "category": "great",
    "id": 31613,
    "text": "Working hard is great, being lazy sometimes is great, but failed potential is the worst."
  },
  {
    "author": "Oscar Wilde",
    "category": "great",
    "id": 30925,
    "text": "No great artist ever sees things as they really are. If he did, he would cease to be an artist."
  },
  {
    "author": "Samuel Smiles",
    "category": "great",
    "id": 31464,
    "text": "The very greatest things - great thoughts, discoveries, inventions - have usually been nurtured in hardship, often pondered over in sorrow, and at length established with difficulty."
  },
  {
    "author": "Elsa Schiaparelli",
    "category": "great",
    "id": 31786,
    "text": "Eating is not merely a material pleasure. Eating well gives a spectacular joy to life and contributes immensely to goodwill and happy companionship. It is of great importance to the morale."
  },
  {
    "author": "Omar Khayyam",
    "category": "great",
    "id": 31443,
    "text": "Myself when young did eagerly frequent doctor and saint, and heard great argument about it and about: but evermore came out by the same door as in I went."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "great",
    "id": 31662,
    "text": "A great revolution in just one single individual will help achieve a change in the destiny of a society and, further, will enable a change in the destiny of humankind."
  },
  {
    "author": "Henry Wadsworth Longfellow",
    "category": "great",
    "id": 31217,
    "text": "Lives of great men all remind us, we can make our lives sublime, and, departing, leave behind us, footprints on the sands of time."
  },
  {
    "author": "Matthew Modine",
    "category": "great",
    "id": 31819,
    "text": "We should all aspire in life to do a multitude of things well - to be a great father, to be a good husband, to be a good lover, you know, to try to do things the best you can is very important to me."
  },
  {
    "author": "Saint Augustine",
    "category": "great",
    "id": 31430,
    "text": "Who can map out the various forces at play in one soul? Man is a great depth, O Lord. The hairs of his head are easier by far to count than his feeling, the movements of his heart."
  },
  {
    "author": "Pythagoras",
    "category": "great",
    "id": 31794,
    "text": "It is better wither to be silent, or to say things of more value than silence. Sooner throw a pearl at hazard than an idle or useless word and do not say a little in many words, but a great deal in a few."
  },
  {
    "author": "Nelson Mandela",
    "category": "great",
    "id": 30847,
    "text": "After climbing a great hill, one only finds that there are many more hills to climb."
  },
  {
    "author": "Maya Angelou",
    "category": "great",
    "id": 30912,
    "text": "My life has been one great big joke, a dance that's walked a song that's spoke, I laugh so hard I almost choke when I think about myself."
  },
  {
    "author": "Robert Frost",
    "category": "great",
    "id": 31043,
    "text": "There never was any heart truly great and generous, that was not also tender and compassionate."
  },
  {
    "author": "Laura Schlessinger",
    "category": "great",
    "id": 31795,
    "text": "Children are our second chance to have a great parent-child relationship."
  },
  {
    "author": "Fyodor Dostoevsky",
    "category": "great",
    "id": 30873,
    "text": "The greatest happiness is to know the source of unhappiness."
  },
  {
    "author": "Woodrow Wilson",
    "category": "great",
    "id": 31362,
    "text": "A little group of willful men, representing no opinion but their own, have rendered the great government of the United States helpless and contemptible."
  },
  {
    "author": "Michael Jackson",
    "category": "great",
    "id": 31201,
    "text": "The Bee Gees who are brilliant, I just love great music."
  },
  {
    "author": "Robert Frost",
    "category": "great",
    "id": 31065,
    "text": "The figure a poem makes. It begins in delight and ends in wisdom... in a clarification of life - not necessarily a great clarification, such as sects and cults are founded on, but in a momentary stay against confusion."
  },
  {
    "author": "Pablo Picasso",
    "category": "great",
    "id": 31268,
    "text": "What might be taken for a precocious genius is the genius of childhood. When the child grows up, it disappears without a trace. It may happen that this boy will become a real painter some day, or even a great painter. But then he will have to begin everything again, from zero."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "great",
    "id": 31275,
    "text": "The bravest sight in the world is to see a great man struggling against adversity."
  },
  {
    "author": "Hillary Clinton",
    "category": "great",
    "id": 31290,
    "text": "Going out and playing football or baseball with the boys, when I was a tomboy, was a great way to learn about winning and losing, and most girls didn't have that experience."
  },
  {
    "author": "Mitt Romney",
    "category": "great",
    "id": 31206,
    "text": "Like me, the great majority of Americans wish both to preserve the traditional definition of marriage and to oppose bias and intolerance directed towards gays and lesbians."
  },
  {
    "author": "Victor Hugo",
    "category": "great",
    "id": 31300,
    "text": "Well, for us, in history where goodness is a rare pearl, he who was good almost takes precedence over he who was great."
  },
  {
    "author": "Samuel Johnson",
    "category": "great",
    "id": 31437,
    "text": "Great works are performed not by strength but by perseverance."
  },
  {
    "author": "Joseph Addison",
    "category": "great",
    "id": 31656,
    "text": "Books are the legacies that a great genius leaves to mankind, which are delivered down from generation to generation as presents to the posterity of those who are yet unborn."
  },
  {
    "author": "Emily Dickinson",
    "category": "great",
    "id": 31526,
    "text": "After great pain, a formal feeling comes. The Nerves sit ceremonious, like tombs."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "great",
    "id": 31185,
    "text": "I never weary of great churches. It is my favorite kind of mountain scenery. Mankind was never so happily inspired as when it made a cathedral."
  },
  {
    "author": "Khalil Gibran",
    "category": "great",
    "id": 30997,
    "text": "Pain and foolishness lead to great bliss and complete knowledge, for Eternal Wisdom created nothing under the sun in vain."
  },
  {
    "author": "Giorgos Seferis",
    "category": "great",
    "id": 31788,
    "text": "Every man of action has a strong dose of egoism, pride, hardness, and cunning. But all those things will be regarded as high qualities if he can make them the means to achieve great ends."
  },
  {
    "author": "Jeff Foxworthy",
    "category": "great",
    "id": 31538,
    "text": "That's the great thing about a tractor. You can't really hear the phone ring."
  },
  {
    "author": "James Dean",
    "category": "great",
    "id": 31630,
    "text": "There is no way to be truly great in this world. We are all impaled on the crook of conditioning."
  },
  {
    "author": "Charles Spurgeon",
    "category": "great",
    "id": 31086,
    "text": "Wisdom is the right use of knowledge. To know is not to be wise. Many men know a great deal, and are all the greater fools for it. There is no fool so great a fool as a knowing fool. But to know how to use knowledge is to have wisdom."
  },
  {
    "author": "Jacques Yves Cousteau",
    "category": "great",
    "id": 31803,
    "text": "The sea, the great unifier, is man's only hope. Now, as never before, the old phrase has a literal meaning: we are all in the same boat."
  },
  {
    "author": "W. C. Fields",
    "category": "great",
    "id": 31226,
    "text": "Show me a great actor and I'll show you a lousy husband. Show me a great actress, and you've seen the devil."
  },
  {
    "author": "Winston Churchill",
    "category": "great",
    "id": 30940,
    "text": "I always seem to get inspiration and renewed vitality by contact with this great novel land of yours which sticks up out of the Atlantic."
  },
  {
    "author": "Joel Osteen",
    "category": "great",
    "id": 31084,
    "text": "People respond when you tell them there is a great future in front of you, you can leave your past behind."
  },
  {
    "author": "Donald Trump",
    "category": "great",
    "id": 31602,
    "text": "It's a great thing when you can show that you've been successful and that you've made a lot of money and that you've employed a lot of people."
  },
  {
    "author": "George Orwell",
    "category": "great",
    "id": 31246,
    "text": "The great enemy of clear language is insincerity. When there is a gap between one's real and one's declared aims, one turns, as it were, instinctively to long words and exhausted idioms, like a cuttlefish squirting out ink."
  },
  {
    "author": "Plato",
    "category": "great",
    "id": 30861,
    "text": "The greatest wealth is to live content with little."
  },
  {
    "author": "Plato",
    "category": "great",
    "id": 31109,
    "text": "Nothing in the affairs of men is worthy of great anxiety."
  },
  {
    "author": "Anatole France",
    "category": "great",
    "id": 31761,
    "text": "Religion has done love a great service by making it a sin."
  },
  {
    "author": "Jeff Bezos",
    "category": "great",
    "id": 31684,
    "text": "If you do build a great experience, customers tell each other about that. Word of mouth is very powerful."
  },
  {
    "author": "Alan Watts",
    "category": "great",
    "id": 31784,
    "text": "You are that vast thing that you see far, far off with great telescopes."
  },
  {
    "author": "Igor Stravinsky",
    "category": "great",
    "id": 31632,
    "text": "Lesser artists borrow, great artists steal."
  },
  {
    "author": "Lord Byron",
    "category": "great",
    "id": 31675,
    "text": "I have great hopes that we shall love each other all our lives as much as if we had never married at all."
  },
  {
    "author": "Robert Kennedy",
    "category": "great",
    "id": 30845,
    "text": "Only those who dare to fail greatly can ever achieve greatly."
  },
  {
    "author": "Leon Trotsky",
    "category": "great",
    "id": 31108,
    "text": "Life is not an easy matter... You cannot live through it without falling into frustration and cynicism unless you have before you a great idea which raises you above personal misery, above weakness, above all kinds of perfidy and baseness."
  },
  {
    "author": "John Wooden",
    "category": "great",
    "id": 30969,
    "text": "Material possessions, winning scores, and great reputations are meaningless in the eyes of the Lord, because He knows what we really are and that is all that matters."
  },
  {
    "author": "Marcus Aurelius",
    "category": "great",
    "id": 30864,
    "text": "A man's worth is no greater than his ambitions."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "great",
    "id": 31340,
    "text": "There is none made so great, but he may both need the help and service, and stand in fear of the power and unkindness, even of the meanest of mortals."
  },
  {
    "author": "Katherine Mansfield",
    "category": "great",
    "id": 31057,
    "text": "I always felt that the great high privilege, relief and comfort of friendship was that one had to explain nothing."
  },
  {
    "author": "Thomas Carlyle",
    "category": "great",
    "id": 31262,
    "text": "The three great elements of modern civilization, Gun powder, Printing, and the Protestant religion."
  },
  {
    "author": "Jim Capaldi",
    "category": "great",
    "id": 31671,
    "text": "Traffic was very, very free. It was great."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "great",
    "id": 31542,
    "text": "Too great haste to repay an obligation is a kind of ingratitude."
  },
  {
    "author": "Andrew Jackson",
    "category": "great",
    "id": 31409,
    "text": "The planter, the farmer, the mechanic, and the laborer... form the great body of the people of the United States, they are the bone and sinew of the country men who love liberty and desire nothing but equal rights and equal laws."
  },
  {
    "author": "Saint Augustine",
    "category": "great",
    "id": 31424,
    "text": "Our bodies are shaped to bear children, and our lives are a working out of the processes of creation. All our ambitions and intelligence are beside that great elemental point."
  },
  {
    "author": "Coretta Scott King",
    "category": "great",
    "id": 31202,
    "text": "Hate is too great a burden to bear. It injures the hater more than it injures the hated."
  },
  {
    "author": "John Ruskin",
    "category": "great",
    "id": 31646,
    "text": "Every great person is always being helped by everybody for their gift is to get good out of all things and all persons."
  },
  {
    "author": "Victor Hugo",
    "category": "great",
    "id": 30996,
    "text": "Have courage for the great sorrows of life and patience for the small ones and when you have laboriously accomplished your daily task, go to sleep in peace."
  },
  {
    "author": "Voltaire",
    "category": "great",
    "id": 31161,
    "text": "The infinitely little have a pride infinitely great."
  },
  {
    "author": "Rainer Maria Rilke",
    "category": "great",
    "id": 31350,
    "text": "No great art has ever been made without the artist having known danger."
  },
  {
    "author": "Bill Gates",
    "category": "great",
    "id": 31197,
    "text": "I'm sorry that we have to have a Washington presence. We thrived during our first 16 years without any of this. I never made a political visit to Washington and we had no people here. It wasn't on our radar screen. We were just making great software."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "great",
    "id": 31435,
    "text": "Great is the power of habit. It teaches us to bear fatigue and to despise wounds and pain."
  },
  {
    "author": "George Whitefield",
    "category": "great",
    "id": 31544,
    "text": "The great and important duty which is incumbent on Christians, is to guard against all appearance of evil to watch against the first risings in the heart to evil and to have a guard upon our actions, that they may not be sinful, or so much as seem to be so."
  },
  {
    "author": "Jean-Jacques Rousseau",
    "category": "great",
    "id": 31331,
    "text": "People who know little are usually great talkers, while men who know much say little."
  },
  {
    "author": "Edmund Burke",
    "category": "great",
    "id": 31348,
    "text": "We must all obey the great law of change. It is the most powerful law of nature."
  },
  {
    "author": "Colin Powell",
    "category": "great",
    "id": 31664,
    "text": "Wouldn't it be great if we could look forward to a whole world in which no child will be left behind?"
  },
  {
    "author": "Oscar Wilde",
    "category": "great",
    "id": 30929,
    "text": "A little sincerity is a dangerous thing, and a great deal of it is absolutely fatal."
  },
  {
    "author": "Donald Trump",
    "category": "great",
    "id": 31599,
    "text": "A lot of people feel very good about Mitt Romney and I think he's going to do a great job."
  },
  {
    "author": "Pope John XXIII",
    "category": "great",
    "id": 31361,
    "text": "See everything, overlook a great deal, correct a little."
  },
  {
    "author": "Francis Bacon",
    "category": "great",
    "id": 31607,
    "text": "He that hath wife and children hath given hostages to fortune for they are impediments to great enterprises, either of virtue or mischief."
  },
  {
    "author": "Luther Burbank",
    "category": "great",
    "id": 31708,
    "text": "I see humanity now as one vast plant, needing for its highest fulfillment only love, the natural blessings of the great outdoors, and intelligent crossing and selection."
  },
  {
    "author": "Benjamin Franklin",
    "category": "great",
    "id": 30989,
    "text": "Human felicity is produced not as much by great pieces of good fortune that seldom happen as by little advantages that occur every day."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "great",
    "id": 31578,
    "text": "King Louis Philippe once said to me that he attributed the great success of the British nation in political life to their talking politics after dinner."
  },
  {
    "author": "Alexis de Tocqueville",
    "category": "great",
    "id": 31820,
    "text": "He was as great as a man can be without morality."
  },
  {
    "author": "Paulo Coelho",
    "category": "great",
    "id": 31291,
    "text": "In the United States, I am a great success, but I am not a celebrity."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "great",
    "id": 31288,
    "text": "There is no great genius without some touch of madness."
  },
  {
    "author": "Andrew Jackson",
    "category": "great",
    "id": 31434,
    "text": "The great constitutional corrective in the hands of the people against usurpation of power, or corruption by their agents is the right of suffrage and this when used with calmness and deliberation will prove strong enough."
  },
  {
    "author": "Billy Graham",
    "category": "great",
    "id": 31310,
    "text": "We're a diverse society, and I think the TV is doing a great job in showing that we're all human beings, that we can all get along, that we can all be together, and I think that's a marvelous thing."
  },
  {
    "author": "Mitt Romney",
    "category": "great",
    "id": 30862,
    "text": "And the American people are the greatest people in the world. What makes America the greatest nation in the world is the heart of the American people: hardworking, innovative, risk-taking, God- loving, family-oriented American people."
  },
  {
    "author": "Billy Graham",
    "category": "great",
    "id": 31351,
    "text": "A lot of Jews are great friends of mine."
  },
  {
    "author": "E. B. White",
    "category": "great",
    "id": 31215,
    "text": "Prejudice is a great time saver. You can form opinions without having to get the facts."
  },
  {
    "author": "Arthur Schopenhauer",
    "category": "great",
    "id": 31636,
    "text": "Great minds are related to the brief span of time during which they live as great buildings are to a little square in which they stand: you cannot see them in all their magnitude because you are standing too close to them."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "great",
    "id": 30959,
    "text": "Great ambition is the passion of a great character. Those endowed with it may perform very good or very bad acts. All depends on the principles which direct them."
  },
  {
    "author": "Madeleine Albright",
    "category": "great",
    "id": 31682,
    "text": "I really think that there was a great advantage in many ways to being a woman. I think we are a lot better at personal relationships, and then have the capability obviously of telling it like it is when it's necessary."
  }
]

quotes['happiness'] = [
  {
    "author": "Maurice Chevalier",
    "category": "happiness",
    "id": 31915,
    "text": "If you wait for the perfect moment when all is safe and assured, it may never arrive. Mountains will not be climbed, races won, or lasting happiness achieved."
  },
  {
    "author": "Fiona Shaw",
    "category": "happiness",
    "id": 32516,
    "text": "There once was a demographic survey done to determine if money was connected to happiness and Ireland was the only place where this did not turn out to be true."
  },
  {
    "author": "George Burns",
    "category": "happiness",
    "id": 31994,
    "text": "Happiness is having a large, loving, caring, close-knit family in another city."
  },
  {
    "author": "Louise Hart",
    "category": "happiness",
    "id": 32220,
    "text": "Self-esteem is as important to our well-being as legs are to a table. It is essential for physical and mental health and for happiness."
  },
  {
    "author": "Alain Delon",
    "category": "happiness",
    "id": 32778,
    "text": "I knew everything and received everything. But real happiness, is giving."
  },
  {
    "author": "Adam Clarke",
    "category": "happiness",
    "id": 32597,
    "text": "Now an infinite happiness cannot be purchased by any price less than that which is infinite in value and infinity of merit can only result from a nature that is infinitely divine or perfect."
  },
  {
    "author": "Emma Thompson",
    "category": "happiness",
    "id": 32370,
    "text": "We've got people looking at our seamy side and our sad side a lot of the time because that's easier. It's much more difficult to make a film about happiness with lots of jokes in it."
  },
  {
    "author": "Franz Schubert",
    "category": "happiness",
    "id": 32431,
    "text": "You believe happiness to be derived from the place in which once you have been happy, but in truth it is centered in ourselves."
  },
  {
    "author": "Charles Spurgeon",
    "category": "happiness",
    "id": 31843,
    "text": "It is not how much we have, but how much we enjoy, that makes happiness."
  },
  {
    "author": "Seal",
    "category": "happiness",
    "id": 32640,
    "text": "The arrival of any child brings you a lot of happiness."
  },
  {
    "author": "Carl Jung",
    "category": "happiness",
    "id": 32045,
    "text": "The word 'happiness' would lose its meaning if it were not balanced by sadness."
  },
  {
    "author": "Lafcadio Hearn",
    "category": "happiness",
    "id": 32344,
    "text": "But what is after all the happiness of mere power? There is a greater happiness possible than to be lord of heaven and earth that is the happiness of being truly loved."
  },
  {
    "author": "Maxwell Maltz",
    "category": "happiness",
    "id": 32291,
    "text": "We are built to conquer environment, solve problems, achieve goals, and we find no real satisfaction or happiness in life without obstacles to conquer and goals to achieve."
  },
  {
    "author": "Miuccia Prada",
    "category": "happiness",
    "id": 32393,
    "text": "It's horrible when people are only interested in buying labels, because it doesn't bring them the happiness they think it will."
  },
  {
    "author": "Marguerite Duras",
    "category": "happiness",
    "id": 32596,
    "text": "The house a woman creates is a Utopia. She can't help it - can't help trying to interest her nearest and dearest not in happiness itself but in the search for it."
  },
  {
    "author": "William S. Burroughs",
    "category": "happiness",
    "id": 32114,
    "text": "Happiness is a byproduct of function, purpose, and conflict those who seek happiness for itself seek victory without war."
  },
  {
    "author": "Helen Keller",
    "category": "happiness",
    "id": 31848,
    "text": "Everything has its wonders, even darkness and silence, and I learn, whatever state I may be in, therein to be content."
  },
  {
    "author": "Bennett Miller",
    "category": "happiness",
    "id": 32770,
    "text": "I think I am missing a gene that most people have to enable them to feel happiness about success and these kind of things."
  },
  {
    "author": "Donny Osmond",
    "category": "happiness",
    "id": 32482,
    "text": "The mindset of chasing that next #1 record doesn't exist for me anymore. It's more about being a well-rounded entertainer than being a pop artist. Obviously, it would be wonderful to have a hit record but I don't base my happiness on that anymore. It's about the accomplishment of a project that satisfies me. I just want to enjoy the ride."
  },
  {
    "author": "Andy Rooney",
    "category": "happiness",
    "id": 31891,
    "text": "Happiness depends more on how life strikes you than on what happens."
  },
  {
    "author": "George Santayana",
    "category": "happiness",
    "id": 32126,
    "text": "A string of excited, fugitive, miscellaneous pleasures is not happiness happiness resides in imaginative reflection and judgment, when the picture of one's life, or of human life, as it truly has been or is, satisfies the will, and is gladly accepted."
  },
  {
    "author": "Paul Sweeney",
    "category": "happiness",
    "id": 32529,
    "text": "How often we fail to realize our good fortune in living in a country where happiness is more than a lack of tragedy."
  },
  {
    "author": "Michael J. Fox",
    "category": "happiness",
    "id": 32104,
    "text": "My happiness grows in direct proportion to my acceptance, and in inverse proportion to my expectations."
  },
  {
    "author": "Thornton Wilder",
    "category": "happiness",
    "id": 32402,
    "text": "When God loves a creature he wants the creature to know the highest happiness and the deepest misery He wants him to know all that being alive can bring. That is his best gift. There is no happiness save in understanding the whole."
  },
  {
    "author": "Maurice Maeterlinck",
    "category": "happiness",
    "id": 32636,
    "text": "Many a happiness in life, as many a disaster, can be due to chance, but the peace within us can never be governed by chance."
  },
  {
    "author": "Billy Ocean",
    "category": "happiness",
    "id": 32690,
    "text": "Success can create more madness than happiness."
  },
  {
    "author": "Logan P. Smith",
    "category": "happiness",
    "id": 32403,
    "text": "Happiness is a wine of the rarest vintage, and seems insipid to a vulgar taste."
  },
  {
    "author": "Henry Ford",
    "category": "happiness",
    "id": 32052,
    "text": "Wealth, like happiness, is never attained when sought after directly. It comes as a by-product of providing a useful service."
  },
  {
    "author": "Euripides",
    "category": "happiness",
    "id": 31924,
    "text": "Happiness is brief. It will not stay. God batters at its sails."
  },
  {
    "author": "Adrian Grenier",
    "category": "happiness",
    "id": 32351,
    "text": "It's enough to indulge and to be selfish but true happiness is really when you start giving back."
  },
  {
    "author": "Leigh Hunt",
    "category": "happiness",
    "id": 32724,
    "text": "The groundwork of all happiness is health."
  },
  {
    "author": "Aeschylus",
    "category": "happiness",
    "id": 32254,
    "text": "And one who is just of his own free will shall not lack for happiness and he will never come to utter ruin."
  },
  {
    "author": "Helen Keller",
    "category": "happiness",
    "id": 31979,
    "text": "Your success and happiness lies in you. Resolve to keep happy, and your joy and you shall form an invincible host against difficulties."
  },
  {
    "author": "Eric Hoffer",
    "category": "happiness",
    "id": 32251,
    "text": "The search for happiness is one of the chief sources of unhappiness."
  },
  {
    "author": "Thomas Szasz",
    "category": "happiness",
    "id": 32442,
    "text": "Happiness is an imaginary condition, formerly attributed by the living to the dead, now usually attributed by adults to children, and by children to adults."
  },
  {
    "author": "Kin Hubbard",
    "category": "happiness",
    "id": 31923,
    "text": "It's pretty hard to tell what does bring happiness poverty and wealth have both failed."
  },
  {
    "author": "Ogden Nash",
    "category": "happiness",
    "id": 32261,
    "text": "There is only one way to achieve happiness on this terrestrial ball, and that is to have either a clear conscience or none at all."
  },
  {
    "author": "Taylor Swift",
    "category": "happiness",
    "id": 32177,
    "text": "I have this really high priority on happiness and finding something to be happy about."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "happiness",
    "id": 32065,
    "text": "The art of being happy lies in the power of extracting happiness from common things."
  },
  {
    "author": "James Madison",
    "category": "happiness",
    "id": 32205,
    "text": "To suppose that any form of government will secure liberty or happiness without any virtue in the people, is a chimerical idea."
  },
  {
    "author": "William E. Gladstone",
    "category": "happiness",
    "id": 31838,
    "text": "Be happy with what you have and are, be generous with both, and you won't have to hunt for happiness."
  },
  {
    "author": "David Hyde Pierce",
    "category": "happiness",
    "id": 32686,
    "text": "I was as happy doing theater in New York for little or no money as I am now doing television for more money. The happiness, I guess, comes out of it being a good job. The success has to do with the fact that it's a good job that will continue."
  },
  {
    "author": "J. Donald Walters",
    "category": "happiness",
    "id": 32120,
    "text": "Happiness is not a brilliant climax to years of grim struggle and anxiety. It is a long succession of little decisions simply to be happy in the moment."
  },
  {
    "author": "Garth Brooks",
    "category": "happiness",
    "id": 32245,
    "text": "Happiness isn't getting what you want, it's wanting what you got."
  },
  {
    "author": "Justin Long",
    "category": "happiness",
    "id": 32734,
    "text": "If you can measure success in this business based on happiness alone I feel like I've hit the lottery."
  },
  {
    "author": "John Gunther",
    "category": "happiness",
    "id": 32422,
    "text": "All happiness depends on a leisurely breakfast."
  },
  {
    "author": "Oliver Goldsmith",
    "category": "happiness",
    "id": 32274,
    "text": "Romance and novel paint beauty in colors more charming than nature, and describe a happiness that humans never taste. How deceptive and destructive are those pictures of consummate bliss!"
  },
  {
    "author": "Bertrand Russell",
    "category": "happiness",
    "id": 31905,
    "text": "Man needs, for his happiness, not only the enjoyment of this or that, but hope and enterprise and change."
  },
  {
    "author": "Tom Wilson",
    "category": "happiness",
    "id": 32545,
    "text": "Happiness doesn't depend on how much you have to enjoy, but how much you enjoy what you have."
  },
  {
    "author": "Aeschylus",
    "category": "happiness",
    "id": 32197,
    "text": "Happiness is a choice that requires effort at times."
  },
  {
    "author": "H. Jackson Brown, Jr.",
    "category": "happiness",
    "id": 32048,
    "text": "Success is getting what you want. Happiness is liking what you get."
  },
  {
    "author": "Thomas Jefferson",
    "category": "happiness",
    "id": 31973,
    "text": "If we can but prevent the government from wasting the labours of the people, under the pretence of taking care of them, they must become happy."
  },
  {
    "author": "Loretta Lynn",
    "category": "happiness",
    "id": 32433,
    "text": "My life has run from misery to happiness."
  },
  {
    "author": "Baruch Spinoza",
    "category": "happiness",
    "id": 31889,
    "text": "All happiness or unhappiness solely depends upon the quality of the object to which we are attached by love."
  },
  {
    "author": "William Law",
    "category": "happiness",
    "id": 32397,
    "text": "All people desire what they believe will make them happy. If a person is not full of desire for God, we can only conclude that he is engaged with another happiness."
  },
  {
    "author": "Letty Cottin Pogrebin",
    "category": "happiness",
    "id": 32810,
    "text": "Although Freud said happiness is composed of love and work, reality often forces us to choose love or work."
  },
  {
    "author": "Donna Rice",
    "category": "happiness",
    "id": 32697,
    "text": "Before the boat docked, however, he confessed because he was contemplating running for president, he couldn't separate from his wife. I believed him when he told me he faced a difficult choice between pursuing personal happiness and his political destiny."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "happiness",
    "id": 32090,
    "text": "Where fear is, happiness is not."
  },
  {
    "author": "Ai Weiwei",
    "category": "happiness",
    "id": 32524,
    "text": "This nation is notorious for its ability to make or fake anything cheaply. 'Made-in-China' goods now fill homes around the world. But our giant country has a small problem. We can't manufacture the happiness of our people."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "happiness",
    "id": 32134,
    "text": "The happiness and misery of men depend no less on temper than fortune."
  },
  {
    "author": "Nadia Giosia",
    "category": "happiness",
    "id": 32653,
    "text": "First and foremost, you've got to make yourself happy. Essentially being who you are is the most important thing. When you're after truth, happiness always comes."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "happiness",
    "id": 32248,
    "text": "Genuine happiness can only be achieved when we transform our way of life from the unthinking pursuit of pleasure to one committed to enriching our inner lives, when we focus on 'being more' rather than simply having more."
  },
  {
    "author": "Orson Pratt",
    "category": "happiness",
    "id": 32674,
    "text": "An order of government, established by such an all-wise, powerful being, must be good and perfect, and must be calculated to promote the permanent peace, happiness, and well-being of all his subjects."
  },
  {
    "author": "John Buchan",
    "category": "happiness",
    "id": 32672,
    "text": "There may be Peace without Joy, and Joy without Peace, but the two combined make Happiness."
  },
  {
    "author": "Gabriel Garcia Marquez",
    "category": "happiness",
    "id": 32268,
    "text": "Always remember that the most important thing in a good marriage is not happiness, but stability."
  },
  {
    "author": "Linus Pauling",
    "category": "happiness",
    "id": 31955,
    "text": "Satisfaction of one's curiosity is one of the greatest sources of happiness in life."
  },
  {
    "author": "Anthony Storr",
    "category": "happiness",
    "id": 32765,
    "text": "If we did not look to marriage as the principal source of happiness, fewer marriages would end in tears."
  },
  {
    "author": "Islom Karimov",
    "category": "happiness",
    "id": 32793,
    "text": "I say there is not more happiness for me than the freedom of my Homeland."
  },
  {
    "author": "Francis Hutcheson",
    "category": "happiness",
    "id": 32819,
    "text": "That action is best which procures the greatest happiness for the greatest numbers."
  },
  {
    "author": "Richard Dreyfuss",
    "category": "happiness",
    "id": 32659,
    "text": "Happiness has a bad rap. People say it shouldn't be your goal in life. Oh, yes it should."
  },
  {
    "author": "Blaise Pascal",
    "category": "happiness",
    "id": 32113,
    "text": "Imagination disposes of everything it creates beauty, justice, and happiness, which are everything in this world."
  },
  {
    "author": "Henry James Sumner Maine",
    "category": "happiness",
    "id": 32744,
    "text": "Law is stable the societies we are speaking of are progressive. The greater or less happiness of a people depends on the degree of promptitude with which the gulf is narrowed."
  },
  {
    "author": "Confucius",
    "category": "happiness",
    "id": 32011,
    "text": "They must often change, who would be constant in happiness or wisdom."
  },
  {
    "author": "Brandon Boyd",
    "category": "happiness",
    "id": 32395,
    "text": "I learned from a very young age that if I pursued the things that truly excited me, that they would reward in more important ways, like happiness."
  },
  {
    "author": "Peter MacKay",
    "category": "happiness",
    "id": 32757,
    "text": "I find happiness comes from numerous sources in my life. Most often, the happy moments I cherish most are quiet moments with my wife and family back home in Nova Scotia."
  },
  {
    "author": "Abdul Kalam",
    "category": "happiness",
    "id": 32042,
    "text": "Be more dedicated to making solid achievements than in running after swift but synthetic happiness."
  },
  {
    "author": "Henry Drummond",
    "category": "happiness",
    "id": 32326,
    "text": "Happiness... consists in giving, and in serving others."
  },
  {
    "author": "Sophocles",
    "category": "happiness",
    "id": 32239,
    "text": "When a man has lost all happiness, he's not alive. Call him a breathing corpse."
  },
  {
    "author": "Sheryl Swoopes",
    "category": "happiness",
    "id": 32627,
    "text": "To me, the most important thing is happiness."
  },
  {
    "author": "Anita Baker",
    "category": "happiness",
    "id": 32238,
    "text": "Completeness? Happiness? These words don't come close to describing my emotions. There truly is nothing I can say to capture what motherhood means to me, particularly given my medical history."
  },
  {
    "author": "William Cobbett",
    "category": "happiness",
    "id": 32526,
    "text": "Happiness, or misery, is in the mind. It is the mind that lives."
  },
  {
    "author": "Emmylou Harris",
    "category": "happiness",
    "id": 32611,
    "text": "My parents were not very happy. They were very worried about me pursuing a career that even if I had talent might not give me the happiness and the success that they - any parent hopes for their child."
  },
  {
    "author": "Gertrude Jekyll",
    "category": "happiness",
    "id": 32669,
    "text": "The lesson I have thoroughly learnt, and wish to pass on to others, is to know the enduring happiness that the love of a garden gives."
  },
  {
    "author": "Richard Whately",
    "category": "happiness",
    "id": 32594,
    "text": "Happiness is no laughing matter."
  },
  {
    "author": "Leona Lewis",
    "category": "happiness",
    "id": 32469,
    "text": "For me, love is happiness and inspiration."
  },
  {
    "author": "J. B. Priestley",
    "category": "happiness",
    "id": 32457,
    "text": "To show a child what once delighted you, to find the child's delight added to your own - this is happiness."
  },
  {
    "author": "Madame de Stael",
    "category": "happiness",
    "id": 32539,
    "text": "The greatest happiness is to transform one's feelings into action."
  },
  {
    "author": "Hugh Laurie",
    "category": "happiness",
    "id": 32454,
    "text": "I admit I can't shake the idea that there is virtue in suffering, that there is a sort of psychic economy, whereby if you embrace success, happiness and comfort, these things have to be paid for."
  },
  {
    "author": "Alfred Lord Tennyson",
    "category": "happiness",
    "id": 31920,
    "text": "The happiness of a man in this life does not consist in the absence but in the mastery of his passions."
  },
  {
    "author": "Victoria Woodhull",
    "category": "happiness",
    "id": 32691,
    "text": "I ask the rights to pursue happiness by having a voice in that government to which I am accountable."
  },
  {
    "author": "Samuel Johnson",
    "category": "happiness",
    "id": 32144,
    "text": "Nothing flatters a man as much as the happiness of his wife he is always proud of himself as the source of it."
  },
  {
    "author": "Milan Kundera",
    "category": "happiness",
    "id": 32441,
    "text": "The sound of laughter is like the vaulted dome of a temple of happiness."
  },
  {
    "author": "Henry St. John",
    "category": "happiness",
    "id": 32465,
    "text": "Liberty is to the collective body, what health is to every individual body. Without health no pleasure can be tasted by man without liberty, no happiness can be enjoyed by society."
  },
  {
    "author": "Thomas Aquinas",
    "category": "happiness",
    "id": 32240,
    "text": "Happiness is secured through virtue it is a good attained by man's own will."
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "happiness",
    "id": 32054,
    "text": "Love is the master key that opens the gates of happiness."
  },
  {
    "author": "Arthur Schopenhauer",
    "category": "happiness",
    "id": 31900,
    "text": "The greatest of follies is to sacrifice health for any other kind of happiness."
  },
  {
    "author": "Rick Pitino",
    "category": "happiness",
    "id": 32720,
    "text": "I'd learned how much happiness money can bring you. Very little."
  },
  {
    "author": "Henry Knox",
    "category": "happiness",
    "id": 32767,
    "text": "We have arrived at that point of time in which we are forced to see our own humiliation, as a nation, and that a progression in this line cannot be a productive of happiness, private or public."
  },
  {
    "author": "Jonathan Mayhew",
    "category": "happiness",
    "id": 32711,
    "text": "It is our happiness to live under the government of a PRINCE who is satisfied with ruling according to law as every other good prince will - We enjoy under his administration all the liberty that is proper and expedient for us."
  },
  {
    "author": "Shawn Johnson",
    "category": "happiness",
    "id": 32466,
    "text": "My parents- they've been my biggest influences and supporters since day one. They teach me every day that happiness comes from within and not from something outside of your heart."
  }
]

quotes['health'] = [
  {
    "author": "Ruben Studdard",
    "category": "health",
    "id": 33503,
    "text": "I've never had any health problems and I'm Ruben, man, all the way through."
  },
  {
    "author": "Michele Bachmann",
    "category": "health",
    "id": 33578,
    "text": "Well, what did we buy? Instead of a leaner, smarter government, we bought a bureaucracy that now tells us which light bulbs to buy, and which will put 16,500 IRS agents in charge of policing President Obama's health care bill."
  },
  {
    "author": "Colin Powell",
    "category": "health",
    "id": 32950,
    "text": "The chief condition on which, life, health and vigor depend on, is action. It is by action that an organism develops its faculties, increases its energy, and attains the fulfillment of its destiny."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "health",
    "id": 32842,
    "text": "The trouble with always trying to preserve the health of the body is that it is so difficult to do without destroying the health of the mind."
  },
  {
    "author": "Iain Duncan Smith",
    "category": "health",
    "id": 33057,
    "text": "For families across the UK who are income-poor, but more than that, whose lives are blighted by worklessness, educational failure, family breakdown, problem debt and poor health, as well as other problems, giving them an extra pound - say through increased benefits - will not address the reason they find themselves in difficulty in the first place."
  },
  {
    "author": "Nathan Deal",
    "category": "health",
    "id": 33055,
    "text": "For the last 3 years, we have celebrated National Nurses Week. Beginning on May 6, we will once again have the opportunity to truly commend the nursing community for their contributions to our national health delivery system."
  },
  {
    "author": "Thomas Frank",
    "category": "health",
    "id": 33101,
    "text": "Yes, Democrats can prove that America pays more for health care than other countries yes, they have won the dispute that private health insurance is needlessly expensive. But what they've lost is the argument that we are a society."
  },
  {
    "author": "Denzel Washington",
    "category": "health",
    "id": 32835,
    "text": "I made a commitment to completely cut out drinking and anything that might hamper me from getting my mind and body together. And the floodgates of goodness have opened upon me - spiritually and financially."
  },
  {
    "author": "John Cameron",
    "category": "health",
    "id": 33409,
    "text": "I am now almost certain that we need more radiation for better health."
  },
  {
    "author": "Jerry Costello",
    "category": "health",
    "id": 33617,
    "text": "Coal is absolutely critical to our nation's economic health and global competitiveness."
  },
  {
    "author": "Jiddu Krishnamurti",
    "category": "health",
    "id": 32934,
    "text": "It's no measure of health to be well adjusted to a profoundly sick society."
  },
  {
    "author": "Henrik Ibsen",
    "category": "health",
    "id": 32862,
    "text": "People who don't know how to keep themselves healthy ought to have the decency to get themselves buried, and not waste time about it."
  },
  {
    "author": "Larry Elder",
    "category": "health",
    "id": 33299,
    "text": "Once brave politicians and others explain the war on drugs' true cost, the American people will scream for a cease-fire. Bring the troops home, people will urge. Treat drugs as a health problem, not as a matter for the criminal justice system."
  },
  {
    "author": "Jan Schakowsky",
    "category": "health",
    "id": 33603,
    "text": "We need a vibrant Medicaid program and strategies to expand affordable access to health care for all, especially for the specialty care services that community health centers do not provide."
  },
  {
    "author": "Eric Cantor",
    "category": "health",
    "id": 33448,
    "text": "I am hopeful for the American people that we can actually improve the outlook for bringing down costs in health care."
  },
  {
    "author": "Bryan Cranston",
    "category": "health",
    "id": 33135,
    "text": "It's funny, I do try to maintain health. I started doing Bikram yoga which is that hothouse yoga, the 105 degrees yoga for 90 minutes. It's great, you purge out all the sweat and you're drinking water."
  },
  {
    "author": "Jim Ramstad",
    "category": "health",
    "id": 33481,
    "text": "American families, families back home in Minnesota, know only too well that out-of-pocket expenses for health care have been rising at an astonishing rate."
  },
  {
    "author": "Dianne Feinstein",
    "category": "health",
    "id": 33230,
    "text": "Today we have a health insurance industry where the first and foremost goal is to maximize profits for shareholders and CEOs, not to cover patients who have fallen ill or to compensate doctors and hospitals for their services. It is an industry that is increasingly concentrated and where Americans are paying more to receive less."
  },
  {
    "author": "Eric Ries",
    "category": "health",
    "id": 33359,
    "text": "Here in Silicon Valley, I have taken part in hundreds of conversations trying to convince people to dive in and become entrepreneurs. All too often, innovators with good, safe, jobs are unwilling to put their family's access to health care at risk by walking away from company-backed medical insurance."
  },
  {
    "author": "Ann Veneman",
    "category": "health",
    "id": 33789,
    "text": "But the fact of the matter is that all scientific evidence would show, based upon what we know about this disease, that muscle cuts - that is, the meat of the animal itself - should not cause any risk to human health."
  },
  {
    "author": "Elizabeth Meriwether",
    "category": "health",
    "id": 33762,
    "text": "Why do British people make such good TV? It's so annoying. Stop it. Is it because they have free health care? Uggh."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "health",
    "id": 32929,
    "text": "It is better to lose health like a spendthrift than to waste it like a miser."
  },
  {
    "author": "Andrew Weil",
    "category": "health",
    "id": 33252,
    "text": "The more easily digestible and refined the carbohydrates, the greater the effect on our health, weight and well-being."
  },
  {
    "author": "Dee Dee Myers",
    "category": "health",
    "id": 32986,
    "text": "As women slowly gain power, their values and priorities are reshaping the agenda. A multitude of studies show that when women control the family funds, they generally spend more on health, nutrition, and education - and less on alcohol and cigarettes."
  },
  {
    "author": "Gro Harlem Brundtland",
    "category": "health",
    "id": 33464,
    "text": "During my nearly five years as director-general of WHO, high-level policymakers have increasingly recognized that health is central to sustainable development."
  },
  {
    "author": "Allen Boyd",
    "category": "health",
    "id": 33733,
    "text": "Our government has made a number of promises to the men and women who served in our nation's armed forces. Sadly, these promises of health care, education and other benefits have existed more in rhetoric than in reality."
  },
  {
    "author": "Jim Ryun",
    "category": "health",
    "id": 33478,
    "text": "The majority of Americans receive health insurance coverage through their employers, but with rising health care costs, many small businesses can no longer afford to provide coverage for their employees."
  },
  {
    "author": "David Limbaugh",
    "category": "health",
    "id": 33580,
    "text": "Americans oppose Obamacare because they understand that it is inconsistent with our liberties and our idea of limited government and that it will destroy the best health care system in the world."
  },
  {
    "author": "Roy Ayers",
    "category": "health",
    "id": 33533,
    "text": "Having good health, being able to breathe and be happy, that's one of the most beautiful gifts. On top of that, I have the gift to play music and make people happy through that. I'm just telling you from my heart, I'm so in love with life."
  },
  {
    "author": "Rahm Emanuel",
    "category": "health",
    "id": 33211,
    "text": "Because of the president's leadership, every American will have access to affordable, quality health care."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "health",
    "id": 32828,
    "text": "The wish for healing has always been half of health."
  },
  {
    "author": "William Hall",
    "category": "health",
    "id": 33815,
    "text": "The sexes were made for each other, and only in the wise and loving union of the two is the fullness of health and duty and happiness to be expected."
  },
  {
    "author": "Picabo Street",
    "category": "health",
    "id": 32878,
    "text": "I've made a promise to myself to be a 100% healthy person if nothing else."
  },
  {
    "author": "Andrew Weil",
    "category": "health",
    "id": 33265,
    "text": "We need to accept the seemingly obvious fact that a toxic environment can make people sick and that no amount of medical intervention can protect us. The health care community must become a powerful political lobby for environmental policy and legislation."
  },
  {
    "author": "Al Sharpton",
    "category": "health",
    "id": 33136,
    "text": "If Charlton Heston can have a constitutional right carry a rifle, why can't grandma have a constitutional right to health care?"
  },
  {
    "author": "James Otis",
    "category": "health",
    "id": 33098,
    "text": "The only principles of public conduct that are worthy of a gentleman or a man are to sacrifice estate, ease, health, and applause, and even life, to the sacred calls of his country."
  },
  {
    "author": "Dick Wolf",
    "category": "health",
    "id": 33179,
    "text": "If you're going to vote on a television contract, there is a certain rationality to saying that the same structures that are applied to Health Plan participation should be placed on the right to vote on a strike."
  },
  {
    "author": "Eric Liu",
    "category": "health",
    "id": 33241,
    "text": "Many smart folks seem to think that if you just get your metaphors and messages right, you'll win. That if you start describing what you favor as a 'moral value' - 'affordable health care is a moral value' etc., - then you'll appeal to red-state voters."
  },
  {
    "author": "Gary Locke",
    "category": "health",
    "id": 33458,
    "text": "I understand that in these difficult economic times, the potential for any additional expense is not welcomed by American businesses. But in the long run, the health insurance reform law promises to cut health-care costs for U.S. businesses, not expand them."
  },
  {
    "author": "Jane Pauley",
    "category": "health",
    "id": 33217,
    "text": "In the beginning when I sat next to Tom Brokaw on the 'Today' show, the stories I was interested in were those having to do with women and children and learning and health. In those days, 25 to 30 years ago, that was called soft news, and not in a nice way."
  },
  {
    "author": "Nancy Pelosi",
    "category": "health",
    "id": 33169,
    "text": "Furthermore, we believe that health care reform, again I said at the beginning of my remarks, that we sent the three pillars that the President's economic stabilization and job creation initiatives were education and innovation - innovation begins in the classroom - clean energy and climate, addressing the climate issues in an innovative way to keep us number one and competitive in the world with the new technology, and the third, first among equals I may say, is health care, health insurance reform."
  },
  {
    "author": "Patricia Hewitt",
    "category": "health",
    "id": 33622,
    "text": "As patients and consumers, we are better informed today about our health care than any previous generation."
  },
  {
    "author": "Richard Russo",
    "category": "health",
    "id": 33215,
    "text": "I don't think there's a shortage of material in the world. Or in my head. I just pray for continued good health, because I've got other stories to tell."
  },
  {
    "author": "Bonnie Blair",
    "category": "health",
    "id": 33782,
    "text": "I never could have achieved the success that I have without setting physical activity and health goals."
  },
  {
    "author": "Susan Faludi",
    "category": "health",
    "id": 33110,
    "text": "As it turns out, social scientists have established only one fact about single women's mental health: employment improves it."
  },
  {
    "author": "Alison Sweeney",
    "category": "health",
    "id": 33220,
    "text": "Hey 'Bachelor,' take notes! Trusting one another and sharing a journey to health leads to lasting relationships!"
  },
  {
    "author": "Jacob Lew",
    "category": "health",
    "id": 33694,
    "text": "If you have a student who graduates from college and they don't have a job, they are now able to stay on their family health plan."
  },
  {
    "author": "Jan Schakowsky",
    "category": "health",
    "id": 33604,
    "text": "In Illinois, community, migrant, homeless and public housing health centers operate 268 primary care sites and serve close to 1 million patients every year."
  },
  {
    "author": "Barack Obama",
    "category": "health",
    "id": 32900,
    "text": "It was the labor movement that helped secure so much of what we take for granted today. The 40-hour work week, the minimum wage, family leave, health insurance, Social Security, Medicare, retirement plans. The cornerstones of the middle-class security all bear the union label."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "health",
    "id": 32928,
    "text": "Talk is by far the most accessible of pleasures. It costs nothing in money, it is all profit, it completes our education, founds and fosters our friendships, and can be enjoyed at any age and in almost any state of health."
  },
  {
    "author": "Fred Upton",
    "category": "health",
    "id": 33402,
    "text": "The national debate on health care once centered on improving access to quality care, yet the effect of Obamacare will be the exact opposite, resulting in the shameful degradation of care for the neediest individuals."
  },
  {
    "author": "John Cornyn",
    "category": "health",
    "id": 33654,
    "text": "If Obamacare is allowed to stand - and Congress is allowed to make the purchase of government-endorsed health insurance compulsory - there will be no meaningful limit on Washington's reach into the lives of the American people. That is certainly not what the Founders intended."
  },
  {
    "author": "Sloane Crosley",
    "category": "health",
    "id": 33188,
    "text": "Alaska is what happens when Willy Wonka and the witch from Hansel and Gretel elope, buy a place together upstate, renounce their sweet teeth, and turn into health fanatics."
  },
  {
    "author": "Debbie Stabenow",
    "category": "health",
    "id": 33460,
    "text": "I think that we have a number of different health care challenges in our country, and certainly addressing the uninsured is one, and the second is making sure that those with health insurance actually get the care that they assume they'll have available to them if they get sick."
  },
  {
    "author": "Alexander Skarsgard",
    "category": "health",
    "id": 33766,
    "text": "Swedes are such a civilised, perfect society - at least on the surface. There's a great safety net, a huge middle class, free education, free health care. People are very polite, they wait their turn. They're not too loud, they're not too quiet, but sometimes it's a little too perfect."
  },
  {
    "author": "Olivia Newton-John",
    "category": "health",
    "id": 33508,
    "text": "Family, nature and health all go together."
  },
  {
    "author": "Bryan Cranston",
    "category": "health",
    "id": 33134,
    "text": "Love is not as important as good health. You cannot be in love if you're not healthy. You can't appreciate it."
  },
  {
    "author": "Sachin Tendulkar",
    "category": "health",
    "id": 33084,
    "text": "There are over 200 million illiterate women in India. This low literacy negatively impacts not just their lives but also their families' and the country's economic development. A girl's lack of education also has a negative impact on the health and well-being of her children."
  },
  {
    "author": "Pierre Dukan",
    "category": "health",
    "id": 33823,
    "text": "It's been proven that fitting more activity into your day can greatly improve your health."
  },
  {
    "author": "Andrew Weil",
    "category": "health",
    "id": 33267,
    "text": "You can't afford to get sick, and you can't depend on the present health care system to keep you well. It's up to you to protect and maintain your body's innate capacity for health and healing by making the right choices in how you live."
  },
  {
    "author": "Allen West",
    "category": "health",
    "id": 33018,
    "text": "One of the critical issues that we have to confront is illegal immigration, because this is a multi-headed Hydra that affects our economy, our health care, our health care, our education systems, our national security, and also our local criminality."
  },
  {
    "author": "Andrew Weil",
    "category": "health",
    "id": 33262,
    "text": "The most common objection that I hear to walking as exercise is that it's too easy, that only sweaty, strenuous activity offers real benefits. But there is abundant evidence that regular, brisk walking is associated with better health, including lower blood pressure, better moods and improved cholesterol ratios."
  },
  {
    "author": "Andrew Bernstein",
    "category": "health",
    "id": 33583,
    "text": "The truth is that stress doesn't come from your boss, your kids, your spouse, traffic jams, health challenges, or other circumstances. It comes from your thoughts about these circumstances."
  },
  {
    "author": "Sherri Shepherd",
    "category": "health",
    "id": 33277,
    "text": "I am trying to inspire people to just take control of their oral health, because if we don't take care of our oral health, it affects so many different aspects of our lives. If your smile and mouth is not together, it affects your relationship, your self-esteem, your health."
  },
  {
    "author": "Lou Gramm",
    "category": "health",
    "id": 33584,
    "text": "Five years ago we were working on a new album when my health began failing."
  },
  {
    "author": "Tim McGraw",
    "category": "health",
    "id": 33421,
    "text": "The issues that matter to me are the social safety nets for people, health care, middle-class concerns. We need to take care of the middle class and the poor in our country."
  },
  {
    "author": "Herbie Mann",
    "category": "health",
    "id": 33545,
    "text": "I recently formed a foundation to raise awareness for prostate cancer. I feel it's very necessary that men be more aware about prostate cancer and their health in general."
  },
  {
    "author": "Ron Wyden",
    "category": "health",
    "id": 33198,
    "text": "When the Veterans Affairs Department implemented a program to provide home-based health care to veterans with multiple chronic conditions - many of the system's most expensive patients to treat - they received astounding results."
  },
  {
    "author": "Cathy McMorris",
    "category": "health",
    "id": 33570,
    "text": "Women oftentimes are the ones making those economic decisions, sitting around the kitchen table and trying to figure out how to pay for rising gas prices or food prices or the health insurance costs. And I think that they see where they expect their leaders in Congress to also make those tough decisions."
  },
  {
    "author": "Chris Van Hollen",
    "category": "health",
    "id": 33738,
    "text": "As we get closer to the end of this Congress, we should be addressing the urgent needs of the American people - the war in Iraq, affordable health care, a sensible energy policy, quality education for our children, retirement security, and a sound and fair fiscal policy."
  },
  {
    "author": "Ron Wyden",
    "category": "health",
    "id": 33202,
    "text": "While Free Choice Vouchers didn't fulfill my vision of a health care system in which every American would be empowered to hire and fire their insurance company, they were a foothold for choice and competition and a safety valve for Americans whose employers are already forcing them to bear more and more of their family's health insurance costs."
  },
  {
    "author": "Ron Wyden",
    "category": "health",
    "id": 33196,
    "text": "For the amount of money that the country is going to spend this year on health care, you can go out and hire a doctor for every seven families in the US and pay the doctor almost $230,000 a year to cover them."
  },
  {
    "author": "Rutherford B. Hayes",
    "category": "health",
    "id": 33099,
    "text": "The filth and noise of the crowded streets soon destroy the elasticity of health which belongs to the country boy."
  },
  {
    "author": "Robert Redford",
    "category": "health",
    "id": 33035,
    "text": "Health food may be good for the conscience but Oreos taste a hell of a lot better."
  },
  {
    "author": "Paul Hawken",
    "category": "health",
    "id": 33407,
    "text": "We are losing our living systems, social systems, cultural systems, governing systems, stability, and our constitutional health, and we're surrendering it all at the same time."
  },
  {
    "author": "Hugh Hefner",
    "category": "health",
    "id": 33339,
    "text": "I am in very good health. I've never felt better."
  },
  {
    "author": "Gary Miller",
    "category": "health",
    "id": 33736,
    "text": "In 2001, America 's hospitals provided nearly $21 billion in uncompensated health care services."
  },
  {
    "author": "Sargent Shriver",
    "category": "health",
    "id": 33133,
    "text": "Do we talk about the dignity of work? Do we give our students any reason for believing it is worthwhile to sacrifice for their work because such sacrifices improve the psychological and mental health of the person who makes them?"
  },
  {
    "author": "Jeanne Moreau",
    "category": "health",
    "id": 33089,
    "text": "You don't have to be a wreck. You don't have to be sick. One's aim in life should be to die in good health. Just like a candle that burns out."
  },
  {
    "author": "John Cornyn",
    "category": "health",
    "id": 33652,
    "text": "By the Obama administration's reasoning, it would be constitutionally permissible to make Americans purchase nearly any product (broccoli, gym membership) that improved their health and thereby contributed to lower health-care costs."
  },
  {
    "author": "Ivan Illich",
    "category": "health",
    "id": 33108,
    "text": "Effective health care depends on self-care this fact is currently heralded as if it were a discovery."
  },
  {
    "author": "Jan Brewer",
    "category": "health",
    "id": 33342,
    "text": "And under the existing circumstances, I understand there are situations where people indeed need care and need services, but I believe in America that the majority of those people are getting those services under situations and circumstances that are afforded to them by their health care providers and their state government."
  },
  {
    "author": "Elaine MacDonald",
    "category": "health",
    "id": 33213,
    "text": "A life coach does for the rest of your life what a personal trainer does for your health and fitness."
  },
  {
    "author": "Martha Plimpton",
    "category": "health",
    "id": 33111,
    "text": "It's easier to lecture women on sexual morality than it is to explain why all Americans shouldn't have comprehensive, fair, and equal health care coverage."
  },
  {
    "author": "David Boreanaz",
    "category": "health",
    "id": 33522,
    "text": "Growing up, I saw my dad do charity work for children with health issues. That had a profound effect on me."
  },
  {
    "author": "Shelley Berman",
    "category": "health",
    "id": 33750,
    "text": "The old problems - love, money, security, status, health, etc. - are still here to plague us or please us."
  },
  {
    "author": "Samuel Wilson",
    "category": "health",
    "id": 33769,
    "text": "To maximize our potential to enhance our health and our knowledge, we should remain open to new understanding and evolving technology or resources that might inspire a change in our approach to these important questions."
  },
  {
    "author": "Arlen Specter",
    "category": "health",
    "id": 33019,
    "text": "There's nothing more important than our good health - that's our principal capital asset."
  },
  {
    "author": "Laurence Sterne",
    "category": "health",
    "id": 33081,
    "text": "People who are always taking care of their health are like misers, who are hoarding a treasure which they have never spirit enough to enjoy."
  },
  {
    "author": "John Kasich",
    "category": "health",
    "id": 33639,
    "text": "And what we're doing in Ohio is we're moving from a basic manufacturing economy to one that's diversified, including energy and health care and agriculture and IT."
  },
  {
    "author": "Joel Robuchon",
    "category": "health",
    "id": 33649,
    "text": "I've never followed a vegan or vegetarian diet in the past, but I think I could do it. It would not be easy. I have worked with nutritionists who have said a vegan diet is not necessarily all positive for your health, because you need nutrients you only find in meats. I believe in a balanced diet."
  },
  {
    "author": "Jan Schakowsky",
    "category": "health",
    "id": 33605,
    "text": "Each and every day health centers provide high-quality primary and preventive care to our constituents."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "health",
    "id": 32955,
    "text": "The health of the people is really the foundation upon which all their happiness and all their powers as a state depend."
  },
  {
    "author": "Darrell Royal",
    "category": "health",
    "id": 32877,
    "text": "I'm still healthy as can be."
  },
  {
    "author": "Max Baucus",
    "category": "health",
    "id": 33671,
    "text": "Health reform is an essential part of restoring America's economy and maintaining our competitiveness."
  },
  {
    "author": "Omar Bongo",
    "category": "health",
    "id": 33472,
    "text": "When they favor the access of other people to education and health care, the countries of the North not only demonstrate generosity or solidarity, but also implement the principles of respecting and promoting human rights."
  },
  {
    "author": "Christopher Hitchens",
    "category": "health",
    "id": 32995,
    "text": "Religion is part of the human make-up. It's also part of our cultural and intellectual history. Religion was our first attempt at literature, the texts, our first attempt at cosmology, making sense of where we are in the universe, our first attempt at health care, believing in faith healing, our first attempt at philosophy."
  },
  {
    "author": "Aphra Behn",
    "category": "health",
    "id": 33222,
    "text": "Nothing is more capable of troubling our reason, and consuming our health, than secret notions of jealousy in solitude."
  },
  {
    "author": "Ann Veneman",
    "category": "health",
    "id": 33791,
    "text": "I think it's important that, as a matter of course, the brain and spinal column were removed from this cow, and that would be the material that would cause concern in terms of human health. And therefore we're confident in the safety of the food supply."
  },
  {
    "author": "Gloria Swanson",
    "category": "health",
    "id": 32872,
    "text": "I became a fanatic about healthy food in 1944."
  }
]

quotes['history'] = [
  {
    "author": "Doug Coupland",
    "category": "history",
    "id": 34138,
    "text": "It's very strange that most people don't care if their knowledge of their family history only goes back three generations."
  },
  {
    "author": "George Eliot",
    "category": "history",
    "id": 34112,
    "text": "Rome - the city of visible history, where the past of a whole hemisphere seems moving in funeral procession with strange ancestral images and trophies gathered from afar."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "history",
    "id": 33828,
    "text": "A small body of determined spirits fired by an unquenchable faith in their mission can alter the course of history."
  },
  {
    "author": "Steve King",
    "category": "history",
    "id": 34632,
    "text": "Our Founding Fathers crafted a constitutional Republic for the first time in the history of the world because they were shaping a form of government that would not have the failures of a democracy in it, but had the representation of democracy in it."
  },
  {
    "author": "Tony Kushner",
    "category": "history",
    "id": 34719,
    "text": "A handful of works in history have had a direct impact on social policy: one or two works of Dickens, some of Zola, 'Uncle Tom's Cabin' and, in modern drama, Larry Kramer's 'The Normal Heart.'"
  },
  {
    "author": "David Hockney",
    "category": "history",
    "id": 34349,
    "text": "You had to be aware that I saw that photography was a mere episode in the history of the optical projection and when the chemicals ended, meaning the picture was fixed by chemicals, we were in a new era."
  },
  {
    "author": "Pablo Picasso",
    "category": "history",
    "id": 34061,
    "text": "I don't believe in accidents. There are only encounters in history. There are no accidents."
  },
  {
    "author": "Thomas Merton",
    "category": "history",
    "id": 34044,
    "text": "If you want to study the social and political history of modern nations, study hell."
  },
  {
    "author": "Julie Burchill",
    "category": "history",
    "id": 34617,
    "text": "I've never been nostalgic, personally or politically - if the past was so great, how come it's history?"
  },
  {
    "author": "Spike Lee",
    "category": "history",
    "id": 34519,
    "text": "Violence is a part of America. I don't want to single out rap music. Let's be honest. America's the most violent country in the history of the world, that's just the way it is. We're all affected by it."
  },
  {
    "author": "Ambrose Bierce",
    "category": "history",
    "id": 33854,
    "text": "History is an account, mostly false, of events, mostly unimportant, which are brought about by rulers, mostly knaves, and soldiers, mostly fools."
  },
  {
    "author": "Dan Quayle",
    "category": "history",
    "id": 33914,
    "text": "It's a very good historical book about history."
  },
  {
    "author": "George W. Bush",
    "category": "history",
    "id": 34223,
    "text": "I sent American troops to Iraq to make its people free, not to make them American. Iraqis will write their own history and find their own way."
  },
  {
    "author": "Rachel Bilson",
    "category": "history",
    "id": 34754,
    "text": "I'm the fourth generation to be in show business. It's pretty neat it's nice to have that family history."
  },
  {
    "author": "George Will",
    "category": "history",
    "id": 33908,
    "text": "World War II was the last government program that really worked."
  },
  {
    "author": "William Hague",
    "category": "history",
    "id": 34432,
    "text": "Very few conflicts in the history of the world have been satisfactorily concluded according to a published timetable, because you lose all flexibility in dealing with your opponents."
  },
  {
    "author": "Rush Limbaugh",
    "category": "history",
    "id": 34104,
    "text": "Our nation was created in ways that allow human potential to prosper, and it created the greatest nation for people in the history of humanity. Now Obama is dismantling it, because he has no appreciation for our greatness. In fact, he resents it. He blames this country for whatever evils he sees around the world."
  },
  {
    "author": "Bruce Springsteen",
    "category": "history",
    "id": 34575,
    "text": "The audiences are there as a result of my history with the band but also as a result of my being able to reach people with a tune."
  },
  {
    "author": "Dante Alighieri",
    "category": "history",
    "id": 33892,
    "text": "Be as a tower firmly set Shakes not its top for any blast that blows."
  },
  {
    "author": "Lev Grossman",
    "category": "history",
    "id": 34800,
    "text": "When it comes to true humility in the face of history, nothing beats complete silence."
  },
  {
    "author": "John Hodgman",
    "category": "history",
    "id": 34711,
    "text": "More people have more access to more readers for less money than ever before in history. It means a lot of dross but it means a lot of very talented people can find and nurture a readership in ways that were not possible twenty years ago. From a creative perspective, that is all that writing is about."
  },
  {
    "author": "Elie Wiesel",
    "category": "history",
    "id": 34290,
    "text": "It all happened so fast. The ghetto. The deportation. The sealed cattle car. The fiery altar upon which the history of our people and the future of mankind were meant to be sacrificed."
  },
  {
    "author": "Douglas MacArthur",
    "category": "history",
    "id": 33875,
    "text": "They died hard, those savage men - like wounded wolves at bay. They were filthy, and they were lousy, and they stunk. And I loved them."
  },
  {
    "author": "Damien Hirst",
    "category": "history",
    "id": 34576,
    "text": "But I think it's more that when you're young, you're invincible, you're immortal - or at least you think you are. The possibilities are limitless, you're inventing the future. Then you get older and suddenly you have a history. It's fixed. You can't change anything. I find that a bit disturbing, to be honest."
  },
  {
    "author": "Alfred North Whitehead",
    "category": "history",
    "id": 34263,
    "text": "No period of history has ever been great or ever can be that does not act on some sort of high, idealistic motives, and idealism in our time has been shoved aside, and we are paying the penalty for it."
  },
  {
    "author": "Wallace Shawn",
    "category": "history",
    "id": 34594,
    "text": "In my early 20s, I studied history and politics, and I really thought that perhaps I would devote my life to that."
  },
  {
    "author": "Winston Churchill",
    "category": "history",
    "id": 33832,
    "text": "History will be kind to me for I intend to write it."
  },
  {
    "author": "Stephen Jay Gould",
    "category": "history",
    "id": 34795,
    "text": "With copious evidence ranging from Plato's haughtiness to Beethoven's tirades, we may conclude that the most brilliant people of history tend to be a prickly lot."
  },
  {
    "author": "Edward Gibbon",
    "category": "history",
    "id": 33909,
    "text": "History is indeed little more than the register of the crimes, follies, and misfortunes of mankind."
  },
  {
    "author": "Konrad Adenauer",
    "category": "history",
    "id": 33907,
    "text": "History is the sum total of things that could have been avoided."
  },
  {
    "author": "David Icke",
    "category": "history",
    "id": 34309,
    "text": "And why do we, who say we oppose tyranny and demand freedom of speech, allow people to go to prison and be vilified, and magazines to be closed down on the spot, for suggesting another version of history."
  },
  {
    "author": "Phyllis George",
    "category": "history",
    "id": 34638,
    "text": "Crafts make us feel rooted, give us a sense of belonging and connect us with our history. Our ancestors used to create these crafts out of necessity, and now we do them for fun, to make money and to express ourselves."
  },
  {
    "author": "Arthur Erickson",
    "category": "history",
    "id": 34494,
    "text": "What is the thread of western civilization that distinguished its course in history? It has to do with the preoccupation of western man with his outward command and his sense of superiority."
  },
  {
    "author": "David Brin",
    "category": "history",
    "id": 34145,
    "text": "The worst mistake of first contact, made throughout history by individuals on both sides of every new encounter, has been the unfortunate habit of making assumptions. It often proved fatal."
  },
  {
    "author": "Ricky Williams",
    "category": "history",
    "id": 34462,
    "text": "Texas was such a welcoming place, and with its unbelievable history and tradition, it's extra special to be a part of that."
  },
  {
    "author": "Victor Hugo",
    "category": "history",
    "id": 34069,
    "text": "What is history? An echo of the past in the future a reflex from the future on the past."
  },
  {
    "author": "David Attenborough",
    "category": "history",
    "id": 34468,
    "text": "I like animals. I like natural history. The travel bit is not the important bit. The travel bit is what you have to do in order to go and look at animals."
  },
  {
    "author": "Jane Goodall",
    "category": "history",
    "id": 34647,
    "text": "War had always seemed to me to be a purely human behavior. Accounts of warlike behavior date back to the very first written records of human history it seemed to be an almost universal characteristic of human groups."
  },
  {
    "author": "Thomas Huxley",
    "category": "history",
    "id": 34173,
    "text": "History warns us that it is the customary fate of new truths to begin as heresies and to end as superstitions."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "history",
    "id": 34043,
    "text": "One could write a history of science in reverse by assembling the solemn pronouncements of highest authority about what could not be done and could never happen."
  },
  {
    "author": "John Podhoretz",
    "category": "history",
    "id": 34414,
    "text": "Robots have a rich and storied history in movies."
  },
  {
    "author": "Colin Powell",
    "category": "history",
    "id": 34137,
    "text": "I don't think we handled the aftermath of the fall of Baghdad as well as we might have. But that's now history."
  },
  {
    "author": "Zoe Saldana",
    "category": "history",
    "id": 34781,
    "text": "I'm so intrigued by women throughout history where the significance of what they were representing at that time is obscured by the fact a man saved them or they were prostitutes."
  },
  {
    "author": "Alice Walker",
    "category": "history",
    "id": 34166,
    "text": "I'm not convinced that women have the education or the sense of their own history enough or that they understand the cruelty of which men are capable and the delight that many men will take in seeing you choose to chain yourself - then they get to say 'See, you did it yourself.'"
  },
  {
    "author": "Richard M. Nixon",
    "category": "history",
    "id": 34213,
    "text": "Once you get into this great stream of history, you can't get out."
  },
  {
    "author": "Richard P. Feynman",
    "category": "history",
    "id": 34081,
    "text": "It is in the admission of ignorance and the admission of uncertainty that there is a hope for the continuous motion of human beings in some direction that doesn't get confined, permanently blocked, as it has so many times before in various periods in the history of man."
  },
  {
    "author": "Erica Jong",
    "category": "history",
    "id": 34222,
    "text": "Women are the only exploited group in history to have been idealized into powerlessness."
  },
  {
    "author": "John Bolton",
    "category": "history",
    "id": 34763,
    "text": "I'm not sure history has ended."
  },
  {
    "author": "Samuel Butler",
    "category": "history",
    "id": 33873,
    "text": "God cannot alter the past, though historians can."
  },
  {
    "author": "Joan Rivers",
    "category": "history",
    "id": 34003,
    "text": "Yesterday is history, tomorrow is a mystery, today is God's gift, that's why we call it the present."
  },
  {
    "author": "Jack Nicklaus",
    "category": "history",
    "id": 34643,
    "text": "I've been fortunate over my career to make a little history on the 16th hole at Augusta National."
  },
  {
    "author": "Lynn Abbey",
    "category": "history",
    "id": 34791,
    "text": "When I'm not writing or tweaking my computer, I do embroidery. When I'm not plunging into the past, tweaking, or embroidering, I'm reading books about history, computers, or embroidery."
  },
  {
    "author": "Richard M. Nixon",
    "category": "history",
    "id": 34187,
    "text": "No event in American history is more misunderstood than the Vietnam War. It was misreported then, and it is misremembered now."
  },
  {
    "author": "B. H. Liddell Hart",
    "category": "history",
    "id": 34783,
    "text": "Helplessness induces hopelessness, and history attests that loss of hope and not loss of lives is what decides the issue of war."
  },
  {
    "author": "Bertrand Russell",
    "category": "history",
    "id": 34028,
    "text": "The megalomaniac differs from the narcissist by the fact that he wishes to be powerful rather than charming, and seeks to be feared rather than loved. To this type belong many lunatics and most of the great men of history."
  },
  {
    "author": "Woodrow Wilson",
    "category": "history",
    "id": 34285,
    "text": "It is like writing history with lightning and my only regret is that it is all so terribly true."
  },
  {
    "author": "Mao Zedong",
    "category": "history",
    "id": 33915,
    "text": "Despise the enemy strategically, but take him seriously tactically."
  },
  {
    "author": "Aldous Huxley",
    "category": "history",
    "id": 33852,
    "text": "That men do not learn very much from the lessons of history is the most important of all the lessons of history."
  },
  {
    "author": "Norman Cousins",
    "category": "history",
    "id": 33895,
    "text": "History is a vast early warning system."
  },
  {
    "author": "Charles de Gaulle",
    "category": "history",
    "id": 34404,
    "text": "In the tumult of men and events, solitude was my temptation now it is my friend. What other satisfaction can be sought once you have confronted History?"
  },
  {
    "author": "James Lovelock",
    "category": "history",
    "id": 34543,
    "text": "There is little evidence that our individual intelligence has improved through recorded history."
  },
  {
    "author": "Leo Tolstoy",
    "category": "history",
    "id": 34072,
    "text": "In all history there is no war which was not hatched by the governments, the governments alone, independent of the interests of the people, to whom war is always pernicious even when successful."
  },
  {
    "author": "Joyce Carol Oates",
    "category": "history",
    "id": 34652,
    "text": "To be Jewish is to be specifically identified with a history. And if you're not aware of that when you're a child, the whole tradition is lost."
  },
  {
    "author": "Richard M. Nixon",
    "category": "history",
    "id": 33885,
    "text": "It is necessary for me to establish a winner image. Therefore, I have to beat somebody."
  },
  {
    "author": "Rahm Emanuel",
    "category": "history",
    "id": 34699,
    "text": "I don't want to go negative on Franklin Delano Roosevelt, but he didn't pass an economic deal in the first 100 days. We have passed the largest Recovery Act in the history of the country."
  },
  {
    "author": "Henry Louis Gates",
    "category": "history",
    "id": 34389,
    "text": "So many people of color who made major contributions to American history have been trapped in the purgatory of history."
  },
  {
    "author": "Kim Novak",
    "category": "history",
    "id": 34798,
    "text": "Just touching that old tree was truly moving to me because when you touch these trees, you have such a sense of the passage of time, of history. It's like you're touching the essence, the very substance of life."
  },
  {
    "author": "Hillary Clinton",
    "category": "history",
    "id": 34078,
    "text": "As I speak to you today, government censors somewhere are working furiously to erase my words from the records of history. But history itself has already condemned these tactics."
  },
  {
    "author": "Dalai Lama",
    "category": "history",
    "id": 33982,
    "text": "The Chinese government wants me to say that for many centuries Tibet has been part of China. Even if I make that statement, many people would just laugh. And my statement will not change past history. History is history."
  },
  {
    "author": "Daniel Craig",
    "category": "history",
    "id": 34524,
    "text": "It's a huge challenge, a huge responsibility. Bond is a huge iconic figure in movie history. These opportunities don't come along very often so I thought, 'Why not?'"
  },
  {
    "author": "Antonia Fraser",
    "category": "history",
    "id": 34792,
    "text": "I think there has been a great deal of valuable revisionism in women's history."
  },
  {
    "author": "Timothy Leary",
    "category": "history",
    "id": 34085,
    "text": "We are dealing with the best-educated generation in history. But they've got a brain dressed up with nowhere to go."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "history",
    "id": 34331,
    "text": "The subject of history is the gradual realization of all that is practically necessary."
  },
  {
    "author": "Anita Roddick",
    "category": "history",
    "id": 34732,
    "text": "All through history, there have always been movements where business was not just about the accumulation of proceeds but also for the public good."
  },
  {
    "author": "William Butler Yeats",
    "category": "history",
    "id": 34050,
    "text": "You that would judge me, do not judge alone this book or that, come to this hallowed place where my friends' portraits hang and look thereon Ireland's history in their lineaments trace think where man's glory most begins and ends and say my glory was I had such friends."
  },
  {
    "author": "B. C. Forbes",
    "category": "history",
    "id": 34040,
    "text": "History has demonstrated that the most notable winners usually encountered heartbreaking obstacles before they triumphed. They won because they refused to become discouraged by their defeats."
  },
  {
    "author": "Karl Marx",
    "category": "history",
    "id": 34075,
    "text": "Revolutions are the locomotives of history."
  },
  {
    "author": "Thomas Carlyle",
    "category": "history",
    "id": 34082,
    "text": "History, a distillation of rumour."
  },
  {
    "author": "William James",
    "category": "history",
    "id": 33844,
    "text": "The world we see that seems so insane is the result of a belief system that is not working. To perceive the world differently, we must be willing to change our belief system, let the past slip away, expand our sense of now, and dissolve the fear in our minds."
  },
  {
    "author": "Haile Selassie",
    "category": "history",
    "id": 34118,
    "text": "Outside the kingdom of the Lord there is no nation which is greater than any other. God and history will remember your judgment."
  },
  {
    "author": "Jonathan Safran Foer",
    "category": "history",
    "id": 34514,
    "text": "We need a better way to talk about eating animals, a way that doesn't ignore or even just shruggingly accept things like habits, cravings, family and history but rather incorporates them into the conversation. The more they are allowed in, the more able we will be to follow our best instincts."
  },
  {
    "author": "Thom Yorke",
    "category": "history",
    "id": 34805,
    "text": "If we got into a situation where people start burning our records, then bring it on. That's the whole point. The gloaming has begun. We're in the darkness. This has happened before. Go read some history."
  },
  {
    "author": "Carl Jung",
    "category": "history",
    "id": 34080,
    "text": "Who has fully realized that history is not contained in thick books but lives in our very blood?"
  },
  {
    "author": "Nick Clegg",
    "category": "history",
    "id": 34706,
    "text": "The UK is not going to leave the European Union. Of course not. We are inextricably wound up with Europe. In terms of culture, history and geography, we are a European nation."
  },
  {
    "author": "Phyllis Schlafly",
    "category": "history",
    "id": 34819,
    "text": "History offers no evidence for the proposition that the assignment of women to military combat jobs is the way to win wars, improve combat readiness, or promote national security."
  },
  {
    "author": "Muhammad Iqbal",
    "category": "history",
    "id": 34399,
    "text": "The possibility of a scientific treatment of history means a wider experience, a greater maturity of practical reason, and finally a fuller realization of certain basic ideas regarding the nature of life and time."
  },
  {
    "author": "Robert Anton Wilson",
    "category": "history",
    "id": 34478,
    "text": "History, sociology, economics, psychology et al. confirmed Joyce's view of Everyman as victim."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "history",
    "id": 34004,
    "text": "In the course of history, men come to see that iron necessity is neither iron nor necessary."
  },
  {
    "author": "Matt Groening",
    "category": "history",
    "id": 34787,
    "text": "Since I was there in the very beginning, I know the history of the characters. So, I make comments about the tone and sometimes remind the writers that we've done that before."
  },
  {
    "author": "Henry A. Kissinger",
    "category": "history",
    "id": 34158,
    "text": "Most foreign policies that history has marked highly, in whatever country, have been originated by leaders who were opposed by experts."
  },
  {
    "author": "Nikki Giovanni",
    "category": "history",
    "id": 34321,
    "text": "I am totally fascinated by people and our history as I understand and continue to explore it. People have so much to give and so far to go and yet we have given and gone a great distance. It's really just interesting to ask: why not? And see where that takes me."
  },
  {
    "author": "Jeff Bezos",
    "category": "history",
    "id": 34672,
    "text": "Strip malls are history."
  },
  {
    "author": "Sean Parker",
    "category": "history",
    "id": 34813,
    "text": "It would be incredibly presumptuous and self-serving of me to believe that Facebook was the end of history. The only way it could possibly be the end of history is if it becomes some sort of artificial super intelligence that takes over the world."
  },
  {
    "author": "Ed Koch",
    "category": "history",
    "id": 34784,
    "text": "If you listen to Giuliani, it's like nobody did anything to improve the city except him. I'm not part of the history. Bloomberg's not part of the history. It's like, he did it. He's the only one. That's why he's a little crazy."
  },
  {
    "author": "Carlos Santana",
    "category": "history",
    "id": 34181,
    "text": "If our history can challenge the next wave of musicians to keep moving and changing, to keep spiritually hungry and horny, that's what it's all about."
  },
  {
    "author": "Aldous Huxley",
    "category": "history",
    "id": 34057,
    "text": "The charm of history and its enigmatic lesson consist in the fact that, from age to age, nothing changes and yet everything is completely different."
  },
  {
    "author": "Robert Fulghum",
    "category": "history",
    "id": 33997,
    "text": "I believe that imagination is stronger than knowledge. That myth is more potent than history. That dreams are more powerful than facts. That hope always triumphs over experience. That laughter is the only cure for grief. And I believe that love is stronger than death."
  },
  {
    "author": "Carroll Quigley",
    "category": "history",
    "id": 34240,
    "text": "The history of the last century shows, as we shall see later, that the advice given to governments by bankers, like the advice they gave to industrialists, was consistently good for bankers, but was often disastrous for governments, businessmen, and the people generally."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "history",
    "id": 33856,
    "text": "History is the version of past events that people have decided to agree upon."
  },
  {
    "author": "Joe Baca",
    "category": "history",
    "id": 33880,
    "text": "Pearl Harbor caused our Nation to wholeheartedly commit to winning World War II, changing the course of our Nation's history and the world's future."
  }
]

quotes['home'] = [
  {
    "author": "Gene Tierney",
    "category": "home",
    "id": 35484,
    "text": "I had known Cole Porter in Hollywood and New York, spent many a warm hour at his home, and met the talented and original people who were drawn to him."
  },
  {
    "author": "Katherine Jenkins",
    "category": "home",
    "id": 35584,
    "text": "I really see myself as a homegirl. Wales is my first home. London is my second home - I've been there 14 years now."
  },
  {
    "author": "Eric Cantona",
    "category": "home",
    "id": 35180,
    "text": "A home is crucial, the foundation of a stable family."
  },
  {
    "author": "Alice Cooper",
    "category": "home",
    "id": 35572,
    "text": "They pick all of us out, and then they decide, they computerize, decide if they like it or don't like it, and then they go home, and then they come back again because they're not sure what they saw."
  },
  {
    "author": "Zig Ziglar",
    "category": "home",
    "id": 34896,
    "text": "I believe that being successful means having a balance of success stories across the many areas of your life. You can't truly be considered successful in your business life if your home life is in shambles."
  },
  {
    "author": "Demi Lovato",
    "category": "home",
    "id": 35335,
    "text": "After hundreds of auditions and nothing, you're sitting home and wondering, 'What am I doing?'"
  },
  {
    "author": "Marilyn vos Savant",
    "category": "home",
    "id": 35268,
    "text": "Working in an office with an array of electronic devices is like trying to get something done at home with half a dozen small children around. The calls for attention are constant."
  },
  {
    "author": "Smedley Butler",
    "category": "home",
    "id": 34853,
    "text": "There are only two things we should fight for. One is the defense of our homes and the other is the Bill of Rights."
  },
  {
    "author": "Gaston Bachelard",
    "category": "home",
    "id": 34846,
    "text": "If I were asked to name the chief benefit of the house, I should say: the house shelters day-dreaming, the house protects the dreamer, the house allows one to dream in peace."
  },
  {
    "author": "Babe Ruth",
    "category": "home",
    "id": 35020,
    "text": "Yesterday's home runs don't win today's games."
  },
  {
    "author": "Todd Tiahrt",
    "category": "home",
    "id": 35023,
    "text": "Children that are raised in a home with a married mother and father consistently do better in every measure of well-being than their peers who come from divorced or step-parent, single-parent, cohabiting homes."
  },
  {
    "author": "Robert Duvall",
    "category": "home",
    "id": 35507,
    "text": "When I'm at home in Virginia, I become more hermit-like. I like my own home."
  },
  {
    "author": "Andrew Weil",
    "category": "home",
    "id": 35805,
    "text": "I am a particular fan of integrative exercise - that is, exercise that occurs in the course of doing some productive activity such as gardening, bicycling to work, doing home improvement projects and so on."
  },
  {
    "author": "Steven Gerrard",
    "category": "home",
    "id": 35667,
    "text": "I listen to the phone-ins on the way home and I know how the fans feel."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "home",
    "id": 35812,
    "text": "It's like, if you can't focus on a movie for 90 minutes without looking at your phone, then don't go to the movies! You've got some issues, so you should probably stay home and work on those issues, and not distract everyone with lights, and sounds, oh my gosh, the tapping on the screens, it makes me crazy!"
  },
  {
    "author": "Danica Patrick",
    "category": "home",
    "id": 35111,
    "text": "To be honest, when I'm home, every day is a Friday for me. It doesn't really matter what day it is for me. A lot of my friends actually have time off during the week, and so it doesn't prohibit me from enjoying myself when I am home on a Monday or a Tuesday."
  },
  {
    "author": "Daniel Dennett",
    "category": "home",
    "id": 35514,
    "text": "The juvenile sea squirt wanders through the sea searching for a suitable rock or hunk of coral to cling to and make its home for life. For this task, it has a rudimentary nervous system. When it finds its spot and takes root, it doesn't need its brain anymore so it eats it!"
  },
  {
    "author": "Robert Neelly Bellah",
    "category": "home",
    "id": 35166,
    "text": "However painful the process of leaving home, for parents and for children, the really frightening thing for both would be the prospect of the child never leaving home."
  },
  {
    "author": "Samuel Goldwyn",
    "category": "home",
    "id": 35069,
    "text": "Why should people go out and pay money to see bad films when they can stay at home and see bad television for nothing?"
  },
  {
    "author": "Jarvis Cocker",
    "category": "home",
    "id": 35690,
    "text": "Every woman I've had a relationship with has found this maddening the fact that I will talk about anything on the stage, and reveal all this stuff, and yet when I'm at home, I clam up and won't discuss anything intimate or personal."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "home",
    "id": 35815,
    "text": "After spending time with the rescued turkeys at Farm Sanctuary's shelter and seeing how similar they are to my furry companion animals at home, I knew I needed to do everything in my power to protect these friendly and curious birds from the daily pain and suffering they endure on factory farms."
  },
  {
    "author": "Richard Roeper",
    "category": "home",
    "id": 35431,
    "text": "When we root-root-root for the home team, we're rooting for our home as much as the team."
  },
  {
    "author": "Debbie Stabenow",
    "category": "home",
    "id": 35689,
    "text": "Five thousand people every day lose their home because of a medical bankruptcy. Most of them had insurance."
  },
  {
    "author": "Barbra Streisand",
    "category": "home",
    "id": 35314,
    "text": "I always wear the same thing at home. I can't be bothered with jewelry. My pants have elastic waists. I like to be comfortable. There are so many more important things to worry about."
  },
  {
    "author": "Ashley Greene",
    "category": "home",
    "id": 35703,
    "text": "I live a dual life. On the red carpet, it's complete glam. But at home, I'm a jeans and T-shirt kind of girl. Simple can be beautiful."
  },
  {
    "author": "Michelle Bachelet",
    "category": "home",
    "id": 35678,
    "text": "I was not born in a home where there were stereotypes. So that was very useful because it gave me the sense of possibilities, of flying, if I may say, of making my hopes and dreams a reality."
  },
  {
    "author": "Eric McCormack",
    "category": "home",
    "id": 35214,
    "text": "Most people, if you live in a big city, you see some form of schizophrenia every day, and it's always in the form of someone homeless. 'Look at that guy - he's crazy. He looks dangerous.' Well, he's on the streets because of mental illness. He probably had a job and a home."
  },
  {
    "author": "Kenny Chesney",
    "category": "home",
    "id": 35329,
    "text": "Social topics may hit too close to home for people, but then again, if you pull a heartstring, then that's what country music is. It's not just songs about getting drunk and leaving your girl."
  },
  {
    "author": "Walter Knott",
    "category": "home",
    "id": 35285,
    "text": "Those who were cowards never started, and those who were weak were lost on the way, but the brave find a home in every land."
  },
  {
    "author": "Bobby Flay",
    "category": "home",
    "id": 35647,
    "text": "Obviously, the easiest recipes are the most successful when it comes to the home cook, because they're not intimidated by them. If I'm doing 'Boy Meets Grill,' and I do something very simple like grilled hamburgers or steaks or chicken, those are the most sought-after recipes."
  },
  {
    "author": "Billy Carter",
    "category": "home",
    "id": 35321,
    "text": "Beer is not a good cocktail-party drink, especially in a home where you don't know where the bathroom is."
  },
  {
    "author": "Alton Brown",
    "category": "home",
    "id": 35569,
    "text": "I'm like a really goofy home ec teacher."
  },
  {
    "author": "Tom Colicchio",
    "category": "home",
    "id": 35560,
    "text": "Most cooks try to learn by making dishes. Doesn't mean you can cook. It means you can make that dish. When you can cook is when you can go to a farmers market, buy a bunch of stuff, then go home and make something without looking at a recipe. Now you're cooking."
  },
  {
    "author": "R. Buckminster Fuller",
    "category": "home",
    "id": 35126,
    "text": "Let architects sing of aesthetics that bring Rich clients in hordes to their knees Just give me a home, in a great circle dome Where stresses and strains are at ease."
  },
  {
    "author": "Guillermo Cabrera Infante",
    "category": "home",
    "id": 35775,
    "text": "I read the Odyssey because it was the story of a man who returned home after being absent for more than twenty years and was recognized only by his dog."
  },
  {
    "author": "Garry Moore",
    "category": "home",
    "id": 35105,
    "text": "Christmas is, of course, the time to be home - in heart as well as body."
  },
  {
    "author": "Angie Stone",
    "category": "home",
    "id": 35133,
    "text": "I'm the type of woman you might say is too good. I'll massage a man's feet, have dinner cooked when he gets home. But once they leave, the door is closed, and the locks are changed."
  },
  {
    "author": "Robert Duvall",
    "category": "home",
    "id": 35508,
    "text": "It's like kids playing house: 'You play the father, I'll play the mother.' You know, you dress up, you play, they pay, you go home. It's a game - acting's a game."
  },
  {
    "author": "Nate Ruess",
    "category": "home",
    "id": 35744,
    "text": "I think any branding for me is band-related. It's really weird to get used to the exposure, because I am a naturally introverted person, and I'm not exactly social. Occasionally I can get comfortable enough to talk, but I spend a lot of my days not talking, especially when I'm at home and not on tour."
  },
  {
    "author": "Josh Hutcherson",
    "category": "home",
    "id": 35731,
    "text": "I play basketball probably four to five days a week when I'm back home."
  },
  {
    "author": "Jesse Jackson",
    "category": "home",
    "id": 35461,
    "text": "In Afghanistan, there is a plan to build democracy hundreds of thousands of troops are protecting it. There is a plan to rebuild and reconstruct there. But many thousands of Americans die from violence and poverty every year and we don't have a plan for reconstruction at home."
  },
  {
    "author": "James Madison",
    "category": "home",
    "id": 34991,
    "text": "The means of defense against foreign danger historically have become the instruments of tyranny at home."
  },
  {
    "author": "Camille Paglia",
    "category": "home",
    "id": 35225,
    "text": "Perhaps there is no greater issue facing contemporary women than the choices they must make about balancing home and work."
  },
  {
    "author": "Cat Deeley",
    "category": "home",
    "id": 35609,
    "text": "A girl's got to do what she's got to do to make somebody pay her a compliment. If that means moaning 'til the cows come home, then so be it."
  },
  {
    "author": "Eminem",
    "category": "home",
    "id": 34906,
    "text": "Say there's a white kid who lives in a nice home, goes to an all-white school, and is pretty much having everything handed to him on a platter - for him to pick up a rap tape is incredible to me, because what that's saying is that he's living a fantasy life of rebellion."
  },
  {
    "author": "Jeffrey Kluger",
    "category": "home",
    "id": 35551,
    "text": "There's only one thing harder than living in a home with an adolescent - and that's being an adolescent. The moodiness, the volatility, the wholesale lack of impulse control, all would be close to clinical conditions if they occurred at another point in life. In adolescence, they're just part of the behavioral portfolio."
  },
  {
    "author": "Richard Bach",
    "category": "home",
    "id": 34968,
    "text": "The simplest questions are the most profound. Where were you born? Where is your home? Where are you going? What are you doing? Think about these once in a while and watch your answers change."
  },
  {
    "author": "Salma Hayek",
    "category": "home",
    "id": 35358,
    "text": "For my wrap present, Colin Farrell gave me a first edition book. I got so involved with this character and I was so sad when the movie was over that when I got home and I tried to read the book I got really emotional and I started crying."
  },
  {
    "author": "Christopher Walken",
    "category": "home",
    "id": 35442,
    "text": "The best thing for me is, when I'm not working, is to be at home and to have a script or two scripts is better, and to be just walking around the house and just thinking about the lines."
  },
  {
    "author": "Danica McKellar",
    "category": "home",
    "id": 35316,
    "text": "Most of the time I liked school and got good grades. In junior high, though, I hit a stumbling block with math - I used to come home and cry because of how frustrated I was! But after a few good teachers and a lot of perseverance, I ended up loving math and even choosing it as a major when I got to college."
  },
  {
    "author": "Stephen Gardiner",
    "category": "home",
    "id": 35763,
    "text": "Land is the secure ground of home, the sea is like life, the outside, the unknown."
  },
  {
    "author": "Mike Huckabee",
    "category": "home",
    "id": 35811,
    "text": "I support workplace clean air. But a federal ban on smoking would mean that you couldn't smoke in your own home. I don't care what people do in their home."
  },
  {
    "author": "Johnny Vegas",
    "category": "home",
    "id": 35377,
    "text": "My first holiday to San Francisco in 1998-99 was supposed to be a two-week vacation but I ended up staying five weeks and nearly didn't come home."
  },
  {
    "author": "Alfred Lord Tennyson",
    "category": "home",
    "id": 35040,
    "text": "A smile abroad is often a scowl at home."
  },
  {
    "author": "Ella Maillart",
    "category": "home",
    "id": 35783,
    "text": "Every time I took a long leave from home, I felt as if I were going to conquer the world. Or rather, take possession of what is my birthright, my inheritance."
  },
  {
    "author": "Potter Stewart",
    "category": "home",
    "id": 35707,
    "text": "The 4th Amendment and the personal rights it secures have a long history. At the very core stands the right of a man to retreat into his own home and there be free from unreasonable governmental intrusion."
  },
  {
    "author": "David Attenborough",
    "category": "home",
    "id": 35349,
    "text": "I think a major element of jetlag is psychological. Nobody ever tells me what time it is at home."
  },
  {
    "author": "Rick Perry",
    "category": "home",
    "id": 35076,
    "text": "When a criminal breaks into your home I'll let the liberals call the lawyer. I'm going to call Smith &amp Wesson."
  },
  {
    "author": "Katherine Jenkins",
    "category": "home",
    "id": 35585,
    "text": "I love coming back to Neath - this is home and always will be."
  },
  {
    "author": "Tommy Lee Jones",
    "category": "home",
    "id": 35709,
    "text": "My home town is very small and very remote and we don't have a movie house."
  },
  {
    "author": "James Madison",
    "category": "home",
    "id": 35000,
    "text": "The loss of liberty at home is to be charged to the provisions against danger, real or imagined, from abroad."
  },
  {
    "author": "Lionel Blue",
    "category": "home",
    "id": 35789,
    "text": "Praying privately in churches, I began to discover that heaven was my true home and also that it was here and now, woven into this life."
  },
  {
    "author": "Bob Dylan",
    "category": "home",
    "id": 34941,
    "text": "My father probably thought the capital of the world was wherever he was at the time. It couldn't possibly be anyplace else. Where he and his wife were in their own home, that, for them, was the capital of the world."
  },
  {
    "author": "Suze Orman",
    "category": "home",
    "id": 35008,
    "text": "Owning a home is a keystone of wealth - both financial affluence and emotional security."
  },
  {
    "author": "Ronald Reagan",
    "category": "home",
    "id": 34909,
    "text": "We should declare war on North Vietnam. We could pave the whole country and put parking strips on it, and still be home by Christmas."
  },
  {
    "author": "George Bernard Shaw",
    "category": "home",
    "id": 34834,
    "text": "Home life is no more natural to us than a cage is natural to a cockatoo."
  },
  {
    "author": "Andrea Jung",
    "category": "home",
    "id": 35819,
    "text": "You know, you go home and you try on a new mascara, and I guess a male CEO can't do that."
  },
  {
    "author": "Norah Jones",
    "category": "home",
    "id": 35375,
    "text": "Sometimes when you're trying to do a record too close to home, you can get really distracted."
  },
  {
    "author": "Cameron Diaz",
    "category": "home",
    "id": 35525,
    "text": "Believe me, you can get into a lot of trouble being sixteen years old in a foreign country with no adult telling you when to come home."
  },
  {
    "author": "Marco Rubio",
    "category": "home",
    "id": 35185,
    "text": "Americans chose a free enterprise system designed to provide a quality of opportunity, not compel a quality of results. And that is why this is only place in the world where you can open up a business in the spare bedroom of your home."
  },
  {
    "author": "Anna Nicole Smith",
    "category": "home",
    "id": 35408,
    "text": "I have been alone since my husband died. I stay in my home. I don't date. It's hard to date when you're at home. Nobody knows you."
  },
  {
    "author": "Claudia Black",
    "category": "home",
    "id": 35368,
    "text": "I feel that I'm at my best as a person and that I'm coming home when I walk on to a set, or on to a stage, so if I can perform in one way or another I think I'll be okay."
  },
  {
    "author": "Joel Osteen",
    "category": "home",
    "id": 34954,
    "text": "On Sundays when I speak, I hopefully give somebody something that they can use the next day at work or at home."
  },
  {
    "author": "Chief Joseph",
    "category": "home",
    "id": 35080,
    "text": "General Howard informed me, in a haughty spirit, that he would give my people 30 days to go back home, collect all their stock, and move onto the reservation."
  },
  {
    "author": "Sigmund Freud",
    "category": "home",
    "id": 34983,
    "text": "Analogies, it is true, decide nothing, but they can make one feel more at home."
  },
  {
    "author": "Chris Brown",
    "category": "home",
    "id": 35082,
    "text": "Since I'm always working, my best holiday memories are definitely when I can just go home and spend time with my family."
  },
  {
    "author": "Natalie Imbruglia",
    "category": "home",
    "id": 35628,
    "text": "I've done a lot of partying in my time because I didn't want to go home and I didn't know what to do."
  },
  {
    "author": "Michael Sheen",
    "category": "home",
    "id": 35581,
    "text": "While I enjoy spending time in L.A., Britain is my home."
  },
  {
    "author": "William Temple",
    "category": "home",
    "id": 35112,
    "text": "The most influential of all educational factors is the conversation in a child's home."
  },
  {
    "author": "Jill Scott",
    "category": "home",
    "id": 34870,
    "text": "To be a queen of a household is a powerful thing."
  },
  {
    "author": "Layne Staley",
    "category": "home",
    "id": 35002,
    "text": "I've always looked for the perfect life to step into. I've taken all the paths to get where I wanted.But no matter where I go, I still come home me."
  },
  {
    "author": "Joe Biden",
    "category": "home",
    "id": 35342,
    "text": "I was kind of secretly hoping one of my kids would go out and make a million bucks. So when they put me in a home, at least I'll have a window with a view."
  },
  {
    "author": "Naguib Mahfouz",
    "category": "home",
    "id": 35598,
    "text": "Events at home, at work, in the street - these are the bases for a story."
  },
  {
    "author": "Michael Phelps",
    "category": "home",
    "id": 35161,
    "text": "Swimming is normal for me. I'm relaxed. I'm comfortable, and I know my surroundings. It's my home."
  },
  {
    "author": "Paris Hilton",
    "category": "home",
    "id": 35098,
    "text": "Yes, I've kissed a lot of guys. I like to kiss, but that's it. I don't go home with anyone. I sleep with my animals, like my baby monkey, Brigitte Bardot."
  },
  {
    "author": "Jesse Ventura",
    "category": "home",
    "id": 35260,
    "text": "We call our country home of the brave and land of the free, but it's not. We give a false portrayal of freedom. We're not free - if we were, we'd allow people their freedom."
  },
  {
    "author": "Shaun White",
    "category": "home",
    "id": 35242,
    "text": "Snowboarding's tough, because you've got to go to the mountains. For me, I love the skateboard season because I get to hangout at home and still be skating. I don't have to travel to Norway or Japan or these crazy places to be snowboarding."
  },
  {
    "author": "Joe Biden",
    "category": "home",
    "id": 35341,
    "text": "Here at home, when Americans were standing in long lines to give blood after the attack on the World Trade Center and the Pentagon, we squandered an obvious opportunity to make service a noble cause again, and rekindle an American spirit of community."
  },
  {
    "author": "David Attenborough",
    "category": "home",
    "id": 35350,
    "text": "It's coming home to roost over the next 50 years or so. It's not just climate change it's sheer space, places to grow food for this enormous horde. Either we limit our population growth or the natural world will do it for us, and the natural world is doing it for us right now."
  },
  {
    "author": "Ann Romney",
    "category": "home",
    "id": 35526,
    "text": "I made a choice to stay home and raise five boys. Believe me, it was hard work."
  },
  {
    "author": "Adam Lambert",
    "category": "home",
    "id": 35348,
    "text": "After my tour I had time to stay at home, be with my boyfriend and hang out with friends and that brought me down to earth and helped me write music from a more relaxed place."
  },
  {
    "author": "Tad Williams",
    "category": "home",
    "id": 34836,
    "text": "Never make your home in a place. Make a home for yourself inside your own head. You'll find what you need to furnish it - memory, friends you can trust, love of learning, and other such things. That way it will go with you wherever you journey."
  },
  {
    "author": "Cat Cora",
    "category": "home",
    "id": 35604,
    "text": "If eating out, order your meal and ask the server to wrap up half of the portion to take home with your for the next day, keeping your portion size in check, and stretching your dollar into two meals."
  },
  {
    "author": "Eric Bana",
    "category": "home",
    "id": 35615,
    "text": "When I shoot I'll take my family with me - one movie a year and then the rest of the time at home."
  },
  {
    "author": "Alan Rickman",
    "category": "home",
    "id": 35249,
    "text": "I'm still living the life where you get home and open the fridge and there's half a pot of yogurt and a half a can of flat Coca-Cola."
  },
  {
    "author": "Michelle Pfeiffer",
    "category": "home",
    "id": 35801,
    "text": "I do portraits. I usually do live models in a class environment, but I've been painting at home more. I really love the human form, and I love faces. I've tried to do landscapes a few times."
  },
  {
    "author": "Jennifer Garner",
    "category": "home",
    "id": 35685,
    "text": "My sisters both are working mothers. I understand that my being an actress as well as being at home isn't some heroic thing. That doesn't mean it isn't confusing or difficult - especially that question of how you find a balance."
  },
  {
    "author": "Elayne Boosler",
    "category": "home",
    "id": 35303,
    "text": "Stand-up is like a movie every night. You write it, direct it, produce it, the audience votes, and you go home. There's nothing more satisfying."
  },
  {
    "author": "John Ratzenberger",
    "category": "home",
    "id": 35776,
    "text": "On my visits back home, if they saw that I was getting a big head, they'd let me know right away."
  },
  {
    "author": "Casey Stengel",
    "category": "home",
    "id": 35221,
    "text": "They say Yogi Berra is funny. Well, he has a lovely wife and family, a beautiful home, money in the bank, and he plays golf with millionaires. What's funny about that?"
  }
]

quotes['hope'] = [
  {
    "author": "Angela Merkel",
    "category": "hope",
    "id": 36552,
    "text": "Overcoming the Cold War required courage from the people of Central and Eastern Europe and what was then the German Democratic Republic, but it also required the steadfastness of Western partner over many decades when many had long lost hope of integration of the two Germanys and Europe."
  },
  {
    "author": "Mark Twain",
    "category": "hope",
    "id": 35834,
    "text": "Lord save us all from a hope tree that has lost the faculty of putting out blossoms."
  },
  {
    "author": "Reinhold Niebuhr",
    "category": "hope",
    "id": 36118,
    "text": "Nothing that is worth doing can be achieved in a lifetime therefore we must be saved by hope."
  },
  {
    "author": "Manuel Puig",
    "category": "hope",
    "id": 36630,
    "text": "Ironically, Latin American countries, in their instability, give writers and intellectuals the hope that they are needed."
  },
  {
    "author": "Aristotle",
    "category": "hope",
    "id": 35843,
    "text": "Hope is the dream of a waking man."
  },
  {
    "author": "Fyodor Dostoevsky",
    "category": "hope",
    "id": 35870,
    "text": "To live without Hope is to Cease to live."
  },
  {
    "author": "Bill Vaughan",
    "category": "hope",
    "id": 36434,
    "text": "We hope that, when the insects take over the world, they will remember with gratitude how we took them along on all our picnics."
  },
  {
    "author": "P. J. Harvey",
    "category": "hope",
    "id": 36808,
    "text": "I tried to use words that were dealing with the emotional quality that any human being could recognize in the way that they felt about their country. It's to do with the world we live in. That world is a brutal one and full of war. It's also full of many wonderful things and love and hope."
  },
  {
    "author": "Alanis Morissette",
    "category": "hope",
    "id": 36203,
    "text": "I see the whole concept of Generation X implies that everyone has lost hope."
  },
  {
    "author": "Dave Matthews",
    "category": "hope",
    "id": 36182,
    "text": "But then there are magical, beautiful things in the world. There's incredible acts of kindness and bravery, and in the most unlikely places, and it gives you hope."
  },
  {
    "author": "William J. Clinton",
    "category": "hope",
    "id": 36380,
    "text": "I still believe in a place called Hope."
  },
  {
    "author": "Sloane Crosley",
    "category": "hope",
    "id": 36549,
    "text": "I hope to one day co-sign a lease with another person but, well, it doesn't plague me that I have yet to do so. Put it this way: I've never had to violently tug at my own pillow at 2 A.M. to get myself to stop snoring."
  },
  {
    "author": "Stephen Hawking",
    "category": "hope",
    "id": 36079,
    "text": "Among physicists, I'm respected I hope."
  },
  {
    "author": "Yves Saint Laurent",
    "category": "hope",
    "id": 36049,
    "text": "I have often said that I wish I had invented blue jeans: the most spectacular, the most practical, the most relaxed and nonchalant. They have expression, modesty, sex appeal, simplicity - all I hope for in my clothes."
  },
  {
    "author": "Desmond Tutu",
    "category": "hope",
    "id": 36089,
    "text": "Hope is being able to see that there is light despite all of the darkness."
  },
  {
    "author": "Jean Kerr",
    "category": "hope",
    "id": 36491,
    "text": "You don't seem to realize that a poor person who is unhappy is in a better position than a rich person who is unhappy. Because the poor person has hope. He thinks money would help."
  },
  {
    "author": "Craig Ferguson",
    "category": "hope",
    "id": 36581,
    "text": "I hope what I do has an art to it, and as an artist you have to try new things and keep yourself entertained."
  },
  {
    "author": "Barbara Bush",
    "category": "hope",
    "id": 36238,
    "text": "Life has changed enormously, and I hope - I hope more people read good things."
  },
  {
    "author": "Samuel Smiles",
    "category": "hope",
    "id": 35875,
    "text": "Hope is like the sun, which, as we journey toward it, casts the shadow of our burden behind us."
  },
  {
    "author": "Calvin Coolidge",
    "category": "hope",
    "id": 36047,
    "text": "Little progress can be made by merely attempting to repress what is evil. Our great hope lies in developing what is good."
  },
  {
    "author": "Karl Rove",
    "category": "hope",
    "id": 36482,
    "text": "For a person who promised hope and civility in politics, Mr. Obama has shown a borderline obsessiveness in blaming Mr. Bush."
  },
  {
    "author": "Elbert Hubbard",
    "category": "hope",
    "id": 35949,
    "text": "Love, we say, is life but love without hope and faith is agonizing death."
  },
  {
    "author": "Arnold H. Glasow",
    "category": "hope",
    "id": 35862,
    "text": "Expecting something for nothing is the most popular form of hope."
  },
  {
    "author": "Vanessa Paradis",
    "category": "hope",
    "id": 36542,
    "text": "I do sometimes strongly hope that in a past life, my most recent life before this, I was absolutely horrible, evil, hideous. Because otherwise - well, hell, to even things up next time around, I'm going to have to pay for this one, am I not?"
  },
  {
    "author": "John Grisham",
    "category": "hope",
    "id": 36792,
    "text": "I've had nine of my books adapted to film, and almost all were enjoyable. I've been very lucky with Hollywood, and look forward to more movies being adapted. But I don't get involved in that process. I know nothing about making movies and I stay away from it and hope for the best."
  },
  {
    "author": "Mignon McLaughlin",
    "category": "hope",
    "id": 36056,
    "text": "Hope is the feeling we have that the feeling we have is not permanent."
  },
  {
    "author": "Carter Burwell",
    "category": "hope",
    "id": 36753,
    "text": "Even if I went off to some other career, I hope I would still be doing Coen films."
  },
  {
    "author": "Marion Cotillard",
    "category": "hope",
    "id": 36553,
    "text": "It was an amazing adventure, it was my dream to be in an American musical... I really hope you are going to love what you are going to see."
  },
  {
    "author": "Marvin Gaye",
    "category": "hope",
    "id": 36823,
    "text": "I hope to refine music, study it, try to find some area that I can unlock. I don't quite know how to explain it but it's there. These can't be the only notes in the world, there's got to be other notes some place, in some dimension, between the cracks on the piano keys."
  },
  {
    "author": "Immanuel Kant",
    "category": "hope",
    "id": 36147,
    "text": "What can I know? What ought I to do? What can I hope?"
  },
  {
    "author": "Nicolas Chamfort",
    "category": "hope",
    "id": 36378,
    "text": "One must not hope to be more than one can be."
  },
  {
    "author": "Jeffrey Archer",
    "category": "hope",
    "id": 36743,
    "text": "Well I certainly have learned and I hope I'm moving on and certainly two years of prison was a terrible punishment."
  },
  {
    "author": "Ed Bradley",
    "category": "hope",
    "id": 36020,
    "text": "Be prepared, work hard, and hope for a little luck. Recognize that the harder you work and the better prepared you are, the more luck you might have."
  },
  {
    "author": "Ingrid Newkirk",
    "category": "hope",
    "id": 36650,
    "text": "I hope SeaWorld is exploring how, like Ringling, it can get out of the wild animal business."
  },
  {
    "author": "Alex Haley",
    "category": "hope",
    "id": 36390,
    "text": "My fondest hope is that 'Roots' may start black, white, brown, red, yellow people digging back for their own roots. Man, that would make me feel 90 feet tall."
  },
  {
    "author": "Garth Brooks",
    "category": "hope",
    "id": 36751,
    "text": "Whatever I do, I hope it's quality, I hope it's something that's class."
  },
  {
    "author": "Ryan Gosling",
    "category": "hope",
    "id": 36393,
    "text": "I just sort of take it from a character perspective, and I don't know if he was necessarily spiritual, but I do think he had hope. He was a character that was comfortable having hope in his life, and hope is faith."
  },
  {
    "author": "Jonathan Sacks",
    "category": "hope",
    "id": 36430,
    "text": "We are biological creatures. We are born, we live, we die. There is no transcendent purpose to existence. At best we are creatures of reason, and by using reason we can cure ourselves of emotional excess. Purged of both hope and fear, we find courage in the face of helplessness, insignificance and uncertainty."
  },
  {
    "author": "Lawrence Kasdan",
    "category": "hope",
    "id": 36663,
    "text": "What you hope for, like Unforgiven did a lot to give you a chance to do it again sometime."
  },
  {
    "author": "Emil Zatopek",
    "category": "hope",
    "id": 36117,
    "text": "An athlete cannot run with money in his pockets. He must run with hope in his heart and dreams in his head."
  },
  {
    "author": "Rose Kennedy",
    "category": "hope",
    "id": 36233,
    "text": "What greater aspiration and challenge are there for a mother than the hope of raising a great son or daughter?"
  },
  {
    "author": "George Chakiris",
    "category": "hope",
    "id": 35924,
    "text": "No matter how dark the moment, love and hope are always possible."
  },
  {
    "author": "Miguel de Cervantes",
    "category": "hope",
    "id": 36335,
    "text": "To withdraw is not to run away, and to stay is no wise action, when there's more reason to fear than to hope."
  },
  {
    "author": "Bryant H. McGill",
    "category": "hope",
    "id": 36215,
    "text": "Truth is not a matter of fact but a state of harmony with progress and hope. Enveloped only in its wings will we ever soar to the promise of our greater selves."
  },
  {
    "author": "Miley Cyrus",
    "category": "hope",
    "id": 36228,
    "text": "I am so excited to let fans in on how important my relationship with my family is to me. I hope to motivate mothers and daughters to build lifetimes of memories together and inspire kids around the world to live their dreams."
  },
  {
    "author": "Mattie Stepanek",
    "category": "hope",
    "id": 36043,
    "text": "Keep all special thoughts and memories for lifetimes to come. Share these keepsakes with others to inspire hope and build from the past, which can bridge to the future."
  },
  {
    "author": "Imran Khan",
    "category": "hope",
    "id": 36352,
    "text": "They do not understand Islam, and I think that is one area where perhaps I hope one day I will play a role in actually making people understand what we perceive Islam to be."
  },
  {
    "author": "Paul Theroux",
    "category": "hope",
    "id": 36617,
    "text": "The moment that changed me for ever was the moment my first child was born. I was happy, filled with hope, and thought, 'Now I understand the whole point of work, of life, of love.'"
  },
  {
    "author": "James Russell Lowell",
    "category": "hope",
    "id": 36061,
    "text": "Children are God's Apostles, sent forth, day by day, to preach of love, and hope, and peace."
  },
  {
    "author": "Michael Palin",
    "category": "hope",
    "id": 36271,
    "text": "Armageddon is not around the corner. This is only what the people of violence want us to believe. The complexity and diversity of the world is the hope for the future."
  },
  {
    "author": "Georges Bernanos",
    "category": "hope",
    "id": 36665,
    "text": "Hope is a risk that must be run."
  },
  {
    "author": "Anna Kendrick",
    "category": "hope",
    "id": 36652,
    "text": "To not be self-conscious of your appearance is huge, and something that I desperately hope to carry into film at some point in my useless life - to not be thinking, 'My ear looks weird from this angle, why is the camera over there?'"
  },
  {
    "author": "Thomas Jefferson",
    "category": "hope",
    "id": 35915,
    "text": "I hope our wisdom will grow with our power, and teach us, that the less we use our power the greater it will be."
  },
  {
    "author": "Antonio Porchia",
    "category": "hope",
    "id": 36721,
    "text": "Flowers are without hope. Because hope is tomorrow and flowers have no tomorrow."
  },
  {
    "author": "Billy Corgan",
    "category": "hope",
    "id": 36239,
    "text": "Like any good tree that one would hope to grow, we must set our roots deep into the ground so that what is real will prosper in the Light of Love."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "hope",
    "id": 35847,
    "text": "Courage is like love it must have hope for nourishment."
  },
  {
    "author": "Stanislav Grof",
    "category": "hope",
    "id": 36157,
    "text": "A radical inner transformation and rise to a new level of consciousness might be the only real hope we have in the current global crisis brought on by the dominance of the Western mechanistic paradigm."
  },
  {
    "author": "Ivan Illich",
    "category": "hope",
    "id": 35890,
    "text": "At the moment of death I hope to be surprised."
  },
  {
    "author": "Paul Walker",
    "category": "hope",
    "id": 36761,
    "text": "I hope I'm in a position to make stuff that I really want to make as opposed to stuff that I just have to make for money reasons, or to sustain a certain marquee value."
  },
  {
    "author": "Christopher Reeve",
    "category": "hope",
    "id": 36541,
    "text": "I have more awareness of other people and, I hope, more sensitivity to their needs. I also find that I'm more direct and outspoken."
  },
  {
    "author": "William Hague",
    "category": "hope",
    "id": 36403,
    "text": "At a time of such hope and optimism in the Middle East, we cannot let the Libyan government violate every principle of international law and human rights with impunity."
  },
  {
    "author": "J. J. Abrams",
    "category": "hope",
    "id": 36606,
    "text": "I hope to make movies that are so small they don't need to make anything to be profitable."
  },
  {
    "author": "Dario Argento",
    "category": "hope",
    "id": 36644,
    "text": "The Opera was a very cold film, a hopeless and dark film, no hope, no love."
  },
  {
    "author": "Jonas Salk",
    "category": "hope",
    "id": 36201,
    "text": "Hope lies in dreams, in imagination, and in the courage of those who dare to make dreams into reality."
  },
  {
    "author": "Aristotle",
    "category": "hope",
    "id": 35894,
    "text": "Hope is a waking dream."
  },
  {
    "author": "William J. Clinton",
    "category": "hope",
    "id": 36274,
    "text": "A lot of presidential memoirs, they say, are dull and self-serving. I hope mine is interesting and self-serving."
  },
  {
    "author": "Bob Riley",
    "category": "hope",
    "id": 36122,
    "text": "Drugs are the enemies of ambition and hope - and when we fight against drugs we are fighting for the future."
  },
  {
    "author": "E. M. Forster",
    "category": "hope",
    "id": 36046,
    "text": "I hate the idea of causes, and if I had to choose between betraying my country and betraying my friend, I hope I should have the guts to betray my country."
  },
  {
    "author": "Spike Lee",
    "category": "hope",
    "id": 36432,
    "text": "Right now a lot of people are still choosing to go to Toronto instead of shooting in New York City, something I haven't done and something I hope I'll never have to do."
  },
  {
    "author": "Neil LaBute",
    "category": "hope",
    "id": 36730,
    "text": "I'm more than open to hope, but I think men and women have a difficult time dealing with each other and often take the low road."
  },
  {
    "author": "Eric Alterman",
    "category": "hope",
    "id": 36656,
    "text": "The myth of the liberal media empowers conservatives to control debate in the United States to the point where liberals cannot even hope for a fair shake anymore."
  },
  {
    "author": "Marlon Wayans",
    "category": "hope",
    "id": 36766,
    "text": "You learn timing on the road. You learn structure and how to read an audience. You learn so much about the business of laughter that you can't learn on a set, because it's all on you. Sometimes you bomb, and you know not to tell that joke again... You just hope people find the humor in the awkwardness."
  },
  {
    "author": "Oscar Hammerstein II",
    "category": "hope",
    "id": 36152,
    "text": "I know the world is filled with troubles and many injustices. But reality is as beautiful as it is ugly. I think it is just as important to sing about beautiful mornings as it is to talk about slums. I just couldn't write anything without hope in it."
  },
  {
    "author": "Thornton Wilder",
    "category": "hope",
    "id": 36230,
    "text": "Hope, like faith, is nothing if it is not courageous it is nothing if it is not ridiculous."
  },
  {
    "author": "Carol Vorderman",
    "category": "hope",
    "id": 36763,
    "text": "Next year, I hope there will be even more parties, lots of holidays and just having a good time, really. Plus wing-walking, air shows and learning to fly, as they are all things I want to do. I won't be restricted by age."
  },
  {
    "author": "Simon Mainwaring",
    "category": "hope",
    "id": 36288,
    "text": "In the social business marketplace, brands that hope to build loyal and growing communities do so most effectively when they demonstrate their core values and allow a community to build and engage around it."
  },
  {
    "author": "Bertrand Russell",
    "category": "hope",
    "id": 36021,
    "text": "Man needs, for his happiness, not only the enjoyment of this or that, but hope and enterprise and change."
  },
  {
    "author": "Tom Cruise",
    "category": "hope",
    "id": 36681,
    "text": "As a young actor, people were trying to define who I was before I really knew that for myself. But I still remember thinking, 'This is what I love doing, and I hope I'm going to be able to do it forever.'"
  },
  {
    "author": "Chloe Moretz",
    "category": "hope",
    "id": 36767,
    "text": "I hope to make acting my career for the rest of my life, if I can."
  },
  {
    "author": "Jerry Costello",
    "category": "hope",
    "id": 36682,
    "text": "Pope John Paul II brought hope to all corners of the world, to people of all faiths and backgrounds, with his powerful belief in the human spirit."
  },
  {
    "author": "Baltasar Gracian",
    "category": "hope",
    "id": 36144,
    "text": "Hope has a good memory, gratitude a bad one."
  },
  {
    "author": "Studs Terkel",
    "category": "hope",
    "id": 36594,
    "text": "I hope for peace and sanity - it's the same thing."
  },
  {
    "author": "Nelson Mandela",
    "category": "hope",
    "id": 35946,
    "text": "Our human compassion binds us the one to the other - not in pity or patronizingly, but as human beings who have learnt how to turn our common suffering into hope for the future."
  },
  {
    "author": "Elie Wiesel",
    "category": "hope",
    "id": 35877,
    "text": "Hope is like peace. It is not a gift from God. It is a gift only we can give one another."
  },
  {
    "author": "Diablo Cody",
    "category": "hope",
    "id": 36373,
    "text": "It's possible that I've matured as a writer, and I hope I've matured emotionally, but I always find myself revisiting these adolescent scenes."
  },
  {
    "author": "Hugh Laurie",
    "category": "hope",
    "id": 36544,
    "text": "One of the principal goals in my life has been to avoid embarrassing my children by doing the job I do. I hope I've managed to do that, and I hope that, with the job I'm in now, they are, if not proud, at least unembarrassed by it. I must say, my three are most agreeable children, who do nothing but delight me."
  },
  {
    "author": "Charlize Theron",
    "category": "hope",
    "id": 36164,
    "text": "I can only hope to be 10 percent of the mom mine was to me. She encouraged me to be confident and enjoy life. That's what I want for my son."
  },
  {
    "author": "Robert Frank",
    "category": "hope",
    "id": 36321,
    "text": "Black and white are the colors of photography. To me they symbolize the alternatives of hope and despair to which mankind is forever subjected."
  },
  {
    "author": "Aung San Suu Kyi",
    "category": "hope",
    "id": 36385,
    "text": "I do protect human rights, and I hope I shall always be looked up as a champion of human rights."
  },
  {
    "author": "Epicurus",
    "category": "hope",
    "id": 35837,
    "text": "Do not spoil what you have by desiring what you have not remember that what you now have was once among the things you only hoped for."
  },
  {
    "author": "Hillary Clinton",
    "category": "hope",
    "id": 35980,
    "text": "It is often when night looks darkest, it is often before the fever breaks that one senses the gathering momentum for change, when one feels that resurrection of hope in the midst of despair and apathy."
  },
  {
    "author": "Bryant H. McGill",
    "category": "hope",
    "id": 36030,
    "text": "While it is important for people to see your promise you must also remember that hope is the keeper of both happiness and disappointment, the father of both progress and failure."
  },
  {
    "author": "Benjamin Banneker",
    "category": "hope",
    "id": 36258,
    "text": "Evil communication corrupts good manners. I hope to live to hear that good communication corrects bad manners."
  },
  {
    "author": "William Shenstone",
    "category": "hope",
    "id": 36662,
    "text": "Hope is a flatterer, but the most upright of all parasites for she frequents the poor man's hut, as well as the palace of his superior."
  },
  {
    "author": "Tom DeLonge",
    "category": "hope",
    "id": 36625,
    "text": "I don't believe that I'm better than anybody, but I do believe that I'll try harder than most and I hope that people just join me for a little bit of a ride."
  },
  {
    "author": "Barbara Kingsolver",
    "category": "hope",
    "id": 36310,
    "text": "The very least you can do in your life is to figure out what you hope for. And the most you can do is live inside that hope."
  },
  {
    "author": "William Makepeace Thackeray",
    "category": "hope",
    "id": 35873,
    "text": "It is only hope which is real, and reality is a bitterness and a deceit."
  },
  {
    "author": "Daniel Day-Lewis",
    "category": "hope",
    "id": 36277,
    "text": "Ireland was a place for the renewal of hope and I still see it like that."
  },
  {
    "author": "Howard Mumford Jones",
    "category": "hope",
    "id": 36441,
    "text": "I, for one, hope that youth will again revolt and again demoralize the dead weight of conformity that now lies upon us."
  },
  {
    "author": "Lech Walesa",
    "category": "hope",
    "id": 36451,
    "text": "The hope of the nation which throughout the nineteenth century had not for a moment reconciled itself with the loss of independence, and fighting for its own freedom, fought at the same time for the freedom of other nations."
  }
]

quotes['humor'] = [
  {
    "author": "Mel Brooks",
    "category": "humor",
    "id": 36854,
    "text": "Humor is just another defense against the universe."
  },
  {
    "author": "H. G. Wells",
    "category": "humor",
    "id": 36936,
    "text": "Cynicism is humor in ill health."
  },
  {
    "author": "Sid Caesar",
    "category": "humor",
    "id": 36873,
    "text": "Comedy has to be based on truth. You take the truth and you put a little curlicue at the end."
  },
  {
    "author": "Teddy Thompson",
    "category": "humor",
    "id": 37245,
    "text": "I think I'm too cynical for L.A. My sense of humor doesn't go down well here, which probably affects my love life. I need to have a laugh track following me around so people know I'm trying to be funny."
  },
  {
    "author": "Kyle Chandler",
    "category": "humor",
    "id": 37044,
    "text": "Sometimes a scene may be about one thing, and it may end up still being about that, but the emotionality of it comes from somewhere else, or the humor of it comes from somewhere else, and it gives it that real-life quality."
  },
  {
    "author": "Sinclair Lewis",
    "category": "humor",
    "id": 37056,
    "text": "There are two insults no human being will endure: that he has no sense of humor, and that he has never known trouble."
  },
  {
    "author": "Robertson Davies",
    "category": "humor",
    "id": 37135,
    "text": "The love of truth lies at the root of much humor."
  },
  {
    "author": "Alexander Payne",
    "category": "humor",
    "id": 37084,
    "text": "I get asked, 'How can you have such failures in your films?' Well, what else is life about? There's some sense of constant failure in something. Humor gives you a distance from it."
  },
  {
    "author": "Colin Firth",
    "category": "humor",
    "id": 36973,
    "text": "I always thought the biggest failing of Americans was their lack of irony. They are very serious there! Naturally, there are exceptions... the Jewish, Italian, and Irish humor of the East Coast."
  },
  {
    "author": "Russell Baker",
    "category": "humor",
    "id": 37010,
    "text": "Newspaper people, once celebrated as founts of ribald humor and uncouth fun, have of late lost all their gaiety, and small wonder."
  },
  {
    "author": "Bob Newhart",
    "category": "humor",
    "id": 37103,
    "text": "I don't know how many sacred cows there are today. I think there's a little confusion between humor and gross passing for humor. That's kind of regrettable."
  },
  {
    "author": "Max Irons",
    "category": "humor",
    "id": 37267,
    "text": "Kindness and a generous spirit go a long way. And a sense of humor. It's like medicine - very healing."
  },
  {
    "author": "Samuel Butler",
    "category": "humor",
    "id": 36919,
    "text": "A sense of humor keen enough to show a man his own absurdities will keep him from the commission of all sins, or nearly all, save those worth committing."
  },
  {
    "author": "Jeff Ross",
    "category": "humor",
    "id": 37238,
    "text": "Humor that is edgy is never squeaky clean."
  },
  {
    "author": "Tabitha Soren",
    "category": "humor",
    "id": 37284,
    "text": "At NBC I wasn't really sure if the grandparents were going to get my sense of humor on a particular topic."
  },
  {
    "author": "Melissa Rosenberg",
    "category": "humor",
    "id": 37128,
    "text": "My humor tends to be a little more edgy than is appropriate for 'Twilight,' although I got some in there. That was fun! There's just a tonal difference. For me, storytelling is storytelling. But, I do like writing for grown ups."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "humor",
    "id": 36911,
    "text": "The overwhelming majority of Americans are possessed of two great qualities a sense of humor and a sense of proportion."
  },
  {
    "author": "Selma Blair",
    "category": "humor",
    "id": 37134,
    "text": "Bathroom humor, fart, and poo poo humor in movies gets a laugh. It's a pretty easy audience, and that's been around for ages."
  },
  {
    "author": "Thomas Jefferson",
    "category": "humor",
    "id": 36898,
    "text": "In truth, politeness is artificial good humor, it covers the natural want of it, and ends by rendering habitual a substitute nearly equivalent to the real virtue."
  },
  {
    "author": "Edward de Bono",
    "category": "humor",
    "id": 37003,
    "text": "It has always surprised me how little attention philosophers have paid to humor, since it is a more significant process of mind than reason. Reason can only sort out perceptions, but the humor process is involved in changing them."
  },
  {
    "author": "Christopher Heyerdahl",
    "category": "humor",
    "id": 37350,
    "text": "Certainly, anyone whom I've witnessed, who has gone through something horrible and life-changing, has a sense of ironic humor, or an ability to look at the peculiarities of the world and find humor in it."
  },
  {
    "author": "Sherilyn Fenn",
    "category": "humor",
    "id": 37215,
    "text": "I don't think I could ever do a network sitcom because the humor is often based on some trite circumstance. I don't want to be a part of a show where it's mostly about coming up with the jokes."
  },
  {
    "author": "Antonio Banderas",
    "category": "humor",
    "id": 37023,
    "text": "I love the diversity of America. I love the plain, normal sense of humor Americans have. It is not wicked, like in some countries. And I also love how new America is."
  },
  {
    "author": "William Makepeace Thackeray",
    "category": "humor",
    "id": 36925,
    "text": "Good humor is one of the best articles of dress one can wear in society."
  },
  {
    "author": "Robert Collier",
    "category": "humor",
    "id": 36945,
    "text": "Our subconscious minds have no sense of humor, play no jokes and cannot tell the difference between reality and an imagined thought or image. What we continually think about eventually will manifest in our lives."
  },
  {
    "author": "Gloria Allred",
    "category": "humor",
    "id": 37210,
    "text": "Do feminists have a sense of humor? Yes."
  },
  {
    "author": "Gordon Gee",
    "category": "humor",
    "id": 37301,
    "text": "I often have said that to be a college president, you need a thick skin, a good sense of humor, and nerves like sewer pipes."
  },
  {
    "author": "Peter De Vries",
    "category": "humor",
    "id": 36879,
    "text": "The satirist shoots to kill while the humorist brings his prey back alive and eventually releases him again for another chance."
  },
  {
    "author": "Jimmy Buffett",
    "category": "humor",
    "id": 36921,
    "text": "Humor has bailed me out of more tight situations than I can think of. If you go with your instincts and keep your humor, creativity follows. With luck, success comes, too."
  },
  {
    "author": "Colm Meaney",
    "category": "humor",
    "id": 37193,
    "text": "I suppose I look for humor in most situations because it humanizes things it makes a character much more three-dimensional if there's some kind of humor. Not necessarily laugh-out-loud type of stuff, just a sense that there is a humorous edge to things. I do like that."
  },
  {
    "author": "Amy Schumer",
    "category": "humor",
    "id": 37330,
    "text": "I've always been really dark, and drawn to darker humor. Nothing has been forced, and I don't say anything for shock value."
  },
  {
    "author": "Kathy Griffin",
    "category": "humor",
    "id": 37014,
    "text": "A lot of stars don't have a sense of humor."
  },
  {
    "author": "Casey Affleck",
    "category": "humor",
    "id": 37230,
    "text": "If I can't see the humor in it, how am I going to be funny?"
  },
  {
    "author": "Anne Lamott",
    "category": "humor",
    "id": 36979,
    "text": "We can't understand when we're pregnant, or when our siblings are expecting, how profound it is to have a shared history with a younger generation: blood, genes, humor. It means we were actually here, on Earth, for a time - like the Egyptians with their pyramids, only with children."
  },
  {
    "author": "Bill Cosby",
    "category": "humor",
    "id": 36833,
    "text": "You can turn painful situations around through laughter. If you can find humor in anything, even poverty, you can survive it."
  },
  {
    "author": "Billy Gardell",
    "category": "humor",
    "id": 37300,
    "text": "The quickest way to defuse fear or insecurity or anger is usually humor. I think comics figure that out quickly, and, once you figure it out, you think, 'Hey, if I can do this and get paid, that would be kind of cool.'"
  },
  {
    "author": "Terrence Howard",
    "category": "humor",
    "id": 37127,
    "text": "Sometimes the only way to make palatable that which is appalling and apprehensive is to season it with some humor."
  },
  {
    "author": "Jami Gertz",
    "category": "humor",
    "id": 36910,
    "text": "Being a Hot Mom means being respected as a mom and a woman. And, the key to being a Hot Mom is having a sense of humor about yourself and all the crazy situations that arise."
  },
  {
    "author": "Herman Wouk",
    "category": "humor",
    "id": 37333,
    "text": "I regard the writing of humor as a supreme artistic challenge."
  },
  {
    "author": "John Kricfalusi",
    "category": "humor",
    "id": 37205,
    "text": "I'll let you in on a secret: I can't stand Jay Ward. I hate being compared to Rocky and Bullwinkle. It's just a different style of humor."
  },
  {
    "author": "David Duchovny",
    "category": "humor",
    "id": 36986,
    "text": "There are certain things I learned when I first started learning about acting, to try and place the character physically and emotionally. And the way you place them emotionally is often with humor."
  },
  {
    "author": "Ian MacKaye",
    "category": "humor",
    "id": 37140,
    "text": "I think sometimes my humor is extremely dry, and a lot of times I would say things that I thought were very funny but... I have a reputation of - people think of me as a very fundamentalist, humorless fellow."
  },
  {
    "author": "Robert Benchley",
    "category": "humor",
    "id": 36881,
    "text": "There seems to be no lengths to which humorless people will not go to analyze humor. It seems to worry them."
  },
  {
    "author": "Brittany Daniel",
    "category": "humor",
    "id": 37355,
    "text": "Comedy is so hard to do, so it was very cool to do dead pan humor."
  },
  {
    "author": "James Thurber",
    "category": "humor",
    "id": 36977,
    "text": "The nation that complacently and fearfully allows its artists and writers to become suspected rather than respected is no longer regarded as a nation possessed with humor or depth."
  },
  {
    "author": "Marion Ross",
    "category": "humor",
    "id": 37218,
    "text": "But if you don't watch me, I will try and sneak in some humor. I see humor everywhere in life around me."
  },
  {
    "author": "Mary Kay Blakely",
    "category": "humor",
    "id": 37352,
    "text": "Our humor turns our anger into a fine art."
  },
  {
    "author": "Josh Bowman",
    "category": "humor",
    "id": 37326,
    "text": "A good sense of humor will get you everywhere."
  },
  {
    "author": "Catherine Deneuve",
    "category": "humor",
    "id": 36897,
    "text": "A woman has to be intelligent, have charm, a sense of humor, and be kind. It's the same qualities I require from a man."
  },
  {
    "author": "Joe Grant",
    "category": "humor",
    "id": 37340,
    "text": "Dali had a good sense of humor - obviously you could tell just looking at him he was funny."
  },
  {
    "author": "Margaret Cho",
    "category": "humor",
    "id": 36992,
    "text": "It's good to be able to laugh at yourself and the problems you face in life. Sense of humor can save you."
  },
  {
    "author": "Michael J. Fox",
    "category": "humor",
    "id": 36922,
    "text": "I think the scariest person in the world is the person with no sense of humor."
  },
  {
    "author": "Bill Cosby",
    "category": "humor",
    "id": 36838,
    "text": "There is hope for the future because God has a sense of humor and we are funny to God."
  },
  {
    "author": "Nigel Cole",
    "category": "humor",
    "id": 37342,
    "text": "I think films about men are often about characters who don't want to express their feelings. You're supposed to kind of admire them for not expressing their feelings. And I feel that's a bit dull. Women's stories often have stronger emotional content, which I enjoy doing. What I really love doing is mixing that with humor."
  },
  {
    "author": "Sloane Crosley",
    "category": "humor",
    "id": 37041,
    "text": "I think a lot of humor is about distracting yourself. Pretend you're not trying to make it funny. Because for some reason the effort to be funny smells like sulphur in our culture."
  },
  {
    "author": "Bryan Cranston",
    "category": "humor",
    "id": 37035,
    "text": "Mixing humor and politics is something that works."
  },
  {
    "author": "Clifton Paul Fadiman",
    "category": "humor",
    "id": 36859,
    "text": "A sense of humor is the ability to understand a joke - and that the joke is oneself."
  },
  {
    "author": "Agnes Repplier",
    "category": "humor",
    "id": 36853,
    "text": "Humor brings insight and tolerance. Irony brings a deeper and less friendly understanding."
  },
  {
    "author": "Leslie Mann",
    "category": "humor",
    "id": 37321,
    "text": "I like dark humor. My favorite movie of all time is 'Harold and Maude.'"
  },
  {
    "author": "Tony Hale",
    "category": "humor",
    "id": 37320,
    "text": "And you know, whether it's drama or comedy, the best work is based on truth. It's just that, with comedy, the circumstances are just crazy-heightened, and you have these crazy things thrown at you. But you still have to do it truthfully, because that's where the humor comes from. So it's not that difficult to cross over."
  },
  {
    "author": "Hank Ketcham",
    "category": "humor",
    "id": 37180,
    "text": "Anyone in the humor business isn't thinking clearly if he doesn't surround himself with idea people. Otherwise, you settle for mediocrity - or you burn yourself out."
  },
  {
    "author": "Allen Klein",
    "category": "humor",
    "id": 37113,
    "text": "Laughter, and the broader category of humor, are key elements in helping us go on with our life after a loss."
  },
  {
    "author": "Peter Ustinov",
    "category": "humor",
    "id": 36847,
    "text": "Comedy is simply a funny way of being serious."
  },
  {
    "author": "Jacob August Riis",
    "category": "humor",
    "id": 36884,
    "text": "The more I live, the more I think that humor is the saving sense."
  },
  {
    "author": "Tom Berenger",
    "category": "humor",
    "id": 37196,
    "text": "There's a hysterical, tired sense of humor that comes after working 14 hours a day, six days a week. I like those things because they take the pressure off the constant stress."
  },
  {
    "author": "Allen Klein",
    "category": "humor",
    "id": 37112,
    "text": "Advertisers also know that humor can help bond us to their product."
  },
  {
    "author": "Will Eisner",
    "category": "humor",
    "id": 37360,
    "text": "Humor has historically been tied to the mores of the day. The Yellow Kid was predicated on what people thought was funny about the immigrant Irish. When you're different in a society, you're funny."
  },
  {
    "author": "Al Yankovic",
    "category": "humor",
    "id": 37070,
    "text": "It's hard to force creativity and humor."
  },
  {
    "author": "Vera Farmiga",
    "category": "humor",
    "id": 37013,
    "text": "I think God gave us senses of humor, and we should use them."
  },
  {
    "author": "Zac Efron",
    "category": "humor",
    "id": 37057,
    "text": "I wore goofy hats to school and did musical theater. Most people thought I was a dork. But if you have a sense of humor about it, no one can bring you down."
  },
  {
    "author": "Kristin Hersh",
    "category": "humor",
    "id": 37236,
    "text": "I've always chosen my band members based on their sense of humor. It might sound stupid, but it means not only are they fun to live with on a tour bus for years, but humor implies intelligence."
  },
  {
    "author": "Allen Klein",
    "category": "humor",
    "id": 36870,
    "text": "Humor can alter any situation and help us cope at the very instant we are laughing."
  },
  {
    "author": "Silvio Berlusconi",
    "category": "humor",
    "id": 37322,
    "text": "I'm not a traditional politician, and I have a sense of humor. I'll try to soften it and become boring, maybe even very boring, but I'm not sure if I'll be able to."
  },
  {
    "author": "Carrie Preston",
    "category": "humor",
    "id": 37246,
    "text": "Back in 2004, Kellie Overbey handed me her play 'Girl Talk' to read. I fell in love with her brutally delicious humor and the fearlessly deft way in which she drew her characters. They jumped off the page and begged me to give them a space in which to stomp around."
  },
  {
    "author": "Gail Porter",
    "category": "humor",
    "id": 37162,
    "text": "I try to cope with everything through humor."
  },
  {
    "author": "Ari Graynor",
    "category": "humor",
    "id": 37351,
    "text": "I was a precocious only child, and then I went through a fat, awkward stage for several years, so I learned to fall back on my humor and personality when I was growing up. It's how you survive, so I think it was more of a natural progression for me, developing into comedy."
  },
  {
    "author": "Jason Alexander",
    "category": "humor",
    "id": 37332,
    "text": "The thing about For Better or Worse is the only thing that made me an okay director for that is that I have a sense of humor, and it was supposed to be funny."
  },
  {
    "author": "Thomas W. Higginson",
    "category": "humor",
    "id": 36891,
    "text": "There is no defense against adverse fortune which is so effectual as an habitual sense of humor."
  },
  {
    "author": "David Alan Grier",
    "category": "humor",
    "id": 37101,
    "text": "As I get older, my sense of humor is my biggest asset."
  },
  {
    "author": "Nicole Appleton",
    "category": "humor",
    "id": 37048,
    "text": "I find intelligence sexy. I find a sense of humor sexy. I find sensitivity sexy."
  },
  {
    "author": "J. J. Abrams",
    "category": "humor",
    "id": 37054,
    "text": "One of my favorite things about 'Star Trek' wasn't just the overt banter but the humor in that show about the relationships between the main characters and their reactions to the situations they would face there was a lot of comedy in that show without ever breaking its reality."
  },
  {
    "author": "Allen Klein",
    "category": "humor",
    "id": 36928,
    "text": "Your attitude is like a box of crayons that color your world. Constantly color your picture gray, and your picture will always be bleak. Try adding some bright colors to the picture by including humor, and your picture begins to lighten up."
  },
  {
    "author": "Erma Bombeck",
    "category": "humor",
    "id": 36899,
    "text": "There is a thin line that separates laughter and pain, comedy and tragedy, humor and hurt."
  },
  {
    "author": "Andy Milonakis",
    "category": "humor",
    "id": 37286,
    "text": "I'm going to do a lot of weird stuff that's not going to be like me prancing around like an insane 12-year-old. I showed everybody that side of me and I think it's time to do different stuff, even when it comes down to the type of humor. I want to do some drier, weirder stuff."
  },
  {
    "author": "Bobby Clarke",
    "category": "humor",
    "id": 37359,
    "text": "We take the shortest route to the puck and arrive in ill humor."
  },
  {
    "author": "Lisa Loeb",
    "category": "humor",
    "id": 37145,
    "text": "The guys in my band are great-we watch movies, we eat pizza, take walks, read books. Everybody has a really great sense of humor. And my boyfriend comes and visits me on the road."
  },
  {
    "author": "Kate Clinton",
    "category": "humor",
    "id": 37212,
    "text": "Lesbian humor isn't trying to sell anything, it doesn't have to sell out. Coming out as a lesbian onstage is still a very political act if it weren't, more women would do it."
  },
  {
    "author": "Arthur Hailey",
    "category": "humor",
    "id": 37324,
    "text": "The president of General Motors was in a foul humor."
  },
  {
    "author": "Richard Russo",
    "category": "humor",
    "id": 37091,
    "text": "At the risk of appearing disingenuous, I don't really think of myself as 'writing humor.' I'm simply reporting on the world I observe, which is frequently hilarious."
  },
  {
    "author": "Mark Van Doren",
    "category": "humor",
    "id": 37346,
    "text": "Nothing in man is more serious than his sense of humor it is the sign that he wants all the truth."
  },
  {
    "author": "Alfred North Whitehead",
    "category": "humor",
    "id": 37000,
    "text": "The total absence of humor from the Bible is one of the most singular things in all literature."
  },
  {
    "author": "Calvin Klein",
    "category": "humor",
    "id": 36990,
    "text": "What we're doing is fun - if you have any sense of humor at all!"
  },
  {
    "author": "Alanis Morissette",
    "category": "humor",
    "id": 36951,
    "text": "In my opinion, I think sarcasm and humor in a song, without turning it into a novelty song, is really charming."
  },
  {
    "author": "Alan Thicke",
    "category": "humor",
    "id": 37241,
    "text": "There are psychological repercussions to illness and we need a little more help to get through the effects not only on the afflicted but on the family. And I think there's even a place for humor in that."
  },
  {
    "author": "Carmen Electra",
    "category": "humor",
    "id": 37107,
    "text": "People who know me know I have a sense of humor that can really push the envelope."
  },
  {
    "author": "Allen Klein",
    "category": "humor",
    "id": 36874,
    "text": "Humor does not diminish the pain - it makes the space around it get bigger."
  },
  {
    "author": "Justin Halpern",
    "category": "humor",
    "id": 37331,
    "text": "Although Kurt Vonnegut may not be considered a humor writer, 'Breakfast of Champions' is one of the funniest books I've ever read."
  },
  {
    "author": "Cheryl Hines",
    "category": "humor",
    "id": 37222,
    "text": "I was a little shocked at how adult some of the humor was, because I was never that into animation before and when I watched 'Shrek' I really laughed out loud."
  },
  {
    "author": "Steve Irwin",
    "category": "humor",
    "id": 37046,
    "text": "You know, I'm Australian, and we have got the worst sense of humor. We are cruel to each other."
  },
  {
    "author": "Craig Ferguson",
    "category": "humor",
    "id": 37050,
    "text": "I realized women and humor were linked very closely."
  }
]

quotes['imagination'] = [
  {
    "author": "Philip Roth",
    "category": "imagination",
    "id": 37901,
    "text": "Obviously the facts are never just coming at you but are incorporated by an imagination that is formed by your previous experience. Memories of the past are not memories of facts but memories of your imaginings of the facts."
  },
  {
    "author": "Joyce Carol Oates",
    "category": "imagination",
    "id": 37677,
    "text": "Obviously the imagination is fueled by emotions beyond the control of the conscious mind."
  },
  {
    "author": "J. K. Rowling",
    "category": "imagination",
    "id": 37497,
    "text": "Imagination is not only the uniquely human capacity to envision that which is not, and therefore the fount of all invention and innovation. In its arguably most transformative and revelatory capacity, it is the power to that enables us to empathize with humans whose experiences we have never shared."
  },
  {
    "author": "Leonard Orr",
    "category": "imagination",
    "id": 38013,
    "text": "It takes as much imagination to create debt as to create income."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "imagination",
    "id": 37529,
    "text": "A poet ought not to pick nature's pocket. Let him borrow, and so borrow as to repay by the very act of borrowing. Examine nature accurately, but write from recollection, and trust more to the imagination than the memory."
  },
  {
    "author": "Claude Bernard",
    "category": "imagination",
    "id": 37665,
    "text": "Put off your imagination, as you put off your overcoat, when you enter the laboratory. Put it on again, as you put on your overcoat, when you leave."
  },
  {
    "author": "Bruce Greenwood",
    "category": "imagination",
    "id": 38022,
    "text": "If you don't pay attention and if your imagination isn't pretty much engaged, you're going to miss things and you're going to miss opportunities for it to be as compelling and as creepy as it can be."
  },
  {
    "author": "Nathan Fillion",
    "category": "imagination",
    "id": 37721,
    "text": "I think my printing to this day looks like the printing right out of a comic book. Actually, I always wanted to be in a comic book. I watched cartoons when I was a kid, too, and both comics and cartoons lit fire in my imagination. This realm holds a lot of interest for me, a lot of passion for me. So to be comic-ized, yeah, that's cool."
  },
  {
    "author": "Wallace Stevens",
    "category": "imagination",
    "id": 37684,
    "text": "To regard the imagination as metaphysics is to think of it as part of life, and to think of it as part of life is to realize the extent of artifice. We live in the mind."
  },
  {
    "author": "Voltaire",
    "category": "imagination",
    "id": 37445,
    "text": "Love is a canvas furnished by nature and embroidered by imagination."
  },
  {
    "author": "James A. Michener",
    "category": "imagination",
    "id": 37890,
    "text": "The really great writers are people like Emily Bronte who sit in a room and write out of their limited experience and unlimited imagination."
  },
  {
    "author": "Barbara Januszkiewicz",
    "category": "imagination",
    "id": 37858,
    "text": "Imagination needs to be fed."
  },
  {
    "author": "Joseph Conrad",
    "category": "imagination",
    "id": 37611,
    "text": "Only in men's imagination does every truth find an effective and undeniable existence. Imagination, not invention, is the supreme master of art as of life."
  },
  {
    "author": "Jane Campion",
    "category": "imagination",
    "id": 37712,
    "text": "There's no artist in this world that doesn't enjoy the dream that if they have bad reviews now, the story of Keats can redeem them, in their fantasy or imagination, in the future. I think Keats' poem 'Endymion' is a really difficult poem, and I'm not surprised that a lot of people pulled it apart in a way."
  },
  {
    "author": "Donald Trump",
    "category": "imagination",
    "id": 37499,
    "text": "A certificate of live birth is not the same thing by any stretch of the imagination as a birth certificate."
  },
  {
    "author": "Marcello Mastroianni",
    "category": "imagination",
    "id": 37888,
    "text": "Woman is the sun, an extraordinary creature, one that makes the imagination gallop."
  },
  {
    "author": "Billy Connolly",
    "category": "imagination",
    "id": 37622,
    "text": "I think my securities far outweigh my insecurities. I am not nearly as afraid of myself and my imagination as I used to be."
  },
  {
    "author": "Anna Deavere Smith",
    "category": "imagination",
    "id": 37704,
    "text": "I made a real specific decision when I came out of school and most artists were writing about home - if you were a woman, you were writing about being a woman - and I decided not to do that, write about what you know. That's not what I do. I went as far away from home as possible in terms of the development of my imagination."
  },
  {
    "author": "Rachel Zoe",
    "category": "imagination",
    "id": 37991,
    "text": "I don't think that people should wear dresses two sizes too small. I just think that sexiness is better left to the imagination. It's just more tasteful."
  },
  {
    "author": "Vladimir Nabokov",
    "category": "imagination",
    "id": 37604,
    "text": "Imagination, the supreme delight of the immortal and the immature, should be limited. In order to enjoy life, we should not enjoy it too much."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "imagination",
    "id": 37403,
    "text": "One is never fortunate or as unfortunate as one imagines."
  },
  {
    "author": "Havelock Ellis",
    "category": "imagination",
    "id": 37592,
    "text": "Man lives by imagination."
  },
  {
    "author": "Theodore Gericault",
    "category": "imagination",
    "id": 38060,
    "text": "With the brush we merely tint, while the imagination alone produces colour."
  },
  {
    "author": "Duane Michals",
    "category": "imagination",
    "id": 37400,
    "text": "Trust that little voice in your head that says 'Wouldn't it be interesting if...' And then do it."
  },
  {
    "author": "LeVar Burton",
    "category": "imagination",
    "id": 37910,
    "text": "It's definitely true that there are a lot of the devices we used on 'Star Trek,' that came out the imagination of the writers, and the creators that are actually in the world today."
  },
  {
    "author": "Bruce Springsteen",
    "category": "imagination",
    "id": 37655,
    "text": "I do a lot of curiosity buying I buy it if I like the album cover, I buy it if I like the name of the band, anything that sparks my imagination. I still like to go to record stores, I like to just wander around and I'll buy whatever catches my attention."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "imagination",
    "id": 37384,
    "text": "Imagination rules the world."
  },
  {
    "author": "Ida Tarbell",
    "category": "imagination",
    "id": 37918,
    "text": "Imagination is the only key to the future. Without it none exists - with it all things are possible."
  },
  {
    "author": "Tom Waits",
    "category": "imagination",
    "id": 37728,
    "text": "My reality needs imagination like a bulb needs a socket. My imagination needs reality like a blind man needs a cane."
  },
  {
    "author": "Bruno Rossi",
    "category": "imagination",
    "id": 38051,
    "text": "The initial motivation of the experiment which led to this discovery was a subconscious feeling for the inexhaustible wealth of nature, a wealth that goes far beyond the imagination of man."
  },
  {
    "author": "Irving Howe",
    "category": "imagination",
    "id": 38062,
    "text": "Imagination is not something apart and hermetic, not a way of leaving reality behind it is a way of engaging reality."
  },
  {
    "author": "Shigeru Miyamoto",
    "category": "imagination",
    "id": 37595,
    "text": "I think what's really the most ideal thing is for the player themselves, within their own imagination, to carve out what they view as being the essence of the character."
  },
  {
    "author": "Deepak Chopra",
    "category": "imagination",
    "id": 37528,
    "text": "We're living in a time when the world has suddenly discovered India because it's run out of raw material for its imagination. The raw materials for imagination are inexhaustible here."
  },
  {
    "author": "Anatole France",
    "category": "imagination",
    "id": 37402,
    "text": "To imagine is everything, to know is nothing at all."
  },
  {
    "author": "Edgar Degas",
    "category": "imagination",
    "id": 37562,
    "text": "It is all very well to copy what one sees, but it is far better to draw what one now only sees in one's memory. That is a transformation in which imagination collaborates with memory."
  },
  {
    "author": "Christina Aguilera",
    "category": "imagination",
    "id": 37584,
    "text": "I love theatrics and have a huge imagination: Why would I want to sit onstage and sing a bunch of ballads back-to-back?"
  },
  {
    "author": "Diana Krall",
    "category": "imagination",
    "id": 37973,
    "text": "But the greatest thing about music is putting it out there for people to figure out. You want the listener to find the song on their own. If you give too much away, it takes away from the imagination."
  },
  {
    "author": "Jack Vance",
    "category": "imagination",
    "id": 37851,
    "text": "Then there was Clark Ashton Smith, who wrote for Weird Tales and who had a wild imagination. He wasn't a very talented writer, but his imagination was wonderful."
  },
  {
    "author": "Clive Barker",
    "category": "imagination",
    "id": 38005,
    "text": "My imagination is my polestar I steer by that."
  },
  {
    "author": "Terry Eagleton",
    "category": "imagination",
    "id": 37749,
    "text": "Cynicism and naivety lie cheek by jowl in the American imagination if the United States is one of the most venal nations on Earth, it is also one of the most earnestly idealistic."
  },
  {
    "author": "Jennifer Lopez",
    "category": "imagination",
    "id": 37644,
    "text": "You have to come in and be that character when you walk into the room. That's what one of my first acting teachers taught me. You know, don't go in there being Jennifer and then expect to flip and change, because they're not going to have that imagination."
  },
  {
    "author": "Tim Robbins",
    "category": "imagination",
    "id": 37723,
    "text": "Toy Soldiers was my introduction to film. I certainly didn't think I was doing art by any stretch of the imagination."
  },
  {
    "author": "Chris Van Allsburg",
    "category": "imagination",
    "id": 37985,
    "text": "The Polar Express is about faith, and the power of imagination to sustain faith. It's also about the desire to reside in a world where magic can happen, the kind of world we all believed in as children, but one that disappears as we grow older."
  },
  {
    "author": "Sam Raimi",
    "category": "imagination",
    "id": 37760,
    "text": "I like something where I can really use my imagination and be an active participant in the construction of the monster and usually that's in the world of the supernatural or the world of the fantastic, so that's why those kinds of stories about demons and the supernatural appeal to me or maybe I'm really interested in that subject."
  },
  {
    "author": "Joaquin Phoenix",
    "category": "imagination",
    "id": 37688,
    "text": "Sometimes a character is really based on research that you do. Other times it's just based on your imagination or perhaps your conversation with the director. Or sometimes all of the above. It depends on the movie and character."
  },
  {
    "author": "Ron Perlman",
    "category": "imagination",
    "id": 37715,
    "text": "Every time you get on a stage or in front of a camera, the whole exercise is about imagination. You're constantly depicting something that doesn't exist, and trying to find the reality of it. Once you settle on that premise, everything else is a matter of degrees."
  },
  {
    "author": "Albert Einstein",
    "category": "imagination",
    "id": 37429,
    "text": "I am enough of an artist to draw freely upon my imagination."
  },
  {
    "author": "Edmund Wilson",
    "category": "imagination",
    "id": 38028,
    "text": "The product of the scientific imagination is a new vision of relations - like that of artistic imagination."
  },
  {
    "author": "Guy Fieri",
    "category": "imagination",
    "id": 37897,
    "text": "Cooking with kids is not just about ingredients, recipes, and cooking. It's about harnessing imagination, empowerment, and creativity."
  },
  {
    "author": "Thomas Traherne",
    "category": "imagination",
    "id": 37875,
    "text": "To think the world therefore a general Bedlam, or place of madmen, and oneself a physician, is the most necessary point of present wisdom: an important imagination, and the way to happiness."
  },
  {
    "author": "Jack Prelutsky",
    "category": "imagination",
    "id": 37904,
    "text": "Then I decided to draw from and on my own imagination, and everything came out perfect."
  },
  {
    "author": "Shia LaBeouf",
    "category": "imagination",
    "id": 37587,
    "text": "What's cool is when you're able to give your audience imagination and you don't have to cage them in like animals."
  },
  {
    "author": "Dweezil Zappa",
    "category": "imagination",
    "id": 37856,
    "text": "I didn't really hear any other music other than what my dad was working on until I was 12. My recollection of hearing other music was that I liked some things that I heard but I always thought, 'Where's the rest of it?' It didn't have the same amount of detail or instrumentation or imagination in the arrangements."
  },
  {
    "author": "Brad Henry",
    "category": "imagination",
    "id": 37456,
    "text": "A good teacher can inspire hope, ignite the imagination, and instill a love of learning."
  },
  {
    "author": "Simon Pegg",
    "category": "imagination",
    "id": 37409,
    "text": "I used to lie in bed in my flat and imagine what would happen if there was a zombie attack."
  },
  {
    "author": "Ben Okri",
    "category": "imagination",
    "id": 37729,
    "text": "The higher the artist, the fewer the gestures. The fewer the tools, the greater the imagination. The greater the will, the greater the secret failure."
  },
  {
    "author": "Barbara Januszkiewicz",
    "category": "imagination",
    "id": 37996,
    "text": "Be drawn to the visual arts for it can expand your imagination."
  },
  {
    "author": "Catherine the Great",
    "category": "imagination",
    "id": 37614,
    "text": "A great wind is blowing, and that gives you either imagination or a headache."
  },
  {
    "author": "Manuel Puig",
    "category": "imagination",
    "id": 37707,
    "text": "For someone who writes fiction, in order to activate the imagination and the unconscious, it's essential to be free."
  },
  {
    "author": "Henry Miller",
    "category": "imagination",
    "id": 37391,
    "text": "Imagination is the voice of daring. If there is anything Godlike about God it is that. He dared to imagine everything."
  },
  {
    "author": "Lionel Trilling",
    "category": "imagination",
    "id": 37865,
    "text": "There is no connection between the political ideas of our educated class and the deep places of the imagination."
  },
  {
    "author": "Richard Hofstadter",
    "category": "imagination",
    "id": 38055,
    "text": "The delicate thing about the university is that it has a mixed character, that it is suspended between its position in the eternal world, with all its corruption and evils and cruelties, and the splendid world of our imagination."
  },
  {
    "author": "Eric Bana",
    "category": "imagination",
    "id": 37687,
    "text": "I guess I'm a very keen observer, and I'd like to think I have a good imagination."
  },
  {
    "author": "Janet Jackson",
    "category": "imagination",
    "id": 37678,
    "text": "Another side to me is this very sexual being. When I look back on my life, it's always been there. It's been there since I was 10 years old, having the imagination that I had."
  },
  {
    "author": "Diana Krall",
    "category": "imagination",
    "id": 37841,
    "text": "So much of what we do as artists is a combination of personal experience and imagination, and how that all creeps into your work is not so linear."
  },
  {
    "author": "Napoleon Hill",
    "category": "imagination",
    "id": 37441,
    "text": "All the breaks you need in life wait within your imagination, Imagination is the workshop of your mind, capable of turning mind energy into accomplishment and wealth."
  },
  {
    "author": "Tommy Lee Jones",
    "category": "imagination",
    "id": 37738,
    "text": "All my life I've had the privilege to make my living with my imagination, and the most important thing has been to see my creative life grow. I was educated to do that and have lived accordingly."
  },
  {
    "author": "George William Curtis",
    "category": "imagination",
    "id": 37821,
    "text": "Imagination is as good as many voyages - and how much cheaper!"
  },
  {
    "author": "Elinor Wylie",
    "category": "imagination",
    "id": 37416,
    "text": "I am better able to imagine hell than heaven it is my inheritance, I suppose."
  },
  {
    "author": "Dougray Scott",
    "category": "imagination",
    "id": 37854,
    "text": "You'd have to have one hell of an imagination to completely make up a story, but historians are very anal about what they think should be portrayed on screen. Thankfully they don't make movies we do."
  },
  {
    "author": "Thomas Moore",
    "category": "imagination",
    "id": 37555,
    "text": "True change takes place in the imagination."
  },
  {
    "author": "Tom Robbins",
    "category": "imagination",
    "id": 37632,
    "text": "People write memoirs because they lack the imagination to make things up."
  },
  {
    "author": "Paul Farmer",
    "category": "imagination",
    "id": 37693,
    "text": "It is clear that the pharmaceutical industry is not, by any stretch of the imagination, doing enough to ensure that the poor have access to adequate medical care."
  },
  {
    "author": "Emma Caulfield",
    "category": "imagination",
    "id": 37940,
    "text": "I definitely gravitate towards quality genre projects and genre of any kind whether it's science fiction, horror or really anything. I'm just drawn to quality. I don't think 'Darkness Falls' is horror there isn't any gore by any stretch of the imagination."
  },
  {
    "author": "C. S. Lewis",
    "category": "imagination",
    "id": 37433,
    "text": "Reason is the natural order of truth but imagination is the organ of meaning."
  },
  {
    "author": "Rita Dove",
    "category": "imagination",
    "id": 37718,
    "text": "Without imagination we can go nowhere. And imagination is not restricted to the arts. Every scientist I have met who has been a success has had to imagine."
  },
  {
    "author": "Ernst Toller",
    "category": "imagination",
    "id": 37951,
    "text": "Most people have no imagination. If they could imagine the sufferings of others, they would not make them suffer so. What separated a German mother from a French mother?"
  },
  {
    "author": "Teena Marie",
    "category": "imagination",
    "id": 37807,
    "text": "I have enough love to last me a lifetime! Thank God I'll never lose my imagination and my passion. That's really what it is. I'm still passionate about what I do."
  },
  {
    "author": "Camille Paglia",
    "category": "imagination",
    "id": 37566,
    "text": "Out with stereotypes, feminism proclaims. But stereotypes are the west's stunning sexual personae, the vehicles of art's assault against nature. The moment there is imagination, there is myth."
  },
  {
    "author": "Brit Marling",
    "category": "imagination",
    "id": 37737,
    "text": "I feel like I'm a much better person when I'm developing my imagination and my innocence and my vulnerability. I like that version of me better than the version where I'm just working on my analytical mind."
  },
  {
    "author": "Marcel Proust",
    "category": "imagination",
    "id": 37507,
    "text": "Let us leave pretty women to men devoid of imagination."
  },
  {
    "author": "Janet Jackson",
    "category": "imagination",
    "id": 37679,
    "text": "I had a pretty sexual imagination for a kid."
  },
  {
    "author": "Ludwig Wittgenstein",
    "category": "imagination",
    "id": 37570,
    "text": "Uttering a word is like striking a note on the keyboard of the imagination."
  },
  {
    "author": "Bruce Catton",
    "category": "imagination",
    "id": 37867,
    "text": "Sooner or later you must move down an unknown road that leads beyond the range of the imagination, and the only certainty is that the trip has to be made."
  },
  {
    "author": "Emile Hirsch",
    "category": "imagination",
    "id": 37849,
    "text": "On 'Into The Wild' I spent months risking my life and on 'Speed Racer' I spent 60 days acting in front of a green screen. No danger to my physical self, but I sure had to use my imagination."
  },
  {
    "author": "Mark Victor Hansen",
    "category": "imagination",
    "id": 38034,
    "text": "In imagination, there's no limitation."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "imagination",
    "id": 37393,
    "text": "There are no rules of architecture for a castle in the clouds."
  },
  {
    "author": "Thomas A. Edison",
    "category": "imagination",
    "id": 37383,
    "text": "To invent, you need a good imagination and a pile of junk."
  },
  {
    "author": "J. K. Rowling",
    "category": "imagination",
    "id": 37512,
    "text": "However my parents - both of whom came from impoverished backgrounds and neither of whom had been to college, took the view that my overactive imagination was an amusing quirk that would never pay a mortgage or secure a pension."
  },
  {
    "author": "Susan Sarandon",
    "category": "imagination",
    "id": 37838,
    "text": "I think I'm an actor because I have very strong imagination and empathy. I never studied acting, but those two qualities are exactly the qualities that make for an activist."
  },
  {
    "author": "Marquis de Sade",
    "category": "imagination",
    "id": 37484,
    "text": "Happiness is ideal, it is the work of the imagination."
  },
  {
    "author": "Curtis Sittenfeld",
    "category": "imagination",
    "id": 37923,
    "text": "People who think my books are autobiographical, which they're not, credit me with having a much better memory than I do. I do, however, have a powerful imagination."
  },
  {
    "author": "Joe Rogan",
    "category": "imagination",
    "id": 37726,
    "text": "I never in my wildest imagination dreamed that I would somehow become a sports commentator."
  },
  {
    "author": "Ishmael Reed",
    "category": "imagination",
    "id": 37880,
    "text": "Writing poetry is the hard manual labor of the imagination."
  },
  {
    "author": "Edgar Allan Poe",
    "category": "imagination",
    "id": 37431,
    "text": "All religion, my friend, is simply evolved out of fraud, fear, greed, imagination, and poetry."
  },
  {
    "author": "Percy Ross",
    "category": "imagination",
    "id": 37745,
    "text": "A clever, imagination, humorous request can open closed doors and closed minds."
  },
  {
    "author": "Stephen Covey",
    "category": "imagination",
    "id": 37385,
    "text": "Live out of your imagination, not your history."
  },
  {
    "author": "Fay Godwin",
    "category": "imagination",
    "id": 37955,
    "text": "I like photographs which leave something to the imagination."
  },
  {
    "author": "Mason Cooley",
    "category": "imagination",
    "id": 37542,
    "text": "Taste refers to the past, imagination to the future."
  },
  {
    "author": "Chris Brown",
    "category": "imagination",
    "id": 37407,
    "text": "I always imagined I could be what I wanted to be."
  }
]

quotes['inspirational'] = [
  {
    "author": "Michael Jordan",
    "category": "inspirational",
    "id": 38082,
    "text": "If you accept the expectations of others, especially negative ones, then you never will change the outcome."
  },
  {
    "author": "Thomas Merton",
    "category": "inspirational",
    "id": 38089,
    "text": "Every moment and every event of every man's life on earth plants something in his soul."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "inspirational",
    "id": 38157,
    "text": "Nurture your minds with great thoughts. To believe in the heroic makes heroes."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "inspirational",
    "id": 38141,
    "text": "Every heart that has beat strongly and cheerfully has left a hopeful impulse behind it in the world, and bettered the tradition of mankind."
  },
  {
    "author": "Pope Paul VI",
    "category": "inspirational",
    "id": 38159,
    "text": "Of all human activities, man's listening to God is the supreme act of his reasoning and will."
  },
  {
    "author": "Plutarch",
    "category": "inspirational",
    "id": 38084,
    "text": "What we achieve inwardly will change outer reality."
  },
  {
    "author": "Tony Robbins",
    "category": "inspirational",
    "id": 38118,
    "text": "We can change our lives. We can do, have, and be exactly what we wish."
  },
  {
    "author": "Tony Robbins",
    "category": "inspirational",
    "id": 38129,
    "text": "Only those who have learned the power of sincere and selfless contribution experience life's deepest joy: true fulfillment."
  },
  {
    "author": "Michael Gove",
    "category": "inspirational",
    "id": 38186,
    "text": "The single most important thing in a child's performance is the quality of the teacher. Making sure a child spends the maximum amount of time with inspirational teachers is the most important thing."
  },
  {
    "author": "Buddha",
    "category": "inspirational",
    "id": 38075,
    "text": "Thousands of candles can be lighted from a single candle, and the life of the candle will not be shortened. Happiness never decreases by being shared."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "inspirational",
    "id": 38095,
    "text": "In a gentle way, you can shake the world."
  },
  {
    "author": "Phillips Brooks",
    "category": "inspirational",
    "id": 38173,
    "text": "Happiness is the natural flower of duty."
  },
  {
    "author": "Harry Emerson Fosdick",
    "category": "inspirational",
    "id": 38162,
    "text": "It is by acts and not by ideas that people live."
  },
  {
    "author": "Ben Okri",
    "category": "inspirational",
    "id": 38138,
    "text": "The most authentic thing about us is our capacity to create, to overcome, to endure, to transform, to love and to be greater than our suffering."
  },
  {
    "author": "Abraham Joshua Heschel",
    "category": "inspirational",
    "id": 38123,
    "text": "Wonder rather than doubt is the root of all knowledge."
  },
  {
    "author": "Plato",
    "category": "inspirational",
    "id": 38119,
    "text": "Thinking: the talking of the soul with itself."
  },
  {
    "author": "Ray Manzarek",
    "category": "inspirational",
    "id": 38178,
    "text": "The only thing that ultimately matters is to eat an ice-cream cone, play a slide trombone, plant a small tree, good God, now you're free."
  },
  {
    "author": "Roma Downey",
    "category": "inspirational",
    "id": 38226,
    "text": "This CD became something of a personal journey for me. The tone of the whole CD is uplifting and inspirational. It's an upper. We have enough downers in the world."
  },
  {
    "author": "Peter Diamandis",
    "category": "inspirational",
    "id": 38199,
    "text": "Space is an inspirational concept that allows you to dream big."
  },
  {
    "author": "Smokey Robinson",
    "category": "inspirational",
    "id": 38208,
    "text": "Had I not come out with an inspirational CD, you perhaps would have never known that I feel like I feel, that all songs, all the music I've ever done is a gift from God."
  },
  {
    "author": "Walt Whitman",
    "category": "inspirational",
    "id": 38166,
    "text": "We convince by our presence."
  },
  {
    "author": "Babe Ruth",
    "category": "inspirational",
    "id": 38103,
    "text": "Don't let the fear of striking out hold you back."
  },
  {
    "author": "Aristotle",
    "category": "inspirational",
    "id": 38073,
    "text": "Hope is a waking dream."
  },
  {
    "author": "Steve Berry",
    "category": "inspirational",
    "id": 38229,
    "text": "A concerted effort to preserve our heritage is a vital link to our cultural, educational, aesthetic, inspirational, and economic legacies - all of the things that quite literally make us who we are."
  },
  {
    "author": "Donald Cargill",
    "category": "inspirational",
    "id": 38143,
    "text": "And now, this is the sweetest and most glorious day that ever my eyes did see."
  },
  {
    "author": "Steve Sabol",
    "category": "inspirational",
    "id": 38202,
    "text": "Look at a football field. It looks like a big movie screen. This is theatre. Football combines the strategy of chess. It's part ballet. It's part battleground, part playground. We clarify, amplify and glorify the game with our footage, the narration and that music, and in the end create an inspirational piece of footage."
  },
  {
    "author": "Mindy Kaling",
    "category": "inspirational",
    "id": 38203,
    "text": "Almost every college playwright or sketch or improv comedian was sort of aware of Christopher Durang - even kids in high school. His short plays were so accessible to younger people and I think that was inspirational to me."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "inspirational",
    "id": 38081,
    "text": "Believe you can and you're halfway there."
  },
  {
    "author": "Tony Robbins",
    "category": "inspirational",
    "id": 38122,
    "text": "It is in your moments of decision that your destiny is shaped."
  },
  {
    "author": "Sylvester Stallone",
    "category": "inspirational",
    "id": 38169,
    "text": "I believe there's an inner power that makes winners or losers. And the winners are the ones who really listen to the truth of their hearts."
  },
  {
    "author": "Buddha",
    "category": "inspirational",
    "id": 38072,
    "text": "Health is the greatest gift, contentment the greatest wealth, faithfulness the best relationship."
  },
  {
    "author": "Boris Vallejo",
    "category": "inspirational",
    "id": 38231,
    "text": "There have been many different artists that have been inspirational. I suppose the question is directed to what was the reason why I went into fantasy illustration."
  },
  {
    "author": "Marcus Aurelius",
    "category": "inspirational",
    "id": 38127,
    "text": "Look within. Within is the fountain of good, and it will ever bubble up, if thou wilt ever dig."
  },
  {
    "author": "Candice Swanepoel",
    "category": "inspirational",
    "id": 38216,
    "text": "I'd like to one day be featured on a list of inspirational people who have made a difference in the world, whether it be helping underprivileged people or putting an end to the poaching of wildlife in Africa."
  },
  {
    "author": "Lee Ritenour",
    "category": "inspirational",
    "id": 38228,
    "text": "I've done a lot of albums and I kinda know when I'm onto something that was inspirational for me to record and create, and this was one of those projects where I really enjoyed making the album."
  },
  {
    "author": "Friedrich Schiller",
    "category": "inspirational",
    "id": 38179,
    "text": "Mankind is made great or little by its own will."
  },
  {
    "author": "Audre Lorde",
    "category": "inspirational",
    "id": 38163,
    "text": "I am deliberate and afraid of nothing."
  },
  {
    "author": "Max Weinberg",
    "category": "inspirational",
    "id": 38210,
    "text": "I will always desire to play with Bruce Springsteen. He's the most inspirational, most dedicated, most committed and most focused artist I've ever seen. I like to be around people like that."
  },
  {
    "author": "Michael Jackson",
    "category": "inspirational",
    "id": 38131,
    "text": "Let us dream of tomorrow where we can truly love from the soul, and know love as the ultimate truth at the heart of all creation."
  },
  {
    "author": "Rabindranath Tagore",
    "category": "inspirational",
    "id": 38083,
    "text": "Clouds come floating into my life, no longer to carry rain or usher storm, but to add color to my sunset sky."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "inspirational",
    "id": 38111,
    "text": "Every charitable act is a stepping stone toward heaven."
  },
  {
    "author": "Thomas Jefferson",
    "category": "inspirational",
    "id": 38087,
    "text": "The glow of one warm thought is to me worth more than money."
  },
  {
    "author": "Zane Grey",
    "category": "inspirational",
    "id": 38184,
    "text": "I arise full of eagerness and energy, knowing well what achievement lies ahead of me."
  },
  {
    "author": "Robert H. Schuller",
    "category": "inspirational",
    "id": 38126,
    "text": "What great thing would you attempt if you knew you could not fail?"
  },
  {
    "author": "Edith Wharton",
    "category": "inspirational",
    "id": 38110,
    "text": "There are two ways of spreading light: to be the candle or the mirror that reflects it."
  },
  {
    "author": "Robert Frost",
    "category": "inspirational",
    "id": 38104,
    "text": "The best way out is always through."
  },
  {
    "author": "Joyce Meyer",
    "category": "inspirational",
    "id": 38113,
    "text": "A #2 pencil and a dream can take you anywhere."
  },
  {
    "author": "Carter Burwell",
    "category": "inspirational",
    "id": 38213,
    "text": "The flow of Guiness into the studio was inspirational as well as nutritive."
  },
  {
    "author": "Bill Copeland",
    "category": "inspirational",
    "id": 38067,
    "text": "Try to be like the turtle - at ease in your own shell."
  },
  {
    "author": "Amelia Barr",
    "category": "inspirational",
    "id": 38101,
    "text": "It is always the simple that produces the marvelous."
  },
  {
    "author": "Carol Ann Duffy",
    "category": "inspirational",
    "id": 38220,
    "text": "I grew up in a bookless house - my parents didn't read poetry, so if I hadn't had the chance to experience it at school I'd never have experienced it. But I loved English, and I was very lucky in that I had inspirational English teachers, Miss Scriven and Mr. Walker, and they liked us to learn poems by heart, which I found I loved doing."
  },
  {
    "author": "Han Suyin",
    "category": "inspirational",
    "id": 38128,
    "text": "There is nothing stronger in the world than gentleness."
  },
  {
    "author": "John Muir",
    "category": "inspirational",
    "id": 38154,
    "text": "How glorious a greeting the sun gives the mountains!"
  },
  {
    "author": "Charles Morgan",
    "category": "inspirational",
    "id": 38167,
    "text": "As knowledge increases, wonder deepens."
  },
  {
    "author": "James Iha",
    "category": "inspirational",
    "id": 38223,
    "text": "I love a lot of the New York bands, but Patti Smith stands out. I just read 'Just Kids' and it's an inspirational, well-written account of an emerging New York artist in the late seventies."
  },
  {
    "author": "Arlen Specter",
    "category": "inspirational",
    "id": 38188,
    "text": "It's inspirational to see someone who is dying smile."
  },
  {
    "author": "Harry Seidler",
    "category": "inspirational",
    "id": 38218,
    "text": "Architecture is not an inspirational business, it's a rational procedure to do sensible and hopefully beautiful things that's all."
  },
  {
    "author": "Emile Zola",
    "category": "inspirational",
    "id": 38164,
    "text": "The truth is on the march and nothing will stop it."
  },
  {
    "author": "Aristotle Onassis",
    "category": "inspirational",
    "id": 38065,
    "text": "It is during our darkest moments that we must focus to see the light."
  },
  {
    "author": "Rodney Atkins",
    "category": "inspirational",
    "id": 38224,
    "text": "Every song you're trying to find something that going to connect in different ways but for me the songs that I'm really drawn to are inspirational, songs that lift you and that everybody can relate to no matter where you're from."
  },
  {
    "author": "Taisen Deshimaru",
    "category": "inspirational",
    "id": 38175,
    "text": "Think with your whole body."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "inspirational",
    "id": 38066,
    "text": "Don't judge each day by the harvest you reap but by the seeds that you plant."
  },
  {
    "author": "Leo Buscaglia",
    "category": "inspirational",
    "id": 38091,
    "text": "The fact that I can plant a seed and it becomes a flower, share a bit of knowledge and it becomes another's, smile at someone and receive a smile in return, are to me continual spiritual exercises."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "inspirational",
    "id": 38094,
    "text": "I am prepared for the worst, but hope for the best."
  },
  {
    "author": "Martin Luther",
    "category": "inspirational",
    "id": 38070,
    "text": "Even if I knew that tomorrow the world would go to pieces, I would still plant my apple tree."
  },
  {
    "author": "James Allen",
    "category": "inspirational",
    "id": 38151,
    "text": "A man has to learn that he cannot command things, but that he can command himself that he cannot coerce the wills of others, but that he can mold and master his own will: and things serve him who serves Truth people seek guidance of him who is master of himself."
  },
  {
    "author": "Joseph Barber Lightfoot",
    "category": "inspirational",
    "id": 38176,
    "text": "Plant thy foot firmly in the prints which His foot has made before thee."
  },
  {
    "author": "Joseph Campbell",
    "category": "inspirational",
    "id": 38068,
    "text": "Find a place inside where there's joy, and the joy will burn out the pain."
  },
  {
    "author": "Jim Elliot",
    "category": "inspirational",
    "id": 38079,
    "text": "God always gives His best to those who leave the choice with him."
  },
  {
    "author": "Mindy Kaling",
    "category": "inspirational",
    "id": 38195,
    "text": "I try not to put anything political on the forefront of what I'm trying to do creatively. At the same time, I do think it's wonderful when I hear people say that it's inspirational that I'm an Indian woman on camera. My life is very diverse, and my friends are a diverse group of people."
  },
  {
    "author": "Amelia Barr",
    "category": "inspirational",
    "id": 38133,
    "text": "It is only in sorrow bad weather masters us in joy we face the storm and defy it."
  },
  {
    "author": "Richard Bach",
    "category": "inspirational",
    "id": 38108,
    "text": "You are always free to change your mind and choose a different future, or a different past."
  },
  {
    "author": "Ashthon Jones",
    "category": "inspirational",
    "id": 38230,
    "text": "I love inspirational R&ampB, like Mary J. Blige and Jennifer Hudson. I want to do that. That kind of music stays with you."
  },
  {
    "author": "Jiddu Krishnamurti",
    "category": "inspirational",
    "id": 38130,
    "text": "In oneself lies the whole world and if you know how to look and learn, the door is there and the key is in your hand. Nobody on earth can give you either the key or the door to open, except yourself."
  },
  {
    "author": "Pablo Neruda",
    "category": "inspirational",
    "id": 38161,
    "text": "The books that help you most are those which make you think that most. The hardest way of learning is that of easy reading but a great book that comes from a great thinker is a ship of thought, deep freighted with truth and beauty."
  },
  {
    "author": "David Cameron",
    "category": "inspirational",
    "id": 38185,
    "text": "Half a century ago, the amazing courage of Rosa Parks, the visionary leadership of Martin Luther King, and the inspirational actions of the civil rights movement led politicians to write equality into the law and make real the promise of America for all her citizens."
  },
  {
    "author": "Cheryl James",
    "category": "inspirational",
    "id": 38189,
    "text": "The best form of flattery is to be admired, imitated or respected. I've always felt proud our fans look up to us or feel we are inspirational."
  },
  {
    "author": "George Lucas",
    "category": "inspirational",
    "id": 38192,
    "text": "'Star Wars' is fun, its exciting, its inspirational, and people respond to that. It's what they want."
  },
  {
    "author": "Pope John XXIII",
    "category": "inspirational",
    "id": 38077,
    "text": "I have looked into your eyes with my eyes. I have put my heart near your heart."
  },
  {
    "author": "John Maynard Keynes",
    "category": "inspirational",
    "id": 38181,
    "text": "Ideas shape the course of history."
  },
  {
    "author": "Henry Rollins",
    "category": "inspirational",
    "id": 38096,
    "text": "I believe that one defines oneself by reinvention. To not be like your parents. To not be like your friends. To be yourself. To cut yourself out of stone."
  },
  {
    "author": "Pierre-Joseph Proudhon",
    "category": "inspirational",
    "id": 38136,
    "text": "When deeds speak, words are nothing."
  },
  {
    "author": "R. Kelly",
    "category": "inspirational",
    "id": 38211,
    "text": "I am very conscious of who I am as an artist and as an inspirational person."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "inspirational",
    "id": 38115,
    "text": "With self-discipline most anything is possible."
  },
  {
    "author": "Junipero Serra",
    "category": "inspirational",
    "id": 38150,
    "text": "I pray God may preserve your health and life many years."
  },
  {
    "author": "Snoop Dogg",
    "category": "inspirational",
    "id": 38198,
    "text": "To me, the Seventies were very inspirational and very influential... With my whole persona as Snoop Dogg, as a person, as a rapper. I just love the Seventies style, the way all the players dressed nice, you know, kept their hair looking good, drove sharp cars and they talked real slick."
  },
  {
    "author": "Alan Watts",
    "category": "inspirational",
    "id": 38121,
    "text": "You don't look out there for God, something in the sky, you look in you."
  },
  {
    "author": "Smokey Robinson",
    "category": "inspirational",
    "id": 38205,
    "text": "So I wanted to sing inspirational music, and that's exactly how I approached it - only the words have been changed to declare my relationship with God."
  },
  {
    "author": "Fulton J. Sheen",
    "category": "inspirational",
    "id": 38106,
    "text": "Show me your hands. Do they have scars from giving? Show me your feet. Are they wounded in service? Show me your heart. Have you left a place for divine love?"
  },
  {
    "author": "Anne Frank",
    "category": "inspirational",
    "id": 38098,
    "text": "Whoever is happy will make others happy too."
  },
  {
    "author": "Jimmy Dean",
    "category": "inspirational",
    "id": 38090,
    "text": "I can't change the direction of the wind, but I can adjust my sails to always reach my destination."
  },
  {
    "author": "Benjamin Franklin",
    "category": "inspirational",
    "id": 38109,
    "text": "A place for everything, everything in its place."
  },
  {
    "author": "Ella Baker",
    "category": "inspirational",
    "id": 38140,
    "text": "Give light and people will find the way."
  },
  {
    "author": "Meister Eckhart",
    "category": "inspirational",
    "id": 38158,
    "text": "A human being has so many skins inside, covering the depths of the heart. We know so many things, but we don't know ourselves! Why, thirty or forty skins or hides, as thick and hard as an ox's or bear's, cover the soul. Go into your own ground and learn to know yourself there."
  },
  {
    "author": "Napoleon Hill",
    "category": "inspirational",
    "id": 38099,
    "text": "Cherish your visions and your dreams as they are the children of your soul, the blueprints of your ultimate achievements."
  },
  {
    "author": "William Bartram",
    "category": "inspirational",
    "id": 38120,
    "text": "On the recollection of so many and great favours and blessings, I now, with a high sense of gratitude, presume to offer up my sincere thanks to the Almighty, the Creator and Preserver."
  },
  {
    "author": "Taylor Dayne",
    "category": "inspirational",
    "id": 38227,
    "text": "My tastes and inspirational artists were always rather eclectic and diverse."
  },
  {
    "author": "Herman Cain",
    "category": "inspirational",
    "id": 38190,
    "text": "One of the things that I did before I ran for president is I was a professional speaker. Not a motivational speaker - an inspirational speaker. Motivation comes from within. You have to be inspired. That's what I do. I inspire people, I inspire the public, I inspire my staff. I inspired the organizations I took over to want to succeed."
  },
  {
    "author": "Ken Hensley",
    "category": "inspirational",
    "id": 38152,
    "text": "I know why I am here and my only real focused goal is to live each day to the fullest and to try and honor God and be an encouragement to others. What the future holds is firmly in God's hands, and I am very happy about that!"
  },
  {
    "author": "Norman Vincent Peale",
    "category": "inspirational",
    "id": 38080,
    "text": "Change your thoughts and you change your world."
  }
]

quotes['intelligence'] = [
  {
    "author": "Lucien Bouchard",
    "category": "intelligence",
    "id": 38810,
    "text": "It's the continuation of everyone's childhood to see these young children who grow up full of life, full of intelligence, full of a sense of wonder. And within an instant they're gone from this world. It's terrible."
  },
  {
    "author": "King Abdullah II",
    "category": "intelligence",
    "id": 38511,
    "text": "If you look at military and intelligence positions from the 1950s, the Israeli-Palestinian conflict has always been against American national interests."
  },
  {
    "author": "Howard Gardner",
    "category": "intelligence",
    "id": 38683,
    "text": "I need to add that my work on multiple intelligences received a huge boost in 1995 when Daniel Goleman published his book on emotional intelligence. I am often confused with Dan. Initially, though Dan and I are longtime friends, this confusion irritated me."
  },
  {
    "author": "Frank Carlucci",
    "category": "intelligence",
    "id": 38339,
    "text": "Intelligence is not a science."
  },
  {
    "author": "Bob Graham",
    "category": "intelligence",
    "id": 38649,
    "text": "This president has been reluctant to hold anybody accountable. No one was held accountable after September the 11th. Nobody's been held accountable after the clear flaws in intelligence leading up to the war in Iraq."
  },
  {
    "author": "Roger Ebert",
    "category": "intelligence",
    "id": 38282,
    "text": "Your intellect may be confused, but your emotions will never lie to you."
  },
  {
    "author": "Rose Kennedy",
    "category": "intelligence",
    "id": 38401,
    "text": "I tell myself that God gave my children many gifts - spirit, beauty, intelligence, the capacity to make friends and to inspire respect. There was only one gift he held back - length of life."
  },
  {
    "author": "Arthur H. Compton",
    "category": "intelligence",
    "id": 38834,
    "text": "It is not difficult for me to have this faith, for it is incontrovertible that where there is a plan there is intelligence - an orderly, unfolding universe testifies to the truth of the most majestic statement ever uttered - 'In the beginning, God.'"
  },
  {
    "author": "Jerry Cantrell",
    "category": "intelligence",
    "id": 38753,
    "text": "Rehearsals and this band are two words that don't really go together, kinda like Military Intelligence."
  },
  {
    "author": "Albert Einstein",
    "category": "intelligence",
    "id": 38342,
    "text": "The true sign of intelligence is not knowledge but imagination."
  },
  {
    "author": "Titus Livius",
    "category": "intelligence",
    "id": 38512,
    "text": "Many difficulties which nature throws in our way, may be smoothed away by the exercise of intelligence."
  },
  {
    "author": "Morris West",
    "category": "intelligence",
    "id": 38655,
    "text": "If God be God and man a creature made in image of the divine intelligence, his noblest function is the search for truth."
  },
  {
    "author": "Socrates",
    "category": "intelligence",
    "id": 38252,
    "text": "I know that I am intelligent, because I know that I know nothing."
  },
  {
    "author": "Pablo Picasso",
    "category": "intelligence",
    "id": 38384,
    "text": "Sculpture is the art of the intelligence."
  },
  {
    "author": "Carl Jung",
    "category": "intelligence",
    "id": 38295,
    "text": "We should not pretend to understand the world only by the intellect. The judgement of the intellect is only part of the truth."
  },
  {
    "author": "Gijs de Vries",
    "category": "intelligence",
    "id": 38618,
    "text": "In intelligence work, there are limits to the amount of information one can share. Confidentiality is essential."
  },
  {
    "author": "Scott Ritter",
    "category": "intelligence",
    "id": 38625,
    "text": "When I resigned, I put the U.S. Government on notice that I'm going to stick to policy issues, that I have no intention of going out and blowing the cover off of the intelligence operations, that those are truly sensitive and they should not be exposed."
  },
  {
    "author": "George Orwell",
    "category": "intelligence",
    "id": 38294,
    "text": "There are some ideas so wrong that only a very intelligent person could believe in them."
  },
  {
    "author": "Cofer Black",
    "category": "intelligence",
    "id": 38657,
    "text": "I was an intelligence officer, not a policy-maker."
  },
  {
    "author": "Martin McGuinness",
    "category": "intelligence",
    "id": 38725,
    "text": "The fact is that a car used by Gerry Adams and myself during the course of the Mitchell review was bugged by elements within British military intelligence."
  },
  {
    "author": "Daniel Goleman",
    "category": "intelligence",
    "id": 38479,
    "text": "My hope was that organizations would start including this range of skills in their training programs - in other words, offer an adult education in social and emotional intelligence."
  },
  {
    "author": "Annie Jump Cannon",
    "category": "intelligence",
    "id": 38829,
    "text": "Teaching man his relatively small sphere in the creation, it also encourages him by its lessons of the unity of Nature and shows him that his power of comprehension allies him with the great intelligence over-reaching all."
  },
  {
    "author": "Richard M. Helms",
    "category": "intelligence",
    "id": 38826,
    "text": "Yes we have a specific procedure which we follow in all cases where the Agency is in contact, for the purposes of acquiring intelligence or whatever the case may be, with an individual."
  },
  {
    "author": "George Tenet",
    "category": "intelligence",
    "id": 38760,
    "text": "To understand a difficult topic like Iraq takes patience and care. Unfortunately, you rarely hear a patient, careful or thoughtful discussion of intelligence these days."
  },
  {
    "author": "Damon Albarn",
    "category": "intelligence",
    "id": 38459,
    "text": "The Gorillaz cartoons seem more real to me than the actual people on TV. Because at least you know that there's some intelligence behind the cartoons, and there's a lot of work that's gone into it, so it can't all be just a lie."
  },
  {
    "author": "John Fowles",
    "category": "intelligence",
    "id": 38302,
    "text": "There are only two races on this planet - the intelligent and the stupid."
  },
  {
    "author": "Studs Terkel",
    "category": "intelligence",
    "id": 38585,
    "text": "I've always felt, in all my books, that there's a deep decency in the American people and a native intelligence - providing they have the facts, providing they have the information."
  },
  {
    "author": "Simone Weil",
    "category": "intelligence",
    "id": 38423,
    "text": "Whatever debases the intelligence degrades the entire human being."
  },
  {
    "author": "Bill Maher",
    "category": "intelligence",
    "id": 38439,
    "text": "The Clinton White House today said they would start to give national security and intelligence briefings to George Bush. I don't know how well this is working out. Today after the first one Bush said, 'I've got one question: What color is the red phone?'"
  },
  {
    "author": "Arthur Schopenhauer",
    "category": "intelligence",
    "id": 38389,
    "text": "Nature shows that with the growth of intelligence comes increased capacity for pain, and it is only with the highest degree of intelligence that suffering reaches its supreme point."
  },
  {
    "author": "Thomas A. Edison",
    "category": "intelligence",
    "id": 38345,
    "text": "Being busy does not always mean real work. The object of all work is production or accomplishment and to either of these ends there must be forethought, system, planning, intelligence, and honest purpose, as well as perspiration. Seeming to do is not doing."
  },
  {
    "author": "Dick Cheney",
    "category": "intelligence",
    "id": 38498,
    "text": "It's not just Bin Laden or just those that are involved in the counterterrorism effort. We've gotta cast the net broader than that. But I think it's a - very special tribute that we all owe to the bravery and courage of the men and women in the intelligence and military business who performed so well to finally get it done."
  },
  {
    "author": "Henry Adams",
    "category": "intelligence",
    "id": 38489,
    "text": "No man likes to have his intelligence or good faith questioned, especially if he has doubts about it himself."
  },
  {
    "author": "Robert Kiyosaki",
    "category": "intelligence",
    "id": 38316,
    "text": "You have to be smart. The easy days are over."
  },
  {
    "author": "Barbara Walters",
    "category": "intelligence",
    "id": 38602,
    "text": "A great many people think that polysyllables are a sign of intelligence."
  },
  {
    "author": "Laurence J. Peter",
    "category": "intelligence",
    "id": 38421,
    "text": "The best intelligence test is what we do with our leisure."
  },
  {
    "author": "Mark Kennedy",
    "category": "intelligence",
    "id": 38571,
    "text": "All of the biggest technological inventions created by man - the airplane, the automobile, the computer - says little about his intelligence, but speaks volumes about his laziness."
  },
  {
    "author": "Irene Peter",
    "category": "intelligence",
    "id": 38334,
    "text": "Ignorance is no excuse, it's the real thing."
  },
  {
    "author": "Clyde Tombaugh",
    "category": "intelligence",
    "id": 38526,
    "text": "I think there's a supreme power behind the whole thing, an intelligence. Look at all of the instincts of nature, both animals and plants, the very ingenious ways they survive. If you cut yourself, you don't have to think about it."
  },
  {
    "author": "George J. Mitchell",
    "category": "intelligence",
    "id": 38661,
    "text": "I had been involved in U.S. intelligence in Berlin, Germany, while in the military and had worked with a contact with the Central Intelligence Agency office there."
  },
  {
    "author": "Rush Limbaugh",
    "category": "intelligence",
    "id": 38427,
    "text": "George W. Bush attended the intelligence briefing every day. Obama has not even attended half of them. He sends surrogates. That to me is significant."
  },
  {
    "author": "Honore de Balzac",
    "category": "intelligence",
    "id": 38393,
    "text": "For passion, be it observed, brings insight with it it can give a sort of intelligence to simpletons, fools, and idiots, especially during youth."
  },
  {
    "author": "Roy H. Williams",
    "category": "intelligence",
    "id": 38250,
    "text": "A smart man makes a mistake, learns from it, and never makes that mistake again. But a wise man finds a smart man and learns from him how to avoid the mistake altogether."
  },
  {
    "author": "Plutarch",
    "category": "intelligence",
    "id": 38279,
    "text": "The mind is not a vessel to be filled but a fire to be kindled."
  },
  {
    "author": "Warren Christopher",
    "category": "intelligence",
    "id": 38587,
    "text": "I don't want to talk about intelligence matters. I will say, however, that intelligence-community estimates should not become public in the way of this city and in the way of Congress."
  },
  {
    "author": "Matt Walsh",
    "category": "intelligence",
    "id": 38815,
    "text": "Although I do use some of my psychology training in comedy, but it's more like pop psychology, not a course of treatment or anything. To me, it's more like social intelligence."
  },
  {
    "author": "Aldrich Ames",
    "category": "intelligence",
    "id": 38844,
    "text": "In my professional work with the Agency, by the late '70s, I had come to question the value of a great deal of what we were doing, in terms of the intelligence agency's impact on American policy."
  },
  {
    "author": "Tiger Woods",
    "category": "intelligence",
    "id": 38449,
    "text": "My dad used to say, 'Just because you dress up in a coat and tie, it doesn't influence your intelligence.'"
  },
  {
    "author": "Timothy Leary",
    "category": "intelligence",
    "id": 38413,
    "text": "The universe is an intelligence test."
  },
  {
    "author": "Russell Lynes",
    "category": "intelligence",
    "id": 38509,
    "text": "Cynicism is the intellectual cripple's substitute for intelligence."
  },
  {
    "author": "Bryant H. McGill",
    "category": "intelligence",
    "id": 38323,
    "text": "It is better to have a fair intellect that is well used than a powerful one that is idle."
  },
  {
    "author": "Leonard Boswell",
    "category": "intelligence",
    "id": 38697,
    "text": "The National Intelligence Director needs the authority to do the job we are asking him to do. That means power over the intelligence budget. And to be effective, to be allowed to do his or her job, they must have authority over the budget."
  },
  {
    "author": "Todd Solondz",
    "category": "intelligence",
    "id": 38532,
    "text": "The ability to take pleasure in one's life is a skill and is a kind of intelligence. So intelligence is a hard thing to evaluate and it manifests itself in so many different ways. I do think the ability to know how to live a life and not be miserable is a sign of that."
  },
  {
    "author": "Albert Einstein",
    "category": "intelligence",
    "id": 38237,
    "text": "We should take care not to make the intellect our god it has, of course, powerful muscles, but no personality."
  },
  {
    "author": "Charles Foster Bass",
    "category": "intelligence",
    "id": 38660,
    "text": "The Intelligence Committee will also examine present counterintelligence programs for the Department of Energy, the National Laboratories, and the Department of Defense."
  },
  {
    "author": "Bobby Ray Inman",
    "category": "intelligence",
    "id": 38793,
    "text": "The standard rumor at the time was that Rumsfeld, as chief of staff, had persuaded President Ford to appoint George H.W. Bush as director of Central Intelligence, assuming that that got rid of a potential competitor for the presidency."
  },
  {
    "author": "Carl Levin",
    "category": "intelligence",
    "id": 38694,
    "text": "Dr. Rice's record on Iraq gives me great concern. In her public statements she clearly overstated and exaggerated the intelligence concerning Iraq before the war in order to support the President's decision to initiate military action against Iraq."
  },
  {
    "author": "Yuri Milner",
    "category": "intelligence",
    "id": 38599,
    "text": "There is huge demand for artificial intelligence technologies."
  },
  {
    "author": "Bob Graham",
    "category": "intelligence",
    "id": 38647,
    "text": "We need to make a greater investment in human intelligence."
  },
  {
    "author": "Lewis Mumford",
    "category": "intelligence",
    "id": 38499,
    "text": "One of the functions of intelligence is to take account of the dangers that come from trusting solely to the intelligence."
  },
  {
    "author": "Auguste Rodin",
    "category": "intelligence",
    "id": 38431,
    "text": "There are unknown forces in nature when we give ourselves wholly to her, without reserve, she lends them to us she shows us these forms, which our watching eyes do not see, which our intelligence does not understand or suspect."
  },
  {
    "author": "Andrew Eldritch",
    "category": "intelligence",
    "id": 38684,
    "text": "People have taught me not to look for intelligence in rockmusic."
  },
  {
    "author": "John Sherman Cooper",
    "category": "intelligence",
    "id": 38701,
    "text": "The intelligence investigation under the leadership of Senator Church, which I know has helped cause this investigation by you, points out that the agencies did not disclose certain facts to us and that certain plots were going on."
  },
  {
    "author": "Jon Porter",
    "category": "intelligence",
    "id": 38640,
    "text": "The Patriot Act removed major legal barriers that prevented the law enforcement, intelligence, and national defense communities from talking and coordinating their work to protect the American people and our national security."
  },
  {
    "author": "Lena Horne",
    "category": "intelligence",
    "id": 38312,
    "text": "Always be smarter than the people who hire you."
  },
  {
    "author": "Paul Harris",
    "category": "intelligence",
    "id": 38471,
    "text": "In the clashes between ignorance and intelligence, ignorance is generally the aggressor."
  },
  {
    "author": "Ambrose Bierce",
    "category": "intelligence",
    "id": 38308,
    "text": "Mad, adj. Affected with a high degree of intellectual independence."
  },
  {
    "author": "Jean Baudrillard",
    "category": "intelligence",
    "id": 38501,
    "text": "The sad thing about artificial intelligence is that it lacks artifice and therefore intelligence."
  },
  {
    "author": "Wolfgang Amadeus Mozart",
    "category": "intelligence",
    "id": 38375,
    "text": "Neither a lofty degree of intelligence nor imagination nor both together go to the making of genius. Love, love, love, that is the soul of genius."
  },
  {
    "author": "Mikhail Bakunin",
    "category": "intelligence",
    "id": 38523,
    "text": "I listen to them freely and with all the respect merited by their intelligence, their character, their knowledge, reserving always my incontestable right of criticism and censure."
  },
  {
    "author": "Francis Bacon",
    "category": "intelligence",
    "id": 38311,
    "text": "God has placed no limits to the exercise of the intellect he has given us, on this side of the grave."
  },
  {
    "author": "Victor Hugo",
    "category": "intelligence",
    "id": 38379,
    "text": "Scepticism, that dry caries of the intelligence."
  },
  {
    "author": "Nichelle Nichols",
    "category": "intelligence",
    "id": 38814,
    "text": "I think anybody with any intelligence sits down and sees Star Trek not a kids' show."
  },
  {
    "author": "Alistair Cooke",
    "category": "intelligence",
    "id": 38463,
    "text": "Curiosity is free-wheeling intelligence."
  },
  {
    "author": "Stephen Cambone",
    "category": "intelligence",
    "id": 38709,
    "text": "One is to ensure that the war fighters and the intelligence analysts get the information that they need when they need it, in a format that's useful to them."
  },
  {
    "author": "John Ciardi",
    "category": "intelligence",
    "id": 38505,
    "text": "Intelligence recognizes what has happened. Genius recognizes what will happen."
  },
  {
    "author": "Miguel de Unamuno",
    "category": "intelligence",
    "id": 38464,
    "text": "That which the Fascists hate above all else, is intelligence."
  },
  {
    "author": "Saint Augustine",
    "category": "intelligence",
    "id": 38388,
    "text": "Our bodies are shaped to bear children, and our lives are a working out of the processes of creation. All our ambitions and intelligence are beside that great elemental point."
  },
  {
    "author": "Maurice Saatchi",
    "category": "intelligence",
    "id": 38717,
    "text": "Advertising must respect the intelligence of its audience and if it does not prompt them to think, it will be instantly dismissed."
  },
  {
    "author": "George H. Mead",
    "category": "intelligence",
    "id": 38734,
    "text": "The intelligence of the lower forms of animal life, like a great deal of human intelligence, does not involve a self."
  },
  {
    "author": "Cofer Black",
    "category": "intelligence",
    "id": 38784,
    "text": "We worked to develop our own operations to advance U.S. counterterrorism objectives by penetrating terrorist safe havens and collecting intelligence that would inform policy and enable our own operations."
  },
  {
    "author": "Alan Moore",
    "category": "intelligence",
    "id": 38335,
    "text": "Don't leave home without your sword - your intellect."
  },
  {
    "author": "Michael Mandelbaum",
    "category": "intelligence",
    "id": 38613,
    "text": "The war on terror, I believe, will be waged by effective intelligence and police work and cruise missiles."
  },
  {
    "author": "Henri Bergson",
    "category": "intelligence",
    "id": 38577,
    "text": "Intelligence is the faculty of making artificial objects, especially tools to make tools."
  },
  {
    "author": "Steve Wozniak",
    "category": "intelligence",
    "id": 38333,
    "text": "Wherever smart people work, doors are unlocked."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "intelligence",
    "id": 38364,
    "text": "If men can develop weapons that are so terrifying as to make the thought of global war include almost a sentence for suicide, you would think that man's intelligence and his comprehension... would include also his ability to find a peaceful solution."
  },
  {
    "author": "Quentin Crisp",
    "category": "intelligence",
    "id": 38476,
    "text": "Though intelligence is powerless to modify character, it is a dab hand at finding euphemisms for its weaknesses."
  },
  {
    "author": "Alvin Toffler",
    "category": "intelligence",
    "id": 38420,
    "text": "You can use all the quantitative data you can get, but you still have to distrust it and use your own intelligence and judgment."
  },
  {
    "author": "Washington Irving",
    "category": "intelligence",
    "id": 38428,
    "text": "After all, it is the divinity within that makes the divinity without and I have been more fascinated by a woman of talent and intelligence, though deficient in personal charms, than I have been by the most regular beauty."
  },
  {
    "author": "Richard M. Helms",
    "category": "intelligence",
    "id": 38827,
    "text": "This also turned out to be negative, so there is no material in the Central Intelligence Agency, either in the records or in the mind of any of the individuals, that there was any contact had or even contemplated with him."
  },
  {
    "author": "Peter Thiel",
    "category": "intelligence",
    "id": 38806,
    "text": "People don't want to believe that technology is broken. Pharmaceuticals, robotics, artificial intelligence, nanotechnology - all these areas where the progress has been a lot more limited than people think. And the question is why."
  },
  {
    "author": "Gijs de Vries",
    "category": "intelligence",
    "id": 38619,
    "text": "You can't get closer to the heart of national sovereignty than national security and intelligence services."
  },
  {
    "author": "Malcolm X",
    "category": "intelligence",
    "id": 38357,
    "text": "I don't even call it violence when it's in self defense I call it intelligence."
  },
  {
    "author": "Blaise Pascal",
    "category": "intelligence",
    "id": 38274,
    "text": "Small minds are concerned with the extraordinary, great minds with the ordinary."
  },
  {
    "author": "Daniel Hannan",
    "category": "intelligence",
    "id": 38672,
    "text": "The 'Robben Island Bible' has arrived at the British Museum. It's a garish thing, its cover plastered with pink and gold Hindu images, designed to hide its contents. Within is the finest collection of words generated by human intelligence: the complete works of William Shakespeare."
  },
  {
    "author": "Markus Wolf",
    "category": "intelligence",
    "id": 38776,
    "text": "Making use of human weaknesses in intelligence work is a logical matter. It keeps coming up, and of course you try to look at all the aspects that interest you in a human being."
  },
  {
    "author": "Lee H. Hamilton",
    "category": "intelligence",
    "id": 38570,
    "text": "You'll remember Dr. Rice said that several times: It was not a warning about the place and the method and the time - it was a general warning. And that points out the imperfection, if you would, of our intelligence."
  },
  {
    "author": "John Steinbeck",
    "category": "intelligence",
    "id": 38415,
    "text": "It has always been my private conviction that any man who puts his intelligence up against a fish and loses had it coming."
  },
  {
    "author": "Stephen Hawking",
    "category": "intelligence",
    "id": 38382,
    "text": "It is not clear that intelligence has any long-term survival value."
  },
  {
    "author": "William Shenstone",
    "category": "intelligence",
    "id": 38569,
    "text": "The best time to frame an answer to the letters of a friend, is the moment you receive them. Then the warmth of friendship, and the intelligence received, most forcibly cooperate."
  }
]

quotes['jealousy'] = [
  {
    "author": "James M. Barrie",
    "category": "jealousy",
    "id": 38925,
    "text": "That is ever the way. 'Tis all jealousy to the bride and good wishes to the corpse."
  },
  {
    "author": "Julie Burchill",
    "category": "jealousy",
    "id": 38935,
    "text": "I have experienced jealousy, possessiveness, verbal abuse and violence from men, but I have also experienced jealousy, possessiveness, verbal abuse and violence from women, usually when I failed to respond to their advances."
  },
  {
    "author": "Mary Schmich",
    "category": "jealousy",
    "id": 38859,
    "text": "Don't waste time on jealousy. Sometimes you're ahead, sometimes you're behind."
  },
  {
    "author": "Ludovico Ariosto",
    "category": "jealousy",
    "id": 38901,
    "text": "From heresy, frenzy and jealousy, good Lord deliver me."
  },
  {
    "author": "Lawrence Durrell",
    "category": "jealousy",
    "id": 38869,
    "text": "It is not love that is blind, but jealousy."
  },
  {
    "author": "Chris O'Dowd",
    "category": "jealousy",
    "id": 38942,
    "text": "There tends to be a jealousy in England towards countries that are successful."
  },
  {
    "author": "Jonathan Raban",
    "category": "jealousy",
    "id": 38952,
    "text": "Critics? Don't talk to me of critics! You think some jackanapes journalist, his soul eaten away by the maggots of jealousy and failure, has anything worthwhile to say of art? I don't."
  },
  {
    "author": "Rupert Everett",
    "category": "jealousy",
    "id": 38917,
    "text": "It's amazing the clarity that comes with psychotic jealousy."
  },
  {
    "author": "Erica Jong",
    "category": "jealousy",
    "id": 38870,
    "text": "Jealousy is all the fun you think they had."
  },
  {
    "author": "Ricky Williams",
    "category": "jealousy",
    "id": 38924,
    "text": "To talk about balance, it's easier to talk about what's out of balance. And I think anytime that you have any disease, and disease meaning lack of ease, lack of flow... dis-ease. So any time there's disease, you're out of balance, whether it's jealousy, anger, greed, anxiety, fear."
  },
  {
    "author": "Adriana Lima",
    "category": "jealousy",
    "id": 38941,
    "text": "I like jealous men. I love jealousy. I do."
  },
  {
    "author": "Johann Kaspar Lavater",
    "category": "jealousy",
    "id": 38878,
    "text": "The jealous are possessed by a mad devil and a dull spirit at the same time."
  },
  {
    "author": "Patrick Henry",
    "category": "jealousy",
    "id": 38860,
    "text": "Guard with jealous attention the public liberty. Suspect everyone who approaches that jewel. Unfortunately, nothing will preserve it but downright force. Whenever you give up that force, you are inevitably ruined."
  },
  {
    "author": "Michael Ian Black",
    "category": "jealousy",
    "id": 38947,
    "text": "I don't watch that much comedy. I think it's professional jealousy. That and a lack of support for my community."
  },
  {
    "author": "Conrad Veidt",
    "category": "jealousy",
    "id": 38949,
    "text": "My birth neither shook the German Empire nor caused much of an upheaval in the home. It pleased mother, caused father a certain amount of pride and my elder brother the usual fraternal jealousy of a hitherto only son."
  },
  {
    "author": "Van Wyck Brooks",
    "category": "jealousy",
    "id": 38900,
    "text": "Magnanimous people have no vanity, they have no jealousy, and they feed on the true and the solid wherever they find it. And, what is more, they find it everywhere."
  },
  {
    "author": "Saint Augustine",
    "category": "jealousy",
    "id": 38912,
    "text": "What I needed most was to love and to be loved, eager to be caught. Happily I wrapped those painful bonds around me and sure enough, I would be lashed with the red-hot pokers or jealousy, by suspicions and fear, by burst of anger and quarrels."
  },
  {
    "author": "Jeff Foxworthy",
    "category": "jealousy",
    "id": 38897,
    "text": "I have never been jealous. Not even when my dad finished fifth grade a year before I did."
  },
  {
    "author": "Ruth Rendell",
    "category": "jealousy",
    "id": 38908,
    "text": "The knives of jealousy are honed on details."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "jealousy",
    "id": 38916,
    "text": "Jealousy lives upon doubts. It becomes madness or ceases entirely as soon as we pass from doubt to certainty."
  },
  {
    "author": "Bob Marley",
    "category": "jealousy",
    "id": 38851,
    "text": "Life is one big road with lots of signs. So when you riding through the ruts, don't complicate your mind. Flee from hate, mischief and jealousy. Don't bury your thoughts, put your vision to reality. Wake Up and Live!"
  },
  {
    "author": "Mary Douglas",
    "category": "jealousy",
    "id": 38939,
    "text": "Religion can make it worse. Are you supposing that if people were encouraged to believe in a transcendent reality, and to be encouraged by grand rituals and music and preaching, to love their neighbors, then they would put jealousy and frustration aside?"
  },
  {
    "author": "Mary Baker Eddy",
    "category": "jealousy",
    "id": 38904,
    "text": "Jealousy is the grave of affection."
  },
  {
    "author": "Lena Dunham",
    "category": "jealousy",
    "id": 38933,
    "text": "I feel like a lot of the female relationships I see on TV or in movies are in some way free of the kind of jealousy and anxiety and posturing that has been such a huge part of my female friendships, which I hope lessens a little bit with age."
  },
  {
    "author": "Saint Augustine",
    "category": "jealousy",
    "id": 38868,
    "text": "He that is jealous is not in love."
  },
  {
    "author": "Anna Held",
    "category": "jealousy",
    "id": 38936,
    "text": "I do not say anything from jealousy."
  },
  {
    "author": "Paul Eldridge",
    "category": "jealousy",
    "id": 38932,
    "text": "Jealousy would be far less torturous if we understood that love is a passion entirely unrelated to our merits."
  },
  {
    "author": "Lord Byron",
    "category": "jealousy",
    "id": 38918,
    "text": "Lovers may be - and indeed generally are - enemies, but they never can be friends, because there must always be a spice of jealousy and a something of Self in all their speculations."
  },
  {
    "author": "George Eliot",
    "category": "jealousy",
    "id": 38911,
    "text": "Anger and jealousy can no more bear to lose sight of their objects than love."
  },
  {
    "author": "Kristin Bauer van Straten",
    "category": "jealousy",
    "id": 38929,
    "text": "People can do all kinds of things that maybe aren't wise in hindsight because of jealousy."
  },
  {
    "author": "Summer Altice",
    "category": "jealousy",
    "id": 38861,
    "text": "People are taken aback by a confident, pretty girl who knows what she wants in life and isn't going to let anyone get in her way. And you know what it's all about? Jealousy."
  },
  {
    "author": "Fulton J. Sheen",
    "category": "jealousy",
    "id": 38871,
    "text": "Jealousy is the tribute mediocrity pays to genius."
  },
  {
    "author": "Max Frisch",
    "category": "jealousy",
    "id": 38879,
    "text": "Jealousy is the fear of comparison."
  },
  {
    "author": "George Washington",
    "category": "jealousy",
    "id": 38856,
    "text": "It will be found an unjust and unwise jealousy to deprive a man of his natural liberty upon the supposition he may abuse it."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "jealousy",
    "id": 38862,
    "text": "Jealousy contains more of self-love than of love."
  },
  {
    "author": "Alexis Carrel",
    "category": "jealousy",
    "id": 38882,
    "text": "Like hatred, jealousy is forbidden by the laws of life because it is essentially destructive."
  },
  {
    "author": "Gene Tierney",
    "category": "jealousy",
    "id": 38865,
    "text": "Jealousy is, I think, the worst of all faults because it makes a victim of both parties."
  },
  {
    "author": "Emile M. Cioran",
    "category": "jealousy",
    "id": 38885,
    "text": "Jealousy - that jumble of secret worship and ostensible aversion."
  },
  {
    "author": "Nas",
    "category": "jealousy",
    "id": 38955,
    "text": "I don't get jealousy, I don't get how people hate each other - I never did."
  },
  {
    "author": "Richard Perle",
    "category": "jealousy",
    "id": 38940,
    "text": "The jealousy and resentment that animate the terrorists also affect many of our former cold war allies."
  },
  {
    "author": "Aphra Behn",
    "category": "jealousy",
    "id": 38907,
    "text": "Nothing is more capable of troubling our reason, and consuming our health, than secret notions of jealousy in solitude."
  },
  {
    "author": "Salvador Dali",
    "category": "jealousy",
    "id": 38915,
    "text": "The thermometer of success is merely the jealousy of the malcontents."
  },
  {
    "author": "Sidonie Gabrielle Colette",
    "category": "jealousy",
    "id": 38894,
    "text": "The lovesick, the betrayed, and the jealous all smell alike."
  },
  {
    "author": "George Orwell",
    "category": "jealousy",
    "id": 38910,
    "text": "Serious sport has nothing to do with fair play. It is bound up with hatred, jealousy, boastfulness, disregard of all rules and sadistic pleasure in witnessing violence. In other words, it is war minus the shooting."
  },
  {
    "author": "Herodotus",
    "category": "jealousy",
    "id": 38906,
    "text": "But I like not these great success of yours for I know how jealous are the gods."
  },
  {
    "author": "George Byron",
    "category": "jealousy",
    "id": 38937,
    "text": "Lovers may be and indeed generally are enemies, but they never can be friends, because there must always be a spice of jealousy and a something of Self in all their speculations."
  },
  {
    "author": "Oliver Stone",
    "category": "jealousy",
    "id": 38864,
    "text": "Never underestimate the power of jealousy and the power of envy to destroy. Never underestimate that."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "jealousy",
    "id": 38913,
    "text": "Jealousy is bred in doubts. When those doubts change into certainties, then the passion either ceases or turns absolute madness."
  },
  {
    "author": "Martina Hingis",
    "category": "jealousy",
    "id": 38950,
    "text": "That's one of the reasons I moved to Florida. Of course, the main reason is the weather and the training. But there's more jealousy in Switzerland because it's so little and they don't have so many athletes."
  },
  {
    "author": "Jude Law",
    "category": "jealousy",
    "id": 38890,
    "text": "There's no regret. You can't regret. I mean, I've felt regret but I've also refused to allow regret to sow a seed and live in me because I don't believe it. You feel it, it's like guilt, it's like jealousy, it's like all those horrible things. You've just got to snip them and get them out, because they're no good."
  },
  {
    "author": "Ambrose Bierce",
    "category": "jealousy",
    "id": 38874,
    "text": "Jealous, adj. Unduly concerned about the preservation of that which can be lost only if not worth keeping."
  },
  {
    "author": "Baltasar Gracian",
    "category": "jealousy",
    "id": 38895,
    "text": "The envious die not once, but as oft as the envied win applause."
  },
  {
    "author": "James Beattie",
    "category": "jealousy",
    "id": 38943,
    "text": "No jealousy their dawn of love overcast, nor blasted were their wedded days with strife each season looked delightful as it past, to the fond husband and the faithful wife."
  },
  {
    "author": "Henry Lawson",
    "category": "jealousy",
    "id": 38953,
    "text": "On the same line of reasoning, if Australians were to be Australians, or rather if Australians were as separate from any other nation as Australia from any other land, there would be no jealousy between them on England's account."
  },
  {
    "author": "William Wycherley",
    "category": "jealousy",
    "id": 38886,
    "text": "Hunger, revenge, to sleep are petty foes, But only death the jealous eyes can close."
  },
  {
    "author": "Sidonie Gabrielle Colette",
    "category": "jealousy",
    "id": 38927,
    "text": "Jealousy is not at all low, but it catches us humbled and bowed down, at first sight."
  },
  {
    "author": "David Seabury",
    "category": "jealousy",
    "id": 38928,
    "text": "Nature is at work. Character and destiny are her handiwork. She gives us love and hate, jealousy and reverence. All that is ours is the power to choose which impulse we shall follow."
  },
  {
    "author": "Aristotle",
    "category": "jealousy",
    "id": 38854,
    "text": "Jealousy is both reasonable and belongs to reasonable men, while envy is base and belongs to the base, for the one makes himself get good things by jealousy, while the other does not allow his neighbour to have them through envy."
  },
  {
    "author": "Aaron Carter",
    "category": "jealousy",
    "id": 38920,
    "text": "Love shouldn't be about jealousy or anything like that. It should be about commitment and being able to trust that person. If you can't have that from the get-go, there's a problem."
  },
  {
    "author": "William Shenstone",
    "category": "jealousy",
    "id": 38896,
    "text": "Jealousy is the fear or apprehension of superiority: envy our uneasiness under it."
  },
  {
    "author": "B. C. Forbes",
    "category": "jealousy",
    "id": 38867,
    "text": "Jealousy... is a mental cancer."
  },
  {
    "author": "Joseph P. Kennedy",
    "category": "jealousy",
    "id": 38887,
    "text": "More men die of jealousy than of cancer."
  },
  {
    "author": "Harriet Ann Jacobs",
    "category": "jealousy",
    "id": 38891,
    "text": "I would rather drudge out my life on a cotton plantation, till the grave opened to give me rest, than to live with an unprincipled master and a jealous mistress."
  },
  {
    "author": "Richard Le Gallienne",
    "category": "jealousy",
    "id": 38931,
    "text": "There is something mean in human nature that prefers to think evil, that gives a willing ear and a ready welcome to calumny, a sort of jealousy of goodness and greatness and things of good report."
  },
  {
    "author": "Gary Allan",
    "category": "jealousy",
    "id": 38876,
    "text": "You can be the moon and still be jealous of the stars."
  },
  {
    "author": "John Dryden",
    "category": "jealousy",
    "id": 38903,
    "text": "Jealousy is the jaundice of the soul."
  },
  {
    "author": "Havelock Ellis",
    "category": "jealousy",
    "id": 38884,
    "text": "Jealousy, that dragon which slays love under the pretence of keeping it alive."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "jealousy",
    "id": 38919,
    "text": "What makes the pain we feel from shame and jealousy so cutting is that vanity can give us no assistance in bearing them."
  },
  {
    "author": "Keira Knightley",
    "category": "jealousy",
    "id": 38914,
    "text": "I don't think that you can fake warmth. You can fake lust, jealousy, anger those are all quite easy. But actual, genuine warmth? I don't think you can fake it."
  },
  {
    "author": "Milan Kundera",
    "category": "jealousy",
    "id": 38923,
    "text": "Dogs are our link to paradise. They don't know evil or jealousy or discontent."
  },
  {
    "author": "Chrissie Hynde",
    "category": "jealousy",
    "id": 38930,
    "text": "In my experience lust only ever leads to misery. All that suspicion and jealousy and anguish it unleashes. I don't want those things in my life."
  },
  {
    "author": "Heidi Klum",
    "category": "jealousy",
    "id": 38853,
    "text": "I think it's important to get your surroundings as well as yourself into a positive state - meaning surround yourself with positive people, not the kind who are negative and jealous of everything you do."
  },
  {
    "author": "Marilyn Manson",
    "category": "jealousy",
    "id": 38880,
    "text": "I am drawn to women who are independent and creative, which is problematic because it's a struggle, a competition of careers. There's jealousy."
  },
  {
    "author": "Dorothy Corkville Briggs",
    "category": "jealousy",
    "id": 38922,
    "text": "The surest route to breeding jealousy is to compare. Since jealousy comes from feeling less than another, comparisons only fan the fires."
  },
  {
    "author": "Karl Kraus",
    "category": "jealousy",
    "id": 38875,
    "text": "Jealousy is a dog's bark which attracts thieves."
  },
  {
    "author": "J. M. Barrie",
    "category": "jealousy",
    "id": 38954,
    "text": "That is ever the way. Tis all jealousy to the bride and good wishes to the corpse."
  },
  {
    "author": "George Eliot",
    "category": "jealousy",
    "id": 38877,
    "text": "Jealousy is never satisfied with anything short of an omniscience that would detect the subtlest fold of the heart."
  },
  {
    "author": "William Graham Sumner",
    "category": "jealousy",
    "id": 38945,
    "text": "It is remarkable that jealousy of individual property in land often goes along with very exaggerated doctrines of tribal or national property in land."
  },
  {
    "author": "Clyde Tombaugh",
    "category": "jealousy",
    "id": 38873,
    "text": "That's the way I got along in life. I don't ever remember being particularly jealous of anybody, because I figured if I can't do it myself, I don't deserve to get it."
  },
  {
    "author": "Baruch Spinoza",
    "category": "jealousy",
    "id": 38888,
    "text": "Those who are believed to be most abject and humble are usually most ambitious and envious."
  },
  {
    "author": "Arthur Golden",
    "category": "jealousy",
    "id": 38902,
    "text": "Passion can quickly slip to jealousy, or even hatred."
  },
  {
    "author": "George Eliot",
    "category": "jealousy",
    "id": 38921,
    "text": "There is a sort of jealousy which needs very little fire it is hardly a passion, but a blight bred in the cloudy, damp despondency of uneasy egoism."
  },
  {
    "author": "Sylvia Kristel",
    "category": "jealousy",
    "id": 38926,
    "text": "Back then I didn't think a woman like that, or a relationship like that, could exist with complete freedom and no jealousy or possessiveness. I thought it sounded too good to be true and I was certainly convinced it wasn't the life for me!"
  },
  {
    "author": "Abbott L. Lowell",
    "category": "jealousy",
    "id": 38944,
    "text": "You will not accept credit that is due to another, or harbor jealousy of an explorer who is more fortunate."
  },
  {
    "author": "Jeff Ross",
    "category": "jealousy",
    "id": 38951,
    "text": "When I see a good singer, I get teary-eyed. Part of it is jealousy because all comedians are frustrated rock stars. That's a fact."
  },
  {
    "author": "William Penn",
    "category": "jealousy",
    "id": 38858,
    "text": "The jealous are troublesome to others, but a torment to themselves."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "jealousy",
    "id": 38852,
    "text": "A competent and self-confident person is incapable of jealousy in anything. Jealousy is invariably a symptom of neurotic insecurity."
  },
  {
    "author": "Solomon Ibn Gabirol",
    "category": "jealousy",
    "id": 38898,
    "text": "Jealousy is cruel as the grave: the coals thereof are coals of fire."
  },
  {
    "author": "Germaine Greer",
    "category": "jealousy",
    "id": 38905,
    "text": "Man is jealous because of his amour propre woman is jealous because of her lack of it."
  },
  {
    "author": "Antisthenes",
    "category": "jealousy",
    "id": 38892,
    "text": "As iron is eaten away by rust, so the envious are consumed by their own passion."
  },
  {
    "author": "Washington Irving",
    "category": "jealousy",
    "id": 38889,
    "text": "There is never jealousy where there is not strong regard."
  },
  {
    "author": "Francoise Sagan",
    "category": "jealousy",
    "id": 38863,
    "text": "To jealousy, nothing is more frightful than laughter."
  },
  {
    "author": "H. G. Wells",
    "category": "jealousy",
    "id": 38883,
    "text": "Moral indignation is jealousy with a halo."
  },
  {
    "author": "Adrian Lyne",
    "category": "jealousy",
    "id": 38948,
    "text": "Obviously, in dealing with a relationship, sexuality has to be involved, and jealousy and emotions like that. And I don't know, I've always been intrigued by those emotions."
  },
  {
    "author": "Lope de Vega",
    "category": "jealousy",
    "id": 38893,
    "text": "There is no greater glory than love, nor any great punishment than jealously."
  },
  {
    "author": "Jean Baudrillard",
    "category": "jealousy",
    "id": 38857,
    "text": "A negative judgment gives you more satisfaction than praise, provided it smacks of jealousy."
  },
  {
    "author": "George Meredith",
    "category": "jealousy",
    "id": 38946,
    "text": "Jealousy is love bed of burning snarl."
  },
  {
    "author": "Rodney Dangerfield",
    "category": "jealousy",
    "id": 38866,
    "text": "My wife's jealousy is getting ridiculous. The other day she looked at my calendar and wanted to know who May was."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "jealousy",
    "id": 38909,
    "text": "Love is that condition in which the happiness of another person is essential to your own... Jealousy is a disease, love is a healthy condition. The immature mind often mistakes one for the other, or assumes that the greater the love, the greater the jealousy."
  },
  {
    "author": "Cheryl Tiegs",
    "category": "jealousy",
    "id": 38934,
    "text": "But when I would see the surrogate, my first instinct, my first reaction would be jealousy, because she was doing what I wanted to do."
  }
]

quotes['knowledge'] = [
  {
    "author": "Robert Staughton Lynd",
    "category": "knowledge",
    "id": 39514,
    "text": "One of the greatest joys known to man is to take a flight into ignorance in search of knowledge."
  },
  {
    "author": "Walt Disney",
    "category": "knowledge",
    "id": 39128,
    "text": "We did it Disneyland, in the knowledge that most of the people I talked to thought it would be a financial disaster - closed and forgotten within the first year."
  },
  {
    "author": "Charles Babbage",
    "category": "knowledge",
    "id": 39485,
    "text": "It will be readily admitted, that a degree conferred by an university, ought to be a pledge to the public that he who holds it possesses a certain quantity of knowledge."
  },
  {
    "author": "Michael Caine",
    "category": "knowledge",
    "id": 39330,
    "text": "I feel like 35. At 35 you're old enough to know something and young enough to look forward to what you can do with the knowledge. So I stayed at 35!"
  },
  {
    "author": "Plato",
    "category": "knowledge",
    "id": 39123,
    "text": "Knowledge becomes evil if the aim be not virtuous."
  },
  {
    "author": "David Icke",
    "category": "knowledge",
    "id": 39394,
    "text": "In the Atlantean period there were many energies being used and information and knowledge being used which were, for particular reasons of safety, withdrawn, shall we say, to prevent complete catastrophe, to prevent total destruction of your planet."
  },
  {
    "author": "Laurel Clark",
    "category": "knowledge",
    "id": 39692,
    "text": "As a physician, I understand how important it is to collect data on people so we can understand what's happening with them. I will be in the position to help enable that knowledge."
  },
  {
    "author": "David Cronenberg",
    "category": "knowledge",
    "id": 39593,
    "text": "Do you remember when you found out you wouldn't live forever? People don't talk about this, but everybody had to go through it because you're not born with that knowledge."
  },
  {
    "author": "Ayumi Hamasaki",
    "category": "knowledge",
    "id": 39671,
    "text": "It's hard to decide how to match words to music. It's not like it's twice the work. It's always difficult for me to explain to the composer what I'm looking for. I'm not a professional I lack even basic knowledge about writing music."
  },
  {
    "author": "Daniel D. Palmer",
    "category": "knowledge",
    "id": 39432,
    "text": "The most wonderful study of mankind is man. Relieving human suffering and diffusing universal knowledge is humanitarian."
  },
  {
    "author": "Louis Pasteur",
    "category": "knowledge",
    "id": 39194,
    "text": "Science knows no country, because knowledge belongs to humanity, and is the torch which illuminates the world. Science is the highest personification of the nation because that nation will remain the first which carries the furthest the works of thought and intelligence."
  },
  {
    "author": "Mira Nair",
    "category": "knowledge",
    "id": 39611,
    "text": "We have to realize only in communication, in real knowledge, in real reaching out, can there be an understanding that there's humanity everywhere, and that's what I'm trying to do."
  },
  {
    "author": "Ambrose Bierce",
    "category": "knowledge",
    "id": 39164,
    "text": "The small part of ignorance that we arrange and classify we give the name of knowledge."
  },
  {
    "author": "Alan Alda",
    "category": "knowledge",
    "id": 39389,
    "text": "I find myself going to places where I really have no business, speaking to these people in a whole other field that I have no extensive knowledge of. But I do it very often because it scares me."
  },
  {
    "author": "G. I. Gurdjieff",
    "category": "knowledge",
    "id": 39033,
    "text": "Without self knowledge, without understanding the working and functions of his machine, man cannot be free, he cannot govern himself and he will always remain a slave."
  },
  {
    "author": "Cheech Marin",
    "category": "knowledge",
    "id": 39852,
    "text": "What I look for when I see a piece of art for the first time is some kind of emotional, intellectual experience, that's a combination of both of those things and is informed by my knowledge and something new that I see the artist doing."
  },
  {
    "author": "Arthur Schopenhauer",
    "category": "knowledge",
    "id": 39196,
    "text": "The fundament upon which all our knowledge and learning rests is the inexplicable."
  },
  {
    "author": "Albert Einstein",
    "category": "knowledge",
    "id": 39059,
    "text": "Imagination is more important than knowledge."
  },
  {
    "author": "Cybill Shepherd",
    "category": "knowledge",
    "id": 39869,
    "text": "It's hard for women to talk about these things, and for the doctors to really talk about it too, and to even have the knowledge of what's going on. That's why I'm doing this and urging women to speak out and talk to their doctors frankly."
  },
  {
    "author": "Stanley Fish",
    "category": "knowledge",
    "id": 39954,
    "text": "Belief and knowledge are considered to be two different things. But they are not."
  },
  {
    "author": "John Warnock",
    "category": "knowledge",
    "id": 39775,
    "text": "Without television and mass communication, that knowledge wouldn't exist. So I think it actually has the possibility of turning people into more understanding and more empathetic people."
  },
  {
    "author": "Carlos Castenada",
    "category": "knowledge",
    "id": 39453,
    "text": "A man of knowledge chooses a path with a heart and follows it and then he looks and rejoices and laughs and then he sees and knows."
  },
  {
    "author": "Yoshihiko Noda",
    "category": "knowledge",
    "id": 39781,
    "text": "I hope to attend it as Japan needs to tell the world the lessons, knowledge and reflections learned from the nuclear crisis at the Fukushima No. 1 power plant."
  },
  {
    "author": "Frederick Soddy",
    "category": "knowledge",
    "id": 39842,
    "text": "To-day it appears as though it may well be altogether abolished in the future as it has to some extent been mitigated in the past by the unceasing, and as it now appears, unlimited ascent of man to knowledge, and through knowledge to physical power and dominion over Nature."
  },
  {
    "author": "Jean-Francois Lyotard",
    "category": "knowledge",
    "id": 39863,
    "text": "What guides Marxism, then, is a different model of society, and a different conception of the function of the knowledge that can be produced by society and acquired from it."
  },
  {
    "author": "Laurent Lamothe",
    "category": "knowledge",
    "id": 39946,
    "text": "I wanted to contribute my time, myself, my knowledge, my love, because Haiti is my everything."
  },
  {
    "author": "Pierre Curie",
    "category": "knowledge",
    "id": 39932,
    "text": "Is it right to probe so deeply into Nature's secrets? The question must here be raised whether it will benefit mankind, or whether the knowledge will be harmful."
  },
  {
    "author": "Christopher Lasch",
    "category": "knowledge",
    "id": 39418,
    "text": "Knowledge is what we get when an observer, preferably a scientifically trained observer, provides us with a copy of reality that we can all recognize."
  },
  {
    "author": "Arthur Conan Doyle",
    "category": "knowledge",
    "id": 39254,
    "text": "His ignorance was as remarkable as his knowledge."
  },
  {
    "author": "Robert Quillen",
    "category": "knowledge",
    "id": 39291,
    "text": "Discussion is an exchange of knowledge an argument an exchange of ignorance."
  },
  {
    "author": "Voltaire",
    "category": "knowledge",
    "id": 39106,
    "text": "All men are born with a nose and ten fingers, but no one was born with a knowledge of God."
  },
  {
    "author": "Orison Swett Marden",
    "category": "knowledge",
    "id": 39171,
    "text": "Wisdom is knowledge which has become a part of one's being."
  },
  {
    "author": "Frederick Soddy",
    "category": "knowledge",
    "id": 39841,
    "text": "On our plane knowledge and ignorance are the immemorial adversaries."
  },
  {
    "author": "Avery Brooks",
    "category": "knowledge",
    "id": 39386,
    "text": "Knowledge is going to make you stronger. Knowledge is going to let you control your life. Knowledge is going to give you the wisdom to teach their children. Knowledge is the thing that makes you smile in the face of disaster."
  },
  {
    "author": "Simone Weil",
    "category": "knowledge",
    "id": 39025,
    "text": "Evil being the root of mystery, pain is the root of knowledge."
  },
  {
    "author": "Paul Davies",
    "category": "knowledge",
    "id": 39642,
    "text": "Is there anything science should not try to explain? Science is knowledge and knowledge is power - power to do good or evil. Sometimes ignorance is bliss."
  },
  {
    "author": "Carl Jung",
    "category": "knowledge",
    "id": 39158,
    "text": "Knowledge rests not upon truth alone, but upon error also."
  },
  {
    "author": "Zhuangzi",
    "category": "knowledge",
    "id": 39297,
    "text": "Men honor what lies within the sphere of their knowledge, but do not realize how dependent they are on what lies beyond it."
  },
  {
    "author": "Toshihiko Fukui",
    "category": "knowledge",
    "id": 39866,
    "text": "The increased global linkages promote economic growth in the world through two key mechanisms: the division of labor and the international spillovers of knowledge."
  },
  {
    "author": "Thomas a Kempis",
    "category": "knowledge",
    "id": 39495,
    "text": "But because many endeavor to get knowledge rather than to live well, they are often deceived and reap little or no benefit from their labor."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "knowledge",
    "id": 39002,
    "text": "Knowledge which is divorced from justice, may be called cunning rather than wisdom."
  },
  {
    "author": "Charles Stanley",
    "category": "knowledge",
    "id": 39279,
    "text": "Helping someone come to a saving knowledge of Christ is the greatest achievement possible."
  },
  {
    "author": "Ruben Studdard",
    "category": "knowledge",
    "id": 39669,
    "text": "All of them had so much to offer us as far as, you know, knowledge in the music industry, and especially Randy and Paula because, you know, they've been artists."
  },
  {
    "author": "Milan Kundera",
    "category": "knowledge",
    "id": 39224,
    "text": "A novel that does not uncover a hitherto unknown segment of existence is immoral. Knowledge is the novel's only morality."
  },
  {
    "author": "Voltaire",
    "category": "knowledge",
    "id": 39118,
    "text": "It is an infantile superstition of the human spirit that virginity would be thought a virtue and not the barrier that separates ignorance from knowledge."
  },
  {
    "author": "Albert Einstein",
    "category": "knowledge",
    "id": 39063,
    "text": "Whoever undertakes to set himself up as a judge of Truth and Knowledge is shipwrecked by the laughter of the gods."
  },
  {
    "author": "Marvin Minsky",
    "category": "knowledge",
    "id": 39806,
    "text": "I think Lenat is headed in the right direction, but someone needs to include a knowledge base about learning."
  },
  {
    "author": "Daniel Akaka",
    "category": "knowledge",
    "id": 39947,
    "text": "I have witnessed how education opens doors, and I know that when sound instruction takes place, students experience the joys of new-found knowledge and the ability to excel."
  },
  {
    "author": "Aldous Huxley",
    "category": "knowledge",
    "id": 39146,
    "text": "Thought must be divided against itself before it can come to any knowledge of itself."
  },
  {
    "author": "Thomas Aquinas",
    "category": "knowledge",
    "id": 39258,
    "text": "The knowledge of God is the cause of things. For the knowledge of God is to all creatures what the knowledge of the artificer is to things made by his art."
  },
  {
    "author": "Leonardo da Vinci",
    "category": "knowledge",
    "id": 38997,
    "text": "Where there is shouting, there is no true knowledge."
  },
  {
    "author": "Seymour Papert",
    "category": "knowledge",
    "id": 39685,
    "text": "The role of the teacher is to create the conditions for invention rather than provide ready-made knowledge."
  },
  {
    "author": "John Cheever",
    "category": "knowledge",
    "id": 39766,
    "text": "Wisdom we know is the knowledge of good and evil, not the strength to choose between the two."
  },
  {
    "author": "Lucy Powell",
    "category": "knowledge",
    "id": 39476,
    "text": "These are tough times and under this Tory-led government many people in Manchester are suffering and getting left behind. If elected I will use all my energy, skills, experience and knowledge to stand up for our communities and get things done for the better."
  },
  {
    "author": "George Andrew Olah",
    "category": "knowledge",
    "id": 39951,
    "text": "My father was a lawyer and to my best knowledge nobody in my family before had interest in science."
  },
  {
    "author": "Sydney Madwed",
    "category": "knowledge",
    "id": 39327,
    "text": "If you want to be truly successful invest in yourself to get the knowledge you need to find your unique factor. When you find it and focus on it and persevere your success will blossom."
  },
  {
    "author": "Peter Drucker",
    "category": "knowledge",
    "id": 39003,
    "text": "Today knowledge has power. It controls access to opportunity and advancement."
  },
  {
    "author": "Bill James",
    "category": "knowledge",
    "id": 39675,
    "text": "Crime shapes how we think about the world it shapes social decisions that we make it shapes our base of knowledge. But we don't talk about it intelligently."
  },
  {
    "author": "Ernest Holmes",
    "category": "knowledge",
    "id": 39230,
    "text": "Borrowing knowledge of reality from all sources, taking the best from every study, Science of Mind brings together the highest enlightenment of the ages."
  },
  {
    "author": "Albert Einstein",
    "category": "knowledge",
    "id": 38958,
    "text": "Information is not knowledge."
  },
  {
    "author": "Walter Lang",
    "category": "knowledge",
    "id": 39573,
    "text": "With our knowledge of modern-day genetics, we realize that it was possible for God to place the potential for all people throughout history into the genes of Adam and Eve when He created them."
  },
  {
    "author": "Tom Clancy",
    "category": "knowledge",
    "id": 39466,
    "text": "People live longer today than they ever have. They live happier lives, have more knowledge, more information. All this is the result of communications technology. How is any of that bad?"
  },
  {
    "author": "George Bernard Shaw",
    "category": "knowledge",
    "id": 39109,
    "text": "What we want is to see the child in pursuit of knowledge, and not knowledge in pursuit of the child."
  },
  {
    "author": "Theodore Bikel",
    "category": "knowledge",
    "id": 39470,
    "text": "Epistemology is the study of knowledge. By what conduit do we know what we know?"
  },
  {
    "author": "James M. Baldwin",
    "category": "knowledge",
    "id": 39911,
    "text": "Like all science, psychology is knowledge and like science again, it is knowledge of a definite thing, the mind."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "knowledge",
    "id": 39064,
    "text": "Science investigates religion interprets. Science gives man knowledge which is power religion gives man wisdom which is control."
  },
  {
    "author": "Bertrand Russell",
    "category": "knowledge",
    "id": 39160,
    "text": "The degree of one's emotions varies inversely with one's knowledge of the facts."
  },
  {
    "author": "Thomas Bulfinch",
    "category": "knowledge",
    "id": 39572,
    "text": "Without a knowledge of mythology much of the elegant literature of our own language cannot be understood and appreciated."
  },
  {
    "author": "Lawrence Hargrave",
    "category": "knowledge",
    "id": 39889,
    "text": "To remove this obstacle I repeat or refer to such knowledge as has come under my notice, my own previously expressed views, and also describe and exhibit my last experiments and explain their novelty and utility."
  },
  {
    "author": "Samuel Butler",
    "category": "knowledge",
    "id": 39186,
    "text": "A little knowledge is a dangerous thing, but a little want of knowledge is also a dangerous thing."
  },
  {
    "author": "Blaise Pascal",
    "category": "knowledge",
    "id": 39175,
    "text": "Vanity of science. Knowledge of physical science will not console me for ignorance of morality in time of affliction, but knowledge of morality will always console me for ignorance of physical science."
  },
  {
    "author": "Natalia Makarova",
    "category": "knowledge",
    "id": 39906,
    "text": "I don't keep my secrets or my knowledge to myself."
  },
  {
    "author": "Daniel J. Boorstin",
    "category": "knowledge",
    "id": 39399,
    "text": "Knowledge is not simply another commodity. On the contrary. Knowledge is never used up. It increases by diffusion and grows by dispersion."
  },
  {
    "author": "Khalil Gibran",
    "category": "knowledge",
    "id": 38968,
    "text": "Pain and foolishness lead to great bliss and complete knowledge, for Eternal Wisdom created nothing under the sun in vain."
  },
  {
    "author": "Vijay Singh",
    "category": "knowledge",
    "id": 39944,
    "text": "Golf is about knowledge, and studying another player - more than listening to a teacher - is the best way to get it."
  },
  {
    "author": "Shirley MacLaine",
    "category": "knowledge",
    "id": 39362,
    "text": "When a child comes in, I believe that it's a 'multipersonhood,' and it knows it, its consciousness knows it, and it has a nuclei in the center of its consciousness that is the repository of all experience and all knowledge. And when you look in the eyes of your baby and you feel this sense that they are an old soul, I believe indeed they are."
  },
  {
    "author": "Plato",
    "category": "knowledge",
    "id": 38984,
    "text": "Knowledge which is acquired under compulsion obtains no hold on the mind."
  },
  {
    "author": "Betty Hill",
    "category": "knowledge",
    "id": 39693,
    "text": "And I'm walking along and we're laughing, kidding, joking, and see he understood the leader, the one we called the leader, had some knowledge of English, although limited."
  },
  {
    "author": "Emma Thompson",
    "category": "knowledge",
    "id": 39358,
    "text": "It is remarkable how many misconceptions there are here about life in the developing world and I think that that knowledge gap has done a lot to contribute to the imbalance quite frankly."
  },
  {
    "author": "Albert J. Nock",
    "category": "knowledge",
    "id": 39756,
    "text": "Perhaps the prevalence of pedantry may be largely accounted for by the common error of thinking that, because useful knowledge should be remembered, any kind of knowledge that is at all worth learning should be remembered too."
  },
  {
    "author": "Immanuel Kant",
    "category": "knowledge",
    "id": 39198,
    "text": "It is beyond a doubt that all our knowledge that begins with experience."
  },
  {
    "author": "Mary Astell",
    "category": "knowledge",
    "id": 39555,
    "text": "We all agree that its fit to be as Happy as we can, and we need no Instructor to teach us this Knowledge, 'tis born with us, and is inseparable from our Being, but we very much need to be Inform'd what is the true Way to Happiness."
  },
  {
    "author": "Joseph Wood Krutch",
    "category": "knowledge",
    "id": 39182,
    "text": "It is not ignorance but knowledge which is the mother of wonder."
  },
  {
    "author": "Trofim Lysenko",
    "category": "knowledge",
    "id": 39815,
    "text": "Agricultural practice served Darwin as the material basis for the elaboration of his theory of Evolution, which explained the natural causation of the adaptation we see in the structure of the organic world. That was a great advance in the knowledge of living nature."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "knowledge",
    "id": 38973,
    "text": "It is not when truth is dirty, but when it is shallow, that the lover of knowledge is reluctant to step into its waters."
  },
  {
    "author": "Joseph Story",
    "category": "knowledge",
    "id": 39738,
    "text": "A good government implies two things first, fidelity to the objects of the government secondly, a knowledge of the means, by which those objects can be best attained."
  },
  {
    "author": "W. Edwards Deming",
    "category": "knowledge",
    "id": 39541,
    "text": "You should not ask questions without knowledge."
  },
  {
    "author": "William Ellery Channing",
    "category": "knowledge",
    "id": 39416,
    "text": "It is not the quantity but the quality of knowledge which determines the mind's dignity."
  },
  {
    "author": "Roger Babson",
    "category": "knowledge",
    "id": 39006,
    "text": "Property may be destroyed and money may lose its purchasing power but, character, health, knowledge and good judgement will always be in demand under all conditions."
  },
  {
    "author": "Jean-Francois Lyotard",
    "category": "knowledge",
    "id": 39677,
    "text": "If we wish to discuss knowledge in the most highly developed contemporary society, we must answer the preliminary question of what methodological representation to apply to that society."
  },
  {
    "author": "Bede Griffiths",
    "category": "knowledge",
    "id": 39137,
    "text": "God had brought me to my knees and made me acknowledge my own nothingness, and out of that knowledge I had been reborn. I was no longer the centre of my life and therefore I could see God in everything."
  },
  {
    "author": "Georg C. Lichtenberg",
    "category": "knowledge",
    "id": 39367,
    "text": "The Greeks possessed a knowledge of human nature we seem hardly able to attain to without passing through the strengthening hibernation of a new barbarism."
  },
  {
    "author": "Walter Mosley",
    "category": "knowledge",
    "id": 39211,
    "text": "When you deal with a person who's experiencing dementia, you can see where they're struggling with knowledge. You can see what they forget completely, what they forget but they know what they once knew. You can tell how they're trying to remember."
  },
  {
    "author": "Robert Mugabe",
    "category": "knowledge",
    "id": 39336,
    "text": "True, some land was bought by a few Cabinet Ministers. They bought the land. No minister, to my knowledge acquired land which was meant for resettlement."
  },
  {
    "author": "Anton Chekhov",
    "category": "knowledge",
    "id": 39140,
    "text": "Knowledge is of no value unless you put it into practice."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "knowledge",
    "id": 38989,
    "text": "We know accurately only when we know little, with knowledge doubt increases."
  },
  {
    "author": "Michel de Montaigne",
    "category": "knowledge",
    "id": 39213,
    "text": "We can be knowledgable with other men's knowledge but we cannot be wise with other men's wisdom."
  },
  {
    "author": "John Jewel",
    "category": "knowledge",
    "id": 39915,
    "text": "The word of God is full of sad and grave counsel, full of the knowledge of God, of examples of virtues, and of correction of vices, of the end of this life, and of the life to come."
  },
  {
    "author": "Marilyn vos Savant",
    "category": "knowledge",
    "id": 39041,
    "text": "To acquire knowledge, one must study but to acquire wisdom, one must observe."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "knowledge",
    "id": 39181,
    "text": "The more extensive a man's knowledge of what has been done, the greater will be his power of knowing what to do."
  }
]

quotes['leadership'] = [
  {
    "author": "Rahm Emanuel",
    "category": "leadership",
    "id": 40199,
    "text": "Because of the president's leadership, every American will have access to affordable, quality health care."
  },
  {
    "author": "Max Lucado",
    "category": "leadership",
    "id": 39969,
    "text": "A man who wants to lead the orchestra must turn his back on the crowd."
  },
  {
    "author": "Marco Rubio",
    "category": "leadership",
    "id": 40105,
    "text": "We live in a society obsessed with public opinion. But leadership has never been about popularity."
  },
  {
    "author": "Steve Wynn",
    "category": "leadership",
    "id": 40401,
    "text": "You watch television and see what's going on on this debt ceiling issue. And what I consider to be a total lack of leadership from the President and nothing's going to get fixed until the President himself steps up and wrangles both parties in Congress."
  },
  {
    "author": "Max de Pree",
    "category": "leadership",
    "id": 40151,
    "text": "The signs of outstanding leadership appear primarily among the followers. Are the followers reaching their potential? Are they learning? Serving? Do they achieve the required results? Do they change with grace? Manage conflict?"
  },
  {
    "author": "Lao Tzu",
    "category": "leadership",
    "id": 39958,
    "text": "A leader is best when people barely know he exists, when his work is done, his aim fulfilled, they will say: we did it ourselves."
  },
  {
    "author": "William James",
    "category": "leadership",
    "id": 39986,
    "text": "If you want a quality, act as if you already had it."
  },
  {
    "author": "J. P. Morgan",
    "category": "leadership",
    "id": 40009,
    "text": "Go as far as you can see when you get there, you'll be able to see farther."
  },
  {
    "author": "Jim Rohn",
    "category": "leadership",
    "id": 39973,
    "text": "Affirmation without discipline is the beginning of delusion."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "leadership",
    "id": 40189,
    "text": "Leadership that exploits and sacrifices young people on the altar of its goals is nothing more than raw, demonic power. Genuine leadership is found in ceaseless efforts to foster young people, to pave the way forward for them."
  },
  {
    "author": "Tom Peters",
    "category": "leadership",
    "id": 40002,
    "text": "If a window of opportunity appears, don't pull down the shade."
  },
  {
    "author": "Debbie Wasserman Schultz",
    "category": "leadership",
    "id": 40231,
    "text": "We've been sitting at the compromise table for a long time. We're just waiting for that cold chair to be warmed up by the Republican leadership. They still have time to do the right thing and be responsible. They just seem to be moving further and further away from it."
  },
  {
    "author": "Lindsey Graham",
    "category": "leadership",
    "id": 40236,
    "text": "President Bush has shown great leadership. He has said that the 21st century will not be ruled or dictated by terrorists, dictators, and murderers. He is absolutely right. God bless him for his resolve."
  },
  {
    "author": "John Olver",
    "category": "leadership",
    "id": 40363,
    "text": "The conduct of President Bush's war of choice has been plagued with incompetent civilian leadership decisions that have cost many lives and rendered the war on and occupation of Iraq a strategic policy disaster for the United States."
  },
  {
    "author": "Anne M. Mulcahy",
    "category": "leadership",
    "id": 40283,
    "text": "Not everybody is created equal, and it's important for companies to identify those high potentials and treat them differently, accelerate their development and pay them more. That process is so incredibly important to developing first-class leadership in a company."
  },
  {
    "author": "Chester Irving Barnard",
    "category": "leadership",
    "id": 40513,
    "text": "Organizations endure, however, in proportion to the breadth of the morality by which they are governed. Thus the endurance of organization depends upon the quality of leadership and that quality derives from the breadth of the morality upon which it rests."
  },
  {
    "author": "Donald Evans",
    "category": "leadership",
    "id": 40373,
    "text": "At the very outset I want to say how the people of America appreciate the steadfast support of the people of Morocco, the leadership of Morocco in our war against terrorism."
  },
  {
    "author": "Octavia Butler",
    "category": "leadership",
    "id": 40214,
    "text": "I recognize we will pay more attention when we have different leadership."
  },
  {
    "author": "Neil Sheehan",
    "category": "leadership",
    "id": 40427,
    "text": "We had a military and political leadership at that period which was genuinely deluded."
  },
  {
    "author": "Vance Packard",
    "category": "leadership",
    "id": 40498,
    "text": "Leadership appears to be the art of getting others to want to do something you are convinced should be done."
  },
  {
    "author": "Park Geun-hye",
    "category": "leadership",
    "id": 40352,
    "text": "Different times need different types of leadership."
  },
  {
    "author": "Charles Williams",
    "category": "leadership",
    "id": 40433,
    "text": "The Divine Thing that made itself the foundation of the Church does not seem, to judge by his comments on the religious leadership of his day, to have hoped much from officers of a church."
  },
  {
    "author": "Dianne Feinstein",
    "category": "leadership",
    "id": 40193,
    "text": "Ninety percent of leadership is the ability to communicate something people want."
  },
  {
    "author": "Dianna Agron",
    "category": "leadership",
    "id": 40350,
    "text": "I definitely wasn't cool in high school. I really wasn't. I did belong to many of the clubs and was in leadership on yearbook and did the musical theater route, so I had friends in all areas. But I certainly did not know what to wear, did not know how to do my hair, all those things."
  },
  {
    "author": "Henry Bonilla",
    "category": "leadership",
    "id": 40426,
    "text": "President Bush offers the American people an optimistic vision and a clear choice in November. The President has provided steady leadership in remarkably changing times. He knows exactly where he wants to lead this country, and he has complete confidence in the American people."
  },
  {
    "author": "Bill Owens",
    "category": "leadership",
    "id": 40359,
    "text": "Leadership is an active role 'lead' is a verb. But the leader who tries to do it all is headed for burnout, and in a powerful hurry."
  },
  {
    "author": "David Cameron",
    "category": "leadership",
    "id": 40146,
    "text": "Yes, America must do the right thing, but to provide moral leadership, America must do it in the right way, too."
  },
  {
    "author": "Abdul Kalam",
    "category": "leadership",
    "id": 40071,
    "text": "Educationists should build the capacities of the spirit of inquiry, creativity, entrepreneurial and moral leadership among students and become their role model."
  },
  {
    "author": "John H. Johnson",
    "category": "leadership",
    "id": 40056,
    "text": "To succeed, one must be creative and persistent."
  },
  {
    "author": "Sherrod Brown",
    "category": "leadership",
    "id": 40369,
    "text": "Republican leadership in Congress let the energy companies write the energy bill that sent prices soaring, and has turned a blind eye to the struggles of working families trying to make ends meet."
  },
  {
    "author": "Herman Cain",
    "category": "leadership",
    "id": 40144,
    "text": "The one thing that the President can do is to establish a real energy independence plan. We have all the recources we need right here in this country to establish energy independence if we had the leadership."
  },
  {
    "author": "Karen Kain",
    "category": "leadership",
    "id": 40354,
    "text": "It's a different era. Our job now is to show leadership and vision and to help the next generation of artists."
  },
  {
    "author": "Michael Pollan",
    "category": "leadership",
    "id": 40259,
    "text": "The things journalists should pay attention to are the issues the political leadership agrees on, rather than to their supposed antagonisms."
  },
  {
    "author": "James Cash Penney",
    "category": "leadership",
    "id": 40121,
    "text": "Honor bespeaks worth. Confidence begets trust. Service brings satisfaction. Cooperation proves the quality of leadership."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "leadership",
    "id": 40190,
    "text": "Where there is an absence of international political leadership, civil society should step in to fill the gap, providing the energy and vision needed to move the world in a new and better direction."
  },
  {
    "author": "Alexis Herman",
    "category": "leadership",
    "id": 40436,
    "text": "The public sector certainly includes the Department of Labor. Those are jobs that are available. They are open and they are good paying jobs. The government as a whole has been actually retrenching under President Clinton's leadership."
  },
  {
    "author": "Chuck Hagel",
    "category": "leadership",
    "id": 40326,
    "text": "Alliances and international organizations should be understood as opportunities for leadership and a means to expand our influence, not as constraints on our power."
  },
  {
    "author": "Paul Ryan",
    "category": "leadership",
    "id": 40124,
    "text": "So here's the question: Without a change in leadership, why would the next four years be any different from the last four years?"
  },
  {
    "author": "Casey Stengel",
    "category": "leadership",
    "id": 40028,
    "text": "The key to being a good manager is keeping the people who hate me away from those who are still undecided."
  },
  {
    "author": "Peter King",
    "category": "leadership",
    "id": 40300,
    "text": "But 85 percent of the mosques have extremist leadership in this country. Most Muslims, the overwhelming majority of Muslims, are loyal Americans."
  },
  {
    "author": "Ron Kind",
    "category": "leadership",
    "id": 40281,
    "text": "We should see the leadership from the White House setting dates certain for certain goals of achieving greater alliance on alternative and renewable energy sources, but we are not."
  },
  {
    "author": "H. Rap Brown",
    "category": "leadership",
    "id": 40273,
    "text": "An old African leader says about leadership, he says that leadership should never be shared it should always remain in the hands of the dispossessed people. We will lead the revolution."
  },
  {
    "author": "Dennis Cardoza",
    "category": "leadership",
    "id": 40430,
    "text": "The truth is the Republican leadership has created a credit card Congress that is recklessly selling out the future of America, our children and our grandchildren, and President Bush is the most fiscally irresponsible President in the history of America."
  },
  {
    "author": "Harriet Harman",
    "category": "leadership",
    "id": 40466,
    "text": "Actually, I don't ever think there will be a men-only team of leadership in the Labour party again. People would look at it and say, 'What? Are there no women in the party to be part of the leadership? Do men want to do it all themselves?' It just won't happen again."
  },
  {
    "author": "Rick Larsen",
    "category": "leadership",
    "id": 40378,
    "text": "We need safe communities that are free from methamphetamine and a federal commitment to stand next to state leadership and law enforcement in the fight against this epidemic."
  },
  {
    "author": "Tom Ridge",
    "category": "leadership",
    "id": 40485,
    "text": "You have to enable and empower people to make decisions independent of you. As I've learned, each person on a team is an extension of your leadership if they feel empowered by you they will magnify your power to lead."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "leadership",
    "id": 40101,
    "text": "I speak directly to the people, and I know that the people of California want to have better leadership. They want to have great leadership. They want to have somebody that will represent them. And it doesn't matter if you're a Democrat or a Republican, young or old."
  },
  {
    "author": "Mitt Romney",
    "category": "leadership",
    "id": 40081,
    "text": "My leadership will end the Obama era and begin a new era of American prosperity."
  },
  {
    "author": "Donald Rumsfeld",
    "category": "leadership",
    "id": 40122,
    "text": "Presidential leadership needn't always cost money. Look for low- and no-cost options. They can be surprisingly effective."
  },
  {
    "author": "Kamala Harris",
    "category": "leadership",
    "id": 40268,
    "text": "Doing nothing while the middle class is hurting. That's not leadership. Loose regulations and lax enforcement. That's not leadership. That's abandoning our middle class."
  },
  {
    "author": "Zbigniew Brzezinski",
    "category": "leadership",
    "id": 40181,
    "text": "I think it is important to ask ourselves as citizens, not as Democrats attacking the administration, but as citizens, whether a world power can really provide global leadership on the basis of fear and anxiety?"
  },
  {
    "author": "Henry A. Kissinger",
    "category": "leadership",
    "id": 40010,
    "text": "A leader does not deserve the name unless he is willing occasionally to stand alone."
  },
  {
    "author": "Barack Obama",
    "category": "leadership",
    "id": 40068,
    "text": "We can't drive our SUVs and eat as much as we want and keep our homes on 72 degrees at all times... and then just expect that other countries are going to say OK. That's not leadership. That's not going to happen."
  },
  {
    "author": "Bill Kristol",
    "category": "leadership",
    "id": 40399,
    "text": "In any case, decisions on troop levels in the American system of government are not made by any general or set of generals but by the civilian leadership of the war effort."
  },
  {
    "author": "Debbie Wasserman Schultz",
    "category": "leadership",
    "id": 40228,
    "text": "Democrats are going to proudly run on the fact that we turned the economy around. It was our policies under President Obama's leadership through the Recovery Act, through investing in the automobile industry."
  },
  {
    "author": "Paul Ryan",
    "category": "leadership",
    "id": 40128,
    "text": "We need leadership. We don't need a doubling down on the failed politics of the past."
  },
  {
    "author": "George Will",
    "category": "leadership",
    "id": 40174,
    "text": "Leadership is, among other things, the ability to inflict pain and get away with it - short-term pain for long-term gain."
  },
  {
    "author": "Young Jeezy",
    "category": "leadership",
    "id": 40394,
    "text": "Music is all about leadership and there ain't really a lot of leaders."
  },
  {
    "author": "John Patrick",
    "category": "leadership",
    "id": 40481,
    "text": "IBM has taken a leadership role in this area and is prepared to be a technology partner with companies around the world to take advantage of these new developments."
  },
  {
    "author": "Eric Hoffer",
    "category": "leadership",
    "id": 40118,
    "text": "Charlatanism of some degree is indispensable to effective leadership."
  },
  {
    "author": "Howard Dean",
    "category": "leadership",
    "id": 40226,
    "text": "There are no ideas in the Republican Party right now in the Congress. They're the party of no. They desperately need some intellectual leadership. And whatever you think of Newt Gingrich, he can supply intellectual leadership. So I hope he does run."
  },
  {
    "author": "Indra Nooyi",
    "category": "leadership",
    "id": 40418,
    "text": "The one thing I have learned as a CEO is that leadership at various levels is vastly different. When I was leading a function or a business, there were certain demands and requirements to be a leader. As you move up the organization, the requirements for leading that organization don't grow vertically they grow exponentially."
  },
  {
    "author": "Ingvar Kamprad",
    "category": "leadership",
    "id": 40209,
    "text": "If there is such a thing as good leadership, it is to give a good example. I have to do so for all the Ikea employees."
  },
  {
    "author": "Susan Faludi",
    "category": "leadership",
    "id": 40448,
    "text": "What happened with Hurricane Katrina was the American electorate was forced to look at what lay behind the veneer of chest-beating. We all saw the consequences of having terrible government leadership."
  },
  {
    "author": "James Humes",
    "category": "leadership",
    "id": 40254,
    "text": "One secret of leadership is that the mind of a leader never turns off. Leaders even when they are sightseers or spectators, are active not passive observers."
  },
  {
    "author": "James Stockdale",
    "category": "leadership",
    "id": 40374,
    "text": "He's a novice, but he's had these - he's experienced in leadership in tight circumstances. He started - he dropped the first bomb, led the first air strike into North Vietnam."
  },
  {
    "author": "Bob Riley",
    "category": "leadership",
    "id": 40265,
    "text": "Half a world away nations that once lived under oppression and tyranny are now budding democracies due in large part to America 's leadership and the sacrifices of our military."
  },
  {
    "author": "Aristotle Onassis",
    "category": "leadership",
    "id": 39993,
    "text": "To succeed in business it is necessary to make others see things as you see them."
  },
  {
    "author": "E. P. Thompson",
    "category": "leadership",
    "id": 40447,
    "text": "I don't care tuppence whether I'm forced into a leadership position or not. I'd much sooner not."
  },
  {
    "author": "Conrad Burns",
    "category": "leadership",
    "id": 40372,
    "text": "Vocational education programs have made a real difference in the lives of countless young people nationwide they build self-confidence and leadership skills by allowing students to utilize their unique gifts and talents."
  },
  {
    "author": "James Dobson",
    "category": "leadership",
    "id": 40161,
    "text": "My observation is that women are merely waiting for their husbands to assume leadership."
  },
  {
    "author": "Ron Fournier",
    "category": "leadership",
    "id": 40154,
    "text": "With gridlock the norm, Congress's approval rating is below 10 percent and the public has lost faith in its national leadership."
  },
  {
    "author": "Zhang Ziyi",
    "category": "leadership",
    "id": 40366,
    "text": "The atmosphere at my school was very competitive. Young girls were competing with each other every day for status, for leadership, for the affection of the teachers. I hated it."
  },
  {
    "author": "Denise Morrison",
    "category": "leadership",
    "id": 40462,
    "text": "I think leadership is service and there is power in that giving: to help people, to inspire and motivate them to reach their fullest potential."
  },
  {
    "author": "James MacGregor Burns",
    "category": "leadership",
    "id": 40490,
    "text": "Woodrow Wilson called for leaders who, by boldly interpreting the nation's conscience, could lift a people out of their everyday selves. That people can be lifted into their better selves is the secret of transforming leadership."
  },
  {
    "author": "Rahm Emanuel",
    "category": "leadership",
    "id": 40200,
    "text": "Whose leadership, whose judgment, whose values do you want in the White House when that crisis lands like a thud on the Oval Office desk?"
  },
  {
    "author": "Andy Hertzfeld",
    "category": "leadership",
    "id": 40383,
    "text": "But I think Steve's main contribution besides just the pure leadership is his passion for excellence. He's a perfectionist. Good enough isn't good enough. And also his creative spirit. You know he really, really wants to do something great."
  },
  {
    "author": "David Miliband",
    "category": "leadership",
    "id": 40221,
    "text": "The biggest novelty of 2013 will be new leadership in China. Very little is known about the views of the new leaders - who will rule the country for ten years. But we do know they're the first generation of Chinese leaders who have spent the majority of their lives in a China 'opening up' to the rest of the world."
  },
  {
    "author": "James Humes",
    "category": "leadership",
    "id": 40232,
    "text": "The art of communication is the language of leadership."
  },
  {
    "author": "Vaclav Havel",
    "category": "leadership",
    "id": 40031,
    "text": "The exercise of power is determined by thousands of interactions between the world of the powerful and that of the powerless, all the more so because these worlds are never divided by a sharp line: everyone has a small part of himself in both."
  },
  {
    "author": "Zach Wamp",
    "category": "leadership",
    "id": 40355,
    "text": "Hamas, also elected to governmental leadership in Palestine, includes the jihadists, people who have declared war on the United States of America and its ally, Israel."
  },
  {
    "author": "Thomas E. Mann",
    "category": "leadership",
    "id": 40286,
    "text": "All of this suggests that while citizens became more comfortable with President Bush after September 11 and thought him to have the requisite leadership skills, they continue to harbor doubts about his priorities, loyalties, interests, and policies."
  },
  {
    "author": "Madeleine Albright",
    "category": "leadership",
    "id": 40138,
    "text": "But I do not believe that the world would be entirely different if there were more women leaders. Maybe if everybody in leadership was a woman, you might not get into the conflicts in the first place. But if you watch the women who have made it to the top, they haven't exactly been non-aggressive - including me."
  },
  {
    "author": "Ray Kroc",
    "category": "leadership",
    "id": 40047,
    "text": "You're only as good as the people you hire."
  },
  {
    "author": "Mitt Romney",
    "category": "leadership",
    "id": 40082,
    "text": "Central to America's rise to global leadership is our Judeo-Christian tradition with the vision of the goodness and possibilities of every human life."
  },
  {
    "author": "Peter Drucker",
    "category": "leadership",
    "id": 39967,
    "text": "Management is doing things right leadership is doing the right things."
  },
  {
    "author": "Sultan bin Abdul-Aziz Al Saud",
    "category": "leadership",
    "id": 40494,
    "text": "With King Abdullah's leadership and his people's trust he can keep the kingdom stable and secure in all its affairs."
  },
  {
    "author": "Preet Bharara",
    "category": "leadership",
    "id": 40423,
    "text": "History has shown that one cannot legislate a culture of integrity. And yet, one of the paramount responsibilities and challenges of corporate leadership is to ensure such a culture."
  },
  {
    "author": "James Freeman Clarke",
    "category": "leadership",
    "id": 40055,
    "text": "Strong convictions precede great actions."
  },
  {
    "author": "C. L. R. James",
    "category": "leadership",
    "id": 40316,
    "text": "One of the surest signs of the estimated changes in the consciousness of the American proletariat is to be found in the character of the demands now being put forward by the leadership."
  },
  {
    "author": "Earl Monroe",
    "category": "leadership",
    "id": 40455,
    "text": "Jamal Crawford reminds me the most of myself, the way he goes to the basket. But they need leadership."
  },
  {
    "author": "John Dingell",
    "category": "leadership",
    "id": 40365,
    "text": "This is one of the major problems we have. By the way, it was endorsed by leadership on both sides of the aisle and both ends of the Capitol, by the NRA and also by the gun control groups."
  },
  {
    "author": "Marco Rubio",
    "category": "leadership",
    "id": 40094,
    "text": "Leadership can not be measured in a poll or even in the result of an election. It can only be truly seen with the benefit of time. From the perspective of 20 years, not 20 days."
  },
  {
    "author": "Studs Terkel",
    "category": "leadership",
    "id": 40269,
    "text": "I'm not up on the Internet, but I hear that is a democratic possibility. People can connect with each other. I think people are ready for something, but there is no leadership to offer it to them. People are ready to say, 'Yes, we are part of a world.'"
  },
  {
    "author": "Ron Fournier",
    "category": "leadership",
    "id": 40155,
    "text": "Washington's answer to a self-inflicted financial crisis reminded Americans why they so deeply distrust the political class. The 'fiscal cliff' process was secretive and sloppy, and the nation's so-called leadership lacked the political courage to address our root problems: joblessness and debt."
  },
  {
    "author": "David Miliband",
    "category": "leadership",
    "id": 40222,
    "text": "The test of leadership for David Cameron was actually to bring the British Conservative Party back in to the mainstream."
  },
  {
    "author": "Ed Markey",
    "category": "leadership",
    "id": 40309,
    "text": "The problem is, is that President Bush and the Republican leadership in the Congress have resisted attempts to increase dramatically our fuel economy standards over the last five years."
  },
  {
    "author": "David Cameron",
    "category": "leadership",
    "id": 40092,
    "text": "Half a century ago, the amazing courage of Rosa Parks, the visionary leadership of Martin Luther King, and the inspirational actions of the civil rights movement led politicians to write equality into the law and make real the promise of America for all her citizens."
  },
  {
    "author": "Tom Lantos",
    "category": "leadership",
    "id": 40409,
    "text": "The Chinese leadership hoped that the world would soon forget the Tiananmen Square massacre. Our job in Congress is to ensure that we never forget those who lost their lives in Tiananmen Square that day or the pro-democracy cause for which they fought."
  },
  {
    "author": "David Joseph Schwartz",
    "category": "leadership",
    "id": 40008,
    "text": "How we think shows through in how we act. Attitudes are mirrors of the mind. They reflect thinking."
  }
]

quotes['learning'] = [
  {
    "author": "Tommy Mottola",
    "category": "learning",
    "id": 41448,
    "text": "Everything starts and ends with the song, and working with writers and really learning their process and craft was an invaluable experience."
  },
  {
    "author": "Ashley Scott",
    "category": "learning",
    "id": 41272,
    "text": "I was training more learning how to scuba dive which I'd never done which was really, really, really cool."
  },
  {
    "author": "William Godwin",
    "category": "learning",
    "id": 41043,
    "text": "Learning is the ally, not the adversary of genius... he who reads in a proper spirit, can scarcely read too much."
  },
  {
    "author": "Ted Allen",
    "category": "learning",
    "id": 40920,
    "text": "I really have a great deal of humility in that department, and a great deal of respect for people who spend their lives learning how to make these amazing preparations."
  },
  {
    "author": "Ari Graynor",
    "category": "learning",
    "id": 41463,
    "text": "Working with David Gordon Green, and Jonah Hill, and Michael Cera, and Drew Barrymore, and all of those people - those are the best people in comedy to work with. Anna Faris. You know, that's my goal, to keep learning and to just keep working with the best people I can. And yeah, we do all hang out, and we all kind of know each other."
  },
  {
    "author": "Cleo Moore",
    "category": "learning",
    "id": 41386,
    "text": "I'm not a very good painter, but I'm learning a lot."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "learning",
    "id": 40532,
    "text": "He who would learn to fly one day must first learn to stand and walk and run and climb and dance one cannot fly into flying."
  },
  {
    "author": "Michael N. Castle",
    "category": "learning",
    "id": 41090,
    "text": "During the days of segregation, there was not a place of higher learning for African Americans. They were simply not welcome in many of the traditional schools. And from this backward policy grew the network of historical black colleges and universities."
  },
  {
    "author": "Donna Tartt",
    "category": "learning",
    "id": 41109,
    "text": "The novel is about five students of classics who are studying with a classics professor, and they take the ideas of the things that they're learning from him a bit too seriously, with terrible consequences."
  },
  {
    "author": "Miguel de Icaza",
    "category": "learning",
    "id": 41246,
    "text": "We have a lot of existing customers which are also considering Linux desktop migrations and rolling out some of these programs, so we're learning from them."
  },
  {
    "author": "Madeleine Peyroux",
    "category": "learning",
    "id": 41374,
    "text": "I was just learning to play guitar when Tracy Chapman came out. She wrote these songs, she played them by herself and I so admired her for that."
  },
  {
    "author": "Jeremy Collier",
    "category": "learning",
    "id": 41204,
    "text": "Learning gives us a fuller conviction of the imperfections of our nature which one would think, might dispose us to modesty."
  },
  {
    "author": "Rose Kennedy",
    "category": "learning",
    "id": 40712,
    "text": "Neither comprehension nor learning can take place in an atmosphere of anxiety."
  },
  {
    "author": "Chuck Close",
    "category": "learning",
    "id": 41357,
    "text": "I wanted to translate from one flat surface to another. In fact, my learning disabilities controlled a lot of things. I don't recognize faces, so I'm sure it's what drove me to portraits in the first place."
  },
  {
    "author": "Eric Hoffer",
    "category": "learning",
    "id": 40553,
    "text": "In times of change learners inherit the earth while the learned find themselves beautifully equipped to deal with a world that no longer exists."
  },
  {
    "author": "Bill Rancic",
    "category": "learning",
    "id": 41322,
    "text": "This was our last stop. This was it. We had those two embryos that we had banked prior to learning about the breast cancer, and with the medicine she was on, this was our last effort. The prayers were answered."
  },
  {
    "author": "Margaret Mead",
    "category": "learning",
    "id": 40574,
    "text": "I learned the value of hard work by working hard."
  },
  {
    "author": "Miuccia Prada",
    "category": "learning",
    "id": 40899,
    "text": "My learning process is by eye alone it's not at all scientific."
  },
  {
    "author": "Hermann Hesse",
    "category": "learning",
    "id": 40788,
    "text": "There is, so I believe, in the essence of everything, something that we cannot call learning. There is, my friend, only a knowledge - that is everywhere."
  },
  {
    "author": "Thomas Carper",
    "category": "learning",
    "id": 41464,
    "text": "That's not all our crops can do. We are also learning how to transform plants into factories. We can now raise plants that will create enzymes that would otherwise be created in chemical factories."
  },
  {
    "author": "Suzanne Fields",
    "category": "learning",
    "id": 41031,
    "text": "Hollywood and the recording industry argue that current law permits the copying of songs and movies, and sharing them on the Internet. This enables young people to grow up learning how to steal."
  },
  {
    "author": "Francis Bacon",
    "category": "learning",
    "id": 40679,
    "text": "People usually think according to their inclinations, speak according to their learning and ingrained opinions, but generally act according to custom."
  },
  {
    "author": "Mike Wallace",
    "category": "learning",
    "id": 40988,
    "text": "I'm nearing the end of the road and still learning."
  },
  {
    "author": "Benjamin Spock",
    "category": "learning",
    "id": 40884,
    "text": "All the time a person is a child he is both a child and learning to be a parent. After he becomes a parent he becomes predominantly a parent reliving childhood."
  },
  {
    "author": "Ray Charles",
    "category": "learning",
    "id": 40864,
    "text": "Learning to read music in Braille and play by ear helped me develop a damn good memory."
  },
  {
    "author": "Edward Thorndike",
    "category": "learning",
    "id": 40786,
    "text": "Human beings are accustomed to think of intellect as the power of having and controlling ideas and of ability to learn as synonymous with ability to have ideas. But learning by having ideas is really one of the rare and isolated events in nature."
  },
  {
    "author": "Tony Robbins",
    "category": "learning",
    "id": 40558,
    "text": "The truth is that we can learn to condition our minds, bodies, and emotions to link pain or pleasure to whatever we choose. By changing what we link pain and pleasure to, we will instantly change our behaviors."
  },
  {
    "author": "Carl Rogers",
    "category": "learning",
    "id": 40811,
    "text": "I believe that the testing of the student's achievements in order to see if he meets some criterion held by the teacher, is directly contrary to the implications of therapy for significant learning."
  },
  {
    "author": "Tony Williams",
    "category": "learning",
    "id": 41495,
    "text": "I've studied all my musical life, but learning is only good if you do something constructive with it."
  },
  {
    "author": "Archie Panjabi",
    "category": "learning",
    "id": 41129,
    "text": "I'd love to do a romantic comedy. And perhaps, if the character was right and I had a good gut instinct, a Bollywood movie. And I'd love to direct. One day. I'm learning a lot on the set of 'The Good Wife.'"
  },
  {
    "author": "Mstislav Rostropovich",
    "category": "learning",
    "id": 41256,
    "text": "When I started learning the cello, I fell in love with the instrument because it seemed like a voice - my voice."
  },
  {
    "author": "Christopher Meloni",
    "category": "learning",
    "id": 40793,
    "text": "I had no expectations about fatherhood, really, but it's definitely a journey I'm glad to be taking. Number one, it's a great learning experience. When my mother told me it's a 24/7 job, she wasn't kidding."
  },
  {
    "author": "Frankie Muniz",
    "category": "learning",
    "id": 41472,
    "text": "Acting classes, I guess, are good and I would like to maybe sometime take one. But I would feel like I was learning someone else's technique. I like mine."
  },
  {
    "author": "Abraham Cahan",
    "category": "learning",
    "id": 41265,
    "text": "Only the other world has substance and reality only good deeds and holy learning have tangible worth."
  },
  {
    "author": "David Duchovny",
    "category": "learning",
    "id": 40818,
    "text": "I may be learning guitar, but I'll never be able to sing."
  },
  {
    "author": "Lindsay Lohan",
    "category": "learning",
    "id": 40895,
    "text": "I think my biggest focus for myself is learning how to continue to get through the trauma that my father has caused in my life."
  },
  {
    "author": "J. K. Rowling",
    "category": "learning",
    "id": 40741,
    "text": "I think you're working and learning until you die."
  },
  {
    "author": "Daniel J. Boorstin",
    "category": "learning",
    "id": 40662,
    "text": "Education is learning what you didn't even know you didn't know."
  },
  {
    "author": "e. e. cummings",
    "category": "learning",
    "id": 40582,
    "text": "I'd rather learn from one bird how to sing than to teach ten thousand stars how not to dance."
  },
  {
    "author": "Debbie Stabenow",
    "category": "learning",
    "id": 41105,
    "text": "Quality afterschool programs provide safe, engaging and fun learning experiences to help children and youth develop their social, emotional, physical, cultural and academic skills."
  },
  {
    "author": "Anthony de Mello",
    "category": "learning",
    "id": 40646,
    "text": "These things will destroy the human race: politics without principle, progress without compassion, wealth without work, learning without silence, religion without fearlessness and worship without awareness."
  },
  {
    "author": "Dan Farmer",
    "category": "learning",
    "id": 41381,
    "text": "I was fairly solitary. I didn't like structured learning. People didn't seem to be my cup of tea."
  },
  {
    "author": "James Blake",
    "category": "learning",
    "id": 41362,
    "text": "I think when you're learning an instrument, you are restricted because much of it is the noise of individual theory and your ability to play the instrument."
  },
  {
    "author": "Jeremy Renner",
    "category": "learning",
    "id": 40956,
    "text": "What matters to me is learning and growing, and getting to do what I love to do. As long as I can do that, I'm happy."
  },
  {
    "author": "Beck",
    "category": "learning",
    "id": 41111,
    "text": "Every time you go in, it's like starting over. You don't know how you did the other records. You're learning all over. It's some weird musician amnesia, or maybe the road wipes it out."
  },
  {
    "author": "Janis Ian",
    "category": "learning",
    "id": 41065,
    "text": "I've always been an avid reader. If I don't have a book in the car, I'll stop and pick one up just to have something to read. I don't even remember learning to read."
  },
  {
    "author": "Katharine Fullerton Gerould",
    "category": "learning",
    "id": 41217,
    "text": "Ignorance of what real learning is, and a consequent suspicion of it materialism, and a consequent intellectual laxity, both of these have done destructive work in the colleges."
  },
  {
    "author": "Michael Gove",
    "category": "learning",
    "id": 41095,
    "text": "It is literally the case that learning languages makes you smarter. The neural networks in the brain strengthen as a result of language learning."
  },
  {
    "author": "Andrea Jung",
    "category": "learning",
    "id": 40967,
    "text": "I became CEO at the beginning of the hit on old economy stocks. When something like that occurs in your first six months as a CEO of a more traditional branded firm, it makes for a fast learning curve."
  },
  {
    "author": "Jennifer Yuh Nelson",
    "category": "learning",
    "id": 41457,
    "text": "Growing up, my sisters and I would always talk stories. One of my frustrations was I didn't know anything about cameras. I didn't know how to make a film and I obviously didn't have a special effects budget. I was a kid. So I was learning to draw to get down the stuff that was in my head, that I couldn't afford to actually do."
  },
  {
    "author": "Nikki Giovanni",
    "category": "learning",
    "id": 40936,
    "text": "I spend a lot of time learning about bird watching."
  },
  {
    "author": "Roy Romer",
    "category": "learning",
    "id": 41358,
    "text": "Productivity is going to be a critical issue. And it's not just about getting more time for professors in the classroom. It involves reexamining the learning experience and restructuring faculty and the use of faculty time."
  },
  {
    "author": "Layne Staley",
    "category": "learning",
    "id": 40830,
    "text": "We started this band as kids, and as time has gone on, we've grown and are learning to accommodate each others' differences."
  },
  {
    "author": "Peter Drucker",
    "category": "learning",
    "id": 40593,
    "text": "We now accept the fact that learning is a lifelong process of keeping abreast of change. And the most pressing task is to teach people how to learn."
  },
  {
    "author": "Kevin Kelly",
    "category": "learning",
    "id": 41020,
    "text": "This is actually a very important principle that science is learning about large systems like evolution and that futurists are learning about anticipating human society: just because a future scenario is plausible doesn't mean we can get there from here."
  },
  {
    "author": "Flora Lewis",
    "category": "learning",
    "id": 40951,
    "text": "Learning another language is not only learning different words for the same things, but learning another way to think about things."
  },
  {
    "author": "Roger Ascham",
    "category": "learning",
    "id": 41424,
    "text": "Young children were sooner allured by love, than driven by beating, to attain good learning."
  },
  {
    "author": "Wayne Rooney",
    "category": "learning",
    "id": 40957,
    "text": "There are many ways to grow football-wise. You go slow or are pushed to go faster, otherwise you get left behind. For me, there would be trouble in stopping learning."
  },
  {
    "author": "Jeffrey Kluger",
    "category": "learning",
    "id": 40912,
    "text": "The mind of the polyglot is a very particular thing, and scientists are only beginning to look closely at how acquiring a second language influences learning, behavior and the very structure of the brain itself."
  },
  {
    "author": "J. J. Abrams",
    "category": "learning",
    "id": 40939,
    "text": "What I'm still grappling with and learning how to do is to be looking and thinking cinematically, having come from television."
  },
  {
    "author": "Ellen Pompeo",
    "category": "learning",
    "id": 41149,
    "text": "Learning about the way people process information and their emotions is hugely helpful to my work."
  },
  {
    "author": "Lauryn Hill",
    "category": "learning",
    "id": 40781,
    "text": "This life is a process of learning."
  },
  {
    "author": "Rian Johnson",
    "category": "learning",
    "id": 41225,
    "text": "Hopefully with each thing that you do you're learning something, you're growing, and you're pushing yourself a little harder in some way or another. So I think you'd be in real trouble if each new thing that you create didn't feel like 'Oh, wow. I feel like I'm doing something a little different this time.'"
  },
  {
    "author": "Lillian Gish",
    "category": "learning",
    "id": 40729,
    "text": "A happy life is one spent in learning, earning, and yearning."
  },
  {
    "author": "Adam Sandler",
    "category": "learning",
    "id": 40853,
    "text": "It definitely has learning a lesson about the way you're living your life. I wouldn't compare our movie to that, but it has a structure where it's about a man who doesn't appreciate all that he has and finds out at the end that life has been great and he has to enjoy that."
  },
  {
    "author": "Mickey Hart",
    "category": "learning",
    "id": 41403,
    "text": "Art in the classroom not only spurs creativity, it also inspires learning."
  },
  {
    "author": "Galileo Galilei",
    "category": "learning",
    "id": 40584,
    "text": "I have never met a man so ignorant that I couldn't learn something from him."
  },
  {
    "author": "Elisabeth Rohm",
    "category": "learning",
    "id": 40932,
    "text": "You never stop learning. If you have a teacher, you never stop being a student."
  },
  {
    "author": "Junior Seau",
    "category": "learning",
    "id": 41034,
    "text": "As I was coming up, it always seemed like I was learning. If it wasn't from school, it was the 'hood. The influences of the 'hood are very powerful."
  },
  {
    "author": "Lord Chesterfield",
    "category": "learning",
    "id": 40779,
    "text": "Wear your learning like your watch, in a private pocket and do not pull it out, and strike it, merely to show that you have one."
  },
  {
    "author": "Tyne Daly",
    "category": "learning",
    "id": 41411,
    "text": "The director's job is full of all sorts of annoyances and details - like how many cars are on the street. Ugh. I don't want it. I like my gig. And I feel that for the next 30 years or so I can keep learning more about it."
  },
  {
    "author": "Timothy Leary",
    "category": "learning",
    "id": 40734,
    "text": "Learning how to operate a soul figures to take time."
  },
  {
    "author": "Marie von Ebner-Eschenbach",
    "category": "learning",
    "id": 40601,
    "text": "In youth we learn in age we understand."
  },
  {
    "author": "Oscar Wilde",
    "category": "learning",
    "id": 40619,
    "text": "Everybody who is incapable of learning has taken to teaching."
  },
  {
    "author": "Dweezil Zappa",
    "category": "learning",
    "id": 41182,
    "text": "For me, the most difficult thing is that I am learning melodies on guitar from some songs whose melodies were not meant to be played on guitar. Ever. They were intended mostly for keyboards or melodic percussion."
  },
  {
    "author": "Karlie Kloss",
    "category": "learning",
    "id": 41061,
    "text": "You have to grow thick skin and that only comes with time and learning."
  },
  {
    "author": "Carter Burwell",
    "category": "learning",
    "id": 41007,
    "text": "Learning how to improvise really awakened my interest in music."
  },
  {
    "author": "Henry David Thoreau",
    "category": "learning",
    "id": 40549,
    "text": "I have learned, that if one advances confidently in the direction of his dreams, and endeavors to live the life he has imagined, he will meet with a success unexpected in common hours."
  },
  {
    "author": "Linda Vester",
    "category": "learning",
    "id": 41413,
    "text": "I think I'd like to stay anchoring because, number one, I'm learning a lot, and I love it when I'm learning. And number two, I also have the luxury of a stable life."
  },
  {
    "author": "Tracy Kidder",
    "category": "learning",
    "id": 41236,
    "text": "The hardest thing was learning to write. I was 13, and the only writing I had done was for Social Studies. It consisted of copying passages right out of the encyclopedia."
  },
  {
    "author": "Eminem",
    "category": "learning",
    "id": 40624,
    "text": "A lot of the problems I had with fame I was bringing on myself. A lot of self-loathing, a lot of woe-is-me. Now I'm learning to see the positive side of things, instead of, like, 'I can't go to Kmart. I can't take my kids to the haunted house.'"
  },
  {
    "author": "Laura Linney",
    "category": "learning",
    "id": 40875,
    "text": "I had learning disabilities, and I couldn't express myself in the written word."
  },
  {
    "author": "Benjamin Franklin",
    "category": "learning",
    "id": 40525,
    "text": "Tell me and I forget. Teach me and I remember. Involve me and I learn."
  },
  {
    "author": "Mick Taylor",
    "category": "learning",
    "id": 41192,
    "text": "I've never stopped learning."
  },
  {
    "author": "Jean-Bertrand Aristide",
    "category": "learning",
    "id": 41104,
    "text": "Of course, learning is strengthened and solidified when it occurs in a safe, secure and normal environment."
  },
  {
    "author": "Abigail Adams",
    "category": "learning",
    "id": 40666,
    "text": "Learning is not attained by chance, it must be sought for with ardor and diligence."
  },
  {
    "author": "Siobhan Davies",
    "category": "learning",
    "id": 41130,
    "text": "Yes - it's the same in any other work - the more you massage your thinking the more capable I believe you are of expanding how you go about things and learning."
  },
  {
    "author": "Bo Derek",
    "category": "learning",
    "id": 40870,
    "text": "It's really difficult for me. Language, I am sorry that I haven't. I think I just always expected that you learn a word in place of a word and when I discovered how difficult the grammar was and learning that was very discouraging for me."
  },
  {
    "author": "Anna Deavere Smith",
    "category": "learning",
    "id": 40955,
    "text": "Learning is a tunnel experience that makes us think more broadly."
  },
  {
    "author": "Confucius",
    "category": "learning",
    "id": 40621,
    "text": "Learning without thought is labor lost thought without learning is perilous."
  },
  {
    "author": "John Hope Franklin",
    "category": "learning",
    "id": 41486,
    "text": "We also learn that this country and the Western world have no monopoly of goodness and truth and scholarship, we begin to appreciate the ingredients that are indispensable to making a better world. In a life of learning that is, perhaps, the greatest lesson of all."
  },
  {
    "author": "B. B. King",
    "category": "learning",
    "id": 40833,
    "text": "Jazz is the big brother of the blues. If a guy's playing blues like we play, he's in high school. When he starts playing jazz it's like going on to college, to a school of higher learning."
  },
  {
    "author": "Leo Buscaglia",
    "category": "learning",
    "id": 40633,
    "text": "Change is the end result of all true learning."
  },
  {
    "author": "Bobby McFerrin",
    "category": "learning",
    "id": 41245,
    "text": "I grew up in a time when being a musician and learning to be a musician was actually very wonderful."
  },
  {
    "author": "Ron Rash",
    "category": "learning",
    "id": 41405,
    "text": "I love learning about different dialects and I own all sorts of regional and time-period slang dictionaries. I often browse through relevant ones while writing a story. I also read a lot of diaries and oral histories."
  },
  {
    "author": "Koichi Tanaka",
    "category": "learning",
    "id": 41383,
    "text": "In such an environment, I was able to study things that could be of immediate usefulness to the world. That learning experience undoubtedly served me well when I eventually entered the work force."
  },
  {
    "author": "Chuck Grassley",
    "category": "learning",
    "id": 40775,
    "text": "What makes a child gifted and talented may not always be good grades in school, but a different way of looking at the world and learning."
  },
  {
    "author": "Winona Ryder",
    "category": "learning",
    "id": 41019,
    "text": "I think I'm learning to be bolder in my career choices and be more confident in my personal life. I haven't always felt very secure as an individual, but now I feel I certain confidence and sense of self that gets me through the day a lot better than before."
  },
  {
    "author": "Michelle Obama",
    "category": "learning",
    "id": 40563,
    "text": "We learned about honesty and integrity - that the truth matters... that you don't take shortcuts or play by your own set of rules... and success doesn't count unless you earn it fair and square."
  },
  {
    "author": "William Pollard",
    "category": "learning",
    "id": 41188,
    "text": "Information is a source of learning. But unless it is organized, processed, and available to the right people in a format for decision making, it is a burden, not a benefit."
  }
]

quotes['legal'] = [
  {
    "author": "Nicole Kidman",
    "category": "legal",
    "id": 41535,
    "text": "I have a different approach. I don't file lawsuits because I really don't care."
  },
  {
    "author": "Michael Moriarty",
    "category": "legal",
    "id": 41776,
    "text": "I've become so earthy. And I never was earthy. I'm doing all kinds of different roles which are not at all like the intellectual and the legal mind of Ben Stone."
  },
  {
    "author": "Michael Bloomberg",
    "category": "legal",
    "id": 41610,
    "text": "These endless legal challenges that define elections in New York are a joke in this country, and they are the reason why it is so expensive, or one of the reasons, it's so expensive to run here and why so many people decide not to run."
  },
  {
    "author": "James E. Rogers",
    "category": "legal",
    "id": 41553,
    "text": "I come from a profession which has suffered greatly because of the lack of civility. Lawyers treat each other poorly and it has come home to haunt them. The public will not tolerate a lack of civility."
  },
  {
    "author": "Pat Travers",
    "category": "legal",
    "id": 41852,
    "text": "We got a little waylaid along the way. The whole problem started about 10 years ago with management and legal battles, then still trying to make albums while I was doing all of that."
  },
  {
    "author": "John Yoo",
    "category": "legal",
    "id": 41738,
    "text": "Once the attacks occur, as we learned on Sept. 11, it is too late. It makes little sense to deprive ourselves of an important, and legal, means to detect and prevent terrorist attacks while we are still in the middle of a fight to the death with al Qaeda."
  },
  {
    "author": "Jean-Pierre Raffarin",
    "category": "legal",
    "id": 41692,
    "text": "I think that the proposed constitution is one of the European legal documents with the strongest social dimension I have seen since I began following European issues."
  },
  {
    "author": "Cliff Stearns",
    "category": "legal",
    "id": 41661,
    "text": "Mr. Speaker, the fact of the matter is that the Ten Commandments are a historical document that contains moral, ethical, and legal truisms that any person of any religion or even an atheist can recognize and appreciate."
  },
  {
    "author": "Frederic Bastiat",
    "category": "legal",
    "id": 41630,
    "text": "Is not liberty the destruction of all despotism - including, of course, legal despotism?"
  },
  {
    "author": "Joe Wilson",
    "category": "legal",
    "id": 41821,
    "text": "We need to be discussing issues specifically to help the American people. And that would not include illegal aliens. These are people - I'm for immigration - legal immigration. I've been an immigration attorney. But people who have come to our country and violated laws, we should not be providing full health care services."
  },
  {
    "author": "Andrew Johnson",
    "category": "legal",
    "id": 41647,
    "text": "Outside of the Constitution we have no legal authority more than private citizens, and within it we have only so much as that instrument gives us. This broad principle limits all our functions and applies to all subjects."
  },
  {
    "author": "Clarence Darrow",
    "category": "legal",
    "id": 41522,
    "text": "The trouble with law is lawyers."
  },
  {
    "author": "Norman Ralph Augustine",
    "category": "legal",
    "id": 41537,
    "text": "People do not win people fights. Lawyers do."
  },
  {
    "author": "Clare Short",
    "category": "legal",
    "id": 41753,
    "text": "So my own suspicion is that the attorney has stopped this prosecution because part of her defence was to question legality and that would have brought his advice into the public domain again and there was something fishy about the way in which he said war was legal."
  },
  {
    "author": "George Sutherland",
    "category": "legal",
    "id": 41848,
    "text": "The legal right of a taxpayer to decrease the amount of what otherwise would be his taxes, or altogether avoid them, by means which the law permits, cannot be doubted."
  },
  {
    "author": "William Landay",
    "category": "legal",
    "id": 41825,
    "text": "Crime and legal stories, broadly speaking, are just where my interest happens to lie."
  },
  {
    "author": "Franklin P. Jones",
    "category": "legal",
    "id": 41605,
    "text": "Anybody who thinks talk is cheap should get some legal advice."
  },
  {
    "author": "Joseph Ratzinger",
    "category": "legal",
    "id": 41649,
    "text": "Above all, we must have great respect for these people who also suffer and who want to find their own way of correct living. On the other hand, to create a legal form of a kind of homosexual marriage, in reality, does not help these people."
  },
  {
    "author": "Beverly Cleary",
    "category": "legal",
    "id": 41675,
    "text": "I write in longhand on yellow legal pads."
  },
  {
    "author": "Harold H. Greene",
    "category": "legal",
    "id": 41704,
    "text": "You can't just lecture the poor that they shouldn't riot or go to extremes. You have to make the means of legal redress available."
  },
  {
    "author": "Calvin Coolidge",
    "category": "legal",
    "id": 41508,
    "text": "Collecting more taxes than is absolutely necessary is legalized robbery."
  },
  {
    "author": "Kilari Anand Paul",
    "category": "legal",
    "id": 41855,
    "text": "Does the imam have a legal right to build the mosque at Ground Zero? The answer is yes. But is it the right thing to do? The answer is no. And most Americans, and most moderate Muslims, join with me in that call."
  },
  {
    "author": "Igor Ivanov",
    "category": "legal",
    "id": 41853,
    "text": "We believe the use of force against Iraq, especially with reference to previous resolutions of the UN Security Council, has no grounds, including legal grounds."
  },
  {
    "author": "Robert Mueller",
    "category": "legal",
    "id": 41652,
    "text": "What we bring to the table is not only our 56 field offices in the United States and our number of resident agencies, but also we have 45 legal attaches overseas."
  },
  {
    "author": "Andy Gibb",
    "category": "legal",
    "id": 41714,
    "text": "I've been working at performing for five years now. I've been working in Australia and Spain and England. When I was only 15 or 16, 1 was performing in bars I could have had legal problems, but it's also the only way to get to know what music is all about."
  },
  {
    "author": "Jim Sensenbrenner",
    "category": "legal",
    "id": 41750,
    "text": "Moreover, from reforming the tax code to our immigration system, to commonsense legal reform, President Bush put America on notice that he will continue fighting to make the country, and the world, a better place for future generations."
  },
  {
    "author": "Daniel Ek",
    "category": "legal",
    "id": 41785,
    "text": "There are half a billion people that listen to music online and the vast majority are doing so illegally. But if we bring those people over to the legal side and Spotify, what is going to happen is we are going to double the music industry and that will lead to more artists creating great new music."
  },
  {
    "author": "Robert Casey",
    "category": "legal",
    "id": 41673,
    "text": "Legal abortion will never rest easy on this nation's conscience."
  },
  {
    "author": "Robert Byrd",
    "category": "legal",
    "id": 41589,
    "text": "Hitler never abandoned the cloak of legality he recognized the enormous psychological value of having the law on his side. Instead, he turned the law inside out and made illegality legal."
  },
  {
    "author": "Elena Kagan",
    "category": "legal",
    "id": 41774,
    "text": "When the Senate ceases to engage nominees in meaningful discussion of legal issues, the confirmation process takes on an air of vacuity and farce, and the Senate becomes incapable of either properly evaluating nominees or appropriately educating the public."
  },
  {
    "author": "Dennis Hastert",
    "category": "legal",
    "id": 41549,
    "text": "Cagey trial lawyers have figured out there's a pretty good likelihood their case - no matter what its merit - will literally get its day in court because of favorable judges."
  },
  {
    "author": "Heather Wilson",
    "category": "legal",
    "id": 41771,
    "text": "I support legal immigration. I don't support amnesty because it is not fair to people standing in line at consulates around the world."
  },
  {
    "author": "Bobby Rush",
    "category": "legal",
    "id": 41847,
    "text": "Daley may not feel a moral responsibility to eliminate discrimination but he has a legal obligation to do so."
  },
  {
    "author": "Lisa Scottoline",
    "category": "legal",
    "id": 41759,
    "text": "Truly I never thought of myself as writing legal thrillers, and I still don't think I do. I write stories about women."
  },
  {
    "author": "Joseph Addison",
    "category": "legal",
    "id": 41588,
    "text": "No oppression is so heavy or lasting as that which is inflicted by the perversion and exorbitance of legal authority."
  },
  {
    "author": "Pam Bondi",
    "category": "legal",
    "id": 41758,
    "text": "The only people that should vote should be legal."
  },
  {
    "author": "John Yoo",
    "category": "legal",
    "id": 41737,
    "text": "While Taliban fighters had an initial claim to protection under the conventions, they lost POW status by failing to obey the standards of conduct for legal combatants: wearing uniforms, a responsible command structure, and obeying the laws of war."
  },
  {
    "author": "Christopher Darden",
    "category": "legal",
    "id": 41544,
    "text": "The law has no compassion. And justice is administered without compassion."
  },
  {
    "author": "Mary Roberts Rinehart",
    "category": "legal",
    "id": 41573,
    "text": "I never saw a lawyer yet who would admit he was making money."
  },
  {
    "author": "Hans Frank",
    "category": "legal",
    "id": 41763,
    "text": "I worked as a lawyer as a member of the teaching staff of a technical college and then I worked principally as legal adviser to Adolf Hitler and the National Socialist German Workers Party."
  },
  {
    "author": "Daniel Ek",
    "category": "legal",
    "id": 41786,
    "text": "There are millions of people who consume music illegally every month. Just getting them into a legal service will make the music industry way bigger than it's ever been before."
  },
  {
    "author": "Felix Frankfurter",
    "category": "legal",
    "id": 41558,
    "text": "To some lawyers, all facts are created equal."
  },
  {
    "author": "Michael K. Simpson",
    "category": "legal",
    "id": 41694,
    "text": "History has shown us that, on extraordinarily rare occasions, it becomes necessary for the federal government to intervene on behalf of individuals whose 14th Amendment rights to legal due process and equal protection may be violated by a state."
  },
  {
    "author": "Alexei Navalny",
    "category": "legal",
    "id": 41765,
    "text": "When men are arrested without any legal basis and for political reasons, it's merely a routine, everyday occurrence in Russia, and hardly anyone has any sympathy."
  },
  {
    "author": "Honore de Balzac",
    "category": "legal",
    "id": 41515,
    "text": "Laws are spider webs through which the big flies pass and the little ones get caught."
  },
  {
    "author": "Hassan Nasrallah",
    "category": "legal",
    "id": 41601,
    "text": "However, there is no legal and legitimate state called Israel."
  },
  {
    "author": "George Segal",
    "category": "legal",
    "id": 41667,
    "text": "Farming with live animals is a 7 day a week, legal form of slavery."
  },
  {
    "author": "Colin Powell",
    "category": "legal",
    "id": 41583,
    "text": "In terms of the legal matter of creating a contract between two people that's called marriage, and allowing them to live together with the protection of law, it seems to me is the way we should be moving in this country."
  },
  {
    "author": "Robert E. Lee",
    "category": "legal",
    "id": 41519,
    "text": "Obedience to lawful authority is the foundation of manly character."
  },
  {
    "author": "John Perry Barlow",
    "category": "legal",
    "id": 41749,
    "text": "They seem to have forgotten that, and are back saying the only purpose of P2P networks is for illegal trading of owned goods. We claim part of the reason for P2P is for legal trading of what ought to be in public domain. And what is in public domain in many cases."
  },
  {
    "author": "Cass Sunstein",
    "category": "legal",
    "id": 41742,
    "text": "Catholicism is a wide tent in terms of political and legal positions. We could have nine Catholics on the Supreme Court and a great deal of diversity toward the law."
  },
  {
    "author": "Jose Serrano",
    "category": "legal",
    "id": 41784,
    "text": "We must make immigration a legal, orderly process to eliminate this issue, not further criminalize it."
  },
  {
    "author": "Jose Maria Aznar",
    "category": "legal",
    "id": 41745,
    "text": "Disarming Iraq is legal under a series of U.N. resolutions. Iraq is in flagrant violation of U.N. Security Council resolutions."
  },
  {
    "author": "Sonia Sotomayor",
    "category": "legal",
    "id": 41625,
    "text": "All of the legal defense funds out there, they're looking for people out there with court of appeals experience, because court of appeals is where policy is made. And I know, I know this is on tape and I should never say that because we don't make law, I know. I know."
  },
  {
    "author": "Jack Kingston",
    "category": "legal",
    "id": 41538,
    "text": "Frivolous lawsuits are booming in this county. The U.S. has more costs of litigation per person than any other industrialized nation in the world, and it is crippling our economy."
  },
  {
    "author": "H. G. Wells",
    "category": "legal",
    "id": 41518,
    "text": "Advertising is legalized lying."
  },
  {
    "author": "Val Kilmer",
    "category": "legal",
    "id": 41752,
    "text": "Again, in Wag the Dog, war has to be declared by an act of congress. But if you go to war, you don't have to declare war. You're just at war and we did that, which is not legal."
  },
  {
    "author": "Elton Gallegly",
    "category": "legal",
    "id": 41733,
    "text": "Instead, California is one of only 10 states that provides in-state college and university tuition to illegal immigrants. That's grossly unfair to a legal high school student who moves out of California for a year, then returns to attend college."
  },
  {
    "author": "Joe Lieberman",
    "category": "legal",
    "id": 41679,
    "text": "I also urge the Obama administration - both on its own and in cooperation with other responsible governments around the world - to use all legal means necessary to shut down WikiLeaks before it can do more damage by releasing additional cables. WikiLeaks' activities represent a shared threat to collective international security."
  },
  {
    "author": "Jay Alan Sekulow",
    "category": "legal",
    "id": 41560,
    "text": "I wouldn't pretend to tell you we don't pay our lawyers well."
  },
  {
    "author": "Christopher Darden",
    "category": "legal",
    "id": 41539,
    "text": "The events of the day inspired me to become a lawyer."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "legal",
    "id": 41576,
    "text": "Never forget that everything Hitler did in Germany was legal."
  },
  {
    "author": "Tammy Bruce",
    "category": "legal",
    "id": 41557,
    "text": "Unfortunately, what many people forget is that judges are just lawyers in robes."
  },
  {
    "author": "George Soros",
    "category": "legal",
    "id": 41641,
    "text": "Who most benefits from keeping marijuana illegal? The greatest beneficiaries are the major criminal organizations in Mexico and elsewhere that earn billions of dollars annually from this illicit trade - and who would rapidly lose their competitive advantage if marijuana were a legal commodity."
  },
  {
    "author": "Ted Demme",
    "category": "legal",
    "id": 41594,
    "text": "But my humble opinion is, I'm not quite sure where I stand on the legalization of drugs - though, if tequila is legal, pot should probably be legal."
  },
  {
    "author": "Ernestine Rose",
    "category": "legal",
    "id": 41773,
    "text": "It is high time to compel man by the might of right to give woman her political, legal and social rights. She will find her own sphere in accordance with her capacities, powers and tastes and yet she will be woman still."
  },
  {
    "author": "Marco Rubio",
    "category": "legal",
    "id": 41599,
    "text": "We should be the pro-legal immigration party. A party that has a positive platform and agenda on how we can create a legal immigration system that works for immigrants and works for America."
  },
  {
    "author": "Addison Mizner",
    "category": "legal",
    "id": 41542,
    "text": "Ignorance of the law excuses no man from practicing it."
  },
  {
    "author": "Amber Frey",
    "category": "legal",
    "id": 41796,
    "text": "I feel like there was justice. It was served through the legal system you know. Everything that I endured. It was all worth it."
  },
  {
    "author": "Jon Porter",
    "category": "legal",
    "id": 41706,
    "text": "Under current law volunteers who are not working with an official nonprofit organization are not covered by the Volunteer Protection Act. Therefore, there are absolutely no legal protections for the average American who wishes to volunteer."
  },
  {
    "author": "Michael Jordan",
    "category": "legal",
    "id": 41578,
    "text": "Gambling is legal and betting is legal, for what I bet."
  },
  {
    "author": "NeNe Leakes",
    "category": "legal",
    "id": 41669,
    "text": "I'm coming out with my line of shoes and my very first shoe is called 'The Nethia.' How we came up with the name is that my legal name is Linnethia and we shortened it."
  },
  {
    "author": "Jose A. Rodriguez, Jr.",
    "category": "legal",
    "id": 41806,
    "text": "Drones can be a highly effective way of dealing with high-priority targets, but they should not become the drug of choice for an administration that is afraid to use successful, legal and safe tactics of the past."
  },
  {
    "author": "Jordana Brewster",
    "category": "legal",
    "id": 41703,
    "text": "People spend so much time in their cars, and it's a legal way to have fun by speeding a little bit or testing yourself a little bit, and you get to invest in your car. For some people, it becomes their baby."
  },
  {
    "author": "Edward Bennett Williams",
    "category": "legal",
    "id": 41572,
    "text": "They don't need a lawyer, they need a toastmaster."
  },
  {
    "author": "Bobby Darin",
    "category": "legal",
    "id": 41636,
    "text": "I'm more married to Sandy now than when we were married with the legal document. We're still married as parents."
  },
  {
    "author": "Samuel Alito",
    "category": "legal",
    "id": 41570,
    "text": "I have been committed to carrying out my duties... in accordance with both the letter and spirit of all applicable rules of ethics and canons of conduct."
  },
  {
    "author": "John Yoo",
    "category": "legal",
    "id": 41736,
    "text": "The effort to blur the lines between Guantanamo and Abu Ghraib reflects a deep misunderstanding about the different legal regimes that apply to Iraq and the war against al Qaeda."
  },
  {
    "author": "J. M. Coetzee",
    "category": "legal",
    "id": 41754,
    "text": "Strictly speaking, my interest is not in legal rights for animals but in a change of heart towards animals."
  },
  {
    "author": "Tony Campolo",
    "category": "legal",
    "id": 41615,
    "text": "I contend the state ought to do its thing and provide legal rights for all couples who want to be joined together for life. The church should bless unions that it sees fit to bless, and they should be called marriages."
  },
  {
    "author": "Gary Locke",
    "category": "legal",
    "id": 41684,
    "text": "Every year, some 65,000 high school students - many of them star students and leaders in their communities - are unable to go to college or get a good job because they have no legal status."
  },
  {
    "author": "Betty Hill",
    "category": "legal",
    "id": 41700,
    "text": "I mean you might say he had a travelling post office, but also Barney was very, very active. He was a legal officer for the NAACP and they had a lot of problems after Pease."
  },
  {
    "author": "Don Henley",
    "category": "legal",
    "id": 41556,
    "text": "Lawsuits should not be used to destroy a viable and independent distribution system. The solution lies in the marketplace and not the courtroom."
  },
  {
    "author": "Salvatore J. Cordileone",
    "category": "legal",
    "id": 41830,
    "text": "In places where marriage's core meaning has been altered through legal action, officials are beginning to target for punishment those believers and churches that refuse to adapt."
  },
  {
    "author": "Wilhelm von Humboldt",
    "category": "legal",
    "id": 41827,
    "text": "Coercion may prevent many transgressions but it robs even actions which are legal of a part of their beauty. Freedom may lead to many transgressions, but it lends even to vices a less ignoble form."
  },
  {
    "author": "Nursultan Nazarbayev",
    "category": "legal",
    "id": 41813,
    "text": "For centuries we have been living in the society where not laws but people ruled, where there was no legal state."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "legal",
    "id": 41513,
    "text": "Compromise is the best and cheapest lawyer."
  },
  {
    "author": "Laurence Tribe",
    "category": "legal",
    "id": 41845,
    "text": "Even those who, like me, believe that Roe v. Wade and the decisions elaborating on reproductive rights were constitutionally correct must recognize that, for many on the right, the sudden and relatively sloppily reasoned character of the abortion rulings... did real damage to the Court's reputation as a relatively neutral arbiter of legal disputes."
  },
  {
    "author": "John Harington",
    "category": "legal",
    "id": 41575,
    "text": "From your confessor, lawyer and physician, hide not your case on no condition."
  },
  {
    "author": "Patricia Ireland",
    "category": "legal",
    "id": 41727,
    "text": "When I started law school I was shocked to learn that our legal system traditionally had the man as the head and master of the family. As late as the '70s and '80s when we were fighting for the Equal Rights Amendment, states like Louisiana still had a head and master law."
  },
  {
    "author": "Roger Wicker",
    "category": "legal",
    "id": 41778,
    "text": "Embryonic stem cell research is legal in America, and nothing in the administration's current policy affects that legality 400 lines are currently being used to conduct embryonic stem cell research, both in the private sector and by the Federal Government."
  },
  {
    "author": "Hillary Clinton",
    "category": "legal",
    "id": 41580,
    "text": "You cannot have maternal health without reproductive health. And reproductive health includes contraception and family planning and access to legal, safe abortion."
  },
  {
    "author": "Lindsey Graham",
    "category": "legal",
    "id": 41658,
    "text": "The legal system in Afghanistan is very immature and porous."
  },
  {
    "author": "Adam Rickitt",
    "category": "legal",
    "id": 41677,
    "text": "However saying that I totally support the concept of civil partnerships in the eyes of the law, and think it a disgrace that same sex couples have had to wait so long for legal rights, protection and recognition."
  },
  {
    "author": "Andrew Thomas",
    "category": "legal",
    "id": 41843,
    "text": "Today, corruption has won and justice has lost. I brought corruption cases in good faith involving powerful people, and the political and legal establishment blatantly covered up and retaliated by targeting my law license."
  },
  {
    "author": "Aleksandr Solzhenitsyn",
    "category": "legal",
    "id": 41606,
    "text": "I have spent all my life under a Communist regime, and I will tell you that a society without any objective legal scale is a terrible one indeed. But a society with no other scale but the legal one is not quite worthy of man either."
  },
  {
    "author": "Daniel Goleman",
    "category": "legal",
    "id": 41543,
    "text": "I would say that IQ is the strongest predictor of which field you can get into and hold a job in, whether you can be an accountant, lawyer or nurse, for example."
  },
  {
    "author": "Ron Wyden",
    "category": "legal",
    "id": 41631,
    "text": "It is hard to see Judge Roberts as a judicial activist who would place ideological purity or a particular agenda above or ahead the need for thoughtful legal reasoning."
  },
  {
    "author": "Kenneth Anger",
    "category": "legal",
    "id": 41842,
    "text": "I have a problem with censorship by the lawyer - by legal people by the publishing firm, and I may be changing publishers. They don't seem to want to take too many risks with living people."
  },
  {
    "author": "Steven Wright",
    "category": "legal",
    "id": 41507,
    "text": "I busted a mirror and got seven years bad luck, but my lawyer thinks he can get me five."
  }
]

quotes['life'] = [
  {
    "author": "Saint Patrick",
    "category": "life",
    "id": 42714,
    "text": "If I have any worth, it is to live my life for God so as to teach these peoples even though some of them still look down on me."
  },
  {
    "author": "Tupac Shakur",
    "category": "life",
    "id": 42604,
    "text": "I worked hard all my life as far as this music business. I dreamed of the day when I could go to New York and feel comfortable and they could come out here and be comfortable."
  },
  {
    "author": "William James",
    "category": "life",
    "id": 41984,
    "text": "This life is worth living, we can say, since it is what we make it."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "life",
    "id": 42763,
    "text": "If you have no confidence in self, you are twice defeated in the race of life. With confidence, you have won even before you have started."
  },
  {
    "author": "Steve Jobs",
    "category": "life",
    "id": 42118,
    "text": "Again, you can't connect the dots looking forward you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something - your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life."
  },
  {
    "author": "Robert Frost",
    "category": "life",
    "id": 42577,
    "text": "The figure a poem makes. It begins in delight and ends in wisdom... in a clarification of life - not necessarily a great clarification, such as sects and cults are founded on, but in a momentary stay against confusion."
  },
  {
    "author": "William Shakespeare",
    "category": "life",
    "id": 42319,
    "text": "I bear a charmed life."
  },
  {
    "author": "Eminem",
    "category": "life",
    "id": 42292,
    "text": "Say there's a white kid who lives in a nice home, goes to an all-white school, and is pretty much having everything handed to him on a platter - for him to pick up a rap tape is incredible to me, because what that's saying is that he's living a fantasy life of rebellion."
  },
  {
    "author": "Carl Sandburg",
    "category": "life",
    "id": 41899,
    "text": "A baby is God's opinion that life should go on."
  },
  {
    "author": "Anne Hathaway",
    "category": "life",
    "id": 42433,
    "text": "Loneliness is my least favorite thing about life. The thing that I'm most worried about is just being alone without anybody to care for or someone who will care for me."
  },
  {
    "author": "Albert Einstein",
    "category": "life",
    "id": 42133,
    "text": "Without deep reflection one knows from daily life that one exists for other people."
  },
  {
    "author": "Jim Morrison",
    "category": "life",
    "id": 42125,
    "text": "People fear death even more than pain. It's strange that they fear death. Life hurts a lot more than death. At the point of death, the pain is over. Yeah, I guess it is a friend."
  },
  {
    "author": "Lao Tzu",
    "category": "life",
    "id": 42149,
    "text": "In dwelling, live close to the ground. In thinking, keep to the simple. In conflict, be fair and generous. In governing, don't try to control. In work, do what you enjoy. In family life, be completely present."
  },
  {
    "author": "Drew Barrymore",
    "category": "life",
    "id": 42847,
    "text": "I never regret anything. Because every little detail of your life is what made you into who you are in the end."
  },
  {
    "author": "Bede Griffiths",
    "category": "life",
    "id": 42592,
    "text": "God had brought me to my knees and made me acknowledge my own nothingness, and out of that knowledge I had been reborn. I was no longer the centre of my life and therefore I could see God in everything."
  },
  {
    "author": "Plato",
    "category": "life",
    "id": 42642,
    "text": "Attention to health is life's greatest hindrance."
  },
  {
    "author": "Wayne Dyer",
    "category": "life",
    "id": 42246,
    "text": "Stop acting as if life is a rehearsal. Live this day as if it were your last. The past is over and gone. The future is not guaranteed."
  },
  {
    "author": "Henry Ford",
    "category": "life",
    "id": 42833,
    "text": "As we advance in life we learn the limits of our abilities."
  },
  {
    "author": "H. Jackson Brown, Jr.",
    "category": "life",
    "id": 42350,
    "text": "Choose your life's mate carefully. From this one decision will come 90 percent of all your happiness or misery."
  },
  {
    "author": "Dorothea Lange",
    "category": "life",
    "id": 42724,
    "text": "Photography takes an instant out of time, altering life by holding it still."
  },
  {
    "author": "Arthur Schopenhauer",
    "category": "life",
    "id": 42416,
    "text": "Each day is a little life: every waking and rising a little birth, every fresh morning a little youth, every going to rest and sleep a little death."
  },
  {
    "author": "Henry David Thoreau",
    "category": "life",
    "id": 42476,
    "text": "What is called genius is the abundance of life and health."
  },
  {
    "author": "Sylvia Plath",
    "category": "life",
    "id": 42665,
    "text": "And by the way, everything in life is writable about if you have the outgoing guts to do it, and the imagination to improvise. The worst enemy to creativity is self-doubt."
  },
  {
    "author": "Albert Einstein",
    "category": "life",
    "id": 42106,
    "text": "Imagination is everything. It is the preview of life's coming attractions."
  },
  {
    "author": "Virginia Satir",
    "category": "life",
    "id": 42590,
    "text": "Life is not what it's supposed to be. It's what it is. The way you cope with it is what makes the difference."
  },
  {
    "author": "Thomas Jefferson",
    "category": "life",
    "id": 42250,
    "text": "Books constitute capital. A library book lasts as long as a house, for hundreds of years. It is not, then, an article of mere consumption but fairly of capital, and often in the case of professional men, setting out in life, it is their only capital."
  },
  {
    "author": "Albert Einstein",
    "category": "life",
    "id": 42132,
    "text": "The monotony and solitude of a quiet life stimulates the creative mind."
  },
  {
    "author": "Gabriel Byrne",
    "category": "life",
    "id": 42314,
    "text": "Presents don't really mean much to me. I don't want to sound mawkish, but - it was the realization that I have a great many people in my life who really love me, and who I really love."
  },
  {
    "author": "Abraham Maslow",
    "category": "life",
    "id": 42474,
    "text": "If you plan on being anything less than you are capable of being, you will probably be unhappy all the days of your life."
  },
  {
    "author": "Emile Zola",
    "category": "life",
    "id": 42221,
    "text": "If you ask me what I came into this life to do, I will tell you: I came to live out loud."
  },
  {
    "author": "Marilyn Monroe",
    "category": "life",
    "id": 42453,
    "text": "Sometimes I think it would be easier to avoid old age, to die young, but then you'd never complete your life, would you? You'd never wholly know you."
  },
  {
    "author": "Dan Millman",
    "category": "life",
    "id": 42783,
    "text": "Faith means living with uncertainty - feeling your way through life, letting your heart guide you like a lantern in the dark."
  },
  {
    "author": "Sophia Loren",
    "category": "life",
    "id": 42659,
    "text": "There is a fountain of youth: it is your mind, your talents, the creativity you bring to your life and the lives of people you love. When you learn to tap this source, you will truly have defeated age."
  },
  {
    "author": "Napoleon Hill",
    "category": "life",
    "id": 42651,
    "text": "It takes half your life before you discover life is a do-it-yourself project."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "life",
    "id": 42409,
    "text": "People disparage knowing and the intellectual life, and urge doing. I am content with knowing, if only I could know."
  },
  {
    "author": "Leon Trotsky",
    "category": "life",
    "id": 42785,
    "text": "Life is not an easy matter... You cannot live through it without falling into frustration and cynicism unless you have before you a great idea which raises you above personal misery, above weakness, above all kinds of perfidy and baseness."
  },
  {
    "author": "Will Smith",
    "category": "life",
    "id": 42772,
    "text": "Life is lived on the edge."
  },
  {
    "author": "Samuel Butler",
    "category": "life",
    "id": 42034,
    "text": "Human life is as evanescent as the morning dew or a flash of lightning."
  },
  {
    "author": "George Bernard Shaw",
    "category": "life",
    "id": 42209,
    "text": "Life isn't about finding yourself. Life is about creating yourself."
  },
  {
    "author": "Eminem",
    "category": "life",
    "id": 42373,
    "text": "I need drama in my life to keep making music."
  },
  {
    "author": "John Ruskin",
    "category": "life",
    "id": 42013,
    "text": "There is no wealth but life."
  },
  {
    "author": "Gary Ryan Blair",
    "category": "life",
    "id": 42639,
    "text": "We only live once, but once is enough if we do it right. Live your life with class, dignity, and style so that an exclamation, rather than a question mark signifies it!"
  },
  {
    "author": "Benjamin Franklin",
    "category": "life",
    "id": 42158,
    "text": "Life's Tragedy is that we get old to soon and wise too late."
  },
  {
    "author": "Mitch Hedberg",
    "category": "life",
    "id": 42845,
    "text": "I'm a heroine addict. I need to have sex with women who have saved someone's life."
  },
  {
    "author": "William Feather",
    "category": "life",
    "id": 41979,
    "text": "One way to get the most out of life is to look upon it as an adventure."
  },
  {
    "author": "Wilma Rudolph",
    "category": "life",
    "id": 42546,
    "text": "Winning is great, sure, but if you are really going to do something in life, the secret is learning how to lose. Nobody goes undefeated all the time. If you can pick up after a crushing defeat, and go on to win again, you are going to be a champion someday."
  },
  {
    "author": "Malcolm X",
    "category": "life",
    "id": 42672,
    "text": "My Alma mater was books, a good library... I could spend the rest of my life reading, just satisfying my curiosity."
  },
  {
    "author": "John Wayne",
    "category": "life",
    "id": 42156,
    "text": "Life is tough, but it's tougher when you're stupid."
  },
  {
    "author": "Tallulah Bankhead",
    "category": "life",
    "id": 42568,
    "text": "If I had to live my life again, I'd make the same mistakes, only sooner."
  },
  {
    "author": "Wayne Dyer",
    "category": "life",
    "id": 41940,
    "text": "What we think determines what happens to us, so if we want to change our lives, we need to stretch our minds."
  },
  {
    "author": "Muhammad Ali",
    "category": "life",
    "id": 42338,
    "text": "Frazier is so ugly that he should donate his face to the US Bureau of Wild Life."
  },
  {
    "author": "Henry David Thoreau",
    "category": "life",
    "id": 42549,
    "text": "Live the life you've dreamed."
  },
  {
    "author": "George Bernard Shaw",
    "category": "life",
    "id": 41943,
    "text": "Use your health, even to the point of wearing it out. That is what it is for. Spend all you have before you die do not outlive yourself."
  },
  {
    "author": "Les Brown",
    "category": "life",
    "id": 42556,
    "text": "Accept responsibility for your life. Know that it is you who will get you where you want to go, no one else."
  },
  {
    "author": "Katharine Hepburn",
    "category": "life",
    "id": 42280,
    "text": "Life is hard. After all, it kills you."
  },
  {
    "author": "Paulo Coelho",
    "category": "life",
    "id": 42390,
    "text": "Life was always a matter of waiting for the right moment to act."
  },
  {
    "author": "George Bernard Shaw",
    "category": "life",
    "id": 42595,
    "text": "Home life is no more natural to us than a cage is natural to a cockatoo."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "life",
    "id": 42065,
    "text": "Where there is love there is life."
  },
  {
    "author": "Stephen King",
    "category": "life",
    "id": 42793,
    "text": "A lot of us grow up and we grow out of the literal interpretation that we get when we're children, but we bear the scars all our life. Whether they're scars of beauty or scars of ugliness, it's pretty much in the eye of the beholder."
  },
  {
    "author": "Margaret J. Wheatley",
    "category": "life",
    "id": 42192,
    "text": "In our daily life, we encounter people who are angry, deceitful, intent only on satisfying their own needs. There is so much anger, distrust, greed, and pettiness that we are losing our capacity to work well together."
  },
  {
    "author": "Aristotle",
    "category": "life",
    "id": 42429,
    "text": "Thou wilt find rest from vain fancies if thou doest every act in life as though it were thy last."
  },
  {
    "author": "Og Mandino",
    "category": "life",
    "id": 42147,
    "text": "Beginning today, treat everyone you meet as if they were going to be dead by midnight. Extend to them all the care, kindness and understanding you can muster, and do it with no thought of any reward. Your life will never be the same again."
  },
  {
    "author": "Isaac Asimov",
    "category": "life",
    "id": 41985,
    "text": "Life is pleasant. Death is peaceful. It's the transition that's troublesome."
  },
  {
    "author": "Thomas Jefferson",
    "category": "life",
    "id": 42171,
    "text": "We hold these truths to be self-evident: that all men are created equal that they are endowed by their Creator with certain unalienable rights that among these are life, liberty, and the pursuit of happiness."
  },
  {
    "author": "Eleanor Roosevelt",
    "category": "life",
    "id": 42206,
    "text": "Probably the happiest period in life most frequently is in middle age, when the eager passions of youth are cooled, and the infirmities of age not yet begun as we see that the shadows, which are at morning and evening so large, almost entirely disappear at midday."
  },
  {
    "author": "Khalil Gibran",
    "category": "life",
    "id": 42215,
    "text": "March on. Do not tarry. To go forward is to move toward perfection. March on, and fear not the thorns, or the sharp stones on life's path."
  },
  {
    "author": "Christopher Morley",
    "category": "life",
    "id": 42325,
    "text": "A man who has never made a woman angry is a failure in life."
  },
  {
    "author": "William Wallace",
    "category": "life",
    "id": 41890,
    "text": "Every man dies. Not every man really lives."
  },
  {
    "author": "Eleanor Roosevelt",
    "category": "life",
    "id": 42326,
    "text": "Autobiographies are only useful as the lives you read about and analyze may suggest to you something that you may find useful in your own journey through life."
  },
  {
    "author": "Tony Robbins",
    "category": "life",
    "id": 42500,
    "text": "Only those who have learned the power of sincere and selfless contribution experience life's deepest joy: true fulfillment."
  },
  {
    "author": "Zig Ziglar",
    "category": "life",
    "id": 42177,
    "text": "You can have everything in life you want, if you will just help other people get what they want."
  },
  {
    "author": "Nikki Giovanni",
    "category": "life",
    "id": 42615,
    "text": "I really don't think life is about the I-could-have-beens. Life is only about the I-tried-to-do. I don't mind the failure but I can't imagine that I'd forgive myself if I didn't try."
  },
  {
    "author": "Albert Schweitzer",
    "category": "life",
    "id": 42455,
    "text": "There are two means of refuge from the miseries of life: music and cats."
  },
  {
    "author": "Steve Jobs",
    "category": "life",
    "id": 42282,
    "text": "My favorite things in life don't cost any money. It's really clear that the most precious resource we all have is time."
  },
  {
    "author": "Ludwig Wittgenstein",
    "category": "life",
    "id": 42538,
    "text": "Death is not an event in life: we do not live to experience death. If we take eternity to mean not infinite temporal duration but timelessness, then eternal life belongs to those who live in the present."
  },
  {
    "author": "Faith Hill",
    "category": "life",
    "id": 42610,
    "text": "I think what makes our marriage work amid all the glare is that my husband is my best friend. He inspires everything in my life and enables me to do the best that I can. I want to hang out with him more than anyone."
  },
  {
    "author": "Emily Dickinson",
    "category": "life",
    "id": 42787,
    "text": "Find ecstasy in life the mere sense of living is joy enough."
  },
  {
    "author": "Will Smith",
    "category": "life",
    "id": 42696,
    "text": "So if you stay ready, you ain't gotta get ready, and that is how I run my life."
  },
  {
    "author": "Woody Allen",
    "category": "life",
    "id": 42018,
    "text": "Seventy percent of success in life is showing up."
  },
  {
    "author": "Wallis Simpson",
    "category": "life",
    "id": 42426,
    "text": "A woman's life can really be a succession of lives, each revolving around some emotionally compelling situation or challenge, and each marked off by some intense experience."
  },
  {
    "author": "Leo Buscaglia",
    "category": "life",
    "id": 42655,
    "text": "Life lived for tomorrow will always be just a day away from being realized."
  },
  {
    "author": "Joseph Campbell",
    "category": "life",
    "id": 42342,
    "text": "Life is without meaning. You bring the meaning to it. The meaning of life is whatever you ascribe it to be. Being alive is the meaning."
  },
  {
    "author": "John F. Kennedy",
    "category": "life",
    "id": 41929,
    "text": "The courage of life is often a less dramatic spectacle than the courage of a final moment but it is no less a magnificent mixture of triumph and tragedy."
  },
  {
    "author": "David Herbert Lawrence",
    "category": "life",
    "id": 42353,
    "text": "I want to live my life so that my nights are not full of regrets."
  },
  {
    "author": "Brooke Shields",
    "category": "life",
    "id": 42854,
    "text": "Smoking kills. If you're killed, you've lost a very important part of your life."
  },
  {
    "author": "Tony Robbins",
    "category": "life",
    "id": 42395,
    "text": "Life is a gift, and it offers us the privilege, opportunity, and responsibility to give something back by becoming more."
  },
  {
    "author": "Mitt Romney",
    "category": "life",
    "id": 42816,
    "text": "I spent my whole life in the private sector, 25 years in the private sector. I understand that when government takes more money out of the hands of people, it makes it more difficult for them to buy things. If they can't buy things, the economy doesn't grow. If the economy doesn't grow, we don't put Americans to work."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "life",
    "id": 41898,
    "text": "He who has a why to live can bear almost any how."
  },
  {
    "author": "Samuel Butler",
    "category": "life",
    "id": 42028,
    "text": "Life is the art of drawing sufficient conclusions from insufficient premises."
  },
  {
    "author": "Buddha",
    "category": "life",
    "id": 41860,
    "text": "Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment."
  },
  {
    "author": "Henry David Thoreau",
    "category": "life",
    "id": 41957,
    "text": "To affect the quality of the day, that is the highest of arts."
  },
  {
    "author": "George Carlin",
    "category": "life",
    "id": 42598,
    "text": "When you step on the brakes your life is in your foot's hands."
  },
  {
    "author": "Kevin Costner",
    "category": "life",
    "id": 42648,
    "text": "I haven't lived a perfect life. I have regrets. But that's from a lifetime of taking chances, making decisions, and trying not to be frozen. The only thing that I can do with my regrets is understand them."
  },
  {
    "author": "John F. Kennedy",
    "category": "life",
    "id": 41872,
    "text": "Change is the law of life. And those who look only to the past or present are certain to miss the future."
  },
  {
    "author": "Eileen Caddy",
    "category": "life",
    "id": 42728,
    "text": "Gratitude helps you to grow and expand gratitude brings joy and laughter into your life and into the lives of all those around you."
  },
  {
    "author": "William James",
    "category": "life",
    "id": 41982,
    "text": "To change ones life: Start immediately. Do it flamboyantly."
  },
  {
    "author": "Brendan Gill",
    "category": "life",
    "id": 42054,
    "text": "Not a shred of evidence exists in favor of the idea that life is serious."
  },
  {
    "author": "Albert Camus",
    "category": "life",
    "id": 41869,
    "text": "You will never be happy if you continue to search for what happiness consists of. You will never live if you are looking for the meaning of life."
  },
  {
    "author": "Zig Ziglar",
    "category": "life",
    "id": 42470,
    "text": "Honesty and integrity are absolutely essential for success in life - all areas of life. The really good news is that anyone can develop both honesty and integrity."
  },
  {
    "author": "Henry Ford",
    "category": "life",
    "id": 42266,
    "text": "Life is a series of experiences, each one of which makes us bigger, even though sometimes it is hard to realize this. For the world was built to develop character, and we must learn that the setbacks and grieves which we endure help us in our marching onward."
  }
]

quotes['love'] = [
  {
    "author": "Thomas Moore",
    "category": "love",
    "id": 43664,
    "text": "Romantic love is an illusion. Most of us discover this truth at the end of a love affair or else when the sweet emotions of love lead us into marriage and then turn down their flames."
  },
  {
    "author": "Tallulah Bankhead",
    "category": "love",
    "id": 43699,
    "text": "I'll come and make love to you at five o'clock. If I'm late start without me."
  },
  {
    "author": "James A. Baldwin",
    "category": "love",
    "id": 42877,
    "text": "Love does not begin and end the way we seem to think it does. Love is a battle, love is a war love is a growing up."
  },
  {
    "author": "Marie von Ebner-Eschenbach",
    "category": "love",
    "id": 43717,
    "text": "We don't believe in rheumatism and true love until after the first attack."
  },
  {
    "author": "Pietro Aretino",
    "category": "love",
    "id": 43751,
    "text": "I love you, and because I love you, I would sooner have you hate me for telling you the truth than adore me for telling you lies."
  },
  {
    "author": "e. e. cummings",
    "category": "love",
    "id": 42984,
    "text": "Be of love a little more careful than of anything."
  },
  {
    "author": "Marcus Aurelius",
    "category": "love",
    "id": 43153,
    "text": "When you arise in the morning, think of what a precious privilege it is to be alive - to breathe, to think, to enjoy, to love."
  },
  {
    "author": "Ernest Hemingway",
    "category": "love",
    "id": 43211,
    "text": "I love sleep. My life has the tendency to fall apart when I'm awake, you know?"
  },
  {
    "author": "Niccolo Machiavelli",
    "category": "love",
    "id": 43711,
    "text": "The distinction between children and adults, while probably useful for some purposes, is at bottom a specious one, I feel. There are only individual egos, crazy for love."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "love",
    "id": 43615,
    "text": "Absences are a good influence in love and keep it bright and delicate."
  },
  {
    "author": "Thomas S. Monson",
    "category": "love",
    "id": 43013,
    "text": "Choose your love, Love your choice."
  },
  {
    "author": "Werner Erhard",
    "category": "love",
    "id": 43102,
    "text": "You don't have to go looking for love when it's where you come from."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "love",
    "id": 43373,
    "text": "Not necessity, not desire - no, the love of power is the demon of men. Let them have everything - health, food, a place to live, entertainment - they are and remain unhappy and low-spirited: for the demon waits and waits and will be satisfied."
  },
  {
    "author": "H. L. Mencken",
    "category": "love",
    "id": 43606,
    "text": "Women have simple tastes. They get pleasure out of the conversation of children in arms and men in love."
  },
  {
    "author": "John Wooden",
    "category": "love",
    "id": 43621,
    "text": "Love is the most important thing in the world. Hate, we should remove from the dictionary."
  },
  {
    "author": "Virgil",
    "category": "love",
    "id": 43049,
    "text": "Love conquers all."
  },
  {
    "author": "Edgar Allan Poe",
    "category": "love",
    "id": 43522,
    "text": "There is something in the unselfish and self-sacrificing love of a brute, which goes directly to the heart of him who has had frequent occasion to test the paltry friendship and gossamer fidelity of mere Man."
  },
  {
    "author": "Thomas a Kempis",
    "category": "love",
    "id": 43554,
    "text": "Love feels no burden, thinks nothing of trouble, attempts what is above its strength, pleads no excuse of impossibility for it thinks all things lawful for itself, and all things possible."
  },
  {
    "author": "Bruce Lee",
    "category": "love",
    "id": 42860,
    "text": "Love is like a friendship caught on fire. In the beginning a flame, very pretty, often hot and fierce, but still only light and flickering. As love grows older, our hearts mature and our love becomes as coals, deep-burning and unquenchable."
  },
  {
    "author": "Judith Viorst",
    "category": "love",
    "id": 43271,
    "text": "One advantage of marriage is that, when you fall out of love with him or he falls out of love with you, it keeps you together until you fall in again."
  },
  {
    "author": "Albert Camus",
    "category": "love",
    "id": 43493,
    "text": "Man is an idea, and a precious small idea once he turns his back on love."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "love",
    "id": 43206,
    "text": "Love of beauty is taste. The creation of beauty is art."
  },
  {
    "author": "W. H. Auden",
    "category": "love",
    "id": 43678,
    "text": "A poet is, before anything else, a person who is passionately in love with language."
  },
  {
    "author": "Hubert H. Humphrey",
    "category": "love",
    "id": 43364,
    "text": "The greatest healing therapy is friendship and love."
  },
  {
    "author": "Jesus Christ",
    "category": "love",
    "id": 43456,
    "text": "All the commandments: You shall not commit adultery, you shall not kill, you shall not steal, you shall not covet, and so on, are summed up in this single command: You must love your neighbor as yourself."
  },
  {
    "author": "Audrey Hepburn",
    "category": "love",
    "id": 42886,
    "text": "I was born with an enormous need for affection, and a terrible need to give it."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "love",
    "id": 43453,
    "text": "Courage is like love it must have hope for nourishment."
  },
  {
    "author": "Robert Frost",
    "category": "love",
    "id": 43415,
    "text": "A poet never takes notes. You never take notes in a love affair."
  },
  {
    "author": "Erich Fromm",
    "category": "love",
    "id": 43313,
    "text": "The mother-child relationship is paradoxical and, in a sense, tragic. It requires the most intense love on the mother's side, yet this very love must help the child grow away from the mother, and to become fully independent."
  },
  {
    "author": "William Ellery Channing",
    "category": "love",
    "id": 43577,
    "text": "Faith is love taking the form of aspiration."
  },
  {
    "author": "Mother Teresa",
    "category": "love",
    "id": 42869,
    "text": "I have found the paradox, that if you love until it hurts, there can be no more hurt, only more love."
  },
  {
    "author": "Samuel Lover",
    "category": "love",
    "id": 42892,
    "text": "Come live in my heart, and pay no rent."
  },
  {
    "author": "Michael Jackson",
    "category": "love",
    "id": 43421,
    "text": "Let us dream of tomorrow where we can truly love from the soul, and know love as the ultimate truth at the heart of all creation."
  },
  {
    "author": "Rainer Maria Rilke",
    "category": "love",
    "id": 43418,
    "text": "For one human being to love another that is perhaps the most difficult of all our tasks, the ultimate, the last test and proof, the work for which all other work is but preparation."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "love",
    "id": 43346,
    "text": "There is always some madness in love. But there is also always some reason in madness."
  },
  {
    "author": "Erich Segal",
    "category": "love",
    "id": 43513,
    "text": "True love comes quietly, without banners or flashing lights. If you hear bells, get your ears checked."
  },
  {
    "author": "Judith Viorst",
    "category": "love",
    "id": 43120,
    "text": "Love is much nicer to be in than an automobile accident, a tight girdle, a higher tax bracket or a holding pattern over Philadelphia."
  },
  {
    "author": "Julia Roberts",
    "category": "love",
    "id": 43731,
    "text": "True love doesn't come to you it has to be inside you."
  },
  {
    "author": "Bill Gates",
    "category": "love",
    "id": 43748,
    "text": "People everywhere love Windows."
  },
  {
    "author": "Nathaniel Hawthorne",
    "category": "love",
    "id": 43626,
    "text": "All brave men love for he only is brave who has affections to fight for, whether in the daily battle of life, or in physical contests."
  },
  {
    "author": "Lord Byron",
    "category": "love",
    "id": 42979,
    "text": "Absence - that common cure of love."
  },
  {
    "author": "Michael Jordan",
    "category": "love",
    "id": 43317,
    "text": "Even when I'm old and grey, I won't be able to play it, but I'll still love the game."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "love",
    "id": 43472,
    "text": "Don't forget to love yourself."
  },
  {
    "author": "Nikola Tesla",
    "category": "love",
    "id": 43608,
    "text": "I do not think there is any thrill that can go through the human heart like that felt by the inventor as he sees some creation of the brain unfolding to success... such emotions make a man forget food, sleep, friends, love, everything."
  },
  {
    "author": "Mignon McLaughlin",
    "category": "love",
    "id": 43071,
    "text": "No one has ever loved anyone the way everyone wants to be loved."
  },
  {
    "author": "Washington Irving",
    "category": "love",
    "id": 43310,
    "text": "Love is never lost. If not reciprocated, it will flow back and soften and purify the heart."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "love",
    "id": 43291,
    "text": "Where love is, there God is also."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "love",
    "id": 42922,
    "text": "True love is like ghosts, which everyone talks about and few have seen."
  },
  {
    "author": "Saint Augustine",
    "category": "love",
    "id": 43596,
    "text": "He that is jealous is not in love."
  },
  {
    "author": "Joseph Campbell",
    "category": "love",
    "id": 43339,
    "text": "When people get married because they think it's a long-time love affair, they'll be divorced very soon, because all love affairs end in disappointment. But marriage is a recognition of a spiritual identity."
  },
  {
    "author": "Ellen Key",
    "category": "love",
    "id": 43622,
    "text": "Love is moral even without legal marriage, but marriage is immoral without love."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "love",
    "id": 43360,
    "text": "There is not enough love and goodness in the world to permit giving any of it away to imaginary beings."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "love",
    "id": 43303,
    "text": "Man's nature is not essentially evil. Brute nature has been know to yield to the influence of love. You must never despair of human nature."
  },
  {
    "author": "Albert Einstein",
    "category": "love",
    "id": 43178,
    "text": "You can't blame gravity for falling in love."
  },
  {
    "author": "Anthony Hopkins",
    "category": "love",
    "id": 43769,
    "text": "Why love if losing hurts so much? I have no answers anymore only the life I have lived. The pain now is part of the happiness then."
  },
  {
    "author": "George Bernard Shaw",
    "category": "love",
    "id": 43442,
    "text": "Oh, the tiger will love you. There is no sincerer love than the love of food."
  },
  {
    "author": "Queen Elizabeth II",
    "category": "love",
    "id": 43593,
    "text": "Grief is the price we pay for love."
  },
  {
    "author": "Will Smith",
    "category": "love",
    "id": 43524,
    "text": "Love is the ultimate theme, but it's not just for women."
  },
  {
    "author": "Richard Bach",
    "category": "love",
    "id": 43575,
    "text": "True love stories never have endings."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "love",
    "id": 43309,
    "text": "Is it not enough to know the evil to shun it? If not, we should be sincere enough to admit that we love evil too well to give it up."
  },
  {
    "author": "Aldous Huxley",
    "category": "love",
    "id": 43779,
    "text": "The impulse to cruelty is, in many people, almost as violent as the impulse to sexual love - almost as violent and much more mischievous."
  },
  {
    "author": "Marilyn Monroe",
    "category": "love",
    "id": 43382,
    "text": "I love a natural look in pictures."
  },
  {
    "author": "Vincent Van Gogh",
    "category": "love",
    "id": 43631,
    "text": "The more I think about it, the more I realize there is nothing more artistic than to love others."
  },
  {
    "author": "Christopher Marlowe",
    "category": "love",
    "id": 43112,
    "text": "Who ever loved that loved not at first sight?"
  },
  {
    "author": "Mother Teresa",
    "category": "love",
    "id": 42896,
    "text": "The hunger for love is much more difficult to remove than the hunger for bread."
  },
  {
    "author": "Freddy Fender",
    "category": "love",
    "id": 43690,
    "text": "I'm a romantic, and we romantics are more sensitive to the way people feel. We love more, and we hurt more. When we're hurt, we hurt for a long time."
  },
  {
    "author": "Miguel de Unamuno",
    "category": "love",
    "id": 43061,
    "text": "Love is the child of illusion and the parent of disillusion."
  },
  {
    "author": "Albert Camus",
    "category": "love",
    "id": 43497,
    "text": "To abandon oneself to principles is really to die - and to die for an impossible love which is the contrary of love."
  },
  {
    "author": "Garrison Keillor",
    "category": "love",
    "id": 43538,
    "text": "Thank you, God, for this good life and forgive us if we do not love it enough."
  },
  {
    "author": "Francois Rabelais",
    "category": "love",
    "id": 43097,
    "text": "To good and true love fear is forever affixed."
  },
  {
    "author": "Mitt Romney",
    "category": "love",
    "id": 43604,
    "text": "My mom and dad gave their kids the greatest gift of all - the gift of unconditional love. They cared deeply about who we would be, and much less about what we would do."
  },
  {
    "author": "George Eliot",
    "category": "love",
    "id": 42908,
    "text": "I like not only to be loved, but also to be told I am loved."
  },
  {
    "author": "Arthur Conan Doyle",
    "category": "love",
    "id": 43270,
    "text": "We can't command our love, but we can our actions."
  },
  {
    "author": "Abraham Joshua Heschel",
    "category": "love",
    "id": 43848,
    "text": "A religious man is a person who holds God and man in one thought at one time, at all times, who suffers harm done to others, whose greatest passion is compassion, whose greatest strength is love and defiance of despair."
  },
  {
    "author": "William Dunbar",
    "category": "love",
    "id": 43132,
    "text": "All love is lost but upon God alone."
  },
  {
    "author": "Hans Urs von Balthasar",
    "category": "love",
    "id": 43852,
    "text": "Even if a unity of faith is not possible, a unity of love is."
  },
  {
    "author": "Barbara Pym",
    "category": "love",
    "id": 42970,
    "text": "How absurd and delicious it is to be in love with somebody younger than yourself. Everybody should try it."
  },
  {
    "author": "Bob Hope",
    "category": "love",
    "id": 43042,
    "text": "People who throw kisses are hopelessly lazy."
  },
  {
    "author": "Mae West",
    "category": "love",
    "id": 43397,
    "text": "A woman in love can't be reasonable - or she probably wouldn't be in love."
  },
  {
    "author": "Maya Angelou",
    "category": "love",
    "id": 43212,
    "text": "If we lose love and self respect for each other, this is how we finally die."
  },
  {
    "author": "Tammy Wynette",
    "category": "love",
    "id": 43050,
    "text": "Sometimes it's hard to be a woman giving all your love to just one man."
  },
  {
    "author": "Elbert Hubbard",
    "category": "love",
    "id": 43449,
    "text": "Love grows by giving. The love we give away is the only love we keep. The only way to retain love is to give it away."
  },
  {
    "author": "Henry David Thoreau",
    "category": "love",
    "id": 43354,
    "text": "Do what you love. Know your own bone gnaw at it, bury it, unearth it, and gnaw it still."
  },
  {
    "author": "Meir Kahane",
    "category": "love",
    "id": 43600,
    "text": "Love has its place, as does hate. Peace has its place, as does war. Mercy has its place, as do cruelty and revenge."
  },
  {
    "author": "Saint Augustine",
    "category": "love",
    "id": 43254,
    "text": "What does love look like? It has the hands to help others. It has the feet to hasten to the poor and needy. It has eyes to see misery and want. It has the ears to hear the sighs and sorrows of men. That is what love looks like."
  },
  {
    "author": "Jon Bon Jovi",
    "category": "love",
    "id": 43546,
    "text": "Believe in love. Believe in magic. Hell, believe in Santa Clause. Believe in others. Believe in yourself. Believe in your dreams. If you don't, who will?"
  },
  {
    "author": "Arthur Rubinstein",
    "category": "love",
    "id": 43357,
    "text": "I have found that if you love life, life will love you back."
  },
  {
    "author": "Mitt Romney",
    "category": "love",
    "id": 43548,
    "text": "I believe in an America where millions of Americans believe in an America that's the America millions of Americans believe in. That's the America I love."
  },
  {
    "author": "Antoine de Saint-Exupery",
    "category": "love",
    "id": 43242,
    "text": "Love does not consist in gazing at each other, but in looking outward together in the same direction."
  },
  {
    "author": "Miguel de Unamuno",
    "category": "love",
    "id": 42943,
    "text": "It is sad not to love, but it is much sadder not to be able to love."
  },
  {
    "author": "Satchel Paige",
    "category": "love",
    "id": 43396,
    "text": "Work like you don't need the money. Love like you've never been hurt. Dance like nobody's watching."
  },
  {
    "author": "Oscar Wilde",
    "category": "love",
    "id": 43295,
    "text": "When a man has once loved a woman he will do anything for her except continue to love her."
  },
  {
    "author": "Ray Bradbury",
    "category": "love",
    "id": 43629,
    "text": "Love is the answer to everything. It's the only reason to do anything. If you don't write stories you love, you'll never make it. If you don't write stories that other people love, you'll never make it."
  },
  {
    "author": "Henri Matisse",
    "category": "love",
    "id": 43072,
    "text": "He who loves, flies, runs, and rejoices he is free and nothing holds him back."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "love",
    "id": 43155,
    "text": "Man must evolve for all human conflict a method which rejects revenge, aggression and retaliation. The foundation of such a method is love."
  },
  {
    "author": "Robert Kiyosaki",
    "category": "love",
    "id": 43822,
    "text": "When people are lame, they love to blame."
  },
  {
    "author": "Mother Teresa",
    "category": "love",
    "id": 43141,
    "text": "Spread love everywhere you go. Let no one ever come to you without leaving happier."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "love",
    "id": 43161,
    "text": "Love is the only force capable of transforming an enemy into friend."
  },
  {
    "author": "David Wilkerson",
    "category": "love",
    "id": 43043,
    "text": "Love is not only something you feel, it is something you do."
  },
  {
    "author": "Honore de Balzac",
    "category": "love",
    "id": 42879,
    "text": "A woman knows the face of the man she loves as a sailor knows the open sea."
  }
]

quotes['marriage'] = [
  {
    "author": "Peter De Vries",
    "category": "marriage",
    "id": 43958,
    "text": "The bonds of matrimony are like any other bonds - they mature slowly."
  },
  {
    "author": "George Jessel",
    "category": "marriage",
    "id": 44011,
    "text": "The human brain starts working the moment you are born and never stops until you stand up to speak in public."
  },
  {
    "author": "Rick Perry",
    "category": "marriage",
    "id": 44166,
    "text": "Crucial to understanding federalism in modern day America is the concept of mobility, or 'the ability to vote with your feet.' If you don't support the death penalty and citizens packing a pistol - don't come to Texas. If you don't like medicinal marijuana and gay marriage, don't move to California."
  },
  {
    "author": "Carrie Underwood",
    "category": "marriage",
    "id": 44292,
    "text": "It's nice to know you have support. Last night I got a marriage proposal. I just laughed."
  },
  {
    "author": "Jean Giraudoux",
    "category": "marriage",
    "id": 43976,
    "text": "Faithful women are all alike, they think only of their fidelity, never of their husbands."
  },
  {
    "author": "Henry Louis Gates",
    "category": "marriage",
    "id": 44228,
    "text": "The sad truth is that the civil rights movement cannot be reborn until we identify the causes of black suffering, some of them self-inflicted. Why can't black leaders organize rallies around responsible sexuality, birth within marriage, parents reading to their children and students staying in school and doing homework?"
  },
  {
    "author": "Maggie Gallagher",
    "category": "marriage",
    "id": 44609,
    "text": "When a marriage culture fails, sexual desire no longer unites instead it fragments."
  },
  {
    "author": "Stockwell Day",
    "category": "marriage",
    "id": 44438,
    "text": "Our national media refuses to report that even the Supreme Court did not say marriage was a human right in all cases nor did it say that the heterosexual definition violated anyone's right or that the heterosexual definition of marriage was unconstitutional."
  },
  {
    "author": "Henny Youngman",
    "category": "marriage",
    "id": 44097,
    "text": "Some people ask the secret of our long marriage. We take time to go to a restaurant two times a week. A little candlelight, dinner, soft music and dancing. She goes Tuesdays, I go Fridays."
  },
  {
    "author": "Dan Savage",
    "category": "marriage",
    "id": 44334,
    "text": "Straight couples don't have to be monogamous to be married or married to be monogamous. Monogamy no more defines marriage than the presence of children does. Monogamy isn't compulsory and its absence doesn't invalidate a marriage."
  },
  {
    "author": "Anita Ekberg",
    "category": "marriage",
    "id": 44705,
    "text": "The most important thing for a good marriage is to learn how to argue peaceably."
  },
  {
    "author": "James Lafferty",
    "category": "marriage",
    "id": 44691,
    "text": "The whole Haley-Nathan marriage deal was a pretty good twist huh? I hope we got all of you with it. That particular story line even suprised me when I read it, it's a good one and it'll provide for some good stories to come."
  },
  {
    "author": "Stephen Leacock",
    "category": "marriage",
    "id": 44003,
    "text": "Many a man in love with a dimple makes the mistake of marrying the whole girl."
  },
  {
    "author": "Richard Armour",
    "category": "marriage",
    "id": 44123,
    "text": "Children are supposed to help hold a marriage together. They do this in a number of ways. For instance, they demand so much attention that a husband and wife, concentrating on their children, fail to notice each other's faults."
  },
  {
    "author": "Tamae Watanabe",
    "category": "marriage",
    "id": 44834,
    "text": "The reason for not getting married was that I just didn't have a partner to get married to. Climbing mountains was more attractive to me than marriage, or other fun things like that."
  },
  {
    "author": "Bette Davis",
    "category": "marriage",
    "id": 44124,
    "text": "An affair now and then is good for a marriage. It adds spice, stops it from getting boring... I ought to know."
  },
  {
    "author": "Judy Biggert",
    "category": "marriage",
    "id": 44390,
    "text": "No Congress ever has seen fit to amend the Constitution to address any issue related to marriage. No Constitutional Amendment was needed to ban polygamy or bigamy, nor was a Constitutional Amendment needed to set a uniform age of majority to ban child marriages."
  },
  {
    "author": "Bill Cosby",
    "category": "marriage",
    "id": 43882,
    "text": "Let us now set forth one of the fundamental truths about marriage: the wife is in charge."
  },
  {
    "author": "Ali Larter",
    "category": "marriage",
    "id": 44704,
    "text": "But to sustain a marriage for 50 years, you have to get real a little bit and find someone who is understanding and who you can grow with. My mom always says, 'Marry the man who loves you a millimeter more.'"
  },
  {
    "author": "Teri Garr",
    "category": "marriage",
    "id": 44539,
    "text": "I refused David Letterman's proposal of marriage for obvious reasons, but thanks for asking."
  },
  {
    "author": "Pope Benedict XVI",
    "category": "marriage",
    "id": 44246,
    "text": "We must have great respect for these people who also suffer and who want to find their own way of correct living. On the other hand, to create a legal form of a kind of homosexual marriage, in reality, does not help these people."
  },
  {
    "author": "Bono",
    "category": "marriage",
    "id": 44245,
    "text": "Marriage is this grand madness, and I think if people knew that, they would perhaps take it more seriously."
  },
  {
    "author": "Sam Ewing",
    "category": "marriage",
    "id": 44354,
    "text": "Nobody ever asks a father how he manages to combine marriage and a career."
  },
  {
    "author": "Mary McCormack",
    "category": "marriage",
    "id": 44823,
    "text": "I've done an informal, anecdotal survey about marriage, and I've found no evidence that it brings happiness."
  },
  {
    "author": "Barbra Streisand",
    "category": "marriage",
    "id": 43927,
    "text": "Why does a woman work ten years to change a man's habits and then complain that he's not the man she married?"
  },
  {
    "author": "Gene Robinson",
    "category": "marriage",
    "id": 44699,
    "text": "Stability is why society has an interest in marriage."
  },
  {
    "author": "Jennifer Garner",
    "category": "marriage",
    "id": 44398,
    "text": "I don't have this fantasy about marriage anymore. Everyone says it takes hard work. Well, it kind of does - and I'm much more pragmatic about romance than I used to be."
  },
  {
    "author": "Simone Signoret",
    "category": "marriage",
    "id": 44131,
    "text": "Chains do not hold a marriage together. It is threads, hundreds of tiny threads, which sew people together through the years."
  },
  {
    "author": "Jack Kingston",
    "category": "marriage",
    "id": 44595,
    "text": "Marriage cannot be severed from its cultural, religious and natural roots without weakening the good influence of society."
  },
  {
    "author": "Kate Adie",
    "category": "marriage",
    "id": 44473,
    "text": "I was sent to a nice Church of England girls' school and at that time, after university, a woman was expected to become a teacher, a nurse or a missionary - prior to marriage."
  },
  {
    "author": "Al Goldstein",
    "category": "marriage",
    "id": 44513,
    "text": "The only way marriage can work is if a man respects the woman and she is a thinking woman and he wants to work on the marriage."
  },
  {
    "author": "Benjamin Carson",
    "category": "marriage",
    "id": 44294,
    "text": "Marriage is a very sacred institution and should not be degraded by allowing every other type of relationship to be made equivalent to it."
  },
  {
    "author": "Rita Rudner",
    "category": "marriage",
    "id": 43930,
    "text": "Men who have a pierced ear are better prepared for marriage - they've experienced pain and bought jewelry."
  },
  {
    "author": "Catherine Deneuve",
    "category": "marriage",
    "id": 44236,
    "text": "Marriage is obsolete and a trap."
  },
  {
    "author": "Mary Wesley",
    "category": "marriage",
    "id": 44369,
    "text": "People try much less hard to make a marriage work than they used to fifty years ago. Divorce is easier."
  },
  {
    "author": "Samuel Butler",
    "category": "marriage",
    "id": 44134,
    "text": "Marriage is distinctly and repeatedly excluded from heaven. Is this because it is thought likely to mar the general felicity?"
  },
  {
    "author": "Michael Cunningham",
    "category": "marriage",
    "id": 44747,
    "text": "I have no useful theories about love and marriage."
  },
  {
    "author": "Moliere",
    "category": "marriage",
    "id": 43953,
    "text": "Love is often the fruit of marriage."
  },
  {
    "author": "Emma Goldman",
    "category": "marriage",
    "id": 43980,
    "text": "On rare occasions one does hear of a miraculous case of a married couple falling in love after marriage, but on close examination it will be found that it is a mere adjustment to the inevitable."
  },
  {
    "author": "Jamie Lee Curtis",
    "category": "marriage",
    "id": 44554,
    "text": "My mother and stepfather were married 43 years, so I have watched a long marriage. I feel like I had a very good role model for that. And, you know, it's just a number."
  },
  {
    "author": "Joseph Joubert",
    "category": "marriage",
    "id": 43959,
    "text": "Only choose in marriage a man whom you would choose as a friend if he were a woman."
  },
  {
    "author": "Cher",
    "category": "marriage",
    "id": 44290,
    "text": "To me marriage is for five or ten years."
  },
  {
    "author": "Lynn Redgrave",
    "category": "marriage",
    "id": 44452,
    "text": "There were times after my marriage ended where, you know, I really felt like I was at the bottom of a mountain, there was a great big, fog up there, and I'm never going to cross to the other side."
  },
  {
    "author": "Nick Cave",
    "category": "marriage",
    "id": 44300,
    "text": "Getting married, for me, was the best thing I ever did. I was suddenly beset with an immense sense of release, that we have something more important than our separate selves, and that is the marriage. There's immense happiness that can come from working towards that."
  },
  {
    "author": "Michelle Williams",
    "category": "marriage",
    "id": 44446,
    "text": "I don't know what my version of a relationship or marriage is yet, because the typical model seems a little broken to me."
  },
  {
    "author": "Pearl S. Buck",
    "category": "marriage",
    "id": 44298,
    "text": "Nothing in life is as good as the marriage of true minds between man and woman. As good? It is life itself."
  },
  {
    "author": "George W. Bush",
    "category": "marriage",
    "id": 44162,
    "text": "I believe a marriage is between a man and a woman."
  },
  {
    "author": "David Limbaugh",
    "category": "marriage",
    "id": 44633,
    "text": "Obama's position on marriage is brazenly cynical."
  },
  {
    "author": "Reese Witherspoon",
    "category": "marriage",
    "id": 43918,
    "text": "I think women are natural caretakers. They take care of everybody. They take care of their husbands and their kids and their dogs, and don't spend a lot of time just getting back and taking time out."
  },
  {
    "author": "Princess Diana",
    "category": "marriage",
    "id": 44144,
    "text": "I think like any marriage, especially when you've had divorced parents like myself you want to try even harder to make it work."
  },
  {
    "author": "John Updike",
    "category": "marriage",
    "id": 44328,
    "text": "The first breath of adultery is the freest after it, constraints aping marriage develop."
  },
  {
    "author": "Joseph Ratzinger",
    "category": "marriage",
    "id": 44478,
    "text": "Above all, we must have great respect for these people who also suffer and who want to find their own way of correct living. On the other hand, to create a legal form of a kind of homosexual marriage, in reality, does not help these people."
  },
  {
    "author": "Jim Bunning",
    "category": "marriage",
    "id": 44818,
    "text": "The activists will not stop in trying to impose their extreme views on the rest of us, and they have now plotted out a state-by-state strategy to increase the number of judicial decisions redefining marriage without the voice of the people being heard."
  },
  {
    "author": "Kinky Friedman",
    "category": "marriage",
    "id": 44045,
    "text": "I support gay marriage. I believe they have a right to be as miserable as the rest of us."
  },
  {
    "author": "Chris Kyle",
    "category": "marriage",
    "id": 44708,
    "text": "You're not just going out there, maybe sacrificing your own life. There's also sacrifices still going on at home. You can serve in the military and have a good marriage, but you just need to be aware of it so you can take those steps to take care of it."
  },
  {
    "author": "Michael J. Fox",
    "category": "marriage",
    "id": 44150,
    "text": "But the key to our marriage is the capacity to give each other a break. And to realize that it's not how our similarities work together it's how our differences work together."
  },
  {
    "author": "Elvis Presley",
    "category": "marriage",
    "id": 43984,
    "text": "When I get married, it'll be no secret."
  },
  {
    "author": "Henny Youngman",
    "category": "marriage",
    "id": 43874,
    "text": "Do you know what it means to come home at night to a woman who'll give you a little love, a little affection, a little tenderness? It means you're in the wrong house, that's what it means."
  },
  {
    "author": "Franz Kafka",
    "category": "marriage",
    "id": 44196,
    "text": "Woman, or more precisely put, perhaps, marriage, is the representative of life with which you are meant to come to terms."
  },
  {
    "author": "Euripides",
    "category": "marriage",
    "id": 43920,
    "text": "It's not beauty but fine qualities, my girl, that keep a husband."
  },
  {
    "author": "Adam Rickitt",
    "category": "marriage",
    "id": 44720,
    "text": "I think church and state should remain entirely separate at all costs, and that the decision of religious marriage should be of each faith to debate and decide free of political influence."
  },
  {
    "author": "Gerrit Smith",
    "category": "marriage",
    "id": 44579,
    "text": "The Southern slave would obey God in respect to marriage, and also to the reading and studying of His word. But this, as we have seen, is forbidden him."
  },
  {
    "author": "Rob Brydon",
    "category": "marriage",
    "id": 44811,
    "text": "The thing is, when I had my first success it did coincide with the end of my first marriage, and because I went on to have a very, very unhappy two years, I don't think I equate career success with personal happiness."
  },
  {
    "author": "Anthony Holden",
    "category": "marriage",
    "id": 44555,
    "text": "I decided he'd changed so much that a whole new book was required and that book actually I can say so was the first to say that the marriage was in trouble and the Prince didn't like at all and my book was being serialized in the Sunday Times over five weeks."
  },
  {
    "author": "Woody Allen",
    "category": "marriage",
    "id": 44096,
    "text": "Marriage is the death of hope."
  },
  {
    "author": "Karl Pilkington",
    "category": "marriage",
    "id": 44636,
    "text": "To be honest, marriage doesn't scare me and that, it's just once you've been together for so long, if you haven't got any kids it's just a big expensive day out for everyone else to enjoy, isn't it?"
  },
  {
    "author": "Lindsay Lohan",
    "category": "marriage",
    "id": 44312,
    "text": "Marriage is a big deal, but who's to say I'm not going to pull a Vegas and get married to see what it's like for a minute?"
  },
  {
    "author": "Joey Adams",
    "category": "marriage",
    "id": 44120,
    "text": "Marriage is give and take. You'd better give it to her or she'll take it anyway."
  },
  {
    "author": "Herbert Spencer",
    "category": "marriage",
    "id": 43971,
    "text": "Marriage: A word which should be pronounced 'mirage'."
  },
  {
    "author": "Helen Gahagan",
    "category": "marriage",
    "id": 44002,
    "text": "When a marriage works, nothing on earth can take its place."
  },
  {
    "author": "Ellie Goulding",
    "category": "marriage",
    "id": 44333,
    "text": "The only day I remember of my parents' marriage was the day my dad walked out. As I stood there at five years old, with my older sister and younger brother, I knew that he was gone."
  },
  {
    "author": "Dick Morris",
    "category": "marriage",
    "id": 44757,
    "text": "No candidate can win a presidential race advocating gay marriage and opposing the military action in Iraq."
  },
  {
    "author": "Nadia Comaneci",
    "category": "marriage",
    "id": 44749,
    "text": "My marriage to my husband, Bart Conner in 1996 is my proudest personal moment."
  },
  {
    "author": "Washington Irving",
    "category": "marriage",
    "id": 44171,
    "text": "Marriage is the torment of one, the felicity of two, the strife and enmity of three."
  },
  {
    "author": "James Brolin",
    "category": "marriage",
    "id": 44815,
    "text": "The fact is, I am in my third marriage and I do not believe in divorce. But I was half the problem, I guarantee you. More than half the problem. I couldn't negotiate with the other women."
  },
  {
    "author": "Michel de Montaigne",
    "category": "marriage",
    "id": 43858,
    "text": "A good marriage would be between a blind wife and a deaf husband."
  },
  {
    "author": "Steven Curtis Chapman",
    "category": "marriage",
    "id": 44014,
    "text": "There's nothing like a good cheating song to make me want to run home to be with my wife."
  },
  {
    "author": "John Krasinski",
    "category": "marriage",
    "id": 44716,
    "text": "I know I'm guilty of and I think a lot of people are guilty of sort of getting starry-eyed with love and sort of looking over the bad things and keep going and you don't really prepare for how much work marriage really is."
  },
  {
    "author": "David Steinberg",
    "category": "marriage",
    "id": 44698,
    "text": "I used to have a theory actually that, if you've had a good childhood, a good marriage and a little bit of money in the bank, you're going to make a lousy comedian."
  },
  {
    "author": "Colin Chapman",
    "category": "marriage",
    "id": 44157,
    "text": "The secret of a successful marriage is not to be at home too much."
  },
  {
    "author": "George Will",
    "category": "marriage",
    "id": 44474,
    "text": "Well, you know, the definition of second marriage is the triumph of hope over experience."
  },
  {
    "author": "Jesse Tyler Ferguson",
    "category": "marriage",
    "id": 44734,
    "text": "The definition of marriage cannot be disputed. It's right there in black and white and it's been the same since the start of Wikipedia."
  },
  {
    "author": "Camille Paglia",
    "category": "marriage",
    "id": 44209,
    "text": "Now that virtually every career is an option for ambitious girls, it can no longer be considered regressive or reactionary to reintroduce discussion of marriage and motherhood to primary education. We certainly do not want to return to the simplistic duality of home economics classes for girls and wood shop for boys."
  },
  {
    "author": "Gary Bauer",
    "category": "marriage",
    "id": 44498,
    "text": "Independence doesn't - doesn't equate to moderates. Millions of independents are pro-life. Millions of independents believe marriage is between a man and a woman."
  },
  {
    "author": "Jack Kingston",
    "category": "marriage",
    "id": 44593,
    "text": "But whether a couple is a man and a woman has everything to do with the meaning of marriage."
  },
  {
    "author": "Raquel Welch",
    "category": "marriage",
    "id": 44642,
    "text": "We all have a childhood dream that when there is love, everything goes like silk, but the reality is that marriage requires a lot of compromise."
  },
  {
    "author": "Barbara Ehrenreich",
    "category": "marriage",
    "id": 44226,
    "text": "Marriage is socialism among two people."
  },
  {
    "author": "Elbert Hubbard",
    "category": "marriage",
    "id": 43893,
    "text": "Never get married in college it's hard to get a start if a prospective employer finds you've already made one mistake."
  },
  {
    "author": "Zoe Lister-Jones",
    "category": "marriage",
    "id": 44737,
    "text": "We are very puritan in America. We still hold true to these really antiquated values, this idea of the sanctity of marriage."
  },
  {
    "author": "Lisa Bonet",
    "category": "marriage",
    "id": 44565,
    "text": "My mother, brave woman, lost her whole family when she decided to marry a black man in the '60s. When the marriage fell apart, she had to come back to her family."
  },
  {
    "author": "Mitt Romney",
    "category": "marriage",
    "id": 44084,
    "text": "Like me, the great majority of Americans wish both to preserve the traditional definition of marriage and to oppose bias and intolerance directed towards gays and lesbians."
  },
  {
    "author": "Rick Santorum",
    "category": "marriage",
    "id": 44459,
    "text": "I'm always told that what I say is controversial. Why is it controversial? Because I speak from a tradition that has now fallen out of favor with the dominant media in this country. And so when I say things like marriage should be between one man and one woman, I'm called a bigot."
  },
  {
    "author": "Arsenio Hall",
    "category": "marriage",
    "id": 44762,
    "text": "I love being in a relationship, but marriage isn't for me."
  },
  {
    "author": "Anna Benson",
    "category": "marriage",
    "id": 44206,
    "text": "But marriage goes in waves. You've got to be patient. People bail and give up on their marriages way too early. They just don't put the work and the effort into it. You've got to suck up your ego a lot of times, because that can be a big downfall."
  },
  {
    "author": "Mark Udall",
    "category": "marriage",
    "id": 44598,
    "text": "I support allowing gay couples to marry because of - not in spite of - my values. And many of those values are the same ones deeply held by those who do not believe in gay marriage."
  },
  {
    "author": "Dalton Trumbo",
    "category": "marriage",
    "id": 44776,
    "text": "A good businessman never makes a contract unless he's sure he can carry it through, yet every fool on earth is perfectly willing to sign a marriage contract without considering whether he can live up to it or not."
  },
  {
    "author": "Gary Numan",
    "category": "marriage",
    "id": 44396,
    "text": "I am very old-fashioned about marriage. It is for life and I mean it. I always knew that when I met the right girl, the life I had before - being single, in a band, girls everywhere - would be over."
  },
  {
    "author": "James Carville",
    "category": "marriage",
    "id": 44204,
    "text": "I was against gay marriage until I realized I didn't have to get one."
  },
  {
    "author": "Keith O'Brien",
    "category": "marriage",
    "id": 44729,
    "text": "Clearly, if it is sensible to hold a referendum on independence, it is crucial that we have one on marriage. It is the only way the country can move forward on this issue. Let all those who have a view on this subject place their trust in the Scottish people and let Scotland decide."
  },
  {
    "author": "Brendan Behan",
    "category": "marriage",
    "id": 43916,
    "text": "The big difference between sex for money and sex for free is that sex for money usually costs a lot less."
  }
]

quotes['medical'] = [
  {
    "author": "Ashley Montagu",
    "category": "medical",
    "id": 44947,
    "text": "One goes through school, college, medical school and one's internship learning little or nothing about goodness but a good deal about success."
  },
  {
    "author": "Chris Christie",
    "category": "medical",
    "id": 44924,
    "text": "A retired teacher paid $62,000 towards her pension and nothing, yes nothing, for full family medical, dental and vision coverage over her entire career. What will we pay her? $1.4 million in pension benefits and another $215,000 in health care benefit premiums over her lifetime."
  },
  {
    "author": "Dianne Feinstein",
    "category": "medical",
    "id": 44976,
    "text": "I basically believe the medical insurance industry should be nonprofit, not profit-making. There is no way a health reform plan will work when it is implemented by an industry that seeks to return money to shareholders instead of using that money to provide health care."
  },
  {
    "author": "Roger Wicker",
    "category": "medical",
    "id": 45088,
    "text": "It is false to suggest that medical breakthroughs come only through government research."
  },
  {
    "author": "Peter Lewis Allen",
    "category": "medical",
    "id": 45135,
    "text": "Was this an old disease, and, if so, which one? If it was new, what did that say about the state of medical knowledge? And in any case, how could physicians make sense of it?"
  },
  {
    "author": "Nicolas Cage",
    "category": "medical",
    "id": 44876,
    "text": "I was always shocked when I went to the doctor's office and they did my X-ray and didn't find that I had eight more ribs than I should have or that my blood was the color green."
  },
  {
    "author": "Bill Hicks",
    "category": "medical",
    "id": 44911,
    "text": "If you're so pro-life, do me a favour: don't lock arms and block medical clinics. If you're so pro-life, lock arms and block cemeteries."
  },
  {
    "author": "Chester Brown",
    "category": "medical",
    "id": 45026,
    "text": "That's the thing. in medicine, you're used to saying there's a problem within the person, and saying there's a problem within the culture, that's not a medical answer. Medicine has to look in one direction, so there's only one type of answer that they can find."
  },
  {
    "author": "David M. Brown",
    "category": "medical",
    "id": 45143,
    "text": "As a physician and as a pilot, I think it lets me be a pretty good translator having one foot in the medical world and one foot in the flying world. Sometimes when the medical guys come in and speak medical stuff to the pilots, the pilots really don't know what they're saying."
  },
  {
    "author": "Peter Shaffer",
    "category": "medical",
    "id": 44894,
    "text": "Passion, you see, can be destroyed by a doctor. It cannot be created."
  },
  {
    "author": "Jan Schakowsky",
    "category": "medical",
    "id": 45021,
    "text": "Community health centers do a great deal with limited resources. They provide critical medical care services to many who would otherwise have no other place to go or would end up in an emergency room."
  },
  {
    "author": "David Suzuki",
    "category": "medical",
    "id": 44925,
    "text": "The medical literature tells us that the most effective ways to reduce the risk of heart disease, cancer, stroke, diabetes, Alzheimer's, and many more problems are through healthy diet and exercise. Our bodies have evolved to move, yet we now use the energy in oil instead of muscles to do our work."
  },
  {
    "author": "Timothy Murphy",
    "category": "medical",
    "id": 45050,
    "text": "If one of us, any of us, any American is traveling in a town somewhere in America and a medical crisis hits them, for someone who is diabetic or perhaps has heart disease or some other problems, where do we get the records to determine what to do?"
  },
  {
    "author": "Andrew Weil",
    "category": "medical",
    "id": 44952,
    "text": "Citizens must pressure the American Hospital Association, the American Public Health Association, the Centers for Disease Control and other relevant governmental agencies to make greening our hospitals and medical centers a top priority so that they themselves don't create even more illness."
  },
  {
    "author": "Ralph Merkle",
    "category": "medical",
    "id": 44941,
    "text": "If we can reduce the cost and improve the quality of medical technology through advances in nanotechnology, we can more widely address the medical conditions that are prevalent and reduce the level of human suffering."
  },
  {
    "author": "Kenneth Joseph Arrow",
    "category": "medical",
    "id": 45141,
    "text": "In 1963 and later papers, I pointed out that the special market characteristics of medical care and medical insurance could be explained by reference to differences in information among the parties involved."
  },
  {
    "author": "Stanislav Grof",
    "category": "medical",
    "id": 44951,
    "text": "I read Freud's Introductory Lectures in Psychoanalysis in basically one sitting. I decided to enroll in medical school. It was almost like a conversion experience."
  },
  {
    "author": "Jenny McCarthy",
    "category": "medical",
    "id": 44929,
    "text": "Information on how to heal autism and how to possibly delay vaccines or prevent autism shouldn't come from me. It should come from the medical establishment."
  },
  {
    "author": "Tulsi Gabbard",
    "category": "medical",
    "id": 45104,
    "text": "I am a military police officer and I have served on two deployments my first was to Iraq, in a medical unit, and my second deployment was to Kuwait, as a military police platoon leader."
  },
  {
    "author": "Ralph Merkle",
    "category": "medical",
    "id": 45010,
    "text": "Today we see a human population of over 6 billion people, many of whom have serious medical conditions, which either can't be treated or cannot be treated economically."
  },
  {
    "author": "Tim Murphy",
    "category": "medical",
    "id": 45074,
    "text": "However, many skilled medical volunteers are turned away because community health centers cannot afford to cover their additional medical liability insurance."
  },
  {
    "author": "Lewis Thomas",
    "category": "medical",
    "id": 44874,
    "text": "The great secret of doctors, known only to their wives, but still hidden from the public, is that most things get better by themselves most things, in fact, are better in the morning."
  },
  {
    "author": "Anton Chekhov",
    "category": "medical",
    "id": 44856,
    "text": "Medicine is my lawful wife and literature my mistress when I get tired of one, I spend the night with the other."
  },
  {
    "author": "John Sununu",
    "category": "medical",
    "id": 44945,
    "text": "It worries me about our unwillingness to really address reforms and modernization in Medicare. This thing was designed 37 years ago. It has not evolved to keep pace with current medical technology."
  },
  {
    "author": "David Gest",
    "category": "medical",
    "id": 45011,
    "text": "I can help a lot of other people who've gone through the same thing by building a center that will help men and women who don't have the funds to take care of themselves and get the medical treatment."
  },
  {
    "author": "Steven Van Zandt",
    "category": "medical",
    "id": 45063,
    "text": "C-17s should be ready to go at various military bases around the world packed with water, food, medical supplies, sleeping bags and tents, all prepared to be air dropped in alongside soldiers and doctors to begin relief efforts."
  },
  {
    "author": "Alex Chiu",
    "category": "medical",
    "id": 45025,
    "text": "Immortality Device has been tested and researched by medical researchers all over the world from time to time. They email me and told me what they found. I post their results sometimes on my site."
  },
  {
    "author": "Mary Stuart Masterson",
    "category": "medical",
    "id": 45084,
    "text": "The fact that he didn't get credit for a while is more the story of social injustice. But his own spirit wasn't driven by that, and wasn't dependent upon that. He just wished he had the cash to go to medical school."
  },
  {
    "author": "Marcel Proust",
    "category": "medical",
    "id": 44863,
    "text": "Three-quarters of the sicknesses of intelligent people come from their intelligence. They need at least a doctor who can understand this sickness."
  },
  {
    "author": "Katherine Dunn",
    "category": "medical",
    "id": 45032,
    "text": "Prior to penicillin and medical research, death was an everyday occurrence. It was intimate."
  },
  {
    "author": "Marc Garneau",
    "category": "medical",
    "id": 45089,
    "text": "The space industry is developing and delivering benefits that tie into our immediate needs and priorities here on Earth-for example, medical and materials research, and satellite communications."
  },
  {
    "author": "Erma Bombeck",
    "category": "medical",
    "id": 44853,
    "text": "Never go to a doctor whose office plants have died."
  },
  {
    "author": "Tim Berners-Lee",
    "category": "medical",
    "id": 44972,
    "text": "The Google algorithm was a significant development. I've had thank-you emails from people whose lives have been saved by information on a medical website or who have found the love of their life on a dating website."
  },
  {
    "author": "Alice Hamilton",
    "category": "medical",
    "id": 45109,
    "text": "Every article I wrote in those days, every speech I made, is full of pleading for the recognition of lead poisoning as a real and serious medical problem."
  },
  {
    "author": "Doug Ose",
    "category": "medical",
    "id": 45114,
    "text": "Drug abuse is a medical disease that requires medical professionals."
  },
  {
    "author": "Ken Wilber",
    "category": "medical",
    "id": 45133,
    "text": "I went to Duke University in the medical track. And then I decided I wanted to do something more creative, so I switched to biochemistry at Nebraska."
  },
  {
    "author": "Barbara Boxer",
    "category": "medical",
    "id": 44968,
    "text": "We have the greatest hospitals, doctors, and medical technology in the world - we need to make them accessible to every American."
  },
  {
    "author": "James H. Boren",
    "category": "medical",
    "id": 44899,
    "text": "I got the bill for my surgery. Now I know what those doctors were wearing masks for."
  },
  {
    "author": "Garry Trudeau",
    "category": "medical",
    "id": 44992,
    "text": "Medical decisions have been politicized. What doctor wants a state legislator in his consulting room?"
  },
  {
    "author": "Abbie Hoffman",
    "category": "medical",
    "id": 45098,
    "text": "Understand that legal and illegal are political, and often arbitrary, categorizations use and abuse are medical, or clinical, distinctions."
  },
  {
    "author": "Samuel Wilson",
    "category": "medical",
    "id": 45077,
    "text": "I completed medical school at Loma Linda University School of Medicine in 1984."
  },
  {
    "author": "Zach Wamp",
    "category": "medical",
    "id": 45033,
    "text": "Failure to properly control our borders costs citizens in many ways: schools become overcrowded, medical resources are stretched too thin, other government services are overtaxed, and taxes increase further."
  },
  {
    "author": "Les Aspin",
    "category": "medical",
    "id": 45138,
    "text": "We ought to be providing protective sanctuaries for the Kurdish rebels. That means finding some places where they can come and to which we will then be able to provide food and water and medical help."
  },
  {
    "author": "Ovid",
    "category": "medical",
    "id": 44875,
    "text": "Medicine sometimes snatches away health, sometimes gives it."
  },
  {
    "author": "Norman Cousins",
    "category": "medical",
    "id": 44884,
    "text": "It is reasonable to expect the doctor to recognize that science may not have all the answers to problems of health and healing."
  },
  {
    "author": "Roberto Duran",
    "category": "medical",
    "id": 45086,
    "text": "If I had the medical clearance to fight, I would want to fight the best. The best would be Mayweather."
  },
  {
    "author": "Anita Baker",
    "category": "medical",
    "id": 44916,
    "text": "Completeness? Happiness? These words don't come close to describing my emotions. There truly is nothing I can say to capture what motherhood means to me, particularly given my medical history."
  },
  {
    "author": "Tabare Vazquez",
    "category": "medical",
    "id": 45139,
    "text": "Because of my medical and ideological training, I am accustomed to saying that life is adaptation and symbiosis."
  },
  {
    "author": "David Bohm",
    "category": "medical",
    "id": 44989,
    "text": "Yet it looks as if the thing we use to solve our problems with is the source of our problems. It's like going to the doctor and having him make you ill. In fact, in 20% of medical cases we do apparently have that going on. But in the case of thought, its far over 20%."
  },
  {
    "author": "John Paul Stevens",
    "category": "medical",
    "id": 45131,
    "text": "To make a coverage decision, doesn't one have to make a medical judgment?"
  },
  {
    "author": "Lincoln Chafee",
    "category": "medical",
    "id": 45069,
    "text": "Reform of the medical liability system should be considered as part of a comprehensive response to surging medical malpractice premiums that endanger Americans' access to quality medical care."
  },
  {
    "author": "Leonard Alfred George Strong",
    "category": "medical",
    "id": 45144,
    "text": "I broke down while at Oxford, was rejected by a record number of medical tribunals during the War, and finally got permission to leave Oxford and do civilian work till the War ended."
  },
  {
    "author": "Mary Stuart Masterson",
    "category": "medical",
    "id": 45085,
    "text": "I'd like to think Helen very much understood what it was to be disadvantaged in the medical field. And that that was something that she never let dictate her choices."
  },
  {
    "author": "William Westmoreland",
    "category": "medical",
    "id": 45002,
    "text": "When I took command in Vietnam, I gave great emphasis to food and medical care - and to the mail."
  },
  {
    "author": "Paul Farmer",
    "category": "medical",
    "id": 44949,
    "text": "It is clear that the pharmaceutical industry is not, by any stretch of the imagination, doing enough to ensure that the poor have access to adequate medical care."
  },
  {
    "author": "Jack Irons",
    "category": "medical",
    "id": 45094,
    "text": "After wrestling with myself for six months, I began medical treatment. During that time I started a band with some friends of mine called Jack's Car, but that didn't last."
  },
  {
    "author": "Paz de la Huerta",
    "category": "medical",
    "id": 45070,
    "text": "I unfortunately had a lot of medical procedures throughout my life, so I decided to paint all of my surgeries as a way to heal and as a way to grow."
  },
  {
    "author": "Barbara Mikulski",
    "category": "medical",
    "id": 44898,
    "text": "A pregnant woman facing the most dire circumstances must be able to count on her doctor to do what is medically necessary to protect her from serious physical harm."
  },
  {
    "author": "Nana Mouskouri",
    "category": "medical",
    "id": 45005,
    "text": "For my convalescence, I had to exercise my voice only with vowels. It is a medical rule after a long loss of voice."
  },
  {
    "author": "Ben Quayle",
    "category": "medical",
    "id": 45095,
    "text": "I welcome the President and working with him to try to get some of that medical malpractice reform so we can get the cost of health care to come down."
  },
  {
    "author": "Paul Farmer",
    "category": "medical",
    "id": 44931,
    "text": "Civil and political rights are critical, but not often the real problem for the destitute sick. My patients in Haiti can now vote but they can't get medical care or clean water."
  },
  {
    "author": "Tipper Gore",
    "category": "medical",
    "id": 45107,
    "text": "Eating disorders can have serious medical and psychological consequences which, left unchecked, can kill. Parents should address this issue and ask their children to discuss how they feel about themselves."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "medical",
    "id": 44905,
    "text": "If you want total security, go to prison. There you're fed, clothed, given medical care and so on. The only thing lacking... is freedom."
  },
  {
    "author": "Brad Henry",
    "category": "medical",
    "id": 44919,
    "text": "No one should have to choose between medicine and other necessities. No one should have to use the emergency room every time a child gets sick. And no one should have to live in constant fear that a medical problem will become a financial crisis."
  },
  {
    "author": "Bill Nelson",
    "category": "medical",
    "id": 45115,
    "text": "Americans of all ages deserve quality end-of-life medical care."
  },
  {
    "author": "Henny Youngman",
    "category": "medical",
    "id": 44873,
    "text": "When I told my doctor I couldn't afford an operation, he offered to touch-up my X-rays."
  },
  {
    "author": "John Cameron",
    "category": "medical",
    "id": 45043,
    "text": "When I entered medical physics in 1958 there were fewer than 100 in the U.S. and I could see many opportunities to apply my knowledge of nuclear physics."
  },
  {
    "author": "Michael J. Fox",
    "category": "medical",
    "id": 44920,
    "text": "Medical science has proven time and again that when the resources are provided, great progress in the treatment, cure, and prevention of disease can occur."
  },
  {
    "author": "P. G. Wodehouse",
    "category": "medical",
    "id": 44970,
    "text": "It was my Uncle George who discovered that alcohol was a food well in advance of modern medical thought."
  },
  {
    "author": "Carl Levin",
    "category": "medical",
    "id": 45061,
    "text": "Even top caliber hospitals cannot escape medical mistakes that sometimes result in irreparable damage to patients."
  },
  {
    "author": "Groucho Marx",
    "category": "medical",
    "id": 44851,
    "text": "I'm not feeling very well - I need a doctor immediately. Ring the nearest golf course."
  },
  {
    "author": "Nicole Kidman",
    "category": "medical",
    "id": 44927,
    "text": "Stay out of the sun, because it is the worst thing in terms of aging. I'm very medical. I come from a medical family."
  },
  {
    "author": "Gerald Griffin",
    "category": "medical",
    "id": 45145,
    "text": "I found out that colonels can stay until they drop dead or get a walker and being a critical medical specialty as an Army trained emergency room doctor, I could stay until age 67."
  },
  {
    "author": "Christopher Shays",
    "category": "medical",
    "id": 45101,
    "text": "Yes, there is a story about Agent Orange, and we knew that it harmed our troops and we knew how long it was to get the medical community to accept that, the military to accept it, the VA to accept it."
  },
  {
    "author": "Marlo Thomas",
    "category": "medical",
    "id": 44973,
    "text": "Today, all patients accepted for treatment at St. Jude's are treated without regard for the family's ability to pay. Everything beyond what is covered by insurance is taken care of, and for those without insurance, all of the medical costs are absorbed by the hospital."
  },
  {
    "author": "Lewis Thomas",
    "category": "medical",
    "id": 44943,
    "text": "Medical knowledge and technical savvy are biodegradable. The sort of medicine that was practiced in Boston or New York or Atlanta fifty years ago would be as strange to a medical student or intern today as the ceremonial dance of a !Kung San tribe would seem to a rock festival audience in Hackensack."
  },
  {
    "author": "Eli Wallach",
    "category": "medical",
    "id": 44995,
    "text": "I'd come out of the army after five years as a medic. I was a medical administrator and we ran hospitals, and I was a Captain in the army at the end, in 1945."
  },
  {
    "author": "Alex Chiu",
    "category": "medical",
    "id": 45024,
    "text": "Oh there are lots of doctors and medical professionals out there who buy my devices at whole sale price."
  },
  {
    "author": "Bill Maher",
    "category": "medical",
    "id": 44912,
    "text": "Whenever the people are for gay marriage or medical marijuana or assisted suicide, suddenly the 'will of the people' goes out the window."
  },
  {
    "author": "Larry Niven",
    "category": "medical",
    "id": 45030,
    "text": "I'd visit the near future, close enough that someone might want to talk to Larry Niven and can figure out the language distant enough to get me decent medical techniques and a ticket to the Moon."
  },
  {
    "author": "Paul Farmer",
    "category": "medical",
    "id": 44960,
    "text": "I mean, everybody should have access to medical care. And, you know, it shouldn't be such a big deal."
  },
  {
    "author": "Karen Duffy",
    "category": "medical",
    "id": 45081,
    "text": "In addition, I'll be attending women's health expos and medical conferences with the goal to promote dialogue between women and their health-care providers."
  },
  {
    "author": "Cass Canfield",
    "category": "medical",
    "id": 44880,
    "text": "Some people think that doctors and nurses can put scrambled eggs back in the shell."
  },
  {
    "author": "Barbara Boxer",
    "category": "medical",
    "id": 44967,
    "text": "Medical professionals, not insurance company bureaucrats, should be making health care decisions."
  },
  {
    "author": "John Templeton",
    "category": "medical",
    "id": 45059,
    "text": "Three of my children are medical doctors, they know at least a hundred times as much about your body as my grandfather knew, but they don't know much more about soul than he did."
  },
  {
    "author": "Sandra Fluke",
    "category": "medical",
    "id": 45132,
    "text": "I was proud to share the stories of my friends at Georgetown Law who have suffered dire medical consequences because our student insurance does not cover contraception for the purpose of preventing pregnancy."
  },
  {
    "author": "Richard Reeves",
    "category": "medical",
    "id": 45124,
    "text": "Kennedy lied and lied about his health while he was alive, even using his father's influence to get into the Navy without ever taking a medical examination."
  },
  {
    "author": "Nathan Deal",
    "category": "medical",
    "id": 45057,
    "text": "Consider this: I can go to Antarctica and get cash from an ATM without a glitch, but should I fall ill during my travels, a hospital there could not access my medical records or know what medications I am on."
  },
  {
    "author": "Alice James",
    "category": "medical",
    "id": 44903,
    "text": "One has a greater sense of degradation after an interview with a doctor than from any human experience."
  },
  {
    "author": "John Cameron",
    "category": "medical",
    "id": 45042,
    "text": "I am sure that I have been much more useful to society as a medical physicist."
  },
  {
    "author": "Martin H. Fischer",
    "category": "medical",
    "id": 44895,
    "text": "In the sick room, ten cents' worth of human understanding equals ten dollars' worth of medical science."
  },
  {
    "author": "Robin Tunney",
    "category": "medical",
    "id": 45068,
    "text": "After I read all the medical journals and watched all the documentaries, I still didn't understand the physical sensation of ticking and where it comes from and what it feels like."
  },
  {
    "author": "Jim Gerlach",
    "category": "medical",
    "id": 45012,
    "text": "Long gone are the days when hospital stays and surgeries made up the bulk of seniors' annual medical expenses."
  },
  {
    "author": "Warwick Davis",
    "category": "medical",
    "id": 45006,
    "text": "When I was born in 1970 with a rare genetic disorder called spondyloepiphyseal dysplasia congenita (SED), medical science wasn't what it is today and my mum and dad were treated terribly by the medical profession."
  },
  {
    "author": "Alice Hamilton",
    "category": "medical",
    "id": 45023,
    "text": "When I talked to my medical friends about the strange silence on this subject in American medical magazines and textbooks, I gained the impression that here was a subject tainted with Socialism or with feminine sentimentality for the poor."
  },
  {
    "author": "Laurel Clark",
    "category": "medical",
    "id": 45008,
    "text": "The Navy's paid for you to go through school, and then they need doctors to go out and take care of people who are in various different parts of the world. I decided to pay back my time first as an undersea medical officer. I was stationed in Scotland."
  },
  {
    "author": "Michelle Malkin",
    "category": "medical",
    "id": 44964,
    "text": "President Obama and his radical feminist enforcers have had it in for Catholic medical providers from the get-go. It's about time all people of faith fought back against this unprecedented encroachment on religious liberty. First, they came for the Catholics. Who's next?"
  },
  {
    "author": "Jonathan Kellerman",
    "category": "medical",
    "id": 45125,
    "text": "I don't practice, but I am still officially in paediatrics. I keep in touch with journals, and I have a very good data bank of medical information and there is a key thing for a writer knowing where to go. I know where to go to get the information that I need."
  },
  {
    "author": "Ovid",
    "category": "medical",
    "id": 44871,
    "text": "Time is generally the best doctor."
  },
  {
    "author": "Abe Lemons",
    "category": "medical",
    "id": 44923,
    "text": "Finish last in your league and they call you idiot. Finish last in medical school and they call you doctor."
  }
]

quotes['men'] = [
  {
    "author": "Kin Hubbard",
    "category": "men",
    "id": 45175,
    "text": "Boys will be boys, and so will a lot of middle-aged men."
  },
  {
    "author": "Thomas Paine",
    "category": "men",
    "id": 45529,
    "text": "Reputation is what men and women think of us character is what God and angels know of us."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "men",
    "id": 45319,
    "text": "It has always been a mystery to me how men can feel themselves honoured by the humiliation of their fellow beings."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "men",
    "id": 45888,
    "text": "I do not believe in a fate that falls on men however they act but I do believe in a fate that falls on them unless they act."
  },
  {
    "author": "George Bernard Shaw",
    "category": "men",
    "id": 45434,
    "text": "Choose silence of all virtues, for by it you hear other men's imperfections, and conceal your own."
  },
  {
    "author": "Anne Morrow Lindbergh",
    "category": "men",
    "id": 45337,
    "text": "Men kick friendship around like a football, but it doesn't seem to crack. Women treat it like glass and it goes to pieces."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "men",
    "id": 45176,
    "text": "Passion makes idiots of the cleverest men, and makes the biggest idiots clever."
  },
  {
    "author": "Thomas Carlyle",
    "category": "men",
    "id": 45869,
    "text": "Men do less than they ought, unless they do all that they can."
  },
  {
    "author": "Aldo Leopold",
    "category": "men",
    "id": 45833,
    "text": "Conservation is a state of harmony between men and land."
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "men",
    "id": 45196,
    "text": "Men do not quit playing because they grow old they grow old because they quit playing."
  },
  {
    "author": "William Blake",
    "category": "men",
    "id": 46045,
    "text": "What is the price of experience? Do men buy it for a song? Or wisdom for a dance in the street? No, it is bought with the price of all the man hath, his house, his wife, his children."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "men",
    "id": 45997,
    "text": "There are but very few men clever enough to know all the mischief they do."
  },
  {
    "author": "Mary Wollstonecraft",
    "category": "men",
    "id": 46089,
    "text": "Women are systematically degraded by receiving the trivial attentions which men think it manly to pay to the sex, when, in fact, men are insultingly supporting their own superiority."
  },
  {
    "author": "William Shakespeare",
    "category": "men",
    "id": 45361,
    "text": "Men are April when they woo, December when they wed. Maids are May when they are maids, but the sky changes when they are wives."
  },
  {
    "author": "William Butler Yeats",
    "category": "men",
    "id": 46057,
    "text": "I have known more men destroyed by the desire to have wife and child and to keep them in comfort than I have seen destroyed by drink and harlots."
  },
  {
    "author": "Annie Lennox",
    "category": "men",
    "id": 45991,
    "text": "We all fight over what the label 'feminism' means but for me it's about empowerment. It's not about being more powerful than men - it's about having equal rights with protection, support, justice. It's about very basic things. It's not a badge like a fashion item."
  },
  {
    "author": "John F. Kennedy",
    "category": "men",
    "id": 45292,
    "text": "Do not pray for easy lives. Pray to be stronger men."
  },
  {
    "author": "Helen Keller",
    "category": "men",
    "id": 45289,
    "text": "Security is mostly a superstition. It does not exist in nature, nor do the children of men as a whole experience it. Avoiding danger is no safer in the long run than outright exposure. Life is either a daring adventure, or nothing."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "men",
    "id": 46052,
    "text": "We cannot learn men from books."
  },
  {
    "author": "George Bernard Shaw",
    "category": "men",
    "id": 45467,
    "text": "If women were particular about men's characters, they would never get married at all."
  },
  {
    "author": "Martin Luther",
    "category": "men",
    "id": 45620,
    "text": "I shall never be a heretic I may err in dispute, but I do not wish to decide anything finally on the other hand, I am not bound by the opinions of men."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "men",
    "id": 45366,
    "text": "Trust men and they will be true to you treat them greatly and they will show themselves great."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "men",
    "id": 45177,
    "text": "The truth is found when men are free to pursue it."
  },
  {
    "author": "Benjamin Haydon",
    "category": "men",
    "id": 45269,
    "text": "When a man is no longer anxious to do better than well, he is done for."
  },
  {
    "author": "Plato",
    "category": "men",
    "id": 45603,
    "text": "Whatever deceives men seems to produce a magical enchantment."
  },
  {
    "author": "David Hilbert",
    "category": "men",
    "id": 46138,
    "text": "If one were to bring ten of the wisest men in the world together and ask them what was the most stupid thing in existence, they would not be able to discover anything so stupid as astrology."
  },
  {
    "author": "Walter Lippmann",
    "category": "men",
    "id": 46143,
    "text": "In a free society the state does not administer the affairs of men. It administers justice among men who conduct their own affairs."
  },
  {
    "author": "Thomas Jefferson",
    "category": "men",
    "id": 45343,
    "text": "Books constitute capital. A library book lasts as long as a house, for hundreds of years. It is not, then, an article of mere consumption but fairly of capital, and often in the case of professional men, setting out in life, it is their only capital."
  },
  {
    "author": "Christopher Dawson",
    "category": "men",
    "id": 45908,
    "text": "As soon as men decide that all means are permitted to fight an evil, then their good becomes indistinguishable from the evil that they set out to destroy."
  },
  {
    "author": "Aldous Huxley",
    "category": "men",
    "id": 45718,
    "text": "It was one of those evenings when men feel that truth, goodness and beauty are one. In the morning, when they commit their discovery to paper, when others read it written there, it looks wholly ridiculous."
  },
  {
    "author": "Aristotle",
    "category": "men",
    "id": 45441,
    "text": "It is unbecoming for young men to utter maxims."
  },
  {
    "author": "George Jean Nathan",
    "category": "men",
    "id": 46101,
    "text": "I know many married men, I even know a few happily married men, but I don't know one who wouldn't fall down the first open coal hole running after the first pretty girl who gave him a wink."
  },
  {
    "author": "Louis Farrakhan",
    "category": "men",
    "id": 45901,
    "text": "Because wherever I am today, I still owe it to God and I owe it to two men - the Honorable Elijah Muhammad and Malcolm X and of course, two very special women, my mother and my wife."
  },
  {
    "author": "Ambrose Bierce",
    "category": "men",
    "id": 45895,
    "text": "Men become civilized, not in proportion to their willingness to believe, but in proportion to their readiness to doubt."
  },
  {
    "author": "Richard Wright",
    "category": "men",
    "id": 45793,
    "text": "Men can starve from a lack of self-realization as much as they can from a lack of bread."
  },
  {
    "author": "Andrew Cohen",
    "category": "men",
    "id": 45937,
    "text": "Most men are very attached to the idea of being male, and usually experience a lot of fear and insecurity around the idea of being a man. Most women are very identified with their gender, and also experience a tremendous amount of fear and insecurity."
  },
  {
    "author": "Samuel Gompers",
    "category": "men",
    "id": 45764,
    "text": "Time is the most valuable thing on earth: time to think, time to act, time to extend our fraternal relations, time to become better men, time to become better women, time to become better and more independent citizens."
  },
  {
    "author": "John Steinbeck",
    "category": "men",
    "id": 45329,
    "text": "It has always seemed strange to me... the things we admire in men, kindness and generosity, openness, honesty, understanding and feeling, are the concomitants of failure in our system. And those traits we detest, sharpness, greed, acquisitiveness, meanness, egotism and self-interest, are the traits of success. And while men admire the quality of the first they love the produce of the second."
  },
  {
    "author": "H. L. Mencken",
    "category": "men",
    "id": 45642,
    "text": "The only really happy folk are married women and single men."
  },
  {
    "author": "Thomas Hardy",
    "category": "men",
    "id": 45936,
    "text": "It is difficult for a woman to define her feelings in language which is chiefly made by men to express theirs."
  },
  {
    "author": "Calvin Coolidge",
    "category": "men",
    "id": 45889,
    "text": "It is only when men begin to worship that they begin to grow."
  },
  {
    "author": "Sarah Jessica Parker",
    "category": "men",
    "id": 45787,
    "text": "When men attempt bold gestures, generally it's considered romantic. When women do it, it's often considered desperate or psycho."
  },
  {
    "author": "Benjamin Franklin",
    "category": "men",
    "id": 45374,
    "text": "Content makes poor men rich discontent makes rich men poor."
  },
  {
    "author": "Nora Ephron",
    "category": "men",
    "id": 45560,
    "text": "Beware of men who cry. It's true that men who cry are sensitive to and in touch with feelings, but the only feelings they tend to be sensitive to and in touch with are their own."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "men",
    "id": 45478,
    "text": "Whoever has provoked men to rage against him has always gained a party in his favor, too."
  },
  {
    "author": "W. E. B. Du Bois",
    "category": "men",
    "id": 45777,
    "text": "Education is that whole system of human training within and without the school house walls, which molds and develops men."
  },
  {
    "author": "Zhang Ziyi",
    "category": "men",
    "id": 45254,
    "text": "Men are different. When they are in love they may also have other girlfriends."
  },
  {
    "author": "Norman Mailer",
    "category": "men",
    "id": 45893,
    "text": "The highest prize in a world of men is the most beautiful woman available on your arm and living there in her heart loyal to you."
  },
  {
    "author": "George Bernard Shaw",
    "category": "men",
    "id": 45386,
    "text": "Clever and attractive women do not want to vote they are willing to let men govern as long as they govern men."
  },
  {
    "author": "Albert Camus",
    "category": "men",
    "id": 45543,
    "text": "Men are never really willing to die except for the sake of freedom: therefore they do not believe in dying completely."
  },
  {
    "author": "Marilyn Monroe",
    "category": "men",
    "id": 45456,
    "text": "Girls shouldn't worry about being the equal of men in the business world."
  },
  {
    "author": "Knute Rockne",
    "category": "men",
    "id": 45225,
    "text": "Most men, when they think they are thinking, are merely rearranging their prejudices."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "men",
    "id": 45920,
    "text": "There is no better proof of a man's being truly good than his desiring to be constantly under the observation of good men."
  },
  {
    "author": "Abraham Lincoln",
    "category": "men",
    "id": 45308,
    "text": "Every man is said to have his peculiar ambition. Whether it be true or not, I can say for one that I have no other so great as that of being truly esteemed of my fellow men, by rendering myself worthy of their esteem."
  },
  {
    "author": "George Orwell",
    "category": "men",
    "id": 45521,
    "text": "We have now sunk to a depth at which restatement of the obvious is the first duty of intelligent men."
  },
  {
    "author": "Edmund Burke",
    "category": "men",
    "id": 45836,
    "text": "There is a boundary to men's passions when they act from feelings but none when they are under the influence of imagination."
  },
  {
    "author": "Charles Dickens",
    "category": "men",
    "id": 45562,
    "text": "Reflect upon your present blessings of which every man has many - not on your past misfortunes, of which all men have some."
  },
  {
    "author": "Red Skelton",
    "category": "men",
    "id": 45432,
    "text": "All men make mistakes, but married men find out about them sooner."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "men",
    "id": 45422,
    "text": "Great men or men of great gifts you shall easily find, but symmetrical men never."
  },
  {
    "author": "Katharine Hepburn",
    "category": "men",
    "id": 45602,
    "text": "Plain women know more about men than beautiful women do."
  },
  {
    "author": "Napoleon Bonaparte",
    "category": "men",
    "id": 45615,
    "text": "All religions have been made by men."
  },
  {
    "author": "Pythagoras",
    "category": "men",
    "id": 46108,
    "text": "As long as man continues to be the ruthless destroyer of lower living beings he will never know health or peace. For as long as men massacre animals, they will kill each other."
  },
  {
    "author": "Francis of Assisi",
    "category": "men",
    "id": 45159,
    "text": "If you have men who will exclude any of God's creatures from the shelter of compassion and pity, you will have men who will deal likewise with their fellow men."
  },
  {
    "author": "Francoise Sagan",
    "category": "men",
    "id": 45739,
    "text": "A dress makes no sense unless it inspires men to take it off of you."
  },
  {
    "author": "Thomas Jefferson",
    "category": "men",
    "id": 45309,
    "text": "We hold these truths to be self-evident: that all men are created equal that they are endowed by their Creator with certain unalienable rights that among these are life, liberty, and the pursuit of happiness."
  },
  {
    "author": "Lorraine Hansberry",
    "category": "men",
    "id": 45519,
    "text": "A woman who is willing to be herself and pursue her own potential runs not so much the risk of loneliness, as the challenge of exposure to more interesting men - and people in general."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "men",
    "id": 45210,
    "text": "In life we shall find many men that are great, and some that are good, but very few men that are both great and good."
  },
  {
    "author": "Edwin Hubbel Chapin",
    "category": "men",
    "id": 45272,
    "text": "Neutral men are the devil's allies."
  },
  {
    "author": "Plato",
    "category": "men",
    "id": 45583,
    "text": "Nothing can be more absurd than the practice that prevails in our country of men and women not following the same pursuits with all their strengths and with one mind, for thus, the state instead of being whole is reduced to half."
  },
  {
    "author": "Winston Churchill",
    "category": "men",
    "id": 45317,
    "text": "Men occasionally stumble over the truth, but most of them pick themselves up and hurry off as if nothing had happened."
  },
  {
    "author": "Jean-Paul Sartre",
    "category": "men",
    "id": 45815,
    "text": "I do not believe in God his existence has been disproved by Science. But in the concentration camp, I learned to believe in men."
  },
  {
    "author": "Alice Walker",
    "category": "men",
    "id": 45703,
    "text": "The animals of the world exist for their own reasons. They were not made for humans any more than black people were made for white, or women created for men."
  },
  {
    "author": "George S. Patton",
    "category": "men",
    "id": 45358,
    "text": "It is foolish and wrong to mourn the men who died. Rather we should thank God that such men lived."
  },
  {
    "author": "Benjamin Franklin",
    "category": "men",
    "id": 45404,
    "text": "Nine men in ten are would be suicides."
  },
  {
    "author": "Camille Paglia",
    "category": "men",
    "id": 45812,
    "text": "Woman is the dominant sex. Men have to do all sorts of stuff to prove that they are worthy of woman's attention."
  },
  {
    "author": "Camille Paglia",
    "category": "men",
    "id": 46029,
    "text": "Men know they are sexual exiles. They wander the earth seeking satisfaction, craving and despising, never content. There is nothing in that anguished motion for women to envy."
  },
  {
    "author": "Blaise Pascal",
    "category": "men",
    "id": 45970,
    "text": "The greater intellect one has, the more originality one finds in men. Ordinary persons find no difference between men."
  },
  {
    "author": "Clarence Darrow",
    "category": "men",
    "id": 45200,
    "text": "I am an agnostic I do not pretend to know what many ignorant men are sure of."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "men",
    "id": 46040,
    "text": "Fame and power are the objects of all men. Even their partial fruition is gained by very few and that, too, at the expense of social pleasure, health, conscience, life."
  },
  {
    "author": "William Shakespeare",
    "category": "men",
    "id": 45377,
    "text": "There have been many great men that have flattered the people who ne'er loved them."
  },
  {
    "author": "Abbe Pierre",
    "category": "men",
    "id": 45835,
    "text": "What I would say to the young men and women who are beset by hopelessness and doubt is that they should go and see what is being done on the ground to fight poverty, not like going to the zoo but to take action, to open their hearts and their consciences."
  },
  {
    "author": "Herman Melville",
    "category": "men",
    "id": 45735,
    "text": "We cannot live only for ourselves. A thousand fibers connect us with our fellow men."
  },
  {
    "author": "Aristotle",
    "category": "men",
    "id": 45418,
    "text": "Perfect friendship is the friendship of men who are good, and alike in excellence for these wish well alike to each other qua good, and they are good in themselves."
  },
  {
    "author": "Robert Kennedy",
    "category": "men",
    "id": 45623,
    "text": "Whenever men take the law into their own hands, the loser is the law. And when the law loses, freedom languishes."
  },
  {
    "author": "Rebecca West",
    "category": "men",
    "id": 46060,
    "text": "A strong hatred is the best lamp to bear in our hands as we go over the dark places of life, cutting away the dead things men tell us to revere."
  },
  {
    "author": "Antoine de Saint-Exupery",
    "category": "men",
    "id": 46118,
    "text": "Only the unknown frightens men. But once a man has faced the unknown, that terror becomes the known."
  },
  {
    "author": "H. L. Mencken",
    "category": "men",
    "id": 45678,
    "text": "Men have a much better time of it than women. For one thing, they marry later for another thing, they die earlier."
  },
  {
    "author": "Antoine de Saint-Exupery",
    "category": "men",
    "id": 46116,
    "text": "One can be a brother only in something. Where there is no tie that binds men, men are not united but merely lined up."
  },
  {
    "author": "Niccolo Machiavelli",
    "category": "men",
    "id": 45479,
    "text": "A return to first principles in a republic is sometimes caused by the simple virtues of one man. His good example has such an influence that the good men strive to imitate him, and the wicked are ashamed to lead a life so contrary to his example."
  },
  {
    "author": "Henry Wadsworth Longfellow",
    "category": "men",
    "id": 45396,
    "text": "Heights by great men reached and kept were not obtained by sudden flight but, while their companions slept, they were toiling upward in the night."
  },
  {
    "author": "Noah Webster",
    "category": "men",
    "id": 45775,
    "text": "All the miseries and evils which men suffer from vice, crime, ambition, injustice, oppression, slavery and war, proceed from their despising or neglecting the precepts contained in the Bible."
  },
  {
    "author": "Victor Hugo",
    "category": "men",
    "id": 45780,
    "text": "The mountains, the forest, and the sea, render men savage they develop the fierce, but yet do not destroy the human."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "men",
    "id": 45930,
    "text": "The happiness and misery of men depend no less on temper than fortune."
  },
  {
    "author": "Madeleine Albright",
    "category": "men",
    "id": 45960,
    "text": "I love being a woman and I was not one of these women who rose through professional life by wearing men's clothes or looking masculine. I loved wearing bright colors and being who I am."
  },
  {
    "author": "Blaise Pascal",
    "category": "men",
    "id": 45969,
    "text": "Men blaspheme what they do not know."
  },
  {
    "author": "Leo Tolstoy",
    "category": "men",
    "id": 45557,
    "text": "Government is an association of men who do violence to the rest of us."
  },
  {
    "author": "Henry David Thoreau",
    "category": "men",
    "id": 45501,
    "text": "I have thought there was some advantage even in death, by which we mingle with the herd of common men."
  },
  {
    "author": "E. B. White",
    "category": "men",
    "id": 45215,
    "text": "Luck is not something you can mention in the presence of self-made men."
  },
  {
    "author": "Walter Scott",
    "category": "men",
    "id": 45218,
    "text": "All men who have turned out worth anything have had the chief hand in their own education."
  },
  {
    "author": "Charles Baudelaire",
    "category": "men",
    "id": 46056,
    "text": "The unique and supreme voluptuousness of love lies in the certainty of committing evil. And men and women know from birth that in evil is found all sensual delight."
  }
]

quotes['mom'] = [
  {
    "author": "Amy Winehouse",
    "category": "mom",
    "id": 46286,
    "text": "I know I'm talented, but I wasn't put here to sing. I was put here to be a wife and a mom and look after my family. I love what I do, but it's not where it begins and ends."
  },
  {
    "author": "Emma Bonino",
    "category": "mom",
    "id": 46198,
    "text": "A woman must combine the role of mother, wife and politician."
  },
  {
    "author": "Cheryl James",
    "category": "mom",
    "id": 46795,
    "text": "I've changed my life in a lot of ways. I'm a mom, a wife, and a Christian. Some of the things I expressed in my early 20s aren't what I care to express right now."
  },
  {
    "author": "Holly Marie Combs",
    "category": "mom",
    "id": 47099,
    "text": "When you become a mom you just learn how to function sleep deprived and you do get used to it. I came back to work when Finley was three months old and the first few months were rough. Then somehow you learn to exist on no sleep and now when he does upon occasion sleep through the night, which is like a full six hours, you're pretty sure he's suffocating. So you don't sleep anyway."
  },
  {
    "author": "Elizabeth Olsen",
    "category": "mom",
    "id": 46643,
    "text": "I was embarrassed that I even wanted to become an actress because coming from L.A., with two older sisters in the business and a mom who had been a ballet dancer, it was such a cliche."
  },
  {
    "author": "Vin Diesel",
    "category": "mom",
    "id": 46400,
    "text": "My mom insisted on multigrain bread and never allowed soda in the house."
  },
  {
    "author": "Elena Anaya",
    "category": "mom",
    "id": 46984,
    "text": "I love to fly. I always wanted to fly. It's been one of my dreams since I was 3 years old. I remember saying to my mom, 3 years old, every day, 'I can fly!' Living on the ninth floor, it was dangerous."
  },
  {
    "author": "Kate Hudson",
    "category": "mom",
    "id": 46921,
    "text": "I always wanted to be a mom."
  },
  {
    "author": "Molly Shannon",
    "category": "mom",
    "id": 47103,
    "text": "Losing my mom at such a young age had a profound effect on my life."
  },
  {
    "author": "Claudette Colbert",
    "category": "mom",
    "id": 46215,
    "text": "Why do grandparents and grandchildren get along so well? The mother."
  },
  {
    "author": "Jordin Sparks",
    "category": "mom",
    "id": 46445,
    "text": "When I turned 18, my mom, my nana and I all went and had tattoos of our favorite Bible verses put on the inside of our wrists. Mine is 1st Timothy, 4:12."
  },
  {
    "author": "James Belushi",
    "category": "mom",
    "id": 46923,
    "text": "I don't deal with death very well. My brother, John Candy, my dad, my mom, Brandon Tartikoff just a couple of weeks ago. I mean, you lose a lot of people in your life, and that's one thing I am constantly working on - pain management."
  },
  {
    "author": "Busy Philipps",
    "category": "mom",
    "id": 46660,
    "text": "Birdie is amazing and such an incredible child and I'm having such a great time being a mom but I still want to have a career and I still look forward to auditions and parts, and when I don't get them I'm disappointed."
  },
  {
    "author": "Thomas Kincade",
    "category": "mom",
    "id": 47064,
    "text": "I remember my mom had a big collection of copies of Saturday Evening Post magazines, and that was really my introduction to those great illustrators."
  },
  {
    "author": "David Cassidy",
    "category": "mom",
    "id": 46762,
    "text": "My mom used to take me down to the Jersey Shore when I was 7, 8, 9 years old. I can remember being down in that area - Belmar, Seaside Heights, Asbury Park and all those places that I went back and revisited."
  },
  {
    "author": "Ricky Skaggs",
    "category": "mom",
    "id": 46820,
    "text": "I always had a standard of, back when I was doing the country music I always told people I would never record a song that I wouldn't sit down and sing in front of my mom and dad."
  },
  {
    "author": "Idina Menzel",
    "category": "mom",
    "id": 46674,
    "text": "I'm a mom - I'm lucky if I get to shower in the morning. Luckily, nail polish stays on my toes. I've been so bad on the upkeep, though."
  },
  {
    "author": "Carly Fiorina",
    "category": "mom",
    "id": 46162,
    "text": "My mother taught me about the power of inspiration and courage, and she did it with a strength and a passion that I wish could be bottled."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "mom",
    "id": 46410,
    "text": "These days it's cool to be ethnic and to be different, but when I was a kid, it was not cool - at all. My friends would come over and my mom would make crepes with eggs, stuffed with mozzarella cheese, tomatoes and spinach. And they'd be like, 'What is this?'"
  },
  {
    "author": "Ambrose Bierce",
    "category": "mom",
    "id": 46159,
    "text": "Sweater, n.: garment worn by child when its mother is feeling chilly."
  },
  {
    "author": "Eminem",
    "category": "mom",
    "id": 46238,
    "text": "I'd go to, like, six different schools in one year. We were on welfare, and my mom never ever worked."
  },
  {
    "author": "Eddie Vedder",
    "category": "mom",
    "id": 46443,
    "text": "No matter how good you are, at some point your kids are gonna have to create their own independence and think that Mom and Dad aren't cool, just to establish themselves. That's what adolescence is about. They're gonna go through that no matter what."
  },
  {
    "author": "Robert Griffin III",
    "category": "mom",
    "id": 46610,
    "text": "I'm a military kid, both parents in the military - Mom did 12 years, Dad did 21, served in two wars. So discipline is something that was huge."
  },
  {
    "author": "Miranda Lambert",
    "category": "mom",
    "id": 46373,
    "text": "My mom was always saying: 'Be whatever you want to be, but stick with it. Don't waver. Don't change who you are for anybody.'"
  },
  {
    "author": "Emmanuelle Chriqui",
    "category": "mom",
    "id": 46743,
    "text": "When I look up and see a star, I know my mom is there. She's with me all the time. It's a powerful connection."
  },
  {
    "author": "Elizabeth Taylor",
    "category": "mom",
    "id": 46164,
    "text": "I've been through it all, baby, I'm mother courage."
  },
  {
    "author": "Chris Christie",
    "category": "mom",
    "id": 46331,
    "text": "Mom spent the time that she was supposed to be a kid actully raising children, her younger brother and younger sister. She was tough as nails and did not suffer fools at all. And the truth was she could not afford to. She spoke the truth, bluntly, directly, and without much varnish. I am her son."
  },
  {
    "author": "Paul Ryan",
    "category": "mom",
    "id": 46281,
    "text": "And to this day, my Mom is my role model."
  },
  {
    "author": "Lucas Grabeel",
    "category": "mom",
    "id": 47021,
    "text": "I grew up with the classics. My mom and I would sit and watch 'Singin' in the Rain' and 'White Christmas' - those kind of movies."
  },
  {
    "author": "Zayn Malik",
    "category": "mom",
    "id": 46753,
    "text": "Our parents are obviously proud, but they're still trying to get used to the fact that we're in a band. I have a feeling my mom would actually like One Direction if I wasn't in it!"
  },
  {
    "author": "Martina McBride",
    "category": "mom",
    "id": 46559,
    "text": "That's the hardest thing about being a mom. You want to be cool, and you want them to like you all the time, but you can't always have that. You're gonna have times where you have to say no, and you won't be the most popular person in the house."
  },
  {
    "author": "Tom Hardy",
    "category": "mom",
    "id": 46834,
    "text": "Being an only child, I didn't have any other family but my mom and dad really, since the rest of my family lived quite far away from London."
  },
  {
    "author": "Lisa Loeb",
    "category": "mom",
    "id": 46622,
    "text": "I think a good mom is an awake mom. At least for me, I've always been a kinder, better person awake than sleep-deprived!"
  },
  {
    "author": "Pauly Shore",
    "category": "mom",
    "id": 47061,
    "text": "My mom is two people to me. She's my mom number one, and then she's this lady most comedians know as being a legendary owner of a nightclub that's responsible for starting a lot of heavy careers."
  },
  {
    "author": "Al Lewis",
    "category": "mom",
    "id": 46231,
    "text": "What motivated me? My mother. My mother was an immigrant woman, a peasant woman, struggled all her life, worked in the garment center."
  },
  {
    "author": "Sophia Bush",
    "category": "mom",
    "id": 46416,
    "text": "Because sorry to say, women run the house. They run the family. They hold things up. I mean, it's like you don't ever see your mom get sick because she handles everything. And it's kind of amazing I think to show people just how strong women are."
  },
  {
    "author": "Ben Affleck",
    "category": "mom",
    "id": 46465,
    "text": "There is nothing worse that a thirteen-year-old boy. You're embarrassed by your parents, and you're trying to find your independance because, deep inside, you are so dependent on your mom."
  },
  {
    "author": "Balthazar Getty",
    "category": "mom",
    "id": 46989,
    "text": "My mom just understands about stuff. We have a really good trust, and she knows I can take care of myself."
  },
  {
    "author": "T-Bone Burnett",
    "category": "mom",
    "id": 46931,
    "text": "I naturally wanted to be saved, so when I came home I told my mom I wanted to be confirmed. That's the way I related to it, being raised an Episcopalian. I went to Dallas and got confirmed."
  },
  {
    "author": "Steve Case",
    "category": "mom",
    "id": 46734,
    "text": "My father still is a lawyer, and my mom was a teacher and then later a career counselor."
  },
  {
    "author": "Carmen Electra",
    "category": "mom",
    "id": 46591,
    "text": "My mom was amazing. She believed in me and we were best friends."
  },
  {
    "author": "Victoria Justice",
    "category": "mom",
    "id": 46577,
    "text": "My mom is not trying to live vicariously through me."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "mom",
    "id": 46148,
    "text": "Men are what their mothers made them."
  },
  {
    "author": "Jim DeMint",
    "category": "mom",
    "id": 46252,
    "text": "One of the greatest titles in the world is parent, and one of the biggest blessings in the world is to have parents to call mom and dad."
  },
  {
    "author": "Toni Braxton",
    "category": "mom",
    "id": 46222,
    "text": "I'd lose my mind if I heard my kid call the nanny Mommy."
  },
  {
    "author": "Trisha Yearwood",
    "category": "mom",
    "id": 46638,
    "text": "When you're sick, nobody takes care of you like your mom."
  },
  {
    "author": "Beau Bridges",
    "category": "mom",
    "id": 46803,
    "text": "My mom is many times responsible for getting us all together, but we trade off at each other's houses. My brother and I are actors and are traveling a lot of our job."
  },
  {
    "author": "Ethel Waters",
    "category": "mom",
    "id": 46555,
    "text": "We never had a bathtub. Mom would bathe me in the wooden or tin washtub in the kitchen, or in a big lard can."
  },
  {
    "author": "Jon Hamm",
    "category": "mom",
    "id": 46907,
    "text": "For a kid who's lost his mom and all the rage and grief that no one was able to talk out of me, football was a very therapeutic sport. Very."
  },
  {
    "author": "Ashley Greene",
    "category": "mom",
    "id": 46491,
    "text": "When I was 15, I worked at a dry cleaner because I wanted Abercrombie & Fitch jeans. My mom told me I could have $20 jeans, not $70 jeans, unless I was willing to work for them. So I did!"
  },
  {
    "author": "Eddie Murray",
    "category": "mom",
    "id": 47009,
    "text": "No one was more important than my mom and dad. I know they are watching from a place up in heaven here today to make sure all their kids are doing good."
  },
  {
    "author": "Ed O'Neill",
    "category": "mom",
    "id": 47006,
    "text": "That's a big deal for kids, when they come into the kitchen and the teacher is drinking coffee with mom. They react differently on the next day when you say: 'Sit down and shut-up!'"
  },
  {
    "author": "Mitt Romney",
    "category": "mom",
    "id": 46241,
    "text": "Mom and Dad were married 64 years. And if you wondered what their secret was, you could have asked the local florist - because every day Dad gave Mom a rose, which he put on her bedside table. That's how she found out what happened on the day my father died - she went looking for him because that morning, there was no rose."
  },
  {
    "author": "Rico Rodriguez",
    "category": "mom",
    "id": 47076,
    "text": "For as long as I've been acting, I have been very lucky to be paired with really great actresses playing my mom."
  },
  {
    "author": "Andrew Mason",
    "category": "mom",
    "id": 46609,
    "text": "When you think of couponing, you picture a mom cutting coupons out of the back of the newspaper."
  },
  {
    "author": "Ruben Studdard",
    "category": "mom",
    "id": 46736,
    "text": "Simon is cool. You know, it's different if you ever see him around his mom. He acts totally different."
  },
  {
    "author": "Cecily von Ziegesar",
    "category": "mom",
    "id": 46920,
    "text": "I'd never really babysat. I feel like I'm Blair, or 'Gossip Girl.' A teenager, basically - and now suddenly I'm a mom?"
  },
  {
    "author": "Jordin Sparks",
    "category": "mom",
    "id": 46444,
    "text": "I was always okay with the fact that I was taller and bigger than everybody else growing up. My mom, my dad, and my friends always told me I was beautiful."
  },
  {
    "author": "Melanie Roach",
    "category": "mom",
    "id": 47089,
    "text": "I've been a pretty selfish mom and a very unselfish athlete for about three years now and it's time to put my family first. It's probably time to move on."
  },
  {
    "author": "Glenn Hughes",
    "category": "mom",
    "id": 46932,
    "text": "I heard the Beatles and the Stones, and Mom bought me an electric guitar. I played lead for four years and then switched to bass. One day someone suggested that I should sing, so I sheepishly stepped up to the microphone and the rest is rock history."
  },
  {
    "author": "Aasif Mandvi",
    "category": "mom",
    "id": 46978,
    "text": "When I was 11 my friend's mom made a peanut butter sandwich. I ate the sandwich and was like, 'I'm never eating anything else again.' And I still eat peanut butter every day. I would put peanut butter on a steak."
  },
  {
    "author": "Schuyler Fisk",
    "category": "mom",
    "id": 47115,
    "text": "Part of the reason that I moved to Los Angeles is that even though my mom introduced me to all kinds of music, I really wanted to work on having my own identify, on being who I am and doing what I do, and seeing how people responded."
  },
  {
    "author": "Ashley Greene",
    "category": "mom",
    "id": 46493,
    "text": "I remember getting this scrapbook that this girl made, that I actually gave to my mom to hold onto because she has a 'Twilight' shrine in their house in Florida. It was just this scrapbook of me, starting with 'Twilight,' and the whole progression of me and my career throughout that, and other stuff that I had done in between."
  },
  {
    "author": "Lance Armstrong",
    "category": "mom",
    "id": 46247,
    "text": "My mom was such a strong character. I don't want to say she was like a man, but she was tough."
  },
  {
    "author": "Jennifer M. Granholm",
    "category": "mom",
    "id": 46566,
    "text": "This is the place where anybody - like an African American kid raised by a single mom - can be president."
  },
  {
    "author": "Cuba Gooding, Jr.",
    "category": "mom",
    "id": 46255,
    "text": "Don't let people disrespect you. My mom says don't open the door to the devil. Surround yourself with positive people."
  },
  {
    "author": "Bridget Moynahan",
    "category": "mom",
    "id": 46995,
    "text": "I'm not sure anyone - and I could be wrong in this - grows up thinking, I want to be a single mom."
  },
  {
    "author": "Isabelle Fuhrman",
    "category": "mom",
    "id": 47011,
    "text": "I never let anyone pluck, including myself, unless my mom approves. She guards my eyebrows. She's like the eyebrow police!"
  },
  {
    "author": "Marissa Mayer",
    "category": "mom",
    "id": 46567,
    "text": "You can be good at technology and like fashion and art. You can be good at technology and be a jock. You can be good at technology and be a mom. You can do it your way, on your terms."
  },
  {
    "author": "Reese Hoffa",
    "category": "mom",
    "id": 47137,
    "text": "When you have lost people like I lost my birth mom at a young age and you remember the whole process of losing her, you want to grab on to something that makes you whole."
  },
  {
    "author": "Pablo Picasso",
    "category": "mom",
    "id": 46149,
    "text": "My mother said to me, 'If you are a soldier, you will become a general. If you are a monk, you will become the Pope.' Instead, I was a painter, and became Picasso."
  },
  {
    "author": "Wayne Brady",
    "category": "mom",
    "id": 46565,
    "text": "My mom didn't let me play video games growing up, so now I do. Gaming gives me a chance to just let go, blow somebody up and fight somebody from another dimension. It's all escapism."
  },
  {
    "author": "Sean Hayes",
    "category": "mom",
    "id": 46911,
    "text": "When I came out of my mom's womb, I had 'sitcom' stamped on my forehead."
  },
  {
    "author": "Vince Gill",
    "category": "mom",
    "id": 46794,
    "text": "The real beauty of it - key to my life was playing key chords on a banjo. For somebody else it may be a golf club that mom and dad put in their hands or a baseball or ballet lessons. Real gift to give to me and put it in writing."
  },
  {
    "author": "Eliza Dushku",
    "category": "mom",
    "id": 46668,
    "text": "We didn't have a TV in the living room and all my friends thought we were kind of weird. When they'd come over, my mom wanted to talk to them about current events."
  },
  {
    "author": "Art Linkletter",
    "category": "mom",
    "id": 46228,
    "text": "I stand fearlessly for small dogs, the American Flag, motherhood and the Bible. That's why people love me."
  },
  {
    "author": "Holly Madison",
    "category": "mom",
    "id": 46675,
    "text": "I've always wanted to be a mom."
  },
  {
    "author": "Trey Anastasio",
    "category": "mom",
    "id": 46647,
    "text": "When I was growing up in New Jersey, my mom would regularly take my sister and I into the city to see shows. I have many fond memories of standing in the half-price ticket line in Times Square and going to matinees."
  },
  {
    "author": "Jessica Lange",
    "category": "mom",
    "id": 46146,
    "text": "The natural state of motherhood is unselfishness. When you become a mother, you are no longer the center of your own universe. You relinquish that position to your children."
  },
  {
    "author": "Mandy Patinkin",
    "category": "mom",
    "id": 46623,
    "text": "My mom was a great cook and great baker all her life."
  },
  {
    "author": "Busy Philipps",
    "category": "mom",
    "id": 46661,
    "text": "I'm somebody who doesn't work with a stylist. I'll be honest with you, I'm a mom and it's just not something I want to put money toward because it's expensive to have somebody who helps dress you and I feel like I have to pay for preschool and so many things... so I don't have a stylist."
  },
  {
    "author": "Melissa Bean",
    "category": "mom",
    "id": 46755,
    "text": "I am excited to rise today to support National Mom and Pop Business Owners Day. This celebration honors the husband and wife business owner teams whose work helps drive the economy and fuel job growth."
  },
  {
    "author": "Molly Sims",
    "category": "mom",
    "id": 46876,
    "text": "My mom FedExes a red velvet cake she makes from scratch to me every birthday."
  },
  {
    "author": "Gwen Stefani",
    "category": "mom",
    "id": 46388,
    "text": "Being a singer is all about me. About ego. Being a mom is all about being selfless - two different worlds."
  },
  {
    "author": "Jacqueline Emerson",
    "category": "mom",
    "id": 47062,
    "text": "When I was six years old my friend was auditioning for 'Annie,' and I decided I wanted to audition with her. My mom was worried I would fall flat on my face because I'd never opened my mouth to sing, so she sent me to vocal lessons. I did the audition and fell in love with the entire process of a show."
  },
  {
    "author": "Oliver Hudson",
    "category": "mom",
    "id": 46893,
    "text": "My mom is in her mid-60s and has more energy and is more youthful than any human being I know. It's pretty incredible."
  },
  {
    "author": "Shuler Hensley",
    "category": "mom",
    "id": 47101,
    "text": "My Mom is a ballet director, so I had this idea in me that classical training is the best foundation for anything you do, so I wanted to get a classical background and voice."
  },
  {
    "author": "Logan Marshall-Green",
    "category": "mom",
    "id": 47132,
    "text": "My mom introduced me to science-fiction."
  },
  {
    "author": "Christina Aguilera",
    "category": "mom",
    "id": 46297,
    "text": "Thankfully, I have my mom and a small group of close friends who are there for me 24/7 and whom I can trust and depend on."
  },
  {
    "author": "Tommy Franks",
    "category": "mom",
    "id": 47016,
    "text": "The military infrastructure grew me. My faith in God is important, my belief in my country is important, my relationship to my family is important, the things that Mom and Dad tell you growing up are important."
  },
  {
    "author": "Ashley Tisdale",
    "category": "mom",
    "id": 46354,
    "text": "I don't drink, and I don't smoke. It's a personal preference. My mom has never drunk or smoked. I look up to my mom."
  },
  {
    "author": "Caroline Wozniacki",
    "category": "mom",
    "id": 46724,
    "text": "One day my dad would say, 'OK, if you want to play tennis I can help you out.' And that's how it started. And I had a goal. I wanted to beat my mom first. And my parents and my brother. And that was the ultimate goal."
  },
  {
    "author": "Erma Bombeck",
    "category": "mom",
    "id": 46160,
    "text": "Who in their infinite wisdom decreed that Little League uniforms be white? Certainly not a mother."
  },
  {
    "author": "Kate Walsh",
    "category": "mom",
    "id": 46838,
    "text": "My mom, she's a breast cancer survivor and because of that I had started getting mammograms once a year, starting at age 30."
  },
  {
    "author": "Angela Kinsey",
    "category": "mom",
    "id": 46864,
    "text": "My very sassy, older southern sister is very quick to point out that it's a luxury that my daughter gets to come to work with me. She does, and I have lunch with her every single day. My mom says I have 'high class problems.'"
  },
  {
    "author": "Ashton Eaton",
    "category": "mom",
    "id": 47058,
    "text": "When I see my mom in the stands, it always pushes me to succeed."
  },
  {
    "author": "Jennifer Garner",
    "category": "mom",
    "id": 46478,
    "text": "My mom has always said that the one thing she wishes she had done differently is have a job. She felt like the single-mindedness made her a little nuts sometimes, and she could have used an outlet for herself when we were little."
  },
  {
    "author": "Jeffrey Kluger",
    "category": "mom",
    "id": 46436,
    "text": "The golden child may be the oldest one, unless it's the youngest. It may be the toughest one, unless it's the most sensitive. It's not even necessary that Mom and Dad have the same favorite - and typically they don't."
  },
  {
    "author": "Anna Chlumsky",
    "category": "mom",
    "id": 46644,
    "text": "From the very start of all of this, my mom has read the scripts first. And if she liked something, she let me read it. She told our agent what kinds of parts that we would want."
  },
  {
    "author": "Miranda Lambert",
    "category": "mom",
    "id": 46374,
    "text": "My mom always says I cut my teeth on the church pew."
  }
]

quotes['money'] = [
  {
    "author": "Beth Ditto",
    "category": "money",
    "id": 47957,
    "text": "'Get a Job' is about all the rich kids we knew when we were younger, kids who never had jobs but always had money for partying or getting their hair done."
  },
  {
    "author": "Bob Hope",
    "category": "money",
    "id": 47342,
    "text": "I love to go to Washington - if only to be near my money."
  },
  {
    "author": "Ice Cube",
    "category": "money",
    "id": 48007,
    "text": "When I was in N.W.A. and didn't get paid all the money I was owed, that's when the business side of showbiz hit me."
  },
  {
    "author": "Stanley Weiser",
    "category": "money",
    "id": 47221,
    "text": "A fool and his money are lucky enough to get together in the first place."
  },
  {
    "author": "Henry Ford",
    "category": "money",
    "id": 47380,
    "text": "Money is like an arm or leg - use it or lose it."
  },
  {
    "author": "John Ruskin",
    "category": "money",
    "id": 47144,
    "text": "A little thought and a little kindness are often worth more than a great deal of money."
  },
  {
    "author": "Justin Bieber",
    "category": "money",
    "id": 47802,
    "text": "I've got my eye on a few things to spend my money on. I've got my own bank card but I am really good with money. I don't spend too much at all."
  },
  {
    "author": "Jackie Kennedy",
    "category": "money",
    "id": 47604,
    "text": "I don't understand it. Jack will spend any amount of money to buy votes but he balks at investing a thousand dollars in a beautiful painting."
  },
  {
    "author": "Peter Singer",
    "category": "money",
    "id": 48023,
    "text": "We have a new generation of very rich people who want to do more with their money than buy a lot of expensive toys. They want to live meaningful lives."
  },
  {
    "author": "Henry Ford",
    "category": "money",
    "id": 47273,
    "text": "If money is your hope for independence you will never have it. The only real security that a man will have in this world is a reserve of knowledge, experience, and ability."
  },
  {
    "author": "Tony Campolo",
    "category": "money",
    "id": 48088,
    "text": "Getting the government to put money into social programs run by religious institutions is a practice that started during the Clinton years, when Bill Clinton advocated the AmeriCorps program."
  },
  {
    "author": "Donald Trump",
    "category": "money",
    "id": 47403,
    "text": "Money was never a big motivation for me, except as a way to keep score. The real excitement is playing the game."
  },
  {
    "author": "Karl Marx",
    "category": "money",
    "id": 47424,
    "text": "The writer must earn money in order to be able to live and to write, but he must by no means live and write for the purpose of making money."
  },
  {
    "author": "Ambrose Bierce",
    "category": "money",
    "id": 47465,
    "text": "Architect. One who drafts a plan of your house, and plans a draft of your money."
  },
  {
    "author": "Mario Puzo",
    "category": "money",
    "id": 47303,
    "text": "Friendship and money: oil and water."
  },
  {
    "author": "John Maynard Keynes",
    "category": "money",
    "id": 47203,
    "text": "Most men love money and security more, and creation and construction less, as they get older."
  },
  {
    "author": "Will Rogers",
    "category": "money",
    "id": 47350,
    "text": "If you make any money, the government shoves you in the creek once a year with it in your pockets, and all that don't get wet you can keep."
  },
  {
    "author": "Chloe Sevigny",
    "category": "money",
    "id": 47736,
    "text": "I definitely spend the most money on shoes, partly because vintage footwear can be a little funky - in a bad way. I like to keep things pretty simple up top and then go weird with the shoes."
  },
  {
    "author": "Jim Carrey",
    "category": "money",
    "id": 47527,
    "text": "The money can be a hindrance to someone like me because the danger is that you start thinking, 'Is that a $20 million take?' That kind of thing, and being self-critical."
  },
  {
    "author": "Thomas Fuller",
    "category": "money",
    "id": 47524,
    "text": "A drinker has a hole under his nose that all his money runs into."
  },
  {
    "author": "Jeff Foxworthy",
    "category": "money",
    "id": 47598,
    "text": "Find something in life that you love doing. If you make a lot of money, that's a bonus, and if you don't, you still won't hate going to work."
  },
  {
    "author": "Paul Ryan",
    "category": "money",
    "id": 47742,
    "text": "We need to stop spending money we don't have."
  },
  {
    "author": "Ogden Nash",
    "category": "money",
    "id": 47584,
    "text": "Certainly there are things in life that money can't buy, but it's very funny - Did you ever try buying then without money?"
  },
  {
    "author": "Placido Domingo",
    "category": "money",
    "id": 47222,
    "text": "If money was my only motivation, I would organize myself differently."
  },
  {
    "author": "David Duchovny",
    "category": "money",
    "id": 48011,
    "text": "I just spend my money on the essentials. Just basically food and shelter."
  },
  {
    "author": "Steve Forbes",
    "category": "money",
    "id": 47876,
    "text": "There is something fundamentally unfair about a government that takes away so much of people's money, power, and personal control while telling them that life will be better as a result."
  },
  {
    "author": "Mark Twain",
    "category": "money",
    "id": 47147,
    "text": "Honesty is the best policy - when there is money in it."
  },
  {
    "author": "Adam Smith",
    "category": "money",
    "id": 47420,
    "text": "Labour was the first price, the original purchase - money that was paid for all things. It was not by gold or by silver, but by labour, that all wealth of the world was originally purchased."
  },
  {
    "author": "Rick Perry",
    "category": "money",
    "id": 47863,
    "text": "You got to have a courageous president to stand up and says, listen, if - if you send a bill to me that spends more money than what we've coming in, I'll veto it. I mean, I'm going to try to work with you the best I can, but I'm going to veto it."
  },
  {
    "author": "Rick Perry",
    "category": "money",
    "id": 47918,
    "text": "I mean, Dodd-Frank is strangling small community banks. It doesn't make any difference what the interest rate is. They're not - they're not going to loan the money because they can't make any money for one thing plus the cost of compliance."
  },
  {
    "author": "Samuel Butler",
    "category": "money",
    "id": 47537,
    "text": "We shall never get people whose time is money to take much interest in atoms."
  },
  {
    "author": "Josh Billings",
    "category": "money",
    "id": 47651,
    "text": "It ain't often that a man's reputation outlasts his money."
  },
  {
    "author": "Francis Ford Coppola",
    "category": "money",
    "id": 48102,
    "text": "As long as I can make lots of money in other businesses, I'll continue to subsidize my own work."
  },
  {
    "author": "Oliver Herford",
    "category": "money",
    "id": 47666,
    "text": "A man must love a thing very much if he not only practices it without any hope of fame and money, but even... without any hope of doing it well."
  },
  {
    "author": "Gary Oldman",
    "category": "money",
    "id": 47729,
    "text": "Growing up in a particular neighborhood, growing up in a working-class family, not having much money, all of those things fire you and can give you an edge, can give you an anger."
  },
  {
    "author": "Iain Duncan Smith",
    "category": "money",
    "id": 47968,
    "text": "For those who are able to work, work has to be seen as the best route out of poverty. For work is not just about more money - it is transformative. It's about taking responsibility for yourself and your family."
  },
  {
    "author": "Michael Bloomberg",
    "category": "money",
    "id": 48047,
    "text": "You know, if you look back in the 1930s, the money went to infrastructure. The bridges, the municipal buildings, the roads, those were all built with stimulus money spent on infrastructure. This stimulus bill has fundamentally gone, started out with a $500 rebate check, remember. That went to buy flat-screen TVs made in China."
  },
  {
    "author": "Justin Bieber",
    "category": "money",
    "id": 47898,
    "text": "I grew up in a really small town with not a lot of money, and I liked singing, but it was just something that was a hobby."
  },
  {
    "author": "Arthur Rock",
    "category": "money",
    "id": 47240,
    "text": "You know, a lot of people are just interested in, in building a company so they can make money and get out."
  },
  {
    "author": "Barack Obama",
    "category": "money",
    "id": 47381,
    "text": "I know that campaigns can seem small, and even silly. Trivial things become big distractions. Serious issues become sound bites. And the truth gets buried under an avalanche of money and advertising. If you're sick of hearing me approve this message, believe me - so am I."
  },
  {
    "author": "Clare Boothe Luce",
    "category": "money",
    "id": 47170,
    "text": "A woman's best protection is a little money of her own."
  },
  {
    "author": "Michael Kors",
    "category": "money",
    "id": 47993,
    "text": "North Americans as a whole need to embrace having clothes altered to their body. I hear it all the time: why do the Europeans always look so good? They have a relationship with their tailor and spend the time and money to make their clothes look their best."
  },
  {
    "author": "Rose Kennedy",
    "category": "money",
    "id": 47795,
    "text": "It's our money, and we're free to spend it any way we please."
  },
  {
    "author": "Mignon McLaughlin",
    "category": "money",
    "id": 47509,
    "text": "There are a handful of people whom money won't spoil, and we all count ourselves among them."
  },
  {
    "author": "Craig Bruce",
    "category": "money",
    "id": 47882,
    "text": "Geez, all that money we waste on space exploration just think how many bombs that would buy!"
  },
  {
    "author": "Joel Osteen",
    "category": "money",
    "id": 47367,
    "text": "Prospering just doesn't have to do with money."
  },
  {
    "author": "Iain Duncan Smith",
    "category": "money",
    "id": 48137,
    "text": "Thankfully, due to the United Kingdom and the commitment of the Westminster government we are able to ensure that money brought in, whether it be from the City of London or from North Sea oil, can be pooled and directed to wherever it is needed most. That is what being in the United Kingdom is all about."
  },
  {
    "author": "Michael Caine",
    "category": "money",
    "id": 47837,
    "text": "Save your money. You're going to need twice as much money in your old age as you think."
  },
  {
    "author": "David Bailey",
    "category": "money",
    "id": 47865,
    "text": "To get rich, you have to be making money while you're asleep."
  },
  {
    "author": "William Blake",
    "category": "money",
    "id": 47479,
    "text": "Want of money and the distress of a thief can never be alleged as the cause of his thieving, for many honest people endure greater hardships with fortitude. We must therefore seek the cause elsewhere than in want of money, for that is the miser's passion, not the thief s."
  },
  {
    "author": "Kevin Costner",
    "category": "money",
    "id": 47890,
    "text": "Money isn't a major motivating force in my life. Nor is my profession. There are other things that I care more about than being an actor."
  },
  {
    "author": "Jonathan Sacks",
    "category": "money",
    "id": 47974,
    "text": "A survey carried out across the U.S. between 2004 and 2006 showed that frequent church- or synagogue-goers are more likely to give money to charity."
  },
  {
    "author": "Ang Lee",
    "category": "money",
    "id": 47938,
    "text": "If there's something that can be formulated, regulated, give you security, then nobody would lose money. Every movie would be successful. And that's certainly not the case."
  },
  {
    "author": "Kinky Friedman",
    "category": "money",
    "id": 47665,
    "text": "I've always said money may buy you a fine dog, but only love can make it wag its tail."
  },
  {
    "author": "Gore Vidal",
    "category": "money",
    "id": 47555,
    "text": "The more money an American accumulates, the less interesting he becomes."
  },
  {
    "author": "Paul Ryan",
    "category": "money",
    "id": 47585,
    "text": "If borrowing and spending all this money led to more jobs than we would be at full employment already."
  },
  {
    "author": "Ray Davies",
    "category": "money",
    "id": 47397,
    "text": "Money and corruption are ruining the land, crooked politicians betray the working man, pocketing the profits and treating us like sheep, and we're tired of hearing promises that we know they'll never keep."
  },
  {
    "author": "Coretta Scott King",
    "category": "money",
    "id": 47663,
    "text": "I'm fulfilled in what I do. I never thought that a lot of money or fine clothes - the finer things of life - would make you happy. My concept of happiness is to be filled in a spiritual sense."
  },
  {
    "author": "Mike Tyson",
    "category": "money",
    "id": 47416,
    "text": "I know why they don't like me because they want the money I have."
  },
  {
    "author": "Jon Cryer",
    "category": "money",
    "id": 48106,
    "text": "To avoid ignorance and bullying, I've had to hide the fact that I'm a troll. You have no idea how much time and money I've spent on electrolysis and hair dye and reconstructive surgery so I can look like this."
  },
  {
    "author": "Mario Batali",
    "category": "money",
    "id": 48135,
    "text": "The way the bankers have kind of toppled the way money is distributed, and taken most of it into their own hands, is as good as Stalin or Hitler."
  },
  {
    "author": "Abraham Lincoln",
    "category": "money",
    "id": 47256,
    "text": "I can make more generals, but horses cost money."
  },
  {
    "author": "Mitt Romney",
    "category": "money",
    "id": 47391,
    "text": "Now workers should have the right to join unions. But unions should not be forced upon workers. And unions should not have the power to take money our of their members' paychecks to buy the support of politicians that are favored by the union bosses."
  },
  {
    "author": "Muhammad Yunus",
    "category": "money",
    "id": 48063,
    "text": "I had no idea that I would ever get involved with something like lending money to poor people, given the circumstances in which I was working in Bangladesh."
  },
  {
    "author": "George Michael",
    "category": "money",
    "id": 47987,
    "text": "I've been very well remunerated for my talents over the years so I really don't need the public's money."
  },
  {
    "author": "Dave Davies",
    "category": "money",
    "id": 47849,
    "text": "I think that what went wrong with religion is the same thing that went wrong with politics. Is that it became too money based and too controlling. It's just a weakness that we human beings have for control - we want one thing and then we want more and then we want more."
  },
  {
    "author": "Willie Nelson",
    "category": "money",
    "id": 47866,
    "text": "I would like to see more airplay for all artists, no matter what age. I think there's a lot of money being spent toward the young guys, but a lot of the older guys are the ones who blazed the trail for those young guys."
  },
  {
    "author": "Jerry Saltz",
    "category": "money",
    "id": 47722,
    "text": "Now people look at 'The Scream' or Van Gogh's 'Irises' or a Picasso and see its new content: money. Auction houses inherently equate capital with value."
  },
  {
    "author": "Paul McCartney",
    "category": "money",
    "id": 47522,
    "text": "When you first get money, you buy all these things so no one thinks you're mean, and you spread it around. You get a chauffeur and you find yourself thrown around the back of this car and you think, I was happier when I had my own little car! I could drive myself!"
  },
  {
    "author": "Glenn Beck",
    "category": "money",
    "id": 47954,
    "text": "I'm a dad, and I no longer see a way for my kids to even inherit the money that I'm making, let alone go out there, have an idea, and create it in their own lifetime."
  },
  {
    "author": "Dan Millman",
    "category": "money",
    "id": 47738,
    "text": "Money is neither my god nor my devil. It is a form of energy that tends to make us more of who we already are, whether it's greedy or loving."
  },
  {
    "author": "Kevin Bacon",
    "category": "money",
    "id": 47431,
    "text": "I think one of the most pervasive evils in this world is greed and acquiring money for money's sake. Once you have six houses and a plane, it's just about a number. It's never been anything I understood."
  },
  {
    "author": "Donald Trump",
    "category": "money",
    "id": 47458,
    "text": "Love him or hate him, Trump is a man who is certain about what he wants and sets out to get it, no holds barred. Women find his power almost as much of a turn-on as his money."
  },
  {
    "author": "Shia LaBeouf",
    "category": "money",
    "id": 47819,
    "text": "At this point I have enough money to live 25 lifetimes. You couldn't spend the money I've accrued now."
  },
  {
    "author": "Walt Disney",
    "category": "money",
    "id": 47375,
    "text": "You reach a point where you don't work for money."
  },
  {
    "author": "Diane Kruger",
    "category": "money",
    "id": 48125,
    "text": "What counts in Hollywood is box office. It doesn't really matter what people think of you as an actor because, as long as you have been in a movie that has made money, you will always get another job."
  },
  {
    "author": "David Korten",
    "category": "money",
    "id": 47229,
    "text": "Money is a mechanism for control."
  },
  {
    "author": "Samuel Butler",
    "category": "money",
    "id": 47507,
    "text": "Brigands demand your money or your life women require both."
  },
  {
    "author": "Martin Scorsese",
    "category": "money",
    "id": 47808,
    "text": "I think there's only one or two films where I've had all the financial support I needed. All the rest, I wish I'd had the money to shoot another ten days."
  },
  {
    "author": "Adam Smith",
    "category": "money",
    "id": 47191,
    "text": "No complaint... is more common than that of a scarcity of money."
  },
  {
    "author": "Bobby Darin",
    "category": "money",
    "id": 47655,
    "text": "A group or an artist shouldn't get his money until his boss gets his."
  },
  {
    "author": "Freddie Mercury",
    "category": "money",
    "id": 47776,
    "text": "And, we have no such thing as a budget anymore. Our manager freaks when we show him the bill. We're lavish to the bone, but all our money goes back into the product."
  },
  {
    "author": "Alfred Marshall",
    "category": "money",
    "id": 47226,
    "text": "Civilized countries generally adopt gold or silver or both as money."
  },
  {
    "author": "Kim Kardashian",
    "category": "money",
    "id": 47627,
    "text": "I don't talk about money."
  },
  {
    "author": "Dean Kamen",
    "category": "money",
    "id": 47209,
    "text": "I'd rather lose my own money than someone else's."
  },
  {
    "author": "Robert Redford",
    "category": "money",
    "id": 47962,
    "text": "I don't know what your childhood was like, but we didn't have much money. We'd go to a movie on a Saturday night, then on Wednesday night my parents would walk us over to the library. It was such a big deal, to go in and get my own book."
  },
  {
    "author": "George Bernard Shaw",
    "category": "money",
    "id": 47327,
    "text": "We are the only real aristocracy in the world: the aristocracy of money."
  },
  {
    "author": "Kin Hubbard",
    "category": "money",
    "id": 47561,
    "text": "When a fellow says, 'It ain't the money but the principle of the thing,' it's the money."
  },
  {
    "author": "Angus Young",
    "category": "money",
    "id": 48136,
    "text": "I saw Deep Purple live once and I paid money for it and I thought, 'Geez, this is ridiculous.' You just see through all that sort of stuff. I never liked those Deep Purples or those sort of things. I always hated it. I always thought it was a poor man's Led Zeppelin."
  },
  {
    "author": "Steven Wright",
    "category": "money",
    "id": 47408,
    "text": "I went to the bank and asked to borrow a cup of money. They said, 'What for?' I said, 'I'm going to buy some sugar.'"
  },
  {
    "author": "Elvis Presley",
    "category": "money",
    "id": 47829,
    "text": "I like to sing ballads the way Eddie Fisher does and the way Perry Como does. But the way I'm singing now is what makes the money."
  },
  {
    "author": "Erykah Badu",
    "category": "money",
    "id": 47767,
    "text": "The music business is motivated by money. Music is motivated by energy and feelings."
  },
  {
    "author": "Abu Bakar Bashir",
    "category": "money",
    "id": 47818,
    "text": "Arab leaders worry more about making money from the profits they get from oil and gas that they turn the other way when Lebanon is being destroyed right next to them. Their neighbours are being murdered, but they only make calculations for their own benefit."
  },
  {
    "author": "James Taylor",
    "category": "money",
    "id": 48104,
    "text": "Time will take your money, but money won't buy time."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "money",
    "id": 47157,
    "text": "Many people take no care of their money till they come nearly to the end of it, and others do just the same with their time."
  },
  {
    "author": "Henry A. Wallace",
    "category": "money",
    "id": 48043,
    "text": "If we define an American fascist as one who in case of conflict puts money and power ahead of human beings, then there are undoubtedly several million fascists in the United States."
  },
  {
    "author": "Ron Paul",
    "category": "money",
    "id": 47377,
    "text": "A system of capitalism presumes sound money, not fiat money manipulated by a central bank. Capitalism cherishes voluntary contracts and interest rates that are determined by savings, not credit creation by a central bank."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "money",
    "id": 47399,
    "text": "The price we have to pay for money is sometimes liberty."
  },
  {
    "author": "Samuel Johnson",
    "category": "money",
    "id": 47517,
    "text": "You cannot spend money in luxury without doing good to the poor. Nay, you do more good to them by spending it in luxury, than by giving it for by spending it in luxury, you make them exert industry, whereas by giving it, you keep them idle."
  },
  {
    "author": "Stephen King",
    "category": "money",
    "id": 47582,
    "text": "Like anything else that happens on its own, the act of writing is beyond currency. Money is great stuff to have, but when it comes to the act of creation, the best thing is not to think of money too much. It constipates the whole process."
  }
]

quotes['morning'] = [
  {
    "author": "Maud Welzen",
    "category": "morning",
    "id": 48987,
    "text": "I like to eat yogurt in the morning. It's easy and quick and available anywhere."
  },
  {
    "author": "Eddie Campbell",
    "category": "morning",
    "id": 48843,
    "text": "I'm thinking to myself, I just love doing the art, it takes me a morning to do."
  },
  {
    "author": "Paul Hornung",
    "category": "morning",
    "id": 48595,
    "text": "Never get married in the morning - you never know who you might meet that night."
  },
  {
    "author": "Anne Tyler",
    "category": "morning",
    "id": 48539,
    "text": "The one ironclad rule is that I have to try. I have to walk into my writing room and pick up my pen every weekday morning."
  },
  {
    "author": "Nancy Kerrigan",
    "category": "morning",
    "id": 48702,
    "text": "It wasn't always easy getting up at 5 o'clock in the morning to go to the rink. Sometimes I wanted to just go back to sleep."
  },
  {
    "author": "Henry David Thoreau",
    "category": "morning",
    "id": 48219,
    "text": "All men are children, and of one family. The same tale sends them all to bed, and wakes them in the morning."
  },
  {
    "author": "Charlie Kimball",
    "category": "morning",
    "id": 49017,
    "text": "It takes more than driving to become an IndyCar driver. Gone are the days when drivers show up Friday morning and go home Sunday night. We're all integral to our partnerships, commercially, motorsports. We're as much champions in the boardroom as we are on the racetrack."
  },
  {
    "author": "George W. Bush",
    "category": "morning",
    "id": 48250,
    "text": "Freedom itself was attacked this morning by a faceless coward, and freedom will be defended."
  },
  {
    "author": "Ursula K. Le Guin",
    "category": "morning",
    "id": 48194,
    "text": "Morning comes whether you set the alarm or not."
  },
  {
    "author": "Beth Ditto",
    "category": "morning",
    "id": 48462,
    "text": "For me the greatest revenge of all is having a happy adulthood, waking up in my gorgeous turquoise bedroom in the morning beside a person who really inspires me. That's the best revenge a girl-loving girl from the Bible belt could possibly have. And, importantly, it's healthy."
  },
  {
    "author": "Molly Sims",
    "category": "morning",
    "id": 48775,
    "text": "I'm going to get up every morning at 6:30 to work out. Then, when I've kept with it all week, I give myself something I really want, like a new handbag or a piece of jewelry I'm coveting."
  },
  {
    "author": "Mika Brzezinski",
    "category": "morning",
    "id": 48574,
    "text": "I am up at 3:30, reading the op-ed pages and getting ready to be on the air by 6 A.M. on the set of 'Morning Joe,' and after three hours of TV and two hours on the radio, it is only 12 noon."
  },
  {
    "author": "Sholom Aleichem",
    "category": "morning",
    "id": 48280,
    "text": "A bachelor is a man who comes to work each morning from a different direction."
  },
  {
    "author": "Alan Dean Foster",
    "category": "morning",
    "id": 48787,
    "text": "I write early in the morning, usually after reading portions of at least half a dozen newspapers on the web."
  },
  {
    "author": "Jennifer Aniston",
    "category": "morning",
    "id": 48295,
    "text": "What inspires you, what excites you when you wake up in the morning?"
  },
  {
    "author": "Namie Amuro",
    "category": "morning",
    "id": 48554,
    "text": "Now, on nights that I can't sleep, I play video games alone until the morning."
  },
  {
    "author": "Peter Carey",
    "category": "morning",
    "id": 48846,
    "text": "At the very end of a book I can manage to work for longer stretches, but mostly, making stuff up for three hours, that's enough. I can't do any more. At the end of the day I might tinker with my morning's work and maybe write some again. But I think three hours is fine."
  },
  {
    "author": "Donald Evans",
    "category": "morning",
    "id": 48769,
    "text": "I am on my way to Ghana tomorrow morning and you just need to know that this Administration is very focused on doing all we can to promote economic development in this part of the world, in Africa, throughout Africa, North Africa and sub-Saharan Africa."
  },
  {
    "author": "Tom Jones",
    "category": "morning",
    "id": 48632,
    "text": "I think it's good that I had some experience of the real world before I became successful. You know, having to get up in the morning and going to work in construction."
  },
  {
    "author": "Haruki Murakami",
    "category": "morning",
    "id": 48427,
    "text": "Mere humans who root through their refrigerators at three o'clock in the morning can only produce writing that matches what they do. And that includes me."
  },
  {
    "author": "Henry David Thoreau",
    "category": "morning",
    "id": 48222,
    "text": "The light which puts out our eyes is darkness to us. Only that day dawns to which we are awake. There is more day to dawn. The sun is but a morning star."
  },
  {
    "author": "Paul Newman",
    "category": "morning",
    "id": 48346,
    "text": "You can't be as old as I am without waking up with a surprised look on your face every morning: 'Holy Christ, whaddya know - I'm still around!' It's absolutely amazing that I survived all the booze and smoking and the cars and the career."
  },
  {
    "author": "Du Fu",
    "category": "morning",
    "id": 48810,
    "text": "This morning's scene is good and fine, Long rain has not harmed the land."
  },
  {
    "author": "Meriwether Lewis",
    "category": "morning",
    "id": 48814,
    "text": "The rain, which had continued yesterday and last night, ceased this morning. We then proceeded, and after passing two small islands about ten miles further, stopped for the night at Piper's landing, opposite another island."
  },
  {
    "author": "Martha Plimpton",
    "category": "morning",
    "id": 48382,
    "text": "I am not a morning person. I like to sleep in."
  },
  {
    "author": "Florence King",
    "category": "morning",
    "id": 48857,
    "text": "Now the only thing I miss about sex is the cigarette afterward. Next to the first one in the morning, it's the best one of all. It tasted so good that even if I had been frigid I would have pretended otherwise just to be able to smoke it."
  },
  {
    "author": "Christopher Meloni",
    "category": "morning",
    "id": 48439,
    "text": "Look, I hate to sound like Pollyanna, but I literally can't wait to get to work in the morning. I've got steady jobs, I've got my health, and I'm here in the greatest city in the world. I'd be a pig not to be grateful."
  },
  {
    "author": "Benjamin Franklin",
    "category": "morning",
    "id": 48148,
    "text": "I wake up every morning at nine and grab for the morning paper. Then I look at the obituary page. If my name is not on it, I get up."
  },
  {
    "author": "Thomas Ken",
    "category": "morning",
    "id": 48981,
    "text": "Remember that God under the Law ordained a Lamb to be offered up to Him every Morning and Evening."
  },
  {
    "author": "Jackson Browne",
    "category": "morning",
    "id": 48687,
    "text": "I love to read. I love to stretch. In the morning, I get up, and if I'm not in a hurry, I will lie on the floor on a rug, look through some books and magazines, and maybe listen to music and try to do stretching exercises to tune up."
  },
  {
    "author": "Dinah Sheridan",
    "category": "morning",
    "id": 48880,
    "text": "I looked at films as a career from necessity but all I have really wanted is my home and children. The two things just do not work out together when one has to leave home at 5.30 am in the morning to go to the studio."
  },
  {
    "author": "Kevin Garnett",
    "category": "morning",
    "id": 48525,
    "text": "Too much coffee. Too much coffee and Gatorade. It's a hell of a mix. If you're ever tired in the morning, just try that mix, and tell me what you think."
  },
  {
    "author": "Ray Stevenson",
    "category": "morning",
    "id": 48935,
    "text": "Nobody wakes up in the morning thinking, 'I'm a bad guy.' They think they're the right guy."
  },
  {
    "author": "Erin Heatherton",
    "category": "morning",
    "id": 49001,
    "text": "I work out twice a day, once in the morning and once before bed. I'll start with half an hour of running and then some yoga to stretch everything out so everything is warm."
  },
  {
    "author": "Jean Claude Van Damme",
    "category": "morning",
    "id": 48336,
    "text": "You know, I looked at my face in the mirror this morning, and I like being old. My face has more content and when I train in the gym now, I am not training to be strong or handsome - just better than I was yesterday. These days the race is just against myself."
  },
  {
    "author": "Criss Angel",
    "category": "morning",
    "id": 48582,
    "text": "I had an amazing childhood, lots of love. But my dad worked his tail off, getting up at 4 in the morning and going off at 5, 6 o'clock, yet he always had time to spend with his kids and his wife."
  },
  {
    "author": "Kate Clinton",
    "category": "morning",
    "id": 48473,
    "text": "I want to host a religious show. I'm sure nobody will be wanting the 11 o'clock spot on Sunday morning. I think we should really get some of our own preachers and preach that gay is good. And we'd have a great choir."
  },
  {
    "author": "Russell Crowe",
    "category": "morning",
    "id": 48483,
    "text": "My days, if they start in the morning with a cuddle from my son, are just so much more glorious than they were prior to that."
  },
  {
    "author": "Marsha Sinetar",
    "category": "morning",
    "id": 48233,
    "text": "Burning desire to be or do something gives us staying power - a reason to get up every morning or to pick ourselves up and start in again after a disappointment."
  },
  {
    "author": "Karl Philipp Moritz",
    "category": "morning",
    "id": 48763,
    "text": "My host at Richmond, yesterday morning, could not sufficiently express his surprise that I intended to venture to walk as far as Oxford, and still farther. He however was so kind as to send his son, a clever little boy, to show me the road leading to Windsor."
  },
  {
    "author": "Anne Sullivan",
    "category": "morning",
    "id": 48316,
    "text": "My heart is singing for joy this morning! A miracle has happened! The light of understanding has shone upon my little pupil's mind, and behold, all things are changed!"
  },
  {
    "author": "Jodi Picoult",
    "category": "morning",
    "id": 48237,
    "text": "I woke up one morning thinking about wolves and realized that wolf packs function as families. Everyone has a role, and if you act within the parameters of your role, the whole pack succeeds, and when that falls apart, so does the pack."
  },
  {
    "author": "Vivienne Westwood",
    "category": "morning",
    "id": 48333,
    "text": "In the morning, I practice 15 minutes of yoga."
  },
  {
    "author": "Shimon Peres",
    "category": "morning",
    "id": 48443,
    "text": "Early in the morning, I fell in love with the girl that later on became my wife. At that time, we were so naive. I wanted to charm her, so I read her Capital by Marx. I thought somehow she would be convinced by the strength of his criticism about capital."
  },
  {
    "author": "Lesley Gore",
    "category": "morning",
    "id": 48900,
    "text": "I think I turned to writing really just to wake up in the morning and be a musician and to have something to do, and feel like a musician every day even if I wasn't working."
  },
  {
    "author": "Anne Morrow Lindbergh",
    "category": "morning",
    "id": 48174,
    "text": "Arranging a bowl of flowers in the morning can give a sense of quiet in a crowded day - like writing a poem or saying a prayer."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "morning",
    "id": 48395,
    "text": "I should just put it bluntly, because we're all sort of friends here now - it's exceedingly likely that my greatest success is behind me. Oh, so Jesus, what a thought! You know that's the kind of thought that could lead a person to start drinking gin at nine o'clock in the morning, and I don't want to go there."
  },
  {
    "author": "Taylor Lautner",
    "category": "morning",
    "id": 48601,
    "text": "You show up in Paris, and on the drive from the airport to the hotel you're like, 'This is so cool! I want to see something! I want to go to the Eiffel Tower!' And then you leave the next morning. You think, Oh, I didn't get to do anything. I tell people: I've been just about everywhere, but I've seen nothing."
  },
  {
    "author": "Victoria Abril",
    "category": "morning",
    "id": 48745,
    "text": "I went to dance classes from 9 in the morning until 1, then to school from 3 to 10 at night, always under the threat that if I failed a single course I could forget about dancing."
  },
  {
    "author": "Chris Elliott",
    "category": "morning",
    "id": 48983,
    "text": "That's what keeps me up at three in the morning: Who's looking at reviews of Cabin Boy right now?"
  },
  {
    "author": "Shepard Smith",
    "category": "morning",
    "id": 48760,
    "text": "In New York, I like it when you can get bagels at 3 in the morning."
  },
  {
    "author": "Demi Lovato",
    "category": "morning",
    "id": 48352,
    "text": "I pray every night before I go to sleep and every morning when I wake up."
  },
  {
    "author": "Gaston Bachelard",
    "category": "morning",
    "id": 48524,
    "text": "The repose of sleep refreshes only the body. It rarely sets the soul at rest. The repose of the night does not belong to us. It is not the possession of our being. Sleep opens within us an inn for phantoms. In the morning we must sweep out the shadows."
  },
  {
    "author": "Robert Forster",
    "category": "morning",
    "id": 48901,
    "text": "Well, you know what? The actor still gets up in the morning, if he's still got something to work with, you go out there and you do it. Never quit!"
  },
  {
    "author": "David Hockney",
    "category": "morning",
    "id": 48332,
    "text": "I draw flowers every day and send them to my friends so they get fresh blooms every morning."
  },
  {
    "author": "Emanuel Cleaver",
    "category": "morning",
    "id": 48870,
    "text": "Hope is the motivation that empowers the unemployed, enabling them to get out of bed every single morning with unbounded enthusiasm as they look for work."
  },
  {
    "author": "Andrea Jung",
    "category": "morning",
    "id": 48334,
    "text": "There are pros and cons of experience. A con is that you can't look at the business with a fresh pair of eyes and as objectively as if you were a new CEO. Fire yourself on a Friday night and come in on Monday morning as if a search firm put you there as a turn-around leader. Can you be objective and make the bold change?"
  },
  {
    "author": "David Mamet",
    "category": "morning",
    "id": 48396,
    "text": "There's nothing in the world more silent than the telephone the morning after everybody pans your play. It won't ring from room service your mother won't be calling you. If the phone has not rung by 8 in the morning, you're dead."
  },
  {
    "author": "Frances O'Grady",
    "category": "morning",
    "id": 48422,
    "text": "As long as the number one worry for people, keeping them up at nights, is whether they're going to have a job in the morning, then they are less likely to resist unfair changes, or unfair treatment, or cuts in real pay at work."
  },
  {
    "author": "John Cheever",
    "category": "morning",
    "id": 48198,
    "text": "It was a splendid summer morning and it seemed as if nothing could go wrong."
  },
  {
    "author": "Philip Pullman",
    "category": "morning",
    "id": 48535,
    "text": "What I couldn't help noticing was that I learned more about the novel in a morning by trying to write a page of one than I'd learned in seven years or so of trying to write criticism."
  },
  {
    "author": "Drew Brees",
    "category": "morning",
    "id": 48329,
    "text": "I obviously take a lot of pride in what I do on the football field, because that has the ability to influence a lot of people. That puts smiles on people's faces. That gives people a pep in their step on Monday morning when they go back to work."
  },
  {
    "author": "Benjamin Netanyahu",
    "category": "morning",
    "id": 48398,
    "text": "There is a fundamental situation in which the country has reached rock bottom, that a mother can't send her children out of the house in the morning. The country has reached rock bottom and this needs to be changed."
  },
  {
    "author": "Clayton Christensen",
    "category": "morning",
    "id": 48905,
    "text": "Each of our children during their high school years went to 'early morning seminary' - scripture study classes that met in the home of a church member every school day morning from 6:30 until 7:15."
  },
  {
    "author": "Ernie Banks",
    "category": "morning",
    "id": 48507,
    "text": "When I wake up in the morning, I feel like a billionaire without paying taxes."
  },
  {
    "author": "Carlos Fuentes",
    "category": "morning",
    "id": 48565,
    "text": "I am a morning writer I am writing at eight-thirty in longhand and I keep at it until twelve-thirty, when I go for a swim. Then I come back, have lunch, and read in the afternoon until I take my walk for the next day's writing."
  },
  {
    "author": "Tom Lantos",
    "category": "morning",
    "id": 48832,
    "text": "Hezbollah's contempt for human suffering is total, as it showed once again this morning when its rockets murdered two Israeli Arab children in Nazareth."
  },
  {
    "author": "Adelbert von Chamisso",
    "category": "morning",
    "id": 48879,
    "text": "My first care the following morning was, to devise some means of discovering the man in the grey cloak."
  },
  {
    "author": "Lars Ulrich",
    "category": "morning",
    "id": 48929,
    "text": "If there was no Black Sabbath, I could still possibly be a morning newspaper delivery boy. No fun."
  },
  {
    "author": "Jayma Mays",
    "category": "morning",
    "id": 48909,
    "text": "This morning I was laughing at my cat who was running up the stairs and slipped, and pretended like it didn't happen."
  },
  {
    "author": "Jackie Cooper",
    "category": "morning",
    "id": 48798,
    "text": "I would also like to act, once in a while, but not get up every morning at 5:30 or six o'clock and pound into the studio and get home at 7:30 or eight o'clock at night, or act over and over and over every night on Broadway, either."
  },
  {
    "author": "Cindy Crawford",
    "category": "morning",
    "id": 48354,
    "text": "But I try to steal other moments. Sometimes I get up very early in the morning and enjoy a quiet house and cup of tea before the craziness begins. Other times, I'll take a quick walk on the beach. You can find peace in a few minutes."
  },
  {
    "author": "Nicki Minaj",
    "category": "morning",
    "id": 48489,
    "text": "When I get up in the morning and put on a pink or a green wig, I see myself as a piece of animation. It lets me be the person I want to be, a person who's not embarrassed to have fun."
  },
  {
    "author": "Marlo Thomas",
    "category": "morning",
    "id": 48195,
    "text": "Never face facts if you do you'll never get up in the morning."
  },
  {
    "author": "Norton Juster",
    "category": "morning",
    "id": 48902,
    "text": "I write best in the morning, and I can only write for about half a day, that's about it."
  },
  {
    "author": "Jonathan Swift",
    "category": "morning",
    "id": 48292,
    "text": "I never knew a man come to greatness or eminence who lay abed late in the morning."
  },
  {
    "author": "Pete Hamill",
    "category": "morning",
    "id": 48449,
    "text": "I don't ask for the meaning of the song of a bird or the rising of the sun on a misty morning. There they are, and they are beautiful."
  },
  {
    "author": "George Ade",
    "category": "morning",
    "id": 48410,
    "text": "It is not time for mirth and laughter, the cold, gray dawn of the morning after."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "morning",
    "id": 48492,
    "text": "Couldn't start the morning without caffeine."
  },
  {
    "author": "Michelle Kwan",
    "category": "morning",
    "id": 48824,
    "text": "I got a call this morning, and it was from Nancy Kerrigan, wishing me luck. She wished me luck and sent me all her good wishes."
  },
  {
    "author": "William John Wills",
    "category": "morning",
    "id": 48736,
    "text": "We have this morning dropped anchor, just off Williamstown."
  },
  {
    "author": "Alice Cooper",
    "category": "morning",
    "id": 48300,
    "text": "The two most joyous times of the year are Christmas morning and the end of school."
  },
  {
    "author": "Kathy Griffin",
    "category": "morning",
    "id": 48505,
    "text": "It is a challenge, with the global fame, to try to act like I put my pants on one leg at a time, when in fact I have Pippa Middleton help me put my pants on every morning. She's my lady-in-waiting as well."
  },
  {
    "author": "David Eddings",
    "category": "morning",
    "id": 48886,
    "text": "I get up at an unholy hour in the morning my work day is completed by the time the sun rises. I have a slightly bad back which has made an enormous contribution to American literature."
  },
  {
    "author": "Regis Philbin",
    "category": "morning",
    "id": 48691,
    "text": "It means a lot in my business and its a wonderful feeling to be recognized for what you have done over a lifetime, but I didn't go crazy. I still eat my cereal in the morning, have a sandwich in the afternoon, go to bed at night. You know, nothing really different."
  },
  {
    "author": "Lesley Gore",
    "category": "morning",
    "id": 48899,
    "text": "I don't know any other lifestyle. I get up in the morning and I really do feel that the world is my oyster, and I start that way, the same as I would if I were preparing to write a song: put a blank piece of paper up on the piano and you go for it."
  },
  {
    "author": "Gavin MacLeod",
    "category": "morning",
    "id": 48771,
    "text": "We were making new ones the second year. We were in syndication the second year. So we were on Saturday nights, prime time, every morning, and then they put it on Sunday evenings too. So it was all over the place."
  },
  {
    "author": "Billy Wilder",
    "category": "morning",
    "id": 48308,
    "text": "You have to have a dream so you can get up in the morning."
  },
  {
    "author": "Baz Luhrmann",
    "category": "morning",
    "id": 48608,
    "text": "Sydney in general is eclectic. You can be on that brilliant blue ocean walk in the morning and then within 20 minutes you can be in a completely vast suburban sprawl or an Italian or Asian suburb, and it's that mix of people, it's that melting pot of people that give it its vital personality."
  },
  {
    "author": "Mitch Hedberg",
    "category": "morning",
    "id": 48224,
    "text": "I recently took up ice sculpting. Last night I made an ice cube. This morning I made 12, I was prolific."
  },
  {
    "author": "Robertson Davies",
    "category": "morning",
    "id": 48442,
    "text": "A truly great book should be read in youth, again in maturity and once more in old age, as a fine building should be seen by morning light, at noon and by moonlight."
  },
  {
    "author": "George Washington Carver",
    "category": "morning",
    "id": 48170,
    "text": "Nothing is more beautiful than the loveliness of the woods before sunrise."
  },
  {
    "author": "Drew Barrymore",
    "category": "morning",
    "id": 48317,
    "text": "I still, at hotel rooms, I do this one sort of not-so-cool thing: continually shoving my room service tray in front of someone else's door. Because I don't want the remnants. I don't want to be caught, like, being like the pig that I was at two in the morning."
  },
  {
    "author": "Lewis Black",
    "category": "morning",
    "id": 48272,
    "text": "And I know this happens because I took economics, and I'd explain it to ya, but I flunked that course. Not my fault. They taught it at 8 o'clock in the morning. And there is absolutely nothing you can learn out of one bloodshot eye."
  },
  {
    "author": "Yoko Ono",
    "category": "morning",
    "id": 48296,
    "text": "Smile in the mirror. Do that every morning and you'll start to see a big difference in your life."
  },
  {
    "author": "Jeb Bush",
    "category": "morning",
    "id": 48477,
    "text": "I don't wake up each morning saying, 'Oh, wow, it's me. I think I'm the cat's meow. I'm the best.'"
  },
  {
    "author": "Harrison Ford",
    "category": "morning",
    "id": 48471,
    "text": "What is news? It's hard to quantify. Certainly news has changed completely, and the morning shows are not really designed to bring you the news, except to tell you what happened overnight, and the rest of it is a kind of magazine mentality - a little bit of this, a little bit of that. It's harder to be an educated and informed citizen."
  },
  {
    "author": "John Hawkes",
    "category": "morning",
    "id": 48513,
    "text": "Hitchhiking was such a pure form of existence. You'd wake up in the morning, and you'd have no idea what your day was going to be. And that's something I've never been able to shake. I loved that."
  },
  {
    "author": "Heraclitus",
    "category": "morning",
    "id": 48150,
    "text": "The sun is new each day."
  },
  {
    "author": "Dick Gregory",
    "category": "morning",
    "id": 48404,
    "text": "When I first broke through, there was only NBC, CBS and ABC, and they had news in the morning and in the evening - there wasn't no 24-hour news."
  }
]

quotes['motivational'] = [
  {
    "author": "Orison Swett Marden",
    "category": "motivational",
    "id": 49115,
    "text": "We make the world we live in and shape our own environment."
  },
  {
    "author": "Gordon B. Hinckley",
    "category": "motivational",
    "id": 49112,
    "text": "Without hard work, nothing grows but weeds."
  },
  {
    "author": "Dale Carnegie",
    "category": "motivational",
    "id": 49060,
    "text": "If you want to conquer fear, don't sit home and think about it. Go out and get busy."
  },
  {
    "author": "Epictetus",
    "category": "motivational",
    "id": 49105,
    "text": "Only the educated are free."
  },
  {
    "author": "Helen Keller",
    "category": "motivational",
    "id": 49038,
    "text": "Optimism is the faith that leads to achievement. Nothing can be done without hope and confidence."
  },
  {
    "author": "Walter Elliot",
    "category": "motivational",
    "id": 49098,
    "text": "Perseverance is not a long race it is many short races one after the other."
  },
  {
    "author": "Robert H. Schuller",
    "category": "motivational",
    "id": 49068,
    "text": "Problems are not stop signs, they are guidelines."
  },
  {
    "author": "Wayne Dyer",
    "category": "motivational",
    "id": 49033,
    "text": "Be miserable. Or motivate yourself. Whatever has to be done, it's always your choice."
  },
  {
    "author": "Muhammad Iqbal",
    "category": "motivational",
    "id": 49126,
    "text": "The ultimate aim of the ego is not to see something, but to be something."
  },
  {
    "author": "C. S. Lewis",
    "category": "motivational",
    "id": 49029,
    "text": "You are never too old to set another goal or to dream a new dream."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "motivational",
    "id": 49110,
    "text": "To be wholly devoted to some intellectual exercise is to have succeeded in life."
  },
  {
    "author": "Mark Caine",
    "category": "motivational",
    "id": 49079,
    "text": "The first step toward success is taken when you refuse to be a captive of the environment in which you first find yourself."
  },
  {
    "author": "John W. Gardner",
    "category": "motivational",
    "id": 49070,
    "text": "True happiness involves the full use of one's power and talents."
  },
  {
    "author": "Og Mandino",
    "category": "motivational",
    "id": 49034,
    "text": "Always do your best. What you plant now, you will harvest later."
  },
  {
    "author": "Ella Wheeler Wilcox",
    "category": "motivational",
    "id": 49036,
    "text": "Always continue the climb. It is possible for you to do whatever you choose, if you first get to know who you are and are willing to work with a power that is greater than ourselves to do it."
  },
  {
    "author": "Christopher Morley",
    "category": "motivational",
    "id": 49133,
    "text": "Big shots are only little shots who keep shooting."
  },
  {
    "author": "Rupert Murdoch",
    "category": "motivational",
    "id": 49096,
    "text": "In motivating people, you've got to engage their minds and their hearts. I motivate people, I hope, by example - and perhaps by excitement, by having productive ideas to make others feel involved."
  },
  {
    "author": "Bobby Knight",
    "category": "motivational",
    "id": 49119,
    "text": "The will to succeed is important, but what's more important is the will to prepare."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "motivational",
    "id": 49076,
    "text": "Never complain and never explain."
  },
  {
    "author": "Albert Einstein",
    "category": "motivational",
    "id": 49045,
    "text": "You have to learn the rules of the game. And then you have to play better than anyone else."
  },
  {
    "author": "Baltasar Gracian",
    "category": "motivational",
    "id": 49114,
    "text": "The wise does at once what the fool does at last."
  },
  {
    "author": "Jack London",
    "category": "motivational",
    "id": 49104,
    "text": "You can't wait for inspiration. You have to go after it with a club."
  },
  {
    "author": "Saint Teresa of Avila",
    "category": "motivational",
    "id": 49063,
    "text": "Be gentle to all and stern with yourself."
  },
  {
    "author": "Wayne Dyer",
    "category": "motivational",
    "id": 49097,
    "text": "Go for it now. The future is promised to no one."
  },
  {
    "author": "Carl Sandburg",
    "category": "motivational",
    "id": 49111,
    "text": "To be a good loser is to learn how to win."
  },
  {
    "author": "Denis Waitley",
    "category": "motivational",
    "id": 49039,
    "text": "Learn from the past, set vivid, detailed goals for the future, and live in the only moment of time over which you have any control: now."
  },
  {
    "author": "George S. Patton",
    "category": "motivational",
    "id": 49093,
    "text": "You need to overcome the tug of people against you as you reach for high goals."
  },
  {
    "author": "Mark Twain",
    "category": "motivational",
    "id": 49054,
    "text": "The secret of getting ahead is getting started."
  },
  {
    "author": "Michael Korda",
    "category": "motivational",
    "id": 49125,
    "text": "One way to keep momentum going is to have constantly greater goals."
  },
  {
    "author": "Thomas Jefferson",
    "category": "motivational",
    "id": 49041,
    "text": "Do you want to know who you are? Don't ask. Act! Action will delineate and define you."
  },
  {
    "author": "Katharine Hepburn",
    "category": "motivational",
    "id": 49057,
    "text": "We are taught you must blame your father, your sisters, your brothers, the school, the teachers - but never blame yourself. It's never your fault. But it's always your fault, because if you wanted to change you're the one who has got to change."
  },
  {
    "author": "Baruch Spinoza",
    "category": "motivational",
    "id": 49130,
    "text": "Do not weep do not wax indignant. Understand."
  },
  {
    "author": "Natalie Gulbis",
    "category": "motivational",
    "id": 49087,
    "text": "When you fail you learn from the mistakes you made and it motivates you to work even harder."
  },
  {
    "author": "Benjamin Franklin",
    "category": "motivational",
    "id": 49044,
    "text": "By failing to prepare, you are preparing to fail."
  },
  {
    "author": "Walt Disney",
    "category": "motivational",
    "id": 49040,
    "text": "If you can dream it, you can do it."
  },
  {
    "author": "Mia Hamm",
    "category": "motivational",
    "id": 49066,
    "text": "I've worked too hard and too long to let anything stand in the way of my goals. I will not let my teammates down and I will not let myself down."
  },
  {
    "author": "Eliza Dushku",
    "category": "motivational",
    "id": 49102,
    "text": "Go big or go home. Because it's true. What do you have to lose?"
  },
  {
    "author": "Jim Carrey",
    "category": "motivational",
    "id": 49121,
    "text": "If you've got a talent, protect it."
  },
  {
    "author": "John F. Kennedy",
    "category": "motivational",
    "id": 49051,
    "text": "Things do not happen. Things are made to happen."
  },
  {
    "author": "Sophocles",
    "category": "motivational",
    "id": 49081,
    "text": "Who seeks shall find."
  },
  {
    "author": "Robert H. Schuller",
    "category": "motivational",
    "id": 49074,
    "text": "I'd rather attempt to do something great and fail than to attempt to do nothing and succeed."
  },
  {
    "author": "Henry David Thoreau",
    "category": "motivational",
    "id": 49052,
    "text": "What you get by achieving your goals is not as important as what you become by achieving your goals."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "motivational",
    "id": 49099,
    "text": "Motivation is the art of getting people to do what you want them to do because they want to do it."
  },
  {
    "author": "Ken Venturi",
    "category": "motivational",
    "id": 49035,
    "text": "I don't believe you have to be better than everybody else. I believe you have to be better than you ever thought you could be."
  },
  {
    "author": "Brian Tracy",
    "category": "motivational",
    "id": 49116,
    "text": "I've found that luck is quite predictable. If you want more luck, take more chances. Be more active. Show up more often."
  },
  {
    "author": "Victor Kiam",
    "category": "motivational",
    "id": 49042,
    "text": "Even if you fall on your face, you're still moving forward."
  },
  {
    "author": "Elbert Hubbard",
    "category": "motivational",
    "id": 49082,
    "text": "Do your work with your whole heart, and you will succeed - there's so little competition."
  },
  {
    "author": "Jim Rohn",
    "category": "motivational",
    "id": 49026,
    "text": "If you don't design your own life plan, chances are you'll fall into someone else's plan. And guess what they have planned for you? Not much."
  },
  {
    "author": "Dan Millman",
    "category": "motivational",
    "id": 49113,
    "text": "I learned that we can do anything, but we can't do everything... at least not at the same time. So think of your priorities not in terms of what activities you do, but when you do them. Timing is everything."
  },
  {
    "author": "Woodrow Wilson",
    "category": "motivational",
    "id": 49106,
    "text": "You are not here merely to make a living. You are here in order to enable the world to live more amply, with greater vision, with a finer spirit of hope and achievement. You are here to enrich the world, and you impoverish yourself if you forget the errand."
  },
  {
    "author": "John Burroughs",
    "category": "motivational",
    "id": 49128,
    "text": "If you think you can do it, you can."
  },
  {
    "author": "Nikos Kazantzakis",
    "category": "motivational",
    "id": 49069,
    "text": "In order to succeed, we must first believe that we can."
  },
  {
    "author": "Muhammad Ali",
    "category": "motivational",
    "id": 49048,
    "text": "I know where I'm going and I know the truth, and I don't have to be what you want me to be. I'm free to be what I want."
  },
  {
    "author": "Henry Ford",
    "category": "motivational",
    "id": 49080,
    "text": "You can't build a reputation on what you are going to do."
  },
  {
    "author": "Henry David Thoreau",
    "category": "motivational",
    "id": 49085,
    "text": "What is called genius is the abundance of life and health."
  },
  {
    "author": "Sophocles",
    "category": "motivational",
    "id": 49059,
    "text": "Always desire to learn something useful."
  },
  {
    "author": "Albert Camus",
    "category": "motivational",
    "id": 49092,
    "text": "To know oneself, one should assert oneself."
  },
  {
    "author": "Benjamin Franklin",
    "category": "motivational",
    "id": 49055,
    "text": "Well done is better than well said."
  },
  {
    "author": "Richard Rorty",
    "category": "motivational",
    "id": 49131,
    "text": "There is nothing deep down inside us except what we have put there ourselves."
  },
  {
    "author": "Dean Koontz",
    "category": "motivational",
    "id": 49120,
    "text": "I really believe that everyone has a talent, ability, or skill that he can mine to support himself and to succeed in life."
  },
  {
    "author": "Dalai Lama",
    "category": "motivational",
    "id": 49023,
    "text": "Be kind whenever possible. It is always possible."
  },
  {
    "author": "Confucius",
    "category": "motivational",
    "id": 49031,
    "text": "The will to win, the desire to succeed, the urge to reach your full potential... these are the keys that will unlock the door to personal excellence."
  },
  {
    "author": "Jim Elliot",
    "category": "motivational",
    "id": 49108,
    "text": "Wherever you are - be all there."
  },
  {
    "author": "Leo Buscaglia",
    "category": "motivational",
    "id": 49073,
    "text": "Your talent is God's gift to you. What you do with it is your gift back to God."
  },
  {
    "author": "Jim Rohn",
    "category": "motivational",
    "id": 49046,
    "text": "Either you run the day or the day runs you."
  },
  {
    "author": "Golda Meir",
    "category": "motivational",
    "id": 49127,
    "text": "The dog that trots about finds a bone."
  },
  {
    "author": "Flip Wilson",
    "category": "motivational",
    "id": 49118,
    "text": "You can't expect to hit the jackpot if you don't put a few nickels in the machine."
  },
  {
    "author": "Amelia Earhart",
    "category": "motivational",
    "id": 49089,
    "text": "The most effective way to do it, is to do it."
  },
  {
    "author": "William James",
    "category": "motivational",
    "id": 49047,
    "text": "Act as if what you do makes a difference. It does."
  },
  {
    "author": "Thomas Paine",
    "category": "motivational",
    "id": 49071,
    "text": "The harder the conflict, the more glorious the triumph."
  },
  {
    "author": "Miguel Angel Ruiz",
    "category": "motivational",
    "id": 49049,
    "text": "Be Impeccable With Your Word. Speak with integrity. Say only what you mean. Avoid using the word to speak against yourself or to gossip about others. Use the power of your word in the direction of truth and love."
  },
  {
    "author": "Thomas Fuller",
    "category": "motivational",
    "id": 49129,
    "text": "One may miss the mark by aiming too high as too low."
  },
  {
    "author": "Matthew Henry",
    "category": "motivational",
    "id": 49028,
    "text": "After a storm comes a calm."
  },
  {
    "author": "Alfred A. Montapert",
    "category": "motivational",
    "id": 49037,
    "text": "Expect problems and eat them for breakfast."
  },
  {
    "author": "John Burroughs",
    "category": "motivational",
    "id": 49088,
    "text": "Leap, and the net will appear."
  },
  {
    "author": "Peter Marshall",
    "category": "motivational",
    "id": 49107,
    "text": "Small deeds done are better than great deeds planned."
  },
  {
    "author": "Aristotle",
    "category": "motivational",
    "id": 49062,
    "text": "Quality is not an act, it is a habit."
  },
  {
    "author": "Baltasar Gracian",
    "category": "motivational",
    "id": 49084,
    "text": "Know or listen to those who know."
  },
  {
    "author": "John Donne",
    "category": "motivational",
    "id": 49117,
    "text": "Be thine own palace, or the world's thy jail."
  },
  {
    "author": "Ted Turner",
    "category": "motivational",
    "id": 49095,
    "text": "You can never quit. Winners never quit, and quitters never win."
  },
  {
    "author": "Thomas Jefferson",
    "category": "motivational",
    "id": 49050,
    "text": "Determine never to be idle. No person will have occasion to complain of the want of time who never loses any. It is wonderful how much may be done if we are always doing."
  },
  {
    "author": "Cicely Tyson",
    "category": "motivational",
    "id": 49132,
    "text": "You never know what motivates you."
  },
  {
    "author": "Jessica Savitch",
    "category": "motivational",
    "id": 49109,
    "text": "No matter how many goals you have achieved, you must set your sights on a higher one."
  },
  {
    "author": "Ayn Rand",
    "category": "motivational",
    "id": 49025,
    "text": "A creative man is motivated by the desire to achieve, not by the desire to beat others."
  },
  {
    "author": "Epictetus",
    "category": "motivational",
    "id": 49043,
    "text": "The key is to keep company only with people who uplift you, whose presence calls forth your best."
  },
  {
    "author": "Tony Robbins",
    "category": "motivational",
    "id": 49077,
    "text": "Setting goals is the first step in turning the invisible into the visible."
  },
  {
    "author": "Baruch Spinoza",
    "category": "motivational",
    "id": 49100,
    "text": "Fear cannot be without hope nor hope without fear."
  },
  {
    "author": "Eileen Caddy",
    "category": "motivational",
    "id": 49064,
    "text": "Set your sights high, the higher the better. Expect the most wonderful things to happen, not in the future but right now. Realize that nothing is too good. Allow absolutely nothing to hamper you or hold you up in any way."
  },
  {
    "author": "Donna Brazile",
    "category": "motivational",
    "id": 49124,
    "text": "I was motivated to be different in part because I was different."
  },
  {
    "author": "Bradley Whitford",
    "category": "motivational",
    "id": 49090,
    "text": "Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth."
  },
  {
    "author": "Sasha Cohen",
    "category": "motivational",
    "id": 49058,
    "text": "Follow your dreams, work hard, practice and persevere. Make sure you eat a variety of foods, get plenty of exercise and maintain a healthy lifestyle."
  },
  {
    "author": "Philip Emeagwali",
    "category": "motivational",
    "id": 49086,
    "text": "The hardships that I encountered in the past will help me succeed in the future."
  },
  {
    "author": "Simone Weil",
    "category": "motivational",
    "id": 49103,
    "text": "I can, therefore I am."
  },
  {
    "author": "John D. Rockefeller",
    "category": "motivational",
    "id": 49056,
    "text": "If you want to succeed you should strike out on new paths, rather than travel the worn paths of accepted success."
  },
  {
    "author": "William James",
    "category": "motivational",
    "id": 49091,
    "text": "Begin to be now what you will be hereafter."
  },
  {
    "author": "Emile Zola",
    "category": "motivational",
    "id": 49065,
    "text": "If you ask me what I came into this life to do, I will tell you: I came to live out loud."
  },
  {
    "author": "Sylvia Browne",
    "category": "motivational",
    "id": 49122,
    "text": "The weeds keep multiplying in our garden, which is our mind ruled by fear. Rip them out and call them by name."
  },
  {
    "author": "Julie Andrews",
    "category": "motivational",
    "id": 49101,
    "text": "Perseverance is failing 19 times and succeeding the 20th."
  },
  {
    "author": "Jim Rohn",
    "category": "motivational",
    "id": 49053,
    "text": "Learning is the beginning of wealth. Learning is the beginning of health. Learning is the beginning of spirituality. Searching and learning is where the miracle process all begins."
  },
  {
    "author": "Ralph Marston",
    "category": "motivational",
    "id": 49075,
    "text": "What you do today can improve all your tomorrows."
  }
]

quotes['movies'] = [
  {
    "author": "Jeff Bridges",
    "category": "movies",
    "id": 49255,
    "text": "Nowadays it seems more and more like the 'business' in 'show business' is underlined, and there are campaigns, and it's all part of getting people in to see the movies."
  },
  {
    "author": "Nathan Fillion",
    "category": "movies",
    "id": 49797,
    "text": "I'll tell you what I really enjoy. We all go to the movies, we all watch television, we know what they're about, how they work. When the main character is a cop or a spy, it's very exciting, but I also very much enjoy when the main characters are nobodies - a trucker."
  },
  {
    "author": "Samuel Goldwyn",
    "category": "movies",
    "id": 49158,
    "text": "Why should people go out and pay money to see bad films when they can stay at home and see bad television for nothing?"
  },
  {
    "author": "Adam Sandler",
    "category": "movies",
    "id": 49390,
    "text": "I'm not looking to get away from anything. I like what I've done. I like what I get to do and I enjoy working with my friends. I loved those movies, but this is incredible."
  },
  {
    "author": "Vanessa Hudgens",
    "category": "movies",
    "id": 49620,
    "text": "My passion is doing movies, and as long as I keep doing that, I'll be happy. I want to do movies, fun roles and dramatic ones. I love all of it."
  },
  {
    "author": "Alfred Hitchcock",
    "category": "movies",
    "id": 49149,
    "text": "A good film is when the price of the dinner, the theatre admission and the babysitter were worth it."
  },
  {
    "author": "Amanda Seyfried",
    "category": "movies",
    "id": 49384,
    "text": "I mean, why am I considered an 'it girl?' Because I'm in a lot of movies right now or am on the covers of magazines? I just hope there is something solid behind that. Because here's the thing with 'it girl' status. It's great and amazing that anybody is saying that at all. But how long does that last?"
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "movies",
    "id": 49770,
    "text": "Sometimes I make very selfish choices like I did 'Once Upon A Time' for my inner 8-year-old and my hypothetical future child. I've done some movies because I would regret them if I didn't, but other projects I've done because they've scared me or if I felt I needed to do a big romantic comedy to help me professionally."
  },
  {
    "author": "Tim Burton",
    "category": "movies",
    "id": 49284,
    "text": "I don't know what it was, maybe the movie theaters in my immediate surrounding neighbourhood in Burbank, but I never saw what would be considered A movies."
  },
  {
    "author": "Richard Pryor",
    "category": "movies",
    "id": 49397,
    "text": "Movies are movies, and I don't think any of them are going to hurt the moral fiber of America and all that nonsense."
  },
  {
    "author": "Amber Heard",
    "category": "movies",
    "id": 49944,
    "text": "When I go into making a movie, personally, I don't try to bring other pieces of movies with me."
  },
  {
    "author": "John Cusack",
    "category": "movies",
    "id": 49407,
    "text": "It's like those high-school yearbook photos that everyone would rather not see: Oh my God, look at that mullet hair. I have those photos too, but for me, they're, like, entire movies. And they show them on cable."
  },
  {
    "author": "Laura Linney",
    "category": "movies",
    "id": 49474,
    "text": "I tend to make low-budget movies but, yeah, I make more money than I ever thought I would make."
  },
  {
    "author": "Kevin Smith",
    "category": "movies",
    "id": 49843,
    "text": "So I know how I watch movies which is on my laptop, man. And that's how I suspect a lot of people do it."
  },
  {
    "author": "Jerry Saltz",
    "category": "movies",
    "id": 49233,
    "text": "My nominee for Best Picture of the year - maybe the best picture ever, because it's essentially made up of and is an ecstatic love letter to all other movies - is Christian Marclay's endlessly enticing must-see masterpiece 'The Clock.'"
  },
  {
    "author": "Spike Lee",
    "category": "movies",
    "id": 49417,
    "text": "A lot of times you get credit for stuff in your movies you didn't intend to be there."
  },
  {
    "author": "Aishwarya Rai",
    "category": "movies",
    "id": 49256,
    "text": "Even in India the Hindi film industry might be the best known but there are movies made in other regional languages in India, be it Tamil or Bengali. Those experiences too are different from the ones in Bombay."
  },
  {
    "author": "Oskar Werner",
    "category": "movies",
    "id": 49173,
    "text": "I'm married to the theater but my mistress is the films."
  },
  {
    "author": "Gary Ross",
    "category": "movies",
    "id": 50030,
    "text": "Family entertainment is really very necessary in our culture. Look how profitable they are. It's almost not discretionary. You need to take your family to the movies."
  },
  {
    "author": "Joseph Gordon-Levitt",
    "category": "movies",
    "id": 49446,
    "text": "The movies I watch and the music I listen to and the books I read - those are important to me. It's very important to me, and I don't know what I would do without those things."
  },
  {
    "author": "John Cusack",
    "category": "movies",
    "id": 49406,
    "text": "I think being self-referential is really narcissistic. Who's to say anybody's even thinking of you that much? But some of these movies that I've done, people still recite lines to me, even 20 years later."
  },
  {
    "author": "Chris Evans",
    "category": "movies",
    "id": 49928,
    "text": "All my good movies, nobody sees."
  },
  {
    "author": "Jason Statham",
    "category": "movies",
    "id": 49443,
    "text": "A lot of action movies today seem to have scenes that just lead up to the action."
  },
  {
    "author": "Famke Janssen",
    "category": "movies",
    "id": 49994,
    "text": "I love scary movies. The Shining and Don't Look Now are two of the best."
  },
  {
    "author": "John Cusack",
    "category": "movies",
    "id": 49329,
    "text": "If people are constantly reading about you, and you're overexposed, they've got no reason to go see your movies. Also, it's not pleasant or nice to have your privacy invaded."
  },
  {
    "author": "Stephenie Meyer",
    "category": "movies",
    "id": 49909,
    "text": "I've seen little pieces of 'Interview with a Vampire' when it was on TV, but I kind of always go yuck! I don't watch R-rated movies, so that really cuts down on a lot of the horror."
  },
  {
    "author": "Josh Hutcherson",
    "category": "movies",
    "id": 49718,
    "text": "There's definitely a large fan base for the 'Twilight' and 'Harry Potter' movies that need their next fix."
  },
  {
    "author": "Monica Lewinsky",
    "category": "movies",
    "id": 49643,
    "text": "Well, it was actually - I brought the idea of doing a documentary to HBO back in 2000, when there were some press reports sort of were bandied about that there were going to TV movies based on some of the books that were out."
  },
  {
    "author": "Clive Owen",
    "category": "movies",
    "id": 49414,
    "text": "Obviously, I'm attracted to heavier movies."
  },
  {
    "author": "Roger Ebert",
    "category": "movies",
    "id": 49447,
    "text": "We can now have action movies with two stars where one might be African American and one might be Asian American. One of them doesn't have to be white, and the other one doesn't have to be the ethnic sidekick. We're way over that. And I think it's happening in society, too."
  },
  {
    "author": "Kristen Stewart",
    "category": "movies",
    "id": 49304,
    "text": "Sure, 'Twilight' is really huge right now and everybody's freaking out over it, but it will go away soon and I will be back to doing what I'm used to doing: weird little movies that nobody sees."
  },
  {
    "author": "Jean Claude Van Damme",
    "category": "movies",
    "id": 50043,
    "text": "Life is short. I'm 47 years old. I've got 10 years to go where I can be the best I can be. I want those 10 years to be precious, not like before, cranking two or three movies a year. I've made a ton of movies in my life, but so what?"
  },
  {
    "author": "Julie Bowen",
    "category": "movies",
    "id": 50035,
    "text": "Television is where the best work for women is right now. I would love to do more movies, but the reality is women have many more opportunities on television to play a greater variety of characters."
  },
  {
    "author": "Lawrence Kasdan",
    "category": "movies",
    "id": 49783,
    "text": "The movies that made me want to make movies were action movies, and thrillers, and Kurosawa films, you know, where you have an opportunity every day to shoot it in an unusual way. I was looking for something like that."
  },
  {
    "author": "Charlie Chaplin",
    "category": "movies",
    "id": 49200,
    "text": "Movies are a fad. Audiences really want to see live actors on a stage."
  },
  {
    "author": "Christopher Nolan",
    "category": "movies",
    "id": 49710,
    "text": "But in the back of my mind I've always looked to the biggest-scale Hollywood movies. Because to me the most satisfying experience is of watching a movie, if it's done really well. And so that aspiration is always it for me, if I have the opportunity to do it."
  },
  {
    "author": "Christopher Meloni",
    "category": "movies",
    "id": 49616,
    "text": "I rarely see one of the 'summer blockbuster' movies. I'd like to see a stronger focus on smaller, smarter movies."
  },
  {
    "author": "Zoe Kazan",
    "category": "movies",
    "id": 50114,
    "text": "I don't have a lot of patience for boring arthouse movies."
  },
  {
    "author": "Robert Rodriguez",
    "category": "movies",
    "id": 49857,
    "text": "Frank is such a great visual storyteller, that if you study his artwork you see that his Sin City books are already the best movies never seen on the big screen."
  },
  {
    "author": "David Cronenberg",
    "category": "movies",
    "id": 50036,
    "text": "But when you're writing a script - for me anyway - you have to sort of create an enforced innocence. You have to divest yourself of worrying about a lot of stuff like what movies are hot, what movies are not hot, what the budget of this movie might be."
  },
  {
    "author": "Leonardo DiCaprio",
    "category": "movies",
    "id": 49591,
    "text": "I grew up when I was 15 when I had my first opportunity in movies. I watched every great movie for a year and a half, and since then I've asked myself how I can emulate such artistry. That's really my motivation. I want to do something as good as my heroes have done."
  },
  {
    "author": "LL Cool J",
    "category": "movies",
    "id": 49493,
    "text": "I don't wanna abandon my identity as LL Cool J, but at the same time, I had to figure out how to let people know that I'm really serious about making these movies."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "movies",
    "id": 49769,
    "text": "It's like, if you can't focus on a movie for 90 minutes without looking at your phone, then don't go to the movies! You've got some issues, so you should probably stay home and work on those issues, and not distract everyone with lights, and sounds, oh my gosh, the tapping on the screens, it makes me crazy!"
  },
  {
    "author": "Oliver Stone",
    "category": "movies",
    "id": 49954,
    "text": "One of the joys of going to the movies was that it was trashy, and we should never lose that."
  },
  {
    "author": "Sydney Pollack",
    "category": "movies",
    "id": 49182,
    "text": "Every single art form is involved in film, in a way."
  },
  {
    "author": "Dennis Quaid",
    "category": "movies",
    "id": 49189,
    "text": "Sometimes in movies, I still have to be the hero, but it's not all that important to me anymore."
  },
  {
    "author": "Nancy Reagan",
    "category": "movies",
    "id": 49908,
    "text": "The movies were custard compared to politics."
  },
  {
    "author": "Dane Cook",
    "category": "movies",
    "id": 49762,
    "text": "I like to play guitar, jam out, play the blues, go watch movies. I love movies."
  },
  {
    "author": "Johnny Knoxville",
    "category": "movies",
    "id": 50103,
    "text": "I'm not looking to lose anything. I'm looking to continue making movies."
  },
  {
    "author": "Tim Robbins",
    "category": "movies",
    "id": 49807,
    "text": "I don't think people have been able to deal with the fact that African American filmmakers can make movies about life and relationships."
  },
  {
    "author": "Fred Durst",
    "category": "movies",
    "id": 49504,
    "text": "I want to make timeless movies."
  },
  {
    "author": "Elvis Presley",
    "category": "movies",
    "id": 49278,
    "text": "Those movies sure got me into a rut."
  },
  {
    "author": "Kevin James",
    "category": "movies",
    "id": 49826,
    "text": "For some reason and I don't know why, but I don't think that I'm funny in California. So I always want to do my movies east somewhere."
  },
  {
    "author": "Denzel Washington",
    "category": "movies",
    "id": 49433,
    "text": "It's simple: You get a part. You play a part. You play it well. You do your work and you go home. And what is wonderful about movies is that once they're done, they belong to the people. Once you make it, it's what they see. That's where my head is at."
  },
  {
    "author": "Carter Burwell",
    "category": "movies",
    "id": 49904,
    "text": "John Barry was my hero when I was about 13. His scores to the James Bond movies were the scores of my life back then."
  },
  {
    "author": "Reed Hastings",
    "category": "movies",
    "id": 50090,
    "text": "Our brand at Netflix is really focused on movies and TV shows."
  },
  {
    "author": "Adam Savage",
    "category": "movies",
    "id": 50026,
    "text": "When I finally got up to Industrial Light And Magic to work on the 'Star Wars' movies as a model-maker, it felt like dying and going to heaven."
  },
  {
    "author": "Stanislav Grof",
    "category": "movies",
    "id": 49763,
    "text": "I spent much of my later childhood and adolescence very, very involved and interested in art, and particularly in animated movies."
  },
  {
    "author": "Danica McKellar",
    "category": "movies",
    "id": 49345,
    "text": "I played Winnie Cooper on 'The Wonder Years' from ages 12-18, and did a few other movies during some of the summers."
  },
  {
    "author": "Jonah Hill",
    "category": "movies",
    "id": 49880,
    "text": "I love it, man I'm 23 years old and I'm lucky enough to write movies as a job! I just feel really blessed and can't believe it's happening."
  },
  {
    "author": "Danny Boyle",
    "category": "movies",
    "id": 49537,
    "text": "I love watching the Bond movies obviously and I grew up reading the books as a kid. I've always loved them because of that."
  },
  {
    "author": "Joss Whedon",
    "category": "movies",
    "id": 49869,
    "text": "I think everyone who makes movies should be forced to do television. Because you have to finish. You have to get it done, and there are a lot of decisions made just for the sake of making decisions. You do something because it's efficient and because it gets the story told and it connects to the audience."
  },
  {
    "author": "Ang Lee",
    "category": "movies",
    "id": 49315,
    "text": "Making movies is a way of understanding myself and the world."
  },
  {
    "author": "Kevin Smith",
    "category": "movies",
    "id": 49690,
    "text": "I just love movies, so suddenly, you're political about movies, and that's dark. It's just not fun when something you love becomes calculated."
  },
  {
    "author": "Andy Murray",
    "category": "movies",
    "id": 49902,
    "text": "I never read. The paper or anything. I watch a lot of movies, and TV series and stuff. But I never, never read."
  },
  {
    "author": "Orson Welles",
    "category": "movies",
    "id": 49143,
    "text": "A film is never really good unless the camera is an eye in the head of a poet."
  },
  {
    "author": "John Podhoretz",
    "category": "movies",
    "id": 49339,
    "text": "Robots have a rich and storied history in movies."
  },
  {
    "author": "Debra Winger",
    "category": "movies",
    "id": 49662,
    "text": "I happen to be interested in watching a face age. I like faces of women aging so it makes me personally quite sad. That's a beautiful gift from God. If people don't want to see that anymore then I won't be in anymore movies."
  },
  {
    "author": "Alex Winter",
    "category": "movies",
    "id": 50119,
    "text": "I think movies are good for getting into dream states or exploring weird alternate states of thinking."
  },
  {
    "author": "Lena Dunham",
    "category": "movies",
    "id": 49396,
    "text": "I spent all my time on my movies worried that people were eating and that the schedule was being kept, so to have experts in those areas giving me the brain space as a writer and director is huge."
  },
  {
    "author": "Michelle Williams",
    "category": "movies",
    "id": 49790,
    "text": "For me, relationships are the real action movies. Bombs are exploding every day and the kitchen is Ground Zero."
  },
  {
    "author": "Kristen Wiig",
    "category": "movies",
    "id": 49804,
    "text": "When you're on your deathbed, you probably aren't counting the movies you've made."
  },
  {
    "author": "Joe Morton",
    "category": "movies",
    "id": 50133,
    "text": "James Cameron has always been way ahead of the curve in terms of the use of technology in his movies."
  },
  {
    "author": "Morgan Freeman",
    "category": "movies",
    "id": 49351,
    "text": "Most of the time it's the role. Sometimes it's the story and sometimes it just the paycheck. It's the little movies that come out as stories or the fact that I have work to go out, you know what I'm saying, you can only be out so long without work, you start getting antsy."
  },
  {
    "author": "Janeane Garofalo",
    "category": "movies",
    "id": 50011,
    "text": "I don't think Hollywood was trying to do anything with me. In fact, they lost interest pretty quick. I think I got lucky, briefly, in the '90s, and it just so happened that those movies were the opportunities that came my way. Then it just kind of stopped."
  },
  {
    "author": "Richard King",
    "category": "movies",
    "id": 49438,
    "text": "I'm not impressed by someone's degree... I'm impressed by them making movies."
  },
  {
    "author": "Adam Sandler",
    "category": "movies",
    "id": 49344,
    "text": "I do love the films I've done in the past. I work hard in my movies and my friends work hard and we're trying to make people laugh and I'm very proud of that."
  },
  {
    "author": "Niklas Zennstrom",
    "category": "movies",
    "id": 49963,
    "text": "And the VCR did the same thing: the movie industry thought nobody would ever watch movies any more."
  },
  {
    "author": "Clive Owen",
    "category": "movies",
    "id": 49411,
    "text": "I go off and make movies I come home, and I'm a dad and I hang with my girls."
  },
  {
    "author": "Emily Mortimer",
    "category": "movies",
    "id": 49893,
    "text": "I'm just happy to be a film where for once I don't have to worry about my hair, because my managers are always complaining about my hair looking depressing in my movies. Which is true. I mean, it's true."
  },
  {
    "author": "Gabrielle Union",
    "category": "movies",
    "id": 49623,
    "text": "Reality TV looks more like America than movies do."
  },
  {
    "author": "Vincent D'Onofrio",
    "category": "movies",
    "id": 49385,
    "text": "It's like why people read scary books or go see scary movies. Because it creates a distance. They're scared, but they're not going to get hurt."
  },
  {
    "author": "Selma Blair",
    "category": "movies",
    "id": 50006,
    "text": "It's fun to go to the movies and be scared."
  },
  {
    "author": "Danny Boyle",
    "category": "movies",
    "id": 49540,
    "text": "Movies about space raise those questions of what we're doing here, and that inevitably introduces a spiritual dimension."
  },
  {
    "author": "Ben Affleck",
    "category": "movies",
    "id": 49684,
    "text": "I knew I had to get out of Boston and stop making movies there, at least for one movie, otherwise no one would ever consider me for a movie that took place south of Providence."
  },
  {
    "author": "Jason Reitman",
    "category": "movies",
    "id": 49487,
    "text": "Well, Toronto, I consider to be the birthplace of my films. I've made three films and this is the third one to premiere here in the same theater on the same day at the same time - they are my audience. They're the people that I think about while I'm writing, directing, and editing. I specifically make movies for them."
  },
  {
    "author": "Seth Rogen",
    "category": "movies",
    "id": 49853,
    "text": "I don't make the best movies in the world, but at times, I do feel like I'm adding something to the cinematic community."
  },
  {
    "author": "Ben Affleck",
    "category": "movies",
    "id": 49683,
    "text": "My movies are unadorned, they're not particularly fancy, I think they're kind of workmanlike in some ways, focusing on the writing and the acting."
  },
  {
    "author": "Kristen Stewart",
    "category": "movies",
    "id": 49338,
    "text": "I don't want to make movies for kids, and I don't want to make movies for adults either."
  },
  {
    "author": "Hank Azaria",
    "category": "movies",
    "id": 50096,
    "text": "I was a huge fan of comedy and movies and TV growing up, and I was able to memorize and mimic a lot of things, not realizing that that meant I probably wanted to be an actor. I just really, really amused myself and my friends with memorizing entire George Carlin or Steve Martin albums."
  },
  {
    "author": "Elizabeth Hurley",
    "category": "movies",
    "id": 49999,
    "text": "When I started doing movies, every crew member was older than me."
  },
  {
    "author": "James Franco",
    "category": "movies",
    "id": 49921,
    "text": "When we were doing 'Freaks and Geeks', I didn't quite understand how movies and TV worked, and I would improvise even if the camera wasn't on me. I thought I was helping the other actors by keeping them on their toes, but nobody appreciated it when I would trip them up. So I was improvising a little bit back then, but not in a productive way."
  },
  {
    "author": "Channing Tatum",
    "category": "movies",
    "id": 49655,
    "text": "In all the movies I'm in love with someone in my head. There's always love in a film somewhere. It doesn't matter even if it's an action movie."
  },
  {
    "author": "Kristin Scott Thomas",
    "category": "movies",
    "id": 49323,
    "text": "Movies make you immortal and ageless."
  },
  {
    "author": "Bill Vaughan",
    "category": "movies",
    "id": 49532,
    "text": "I'm an actor. And I guess I've done so many movies I've achieved some high visibility. But a star? I guess I still think of myself as kind of a worker ant."
  },
  {
    "author": "Al Pacino",
    "category": "movies",
    "id": 49612,
    "text": "It's never really that much fun for me to do movies anyway, because you - you know, you have to get up very early in the morning and you have to go in and you spend a lot of time waiting around."
  },
  {
    "author": "Marco Rubio",
    "category": "movies",
    "id": 49276,
    "text": "You know those movies where the people in the audience are screaming, 'Don't go in that door!' because you know the killer is there? Well, it is the same thing with this debt. We know how this ends."
  },
  {
    "author": "John Cusack",
    "category": "movies",
    "id": 49403,
    "text": "I don't want to produce anymore small or independent movies because it's just too hard these days."
  },
  {
    "author": "Julia Roberts",
    "category": "movies",
    "id": 49268,
    "text": "I think less is more when it comes to kissing in the movies."
  },
  {
    "author": "Javier Bardem",
    "category": "movies",
    "id": 49668,
    "text": "Bond is the longest-running franchise ever and there's a reason for that: they are action movies but they are also touched by current events without being political or too serious."
  }
]

quotes['movingon'] = [
  {
    "author": "Carl Sandburg",
    "category": "movingon",
    "id": 50148,
    "text": "I tell you the past is a bucket of ashes, so live not in your yesterdays, no just for tomorrow, but in the here and now. Keep moving and forget the post mortems and remember, no one can get the jump on the future."
  },
  {
    "author": "George Allen, Sr.",
    "category": "movingon",
    "id": 50168,
    "text": "Forget the past - the future will give you plenty to worry about."
  },
  {
    "author": "Ashley Greene",
    "category": "movingon",
    "id": 50175,
    "text": "I can still love an ex as a person, regardless if the breakup was bad. I would never wish anything negative on them. It takes more energy to hate them than to wish them well."
  },
  {
    "author": "Meg Whitman",
    "category": "movingon",
    "id": 50196,
    "text": "It is very clear that voice communications is moving on to the Internet. In the end, the price that anyone can provide for voice transmission on the Net will trend toward zero."
  },
  {
    "author": "Regis Philbin",
    "category": "movingon",
    "id": 50194,
    "text": "I'm moving on. I should have made that clear when I made the announcement. I guess I wasn't clear. If people think you're leaving a show after all these years, you might be retiring. So I understand where they're coming from, but I should have impressed the fact that I hope I'm just moving on right now."
  },
  {
    "author": "Marcia Gay Harden",
    "category": "movingon",
    "id": 50198,
    "text": "In the theater, it's about taking time in a musical segment, a pause in a musical way and then moving on."
  },
  {
    "author": "Ann Landers",
    "category": "movingon",
    "id": 50146,
    "text": "Expect trouble as an inevitable part of life and repeat to yourself, the most comforting words of all this, too, shall pass."
  },
  {
    "author": "Wayne Coyne",
    "category": "movingon",
    "id": 50201,
    "text": "I can see that if this was an album done 10 or 15 years ago we could see we were moving on to some place else."
  },
  {
    "author": "Emile M. Cioran",
    "category": "movingon",
    "id": 50164,
    "text": "What surrounds us we endure better for giving it a name - and moving on."
  },
  {
    "author": "Brian Eno",
    "category": "movingon",
    "id": 50159,
    "text": "I don't live in the past at all I'm always wanting to do something new. I make a point of constantly trying to forget and get things out of my mind."
  },
  {
    "author": "Phylicia Rashad",
    "category": "movingon",
    "id": 50187,
    "text": "There's always something to suggest that you'll never be who you wanted to be. Your choice is to take it or keep on moving."
  },
  {
    "author": "Mick Jagger",
    "category": "movingon",
    "id": 50165,
    "text": "I must be careful not to get trapped in the past. That's why I tend to forget my songs."
  },
  {
    "author": "Demi Lovato",
    "category": "movingon",
    "id": 50158,
    "text": "Recovery is something that you have to work on every single day and it's something that it doesn't get a day off."
  },
  {
    "author": "Sarah Fielding",
    "category": "movingon",
    "id": 50173,
    "text": "The words of kindness are more healing to a drooping heart than balm or honey."
  },
  {
    "author": "Alanis Morissette",
    "category": "movingon",
    "id": 50170,
    "text": "What's that line from TS Eliot? To arrive at the place where you started, but to know it for the first time. I'm able to write about a breakup from a different place. Same brokenness. Same rock-bottom. But a little more informed, now I'm older. Thank God for growing up."
  },
  {
    "author": "Danica Patrick",
    "category": "movingon",
    "id": 50151,
    "text": "Take those chances and you can achieve greatness, whereas if you go conservative, you'll never know. I truly believe what doesn't kill you makes you stronger. Even if you fail, learning and moving on is sometimes the best thing."
  },
  {
    "author": "Drew Carey",
    "category": "movingon",
    "id": 50184,
    "text": "The Marines was a fresh start - that is why they shave your head. I wish they would let you change your name."
  },
  {
    "author": "Johnny Cash",
    "category": "movingon",
    "id": 50135,
    "text": "You build on failure. You use it as a stepping stone. Close the door on the past. You don't try to forget the mistakes, but you don't dwell on it. You don't let it have any of your energy, or any of your time, or any of your space."
  },
  {
    "author": "Emma Thompson",
    "category": "movingon",
    "id": 50171,
    "text": "If you've got to my age, you've probably had your heart broken many times. So it's not that difficult to unpack a bit of grief from some little corner of your heart and cry over it."
  },
  {
    "author": "Mary Pickford",
    "category": "movingon",
    "id": 50163,
    "text": "You may have a fresh start any moment you choose, for this thing that we call 'failure' is not the falling down, but the staying down."
  },
  {
    "author": "Benjamin Netanyahu",
    "category": "movingon",
    "id": 50191,
    "text": "I can tell you one thing, Iran is closer to developing nuclear weapons today than it was a week ago, or a month ago or a year ago. It's just moving on with its efforts."
  },
  {
    "author": "Kate Winslet",
    "category": "movingon",
    "id": 50195,
    "text": "So I won an Oscar. It's amazing. I've got that for the rest of my life for a performance I am proud of. It nearly killed me. I am really proud of the film. That's it, moving on."
  },
  {
    "author": "Hank Azaria",
    "category": "movingon",
    "id": 50179,
    "text": "Getting over someone is a grieving process. You mourn the loss of the relationship, and that's only expedited by 'Out of sight, out of mind.' But when you walk outside and see them on a billboard or on TV or on the cover of a magazine, it reopens the wound. It's a high-class problem, but it's real."
  },
  {
    "author": "Rita Rudner",
    "category": "movingon",
    "id": 50154,
    "text": "I love to shop after a bad relationship. I don't know. I buy a new outfit and it makes me feel better. It just does. Sometimes I see a really great outfit, I'll break up with someone on purpose."
  },
  {
    "author": "Summer Glau",
    "category": "movingon",
    "id": 50207,
    "text": "After doing 'Firefly' and moving on, I always wanted to be part of a series again. I love doing films, too, but there's just something special about being part of the team and feeling like you're actually a part of the family, and I always look to re-create that."
  },
  {
    "author": "Lord Byron",
    "category": "movingon",
    "id": 50155,
    "text": "The heart will break, but broken live on."
  },
  {
    "author": "David Remnick",
    "category": "movingon",
    "id": 50202,
    "text": "The world is a crazy, beautiful, ugly complicated place, and it keeps moving on from crisis to strangeness to beauty to weirdness to tragedy. The caravan keeps moving on, and the job of the longform writer or filmmaker or radio broadcaster is to stop - is to pause - and when the caravan goes away, that's when this stuff comes."
  },
  {
    "author": "Hubert H. Humphrey",
    "category": "movingon",
    "id": 50140,
    "text": "The greatest healing therapy is friendship and love."
  },
  {
    "author": "Christiaan Barnard",
    "category": "movingon",
    "id": 50189,
    "text": "Suffering isn't ennobling, recovery is."
  },
  {
    "author": "Romain Rolland",
    "category": "movingon",
    "id": 50161,
    "text": "One makes mistakes that is life. But it is never a mistake to have loved."
  },
  {
    "author": "Justin Halpern",
    "category": "movingon",
    "id": 50188,
    "text": "I kind of came to the conclusion after I did finally get married that love and relationships are just a series of horrific losses with hopefully one win."
  },
  {
    "author": "Gwen Ifill",
    "category": "movingon",
    "id": 50205,
    "text": "If it were the Clinton people, they'd be sitting around figuring out how to pull themselves out. Instead the president is continuing to go around the country and peddling Social Security, which the needle is not moving on."
  },
  {
    "author": "Jack Dempsey",
    "category": "movingon",
    "id": 50176,
    "text": "By forgetting the past and by throwing myself into other interests, I forget to worry."
  },
  {
    "author": "Dave Mustaine",
    "category": "movingon",
    "id": 50145,
    "text": "Moving on, is a simple thing, what it leaves behind is hard."
  },
  {
    "author": "Jean Kerr",
    "category": "movingon",
    "id": 50147,
    "text": "Being divorced is like being hit by a Mack truck. If you live through it, you start looking very carefully to the right and to the left."
  },
  {
    "author": "Nicole Richie",
    "category": "movingon",
    "id": 50181,
    "text": "I will be really happy once I have done my jail time. I can start fresh."
  },
  {
    "author": "Walter Anderson",
    "category": "movingon",
    "id": 50134,
    "text": "Bad things do happen how I respond to them defines my character and the quality of my life. I can choose to sit in perpetual sadness, immobilized by the gravity of my loss, or I can choose to rise from the pain and treasure the most precious gift I have - life itself."
  },
  {
    "author": "Omar Khayyam",
    "category": "movingon",
    "id": 50160,
    "text": "The moving finger writes, and having written moves on. Nor all thy piety nor all thy wit, can cancel half a line of it."
  },
  {
    "author": "Marvin Minsky",
    "category": "movingon",
    "id": 50206,
    "text": "Kubrick's vision seemed to be that humans are doomed, whereas Clarke's is that humans are moving on to a better stage of evolution."
  },
  {
    "author": "Jennifer Aniston",
    "category": "movingon",
    "id": 50142,
    "text": "I think it's important to have closure in any relationship that ends - from a romantic relationship to a friendship. You should always have a sense of clarity at the end and know why it began and why it ended. You need that in your life to move cleanly into your next phase."
  },
  {
    "author": "Maxwell Maltz",
    "category": "movingon",
    "id": 50153,
    "text": "Man maintains his balance, poise, and sense of security only as he is moving forward."
  },
  {
    "author": "Yoko Ono",
    "category": "movingon",
    "id": 50157,
    "text": "Healing yourself is connected with healing others."
  },
  {
    "author": "Sai Baba",
    "category": "movingon",
    "id": 50136,
    "text": "Love one another and help others to rise to the higher levels, simply by pouring out love. Love is infectious and the greatest healing energy."
  },
  {
    "author": "Mike Shinoda",
    "category": "movingon",
    "id": 50174,
    "text": "Who can't relate to the idea of leaving one chapter behind and moving on to the next?"
  },
  {
    "author": "Susan Lucci",
    "category": "movingon",
    "id": 50209,
    "text": "Life goes on, and I'm moving on to the next thing, but I hope the soaps that are still running will thrive. They have millions of loyal viewers."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "movingon",
    "id": 50141,
    "text": "It is only through labor and painful effort, by grim energy and resolute courage, that we move on to better things."
  },
  {
    "author": "Denis Waitley",
    "category": "movingon",
    "id": 50137,
    "text": "Don't dwell on what went wrong. Instead, focus on what to do next. Spend your energies on moving forward toward finding the answer."
  },
  {
    "author": "Karen Thompson Walker",
    "category": "movingon",
    "id": 50203,
    "text": "I like to edit my sentences as I write them. I rearrange a sentence many times before moving on to the next one. For me, that editing process feels like a form of play, like a puzzle that needs solving, and it's one of the most satisfying parts of writing."
  },
  {
    "author": "Lewis B. Smedes",
    "category": "movingon",
    "id": 50138,
    "text": "Forgiving does not erase the bitter past. A healed memory is not a deleted memory. Instead, forgiving what we cannot forget creates a new way to remember. We change the memory of our past into a hope for our future."
  },
  {
    "author": "Beverley Mitchell",
    "category": "movingon",
    "id": 50190,
    "text": "Part of growing up is just taking what you learn from that and moving on and not taking it to heart."
  },
  {
    "author": "Jordin Sparks",
    "category": "movingon",
    "id": 50192,
    "text": "As far as friendships go, things change even without the fame. People start moving on. I have a few friends that are married and are starting to have kids and I'm like, 'Oh my goodness gracious - that's so insane.' I also have friends who are just doing their own thing, which is cool."
  },
  {
    "author": "Gerry Cooney",
    "category": "movingon",
    "id": 50208,
    "text": "All of the sports have a safety net, but boxing is the only sport that has none. So when the fighter is through, he is through. While he was fighting his management was very excited for him, but now that he is done, that management team is moving on."
  },
  {
    "author": "Walter Scott",
    "category": "movingon",
    "id": 50166,
    "text": "O! many a shaft, at random sent, Finds mark the archer little meant! And many a word, at random spoken, May soothe or wound a heart that's broken!"
  },
  {
    "author": "Albert Camus",
    "category": "movingon",
    "id": 50139,
    "text": "Blessed are the hearts that can bend they shall never be broken."
  },
  {
    "author": "Dennis Hastert",
    "category": "movingon",
    "id": 50199,
    "text": "With more than 67 percent of the Nation's freight moving on highways, economists believe that our ability to compete internationally is tied to the quality of our infrastructure."
  },
  {
    "author": "Jeffrey Archer",
    "category": "movingon",
    "id": 50197,
    "text": "Well I certainly have learned and I hope I'm moving on and certainly two years of prison was a terrible punishment."
  },
  {
    "author": "David Milne",
    "category": "movingon",
    "id": 50200,
    "text": "We are also fortunate in being in quite a sheltered environment, in terms of people moving on to do other things, because there are relatively few companies in Scotland that are looking for the skill set that we've developed."
  },
  {
    "author": "Adam Brody",
    "category": "movingon",
    "id": 50167,
    "text": "Any time you end a relationship, and everyone has ended plenty in their life, it's always a tough thing and hard to get over."
  },
  {
    "author": "Heidi Klum",
    "category": "movingon",
    "id": 50156,
    "text": "I've been heartbroken. I've broken hearts. That's part of life, and its part of figuring out who you are so you can find the right partner."
  },
  {
    "author": "Dave Pelzer",
    "category": "movingon",
    "id": 50143,
    "text": "To help yourself, you must be yourself. Be the best that you can be. When you make a mistake, learn from it, pick yourself up and move on."
  },
  {
    "author": "Andy Summers",
    "category": "movingon",
    "id": 50204,
    "text": "I am pretty embroiled in moving on and moving forward with music."
  },
  {
    "author": "Duncan Sheik",
    "category": "movingon",
    "id": 50182,
    "text": "I actually think sadness and darkness can be very beautiful and healing."
  },
  {
    "author": "Barbara Sher",
    "category": "movingon",
    "id": 50177,
    "text": "When you start using senses you've neglected, your reward is to see the world with completely fresh eyes."
  },
  {
    "author": "Marianne Williamson",
    "category": "movingon",
    "id": 50152,
    "text": "The goal of spiritual practice is full recovery, and the only thing you need to recover from is a fractured sense of self."
  },
  {
    "author": "David Brainerd",
    "category": "movingon",
    "id": 50185,
    "text": "The all-seeing eye of God beheld our deplorable state infinite pity touched the heart of the Father of mercies and infinite wisdom laid the plan of our recovery."
  },
  {
    "author": "Jason Biggs",
    "category": "movingon",
    "id": 50186,
    "text": "Like anyone who goes to college, you're leaving a familiar surrounding and a comfortable environment and your friends and everything, and you're starting fresh. It can be pretty daunting."
  },
  {
    "author": "Paul Anka",
    "category": "movingon",
    "id": 50178,
    "text": "I've always believed that if you don't stay moving, they will throw dirt on you."
  },
  {
    "author": "Julius Erving",
    "category": "movingon",
    "id": 50193,
    "text": "But you know, if you live an affluent lifestyle, there are all types of trappings that are there that you have to be cognizant of, and you've got to try and communicate freely and gain understanding about and then keep moving on, because you know, sometimes lifestyles are chosen for us as opposed to us choosing them."
  },
  {
    "author": "Nelson Mandela",
    "category": "movingon",
    "id": 50144,
    "text": "Forget the past."
  },
  {
    "author": "Carrie Brownstein",
    "category": "movingon",
    "id": 50162,
    "text": "I'm pretty horrible at relationships and haven't been in many long-term ones. Leaving and moving on - returning to a familiar sense of self-reliance and autonomy - is what I know that feeling is as comfortable and comforting as it might be for a different kind of person to stay."
  },
  {
    "author": "Robert Wyatt",
    "category": "movingon",
    "id": 50180,
    "text": "I know people who grow old and bitter. I want to keep making a fresh start. I don't want them to defeat me. That would be suicidal."
  },
  {
    "author": "Gene Tierney",
    "category": "movingon",
    "id": 50169,
    "text": "Some women feel the best cure for a broken heart is a new beau."
  },
  {
    "author": "Harold Pinter",
    "category": "movingon",
    "id": 50183,
    "text": "I mean, don't forget the earth's about five thousand million years old, at least. Who can afford to live in the past?"
  },
  {
    "author": "Ulysses S. Grant",
    "category": "movingon",
    "id": 50149,
    "text": "The art of war is simple enough. Find out where your enemy is. Get at him as soon as you can. Strike him as hard as you can, and keep moving on."
  },
  {
    "author": "Kristen Wiig",
    "category": "movingon",
    "id": 50172,
    "text": "I can relate to having those people in your life that you feel are moving on to this great, big, normal life and you're like, 'What's wrong with me?'"
  },
  {
    "author": "Billy Corgan",
    "category": "movingon",
    "id": 50150,
    "text": "I think a spiritual journey is not so much a journey of discovery. It's a journey of recovery. It's a journey of uncovering your own inner nature. It's already there."
  }
]

quotes['music'] = [
  {
    "author": "Willie Nelson",
    "category": "music",
    "id": 50770,
    "text": "I think Ray Charles did as much as anybody when he did his country music album. Ray Charles broke down borders and showed the similarities between country music and R&ampB."
  },
  {
    "author": "Bruce Springsteen",
    "category": "music",
    "id": 51196,
    "text": "And whether you're drawn to gospel music or church music or honky-tonk music, it informs your character and it informs your talent."
  },
  {
    "author": "Katy Perry",
    "category": "music",
    "id": 50745,
    "text": "Oh, I will always be honest with my music. The records are black boxes for me. Like if you want to know who I am, my views, my perspective, things I love, things I hate, my convictions, my anthems. I've never let people's opinions affect the way I write."
  },
  {
    "author": "David Byrne",
    "category": "music",
    "id": 50784,
    "text": "It didn't even occur to me that I'm the last person in the world who should play salsa or Brazilian music."
  },
  {
    "author": "John Stamos",
    "category": "music",
    "id": 50959,
    "text": "I like when guests come over early and we chop veggies and talk and play music."
  },
  {
    "author": "Jack Black",
    "category": "music",
    "id": 50614,
    "text": "I don't have any real spirituality in my life - I'm kind of an atheist - but when music can take me to the highest heights, it's almost like a spiritual feeling. It fills that void for me."
  },
  {
    "author": "Bob Dylan",
    "category": "music",
    "id": 50354,
    "text": "Here's the thing with me and the religious thing. This is the flat-out truth: I find the religiosity and philosophy in the music. I don't find it anywhere else."
  },
  {
    "author": "Brian Eno",
    "category": "music",
    "id": 50641,
    "text": "Avant-garde music is sort of research music. You're glad someone's done it but you don't necessarily want to listen to it."
  },
  {
    "author": "Leonard Cohen",
    "category": "music",
    "id": 50772,
    "text": "We used to play music for fun. Much more than now. Now nobody picks up a guitar unless they're paid for it."
  },
  {
    "author": "Norah Jones",
    "category": "music",
    "id": 51176,
    "text": "I just want to make my music, and I want it to stand on its own."
  },
  {
    "author": "Taylor Swift",
    "category": "music",
    "id": 50597,
    "text": "I don't think I'd ever make an album of just covers because I love writing my own music."
  },
  {
    "author": "Eminem",
    "category": "music",
    "id": 50330,
    "text": "I've accomplished enough with the music that I haven't had to go out there and do other things to over-saturate."
  },
  {
    "author": "Ellie Goulding",
    "category": "music",
    "id": 50781,
    "text": "I start really missing London when I go away. I have a little flat, but very central. I live above a pub and you'd think it'd be a nightmare, but I like hearing the music and it's quite comforting."
  },
  {
    "author": "Jimmy Page",
    "category": "music",
    "id": 51106,
    "text": "I always believed in the music we did and that's why it was uncompromising."
  },
  {
    "author": "Harlan Howard",
    "category": "music",
    "id": 50849,
    "text": "Country music is three chords and the truth."
  },
  {
    "author": "Julie Andrews",
    "category": "music",
    "id": 50841,
    "text": "I was lucky enough to be the lady that was asked to be Maria in the Sound Of Music, and that film was fortunate enough to be huge hit. The same with Mary Poppins. I got terribly lucky in that respect."
  },
  {
    "author": "Xun Zi",
    "category": "music",
    "id": 50455,
    "text": "Music is a fantastic peacekeeper of the world, it is integral to harmony, and it is a required fundamental of human emotion."
  },
  {
    "author": "John Erskine",
    "category": "music",
    "id": 50665,
    "text": "Music is the only language in which you cannot say a mean or sarcastic thing."
  },
  {
    "author": "Erykah Badu",
    "category": "music",
    "id": 50977,
    "text": "Music and the music business are two different things."
  },
  {
    "author": "Phil Collins",
    "category": "music",
    "id": 50961,
    "text": "Beyond a certain point, the music isn't mine anymore. It's yours."
  },
  {
    "author": "Tomas Luis de Victoria",
    "category": "music",
    "id": 51197,
    "text": "Music can affect for good or ill the body as well as the mind."
  },
  {
    "author": "Gary Cherone",
    "category": "music",
    "id": 50289,
    "text": "I was growing up listening to Queen. Freddie Mercury threw those incredible melodies into his songs."
  },
  {
    "author": "Marilyn vos Savant",
    "category": "music",
    "id": 50416,
    "text": "Teens think listening to music helps them concentrate. It doesn't. It relieves them of the boredom that concentration on homework induces."
  },
  {
    "author": "Stevie Nicks",
    "category": "music",
    "id": 50253,
    "text": "It was my 16th birthday - my mom and dad gave me my Goya classical guitar that day. I sat down, wrote this song, and I just knew that that was the only thing I could ever really do - write songs and sing them to people."
  },
  {
    "author": "Eric Clapton",
    "category": "music",
    "id": 50715,
    "text": "From the beginning, I knew intuitively that if nothing else, music was safe, and that nobody could tell me anything about it. Music didn't need a middleman, whereas all the other things in school needed some kind of explanation."
  },
  {
    "author": "Demi Lovato",
    "category": "music",
    "id": 50840,
    "text": "I want my music to do the explaining."
  },
  {
    "author": "Quincy Jones",
    "category": "music",
    "id": 51029,
    "text": "If architecture is frozen music then music must be liquid architecture."
  },
  {
    "author": "April Winchell",
    "category": "music",
    "id": 50574,
    "text": "I am severely distracted these days. It's hard to sit in front of the computer, uploading bad music for hours, when you have a wonderful boyfriend who treats you like a Goddess."
  },
  {
    "author": "Alanis Morissette",
    "category": "music",
    "id": 50579,
    "text": "Over the last couple of years, I've really worked toward balancing my life out more, having a little bit more time with friends, family and my boyfriend. There was a period of time when they were way down the list. It was all about music and touring and if everything fell by the wayside, so be it."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "music",
    "id": 51191,
    "text": "Pop music has progressed."
  },
  {
    "author": "Dave Matthews",
    "category": "music",
    "id": 50965,
    "text": "Good music is good music, and everything else can go to hell."
  },
  {
    "author": "Jeff Bridges",
    "category": "music",
    "id": 50632,
    "text": "Yeah, I've been interested in music since I was a teenager, always writing songs."
  },
  {
    "author": "Willie Nelson",
    "category": "music",
    "id": 50766,
    "text": "A lot of country music is sad."
  },
  {
    "author": "Jimi Hendrix",
    "category": "music",
    "id": 50216,
    "text": "Music doesn't lie. If there is something to be changed in this world, then it can only happen through music."
  },
  {
    "author": "Katherine Jenkins",
    "category": "music",
    "id": 51148,
    "text": "I sing a mixture of everything from opera, folk music, Broadway. It's a mix of things."
  },
  {
    "author": "David Byrne",
    "category": "music",
    "id": 50792,
    "text": "We tend to mistake music for the physical object."
  },
  {
    "author": "Truman Capote",
    "category": "music",
    "id": 50407,
    "text": "To me, the greatest pleasure of writing is not what it's about, but the inner music that words make."
  },
  {
    "author": "Glenn Beck",
    "category": "music",
    "id": 50995,
    "text": "A country is made not by policy alone, but by its music, its entertainment shows, all of it."
  },
  {
    "author": "Alanis Morissette",
    "category": "music",
    "id": 50586,
    "text": "Music will always be a part of my life. I love music and I don't care how many units I sell."
  },
  {
    "author": "William Wordsworth",
    "category": "music",
    "id": 50412,
    "text": "I listened, motionless and still And, as I mounted up the hill, The music in my heart I bore, Long after it was heard no more."
  },
  {
    "author": "Faith Evans",
    "category": "music",
    "id": 51149,
    "text": "I'm really an inner spirit that only makes itself known through the music. A lot of people think I'm an introvert, or quiet and moody. I've even heard some people say that there's a certain mystery or darkness about me. I'm not that way. I'm just really into what I do."
  },
  {
    "author": "Bob Dylan",
    "category": "music",
    "id": 50357,
    "text": "Folk music is a bunch of fat people."
  },
  {
    "author": "Michael Tippett",
    "category": "music",
    "id": 50981,
    "text": "I am quite certain in my heart of hearts that modern music and modern art is not a conspiracy, but is a form of truth and integrity for those who practise it honestly, decently and with all their being."
  },
  {
    "author": "Ani DiFranco",
    "category": "music",
    "id": 51015,
    "text": "Pop stardom is not very compelling. I'm much more interested in a relationship between performer and audience that is of equals. I came up through folk music, and there's no pomp and circumstance to the performance. There's no, like, 'I'll be the rock star, you be the adulating fan.'"
  },
  {
    "author": "Ludwig van Beethoven",
    "category": "music",
    "id": 50411,
    "text": "Music should strike fire from the heart of man, and bring tears form the eyes of woman."
  },
  {
    "author": "Igor Stravinsky",
    "category": "music",
    "id": 50352,
    "text": "I haven't understood a bar of music in my life, but I have felt it."
  },
  {
    "author": "Cat Stevens",
    "category": "music",
    "id": 50660,
    "text": "I became alienated from this religious upbringing, and started making music. I wanted to be a big star. All those things I saw in the films and on the media took hold of me, and perhaps I thought this was my god: the goal of making money."
  },
  {
    "author": "Eric Clapton",
    "category": "music",
    "id": 51100,
    "text": "But I did go to music really early on, even when I was 4 or 5, I was responding to music probably in ways other kids were not."
  },
  {
    "author": "Justin Bieber",
    "category": "music",
    "id": 50518,
    "text": "I think older people can appreciate my music because I really show my heart when I sing, and it's not corny. I think I can grow as an artist, and my fans will grow with me."
  },
  {
    "author": "Peter Tosh",
    "category": "music",
    "id": 50724,
    "text": "I travel the garden of music, thru inspiration. It's a large, very large garden, seen?"
  },
  {
    "author": "Shania Twain",
    "category": "music",
    "id": 50813,
    "text": "Marilyn Monroe never sold a platinum album. And more people know my music than what I look like."
  },
  {
    "author": "David Bowie",
    "category": "music",
    "id": 50499,
    "text": "I felt I really wanted to back off from music completely and just work within the visual arts in some way. I started painting quite passionately at that time."
  },
  {
    "author": "Stendhal",
    "category": "music",
    "id": 50479,
    "text": "The more a race is governed by its passions, the less it has acquired the habit of cautious and reasoned argument, the more intense will be its love of music."
  },
  {
    "author": "Snoop Dogg",
    "category": "music",
    "id": 51095,
    "text": "I just change with the times. I really don't have a say in what's going on. Music was here before me."
  },
  {
    "author": "Billy Joel",
    "category": "music",
    "id": 50946,
    "text": "Don't make music for some vast, unseen audience or market or ratings share or even for something as tangible as money. Though it's crucial to make a living, that shouldn't be your inspiration. Do it for yourself."
  },
  {
    "author": "Aimee Mann",
    "category": "music",
    "id": 50290,
    "text": "There's a lot of music that sounds like it's literally computer-generated, totally divorced from a guy sitting down at an instrument."
  },
  {
    "author": "Jay-Z",
    "category": "music",
    "id": 50591,
    "text": "Racism is taught in the home. We agree on that? Well, it's very hard to teach racism to a teenager who's listening to rap music and who idolizes, say, Snoop Dogg. It's hard to say, 'That guy is less than you.' The kid is like, 'I like that guy, he's cool. How is he less than me?"
  },
  {
    "author": "Heinrich Heine",
    "category": "music",
    "id": 50259,
    "text": "When words leave off, music begins."
  },
  {
    "author": "Norah Jones",
    "category": "music",
    "id": 51163,
    "text": "It's true, there's a lot of melancholy in my music. I don't know why, I'm not a melancholy person. I've always been drawn to it. Ever since I was a kid, if I had an album I would play the ballads on repeat."
  },
  {
    "author": "Joseph Gordon-Levitt",
    "category": "music",
    "id": 50644,
    "text": "The spiral in a snail's shell is the same mathematically as the spiral in the Milky Way galaxy, and it's also the same mathematically as the spirals in our DNA. It's the same ratio that you'll find in very basic music that transcends cultures all over the world."
  },
  {
    "author": "Oscar Wilde",
    "category": "music",
    "id": 50311,
    "text": "If one plays good music, people don't listen and if one plays bad music people don't talk."
  },
  {
    "author": "Saul Williams",
    "category": "music",
    "id": 51032,
    "text": "I think it's a mistake where rap music is these days. It doesn't seem to be able to look out of the ghetto and that's ultimately unfortunate, because it defines our limitations."
  },
  {
    "author": "Billy Joel",
    "category": "music",
    "id": 50846,
    "text": "If you make music for the human needs you have within yourself, then you do it for all humans who need the same things. You enrich humanity with the profound expression of these feelings."
  },
  {
    "author": "Christina Aguilera",
    "category": "music",
    "id": 50670,
    "text": "I turned to music originally because of my past and needing a release or an outlet to get out anger or frustration or hurt."
  },
  {
    "author": "Denis Diderot",
    "category": "music",
    "id": 50613,
    "text": "Good music is very close to primitive language."
  },
  {
    "author": "Manuel Puig",
    "category": "music",
    "id": 50590,
    "text": "I'm not terribly happy about rock and roll. Certain rock music is uninspiring, numbing it makes you feel like an idiot."
  },
  {
    "author": "Annie Lennox",
    "category": "music",
    "id": 50914,
    "text": "I love to make music and stay grounded."
  },
  {
    "author": "Jonathan Davis",
    "category": "music",
    "id": 50889,
    "text": "I've been a fan of electronic music since the beginning."
  },
  {
    "author": "Norah Jones",
    "category": "music",
    "id": 51164,
    "text": "For me making music is part social, part interaction, part collaboration."
  },
  {
    "author": "Mary J. Blige",
    "category": "music",
    "id": 50417,
    "text": "Music makes us want to live. You don't know how many times people have told me that they'd been down and depressed and just wanted to die. But then a special song caught their ear and that helped give them renewed strength. That's the power music has."
  },
  {
    "author": "Billy Corgan",
    "category": "music",
    "id": 50731,
    "text": "You have to be willing to deal with the ups and downs of the music, the ups and downs of the audience."
  },
  {
    "author": "Martin Scorsese",
    "category": "music",
    "id": 50630,
    "text": "Popular music formed the soundtrack of my life."
  },
  {
    "author": "Jerry Garcia",
    "category": "music",
    "id": 50388,
    "text": "I don't know why, it's the same reason why you like some music and you don't like others. There's something about it that you like. Ultimately I don't find it's in my best interests to try and analyze it, since it's fundamentally emotional."
  },
  {
    "author": "Joni Mitchell",
    "category": "music",
    "id": 51121,
    "text": "There was this mountain village in Russia where my music was getting in on some German radio station. I remember this because music used to get up to Saskatchewan from Texas. Late at night after the local station closed down."
  },
  {
    "author": "Barbara Januszkiewicz",
    "category": "music",
    "id": 51031,
    "text": "Jazz vision is the fusion of music and art a real paradox of same-yet different. Here we play in exchanges, like the hardness of the key of c# major and from the softness of Db major - capturing, reflecting and improvising."
  },
  {
    "author": "Barry White",
    "category": "music",
    "id": 50864,
    "text": "I quit high school on my birthday. It was my senior year and I didn't see the point. This was 1962, and I was ready to make music."
  },
  {
    "author": "Johann Sebastian Bach",
    "category": "music",
    "id": 50919,
    "text": "Music is an agreeable harmony for the honor of God and the permissible delights of the soul."
  },
  {
    "author": "Norah Jones",
    "category": "music",
    "id": 51175,
    "text": "Maybe I'm genetically more inclined to music - but the music I make is so far removed from Indian classical music. I grew up in Texas!"
  },
  {
    "author": "Carlos Santana",
    "category": "music",
    "id": 50673,
    "text": "First of all, the music that people call Latin or Spanish is really African. So Black people need to get the credit for that."
  },
  {
    "author": "W. H. Auden",
    "category": "music",
    "id": 50754,
    "text": "A verbal art like poetry is reflective it stops to think. Music is immediate, it goes on to become."
  },
  {
    "author": "Zhuangzi",
    "category": "music",
    "id": 50618,
    "text": "Those who seek to satisfy the mind of man by hampering it with ceremonies and music and affecting charity and devotion have lost their original nature."
  },
  {
    "author": "Jonathan Davis",
    "category": "music",
    "id": 50587,
    "text": "I don't like painting flowers in my music. I like painting guts and pain."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "music",
    "id": 51193,
    "text": "I find that it isn't wise to attempt to judge people on their public persona, and even on the music they make. Because I've met so many people whose music I cannot stand, and they're very nice. At the same time, I've met people whose music I've loved, and they're not the person you've invested all this emotion in."
  },
  {
    "author": "Michael Stipe",
    "category": "music",
    "id": 50295,
    "text": "Sometimes before we make a record I go back and listen to a few. It's equally humbling and uplifting."
  },
  {
    "author": "Ozzy Osbourne",
    "category": "music",
    "id": 50595,
    "text": "All that stuff about heavy metal and hard rock, I don't subscribe to any of that. It's all just music. I mean, the heavy metal from the Seventies sounds nothing like the stuff from the Eighties, and that sounds nothing like the stuff from the Nineties. Who's to say what is and isn't a certain type of music?"
  },
  {
    "author": "Rabindranath Tagore",
    "category": "music",
    "id": 50380,
    "text": "Music fills the infinite between two souls."
  },
  {
    "author": "Robert Plant",
    "category": "music",
    "id": 50652,
    "text": "When I was a kid, I was following black soul music."
  },
  {
    "author": "David Duchovny",
    "category": "music",
    "id": 50948,
    "text": "I don't need my phone to play me music. I need it to be a phone and an e-mail thing."
  },
  {
    "author": "David Byrne",
    "category": "music",
    "id": 50798,
    "text": "So there's no guarantee if you like the music you will empathize with the culture and the people who made it. It doesn't necessarily happen. I think it can, but it doesn't necessarily happen. Which is kind of a shame."
  },
  {
    "author": "Brian Eno",
    "category": "music",
    "id": 50697,
    "text": "Lyrics are always misleading because they make people think that that's what the music is about."
  },
  {
    "author": "Lawrence Welk",
    "category": "music",
    "id": 51206,
    "text": "One time I introduced my orchestra as the Shampoo Music Makers instead of the Champagne Music Makers."
  },
  {
    "author": "Archie Shepp",
    "category": "music",
    "id": 51079,
    "text": "Negro music and culture are intrinsically improvisational, existential. Nothing is sacred. After a decade, a musical idea, no matter how innovative, is threatened."
  },
  {
    "author": "Kid Rock",
    "category": "music",
    "id": 50782,
    "text": "I am happy to make money. I want to make more money, make more music, eat Big Macs and drink Budweisers."
  },
  {
    "author": "David Ogden Stiers",
    "category": "music",
    "id": 51082,
    "text": "High school music teachers... nobody makes a living off it."
  },
  {
    "author": "Quentin Tarantino",
    "category": "music",
    "id": 50482,
    "text": "I'm a big collector of vinyl - I have a record room in my house - and I've always had a huge soundtrack album collection. So what I do, as I'm writing a movie, is go through all those songs, trying to find good songs for fights, or good pieces of music to layer into the film."
  },
  {
    "author": "Chris Rock",
    "category": "music",
    "id": 50569,
    "text": "Music is the soundtrack to the crappy movie that is my life."
  },
  {
    "author": "Quentin Tarantino",
    "category": "music",
    "id": 50443,
    "text": "To me, movies and music go hand in hand. When I'm writing a script, one of the first things I do is find the music I'm going to play for the opening sequence."
  },
  {
    "author": "Bono",
    "category": "music",
    "id": 50903,
    "text": "I think ABBA have a pure joy to their music and that's what makes them extraordinary."
  },
  {
    "author": "Plutarch",
    "category": "music",
    "id": 50415,
    "text": "Medicine to produce health must examine disease and music, to create harmony must investigate discord."
  },
  {
    "author": "Adam Lambert",
    "category": "music",
    "id": 51070,
    "text": "I think Lady Gaga is great and is changing pop music and bringing back a certain rock 'n' roll spirit, swagger to the game."
  }
]

quotes['nature'] = [
  {
    "author": "Laurence J. Peter",
    "category": "nature",
    "id": 51773,
    "text": "Every girl should use what Mother Nature gave her before Father Time takes it away."
  },
  {
    "author": "Ellsworth Huntington",
    "category": "nature",
    "id": 51846,
    "text": "We are learning, too, that the love of beauty is one of Nature's greatest healers."
  },
  {
    "author": "Saint Augustine",
    "category": "nature",
    "id": 51539,
    "text": "Miracles are not contrary to nature, but only contrary to what we know about nature."
  },
  {
    "author": "John Updike",
    "category": "nature",
    "id": 52066,
    "text": "Dreams come true without that possibility, nature would not incite us to have them."
  },
  {
    "author": "Henry David Thoreau",
    "category": "nature",
    "id": 51414,
    "text": "If the machine of government is of such a nature that it requires you to be the agent of injustice to another, then, I say, break the law."
  },
  {
    "author": "Lindsay Lohan",
    "category": "nature",
    "id": 52036,
    "text": "Beauty is grace and confidence. I've learned to accept and appreciate what nature gave me."
  },
  {
    "author": "Thomas Paine",
    "category": "nature",
    "id": 51549,
    "text": "But such is the irresistable nature of truth, that all it asks, and all it wants is the liberty of appearing."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "nature",
    "id": 51606,
    "text": "The salary of the chief executive of a large corporation is not a market award for achievement. It is frequently in the nature of a warm personal gesture by the individual to himself."
  },
  {
    "author": "Alexander Pope",
    "category": "nature",
    "id": 51681,
    "text": "All nature is but art unknown to thee."
  },
  {
    "author": "Andrew Marvell",
    "category": "nature",
    "id": 52122,
    "text": "Self-preservation, nature's first great law, all the creatures, except man, doth awe."
  },
  {
    "author": "Anatole France",
    "category": "nature",
    "id": 51662,
    "text": "It is human nature to think wisely and act in an absurd fashion."
  },
  {
    "author": "Sara Teasdale",
    "category": "nature",
    "id": 51363,
    "text": "Life has loveliness to sell, all beautiful and splendid things, blue waves whitened on a cliff, soaring fire that sways and sings, and children's faces looking up, holding wonder like a cup."
  },
  {
    "author": "Thomas Moore",
    "category": "nature",
    "id": 51328,
    "text": "And the heart that is soonest awake to the flowers is always the first to be touch'd by the thorns."
  },
  {
    "author": "Calvin Coolidge",
    "category": "nature",
    "id": 51659,
    "text": "Men speak of natural rights, but I challenge any one to show where in nature any rights existed or were recognized until there was established for their declaration and protection a duly promulgated body of corresponding laws."
  },
  {
    "author": "Louis Nizer",
    "category": "nature",
    "id": 52154,
    "text": "A beautiful lady is an accident of nature. A beautiful old lady is a work of art."
  },
  {
    "author": "Steve Lacy",
    "category": "nature",
    "id": 52110,
    "text": "I think it is in collaboration that the nature of art is revealed."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "nature",
    "id": 51262,
    "text": "It is not so much for its beauty that the forest makes a claim upon men's hearts, as for that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit."
  },
  {
    "author": "Abraham Lincoln",
    "category": "nature",
    "id": 51213,
    "text": "All my life I have tried to pluck a thistle and plant a flower wherever the flower would grow in thought and mind."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "nature",
    "id": 51617,
    "text": "Our character is not so much the product of race and heredity as of those circumstances by which nature forms our habits, by which we are nurtured and live."
  },
  {
    "author": "Herbert Simon",
    "category": "nature",
    "id": 52133,
    "text": "Most of us really aren't horribly unique. There are 6 billion of us. Put 'em all in one room and very few would stand out as individuals. So maybe we ought to think of worth in terms of our ability to get along as a part of nature, rather than being the lords over nature."
  },
  {
    "author": "Richard P. Feynman",
    "category": "nature",
    "id": 51630,
    "text": "Nature uses only the longest threads to weave her patterns, so that each small piece of her fabric reveals the organization of the entire tapestry."
  },
  {
    "author": "Henry David Thoreau",
    "category": "nature",
    "id": 51443,
    "text": "Nature is full of genius, full of the divinity so that not a snowflake escapes its fashioning hand."
  },
  {
    "author": "May Sarton",
    "category": "nature",
    "id": 51660,
    "text": "Everything that slows us down and forces patience, everything that sets us back into the slow circles of nature, is a help. Gardening is an instrument of grace."
  },
  {
    "author": "Herman Melville",
    "category": "nature",
    "id": 52041,
    "text": "Is there some principal of nature which states that we never know the quality of what we have until it is gone?"
  },
  {
    "author": "William James",
    "category": "nature",
    "id": 51493,
    "text": "The deepest principle in human nature is the craving to be appreciated."
  },
  {
    "author": "Woody Allen",
    "category": "nature",
    "id": 51289,
    "text": "I am two with nature."
  },
  {
    "author": "Georg C. Lichtenberg",
    "category": "nature",
    "id": 52054,
    "text": "What is called an acute knowledge of human nature is mostly nothing but the observer's own weaknesses reflected back from others."
  },
  {
    "author": "John Muir",
    "category": "nature",
    "id": 51249,
    "text": "The mountains are calling and I must go."
  },
  {
    "author": "Marquis de Sade",
    "category": "nature",
    "id": 51891,
    "text": "The primary and most beautiful of Nature's qualities is motion, which agitates her at all times, but this motion is simply a perpetual consequence of crimes, she conserves it by means of crimes only."
  },
  {
    "author": "William Burroughs",
    "category": "nature",
    "id": 51942,
    "text": "This is a war universe. War all the time. That is its nature. There may be other universes based on all sorts of other principles, but ours seems to be based on war and games."
  },
  {
    "author": "Hosea Ballou",
    "category": "nature",
    "id": 51951,
    "text": "Disease is the retribution of outraged Nature."
  },
  {
    "author": "Herbert Spencer",
    "category": "nature",
    "id": 51993,
    "text": "An argument fatal to the communist theory, is suggested by the fact, that a desire for property is one of the elements of our nature."
  },
  {
    "author": "Izaak Walton",
    "category": "nature",
    "id": 51378,
    "text": "Those little nimble musicians of the air, that warble forth their curious ditties, with which nature hath furnished them to the shame of art."
  },
  {
    "author": "Julian Assange",
    "category": "nature",
    "id": 52030,
    "text": "If journalism is good, it is controversial, by its nature."
  },
  {
    "author": "J. G. Holland",
    "category": "nature",
    "id": 52038,
    "text": "Nature is the master of talents genius is the master of nature."
  },
  {
    "author": "Taslima Nasrin",
    "category": "nature",
    "id": 52204,
    "text": "Nature says women are human beings, men have made religions to deny it. Nature says women are human beings, men cry out no!"
  },
  {
    "author": "Joseph Addison",
    "category": "nature",
    "id": 51755,
    "text": "To be perfectly just is an attribute of the divine nature to be so to the utmost of our abilities, is the glory of man."
  },
  {
    "author": "Marco Rubio",
    "category": "nature",
    "id": 51932,
    "text": "It's not in our nature. Americans have never been a people that drive through a nice neighborhood and say, 'Oh, I hate the people who live in these nice houses.'"
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "nature",
    "id": 51618,
    "text": "Though nature be ever so generous, yet can she not make a hero alone. Fortune must contribute her part too and till both concur, the work cannot be perfected."
  },
  {
    "author": "Hal Borland",
    "category": "nature",
    "id": 51343,
    "text": "You can't be suspicious of a tree, or accuse a bird or a squirrel of subversion or challenge the ideology of a violet."
  },
  {
    "author": "Drew Barrymore",
    "category": "nature",
    "id": 51895,
    "text": "Becoming emancipated at 14, my life wasn't normal. I didn't have to go to school, so I didn't. I was rebellious by nature. I spent my 20s focusing on my company, Flower Films, and producing movies. Now that I'm almost 30, I would like to try other things in lie. I'm crazy about photography, and I want to take an art history class."
  },
  {
    "author": "John Garamendi",
    "category": "nature",
    "id": 52014,
    "text": "Mother Nature comes up against reality, and the reality is that the system doesn't work."
  },
  {
    "author": "William Cowper",
    "category": "nature",
    "id": 51840,
    "text": "Nature is a good name for an effect whose cause is God."
  },
  {
    "author": "Elisabeth Kubler-Ross",
    "category": "nature",
    "id": 51299,
    "text": "Should you shield the canyons from the windstorms you would never see the true beauty of their carvings."
  },
  {
    "author": "Herbert Read",
    "category": "nature",
    "id": 51939,
    "text": "I am not going to claim that modern anarchism has any direct relation to Roman jurisprudence but I do claim that it has its basis in the laws of nature rather than in the state of nature."
  },
  {
    "author": "Walt Disney",
    "category": "nature",
    "id": 51499,
    "text": "I don't like formal gardens. I like wild nature. It's just the wilderness instinct in me, I guess."
  },
  {
    "author": "Jimmy Carter",
    "category": "nature",
    "id": 51784,
    "text": "It is good to realize that if love and peace can prevail on earth, and if we can teach our children to honor nature's gifts, the joys and beauties of the outdoors will be here forever."
  },
  {
    "author": "Andy Goldsworthy",
    "category": "nature",
    "id": 51373,
    "text": "Occasionally I have come across a last patch of snow on top of a mountain in late May or June. There's something very powerful about finding snow in summer."
  },
  {
    "author": "Edward Steichen",
    "category": "nature",
    "id": 51325,
    "text": "I knew, of course, that trees and plants had roots, stems, bark, branches and foliage that reached up toward the light. But I was coming to realize that the real magician was light itself."
  },
  {
    "author": "Havelock Ellis",
    "category": "nature",
    "id": 51344,
    "text": "The sun, the moon and the stars would have disappeared long ago... had they happened to be within the reach of predatory human hands."
  },
  {
    "author": "Lady Gaga",
    "category": "nature",
    "id": 51818,
    "text": "I'm definitely a Polaroid camera girl. For me, what I'm really excited about is bringing back the artistry and the nature of Polaroid."
  },
  {
    "author": "Nathan Fillion",
    "category": "nature",
    "id": 52083,
    "text": "You want to put out a TV show? If you have the money to do it on your own, by yourself, and you have a TV network, you can do it by yourself. But the nature of the beast is, art needs finance. That's how this industry works. So until the Internet becomes our source of entertainment - and watch it, I believe it will - this is how things go."
  },
  {
    "author": "Bjork",
    "category": "nature",
    "id": 51988,
    "text": "It's incredible how nature sets females up to take care of people, and yet it is tricky for them to take care of themselves."
  },
  {
    "author": "David Hume",
    "category": "nature",
    "id": 51957,
    "text": "Human Nature is the only science of man and yet has been hitherto the most neglected."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "nature",
    "id": 51574,
    "text": "It is the nature of every person to error, but only the fool perseveres in error."
  },
  {
    "author": "Hamlin Garland",
    "category": "nature",
    "id": 51388,
    "text": "Whenever the pressure of our complex city life thins my blood and numbs my brain, I seek relief in the trail and when I hear the coyote wailing to the yellow dawn, my cares fall from me - I am happy."
  },
  {
    "author": "Henry Beston",
    "category": "nature",
    "id": 51699,
    "text": "The three great elemental sounds in nature are the sound of rain, the sound of wind in a primeval wood, and the sound of outer ocean on a beach."
  },
  {
    "author": "Sallust",
    "category": "nature",
    "id": 52019,
    "text": "It is a law of human nature that in victory even the coward may boast of his prowess, while defeat injures the reputation even of the brave."
  },
  {
    "author": "Hermann Hesse",
    "category": "nature",
    "id": 51940,
    "text": "What constitutes a real, live human being is more of a mystery than ever these days, and men each one of whom is a valuable, unique experiment on the part of nature are shot down wholesale."
  },
  {
    "author": "Deepak Chopra",
    "category": "nature",
    "id": 51715,
    "text": "It is the nature of babies to be in bliss."
  },
  {
    "author": "Mary Wollstonecraft",
    "category": "nature",
    "id": 52144,
    "text": "Learn from me, if not by my precepts, then by my example, how dangerous is the pursuit of knowledge and how much happier is that man who believes his native town to be the world than he who aspires to be greater than his nature will allow."
  },
  {
    "author": "Arnold J. Toynbee",
    "category": "nature",
    "id": 51754,
    "text": "As human beings, we are endowed with freedom of choice, and we cannot shuffle off our responsibility upon the shoulders of God or nature. We must shoulder it ourselves. It is our responsibility."
  },
  {
    "author": "Marco Rubio",
    "category": "nature",
    "id": 51931,
    "text": "We are a people that have always celebrated other people's success so long as we always had the opportunity to meet that success ourselves. That is the American nature. That is the American character. That is one of the things that makes us different from the rest of the world. And I'm afraid we could lose that or are on the verge of losing that."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "nature",
    "id": 51969,
    "text": "Ultimately, all human activities have as their goal the realization of happiness. Why, then, have we ended up producing the opposite result? Could the underlying cause be our failure to correctly understand the true nature of happiness?"
  },
  {
    "author": "Annie Leibovitz",
    "category": "nature",
    "id": 51317,
    "text": "Nature is so powerful, so strong. Capturing its essence is not easy - your work becomes a dance with light and the weather. It takes you to a place within yourself."
  },
  {
    "author": "Thomas Merton",
    "category": "nature",
    "id": 51245,
    "text": "By reading the scriptures I am so renewed that all nature seems renewed around me and with me. The sky seems to be a pure, a cooler blue, the trees a deeper green. The whole world is charged with the glory of God and I feel fire and music under my feet."
  },
  {
    "author": "Albert J. Nock",
    "category": "nature",
    "id": 52199,
    "text": "Assuming that man has a distinct spiritual nature, a soul, why should it be thought unnatural that under appropriate conditions of maladjustment, his soul might die before his body does or that his soul might die without his knowing it?"
  },
  {
    "author": "Lee Atwater",
    "category": "nature",
    "id": 51774,
    "text": "My illness has taught me something about the nature of humanity, love, brotherhood and relationships that I never understood, and probably never would have. So, from that standpoint, there is some truth and good in everything."
  },
  {
    "author": "Neil Armstrong",
    "category": "nature",
    "id": 51564,
    "text": "I think we're going to the moon because it's in the nature of the human being to face challenges. It's by the nature of his deep inner soul... we're required to do these things just as salmon swim upstream."
  },
  {
    "author": "Johannes Kepler",
    "category": "nature",
    "id": 52016,
    "text": "The diversity of the phenomena of nature is so great, and the treasures hidden in the heavens so rich, precisely in order that the human mind shall never be lacking in fresh nourishment."
  },
  {
    "author": "Alexander Pope",
    "category": "nature",
    "id": 51666,
    "text": "The way of the Creative works through change and transformation, so that each thing receives its true nature and destiny and comes into permanent accord with the Great Harmony: this is what furthers and what perseveres."
  },
  {
    "author": "Plato",
    "category": "nature",
    "id": 51486,
    "text": "To prefer evil to good is not in human nature and when a man is compelled to choose one of two evils, no one will choose the greater when he might have the less."
  },
  {
    "author": "Denis Diderot",
    "category": "nature",
    "id": 51863,
    "text": "No man has received from nature the right to command his fellow human beings."
  },
  {
    "author": "Virginia Woolf",
    "category": "nature",
    "id": 51678,
    "text": "It is the nature of the artist to mind excessively what is said about him. Literature is strewn with the wreckage of men who have minded beyond reason the opinions of others."
  },
  {
    "author": "Lou Holtz",
    "category": "nature",
    "id": 51237,
    "text": "A bird doesn't sing because it has an answer, it sings because it has a song."
  },
  {
    "author": "Alexander Pope",
    "category": "nature",
    "id": 51675,
    "text": "All are but parts of one stupendous whole, Whose body Nature is, and God the soul."
  },
  {
    "author": "Kristin Scott Thomas",
    "category": "nature",
    "id": 52190,
    "text": "French is a foreign language, but I've been speaking it since I was 18 so it's second nature to me."
  },
  {
    "author": "William Wordsworth",
    "category": "nature",
    "id": 51576,
    "text": "Nature never did betray the heart that loved her."
  },
  {
    "author": "Antoine de Saint-Exupery",
    "category": "nature",
    "id": 51646,
    "text": "The machine does not isolate man from the great problems of nature but plunges him more deeply into them."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "nature",
    "id": 51503,
    "text": "In nature we never see anything isolated, but everything in connection with something else which is before it, beside it, under it and over it."
  },
  {
    "author": "Bertrand Russell",
    "category": "nature",
    "id": 51275,
    "text": "I've made an odd discovery. Every time I talk to a savant I feel quite sure that happiness is no longer a possibility. Yet when I talk with my gardener, I'm convinced of the opposite."
  },
  {
    "author": "Martin Luther",
    "category": "nature",
    "id": 51247,
    "text": "For in the true nature of things, if we rightly consider, every green tree is far more glorious than if it were made of gold and silver."
  },
  {
    "author": "Andrea Arnold",
    "category": "nature",
    "id": 52166,
    "text": "Whenever I get fed up with life I love to go wandering in nature."
  },
  {
    "author": "Bob Dylan",
    "category": "nature",
    "id": 51484,
    "text": "I think I have a dualistic nature."
  },
  {
    "author": "Sienna Miller",
    "category": "nature",
    "id": 52077,
    "text": "Human nature is such that monogamy is a really hard thing to achieve."
  },
  {
    "author": "Vera Farmiga",
    "category": "nature",
    "id": 52115,
    "text": "The Ukrainian community is tight-knit by nature."
  },
  {
    "author": "Tennessee Williams",
    "category": "nature",
    "id": 51792,
    "text": "A vacuum is a hell of a lot better than some of the stuff that nature replaces it with."
  },
  {
    "author": "Wendell Berry",
    "category": "nature",
    "id": 51357,
    "text": "I am not bound for any public place, but for ground of my own where I have planted vines and orchard trees, and in the heat of the day climbed up into the healing shadow of the woods."
  },
  {
    "author": "John Fowles",
    "category": "nature",
    "id": 51365,
    "text": "In some mysterious way woods have never seemed to me to be static things. In physical terms, I move through them yet in metaphysical ones, they seem to move through me."
  },
  {
    "author": "Andrew Bernstein",
    "category": "nature",
    "id": 51873,
    "text": "Nothing is given to man on earth - struggle is built into the nature of life, and conflict is possible - the hero is the man who lets no obstacle prevent him from pursuing the values he has chosen."
  },
  {
    "author": "John Paul Jones",
    "category": "nature",
    "id": 51620,
    "text": "It seems to be a law of nature, inflexible and inexorable, that those who will not risk cannot win."
  },
  {
    "author": "Isaac Bashevis Singer",
    "category": "nature",
    "id": 51747,
    "text": "What nature delivers to us is never stale. Because what nature creates has eternity in it."
  },
  {
    "author": "Robin Williams",
    "category": "nature",
    "id": 51240,
    "text": "Spring is nature's way of saying, 'Let's party!'"
  },
  {
    "author": "Geoffrey Chaucer",
    "category": "nature",
    "id": 52171,
    "text": "By nature, men love newfangledness."
  },
  {
    "author": "Garry Kasparov",
    "category": "nature",
    "id": 52116,
    "text": "Women, by their nature, are not exceptional chess players: they are not great fighters."
  },
  {
    "author": "Alexander Pope",
    "category": "nature",
    "id": 51668,
    "text": "A God without dominion, providence, and final causes, is nothing else but fate and nature."
  },
  {
    "author": "John Ruskin",
    "category": "nature",
    "id": 51220,
    "text": "Sunshine is delicious, rain is refreshing, wind braces us up, snow is exhilarating there is really no such thing as bad weather, only different kinds of good weather."
  },
  {
    "author": "Archibald Alexander",
    "category": "nature",
    "id": 51928,
    "text": "Nature never makes any blunders, when she makes a fool she means it."
  },
  {
    "author": "Marcus Aurelius",
    "category": "nature",
    "id": 51507,
    "text": "Observe constantly that all things take place by change, and accustom thyself to consider that the nature of the Universe loves nothing so much as to change the things which are, and to make new things like them."
  },
  {
    "author": "Rabindranath Tagore",
    "category": "nature",
    "id": 51250,
    "text": "The butterfly counts not months but moments, and has time enough."
  }
]

quotes['parenting'] = [
  {
    "author": "Voltaire",
    "category": "parenting",
    "id": 52223,
    "text": "How pleasant it is for a father to sit at his child's board. It is like an aged man reclining under the shadow of an oak which he has planted."
  },
  {
    "author": "Debra Winger",
    "category": "parenting",
    "id": 52328,
    "text": "I hope to find the roles that are age appropriate but not yearning to be younger, or parenting ad nauseam."
  },
  {
    "author": "Russell Baker",
    "category": "parenting",
    "id": 52233,
    "text": "Don't try to make children grow up to be like you, or they may do it."
  },
  {
    "author": "Norma Shearer",
    "category": "parenting",
    "id": 52284,
    "text": "I get whatever placidity I have from my father. But my mother taught me how to take it on the chin."
  },
  {
    "author": "Mayim Bialik",
    "category": "parenting",
    "id": 52334,
    "text": "Attachment parenting is not a passive parenting style."
  },
  {
    "author": "Jennifer Aniston",
    "category": "parenting",
    "id": 52309,
    "text": "Parenting is one of the hardest jobs on earth."
  },
  {
    "author": "Erica Jong",
    "category": "parenting",
    "id": 52322,
    "text": "Women are individuals in parenting, and why not?"
  },
  {
    "author": "Clive Owen",
    "category": "parenting",
    "id": 52319,
    "text": "Very often when you see families it's all perfect and neat, and parenting isn't like that. You do have constant negotiations. Things are ever developing and ever changing, and you constantly have to evaluate how you deal with your kids."
  },
  {
    "author": "Mayim Bialik",
    "category": "parenting",
    "id": 52337,
    "text": "I came to parenting the way most of us do - knowing nothing and trying to learn everything."
  },
  {
    "author": "Gloria Steinem",
    "category": "parenting",
    "id": 52231,
    "text": "Most American children suffer too much mother and too little father."
  },
  {
    "author": "Miguel de Cervantes",
    "category": "parenting",
    "id": 52262,
    "text": "No fathers or mothers think their own children ugly."
  },
  {
    "author": "Bill Cosby",
    "category": "parenting",
    "id": 52221,
    "text": "A new father quickly learns that his child invariably comes to the bathroom at precisely the times when he's in there, as if he needed company. The only way for this father to be certain of bathroom privacy is to shave at the gas station."
  },
  {
    "author": "Sloane Crosley",
    "category": "parenting",
    "id": 52326,
    "text": "My grandmother was a kind of Scarsdale, New York, society woman, best known in her day as the author of the 1959 book 'Growing Your Own Way: An Informal Guide for Teen-Agers' - this despite being a person whose parenting style made Joan Crawford's wire hangers look like pool noodles."
  },
  {
    "author": "Bill Cosby",
    "category": "parenting",
    "id": 52224,
    "text": "The truth is that parents are not really interested in justice. They just want quiet."
  },
  {
    "author": "Padma Lakshmi",
    "category": "parenting",
    "id": 52332,
    "text": "In truth, I am a single mother. But I don't feel alone at all in parenting my daughter. Krishna has a whole other side of her family who loves her, too. And so Krishna is parented by me, but also by her grandmother and aunts and cousins and uncles and friends."
  },
  {
    "author": "Jane D. Hull",
    "category": "parenting",
    "id": 52232,
    "text": "At the end of the day, the most overwhelming key to a child's success is the positive involvement of parents."
  },
  {
    "author": "Sigmund Freud",
    "category": "parenting",
    "id": 52212,
    "text": "I cannot think of any need in childhood as strong as the need for a father's protection."
  },
  {
    "author": "Garrison Keillor",
    "category": "parenting",
    "id": 52236,
    "text": "Nothing you do for children is ever wasted. They seem not to notice us, hovering, averting our eyes, and they seldom offer thanks, but what we do for them is never wasted."
  },
  {
    "author": "Andrew Shue",
    "category": "parenting",
    "id": 52283,
    "text": "There are 80 million moms in the United States. Forty million stay at home with their children."
  },
  {
    "author": "Liza Minnelli",
    "category": "parenting",
    "id": 52274,
    "text": "I've said it before, but it's absolutely true: My mother gave me my drive, but my father gave me my dreams. Thanks to him, I could see a future."
  },
  {
    "author": "Marjorie Holmes",
    "category": "parenting",
    "id": 52287,
    "text": "What feeling is so nice as a child's hand in yours? So small, so soft and warm, like a kitten huddling in the shelter of your clasp."
  },
  {
    "author": "Buddha",
    "category": "parenting",
    "id": 52209,
    "text": "To enjoy good health, to bring true happiness to one's family, to bring peace to all, one must first discipline and control one's own mind. If a man can control his mind he can find the way to Enlightenment, and all wisdom and virtue will naturally come to him."
  },
  {
    "author": "June Allyson",
    "category": "parenting",
    "id": 52298,
    "text": "I'd just as soon stay home and raise babies."
  },
  {
    "author": "Ryan Phillippe",
    "category": "parenting",
    "id": 52345,
    "text": "I grew up with no money. My kids will grow up with a lot of money and so it's really important to me, and it will always be a part of my parenting, to keep them conscientious and connected socially to other people."
  },
  {
    "author": "Kamisese Mara",
    "category": "parenting",
    "id": 52272,
    "text": "The family teaches us about the importance of knowledge, education, hard work and effort. It teaches us about enjoying ourselves, having fun, keeping fit and healthy."
  },
  {
    "author": "Mary J. Blige",
    "category": "parenting",
    "id": 52318,
    "text": "I barely have time for my own children. To adopt more children and not have time for them, that would be poor parenting on my part."
  },
  {
    "author": "Nadia Boulanger",
    "category": "parenting",
    "id": 52244,
    "text": "Loving a child doesn't mean giving in to all his whims to love him is to bring out the best in him, to teach him to love what is difficult."
  },
  {
    "author": "Lisa Whelchel",
    "category": "parenting",
    "id": 52354,
    "text": "I'm hosting weekend retreats all over America. It is like a 24-hour slumber party for moms. We laugh, eat, play games, get massages, win prizes, talk about parenting and even cry a bit."
  },
  {
    "author": "Robbie Coltrane",
    "category": "parenting",
    "id": 52291,
    "text": "Believe me, my children have more stamina than a power station."
  },
  {
    "author": "Phil McGraw",
    "category": "parenting",
    "id": 52249,
    "text": "The Internet is just bringing all kinds of information into the home. There's just a lot of distraction, a lot of competition for the parent's voice to resonate in the children's ears."
  },
  {
    "author": "Coretta Scott King",
    "category": "parenting",
    "id": 52299,
    "text": "Mama and Daddy King represent the best in manhood and womanhood, the best in a marriage, the kind of people we are trying to become."
  },
  {
    "author": "Mel Carnahan",
    "category": "parenting",
    "id": 52350,
    "text": "Parents are key when it comes to keeping kids off drugs. Good parenting is the best anti-drug we have."
  },
  {
    "author": "Jill Clayburgh",
    "category": "parenting",
    "id": 52302,
    "text": "I wasn't very good about juggling family and my career. I was interested in who was coming to the children's birthday party, what my son was writing. I was thinking about Legos."
  },
  {
    "author": "Beverly Cleary",
    "category": "parenting",
    "id": 52282,
    "text": "I don't think children's inner feelings have changed. They still want a mother and father in the very same house they want places to play."
  },
  {
    "author": "Anne Sullivan",
    "category": "parenting",
    "id": 52285,
    "text": "It's a great mistake, I think, to put children off with falsehoods and nonsense, when their growing powers of observation and discrimination excite in them a desire to know about things."
  },
  {
    "author": "Christy Turlington",
    "category": "parenting",
    "id": 52257,
    "text": "Parents should not smoke in order to discourage their kids from smoking. A child is more likely to smoke when they have been raised in the environment of a smoker."
  },
  {
    "author": "Mika Brzezinski",
    "category": "parenting",
    "id": 52338,
    "text": "I realize that of all people, I am no expert on parenting or marriage."
  },
  {
    "author": "Marcelene Cox",
    "category": "parenting",
    "id": 52281,
    "text": "No one knows his true character until he has run out of gas, purchased something on the installment plan and raised an adolescent."
  },
  {
    "author": "Olivia Newton-John",
    "category": "parenting",
    "id": 52241,
    "text": "To me luxury is to be at home with my daughter, and the occasional massage doesn't hurt."
  },
  {
    "author": "Martin Mull",
    "category": "parenting",
    "id": 52238,
    "text": "Having children is like having a bowling alley installed in your brain."
  },
  {
    "author": "Jennifer Aniston",
    "category": "parenting",
    "id": 52311,
    "text": "Of course, the ideal scenario for parenting is obviously two parents of a mature age."
  },
  {
    "author": "Eric McCormack",
    "category": "parenting",
    "id": 52348,
    "text": "I'm torn about late parenting. I believe people should spend their twenties living and having fun and not having any regrets later. I also think people in their thirties generally make better parents but so many of my friends are having trouble - myself included - as fathers get older."
  },
  {
    "author": "Milton Sapirstein",
    "category": "parenting",
    "id": 52279,
    "text": "Education, like neurosis, begins at home."
  },
  {
    "author": "Carl Jung",
    "category": "parenting",
    "id": 52216,
    "text": "Children are educated by what the grown-up is and not by his talk."
  },
  {
    "author": "Harry Connick, Jr.",
    "category": "parenting",
    "id": 52235,
    "text": "I think a dad has to make his daughter feel that he's genuinely interested in what she's going through."
  },
  {
    "author": "Meryl Streep",
    "category": "parenting",
    "id": 52251,
    "text": "The interesting thing about being a mother is that everyone wants pets, but no one but me cleans the kitty litter."
  },
  {
    "author": "Brooke Shields",
    "category": "parenting",
    "id": 52289,
    "text": "I think I'm going to have to live vicariously through my daughter's rebellion because I certainly never did go through adolescence."
  },
  {
    "author": "Barbara Bush",
    "category": "parenting",
    "id": 52310,
    "text": "I'm worried about parents who aren't parenting."
  },
  {
    "author": "Jillian Michaels",
    "category": "parenting",
    "id": 52343,
    "text": "Parenting is not for sissies. You have to sacrifice and grow up."
  },
  {
    "author": "Roy L. Smith",
    "category": "parenting",
    "id": 52227,
    "text": "We are apt to forget that children watch examples better than they listen to preaching."
  },
  {
    "author": "Tori Spelling",
    "category": "parenting",
    "id": 52316,
    "text": "I thought that once we were out of the baby stage, parenting would be a breeze."
  },
  {
    "author": "Mayim Bialik",
    "category": "parenting",
    "id": 52333,
    "text": "Relationships are complicated no matter what style of parenting you choose."
  },
  {
    "author": "Gena Lee Nolin",
    "category": "parenting",
    "id": 52247,
    "text": "My children are the reason I laugh, smile and want to get up every morning."
  },
  {
    "author": "George Bernard Shaw",
    "category": "parenting",
    "id": 52220,
    "text": "Parentage is a very important profession, but no test of fitness for it is ever imposed in the interest of the children."
  },
  {
    "author": "Miriam Makeba",
    "category": "parenting",
    "id": 52234,
    "text": "Girls are the future mothers of our society, and it is important that we focus on their well-being."
  },
  {
    "author": "Benjamin Spock",
    "category": "parenting",
    "id": 52264,
    "text": "The child supplies the power but the parents have to do the steering."
  },
  {
    "author": "Jane Fonda",
    "category": "parenting",
    "id": 52323,
    "text": "While not impossible, it is especially challenging for teenage parents to develop bonds with their children. A high percent of them were themselves children of teenage parents and have never experienced appropriate parenting."
  },
  {
    "author": "Ryan Phillippe",
    "category": "parenting",
    "id": 52295,
    "text": "Home life's great, man. The kids are great, happy and healthy. I've reached this sort of wonderful precipice."
  },
  {
    "author": "Ellen Goodman",
    "category": "parenting",
    "id": 52294,
    "text": "We criticize mothers for closeness. We criticize fathers for distance. How many of us have expected less from our fathers and appreciated what they gave us more? How many of us always let them off the hook?"
  },
  {
    "author": "Evan Bayh",
    "category": "parenting",
    "id": 52219,
    "text": "Mothers - especially single mothers - are heroic in their efforts to raise our nation's children, but men must also take responsibility for their children and recognize the impact they have on their families' well-being."
  },
  {
    "author": "Bob Barr",
    "category": "parenting",
    "id": 52342,
    "text": "For decades, parents were told by so-called parenting 'experts' that offspring would be best raised on the belief each is special and entitled to all life has to offer."
  },
  {
    "author": "Temple Grandin",
    "category": "parenting",
    "id": 52308,
    "text": "Autism is a neurological disorder. It's not caused by bad parenting. It's caused by, you know, abnormal development in the brain. The emotional circuits in the brain are abnormal. And there also are differences in the white matter, which is the brain's computer cables that hook up the different brain departments."
  },
  {
    "author": "Anthony Edwards",
    "category": "parenting",
    "id": 52237,
    "text": "There's really no point in having children if you're not going to be home enough to father them."
  },
  {
    "author": "Michael Showalter",
    "category": "parenting",
    "id": 52352,
    "text": "For me, Twitter works best as a way of taking pictures of being stuck in traffic on the Brooklyn Bridge. If people really want to read really funny quips about life, parenting, and pop culture, then by all means read Michael Ian Black's tweets."
  },
  {
    "author": "Erma Bombeck",
    "category": "parenting",
    "id": 52225,
    "text": "Never lend your car to anyone to whom you have given birth."
  },
  {
    "author": "Charles R. Swindoll",
    "category": "parenting",
    "id": 52218,
    "text": "Each day of our lives we make deposits in the memory banks of our children."
  },
  {
    "author": "Doug Larson",
    "category": "parenting",
    "id": 52230,
    "text": "Few things are more satisfying than seeing your children have teenagers of their own."
  },
  {
    "author": "Emma Thompson",
    "category": "parenting",
    "id": 52315,
    "text": "Indeed - judicious, consistent parenting is a dream of mine. No judgements, learning space and listening carefully are my goals."
  },
  {
    "author": "Stevie Nicks",
    "category": "parenting",
    "id": 52290,
    "text": "Do you want to be an artist and a writer, or a wife and a lover? With kids, your focus changes. I don't want to go to PTA meetings."
  },
  {
    "author": "Marie Osmond",
    "category": "parenting",
    "id": 52301,
    "text": "There are some great questions to ask your doctor. If he says 'no,' then you find yourself a different doctor. There really has to be a change in how we medically look at women at this time. I mean, this is not just baby gloom."
  },
  {
    "author": "John F. Kennedy",
    "category": "parenting",
    "id": 52214,
    "text": "Mothers all want their sons to grow up to be president, but they don't want them to become politicians in the process."
  },
  {
    "author": "Ron Taffel",
    "category": "parenting",
    "id": 52213,
    "text": "Even as kids reach adolescence, they need more than ever for us to watch over them. Adolescence is not about letting go. It's about hanging on during a very bumpy ride."
  },
  {
    "author": "Matthew Broderick",
    "category": "parenting",
    "id": 52252,
    "text": "Having a baby changes the way you view your in-laws. I love it when they come to visit now. They can hold the baby and I can go out."
  },
  {
    "author": "Joan Cusack",
    "category": "parenting",
    "id": 52346,
    "text": "I take parenting incredibly seriously. I want to be there for my kids and help them navigate the world, and develop skills, emotional intelligence, to enjoy life, and I'm lucky to be able to do that and have two healthy, normal boys."
  },
  {
    "author": "Fiona Apple",
    "category": "parenting",
    "id": 52324,
    "text": "No, I've never wanted kids. But I do read about parenting a lot."
  },
  {
    "author": "Clive Owen",
    "category": "parenting",
    "id": 52270,
    "text": "Parenthood and family come first for me, and when I'm not working I'm cool with the Teletubbies."
  },
  {
    "author": "Franklin P. Jones",
    "category": "parenting",
    "id": 52261,
    "text": "You can learn many things from children. How much patience you have, for instance."
  },
  {
    "author": "Edie Falco",
    "category": "parenting",
    "id": 52320,
    "text": "We're living in a time when parenting is not at all mirroring the way I was parented. For me, I just followed my parents around on their errands when they were busy on the phone, I was quiet. It's a different kettle of fish these days: They run the house, and you listen to their music, and you go to their appointments."
  },
  {
    "author": "Bob Filner",
    "category": "parenting",
    "id": 52256,
    "text": "Childhood obesity is best tackled at home through improved parental involvement, increased physical exercise, better diet and restraint from eating."
  },
  {
    "author": "Billy Graham",
    "category": "parenting",
    "id": 52210,
    "text": "A child who is allowed to be disrespectful to his parents will not have true respect for anyone."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "parenting",
    "id": 52211,
    "text": "We never know the love of a parent till we become parents ourselves."
  },
  {
    "author": "Ogden Nash",
    "category": "parenting",
    "id": 52277,
    "text": "Parents were invented to make children happy by giving them something to ignore."
  },
  {
    "author": "Todd Tiahrt",
    "category": "parenting",
    "id": 52239,
    "text": "The well-being and welfare of children should always be our focus."
  },
  {
    "author": "Audre Lorde",
    "category": "parenting",
    "id": 52313,
    "text": "I would like to do another piece of fiction dealing with a number of issues: Lesbian parenting, the 1960's, and interracial relationships in the Lesbian and Gay community."
  },
  {
    "author": "Reese Witherspoon",
    "category": "parenting",
    "id": 52280,
    "text": "I feel very blessed to have two wonderful, healthy children who keep me completely grounded, sane and throw up on my shoes just before I go to an awards show just so I know to keep it real."
  },
  {
    "author": "Virginia Satir",
    "category": "parenting",
    "id": 52307,
    "text": "What lingers from the parent's individual past, unresolved or incomplete, often becomes part of her or his irrational parenting."
  },
  {
    "author": "Ben Stein",
    "category": "parenting",
    "id": 52306,
    "text": "Screaming at children over their grades, especially to the point of the child's tears, is child abuse, pure and simple. It's not funny and it's not good parenting. It is a crushing, scarring, disastrous experience for the child. It isn't the least bit funny."
  },
  {
    "author": "Arlie Russell Hochschild",
    "category": "parenting",
    "id": 52353,
    "text": "In response to our fast-food culture, a 'slow food' movement appeared. Out of hurried parenthood, a move toward slow parenting could be growing. With vital government supports for state-of-the-art public child care and paid parental leave, maybe we would be ready to try slow love and marriage."
  },
  {
    "author": "Kenny G",
    "category": "parenting",
    "id": 52292,
    "text": "That's my ideal day, time with my boys."
  },
  {
    "author": "Mayim Bialik",
    "category": "parenting",
    "id": 52335,
    "text": "I've become sort of an accidental advocate for attachment parenting, which is a style of parenting that... basically, the way mammals parent and the way people have parented for pretty much all of human history except the last 200 years or so."
  },
  {
    "author": "Sloane Crosley",
    "category": "parenting",
    "id": 52327,
    "text": "Ah, the power of two. There's nothing quite like it. Especially when it comes to paying utility bills, parenting, cooking elaborate meals, purchasing a grown-up bed, jumping rope and lifting heavy machinery. The world favours pairs. Who wants to waste the wood building an ark for singletons?"
  },
  {
    "author": "Connie Sellecca",
    "category": "parenting",
    "id": 52263,
    "text": "You have to support your children to have a healthy relationship."
  },
  {
    "author": "Eddie Vedder",
    "category": "parenting",
    "id": 52325,
    "text": "I'm trying to break any chain of negative parenting that I might have survived."
  },
  {
    "author": "John Boehner",
    "category": "parenting",
    "id": 52259,
    "text": "Studies show that children best flourish when one mom and one dad are there to raise them."
  },
  {
    "author": "Frank A. Clark",
    "category": "parenting",
    "id": 52245,
    "text": "A baby is born with a need to be loved - and never outgrows it."
  },
  {
    "author": "Honore de Balzac",
    "category": "parenting",
    "id": 52215,
    "text": "A mother who is really a mother is never free."
  },
  {
    "author": "Bill Cosby",
    "category": "parenting",
    "id": 52304,
    "text": "No matter how calmly you try to referee, parenting will eventually produce bizarre behavior, and I'm not talking about the kids. Their behavior is always normal."
  },
  {
    "author": "John H. Johnson",
    "category": "parenting",
    "id": 52296,
    "text": "My mother was the influence in my life. She was strong she had great faith in the ultimate triumph of justice and hard work. She believed passionately in education."
  },
  {
    "author": "Bill Cosby",
    "category": "parenting",
    "id": 52305,
    "text": "My childhood should have taught me lessons for my own fatherhood, but it didn't because parenting can only be learned by people who have no children."
  },
  {
    "author": "Alvin Toffler",
    "category": "parenting",
    "id": 52268,
    "text": "Parenthood remains the greatest single preserve of the amateur."
  }
]

quotes['patience'] = [
  {
    "author": "Stanislaw Lec",
    "category": "patience",
    "id": 52411,
    "text": "You must first have a lot of patience to learn to have patience."
  },
  {
    "author": "George Washington",
    "category": "patience",
    "id": 52421,
    "text": "The marvel of all history is the patience with which men and women submit to burdens unnecessarily laid upon them by their governments."
  },
  {
    "author": "Tyrone Power",
    "category": "patience",
    "id": 52585,
    "text": "I've done an awful lot of stuff that's a monument to public patience."
  },
  {
    "author": "Margaret J. Wheatley",
    "category": "patience",
    "id": 52467,
    "text": "Hopelessness has surprised me with patience."
  },
  {
    "author": "Edmund Burke",
    "category": "patience",
    "id": 52372,
    "text": "Our patience will achieve more than our force."
  },
  {
    "author": "David Wilkerson",
    "category": "patience",
    "id": 52480,
    "text": "A final word: I am not knowledgeable about the internet. I do not have a computer. I guess that at 74 years of age, I don't have the patience to learn."
  },
  {
    "author": "Yiannis Stournaras",
    "category": "patience",
    "id": 52582,
    "text": "Difficult years lie ahead, patience is required."
  },
  {
    "author": "Beverly Cleary",
    "category": "patience",
    "id": 52517,
    "text": "When I was in the first grade I was afraid of the teacher and had a miserable time in the reading circle, a difficulty that was overcome by the loving patience of my second grade teacher. Even though I could read, I refused to do so."
  },
  {
    "author": "Simon Raven",
    "category": "patience",
    "id": 52574,
    "text": "And so, at the age of thirty, I had successively disgraced myself with three fine institutions, each of which had made me free of its full and rich resources, had trained me with skill and patience, and had shown me nothing but forbearance and charity when I failed in trust."
  },
  {
    "author": "Tony Kushner",
    "category": "patience",
    "id": 52492,
    "text": "Artists know that diligence counts as much, if not more, as inspiration in art, as in politics, patience counts as much as revolution."
  },
  {
    "author": "Matthew Arnold",
    "category": "patience",
    "id": 52530,
    "text": "Sad Patience, too near neighbour to despair."
  },
  {
    "author": "Harry Shum, Jr.",
    "category": "patience",
    "id": 52546,
    "text": "I've always been a person with patience, and I don't like to force things."
  },
  {
    "author": "Zoe Kazan",
    "category": "patience",
    "id": 52525,
    "text": "I don't have a lot of patience for boring arthouse movies."
  },
  {
    "author": "Ismail Haniyeh",
    "category": "patience",
    "id": 52524,
    "text": "When I said a few weeks ago that our people would eat cooking oil and olives if necessary, I didn't mean that there really would be only oil and olives. What I meant was that our people have the necessary patience to endure the current difficult situation. Palestinians would rather do without certain food items than their national rights."
  },
  {
    "author": "Elbert Hubbard",
    "category": "patience",
    "id": 52364,
    "text": "How many a man has thrown up his hands at a time when a little more effort, a little more patience would have achieved success."
  },
  {
    "author": "Bill Brandt",
    "category": "patience",
    "id": 52570,
    "text": "Sometimes they are a matter of luck the photographer could not expect or hope for them. Sometimes they are a matter of patience, waiting for an effect to be repeated that he has seen and lost or for one that he anticipates."
  },
  {
    "author": "Ridley Pearson",
    "category": "patience",
    "id": 52581,
    "text": "As a young boy, I read 'Cheaper by the Dozen' and immediately became neurotic about my use of time. It taxed me severely, but only for the next 50 years. But I think it also allowed me to discipline myself to sit in the chair and be a writer, where one of the most needed qualities is patience."
  },
  {
    "author": "Lexa Doig",
    "category": "patience",
    "id": 52501,
    "text": "Thank God my parents had an abundance of patience."
  },
  {
    "author": "Thomas Fuller",
    "category": "patience",
    "id": 52363,
    "text": "Abused patience turns to fury."
  },
  {
    "author": "Francis Bacon",
    "category": "patience",
    "id": 52384,
    "text": "Who ever is out of patience is out of possession of their soul."
  },
  {
    "author": "Philip Massinger",
    "category": "patience",
    "id": 52413,
    "text": "Patience, the beggar's virtue, shall find no harbor here."
  },
  {
    "author": "John Dryden",
    "category": "patience",
    "id": 52400,
    "text": "Beware the fury of a patient man."
  },
  {
    "author": "Major Taylor",
    "category": "patience",
    "id": 52544,
    "text": "I pray they will carry on in spite of that dreadful monster prejudice, and with patience, courage, fortitude and perseverance achieve success for themselves."
  },
  {
    "author": "Dick Dale",
    "category": "patience",
    "id": 52483,
    "text": "I don't play pyrotechnic scales. I play about frustration, patience, anger. Music is an extension of my soul."
  },
  {
    "author": "Kin Hubbard",
    "category": "patience",
    "id": 52392,
    "text": "Lack of pep is often mistaken for patience."
  },
  {
    "author": "Arnold H. Glasow",
    "category": "patience",
    "id": 52378,
    "text": "The key to everything is patience. You get the chicken by hatching the egg, not by smashing it."
  },
  {
    "author": "Solomon Ibn Gabirol",
    "category": "patience",
    "id": 52368,
    "text": "The test of good manners is to be patient with the bad ones."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "patience",
    "id": 52440,
    "text": "We have no patience with other people's vanity because it is offensive to our own."
  },
  {
    "author": "Thomas Hardy",
    "category": "patience",
    "id": 52408,
    "text": "Patience, that blending of moral courage with physical timidity."
  },
  {
    "author": "Heraclitus",
    "category": "patience",
    "id": 52374,
    "text": "Good character is not formed in a week or a month. It is created little by little, day by day. Protracted and patient effort is needed to develop good character."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "patience",
    "id": 52377,
    "text": "Patience is necessary, and one cannot reap immediately where one has sown."
  },
  {
    "author": "Phaedrus",
    "category": "patience",
    "id": 52410,
    "text": "Everyone ought to bear patiently the results of his own conduct."
  },
  {
    "author": "Ilie Nastase",
    "category": "patience",
    "id": 52583,
    "text": "If you have confidence you have patience. Confidence, that is everything."
  },
  {
    "author": "Elisha Cuthbert",
    "category": "patience",
    "id": 52460,
    "text": "When I was 20, I thought I was 30 - but I was so far from it. When you're young, you want everything to happen now. As you mature, you can look back and see all the great things you achieved with time and patience."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "patience",
    "id": 52393,
    "text": "Patience is the support of weakness impatience the ruin of strength."
  },
  {
    "author": "Cleveland Amory",
    "category": "patience",
    "id": 52456,
    "text": "As anyone who has ever been around a cat for any length of time well knows, cats have enormous patience with the limitations of the human kind."
  },
  {
    "author": "Anthony Hamilton",
    "category": "patience",
    "id": 52429,
    "text": "I learned patience, perseverance, and dedication. Now I really know myself, and I know my voice. It's a voice of pain and victory."
  },
  {
    "author": "Robert Falcon Scott",
    "category": "patience",
    "id": 52477,
    "text": "I can imagine few things more trying to the patience than the long wasted days of waiting."
  },
  {
    "author": "Tom Holt",
    "category": "patience",
    "id": 52542,
    "text": "Everything is out there if you know how to find it, and have the patience. I don't and haven't, but that's my problem."
  },
  {
    "author": "Melissa Rosenberg",
    "category": "patience",
    "id": 52496,
    "text": "Everyone is given one gift, a reason for being, and it's our obligation to do something with it. Obviously, it's a challenge - but if you're not taking the bull by the horns, I have no patience for you. You're just taking up space."
  },
  {
    "author": "Debra Winger",
    "category": "patience",
    "id": 52479,
    "text": "If I could have one prayer answered, I would pray for patience. I move so fast sometimes. I try to slow down."
  },
  {
    "author": "Randy Travis",
    "category": "patience",
    "id": 52562,
    "text": "I've learned the importance of loving what you do. I have also learned more patience due to the nature of the music business."
  },
  {
    "author": "Nicholas Brendon",
    "category": "patience",
    "id": 52559,
    "text": "Constant repetition of tongue-twisters was like lifting weights for me, but patience and persistence have paid off."
  },
  {
    "author": "Frances O'Grady",
    "category": "patience",
    "id": 52535,
    "text": "My impression is that most women public service workers have a long fuse. Precisely because they care so deeply about services, more than anyone, they still want to find a sensible and fair negotiated agreement. But their patience has run out."
  },
  {
    "author": "Ralph Marston",
    "category": "patience",
    "id": 52416,
    "text": "The keys to patience are acceptance and faith. Accept things as they are, and look realistically at the world around you. Have faith in yourself and in the direction you have chosen."
  },
  {
    "author": "Tom Lantos",
    "category": "patience",
    "id": 52550,
    "text": "The patience of the American public with dilatory diplomatic delays will be very limited."
  },
  {
    "author": "Ryunosuke Satoro",
    "category": "patience",
    "id": 52468,
    "text": "Find patience in the breath of life."
  },
  {
    "author": "Ryan White",
    "category": "patience",
    "id": 52526,
    "text": "We had great faith that with patience, understanding, and education, that my family and I could be helpful in changing their minds and attitudes around."
  },
  {
    "author": "Michelangelo",
    "category": "patience",
    "id": 52373,
    "text": "Genius is eternal patience."
  },
  {
    "author": "Abu Bakr",
    "category": "patience",
    "id": 52475,
    "text": "There is no harm in patience, and no profit in lamentation. Death is easier to bear (than) that which precedes it, and more severe than that which comes after it. Remember the death of the Apostle of God, and your sorrow will be lessened."
  },
  {
    "author": "Thomas Huxley",
    "category": "patience",
    "id": 52448,
    "text": "Patience and tenacity are worth more than twice their weight of cleverness."
  },
  {
    "author": "John Updike",
    "category": "patience",
    "id": 52406,
    "text": "A healthy male adult bore consumes each year one and a half times his own weight in other people's patience."
  },
  {
    "author": "David Duchovny",
    "category": "patience",
    "id": 52473,
    "text": "I think patience is a skill and I wish I had it."
  },
  {
    "author": "Gail Simmons",
    "category": "patience",
    "id": 52507,
    "text": "Patience is the secret to good food."
  },
  {
    "author": "John Major",
    "category": "patience",
    "id": 52472,
    "text": "The first requirement of politics is not intellect or stamina but patience. Politics is a very long run game and the tortoise will usually beat the hare."
  },
  {
    "author": "Yingluck Shinawatra",
    "category": "patience",
    "id": 52577,
    "text": "I will exercise patience and will provide all facts to the general public."
  },
  {
    "author": "Ovid",
    "category": "patience",
    "id": 52399,
    "text": "Bear patiently with a rival."
  },
  {
    "author": "Christina Milian",
    "category": "patience",
    "id": 52528,
    "text": "My advice to someone to follow in my footsteps is to have patience. I've been doing this for twelve years."
  },
  {
    "author": "T. Boone Pickens",
    "category": "patience",
    "id": 52498,
    "text": "I think I have more patience now than I did in the past."
  },
  {
    "author": "Harriet Tubman",
    "category": "patience",
    "id": 52415,
    "text": "Every great dream begins with a dreamer. Always remember, you have within you the strength, the patience, and the passion to reach for the stars to change the world."
  },
  {
    "author": "Gustavo Dudamel",
    "category": "patience",
    "id": 52541,
    "text": "My relationship with the Philharmonia Orchestra brought me many times to London and I will always reflect positively on that early period of development with them - their patience, their warmth, their dedication."
  },
  {
    "author": "Star Jones",
    "category": "patience",
    "id": 52512,
    "text": "No, you're not allowed to be bossy when you're married. You have to learn compromise, and compassion and patience."
  },
  {
    "author": "Charles Sturt",
    "category": "patience",
    "id": 52529,
    "text": "Now it is evident that a little insight into the customs of every people is necessary to insure a kindly communication this, joined with patience and kindness, will seldom fail with the natives of the interior."
  },
  {
    "author": "Saadi",
    "category": "patience",
    "id": 52371,
    "text": "Have patience. All things are difficult before they become easy."
  },
  {
    "author": "Adam Scott",
    "category": "patience",
    "id": 52567,
    "text": "You know, writing is really difficult, and it takes a real patience and a skill. I don't know if I have that. I admire it in others, so much, and I envy it."
  },
  {
    "author": "Elliot Paul",
    "category": "patience",
    "id": 52553,
    "text": "Patience makes a women beautiful in middle age."
  },
  {
    "author": "Jenny Agutter",
    "category": "patience",
    "id": 52540,
    "text": "I have a huge respect for writers and realise that this is not an area that I find easy. I doubt that I would have the patience in front of a blank sheet of paper to become a writer."
  },
  {
    "author": "E. Joseph Cossman",
    "category": "patience",
    "id": 52469,
    "text": "The greatest power is often simple patience."
  },
  {
    "author": "Charles Stanley",
    "category": "patience",
    "id": 52450,
    "text": "The Scriptures contain many stories of people who waited years or even decades before the Lord's promises came to pass. What modern believers can learn from the patience of biblical saints like Abraham, Joseph, David, and Paul is that waiting upon the Lord has eternal rewards."
  },
  {
    "author": "Laurence J. Peter",
    "category": "patience",
    "id": 52398,
    "text": "Fortune knocks but once, but misfortune has much more patience."
  },
  {
    "author": "Ingrid Newkirk",
    "category": "patience",
    "id": 52518,
    "text": "Give your dog or cat respect, patience, understanding and love. And if you just change to one vegetarian day a week, that's a wonderful step that will save animal lives. It means you have chosen something kind instead of something cruel."
  },
  {
    "author": "Phillips Brooks",
    "category": "patience",
    "id": 52365,
    "text": "Be patient and understanding. Life is too short to be vengeful or malicious."
  },
  {
    "author": "William Shakespeare",
    "category": "patience",
    "id": 52423,
    "text": "No, I will be the pattern of all patience I will say nothing."
  },
  {
    "author": "Cee Lo Green",
    "category": "patience",
    "id": 52548,
    "text": "Tolerance, compromise, understanding, acceptance, patience - I want those all to be very sharp tools in my shed."
  },
  {
    "author": "Tertullian",
    "category": "patience",
    "id": 52404,
    "text": "Hope is patience with the lamp lit."
  },
  {
    "author": "Evelyn Underhill",
    "category": "patience",
    "id": 52495,
    "text": "Deliberately seek opportunities for kindness, sympathy, and patience."
  },
  {
    "author": "Lauren Bacall",
    "category": "patience",
    "id": 52500,
    "text": "Patience was not my strong point."
  },
  {
    "author": "Benjamin Franklin",
    "category": "patience",
    "id": 52422,
    "text": "He that can have patience can have what he will."
  },
  {
    "author": "Bret Harte",
    "category": "patience",
    "id": 52412,
    "text": "Never a tear bedims the eye that time and patience will not dry."
  },
  {
    "author": "Vanessa Paradis",
    "category": "patience",
    "id": 52488,
    "text": "My mum told me to have patience. It's about realising that when things aren't going the way you want them to, or you don't have inspiration, it will come."
  },
  {
    "author": "Milla Jovovich",
    "category": "patience",
    "id": 52539,
    "text": "I'm not really easy to live with! There needs to be unlimited patience and unconditional love. Men I've known before loved my independent spirit and were proud of my success, to the point that they'd become jealous of the time I devote to my career."
  },
  {
    "author": "Gertrude Jekyll",
    "category": "patience",
    "id": 52443,
    "text": "A garden is a grand teacher. It teaches patience and careful watchfulness it teaches industry and thrift above all it teaches entire trust."
  },
  {
    "author": "Paul Gleason",
    "category": "patience",
    "id": 52503,
    "text": "My biggest weakness is patience, wanting to see things happen too quickly or get changes in place right away. Not having the patience to let things develop."
  },
  {
    "author": "Michael Chiklis",
    "category": "patience",
    "id": 52558,
    "text": "Patience has never been my strong suit."
  },
  {
    "author": "Jean-Jacques Rousseau",
    "category": "patience",
    "id": 52361,
    "text": "Patience is bitter, but its fruit is sweet."
  },
  {
    "author": "Tokugawa Ieyasu",
    "category": "patience",
    "id": 52522,
    "text": "The strong manly ones in life are those who understand the meaning of the word patience."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "patience",
    "id": 52418,
    "text": "If patience is worth anything, it must endure to the end of time. And a living faith will last in the midst of the blackest storm."
  },
  {
    "author": "Pauline Kael",
    "category": "patience",
    "id": 52547,
    "text": "It seems likely that many of the young who don't wait for others to call them artists, but simply announce that they are, don't have the patience to make art."
  },
  {
    "author": "Andrew Greeley",
    "category": "patience",
    "id": 52532,
    "text": "Is the patience of the American people that long suffering? Is there no outrage left in the country?"
  },
  {
    "author": "Peter Marshall",
    "category": "patience",
    "id": 52462,
    "text": "Teach us, O Lord, the disciplines of patience, for to wait is often harder than to work."
  },
  {
    "author": "Corazon Aquino",
    "category": "patience",
    "id": 52434,
    "text": "Faith is not simply a patience that passively suffers until the storm is past. Rather, it is a spirit that bears things - with resignations, yes, but above all, with blazing, serene hope."
  },
  {
    "author": "Katherine Heigl",
    "category": "patience",
    "id": 52478,
    "text": "I'm terrible with patience."
  },
  {
    "author": "Ambrose Bierce",
    "category": "patience",
    "id": 52435,
    "text": "Meekness: Uncommon patience in planning a revenge that is worth while."
  },
  {
    "author": "Cesar Chavez",
    "category": "patience",
    "id": 52476,
    "text": "There is no substitute for hard work, 23 or 24 hours a day. And there is no substitute for patience and acceptance."
  },
  {
    "author": "Hyman Rickover",
    "category": "patience",
    "id": 52409,
    "text": "Good ideas are not adopted automatically. They must be driven into practice with courageous patience."
  },
  {
    "author": "Thomas Perry",
    "category": "patience",
    "id": 52543,
    "text": "Reading a novel in which all characters illustrate patience, hard work, chastity, and delayed gratification could be a pretty dull experience."
  },
  {
    "author": "Charlie Chaplin",
    "category": "patience",
    "id": 52430,
    "text": "I do not have much patience with a thing of beauty that must be explained to be understood. If it does need additional interpretation by someone other than the creator, then I question whether it has fulfilled its purpose."
  },
  {
    "author": "Wesley Morris",
    "category": "patience",
    "id": 52519,
    "text": "In movies, there are some things the French do that Americans are increasingly incapable of doing. One is honoring the complexities of youth. It's a quiet, difficult undertaking, requiring subtlety in a filmmaker and perception and patience from us."
  },
  {
    "author": "Jim Bishop",
    "category": "patience",
    "id": 52505,
    "text": "When you read about a car crash in which two or three youngsters are killed, do you pause to dwell on the amount of love and treasure and patience parents poured into bodies no longer suitable for open caskets?"
  },
  {
    "author": "David Hobson",
    "category": "patience",
    "id": 52449,
    "text": "I grow plants for many reasons: to please my eye or to please my soul, to challenge the elements or to challenge my patience, for novelty or for nostalgia, but mostly for the joy in seeing them grow."
  }
]

quotes['patriotism'] = [
  {
    "author": "John F. Kennedy",
    "category": "patriotism",
    "id": 52588,
    "text": "Let every nation know, whether it wishes us well or ill, that we shall pay any price, bear any burden, meet any hardship, support any friend, oppose any foe to assure the survival and the success of liberty."
  },
  {
    "author": "Guy de Maupassant",
    "category": "patriotism",
    "id": 52615,
    "text": "Patriotism is a kind of religion it is the egg from which wars are hatched."
  },
  {
    "author": "Schuyler Colfax",
    "category": "patriotism",
    "id": 52738,
    "text": "These martyrs of patriotism gave their lives for an idea."
  },
  {
    "author": "Arthur C. Clarke",
    "category": "patriotism",
    "id": 52630,
    "text": "It is not easy to see how the more extreme forms of nationalism can long survive when men have seen the Earth in its true perspective as a single small globe against the stars."
  },
  {
    "author": "John Bolton",
    "category": "patriotism",
    "id": 52675,
    "text": "There is no patriotic obligation to help advance the career of a politician who is otherwise pursuing interests that are fundamentally antithetical to your values. That's not the call of patriotism."
  },
  {
    "author": "Bob Riley",
    "category": "patriotism",
    "id": 52684,
    "text": "I have long believed that sacrifice is the pinnacle of patriotism."
  },
  {
    "author": "Rosa DeLauro",
    "category": "patriotism",
    "id": 52730,
    "text": "1 month ago the American people stopped to remember the third anniversary of the beginning of the Iraq war. We thought first and foremost of the selflessness, patriotism and heroism by our troops, our National Guard and Reserves."
  },
  {
    "author": "Bill Kristol",
    "category": "patriotism",
    "id": 52716,
    "text": "Patriotism is an indispensable weapon in the defense of civilization against barbarism."
  },
  {
    "author": "Ted Cruz",
    "category": "patriotism",
    "id": 52660,
    "text": "Look, I think Hispanic community - the values that resonate in our community are fundamentally conservative. They are faith, family and patriotism."
  },
  {
    "author": "George William Curtis",
    "category": "patriotism",
    "id": 52653,
    "text": "A man's country is not a certain area of land, of mountains, rivers, and woods, but it is a principle and patriotism is loyalty to that principle."
  },
  {
    "author": "William Shenstone",
    "category": "patriotism",
    "id": 52635,
    "text": "The proper means of increasing the love we bear our native country is to reside some time in a foreign one."
  },
  {
    "author": "Richard Ford",
    "category": "patriotism",
    "id": 52705,
    "text": "America beats on you so hard the whole time. You are constantly being pummeled by other people's rights and their sense of patriotism."
  },
  {
    "author": "Jennifer Granholm",
    "category": "patriotism",
    "id": 52681,
    "text": "If you are tired of partisanship over patriotism, you need to vote for a change in direction."
  },
  {
    "author": "Bill Maher",
    "category": "patriotism",
    "id": 52622,
    "text": "I do think the patriotic thing to do is to critique my country. How else do you make a country better but by pointing out its flaws?"
  },
  {
    "author": "Steve Allen",
    "category": "patriotism",
    "id": 52700,
    "text": "Totalitarianism is patriotism institutionalized."
  },
  {
    "author": "Scott Ritter",
    "category": "patriotism",
    "id": 52662,
    "text": "One, if you attack my integrity, I will defend myself. If you attack my patriotism, I will defend myself. If you come after my family, I will counter-attack viciously, I will destroy you."
  },
  {
    "author": "Charles de Gaulle",
    "category": "patriotism",
    "id": 52608,
    "text": "Patriotism is when love of your own people comes first nationalism, when hate for people other than your own comes first."
  },
  {
    "author": "Todd Gitlin",
    "category": "patriotism",
    "id": 52687,
    "text": "The mobilisation which Bush has been able to perform since 11 September 2001 has to be fought - at least by Americans - in the name of a wise, honourable and democratic patriotism."
  },
  {
    "author": "Barack Obama",
    "category": "patriotism",
    "id": 52595,
    "text": "We, the People, recognize that we have responsibilities as well as rights that our destinies are bound together that a freedom which only asks what's in it for me, a freedom without a commitment to others, a freedom without love or charity or duty or patriotism, is unworthy of our founding ideals, and those who died in their defense."
  },
  {
    "author": "Samuel Johnson",
    "category": "patriotism",
    "id": 52605,
    "text": "Patriotism is the last refuge of the scoundrel."
  },
  {
    "author": "Bob Dylan",
    "category": "patriotism",
    "id": 52650,
    "text": "I define nothing. Not beauty, not patriotism. I take each thing as it is, without prior rules about what it should be."
  },
  {
    "author": "O. Henry",
    "category": "patriotism",
    "id": 52658,
    "text": "Love and business and family and religion and art and patriotism are nothing but shadows of words when a man's starving!"
  },
  {
    "author": "Evan Bayh",
    "category": "patriotism",
    "id": 52698,
    "text": "Across the country military families are facing dire financial circumstances due to longer than expected tours of duties. They are being penalized for their patriotism - no one should have to choose between doing right by their country and doing right by their families."
  },
  {
    "author": "Mick Jagger",
    "category": "patriotism",
    "id": 52625,
    "text": "Patriotism is an instant reaction that fades away when the war starts."
  },
  {
    "author": "Pablo Casals",
    "category": "patriotism",
    "id": 52638,
    "text": "The love of one's country is a splendid thing. But why should love stop at the border?"
  },
  {
    "author": "Todd Gitlin",
    "category": "patriotism",
    "id": 52688,
    "text": "There is a fuzzy but real distinction that can and I believe should be made, between patriotism, which is attachment to a way of life, and nationalism, which is the insistence that your way of life deserves to rule over other ways of life."
  },
  {
    "author": "Jesse Ventura",
    "category": "patriotism",
    "id": 52633,
    "text": "Patriotism is voluntary. It is a feeling of loyalty and allegiance that is the result of knowledge and belief. A patriot shows their their patriotism through their actions, by their choice."
  },
  {
    "author": "Alfred Adler",
    "category": "patriotism",
    "id": 52623,
    "text": "It is the patriotic duty of every man to lie for his country."
  },
  {
    "author": "Ricardo Montalban",
    "category": "patriotism",
    "id": 52659,
    "text": "Politics is too partisan, and sometimes patriotism is cast aside. Patriotism is honor and love of your country and your brothers and sisters. With politics I get the impression that it's all about what's good for the party and not necessarily what's good for the country."
  },
  {
    "author": "Clarence Darrow",
    "category": "patriotism",
    "id": 52596,
    "text": "True patriotism hates injustice in its own land more than anywhere else."
  },
  {
    "author": "Vic Snyder",
    "category": "patriotism",
    "id": 52734,
    "text": "Unfortunately, our history has abundant examples of patriotism being used to hurt those who express views in disagreement with that of the majority."
  },
  {
    "author": "Henry Bolingbroke",
    "category": "patriotism",
    "id": 52644,
    "text": "Patriotism must be founded on great principals and supported by great virtue."
  },
  {
    "author": "Clara Barton",
    "category": "patriotism",
    "id": 52626,
    "text": "The patriot blood of my father was warm in my veins."
  },
  {
    "author": "Francis John McConnell",
    "category": "patriotism",
    "id": 52739,
    "text": "We need a type of patriotism that recognizes the virtues of those who are opposed to us."
  },
  {
    "author": "Janet Suzman",
    "category": "patriotism",
    "id": 52718,
    "text": "Jews have had to carry around their own sense of self in a carpet bag and I think perhaps too much emphasis might be being put on nationality and on the other hand patriotism, that sort of thing."
  },
  {
    "author": "Michael D. Higgins",
    "category": "patriotism",
    "id": 52710,
    "text": "I am delighted with the strong vote I have received. My message of positive leadership, patriotism and commitment clearly was resonating with tens of thousands of ordinary Irish people."
  },
  {
    "author": "Jack Bowman",
    "category": "patriotism",
    "id": 52712,
    "text": "But my patriotism goes for something beyond what we have. We don't have something that I want to die for - anymore."
  },
  {
    "author": "Kjell Magne Bondevik",
    "category": "patriotism",
    "id": 52721,
    "text": "Unfortunately, religion, like patriotism, is easy to misuse for political purposes."
  },
  {
    "author": "Voltaire",
    "category": "patriotism",
    "id": 52594,
    "text": "It is lamentable, that to be a good patriot one must become the enemy of the rest of mankind."
  },
  {
    "author": "Ann Coulter",
    "category": "patriotism",
    "id": 52619,
    "text": "Liberals become indignant when you question their patriotism, but simultaneously work overtime to give terrorists a cushion for the next attack and laugh at dumb Americans who love their country and hate the enemy."
  },
  {
    "author": "William Ralph Inge",
    "category": "patriotism",
    "id": 52612,
    "text": "A nation is a society united by a delusion about its ancestry and by common hatred of its neighbours."
  },
  {
    "author": "Parker Stevenson",
    "category": "patriotism",
    "id": 52704,
    "text": "I think the reaction to a World War II situation would be the same today as it was in 1942. Initially, people would question, but once patriotism got stirred up, the whole thing would gather momentum and we'd all pull together."
  },
  {
    "author": "Ted Cruz",
    "category": "patriotism",
    "id": 52699,
    "text": "I think Hispanic community - the values that resonate in our community are fundamentally conservative. They are faith, family and patriotism. Do you know the rate of military enlistment among Hispanics is higher than any demographic in this country? And they are also hard work and responsibility."
  },
  {
    "author": "George Bernard Shaw",
    "category": "patriotism",
    "id": 52593,
    "text": "Patriotism is your conviction that this country is superior to all others because you were born in it."
  },
  {
    "author": "John Woo",
    "category": "patriotism",
    "id": 52727,
    "text": "My films are always concerned with family, friendship, honor, and patriotism."
  },
  {
    "author": "Ronald Reagan",
    "category": "patriotism",
    "id": 52586,
    "text": "If we ever forget that we are One Nation Under God, then we will be a nation gone under."
  },
  {
    "author": "Barbara Ehrenreich",
    "category": "patriotism",
    "id": 52607,
    "text": "No matter that patriotism is too often the refuge of scoundrels. Dissent, rebellion, and all-around hell-raising remain the true duty of patriots."
  },
  {
    "author": "Mark Twain",
    "category": "patriotism",
    "id": 52589,
    "text": "Patriot: the person who can holler the loudest without knowing what he is hollering about."
  },
  {
    "author": "Henry Louis Gates",
    "category": "patriotism",
    "id": 52666,
    "text": "Patriotism is best exemplified through auto-critique."
  },
  {
    "author": "Denis Diderot",
    "category": "patriotism",
    "id": 52664,
    "text": "Patriotism is an ephemeral motive that scarcely ever outlasts the particular threat to society that aroused it."
  },
  {
    "author": "Malcolm Turnbull",
    "category": "patriotism",
    "id": 52686,
    "text": "My commitment to the Republican movement was pure and simply patriotism, a love of Australia... a desire or passion that all of our national symbols should be unequivocally and unambiguously Australian."
  },
  {
    "author": "Greil Marcus",
    "category": "patriotism",
    "id": 52720,
    "text": "Patriotism in America, as I understand it, is a matter of suffering, when the country fails to live up to its promises, or actively betrays them."
  },
  {
    "author": "Mike Ferguson",
    "category": "patriotism",
    "id": 52711,
    "text": "Although the war in which you fought took place more than half-a-century ago, your courage, your sacrifice and your patriotism reaches through the decades and inspires us today."
  },
  {
    "author": "George Santayana",
    "category": "patriotism",
    "id": 52617,
    "text": "To me, it seems a dreadful indignity to have a soul controlled by geography."
  },
  {
    "author": "Robert Charles Winthrop",
    "category": "patriotism",
    "id": 52736,
    "text": "There are no points of the compass on the chart of true patriotism."
  },
  {
    "author": "Friedrich Durrenmatt",
    "category": "patriotism",
    "id": 52637,
    "text": "We do not consider patriotism desirable if it contradicts civilized behavior."
  },
  {
    "author": "Bernadine Dohrn",
    "category": "patriotism",
    "id": 52677,
    "text": "The aspects of patriotism that hush dissent, encourage going along, and sanction comfortable distancing and compliance with what is indecent and unacceptable... those aspects are too fundamental to ignore or gloss over."
  },
  {
    "author": "Edith Cavell",
    "category": "patriotism",
    "id": 52620,
    "text": "I realize that patriotism is not enough. I must have no hatred or bitterness towards anyone."
  },
  {
    "author": "Calvin Coolidge",
    "category": "patriotism",
    "id": 52601,
    "text": "Patriotism is easy to understand in America. It means looking out for yourself by looking out for your country."
  },
  {
    "author": "Michael Mandelbaum",
    "category": "patriotism",
    "id": 52701,
    "text": "The values, the programs, the formula, the determination, and the patriotism responsible for America's past success are still here to be tapped."
  },
  {
    "author": "George McGovern",
    "category": "patriotism",
    "id": 52600,
    "text": "The highest patriotism is not a blind acceptance of official policy, but a love of one's country deep enough to call her to a higher plain."
  },
  {
    "author": "John Amery",
    "category": "patriotism",
    "id": 52728,
    "text": "It is not the Government, the members of Parliament to whom the ultimate decision belongs, it is up to you to go forward sure of your sacred right of free opinion, sure of your patriotism."
  },
  {
    "author": "Jimmy Carter",
    "category": "patriotism",
    "id": 52661,
    "text": "Unfortunately, after Sept. 11, there was an outburst in America of intense suffering and patriotism, and the Bush administration was very shrewd and effective in painting anyone who disagreed with the policies as unpatriotic or even traitorous."
  },
  {
    "author": "Robert Jackson",
    "category": "patriotism",
    "id": 52722,
    "text": "To believe that patriotism will not flourish if patriotic ceremonies are voluntary... is to make an unflattering estimate of the appeal of our institutions to free minds."
  },
  {
    "author": "Oscar Wilde",
    "category": "patriotism",
    "id": 52591,
    "text": "Patriotism is the virtue of the vicious."
  },
  {
    "author": "Eric Hobsbawm",
    "category": "patriotism",
    "id": 52703,
    "text": "It seems that American patriotism measures itself against an outcast group. The right Americans are the right Americans because they're not like the wrong Americans, who are not really Americans."
  },
  {
    "author": "Rebecca Harding Davis",
    "category": "patriotism",
    "id": 52707,
    "text": "Our young people have come to look upon war as a kind of beneficent deity, which not only adds to the national honor but uplifts a nation and develops patriotism and courage."
  },
  {
    "author": "Michael Ignatieff",
    "category": "patriotism",
    "id": 52696,
    "text": "Patriotism is strong nationalistic feeling for a country whose borders and whose legitimacy and whose ethnic composition is taken for granted."
  },
  {
    "author": "Robert Reich",
    "category": "patriotism",
    "id": 52714,
    "text": "True patriotism isn't cheap. It's about taking on a fair share of the burden of keeping America going."
  },
  {
    "author": "George J. Mitchell",
    "category": "patriotism",
    "id": 52695,
    "text": "In every society in human history, including the United States, those in power seek to imbue themselves with the attributes of religion and patriotism as a way of getting greater support for their policy and insulating themselves from any criticism."
  },
  {
    "author": "Albert Einstein",
    "category": "patriotism",
    "id": 52647,
    "text": "Heroism on command, senseless violence, and all the loathsome nonsense that goes by the name of patriotism - how passionately I hate them!"
  },
  {
    "author": "Robert Walpole",
    "category": "patriotism",
    "id": 52692,
    "text": "Gentlemen have talked a great deal of patriotism. A venerable word, when duly practiced."
  },
  {
    "author": "Will Thomas",
    "category": "patriotism",
    "id": 52737,
    "text": "Obama has been attacked repeatedly for not wearing a flag pin, with Republicans claiming that his patriotism is in question. It's all a bit silly."
  },
  {
    "author": "Michael Ignatieff",
    "category": "patriotism",
    "id": 52639,
    "text": "I distinguish, between nationalism and patriotism."
  },
  {
    "author": "Richard Dreyfuss",
    "category": "patriotism",
    "id": 52708,
    "text": "Let's give some substance to patriotism. It may take a generation."
  },
  {
    "author": "Chaim Potok",
    "category": "patriotism",
    "id": 52680,
    "text": "Every man who has shown the world the way to beauty, to true culture, has been a rebel, a 'universal' without patriotism, without home, who has found his people everywhere."
  },
  {
    "author": "Tom Hooper",
    "category": "patriotism",
    "id": 52690,
    "text": "In 'The King's Speech,' patriotism is utterly contained within a historical moment, the third of September, 1939, where the aggressor is clear, the fight is clear, it hasn't become complicated over time."
  },
  {
    "author": "Joseph Brodsky",
    "category": "patriotism",
    "id": 52683,
    "text": "For a writer only one form of patriotism exists: his attitude toward language."
  },
  {
    "author": "Howard Zinn",
    "category": "patriotism",
    "id": 52606,
    "text": "Dissent is the highest form of patriotism."
  },
  {
    "author": "Malcolm X",
    "category": "patriotism",
    "id": 52592,
    "text": "You're not supposed to be so blind with patriotism that you can't face reality. Wrong is wrong, no matter who says it."
  },
  {
    "author": "Wallace Shawn",
    "category": "patriotism",
    "id": 52685,
    "text": "Patriotism is considered to be an emotion a person ought to feel. But why? Why is it nobler to love your own country than to love someone else's?"
  },
  {
    "author": "Bill Vaughan",
    "category": "patriotism",
    "id": 52609,
    "text": "A real patriot is the fellow who gets a parking ticket and rejoices that the system works."
  },
  {
    "author": "James Branch Cabell",
    "category": "patriotism",
    "id": 52726,
    "text": "Patriotism is the religion of hell."
  },
  {
    "author": "Frank Knox",
    "category": "patriotism",
    "id": 52732,
    "text": "Patriotism was a living fire of unquestioned belief and purpose."
  },
  {
    "author": "Ronnie James Dio",
    "category": "patriotism",
    "id": 52693,
    "text": "The music industry's actions at the time of 9/11 and since have been actions driven by patriotism in most instances, and greed and stupidity to a lesser degree. Sounds like real life doesn't it?"
  },
  {
    "author": "Bill Kristol",
    "category": "patriotism",
    "id": 52715,
    "text": "If terror groups are to be defeated, it is national governments that will have to do so. In nations like India, governments will have to call on the patriotism of citizens to fight the terrorists. In a nation like Pakistan, the government will have to be persuaded to deal with those in their midst who are complicit."
  },
  {
    "author": "George Orwell",
    "category": "patriotism",
    "id": 52604,
    "text": "Patriotism is usually stronger than class hatred, and always stronger than internationalism."
  },
  {
    "author": "Sinclair Lewis",
    "category": "patriotism",
    "id": 52631,
    "text": "Intellectually I know that America is no better than any other country emotionally I know she is better than every other country."
  },
  {
    "author": "Dale Carnegie",
    "category": "patriotism",
    "id": 52598,
    "text": "Each nation feels superior to other nations. That breeds patriotism - and wars."
  },
  {
    "author": "George Galloway",
    "category": "patriotism",
    "id": 52670,
    "text": "There are those who wrap themselves in flags and blow the tinny trumpet of patriotism as a means of fooling the people."
  },
  {
    "author": "Tommy Lee Jones",
    "category": "patriotism",
    "id": 52679,
    "text": "If military movies were automatically successful we'd make nothing but military movies. But seriously, patriotism is one thing that all Americans have in common."
  },
  {
    "author": "John Sergeant Wise",
    "category": "patriotism",
    "id": 52709,
    "text": "In all her history, from the formation of the federal government until the hour of secession, no year stands out more prominently than the year 1858 as evidencing the national patriotism of Virginia."
  },
  {
    "author": "Bertrand Russell",
    "category": "patriotism",
    "id": 52603,
    "text": "Patriotism is the willingness to kill and be killed for trivial reasons."
  },
  {
    "author": "Bruce Springsteen",
    "category": "patriotism",
    "id": 52672,
    "text": "There is a real patriotism underneath the best of my music but it is a critical, questioning and often angry patriotism."
  },
  {
    "author": "George Washington",
    "category": "patriotism",
    "id": 52648,
    "text": "Guard against the impostures of pretended patriotism."
  },
  {
    "author": "Lech Walesa",
    "category": "patriotism",
    "id": 52671,
    "text": "I want to light the lights of patriotism."
  },
  {
    "author": "Nick Lampson",
    "category": "patriotism",
    "id": 52656,
    "text": "But this Veterans Day, I believe we should do more than sing the praises of the bravery and patriotism that our veterans have embodied in the past. We should take this opportunity to re-evaluate how we are treating our veterans in the present."
  },
  {
    "author": "George Borrow",
    "category": "patriotism",
    "id": 52645,
    "text": "Next to the love of God, the love of country is the best preventive of crime."
  },
  {
    "author": "William Blum",
    "category": "patriotism",
    "id": 52733,
    "text": "America's state religion, is patriotism, a phenomenon which has convinced many of the citizenry that 'treason' is morally worse than murder or rape."
  },
  {
    "author": "Dominique de Villepin",
    "category": "patriotism",
    "id": 52729,
    "text": "I think that economic patriotism is the very foundation of a European vision."
  }
]

quotes['peace'] = [
  {
    "author": "Omar N. Bradley",
    "category": "peace",
    "id": 52950,
    "text": "Ours is a world of nuclear giants and ethical infants. We know more about war that we know about peace, more about killing that we know about living."
  },
  {
    "author": "Robert Johnson",
    "category": "peace",
    "id": 53024,
    "text": "A man will treat a woman almost exactly the way he treats his own interior feminine. In fact, he hasn't the ability to see a woman, objectively speaking, until he has made some kind of peace with his interior woman."
  },
  {
    "author": "Harry S. Truman",
    "category": "peace",
    "id": 52924,
    "text": "It is understanding that gives us an ability to have peace. When we understand the other fellow's viewpoint, and he understands ours, then we can sit down and work out our differences."
  },
  {
    "author": "Mos Def",
    "category": "peace",
    "id": 53283,
    "text": "Bob Marley performed the 'One Love Peace' concert in Jamaica with the two different warring political sides. There's always been that in black music and culture in general. It's no surprise because black music is such a reflection of what's going on in black life. It's not unusual for hip-hop."
  },
  {
    "author": "George W. Bush",
    "category": "peace",
    "id": 52981,
    "text": "I just want you to know that, when we talk about war, we're really talking about peace."
  },
  {
    "author": "Georg C. Lichtenberg",
    "category": "peace",
    "id": 53113,
    "text": "Nothing is more conducive to peace of mind than not having any opinion at all."
  },
  {
    "author": "Javier Bardem",
    "category": "peace",
    "id": 53207,
    "text": "When you know people are really at peace with who they are and what they do, they collaborate and want to help you to improve."
  },
  {
    "author": "Benjamin Netanyahu",
    "category": "peace",
    "id": 53260,
    "text": "The Israeli government has proved over the past year its commitment to peace, both in words and deeds. By contrast, the Palestinians are posing preconditions for renewing the diplomatic process in a way they have not done over the course of 16 years."
  },
  {
    "author": "Michael Franti",
    "category": "peace",
    "id": 52806,
    "text": "Power to the peaceful!"
  },
  {
    "author": "Chief Joseph",
    "category": "peace",
    "id": 53052,
    "text": "If the white man wants to live in peace with the Indian he can live in peace."
  },
  {
    "author": "Lester B. Pearson",
    "category": "peace",
    "id": 53454,
    "text": "It would be especially tragic if the people who most cherish ideals of peace, who are most anxious for political cooperation on a wider than national scale, made the mistake of underestimating the pace of economic change in our modern world."
  },
  {
    "author": "Joseph Roux",
    "category": "peace",
    "id": 52875,
    "text": "We call that person who has lost his father, an orphan and a widower that man who has lost his wife. But that man who has known the immense unhappiness of losing a friend, by what name do we call him? Here every language is silent and holds its peace in impotence."
  },
  {
    "author": "Greg Walden",
    "category": "peace",
    "id": 53556,
    "text": "A man of strength and wisdom, John Paul became an inspiration to generations of both Catholics and non-Catholics throughout the world by encouraging freedom, promoting peace and respecting all faiths."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "peace",
    "id": 52945,
    "text": "Though force can protect in emergency, only justice, fairness, consideration and cooperation can finally lead men to the dawn of eternal peace."
  },
  {
    "author": "George Harrison",
    "category": "peace",
    "id": 52967,
    "text": "When you've seen beyond yourself, then you may find, peace of mind is waiting there."
  },
  {
    "author": "Brad Pitt",
    "category": "peace",
    "id": 53349,
    "text": "Deregulation created this epidemic of greed which according to the rules of capitalism was OK. Beyond that there was criminal behaviour. There have been no repercussions and it's hard to make your peace with."
  },
  {
    "author": "Hamid Karzai",
    "category": "peace",
    "id": 53704,
    "text": "People in Afghanistan want peace, including the Taliban. They're also people like we all are. They have families, they have relatives, they have children, they are suffering a tough time."
  },
  {
    "author": "Anna Akhmatova",
    "category": "peace",
    "id": 53179,
    "text": "It was a time when only the dead smiled, happy in their peace."
  },
  {
    "author": "Karl Von Clausewitz",
    "category": "peace",
    "id": 53006,
    "text": "To secure peace is to prepare for war."
  },
  {
    "author": "Francois Hollande",
    "category": "peace",
    "id": 53339,
    "text": "I attach the greatest importance to an amplification of the peace efforts in the Middle East. I would also like to see a greater dialogue between the U.S. and the EU."
  },
  {
    "author": "Yahya Jammeh",
    "category": "peace",
    "id": 53271,
    "text": "Any one who wants to live in peace and freedom will be to live by toil, demonstration of high levels of discipline and tolerance for one another."
  },
  {
    "author": "Joseph Rotblat",
    "category": "peace",
    "id": 53638,
    "text": "My third appeal is to my fellow citizens in all countries: Help us to establish lasting peace in the world."
  },
  {
    "author": "Sai Baba",
    "category": "peace",
    "id": 52884,
    "text": "Let love flow so that it cleanses the world. Then man can live in peace, instead of the state of turmoil he has created through his past ways of life, with all those material interests and earthly ambitions."
  },
  {
    "author": "Gifford Pinchot",
    "category": "peace",
    "id": 53699,
    "text": "World-wide practice of Conservation and the fair and continued access by all nations to the resources they need are the two indispensable foundations of continuous plenty and of permanent peace."
  },
  {
    "author": "Alex Noble",
    "category": "peace",
    "id": 53075,
    "text": "If I have been of service, if I have glimpsed more of the nature and essence of ultimate good, if I am inspired to reach wider horizons of thought and action, if I am at peace with myself, it has been a successful day."
  },
  {
    "author": "Paul Harris",
    "category": "peace",
    "id": 53606,
    "text": "Ignorance is a menace to peace."
  },
  {
    "author": "Eric Burdon",
    "category": "peace",
    "id": 53735,
    "text": "On Memorial Day, I don't want to only remember the combatants. There were also those who came out of the trenches as writers and poets, who started preaching peace, men and women who have made this world a kinder place to live."
  },
  {
    "author": "King Abdullah II",
    "category": "peace",
    "id": 53319,
    "text": "Peace with Israel is a strategic imperative for Jordan."
  },
  {
    "author": "Nikita Khrushchev",
    "category": "peace",
    "id": 53346,
    "text": "The more bombers, the less room for doves of peace."
  },
  {
    "author": "Tony Blair",
    "category": "peace",
    "id": 53208,
    "text": "But in terms of how people live together, how we minimize the prospects of conflict and maximize the prospects of peace, the place of religion in our society today is essential."
  },
  {
    "author": "Aung San Suu Kyi",
    "category": "peace",
    "id": 53017,
    "text": "My attitude to peace is rather based on the Burmese definition of peace - it really means removing all the negative factors that destroy peace in this world. So peace does not mean just putting an end to violence or to war, but to all other factors that threaten peace, such as discrimination, such as inequality, poverty."
  },
  {
    "author": "Alan Dershowitz",
    "category": "peace",
    "id": 53341,
    "text": "Israel can't make peace without the clear support of the United States."
  },
  {
    "author": "King Abdullah II",
    "category": "peace",
    "id": 53318,
    "text": "We have peace with Israel. We're actually the last man standing. So there is going to be immense pressure and people asking, 'Why are we having this relationship when it's not benefiting anybody?' Obviously, my answer is you always benefit from peace."
  },
  {
    "author": "Mitt Romney",
    "category": "peace",
    "id": 52916,
    "text": "If I am elected President of these United States, I will work with all my energy and soul to restore that America, to lift our eyes to a better future. That future is our destiny. That future is out there. It is waiting for us. Our children deserve it, our nation depends upon it, the peace and freedom of the world require it."
  },
  {
    "author": "John F. Kennedy",
    "category": "peace",
    "id": 52849,
    "text": "Peace is a daily, a weekly, a monthly process, gradually changing opinions, slowly eroding old barriers, quietly building new structures."
  },
  {
    "author": "John Wooden",
    "category": "peace",
    "id": 52851,
    "text": "Success is peace of mind which is a direct result of self-satisfaction in knowing you did your best to become the best you are capable of becoming."
  },
  {
    "author": "Marianne Williamson",
    "category": "peace",
    "id": 52844,
    "text": "Forgiveness is not always easy. At times, it feels more painful than the wound we suffered, to forgive the one that inflicted it. And yet, there is no peace without forgiveness."
  },
  {
    "author": "Chris Evans",
    "category": "peace",
    "id": 53478,
    "text": "I love acting. It's my playground, it let's me explore. But my happiness in this world - my level of peace - is never going to be dictated by acting."
  },
  {
    "author": "Victor Hugo",
    "category": "peace",
    "id": 52940,
    "text": "Peace is the virtue of civilization. War is its crime."
  },
  {
    "author": "Chief Joseph",
    "category": "peace",
    "id": 53042,
    "text": "We gave up some of our country to the white men, thinking that then we could have peace. We were mistaken. The white man would not let us alone."
  },
  {
    "author": "Morihei Ueshiba",
    "category": "peace",
    "id": 53118,
    "text": "To injure an opponent is to injure yourself. To control aggression without inflicting injury is the Art of Peace."
  },
  {
    "author": "Morihei Ueshiba",
    "category": "peace",
    "id": 52775,
    "text": "One does not need buildings, money, power, or status to practice the Art of Peace. Heaven is right where you are standing, and that is the place to train."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "peace",
    "id": 52980,
    "text": "The services in wartime are fit only for desperadoes, but in peace are only fit for fools."
  },
  {
    "author": "Barry Sanders",
    "category": "peace",
    "id": 53481,
    "text": "I really love peace and quiet."
  },
  {
    "author": "George Armstrong Custer",
    "category": "peace",
    "id": 53721,
    "text": "You ask me if I will not be glad when the last battle is fought, so far as the country is concerned I, of course, must wish for peace, and will be glad when the war is ended, but if I answer for myself alone, I must say that I shall regret to see the war end."
  },
  {
    "author": "Sean Hannity",
    "category": "peace",
    "id": 53710,
    "text": "I'm at peace with myself because what I talk about is the way I live."
  },
  {
    "author": "Gerald Jampolsky",
    "category": "peace",
    "id": 52923,
    "text": "When I am able to resist the temptation to judge others, I can see them as teachers of forgiveness in my life, reminding me that I can only have peace of mind when I forgive rather than judge."
  },
  {
    "author": "George W. Bush",
    "category": "peace",
    "id": 53030,
    "text": "We've climbed the mighty mountain. I see the valley below, and it's a valley of peace."
  },
  {
    "author": "Benjamin Netanyahu",
    "category": "peace",
    "id": 53230,
    "text": "The Palestinians want a state, but they have to give peace in return. What they're trying to do in the United Nations is to get a state without giving Israel peace or giving Israel peace and security. And I think that's, that's wrong. That should not succeed. That should, that should fail."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "peace",
    "id": 52821,
    "text": "The hope of a secure and livable world lies with disciplined nonconformists who are dedicated to justice, peace and brotherhood."
  },
  {
    "author": "Ronald Reagan",
    "category": "peace",
    "id": 52756,
    "text": "A people free to choose will always choose peace."
  },
  {
    "author": "Andrew Jackson",
    "category": "peace",
    "id": 53059,
    "text": "Peace, above all things, is to be desired, but blood must sometimes be spilled to obtain it on equable and lasting terms."
  },
  {
    "author": "Shimon Peres",
    "category": "peace",
    "id": 53327,
    "text": "Israel welcomes the wind of change, and sees a window of opportunity. Democratic and science-based economies by nature desire peace. Israel does not want to be an island of affluence in an ocean of poverty. Improvements in our neighbours' lives mean improvements to the neighbourhood in which we live."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "peace",
    "id": 53308,
    "text": "Men and women who know the brutal reality of war, who know that war strips people of their very humanity, must unite in a new global partnership for peace."
  },
  {
    "author": "Yitzhak Rabin",
    "category": "peace",
    "id": 53491,
    "text": "A diplomatic peace is not yet the real peace. It is an essential step in the peace process leading towards a real peace."
  },
  {
    "author": "Donald Cargill",
    "category": "peace",
    "id": 53331,
    "text": "Now for my own case, I bless the Lord that, for all that hath been said of me, my conscience doth not condemn me. I do not say I am free of sin, but I am at peace with God through a slain Mediator and I believe that there is no salvation but only in Christ."
  },
  {
    "author": "Sharon Stone",
    "category": "peace",
    "id": 53398,
    "text": "Peace does exist. It exists in your heart and soul."
  },
  {
    "author": "William Feather",
    "category": "peace",
    "id": 53104,
    "text": "That they may have a little peace, even the best dogs are compelled to snarl occasionally."
  },
  {
    "author": "Abraham Maslow",
    "category": "peace",
    "id": 52892,
    "text": "A musician must make music, an artist must paint, a poet must write, if he is to be ultimately at peace with himself."
  },
  {
    "author": "Peace Pilgrim",
    "category": "peace",
    "id": 53184,
    "text": "No one can find inner peace except by working, not in a self- centered way, but for the whole human family."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "peace",
    "id": 52759,
    "text": "Nonviolence is the first article of my faith. It is also the last article of my creed."
  },
  {
    "author": "Novak Djokovic",
    "category": "peace",
    "id": 53350,
    "text": "Even though now I'm pretty popular in my country and tennis is the No. 1 sport, and I'm very flattered that the people recognise me and come up and give me compliments, I'm more a person who likes to have privacy and peace."
  },
  {
    "author": "Dalai Lama",
    "category": "peace",
    "id": 52824,
    "text": "We can never obtain peace in the outer world until we make peace with ourselves."
  },
  {
    "author": "Charles Stanley",
    "category": "peace",
    "id": 53018,
    "text": "When we take our eyes off the whirl of day-to-day activity and concentrate on honoring Him and following in His way, we find a consistent peace that carries us through both plenty and poverty."
  },
  {
    "author": "Lester B. Pearson",
    "category": "peace",
    "id": 53292,
    "text": "The grim fact is that we prepare for war like precocious giants, and for peace like retarded pygmies."
  },
  {
    "author": "Paul Robeson",
    "category": "peace",
    "id": 53662,
    "text": "But the deep desire for peace remained with the American people."
  },
  {
    "author": "Jenny Shipley",
    "category": "peace",
    "id": 53630,
    "text": "Peace is a fragile thing. It takes courage to secure it. It takes wisdom to maintain it."
  },
  {
    "author": "Paul Theroux",
    "category": "peace",
    "id": 53371,
    "text": "When I was in the Peace Corps I never made a phone call. I was in Central Africa I didn't make a phone call for two years. I was in Uganda for another four years and I didn't make a phone call. So for six years I didn't make a phone call, but I wrote letters, I wrote short stories, I wrote books."
  },
  {
    "author": "Victor Hugo",
    "category": "peace",
    "id": 52864,
    "text": "Have courage for the great sorrows of life and patience for the small ones and when you have laboriously accomplished your daily task, go to sleep in peace."
  },
  {
    "author": "Thomas Merton",
    "category": "peace",
    "id": 52901,
    "text": "We are not at peace with others because we are not at peace with ourselves, and we are not at peace with ourselves because we are not at peace with God."
  },
  {
    "author": "King Hussein I",
    "category": "peace",
    "id": 53509,
    "text": "It would behoove the world to become used to this fact: that without a just solution to the Palestine tragedy, there can be no stable peace in the Middle East."
  },
  {
    "author": "Desmond Tutu",
    "category": "peace",
    "id": 52948,
    "text": "If you want peace, you don't talk to your friends. You talk to your enemies."
  },
  {
    "author": "Aung San Suu Kyi",
    "category": "peace",
    "id": 53101,
    "text": "Peace as a goal is an ideal which will not be contested by any government or nation, not even the most belligerent."
  },
  {
    "author": "Norman Borlaug",
    "category": "peace",
    "id": 53015,
    "text": "Therefore I feel that the aforementioned guiding principle must be modified to read: If you desire peace, cultivate justice, but at the same time cultivate the fields to produce more bread otherwise there will be no peace."
  },
  {
    "author": "Gerrit Smith",
    "category": "peace",
    "id": 53631,
    "text": "It is not to be disguised, that a war has broken out between the North and the South. - Political and commercial men are industriously striving to restore peace: but the peace, which they would effect, is superficial, false, and temporary."
  },
  {
    "author": "Natan Sharansky",
    "category": "peace",
    "id": 53554,
    "text": "To understand why dictators have a problem with making peace - or at least a genuine peace - the link between the nature of a regime and its external behavior must be understood."
  },
  {
    "author": "John Paul Jones",
    "category": "peace",
    "id": 53016,
    "text": "An honorable Peace is and always was my first wish! I can take no delight in the effusion of human Blood but, if this War should continue, I wish to have the most active part in it."
  },
  {
    "author": "Ron Paul",
    "category": "peace",
    "id": 52879,
    "text": "I am just absolutely convinced that the best formula for giving us peace and preserving the American way of life is freedom, limited government, and minding our own business overseas."
  },
  {
    "author": "Jock Sturges",
    "category": "peace",
    "id": 53384,
    "text": "All my life I've taken photographs of people who are completely at peace being what they were in the situations I photographed them in."
  },
  {
    "author": "Benjamin Franklin",
    "category": "peace",
    "id": 52859,
    "text": "There was never a good war, or a bad peace."
  },
  {
    "author": "Jet Li",
    "category": "peace",
    "id": 53487,
    "text": "This film 'Hero' talks about the peace of Chinese people."
  },
  {
    "author": "Arthur Henderson",
    "category": "peace",
    "id": 53392,
    "text": "The Disarmament Conference has become the focal point of a great struggle between anarchy and world order... between those who think in terms of inevitable armed conflict and those who seek to build a universal and durable peace."
  },
  {
    "author": "Shirley MacLaine",
    "category": "peace",
    "id": 53175,
    "text": "If anything interferes with my inner peace, I will walk away. Arguments with family members. All that stuff. None of it matters."
  },
  {
    "author": "Seamus Heaney",
    "category": "peace",
    "id": 53576,
    "text": "Whether it be a matter of personal relations within a marriage or political initiatives within a peace process, there is no sure-fire do-it-yourself kit."
  },
  {
    "author": "Theodore Bikel",
    "category": "peace",
    "id": 53332,
    "text": "In my mind the city of Ariel is a thorn in Israel's side and a serious obstacle to peace."
  },
  {
    "author": "Silvia Cartwright",
    "category": "peace",
    "id": 52796,
    "text": "The quest for peace begins in the home, in the school and in the workplace."
  },
  {
    "author": "Kofi Annan",
    "category": "peace",
    "id": 53224,
    "text": "Many African leaders refuse to send their troops on peace keeping missions abroad because they probably need their armies to intimidate their own populations."
  },
  {
    "author": "Neville Chamberlain",
    "category": "peace",
    "id": 53357,
    "text": "I believe it is peace in our time."
  },
  {
    "author": "Yitzhak Rabin",
    "category": "peace",
    "id": 53490,
    "text": "You don't make peace with friends. You make it with very unsavory enemies."
  },
  {
    "author": "Cathy Freeman",
    "category": "peace",
    "id": 53528,
    "text": "Peace, unity and harmony!"
  },
  {
    "author": "Pablo Neruda",
    "category": "peace",
    "id": 53267,
    "text": "Peace goes into the making of a poem as flour goes into the making of bread."
  },
  {
    "author": "Yitzhak Rabin",
    "category": "peace",
    "id": 53684,
    "text": "Give peace a chance."
  },
  {
    "author": "Abraham Kuyper",
    "category": "peace",
    "id": 53595,
    "text": "When the principles that run against your deepest convictions begin to win the day, then the battle is your calling, and peace has become sin. You must at the price of dearest peace lay your convictions bare before friend and enemy with all the fire of your faith."
  },
  {
    "author": "David Cameron",
    "category": "peace",
    "id": 53187,
    "text": "Today, hundreds of millions dwell in freedom, from the Baltic to the Adriatic, from the Western Approaches to the Aegean. And while we must never take this for granted, the first purpose of the European Union - to secure peace - has been achieved and we should pay tribute to all those in the EU, alongside Nato, who made that happen."
  },
  {
    "author": "Alcee Hastings",
    "category": "peace",
    "id": 53344,
    "text": "Not just Christians and Jews, but also Muslims, Buddhists, Hindus and the followers of many other religions believe in values like peace, respect, tolerance and dignity. These are values that bring people together and enable us to build responsible and solid communities."
  },
  {
    "author": "Paloma Picasso",
    "category": "peace",
    "id": 53366,
    "text": "I've always been proud that my name stands for peace."
  },
  {
    "author": "Mariel Hemingway",
    "category": "peace",
    "id": 53435,
    "text": "Self-Realization Fellowship seemed like training. It was the training ground for finding a sense of peace in myself. Because that's my job. It's no one else's."
  },
  {
    "author": "Fredrik Bajer",
    "category": "peace",
    "id": 53529,
    "text": "Peace congresses often start by dealing with some of the less important questions in excessive detail, so at the end there is no time to discuss the most important problems."
  },
  {
    "author": "Jonathan Shapiro",
    "category": "peace",
    "id": 53596,
    "text": "It's to be a person who's able to shoot little arrows into sacred cows and knock politicians off their pedestals, to look out for hypocrisy, advocate for all sorts of things from social justice to peace."
  },
  {
    "author": "Margaret Walker",
    "category": "peace",
    "id": 53064,
    "text": "Let a new earth rise. Let another world be born. Let a bloody peace be written in the sky. Let a second generation full of courage issue forth let a people loving freedom come to growth."
  }
]

quotes['pet'] = [
  {
    "author": "Hippolyte Taine",
    "category": "pet",
    "id": 53820,
    "text": "I have studied many philosophers and many cats. The wisdom of cats is infinitely superior."
  },
  {
    "author": "Busy Philipps",
    "category": "pet",
    "id": 53866,
    "text": "I have the same pet peeve as Anderson Cooper, which is bare feet in public. I hate it. It so grosses me out, especially in New York. Oh my God, New York in the summer with people and their feet in their sandals and their flip-flops, like get it away!"
  },
  {
    "author": "Frederick Pollock",
    "category": "pet",
    "id": 53891,
    "text": "Crabbed and obscure definitions are of no use beyond a narrow circle of students, of whom probably every one has a pet one of his own."
  },
  {
    "author": "Nafisa Joseph",
    "category": "pet",
    "id": 53822,
    "text": "I used to love dogs until I discovered cats."
  },
  {
    "author": "Jack White",
    "category": "pet",
    "id": 53840,
    "text": "Vinyl is the real deal. I've always felt like, until you buy the vinyl record, you don't really own the album. And it's not just me or a little pet thing or some kind of retro romantic thing from the past. It is still alive."
  },
  {
    "author": "Scott Adams",
    "category": "pet",
    "id": 53839,
    "text": "There's kind of a toll you have to pay with a cat if you don't pet her for 10 minutes she'll bother you for six hours."
  },
  {
    "author": "Alyssa Milano",
    "category": "pet",
    "id": 53848,
    "text": "Every time I decide I want a child I get another pet. I have 3 dogs, 13 birds and 3 horses, what does that tell you?"
  },
  {
    "author": "Martha Scott",
    "category": "pet",
    "id": 53785,
    "text": "Do not make the mistake of treating your dogs like humans or they will treat you like dogs."
  },
  {
    "author": "Gary Neville",
    "category": "pet",
    "id": 53876,
    "text": "It is one of my pet hates when I see players who have agents who do everything for them. They don't know how to set up their own bank accounts, they don't know what they are spending their money on and they can't make their own decisions."
  },
  {
    "author": "Garrison Keillor",
    "category": "pet",
    "id": 53777,
    "text": "Cats are intended to teach us that not everything in nature has a function."
  },
  {
    "author": "Doug Coupland",
    "category": "pet",
    "id": 53793,
    "text": "If cats were double the size they are now, they'd probably be illegal."
  },
  {
    "author": "Thornton Wilder",
    "category": "pet",
    "id": 53784,
    "text": "Many who have spent a lifetime in it can tell us less of love than the child that lost a dog yesterday."
  },
  {
    "author": "Alexander Theroux",
    "category": "pet",
    "id": 53896,
    "text": "It's true, you can never eat a pet you name. And anyway, it would be like a ventriloquist eating his dummy."
  },
  {
    "author": "Vivien Leigh",
    "category": "pet",
    "id": 53786,
    "text": "I've always been mad about cats."
  },
  {
    "author": "Zachary Levi",
    "category": "pet",
    "id": 53879,
    "text": "I could probably give you a list of a dozen pet peeves I have about my own physicality and why I couldn't get a second date."
  },
  {
    "author": "Jim Davis",
    "category": "pet",
    "id": 53778,
    "text": "Way down deep, we're all motivated by the same urges. Cats have the courage to live by them."
  },
  {
    "author": "Connie Stevens",
    "category": "pet",
    "id": 53893,
    "text": "Pet me, touch me, love me, that's what I get when I perform. That's when I'm really getting what I want."
  },
  {
    "author": "Christopher Morley",
    "category": "pet",
    "id": 53781,
    "text": "No one appreciates the very special genius of your conversation as the dog does."
  },
  {
    "author": "Bernard Williams",
    "category": "pet",
    "id": 53800,
    "text": "There is no psychiatrist in the world like a puppy licking your face."
  },
  {
    "author": "Robert Benchley",
    "category": "pet",
    "id": 53759,
    "text": "Dachshunds are ideal dogs for small children, as they are already stretched and pulled to such a length that the child cannot do much harm one way or the other."
  },
  {
    "author": "Marie Corelli",
    "category": "pet",
    "id": 53769,
    "text": "I never married because there was no need. I have three pets at home which answer the same purpose as a husband. I have a dog which growls every morning, a parrot which swears all afternoon, and a cat that comes home late at night."
  },
  {
    "author": "Hope Davis",
    "category": "pet",
    "id": 53869,
    "text": "I've been lucky. I've made films that I really like. It's been a combination of what comes to me and what I choose. I've gone after lots of things that I didn't get, pet projects that everybody ends up chasing after. Really, you're lucky if you get anything."
  },
  {
    "author": "Earl Derr Biggers",
    "category": "pet",
    "id": 53824,
    "text": "Only very brave mouse makes nest in cat's ear."
  },
  {
    "author": "William H. Macy",
    "category": "pet",
    "id": 53807,
    "text": "I was a dog in a past life. Really. I'll be walking down the street and dogs will do a sort of double take. Like, Hey, I know him."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "pet",
    "id": 53767,
    "text": "Never wear anything that panics the cat."
  },
  {
    "author": "Mike Ditka",
    "category": "pet",
    "id": 53810,
    "text": "There's just me and my wife and a dog and we feed him Healthy Choice also."
  },
  {
    "author": "Theresa May",
    "category": "pet",
    "id": 53847,
    "text": "We all know the stories about the Human Rights Act... about the illegal immigrant who cannot be deported because, and I am not making this up, he had a pet cat."
  },
  {
    "author": "Anatole France",
    "category": "pet",
    "id": 53747,
    "text": "Until one has loved an animal a part of one's soul remains unawakened."
  },
  {
    "author": "Jerry Ferrara",
    "category": "pet",
    "id": 53895,
    "text": "My biggest pet peeve are just girls who go to sports bars who have no intention on caring what teams are playing, like they're looking for just a night out. That drives me more crazy than anything else. Like, don't pretend to be a sports fan."
  },
  {
    "author": "Bob Hope",
    "category": "pet",
    "id": 53797,
    "text": "The trees in Siberia are miles apart, that is why the dogs are so fast."
  },
  {
    "author": "Paula Cole",
    "category": "pet",
    "id": 53813,
    "text": "Just watching my cats can make me happy."
  },
  {
    "author": "Juan Gris",
    "category": "pet",
    "id": 53902,
    "text": "I always pet a dog with my left hand because if he bit me I'd still have my right hand to paint with."
  },
  {
    "author": "Robert Southey",
    "category": "pet",
    "id": 53796,
    "text": "A kitten is in the animal world what a rosebud is in the garden."
  },
  {
    "author": "Paul Rudd",
    "category": "pet",
    "id": 53894,
    "text": "I think there's something great and generic about goldfish. They're everybody's first pet."
  },
  {
    "author": "Dwight D. Eisenhower",
    "category": "pet",
    "id": 53760,
    "text": "What counts is not necessarily the size of the dog in the fight - it's the size of the fight in the dog."
  },
  {
    "author": "Rebecca Hall",
    "category": "pet",
    "id": 53873,
    "text": "There are people all over the world who like to write fan letters in the voice of their pet: 'Hello, my name is Fifi and I'm a labrador and I think you're great. Paw paw!'"
  },
  {
    "author": "Jane Siberry",
    "category": "pet",
    "id": 53862,
    "text": "I brought a Border Collie back home to Vancouver from Wales - where some of my ancestors are from - and needed to challenge him in other ways than just being my pet. So I investigated sheep herding and took a few lessons, and decided I was probably learning more than my dog!"
  },
  {
    "author": "Wilbur Wright",
    "category": "pet",
    "id": 53883,
    "text": "I am an enthusiast, but not a crank in the sense that I have some pet theories as to the proper construction of a flying machine. I wish to avail myself of all that is already known and then, if possible, add my mite to help on the future worker who will attain final success."
  },
  {
    "author": "Betty White",
    "category": "pet",
    "id": 53845,
    "text": "It's a little known fact that one in three family pets gets lost during its lifetime, and approximately 9 million pets enter shelters each year. That's why it's a wonderful thing to get your pet microchipped and registered with your contact information because then they can be located and the owners can track where their pets are."
  },
  {
    "author": "Max Cannon",
    "category": "pet",
    "id": 53882,
    "text": "We all have our pet things that we like to get religious about."
  },
  {
    "author": "Bill Dana",
    "category": "pet",
    "id": 53803,
    "text": "I had been told that the training procedure with cats was difficult. It's not. Mine had me trained in two days."
  },
  {
    "author": "Mason Cooley",
    "category": "pet",
    "id": 53771,
    "text": "Even cats grow lonely and anxious."
  },
  {
    "author": "Kirsty Gallacher",
    "category": "pet",
    "id": 53852,
    "text": "I love animals and feel very strongly that people should not be allowed to buy a pet if they are not able to look after it."
  },
  {
    "author": "Mason Cooley",
    "category": "pet",
    "id": 53770,
    "text": "A happy arrangement: many people prefer cats to other people, and many cats prefer people to other cats."
  },
  {
    "author": "Billy Graham",
    "category": "pet",
    "id": 53828,
    "text": "A real Christian is a person who can give his pet parrot to the town gossip."
  },
  {
    "author": "Rashida Jones",
    "category": "pet",
    "id": 53842,
    "text": "My pet peeve and my goal in life is to somehow get an adjective for 'integrity' in the dictionary. 'Truthful' doesn't really cover it, or 'genuine.' It should be like 'integritus.'"
  },
  {
    "author": "Ziggy Marley",
    "category": "pet",
    "id": 53846,
    "text": "I used to have this little mouse. I buy birds from the pet store and I let them go."
  },
  {
    "author": "Chris Chocola",
    "category": "pet",
    "id": 53877,
    "text": "The government needs to help those in need, but members of Congress shouldn't take advantage of the situation and use a national tragedy as an opportunity to spend taxpayer dollars on their pet projects."
  },
  {
    "author": "Roger Caras",
    "category": "pet",
    "id": 53806,
    "text": "Cats don't like change without their consent."
  },
  {
    "author": "Josh Duhamel",
    "category": "pet",
    "id": 53875,
    "text": "I've teamed up with PetSmart Charities to celebrate the five million homeless pets who've found homes through their in-store adoption centers, and to spread the word about how we can work together to save millions more pets' lives and, ultimately, end pet homelessness."
  },
  {
    "author": "Kaspar Hauser",
    "category": "pet",
    "id": 53823,
    "text": "Many cats are the death of the mouse."
  },
  {
    "author": "Agnes Repplier",
    "category": "pet",
    "id": 53805,
    "text": "It is impossible for a lover of cats to banish these alert, gentle, and discriminating friends, who give us just enough of their regard and complaisance to make us hunger for more."
  },
  {
    "author": "Hal Sparks",
    "category": "pet",
    "id": 53861,
    "text": "Truth be told, ginormous portions have become a pet peeve of mine."
  },
  {
    "author": "Andre Norton",
    "category": "pet",
    "id": 53818,
    "text": "Perhaps it is because cats do not live by human patterns, do not fit themselves into prescribed behavior, that they are so united to creative people."
  },
  {
    "author": "Al Yankovic",
    "category": "pet",
    "id": 53855,
    "text": "One of my pet peeves is that sometimes the talents of my band get overlooked because, and it was the same problem that Frank Zappa had, with a lot of groups that use humor, people don't realize there's a lot of craft behind the comedy."
  },
  {
    "author": "Kin Hubbard",
    "category": "pet",
    "id": 53772,
    "text": "No one can feel as helpless as the owner of a sick goldfish."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "pet",
    "id": 53741,
    "text": "Women and cats will do as they please, and men and dogs should relax and get used to the idea."
  },
  {
    "author": "George Eliot",
    "category": "pet",
    "id": 53748,
    "text": "Animals are such agreeable friends - they ask no questions they pass no criticisms."
  },
  {
    "author": "Sigmund Freud",
    "category": "pet",
    "id": 53742,
    "text": "Time spent with cats is never wasted."
  },
  {
    "author": "Andy Rooney",
    "category": "pet",
    "id": 53752,
    "text": "The average dog is a nicer person than the average person."
  },
  {
    "author": "Josh Billings",
    "category": "pet",
    "id": 53743,
    "text": "A dog is the only thing on earth that loves you more than you love yourself."
  },
  {
    "author": "Rita Rudner",
    "category": "pet",
    "id": 53789,
    "text": "We've begun to long for the pitter-patter of little feet - so we bought a dog. Well, it's cheaper, and you get more feet."
  },
  {
    "author": "Roger Caras",
    "category": "pet",
    "id": 53753,
    "text": "Dogs are not our whole life, but they make our lives whole."
  },
  {
    "author": "Robert Crais",
    "category": "pet",
    "id": 53878,
    "text": "I had a big Akita, Yoshi, who was fabulous. I loved him. We lost him when he was 12, and I've never been able to replace him. Normally, most people lose a pet and get another and keep going on. But it just felt wrong to me it felt disloyal."
  },
  {
    "author": "Chris Pratt",
    "category": "pet",
    "id": 53859,
    "text": "I have a lot of plants and fish and a pet lizard and Venus flytraps. I have a whole ecosystem in my room, like a running waterfall and different lights and sensors set on digital timers."
  },
  {
    "author": "Albert Schweitzer",
    "category": "pet",
    "id": 53745,
    "text": "There are two means of refuge from the miseries of life: music and cats."
  },
  {
    "author": "Edwin Way Teale",
    "category": "pet",
    "id": 53885,
    "text": "Those who wish to pet and baby wild animals 'love' them. But those who respect their natures and wish to let them live normal lives, love them more."
  },
  {
    "author": "George Carlin",
    "category": "pet",
    "id": 53827,
    "text": "Don't sweat the petty things and don't pet the sweaty things."
  },
  {
    "author": "Norman Ralph Augustine",
    "category": "pet",
    "id": 53812,
    "text": "A hungry dog hunts best. A hungrier dog hunts even better."
  },
  {
    "author": "W. L. George",
    "category": "pet",
    "id": 53819,
    "text": "Cats know how to obtain food without labor, shelter without confinement, and love without penalties."
  },
  {
    "author": "Rachael Ray",
    "category": "pet",
    "id": 53844,
    "text": "We created a line of pet food called Nutrish that's made to human standards, and 100 percent of the proceeds go to animal rescue. One of our top-tier donors is the ASPCA, and they help us challenge animal shelters all across the country to get more animals placed in homes."
  },
  {
    "author": "Richard Dean Anderson",
    "category": "pet",
    "id": 53762,
    "text": "Dogs are my favorite people."
  },
  {
    "author": "Joseph Wood Krutch",
    "category": "pet",
    "id": 53790,
    "text": "Cats are rather delicate creatures and they are subject to a good many different ailments, but I have never heard of one who suffered from insomnia."
  },
  {
    "author": "Agnes Repplier",
    "category": "pet",
    "id": 53814,
    "text": "A kitten is chiefly remarkable for rushing about like mad at nothing whatever, and generally stopping before it gets there."
  },
  {
    "author": "Rodney Dangerfield",
    "category": "pet",
    "id": 53746,
    "text": "I looked up my family tree and found three dogs using it."
  },
  {
    "author": "Michelle Malkin",
    "category": "pet",
    "id": 53858,
    "text": "Environmentalists hate sprawl - except when it comes to the size of their expansive pet legislation on Capitol Hill."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "pet",
    "id": 53756,
    "text": "The dog is the god of frolic."
  },
  {
    "author": "John Bacon",
    "category": "pet",
    "id": 53889,
    "text": "I heard that Jesus had a pet dinosaur. Evolution must be a myth then."
  },
  {
    "author": "Shelley Morrison",
    "category": "pet",
    "id": 53836,
    "text": "Teach your children how to behave with animals. Adopt a pet. Don't go buy one. Please. That's a sin. Let's get these puppy mills out of business."
  },
  {
    "author": "Justin Chambers",
    "category": "pet",
    "id": 53900,
    "text": "And I strongly believe people should rescue dogs, or, at the very least, listen to Bob Barker and have your pet spayed or neutered."
  },
  {
    "author": "Chris Lowe",
    "category": "pet",
    "id": 53881,
    "text": "You can get too bogged down in technology and you can sort of forget what it is you were trying to do. And with the Pet Shop Boys it's primarily about the songs, it's about song writing."
  },
  {
    "author": "Steven Wright",
    "category": "pet",
    "id": 53830,
    "text": "My roommate got a pet elephant. Then it got lost. It's in the apartment somewhere."
  },
  {
    "author": "Fran Lebowitz",
    "category": "pet",
    "id": 53768,
    "text": "If you are a dog and your owner suggests that you wear a sweater suggest that he wear a tail."
  },
  {
    "author": "Joseph Wood Krutch",
    "category": "pet",
    "id": 53801,
    "text": "Cats seem to go on the principle that it never does any harm to ask for what you want."
  },
  {
    "author": "August Strindberg",
    "category": "pet",
    "id": 53799,
    "text": "People who keep dogs are cowards who haven't got the guts to bite people themselves."
  },
  {
    "author": "Lefty Gomez",
    "category": "pet",
    "id": 53782,
    "text": "I've got a new invention. It's a revolving bowl for tired goldfish."
  },
  {
    "author": "Angus Young",
    "category": "pet",
    "id": 53808,
    "text": "There are all sorts of cute puppy dogs, but it doesn't stop people from going out and buying Dobermans."
  },
  {
    "author": "Charles de Gaulle",
    "category": "pet",
    "id": 53751,
    "text": "The better I get to know men, the more I find myself loving dogs."
  },
  {
    "author": "Abraham Lincoln",
    "category": "pet",
    "id": 53739,
    "text": "No matter how much cats fight, there always seem to be plenty of kittens."
  },
  {
    "author": "Oliver Herford",
    "category": "pet",
    "id": 53775,
    "text": "Cat: a pygmy lion who loves mice, hates dogs, and patronizes human beings."
  },
  {
    "author": "Ogden Nash",
    "category": "pet",
    "id": 53776,
    "text": "The trouble with a kitten is that eventually it becomes a cat."
  },
  {
    "author": "Natalie Portman",
    "category": "pet",
    "id": 53834,
    "text": "When a guy tells me I'm cute, it's not something desirable. Cute is more like what you want your pet to be."
  },
  {
    "author": "Pam Brown",
    "category": "pet",
    "id": 53783,
    "text": "Kittens are wide-eyed, soft and sweet. With needles in their jaws and feet."
  },
  {
    "author": "Ron Reagan",
    "category": "pet",
    "id": 53809,
    "text": "We have three cats. It's like having children, but there is no tuition involved."
  },
  {
    "author": "Rodney Dangerfield",
    "category": "pet",
    "id": 53758,
    "text": "What a dog I got, his favorite bone is in my arm."
  },
  {
    "author": "Juliette Lewis",
    "category": "pet",
    "id": 53795,
    "text": "I kind of imagine myself at eighty, a cat lady."
  },
  {
    "author": "Tom Felton",
    "category": "pet",
    "id": 53838,
    "text": "I really liked the snake that breaks out of the cage in the beginning of the movie. I saw it in real life, and it was really cool. Really big and fat. The owls are cool as well, but you can't really pet them."
  },
  {
    "author": "Cleveland Amory",
    "category": "pet",
    "id": 53788,
    "text": "As anyone who has ever been around a cat for any length of time well knows, cats have enormous patience with the limitations of the human kind."
  },
  {
    "author": "Sophie Ellis-Bextor",
    "category": "pet",
    "id": 53867,
    "text": "I try not to wear anything I have to fidget with - there's nothing worse than wearing something and pulling down the hem and re-adjusting the top. My pet hate is when girls wear those strapless dresses and spend the whole night yanking them up."
  },
  {
    "author": "Winston Churchill",
    "category": "pet",
    "id": 53740,
    "text": "I am fond of pigs. Dogs look up to us. Cats look down on us. Pigs treat us as equals."
  }
]

quotes['poetry'] = [
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54287,
    "text": "Poetry, almost by definition, calls attention to its language and form."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "poetry",
    "id": 54097,
    "text": "Women do not have as great a need for poetry because their own essence is poetry."
  },
  {
    "author": "Marilyn Hacker",
    "category": "poetry",
    "id": 54392,
    "text": "I have experienced healing through other writers' poetry, but there's no way I can sit down to write in the hope a poem will have healing potential. If I do, I'll write a bad poem."
  },
  {
    "author": "Gwendolyn Brooks",
    "category": "poetry",
    "id": 54444,
    "text": "Poetry is life distilled."
  },
  {
    "author": "Russell Simmons",
    "category": "poetry",
    "id": 54187,
    "text": "I want to promote poetry to the point where you got all the baldhead kids running around doing poetry, getting the music out of the way and having only words, the spoken word, and then see what happens."
  },
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54300,
    "text": "The idea of avant-garde art is a very suspicious thing to me, the idea that poetry is new and it keeps being new the way Chevrolets every year are new."
  },
  {
    "author": "George Murray",
    "category": "poetry",
    "id": 54521,
    "text": "I've often entertained paranoid suspicions about my fridge and what it's been doing to my poetry when I'm not looking, but I never even considered that my fan was thinking about me."
  },
  {
    "author": "Paul Auster",
    "category": "poetry",
    "id": 54591,
    "text": "I was always interested in French poetry sort of as a sideline to my own work, I was translating contemporary French poets. That kind of spilled out into translation as a way to earn money, pay for food and put bread on the table."
  },
  {
    "author": "Gaston Bachelard",
    "category": "poetry",
    "id": 54383,
    "text": "Poetry is one of the destinies of speech... One would say that the poetic image, in its newness, opens a future to language."
  },
  {
    "author": "Diane Wakoski",
    "category": "poetry",
    "id": 54497,
    "text": "I'm perfectly happy when I look out at an audience and it's all women. I always think it's kind of odd, but then, more women than men, I think, read and write poetry."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "poetry",
    "id": 54014,
    "text": "Personality is everything in art and poetry."
  },
  {
    "author": "Caroline Kennedy",
    "category": "poetry",
    "id": 54141,
    "text": "When you're going through something, whether it's a wonderful thing like having a child or a sad thing like losing somebody, you often feel like 'Oh my God, I'm so overwhelmed I'm dealing with this huge thing on my own.' In fact, poetry's a nice reminder that, no, everybody goes through it. These are universal experiences."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "poetry",
    "id": 54105,
    "text": "Women are treated as unjustly in poetry as in life. The feminine ones are not idealistic, and the idealistic not feminine."
  },
  {
    "author": "Franz Grillparzer",
    "category": "poetry",
    "id": 54433,
    "text": "Prose talks and poetry sings."
  },
  {
    "author": "William Hazlitt",
    "category": "poetry",
    "id": 53922,
    "text": "Poetry is all that is worth remembering in life."
  },
  {
    "author": "John Drinkwater",
    "category": "poetry",
    "id": 54608,
    "text": "Poetry being the sign of that which all men desire, even though the desire be unconscious, intensity of life or completeness of experience, the universality of its appeal is a matter of course."
  },
  {
    "author": "Gerald Brenan",
    "category": "poetry",
    "id": 54674,
    "text": "The cliche is dead poetry."
  },
  {
    "author": "John Millington Synge",
    "category": "poetry",
    "id": 54402,
    "text": "It is the timber of poetry that wears most surely, and there is no timber that has not strong roots among the clay and worms."
  },
  {
    "author": "John Barton",
    "category": "poetry",
    "id": 54396,
    "text": "Poetry is but another form of inquiry into the nature of phenomena, using with its own unique procedures and tools."
  },
  {
    "author": "John Cage",
    "category": "poetry",
    "id": 53948,
    "text": "There is poetry as soon as we realize that we possess nothing."
  },
  {
    "author": "Robert Staughton Lynd",
    "category": "poetry",
    "id": 54325,
    "text": "Cut quarrels out of literature, and you will have very little history or drama or fiction or epic poetry left."
  },
  {
    "author": "John Dryden",
    "category": "poetry",
    "id": 54128,
    "text": "Dancing is the poetry of the foot."
  },
  {
    "author": "Janine Turner",
    "category": "poetry",
    "id": 54550,
    "text": "I have always written poetry but I have never applied it to songwriting."
  },
  {
    "author": "Wilfred Owen",
    "category": "poetry",
    "id": 54218,
    "text": "My subject is War, and the pity of War. The Poetry is in the pity."
  },
  {
    "author": "John Drinkwater",
    "category": "poetry",
    "id": 54603,
    "text": "Any long work in which poetry is persistent, be it epic or drama or narrative, is really a succession of separate poetic experiences governed into a related whole by an energy distinct from that which evoked them."
  },
  {
    "author": "Guy Johnson",
    "category": "poetry",
    "id": 54216,
    "text": "My mother asked me what I wanted for my birthday, so I said I wanted to read poetry with her."
  },
  {
    "author": "Norman MacCaig",
    "category": "poetry",
    "id": 54333,
    "text": "And the second question, can poetry be taught? I didn't think so."
  },
  {
    "author": "Allen Tate",
    "category": "poetry",
    "id": 54480,
    "text": "How does one happen to write a poem: where does it come from? That is the question asked by the psychologists or the geneticists of poetry."
  },
  {
    "author": "Jean Cocteau",
    "category": "poetry",
    "id": 53947,
    "text": "Children and lunatics cut the Gordian knot which the poet spends his life patiently trying to untie."
  },
  {
    "author": "David Antin",
    "category": "poetry",
    "id": 54379,
    "text": "While I've had a great distaste for what's usually called song in modern poetry or for what's usually called music, I really don't think of speech as so far from song."
  },
  {
    "author": "Peter Davison",
    "category": "poetry",
    "id": 54449,
    "text": "My friends never talk to me about my poetry because they're embarrassed that I write it or they're embarrassed by what I write about which are not such extraordinarily terrifying things, but they are the state of human existence."
  },
  {
    "author": "Lascelles Abercrombie",
    "category": "poetry",
    "id": 54202,
    "text": "With several different kinds of poetry to choose from, a man would decide that he would like best to be an epic poet, and he would set out, in conscious determination, on an epic poem."
  },
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54280,
    "text": "I think that it's more likely that in my 60s and 70s I will be writing poetry rather than fiction."
  },
  {
    "author": "Azar Nafisi",
    "category": "poetry",
    "id": 54322,
    "text": "This is a good time to ask apologists for the Islamic regime, who degrades Islam? Who imposes stoning, forced marriage of underage girls and flogging for not wearing the veil? Do such practices represent Iran's ancient history and culture, its ethnic and religious diversity? Its centuries of sensual and subversive poetry?"
  },
  {
    "author": "Michael Sheen",
    "category": "poetry",
    "id": 54199,
    "text": "My dad is a Jack Nicholson lookalike and a frustrated performer, my mother's into reading and poetry. I suppose the thing I owe them most is my confidence."
  },
  {
    "author": "Richard Rosen",
    "category": "poetry",
    "id": 53991,
    "text": "The poem is the point at which our strength gave out."
  },
  {
    "author": "James Russell Lowell",
    "category": "poetry",
    "id": 54051,
    "text": "Poetry is something to make us wiser and better, by continually revealing those types of beauty and truth, which God has set in all men's souls."
  },
  {
    "author": "Lascelles Abercrombie",
    "category": "poetry",
    "id": 54245,
    "text": "By the general process of epic poetry, I mean the way this form of art has constantly responded to the profound needs of the society in which it was made."
  },
  {
    "author": "Lewis Thomas",
    "category": "poetry",
    "id": 54164,
    "text": "The cloning of humans is on most of the lists of things to worry about from Science, along with behaviour control, genetic engineering, transplanted heads, computer poetry and the unrestrained growth of plastic flowers."
  },
  {
    "author": "Helen Thomas",
    "category": "poetry",
    "id": 54401,
    "text": "There are better ways we can transform this virulent hatred - by living our ideals, the Peace Corps, exchange students, teachers, exporting our music, poetry, blue jeans."
  },
  {
    "author": "Philip Levine",
    "category": "poetry",
    "id": 54579,
    "text": "Meet some people who care about poetry the way you do. You'll have that readership. Keep going until you know you're doing work that's worthy. And then see what happens. That's my advice."
  },
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54282,
    "text": "You have to really dive deep back into yourself and get rid of so much modern analytical categorization. It's one of the great things poetry does."
  },
  {
    "author": "Robert Hass",
    "category": "poetry",
    "id": 54705,
    "text": "I think that the job of poetry, its political job, is to refresh the idea of justice, which is going dead in us all the time."
  },
  {
    "author": "Marianne Moore",
    "category": "poetry",
    "id": 53970,
    "text": "Poetry is the art of creating imaginary gardens with real toads."
  },
  {
    "author": "Misha Collins",
    "category": "poetry",
    "id": 54711,
    "text": "Well, I like to write poetry. I'm a published poet."
  },
  {
    "author": "Tom Wesselmann",
    "category": "poetry",
    "id": 54769,
    "text": "I didn't want to deal in poetry. I got rid of that after a few months."
  },
  {
    "author": "Leonard Cohen",
    "category": "poetry",
    "id": 54120,
    "text": "I think the term poet is a very exalted term and should be applied to a man at the end of his work. When he looks back over the body of his work and he's written poetry then let the verdict be that he's a poet."
  },
  {
    "author": "Emily Dickinson",
    "category": "poetry",
    "id": 54015,
    "text": "If I read a book and it makes my whole body so cold no fire can ever warm me, I know that is poetry."
  },
  {
    "author": "James Dickey",
    "category": "poetry",
    "id": 54618,
    "text": "I want a fever, in poetry: a fever, and tranquillity."
  },
  {
    "author": "Sonja Sohn",
    "category": "poetry",
    "id": 54743,
    "text": "This career essentially chased me down while I was on the spoken-word scene in New York. I kept hearing that my delivery of my poetry - which was very personal and cathartic at the time- was very moving to folks. People thought that I was an actress because of my delivery, when I was just dropping into the work and really pouring out my soul."
  },
  {
    "author": "Charlie Chaplin",
    "category": "poetry",
    "id": 54032,
    "text": "Why should poetry have to make sense?"
  },
  {
    "author": "Carl Sandburg",
    "category": "poetry",
    "id": 54057,
    "text": "When I was writing pretty poor poetry, this girl with midnight black hair told me to go on."
  },
  {
    "author": "John Denham",
    "category": "poetry",
    "id": 54740,
    "text": "Poetry is of so subtle a spirit, that in the pouring out of one language into another it will evaporate."
  },
  {
    "author": "Simon Armitage",
    "category": "poetry",
    "id": 54667,
    "text": "People who read poetry, for example, like the feel, the heft and the smell of a book."
  },
  {
    "author": "Elizabeth Jennings",
    "category": "poetry",
    "id": 54770,
    "text": "For me, poetry is always a search for order."
  },
  {
    "author": "Denis Johnson",
    "category": "poetry",
    "id": 54682,
    "text": "All the modern verse plays, they're terrible they're mostly about the poetry. It's more important that the play is first."
  },
  {
    "author": "Shelby Foote",
    "category": "poetry",
    "id": 54527,
    "text": "I began the way nearly everybody I ever heard of - I began writing poetry. And I find that to be quite usual with writers, their trying their hand at poetry."
  },
  {
    "author": "John Drinkwater",
    "category": "poetry",
    "id": 54609,
    "text": "Poetry is the communication through words of certain experiences that can be communicated in no other way."
  },
  {
    "author": "Roger McGough",
    "category": "poetry",
    "id": 54699,
    "text": "If I do a poetry reading I want people to walk out and say they feel better for having been there - not because you've done a comedy performance but because you're talking about your father dying or having young children, things that touch your soul."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "poetry",
    "id": 54034,
    "text": "All slang is metaphor, and all metaphor is poetry."
  },
  {
    "author": "Muhammad Iqbal",
    "category": "poetry",
    "id": 54125,
    "text": "If the object of poetry is, to make men, then poetry is the heir of prophecy."
  },
  {
    "author": "Jack Prelutsky",
    "category": "poetry",
    "id": 54554,
    "text": "I look for poetry in English because it's the only language I read."
  },
  {
    "author": "Salvatore Quasimodo",
    "category": "poetry",
    "id": 54472,
    "text": "Religious poetry, civic poetry, lyric or dramatic poetry are all categories of man's expression which are valid only if the endorsement of formal content is valid."
  },
  {
    "author": "June Jordan",
    "category": "poetry",
    "id": 54439,
    "text": "So, poetry becomes a means for useful dialogue between people who are not only unknown, but mute to each other. It produces a dialogue among people that guards all of us against manipulation by our so-called leaders."
  },
  {
    "author": "John Masefield",
    "category": "poetry",
    "id": 54684,
    "text": "Since the printing press came into being, poetry has ceased to be the delight of the whole community of man it has become the amusement and delight of the few."
  },
  {
    "author": "Leonard Cohen",
    "category": "poetry",
    "id": 53928,
    "text": "Poetry is just the evidence of life. If your life is burning well, poetry is just the ash."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "poetry",
    "id": 53916,
    "text": "The poets have been mysteriously silent on the subject of cheese."
  },
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54297,
    "text": "A poem in form still has to have voice, gesture, a sense of discovery, a metaphoric connection, as any poetry does."
  },
  {
    "author": "Robert Graves",
    "category": "poetry",
    "id": 53944,
    "text": "There's no money in poetry, but then there's no poetry in money, either."
  },
  {
    "author": "Eugenio Montale",
    "category": "poetry",
    "id": 54348,
    "text": "Narrative art, the novel, from Murasaki to Proust, has produced great works of poetry."
  },
  {
    "author": "Virginia Woolf",
    "category": "poetry",
    "id": 54059,
    "text": "Yet, it is true, poetry is delicious the best prose is that which is most full of poetry."
  },
  {
    "author": "Theodore Sturgeon",
    "category": "poetry",
    "id": 54374,
    "text": "Science fiction, outside of poetry, is the only literary field which has no limits, no parameters whatsoever."
  },
  {
    "author": "Don Marquis",
    "category": "poetry",
    "id": 54150,
    "text": "Poetry is what Milton saw when he went blind."
  },
  {
    "author": "Carol Ann Duffy",
    "category": "poetry",
    "id": 54312,
    "text": "I have piles of poetry books in the bathroom, on the stairs, everywhere. The only way to write poetry is to read it."
  },
  {
    "author": "Allen Ginsberg",
    "category": "poetry",
    "id": 54375,
    "text": "I want people to bow as they see me and say he is gifted with poetry, he has seen the presence of the creator."
  },
  {
    "author": "John Cage",
    "category": "poetry",
    "id": 54123,
    "text": "I have nothing to say, I am saying it, and that is poetry."
  },
  {
    "author": "Thomas Harrison",
    "category": "poetry",
    "id": 54691,
    "text": "No art form points like poetry to this originality of language as to its essential and abiding concern."
  },
  {
    "author": "Adrienne Rich",
    "category": "poetry",
    "id": 54255,
    "text": "Poetry is above all a concentration of the power of language, which is the power of our ultimate relationship to everything in the universe."
  },
  {
    "author": "Lynn Johnston",
    "category": "poetry",
    "id": 54434,
    "text": "And my father was a comic. He could play any musical instrument. He loved to perform. He was a wonderfully comedic character. He had the ability to dance and sing and charm and analyze poetry."
  },
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54286,
    "text": "Our most famous writers are Faulkner and Eudora Welty and Flannery O'Connor. It would make sense that the poetry would reflect some of those same values, some of the same techniques."
  },
  {
    "author": "Chaim Potok",
    "category": "poetry",
    "id": 54365,
    "text": "A book is sent out into the world, and there is no way of fully anticipating the responses it will elicit. Consider the responses called forth by the Bible, Homer, Shakespeare - let alone contemporary poetry or a modern novel."
  },
  {
    "author": "Hamlin Garland",
    "category": "poetry",
    "id": 54565,
    "text": "There is no gilding of setting sun or glamor of poetry to light up the ferocious and endless toil of the farmers' wives."
  },
  {
    "author": "Trevor McDonald",
    "category": "poetry",
    "id": 54693,
    "text": "Poetry says the things that I can't say. I read a lot, but I never write it."
  },
  {
    "author": "Johann Georg Hamann",
    "category": "poetry",
    "id": 54613,
    "text": "Poetry is the mother-tongue of the human race."
  },
  {
    "author": "Judith Rodriguez",
    "category": "poetry",
    "id": 54777,
    "text": "I write poetry in order to live more fully."
  },
  {
    "author": "Nathalie Sarraute",
    "category": "poetry",
    "id": 54631,
    "text": "One can't write for all readers. A poet cannot write for people who don't like poetry."
  },
  {
    "author": "Bob Dylan",
    "category": "poetry",
    "id": 54010,
    "text": "It's not easy to define poetry."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "poetry",
    "id": 54106,
    "text": "One has only as much morality as one has philosophy and poetry."
  },
  {
    "author": "Nicholson Baker",
    "category": "poetry",
    "id": 54408,
    "text": "When I really want to be soothed and reminded of why people bother to fiddle with sentences, I often read poetry."
  },
  {
    "author": "Seamus Heaney",
    "category": "poetry",
    "id": 54372,
    "text": "The completely solitary self: that's where poetry comes from, and it gets isolated by crisis, and those crises are often very intimate also."
  },
  {
    "author": "Norman MacCaig",
    "category": "poetry",
    "id": 54336,
    "text": "I was very interested in American poetry for many years. Much less now."
  },
  {
    "author": "Jordin Sparks",
    "category": "poetry",
    "id": 54200,
    "text": "I've written poetry since I was in the first grade, and it wasn't until I was a little bit older that I realized poetry could be put to music and become a song."
  },
  {
    "author": "Satyajit Ray",
    "category": "poetry",
    "id": 54074,
    "text": "At the age when Bengali youth almost inevitably writes poetry, I was listening to European classical music."
  },
  {
    "author": "Aristotle",
    "category": "poetry",
    "id": 54001,
    "text": "Hence poetry is something more philosophic and of graver import than history, since its statements are rather of the nature of universals, whereas those of history are singulars."
  },
  {
    "author": "Robert Morgan",
    "category": "poetry",
    "id": 54295,
    "text": "One of the most powerful devices of poetry is the use of distortions. You can go from talking about the way a minute passes to the way a century passes, or a lifetime."
  },
  {
    "author": "Phyllis Gotlieb",
    "category": "poetry",
    "id": 54742,
    "text": "You don't go after poetry, you take what comes. Maybe the gods do it through me but I certainly do a hell of a lot of the work."
  },
  {
    "author": "Diane Wakoski",
    "category": "poetry",
    "id": 54499,
    "text": "Distinctly American poetry is usually written in the context of one's geographic landscape, sometimes out of one's cultural myths, and often with reference to gender and race or ethnic origins."
  },
  {
    "author": "Antonin Artaud",
    "category": "poetry",
    "id": 54234,
    "text": "Written poetry is worth reading once, and then should be destroyed. Let the dead poets make way for others."
  },
  {
    "author": "Brian Harris",
    "category": "poetry",
    "id": 54626,
    "text": "To be born in Wales, not with a silver spoon in your mouth, but, with music in your blood and with poetry in your soul, is a privilege indeed."
  },
  {
    "author": "Tahar Ben Jelloun",
    "category": "poetry",
    "id": 54101,
    "text": "I came to poetry through the urgent need to denounce injustice, exploitation, humiliation. I know that's not enough to change the world. But to remain silent would have been a kind of intolerable complicity."
  }
]

quotes['politics'] = [
  {
    "author": "Henry Adams",
    "category": "politics",
    "id": 55172,
    "text": "I am an anarchist in politics and an impressionist in art as well as a symbolist in literature. Not that I understand what these terms mean, but I take them to be all merely synonyms of pessimist."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "politics",
    "id": 55133,
    "text": "Where there is politics or economics, there is no morality."
  },
  {
    "author": "Frank Luntz",
    "category": "politics",
    "id": 55638,
    "text": "I've done reasonably well over the last 10 years because I took the strategy of language and politics and applied it to the corporate world, which has never been done before."
  },
  {
    "author": "Jerry Saltz",
    "category": "politics",
    "id": 55128,
    "text": "I've always said that an art critic can put aside politics around art."
  },
  {
    "author": "Joseph Stalin",
    "category": "politics",
    "id": 54782,
    "text": "It is enough that the people know there was an election. The people who cast the votes decide nothing. The people who count the votes decide everything."
  },
  {
    "author": "Laura Bush",
    "category": "politics",
    "id": 55726,
    "text": "I like politics. I like traveling in the United States."
  },
  {
    "author": "Dick Durbin",
    "category": "politics",
    "id": 54960,
    "text": "Our party is a diverse one, as is my home state of Illinois."
  },
  {
    "author": "Lord Acton",
    "category": "politics",
    "id": 55317,
    "text": "The science of politics is the one science that is deposited by the streams of history, like the grains of gold in the sand of a river and the knowledge of the past, the record of truths revealed by experience, is eminently practical, as an instrument of action and a power that goes to making the future."
  },
  {
    "author": "Mike Huckabee",
    "category": "politics",
    "id": 55494,
    "text": "Arkansas is a state where politics is retail."
  },
  {
    "author": "Shimon Peres",
    "category": "politics",
    "id": 55400,
    "text": "The problem of the Middle East is poverty more than politics."
  },
  {
    "author": "Richard Lamm",
    "category": "politics",
    "id": 55686,
    "text": "Politics, like theater, is one of those things where you've got to be wise enough to know when to leave."
  },
  {
    "author": "Charles de Gaulle",
    "category": "politics",
    "id": 54899,
    "text": "Politics is too serious a matter to be left to the politicians."
  },
  {
    "author": "Van Morrison",
    "category": "politics",
    "id": 55236,
    "text": "These days politics, religion, media seem to get all mixed up. Television became the new religion a long time back and the media has taken over."
  },
  {
    "author": "Alexis de Tocqueville",
    "category": "politics",
    "id": 55061,
    "text": "In politics shared hatreds are almost always the basis of friendships."
  },
  {
    "author": "Richard M. Nixon",
    "category": "politics",
    "id": 55111,
    "text": "I reject the cynical view that politics is a dirty business."
  },
  {
    "author": "Dee Dee Myers",
    "category": "politics",
    "id": 55239,
    "text": "As women have played an increasingly important role in politics, there is no question that they've brought a different perspective, focusing attention on a broader set of issues and building alliances with other women."
  },
  {
    "author": "Ed Koch",
    "category": "politics",
    "id": 55564,
    "text": "There's a nastiness out there that wants to harm me with words. These are my enemies - the ideologues, the populists, the columnists who don't like the fact that I take them on toe-to-toe. What I try to do is tell the truth. It's not the coin of the realm in politics."
  },
  {
    "author": "George Will",
    "category": "politics",
    "id": 54919,
    "text": "Conservatives define themselves in terms of what they oppose."
  },
  {
    "author": "Barack Obama",
    "category": "politics",
    "id": 55001,
    "text": "Part of the reason that our politics seems so tough right now and facts and science and argument does not seem to be winning the day all the time is because we're hardwired not to always think clearly when we're scared. And the country's scared."
  },
  {
    "author": "John F. Kennedy",
    "category": "politics",
    "id": 54983,
    "text": "I'm always rather nervous about how you talk about women who are active in politics, whether they want to be talked about as women or as politicians."
  },
  {
    "author": "Marilyn Manson",
    "category": "politics",
    "id": 55106,
    "text": "The advantage of the internet is that it has taken away the charade of politics. China has heard of democracy and people know about certain concepts they wouldn't have previously."
  },
  {
    "author": "Mike Huckabee",
    "category": "politics",
    "id": 55496,
    "text": "Regardless of Bill Clinton's politics or personal life, he grew up in obscurity and was elected to the presidency - twice. Don't take that away from him, because then you take it away from every other kid in America sitting out there in a school bus with a big dream."
  },
  {
    "author": "Serj Tankian",
    "category": "politics",
    "id": 55491,
    "text": "I hate injustice, and I can't help but speak against it. But I don't want to get involved in politics."
  },
  {
    "author": "Russell Baker",
    "category": "politics",
    "id": 54908,
    "text": "Reporters thrive on the world's misfortune. For this reason they often take an indecent pleasure in events that dismay the rest of humanity."
  },
  {
    "author": "Louis D. Brandeis",
    "category": "politics",
    "id": 54864,
    "text": "If we desire respect for the law, we must first make the law respectable."
  },
  {
    "author": "Pericles",
    "category": "politics",
    "id": 55083,
    "text": "Just because you do not take an interest in politics doesn't mean politics won't take an interest in you."
  },
  {
    "author": "Tommy Lee Jones",
    "category": "politics",
    "id": 55532,
    "text": "If you want to know about my politics, the only way to do that is to look at my work."
  },
  {
    "author": "Terry McAuliffe",
    "category": "politics",
    "id": 55707,
    "text": "I've done business with people I've met in politics, who I went to law school with, who I grew up with. Who do you do business with? People you meet in life."
  },
  {
    "author": "Margaret Thatcher",
    "category": "politics",
    "id": 55012,
    "text": "I am in politics because of the conflict between good and evil, and I believe that in the end good will triumph."
  },
  {
    "author": "Otto von Bismarck",
    "category": "politics",
    "id": 55410,
    "text": "Politics is the art of the possible."
  },
  {
    "author": "Gerhard Schroder",
    "category": "politics",
    "id": 54951,
    "text": "I can't let important policy decisions hinge on the fact that an election is coming up every 90 days."
  },
  {
    "author": "Al Franken",
    "category": "politics",
    "id": 55692,
    "text": "Well, a lot of politics is communicating with people, and obviously comedy has something to do with that. I've been a producer and led people. Also, being a comedian, you're under pressure."
  },
  {
    "author": "Lewis Black",
    "category": "politics",
    "id": 54861,
    "text": "Republicans have nothing but bad ideas and Democrats have no ideas."
  },
  {
    "author": "Will Rogers",
    "category": "politics",
    "id": 54813,
    "text": "I don't make jokes. I just watch the government and report the facts."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "politics",
    "id": 54872,
    "text": "Politics is the art of choosing between the disastrous and the unpalatable."
  },
  {
    "author": "Ronald Reagan",
    "category": "politics",
    "id": 54967,
    "text": "It has been said that politics is the second oldest profession. I have learned that it bears a striking resemblance to the first."
  },
  {
    "author": "Adlai E. Stevenson",
    "category": "politics",
    "id": 55166,
    "text": "We mean by 'politics' the people's business - the most important business there is."
  },
  {
    "author": "Jon Meacham",
    "category": "politics",
    "id": 55265,
    "text": "Whether one believes or not, religion is as real a force in the life of the world as economics or politics, and it demands fair-minded attention. Even if you think the entire religious enterprise is at best misguided and at worst counterproductive, it remains vital, inspiring great good and, sometimes, great evil."
  },
  {
    "author": "Leonard Bernstein",
    "category": "politics",
    "id": 54828,
    "text": "A liberal is a man or a woman or a child who looks forward to a better day, a more tranquil night, and a bright, infinite future."
  },
  {
    "author": "Alveda King",
    "category": "politics",
    "id": 55530,
    "text": "America wants solutions. America wants a leader. No more tabloid politics."
  },
  {
    "author": "Charles Edison",
    "category": "politics",
    "id": 55443,
    "text": "Economics, politics, and personalities are often inseparable."
  },
  {
    "author": "Thomas B. Macaulay",
    "category": "politics",
    "id": 54904,
    "text": "Many politicians are in the habit of laying it down as a self-evident proposition that no people ought to be free till they are fit to use their freedom. The maxim is worthy of the fool in the old story who resolved not to go into the water till he had learned to swim."
  },
  {
    "author": "William Gilbert",
    "category": "politics",
    "id": 54950,
    "text": "I always voted at my party's call, and I never thought of thinking for myself at all."
  },
  {
    "author": "Henry Cabot Lodge, Jr.",
    "category": "politics",
    "id": 54962,
    "text": "It has been well said that a hungry man is more interested in four sandwiches than four freedoms."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "politics",
    "id": 55086,
    "text": "Nothing is so admirable in politics as a short memory."
  },
  {
    "author": "Imran Khan",
    "category": "politics",
    "id": 55412,
    "text": "There can only be democracy when money is not allowed to be spent in Politics."
  },
  {
    "author": "Jane Austen",
    "category": "politics",
    "id": 55090,
    "text": "From politics, it was an easy step to silence."
  },
  {
    "author": "Dick Gregory",
    "category": "politics",
    "id": 54863,
    "text": "In most places in the country, voting is looked upon as a right and a duty, but in Chicago it's a sport."
  },
  {
    "author": "George Will",
    "category": "politics",
    "id": 55559,
    "text": "Politics should share one purpose with religion: the steady emancipation of the individual through the education of his passions."
  },
  {
    "author": "Margaret Thatcher",
    "category": "politics",
    "id": 55017,
    "text": "One of the things being in politics has taught me is that men are not a reasoned or reasonable sex."
  },
  {
    "author": "Kevin Costner",
    "category": "politics",
    "id": 55293,
    "text": "I believe people who go into politics want to do the right thing. And then they hit a big wall of re-election and the pettiness of politics. In the end, politics gets in the way of the business of people."
  },
  {
    "author": "Sonny Perdue",
    "category": "politics",
    "id": 55771,
    "text": "I call it people-to-people politics and that's what politics should be about, reaching out and helping one another and touching one another about what we're going to do."
  },
  {
    "author": "Aesop",
    "category": "politics",
    "id": 54831,
    "text": "We hang the petty thieves and appoint the great ones to public office."
  },
  {
    "author": "Ian Mcewan",
    "category": "politics",
    "id": 55521,
    "text": "London in the '70s was a pretty catastrophic dump, I can tell you. We had every kind of industrial trouble we had severe energy problems we were under constant terrorist attack from Irish terrorist groups who started a bombing campaign in English cities politics were fantastically polarized between left and right."
  },
  {
    "author": "Catherine the Great",
    "category": "politics",
    "id": 55480,
    "text": "In politics a capable ruler must be guided by circumstances, conjectures and conjunctions."
  },
  {
    "author": "Ralph Nader",
    "category": "politics",
    "id": 55142,
    "text": "The 'democracy gap' in our politics and elections spells a deep sense of powerlessness by people who drop out, do not vote, or listlessly vote for the 'least worst' every four years and then wonder why after every cycle the 'least worst' gets worse."
  },
  {
    "author": "David Attenborough",
    "category": "politics",
    "id": 55243,
    "text": "I'm not in politics."
  },
  {
    "author": "Daniel J. Boorstin",
    "category": "politics",
    "id": 54893,
    "text": "As you make your bed, so you must lie in it."
  },
  {
    "author": "Moira Kelly",
    "category": "politics",
    "id": 55693,
    "text": "I think to be in politics you have to have the taste for blood on that."
  },
  {
    "author": "Ridley Scott",
    "category": "politics",
    "id": 55602,
    "text": "Politics is very interesting and always leads to conflict."
  },
  {
    "author": "Recep Tayyip Erdogan",
    "category": "politics",
    "id": 55699,
    "text": "As a politician who cherishes religious conviction in his personal sphere, but regards politics as a domain belonging outside religion, I believe that this view is seriously flawed."
  },
  {
    "author": "Laura Ingraham",
    "category": "politics",
    "id": 55617,
    "text": "There's a rule of thumb in politics. If you're at a point where you're complaining about the other guy being mean and unfair and uncivil, that's probably a sign that you're losing."
  },
  {
    "author": "Dennis Kucinich",
    "category": "politics",
    "id": 55543,
    "text": "My philosophy comes from a worldview that looks at the world as one. It's a holistic view that sees the world as interconnected and interdependent and integrated in so many different ways, which informs my politics."
  },
  {
    "author": "Paul Wellstone",
    "category": "politics",
    "id": 55072,
    "text": "A politics that is not sensitive to the concerns and circumstances of people's lives, a politics that does not speak to and include people, is an intellectually arrogant politics that deserves to fail."
  },
  {
    "author": "Ed Gillespie",
    "category": "politics",
    "id": 55739,
    "text": "I think Karl Rove saw that in George W. Bush early on and understood the impact that he could have on Texas politics and probably on national politics."
  },
  {
    "author": "Carly Fiorina",
    "category": "politics",
    "id": 55187,
    "text": "I think what's fascinating is how many people are playing in politics who maybe haven't played before."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "politics",
    "id": 54922,
    "text": "In politics, what begins in fear usually ends in failure."
  },
  {
    "author": "Charles Kennedy",
    "category": "politics",
    "id": 55624,
    "text": "The one thing we can all be sure about in politics is you are as well to expect the unexpected."
  },
  {
    "author": "Adlai E. Stevenson",
    "category": "politics",
    "id": 54818,
    "text": "I have been thinking that I would make a proposition to my Republican friends... that if they will stop telling lies about the Democrats, we will stop telling the truth about them."
  },
  {
    "author": "Jesse Jackson",
    "category": "politics",
    "id": 55256,
    "text": "In politics, an organized minority is a political majority."
  },
  {
    "author": "Nick Clegg",
    "category": "politics",
    "id": 55453,
    "text": "What I hope is in five years' time, I can go to the British people in the election and say: Lots of you doubted that coalition politics worked, but it has worked."
  },
  {
    "author": "Glenn Beck",
    "category": "politics",
    "id": 55217,
    "text": "I don't fancy myself a political commentator. I hate politics. I hate it."
  },
  {
    "author": "Edmund Burke",
    "category": "politics",
    "id": 55052,
    "text": "Politics and the pulpit are terms that have little agreement."
  },
  {
    "author": "Frank Luntz",
    "category": "politics",
    "id": 55636,
    "text": "The challenge in working in politics, particularly if you're working for a political party, is that everyone's a messenger."
  },
  {
    "author": "Vince Cable",
    "category": "politics",
    "id": 55489,
    "text": "And humility in politics means accepting that one party doesn't have all the answers recognising that working in partnership is progress not treachery."
  },
  {
    "author": "Karl Von Clausewitz",
    "category": "politics",
    "id": 55229,
    "text": "Politics is the womb in which war develops."
  },
  {
    "author": "James Bovard",
    "category": "politics",
    "id": 55698,
    "text": "It is important to recognize and politics positive thinking is often the slaves' virtue - something that people do to con themselves about the burden and change being placed upon them."
  },
  {
    "author": "Charles Kennedy",
    "category": "politics",
    "id": 55519,
    "text": "Politics is much too serious to be taken too seriously equally, there are many aspects of it so laughable as to be lamentable."
  },
  {
    "author": "Eric Alterman",
    "category": "politics",
    "id": 55398,
    "text": "The ability of the 1 percent to buy politicians and regulators is nothing new in American politics - just as inequality has been a permanent part of our economic system. This is true of virtually all political and economic systems."
  },
  {
    "author": "Leo Rosten",
    "category": "politics",
    "id": 54911,
    "text": "A conservative is one who admires radicals centuries after they're dead."
  },
  {
    "author": "Georgios A. Papandreou",
    "category": "politics",
    "id": 55168,
    "text": "I never thought of politics as a profession."
  },
  {
    "author": "Damon Albarn",
    "category": "politics",
    "id": 55717,
    "text": "I'm not really one of those people who believes that if you're a musician you can just leave that behind and start getting into politics."
  },
  {
    "author": "Andrew Cuomo",
    "category": "politics",
    "id": 55383,
    "text": "Very few people go into politics to be reviled."
  },
  {
    "author": "Garry Trudeau",
    "category": "politics",
    "id": 55719,
    "text": "When you're young, with less on the line, it's easier to be audacious, to experiment. So I introduced the concerns of my generation - politics, sex, drugs, rock-and-roll, etc. - to the comics page, which for many years caused a rolling furor."
  },
  {
    "author": "Barbara Bush",
    "category": "politics",
    "id": 54871,
    "text": "You may think the president is all-powerful, but he is not. He needs a lot of guidance from the Lord."
  },
  {
    "author": "Louis D. Brandeis",
    "category": "politics",
    "id": 54912,
    "text": "The most important political office is that of the private citizen."
  },
  {
    "author": "Pope John Paul II",
    "category": "politics",
    "id": 54850,
    "text": "Radical changes in world politics leave America with a heightened responsibility to be, for the world, an example of a genuinely free, democratic, just and humane society."
  },
  {
    "author": "James Carville",
    "category": "politics",
    "id": 55622,
    "text": "I think Ralph Nader is the biggest liar in American politics when he said it didn't matter who was president."
  },
  {
    "author": "Kathleen Turner",
    "category": "politics",
    "id": 55605,
    "text": "I'm not very active politically. The causes I work on offer immediate, practical, accessible help, and politics has never meant that to me."
  },
  {
    "author": "Ross Perot",
    "category": "politics",
    "id": 55055,
    "text": "War has rules, mud wrestling has rules - politics has no rules."
  },
  {
    "author": "Thomas Frank",
    "category": "politics",
    "id": 55248,
    "text": "Acknowledging class was always difficult for 'New Democrats' - it was second-wave, it was divisive - but 2008 made retro politics cool again."
  },
  {
    "author": "John Major",
    "category": "politics",
    "id": 55514,
    "text": "Of course there are regrets. I shall regret always that I found my own authentic voice in politics. I was too conservative, too conventional. Too safe, too often. Too defensive. Too reactive. Later, too often on the back foot."
  },
  {
    "author": "Muqtada al Sadr",
    "category": "politics",
    "id": 55407,
    "text": "I am a part of the political process whether the multinational forces are present or not. Politics is serving the people, not chairs and positions."
  },
  {
    "author": "Corazon Aquino",
    "category": "politics",
    "id": 55618,
    "text": "I know my limitations, and I don't like politics. I was only involved because of my husband."
  },
  {
    "author": "Sophia Bush",
    "category": "politics",
    "id": 55352,
    "text": "The more that I know of politics, the more it makes me realize that being a politician is largely useless."
  },
  {
    "author": "Eric Liu",
    "category": "politics",
    "id": 55483,
    "text": "Talk of citizenship today is often thin and tinny. The word has a faintly old-fashioned feel to it when used in everyday conversation. When evoked in national politics, it's usually accompanied by the shrill whine of a descending culture-war mortar."
  },
  {
    "author": "Clarence Darrow",
    "category": "politics",
    "id": 54866,
    "text": "When I was a boy I was told that anybody could become President I'm beginning to believe it."
  },
  {
    "author": "Alexander Hamilton",
    "category": "politics",
    "id": 54803,
    "text": "Those who stand for nothing fall for anything."
  },
  {
    "author": "Tony Kushner",
    "category": "politics",
    "id": 55461,
    "text": "I don't feel, finally, that my politics are entirely determined by the fact that I'm a gay man."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "politics",
    "id": 55051,
    "text": "My objection to Liberalism is this that it is the introduction into the practical business of life of the highest kind namely, politics of philosophical ideas instead of political principles."
  }
]

quotes['positive'] = [
  {
    "author": "Roy H. Williams",
    "category": "positive",
    "id": 56040,
    "text": "One thing that hasn't changed, though, is that we still have to hear the new ad 2 or 3 times before it begins to affect us, even when we're already familiar with the advertiser in question and have a positive opinion of them."
  },
  {
    "author": "Kyan Douglas",
    "category": "positive",
    "id": 56242,
    "text": "I've tried to take the opportunity to be as positive a person as I can be, as positive role model as I can be."
  },
  {
    "author": "Ian Williams",
    "category": "positive",
    "id": 56323,
    "text": "We made happy sounds because we were upset... just trying to make a positive situation out of a negative one."
  },
  {
    "author": "Keith Emerson",
    "category": "positive",
    "id": 56167,
    "text": "We manage to bounce ideas off one another. Every band fights, but at the end of the day, we're very positive about the way we fight. At least we come out with a result."
  },
  {
    "author": "Arthur Smith",
    "category": "positive",
    "id": 56031,
    "text": "I've noticed that my resolutions involve me not doing stuff that I wasn't going to do anyway so here's something more positive. I'm going to retrain as a Latin teacher in a provincial public school."
  },
  {
    "author": "Godfrey Reggio",
    "category": "positive",
    "id": 56086,
    "text": "But in fact if you look at film as a metaphor, only through the negative can you have the positive print. What I'm trying to get to is the positive value of negation."
  },
  {
    "author": "Vince Cable",
    "category": "positive",
    "id": 56036,
    "text": "I think what is happening is I think first of all there is confidence in the U.K. economy. We're in a German rather than a Greek position in international financial markets, which is very positive and keeps our debt service costs down, and we're also beginning to see real evidence of rebalancing."
  },
  {
    "author": "Krist Novoselic",
    "category": "positive",
    "id": 56169,
    "text": "We asserted ourselves as a music community, and showed legislators that music is positive. Especially if you've sold 300 million records worldwide and pay taxes."
  },
  {
    "author": "Jose Saramago",
    "category": "positive",
    "id": 55896,
    "text": "I never appreciated 'positive heroes' in literature. They are almost always cliches, copies of copies, until the model is exhausted. I prefer perplexity, doubt, uncertainty, not just because it provides a more 'productive' literary raw material, but because that is the way we humans really are."
  },
  {
    "author": "W. Clement Stone",
    "category": "positive",
    "id": 55850,
    "text": "There is little difference in people, but that little difference makes a big difference. The little difference is attitude. The big difference is whether it is positive or negative."
  },
  {
    "author": "Bill Parcells",
    "category": "positive",
    "id": 56056,
    "text": "If I have affected someone in a positive way, that means a lot to me."
  },
  {
    "author": "Mark E. Hyman",
    "category": "positive",
    "id": 56302,
    "text": "The news is what it is. It's going to be good, it's going to be positive, it's going to be negative. It's going to have all sorts of effects on candidates always."
  },
  {
    "author": "Martin Yan",
    "category": "positive",
    "id": 55840,
    "text": "Some people never contribute anything positive to society, they may even drain our resources, but most of us try to do something better, to give back."
  },
  {
    "author": "Jerry Kramer",
    "category": "positive",
    "id": 56333,
    "text": "College was especially sweet because of the positive, hopeful atmosphere of a college campus."
  },
  {
    "author": "Rick Larsen",
    "category": "positive",
    "id": 56236,
    "text": "We need a positive economic agenda that invests in the innovation and growth that will create jobs for middle class families and ensure that America remains the world leader."
  },
  {
    "author": "Yani Tseng",
    "category": "positive",
    "id": 56026,
    "text": "I will keep smiling, be positive and never give up! I will give 100 percent each time I play. These are always my goals and my attitude."
  },
  {
    "author": "Luther Allison",
    "category": "positive",
    "id": 56199,
    "text": "I think I'm the most positive guy still going in my generation, and I'm out there to prove that."
  },
  {
    "author": "George Crook",
    "category": "positive",
    "id": 56292,
    "text": "It demonstrates to his simple mind in the most positive manner that we have no prejudice against him on account of his race, and that while he behaves himself he will be treated the same as a white man."
  },
  {
    "author": "Isaiah Berlin",
    "category": "positive",
    "id": 55907,
    "text": "Injustice, poverty, slavery, ignorance - these may be cured by reform or revolution. But men do not live only by fighting evils. They live by positive goals, individual and collective, a vast variety of them, seldom predictable, at times incompatible."
  },
  {
    "author": "Genevieve Gorder",
    "category": "positive",
    "id": 56166,
    "text": "I had the idea for the show like a year and a half, two years ago. And it was all about the things that I didn't like about TV. I was trying to create a positive solution for it. And it actually worked."
  },
  {
    "author": "Sienna Miller",
    "category": "positive",
    "id": 55945,
    "text": "Everyone in L.A. is very positive and upbeat, whereas London can get quite miserable at times."
  },
  {
    "author": "Gil Scott-Heron",
    "category": "positive",
    "id": 56055,
    "text": "Everything that's bad for you catches on too quickly in America, because that's the easiest thing to get people to invest in, the pursuits that are easy and destructive, the ones that bring out the least positive aspects of people."
  },
  {
    "author": "Keith Haring",
    "category": "positive",
    "id": 56253,
    "text": "Shapes that contain no inner components of positive/negative relationships will function better with other shapes of the same nature."
  },
  {
    "author": "Jake Owen",
    "category": "positive",
    "id": 56250,
    "text": "I think if you just look at life in a positive way, positive things will happen."
  },
  {
    "author": "Christopher Dawson",
    "category": "positive",
    "id": 56133,
    "text": "Moreover, behind this vague tendency to treat religion as a side issue in modern life, there exists a strong body of opinion that is actively hostile to Christianity and that regards the destruction of positive religion as absolutely necessary to the advance of modern culture."
  },
  {
    "author": "Eddie Izzard",
    "category": "positive",
    "id": 55981,
    "text": "I just believe in the goodwill of people, the power of people to do something positive."
  },
  {
    "author": "Dalai Lama",
    "category": "positive",
    "id": 55785,
    "text": "In order to carry a positive action we must develop here a positive vision."
  },
  {
    "author": "Gray Davis",
    "category": "positive",
    "id": 56241,
    "text": "I don't know why they're doing it. I have to assume that their motives are positive, not negative. But they don't understand the severity of the problem in this state."
  },
  {
    "author": "Emma Bonino",
    "category": "positive",
    "id": 56074,
    "text": "I am positive that flexibility is a feminine characteristic."
  },
  {
    "author": "Alexander McCall Smith",
    "category": "positive",
    "id": 56070,
    "text": "My Botswana books are positive, and I've never really sought to deny that. They are positive. They present a very positive picture of the country. And I think that that is perfectly defensible given that there is so much written about Africa which is entirely negative."
  },
  {
    "author": "Brian Littrell",
    "category": "positive",
    "id": 56368,
    "text": "I've received a lot of positive feedback from both the secular and Christian markets. People seem to be receiving it with open arms and hearts, and are interested in the stories I want to share about my relationship with God and my faith."
  },
  {
    "author": "Franz Beckenbauer",
    "category": "positive",
    "id": 56228,
    "text": "At any rate, I can only see such a success having positive effects for everyone, particularly as our anticipation of the World cup would only increase further."
  },
  {
    "author": "Ron Fournier",
    "category": "positive",
    "id": 55950,
    "text": "Political consultants are pugilists, masters in the dark art of negativity. Which is why it's surprising to hear Democrats such as Steve McMahon and Republicans like Rich Galen urging their presidential candidates to be more, well, positive."
  },
  {
    "author": "Betty White",
    "category": "positive",
    "id": 55963,
    "text": "I'm a big cockeyed optimist. I try to accentuate the positive as opposed to the negative."
  },
  {
    "author": "Tiger Woods",
    "category": "positive",
    "id": 55807,
    "text": "If you are given a chance to be a role model, I think you should always take it because you can influence a person's life in a positive light, and that's what I want to do. That's what it's all about."
  },
  {
    "author": "Rob McKenna",
    "category": "positive",
    "id": 56370,
    "text": "Washington State has a strong tradition of a positive relationship - positive working relationship between labor and management, whether in the private sector or the public sector. It needs to continue to be that way."
  },
  {
    "author": "Taryn Manning",
    "category": "positive",
    "id": 56156,
    "text": "The Wreckoning is a darker song. But the record is positive."
  },
  {
    "author": "Eric Liu",
    "category": "positive",
    "id": 55989,
    "text": "We tend to think of politics as bad, full of dirty tricks, negative ads, big campaigns, but I am here to explore the original meaning of politics, which is positive and has to do with balancing competing interests and looking for solutions."
  },
  {
    "author": "Marco Rubio",
    "category": "positive",
    "id": 55917,
    "text": "We should be the pro-legal immigration party. A party that has a positive platform and agenda on how we can create a legal immigration system that works for immigrants and works for America."
  },
  {
    "author": "Emmet Fox",
    "category": "positive",
    "id": 55802,
    "text": "You must not under any pretense allow your mind to dwell on any thought that is not positive, constructive, optimistic, kind."
  },
  {
    "author": "Debbie Macomber",
    "category": "positive",
    "id": 56350,
    "text": "In my books and in romance as a genre, there is a positive, uplifting feeling that leaves the reader with a sense of encouragement and hope for a brighter future - or a brighter present."
  },
  {
    "author": "Garrett Hedlund",
    "category": "positive",
    "id": 56090,
    "text": "You might think the thinner version of yourself is going to be the most positive or confident, but that's not how it is for me. When I'm over 200 pounds, that's when I'm the most confident version of myself."
  },
  {
    "author": "Rainn Wilson",
    "category": "positive",
    "id": 56035,
    "text": "I really wanted to do something positive on the Internet. I wanted to try to get young people talking about, thinking about, life's big questions-make it cool and OK to wonder about the heart, the soul and free will and God and death and big topics like that, big human topics."
  },
  {
    "author": "Albert Einstein",
    "category": "positive",
    "id": 55778,
    "text": "The gift of fantasy has meant more to me than my talent for absorbing positive knowledge."
  },
  {
    "author": "Miley Cyrus",
    "category": "positive",
    "id": 55873,
    "text": "You can't live a positive life with a negative mind and if you have a positive outcome you have a positive income and just to have more positivity and just to kind of laugh it off."
  },
  {
    "author": "Kim Stanley Robinson",
    "category": "positive",
    "id": 56065,
    "text": "If the amount of money going into the war economy were invested in landscape restoration, we would be in a far more positive position. It may get a little dire before we pull together, but I think when the prosperous nations, and in particular the U.S., realize they're wrecking their own kids' lives, there will be a mass change in value."
  },
  {
    "author": "Terence Stamp",
    "category": "positive",
    "id": 56193,
    "text": "Peter Ustinov was the first really positive influence in my career. He was real and he bore witness to it. The things he said to you, he lived them."
  },
  {
    "author": "Gianni Versace",
    "category": "positive",
    "id": 56102,
    "text": "I want always to be positive."
  },
  {
    "author": "Casey Kasum",
    "category": "positive",
    "id": 56334,
    "text": "I'd like to feel that an advertiser gets something extra when they advertise with us - a certain humanity that comes from upbeat and positive human interest letters and success stories."
  },
  {
    "author": "David Strathairn",
    "category": "positive",
    "id": 56298,
    "text": "So much money and energy is expended making a film that I think it should be used for positive ends."
  },
  {
    "author": "Greg Rusedski",
    "category": "positive",
    "id": 56324,
    "text": "My biggest problem will be lack of match toughness but I am a positive, optimistic person."
  },
  {
    "author": "Michael K. Williams",
    "category": "positive",
    "id": 56225,
    "text": "Revenge is not a positive state of mind or energy to indulge your self in."
  },
  {
    "author": "Imelda Staunton",
    "category": "positive",
    "id": 55814,
    "text": "Chaotic people often have chaotic lives, and I think they create that. But if you try and have an inner peace and a positive attitude, I think you attract that."
  },
  {
    "author": "Reba McEntire",
    "category": "positive",
    "id": 55971,
    "text": "The upside to anger? Getting it out of your system. You got to express your anger. Then you have room for more positive things. If I hold something in a long time, and then I speak it, it's amazing how the light shines so much brighter."
  },
  {
    "author": "Walter Rudolf Hess",
    "category": "positive",
    "id": 56365,
    "text": "The only positive finding which could be drawn from the first series, was the conclusion that the relationships obviously had a more complicated lay-out than had been thought, for the effects were so varied that no obedience to any law could be discovered."
  },
  {
    "author": "Kristi Yamaguchi",
    "category": "positive",
    "id": 55842,
    "text": "Having achieved my own dreams, I want to give to kids who are less fortunate, who struggle with everyday obstacles. I want to give them something positive in their lives: support."
  },
  {
    "author": "Gabriela Sabatini",
    "category": "positive",
    "id": 56164,
    "text": "Tennis has had a very positive impact on my life."
  },
  {
    "author": "John Clayton",
    "category": "positive",
    "id": 55897,
    "text": "Christians were instructed to serve others, and the thanksgiving was for the grace of God and the fact that God offered a way for man to return to a positive relationship with Him."
  },
  {
    "author": "Garrett Hardin",
    "category": "positive",
    "id": 55941,
    "text": "Of course, a positive growth rate might be taken as evidence that a population is below its optimum."
  },
  {
    "author": "Laurel Clark",
    "category": "positive",
    "id": 56155,
    "text": "I feel blessed to be here representing our country and carrying out th research of scientists around the world... I hope you could feel the positive energy that beamed to the whole planet as we glided over."
  },
  {
    "author": "Taye Diggs",
    "category": "positive",
    "id": 56177,
    "text": "The large ensemble cast and the fact that it was being shot in New York, combined with a lot of strong positive images as far as African Americans are concerned, really turned me on to The Best Man."
  },
  {
    "author": "Rickie Lee Jones",
    "category": "positive",
    "id": 56194,
    "text": "I'm so positive."
  },
  {
    "author": "Mira Sorvino",
    "category": "positive",
    "id": 56159,
    "text": "I want my life to effect the balance to the positive."
  },
  {
    "author": "Dolly Parton",
    "category": "positive",
    "id": 55811,
    "text": "I feel that sin and evil are the negative part of you, and I think it's like a battery: you've got to have the negative and the positive in order to be a complete person."
  },
  {
    "author": "Yao Ming",
    "category": "positive",
    "id": 55841,
    "text": "Fortune cookies are a good idea. If the message is positive, it can make your day a little better."
  },
  {
    "author": "Diane Kruger",
    "category": "positive",
    "id": 55967,
    "text": "Her beauty didn't do her any good and she couldn't use it in any positive way or manipulative way. I just hope that people will look and see and believe in that hope of love, that hope of freedom, even if it was just for a limited time."
  },
  {
    "author": "Lech Walesa",
    "category": "positive",
    "id": 55900,
    "text": "The thing that lies at the foundation of positive change, the way I see it, is service to a fellow human being."
  },
  {
    "author": "Bill Hybels",
    "category": "positive",
    "id": 56293,
    "text": "Those churches have closed down or have been merged with a church that has a more positive vision."
  },
  {
    "author": "Nolan Ryan",
    "category": "positive",
    "id": 56095,
    "text": "And I'm a believer that you take a negative and turn it into a positive, and as it turned out, it was one of the best things that ever happened to me. And so I do appreciate the Ranger staff and the Ranger organization for giving me that opportunity."
  },
  {
    "author": "Cat Cora",
    "category": "positive",
    "id": 56011,
    "text": "I launched Chefs for Humanity, a national nonprofit, with my voice, heart and money from my own pocket. Money gives you the ability to make a difference in the world and, when used in a positive way, is a lot of fun."
  },
  {
    "author": "Peggy Fleming",
    "category": "positive",
    "id": 56163,
    "text": "When the going got tough, I really had to draw on many of the same competitive instincts I did when I was skating. I really had to put my head down and stay positive. I had to fight."
  },
  {
    "author": "Silvan Shalom",
    "category": "positive",
    "id": 56312,
    "text": "We would like to ease the life of the Palestinians. I prepared a new plan that we call a positive agenda."
  },
  {
    "author": "Ambrose Bierce",
    "category": "positive",
    "id": 55875,
    "text": "To be positive is to be mistaken at the top of one's voice."
  },
  {
    "author": "W. Clement Stone",
    "category": "positive",
    "id": 55788,
    "text": "Like success, failure is many things to many people. With Positive Mental Attitude, failure is a learning experience, a rung on the ladder, a plateau at which to get your thoughts in order and prepare to try again."
  },
  {
    "author": "Paul Feig",
    "category": "positive",
    "id": 56042,
    "text": "At the end of the day the question comes, what are you doing for the world? You have to try to do something that's going to add something positive."
  },
  {
    "author": "Parminder Nagra",
    "category": "positive",
    "id": 56247,
    "text": "If I can inspire someone to go in a positive way and pursue a dream, it can only be good."
  },
  {
    "author": "Daniel Johns",
    "category": "positive",
    "id": 55992,
    "text": "I try to stay positive by focusing on how much I'll appreciate my health if I get better."
  },
  {
    "author": "Michel Martelly",
    "category": "positive",
    "id": 56262,
    "text": "When I was campaigning, I told the people if nothing happens under my mandate it will still be a positive thing because my mandate will be used as a rupture between the past and the future."
  },
  {
    "author": "George Saunders",
    "category": "positive",
    "id": 55994,
    "text": "If you think of a work of fiction as a kind of scale model of the world, then the positive valences - where things turn out better than you thought they would - ought to be in there somewhere, too."
  },
  {
    "author": "Queen Latifah",
    "category": "positive",
    "id": 55818,
    "text": "Look at people for an example, but then make sure to do things your way. Surround yourself with positive people."
  },
  {
    "author": "Tim Reid",
    "category": "positive",
    "id": 56366,
    "text": "When the media defines something, you have to question: Is it the definition that you want applied to your culture? I'm trying to determine who's leaving the legacy, and if the legacy that is being left is a positive one."
  },
  {
    "author": "Noam Chomsky",
    "category": "positive",
    "id": 55908,
    "text": "The internet could be a very positive step towards education, organisation and participation in a meaningful society."
  },
  {
    "author": "Alan Cumming",
    "category": "positive",
    "id": 56082,
    "text": "So the experts think we could have an AIDS-free generation in Africa by 2015, even if the mothers are positive."
  },
  {
    "author": "Amanda Seyfried",
    "category": "positive",
    "id": 55957,
    "text": "I love acting like I'm in love. It's a very positive thing."
  },
  {
    "author": "Tia Carrere",
    "category": "positive",
    "id": 56083,
    "text": "I'm concentrating on the positive, on all the wonderful things I'm doing now."
  },
  {
    "author": "Thad Cochran",
    "category": "positive",
    "id": 56343,
    "text": "Well, I think the president is going to do well in terms of his influence for positive change here in the Congress, making sure that we don't overspend, making sure that we spend for only those programs that are justified."
  },
  {
    "author": "B. F. Skinner",
    "category": "positive",
    "id": 55829,
    "text": "The way positive reinforcement is carried out is more important than the amount."
  },
  {
    "author": "Pablo Picasso",
    "category": "positive",
    "id": 55863,
    "text": "Every positive value has its price in negative terms... the genius of Einstein leads to Hiroshima."
  },
  {
    "author": "Maurice Ashley",
    "category": "positive",
    "id": 56376,
    "text": "His tenacity is unmatched in my opinion. Incredible how someone could have suffered that long and come back out of prison with such a good heart and positive things to say and do."
  },
  {
    "author": "Shailene Woodley",
    "category": "positive",
    "id": 56117,
    "text": "I would like to do something dark or small. I love independent films. I love emotional scenes. I love people who are struggling with something. I think it's just the juxtaposition to my incredibly happy, positive demeanor."
  },
  {
    "author": "Vince Neil",
    "category": "positive",
    "id": 56352,
    "text": "I appreciate the 'Surreal Life.' I had a really positive experience on that show, and with those people. I found some love in my heart for religion again, and had the support of a new family of friends. I wouldn't have had the pleasure of meeting those people, if we were not all placed in that fishbowl."
  },
  {
    "author": "Brad Paisley",
    "category": "positive",
    "id": 56060,
    "text": "It comes down to building your own world out here on the road. It's who you surround yourself with. My band and crew are really positive guys."
  },
  {
    "author": "John Thune",
    "category": "positive",
    "id": 56275,
    "text": "Let's not dismiss or attack individual ideas as being inadequate before we have had a chance to assess their positive effect as part of a whole solution."
  },
  {
    "author": "Rory McIlroy",
    "category": "positive",
    "id": 56093,
    "text": "Since turning professional at 18, I have travelled the world playing the game that I love and consider myself a global player. As the World No.1 right now, I wish to be a positive role model and a sportsperson that people respect, and enjoy watching."
  },
  {
    "author": "Yannick Noah",
    "category": "positive",
    "id": 55792,
    "text": "I believe in Karma. If the good is sown, the good is collected. When positive things are made, that returns well."
  },
  {
    "author": "Mark Feuerstein",
    "category": "positive",
    "id": 56360,
    "text": "I just recently joined Twitter. It's very positive - I love all the accolades. If my ego is hurting, I can just open my Twitter account and see 'Oh, I love you! I love the show!' and it's great. I'm trying to find the balance between trying to be funny, being honest and just being a promoter as the guy on 'Royal Pains.'"
  },
  {
    "author": "Ian Somerhalder",
    "category": "positive",
    "id": 55929,
    "text": "I can't let time move on without fighting tooth and nail and hopefully being a part of a revolution that is positive."
  },
  {
    "author": "Sue Wicks",
    "category": "positive",
    "id": 56182,
    "text": "I was very pleased that the positive things about me and my game outshone the aggressive style of play I use. I would never tone that down, because I believe in that style of play, and I believe that you can play rough on the court and still be a good sport."
  },
  {
    "author": "Ashlee Simpson",
    "category": "positive",
    "id": 56181,
    "text": "I took some me time. I think that's a really important thing to do for yourself, especially in this business. And now I feel like I'm in a really good, positive place in my life."
  },
  {
    "author": "Feist",
    "category": "positive",
    "id": 56138,
    "text": "Any kind of anthemic song, for the most part, they're on the positive side of things. It's not hard to identify when a melody is just one degree too complicated or one degree too simple and where that line of pop memorability lies."
  }
]

quotes['power'] = [
  {
    "author": "George A. Smith",
    "category": "power",
    "id": 57163,
    "text": "Our enemies are our evil deeds and their memories, our pride, our selfishness, our malice, our passions, which by conscience or by habit pursue us with a relentlessness past the power of figure to express."
  },
  {
    "author": "Thomas Carlyle",
    "category": "power",
    "id": 56717,
    "text": "Wondrous is the strength of cheerfulness, and its power of endurance - the cheerful man will do more in the same time, will do it better, will preserve it longer, than the sad or sullen."
  },
  {
    "author": "Voltaire",
    "category": "power",
    "id": 56666,
    "text": "The truths of religion are never so well understood as by those who have lost the power of reason."
  },
  {
    "author": "Sydney J. Harris",
    "category": "power",
    "id": 56746,
    "text": "If a small thing has the power to make you angry, does that not indicate something about your size?"
  },
  {
    "author": "Josh Billings",
    "category": "power",
    "id": 56935,
    "text": "There's a great power in words, if you don't hitch too many of them together."
  },
  {
    "author": "Jackie Kennedy",
    "category": "power",
    "id": 56895,
    "text": "There are two kinds of women, those who want power in the world and those who want power in bed."
  },
  {
    "author": "Stephen Hawking",
    "category": "power",
    "id": 56834,
    "text": "I would like nuclear fusion to become a practical power source. It would provide an inexhaustible supply of energy, without pollution or global warming."
  },
  {
    "author": "Jonathan Safran Foer",
    "category": "power",
    "id": 57398,
    "text": "We say no to lots of things that would please us. I would like to punch people every now and then, but I don't. I would like to have something for free rather than pay for it. I would like to skip to the front of the line... I don't mean to brush aside the taste of meat, which is a powerful attraction. But its power is not without limit."
  },
  {
    "author": "Louise Slaughter",
    "category": "power",
    "id": 57239,
    "text": "This House cannot function without an open, accountable, and independent ethics process and the molestation of that process by the majority is an abuse of power that cannot stand."
  },
  {
    "author": "John Ruskin",
    "category": "power",
    "id": 56823,
    "text": "The strength and power of a country depends absolutely on the quantity of good men and women in it."
  },
  {
    "author": "Marianne Williamson",
    "category": "power",
    "id": 56665,
    "text": "In every community, there is work to be done. In every nation, there are wounds to heal. In every heart, there is the power to do it."
  },
  {
    "author": "Rush Limbaugh",
    "category": "power",
    "id": 57009,
    "text": "We are born to action and whatever is capable of suggesting and guiding action has power over us from the first."
  },
  {
    "author": "Hillary Clinton",
    "category": "power",
    "id": 56712,
    "text": "'Smart power' is the use of American power in ways that would help prevent and resolve conflict - not just send our military in."
  },
  {
    "author": "Patricia Cornwell",
    "category": "power",
    "id": 57001,
    "text": "I believe the root of all evil is abuse of power."
  },
  {
    "author": "George Bernard Shaw",
    "category": "power",
    "id": 56622,
    "text": "She had lost the art of conversation but not, unfortunately, the power of speech."
  },
  {
    "author": "Pierre Corneille",
    "category": "power",
    "id": 57255,
    "text": "Master of the universe but not of myself, I am the only rebel against my absolute power."
  },
  {
    "author": "Lord Acton",
    "category": "power",
    "id": 56798,
    "text": "And remember, where you have a concentration of power in a few hands, all too frequently men with the mentality of gangsters get control. History has proven that."
  },
  {
    "author": "Paul Wellstone",
    "category": "power",
    "id": 57270,
    "text": "The American polity is infected with a serious imbalance of power between elites and masses, a power which is the principal threat to our democracy."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "power",
    "id": 56934,
    "text": "A bad book is the worse that it cannot repent. It has not been the devil's policy to keep the masses of mankind in ignorance but finding that they will read, he is doing all in his power to poison their books."
  },
  {
    "author": "William Wordsworth",
    "category": "power",
    "id": 56452,
    "text": "Getting and spending, we lay waste our powers."
  },
  {
    "author": "Douglas MacArthur",
    "category": "power",
    "id": 56914,
    "text": "Always there has been some terrible evil at home or some monstrous foreign power that was going to gobble us up if we did not blindly rally behind it."
  },
  {
    "author": "Peter Drucker",
    "category": "power",
    "id": 56794,
    "text": "Suppliers and especially manufacturers have market power because they have information about a product or a service that the customer does not and cannot have, and does not need if he can trust the brand. This explains the profitability of brands."
  },
  {
    "author": "Thomas Frank",
    "category": "power",
    "id": 57325,
    "text": "There is much to dislike about President Obama's approach to the financial crisis. But opposition, it seems, will have to come from somewhere other than conservatism. The party out of power is also a party out of touch."
  },
  {
    "author": "Voltaire",
    "category": "power",
    "id": 56552,
    "text": "Anyone who has the power to make you believe absurdities has the power to make you commit injustices."
  },
  {
    "author": "Margaret Cho",
    "category": "power",
    "id": 57191,
    "text": "The power of visibility can never be underestimated."
  },
  {
    "author": "Ken Blanchard",
    "category": "power",
    "id": 56752,
    "text": "In the past a leader was a boss. Today's leaders must be partners with their people... they no longer can lead solely based on positional power."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "power",
    "id": 56788,
    "text": "No man deserves to be praised for his goodness, who has it not in his power to be wicked. Goodness without that power is generally nothing more than sloth, or an impotence of will."
  },
  {
    "author": "David Bailey",
    "category": "power",
    "id": 57189,
    "text": "The best advice I ever got was that knowledge is power and to keep reading."
  },
  {
    "author": "Mary Wollstonecraft",
    "category": "power",
    "id": 56977,
    "text": "If women be educated for dependence that is, to act according to the will of another fallible being, and submit, right or wrong, to power, where are we to stop?"
  },
  {
    "author": "Georg Wilhelm Friedrich Hegel",
    "category": "power",
    "id": 57154,
    "text": "Mere goodness can achieve little against the power of nature."
  },
  {
    "author": "Barbara de Angelis",
    "category": "power",
    "id": 56421,
    "text": "No one is in control of your happiness but you therefore, you have the power to change anything about yourself or your life that you want to change."
  },
  {
    "author": "Andrew Jackson",
    "category": "power",
    "id": 57076,
    "text": "It was settled by the Constitution, the laws, and the whole practice of the government that the entire executive power is vested in the President of the United States."
  },
  {
    "author": "Peter Drucker",
    "category": "power",
    "id": 56730,
    "text": "Rank does not confer privilege or give power. It imposes responsibility."
  },
  {
    "author": "Sherri Shepherd",
    "category": "power",
    "id": 57382,
    "text": "I am on the power toothbrush train and I'm asking people to try to using an Oral B power toothbrush. I just started using one and I cannot believe that I waited this long to use a power toothbrush. It's so much easier than using a manual toothbrush."
  },
  {
    "author": "Winston Churchill",
    "category": "power",
    "id": 56559,
    "text": "The power of an air force is terrific when there is nothing to oppose it."
  },
  {
    "author": "Mary McLeod Bethune",
    "category": "power",
    "id": 56887,
    "text": "We have a powerful potential in out youth, and we must have the courage to change old ideas and practices so that we may direct their power toward good ends."
  },
  {
    "author": "John Acton",
    "category": "power",
    "id": 57169,
    "text": "Power tends to corrupt, and absolute power corrupts absolutely."
  },
  {
    "author": "Pat Buckley",
    "category": "power",
    "id": 56509,
    "text": "I believe in the power of weakness."
  },
  {
    "author": "Devon Aoki",
    "category": "power",
    "id": 56702,
    "text": "Everyone has their own insecurities, regardless of how you look or how people perceive you, but sometimes people give their insecurities too much power. Defining beauty is simply a matter of opinion. For me, real beauty has very little to do with the structure of someone's face or body."
  },
  {
    "author": "William Henry Harrison",
    "category": "power",
    "id": 57155,
    "text": "There is nothing more corrupting, nothing more destructive of the noblest and finest feelings of our nature, than the exercise of unlimited power."
  },
  {
    "author": "Lao Tzu",
    "category": "power",
    "id": 56544,
    "text": "Mastering others is strength. Mastering yourself is true power."
  },
  {
    "author": "John Podhoretz",
    "category": "power",
    "id": 57240,
    "text": "Making recess appointments when the Senate isn't in recess is neither rational nor moderate. It's a raw misuse of executive power by a president whose love of government is his most vulnerable spot with the electorate."
  },
  {
    "author": "Eleonora Duse",
    "category": "power",
    "id": 57084,
    "text": "If the sight of the blue skies fills you with joy, if a blade of grass springing up in the fields has power to move you, if the simple things of nature have a message that you understand, rejoice, for your soul is alive."
  },
  {
    "author": "Ralph Cudworth",
    "category": "power",
    "id": 57083,
    "text": "Knowledge is not a passion from without the mind, but an active exertion of the inward strength, vigor and power of the mind, displaying itself from within."
  },
  {
    "author": "Muhammad Ali",
    "category": "power",
    "id": 56545,
    "text": "Only a man who knows what it is like to be defeated can reach down to the bottom of his soul and come up with the extra ounce of power it takes to win when the match is even."
  },
  {
    "author": "Simone Weil",
    "category": "power",
    "id": 56984,
    "text": "To get power over is to defile. To possess is to defile."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "power",
    "id": 56609,
    "text": "What is good? All that heightens the feeling of power, the will to power, power itself in man."
  },
  {
    "author": "Bertrand Russell",
    "category": "power",
    "id": 56767,
    "text": "Next to enjoying ourselves, the next greatest pleasure consists in preventing others from enjoying themselves, or, more generally, in the acquisition of power."
  },
  {
    "author": "Epictetus",
    "category": "power",
    "id": 56428,
    "text": "Make the best use of what is in your power, and take the rest as it happens."
  },
  {
    "author": "Orison Swett Marden",
    "category": "power",
    "id": 56686,
    "text": "Nothing else so destroys the power to stand alone as the habit of leaning upon others. If you lean, you will never be strong or original. Stand alone or bury your ambition to be somebody in the world."
  },
  {
    "author": "Kofi Annan",
    "category": "power",
    "id": 56959,
    "text": "Education is a human right with immense power to transform. On its foundation rest the cornerstones of freedom, democracy and sustainable human development."
  },
  {
    "author": "Barack Obama",
    "category": "power",
    "id": 56661,
    "text": "As a nuclear power - as the only nuclear power to have used a nuclear weapon - the United States has a moral responsibility to act."
  },
  {
    "author": "Jean de la Bruyere",
    "category": "power",
    "id": 57110,
    "text": "We should keep silent about those in power to speak well of them almost implies flattery to speak ill of them while they are alive is dangerous, and when they are dead is cowardly."
  },
  {
    "author": "Voltaire",
    "category": "power",
    "id": 56585,
    "text": "Life is thickly sown with thorns, and I know no other remedy than to pass quickly through them. The longer we dwell on our misfortunes, the greater is their power to harm us."
  },
  {
    "author": "Edward G. Bulwer-Lytton",
    "category": "power",
    "id": 57058,
    "text": "Power is so characteristically calm, that calmness in itself has the aspect of strength."
  },
  {
    "author": "Amelia Barr",
    "category": "power",
    "id": 56955,
    "text": "But the lover's power is the poet's power. He can make love from all the common strings with which this world is strung."
  },
  {
    "author": "Noam Chomsky",
    "category": "power",
    "id": 57202,
    "text": "Concentration of executive power, unless it's very temporary and for specific circumstances, let's say fighting world war two, it's an assault on democracy."
  },
  {
    "author": "Napoleon Hill",
    "category": "power",
    "id": 56649,
    "text": "Man, alone, has the power to transform his thoughts into physical reality man, alone, can dream and make his dreams come true."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "power",
    "id": 56742,
    "text": "To be able to endure odium is the first art to be learned by those who aspire to power."
  },
  {
    "author": "Craig T. Nelson",
    "category": "power",
    "id": 57367,
    "text": "The super power that I would choose would be compassion. Because that's what I think it takes to make it through life-an understanding, a give and take. It saves an awful lot of resentment."
  },
  {
    "author": "Albert Einstein",
    "category": "power",
    "id": 56537,
    "text": "The unleashed power of the atom has changed everything save our modes of thinking and we thus drift toward unparalleled catastrophe."
  },
  {
    "author": "Louisa May Alcott",
    "category": "power",
    "id": 56736,
    "text": "We all have our own life to pursue, our own kind of dream to be weaving, and we all have the power to make wishes come true, as long as we keep believing."
  },
  {
    "author": "Jonathan Swift",
    "category": "power",
    "id": 56968,
    "text": "Power is no blessing in itself, except when it is used to protect the innocent."
  },
  {
    "author": "Greg Anderson",
    "category": "power",
    "id": 57290,
    "text": "Although our inattention can contribute to our lack of total well-being, we also have the power to choose positive behaviors and responses. In that choice we change our every experience of life!"
  },
  {
    "author": "Noam Chomsky",
    "category": "power",
    "id": 56808,
    "text": "The intellectual tradition is one of servility to power, and if I didn't betray it I'd be ashamed of myself."
  },
  {
    "author": "Socrates",
    "category": "power",
    "id": 56618,
    "text": "I only wish that ordinary people had an unlimited capacity for doing harm then they might have an unlimited power for doing good."
  },
  {
    "author": "Phillips Brooks",
    "category": "power",
    "id": 56660,
    "text": "A man who lives right, and is right, has more power in his silence than another has by his words."
  },
  {
    "author": "Alexis de Tocqueville",
    "category": "power",
    "id": 56900,
    "text": "The power of the periodical press is second only to that of the people."
  },
  {
    "author": "William Cobbett",
    "category": "power",
    "id": 56951,
    "text": "Women are a sisterhood. They make common cause in behalf of the sex and, indeed, this is natural enough, when we consider the vast power that the law gives us over them."
  },
  {
    "author": "Beatrix Potter",
    "category": "power",
    "id": 57139,
    "text": "All outward forms of religion are almost useless, and are the causes of endless strife. Believe there is a great power silently working all things for good, behave yourself and never mind the rest."
  },
  {
    "author": "Muqtada al Sadr",
    "category": "power",
    "id": 57388,
    "text": "Obama has no power to change American policy because there are people who specialize in drawing these policies, which have been and still are hostile towards Islam."
  },
  {
    "author": "Paris Hilton",
    "category": "power",
    "id": 56947,
    "text": "I'm not the same person I was. I used to act dumb. It was an act. I am 26 years old, and that act is no longer cute. It is not who I am, nor do I want to be that person for the young girls who looked up to me. I know now that I can make a difference, that I have the power to do that."
  },
  {
    "author": "Arnold J. Toynbee",
    "category": "power",
    "id": 56466,
    "text": "Sooner or later, man has always had to decide whether he worships his own power or the power of God."
  },
  {
    "author": "James Madison",
    "category": "power",
    "id": 56869,
    "text": "The essence of Government is power and power, lodged as it must be in human hands, will ever be liable to abuse."
  },
  {
    "author": "Robin Morgan",
    "category": "power",
    "id": 56871,
    "text": "Knowledge is power. Information is power. The secreting or hoarding of knowledge or information may be an act of tyranny camouflaged as humility."
  },
  {
    "author": "William Moulton Marston",
    "category": "power",
    "id": 56506,
    "text": "Every crisis offers you extra desired power."
  },
  {
    "author": "James Lovelock",
    "category": "power",
    "id": 57194,
    "text": "I have heard that the Saudi Arabians are paying Greenpeace to campaign against Nuclear Power. It wouldn't surprise me at all."
  },
  {
    "author": "Murray Rothbard",
    "category": "power",
    "id": 56826,
    "text": "It is in war that the State really comes into its own: swelling in power, in number, in pride, in absolute dominion over the economy and the society."
  },
  {
    "author": "Marilyn French",
    "category": "power",
    "id": 56769,
    "text": "Well, love is insanity. The ancient Greeks knew that. It is the taking over of a rational and lucid mind by delusion and self-destruction. You lose yourself, you have no power over yourself, you can't even think straight."
  },
  {
    "author": "Thomas Aquinas",
    "category": "power",
    "id": 56836,
    "text": "As regards the individual nature, woman is defective and misbegotten, for the active power of the male seed tends to the production of a perfect likeness in the masculine sex while the production of a woman comes from defect in the active power."
  },
  {
    "author": "Imran Khan",
    "category": "power",
    "id": 57354,
    "text": "People didn't wasn't the People's party to come in to power again, so they saw NS a viable alternative not us, because everyone knew we were not ready."
  },
  {
    "author": "Honore de Balzac",
    "category": "power",
    "id": 56810,
    "text": "Power is not revealed by striking hard or often, but by striking true."
  },
  {
    "author": "Spike Lee",
    "category": "power",
    "id": 57183,
    "text": "Fight the power that be. Fight the power."
  },
  {
    "author": "Alexis Carrel",
    "category": "power",
    "id": 56483,
    "text": "Those who desire to rise as high as our human condition allows, must renounce intellectual pride, the omnipotence of clear thinking, belief in the absolute power of logic."
  },
  {
    "author": "Deborah Tannen",
    "category": "power",
    "id": 56503,
    "text": "Each underestimates her own power and overestimates the other's."
  },
  {
    "author": "Hillary Clinton",
    "category": "power",
    "id": 56758,
    "text": "I believe in delegating power."
  },
  {
    "author": "Charles Evans Hughes",
    "category": "power",
    "id": 57303,
    "text": "The power to wage war is the power to wage war successfully."
  },
  {
    "author": "Charles de Montesquieu",
    "category": "power",
    "id": 57396,
    "text": "The sublimity of administration consists in knowing the proper degree of power that should be exerted on different occasions."
  },
  {
    "author": "Howard Zinn",
    "category": "power",
    "id": 56761,
    "text": "If those in charge of our society - politicians, corporate executives, and owners of press and television - can dominate our ideas, they will be secure in their power. They will not need soldiers patrolling the streets. We will control ourselves."
  },
  {
    "author": "Malcolm X",
    "category": "power",
    "id": 56830,
    "text": "Power in defense of freedom is greater than power in behalf of tyranny and oppression."
  },
  {
    "author": "Deborah Norville",
    "category": "power",
    "id": 57275,
    "text": "'Thank you power' is writing down the moments that are good in your life so that you can go back and reflect on them - so you've got this sort of repository of good stuff in your past."
  },
  {
    "author": "Nido Qubein",
    "category": "power",
    "id": 56929,
    "text": "Nothing can add more power to your life than concentrating all your energies on a limited set of targets."
  },
  {
    "author": "Francis Bacon",
    "category": "power",
    "id": 56418,
    "text": "Knowledge is power."
  },
  {
    "author": "Colin Powell",
    "category": "power",
    "id": 56866,
    "text": "The purposes of the United States should not be doubted. The Security Council resolutions will be enforced - the just demands of peace and security will be met - or action will be unavoidable. And a regime that has lost its legitimacy will also lose its power."
  },
  {
    "author": "Bob Dylan",
    "category": "power",
    "id": 56642,
    "text": "I don't think I've ever been an agnostic. I've always thought there's a superior power, that this is not the real world and that there's a world to come."
  },
  {
    "author": "Frances McDormand",
    "category": "power",
    "id": 56490,
    "text": "The only power you have is the word no."
  },
  {
    "author": "Benjamin F. Wade",
    "category": "power",
    "id": 57087,
    "text": "I am not unconscious of the persuasive power exerted by these considerations to drag men along in the current but I am not at liberty to travel that road."
  },
  {
    "author": "Cal Thomas",
    "category": "power",
    "id": 56811,
    "text": "One of the reasons people hate politics is that truth is rarely a politician's objective. Election and power are."
  },
  {
    "author": "F. Scott Fitzgerald",
    "category": "power",
    "id": 56672,
    "text": "Either you think, or else others have to think for you and take power from you, pervert and discipline your natural tastes, civilize and sterilize you."
  },
  {
    "author": "Friedrich Schiller",
    "category": "power",
    "id": 56465,
    "text": "Power is the most persuasive rhetoric."
  }
]

quotes['relationship'] = [
  {
    "author": "Juan Goytisolo",
    "category": "relationship",
    "id": 58240,
    "text": "And it is because a series of elements in Spanish life which operate today the same way as they did in the times of Blanco White made obvious my relationship with him, based on a similarity in Spain's condition."
  },
  {
    "author": "Candace Bushnell",
    "category": "relationship",
    "id": 57960,
    "text": "My parents had a great marriage. Interestingly, it made it harder for me in relationships because I knew what a good relationship looked like."
  },
  {
    "author": "Ryszard Kapuscinski",
    "category": "relationship",
    "id": 58002,
    "text": "This is the most intimate relationship between literature and its readers: they treat the text as a part of themselves, as a possession."
  },
  {
    "author": "David Cronenberg",
    "category": "relationship",
    "id": 57931,
    "text": "I also think the relationship I have with my audience is a lot more complex than what Hitchcock seemed to want his to be - although I think he had more going on under the surface as well."
  },
  {
    "author": "Kenny Loggins",
    "category": "relationship",
    "id": 57951,
    "text": "I couldn't be in a relationship and behave like somebody else or pretend I felt something I didn't feel. And that includes saying things I thought might jeopardize the relationship."
  },
  {
    "author": "Uma Thurman",
    "category": "relationship",
    "id": 57627,
    "text": "It is better to have a relationship with someone who cheats on you than with someone who does not flush the toilet."
  },
  {
    "author": "Kris Allen",
    "category": "relationship",
    "id": 58102,
    "text": "I'm not a terrible person, I know that, but sometimes in a relationship, I can be crappy."
  },
  {
    "author": "Marion Cotillard",
    "category": "relationship",
    "id": 57555,
    "text": "I think in friendship, you want to be there for your friend, and sometimes you just don't know what to do or the relationship you have with them is not clear enough for you to know what to do."
  },
  {
    "author": "Andrew Cohen",
    "category": "relationship",
    "id": 57831,
    "text": "It is true that women tend to be more identified with their bodies because in this crazy world, both men and women measure women's value as human beings in relationship to their physical appearance."
  },
  {
    "author": "Lea Michele",
    "category": "relationship",
    "id": 57816,
    "text": "When it comes to 'Glee,' I feel like I've been in a relationship, and now I can mingle a bit."
  },
  {
    "author": "Arundhati Roy",
    "category": "relationship",
    "id": 57856,
    "text": "Sometimes I think the world is divided into those who have a comfortable relationship with power and those who have a naturally adversarial relationship with power."
  },
  {
    "author": "Michael Sheen",
    "category": "relationship",
    "id": 57759,
    "text": "You know, we're each the hero of our own story and we perceive what's going on around us, and especially in a relationship, from the kind of viewpoint of, 'Well, this is my story, and I'm the hero of that, and I justify what I do around it.'"
  },
  {
    "author": "Jones Very",
    "category": "relationship",
    "id": 58230,
    "text": "We feel unsatisfied until we know ourselves akin even with that greatness which made the spots on which it rested hallowed and until, by our own lives, and by converse with the thoughts they have bequeathed us, we feel that union and relationship of the spirit which we seek."
  },
  {
    "author": "Buddha",
    "category": "relationship",
    "id": 57480,
    "text": "Health is the greatest gift, contentment the greatest wealth, faithfulness the best relationship."
  },
  {
    "author": "Graham Greene",
    "category": "relationship",
    "id": 57466,
    "text": "In human relationships, kindness and lies are worth a thousand truths."
  },
  {
    "author": "Anne Heche",
    "category": "relationship",
    "id": 57975,
    "text": "I believe I went through a divorce. My relationship with Ellen is no less significant as a marriage than my relationship to Coley."
  },
  {
    "author": "Emily Watson",
    "category": "relationship",
    "id": 58140,
    "text": "My husband. He keeps me grounded. If I were in the world on my own, it would all be much more seductive. But I'm in a relationship that has nothing to do with the film world."
  },
  {
    "author": "Brigitte Bardot",
    "category": "relationship",
    "id": 57606,
    "text": "Films have never shown the kind of relationship that can exist between two women."
  },
  {
    "author": "Joseph Jarman",
    "category": "relationship",
    "id": 58254,
    "text": "Lotta people don't realize when you grow up with people, you have an affinity, a relationship you don't get with anyone else. After you're twenty years old, anyone you meet after that, it's different from the people you knew before."
  },
  {
    "author": "Eknath Easwaran",
    "category": "relationship",
    "id": 58276,
    "text": "It takes a lot of experience of life to see why some relationships last and others do not. But we do not have to wait for a crisis to get an idea of the future of a particular relationship. Our behavior in little every incidents tells us a great deal."
  },
  {
    "author": "Evan Glodell",
    "category": "relationship",
    "id": 58355,
    "text": "I was writing short films and I was going through this really, really, really terrible end of a relationship that I didn't want to be going through. It was too much for me to process and all of a sudden I had this idea for my first feature film and I knew right away I had to start writing it."
  },
  {
    "author": "Dyan Cannon",
    "category": "relationship",
    "id": 58367,
    "text": "I really always expected to somebody to make me happy and I don't think you can really enter into a relationship until you are happy."
  },
  {
    "author": "Jeff Bridges",
    "category": "relationship",
    "id": 57572,
    "text": "I can see how a relationship with a writer would be an easy thing."
  },
  {
    "author": "Tahar Ben Jelloun",
    "category": "relationship",
    "id": 57866,
    "text": "Poetry is a form of mathematics, a highly rigorous relationship with words."
  },
  {
    "author": "Arthur Smith",
    "category": "relationship",
    "id": 57823,
    "text": "The history of the relationship between comedy and swimming is short indeed. Of course it is always funny when someone falls into water, but that's about it."
  },
  {
    "author": "Wilbur Smith",
    "category": "relationship",
    "id": 57865,
    "text": "I'm not a good father and they're not children any more the eldest is in his fifties. My relationship with their mothers broke down and, because of what the law was, they went with their mothers and were imbued with their mothers' morality in life and they were not my people any more."
  },
  {
    "author": "Luke Ford",
    "category": "relationship",
    "id": 58028,
    "text": "At the time I perceived most religious men, particularly the pastors with all their talk about love, faith and relationship, as effeminate."
  },
  {
    "author": "Robert Teeter",
    "category": "relationship",
    "id": 58058,
    "text": "Many citizens see all the leadership of these large institutions together in a conspiracy against them rather than in any adversary relationship with each other."
  },
  {
    "author": "Patti Stanger",
    "category": "relationship",
    "id": 57802,
    "text": "We have all loved a guy we know has issues. Despite popular opinions, until we give it a final try, the relationship will always be in the 'what if' stage."
  },
  {
    "author": "Smokey Robinson",
    "category": "relationship",
    "id": 57750,
    "text": "So I wanted to sing inspirational music, and that's exactly how I approached it - only the words have been changed to declare my relationship with God."
  },
  {
    "author": "Robert Pattinson",
    "category": "relationship",
    "id": 57798,
    "text": "I'm not one of these guys who's constantly in a relationship, not at all."
  },
  {
    "author": "Neil LaBute",
    "category": "relationship",
    "id": 57456,
    "text": "In a relationship you have to open yourself up."
  },
  {
    "author": "Alfred Adler",
    "category": "relationship",
    "id": 57574,
    "text": "The test of one's behavior pattern is their relationship to society, relationship to work and relationship to sex."
  },
  {
    "author": "Michael Rapaport",
    "category": "relationship",
    "id": 58263,
    "text": "In any relationship that comes to an end, there's never just a baseline reason why. You say, 'Oh, I broke up with my girlfriend.' Someone says, 'Why?' You say, 'Well, you got three hours? And then maybe after I tell you my version, you've got to talk to her.'"
  },
  {
    "author": "John Schlesinger",
    "category": "relationship",
    "id": 58083,
    "text": "Oh, the relationship with actors and managers and agents and things is a terrible problem sometimes."
  },
  {
    "author": "Gavin DeGraw",
    "category": "relationship",
    "id": 58124,
    "text": "So if I was dating somebody now and the relationship didn't work out, I'd take that as failing."
  },
  {
    "author": "Katherine Heigl",
    "category": "relationship",
    "id": 57679,
    "text": "I can't cultivate a relationship with my child if it's between takes. I tried that on a movie and realized, 'This is not going to work.' It will work some of the year, but not 12 months a year."
  },
  {
    "author": "Trish Stratus",
    "category": "relationship",
    "id": 58286,
    "text": "And I have the support of the writers: I have a great relationship with the creative team, and they have a good hold of my character and my personality, and they come up with some great stuff, and I'm forever trying to change it up, keep it fresh."
  },
  {
    "author": "Erika Slezak",
    "category": "relationship",
    "id": 58241,
    "text": "My parents had a wonderful marriage, but it was a very dependent relationship. My mother was entirely dependent on my father because that's how it was in those days."
  },
  {
    "author": "Rita Rudner",
    "category": "relationship",
    "id": 57512,
    "text": "I love to shop after a bad relationship. I don't know. I buy a new outfit and it makes me feel better. It just does. Sometimes I see a really great outfit, I'll break up with someone on purpose."
  },
  {
    "author": "Jean-Pierre Raffarin",
    "category": "relationship",
    "id": 58053,
    "text": "What's very important is that we build a space that matters in the world, one that operates according to democratic rules, and that small and large countries enjoy a good relationship."
  },
  {
    "author": "Anthony Storr",
    "category": "relationship",
    "id": 57473,
    "text": "It is only when we no longer compulsively need someone that we can have a real relationship with them."
  },
  {
    "author": "Hunter Tylo",
    "category": "relationship",
    "id": 58274,
    "text": "I have a really great relationship with God. I pray. I read the Bible."
  },
  {
    "author": "Jane Fonda",
    "category": "relationship",
    "id": 57753,
    "text": "My mother killed herself when I was 12. I won't complete that relationship. But I can try to understand her."
  },
  {
    "author": "Rob Sheffield",
    "category": "relationship",
    "id": 57840,
    "text": "Ah, the bond between English boys and California girls. For those of us who aren't either, it's a bond that fascinates and mystifies. So much of the world's favorite music comes out of that relationship."
  },
  {
    "author": "Guy Forget",
    "category": "relationship",
    "id": 57906,
    "text": "I think our strength is this strong relationship we have all together."
  },
  {
    "author": "Wentworth Miller",
    "category": "relationship",
    "id": 57821,
    "text": "I'm very pleased with being a part of the Bean Pole family. It's a relationship that makes sense to me. I'm very pleased to have my name associated with Bean Pole Jeans."
  },
  {
    "author": "Paris Hilton",
    "category": "relationship",
    "id": 57446,
    "text": "I get along with guys most of my friends are guys. It's easier to trust men sometimes. I only have a few close girlfriends that I trust."
  },
  {
    "author": "Anne Rice",
    "category": "relationship",
    "id": 57827,
    "text": "I enjoy the Web site a lot and I like being able to talk to my readers. I've always had a very close relationship with them."
  },
  {
    "author": "Jeanne Moreau",
    "category": "relationship",
    "id": 57656,
    "text": "When Tony was madly in love with me, his relationship with Vanessa Redgrave was ending."
  },
  {
    "author": "Rollo May",
    "category": "relationship",
    "id": 57701,
    "text": "The relationship between commitment and doubt is by no means an antagonistic one. Commitment is healthiest when it's not without doubt but in spite of doubt."
  },
  {
    "author": "Martin Scorsese",
    "category": "relationship",
    "id": 57584,
    "text": "A lot of what I'm obsessed with is the relationship and the dynamics between people and the family, particularly brothers and their father."
  },
  {
    "author": "Orlando Bloom",
    "category": "relationship",
    "id": 57502,
    "text": "I'm quite sensitive to women. I saw how my sister got treated by boyfriends. I read this thing that said when you are in a relationship with a woman, imagine how you would feel if you were her father. That's been my approach, for the most part."
  },
  {
    "author": "Norman Vincent Peale",
    "category": "relationship",
    "id": 57491,
    "text": "It is of practical value to learn to like yourself. Since you must spend so much time with yourself you might as well get some satisfaction out of the relationship."
  },
  {
    "author": "Angela Davis",
    "category": "relationship",
    "id": 57592,
    "text": "To understand how any society functions you must understand the relationship between the men and the women."
  },
  {
    "author": "William J. Clinton",
    "category": "relationship",
    "id": 57534,
    "text": "American and Israel share a special bond. Our relationship is unique among all nations. Like America, Israel is a strong democracy, a symbol of freedom, and an oasis of liberty, a home to the oppressed and persecuted."
  },
  {
    "author": "Wislawa Szymborska",
    "category": "relationship",
    "id": 57789,
    "text": "I usually write for the individual reader -though I would like to have many such readers. There are some poets who write for people assembled in big rooms, so they can live through something collectively. I prefer my reader to take my poem and have a one-on-one relationship with it."
  },
  {
    "author": "Christopher Eccleston",
    "category": "relationship",
    "id": 58015,
    "text": "The film is about Joe discovering who his mother and father are and his relationship with them, and the identity crisis he goes through once he finds out who his parents are."
  },
  {
    "author": "Bill Walton",
    "category": "relationship",
    "id": 58169,
    "text": "I lived to play basketball. Growing up as a kid, Bill Russell and the Boston Celtics were my favorite team. The way they played, the teamwork, the sacrifice, the commitment, the joy, the camaraderie, the relationship with the fans."
  },
  {
    "author": "Lauren Graham",
    "category": "relationship",
    "id": 58021,
    "text": "While I very much wanted to be in a relationship, I didn't want to be in the wrong one."
  },
  {
    "author": "Adrienne Rich",
    "category": "relationship",
    "id": 57860,
    "text": "Poetry is above all a concentration of the power of language, which is the power of our ultimate relationship to everything in the universe."
  },
  {
    "author": "Brittany Murphy",
    "category": "relationship",
    "id": 57869,
    "text": "I did learn one great lesson from a past relationship, and that was to never talk about relationships in print again because I'd rather live my private life than read about it."
  },
  {
    "author": "Kate Middleton",
    "category": "relationship",
    "id": 57969,
    "text": "Well I think if you really go out with someone for quite a long time you do get to know each other very, very well, you go through the good times, you go through the bad times. You know both personally, but also within a relationship as well."
  },
  {
    "author": "Nicole Kidman",
    "category": "relationship",
    "id": 57568,
    "text": "I think when you're in a relationship where you really care for the other person, when they achieve their dreams it's better than when you do yourself."
  },
  {
    "author": "Gustavo Dudamel",
    "category": "relationship",
    "id": 58150,
    "text": "My relationship with the Philharmonia Orchestra brought me many times to London and I will always reflect positively on that early period of development with them - their patience, their warmth, their dedication."
  },
  {
    "author": "Lisa Gardner",
    "category": "relationship",
    "id": 58329,
    "text": "I still like the relationship part of any story. You don't want your character to figure everything out and then at the end of the day, go home and eat soup from a can by herself."
  },
  {
    "author": "Chris Martin",
    "category": "relationship",
    "id": 57858,
    "text": "You know, it's possible for two humans to be in a relationship without there needing to be some public reason for that relationship."
  },
  {
    "author": "DeForest Soaries",
    "category": "relationship",
    "id": 58372,
    "text": "When I was growing up, we used to play basketball in a park that was never shoveled when it snowed. The basketball rims were never fixed. And we understood then that there was a relationship between public policy and our quality of life."
  },
  {
    "author": "Chuck Palahniuk",
    "category": "relationship",
    "id": 57415,
    "text": "Find joy in everything you choose to do. Every job, relationship, home... it's your responsibility to love it, or change it."
  },
  {
    "author": "Ginnifer Goodwin",
    "category": "relationship",
    "id": 57837,
    "text": "I'm a better person in a relationship, and I'm a happier person. I need to come home at the end of the day and have it not be about me and my freaking hair and makeup and character motivations anymore. And I think my work is more inspired when home is safe and sound and solid, because what I do for a living is so bananas and so insecure."
  },
  {
    "author": "Thomas Szasz",
    "category": "relationship",
    "id": 57654,
    "text": "Individual psychotherapy - that is, engaging a distressed fellow human in a disciplined conversation and human relationship - requires that the therapist have the proper temperament and philosophy of life for such work. By that I mean that the therapist must be patient, modest, and a perceptive listener, rather than a talker and advice-giver."
  },
  {
    "author": "Pearl S. Buck",
    "category": "relationship",
    "id": 57726,
    "text": "The basic discovery about any people is the discovery of the relationship between men and women."
  },
  {
    "author": "Malcolm Boyd",
    "category": "relationship",
    "id": 58081,
    "text": "I find Jesus my confidant and companion, brother and savior our relationship is intimate, vulnerable, demanding yet comfortable and reassuring."
  },
  {
    "author": "Gerhard Schroder",
    "category": "relationship",
    "id": 58054,
    "text": "As far as my relationship with President Putin is concerned, it's fine."
  },
  {
    "author": "David Cameron",
    "category": "relationship",
    "id": 57637,
    "text": "It does not seem to me that the steps which would be needed to make Britain - and others - more comfortable in their relationship in the European Union are inherently so outlandish or unreasonable."
  },
  {
    "author": "Boris Becker",
    "category": "relationship",
    "id": 58138,
    "text": "How do you build a relationship when you've hardly shared a word but suddenly share a child? How do you love a daughter you don't see for nearly two years? When does she become your daughter? How does she become your daughter?"
  },
  {
    "author": "Ludwig Quidde",
    "category": "relationship",
    "id": 58196,
    "text": "The relationship of the two problems is rather the reverse. To a great extent disarmament is dependent on guarantees of peace. Security comes first and disarmament second."
  },
  {
    "author": "Jerry O'Connell",
    "category": "relationship",
    "id": 58325,
    "text": "I'm the kind of guy who can't keep a plant alive for a week, let alone a relationship."
  },
  {
    "author": "Jeremy Sisto",
    "category": "relationship",
    "id": 58330,
    "text": "There's a really unique relationship between a single parent and their child. Marriages so easily break up. There's kind of this temporary deal about marriages. That's one of the things that makes it stressful, and that's something that's nonexistent in a parent-child relationship."
  },
  {
    "author": "James Baldwin",
    "category": "relationship",
    "id": 58208,
    "text": "But the relationship of morality and power is a very subtle one. Because ultimately power without morality is no longer power."
  },
  {
    "author": "Scott Stapp",
    "category": "relationship",
    "id": 57593,
    "text": "I always believed in God and Christ, but I was in rebellion - trying to make my relationship with God fit into my life instead of making my life fit in with him. I was stubborn."
  },
  {
    "author": "Demi Moore",
    "category": "relationship",
    "id": 57899,
    "text": "I'm certainly not the first person to be in a relationship with a younger man, but somehow I was plucked out as a bit of a poster girl."
  },
  {
    "author": "Charisma Carpenter",
    "category": "relationship",
    "id": 58051,
    "text": "So, I'm happy to do that because it's a wonderful working relationship but I will be going out for pilot season for half hour work and that's the gamble I'm taking."
  },
  {
    "author": "Susie Orbach",
    "category": "relationship",
    "id": 58118,
    "text": "No one leaves a long-term relationship scot-free or without conflict."
  },
  {
    "author": "Mindy Kaling",
    "category": "relationship",
    "id": 57661,
    "text": "My relationship with my mom is really the single most profound relationship that I've ever had in my life."
  },
  {
    "author": "Ellen Goodman",
    "category": "relationship",
    "id": 58095,
    "text": "There's a trick to the Graceful Exit. It begins with the vision to recognize when a job, a life stage, a relationship is over - and to let go. It means leaving what's over without denying its value."
  },
  {
    "author": "Simon Baker",
    "category": "relationship",
    "id": 58100,
    "text": "In general, the problem in a relationship is when the couple stagnate."
  },
  {
    "author": "Corin Nemec",
    "category": "relationship",
    "id": 57706,
    "text": "I have my ethics and morals. I have my anchor point of what is right and wrong in real life, but I'm not afraid to entertain any and every aspect of personality in relationship to creating a character."
  },
  {
    "author": "David Bohm",
    "category": "relationship",
    "id": 57889,
    "text": "Then there is the further question of what is the relationship of thinking to reality. As careful attention shows, thought itself is in an actual process of movement."
  },
  {
    "author": "Karl Malone",
    "category": "relationship",
    "id": 57982,
    "text": "I never felt I had the kind of relationship with Magic that I could just pick up the phone and call him at home."
  },
  {
    "author": "Benjamin Carson",
    "category": "relationship",
    "id": 57678,
    "text": "Marriage is a very sacred institution and should not be degraded by allowing every other type of relationship to be made equivalent to it."
  },
  {
    "author": "Michel Gondry",
    "category": "relationship",
    "id": 57983,
    "text": "I shoot people in a way that makes the audience feel equal to them. And it's hard to express and it's hard to execute but I think it works on every level - the choice of the material the choice of the actor, my relationship with the actor, and so on."
  },
  {
    "author": "Jarvis Cocker",
    "category": "relationship",
    "id": 57795,
    "text": "Every woman I've had a relationship with has found this maddening the fact that I will talk about anything on the stage, and reveal all this stuff, and yet when I'm at home, I clam up and won't discuss anything intimate or personal."
  },
  {
    "author": "Andrea Riseborough",
    "category": "relationship",
    "id": 58077,
    "text": "I'm interested in having a relationship with the world that's not my own."
  },
  {
    "author": "Jenifer Lewis",
    "category": "relationship",
    "id": 58225,
    "text": "America has a relationship with Bobby and Whitney."
  },
  {
    "author": "Michelangelo Antonioni",
    "category": "relationship",
    "id": 58180,
    "text": "Till now I have never shot a scene without taking account of what stands behind the actors because the relationship between people and their surroundings is of prime importance."
  },
  {
    "author": "George J. Mitchell",
    "category": "relationship",
    "id": 58187,
    "text": "So I developed very early a massive inferiority complex, and I've told the story often about how that inspired me later in life to get involved in other things, because I couldn't out-do my brothers in sports, and it's a very competitive relationship."
  },
  {
    "author": "Gennifer Flowers",
    "category": "relationship",
    "id": 58364,
    "text": "I have never lied about my relationship with Bill Clinton. The only proven liar, at this point, and the only admitted liar, is Bill Clinton not Gennifer Flowers, not Kathleen Willey, not Paula Jones and not Monica Lewinsky, at this point. He is the only proven liar."
  },
  {
    "author": "John Podhoretz",
    "category": "relationship",
    "id": 57639,
    "text": "The attack on ObamaCare was that Congress does not have the power under the Commerce Clause to force a private citizen into a private contractual relationship. If such a thing is permitted to stand, the anti-ObamaCare forces argue, there will be no limit to Congress's power in the future."
  },
  {
    "author": "Steven Moffat",
    "category": "relationship",
    "id": 58000,
    "text": "When writing comedy, you have to have the confidence to believe that there is only one type of relationship in the world, and we are all having it, that all men behave in the same way and so do all women."
  }
]

quotes['religion'] = [
  {
    "author": "Larry David",
    "category": "religion",
    "id": 58841,
    "text": "Religion doesn't play any part in my life in terms of how I live my life. But I don't think I've ever gone through a day in my life without hearing someone say the word 'Jew' or saying it myself."
  },
  {
    "author": "Giovanni Ribisi",
    "category": "religion",
    "id": 59376,
    "text": "I could almost say it is my religion. I guess that sounds pretentious, but I want to live and breathe cinema."
  },
  {
    "author": "Barney Frank",
    "category": "religion",
    "id": 59058,
    "text": "I hope we will not so characterize religious people as being so narrow and so biased towards people not of their own religion that they cannot even work with them in this common cause to which you say they are committed."
  },
  {
    "author": "Tom T. Hall",
    "category": "religion",
    "id": 59147,
    "text": "The first guy who came up with the concept of religion was sitting out under a tree. I'm sure of that."
  },
  {
    "author": "Toni Cade Bambara",
    "category": "religion",
    "id": 59317,
    "text": "And what is religion, you might ask. It's a technology of living."
  },
  {
    "author": "Sri Aurobindo",
    "category": "religion",
    "id": 58916,
    "text": "Indian religion has always felt that since the minds, the temperaments and the intellectual affinities of men are unlimited in their variety, a perfect liberty of thought and of worship must be allowed to the individual in his approach to the Infinite."
  },
  {
    "author": "Natalie Portman",
    "category": "religion",
    "id": 58934,
    "text": "You know, I get much more Jewish in Israel because I like the way that religion is done there."
  },
  {
    "author": "Abraham Joshua Heschel",
    "category": "religion",
    "id": 58478,
    "text": "Worship is a way of seeing the world in the light of God."
  },
  {
    "author": "Jesus Christ",
    "category": "religion",
    "id": 58437,
    "text": "For God so loved the World that he gave his only Son, that whoever believes in him should not perish but have eternal life."
  },
  {
    "author": "William Robertson Smith",
    "category": "religion",
    "id": 59355,
    "text": "The dissolution of the nation destroys the national religion, and dethrones the national deity."
  },
  {
    "author": "Mitt Romney",
    "category": "religion",
    "id": 58577,
    "text": "And let me make this very clear - unlike President Obama, I will not raise taxes on the middle class. As president, I will protect the sanctity of life. I will honor the institution of marriage. And I will guarantee America's first liberty: the freedom of religion."
  },
  {
    "author": "Noah Webster",
    "category": "religion",
    "id": 58805,
    "text": "In my view, the Christian religion is the most important and one of the first things in which all children, under a free government ought to be instructed."
  },
  {
    "author": "Abdurrahman Wahid",
    "category": "religion",
    "id": 58703,
    "text": "All too many Muslims fail to grasp Islam, which teaches one to be lenient towards others and to understand their value systems, knowing that these are tolerated by Islam as a religion."
  },
  {
    "author": "Toni Morrison",
    "category": "religion",
    "id": 58851,
    "text": "It's been mentioned or suggested that Paradise will not be well studied, because it's about this unimportant intellectual topic, which is religion."
  },
  {
    "author": "Bill Gates",
    "category": "religion",
    "id": 58539,
    "text": "Just in terms of allocation of time resources, religion is not very efficient. There's a lot more I could be doing on a Sunday morning."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "religion",
    "id": 58423,
    "text": "Prayer does not change God, but it changes him who prays."
  },
  {
    "author": "John Shelby Spong",
    "category": "religion",
    "id": 59220,
    "text": "Religion is a mixed blessing."
  },
  {
    "author": "Cher",
    "category": "religion",
    "id": 58892,
    "text": "I have a problem with religion that makes it so, like, 'We are the ones. We are the chosen ones.'"
  },
  {
    "author": "Gregory Bateson",
    "category": "religion",
    "id": 58970,
    "text": "Science, like art, religion, commerce, warfare, and even sleep, is based on presuppositions."
  },
  {
    "author": "Terry Jones",
    "category": "religion",
    "id": 59356,
    "text": "I don't think you need religion."
  },
  {
    "author": "E. O. Wilson",
    "category": "religion",
    "id": 58652,
    "text": "Every major religion today is a winner in the Darwinian struggle waged among cultures, and none ever flourished by tolerating its rivals."
  },
  {
    "author": "John Paul Stevens",
    "category": "religion",
    "id": 59377,
    "text": "The government must pursue a course of complete neutrality toward religion."
  },
  {
    "author": "Shirin Ebadi",
    "category": "religion",
    "id": 58833,
    "text": "Human rights is a universal standard. It is a component of every religion and every civilization."
  },
  {
    "author": "Edmond de Goncourt",
    "category": "religion",
    "id": 59259,
    "text": "If there is a God, atheism must seem to Him as less of an insult than religion."
  },
  {
    "author": "Serj Tankian",
    "category": "religion",
    "id": 59051,
    "text": "We first fought the heathens in the name of religion, then Communism, and now in the name of drugs and terrorism. Our excuses for global domination always change."
  },
  {
    "author": "Huston Smith",
    "category": "religion",
    "id": 59128,
    "text": "It is commonly said and known that each civilization has its own religion. Now my claim is that if we look deeper, the different civilizations were brought into being by the different revelations."
  },
  {
    "author": "Thomas Hardy",
    "category": "religion",
    "id": 58693,
    "text": "The main object of religion is not to get a man into heaven, but to get heaven into him."
  },
  {
    "author": "Thomas Paine",
    "category": "religion",
    "id": 58609,
    "text": "Of all the tyrannies that affect mankind, tyranny in religion is the worst."
  },
  {
    "author": "Abraham Lincoln",
    "category": "religion",
    "id": 58506,
    "text": "I care not much for a man's religion whose dog and cat are not the better for it."
  },
  {
    "author": "Ulrich Beck",
    "category": "religion",
    "id": 58825,
    "text": "All theory of modernity in sociology suggests that the more modernity there is, the less religion. In my theory we can realize that this is wrong: atheism is only one belief system among many."
  },
  {
    "author": "Jurgen Habermas",
    "category": "religion",
    "id": 59214,
    "text": "Disappointment over nationalistic authoritarian regimes may have contributed to the fact that today religion offers a new and subjectively more convincing language for old political orientations."
  },
  {
    "author": "Sinead O'Connor",
    "category": "religion",
    "id": 59165,
    "text": "I think there's a difference between God and religion."
  },
  {
    "author": "Arthur C. Clarke",
    "category": "religion",
    "id": 58461,
    "text": "I don't believe in God but I'm very interested in her."
  },
  {
    "author": "Ziggy Marley",
    "category": "religion",
    "id": 58913,
    "text": "If religion had a good purpose, then man would have created something great. But we're man: we mess up everything. We mess up nature. We mess up God. We take what is given to us and make it into what we think it should be."
  },
  {
    "author": "Barbara Walters",
    "category": "religion",
    "id": 59198,
    "text": "I found it interesting that as people become more technically oriented all over the world, at the same time people are becoming increasingly spiritual. The success of the Da Vinci code - even though it was a great yawn - also showed people's interest in religion."
  },
  {
    "author": "Aleksandr Solzhenitsyn",
    "category": "religion",
    "id": 58937,
    "text": "Religion always remains higher than everyday life. In order to make the elevation towards religion easier for people, religion must be able to alter its forms in relation to the consciousness of modern man."
  },
  {
    "author": "Matt Stone",
    "category": "religion",
    "id": 59182,
    "text": "With religion I was always like, 'Does it matter if it's true if it makes you happy?'"
  },
  {
    "author": "Paul Harris",
    "category": "religion",
    "id": 59212,
    "text": "One's religion is one's own possession and he has a right to it."
  },
  {
    "author": "Daniel Radcliffe",
    "category": "religion",
    "id": 58808,
    "text": "I'm very interested in religion as something to study, but I'm not a religious person in the slightest."
  },
  {
    "author": "Lionel Blue",
    "category": "religion",
    "id": 59043,
    "text": "The Christian use of religion as a personal love affair both shocked me, and attracted me."
  },
  {
    "author": "Javier Bardem",
    "category": "religion",
    "id": 59003,
    "text": "But I remember the moment when my father died. I wasn't a very committed Catholic beforehand, but when that happened it suddenly all felt so obvious: I now believe religion is our attempt to find an explanation, for us to feel more protected."
  },
  {
    "author": "Tom Brokaw",
    "category": "religion",
    "id": 59063,
    "text": "If fishing is a religion, fly fishing is high church."
  },
  {
    "author": "Marilyn Manson",
    "category": "religion",
    "id": 58722,
    "text": "My first memories of religion were being taken to Episcopal church. My father was Catholic, but my mother, I believe, was Episcopal. So I sort of veered off into the watered-down version of Catholicism."
  },
  {
    "author": "Felix Adler",
    "category": "religion",
    "id": 59226,
    "text": "No religion can long continue to maintain its purity when the church becomes the subservient vassal of the state."
  },
  {
    "author": "Alice Walker",
    "category": "religion",
    "id": 58681,
    "text": "I don't call myself a Buddhist. I'm a free spirit. I believe I'm here on earth to admire and enjoy it that's my religion."
  },
  {
    "author": "Madeleine Albright",
    "category": "religion",
    "id": 58750,
    "text": "It's one thing to be religious, but it's another thing to make religion your policy."
  },
  {
    "author": "John Keats",
    "category": "religion",
    "id": 58594,
    "text": "I have been astonished that men could die martyrs for religion - I have shuddered at it. I shudder no more - I could be martyred for my religion - Love is my religion - I could die for that."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "religion",
    "id": 58968,
    "text": "I firmly believe that the mission of religion in the 21st century must be to contribute concretely to the peaceful coexistence of humankind."
  },
  {
    "author": "George Orwell",
    "category": "religion",
    "id": 58596,
    "text": "As with the Christian religion, the worst advertisement for Socialism is its adherents."
  },
  {
    "author": "Lucretius",
    "category": "religion",
    "id": 58715,
    "text": "Such are the heights of wickedness to which men are driven by religion."
  },
  {
    "author": "Aaron Neville",
    "category": "religion",
    "id": 58489,
    "text": "I was raised Catholic, but my father's people were Methodist, so we went to both churches."
  },
  {
    "author": "Mary Baker Eddy",
    "category": "religion",
    "id": 58762,
    "text": "I would no more quarrel with a man because of his religion than I would because of his art."
  },
  {
    "author": "Kevin Smith",
    "category": "religion",
    "id": 58925,
    "text": "Haven't two hundred years of failed missionary work overseas taught anybody anything? You can't convert people to anything - whether religion, or something as inane as our flicks."
  },
  {
    "author": "Trey Parker",
    "category": "religion",
    "id": 59006,
    "text": "I grew up with the religion of 'Star Wars,' frankly. That's when I realized there is something bigger out there... and it's called The Force."
  },
  {
    "author": "William Robertson Smith",
    "category": "religion",
    "id": 59350,
    "text": "But, strictly speaking, this mythology was no essential part of ancient religion, for it had no sacred sanction and no binding force on the worshippers."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "religion",
    "id": 58744,
    "text": "In religion as in politics it so happens that we have less charity for those who believe half our creed, than for those who deny the whole of it."
  },
  {
    "author": "William Robertson Smith",
    "category": "religion",
    "id": 59354,
    "text": "Religion did not exist for the saving of souls but for the preservation and welfare of society, and in all that was necessary to this end every man had to take his part, or break with the domestic and political community to which he belonged."
  },
  {
    "author": "Victor Hugo",
    "category": "religion",
    "id": 58603,
    "text": "Toleration is the best religion."
  },
  {
    "author": "Colin Hanks",
    "category": "religion",
    "id": 59279,
    "text": "Religion theme aside, most of the time I'm in some sort of comedy and I'm a straight man and it's really just, let's wind this guy up and see him explode."
  },
  {
    "author": "Mary Augusta Ward",
    "category": "religion",
    "id": 59379,
    "text": "I wanted to show how a man of sensitive and noble character, born for religion, comes to throw off the orthodoxies of his day and moment, and to go out into the wilderness where all is experiment, and spiritual life begins again."
  },
  {
    "author": "G. I. Gurdjieff",
    "category": "religion",
    "id": 58788,
    "text": "Religion is doing a man does not merely think his religion or feel it, he 'lives' his religion as much as he is able, otherwise it is not religion but fantasy or philosophy."
  },
  {
    "author": "Dennis Prager",
    "category": "religion",
    "id": 58893,
    "text": "Leftism seeks to undo most of the values that are distinct to Judeo-Christian religion."
  },
  {
    "author": "Tom Baker",
    "category": "religion",
    "id": 59290,
    "text": "We are pre-disposed for fantasy, there is a natural impulse for human beings to want to get off their heads or out of their heads in something in a substance or a drink or an idea or a religion which will comfort them and make life exciting."
  },
  {
    "author": "Martin Scorsese",
    "category": "religion",
    "id": 58794,
    "text": "My whole life has been movies and religion. That's it. Nothing else."
  },
  {
    "author": "Donny Osmond",
    "category": "religion",
    "id": 59029,
    "text": "My political ideas and things like that, even my religion, I try to keep close to me because it's a personal thing, and I don't shove it down people's throats. I don't condemn any artist that wants to do that, like the Baldwins. That's their choice. But in my world, I'm just an entertainer."
  },
  {
    "author": "Karen Armstrong",
    "category": "religion",
    "id": 59019,
    "text": "When violence becomes imbedded in a region, then this affects everything. It affects your dreams, your fantasies and relationships, and your religion becomes violent, too."
  },
  {
    "author": "Jonathan Sacks",
    "category": "religion",
    "id": 58956,
    "text": "In thinking about religion and society in the 21st century, we should broaden the conversation about faith from doctrinal debates to the larger question of how it might inspire us to strengthen the bonds of belonging that redeem us from our solitude, helping us to construct together a gracious and generous social order."
  },
  {
    "author": "Jim Ryun",
    "category": "religion",
    "id": 59032,
    "text": "The United States is not a nation based upon race, creed, or religion - we are a nation based upon our loyalty and allegiance to our country and her principles."
  },
  {
    "author": "Charles Eastman",
    "category": "religion",
    "id": 59246,
    "text": "The American Indian was an individualist in religion as in war. He had neither a national army nor an organized church."
  },
  {
    "author": "Ambrose Bierce",
    "category": "religion",
    "id": 58617,
    "text": "Religion. A daughter of Hope and Fear, explaining to Ignorance the nature of the Unknowable."
  },
  {
    "author": "George Santayana",
    "category": "religion",
    "id": 58711,
    "text": "Wealth, religion, military victory have more rhetorical than efficacious worth."
  },
  {
    "author": "Anthony Hopkins",
    "category": "religion",
    "id": 58781,
    "text": "We all dream. We dream vividly, depending on our nature. Our existence is beyond our explanation, whether we believe in God or we have religion or we're atheist."
  },
  {
    "author": "Criss Angel",
    "category": "religion",
    "id": 59157,
    "text": "I like to say magic is the world's second oldest profession, a mystical and often awe-inspiring spectacle that, throughout the ages, has blended superstition, trickery and religion."
  },
  {
    "author": "Ralph W. Sockman",
    "category": "religion",
    "id": 59110,
    "text": "Christmas renews our youth by stirring our wonder. The capacity for wonder has been called our most pregnant human faculty, for in it are born our art, our science, our religion."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "religion",
    "id": 58417,
    "text": "When I admire the wonders of a sunset or the beauty of the moon, my soul expands in the worship of the creator."
  },
  {
    "author": "Barack Obama",
    "category": "religion",
    "id": 58567,
    "text": "It was not a religion that attacked us that September day. It was al-Qaeda. We will not sacrifice the liberties we cherish or hunker down behind walls of suspicion and mistrust."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "religion",
    "id": 58817,
    "text": "Religion is not only a part of education, an element of humanity, but the center of everything else, always the first and the ultimate, the absolutely original."
  },
  {
    "author": "Rowan Atkinson",
    "category": "religion",
    "id": 58905,
    "text": "To criticize a person for their race is manifestly irrational and ridiculous, but to criticize their religion, that is a right. That is a freedom."
  },
  {
    "author": "Annie Besant",
    "category": "religion",
    "id": 58850,
    "text": "No philosophy, no religion, has ever brought so glad a message to the world as this good news of Atheism."
  },
  {
    "author": "Walter Koenig",
    "category": "religion",
    "id": 58964,
    "text": "Religious tolerance is something we should all practice however, there have been more persecution and atrocities committed in the name of religion and religious freedom than anything else."
  },
  {
    "author": "Charles Baudelaire",
    "category": "religion",
    "id": 58780,
    "text": "Even if it were proven that God didn't exist, Religion would still be Saintly and Divine."
  },
  {
    "author": "Albert Einstein",
    "category": "religion",
    "id": 58500,
    "text": "True religion is real living living with all one's soul, with all one's goodness and righteousness."
  },
  {
    "author": "Rick Warren",
    "category": "religion",
    "id": 58873,
    "text": "I believe in the separation of church and state, but I do not believe in the separation of politics from religion."
  },
  {
    "author": "Desmond Tutu",
    "category": "religion",
    "id": 58748,
    "text": "God's love is too great to be confined to any one side of a conflict or to any one religion."
  },
  {
    "author": "Robert Shea",
    "category": "religion",
    "id": 59305,
    "text": "Organized religion provides a model of the way all organizations, from the state down to the village garden club, end a price in terms of a member's freedom of thought and action."
  },
  {
    "author": "Ezra Pound",
    "category": "religion",
    "id": 58979,
    "text": "Religion, oh, just another of those numerous failures resulting from an attempt to popularize art."
  },
  {
    "author": "King Abdullah II",
    "category": "religion",
    "id": 58974,
    "text": "You're always going to have extremists in every religion."
  },
  {
    "author": "James Lovelock",
    "category": "religion",
    "id": 58923,
    "text": "It just so happens that the green religion is now taking over from the Christian religion. I don't think people have noticed that, but it's got all the sort of terms that religions use... The greens use guilt. That just shows how religious greens are. You can't win people round by saying they are guilty for putting (carbon dioxide) in the air."
  },
  {
    "author": "Alexander Chase",
    "category": "religion",
    "id": 58469,
    "text": "More and more people care about religious tolerance as fewer and fewer care about religion."
  },
  {
    "author": "Jane Seymour",
    "category": "religion",
    "id": 59057,
    "text": "I believe that there is some spiritual entity that's greater than us. I do not belong to any specific organized religion. I have always believed that, and I believe it even more so now. I believe that someone was listening to me, and someone is giving me an incredibly blessed life."
  },
  {
    "author": "A. N. Wilson",
    "category": "religion",
    "id": 58861,
    "text": "When Christians start thinking about Jesus, things start breaking down, they lose their faith. It's perfectly possible to go to church every Sunday and not ask any questions, just because you like it as a way of life. They fear that if they ask questions they'll lose their Christ, the very linchpin of their religion."
  },
  {
    "author": "Karl Marx",
    "category": "religion",
    "id": 58585,
    "text": "Religion is the sigh of the oppressed creature, the heart of a heartless world, and the soul of soulless conditions. It is the opium of the people."
  },
  {
    "author": "Reese Witherspoon",
    "category": "religion",
    "id": 59171,
    "text": "To play June, I had an immediate connect with her background and culture. We grew up with the same religion and shared a lot of the same values of family and spirituality. But I was really so inspired by what a modern woman she was."
  },
  {
    "author": "Karl Barth",
    "category": "religion",
    "id": 59105,
    "text": "Religion is the possibility of the removal of every ground of confidence except confidence in God alone."
  },
  {
    "author": "Pete Sampras",
    "category": "religion",
    "id": 59230,
    "text": "It's not my place to tell you whom to vote for, to take any political stand, to tell you what religion to believe in. I'm an athlete. I can influence certain things, but when I see other athletes and celebrities telling you whom to vote for, I actually get a bit offended."
  },
  {
    "author": "Alan Dershowitz",
    "category": "religion",
    "id": 58994,
    "text": "Twenty five percent of Israeli citizens are not even Jewish. Anybody can become an Israeli citizen if you qualify. Religion is not a criterion for citizenship."
  },
  {
    "author": "Dalai Lama",
    "category": "religion",
    "id": 58511,
    "text": "Whether you call it Buddhism or another religion, self-discipline, that's important. Self-discipline with awareness of consequences."
  },
  {
    "author": "Zbigniew Brzezinski",
    "category": "religion",
    "id": 58997,
    "text": "Look at Islam in a rational manner and without demagoguery or emotion. It is the leading religion of the world with 1.5 billion followers."
  },
  {
    "author": "Eddie Izzard",
    "category": "religion",
    "id": 58949,
    "text": "I try to just talk about human stories and what I think about religion or teapots or whatever."
  },
  {
    "author": "Mitt Romney",
    "category": "religion",
    "id": 58575,
    "text": "Freedom. Freedom of religion. Freedom to speak their mind. Freedom to build a life. And yes, freedom to build a business. With their own hands. This is the essence of the American experience."
  }
]

quotes['respect'] = [
  {
    "author": "Victoria Justice",
    "category": "respect",
    "id": 59922,
    "text": "I look up to Mick Jagger because he's an amazing performer and he's such an individual. I respect him and admire him eternally."
  },
  {
    "author": "Queen Rania of Jordan",
    "category": "respect",
    "id": 60380,
    "text": "For many, the hijab represents modesty, piety and devotion to God, and I truly respect that. But the hijab should not be used as a means of applying social pressure on people."
  },
  {
    "author": "John Lennon",
    "category": "respect",
    "id": 59479,
    "text": "If being an egomaniac means I believe in what I do and in my art or music, then in that respect you can call me that... I believe in what I do, and I'll say it."
  },
  {
    "author": "Katie Couric",
    "category": "respect",
    "id": 60178,
    "text": "And they like being able to turn on the television day in and day out to see someone that they know and they feel comfortable with and trust hopefully and respect even."
  },
  {
    "author": "Abbie Cornish",
    "category": "respect",
    "id": 60051,
    "text": "I'm a vegetarian and very much active in regards to how I feel about animal rights and protecting animals and giving animals a voice. But at the same time, I appreciate and respect other people's decisions to eat meat. The only thing that I hope is that people are educated, that they're aware, that they're living a conscious lifestyle."
  },
  {
    "author": "J. B. Priestley",
    "category": "respect",
    "id": 59607,
    "text": "There was no respect for youth when I was young, and now that I am old, there is no respect for age, I missed it coming and going."
  },
  {
    "author": "John Hench",
    "category": "respect",
    "id": 60098,
    "text": "Walt had a marvelous intuition. And because he understood people very well, liked them and had great respect for people, there was nothing cynical about Walt."
  },
  {
    "author": "Mary J. Blige",
    "category": "respect",
    "id": 59835,
    "text": "I don't think there's anything they can say about me that I haven't said about myself already. And I would be an absolute total liar, and my fans would not respect me, if I said that my life and my marriage are perfect. But we absolutely love each other we have fun together - it's great."
  },
  {
    "author": "Todd Barry",
    "category": "respect",
    "id": 59943,
    "text": "I do not like sports, unless you consider treating all humankind with love and respect a sport."
  },
  {
    "author": "Yoko Ono",
    "category": "respect",
    "id": 59685,
    "text": "What the Beatles did was something incredible, it was more than what a band could do. We have to give them respect."
  },
  {
    "author": "Walter Annenberg",
    "category": "respect",
    "id": 59821,
    "text": "All I ever seek from good deeds is a measure of respect."
  },
  {
    "author": "Mary Wesley",
    "category": "respect",
    "id": 59987,
    "text": "I remember the evacuee children from towns and cities throwing stones at the farm animals. When we explained that if you did that you wouldn't have any milk, meat or eggs, they soon learned to respect the animals."
  },
  {
    "author": "Bill O'Reilly",
    "category": "respect",
    "id": 60059,
    "text": "Americans will respect your beliefs if you just keep them private."
  },
  {
    "author": "Waylon Jennings",
    "category": "respect",
    "id": 59954,
    "text": "I love Johnny Cash, and I respect Johnny Cash. He's the biggest. He's like an Elvis in this business, but no, he's never been the rebel."
  },
  {
    "author": "Ravi Shankar",
    "category": "respect",
    "id": 59898,
    "text": "In our culture we have such respect for musical instruments, they are like part of God."
  },
  {
    "author": "Darrell Royal",
    "category": "respect",
    "id": 59982,
    "text": "I have found that the players who have played in that game really do have respect for their adversaries."
  },
  {
    "author": "Akbar Hashemi Rafsanjani",
    "category": "respect",
    "id": 60265,
    "text": "We have no problems with Jews and highly respect Judaism as a holy religion."
  },
  {
    "author": "Frank Herbert",
    "category": "respect",
    "id": 59973,
    "text": "Respect for the truth comes close to being the basis for all morality."
  },
  {
    "author": "Charlie Hunnam",
    "category": "respect",
    "id": 60185,
    "text": "A lot of my friends are gangsters. Not like gangsters - well, yeah, all sorts of levels of criminality - but not the types that are preying on innocent people. I have no interest in the type of criminality that has no respect for collateral damage."
  },
  {
    "author": "Abdul Kalam",
    "category": "respect",
    "id": 59426,
    "text": "If we are not free, no one will respect us."
  },
  {
    "author": "Jenny McCarthy",
    "category": "respect",
    "id": 59750,
    "text": "You totally value and respect your body as you get older."
  },
  {
    "author": "Wietse Venema",
    "category": "respect",
    "id": 60266,
    "text": "At the time the Sendmail program had a very poor reputation with respect to security, with four root vulnerabilities per year for two successive years."
  },
  {
    "author": "Carly Fiorina",
    "category": "respect",
    "id": 59721,
    "text": "A woman's experience is different from a man's in virtually every respect, including how she is treated by the media."
  },
  {
    "author": "Bjorn Ulvaeus",
    "category": "respect",
    "id": 60204,
    "text": "I'm so incredibly tired of giving respect to a lot of delusions and crazy ideas just because they are regarded as religions."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "respect",
    "id": 59503,
    "text": "Consult your friend on all things, especially on those which respect yourself. His counsel may then be useful where your own self-love might impair your judgment."
  },
  {
    "author": "Rick Santorum",
    "category": "respect",
    "id": 60057,
    "text": "The Obama administration now has regulations that tells them that they can no longer promote marriage to these young girls. They can no longer promote marriage as a way of avoiding poverty and bad choices that they make in their life. They can no longer even teach abstinence education. They have to be neutral with respect to how people behave."
  },
  {
    "author": "Eric Davis",
    "category": "respect",
    "id": 59874,
    "text": "It's easy to see why pitchers respect McGwire. If you hit behind him, they're saying that they don't respect you. You have to change their thinking."
  },
  {
    "author": "Alan Dundes",
    "category": "respect",
    "id": 60324,
    "text": "Cities all over the world are getting bigger as more and more people move from rural to urban sites, but that has created enormous problems with respect to environmental pollution and the general quality of life."
  },
  {
    "author": "Penelope Cruz",
    "category": "respect",
    "id": 60210,
    "text": "I want to be remembered as somebody that tried to respect her integrity as an artist and as a person. And I don't want to be in any box. I don't want to be one thing."
  },
  {
    "author": "John Fisher",
    "category": "respect",
    "id": 60087,
    "text": "My mission, I guess, has always been the kind of world where lesbian and gay people can celebrate who we are with equal freedom, dignity, and respect."
  },
  {
    "author": "Malcolm X",
    "category": "respect",
    "id": 59542,
    "text": "I have more respect for a man who lets me know where he stands, even if he's wrong. Than the one who comes up like an angel and is nothing but a devil."
  },
  {
    "author": "Carly Fiorina",
    "category": "respect",
    "id": 59624,
    "text": "I think somehow men understand other men's need for respect differently than they understand it for a woman. I'm disappointed to have to say that, but I think it's undeniably true."
  },
  {
    "author": "John Dingell",
    "category": "respect",
    "id": 60293,
    "text": "I have enormous respect for Tom Daschle. The NRA has not yet taken a formal position on which I'm aware of on this matter, and I think Tom may be just getting a little ahead of things."
  },
  {
    "author": "Floyd Mayweather, Jr.",
    "category": "respect",
    "id": 59789,
    "text": "I feel like everybody is against Floyd Mayweather. I don't get any respect."
  },
  {
    "author": "Joseph Ratzinger",
    "category": "respect",
    "id": 59948,
    "text": "Above all, we must have great respect for these people who also suffer and who want to find their own way of correct living. On the other hand, to create a legal form of a kind of homosexual marriage, in reality, does not help these people."
  },
  {
    "author": "Miguel Angel Ruiz",
    "category": "respect",
    "id": 59549,
    "text": "Respect is one of the greatest expressions of love."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "respect",
    "id": 59500,
    "text": "It is not likely that posterity will fall in love with us, but not impossible that it may respect or sympathize so a man would rather leave behind him the portrait of his spirit than a portrait of his face."
  },
  {
    "author": "Dick Cheney",
    "category": "respect",
    "id": 59852,
    "text": "I think we need to significantly reduce the regulatory burden on the private sector. The Obama administration is doing the opposite. They're loading on more and more regulation on the private respect to how the economy functions."
  },
  {
    "author": "Salvador Dali",
    "category": "respect",
    "id": 59434,
    "text": "In order to acquire a growing and lasting respect in society, it is a good thing, if you possess great talent, to give, early in your youth, a very hard kick to the right shin of the society that you love. After that, be a snob."
  },
  {
    "author": "Pedro Martinez",
    "category": "respect",
    "id": 60260,
    "text": "I'm open to play for anybody that would give me respect, treat me the right way, and actually going to make me feel comfortable."
  },
  {
    "author": "Gerrit Smith",
    "category": "respect",
    "id": 60117,
    "text": "The Southern slave would obey God in respect to marriage, and also to the reading and studying of His word. But this, as we have seen, is forbidden him."
  },
  {
    "author": "Michael D. Higgins",
    "category": "respect",
    "id": 60304,
    "text": "The mandate I have received and for which I will speak with heart and head to implement over the next seven years had its four pillars - an inclusive citizenship, equality and participation and respect in a creative society creating an excellence in everything we Irish do."
  },
  {
    "author": "Frank Luntz",
    "category": "respect",
    "id": 60033,
    "text": "The language of America changed with the election of Bill Clinton, because with all due respect to my friends on the Republican side, Bill Clinton is the best communicator of the last 50 years. He felt your pain."
  },
  {
    "author": "Nathan Deal",
    "category": "respect",
    "id": 60318,
    "text": "Science without respect for human life is degrading to us all and reflects a hollow and deceptive philosophy, a philosophy that we as a people should never condone."
  },
  {
    "author": "Oliver Reed",
    "category": "respect",
    "id": 59695,
    "text": "Awe and respect are two different things."
  },
  {
    "author": "Ashley Tisdale",
    "category": "respect",
    "id": 59787,
    "text": "Cheerleaders deserve a lot of respect for what they do."
  },
  {
    "author": "E. M. Forster",
    "category": "respect",
    "id": 59562,
    "text": "The people I respect most behave as if they were immortal and as if society was eternal."
  },
  {
    "author": "Robert Stack",
    "category": "respect",
    "id": 59746,
    "text": "A great chef is an artist that I truly respect."
  },
  {
    "author": "Eli Whitney",
    "category": "respect",
    "id": 59453,
    "text": "I have always believed that I should have had no difficulty in causing my rights to be respected."
  },
  {
    "author": "Zinedine Zidane",
    "category": "respect",
    "id": 59888,
    "text": "We were a family who had come from nothing and now we had respect from French people of all sorts."
  },
  {
    "author": "Jared Leto",
    "category": "respect",
    "id": 60047,
    "text": "My mother is very, very smart and commands respect because she has a lot of respect for herself."
  },
  {
    "author": "Hideki Tojo",
    "category": "respect",
    "id": 60280,
    "text": "To advocate a New Order was to seek freedom and respect for peoples without prejudice, and to seek a stable basis for the existence all peoples, equally, and free of threats."
  },
  {
    "author": "Johnny Vegas",
    "category": "respect",
    "id": 59755,
    "text": "I've got too much respect for stand-ups to call myself one."
  },
  {
    "author": "Jena Malone",
    "category": "respect",
    "id": 59654,
    "text": "A lot of the powerful religious leaders, from Jesus to Buddha to Tibetan monks, they're really talking about the same things: love and acceptable, and the value of friendship, and respecting yourself so you can respect others."
  },
  {
    "author": "Nikita Khrushchev",
    "category": "respect",
    "id": 59798,
    "text": "Economics is a subject that does not greatly respect one's wishes."
  },
  {
    "author": "Frank Lloyd Wright",
    "category": "respect",
    "id": 59582,
    "text": "Respect the masterpiece. It is true reverence to man. There is no quality so great, none so much needed now."
  },
  {
    "author": "Wislawa Szymborska",
    "category": "respect",
    "id": 59925,
    "text": "Solitude is very important in my work as a mode of inspiration, but isolation is not good in this respect. I am not writing poetry about isolation."
  },
  {
    "author": "Bertrand Russell",
    "category": "respect",
    "id": 59519,
    "text": "Against my will, in the course of my travels, the belief that everything worth knowing was known at Cambridge gradually wore off. In this respect my travels were very useful to me."
  },
  {
    "author": "Ambrose Bierce",
    "category": "respect",
    "id": 59529,
    "text": "We submit to the majority because we have to. But we are not compelled to call our attitude of subjection a posture of respect."
  },
  {
    "author": "Taylor Swift",
    "category": "respect",
    "id": 59569,
    "text": "I love making new friends and I respect people for a lot of different reasons."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "respect",
    "id": 59459,
    "text": "Property is intended to serve life, and no matter how much we surround it with rights and respect, it has no personal being. It is part of the earth man walks on. It is not man."
  },
  {
    "author": "David Hasselhoff",
    "category": "respect",
    "id": 60130,
    "text": "Ninety-nine percent of people now call me The Hoff - and it's out of respect."
  },
  {
    "author": "Tecumseh",
    "category": "respect",
    "id": 59428,
    "text": "Show respect to all people, but grovel to none."
  },
  {
    "author": "Francois Hollande",
    "category": "respect",
    "id": 59857,
    "text": "The United Nations will be at the heart of our international activities. France will assume its full responsibilities at the Security Council by putting its status at the service of peace, respect for human rights and development."
  },
  {
    "author": "Shia LaBeouf",
    "category": "respect",
    "id": 59640,
    "text": "So it's kind of nervous to be in this situation, but at the same time you look at all those actors and the work that they've done, I've been in bigger films than all of them and still kept my integrity and still kept my respect."
  },
  {
    "author": "Lena Horne",
    "category": "respect",
    "id": 60038,
    "text": "Every color I can think of and nationality, we were all touched by Dr. King because he made us like each other and respect each other."
  },
  {
    "author": "Dan Quayle",
    "category": "respect",
    "id": 59594,
    "text": "I deserve respect for the things I did not do."
  },
  {
    "author": "Susan Powter",
    "category": "respect",
    "id": 60129,
    "text": "What's natural and right is to go with the energy of how it all has to work together. What's natural and right is interconnectedness, not individualism. What is natural and right is respect for the system, not killing the system. What's natural and right is love."
  },
  {
    "author": "Richard Bach",
    "category": "respect",
    "id": 59494,
    "text": "I want to be very close to someone I respect and admire and have somebody who feels the same way about me."
  },
  {
    "author": "Roger Mahony",
    "category": "respect",
    "id": 60341,
    "text": "With respect to Holy Communion, it is up to the communicant to decide whether they are in a state of grace and worthy to receive the Eucharist. Each one of us makes that decision."
  },
  {
    "author": "Jessica Simpson",
    "category": "respect",
    "id": 59749,
    "text": "I have so much respect for my mom and all the women across the world."
  },
  {
    "author": "Aristotle",
    "category": "respect",
    "id": 59478,
    "text": "Democracy arises out of the notion that those who are equal in any respect are equal in all respects because men are equally free, they claim to be absolutely equal."
  },
  {
    "author": "Lafcadio Hearn",
    "category": "respect",
    "id": 59805,
    "text": "But every great scripture, whether Hebrew, Indian, Persian, or Chinese, apart from its religious value will be found to have some rare and special beauty of its own and in this respect the original Bible stands very high as a monument of sublime poetry and of artistic prose."
  },
  {
    "author": "William Hague",
    "category": "respect",
    "id": 59744,
    "text": "We are not directly involved in Syria. But we will be working with our partners in the European Union and at the United Nations to see if we can persuade the Syrian authorities to go, as I say, more in that direction of respect for democracy and human rights."
  },
  {
    "author": "Laurence Sterne",
    "category": "respect",
    "id": 59422,
    "text": "Respect for ourselves guides our morals, respect for others guides our manners."
  },
  {
    "author": "Katy Perry",
    "category": "respect",
    "id": 59636,
    "text": "I'm a good girl because I really believe in love, integrity, and respect."
  },
  {
    "author": "William Lyon Phelps",
    "category": "respect",
    "id": 59747,
    "text": "This is the final test of a gentleman: his respect for those who can be of no possible service to him."
  },
  {
    "author": "Robin Gibb",
    "category": "respect",
    "id": 59941,
    "text": "The Bee Gees, to us, was the three brothers. In Maurice's name, we would respect that and not be the Bee Gees anymore."
  },
  {
    "author": "James Wolcott",
    "category": "respect",
    "id": 59766,
    "text": "Bad acting comes in many bags, various odors. It can be performed by cardboard refugees from an Ed Wood movie, reciting their dialogue off an eye chart, or by hopped-up pros looking to punch a hole through the fourth wall from pure ballistic force of personality, like Joe Pesci in a bad mood. I can respect bad acting that owns its own style."
  },
  {
    "author": "Anthony Anderson",
    "category": "respect",
    "id": 60172,
    "text": "If they respect the craft and what we're doing and they bring something to the table and they work hard, I don't care what you do as your side job or as your day job."
  },
  {
    "author": "Sam Raimi",
    "category": "respect",
    "id": 60148,
    "text": "My father told me to dress to reflect the respect you have for the people around you. I've never forgotten that."
  },
  {
    "author": "Rick Wakeman",
    "category": "respect",
    "id": 59692,
    "text": "My faith is very private to me. It plays an important part in my life, but I do not try and throw my beliefs at others. I have tremendous respect for all faiths and beliefs, but have a deep concern that religion and faith are currently a long way apart from each other."
  },
  {
    "author": "Jennifer Granholm",
    "category": "respect",
    "id": 59877,
    "text": "With respect to the environment in our state and our state's future - in addition to water which is very important here - I think it is crucial for him to make a sincere commitment to energy efficiency, fuel efficiency, by helping us to produce those cars of the future."
  },
  {
    "author": "Patti LaBelle",
    "category": "respect",
    "id": 59976,
    "text": "Whenever I go out, so many people who respect me ask me what to do in a certain situation. A lot of times, I didn't know the answers because sometimes I was going through the same sort of thing. But then later on, I would think of things that people told me."
  },
  {
    "author": "Justin Townes Earle",
    "category": "respect",
    "id": 60039,
    "text": "I always watched movies and rooted for the bad guys, you know? I've always been that kind of guy. I still hold some respect for criminals that are good at their jobs."
  },
  {
    "author": "Jim Carrey",
    "category": "respect",
    "id": 59541,
    "text": "I need privacy. I would think that because what I do makes a lot of people happy that I might deserve a little bit of respect in return. Instead, the papers try to drag me off my pedestal."
  },
  {
    "author": "Charles Vest",
    "category": "respect",
    "id": 60385,
    "text": "We will work with industrial or Dept. Of Defence sponsorship as long as we keep our principals of openness firm we're proud to work with the military, and they respect that in turn."
  },
  {
    "author": "David Brainerd",
    "category": "respect",
    "id": 59681,
    "text": "Ardent love or desire introduced, as passionately longing to please and glorify the Divine Being, to be in every respect conformed to him, and in that way to enjoy him."
  },
  {
    "author": "Andy Gibb",
    "category": "respect",
    "id": 60197,
    "text": "I respect the people who buy my records and come to my concerts. It's only fair that I always try to give them the very best that's in me. After all, I need them more than they need me."
  },
  {
    "author": "Ausonius",
    "category": "respect",
    "id": 60303,
    "text": "When about to commit a base deed, respect thyself, though there is no witness."
  },
  {
    "author": "Ed Westwick",
    "category": "respect",
    "id": 60232,
    "text": "When I find someone who is worth it, I'll be nice and respect that person and put some time in."
  },
  {
    "author": "William Dean Howells",
    "category": "respect",
    "id": 59720,
    "text": "The conqueror is regarded with awe the wise man commands our respect but it is only the benevolent man that wins our affection."
  },
  {
    "author": "Martin Van Buren",
    "category": "respect",
    "id": 60058,
    "text": "With respect to the northeastern boundary of the United States, no official correspondence between this Government and that of Great Britain has passed since that communicated to Congress toward the close of their last session."
  },
  {
    "author": "Curt Schilling",
    "category": "respect",
    "id": 59897,
    "text": "I think I've earned a certain level of respect, based on my accomplishments and my consistency."
  },
  {
    "author": "Dave Matthews",
    "category": "respect",
    "id": 59938,
    "text": "Success turns a lot of people off. I have a pretty solid sense of joy and respect that irritates people, and can irritate me, too."
  },
  {
    "author": "Jeremy London",
    "category": "respect",
    "id": 60241,
    "text": "If I am still doing what I'm doing and I still have respect in this town, haven't done anything completely and utterly stupid, then I'll be happy with myself."
  },
  {
    "author": "Sylvester Stallone",
    "category": "respect",
    "id": 59771,
    "text": "Like I said, I've got too much respect for women to marry them, but that doesn't mean you can't support them emotionally and financially."
  },
  {
    "author": "Ahmed Chalabi",
    "category": "respect",
    "id": 60382,
    "text": "I call on the international community to be fair to the Iraqi people. My position is that we respect international resolutions but in return demand justice and accountability for those who stole Iraq's money."
  },
  {
    "author": "Will Oldham",
    "category": "respect",
    "id": 60200,
    "text": "I have more respect for somebody who points at his ideal - in this case, the ideal of the pirate - and then becomes something that's more radical, more exciting, more subversive than a pirate could ever be."
  },
  {
    "author": "John Stuart Mill",
    "category": "respect",
    "id": 59606,
    "text": "The duty of man is the same in respect to his own nature as in respect to the nature of all other things, namely not to follow it but to amend it."
  }
]

quotes['romantic'] = [
  {
    "author": "Jeff Bridges",
    "category": "romantic",
    "id": 60406,
    "text": "Most cynics are really crushed romantics: they've been hurt, they're sensitive, and their cynicism is a shell that's protecting this tiny, dear part in them that's still alive."
  },
  {
    "author": "Bai Ling",
    "category": "romantic",
    "id": 60677,
    "text": "I'm a romantic, and I like guys to bring flowers and buy some gifts - not expensive things, just romantic things."
  },
  {
    "author": "Gertrude Stein",
    "category": "romantic",
    "id": 60426,
    "text": "Romance is everything."
  },
  {
    "author": "Elizabeth Wurtzel",
    "category": "romantic",
    "id": 60559,
    "text": "I was meant to date the captain of the football team, I was going to be on a romantic excursion every Saturday night, I was destined to be collecting corsages from every boy in town before prom, accepting such floral offerings like competing sacrifices to a Delphic goddess."
  },
  {
    "author": "Douglas Horton",
    "category": "romantic",
    "id": 60427,
    "text": "The more we are filled with thoughts of lust the less we find true romantic love."
  },
  {
    "author": "Ashley Greene",
    "category": "romantic",
    "id": 60588,
    "text": "I would have loved to do 'Alice in Wonderland.' Being a 'Bond' girl would always be fun. We had a lot of action in 'Eclipse' and I'd definitely like to continue down the action road. I want to do a romantic period piece, but those are really hard to get made because they're very expensive and there's not a huge demographic."
  },
  {
    "author": "Beatrice Wood",
    "category": "romantic",
    "id": 60568,
    "text": "And I think maybe all women, if they just had a chance, would be romantic and believe in love and not sex. And men believe in sex and not love."
  },
  {
    "author": "Florence Welch",
    "category": "romantic",
    "id": 60581,
    "text": "I've always been attracted to romantic secondhand clothes. But my style developed as I started going to these strange raves where everybody had these very definitive costumes."
  },
  {
    "author": "David Coverdale",
    "category": "romantic",
    "id": 60684,
    "text": "When I was very, very young, seven years old, I heard there was school where you could go to learn to draw. That was my absolute driven passion, to become an artist or a painter. So the romantic realist in me, I studied to be a graphic design artist and an art teacher."
  },
  {
    "author": "William Butler Yeats",
    "category": "romantic",
    "id": 60409,
    "text": "Wine comes in at the mouth And love comes in at the eye That's all we shall know for truth Before we grow old and die."
  },
  {
    "author": "Morgan Freeman",
    "category": "romantic",
    "id": 60491,
    "text": "I don't get off on romantic parts. But I often think if I had had my dental work done early on, well, maybe."
  },
  {
    "author": "Christian Bale",
    "category": "romantic",
    "id": 60542,
    "text": "I will never say never, but I will say never to doing the more typical romantic comedies. You know, unless I'm getting audited and I'm on the street and I desperately need some dough and that's the only thing that I'm getting."
  },
  {
    "author": "Paul Simon",
    "category": "romantic",
    "id": 60439,
    "text": "There's something about the sound of a train that's very romantic and nostalgic and hopeful."
  },
  {
    "author": "Harlan Coben",
    "category": "romantic",
    "id": 60549,
    "text": "The state of New Jersey is really two places - terrible cities and wonderful suburbs. I live in the suburbs, the final battleground of the American dream, where people get married and have kids and try to scratch out a happy life for themselves. It's very romantic in that way, but a bit naive. I like to play with that in my work."
  },
  {
    "author": "Richard Thompson",
    "category": "romantic",
    "id": 60732,
    "text": "People want to hear about the extremes of human nature. They want things that are larger than their own lives, and more romantic, and not necessarily of their own experiences."
  },
  {
    "author": "Sarah Jessica Parker",
    "category": "romantic",
    "id": 60410,
    "text": "When men attempt bold gestures, generally it's considered romantic. When women do it, it's often considered desperate or psycho."
  },
  {
    "author": "Sidney Poitier",
    "category": "romantic",
    "id": 60550,
    "text": "I had to satisfy the action fans, the romantic fans, the intellectual fans. It was a terrific burden."
  },
  {
    "author": "Fred Durst",
    "category": "romantic",
    "id": 60551,
    "text": "I'm a romantic guy."
  },
  {
    "author": "Amy Poehler",
    "category": "romantic",
    "id": 60633,
    "text": "There's something so romantic about being broke in New York. You gotta do it. You have to live there once without any money, and then you have to live there when you have money. Let me tell you, of the two, the latter is far better."
  },
  {
    "author": "Bela Lugosi",
    "category": "romantic",
    "id": 60590,
    "text": "The vampire was a complete change from the usual romantic characters I was playing, but it was a success."
  },
  {
    "author": "Jane Campion",
    "category": "romantic",
    "id": 60598,
    "text": "Women today are dealing with both their independence and also the fact that their lives are built around finding and satisfying the romantic models we grew up with."
  },
  {
    "author": "Gabrielle Union",
    "category": "romantic",
    "id": 60569,
    "text": "I love romantic comedies. They're for me the easiest thing to do and the most natural to do. There's nothing natural about holding an uzi hanging out of a moving van shooting at people. That's not second nature to me, thank God."
  },
  {
    "author": "Morgan Freeman",
    "category": "romantic",
    "id": 60511,
    "text": "I have never acted he has never been cast in a romantic lead or has been cast opposite a female love interest in any movie he starred in."
  },
  {
    "author": "Diane Kruger",
    "category": "romantic",
    "id": 60504,
    "text": "I don't have any romantic ideas about marriage. Trust me. A white dress... ? No. It's not something for me."
  },
  {
    "author": "F. Scott Fitzgerald",
    "category": "romantic",
    "id": 60411,
    "text": "I'm a romantic a sentimental person thinks things will last, a romantic person hopes against hope that they won't."
  },
  {
    "author": "Gary Oldman",
    "category": "romantic",
    "id": 60538,
    "text": "I don't think Hollywood knows what to do with me. I would imagine that when it comes to romantic comedies, my name would be pretty low down on the list."
  },
  {
    "author": "Tom Hanks",
    "category": "romantic",
    "id": 60554,
    "text": "If you look at romantic comedies as pieces of commerce, the audience is looking for wish fulfillment."
  },
  {
    "author": "Ashley Tisdale",
    "category": "romantic",
    "id": 60545,
    "text": "I'm a big romantic, so I love guys who are romantic too."
  },
  {
    "author": "Mindy Kaling",
    "category": "romantic",
    "id": 60468,
    "text": "When men hear women want a commitment, they think it means commitment to a romantic relationship, but that's not it. It's a commitment to not floating around anymore. I want a guy who is entrenched in his own life. Entrenched is awesome."
  },
  {
    "author": "Sammy Davis, Jr.",
    "category": "romantic",
    "id": 60438,
    "text": "There are certain romances that belong in certain cities, in a certain atmosphere, in a certain time."
  },
  {
    "author": "Bobby Cannavale",
    "category": "romantic",
    "id": 60805,
    "text": "I'm getting a lot of uninteresting romantic lead guys that look good and fall in love sort of garbage."
  },
  {
    "author": "Tim Roth",
    "category": "romantic",
    "id": 60518,
    "text": "Well, I think first it was rare for me to do anything that had any kind of a romantic note to it."
  },
  {
    "author": "Laurie Holden",
    "category": "romantic",
    "id": 60757,
    "text": "I really, really, really want to do a silly romantic comedy where I can just have a crush on the guy, trip over myself, and laugh and be goofy. I just feel like all I do is cry, sob, and fight zombies and the bad guys."
  },
  {
    "author": "Donna Tartt",
    "category": "romantic",
    "id": 60680,
    "text": "But romantic vision can also lead one away from certain very hard, ugly truths about life that are important to know."
  },
  {
    "author": "John Cusack",
    "category": "romantic",
    "id": 60525,
    "text": "But no, I don't really like romantic comedies, so I don't really care. I never go see 'em."
  },
  {
    "author": "Andre Dubus III",
    "category": "romantic",
    "id": 60765,
    "text": "I got a degree in sociology, didn't read much fiction in college, and I was a pretty political, left-wing type of guy. I wanted to do some kind of work in social change and make things better for the poor man, and I was very romantic and passionate about it."
  },
  {
    "author": "Jeremy Renner",
    "category": "romantic",
    "id": 60597,
    "text": "I lived by the candlelight for two years because I couldn't afford power. It was nice and romantic at the time, but if you can't afford power you're pretty broke. You endure it."
  },
  {
    "author": "Catherine Deneuve",
    "category": "romantic",
    "id": 60497,
    "text": "That's what I like about film-it can be bizarre, classic, normal, romantic. Cinema is to me the most versatile thing."
  },
  {
    "author": "Halle Berry",
    "category": "romantic",
    "id": 60547,
    "text": "I am a hopeless romantic. And I won't stop till I get it right."
  },
  {
    "author": "Nigel Cole",
    "category": "romantic",
    "id": 60798,
    "text": "It seems to me that romantic comedies used to be about falling in love, but in recent years they've really become just comedies where the love story is only there as a spine to hang the jokes on."
  },
  {
    "author": "Patricia Clarkson",
    "category": "romantic",
    "id": 60743,
    "text": "You're always close and you never get that big romantic lead."
  },
  {
    "author": "Dick Dale",
    "category": "romantic",
    "id": 60665,
    "text": "I always wanted a guitar. I always wanted to be a cowboy singer because I also listened to Hank Williams, and he would always sing these neat romantic songs."
  },
  {
    "author": "Elizabeth Meriwether",
    "category": "romantic",
    "id": 60755,
    "text": "I think in a lot of romantic comedies it ends with a kiss, and I feel like in modern day relationships, and maybe just my own experience, it starts with a kiss and then all sort of falls apart and then comes together. You're texting. You're wondering what's going on. There's no definitions, there's no labels."
  },
  {
    "author": "Corey Hart",
    "category": "romantic",
    "id": 60456,
    "text": "My idea of a romantic night is to watch action films."
  },
  {
    "author": "David Lyons",
    "category": "romantic",
    "id": 60810,
    "text": "The thing about romance and romantic movies is that they can be somewhat melodramatic. For a lot of actors, there's a certain cringe factor that's involved with that."
  },
  {
    "author": "Danica McKellar",
    "category": "romantic",
    "id": 60479,
    "text": "I love surprises - champagne and strawberries, all that pampering, romantic stuff. Guys ought to know how to pamper their women properly."
  },
  {
    "author": "Dilma Rousseff",
    "category": "romantic",
    "id": 60802,
    "text": "I am not an adolescent, nor a romantic. I analyze objectively."
  },
  {
    "author": "Eric Bana",
    "category": "romantic",
    "id": 60576,
    "text": "I fell in love with many women at school who had no idea I existed. I'm a bit of a romantic."
  },
  {
    "author": "Igor Stravinsky",
    "category": "romantic",
    "id": 60586,
    "text": "Conductors' careers are made for the most part with 'Romantic' music. 'Classic' music eliminates the conductor we do not remember him in it."
  },
  {
    "author": "Jamie Oliver",
    "category": "romantic",
    "id": 60627,
    "text": "I'm better with my hands, and I always loved the slightly romantic idea of starting with bits of wood and being able to create something to sit on, to eat from, to store your clothes in."
  },
  {
    "author": "Alanis Morissette",
    "category": "romantic",
    "id": 60482,
    "text": "My greatest environments in which I can grow, or grow up, is in personal romantic relationships with a man."
  },
  {
    "author": "Gloria Steinem",
    "category": "romantic",
    "id": 60666,
    "text": "I'd like to be played as a child by Natalie Wood. I'd have some romantic scenes as Audrey Hepburn and have gritty black-and-white scenes as Patricia Neal."
  },
  {
    "author": "Bill Pullman",
    "category": "romantic",
    "id": 60785,
    "text": "Truthfully, I almost avoided 'While You Were Sleeping,' because I find those romantic comedies kind of precious, and they're full of lines that leave you feeling a little bewildered when you say them."
  },
  {
    "author": "Michael Haneke",
    "category": "romantic",
    "id": 60541,
    "text": "People expect me to be dark and gloomy, then write that I'm a jolly chap, and after all, that is what I am. I think it's a case of an absolute romantic naivety that there should be a parallel between the work and the artist."
  },
  {
    "author": "Alison Krauss",
    "category": "romantic",
    "id": 60707,
    "text": "Being in the studio is a really romantic time."
  },
  {
    "author": "Nick Carter",
    "category": "romantic",
    "id": 60441,
    "text": "I used to try to draw my girlfriends. I think one of the most romantic things that anybody can do is draw a portrait of the person you love."
  },
  {
    "author": "Brooke Burke",
    "category": "romantic",
    "id": 60610,
    "text": "I go to Saint Barth in the French West Indies for two weeks each year. That place is amazing. Amazing people, beautiful beaches, great wine, wonderful harbors... It's incredibly romantic."
  },
  {
    "author": "Italo Calvino",
    "category": "romantic",
    "id": 60777,
    "text": "What Romantic terminology called genius or talent or inspiration is nothing other than finding the right road empirically, following one's nose, taking shortcuts."
  },
  {
    "author": "Kim Kardashian",
    "category": "romantic",
    "id": 60470,
    "text": "I think I'll always be a hopeless romantic."
  },
  {
    "author": "Feist",
    "category": "romantic",
    "id": 60685,
    "text": "Well, there's just some universal truths in a way that I've just observed to be true. You read Voltaire. You read modern literature. Anywhere you go, there's these observations about romantic love and what it does people, and these rotten feelings that rarely are people meaning to do that to each other."
  },
  {
    "author": "Arthur Symons",
    "category": "romantic",
    "id": 60812,
    "text": "A realist, in Venice, would become a romantic by mere faithfulness to what he saw before him."
  },
  {
    "author": "Melanie Fiona",
    "category": "romantic",
    "id": 60726,
    "text": "I am a bit of a hopeless romantic. I really do have a faith and a belief in love, and when I love, I love hard."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "romantic",
    "id": 60536,
    "text": "Marriage is not simply a romantic union between two people it's also a political and economic contract of the highest order."
  },
  {
    "author": "Anne Boyd",
    "category": "romantic",
    "id": 60814,
    "text": "Consider what a romantic expedition you are on take notes."
  },
  {
    "author": "Stephen Moyer",
    "category": "romantic",
    "id": 60638,
    "text": "Vampires are so old that they don't need to impress anyone anymore. They're comfortable in their own skin. It's this enigmatic strength that's very romantic and old-fashioned. I think it goes back to something of a Victorian attitude of finding a strong man who's going to look after his woman."
  },
  {
    "author": "James Van Der Beek",
    "category": "romantic",
    "id": 60702,
    "text": "I'm not about to talk about what's romantic in my life - I figure if you talk about it once - then that's an open invitation for everyone to dig into your personal life even further."
  },
  {
    "author": "Billy Strayhorn",
    "category": "romantic",
    "id": 60459,
    "text": "Romance is mush, stifling those who strive."
  },
  {
    "author": "Matthew Macfadyen",
    "category": "romantic",
    "id": 60635,
    "text": "My vanity is I'm terribly romantic! But being married is lovely."
  },
  {
    "author": "Giada De Laurentiis",
    "category": "romantic",
    "id": 60558,
    "text": "Lidia Bastianich, sorry, but kind of boring. I mean, I love Lidia, but you can fall asleep watching her. And Mario Batali? I love Mario to death... but he's not romantic or sensual. Those are the things I bring to the table."
  },
  {
    "author": "Barbara Broccoli",
    "category": "romantic",
    "id": 60783,
    "text": "I think Bond the character is distinct: He's British, he has a certain code that he lives by, he's incorruptible... he's a classical hero, but he's also fallible. He has inner demons, inner conflicts, and he's a romantic."
  },
  {
    "author": "Andre Maurois",
    "category": "romantic",
    "id": 60414,
    "text": "We owe to the Middle Ages the two worst inventions of humanity - romantic love and gunpowder."
  },
  {
    "author": "Aaron Eckhart",
    "category": "romantic",
    "id": 60450,
    "text": "Yeah, but there's nobody who represents romance to me like Cary Grant."
  },
  {
    "author": "Debra Messing",
    "category": "romantic",
    "id": 60681,
    "text": "I think the institute of marriage is a noble thing. The idea of a partner for life is incredibly romantic. But now we're living to 100. A hundred years ago people were dying at age 37. Til death do us part was a much different deal."
  },
  {
    "author": "Gus Van Sant",
    "category": "romantic",
    "id": 60557,
    "text": "The dark comedies tend to be in a non-releasable area. There can be romantic comedies. There can be dramas. But there's no 'dark comedy' inbox for the advertising."
  },
  {
    "author": "Frank Black",
    "category": "romantic",
    "id": 60718,
    "text": "It more or less has the shape of a love song, but 'Crescent Moon' reflects more my longing for an ancient romantic context that includes wild animals, fire, danger of death, stellar navigation, and seasonal intuition."
  },
  {
    "author": "Francine Pascal",
    "category": "romantic",
    "id": 60804,
    "text": "I get some of my ideas from watching my three daughters, but most of them come from my own memories of growing up. I can remember how romantic I was, not just about love, but romance in the classic sense - the romantic ideals: of honor and truth, of loyalty, sacrifice and fairness. Those were the elements that made a story satisfying to me."
  },
  {
    "author": "Carmen Electra",
    "category": "romantic",
    "id": 60628,
    "text": "I'm very romantic."
  },
  {
    "author": "Rachel Hunter",
    "category": "romantic",
    "id": 60455,
    "text": "I'm a dreadful romantic. No matter what I go through in life, I want to fall in love with a man."
  },
  {
    "author": "Cameron Diaz",
    "category": "romantic",
    "id": 60434,
    "text": "I believe that when you're in love you have to pour your heart and soul out to your partner... or why bother? So in that sense I'm an incurable romantic when it comes to men."
  },
  {
    "author": "John Sandford",
    "category": "romantic",
    "id": 60803,
    "text": "There's something about marriage that is not as intensely romantic or interesting as a couple's first meeting."
  },
  {
    "author": "Betty White",
    "category": "romantic",
    "id": 60548,
    "text": "I'm not what you might call sexy, but I'm romantic. Let's put it that way."
  },
  {
    "author": "Dar Williams",
    "category": "romantic",
    "id": 60454,
    "text": "Therapy was the biggest romance of my life."
  },
  {
    "author": "Josh Lucas",
    "category": "romantic",
    "id": 60705,
    "text": "New York has got this sort of wonderful romantic idea of the South."
  },
  {
    "author": "Chevy Chase",
    "category": "romantic",
    "id": 60698,
    "text": "Once I got married and had kids, I moved away from romantic roles, because it seemed wrong to have my 3-year-old wondering why Daddy was kissing someone else."
  },
  {
    "author": "Elizabeth Olsen",
    "category": "romantic",
    "id": 60660,
    "text": "I'm the first one who sees every romantic comedy in theaters."
  },
  {
    "author": "James L. Brooks",
    "category": "romantic",
    "id": 60773,
    "text": "I love romantic comedy, but I think you have to have another idea that you're chasing along with romantic comedy."
  },
  {
    "author": "Rachel McAdams",
    "category": "romantic",
    "id": 60566,
    "text": "I'm a hopeless romantic and I believe that you can find love in many different places and be very conflicted. I've discovered as I've grown up that life is far more complicated than you think it is when you're a kid. It isn't just a straightforward fairytale."
  },
  {
    "author": "Jane Campion",
    "category": "romantic",
    "id": 60599,
    "text": "I think that the romantic impulse is in all of us and that sometimes we live it for a short time, but it's not part of a sensible way of living. It's a heroic path and it generally ends dangerously."
  },
  {
    "author": "Joel Madden",
    "category": "romantic",
    "id": 60540,
    "text": "I've flown across America, I've scaled fences, I've stood under windows and gone out of my way hundreds of times. I'm a hopeless romantic. There's no hope for me."
  },
  {
    "author": "Emily Dickinson",
    "category": "romantic",
    "id": 60407,
    "text": "Morning without you is a dwindled dawn."
  },
  {
    "author": "Fergie",
    "category": "romantic",
    "id": 60604,
    "text": "I love crying at romantic movies like 'The Notebook.' I'm always bawling."
  },
  {
    "author": "Anita Brookner",
    "category": "romantic",
    "id": 60445,
    "text": "The essence of romantic love is that wonderful beginning, after which sadness and impossibility may become the rule."
  },
  {
    "author": "Mindy Kaling",
    "category": "romantic",
    "id": 60513,
    "text": "I regard romantic comedies as a subgenre of sci-fi, in which the world operates according to different rules than my regular human world."
  },
  {
    "author": "Philippa Gregory",
    "category": "romantic",
    "id": 60782,
    "text": "Although some people think I am a romantic novelist I have always thought of myself as a rather gritty radical historian."
  },
  {
    "author": "Christopher Atkins",
    "category": "romantic",
    "id": 60717,
    "text": "I'm really a romantic at heart."
  },
  {
    "author": "Louis C. K.",
    "category": "romantic",
    "id": 60477,
    "text": "If you're a woman and a guy's ever said anything romantic to you, he just left off the second part that would have made you sick if you could have heard it."
  },
  {
    "author": "Maggie Gallagher",
    "category": "romantic",
    "id": 60565,
    "text": "Romantic lovers require from each other at least the facade of reason: We desire to be what romantic love makes us appear in the other's eyes. We want to imagine we are deserving of the love we inspire."
  },
  {
    "author": "Morris Chestnut",
    "category": "romantic",
    "id": 60696,
    "text": "When you are the lead in a romantic comedy, you have to worry about people really liking you."
  },
  {
    "author": "David Fincher",
    "category": "romantic",
    "id": 60683,
    "text": "For a romantic comedy to be three hours long, that's longer than most marriages."
  },
  {
    "author": "Michelle Trachtenberg",
    "category": "romantic",
    "id": 60457,
    "text": "I don't like to search too much. I find it is easier when romance finds you."
  }
]

quotes['sad'] = [
  {
    "author": "Anne Perry",
    "category": "sad",
    "id": 61335,
    "text": "I think it's a terrible thing to write and not enjoy it. It's a sad thing. But of course a lot of people do work because they need to eat. And we all need to eat, but that's not the only reason to work. You couldn't have paid me not to write."
  },
  {
    "author": "Jonathan King",
    "category": "sad",
    "id": 61320,
    "text": "I was sad Jon Ronson, who wrote in the Guardian and has made a TV show for Channel 4, took against me."
  },
  {
    "author": "Khalil Gibran",
    "category": "sad",
    "id": 60822,
    "text": "Sadness is but a wall between two gardens."
  },
  {
    "author": "Franz Schubert",
    "category": "sad",
    "id": 60876,
    "text": "Nobody understands another's sorrow, and nobody another's joy."
  },
  {
    "author": "Jim Lehrer",
    "category": "sad",
    "id": 61110,
    "text": "I've traveled around the country and I read local newspapers and all of that, and it's a sad, sad thing to go from city to city and see the small newspapers and they're tiny. They're tiny not only in size but also in scope."
  },
  {
    "author": "David Bailey",
    "category": "sad",
    "id": 60961,
    "text": "All pictures are unnatural. All pictures are sad because they're about dead people. Paintings you don't think of in a special time or with a specific event. With photos I always think I'm looking at something dead."
  },
  {
    "author": "Voltaire",
    "category": "sad",
    "id": 60909,
    "text": "He who is not just is severe, he who is not wise is sad."
  },
  {
    "author": "Miguel de Unamuno",
    "category": "sad",
    "id": 60901,
    "text": "It is sad not to love, but it is much sadder not to be able to love."
  },
  {
    "author": "Thomas Carlyle",
    "category": "sad",
    "id": 60913,
    "text": "Wondrous is the strength of cheerfulness, and its power of endurance - the cheerful man will do more in the same time, will do it better, will preserve it longer, than the sad or sullen."
  },
  {
    "author": "Julia Louis-Dreyfus",
    "category": "sad",
    "id": 61212,
    "text": "Elaine is just in pain. I think Elaine has become very, very sad woman. She is someone who is in deep need of many hours of analysis and I like to think that I'm not that type of person."
  },
  {
    "author": "Anne Robinson",
    "category": "sad",
    "id": 61294,
    "text": "Sad old blokes, I'm told, now dream of me with a whip in hand."
  },
  {
    "author": "Jamie Foxx",
    "category": "sad",
    "id": 61071,
    "text": "Nobody wants to hear R&ampB. It's sad. If you want to be on the radio you got to stay young."
  },
  {
    "author": "Dianna Agron",
    "category": "sad",
    "id": 61221,
    "text": "It's really sad looking at people like Lindsay Lohan. She's an amazing actress, but you see what happens when people know too much about your personal life. They start not being able to look at you the same way professionally. I don't want that to happen to me."
  },
  {
    "author": "Miranda Lambert",
    "category": "sad",
    "id": 60942,
    "text": "Falling in love is awesome, but I'm never drawn to happy songs per se, so whenever you sit down to write a heartbreak song and you're happily in love, it's like, 'OK, now I have to go back to a sad place to get something good.'"
  },
  {
    "author": "Nina Arianda",
    "category": "sad",
    "id": 61246,
    "text": "Before I left for Germany, I had gotten accepted to the performing arts high school in New York, which was a big dream of mine. And having to leave that was very sad for me."
  },
  {
    "author": "Roger Milla",
    "category": "sad",
    "id": 61345,
    "text": "I only really watch sport. That's where you see real joy. I don't like watching much else on TV, because it's generally either twisted or sad."
  },
  {
    "author": "Sara Teasdale",
    "category": "sad",
    "id": 61135,
    "text": "Though I know he loves me, tonight my heart is sad his kiss was not so wonderful as all the dreams I had."
  },
  {
    "author": "Ernestine Rose",
    "category": "sad",
    "id": 61282,
    "text": "I know that some endeavor to throw the mantle of romance over the subject and treat woman like some ideal existence, not liable to the ills of life. Let those deal in fancy who have nothing better to deal in we have to do with sober, sad realities, with stubborn facts."
  },
  {
    "author": "Teddy Thompson",
    "category": "sad",
    "id": 61242,
    "text": "I love the sad songs with their maudlin, self-deprecating, almost funny lyrics. As an Englishman, they make a lot of sense."
  },
  {
    "author": "Gabriel Mann",
    "category": "sad",
    "id": 61313,
    "text": "Nolan has the strangest affect on people. You know, I think there's something very sad and little boy about him, but at the same time the way he goes about everything is so awkward and obnoxious. He can never say the right thing, you know? And I think if he just didn't try so hard and calmed down, people might actually like him a bit more!"
  },
  {
    "author": "Robert Wyatt",
    "category": "sad",
    "id": 61116,
    "text": "People say, oh it's a shame, you're not nostalgic about the '60s. Well actually, it's quite good, when you think of it. Wouldn't it be sad if I was sitting here wishing it back?"
  },
  {
    "author": "Josh Duhamel",
    "category": "sad",
    "id": 61210,
    "text": "'Vegas' was something very close to me. I had such a blast doing that. I'm still a little upset that we never really got to shoot that final episode. So many people were invested in it. I'll always be sad about that."
  },
  {
    "author": "Vaclav Havel",
    "category": "sad",
    "id": 60952,
    "text": "Sometimes I wonder if suicides aren't in fact sad guardians of the meaning of life."
  },
  {
    "author": "Demian Bichir",
    "category": "sad",
    "id": 61251,
    "text": "It would be sad if my best work had been 20 years ago and now I only had memories."
  },
  {
    "author": "Adam Lambert",
    "category": "sad",
    "id": 61010,
    "text": "Los Angeles can be a really sad city."
  },
  {
    "author": "Pete Townshend",
    "category": "sad",
    "id": 61002,
    "text": "Even modern English people are imperious, superior, ridden by class. All of the hypocrisy and the difficulties that are endemic in being British also make it an incredibly fertile place culturally. A brilliant place to live. Sad but true."
  },
  {
    "author": "H. G. Wells",
    "category": "sad",
    "id": 60831,
    "text": "Affliction comes to us, not to make us sad but sober not to make us sorry but wise."
  },
  {
    "author": "Andrew Gross",
    "category": "sad",
    "id": 61354,
    "text": "'Eyes Wide Open' took shape from two real life events straight from my own past. One was the sad suicide of my young nephew, a troubled kid, who was found at the bottom of a landmark cliff in central California. The second was a chance encounter forty years ago with none other than, ahem, Charles Manson!"
  },
  {
    "author": "Andy Kaufman",
    "category": "sad",
    "id": 61100,
    "text": "My mother sent me to psychiatrists since the age of four because she didn't think little boys should be sad. When my brother was born, I stared out the window for days. Can you imagine that?"
  },
  {
    "author": "Anna Quindlen",
    "category": "sad",
    "id": 61012,
    "text": "If I get the forty additional years statisticians say are likely coming to me, I could fit in at least one, maybe two new lifetimes. Sad that only one of those lifetimes can include being the mother of young children."
  },
  {
    "author": "Judith Rossner",
    "category": "sad",
    "id": 61352,
    "text": "It's astonishing what some women will put up with just to have a warm body. Some of the brightest women I know are just obsessed with that search. It's very sad."
  },
  {
    "author": "Dee Dee Ramone",
    "category": "sad",
    "id": 61273,
    "text": "It was sad when Sid Vicious died... I was freaked out when Phil Lynott died from Thin Lizzy. I cried. It was too crazy."
  },
  {
    "author": "Jean Paul",
    "category": "sad",
    "id": 60965,
    "text": "What makes old age so sad is not that our joys but our hopes cease."
  },
  {
    "author": "George Jones",
    "category": "sad",
    "id": 60964,
    "text": "Country fans need to support country music by buying albums and concert tickets for traditional artists or the music will just fade away. And that would be really sad."
  },
  {
    "author": "Tom Atkins",
    "category": "sad",
    "id": 61388,
    "text": "You know, they just don't make big movie stars the way they used to, maybe because the system has changed, the studio system, but it's sad to see people like Jimmy Stewart go, all the giants of the past."
  },
  {
    "author": "Jennifer Weiner",
    "category": "sad",
    "id": 61179,
    "text": "Money is a tremendous advantage in just about everything, but in terms of reproduction, if you're a poor woman and you are infertile, it's like too bad, so sad. And if you are a wealthy woman, you can kind of buy whatever you want."
  },
  {
    "author": "Keri Russell",
    "category": "sad",
    "id": 61192,
    "text": "It's sad when girls think they don't have anything going on except being pretty."
  },
  {
    "author": "Matthias Schoenaerts",
    "category": "sad",
    "id": 61374,
    "text": "I hooked up with director Jacques Audiard for this film called 'Rust &amp Bone' with Marion Cotillard. I loved that experience so much I'm truly sad that it's over!"
  },
  {
    "author": "Jerry Stiller",
    "category": "sad",
    "id": 61283,
    "text": "It can make you sad to look at pictures from your youth. So there's a trick to it. The trick is not to look at the later pictures."
  },
  {
    "author": "Jean de la Bruyere",
    "category": "sad",
    "id": 60937,
    "text": "It is a sad thing when men have neither the wit to speak well nor the judgment to hold their tongues."
  },
  {
    "author": "Amanda Hocking",
    "category": "sad",
    "id": 61292,
    "text": "I was always depressed growing up. There wasn't a reason for it, I just was. I was sad and morose. I cried a lot, I wrote a lot, and I read a lot and that was how I dealt with it."
  },
  {
    "author": "Henry Louis Gates",
    "category": "sad",
    "id": 60985,
    "text": "The sad truth is that without complex business partnerships between African elites and European traders and commercial agents, the slave trade to the New World would have been impossible, at least on the scale it occurred."
  },
  {
    "author": "Beth Henley",
    "category": "sad",
    "id": 61238,
    "text": "What I loved about the acting class was that you got to think all day long about a person that wasn't you, and figure out why they were sad and what they wanted, what they dreamed."
  },
  {
    "author": "Shania Twain",
    "category": "sad",
    "id": 60983,
    "text": "I'll always be sad that my marriage ended."
  },
  {
    "author": "Slavoj Zizek",
    "category": "sad",
    "id": 61256,
    "text": "What if the Soviet intervention was a blessing in disguise? It saved the myth that if the Soviets were not to intervene, there would have been some flowering authentic democratic socialism and so on. I'm a little bit more of a pessimist there. I think that the Soviets - it's a very sad lesson - by their intervention, saved the myth."
  },
  {
    "author": "Stephanie Beacham",
    "category": "sad",
    "id": 61324,
    "text": "One of the reasons I wanted to teach deaf children was because it made me very sad that they spoke so clumsily and that they moved with less grace that I knew was possible of deaf people."
  },
  {
    "author": "Jim Capaldi",
    "category": "sad",
    "id": 61224,
    "text": "This was an important part of my life. But it was also sad that we didn't play there, cause we had such alot of fans that were waiting for us and Brazilians are great people. It's now my second home."
  },
  {
    "author": "Nancy Pelosi",
    "category": "sad",
    "id": 61048,
    "text": "We're sad about some of the losses of members of great seniority and distinction in the Congress, and some very new members, who will no longer be serving with us."
  },
  {
    "author": "Christopher Durang",
    "category": "sad",
    "id": 61344,
    "text": "Since it's based on my parents, it's more emotionally close to me than some of my more surreal plays. And then I like the balance of the comic and the sad. It should play as funny, but you should care about the characters and feel sad for them."
  },
  {
    "author": "Christina Rossetti",
    "category": "sad",
    "id": 60956,
    "text": "Better by far you should forget and smile that you should remember and be sad."
  },
  {
    "author": "Robert Stack",
    "category": "sad",
    "id": 61204,
    "text": "Someone once accused me of being like Eliot Ness. I sad no sir, I'm not E.N., but I can promise you that I'm not Al Capone!"
  },
  {
    "author": "Nick Rhodes",
    "category": "sad",
    "id": 61073,
    "text": "You listen to a piece of music and it will remind you of something - it might make you happy, it might make you sad, but it is very emotive. And I think that Duran Duran have always understood that."
  },
  {
    "author": "Stephen King",
    "category": "sad",
    "id": 60918,
    "text": "And in real life endings aren't always neat, whether they're happy endings, or whether they're sad endings."
  },
  {
    "author": "Madeleine Peyroux",
    "category": "sad",
    "id": 60893,
    "text": "You have to let it all hang out, let go of the ideas that were more comfortable and embrace some of the sadness in your life."
  },
  {
    "author": "Eric Holder",
    "category": "sad",
    "id": 61163,
    "text": "Saturdays and Sundays, America in the year 2009 does not in some ways differ significantly from the country that existed almost 50 years ago. This is truly sad."
  },
  {
    "author": "Kathryn Stockett",
    "category": "sad",
    "id": 61241,
    "text": "It can be really powerful to write something when you're sad."
  },
  {
    "author": "William Shakespeare",
    "category": "sad",
    "id": 60898,
    "text": "I hold the world but as the world, Gratiano A stage where every man must play a part, And mine is a sad one."
  },
  {
    "author": "Margaret J. Wheatley",
    "category": "sad",
    "id": 60940,
    "text": "I'm sad to report that in the past few years, ever since uncertainty became our insistent 21st century companion, leadership has taken a great leap backwards to the familiar territory of command and control."
  },
  {
    "author": "Kristin Davis",
    "category": "sad",
    "id": 60936,
    "text": "It's nice to be with someone, but I don't think you need to be in a relationship to feel complete. That would be really sad."
  },
  {
    "author": "Mary J. Blige",
    "category": "sad",
    "id": 61025,
    "text": "I remember a time when all my fans were crying and sad and going through hell. Now, we're trying to uplift each other and accept ourselves for who we are, even if nobody else does."
  },
  {
    "author": "Jack Nicholson",
    "category": "sad",
    "id": 60989,
    "text": "There were points in my life where I felt oddly irresistible to women. I'm not in that state now and that makes me sad."
  },
  {
    "author": "Bonnie Blair",
    "category": "sad",
    "id": 61275,
    "text": "It's sad to know I'm done. But looking back, I've got a lot of great memories."
  },
  {
    "author": "Rob Sheffield",
    "category": "sad",
    "id": 61086,
    "text": "In their heyday, the Pet Shop Boys were the Interpol of the Eighties, dressing up to sing really weird pop songs about lust and loneliness in the big city. They're low-pro now, not retro-worshipped in the manner of Depeche Mode, New Order, or The Cure, but you can hear the reason why - these guys are too sad."
  },
  {
    "author": "Beth Henley",
    "category": "sad",
    "id": 61237,
    "text": "Some really good things kind of swing both ways and I like to see people that can swing really, really, really sad and horrible and terrible and really, really, really beautiful and funny."
  },
  {
    "author": "Jim Rohn",
    "category": "sad",
    "id": 60826,
    "text": "The walls we build around us to keep sadness out also keeps out the joy."
  },
  {
    "author": "Evander Holyfield",
    "category": "sad",
    "id": 61185,
    "text": "Deep down, I reckon the sweetest moment will come when it's finally all over. When, at last, I know that I can stop fighting. Of course it'll also be a little sad. The sweetest moments, y'know, always come with just a little sadness."
  },
  {
    "author": "Amber Tamblyn",
    "category": "sad",
    "id": 61196,
    "text": "My father comes from a generation of film that actors my age don't even know about, which is really sad."
  },
  {
    "author": "Steve Lacy",
    "category": "sad",
    "id": 61102,
    "text": "You have to sound sad first of all, then maybe later you can sound good."
  },
  {
    "author": "Andre Rieu",
    "category": "sad",
    "id": 61197,
    "text": "The waltz can be sad and at the same time uplifting. You have to see life from both sides, and the waltz encapsulates that. If you're in my audience you give yourself to me and the waltz will grab you."
  },
  {
    "author": "Ralph Steadman",
    "category": "sad",
    "id": 61087,
    "text": "It makes me so desperately sad to witness just how unforgivably wretched our world has become."
  },
  {
    "author": "Taraji P. Henson",
    "category": "sad",
    "id": 60887,
    "text": "Every human walks around with a certain kind of sadness. They may not wear it on their sleeves, but it's there if you look deep."
  },
  {
    "author": "Marc Maron",
    "category": "sad",
    "id": 61118,
    "text": "I'm sad to see the passing of the great drug warriors. I certainly did my part in that battle and I don't regret any of it."
  },
  {
    "author": "Alanis Morissette",
    "category": "sad",
    "id": 60843,
    "text": "We're taught to be ashamed of confusion, anger, fear and sadness, and to me they're of equal value to happiness, excitement and inspiration."
  },
  {
    "author": "Harry Dean Stanton",
    "category": "sad",
    "id": 61284,
    "text": "You want people to feel something when you tell a story, whether they feel happy or whether they feel sad."
  },
  {
    "author": "Sammy Hagar",
    "category": "sad",
    "id": 61036,
    "text": "All he cares about is going out there with his Jack Daniels bottle. Nothing has changed. That's kind of sad. If David was doing better than he used to be, then that would be different. But it was a joke and he made it that way."
  },
  {
    "author": "Jesse Jackson",
    "category": "sad",
    "id": 61028,
    "text": "It is a historical error for those who were not there to just refer to August 28th as 'I Have a Dream' speech day. That is a real disservice to those who were there. It was a sad day. It was not a celebration environment."
  },
  {
    "author": "Ibrahim Babangida",
    "category": "sad",
    "id": 61141,
    "text": "Informed by our sad experience of history, we require nothing short of a foundation for lasting democracy."
  },
  {
    "author": "Tab Hunter",
    "category": "sad",
    "id": 61263,
    "text": "All the things that happen to people in the industry today, the actors, what they have to put up with, all the people wanting to know every single moment of their lives - I think it's really sad."
  },
  {
    "author": "Doug Davidson",
    "category": "sad",
    "id": 61307,
    "text": "If you win all the time, you lose the drama in life. To make the happy moments happy, you need the sad moments too."
  },
  {
    "author": "Russell Pearce",
    "category": "sad",
    "id": 61211,
    "text": "I mean, that's a sad day in America when you're recalled because you did what you said you were going to do, and the public voted you in to do that."
  },
  {
    "author": "Natalie Imbruglia",
    "category": "sad",
    "id": 61013,
    "text": "It's much easier to write when you're sad. But you can end up isolated and depressed because you almost need to put yourself in that situation to have that angst to write from."
  },
  {
    "author": "Yoko Ono",
    "category": "sad",
    "id": 60842,
    "text": "Experiencing sadness and anger can make you feel more creative, and by being creative, you can get beyond your pain or negativity."
  },
  {
    "author": "Joan Allen",
    "category": "sad",
    "id": 61017,
    "text": "I was a very good girl for a long time, that's what really drew me to acting. The stage was the perfect place to be outrageous, to be sad, to be angry, to be all these different things."
  },
  {
    "author": "Ernie Harwell",
    "category": "sad",
    "id": 60920,
    "text": "It's time to say goodbye, but I think goodbyes are sad and I'd much rather say hello. Hello to a new adventure."
  },
  {
    "author": "Natalie Imbruglia",
    "category": "sad",
    "id": 61091,
    "text": "Divorce was very sad, obviously, but now I've gotten over it."
  },
  {
    "author": "Craig Charles",
    "category": "sad",
    "id": 61186,
    "text": "I have a stepladder. It's a very nice stepladder but it's sad that I never knew my real ladder."
  },
  {
    "author": "Harlan Coben",
    "category": "sad",
    "id": 61034,
    "text": "You can't have an up without a down, a right without a left, a back without a front - or a happy without a sad."
  },
  {
    "author": "Doug Coupland",
    "category": "sad",
    "id": 60923,
    "text": "Christmas makes everything twice as sad."
  },
  {
    "author": "Kerry Washington",
    "category": "sad",
    "id": 61200,
    "text": "I am co-writing a screenplay now and I'm working on the rights to another story I want to do. So I plan to produce and direct. So, for me, I don't really feel that I am vulnerable to that sad baggage that comes with the business of filmmaking."
  },
  {
    "author": "Mike Mills",
    "category": "sad",
    "id": 61134,
    "text": "My experience, with both my parents, is that grief has a lot of down, sad things, but I was also really emotionally raw, in the first year after each of them passed. Flowers smelled more intensely, my relationships were hotter, and I was more willing to risk. I was going for it a lot more. I was 'unsober' and I wasn't playing by my rules."
  },
  {
    "author": "Dierks Bentley",
    "category": "sad",
    "id": 61278,
    "text": "I try to make an album that reflects what I love about country music. It's not just all about happy parties all the time. There are some sad songs."
  },
  {
    "author": "John Cleese",
    "category": "sad",
    "id": 60975,
    "text": "I was very sad to hear of the death of Ronnie Barker, who was such a warm, friendly and encouraging presence to have when I started in television. He was also a great comic actor to learn from."
  },
  {
    "author": "Garrison Keillor",
    "category": "sad",
    "id": 60947,
    "text": "They say such nice things about people at their funerals that it makes me sad that I'm going to miss mine by just a few days."
  },
  {
    "author": "Charles Mackay",
    "category": "sad",
    "id": 61132,
    "text": "There is no such thing as death. In nature nothing dies. From each sad remnant of decay, some forms of life arise so shall his life be taken away before he knoweth that he hath it."
  },
  {
    "author": "Arthur Wellesley",
    "category": "sad",
    "id": 61151,
    "text": "Next to a lost battle, nothing is so sad as a battle that has been won."
  },
  {
    "author": "Helen Clark",
    "category": "sad",
    "id": 61170,
    "text": "Well in the end the world can crank itself up to sanctions, as it has with Zimbabwe, another sad case."
  },
  {
    "author": "Helen Keller",
    "category": "sad",
    "id": 60820,
    "text": "I seldom think about my limitations, and they never make me sad. Perhaps there is just a touch of yearning at times but it is vague, like a breeze among flowers."
  },
  {
    "author": "Eugene O'Neill",
    "category": "sad",
    "id": 60888,
    "text": "One should either be sad or joyful. Contentment is a warm sty for eaters and sleepers."
  },
  {
    "author": "Toni Braxton",
    "category": "sad",
    "id": 61220,
    "text": "I know for works for me - those wonderful sad love songs."
  },
  {
    "author": "Emeli Sande",
    "category": "sad",
    "id": 61285,
    "text": "It would be sad if we lost our instinct and our courage to love and protect."
  }
]

quotes['science'] = [
  {
    "author": "Henri Poincare",
    "category": "science",
    "id": 61725,
    "text": "Science is built up of facts, as a house is with stones. But a collection of facts is no more a science than a heap of stones is a house."
  },
  {
    "author": "Michael Shermer",
    "category": "science",
    "id": 62367,
    "text": "But the power of science lies in open publication, which, with the rise of the Internet, is no longer constrained by the price of paper."
  },
  {
    "author": "Henry Adams",
    "category": "science",
    "id": 61682,
    "text": "Some day science may have the existence of mankind in power, and the human race can commit suicide by blowing up the world."
  },
  {
    "author": "Kary Mullis",
    "category": "science",
    "id": 61963,
    "text": "Science grows like a weed every year."
  },
  {
    "author": "John Polkinghorne",
    "category": "science",
    "id": 61880,
    "text": "If the experience of science teaches anything, it's that the world is very strange and surprising. The many revolutions in science have certainly shown that."
  },
  {
    "author": "John Charles Polanyi",
    "category": "science",
    "id": 62037,
    "text": "Today, Academies of Science use their influence around the world in support of human rights."
  },
  {
    "author": "Kevin J. Anderson",
    "category": "science",
    "id": 61957,
    "text": "We sat around on a hotel balcony with a bottle of wine and tried to figure out how you would go about blowing up a planet. That's the kind of conversations science fiction writers have when they get together. We don't talk about football or anything like that."
  },
  {
    "author": "Edward Thorndike",
    "category": "science",
    "id": 62011,
    "text": "Psychology is the science of the intellects, characters and behavior of animals including man."
  },
  {
    "author": "Josef Albers",
    "category": "science",
    "id": 61895,
    "text": "It is not so for art in appreciation because art is concerned with human behavior. And science is concerned with the behavior of metal or energy. It depends on what the fashion is. Now today it's energy. It's the same soul behind it. The same soul, you see."
  },
  {
    "author": "John Polkinghorne",
    "category": "science",
    "id": 61738,
    "text": "I also think we need to maintain distinctions - the doctrine of creation is different from a scientific cosmology, and we should resist the temptation, which sometimes scientists give in to, to try to assimilate the concepts of theology to the concepts of science."
  },
  {
    "author": "Michelangelo Antonioni",
    "category": "science",
    "id": 62362,
    "text": "I meant exactly what I said: that we are saddled with a culture that hasn't advanced as far as science."
  },
  {
    "author": "Richard Dawkins",
    "category": "science",
    "id": 61537,
    "text": "It has become almost a cliche to remark that nobody boasts of ignorance of literature, but it is socially acceptable to boast ignorance of science and proudly claim incompetence in mathematics."
  },
  {
    "author": "Kyle Chandler",
    "category": "science",
    "id": 61851,
    "text": "What I do is not rocket science, but I sure do love it."
  },
  {
    "author": "John Charles Polanyi",
    "category": "science",
    "id": 62035,
    "text": "Science gives us a powerful vocabulary, and it is impossible to produce a vocabulary with which one can only say nice things."
  },
  {
    "author": "Michael Behe",
    "category": "science",
    "id": 62278,
    "text": "The theory of undirected evolution is already dead, but the work of science continues."
  },
  {
    "author": "James Wood",
    "category": "science",
    "id": 62380,
    "text": "I was really bright as a kid and tested well, and it was clear that I was going to get scholarships to any schools I wanted. My dad always said I could be an engineer at that time it was the elite of society: steady job, working in science, which was then the answer to every problem we had. It was kind of a mandate. Kind of a dream he had for me."
  },
  {
    "author": "Will Durant",
    "category": "science",
    "id": 61637,
    "text": "Every science begins as philosophy and ends as art."
  },
  {
    "author": "Earl Wilson",
    "category": "science",
    "id": 61882,
    "text": "Science may never come up with a better office communication system than the coffee break."
  },
  {
    "author": "Clyde Tombaugh",
    "category": "science",
    "id": 62182,
    "text": "Unfortunately, a lot of the concepts in the Bible are based on ancient mythology that doesn't fit the findings of science."
  },
  {
    "author": "Richard Dawkins",
    "category": "science",
    "id": 61566,
    "text": "I am one of those scientists who feels that it is no longer enough just to get on and do science. We have to devote a significant proportion of our time and resources to defending it from deliberate attack from organised ignorance."
  },
  {
    "author": "Octavia Butler",
    "category": "science",
    "id": 61890,
    "text": "What I'm working on now - I'm back to fantasy, although considering that it's me, I'm turning it into a kind of science fantasy. It's a vampire story - but my vampires are biological vampires. They didn't become vampires because someone bit them they were born that way."
  },
  {
    "author": "Johan Huizinga",
    "category": "science",
    "id": 62302,
    "text": "In Europe art has to a large degree taken the place of religion. In America it seems rather to be science."
  },
  {
    "author": "Karen Armstrong",
    "category": "science",
    "id": 61712,
    "text": "Mythology and science both extend the scope of human beings. Like science and technology, mythology, as we shall see, is not about opting out of this world, but about enabling us to live more intensely within it."
  },
  {
    "author": "Judy Biggert",
    "category": "science",
    "id": 62360,
    "text": "Since coming to Congress, I have been advocating for increased resources for research in the physical sciences and for the Department of Energy Office of Science in particular."
  },
  {
    "author": "Karl Kraus",
    "category": "science",
    "id": 61854,
    "text": "Science is spectral analysis. Art is light synthesis."
  },
  {
    "author": "Laurel Clark",
    "category": "science",
    "id": 62236,
    "text": "It's such a long mission and we get to spend so much time in space... we're doing such exciting research. And I don't want to overemphasize the life science research, but as a physician the life science research that we're doing is extremely exciting."
  },
  {
    "author": "Albert Einstein",
    "category": "science",
    "id": 61488,
    "text": "Science without religion is lame, religion without science is blind."
  },
  {
    "author": "Paul Samuelson",
    "category": "science",
    "id": 61829,
    "text": "Economics has never been a science - and it is even less now than a few years ago."
  },
  {
    "author": "Yancy Butler",
    "category": "science",
    "id": 62300,
    "text": "I dig science fiction, though it was never really my thing."
  },
  {
    "author": "Louis Pasteur",
    "category": "science",
    "id": 61888,
    "text": "There does not exist a category of science to which one can give the name applied science. There are science and the applications of science, bound together as the fruit of the tree which bears it."
  },
  {
    "author": "Paul Dirac",
    "category": "science",
    "id": 61615,
    "text": "In science one tries to tell people, in such a way as to be understood by everyone, something that no one ever knew before. But in poetry, it's the exact opposite."
  },
  {
    "author": "Marcus Aurelius",
    "category": "science",
    "id": 61409,
    "text": "Nothing has such power to broaden the mind as the ability to investigate systematically and truly all that comes under thy observation in life."
  },
  {
    "author": "Robert Trout",
    "category": "science",
    "id": 62177,
    "text": "A successful society is characterized by a rising living standard for its population, increasing investment in factories and basic infrastructure, and the generation of additional surplus, which is invested in generating new discoveries in science and technology."
  },
  {
    "author": "Arthur M. Schlesinger",
    "category": "science",
    "id": 61442,
    "text": "Science and technology revolutionize our lives, but memory, tradition and myth frame our response."
  },
  {
    "author": "Edwin Hubbel Chapin",
    "category": "science",
    "id": 62299,
    "text": "Fashion is the science of appearances, and it inspires one with the desire to seem rather than to be."
  },
  {
    "author": "Jeffery Deaver",
    "category": "science",
    "id": 62213,
    "text": "Certainly going back to Sherlock Holmes we have a tradition of forensic science featured in detective stories."
  },
  {
    "author": "Mary Douglas",
    "category": "science",
    "id": 62068,
    "text": "It seems true that the growth of science and secularism made organized Christianity feel under threat."
  },
  {
    "author": "Steve Wozniak",
    "category": "science",
    "id": 61922,
    "text": "Teachers started recognizing me and praising me for being smart in science and that made me want to be even smarter in science!"
  },
  {
    "author": "Emily Post",
    "category": "science",
    "id": 61824,
    "text": "Nothing is less important than which fork you use. Etiquette is the science of living. It embraces everything. It is ethics. It is honor."
  },
  {
    "author": "Karen Armstrong",
    "category": "science",
    "id": 61867,
    "text": "Well, logos is science or reason, something that helps us to function practically and effectively in the world, and it must therefore be closely in tune and reflect accurately the realities of the world around us."
  },
  {
    "author": "Henry Fielding",
    "category": "science",
    "id": 61885,
    "text": "Fashion is the science of appearance, and it inspires one with the desire to seem rather than to be."
  },
  {
    "author": "Jaron Lanier",
    "category": "science",
    "id": 61919,
    "text": "We're losing track of the vastness of the potential for computer science. We really have to revive the beautiful intellectual joy of it, as opposed to the business potential."
  },
  {
    "author": "William Blake",
    "category": "science",
    "id": 61531,
    "text": "He who would do good to another must do it in Minute Particulars: general Good is the plea of the scoundrel, hypocrite, and flatterer, for Art and Science cannot exist but in minutely organized Particulars."
  },
  {
    "author": "Stephen Leacock",
    "category": "science",
    "id": 61740,
    "text": "Advertising: the science of arresting the human intelligence long enough to get money from it."
  },
  {
    "author": "James Spader",
    "category": "science",
    "id": 62222,
    "text": "I grew up a Red Sox fan. I grew up going to Fenway Park and the Museum of Fine Arts and the Science Museum and Symphony Hall and going to the Common, walking around. My whole family at different times lived and worked in Boston."
  },
  {
    "author": "Konrad Lorenz",
    "category": "science",
    "id": 61426,
    "text": "It is a good morning exercise for a research scientist to discard a pet hypothesis every day before breakfast. It keeps him young."
  },
  {
    "author": "John Charles Polanyi",
    "category": "science",
    "id": 62034,
    "text": "Though neglectful of their responsibility to protect science, scientists are increasingly aware of their responsibility to society."
  },
  {
    "author": "J. J. Abrams",
    "category": "science",
    "id": 61874,
    "text": "I'd love to do a movie where the monster is human, where the issue is not otherworldly, or horror or science fiction."
  },
  {
    "author": "Michael Shermer",
    "category": "science",
    "id": 62366,
    "text": "We know evolution happened because innumerable bits of data from myriad fields of science conjoin to paint a rich portrait of life's pilgrimage."
  },
  {
    "author": "Lord Acton",
    "category": "science",
    "id": 61782,
    "text": "The science of politics is the one science that is deposited by the streams of history, like the grains of gold in the sand of a river and the knowledge of the past, the record of truths revealed by experience, is eminently practical, as an instrument of action and a power that goes to making the future."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "science",
    "id": 61524,
    "text": "There is no way that writers can be tamed and rendered civilized or even cured. The only solution known to science is to provide the patient with an isolation room, where he can endure the acute stages in private and where food can be poked in to him with a stick."
  },
  {
    "author": "Anton Chekhov",
    "category": "science",
    "id": 61613,
    "text": "The wealthy are always surrounded by hangers-on science and art are as well."
  },
  {
    "author": "Alton Brown",
    "category": "science",
    "id": 61837,
    "text": "Enough people have now mentioned Bill Nye the Science Guy to me that I now desperately avoid it all costs."
  },
  {
    "author": "Seth Lloyd",
    "category": "science",
    "id": 62325,
    "text": "Of course, not everybody's willing to go out and do the experiments, but for the people who are willing to go out and do that, - if the experiments don't work, then it means it's not science."
  },
  {
    "author": "Evan Esar",
    "category": "science",
    "id": 61698,
    "text": "Definition of Statistics: The science of producing unreliable facts from reliable figures."
  },
  {
    "author": "Roger Bannister",
    "category": "science",
    "id": 62042,
    "text": "Mothers, unless they were very poor, didn't work. Both of my parents had to leave education. My mother had to work in a cotton mill until 18 or 19, when she took some training in domestic science."
  },
  {
    "author": "John Desmond Bernal",
    "category": "science",
    "id": 62391,
    "text": "The relevance of Marxism to science is that it removes it from its imagined position of complete detachment and shows it as a part, but a critically important part, of economy and social development."
  },
  {
    "author": "Judy Biggert",
    "category": "science",
    "id": 62361,
    "text": "As the Nation's primary supporter of research in the physical sciences, the DOE Office of Science led the way in creating a unique system of large-scale, specialized, often one-of-a-kind facilities for scientific discovery."
  },
  {
    "author": "Francis Bacon",
    "category": "science",
    "id": 61419,
    "text": "If a man's wit be wandering, let him study the mathematics."
  },
  {
    "author": "John B. S. Haldane",
    "category": "science",
    "id": 62074,
    "text": "There can be no truce between science and religion."
  },
  {
    "author": "Louise Slaughter",
    "category": "science",
    "id": 62199,
    "text": "As a microbiologist, I am particularly concerned with Mr. Bush's blatant disregard for science."
  },
  {
    "author": "will.i.am",
    "category": "science",
    "id": 61806,
    "text": "It should be mandatory that you understand computer science."
  },
  {
    "author": "Blake Edwards",
    "category": "science",
    "id": 62101,
    "text": "Nothing matters but the facts. Without them, the science of criminal investigation is nothing more than a guessing game."
  },
  {
    "author": "Gregory Bateson",
    "category": "science",
    "id": 61828,
    "text": "Science, like art, religion, commerce, warfare, and even sleep, is based on presuppositions."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "science",
    "id": 61768,
    "text": "Humanity has experienced many revolutionary changes over the course of history: revolutions in agriculture, in science, industrial production, as well as numerous political revolutions. But these have all been limited to the external aspects of our individual and collective lives."
  },
  {
    "author": "Anna Torv",
    "category": "science",
    "id": 61995,
    "text": "With science fiction there's endless possibilities."
  },
  {
    "author": "Margaret J. Wheatley",
    "category": "science",
    "id": 61751,
    "text": "We know from science that nothing in the universe exists as an isolated or independent entity."
  },
  {
    "author": "Steven Pinker",
    "category": "science",
    "id": 62120,
    "text": "By exploring the political and moral colorings of discoveries about what makes us tick, we can have a more honest science and a less fearful intellectual milieu."
  },
  {
    "author": "Elbert Hubbard",
    "category": "science",
    "id": 61510,
    "text": "Art is the beautiful way of doing things. Science is the effective way of doing things. Business is the economic way of doing things."
  },
  {
    "author": "Claude Bernard",
    "category": "science",
    "id": 62028,
    "text": "Science does not permit exceptions."
  },
  {
    "author": "Henry W. Kendall",
    "category": "science",
    "id": 61731,
    "text": "Many people and governments share the mistaken belief that science, with new, ingenious devices and techniques, can rescue us from the troubles we face without our having to mend our ways and change our patterns of activity. This is not so."
  },
  {
    "author": "Steve Wozniak",
    "category": "science",
    "id": 62052,
    "text": "In some parts of life, like mathematics and science, yeah, I was a genius. I would top all the top scores you could ever measure it by."
  },
  {
    "author": "Fred Saberhagen",
    "category": "science",
    "id": 62318,
    "text": "I finally decided one day, reading science fiction magazines of the time, I could do at least as well as some of these people are doing. So I finally made a serious effort."
  },
  {
    "author": "Stephen Hawking",
    "category": "science",
    "id": 61591,
    "text": "Science predicts that many different kinds of universe will be spontaneously created out of nothing. It is a matter of chance which we are in."
  },
  {
    "author": "E. Y. Harburg",
    "category": "science",
    "id": 61485,
    "text": "Leave the atom alone."
  },
  {
    "author": "John Charles Polanyi",
    "category": "science",
    "id": 62032,
    "text": "Science never gives up searching for truth, since it never claims to have achieved it."
  },
  {
    "author": "Sam Ervin",
    "category": "science",
    "id": 61482,
    "text": "Polygraph tests are 20th-century witchcraft."
  },
  {
    "author": "George Meredith",
    "category": "science",
    "id": 62176,
    "text": "The man of science is nothing if not a poet gone wrong."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "science",
    "id": 61503,
    "text": "Every known fact in natural science was divined by the presentiment of somebody, before it was actually verified."
  },
  {
    "author": "Thomas Huxley",
    "category": "science",
    "id": 61421,
    "text": "Science is simply common sense at its best, that is, rigidly accurate in observation, and merciless to fallacy in logic."
  },
  {
    "author": "James C. Maxwell",
    "category": "science",
    "id": 62377,
    "text": "All the mathematical sciences are founded on relations between physical laws and laws of numbers, so that the aim of exact science is to reduce the problems of nature to the determination of quantities by operations with numbers."
  },
  {
    "author": "Margaret Mead",
    "category": "science",
    "id": 61417,
    "text": "Anthropology demands the open-mindedness with which one must look and listen, record in astonishment and wonder that which one would not have been able to guess."
  },
  {
    "author": "Octavia Butler",
    "category": "science",
    "id": 61984,
    "text": "I began reading science fiction before I was 12 and started writing science fiction around the same time."
  },
  {
    "author": "Timothy Leary",
    "category": "science",
    "id": 61679,
    "text": "Science is all metaphor."
  },
  {
    "author": "Michael Behe",
    "category": "science",
    "id": 62273,
    "text": "It is often said that science must avoid any conclusions which smack of the supernatural."
  },
  {
    "author": "Michael Behe",
    "category": "science",
    "id": 62275,
    "text": "It was a shock to people of the nineteenth century when they discovered, from observations science had made, that many features of the biological world could be ascribed to the elegant principle of natural selection."
  },
  {
    "author": "Walter Gilbert",
    "category": "science",
    "id": 62184,
    "text": "The virtues of science are skepticism and independence of thought."
  },
  {
    "author": "Werner Heisenberg",
    "category": "science",
    "id": 61820,
    "text": "The violent reaction on the recent development of modern physics can only be understood when one realises that here the foundations of physics have started moving and that this motion has caused the feeling that the ground would be cut from science."
  },
  {
    "author": "Roland Joffe",
    "category": "science",
    "id": 62089,
    "text": "Much of Indian science seems intuitive and not bound by the rigid thinking of classical scientists."
  },
  {
    "author": "Elizabeth Warren",
    "category": "science",
    "id": 61706,
    "text": "President Obama believes in a country where we invest in education, in roads and bridges, in science, and in the future so we can create new opportunities so the next kid can make it big and the kid afer that and the kid after that, that's what President Obama believes."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "science",
    "id": 61398,
    "text": "Science investigates religion interprets. Science gives man knowledge which is power religion gives man wisdom which is control."
  },
  {
    "author": "Edward Abbey",
    "category": "science",
    "id": 61672,
    "text": "There is science, logic, reason there is thought verified by experience. And then there is California."
  },
  {
    "author": "Ivan Pavlov",
    "category": "science",
    "id": 62304,
    "text": "But man has still another powerful resource: natural science with its strictly objective methods."
  },
  {
    "author": "Cathy McMorris",
    "category": "science",
    "id": 62293,
    "text": "Math and science fields are not the only areas where we see the United States lagging behind. Less than 1 percent of American high school students study the critical foreign languages of Arabic, Chinese, Japanese, Korean or Russian, combined."
  },
  {
    "author": "J. Michael Straczynski",
    "category": "science",
    "id": 61723,
    "text": "I also like to look at the dynamic that takes place between religion and science because, in a way, both are asking the same questions: Who are we? Where do we come from? Why are we here? Where are we going? The methodologies are diametrically opposed, but their motivation is the same the wellspring is the same in both cases."
  },
  {
    "author": "Tina Turner",
    "category": "science",
    "id": 61956,
    "text": "I was always attracted to science fiction movies."
  },
  {
    "author": "Iain Banks",
    "category": "science",
    "id": 62080,
    "text": "Science fiction has its own history, its own legacy of what's been done, what's been superseded, what's so much part of the furniture it's practically part of the fabric now, what's become no more than a joke... and so on. It's just plain foolish, as well as comically arrogant, to ignore all this, to fail to do the most basic research."
  },
  {
    "author": "Marie Curie",
    "category": "science",
    "id": 61658,
    "text": "In science, we must be interested in things, not in persons."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "science",
    "id": 61548,
    "text": "Shun no toil to make yourself remarkable by some talent or other yet do not devote yourself to one branch exclusively. Strive to get clear notions about all. Give up no science entirely for science is but one."
  },
  {
    "author": "Francois Rabelais",
    "category": "science",
    "id": 61721,
    "text": "Science without conscience is the death of the soul."
  }
]

quotes['smile'] = [
  {
    "author": "Jason Aldean",
    "category": "smile",
    "id": 62569,
    "text": "Country music in the mid-'90s was a big influence on my career, and I played all the songs that are referenced in ''94' back in my club days. Joe Diffie was rocking a sick mullet, and he was hotter than ever... just putting out monster hit after monster hit. It totally takes me back to those days, and it makes me smile every time I hear it."
  },
  {
    "author": "Emily Dickinson",
    "category": "smile",
    "id": 62406,
    "text": "They might not need me but they might. I'll let my head be just in sight a smile as small as mine might be precisely their necessity."
  },
  {
    "author": "Bobby Orr",
    "category": "smile",
    "id": 62478,
    "text": "The biggest thing we get out of it is seeing the kids smile. And hopefully we will also see that the lessons we're teaching - not only the fundamentals of hockey, but also the life values - are sinking in."
  },
  {
    "author": "Louis C. K.",
    "category": "smile",
    "id": 62520,
    "text": "When I take my kids out for dinner or lunch, people smile at us."
  },
  {
    "author": "Russell Baker",
    "category": "smile",
    "id": 62540,
    "text": "You can always tell folks from nonfolks. Folks like to feel good, like to smile for the camera when there's a big photo opportunity for a really good cause."
  },
  {
    "author": "Roma Downey",
    "category": "smile",
    "id": 62529,
    "text": "A smile costs about $240."
  },
  {
    "author": "Paula Radcliffe",
    "category": "smile",
    "id": 62580,
    "text": "You see, with me, when I'm nervous, I smile and laugh."
  },
  {
    "author": "Kin Hubbard",
    "category": "smile",
    "id": 62416,
    "text": "If you haven't seen your wife smile at a traffic cop, you haven't seen her smile her prettiest."
  },
  {
    "author": "Karl Shapiro",
    "category": "smile",
    "id": 62568,
    "text": "But with exquisite breathing you smile, with satisfaction of love, And I touch you again as you tick in the silence and settle in sleep."
  },
  {
    "author": "Christina Rossetti",
    "category": "smile",
    "id": 62427,
    "text": "Better by far you should forget and smile that you should remember and be sad."
  },
  {
    "author": "Simon Wiesenthal",
    "category": "smile",
    "id": 62490,
    "text": "Humour is the weapon of unarmed people: it helps people who are oppressed to smile at the situation that pains them."
  },
  {
    "author": "Ring Lardner",
    "category": "smile",
    "id": 62607,
    "text": "They gave each other a smile with a future in it."
  },
  {
    "author": "Michael Bloomberg",
    "category": "smile",
    "id": 62527,
    "text": "When I came into office, people said, 'Billionaire? How do they live? What do they eat? How do they sleep?' Today, they see me on the subway coming uptown. A couple of people say hi, some people smile and nod. Some people just sleep. It's not an issue."
  },
  {
    "author": "Yoko Ono",
    "category": "smile",
    "id": 62495,
    "text": "Smile in the mirror. Do that every morning and you'll start to see a big difference in your life."
  },
  {
    "author": "Ray Comfort",
    "category": "smile",
    "id": 62608,
    "text": "It takes both courage and talent to stand up in front of fellow human beings and make them crack a smile, and at the same time keep it clean."
  },
  {
    "author": "John Rowland",
    "category": "smile",
    "id": 62685,
    "text": "I hope there have been times when I made you all proud, or made you all smile or at least piqued your interest in this wonderful institution we call government."
  },
  {
    "author": "Doug Coupland",
    "category": "smile",
    "id": 62475,
    "text": "A bland smile is like a green light at an intersection, it feels good when you get one, but you forget it the moment you're past it."
  },
  {
    "author": "Victor Hugo",
    "category": "smile",
    "id": 62462,
    "text": "Joy's smile is much closer to tears than laughter."
  },
  {
    "author": "Jean Giraudoux",
    "category": "smile",
    "id": 62563,
    "text": "Those who weep recover more quickly than those who smile."
  },
  {
    "author": "Kirk Douglas",
    "category": "smile",
    "id": 62627,
    "text": "Virtue is not photogenic. What is it to be a nice guy? To be nothing, that's what. A big fat zero with a smile for everybody."
  },
  {
    "author": "Muriel Spark",
    "category": "smile",
    "id": 62445,
    "text": "It is impossible to persuade a man who does not disagree, but smiles."
  },
  {
    "author": "Rosamund Pike",
    "category": "smile",
    "id": 62632,
    "text": "And I like the look on people's faces when I say I'm doing this movie called Pride and Prejudice and they kind of smile, and then I say I'm in a movie called Doom and they kind of do a double take and try and put the two things together. And they never quite manage to."
  },
  {
    "author": "Robert Plant",
    "category": "smile",
    "id": 62476,
    "text": "It's sort of a feeling of power onstage. It's really the ability to make people smile, or just to turn them one way or another for that duration of time, and for it to have some effect later on. I don't really think it's power... it's the goodness."
  },
  {
    "author": "Sting",
    "category": "smile",
    "id": 62522,
    "text": "It takes a man to suffer ignorance and smile."
  },
  {
    "author": "Andy Rooney",
    "category": "smile",
    "id": 62408,
    "text": "If you smile when no one else is around, you really mean it."
  },
  {
    "author": "Elinor Wylie",
    "category": "smile",
    "id": 62589,
    "text": "In masks outrageous and austere, The years go by in single file But none has merited my fear, And none has quite escaped my smile."
  },
  {
    "author": "Paul Kane",
    "category": "smile",
    "id": 62637,
    "text": "I love a good laugh as well, I think that's so important in life, which is probably why I've dabbled in comedy writing as well as horror. I think if you can make someone laugh or smile it's the most special thing in the world."
  },
  {
    "author": "Neil Kinnock",
    "category": "smile",
    "id": 62702,
    "text": "The Parthenon without the marbles is like a smile with a tooth missing."
  },
  {
    "author": "Carson Kressley",
    "category": "smile",
    "id": 62648,
    "text": "I think ultimately I make people happy: Whether I'm doing the stage show, giving somebody a makeover, or designing clothing, the end goal is to make people smile."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "smile",
    "id": 62510,
    "text": "Religion can emerge in all forms of feeling: here wild anger, there the sweetest pain here consuming hatred, there the childlike smile of serene humility."
  },
  {
    "author": "Thomas S. Monson",
    "category": "smile",
    "id": 62421,
    "text": "Courage, not compromise, brings the smile of God's approval."
  },
  {
    "author": "Tracy Morgan",
    "category": "smile",
    "id": 62638,
    "text": "You get somebody to crack a smile, that's a beautiful thing."
  },
  {
    "author": "Arizona Muse",
    "category": "smile",
    "id": 62679,
    "text": "I don't know why my smile has become a signature pose. I think it's a nice change. I think people want to see happiness, so a smile is what can bring that. I didn't make it my trademark on purpose."
  },
  {
    "author": "Barry White",
    "category": "smile",
    "id": 62556,
    "text": "We forget that this music, music made by my brothers and sisters, is still a baby. It's just beginning. When I think of the possibilities, it makes me smile."
  },
  {
    "author": "Abraham Cahan",
    "category": "smile",
    "id": 62514,
    "text": "Remember that it is not enough to abstain from lying by word of mouth for the worst lies are often conveyed by a false look, smile, or act."
  },
  {
    "author": "Tim Duncan",
    "category": "smile",
    "id": 62471,
    "text": "I enjoy jokes, smiling, and making people smile. I may be a little different, but that's OK, who wants to be normal anyway?"
  },
  {
    "author": "Nathaniel Hawthorne",
    "category": "smile",
    "id": 62479,
    "text": "A stale article, if you dip it in a good, warm, sunny smile, will go off better than a fresh one that you've scowled upon."
  },
  {
    "author": "Jo Brand",
    "category": "smile",
    "id": 62538,
    "text": "So, my style has hopefully changed over the years and it is more relaxed, and I do tend to smile and have more than one expression these days hopefully - which I didn't at the beginning."
  },
  {
    "author": "Jim Broadbent",
    "category": "smile",
    "id": 62670,
    "text": "People smile at me as if they know me. I just smile back. They probably might know me."
  },
  {
    "author": "Alfred Lord Tennyson",
    "category": "smile",
    "id": 62419,
    "text": "A smile abroad is often a scowl at home."
  },
  {
    "author": "Nhat Hanh",
    "category": "smile",
    "id": 62468,
    "text": "If in our daily life we can smile, if we can be peaceful and happy, not only we, but everyone will profit from it. This is the most basic kind of peace work."
  },
  {
    "author": "Drew Barrymore",
    "category": "smile",
    "id": 62506,
    "text": "I don't mind a little Sturm und Drang. When I was doing 'Riding in Cars With Boys,' I wouldn't smile at anybody, because my character, Bev, was angry at the world. I'm the opposite. Inside my head I'd be like, God, I'll explain to you at the end of shooting that I'm not this person."
  },
  {
    "author": "Kellan Lutz",
    "category": "smile",
    "id": 62574,
    "text": "The coolest part about seeing a girl wear something comfortable is the smile that you can just feel coming through from inside her."
  },
  {
    "author": "William Ellery Channing",
    "category": "smile",
    "id": 62549,
    "text": "We smile at the ignorance of the savage who cuts down the tree in order to reach its fruit but the same blunder is made by every person who is over eager and impatient in the pursuit of pleasure."
  },
  {
    "author": "Simon Fowler",
    "category": "smile",
    "id": 62671,
    "text": "Get up and dance, get up and smile, get up and drink to the days that are gone in the shortest while."
  },
  {
    "author": "Jim Valvano",
    "category": "smile",
    "id": 62470,
    "text": "And if you see me, smile and maybe give me a hug. That's important to me too."
  },
  {
    "author": "John Ray",
    "category": "smile",
    "id": 62467,
    "text": "Beauty is power a smile is its sword."
  },
  {
    "author": "Jean Dujardin",
    "category": "smile",
    "id": 62619,
    "text": "I watched Gene Kelly for his smile, for his energy. Vittorio Gassman for his movement. Clark Gable for his mustache. And I watched Lassie who was happy as a dog."
  },
  {
    "author": "W. C. Fields",
    "category": "smile",
    "id": 62458,
    "text": "Start every day off with a smile and get it over with."
  },
  {
    "author": "Ofra Haza",
    "category": "smile",
    "id": 62532,
    "text": "I don't know what I would have done without believing in God. His support gives me power and energy to continue to be optimistic, to smile, not to be depressed. Sometimes, if things are not going so well, I don't cry. I say maybe it's meant to be."
  },
  {
    "author": "Goldie Hawn",
    "category": "smile",
    "id": 62431,
    "text": "I have witnessed the softening of the hardest of hearts by a simple smile."
  },
  {
    "author": "Thomas Paine",
    "category": "smile",
    "id": 62456,
    "text": "I love the man that can smile in trouble, that can gather strength from distress, and grow brave by reflection. 'Tis the business of little minds to shrink, but he whose heart is firm, and whose conscience approves his conduct, will pursue his principles unto death."
  },
  {
    "author": "Charles de Lint",
    "category": "smile",
    "id": 62429,
    "text": "I want to touch the heart of the world and make it smile."
  },
  {
    "author": "Vin Scully",
    "category": "smile",
    "id": 62660,
    "text": "I've told several writers this, and, again, I get back to it, but if you want to make God smile, tell him your plans."
  },
  {
    "author": "Washington Irving",
    "category": "smile",
    "id": 62422,
    "text": "A kind heart is a fountain of gladness, making everything in its vicinity freshen into smiles."
  },
  {
    "author": "Amber Heard",
    "category": "smile",
    "id": 62570,
    "text": "I think I've always had a certain amount of skepticism of this whole 'shut up and smile' theory. I haven't ever swallowed that pill so easily, although I tried."
  },
  {
    "author": "Bryan Cranston",
    "category": "smile",
    "id": 62541,
    "text": "We've been trained since kindergarten: Be nice, be kind, share, put on a smile. So we're conditioned to squash our natural selfish instincts, and that's the right thing for society."
  },
  {
    "author": "Allison Krauss",
    "category": "smile",
    "id": 62669,
    "text": "The smile on your face lets me know that you need me, there's a truth in your heart that says you'll never leave me, and the touch of your hand says you'll catch me whenever I fall."
  },
  {
    "author": "Denis Waitley",
    "category": "smile",
    "id": 62401,
    "text": "A smile is the light in your window that tells others that there is a caring, sharing person inside."
  },
  {
    "author": "John Philpot Curran",
    "category": "smile",
    "id": 62640,
    "text": "His smile is like the silver plate on a coffin."
  },
  {
    "author": "Henning Mankell",
    "category": "smile",
    "id": 62596,
    "text": "Many people say I smile more in Africa than in Sweden."
  },
  {
    "author": "Richard Brinsley Sheridan",
    "category": "smile",
    "id": 62441,
    "text": "To smile at the jest which plants a thorn in another's breast is to become a principal in the mischief."
  },
  {
    "author": "Richard M. DeVos",
    "category": "smile",
    "id": 62455,
    "text": "Few things in the world are more powerful than a positive push. A smile. A world of optimism and hope. A 'you can do it' when things are tough."
  },
  {
    "author": "James Thurber",
    "category": "smile",
    "id": 62505,
    "text": "The appreciative smile, the chuckle, the soundless mirth, so important to the success of comedy, cannot be understood unless one sits among the audience and feels the warmth created by the quality of laughter that the audience takes home with it."
  },
  {
    "author": "Yani Tseng",
    "category": "smile",
    "id": 62588,
    "text": "I like to smile. I smile even when I'm nervous since it calms me down and shows my friendliness."
  },
  {
    "author": "Jay Garner",
    "category": "smile",
    "id": 62717,
    "text": "We ought to be beating our chests every day. We ought to look in the mirror, stick out our chests, suck in our bellies, and say, 'Damn, we're Americans,' and smile."
  },
  {
    "author": "Cat Deeley",
    "category": "smile",
    "id": 62504,
    "text": "As long as you smile, have sparkly eyes and stick your shoulders back, nobody's going to notice your bum or your waist or your feet, for that matter."
  },
  {
    "author": "Serena Williams",
    "category": "smile",
    "id": 62435,
    "text": "I'm really exciting. I smile a lot, I win a lot, and I'm really sexy."
  },
  {
    "author": "Diane Lane",
    "category": "smile",
    "id": 62440,
    "text": "I think that anybody that smiles automatically looks better."
  },
  {
    "author": "Leonardo da Vinci",
    "category": "smile",
    "id": 62452,
    "text": "I love those who can smile in trouble, who can gather strength from distress, and grow brave by reflection. 'Tis the business of little minds to shrink, but they whose heart is firm, and whose conscience approves their conduct, will pursue their principles unto death."
  },
  {
    "author": "John Greenleaf Whittier",
    "category": "smile",
    "id": 62629,
    "text": "The smile of God is victory."
  },
  {
    "author": "Rebecca Black",
    "category": "smile",
    "id": 62686,
    "text": "I like guys with a nice smile. I know it's cliche, but it's so true! I like a guy with a nice smile and nice eyes."
  },
  {
    "author": "Hermann Hesse",
    "category": "smile",
    "id": 62519,
    "text": "To be able to throw one's self away for the sake of a moment, to be able to sacrifice years for a woman's smile - that is happiness."
  },
  {
    "author": "Frank A. Clark",
    "category": "smile",
    "id": 62598,
    "text": "Most smiles are started by another smile."
  },
  {
    "author": "Greta Garbo",
    "category": "smile",
    "id": 62460,
    "text": "Anyone who has a continuous smile on his face conceals a toughness that is almost frightening."
  },
  {
    "author": "Robert Bloch",
    "category": "smile",
    "id": 62503,
    "text": "The man who can smile when things go wrong has thought of someone else he can blame it on."
  },
  {
    "author": "Josh Billings",
    "category": "smile",
    "id": 62466,
    "text": "Marrying for love may be a bit risky, but it is so honest that God can't help but smile on it."
  },
  {
    "author": "Raymond Chandler",
    "category": "smile",
    "id": 62439,
    "text": "She gave me a smile I could feel in my hip pocket."
  },
  {
    "author": "Steven Spielberg",
    "category": "smile",
    "id": 62484,
    "text": "I wanted to do another movie that could make us laugh and cry and feel good about the world. I wanted to do something else that could make us smile. This is a time when we need to smile more and Hollywood movies are supposed to do that for people in difficult times."
  },
  {
    "author": "Arlen Specter",
    "category": "smile",
    "id": 62493,
    "text": "It's inspirational to see someone who is dying smile."
  },
  {
    "author": "Adrienne Barbeau",
    "category": "smile",
    "id": 62661,
    "text": "When I see myself on film it makes me smile, I mean making a good living doing what I enjoy is soo much fun. I just hope that everyone has the chance to enjoy life like I do."
  },
  {
    "author": "Andrea Thompson",
    "category": "smile",
    "id": 62696,
    "text": "When life takes me on a new journey, I simply remember the smile my first ballet recital put on my face and I move forward."
  },
  {
    "author": "Julien Benda",
    "category": "smile",
    "id": 62573,
    "text": "And History will smile to think that this is the species for which Socrates and Jesus Christ died."
  },
  {
    "author": "Rau'Shee Warren",
    "category": "smile",
    "id": 62697,
    "text": "I just smile. And they - my opponents don't like it when I smile at them. They think I'm playing or something. But - like I smile throughout the whole fight. Sometimes I'll be throwing combinations and I just smile and stick my tongue out at them."
  },
  {
    "author": "Lucy Larcom",
    "category": "smile",
    "id": 62444,
    "text": "If the world's a veil of tears, Smile till rainbows span it."
  },
  {
    "author": "Nicole Kidman",
    "category": "smile",
    "id": 62513,
    "text": "I was walking around legally blind. Now I have 20-20 vision. I can't believe I spent so many years blurry, but I think that coincides with how I was feeling. Now I notice if people are watching me, but I also smile right back if someone waves, which helps."
  },
  {
    "author": "Michael Chang",
    "category": "smile",
    "id": 62618,
    "text": "For me, I think the Lord wanted me to win to put a smile on Chinese people's faces."
  },
  {
    "author": "Zebulon Pike",
    "category": "smile",
    "id": 62623,
    "text": "May Heaven be propitious, and smile on the cause of my country."
  },
  {
    "author": "Robert Southwell",
    "category": "smile",
    "id": 62718,
    "text": "When Fortune smiles, I smile to think how quickly she will frown."
  },
  {
    "author": "James Dobson",
    "category": "smile",
    "id": 62584,
    "text": "One of the most important responsibilities in the Christian life is to care about others, smile at them, and be a friend to the friendless."
  },
  {
    "author": "Jeanne Calment",
    "category": "smile",
    "id": 62418,
    "text": "Always keep your smile. That's how I explain my long life."
  },
  {
    "author": "Earl Long",
    "category": "smile",
    "id": 62489,
    "text": "Don't write anything you can phone. Don't phone anything you can talk. Don't talk anything you can whisper. Don't whisper anything you can smile. Don't smile anything you can nod. Don't nod anything you can wink."
  },
  {
    "author": "J. B. Priestley",
    "category": "smile",
    "id": 62525,
    "text": "Comedy, we may say, is society protecting itself - with a smile."
  },
  {
    "author": "Malcolm De Chazal",
    "category": "smile",
    "id": 62641,
    "text": "We sometimes laugh from ear to ear, but it would be impossible for a smile to be wider than the distance between our eyes."
  },
  {
    "author": "Shinichi Suzuki",
    "category": "smile",
    "id": 62432,
    "text": "Children learn to smile from their parents."
  },
  {
    "author": "Jennifer Saunders",
    "category": "smile",
    "id": 62622,
    "text": "I'd much rather have sat there and just been a fly on the wall, instead of having to smile at people. I'd rather have been a waitress. Just gone round and stared at people."
  },
  {
    "author": "Samuel Goldwyn",
    "category": "smile",
    "id": 62486,
    "text": "I think luck is the sense to recognize an opportunity and the ability to take advantage of it... The man who can smile at his breaks and grab his chances gets on."
  },
  {
    "author": "Murray Walker",
    "category": "smile",
    "id": 62560,
    "text": "I'm a car fanatic and each morning I wake up with a smile on my face, whether I'm commentating on the Formula One or at Silver Hatch racetrack in Roary the Racing Car."
  },
  {
    "author": "Tom Wilson",
    "category": "smile",
    "id": 62473,
    "text": "A smile is a facelift that's in everyone's price range!"
  },
  {
    "author": "Peter Facinelli",
    "category": "smile",
    "id": 62682,
    "text": "I enjoy what Twitter is because I can really connect with the fans and it's a great way to share information with them and it's also a great way to entertain. I like being able to put a smile on people's faces and letting them know what I'm doing."
  }
]

quotes['society'] = [
  {
    "author": "Hillary Clinton",
    "category": "society",
    "id": 62739,
    "text": "We must stop thinking of the individual and start thinking about what is best for society."
  },
  {
    "author": "Janet Jackson",
    "category": "society",
    "id": 63039,
    "text": "Dreams can become a reality when we possess a vision that is characterized by the willingness to work hard, a desire for excellence, and a belief in our right and our responsiblity to be equal members of society."
  },
  {
    "author": "Johann Most",
    "category": "society",
    "id": 63605,
    "text": "He who negates present society, and seeks social conditions based on the sharing of property, is a revolutionary whether he calls himself an anarchist or a communist."
  },
  {
    "author": "Jarvis Cocker",
    "category": "society",
    "id": 63476,
    "text": "I think basically becoming famous has taken the place of going to Heaven in modern society, hasn't it? That's the place where your dreams will come true. It's an act of faith now they think that's going to sort things out."
  },
  {
    "author": "Alice Walker",
    "category": "society",
    "id": 63006,
    "text": "The gift of loneliness is sometimes a radical vision of society or one's people that has not previously been taken into account."
  },
  {
    "author": "Zachary Quinto",
    "category": "society",
    "id": 63191,
    "text": "Our society needs to recognize the unstoppable momentum toward unequivocal civil equality for every gay, lesbian, bisexual and transgendered citizen of this country."
  },
  {
    "author": "Theodor Adorno",
    "category": "society",
    "id": 63012,
    "text": "An emancipated society, on the other hand, would not be a unitary state, but the realization of universality in the reconciliation of differences."
  },
  {
    "author": "Frank Zappa",
    "category": "society",
    "id": 62943,
    "text": "Music is always a commentary on society."
  },
  {
    "author": "Albert Camus",
    "category": "society",
    "id": 62839,
    "text": "Without culture, and the relative freedom it implies, society, even when perfect, is but a jungle. This is why any authentic creation is a gift to the future."
  },
  {
    "author": "Barbra Streisand",
    "category": "society",
    "id": 63307,
    "text": "Just like my father, I've always loved education. In school I was a member of the honor society."
  },
  {
    "author": "Andrew Cuomo",
    "category": "society",
    "id": 63200,
    "text": "I believe discrimination still exists in society and we must fight it in every form."
  },
  {
    "author": "David Bohm",
    "category": "society",
    "id": 63029,
    "text": "Similarly, thought is a system. That system not only includes thought and feelings, but it includes the state of the body it includes the whole of society - as thought is passing back and forth between people in a process by which thought evolved from ancient times."
  },
  {
    "author": "Joe Biden",
    "category": "society",
    "id": 63124,
    "text": "For too long in this society, we have celebrated unrestrained individualism over common community."
  },
  {
    "author": "Sandra Lee",
    "category": "society",
    "id": 63695,
    "text": "My brand is a demography-breaker. It speaks to all homemakers and women from all walks of life and all across society."
  },
  {
    "author": "H. Rap Brown",
    "category": "society",
    "id": 63282,
    "text": "When you understand your obligations to God then you can understand your obligations to society."
  },
  {
    "author": "Henry David Thoreau",
    "category": "society",
    "id": 62729,
    "text": "If a man walks in the woods for love of them half of each day, he is in danger of being regarded as a loafer. But if he spends his days as a speculator, shearing off those woods and making the earth bald before her time, he is deemed an industrious and enterprising citizen."
  },
  {
    "author": "Russell Baker",
    "category": "society",
    "id": 62768,
    "text": "Usually, terrible things that are done with the excuse that progress requires them are not really progress at all, but just terrible things."
  },
  {
    "author": "Jinato Hu",
    "category": "society",
    "id": 63130,
    "text": "Diversity in the world is a basic characteristic of human society, and also the key condition for a lively and dynamic world as we see today."
  },
  {
    "author": "Marco Rubio",
    "category": "society",
    "id": 62986,
    "text": "We live in a society obsessed with public opinion. But leadership has never been about popularity."
  },
  {
    "author": "Daisaku Ikeda",
    "category": "society",
    "id": 63406,
    "text": "Divorced from the cosmos, from nature, from society and from each other, we have become fractured and fragmented."
  },
  {
    "author": "Robert Kennedy",
    "category": "society",
    "id": 62858,
    "text": "Every society gets the kind of criminal it deserves. What is equally true is that every community gets the kind of law enforcement it insists on."
  },
  {
    "author": "Bryan Cranston",
    "category": "society",
    "id": 63413,
    "text": "Our whole society is instantaneous."
  },
  {
    "author": "Kesha",
    "category": "society",
    "id": 63198,
    "text": "It's about time that society accepts people for who they are."
  },
  {
    "author": "David Ogilvy",
    "category": "society",
    "id": 63145,
    "text": "Advertising reflects the mores of society, but it does not influence them."
  },
  {
    "author": "Henry Adams",
    "category": "society",
    "id": 63321,
    "text": "American society is a sort of flat, fresh-water pond which absorbs silently, without reaction, anything which is thrown into it."
  },
  {
    "author": "Herbert Read",
    "category": "society",
    "id": 63632,
    "text": "I can imagine no society which does not embody some method of arbitration."
  },
  {
    "author": "Danica McKellar",
    "category": "society",
    "id": 63253,
    "text": "I want to help middle-school girls stay interested in math and be good at it, and see it as friendly and accessible and not this scary thing. Everyone else in society tells them it's not for them. It's for nerdy white guys with pocket protectors."
  },
  {
    "author": "Lyndon B. Johnson",
    "category": "society",
    "id": 63011,
    "text": "We have entered an age in which education is not just a luxury permitting some men an advantage over others. It has become a necessity without which a person is defenseless in this complex, industrialized society. We have truly entered the century of the educated man."
  },
  {
    "author": "Tipper Gore",
    "category": "society",
    "id": 63496,
    "text": "Our society's strong emphasis on dieting and self-image can sometimes lead to eating disorders. We know that more than 5 million Americans suffer from eating disorders, most of them young women."
  },
  {
    "author": "Denis Diderot",
    "category": "society",
    "id": 63005,
    "text": "Disturbances in society are never more fearful than when those who are stirring up the trouble can use the pretext of religion to mask their true designs."
  },
  {
    "author": "Dominic Monaghan",
    "category": "society",
    "id": 63488,
    "text": "I think we are all interested in end-times ideas and also in the current climate that we are all living in, where money is a little harder to come by, things continue to get expensive gas prices are not too far from people's heads. There are more and more people. Human society's going to have real problems."
  },
  {
    "author": "Simon Mainwaring",
    "category": "society",
    "id": 63176,
    "text": "Companies, to date, have often used the excuse that they are only beholden to their shareholders, but we need shareholders to think of themselves as stakeholders in the well being of society as well."
  },
  {
    "author": "Ron Paul",
    "category": "society",
    "id": 62891,
    "text": "The most important element of a free society, where individual rights are held in the highest esteem, is the rejection of the initiation of violence."
  },
  {
    "author": "Christopher Lasch",
    "category": "society",
    "id": 63150,
    "text": "The model of ownership, in a society organized round mass consumption, is addiction."
  },
  {
    "author": "Thomas Jefferson",
    "category": "society",
    "id": 62801,
    "text": "Truth is certainly a branch of morality and a very important one to society."
  },
  {
    "author": "Charles Kuralt",
    "category": "society",
    "id": 63138,
    "text": "I don't have any well-developed philosophy about journalism. Ultimately it is important in a society like this, so people can know about everything that goes wrong."
  },
  {
    "author": "Robert A. Heinlein",
    "category": "society",
    "id": 62723,
    "text": "An armed society is a polite society. Manners are good when one may have to back up his acts with his life."
  },
  {
    "author": "Jonathan Sacks",
    "category": "society",
    "id": 63370,
    "text": "Britain, relative to the U.S., is a highly secular society. Philanthropy alone cannot fill the gap left by government cutbacks. And the sources of altruism go deep into our evolutionary past."
  },
  {
    "author": "Gaston Caperton",
    "category": "society",
    "id": 63609,
    "text": "The gap in education in this country, the unfairness of the schools, is one of the great unfairness in this society."
  },
  {
    "author": "Robert W. Service",
    "category": "society",
    "id": 62947,
    "text": "The only society I like is rough and tough, and the tougher the better. There's where you get down to bedrock and meet human people."
  },
  {
    "author": "Terry Eagleton",
    "category": "society",
    "id": 63620,
    "text": "The British are supposed to be particularly averse to intellectuals, a prejudice closely bound up with their dislike of foreigners. Indeed, one important source of this Anglo-Saxon distaste for highbrows and eggheads was the French revolution, which was seen as an attempt to reconstruct society on the basis of abstract rational principles."
  },
  {
    "author": "Valerie Solanas",
    "category": "society",
    "id": 62782,
    "text": "Our society is not a community, but merely a collection of isolated family units."
  },
  {
    "author": "Andrea Jung",
    "category": "society",
    "id": 63534,
    "text": "When a woman earns a dollar, the payback is higher. She'll invest in her children, in their education, health care, and basic needs. The impact of a woman's role in the economy benefits society at large."
  },
  {
    "author": "John Stuart Mill",
    "category": "society",
    "id": 63018,
    "text": "The only part of the conduct of any one, for which he is amenable to society, is that which concerns others. In the part which merely concerns himself, his independence is, of right, absolute. Over himself, over his own body and mind, the individual is sovereign."
  },
  {
    "author": "Carl Sandburg",
    "category": "society",
    "id": 62888,
    "text": "When a nation goes down, or a society perishes, one condition may always be found they forgot where they came from. They lost sight of what had brought them along."
  },
  {
    "author": "Naguib Mahfouz",
    "category": "society",
    "id": 63440,
    "text": "I believe society has a right to defend itself, just as the individual has the right to attack that with which he disagrees."
  },
  {
    "author": "Christopher Lasch",
    "category": "society",
    "id": 62964,
    "text": "Drugs are merely the most obvious form of addiction in our society. Drug addiction is one of the things that undermines traditional values."
  },
  {
    "author": "Lord Acton",
    "category": "society",
    "id": 63192,
    "text": "Property is not the sacred right. When a rich man becomes poor it is a misfortune, it is not a moral evil. When a poor man becomes destitute, it is a moral evil, teeming with consequences and injurious to society and morality."
  },
  {
    "author": "Karl Marx",
    "category": "society",
    "id": 62922,
    "text": "The ideas of the ruling class are in every epoch the ruling ideas, i.e., the class which is the ruling material force of society, is at the same time its ruling intellectual force."
  },
  {
    "author": "Daniel H. Wilson",
    "category": "society",
    "id": 63583,
    "text": "As a society, I think we express our cultural mores through our politics. We're trying constantly to figure out what's OK and what's not OK. And it's hard, because our society is constantly buffeted by gale force winds of technology. Things are always changing."
  },
  {
    "author": "Christopher Dawson",
    "category": "society",
    "id": 63389,
    "text": "Every society rests in the last resort on the recognition of common principles and common ideals, and if it makes no moral or spiritual appeal to the loyalty of its members, it must inevitably fall to pieces."
  },
  {
    "author": "Michel Foucault",
    "category": "society",
    "id": 63156,
    "text": "Prison continues, on those who are entrusted to it, a work begun elsewhere, which the whole of society pursues on each individual through innumerable mechanisms of discipline."
  },
  {
    "author": "Washington Irving",
    "category": "society",
    "id": 63013,
    "text": "Who ever hears of fat men heading a riot, or herding together in turbulent mobs? No - no, your lean, hungry men who are continually worrying society, and setting the whole community by the ears."
  },
  {
    "author": "Oliver Tambo",
    "category": "society",
    "id": 63603,
    "text": "We seek to create a united Democratic and non-racial society."
  },
  {
    "author": "Jacqueline Bisset",
    "category": "society",
    "id": 63235,
    "text": "There's something about being with a group of people who become like family that must be needed in society."
  },
  {
    "author": "George Bernard Shaw",
    "category": "society",
    "id": 62728,
    "text": "Do not waste your time on Social Questions. What is the matter with the poor is Poverty what is the matter with the rich is Uselessness."
  },
  {
    "author": "Jim Carrey",
    "category": "society",
    "id": 62944,
    "text": "Before I do anything, I think, well what hasn't been seen. Sometimes, that turns out to be something ghastly and not fit for society. And sometimes that inspiration becomes something that's really worthwhile."
  },
  {
    "author": "Stockwell Day",
    "category": "society",
    "id": 63529,
    "text": "I wish the government and the Minister of Justice would address these legal and constitutional arguments, but they refuse to. They want Canadians to go blindly into their brave new world, but it is not wise for a society to move blindly in any direction."
  },
  {
    "author": "V. S. Naipaul",
    "category": "society",
    "id": 63334,
    "text": "Trinidad may seem complex, but to anyone who knows it, it is a simple, colonial, philistine society."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "society",
    "id": 62921,
    "text": "In our society, the women who break down barriers are those who ignore limits."
  },
  {
    "author": "Wole Soyinka",
    "category": "society",
    "id": 63289,
    "text": "Well, the first thing is that truth and power for me form an antithesis, an antagonism, which will hardly ever be resolved. I can define in fact, can simplify the history of human society, the evolution of human society, as a contest between power and freedom."
  },
  {
    "author": "Henry David Thoreau",
    "category": "society",
    "id": 62829,
    "text": "I had three chairs in my house one for solitude, two for friendship, three for society."
  },
  {
    "author": "John McCarthy",
    "category": "society",
    "id": 63540,
    "text": "There is only one thing more harmful to society than an elected official forgetting the promises he made in order to get elected that's when he doesn't forget them."
  },
  {
    "author": "Judi Dench",
    "category": "society",
    "id": 63672,
    "text": "Sometimes nudity is gratuitous. We just live in a society where everything goes."
  },
  {
    "author": "Julie Burchill",
    "category": "society",
    "id": 63399,
    "text": "It's very hard to imagine the phrase 'consumer society' used so cheerfully, and interpreted so enthusiastically, in England."
  },
  {
    "author": "Clint Eastwood",
    "category": "society",
    "id": 62884,
    "text": "Society is at odds with itself."
  },
  {
    "author": "Ai Weiwei",
    "category": "society",
    "id": 63598,
    "text": "Police in China can do whatever they want after 81 days in arbitrary detention you clearly realise that they don't have to obey their own laws. In a society like this there is no negotiation, no discussion, except to tell you that power can crush you any time they want - not only you, your whole family and all people like you."
  },
  {
    "author": "Robert Casey",
    "category": "society",
    "id": 63471,
    "text": "Tolerance is the price we pay for living in a free, pluralistic society."
  },
  {
    "author": "Rand Paul",
    "category": "society",
    "id": 63128,
    "text": "I believe we should work to end all racism in American society and staunchly defend the inherent rights of every person."
  },
  {
    "author": "Christopher Hitchens",
    "category": "society",
    "id": 63060,
    "text": "If you look at any Muslim society and you make a scale of how developed they are, and how successful the economy is, it's a straight line. It depends on how much they emancipate their women."
  },
  {
    "author": "Bill Vaughan",
    "category": "society",
    "id": 62762,
    "text": "Man is the animal that intends to shoot himself out into interplanetary space, after having given up on the problem of an efficient way to get himself five miles to work and back each day."
  },
  {
    "author": "Henrik Ibsen",
    "category": "society",
    "id": 63258,
    "text": "The worst enemy of truth and freedom in our society is the compact majority."
  },
  {
    "author": "Sigmund Freud",
    "category": "society",
    "id": 62896,
    "text": "Civilized society is perpetually menaced with disintegration through this primary hostility of men towards one another."
  },
  {
    "author": "Henning Mankell",
    "category": "society",
    "id": 63691,
    "text": "I work in an old tradition that goes back to the ancient Greeks. You hold a mirror to crime to see what's happening in society. I could never write a crime story just for the sake of it, because I always want to talk about certain things in society."
  },
  {
    "author": "Dennis Prager",
    "category": "society",
    "id": 63083,
    "text": "Although images of perfection in people's personal lives can cause unhappiness, images of perfect societies - utopian images - can cause monstrous evil. In fact, forcefully changing society to conform to societal images was the greatest cause of evil in the twentieth century."
  },
  {
    "author": "Quincy Jones",
    "category": "society",
    "id": 63472,
    "text": "I started imagining this whole different world. It was a society of musicians, a family I hoped I could belong to one day."
  },
  {
    "author": "Martin Yan",
    "category": "society",
    "id": 63561,
    "text": "Some people never contribute anything positive to society, they may even drain our resources, but most of us try to do something better, to give back."
  },
  {
    "author": "Edward Bond",
    "category": "society",
    "id": 63641,
    "text": "All you now do is pursue your private objectives within society. Instead of us being a community, everybody is asked to seek their own personal ends. It's called competition. And competition is antagonism."
  },
  {
    "author": "David Mamet",
    "category": "society",
    "id": 63267,
    "text": "The product of the artist has become less important than the fact of the artist. We wish to absorb this person. We wish to devour someone who has experienced the tragic. In our society this person is much more important than anything he might create."
  },
  {
    "author": "Jean de la Bruyere",
    "category": "society",
    "id": 62753,
    "text": "The wise person often shuns society for fear of being bored."
  },
  {
    "author": "Madeleine Albright",
    "category": "society",
    "id": 63159,
    "text": "The magic of America is that we're a free and open society with a mixed population. Part of our security is our freedom."
  },
  {
    "author": "Baldwin Spencer",
    "category": "society",
    "id": 63285,
    "text": "It is time for the world, the hemisphere and the region to make sure that relevant institutions of civil society and relevant laws are embedded in the mechanisms of governance."
  },
  {
    "author": "Henrik Ibsen",
    "category": "society",
    "id": 63317,
    "text": "The spirit of truth and the spirit of freedom - these are the pillars of society."
  },
  {
    "author": "Tim Robbins",
    "category": "society",
    "id": 63181,
    "text": "I think the enemy is self-censorship. In a free society the biggest danger is that you're afraid to the point where you censor yourself."
  },
  {
    "author": "Herbert Read",
    "category": "society",
    "id": 63627,
    "text": "The point I am making is that in the more primitive forms of society the individual is merely a unit in more developed forms of society he is an independent personality."
  },
  {
    "author": "Randolph Bourne",
    "category": "society",
    "id": 62781,
    "text": "Society is one vast conspiracy for carving one into the kind of statue likes, and then placing it in the most convenient niche it has."
  },
  {
    "author": "Erykah Badu",
    "category": "society",
    "id": 63016,
    "text": "What I work hard at doing is staying on a path of being kind and showing and proving that I'm a good person to society. That's hard. The talent, that's a gift. I just came here like that."
  },
  {
    "author": "J. K. Rowling",
    "category": "society",
    "id": 63044,
    "text": "I'm interested in that drive, that rush to judgment, that is so prevalent in our society.We all know that pleasurable rush that comes from condemning, and in the short term it's quite a satisfying thing to do, isn't it?"
  },
  {
    "author": "Victor Hugo",
    "category": "society",
    "id": 62898,
    "text": "Freedom in art, freedom in society, this is the double goal towards which all consistent and logical minds must strive."
  },
  {
    "author": "Catherine Deneuve",
    "category": "society",
    "id": 63186,
    "text": "There are relatively few role models for young people. We are in a society that is ruled by men."
  },
  {
    "author": "Harry S. Truman",
    "category": "society",
    "id": 62832,
    "text": "Men make history and not the other way around. In periods where there is no leadership, society stands still. Progress occurs when courageous, skillful leaders seize the opportunity to change things for the better."
  },
  {
    "author": "Abdolkarim Soroush",
    "category": "society",
    "id": 63556,
    "text": "We coin concepts and we use them to analyse and explain nature and society. But we seem to forget, midway, that these concepts are our own constructs and start equating them with reality."
  },
  {
    "author": "Joe Biden",
    "category": "society",
    "id": 63265,
    "text": "The devastating punch we took on September 11th still reverberates throughout American society."
  },
  {
    "author": "Marco Rubio",
    "category": "society",
    "id": 63002,
    "text": "We are special because we've been united not by a common race or ethnicity. We're bound together by common values. That family is the most important institution in society. That almighty God is the source of all we have."
  },
  {
    "author": "Talcott Parsons",
    "category": "society",
    "id": 63377,
    "text": "The functions of the family in a highly differentiated society are not to be interpreted as functions directly on behalf of the society, but on behalf of personality."
  },
  {
    "author": "Peter Fonda",
    "category": "society",
    "id": 63544,
    "text": "I have always maintained that society has no business dictating morality."
  },
  {
    "author": "William Ellery Channing",
    "category": "society",
    "id": 63040,
    "text": "No power in society, no hardship in your condition can depress you, keep you down, in knowledge, power, virtue, influence, but by your own consent."
  },
  {
    "author": "Eugene Ionesco",
    "category": "society",
    "id": 63102,
    "text": "No society has been able to abolish human sadness, no political system can deliver us from the pain of living, from our fear of death, our thirst for the absolute. It is the human condition that directs the social condition, not vice versa."
  },
  {
    "author": "Lyndon B. Johnson",
    "category": "society",
    "id": 63019,
    "text": "Our society is illuminated by the spiritual insights of the Hebrew prophets. America and Israel have a common love of human freedom, and they have a common faith in a democratic way of life."
  },
  {
    "author": "George Soros",
    "category": "society",
    "id": 63430,
    "text": "I chose America as my home because I value freedom and democracy, civil liberties and an open society."
  }
]

quotes['sports'] = [
  {
    "author": "James Patrick Murray",
    "category": "sports",
    "id": 63771,
    "text": "Baseball is a game where a curve is an optical illusion, a screwball can be a pitch or a person, stealing is legal and you can spit anywhere you like except in the umpire's eye or on the ball."
  },
  {
    "author": "Cam Gigandet",
    "category": "sports",
    "id": 64274,
    "text": "I grew up playing sports, football, basketball, baseball, everything, and acting was such a different environment and different world for me."
  },
  {
    "author": "Josh Charles",
    "category": "sports",
    "id": 64305,
    "text": "I grew up in Baltimore. And yes, I am a big sports fan, especially when it comes to my local teams."
  },
  {
    "author": "Jessica Biel",
    "category": "sports",
    "id": 64182,
    "text": "I've been involved with sports my whole life, which made clothes and makeup and handbags not that important as a kid. I just didn't care."
  },
  {
    "author": "Peyton Manning",
    "category": "sports",
    "id": 64141,
    "text": "My dad told us up front, 'Guys, if you want to play sports, go ahead, but it's your decision.'"
  },
  {
    "author": "Patricia Heaton",
    "category": "sports",
    "id": 64103,
    "text": "It's a little bit in the genes because my brother is a journalist and my father was a sports writer."
  },
  {
    "author": "Michael Patrick Jann",
    "category": "sports",
    "id": 64236,
    "text": "I come from a background of hanging out with friends and shooting videos with them, with funny stuff coming out of the group. I guess we got the same charge jocks get out of sports."
  },
  {
    "author": "Sutton Foster",
    "category": "sports",
    "id": 64326,
    "text": "I think everybody has something that takes them away or makes them happier. To some people it's baseball or sports or knitting or the movies."
  },
  {
    "author": "Brandi Chastain",
    "category": "sports",
    "id": 64207,
    "text": "Julie, Mia and I just met for a couple days, doing some work but really under the guise of having fun. We do events like the Women's Sports Foundation Dinner, where we get to not only do a good thing for the community but we get to hang out with one another again."
  },
  {
    "author": "Mike Schmidt",
    "category": "sports",
    "id": 64381,
    "text": "They read their sports pages, know their statistics and either root like hell or boo our butts off. I love it. Give me vocal fans, pro or con, over the tourist types who show up in Houston or Montreal and just sit there."
  },
  {
    "author": "Tipper Gore",
    "category": "sports",
    "id": 64180,
    "text": "I have long recognized a link between fitness and mental health and I think we need to encourage young people to take part in sports and team activities because we know it has such positive results."
  },
  {
    "author": "James Collins",
    "category": "sports",
    "id": 64354,
    "text": "If I had a personal wish for the new ideas in this new book it would be that every parent, every counselor, every teacher, every professor, every sports coach that deals with young people would understand the three circle concept."
  },
  {
    "author": "Roger Goodell",
    "category": "sports",
    "id": 64102,
    "text": "We're in a leadership position in sports. People look up to the National Football League."
  },
  {
    "author": "Alastair Campbell",
    "category": "sports",
    "id": 64122,
    "text": "We should confine booing in sports arenas to sport. I love a good boo as much as the next football fan."
  },
  {
    "author": "Peter Ueberroth",
    "category": "sports",
    "id": 63840,
    "text": "The integrity of the game is everything."
  },
  {
    "author": "Tommy Bolt",
    "category": "sports",
    "id": 63876,
    "text": "If you are going to throw a club, it is important to throw it ahead of you, down the fairway, so you don't have to waste energy going back to pick it up."
  },
  {
    "author": "Nick Price",
    "category": "sports",
    "id": 63856,
    "text": "Overall the fundamentals seem to be there and he's obviously got a very mature head on his shoulders. He's got a kind of presence."
  },
  {
    "author": "Jack Kent Cooke",
    "category": "sports",
    "id": 64374,
    "text": "Sports are one of the main cultural activities on the face of the earth."
  },
  {
    "author": "Jackie Joyner-Kersee",
    "category": "sports",
    "id": 64032,
    "text": "We live in a world where sports have the potential to bridge the gap between racism, sexism and discrimination. The 2012 Olympic Games was a great start but hopefully what these games taught us is that if women are given an opportunity on an equal playing field the possibilities for women are endless."
  },
  {
    "author": "Christopher Judge",
    "category": "sports",
    "id": 64392,
    "text": "Movies, TV, sports, come and go, but what you stand for is what people remember. Mandela, Martin Luther King, John Kennedy are people who really stood for something and were willing to die for it. You don't see a whole lot of that any more."
  },
  {
    "author": "Kiana Tom",
    "category": "sports",
    "id": 64067,
    "text": "I have my parents to thank for that, they raised me to be active and play all sports. They taught me the importance of staying healthy, being focused and setting goals in whatever I do."
  },
  {
    "author": "Channing Tatum",
    "category": "sports",
    "id": 63955,
    "text": "My parents couldn't handle my energy so they enrolled me in every sport the school was offering. I didn't resent it because I loved sports and picked them up easily."
  },
  {
    "author": "Jack Nicklaus",
    "category": "sports",
    "id": 63827,
    "text": "He has the finest, fundamentally sound golf swing I've ever seen."
  },
  {
    "author": "Shigeru Miyamoto",
    "category": "sports",
    "id": 63963,
    "text": "I never really participated in specific sports or anything, but once I hit 40, I started to get a little bit more active and began swimming more."
  },
  {
    "author": "Dan Gable",
    "category": "sports",
    "id": 63730,
    "text": "Gold medals aren't really made of gold. They're made of sweat, determination, and a hard-to-find alloy called guts."
  },
  {
    "author": "Tim McGraw",
    "category": "sports",
    "id": 64097,
    "text": "But I was so wrapped up in sports growing up as a kid, that I think I was going to grow to be a pro ball player. But I found out real quick that was not going to happen."
  },
  {
    "author": "Junior Seau",
    "category": "sports",
    "id": 64062,
    "text": "As a sophomore, I wanted to play varsity in three sports. And I accomplished that. It was a great feat that year, and something I held special. I wanted to bring a championship team to Oceanside High School, and it happened. It was a great year that I will never forget."
  },
  {
    "author": "Sanford I. Weill",
    "category": "sports",
    "id": 64155,
    "text": "I think life is sort of like a competition, whether it's in sports, or it's achieving in school, or it's achieving good relationships with people. And competition is a little bit of what it's all about."
  },
  {
    "author": "Susan Orlean",
    "category": "sports",
    "id": 63917,
    "text": "I went to a football school, which meant that I went to a university that served up education and was simultaneously operating a sports franchise."
  },
  {
    "author": "Dietrich Mateschitz",
    "category": "sports",
    "id": 64440,
    "text": "When launching a product called an Energy Drink and named Red Bull, a product that stimulates body and mind, it is a short step to the roots where Red Bull came from. We have been doing this for 20 years - now it's called adventure sports, extreme sports, and outdoor sports."
  },
  {
    "author": "Bret Easton Ellis",
    "category": "sports",
    "id": 64223,
    "text": "Everyone I know who is successful has issues with their father, regardless of whether it was sports or business or entertainment."
  },
  {
    "author": "Joe Garagiola",
    "category": "sports",
    "id": 63860,
    "text": "I went through baseball as 'a player to be named later.'"
  },
  {
    "author": "Dean Cain",
    "category": "sports",
    "id": 64290,
    "text": "I love sports. Anytime I can combine sports with a film I'm a happy guy. It's such a natural fit, because sports always seems to be a metaphor for life. Always, always, always."
  },
  {
    "author": "Beau Bridges",
    "category": "sports",
    "id": 64176,
    "text": "And then I got into sports and gave my guitar to my brother Jeff who was just a little kid at that time."
  },
  {
    "author": "Jo Nesbo",
    "category": "sports",
    "id": 64054,
    "text": "In most sports, your brain and your body will cooperate... But in rock climbing, it is the other way around. Your brain doesn't see the point in climbing upwards. Your brain will tell you to keep as low as possible, to cling to the wall and not get any higher. You have to have your brain persuading your body to do the right movements."
  },
  {
    "author": "Bill Bradley",
    "category": "sports",
    "id": 63998,
    "text": "Sports is a metaphor for overcoming obstacles and achieving against great odds. Athletes, in times of difficulty, can be important role models."
  },
  {
    "author": "Lee Trevino",
    "category": "sports",
    "id": 63837,
    "text": "You can make a lot of money in this game. Just ask my ex-wives. Both of them are so rich that neither of their husbands work."
  },
  {
    "author": "Tom Hicks",
    "category": "sports",
    "id": 64363,
    "text": "I don't have the insight with the Longhorns that I do with the two teams that I own, but as a fan and reading the sports pages, I'm bullish about the Longhorns."
  },
  {
    "author": "Cory Monteith",
    "category": "sports",
    "id": 64109,
    "text": "I'll go out, but I leave early, before the shenanigans. I don't really do the Hollywood party thing. I'd rather watch sports or play videogames or work out or sleep, to be totally honest."
  },
  {
    "author": "Billie Jean King",
    "category": "sports",
    "id": 63923,
    "text": "Women's sports is still in its infancy. The beginning of women's sports in the United States started in 1972, with the passage of Title 9 for girls to finally get athletic scholarships."
  },
  {
    "author": "Joe Garagiola",
    "category": "sports",
    "id": 63850,
    "text": "One thing you learned as a Cubs fan: when you bought you ticket, you could bank on seeing the bottom of the ninth."
  },
  {
    "author": "Roger Federer",
    "category": "sports",
    "id": 64167,
    "text": "I did all the right things in so many tournaments. But like I said, sometimes in sports it just goes the other way. Maybe you've already won so much that it evens it out a bit sometimes. I don't know."
  },
  {
    "author": "Danny Boyle",
    "category": "sports",
    "id": 63962,
    "text": "I'm a big sports fan. Football. Cricket."
  },
  {
    "author": "Jim Sensenbrenner",
    "category": "sports",
    "id": 64225,
    "text": "Football, basketball, and the Olympic sports all have their problems with banned substances."
  },
  {
    "author": "David Duval",
    "category": "sports",
    "id": 64181,
    "text": "We might not make what athletes in other sports make, but we have greater longevity and we do have certain freedoms to do things they can't do. Like stay home one week and play the next week."
  },
  {
    "author": "Arnold Palmer",
    "category": "sports",
    "id": 63839,
    "text": "What other people may find in poetry or art museums, I find in the flight of a good drive."
  },
  {
    "author": "J. Philippe Rushton",
    "category": "sports",
    "id": 64297,
    "text": "The biological factors underlying race differences in sports have consequences for educational achievement, crime and sexual behavior."
  },
  {
    "author": "Greg LeMond",
    "category": "sports",
    "id": 63859,
    "text": "You don't suffer, kill yourself and take the risks I take just for money. I love bike racing."
  },
  {
    "author": "Bob Beamon",
    "category": "sports",
    "id": 64442,
    "text": "I think track is still one of the most exciting participant sports, but we haven't been able to capitalize on that excitement through television and the print media."
  },
  {
    "author": "Bruce Jenner",
    "category": "sports",
    "id": 64186,
    "text": "If I wasn't dyslexic, I probably wouldn't have won the Games. If I had been a better reader, then that would have come easily, sports would have come easily... and I never would have realized that the way you get ahead in life is hard work."
  },
  {
    "author": "Willie Mays",
    "category": "sports",
    "id": 64121,
    "text": "When I was in Birmingham I used to go to a place called Redwood Field. I used to get there for a two o'clock game. Where can you make this kind of money playing sports? It was just a pleasure to go out and enjoy myself and get paid for it."
  },
  {
    "author": "Bernard Williams",
    "category": "sports",
    "id": 64009,
    "text": "Books had instant replay long before televised sports."
  },
  {
    "author": "Rick Snyder",
    "category": "sports",
    "id": 64127,
    "text": "But as a practical matter, Detroit's the sports city in the country."
  },
  {
    "author": "Herb Kohl",
    "category": "sports",
    "id": 64365,
    "text": "As all of us with any involvement in sports knows, no two umpires or no two referees have the same strike zone or call the same kind of a basketball game."
  },
  {
    "author": "Warren Farrell",
    "category": "sports",
    "id": 64047,
    "text": "Men's competitive team sports focus on the balance between individual achievement and team achievement with the emphasis on team achievement."
  },
  {
    "author": "Dick Schaap",
    "category": "sports",
    "id": 64233,
    "text": "I wanted to be a sportswriter because I loved sports and I could not hit the curve ball, the jump shot, or the opposing ball carrier."
  },
  {
    "author": "H. L. Mencken",
    "category": "sports",
    "id": 63879,
    "text": "I hate all sports as rabidly as a person who likes sports hates common sense."
  },
  {
    "author": "Ashley Tisdale",
    "category": "sports",
    "id": 63953,
    "text": "My sister is totally my dad's daughter because she loves sports."
  },
  {
    "author": "Joe Nichols",
    "category": "sports",
    "id": 64004,
    "text": "I am a sports fanatic and being able to perform at halftime for the fans of the Steelers and the Jets is such a thrill for me."
  },
  {
    "author": "A. Bartlett Giamatti",
    "category": "sports",
    "id": 64148,
    "text": "Major sports are major parts of society. It's not anomalous to have people who love sports come from other parts of that society."
  },
  {
    "author": "Luke Bryan",
    "category": "sports",
    "id": 64255,
    "text": "I'm a big sports fan in general."
  },
  {
    "author": "Ted Williams",
    "category": "sports",
    "id": 63755,
    "text": "Baseball is the only field of endeavor where a man can succeed three times out of ten and be considered a good performer."
  },
  {
    "author": "Chris Moneymaker",
    "category": "sports",
    "id": 64202,
    "text": "I used to sports gamble a lot and I was getting killed on that but then I found poker and really enjoyed it. But it was a hobby more than anything else. I played it every day but only on pretty small stakes."
  },
  {
    "author": "Benicio Del Toro",
    "category": "sports",
    "id": 64093,
    "text": "I think having a vision can make someone an influential man. I'm not talking about acting or anything like that, I'm talking about people I admire, whether it's a writer or a musician or a sports figure or a politician, whatever."
  },
  {
    "author": "Neal Schon",
    "category": "sports",
    "id": 64229,
    "text": "I never got into sports at all until I was in my early 20s, after my music career got going."
  },
  {
    "author": "Mike Singletary",
    "category": "sports",
    "id": 63769,
    "text": "Do you know what my favorite part of the game is? The opportunity to play."
  },
  {
    "author": "Angela Ruggiero",
    "category": "sports",
    "id": 64279,
    "text": "I'm in the perfect position. It's a sports position and a political position where I can help better the lives of athletes around the world."
  },
  {
    "author": "Ivan Lendl",
    "category": "sports",
    "id": 64131,
    "text": "Tennis is not like other sports where the coach is hired by an independent entity, and that makes a huge difference in the dynamic."
  },
  {
    "author": "Chris Evert",
    "category": "sports",
    "id": 64169,
    "text": "I think team sports probably teach you more about giving - about being unselfish and being flexible."
  },
  {
    "author": "Dax Shepard",
    "category": "sports",
    "id": 64203,
    "text": "All of my free time is made up of motor sports endeavors, be them motorcycles or off-road racing or track days. I just love anything with an engine. That is one of my main loves. Obviously, my other well-known love is Kristen Bell."
  },
  {
    "author": "Kirsty Gallacher",
    "category": "sports",
    "id": 64178,
    "text": "I come from a sports family and my husband is a rugby player."
  },
  {
    "author": "Joel Silver",
    "category": "sports",
    "id": 64073,
    "text": "I never really was that passionate about playing sports. But when I was at this Mt. Herman school, I did have the ability to throw the frisbee. So when this sport evolved, it was fun because I was good at it."
  },
  {
    "author": "Carrie Underwood",
    "category": "sports",
    "id": 63924,
    "text": "I'm girlie in the sense that I like makeup, but I also love sports and man food."
  },
  {
    "author": "Herbert Hoover",
    "category": "sports",
    "id": 63775,
    "text": "Fishing is much more than fish. It is the great occasion when we may return to the fine simplicity of our forefathers."
  },
  {
    "author": "Billie Joe Armstrong",
    "category": "sports",
    "id": 63928,
    "text": "The things that people do now in sports, you can't even believe. These are complete total athletes. To see what human beings can do in the highest level is amazing."
  },
  {
    "author": "Kevin Costner",
    "category": "sports",
    "id": 63966,
    "text": "I enjoy sports. I get a real joy from playing sports but I don't look for those movies. Oliver Stone wanted to know if I would do Any Given Sunday and it just didn't appeal to me."
  },
  {
    "author": "Cindy Crawford",
    "category": "sports",
    "id": 63919,
    "text": "It's become another dimension to who I am. I don't think Sports Illustrated is going to be wanting me. But who cares? I'm at a different place in my life."
  },
  {
    "author": "John Hodgman",
    "category": "sports",
    "id": 64082,
    "text": "All I can ask from society is that it please stop telling me why I should like sports."
  },
  {
    "author": "Greg Louganis",
    "category": "sports",
    "id": 64353,
    "text": "When you're a kid growing up, and you think you're gay, you know that you're different you're often teased and it can really destroy your self-esteem. But sports can be great for building self-esteem."
  },
  {
    "author": "Kenny Chesney",
    "category": "sports",
    "id": 63996,
    "text": "It sounds like a cliche, but it... you do sing about what you know about. And I grew up in a small town, and I grew up in a place where your whole world revolved around friends, family, school, and church, and sports."
  },
  {
    "author": "Joe DiMaggio",
    "category": "sports",
    "id": 63798,
    "text": "You always get a special kick on opening day, no matter how many you go through. You look forward to it like a birthday party when you're a kid. You think something wonderful is going to happen."
  },
  {
    "author": "John Updike",
    "category": "sports",
    "id": 63807,
    "text": "Golf appeals to the idiot in us and the child. Just how childlike golf players become is proven by their frequent inability to count past five."
  },
  {
    "author": "Mindy Kaling",
    "category": "sports",
    "id": 63945,
    "text": "I'm not good at anything except writing jokes. I wasn't good at sports, I wasn't good at anything artsy, ever. I think there was a real worry for a while about what I would be good at. I was just this chubby little Indian kid who looked like a nerd."
  },
  {
    "author": "Al Michaels",
    "category": "sports",
    "id": 64333,
    "text": "Monday Night Football started in 1970, and when it started, it was something extremely special because sports had not been aired in prime time. So, it was a novelty, and a lot of people thought it wouldn't work, and, of course, it worked spectacularly well."
  },
  {
    "author": "J. C. Watts",
    "category": "sports",
    "id": 63952,
    "text": "I would love to be associated with some sports organization. I was a journalism major. That's kind of intriguing, to do something in the political-commentary arena."
  },
  {
    "author": "Neil Peart",
    "category": "sports",
    "id": 64328,
    "text": "It was actually drumming that gave me the stamina to get into sports later."
  },
  {
    "author": "Kris Allen",
    "category": "sports",
    "id": 64164,
    "text": "I am a huge sports fan."
  },
  {
    "author": "Meyer Lansky",
    "category": "sports",
    "id": 64448,
    "text": "All pro sports, as well as the NCAA, should thank God every day we have sports betting here... We have the only agency in the world that regulates the honesty of games."
  },
  {
    "author": "Elizabeth Price",
    "category": "sports",
    "id": 64429,
    "text": "Anyone could be in the orchestra, or sports team, or arts club at my school. It was precisely the kind of inclusivity that now meets with a sort of scorn and derision as a prizes-for-all culture that generates only mediocrity. There's something so insulting about the idea that including lots of people means mediocrity."
  },
  {
    "author": "Curt Schilling",
    "category": "sports",
    "id": 63970,
    "text": "There's not a long track record of people leaving professional sports to become a software developer."
  },
  {
    "author": "Jack Brickhouse",
    "category": "sports",
    "id": 64443,
    "text": "I regard sports first and foremost as entertainment, so dry documentary narration is not for me."
  },
  {
    "author": "Jack Nicklaus",
    "category": "sports",
    "id": 63828,
    "text": "He's going to be around a long, long time, if his body holds up. That's always a concern with a lot of players because of how much they play. A lot of guys can't handle it. But it looks like he can."
  },
  {
    "author": "Peter Ueberroth",
    "category": "sports",
    "id": 63864,
    "text": "Baseball is a public trust. Players turn over, owners turn over and certain commissioners turn over. But baseball goes on."
  },
  {
    "author": "Jesse Ventura",
    "category": "sports",
    "id": 63796,
    "text": "Wrestling is ballet with violence."
  },
  {
    "author": "Sergei Bubka",
    "category": "sports",
    "id": 64262,
    "text": "My policy was just to give good things for sports in my region."
  },
  {
    "author": "Charles Barkley",
    "category": "sports",
    "id": 63762,
    "text": "These are my new shoes. They're good shoes. They won't make you rich like me, they won't make you rebound like me, they definitely won't make you handsome like me. They'll only make you have shoes like me. That's it."
  },
  {
    "author": "Frank Gifford",
    "category": "sports",
    "id": 63818,
    "text": "Gray skies are just clouds passing over."
  },
  {
    "author": "Jim Lampley",
    "category": "sports",
    "id": 64355,
    "text": "You know, we - we start with a mentality that we'll take a sports project if its good. And we're certainly not on the lookout for them, because to be honest we don't have to. They walk in the door."
  },
  {
    "author": "Ferdinand Porsche",
    "category": "sports",
    "id": 63907,
    "text": "I couldn't find the sports car of my dreams, so I built it myself."
  },
  {
    "author": "Jasmine Tookes",
    "category": "sports",
    "id": 64375,
    "text": "I did a shoot for 'Sports Illustrated,' and my grandpa called me and asked when my issue of 'Playboy' was coming out. It was hilarious as well as embarrassing."
  }
]

quotes['strength'] = [
  {
    "author": "Harry Reid",
    "category": "strength",
    "id": 64929,
    "text": "It has been my honor to support and work with President Barack Obama, a man who has brought courage and character to the presidency. President Obama's strength of character leads him to do the right thing, even when it isn't the easy thing."
  },
  {
    "author": "Mitt Romney",
    "category": "strength",
    "id": 64571,
    "text": "The strength and power and goodness of America has always been based on the strength and power and goodness of our communities, our families, our faiths. That is the bedrock of what makes America, America. In our best days, we can feel the vibrancy of America's communities, large and small."
  },
  {
    "author": "Anne Morrow Lindbergh",
    "category": "strength",
    "id": 64476,
    "text": "Don't wish me happiness - I don't expect to be happy it's gotten beyond that, somehow. Wish me courage and strength and a sense of humor - I will need them all."
  },
  {
    "author": "David Crystal",
    "category": "strength",
    "id": 65079,
    "text": "Academics don't normally manage to alter people's way of thinking through their strength of argument."
  },
  {
    "author": "Moshe Dayan",
    "category": "strength",
    "id": 64908,
    "text": "It was in our power to cause the Arab governments to renounce the policy of strength toward Israel by turning it into a demonstration of weakness."
  },
  {
    "author": "Bernard Ebbers",
    "category": "strength",
    "id": 64981,
    "text": "The strength in our third-quarter financial results is cause for excitement. I'm particularly pleased that we continue to demonstrate impressive growth at the same time we are engaged in important merger discussions."
  },
  {
    "author": "Dag Hammarskjold",
    "category": "strength",
    "id": 64736,
    "text": "The breaking wave and the muscle as it contracts obey the same law. Delicate line gathers the body's total strength in a bold balance. Shall my soul meet so severe a curve, journeying on its way to form?"
  },
  {
    "author": "Bob Keeshan",
    "category": "strength",
    "id": 64794,
    "text": "It requires more strength to be gentle, so it's the everyday encounters of life that I think we've prepared children for and prepared them to be good to other people and to consider other people."
  },
  {
    "author": "Florence Griffith Joyner",
    "category": "strength",
    "id": 65080,
    "text": "I've always overworked in the weight room. I love working with weights. I knew they'd give me the strength I needed."
  },
  {
    "author": "Christopher Lasch",
    "category": "strength",
    "id": 64766,
    "text": "When liberals finally grasped the strength of popular feeling about the family, they cried to appropriate the rhetoric and symbolism of family values for their own purposes."
  },
  {
    "author": "Jane D. Hull",
    "category": "strength",
    "id": 65010,
    "text": "I realized then that the generations may change but the strength of our nation remains solid."
  },
  {
    "author": "Steven Yeun",
    "category": "strength",
    "id": 65074,
    "text": "Whatever I lack in size and strength and speed, I kind of make up for in being grittier. When it comes to something like basketball I'm definitely not the best guy on the court, but I love elbowing and pushing people out or boxing them out."
  },
  {
    "author": "Harriet Tubman",
    "category": "strength",
    "id": 64622,
    "text": "I would fight for my liberty so long as my strength lasted, and if the time came for me to go, the Lord would let them take me."
  },
  {
    "author": "Andrew Shue",
    "category": "strength",
    "id": 64930,
    "text": "Unfortunately, there are so many people who live their whole life in a place that is safe and protected and simple and they don't really have that strength inside to fly."
  },
  {
    "author": "Georg Buchner",
    "category": "strength",
    "id": 64961,
    "text": "The weapon of the Republic is terror, and virtue is its strength."
  },
  {
    "author": "Jay Weatherill",
    "category": "strength",
    "id": 64906,
    "text": "By and large we have got to find the good leaders to work with to make sure that we build the strength in these communities. Simply issuing edicts from Canberra isn't going to solve issues on the APY lands."
  },
  {
    "author": "Katharine Hepburn",
    "category": "strength",
    "id": 64564,
    "text": "My greatest strength is common sense. I'm really a standard brand - like Campbell's tomato soup or Baker's chocolate."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "strength",
    "id": 64535,
    "text": "It is my own firm belief that the strength of the soul grows in proportion as you subdue the flesh."
  },
  {
    "author": "Billy Bush",
    "category": "strength",
    "id": 64997,
    "text": "I'm not slick. I'm not polished. I think my strength is in reacting."
  },
  {
    "author": "Michel de Montaigne",
    "category": "strength",
    "id": 64625,
    "text": "It is a sign of contraction of the mind when it is content, or of weariness. A spirited mind never stops within itself it is always aspiring and going beyond its strength."
  },
  {
    "author": "William Shakespeare",
    "category": "strength",
    "id": 64532,
    "text": "Women may fall when there's no strength in men."
  },
  {
    "author": "Indira Gandhi",
    "category": "strength",
    "id": 64624,
    "text": "A nation' s strength ultimately consists in what it can do on its own, and not in what it can borrow from others."
  },
  {
    "author": "Branch Rickey",
    "category": "strength",
    "id": 64919,
    "text": "I find fault with my children because I like them and I want them to go places - uprightness and strength and courage and civil respect and anything that affects the probabilities of failure on the part of those that are closest to me, that concerns me - I find fault."
  },
  {
    "author": "Lawrence G. Lovasik",
    "category": "strength",
    "id": 64464,
    "text": "Strength of character means the ability to overcome resentment against others, to hide hurt feelings, and to forgive quickly."
  },
  {
    "author": "Olivia Thirlby",
    "category": "strength",
    "id": 64923,
    "text": "I feel like it's always about embracing what it is that you think is wrong with you. It's often times your greatest 'flaw' which actually forays into what is also your greatest strength."
  },
  {
    "author": "William J. Clinton",
    "category": "strength",
    "id": 64752,
    "text": "President Obama's record on national security is a tribute to his strength, and judgment, and to his preference for inclusion and partnership over partisanship."
  },
  {
    "author": "Pedro Almodovar",
    "category": "strength",
    "id": 64824,
    "text": "I also wanted to express the strength of cinema to hide reality, while being entertaining. Cinema can fill in the empty spaces of your life and your loneliness."
  },
  {
    "author": "Adolf Hitler",
    "category": "strength",
    "id": 65181,
    "text": "Strength lies not in defence but in attack."
  },
  {
    "author": "Bear Grylls",
    "category": "strength",
    "id": 64834,
    "text": "My faith isn't very churchy, it's a pretty personal, intimate thing and has been a huge source of strength in moments of life and death."
  },
  {
    "author": "Charles Phillips",
    "category": "strength",
    "id": 65155,
    "text": "They just didn't have the sense of the strength of their vote. Just thought it wasn't necessary."
  },
  {
    "author": "Portia de Rossi",
    "category": "strength",
    "id": 64805,
    "text": "I want to exude strength and intelligence."
  },
  {
    "author": "Hayao Miyazaki",
    "category": "strength",
    "id": 64980,
    "text": "We get strength and encouragement from watching children."
  },
  {
    "author": "Michael Landon",
    "category": "strength",
    "id": 64959,
    "text": "With a houseful of kids you give each other strength."
  },
  {
    "author": "Michelle Obama",
    "category": "strength",
    "id": 64567,
    "text": "I am an example of what is possible when girls from the very beginning of their lives are loved and nurtured by people around them. I was surrounded by extraordinary women in my life who taught me about quiet strength and dignity."
  },
  {
    "author": "Christopher Reeve",
    "category": "strength",
    "id": 64552,
    "text": "A hero is an ordinary individual who finds the strength to persevere and endure in spite of overwhelming obstacles."
  },
  {
    "author": "George Mason",
    "category": "strength",
    "id": 64846,
    "text": "As much as I value an union of all the states, I would not admit the southern states into the union, unless they agreed to the discontinuance of this disgraceful trade, because it would bring weakness and not strength to the union."
  },
  {
    "author": "Andy Stern",
    "category": "strength",
    "id": 65120,
    "text": "And I think we understand we cannot make social change for all workers until we have enough strength, membership strength, and at the same time having membership strength and only making change for a limited group of workers is not what our country really needs for people that work."
  },
  {
    "author": "Henry Rollins",
    "category": "strength",
    "id": 64482,
    "text": "Scar tissue is stronger than regular tissue. Realize the strength, move on."
  },
  {
    "author": "William Moulton Marston",
    "category": "strength",
    "id": 65021,
    "text": "Not even girls want to be girls so long as our feminine archetype lacks force, strength, and power."
  },
  {
    "author": "Booker T. Washington",
    "category": "strength",
    "id": 64495,
    "text": "There are two ways of exerting one's strength: one is pushing down, the other is pulling up."
  },
  {
    "author": "Brad Henry",
    "category": "strength",
    "id": 64769,
    "text": "Something called 'the Oklahoma Standard' became known throughout the world. It means resilience in the face of adversity. It means a strength and compassion that will not be defeated."
  },
  {
    "author": "Ernest Istook",
    "category": "strength",
    "id": 64697,
    "text": "America's strength is not our diversity our strength is our ability to unite people of different backgrounds around common principles. A common language is necessary to reach that goal."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "strength",
    "id": 64667,
    "text": "Not one man in a thousand has the strength of mind or the goodness of heart to be an atheist."
  },
  {
    "author": "Baruch Spinoza",
    "category": "strength",
    "id": 64759,
    "text": "Peace is not the absence of war, but a virtue based on strength of character."
  },
  {
    "author": "Steve Albini",
    "category": "strength",
    "id": 65050,
    "text": "If the label presents them with a contract that the band don't want to sign, all the label has to do is wait. There are a hundred other bands willing to sign the exact same contract, so the label is in a position of strength."
  },
  {
    "author": "Francis Bacon",
    "category": "strength",
    "id": 64621,
    "text": "Many a man's strength is in opposition, and when he faileth, he grows out of use."
  },
  {
    "author": "Linda Hunt",
    "category": "strength",
    "id": 64895,
    "text": "I was always trying to make up for my size, to compensate. So to get people to take you seriously, you have to come at things with a great deal of strength. You have to emphasize that the way you are is unusual. That you don't come along every day."
  },
  {
    "author": "Joe Lieberman",
    "category": "strength",
    "id": 65053,
    "text": "Some in my party threaten to send a message that they don't know a just war when they see it, and more broadly that they're not prepared to use our military strength to protect our security and the cause of freedom."
  },
  {
    "author": "Jerry Costello",
    "category": "strength",
    "id": 65003,
    "text": "Through these adversities, Israel has endured with continued strength, conviction, and faith."
  },
  {
    "author": "Arthur Miller",
    "category": "strength",
    "id": 64728,
    "text": "The apple cannot be stuck back on the Tree of Knowledge once we begin to see, we are doomed and challenged to seek the strength to see more, not less."
  },
  {
    "author": "Doris Humphrey",
    "category": "strength",
    "id": 64669,
    "text": "There are movements which impinge upon the nerves with a strength that is incomparable, for movement has power to stir the senses and emotions, unique in itself."
  },
  {
    "author": "Mother Teresa",
    "category": "strength",
    "id": 64510,
    "text": "Be faithful in small things because it is in them that your strength lies."
  },
  {
    "author": "Jack LaLanne",
    "category": "strength",
    "id": 64825,
    "text": "So many older people, they just sit around all day long and they don't get any exercise. Their muscles atrophy, and they lose their strength, their energy and vitality by inactivity."
  },
  {
    "author": "Georges Duhamel",
    "category": "strength",
    "id": 65022,
    "text": "The swimmer adrift on the open seas measures his strength, and strives with all his muscles to keep himself afloat. But what is he to do when there is no land on the horizon, and none beyond it?"
  },
  {
    "author": "John Forsythe",
    "category": "strength",
    "id": 65156,
    "text": "Part of my strength as an actor comes from what I've learned all these years: when you play a villain, you try to get the light touches when you play a hero, you try to get in some of the warts."
  },
  {
    "author": "Albert Einstein",
    "category": "strength",
    "id": 64459,
    "text": "Only one who devotes himself to a cause with his whole strength and soul can be a true master. For this reason mastery demands all of a person."
  },
  {
    "author": "Pope Paul VI",
    "category": "strength",
    "id": 64712,
    "text": "Liturgy is like a strong tree whose beauty is derived from the continuous renewal of its leaves, but whose strength comes from the old trunk, with solid roots in the ground."
  },
  {
    "author": "Maggie Kuhn",
    "category": "strength",
    "id": 64812,
    "text": "Old age is not a disease - it is strength and survivorship, triumph over all kinds of vicissitudes and disappointments, trials and illnesses."
  },
  {
    "author": "Stafford Cripps",
    "category": "strength",
    "id": 65130,
    "text": "Productive power is the foundation of a country's economic strength."
  },
  {
    "author": "Carry Nation",
    "category": "strength",
    "id": 65178,
    "text": "I felt invincible. My strength was that of a giant. God was certainly standing by me. I smashed five saloons with rocks before I ever took a hatchet."
  },
  {
    "author": "James Hetfield",
    "category": "strength",
    "id": 64652,
    "text": "I like a women who's got some balls, some strength. As long as I can beat her at arm wrestling, that's fine."
  },
  {
    "author": "Cat Cora",
    "category": "strength",
    "id": 64815,
    "text": "The type of cuisine I do, especially after being on 'Iron Chef' for several years, is a lot of global cuisine. My strength has always been Mediterranean cuisine across the board from Morocco, Spain, Italy, Greece, France, but I think now I'm doing a lot of very different cuisines all the time."
  },
  {
    "author": "Adriana Trigiani",
    "category": "strength",
    "id": 64889,
    "text": "I come from hardworking, determined people on both sides of my family... the kind who live with a hard reality from which much strength comes."
  },
  {
    "author": "Maya Angelou",
    "category": "strength",
    "id": 64523,
    "text": "It is time for parents to teach young people early on that in diversity there is beauty and there is strength."
  },
  {
    "author": "Winston Churchill",
    "category": "strength",
    "id": 64455,
    "text": "Continuous effort - not strength or intelligence - is the key to unlocking our potential."
  },
  {
    "author": "Xun Zi",
    "category": "strength",
    "id": 64717,
    "text": "Quarreling over food and drink, having neither scruples nor shame, not knowing right from wrong, not trying to avoid death or injury, not fearful of greater strength or of greater numbers, greedily aware only of food and drink - such is the bravery of the dog and boar."
  },
  {
    "author": "Thorstein Veblen",
    "category": "strength",
    "id": 65098,
    "text": "The basis on which good repute in any highly organized industrial community ultimately rests is pecuniary strength and the means of showing pecuniary strength, and so of gaining or retaining a good name, are leisure and a conspicuous consumption of goods."
  },
  {
    "author": "John George Nicolay",
    "category": "strength",
    "id": 65126,
    "text": "Lincoln's stature and strength, his intelligence and ambition - in short, all the elements which gave him popularity among men in New Salem, rendered him equally attractive to the fair sex of that village."
  },
  {
    "author": "Anais Nin",
    "category": "strength",
    "id": 64518,
    "text": "I, with a deeper instinct, choose a man who compels my strength, who makes enormous demands on me, who does not doubt my courage or my toughness, who does not believe me naive or innocent, who has the courage to treat me like a woman."
  },
  {
    "author": "Russell Brand",
    "category": "strength",
    "id": 64730,
    "text": "Strength does not have to be belligerent and loud."
  },
  {
    "author": "James Kent",
    "category": "strength",
    "id": 65088,
    "text": "Nations are equal in respect to each other, and entitled to claim equal consideration for their rights, whatever may be their relative dimensions or strength or however greatly they may differ in government, religion or manners."
  },
  {
    "author": "Laura Wilkinson",
    "category": "strength",
    "id": 65142,
    "text": "I was vegetarian for a long time, and in the last four years I started eating chicken and fish. I feel like it really built up my strength a lot."
  },
  {
    "author": "Billie Joe Armstrong",
    "category": "strength",
    "id": 64665,
    "text": "Our passion is our strength."
  },
  {
    "author": "Larry Hagman",
    "category": "strength",
    "id": 64831,
    "text": "I went to a military school between the ages of six and 12 and later into the air force. You learn discipline and strength of character."
  },
  {
    "author": "Drew Barrymore",
    "category": "strength",
    "id": 64481,
    "text": "Life is very interesting... in the end, some of your greatest pains, become your greatest strengths."
  },
  {
    "author": "Fay Wray",
    "category": "strength",
    "id": 64951,
    "text": "There is a lot of strength and intelligence in Hollywood."
  },
  {
    "author": "John F. Kennedy",
    "category": "strength",
    "id": 64531,
    "text": "The tax on capital gains directly affects investment decisions, the mobility and flow of risk capital... the ease or difficulty experienced by new ventures in obtaining capital, and thereby the strength and potential for growth in the economy."
  },
  {
    "author": "Thomas Huxley",
    "category": "strength",
    "id": 64630,
    "text": "Freedom and order are not incompatible... truth is strength... free discussion is the very life of truth."
  },
  {
    "author": "Vernon Howard",
    "category": "strength",
    "id": 64484,
    "text": "A truly strong person does not need the approval of others any more than a lion needs the approval of sheep."
  },
  {
    "author": "Mary Lynn Rajskub",
    "category": "strength",
    "id": 65107,
    "text": "The more I get to do this character, the more I realize that she's not just annoying. It's that her strength is not interacting with people socially. She just doesn't have time because she has so much going on in her brain."
  },
  {
    "author": "Alison Lohman",
    "category": "strength",
    "id": 65101,
    "text": "I think everybody faces challenges in their lives. I've definitely been through it - not to the extreme that Astrid did. I try to keep some kind of identity and strength."
  },
  {
    "author": "Pat Riley",
    "category": "strength",
    "id": 64772,
    "text": "There can only be one state of mind as you approach any profound test total concentration, a spirit of togetherness, and strength."
  },
  {
    "author": "Marlo Thomas",
    "category": "strength",
    "id": 64643,
    "text": "In that I found being able to talk to my family about my feelings, praying for strength and realizing that our lives have a deep purpose and the journey of our lives is to find out what that is and express it, was the only way I could have gotten through it."
  },
  {
    "author": "Josefa Iloilo",
    "category": "strength",
    "id": 65059,
    "text": "We need to reach that happy stage of our development when differences and diversity are not seen as sources of division and distrust, but of strength and inspiration."
  },
  {
    "author": "Ricky Williams",
    "category": "strength",
    "id": 64768,
    "text": "I realized a while back that I have an innate ability to be compassionate, and I saw that the strength of compassion is something that healers have and healers use.'"
  },
  {
    "author": "Paul Harris",
    "category": "strength",
    "id": 64939,
    "text": "The very strength of a nation eventually proves to be its weakness."
  },
  {
    "author": "Jamie Kennedy",
    "category": "strength",
    "id": 65125,
    "text": "I'd like to be a wounded leading man. Instead of a pillar of strength, I'd be the scared one."
  },
  {
    "author": "Antonio Gramsci",
    "category": "strength",
    "id": 64749,
    "text": "My practicality consists in this, in the knowledge that if you beat your head against the wall it is your head which breaks and not the wall - that is my strength, my only strength."
  },
  {
    "author": "Thomas a Kempis",
    "category": "strength",
    "id": 64557,
    "text": "Love feels no burden, thinks nothing of trouble, attempts what is above its strength, pleads no excuse of impossibility for it thinks all things lawful for itself, and all things possible."
  },
  {
    "author": "Moshe Sharett",
    "category": "strength",
    "id": 64990,
    "text": "Our role in Israel is a pioneering one, and we need people with certain strength of fiber."
  },
  {
    "author": "Abdul Kalam",
    "category": "strength",
    "id": 64526,
    "text": "God, our Creator, has stored within our minds and personalities, great potential strength and ability. Prayer helps us tap and develop these powers."
  },
  {
    "author": "Woody Harrelson",
    "category": "strength",
    "id": 65066,
    "text": "I think my best skill in this whole deal is as a conduit to try to bring people together, because I think it's in our unity that we'll have the greatest strength."
  },
  {
    "author": "Ernest Hemingway",
    "category": "strength",
    "id": 64454,
    "text": "The world breaks everyone, and afterward, some are strong at the broken places."
  },
  {
    "author": "Steve Forbes",
    "category": "strength",
    "id": 65039,
    "text": "The Chinese government is quickly losing its ideological legitimacy, maintain its rule with force, but cannot draw strength from the ideology of Marx and Mao."
  },
  {
    "author": "Lance Reddick",
    "category": "strength",
    "id": 65087,
    "text": "It's funny, because in drama school, my greatest strength was my range. So my early career was like that: I played all kinds of different characters."
  },
  {
    "author": "Thomas Paine",
    "category": "strength",
    "id": 64565,
    "text": "The strength and power of despotism consists wholly in the fear of resistance."
  },
  {
    "author": "Aishwarya Rai",
    "category": "strength",
    "id": 64553,
    "text": "My family is my strength and my weakness."
  },
  {
    "author": "Jeffrey Sachs",
    "category": "strength",
    "id": 64946,
    "text": "There's a lot of strength in the U.S., but there's a lot of froth also. The froth will blow off. We're going to have to face up to some realities that we're not fully facing up to right now."
  },
  {
    "author": "Picabo Street",
    "category": "strength",
    "id": 64984,
    "text": "My knee is as strong as it was before, if not stronger, and it's a matter of getting my leg strong. I lost six years of strength in about six month's time, so it's going to take another year or two to get that leg back up to full strength, but I'm good to go so far."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "strength",
    "id": 64541,
    "text": "We gain the strength of the temptation we resist."
  }
]

quotes['success'] = [
  {
    "author": "Jeanne Moreau",
    "category": "success",
    "id": 65757,
    "text": "Success is like a liberation or the first phrase of a love story."
  },
  {
    "author": "Wiz Khalifa",
    "category": "success",
    "id": 66139,
    "text": "I always envisioned myself being a rapper and being in the game and having success, but you never know what it feels like or how you're going to be when you're there."
  },
  {
    "author": "Allan Bloom",
    "category": "success",
    "id": 65769,
    "text": "Fathers and mothers have lost the idea that the highest aspiration they might have for their children is for them to be wise... specialized competence and success are all that they can imagine."
  },
  {
    "author": "Monica Seles",
    "category": "success",
    "id": 66026,
    "text": "That's the key to success, isn't it? It has to be fun."
  },
  {
    "author": "Joey Adams",
    "category": "success",
    "id": 65789,
    "text": "Rockefeller once explained the secret of success. 'Get up early, work late - and strike oil.'"
  },
  {
    "author": "Michelle Obama",
    "category": "success",
    "id": 65536,
    "text": "Whether you come from a council estate or a country estate, your success will be determined by your own confidence and fortitude."
  },
  {
    "author": "Fidel Castro",
    "category": "success",
    "id": 65525,
    "text": "They talk about the failure of socialism but where is the success of capitalism in Africa, Asia and Latin America?"
  },
  {
    "author": "Lydia M. Child",
    "category": "success",
    "id": 65228,
    "text": "Belief in oneself is one of the most important bricks in building any successful venture."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "success",
    "id": 65373,
    "text": "That man is a success who has lived well, laughed often and loved much."
  },
  {
    "author": "Jules Renard",
    "category": "success",
    "id": 65711,
    "text": "The danger of success is that it makes us forget the world's dreadful injustice."
  },
  {
    "author": "Brendan Fraser",
    "category": "success",
    "id": 65996,
    "text": "I'm starting to judge success by the time I have for myself, the time I spend with family and friends. My priorities aren't amending they're shifting."
  },
  {
    "author": "Martin Van Buren",
    "category": "success",
    "id": 65646,
    "text": "On receiving from the people the sacred trust twice confided on my illustrious predecessor, and which he has discharged so faithfully and so well, I know that I can not expect to perform the arduous task with equal ability and success."
  },
  {
    "author": "Eliot Spitzer",
    "category": "success",
    "id": 65874,
    "text": "The Occupy movement needs an organizing principle, and - just as the Tea Party did - it needs some actual measures of success. Choose one candidate whose agenda is squarely within that of the movement and make his or her electoral success a focal point."
  },
  {
    "author": "W. Somerset Maugham",
    "category": "success",
    "id": 65257,
    "text": "The common idea that success spoils people by making them vain, egotistic and self-complacent is erroneous on the contrary it makes them, for the most part, humble, tolerant and kind."
  },
  {
    "author": "Malcolm Forbes",
    "category": "success",
    "id": 65556,
    "text": "Success follows doing what you want to do. There is no other way to be successful."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "success",
    "id": 65627,
    "text": "The first requisite for success is the ability to apply your physical and mental energies to one problem incessantly without growing weary."
  },
  {
    "author": "Mia Hamm",
    "category": "success",
    "id": 65760,
    "text": "Success breeds success."
  },
  {
    "author": "Guy Pearce",
    "category": "success",
    "id": 66088,
    "text": "Success comes in waves."
  },
  {
    "author": "Denis Waitley",
    "category": "success",
    "id": 65480,
    "text": "Time is the most precious element of human existence. The successful person knows how to put energy into time and how to draw success from time."
  },
  {
    "author": "Salvador Dali",
    "category": "success",
    "id": 65258,
    "text": "The thermometer of success is merely the jealousy of the malcontents."
  },
  {
    "author": "George Burns",
    "category": "success",
    "id": 65208,
    "text": "I honestly think it is better to be a failure at something you love than to be a success at something you hate."
  },
  {
    "author": "Vicente Fox",
    "category": "success",
    "id": 66072,
    "text": "The real end winner of NAFTA is going to be Mexico because we have the human capital. We have that resource that is vital to the success of the U.S. economy."
  },
  {
    "author": "Ben Barnes",
    "category": "success",
    "id": 66093,
    "text": "Sometimes success comes in ways you don't expect."
  },
  {
    "author": "Woody Allen",
    "category": "success",
    "id": 65465,
    "text": "Seventy percent of success in life is showing up."
  },
  {
    "author": "Edward Everett Hale",
    "category": "success",
    "id": 65707,
    "text": "The making of friends who are real friends, is the best token we have of a man's success in life."
  },
  {
    "author": "Michelle Obama",
    "category": "success",
    "id": 65642,
    "text": "Like so many American families, our families weren't asking for much. They didn't begrudge anyone else's success or care that others had much more than they did... in fact, they admired it."
  },
  {
    "author": "Jack Welch",
    "category": "success",
    "id": 65573,
    "text": "I've learned that mistakes can often be as good a teacher as success."
  },
  {
    "author": "Johnny Depp",
    "category": "success",
    "id": 65432,
    "text": "You do the work and you want people to see it but, um while I'm doing the work, the result doesn't matter at all to me. Ultimately, I don't, I don't care whether the film is - you know - some big giant box-office bonanza and I don't care if its a complete flop. To me, when a film gets made and it's actually finished it's a success. They're all a success in their own way."
  },
  {
    "author": "Mark Twain",
    "category": "success",
    "id": 65210,
    "text": "To succeed in life, you need two things: ignorance and confidence."
  },
  {
    "author": "Ronald Reagan",
    "category": "success",
    "id": 65299,
    "text": "We should measure welfare's success by how many people leave welfare, not by how many are added."
  },
  {
    "author": "Elbert Hubbard",
    "category": "success",
    "id": 65380,
    "text": "He has achieved success who has worked well, laughed often, and loved much."
  },
  {
    "author": "Malcolm X",
    "category": "success",
    "id": 65441,
    "text": "In all our deeds, the proper value and respect for time determines success or failure."
  },
  {
    "author": "Sting",
    "category": "success",
    "id": 65781,
    "text": "One of the rewards of success is freedom, the ability to do whatever you like."
  },
  {
    "author": "J. Michael Straczynski",
    "category": "success",
    "id": 65825,
    "text": "I was very clear that I wanted to keep 'Thor' out of the rest of the Marvel universe for no less than the first six issues. And the success of the book, I think, speaks well to that decision."
  },
  {
    "author": "Carl Lewis",
    "category": "success",
    "id": 66076,
    "text": "To this day, most people think of me as the fastest human. They don't really think me as a long jumper, although that's the event I had more success in."
  },
  {
    "author": "Jeffrey Archer",
    "category": "success",
    "id": 66142,
    "text": "Whenever you analyse anyone who has had any success and they're in the headlines, you will find they are human and make mistakes. I'm certainly that and I've made a lot of mistakes."
  },
  {
    "author": "James Thurber",
    "category": "success",
    "id": 65667,
    "text": "The appreciative smile, the chuckle, the soundless mirth, so important to the success of comedy, cannot be understood unless one sits among the audience and feels the warmth created by the quality of laughter that the audience takes home with it."
  },
  {
    "author": "Robert Baden-Powell",
    "category": "success",
    "id": 65607,
    "text": "Success in training the boy depends largely on the Scoutmaster's own personal example."
  },
  {
    "author": "Denis Waitley",
    "category": "success",
    "id": 65476,
    "text": "Forget about the consequences of failure. Failure is only a temporary change in direction to set you straight for your next success."
  },
  {
    "author": "Kate Moss",
    "category": "success",
    "id": 65833,
    "text": "People think your success is just a matter of having a pretty face. But it's easy to be chewed up and spat out. You've got to stay ahead of the game to be able to stay in it."
  },
  {
    "author": "Erwin Rommel",
    "category": "success",
    "id": 65984,
    "text": "Anyone who has to fight, even with the most modern weapons, against an enemy in complete command of the air, fights like a savage against modern European troops, under the same handicaps and with the same chances of success."
  },
  {
    "author": "Tony Robbins",
    "category": "success",
    "id": 65403,
    "text": "There's no abiding success without commitment."
  },
  {
    "author": "Jose Mourinho",
    "category": "success",
    "id": 65935,
    "text": "I'm not a defender of old or new football managers. I believe in good ones and bad ones, those that achieve success and those that don't."
  },
  {
    "author": "Mahalia Jackson",
    "category": "success",
    "id": 65846,
    "text": "They thought I was a success as soon as I started paying the bills."
  },
  {
    "author": "Jada Pinkett Smith",
    "category": "success",
    "id": 66155,
    "text": "I'm extremely ambitious. I don't know why people are afraid to say that. I won't sell my soul to the devil, but I do want success and I don't think that's bad."
  },
  {
    "author": "Bethenny Frankel",
    "category": "success",
    "id": 66131,
    "text": "I thought doing reality TV would be the greatest success of my life or the biggest mistake."
  },
  {
    "author": "Mindy Kaling",
    "category": "success",
    "id": 65850,
    "text": "I feel lucky because I was a nerd, which I talk about in the book, but I had academic success, so through that, because that's what my parents put a great deal of value on, I had a great childhood because I sort of fulfilled the expectations of being good at school."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "success",
    "id": 65857,
    "text": "I should just put it bluntly, because we're all sort of friends here now - it's exceedingly likely that my greatest success is behind me. Oh, so Jesus, what a thought! You know that's the kind of thought that could lead a person to start drinking gin at nine o'clock in the morning, and I don't want to go there."
  },
  {
    "author": "Paul J. Meyer",
    "category": "success",
    "id": 65282,
    "text": "Success is the progressive realization of predetermined, worthwhile, personal goals."
  },
  {
    "author": "Henry J. Heinz",
    "category": "success",
    "id": 65834,
    "text": "To do a common thing uncommonly well brings success."
  },
  {
    "author": "Paul Simon",
    "category": "success",
    "id": 65870,
    "text": "Without Arthur's voice, I never would have enjoyed that success."
  },
  {
    "author": "Ricky Williams",
    "category": "success",
    "id": 65808,
    "text": "There's more to life than success, and if you can try to be more well-rounded, you'll be able to enjoy your success more. It won't own you or control you."
  },
  {
    "author": "Lisa Loeb",
    "category": "success",
    "id": 66150,
    "text": "My overnight success was really 15 years in the making. I'd been writing songs since I was 6 and playing in bands and performing since I was 14."
  },
  {
    "author": "Danica Patrick",
    "category": "success",
    "id": 65498,
    "text": "I just go where my heart tells me, where my gut tells me to go, where I'm enjoying my life the most, where I feel like I can have the most success. I've truly enjoyed my experience in NASCAR, to the point that I want to do it full time."
  },
  {
    "author": "Alexandre Dumas",
    "category": "success",
    "id": 65284,
    "text": "Nothing succeeds like success."
  },
  {
    "author": "Whoopi Goldberg",
    "category": "success",
    "id": 66100,
    "text": "We're born with success. It is only others who point out our failures, and what they attribute to us as failure."
  },
  {
    "author": "Sloan Wilson",
    "category": "success",
    "id": 65269,
    "text": "Success in almost any field depends more on energy and drive than it does on intelligence. This explains why we have so many stupid leaders."
  },
  {
    "author": "Gail Porter",
    "category": "success",
    "id": 66154,
    "text": "I'm a mum, so my wardrobe consists of sweaters and jeans. As long as I don't leave the house forgetting my jeans, I count that as a fashion success."
  },
  {
    "author": "R. Kelly",
    "category": "success",
    "id": 66137,
    "text": "Well, I believe that the depth of your struggle can determine the height of your success. I was inspired to come out of everything I've been through and end up in a place where I never thought that I would be."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "success",
    "id": 65856,
    "text": "Which is - you know, like check it out, I'm pretty young, I'm only about 40 years old. I still have maybe another four decades of work left in me. And it's exceedingly likely that anything I write from this point forward is going to be judged by the world as the work that came after the freakish success of my last book, right?"
  },
  {
    "author": "Nicole Scherzinger",
    "category": "success",
    "id": 66118,
    "text": "I've always been too hard on myself to behave like I've arrived or even to enjoy whatever success I've had. I've always envisioned myself higher than where I was and I still do. With each success I think, 'That's nice but I'm supposed to go there!'"
  },
  {
    "author": "Niccolo Machiavelli",
    "category": "success",
    "id": 65395,
    "text": "There is nothing more difficult to take in hand, more perilous to conduct, or more uncertain in its success, than to take the lead in the introduction of a new order of things."
  },
  {
    "author": "H. Jackson Brown, Jr.",
    "category": "success",
    "id": 65401,
    "text": "Success is getting what you want. Happiness is liking what you get."
  },
  {
    "author": "Sarah Caldwell",
    "category": "success",
    "id": 66051,
    "text": "Success is important only to the extent that it puts one in a position to do more things one likes to do."
  },
  {
    "author": "Henri Frederic Amiel",
    "category": "success",
    "id": 65635,
    "text": "Everything you need for better future and success has already been written. And guess what? All you have to do is go to the library."
  },
  {
    "author": "Fran Lebowitz",
    "category": "success",
    "id": 65494,
    "text": "Success didn't spoil me, I've always been insufferable."
  },
  {
    "author": "Henri Matisse",
    "category": "success",
    "id": 65604,
    "text": "An artist must never be a prisoner. Prisoner? An artist should never be a prisoner of himself, prisoner of style, prisoner of reputation, prisoner of success, etc."
  },
  {
    "author": "Bobby Unser",
    "category": "success",
    "id": 65597,
    "text": "Success is where preparation and opportunity meet."
  },
  {
    "author": "Aesop",
    "category": "success",
    "id": 65648,
    "text": "The level of our success is limited only by our imagination and no act of kindness, however small, is ever wasted."
  },
  {
    "author": "Arnold H. Glasow",
    "category": "success",
    "id": 65250,
    "text": "Success isn't a result of spontaneous combustion. You must set yourself on fire."
  },
  {
    "author": "Kat Dennings",
    "category": "success",
    "id": 66089,
    "text": "I can't imagine wanting to be famous just for the sake of being famous. I think fame should come along with success, talent."
  },
  {
    "author": "Ambrose Bierce",
    "category": "success",
    "id": 65271,
    "text": "Success is the one unpardonable sin against our fellows."
  },
  {
    "author": "Logan P. Smith",
    "category": "success",
    "id": 65273,
    "text": "How can they say my life is not a success? Have I not for more than sixty years got enough to eat and escaped being eaten?"
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "success",
    "id": 65469,
    "text": "Success consecrates the most offensive crimes."
  },
  {
    "author": "Jim Carrey",
    "category": "success",
    "id": 65531,
    "text": "What I have in common with the character in 'Truman' is this incredible need to please people. I feel like I want to take care of everyone and I also feel this terrible guilt if I am unable to. And I have felt this way ever since all this success started."
  },
  {
    "author": "Bill Cosby",
    "category": "success",
    "id": 65185,
    "text": "In order to succeed, your desire for success should be greater than your fear of failure."
  },
  {
    "author": "Walter Pater",
    "category": "success",
    "id": 66067,
    "text": "To burn always with this hard, gem-like flame, to maintain this ecstasy, is success in life."
  },
  {
    "author": "Sheryl Sandberg",
    "category": "success",
    "id": 65776,
    "text": "I wish I could just go tell all the young women I work with, all these fabulous women, 'Believe in yourself and negotiate for yourself. Own your own success.' I wish I could tell that to my daughter. But it's not that simple."
  },
  {
    "author": "Shirley MacLaine",
    "category": "success",
    "id": 65764,
    "text": "Remember, I come from such an excessively overdone, red-carpet place called Hollywood. So I'm used to people blowing up their success in ways that are far above and beyond the truth."
  },
  {
    "author": "Sandra Bullock",
    "category": "success",
    "id": 65828,
    "text": "I've learned that success comes in a very prickly package. Whether you choose to accept it or not is up to you."
  },
  {
    "author": "Tennessee Williams",
    "category": "success",
    "id": 65265,
    "text": "Success is blocked by concentrating on it and planning for it... Success is shy - it won't come out while you're watching."
  },
  {
    "author": "John F. Kennedy",
    "category": "success",
    "id": 65307,
    "text": "Israel was not created in order to disappear - Israel will endure and flourish. It is the child of hope and the home of the brave. It can neither be broken by adversity nor demoralized by success. It carries the shield of democracy and it honors the sword of freedom."
  },
  {
    "author": "Leonard Cohen",
    "category": "success",
    "id": 65666,
    "text": "Success is survival."
  },
  {
    "author": "Oscar Wilde",
    "category": "success",
    "id": 65222,
    "text": "Success is a science if you have the conditions, you get the result."
  },
  {
    "author": "Danny Thomas",
    "category": "success",
    "id": 65697,
    "text": "Success has nothing to do with what you gain in life or accomplish for yourself. It's what you do for others."
  },
  {
    "author": "Samuel Butler",
    "category": "success",
    "id": 65490,
    "text": "If I die prematurely I shall be saved from being bored to death at my own success."
  },
  {
    "author": "B. C. Forbes",
    "category": "success",
    "id": 65283,
    "text": "The man who has done his level best... is a success, even though the world may write him down a failure."
  },
  {
    "author": "Tim Holden",
    "category": "success",
    "id": 66102,
    "text": "A variety of national and international studies indicate that the broad-based deployment of information technology can have a substantial impact on our nation's economic productivity and growth as well as the educational and social success of our citizens."
  },
  {
    "author": "Plato",
    "category": "success",
    "id": 65408,
    "text": "One man cannot practice many arts with success."
  },
  {
    "author": "Knute Rockne",
    "category": "success",
    "id": 66081,
    "text": "Four years of football are calculated to breed in the average man more of the ingredients of success in life than almost any academic course he takes."
  },
  {
    "author": "Samuel Goldwyn",
    "category": "success",
    "id": 65663,
    "text": "Give me a couple of years, and I'll make that actress an overnight success."
  },
  {
    "author": "Ann Landers",
    "category": "success",
    "id": 65535,
    "text": "The Lord gave us two ends - one to sit on and the other to think with. Success depends on which one we use the most."
  },
  {
    "author": "Peter Singer",
    "category": "success",
    "id": 65821,
    "text": "Do business managers have a commitment to anything more than the success of their company and to making money? It would be hard to say that they do. Indeed, many business leaders deny that there is any conflict between self-interest and the interests of all."
  },
  {
    "author": "Gordon Ramsay",
    "category": "success",
    "id": 65936,
    "text": "I suppose your security is your success and your key to success is your fine palate."
  },
  {
    "author": "Jean Cocteau",
    "category": "success",
    "id": 65601,
    "text": "We must believe in luck. For how else can we explain the success of those we don't like?"
  },
  {
    "author": "Jimmy Buffett",
    "category": "success",
    "id": 65519,
    "text": "Humor has bailed me out of more tight situations than I can think of. If you go with your instincts and keep your humor, creativity follows. With luck, success comes, too."
  },
  {
    "author": "Thornton Wilder",
    "category": "success",
    "id": 65690,
    "text": "Providence has nothing good or high in store for one who does not resolutely aim at something high or good. A purpose is the eternal condition of success."
  },
  {
    "author": "Cyril Connolly",
    "category": "success",
    "id": 65717,
    "text": "The secret of success is to be in harmony with existence, to be always calm to let each wave of life wash us a little farther up the shore."
  },
  {
    "author": "George Hickenlooper",
    "category": "success",
    "id": 65747,
    "text": "I always say be humble but be firm. Humility and openness are the key to success without compromising your beliefs."
  },
  {
    "author": "Ernest Hemingway",
    "category": "success",
    "id": 65415,
    "text": "If you have a success you have it for the wrong reasons. If you become popular it is always because of the worst aspects of your work."
  }
]

quotes['sympathy'] = [
  {
    "author": "Morris Raphael Cohen",
    "category": "sympathy",
    "id": 66322,
    "text": "A creative element is surely present in all great systems, and it does not seem possible that all sympathy or fundamental attitudes of will can be entirely eliminated from any human philosophy."
  },
  {
    "author": "William E. Gladstone",
    "category": "sympathy",
    "id": 66259,
    "text": "There should be a sympathy with freedom, a desire to give it scope, founded not upon visionary ideas, but upon the long experience of many generations within the shores of this happy isle, that in freedom you lay the firmest foundations both of loyalty and order."
  },
  {
    "author": "Mohammed Morsi",
    "category": "sympathy",
    "id": 66330,
    "text": "We all have to announce our full solidarity with the struggle of those seeking freedom and justice in Syria, and translate this sympathy into a clear political vision that supports a peaceful transition to a democratic system of rule that reflects the demands of the Syrian people for freedom."
  },
  {
    "author": "Dirk Benedict",
    "category": "sympathy",
    "id": 66208,
    "text": "Life has never been easy. Nor is it meant to be. It is a matter of being joyous in the face of sorrow."
  },
  {
    "author": "Henry Wadsworth Longfellow",
    "category": "sympathy",
    "id": 66206,
    "text": "There is no grief like the grief that does not speak."
  },
  {
    "author": "John Hall",
    "category": "sympathy",
    "id": 66349,
    "text": "More negatives write than call. It's a cheap shot for me to go on the air with the critical letters or E-mail I get because the reaction of the listeners is always an instantaneous expression of sympathy for me and contempt for the poor critic."
  },
  {
    "author": "Brownie McGhee",
    "category": "sympathy",
    "id": 66334,
    "text": "My guitar was loud as hell, and I had no sympathy for anybody else."
  },
  {
    "author": "Frances E. Willard",
    "category": "sympathy",
    "id": 66329,
    "text": "In externals we advance with lightening express speed, in modes of thought and sympathy we lumber on in stage-coach fashion."
  },
  {
    "author": "Walt Whitman",
    "category": "sympathy",
    "id": 66243,
    "text": "And whoever walks a furlong without sympathy walks to his own funeral drest in his shroud."
  },
  {
    "author": "John Irving",
    "category": "sympathy",
    "id": 66273,
    "text": "I take people very seriously. People are all I take seriously, in fact. Therefore, I have nothing but sympathy for how people behave - and nothing but laughter to console them with."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "sympathy",
    "id": 66201,
    "text": "It is foolish to tear one's hair in grief, as though sorrow would be made less by baldness."
  },
  {
    "author": "Havelock Ellis",
    "category": "sympathy",
    "id": 66247,
    "text": "If men and women are to understand each other, to enter into each other's nature with mutual sympathy, and to become capable of genuine comradeship, the foundation must be laid in youth."
  },
  {
    "author": "Harry Browne",
    "category": "sympathy",
    "id": 66281,
    "text": "Like many people, most Libertarians feel empathy and sympathy for less fortunate people. But they know you can't have perfection in a world of limited resources."
  },
  {
    "author": "William Shakespeare",
    "category": "sympathy",
    "id": 66185,
    "text": "When sorrows come, they come not single spies, but in battalions."
  },
  {
    "author": "William Hull",
    "category": "sympathy",
    "id": 66354,
    "text": "Captain Hale, alone, without sympathy or support, save that from above, on the near approach of death asked for a clergyman to attend him. It was refused. He then requested a Bible that too was refused by his inhuman jailer."
  },
  {
    "author": "William R. Alger",
    "category": "sympathy",
    "id": 66230,
    "text": "A crowd always thinks with its sympathy, never with its reason."
  },
  {
    "author": "Hugh Jackman",
    "category": "sympathy",
    "id": 66261,
    "text": "I like the Rolling Stones for karaoke. 'Sympathy For The Devil' is a great one."
  },
  {
    "author": "Samantha Morton",
    "category": "sympathy",
    "id": 66294,
    "text": "When you've been raised in care, rap music isn't just about guns and sexism. They're talking about real things you can hang on to, problems of identity that you have sympathy with. It's not just about the music, with rap: when I was in care, it meant a whole lot more than that."
  },
  {
    "author": "Irving Babbitt",
    "category": "sympathy",
    "id": 66267,
    "text": "The true humanist maintains a just balance between sympathy and selection."
  },
  {
    "author": "W. H. Davies",
    "category": "sympathy",
    "id": 66350,
    "text": "Teetotallers lack the sympathy and generosity of men that drink."
  },
  {
    "author": "George MacDonald",
    "category": "sympathy",
    "id": 66263,
    "text": "When we are out of sympathy with the young, then I think our work in this world is over."
  },
  {
    "author": "Clyde Tombaugh",
    "category": "sympathy",
    "id": 66289,
    "text": "I have a lot of sympathy for young people because I realize how disturbed I was. How would I deal with life in the future? What would I do for a living?"
  },
  {
    "author": "Mary Beth Whitehead",
    "category": "sympathy",
    "id": 66342,
    "text": "I have great sympathy for people that are infertile, but a life is not something you can give away."
  },
  {
    "author": "Florence Nightingale",
    "category": "sympathy",
    "id": 66285,
    "text": "Women have no sympathy and my experience of women is almost as large as Europe."
  },
  {
    "author": "Les Aspin",
    "category": "sympathy",
    "id": 66351,
    "text": "There's a certain amount of sympathy here for the Bush administration's problem, which is they would like to get rid of Saddam Hussein and they would like to have the Kurds autonomous."
  },
  {
    "author": "Henry David Thoreau",
    "category": "sympathy",
    "id": 66236,
    "text": "It appears to be a law that you cannot have a deep sympathy with both man and nature."
  },
  {
    "author": "Queen Elizabeth II",
    "category": "sympathy",
    "id": 66251,
    "text": "To all those who have suffered as a consequence of our troubled past I extend my sincere thoughts and deep sympathy. With the benefit of historical hindsight we can all see things which we would wish had been done differently or not at all."
  },
  {
    "author": "Edward Gibbon",
    "category": "sympathy",
    "id": 66268,
    "text": "Our sympathy is cold to the relation of distant misery."
  },
  {
    "author": "Peter Storey",
    "category": "sympathy",
    "id": 66353,
    "text": "I didn't feel any remorse or sympathy if I injured a rival. I went over the top a few times but I never broke anyone's leg."
  },
  {
    "author": "George Soros",
    "category": "sympathy",
    "id": 66295,
    "text": "If the terrorists have the sympathy of people, it's much harder to find them. So we need people on our side, and that leads us to be responsible leaders of the world, show some concern with the problems."
  },
  {
    "author": "Malcolm Forbes",
    "category": "sympathy",
    "id": 66210,
    "text": "The more sympathy you give, the less you need."
  },
  {
    "author": "Terry Prachett",
    "category": "sympathy",
    "id": 66318,
    "text": "I didn't go to university. Didn't even finish A-levels. But I have sympathy for those who did."
  },
  {
    "author": "Kate Smith",
    "category": "sympathy",
    "id": 66287,
    "text": "I sometimes get that wonderful sympathy between me and the audience, telling me I've reached their hearts. And when I do, the thrill is mine."
  },
  {
    "author": "Aneurin Bevan",
    "category": "sympathy",
    "id": 66266,
    "text": "I would rather be kept alive in the efficient if cold altruism of a large hospital than expire in a gush of warm sympathy in a small one."
  },
  {
    "author": "Dante Alighieri",
    "category": "sympathy",
    "id": 66192,
    "text": "There is no greater sorrow than to recall happiness in times of misery."
  },
  {
    "author": "A. N. Wilson",
    "category": "sympathy",
    "id": 66276,
    "text": "I very much dislike the intolerance and moralism of many Christians, and feel more sympathy with Honest Doubters than with them."
  },
  {
    "author": "Henry Cabot Lodge",
    "category": "sympathy",
    "id": 66300,
    "text": "Recognition of belligerency as an expression of sympathy is all very well."
  },
  {
    "author": "Queen Elizabeth II",
    "category": "sympathy",
    "id": 66202,
    "text": "Grief is the price we pay for love."
  },
  {
    "author": "Tom Ford",
    "category": "sympathy",
    "id": 66280,
    "text": "September 11th was a moment when America had the sympathy of the world."
  },
  {
    "author": "Michael Gove",
    "category": "sympathy",
    "id": 66271,
    "text": "Learning a foreign language, and the culture that goes with it, is one of the most useful things we can do to broaden the empathy and imaginative sympathy and cultural outlook of children."
  },
  {
    "author": "Jesse Jackson",
    "category": "sympathy",
    "id": 66245,
    "text": "Both tears and sweat are salty, but they render a different result. Tears will get you sympathy sweat will get you change."
  },
  {
    "author": "Voltaire",
    "category": "sympathy",
    "id": 66189,
    "text": "Tears are the silent language of grief."
  },
  {
    "author": "Denis Kearney",
    "category": "sympathy",
    "id": 66335,
    "text": "California must be all American or all Chinese. We are resolved that it shall be American, and are prepared to make it so. May we not rely upon your sympathy and assistance?"
  },
  {
    "author": "Albert Szent-Gyorgyi",
    "category": "sympathy",
    "id": 66310,
    "text": "I am the son of a small and far-away nation and the other laureates have all come from different countries from all over the world and we all were equally received here with signs of sympathy."
  },
  {
    "author": "Saint Augustine",
    "category": "sympathy",
    "id": 66183,
    "text": "What does love look like? It has the hands to help others. It has the feet to hasten to the poor and needy. It has eyes to see misery and want. It has the ears to hear the sighs and sorrows of men. That is what love looks like."
  },
  {
    "author": "George William Norris",
    "category": "sympathy",
    "id": 66328,
    "text": "Men are often biased in their judgment on account of their sympathy and their interests."
  },
  {
    "author": "Aeschylus",
    "category": "sympathy",
    "id": 66194,
    "text": "There is no pain so great as the memory of joy in present grief."
  },
  {
    "author": "Gary Ackerman",
    "category": "sympathy",
    "id": 66311,
    "text": "Whether rich people make money or lose money, they get no sympathy from the public."
  },
  {
    "author": "Erich von Stroheim",
    "category": "sympathy",
    "id": 66306,
    "text": "Because I select my players from a feeling that comes to me when I am with them, a certain sympathy you might call it, or a vibration that exists between us that convinces me they are right."
  },
  {
    "author": "Tim Kaine",
    "category": "sympathy",
    "id": 66316,
    "text": "I'm not going to give a courtesy gift to a person who's going to win, and I'm not going to give a sympathy gift to a person who's going to lose."
  },
  {
    "author": "Juliette Gordon Low",
    "category": "sympathy",
    "id": 66305,
    "text": "Badges mean nothing in themselves, but they mark a certain achievement and they are a link between the rich and the poor. For when one girl sees a badge on a sister Scout's arm, if that girl has won the same badge, it at once awakens an interest and sympathy between them."
  },
  {
    "author": "Wislawa Szymborska",
    "category": "sympathy",
    "id": 66286,
    "text": "I have sympathy for young people, for their growing pains, but I balk when these growing pains are pushed into the foreground, when you make these young people the only vehicles of life's wisdom."
  },
  {
    "author": "Agatha Christie",
    "category": "sympathy",
    "id": 66205,
    "text": "I have sometimes been wildly, despairingly, acutely miserable, racked with sorrow, but through it all I still know quite certainly that just to be alive is a grand thing."
  },
  {
    "author": "Robert Browning",
    "category": "sympathy",
    "id": 66248,
    "text": "Autumn wins you best by this its mute appeal to sympathy for its decay."
  },
  {
    "author": "Barbara Sher",
    "category": "sympathy",
    "id": 66228,
    "text": "The cure for sorrow is to learn something."
  },
  {
    "author": "Daniel Johns",
    "category": "sympathy",
    "id": 66292,
    "text": "I have a theory because I was being beaten up a lot by people outside of school, it was almost like if I could make myself sick enough they'd take sympathy on me."
  },
  {
    "author": "George Eliot",
    "category": "sympathy",
    "id": 66244,
    "text": "Marriage must be a relation either of sympathy or of conquest."
  },
  {
    "author": "Nellie Bly",
    "category": "sympathy",
    "id": 66297,
    "text": "It is only after one is in trouble that one realizes how little sympathy and kindness there are in the world."
  },
  {
    "author": "Woodrow Wilson",
    "category": "sympathy",
    "id": 66257,
    "text": "Interest does not tie nations together it sometimes separates them. But sympathy and understanding does unite them."
  },
  {
    "author": "Lionel Blue",
    "category": "sympathy",
    "id": 66279,
    "text": "I learnt pity, sympathy, and what it was like to be at the other end of the stick. Such lessons can't be learnt in lecture halls."
  },
  {
    "author": "Moliere",
    "category": "sympathy",
    "id": 66212,
    "text": "If you suppress grief too much, it can well redouble."
  },
  {
    "author": "Francis Herbert Hedge",
    "category": "sympathy",
    "id": 66332,
    "text": "Sympathy with nature is part of a good person's religion."
  },
  {
    "author": "Oscar Wilde",
    "category": "sympathy",
    "id": 66186,
    "text": "If there was less sympathy in the world, there would be less trouble in the world."
  },
  {
    "author": "Alphonse de Lamartine",
    "category": "sympathy",
    "id": 66217,
    "text": "Grief knits two hearts in closer bonds than happiness ever can and common sufferings are far stronger links than common joys."
  },
  {
    "author": "F. H. Bradley",
    "category": "sympathy",
    "id": 66302,
    "text": "It is by a wise economy of nature that those who suffer without change, and whom no one can help, become uninteresting. Yet so it may happen that those who need sympathy the most often attract it the least."
  },
  {
    "author": "Billy Tauzin",
    "category": "sympathy",
    "id": 66336,
    "text": "I think we lost a great deal of sympathy and support with the way in which the crisis was handled, most importantly I think when we appeared to be grasping for too much at one time instead of identifying our priorities in a much more responsible fashion."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "sympathy",
    "id": 66246,
    "text": "I'm not looking for sympathy at all."
  },
  {
    "author": "Stafford Cripps",
    "category": "sympathy",
    "id": 66343,
    "text": "Reasoned arguments and suggestions which make allowance for the full difficulties of the state of war that exists may help, and will always be listened to with respect and sympathy."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "sympathy",
    "id": 66239,
    "text": "Two nations between whom there is no intercourse and no sympathy who are as ignorant of each other's habits, thoughts, and feelings, as if they were dwellers in different zones, or inhabitants of different planets. The rich and the poor."
  },
  {
    "author": "Carl Clinton Van Doren",
    "category": "sympathy",
    "id": 66346,
    "text": "IT is mere coincidence that Cooper was born in the year which produced The Power of Sympathy and that when he died Uncle Tom's Cabin was passing through its serial stage, and yet the limits of his life mark almost exactly the first great period of American fiction."
  },
  {
    "author": "Thomas More",
    "category": "sympathy",
    "id": 66215,
    "text": "Here bring your wounded hearts, here tell your anguish Earth has no sorrow that Heaven cannot heal."
  },
  {
    "author": "Eamon de Valera",
    "category": "sympathy",
    "id": 66319,
    "text": "Since this war began our sympathy has gone out to all the suffering people who have been dragged into it. Further hundreds of millions have become involved since I spoke at Limerick fortnight ago."
  },
  {
    "author": "Nigella Lawson",
    "category": "sympathy",
    "id": 66225,
    "text": "You don't go around grieving all the time, but the grief is still there and always will be."
  },
  {
    "author": "Richard M. Nixon",
    "category": "sympathy",
    "id": 66252,
    "text": "We do not learn by inference and deduction and the application of mathematics to philosophy, but by direct intercourse and sympathy."
  },
  {
    "author": "Michael Ealy",
    "category": "sympathy",
    "id": 66331,
    "text": "There's something very beautiful and compelling about someone who has ambition and someone who knows what they want, but it can get a little frustrating at times, so I understand that. I have sympathy for that."
  },
  {
    "author": "Oscar Wilde",
    "category": "sympathy",
    "id": 66235,
    "text": "There is something terribly morbid in the modern sympathy with pain. One should sympathise with the colour, the beauty, the joy of life. The less said about life's sores the better."
  },
  {
    "author": "Carl Hiaasen",
    "category": "sympathy",
    "id": 66282,
    "text": "Here's my rule: You always want to pay cash for your own books, because if they look at the name on the credit card and then they look at the name on the book jacket, then there's this look of such profound sympathy for you that you had to resort to this. It really is withering."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "sympathy",
    "id": 66242,
    "text": "Staying married may have long-term benefits. You can elicit much more sympathy from friends over a bad marriage than you ever can from a good divorce."
  },
  {
    "author": "Meister Eckhart",
    "category": "sympathy",
    "id": 66197,
    "text": "Truly, it is in darkness that one finds the light, so when we are in sorrow, then this light is nearest of all to us."
  },
  {
    "author": "Haruki Murakami",
    "category": "sympathy",
    "id": 66250,
    "text": "You are 27 or 28 right? It is very tough to live at that age. When nothing is sure. I have sympathy with you."
  },
  {
    "author": "Bob Feller",
    "category": "sympathy",
    "id": 66296,
    "text": "Sympathy is something that shouldn't be bestowed upon the Yankees. Apparently it angers them."
  },
  {
    "author": "Victor Hugo",
    "category": "sympathy",
    "id": 66190,
    "text": "Sorrow is a fruit. God does not make it grow on limbs too weak to bear it."
  },
  {
    "author": "Edward Norton",
    "category": "sympathy",
    "id": 66255,
    "text": "I've always thought of acting as more of an exercise in empathy, which is not to be confused with sympathy. You're trying to get inside a certain emotional reality or motivational reality and try to figure out what that's about so you can represent it."
  },
  {
    "author": "Tom Paulin",
    "category": "sympathy",
    "id": 66340,
    "text": "This sympathy is not translated into force against the British government because it is not like the anti- apartheid movement which had a high profile here and Mandela is a more engaging figure than Yasser Arafat."
  },
  {
    "author": "Alfred Lord Tennyson",
    "category": "sympathy",
    "id": 66207,
    "text": "A sorrow's crown of sorrow is remembering happier times."
  },
  {
    "author": "Dorothy Day",
    "category": "sympathy",
    "id": 66327,
    "text": "I believe that we must reach our brother, never toning down our fundamental oppositions, but meeting him when he asks to be met, with a reason for the faith that is in us, as well as with a loving sympathy for them as brothers."
  },
  {
    "author": "John Buchanan Robinson",
    "category": "sympathy",
    "id": 66309,
    "text": "According to your sympathy, you will take pleasure in your own happiness or in the happiness of other people but it is always your own happiness you seek."
  },
  {
    "author": "Agnes Smedley",
    "category": "sympathy",
    "id": 66317,
    "text": "My mother listened to all the news from the camp during the strike. She said little, especially when my father or the men who worked for him were about I remember her instinctive and unhesitating sympathy for the miners."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "sympathy",
    "id": 66188,
    "text": "Only by joy and sorrow does a person know anything about themselves and their destiny. They learn what to do and what to avoid."
  },
  {
    "author": "Alexei Navalny",
    "category": "sympathy",
    "id": 66326,
    "text": "When men are arrested without any legal basis and for political reasons, it's merely a routine, everyday occurrence in Russia, and hardly anyone has any sympathy."
  },
  {
    "author": "Evelyn Underhill",
    "category": "sympathy",
    "id": 66277,
    "text": "Deliberately seek opportunities for kindness, sympathy, and patience."
  },
  {
    "author": "Shinzo Abe",
    "category": "sympathy",
    "id": 66337,
    "text": "I have to express sympathy from the bottom of my heart to those people who were taken as wartime comfort women. As a human being, I would like to express my sympathies, and also as prime minister of Japan I need to apologize to them."
  },
  {
    "author": "Marlo Thomas",
    "category": "sympathy",
    "id": 66214,
    "text": "I think loss of loved ones is the hardest blow in life."
  },
  {
    "author": "Alex Ferguson",
    "category": "sympathy",
    "id": 66313,
    "text": "I feel sympathy for the working class lad. I've always championed about ticket prices and try to equate that to people's salaries."
  },
  {
    "author": "Lech Walesa",
    "category": "sympathy",
    "id": 66269,
    "text": "I belong to a nation which over the past centuries has experienced many hardships and reverses. The world reacted with silence or with mere sympathy when Polish frontiers were crossed by invading armies and the sovereign state had to succumb to brutal force."
  },
  {
    "author": "Henry Ossawa Tanner",
    "category": "sympathy",
    "id": 66272,
    "text": "Many of the artists who have represented Negro life have seen only the comic, ludicrous side of it, and have lacked sympathy with and appreciation for the warm big heart that dwells within such a rough exterior."
  },
  {
    "author": "George Saunders",
    "category": "sympathy",
    "id": 66274,
    "text": "I tend to foster drama via bleakness. If I want the reader to feel sympathy for a character, I cleave the character in half, on his birthday. And then it starts raining. And he's made of sugar."
  },
  {
    "author": "Alton Brown",
    "category": "sympathy",
    "id": 66275,
    "text": "I have nothing but sympathy for the people who are forced to work with me. I'm better now at picking out those that want to play that game with me, and those that don't."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "sympathy",
    "id": 66238,
    "text": "The rule of friendship means there should be mutual sympathy between them, each supplying what the other lacks and trying to benefit the other, always using friendly and sincere words."
  },
  {
    "author": "Mark Feuerstein",
    "category": "sympathy",
    "id": 66347,
    "text": "Okay, so, sometimes in life, I can be a score-keeper - someone who keeps track of what he gives and what he gets in return. An annoying quality, to say the least, and I'm sure my wife has your sympathy, but it's made me highly attuned to when and where credit is due."
  }
]

quotes['teacher'] = [
  {
    "author": "Xun Zi",
    "category": "teacher",
    "id": 66427,
    "text": "When people lack teachers, their tendencies are not corrected when they do not have ritual and moral principles, then their lawlessness is not controlled."
  },
  {
    "author": "Paul O'Grady",
    "category": "teacher",
    "id": 66805,
    "text": "My primary school teacher once poured a bottle of curdled school milk forcefully down my throat. Then I threw it up all over her suede shoes. I'd rather have drunk from the spittoon in Barney's barber shop."
  },
  {
    "author": "Nicole Anderson",
    "category": "teacher",
    "id": 66895,
    "text": "I was in three academic clubs, a huge book worm and the teacher's pet. I was kind of an easy target for bullies."
  },
  {
    "author": "Devon Sawa",
    "category": "teacher",
    "id": 66674,
    "text": "I was a hyper kid in school and the teacher suggested to my mom she needed to do something with me."
  },
  {
    "author": "Peter Jurasik",
    "category": "teacher",
    "id": 66814,
    "text": "I went whole hog at the actor's lifestyle - really embraced it. I had by then known how much I loved acting already, because I discovered acting from a teacher in the seminary - that's the first place I ever did it, in the seminary."
  },
  {
    "author": "Lily Tomlin",
    "category": "teacher",
    "id": 66382,
    "text": "I like a teacher who gives you something to take home to think about besides homework."
  },
  {
    "author": "Mikheil Saakashvili",
    "category": "teacher",
    "id": 66880,
    "text": "I have good relationships with Hillary Clinton, Joseph Biden and especially Richard Holbrooke - he is my teacher. I learned a lot of great things from him."
  },
  {
    "author": "William Arthur Ward",
    "category": "teacher",
    "id": 66473,
    "text": "The mediocre teacher tells. The good teacher explains. The superior teacher demonstrates. The great teacher inspires."
  },
  {
    "author": "Billy Baldwin",
    "category": "teacher",
    "id": 66837,
    "text": "My dad was a high school teacher and made no money."
  },
  {
    "author": "Solomon Ortiz",
    "category": "teacher",
    "id": 66410,
    "text": "Education is the key to success in life, and teachers make a lasting impact in the lives of their students."
  },
  {
    "author": "Jimmy Carter",
    "category": "teacher",
    "id": 66502,
    "text": "In this outward and physical ceremony we attest once again to the inner and spiritual strength of our Nation. As my high school teacher, Miss Julia Coleman, used to say: 'We must adjust to changing times and still hold to unchanging principles.'"
  },
  {
    "author": "Vernon Law",
    "category": "teacher",
    "id": 66484,
    "text": "Experience is a hard teacher because she gives the test first, the lesson afterward."
  },
  {
    "author": "Bill Moyers",
    "category": "teacher",
    "id": 66755,
    "text": "As a student I learned from wonderful teachers and ever since then I've thought everyone is a teacher."
  },
  {
    "author": "Mike Krzyzewski",
    "category": "teacher",
    "id": 66547,
    "text": "I think some parents now look at a youngster failing as the final thing. It's a process, and failure is part of the process. I would like it if the teacher and the parents would connect more. I think that used to be, but we're losing a little bit of that right now."
  },
  {
    "author": "Darrell Royal",
    "category": "teacher",
    "id": 66612,
    "text": "You know, a football coach is nothing more than a teacher. You teach them the same subject, and you have a group of new guys every year."
  },
  {
    "author": "Lee Iacocca",
    "category": "teacher",
    "id": 66378,
    "text": "In a completely rational society, the best of us would be teachers and the rest of us would have to settle for something else."
  },
  {
    "author": "Maria Montessori",
    "category": "teacher",
    "id": 66531,
    "text": "The teacher must derive not only the capacity, but the desire, to observe natural phenomena. The teacher must understand and feel her position of observer: the activity must lie in the phenomenon."
  },
  {
    "author": "Paul O'Grady",
    "category": "teacher",
    "id": 66804,
    "text": "I enjoyed school - although I ran away on the first day. I'd reminded the teacher that it was nearly time for 'Watch With Mother' on TV."
  },
  {
    "author": "Anatole France",
    "category": "teacher",
    "id": 66395,
    "text": "The whole art of teaching is only the art of awakening the natural curiosity of young minds for the purpose of satisfying it afterwards."
  },
  {
    "author": "Nicky Hilton",
    "category": "teacher",
    "id": 66735,
    "text": "I always wanted to be a teacher."
  },
  {
    "author": "Robert Sternberg",
    "category": "teacher",
    "id": 66550,
    "text": "In other words, if a teacher only teaches in one way, then they conclude that the kids who can't learn well that way don't have the ability, when, in fact, it may be that the way the teacher's teaching is not a particularly good match to the way those kids learn."
  },
  {
    "author": "Matt Cameron",
    "category": "teacher",
    "id": 66733,
    "text": "I guess by taking lessons early on, and really trying to play all the rudimentary stuff, and try to have it sound as good as my teacher. It took a lot of practice, which I enjoyed, and still do."
  },
  {
    "author": "Niklaus Wirth",
    "category": "teacher",
    "id": 66632,
    "text": "My duty as a teacher is to train, educate future programmers."
  },
  {
    "author": "Eugen Herrigel",
    "category": "teacher",
    "id": 66879,
    "text": "Far from wishing to awaken the artist in the pupil prematurely, the teacher considers it his first task to make him a skilled artisan with sovereign control of his craft."
  },
  {
    "author": "Ally Condie",
    "category": "teacher",
    "id": 66865,
    "text": "One of the things I've always liked about my husband is he's very good at lots of stuff. He was an English teacher when I met him. He wrote poetry and played the guitar. As time went on, he decided to go into economics, so he's very analytical and mathematical in addition to his artsy side."
  },
  {
    "author": "A. N. Wilson",
    "category": "teacher",
    "id": 66530,
    "text": "I should prefer to have a politician who regularly went to a massage parlour than one who promised a laptop computer for every teacher."
  },
  {
    "author": "Archie Panjabi",
    "category": "teacher",
    "id": 66704,
    "text": "My mother wanted to be a teacher when she was young, and my father didn't approve of it, so she fought very hard to become one. And she did it. So when I said I wanted to become an actress, my mother was very supportive. She always said to me, 'There's no such thing as 'can't.'"
  },
  {
    "author": "Niklaus Wirth",
    "category": "teacher",
    "id": 66706,
    "text": "My being a teacher had a decisive influence on making language and systems as simple as possible so that in my teaching, I could concentrate on the essential issues of programming rather than on details of language and notation."
  },
  {
    "author": "Loni Anderson",
    "category": "teacher",
    "id": 66702,
    "text": "My grandmother was a teacher, my sister was a teacher, my daughter was a teacher and is now a superintendent in northern California, and my son-in-law is a high school principal. I am surrounded."
  },
  {
    "author": "Katherine Jenkins",
    "category": "teacher",
    "id": 66585,
    "text": "Oh, stuff the critics. I don't care. Too many people are snooty about classical. Look, I wasn't brought up in a home where we listened to classical music. It was a singing teacher that thought it would be best for my voice. Then I moved into crossover. And if that makes the music accessible to more people, then great."
  },
  {
    "author": "Noah Hathaway",
    "category": "teacher",
    "id": 66798,
    "text": "My father was a writer and an acting teacher."
  },
  {
    "author": "Brian Sandoval",
    "category": "teacher",
    "id": 66812,
    "text": "Dad worked his entire career as an aviation technician. Mom was a legal secretary who became a teacher. We lived a simple American life."
  },
  {
    "author": "Kid Cudi",
    "category": "teacher",
    "id": 66872,
    "text": "Once I accomplish one thing and I'm satisfied, I try something else. I may be 50 and doing something totally outside of music and acting. Maybe I'll become a kindergarten teacher."
  },
  {
    "author": "Sly Stone",
    "category": "teacher",
    "id": 66451,
    "text": "It's not the teaching, it's the learning."
  },
  {
    "author": "Freeman A. Hrabowski III",
    "category": "teacher",
    "id": 66847,
    "text": "My mother was an English teacher who decided to become a math teacher, and she used me as a guinea pig at home. My father had been a math teacher and then went to work at a steel mill because, frankly, he could make more money doing that."
  },
  {
    "author": "Sela Ward",
    "category": "teacher",
    "id": 66766,
    "text": "I had an art teacher who's the reason I got there in high school who encouraged me to go to Alabama. That's where she had gone and kept raving over their art department."
  },
  {
    "author": "Elisabeth Shue",
    "category": "teacher",
    "id": 66660,
    "text": "I want to be involved with young people in some way. Teenagers. Because that's the most vulnerable time. I have a fantasy of becoming a teacher one day."
  },
  {
    "author": "Eric Hoffer",
    "category": "teacher",
    "id": 66411,
    "text": "It is the malady of our age that the young are so busy teaching us that they have no time left to learn."
  },
  {
    "author": "Jonathan Shapiro",
    "category": "teacher",
    "id": 66777,
    "text": "There was a teacher who recognized that I was interested in cartooning and he was great."
  },
  {
    "author": "Tom Vilsack",
    "category": "teacher",
    "id": 66599,
    "text": "There are ways we can go do a better job of educating young moms and dads about the vital role they have as the child's first teacher. I think there are ways in which we can partner with local school districts and states to do a better job to provide nutrition options at school."
  },
  {
    "author": "Jenna Bush",
    "category": "teacher",
    "id": 66672,
    "text": "As a teacher you can see the difference in kids who have parents who were involved. That difference, by the time these kids get to the third grade, is drastic."
  },
  {
    "author": "William Glasser",
    "category": "teacher",
    "id": 66566,
    "text": "Prior to being allowed to enter the profession, prospective teachers should be asked to talk with a group of friendly students for at least half an hour and be able to engage them in an interesting conversation about any subject the prospective teacher wants to talk about."
  },
  {
    "author": "Sue Kelly",
    "category": "teacher",
    "id": 66753,
    "text": "As a former teacher and a mother and grandmother, I know firsthand the importance of a quality education."
  },
  {
    "author": "W. H. Auden",
    "category": "teacher",
    "id": 66392,
    "text": "A professor is someone who talks in someone else's sleep."
  },
  {
    "author": "Brad Henry",
    "category": "teacher",
    "id": 66374,
    "text": "A good teacher can inspire hope, ignite the imagination, and instill a love of learning."
  },
  {
    "author": "George Shearing",
    "category": "teacher",
    "id": 66811,
    "text": "I studied with a blind teacher from about 5 until I was 16, at two different schools. From the age of 12 until 16, I was in a boarding school-which, I believe, at that time was compulsory for blind children."
  },
  {
    "author": "Yoko Ono",
    "category": "teacher",
    "id": 66559,
    "text": "Events are the best teacher for us. You try to learn from people, there is always some bend to it."
  },
  {
    "author": "Betty Buckley",
    "category": "teacher",
    "id": 66751,
    "text": "Well, the teacher I studied with for nineteen and a half years was a man named Paul Gavert. He was a great lieder singer, so basically I'm a trained lieder singer because of that teacher. The teacher I currently study with - since 1995 - is Joan Lader, who also studied with Gavert."
  },
  {
    "author": "William Glasser",
    "category": "teacher",
    "id": 66404,
    "text": "We can teach a lot of things, but if the teacher can't relate by talking to a group of friendly students, he'll never be a competent teacher."
  },
  {
    "author": "Antonio Tabucchi",
    "category": "teacher",
    "id": 66646,
    "text": "Literature is my life of course, but from an ontological point of view. From an existential point of view, I like being a teacher."
  },
  {
    "author": "Confucius",
    "category": "teacher",
    "id": 66358,
    "text": "If I am walking with two other men, each of them will serve as my teacher. I will pick out the good points of the one and imitate them, and the bad points of the other and correct them in myself."
  },
  {
    "author": "John Leguizamo",
    "category": "teacher",
    "id": 66813,
    "text": "I had a great movement teacher - he showed me how to walk so I wasn't becoming like a cartoon."
  },
  {
    "author": "Mary Catherine Bateson",
    "category": "teacher",
    "id": 66540,
    "text": "Fear is not a good teacher. The lessons of fear are quickly forgotten."
  },
  {
    "author": "Tim Gunn",
    "category": "teacher",
    "id": 66690,
    "text": "If you told me when I was a teen that I would end up being a teacher, I would have said you're out of your mind, because quite frankly I hated school."
  },
  {
    "author": "Andrew Shue",
    "category": "teacher",
    "id": 66678,
    "text": "I was on Oprah's show recently talking about the people who impacted me the most. One was a teacher and one was my soccer coach. I didn't even go into my family, who had the most influence."
  },
  {
    "author": "Martin Mull",
    "category": "teacher",
    "id": 66736,
    "text": "I had a teacher in art school who said something about the only works he really enjoyed seeing or found much in were works where he had a sense that a discovery was made in the course of making this object. I like to hold to that as my marching orders."
  },
  {
    "author": "Charles Stanley",
    "category": "teacher",
    "id": 66501,
    "text": "You can't tell a woman who is called by God to teach that she cannot teach the Word of God... So I think the distinction is that there's a difference between the authority of a pastor and a Bible teacher."
  },
  {
    "author": "Kate Adie",
    "category": "teacher",
    "id": 66625,
    "text": "I was sent to a nice Church of England girls' school and at that time, after university, a woman was expected to become a teacher, a nurse or a missionary - prior to marriage."
  },
  {
    "author": "Jeremy Irvine",
    "category": "teacher",
    "id": 66788,
    "text": "I had a great drama teacher, and he sort of made out drama school as this incredibly difficult thing to get into: 6,000 people apply every year, and some of the schools only have 12 places. It's a phenomenally difficult thing to get into. And that excited me - I wanted that challenge."
  },
  {
    "author": "Greg Iles",
    "category": "teacher",
    "id": 66890,
    "text": "My mother, a teacher, encouraged me to use my creativity as an actual way to make a living, and my father, a Mississippi physician, did two things. First, he taught me that all human beings should be treated equally because no one is better than anyone else, and he never pressured me to become a doctor."
  },
  {
    "author": "Temple Grandin",
    "category": "teacher",
    "id": 66509,
    "text": "Research is starting to show that a child should be engaged at least 20 hours a week. I do not think it matters which program you choose as long as it keeps the child actively engaged with the therapist, teacher, or parent for at least 20 hours a week."
  },
  {
    "author": "John Legend",
    "category": "teacher",
    "id": 66520,
    "text": "Experience is a great teacher."
  },
  {
    "author": "A. Bartlett Giamatti",
    "category": "teacher",
    "id": 66419,
    "text": "Teachers believe they have a gift for giving it drives them with the same irrepressible drive that drives others to create a work of art or a market or a building."
  },
  {
    "author": "Natasha Calis",
    "category": "teacher",
    "id": 66888,
    "text": "I've been acting my whole life. I have this huge imagination! I'm a dancer and my mom's a dance teacher, and I was always performing and entertaining people. I'd go to see live theatre or a movie, and I'd become the main character for a few days afterwards. I loved being somebody new for a temporary amount of time."
  },
  {
    "author": "Carla Bley",
    "category": "teacher",
    "id": 66818,
    "text": "When you are studying jazz, the best thing to do is listen to records or listen to live music. It isn't as though you go to a teacher. You just listen as much as you can and absorb everything."
  },
  {
    "author": "Alan Shepard",
    "category": "teacher",
    "id": 66601,
    "text": "I'd like to say I was smart enough to finish six grades in five years, but I think perhaps the teacher was just glad to get rid of me."
  },
  {
    "author": "Ben Vereen",
    "category": "teacher",
    "id": 66789,
    "text": "I had a teacher, he was 86 years old and his name was Luigi in New York City, and he said, 'Never stop moving. You get to reinvent yourself.' So you have to find ways to reinventing yourself. Especially today, because it's a whole different market - social media is so important."
  },
  {
    "author": "Alton Brown",
    "category": "teacher",
    "id": 66583,
    "text": "I'm like a really goofy home ec teacher."
  },
  {
    "author": "Tom Brown, Jr.",
    "category": "teacher",
    "id": 66600,
    "text": "Evil can be a teacher, if you look at the wisdom of its negative power."
  },
  {
    "author": "Roddy Doyle",
    "category": "teacher",
    "id": 66656,
    "text": "When I started writing full time I had not long stopped being a teacher and when at last I had a full day to write, I would put music on and wonder to myself - am I allowed to do this? Then I thought: 'I am control of this and no one is telling me what I can do.'"
  },
  {
    "author": "Steve Harvey",
    "category": "teacher",
    "id": 66402,
    "text": "Failure is a great teacher, and I think when you make mistakes and you recover from them and you treat them as valuable learning experiences, then you've got something to share."
  },
  {
    "author": "Miranda Cosgrove",
    "category": "teacher",
    "id": 66873,
    "text": "I do home schooling. I went to regular school until fifth grade, and then I started doing home schooling, which it's completely different. I have a teacher on set with me and I just work with her, one-on-one."
  },
  {
    "author": "Thomas Szasz",
    "category": "teacher",
    "id": 66445,
    "text": "A teacher should have maximal authority, and minimal power."
  },
  {
    "author": "John Madden",
    "category": "teacher",
    "id": 66684,
    "text": "I'm sure that had I not been a coach, I would have been some form of a teacher."
  },
  {
    "author": "David Puttnam",
    "category": "teacher",
    "id": 66844,
    "text": "Without any doubt at all, teacher quality is the fundamental differentiator. Not just, incidentally, of education, but I would argue, probably the biggest single differentiator of success for the nations of the 21st Century."
  },
  {
    "author": "Wallace Stegner",
    "category": "teacher",
    "id": 66794,
    "text": "A teacher enlarges people in all sorts of ways besides just his subject matter."
  },
  {
    "author": "Ellen Pompeo",
    "category": "teacher",
    "id": 66718,
    "text": "I don't find acting to be a particularly noble way to make a living. I'm not saving anybody's life, I'm not a teacher, I'm not working for UNICEF. I don't think I'm some big deal."
  },
  {
    "author": "Christa McAuliffe",
    "category": "teacher",
    "id": 66617,
    "text": "NASA was going to pick a public school teacher to go into space, observe and make a journal about the space flight, and I am a teacher who always dreamed of going up into space."
  },
  {
    "author": "John Strachan",
    "category": "teacher",
    "id": 66448,
    "text": "To this end the greatest asset of a school is the personality of the teacher."
  },
  {
    "author": "Steve Case",
    "category": "teacher",
    "id": 66697,
    "text": "My father still is a lawyer, and my mom was a teacher and then later a career counselor."
  },
  {
    "author": "Niki Taylor",
    "category": "teacher",
    "id": 66839,
    "text": "I always think about which blood drive was going on in Georgia that day when that husband or mom or school teacher rolled up their sleeve and actually gave me a second chance at life. It's the ultimate gift of life, and I'm the one who was on the other end."
  },
  {
    "author": "Jim Hunt",
    "category": "teacher",
    "id": 66825,
    "text": "In the depth of the near depression, that he faced when he came in, Barack Obama and Democratic leaders in Congress provided 'recovery funds' that literally kept our classrooms open. Two years ago, these funds saved nearly 20,000 teacher and education jobs - just here in North Carolina."
  },
  {
    "author": "Lance Burton",
    "category": "teacher",
    "id": 66838,
    "text": "When I started out back in Louisville, there was Harry Collins. He was my first teacher. He saw that I was so obsessed with magic that he taught me the love of magic."
  },
  {
    "author": "Tony Visconti",
    "category": "teacher",
    "id": 66696,
    "text": "I could never have a better teacher in those days than my father."
  },
  {
    "author": "Jet Li",
    "category": "teacher",
    "id": 66633,
    "text": "I want to thank my mum, my daddy, my coach, my teacher, everybody in my life."
  },
  {
    "author": "Nathan Fillion",
    "category": "teacher",
    "id": 66613,
    "text": "I kind of fell backwards into acting. I was studying to be a high school teacher. I look now and I understand completely, or actually barely, how much work it is to be a teacher. It's an incredible amount of work."
  },
  {
    "author": "Vinny Guadagnino",
    "category": "teacher",
    "id": 66664,
    "text": "I made my drama teacher cry. I only took drama to get out of writing papers in English and the teacher was this thespian Broadway geek and here I was this Italian guy from Staten Island and I would put her in tears."
  },
  {
    "author": "Doris Roberts",
    "category": "teacher",
    "id": 66466,
    "text": "Everybody's a teacher if you listen."
  },
  {
    "author": "Ed O'Neill",
    "category": "teacher",
    "id": 66831,
    "text": "That's a big deal for kids, when they come into the kitchen and the teacher is drinking coffee with mom. They react differently on the next day when you say: 'Sit down and shut-up!'"
  },
  {
    "author": "Jane Haddam",
    "category": "teacher",
    "id": 66845,
    "text": "I've been a teacher at the college level, in composition mostly, and I've been an editor on magazines."
  },
  {
    "author": "George Osborne",
    "category": "teacher",
    "id": 66620,
    "text": "I think the British people are very, very attached to the idea that the health service is free at the point of use. But there is no reason why every doctor, nurse and teacher in this country has to be employed by the state."
  },
  {
    "author": "Daniel H. Hill",
    "category": "teacher",
    "id": 66856,
    "text": "Jackson went from the professor's chair to the officer's saddle. He carried with him the very elements of character which made him odious as a teacher but I never saw him in an arbitrary mood."
  },
  {
    "author": "Kerry Healey",
    "category": "teacher",
    "id": 66861,
    "text": "As the daughter of a schoolteacher, I feel very strongly that the most important thing in school takes place right there in that classroom, and the interaction between the teacher and the child."
  },
  {
    "author": "Neale Donald Walsch",
    "category": "teacher",
    "id": 66491,
    "text": "I was told to challenge every spiritual teacher, every world leader to utter the one sentence that no religion, no political party, and no nation on the face of the earth will dare utter: 'Ours is not a better way, ours is merely another way."
  },
  {
    "author": "James S. Coleman",
    "category": "teacher",
    "id": 66431,
    "text": "A child's learning is a function more of the characteristics of his classmates than those of the teacher."
  },
  {
    "author": "Kristin Bauer van Straten",
    "category": "teacher",
    "id": 66826,
    "text": "My acting teacher used to say that people reveal themselves in their opposites."
  },
  {
    "author": "Jean Reno",
    "category": "teacher",
    "id": 66758,
    "text": "I first decided to become an actor at school. A teacher gave us a play to do and that had a major impact. At first, I wanted to work in the theatre, but there was something about the ambience of film, especially American films, that always attracted me."
  },
  {
    "author": "Harry S. Truman",
    "category": "teacher",
    "id": 66380,
    "text": "I do not believe there is a problem in this country or the world today which could not be settled if approached through the teaching of the Sermon on the Mount."
  },
  {
    "author": "Donald Norman",
    "category": "teacher",
    "id": 66721,
    "text": "So what does a good teacher do? Create tension - but just the right amount."
  },
  {
    "author": "Will Hermes",
    "category": "teacher",
    "id": 66885,
    "text": "Adele Adkins' retro-soul debut, '19', was striking less for her songs than for that voice: a voluptuous, slightly parched alto that swooped and fluttered like a Dusty Springfield student trying to upstage her teacher, or at least update the rules."
  }
]

quotes['technology'] = [
  {
    "author": "Hideki Tojo",
    "category": "technology",
    "id": 67470,
    "text": "However, even during the preparations for action, we laid our plans in such a manner that should there be progress through diplomatic negotiation, we would be well prepared to cancel operations at the latest moment that communication technology would have permitted."
  },
  {
    "author": "Andy Rooney",
    "category": "technology",
    "id": 66920,
    "text": "Making duplicate copies and computer printouts of things no one wanted even one of in the first place is giving America a new sense of purpose."
  },
  {
    "author": "Michael Morpurgo",
    "category": "technology",
    "id": 67216,
    "text": "It is the child's understanding that teaches the adults the way of the future. They're still doing it today with modern technology."
  },
  {
    "author": "David Boies",
    "category": "technology",
    "id": 67223,
    "text": "Here you have a new technology, and if that technology is going to work, you must allow people to provide central indexes of the data. It's just like a newspaper that publishes classified ads."
  },
  {
    "author": "Nina Garcia",
    "category": "technology",
    "id": 67585,
    "text": "People always ask me if I could live in any other era what would it be, and I tell them none! I feel so lucky to live in an age where technology has changed and continues to change and make life so much more exciting. It keeps everyone young and constantly learning new things."
  },
  {
    "author": "Simon Mainwaring",
    "category": "technology",
    "id": 67058,
    "text": "Let's hope brands recognize that the true power of this technology is not its reach but its ability to communicate substance that adds meaning to our lives. Otherwise, brands will be investing in technology that consumers simply won't buy."
  },
  {
    "author": "Aldous Huxley",
    "category": "technology",
    "id": 66910,
    "text": "Technological progress has merely provided us with more efficient means for going backwards."
  },
  {
    "author": "Carl Sagan",
    "category": "technology",
    "id": 66914,
    "text": "We've arranged a civilization in which most crucial elements profoundly depend on science and technology."
  },
  {
    "author": "Terri Windling",
    "category": "technology",
    "id": 67371,
    "text": "Since fantasy isn't about technology, the accelleration has no impact at all. But it's changed the lives of fantasy writers and editors. I get to live in England and work for a New York publisher!"
  },
  {
    "author": "Ralph Merkle",
    "category": "technology",
    "id": 67391,
    "text": "If you look at the various strategies available for dealing with a new technology, sticking your head in the sand is not the most plausible strategy."
  },
  {
    "author": "Ben Rattray",
    "category": "technology",
    "id": 67757,
    "text": "Social networking technology didn't really exist until 2004-2005. I had the idea to use this technology to bridge this gap between a general interest in addressing social issues and the practical action."
  },
  {
    "author": "Charles E. Wilson",
    "category": "technology",
    "id": 67444,
    "text": "That the way to achieve higher standards of living for all is through science and technology, taking advantage of better tools, methods and organization."
  },
  {
    "author": "Aaron Neville",
    "category": "technology",
    "id": 67495,
    "text": "It's a 360-degree sound experience. Like you're in the middle of the band. A lot of people have the technology to play the format, so why not put it out there. It sounds great."
  },
  {
    "author": "Richard Powers",
    "category": "technology",
    "id": 67366,
    "text": "I think that if the novel's task is to describe where we find ourselves and how we live now, the novelist must take a good, hard look at the most central facts of contemporary life - technology and science."
  },
  {
    "author": "Jonathan Sacks",
    "category": "technology",
    "id": 67111,
    "text": "Which European leader today would not relish the wonder-working powers of a Moses? Budget deficit? Unpopular cuts? How about just a little miracle, an overnight increase in gold reserves, a new oil field, or the next world-changing communications technology? Surely that's not too much to ask."
  },
  {
    "author": "Karen Armstrong",
    "category": "technology",
    "id": 67068,
    "text": "Mythology and science both extend the scope of human beings. Like science and technology, mythology, as we shall see, is not about opting out of this world, but about enabling us to live more intensely within it."
  },
  {
    "author": "Brendan Fraser",
    "category": "technology",
    "id": 67295,
    "text": "As sophisticated as the technology gets, the less sophisticated you have to become as an actor."
  },
  {
    "author": "Ryan Seacrest",
    "category": "technology",
    "id": 67229,
    "text": "With the evolution of technology, kids really need to be computer-savvy."
  },
  {
    "author": "Chris Anderson",
    "category": "technology",
    "id": 67773,
    "text": "And what's interesting about the hybrids taking off is you've now introduced electric motors to the automobile industry. It's the first radical change in automobile technology in 100 years."
  },
  {
    "author": "Ralph Merkle",
    "category": "technology",
    "id": 67102,
    "text": "If we can reduce the cost and improve the quality of medical technology through advances in nanotechnology, we can more widely address the medical conditions that are prevalent and reduce the level of human suffering."
  },
  {
    "author": "Donald Evans",
    "category": "technology",
    "id": 67496,
    "text": "We are the number one economy in the world, and we ought to continue to pursue those kinds of policies that ensure that we maintain that position, like innovation and like technology and like education and like just research and development and discovery."
  },
  {
    "author": "Ron Fournier",
    "category": "technology",
    "id": 67073,
    "text": "Don't underestimate questions from the crowd technology has made voters more informed than ever."
  },
  {
    "author": "Edgar Bronfman, Jr.",
    "category": "technology",
    "id": 67694,
    "text": "The history of the music industry is inevitably also the story of the development of technology. From the player piano to the vinyl disc, from reel-to-reel tape to the cassette, from the CD to the digital download, these formats and devices changed not only the way music was consumed, but the very way artists created it."
  },
  {
    "author": "John Romero",
    "category": "technology",
    "id": 67594,
    "text": "I'm creating the kind of games that I like right now. I'm not being held back by technology."
  },
  {
    "author": "Stella McCartney",
    "category": "technology",
    "id": 67303,
    "text": "I love that you can have the language between the two worlds of technology and fashion, because I don't think that many designers get to do that."
  },
  {
    "author": "Arthur C. Clarke",
    "category": "technology",
    "id": 66902,
    "text": "Any sufficiently advanced technology is indistinguishable from magic."
  },
  {
    "author": "Susan Orlean",
    "category": "technology",
    "id": 67063,
    "text": "Sometimes I'm dazzled by how modern and fabulous we are, and how easy everything can be for us that's the gilded glow of technology, and I marvel at it all the time."
  },
  {
    "author": "Esther Dyson",
    "category": "technology",
    "id": 67386,
    "text": "Part of the problem is when we bring in a new technology we expect it to be perfect in a way that we don't expect the world that we're familiar with to be perfect."
  },
  {
    "author": "K. Eric Drexler",
    "category": "technology",
    "id": 67530,
    "text": "But while doing that I'd been following a variety of fields in science and technology, including the work in molecular biology, genetic engineering, and so forth."
  },
  {
    "author": "Billy Corgan",
    "category": "technology",
    "id": 67032,
    "text": "There's nothing wrong with technology. It's when technology is the story and not the artist, that's the problem."
  },
  {
    "author": "John Sexton",
    "category": "technology",
    "id": 67328,
    "text": "In my mind I needed a symbol of today's technology, and I realized that what I wanted to photograph was the Space Shuttle. And so that's where Places of Power came into being."
  },
  {
    "author": "Laura Marling",
    "category": "technology",
    "id": 67298,
    "text": "I know there are lots of positives in the evolution of technology, but I also think it will be responsible for the end of a unique character, of a specific kind of geographical culture. The world is getting so small, and mass production is getting so big. Everything is in danger of becoming the same."
  },
  {
    "author": "Jaron Lanier",
    "category": "technology",
    "id": 67188,
    "text": "It is impossible to work in information technology without also engaging in social engineering."
  },
  {
    "author": "Edward R. Murrow",
    "category": "technology",
    "id": 66932,
    "text": "The newest computer can merely compound, at speed, the oldest problem in the relations between human beings, and in the end the communicator will be confronted with the old problem, of what to say and how to say it."
  },
  {
    "author": "Antoine de Saint-Exupery",
    "category": "technology",
    "id": 66924,
    "text": "The machine does not isolate man from the great problems of nature but plunges him more deeply into them."
  },
  {
    "author": "Chris Wedge",
    "category": "technology",
    "id": 67697,
    "text": "Well, in our industry it's that the movies cost so much money to make they have to appeal to a broad audience. And I think that's part of what will loosen up in the future, as technology makes it cheaper, you'll be able to make films for a more selective audience. I think people will be able to make more personal movies."
  },
  {
    "author": "Shinya Yamanaka",
    "category": "technology",
    "id": 67509,
    "text": "My goals over the decade include to develop new drugs to treat intractable diseases by using iPS cell technology and to conduct clinical trials using it on a few patients with Parkinson's diseases, diabetes or blood diseases."
  },
  {
    "author": "Stephen Carter",
    "category": "technology",
    "id": 67691,
    "text": "More than 20 years on, sustained competition, informed customers and the rapid growth of new technology provide the necessary environment for substantial deregulation."
  },
  {
    "author": "Fareed Zakaria",
    "category": "technology",
    "id": 67153,
    "text": "What we see today is an American economy that has boomed because of policies and developments of the 1950s and '60s: the interstate-highway system, massive funding for science and technology, a public-education system that was the envy of the world and generous immigration policies."
  },
  {
    "author": "Daniel Yergin",
    "category": "technology",
    "id": 67471,
    "text": "So the major obstacle to the development of new supplies is not geology but what happens above ground: international affairs, politics, investment and technology."
  },
  {
    "author": "Nancy Pelosi",
    "category": "technology",
    "id": 67129,
    "text": "Furthermore, we believe that health care reform, again I said at the beginning of my remarks, that we sent the three pillars that the President's economic stabilization and job creation initiatives were education and innovation - innovation begins in the classroom - clean energy and climate, addressing the climate issues in an innovative way to keep us number one and competitive in the world with the new technology, and the third, first among equals I may say, is health care, health insurance reform."
  },
  {
    "author": "Tom Clancy",
    "category": "technology",
    "id": 67249,
    "text": "There used to be this country called the Soviet Union it's not there anymore. Our technology was better than theirs."
  },
  {
    "author": "Esther Dyson",
    "category": "technology",
    "id": 66963,
    "text": "It may not always be profitable at first for businesses to be online, but it is certainly going to be unprofitable not to be online."
  },
  {
    "author": "Marissa Mayer",
    "category": "technology",
    "id": 67196,
    "text": "You can be good at technology and like fashion and art. You can be good at technology and be a jock. You can be good at technology and be a mom. You can do it your way, on your terms."
  },
  {
    "author": "Reed Hastings",
    "category": "technology",
    "id": 67269,
    "text": "Stone Age. Bronze Age. Iron Age. We define entire epics of humanity by the technology they use."
  },
  {
    "author": "Brian McKnight",
    "category": "technology",
    "id": 67613,
    "text": "Stevie didn't use the technology to drive the song. He used it to enhance. I use the tools to further my work, I don't use my work to further the tools."
  },
  {
    "author": "Theodor Adorno",
    "category": "technology",
    "id": 66937,
    "text": "Technology is making gestures precise and brutal, and with them men."
  },
  {
    "author": "Christian Lous Lange",
    "category": "technology",
    "id": 67262,
    "text": "Technology is a useful servant but a dangerous master."
  },
  {
    "author": "James Dyson",
    "category": "technology",
    "id": 67144,
    "text": "Design and technology should be the subject where mathematical brainboxes and science whizzkids turn their bright ideas into useful products."
  },
  {
    "author": "Marc Andreessen",
    "category": "technology",
    "id": 67061,
    "text": "Any new technology tends to go through a 25-year adoption cycle."
  },
  {
    "author": "K. Eric Drexler",
    "category": "technology",
    "id": 67531,
    "text": "Protein engineering is a technology of molecular machines - of molecular machines that are part of replicators - and so it comes from an area that already raises some of the issues that nanotechnology will raise."
  },
  {
    "author": "Marc Andreessen",
    "category": "technology",
    "id": 67084,
    "text": "I love what the Valley does. I love company building. I love startups. I love technology companies. I love new technology. I love this process of invention. Being able to participate in that as a founder and a product creator, or as an investor or a board member, I just find that hugely satisfying."
  },
  {
    "author": "Gordon Brown",
    "category": "technology",
    "id": 67377,
    "text": "Take, therefore, what modern technology is capable of: the power of our moral sense allied to the power of communications and our ability to organize internationally.That, in my view, gives us the first opportunity as a community to fundamentally change the world."
  },
  {
    "author": "Ellen Ochoa",
    "category": "technology",
    "id": 67544,
    "text": "We are involved in technology development for, you know, missions that we hope to plan that would take us to an asteroid and eventually to Mars."
  },
  {
    "author": "Ernest Istook",
    "category": "technology",
    "id": 67426,
    "text": "Research and development needs permanent tax credits to build the technology that spurs our growth. But no government programs alone can get America's students to study more science and math parents must push and help their children to meet this goal."
  },
  {
    "author": "Kenneth G. Wilson",
    "category": "technology",
    "id": 67676,
    "text": "My graduate studies were carried out at the California Institute of Technology."
  },
  {
    "author": "B. F. Skinner",
    "category": "technology",
    "id": 66935,
    "text": "The real problem is not whether machines think but whether men do."
  },
  {
    "author": "Charles F. Bass",
    "category": "technology",
    "id": 67744,
    "text": "I am in the process of trying to decide whether I can make a substantive and productive contribution to the policy-making process. I was always there because I wanted to work on the pressing issues of the day - I'm interested in energy, I'm interested in the climate bill and technology policy."
  },
  {
    "author": "John W. Thompson",
    "category": "technology",
    "id": 67576,
    "text": "First, I do not think there is any silver bullet to solving the technology side of the security equation."
  },
  {
    "author": "R. Buckminster Fuller",
    "category": "technology",
    "id": 66933,
    "text": "Humanity is acquiring all the right technology for all the wrong reasons."
  },
  {
    "author": "Bob Barr",
    "category": "technology",
    "id": 67361,
    "text": "Looking down the road, space exploration and the benefits it yields - in medicine and information technology - should not be overlooked."
  },
  {
    "author": "Jared Diamond",
    "category": "technology",
    "id": 66957,
    "text": "Technology has to be invented or adopted."
  },
  {
    "author": "Whitfield Diffie",
    "category": "technology",
    "id": 67171,
    "text": "I understood the importance in principle of public key cryptography but it's all moved much faster than I expected. I did not expect it to be a mainstay of advanced communications technology."
  },
  {
    "author": "Jerry Zucker",
    "category": "technology",
    "id": 67745,
    "text": "I love technology, and I love new gadgets. I can no longer figure out how to use any of them, but I love them."
  },
  {
    "author": "Shoshana Zuboff",
    "category": "technology",
    "id": 67761,
    "text": "Technology makes the world a new place."
  },
  {
    "author": "Carly Fiorina",
    "category": "technology",
    "id": 67075,
    "text": "I managed Hewlett Packard through the worst technology downturn in 25 years, the dotcom bust."
  },
  {
    "author": "Stewart Alsop",
    "category": "technology",
    "id": 66984,
    "text": "Gates is the ultimate programming machine. He believes everything can be defined, examined, reduced to essentials, and rearranged into a logical sequence that will achieve a particular goal."
  },
  {
    "author": "St. Vincent",
    "category": "technology",
    "id": 67342,
    "text": "I've been so entwined with technology since I was about 15, recording myself and multitracking and producing things on my own."
  },
  {
    "author": "Jaron Lanier",
    "category": "technology",
    "id": 67187,
    "text": "I feel drawn to experiment with ways that technology can interact with notions of intimacy, because so much of technology is done in a way that's very cold and has such an opposite effect."
  },
  {
    "author": "Keith Richards",
    "category": "technology",
    "id": 67022,
    "text": "To make a rock'n'roll record, technology is the least important thing."
  },
  {
    "author": "James Daly",
    "category": "technology",
    "id": 67413,
    "text": "You know, technology CEOs like to think of themselves as rock 'n roll stars."
  },
  {
    "author": "Tony Visconti",
    "category": "technology",
    "id": 67330,
    "text": "But some great records are are being made with today's technology and there are still great artists among us. Likewise there are artists today who are so reliant on modern technology, they wouldn't have emerged when recording was more organic."
  },
  {
    "author": "Alvin Toffler",
    "category": "technology",
    "id": 67108,
    "text": "Technology feeds on itself. Technology makes more technology possible."
  },
  {
    "author": "Karl Popper",
    "category": "technology",
    "id": 67020,
    "text": "Piecemeal social engineering resembles physical engineering in regarding the ends as beyond the province of technology."
  },
  {
    "author": "Daniel H. Wilson",
    "category": "technology",
    "id": 67314,
    "text": "These days the technology can solve our problems and then some. Solutions may not only erase physical or mental deficits but leave patients better off than \"able-bodied\" folks. The person who has a disability today may have a superability tomorrow."
  },
  {
    "author": "Serge Haroche",
    "category": "technology",
    "id": 67543,
    "text": "Most technological advances in our life now come from serendipitous discoveries. That is a contraction of rocket technology and computer technology and atomic clock technology."
  },
  {
    "author": "Robert Englund",
    "category": "technology",
    "id": 67592,
    "text": "I would like to see the technology used to explore more period horror genre works, for example, E. A. Poe."
  },
  {
    "author": "Dan Lipinski",
    "category": "technology",
    "id": 67227,
    "text": "I hope that we can continue this cooperation on other critical issues related to America's future technological competitiveness. We must work together to encourage the creative talents that have made our country the world leader in technology."
  },
  {
    "author": "Heather Donahue",
    "category": "technology",
    "id": 67645,
    "text": "If we had been less reliant on technology and the security that we enjoy in being divorced from what we used to know, maybe things would have turned out differently."
  },
  {
    "author": "Jack L. Chalker",
    "category": "technology",
    "id": 67715,
    "text": "I have taught history on the high school and college levels, and am or have been a lecturer at the Smithsonian, The National Institutes of Health, and numerous colleges and universities, mostly on science fiction and technology subjects."
  },
  {
    "author": "Robert Redford",
    "category": "technology",
    "id": 67042,
    "text": "It's hard to pay attention these days because of multiple affects of the information technology nowadays. You tend to develop a faster, speedier mind, but I don't think it's necessarily broader or smarter."
  },
  {
    "author": "Simon Mainwaring",
    "category": "technology",
    "id": 67048,
    "text": "Not since the digital revolution in the early '90s has technology placed such a comprehensive burden on business, employees and individuals to reinvent their business plans, services and products, and themselves to keep pace with the changing marketplace."
  },
  {
    "author": "Jeff Zucker",
    "category": "technology",
    "id": 67674,
    "text": "We're in this transition period of figuring out how to deal with all the new technology that is out there, but television still proves to be the granddaddy of them all."
  },
  {
    "author": "Amy Klobuchar",
    "category": "technology",
    "id": 67382,
    "text": "So many times, these kids know more about the technology than their parents. And so many times, we're putting kids in very adult situations and expecting them to behave like they're 40 years old. Well, that's just not going to happen."
  },
  {
    "author": "John Warnock",
    "category": "technology",
    "id": 67748,
    "text": "The personal contact is a personal thing. The fact that some people don't know their neighbors, I don't think that technology is at fault. You don't lose anything with technology. You gain other avenues of understanding."
  },
  {
    "author": "J. J. Abrams",
    "category": "technology",
    "id": 67164,
    "text": "I love the idea of anthropomorphizing machines. I love the idea of taking technology and giving it a personality."
  },
  {
    "author": "Jeff Bridges",
    "category": "technology",
    "id": 67035,
    "text": "Technology is such a broad kind of term, it really applies to so many things, from the electric light to running cars on oil. All of these different things can be called technology. I have kind of a love-hate relationship with it, as I expect most people do. With the computer, I spend so many hours sitting in front of a computer."
  },
  {
    "author": "Vince Neil",
    "category": "technology",
    "id": 67708,
    "text": "With technology now, you can go in and sing a song, and for $100,000, you will sound flawless."
  },
  {
    "author": "John Poindexter",
    "category": "technology",
    "id": 67689,
    "text": "I knew from the beginning that privacy was going to be a huge issue, especially with regard to applying Total Information Awareness in counterterrorism. Because if the technology development was successful, a logical place to apply it was inside the United States."
  },
  {
    "author": "Tadao Ando",
    "category": "technology",
    "id": 67173,
    "text": "The computer offers another kind of creativity. You cannot ignore the creativity that computer technology can bring. But you need to be able to move between those two different worlds."
  },
  {
    "author": "Simon Mainwaring",
    "category": "technology",
    "id": 67053,
    "text": "Non-profits must become deeply engaged in the ways that their donor communities are using social technology."
  },
  {
    "author": "Reggie Watts",
    "category": "technology",
    "id": 67400,
    "text": "Technology is a wonderful tool, but also if used incorrectly a horrible tool. We're fascinated by all aspects of it, whatever makes our human lives easier on the planet, but eventually there will have to be some sort of merger. The fascination isn't going to die down."
  },
  {
    "author": "Warren Farrell",
    "category": "technology",
    "id": 67213,
    "text": "Without husbands, women have to focus on earning more. They work longer hours, they're willing to relocate and they're more likely to choose higher-paying fields like technology."
  },
  {
    "author": "David Suzuki",
    "category": "technology",
    "id": 67093,
    "text": "With the world's human population now at seven billion and growing, and the demand for technology and modern conveniences increasing, we can't control all our negative impacts. But we have to find better ways to live within the limits nature and its cycles impose."
  },
  {
    "author": "Mark Mothersbaugh",
    "category": "technology",
    "id": 67717,
    "text": "I don't cook - I can cook - but I'm not very good. I like being asked over for dinner, because she can't cook either. We would starve if it weren't for modern technology. I know how to work a microwave, but love home cooked meals."
  },
  {
    "author": "Kevin Mitnick",
    "category": "technology",
    "id": 67130,
    "text": "A company can spend hundreds of thousands of dollars on firewalls, intrusion detection systems and encryption and other security technologies, but if an attacker can call one trusted person within the company, and that person complies, and if the attacker gets in, then all that money spent on technology is essentially wasted."
  },
  {
    "author": "Matt Blunt",
    "category": "technology",
    "id": 67658,
    "text": "In spite of advances in technology and changes in the economy, state government still operates on an obsolete 1970s model. We have a typewriter government in an Internet age."
  },
  {
    "author": "Dennis Gabor",
    "category": "technology",
    "id": 66991,
    "text": "The most important and urgent problems of the technology of today are no longer the satisfactions of the primary needs or of archetypal wishes, but the reparation of the evils and damages by the technology of yesterday."
  },
  {
    "author": "Chris Anderson",
    "category": "technology",
    "id": 67772,
    "text": "The first stage in a technology's advance is that it'll fall below a critical price. After it falls below a critical price, it will tend, if it's successful, to rise above a critical mass, a penetration."
  },
  {
    "author": "Iveta Radicova",
    "category": "technology",
    "id": 67775,
    "text": "We need first of all the reform of our justice system. We need reform of the education system, because of quality of education because of innovation and technology. And we need administrative reform. Too much bureaucracy."
  }
]

quotes['teen'] = [
  {
    "author": "Chantal Kreviazuk",
    "category": "teen",
    "id": 67903,
    "text": "Well, I actually first got into music as a small child, and as I became a teen, I sought out making money from music, weather that was singing lounge gigs, backup in studios, or weddings."
  },
  {
    "author": "Selma Blair",
    "category": "teen",
    "id": 67878,
    "text": "I played teen roles until high definition came out, and I could never understand it. I would go in for adult roles and be older than many of the people auditioning, but they'd cast the girl without a line on her face."
  },
  {
    "author": "Alexa Vega",
    "category": "teen",
    "id": 67914,
    "text": "I think I am too old to be doing teen movies. I am just kind of annoyed, because you have all these teen movies coming out with usually either Lindsay Lohan or Hilary Duff doing four of the exact teen movies over and over again."
  },
  {
    "author": "Adriana Lima",
    "category": "teen",
    "id": 67804,
    "text": "I'm a teenager, but I'm independent - I have my own apartment, I have my own life. And I think I have learned more than any of those teenagers have in school. I learned to be responsible, leaving my family and coming here alone."
  },
  {
    "author": "Cecily von Ziegesar",
    "category": "teen",
    "id": 67910,
    "text": "I decided that, if I were to write a teen series, I'd want to set it in a place that was familiar to me - Manhattan, where I'd grown up - and I'd model the characters on myself and my friends."
  },
  {
    "author": "Mary Pipher",
    "category": "teen",
    "id": 67838,
    "text": "Adolescence is when girls experience social pressure to put aside their authentic selves and to display only a small portion of their gifts."
  },
  {
    "author": "Jason Bateman",
    "category": "teen",
    "id": 67885,
    "text": "I think anybody who's doing work in their teen years on TV or in the movies, you're a teen idol by default."
  },
  {
    "author": "John Cusack",
    "category": "teen",
    "id": 67848,
    "text": "I was a teen star. That's disgusting enough."
  },
  {
    "author": "Laurence J. Peter",
    "category": "teen",
    "id": 67795,
    "text": "Heredity is what sets the parents of a teenager wondering about each other."
  },
  {
    "author": "Sophia Bush",
    "category": "teen",
    "id": 67791,
    "text": "Being a teenager is an amazing time and a hard time. It's when you make your best friends - I have girls who will never leave my heart and I still talk to. You get the best and the worst as a teen. You have the best friendships and the worst heartbreaks."
  },
  {
    "author": "Maggie Stiefvater",
    "category": "teen",
    "id": 67893,
    "text": "I saw myself as an outsider as a teen. I was home-schooled and got my G.E.D. when I was 16 I wasn't interested in high school at all and figured that college might be more entertaining."
  },
  {
    "author": "Alice Hoffman",
    "category": "teen",
    "id": 67825,
    "text": "I think growing up is difficult and it's a process that I'm always interested in, with kids and adults, they are often on two different universes."
  },
  {
    "author": "Ally Condie",
    "category": "teen",
    "id": 67930,
    "text": "Being a teen is past for me. Worrying about the world and my place in it is not."
  },
  {
    "author": "Jamie Bell",
    "category": "teen",
    "id": 67880,
    "text": "I had teen angst for a while, but I think every teenager has the angst."
  },
  {
    "author": "Winona Ryder",
    "category": "teen",
    "id": 67815,
    "text": "You've got to grow up sometime."
  },
  {
    "author": "Jules Feiffer",
    "category": "teen",
    "id": 67817,
    "text": "Maturity is only a short break in adolescence."
  },
  {
    "author": "Shakira",
    "category": "teen",
    "id": 67881,
    "text": "I remember the first time I saw the 'Smells Like Teen Spirit' video. I will never forget that day. I just wanted to see Kurt Cobain's face. I had a feeling he was very cute. But, I couldn't see his face. When I finally did see him, he was even cuter than I imagined!"
  },
  {
    "author": "Johnny Depp",
    "category": "teen",
    "id": 67788,
    "text": "As a teenager I was so insecure. I was the type of guy that never fitted in because he never dared to choose. I was convinced I had absolutely no talent at all. For nothing. And that thought took away all my ambition too."
  },
  {
    "author": "Andrew Shue",
    "category": "teen",
    "id": 67823,
    "text": "The most important role models should and could be parents and teachers. But that said, once you're a teenager you've probably gotten as much of an example from your parents as you're going to."
  },
  {
    "author": "Leven Rambin",
    "category": "teen",
    "id": 67919,
    "text": "I'm so fascinated by the concept of teen pregnancy for some reason. Not that I condone it or promote it, but it's just a very real thing in our country and culture."
  },
  {
    "author": "Evelyn Glennie",
    "category": "teen",
    "id": 67863,
    "text": "Before my teen years, I was losing my hearing pretty quickly, and I was getting very, very angry. I was beginning to become an angry person because of that."
  },
  {
    "author": "Louise J. Kaplan",
    "category": "teen",
    "id": 67844,
    "text": "Adolescence is the conjugator of childhood and adulthood."
  },
  {
    "author": "David Elkind",
    "category": "teen",
    "id": 67811,
    "text": "Friendships in childhood are usually a matter of chance, whereas in adolescence they are most often a matter of choice."
  },
  {
    "author": "Victoria Justice",
    "category": "teen",
    "id": 67874,
    "text": "To even be called the 'teen queen' is crazy."
  },
  {
    "author": "Stephen Dorff",
    "category": "teen",
    "id": 67912,
    "text": "I don't want to just be in the normal kind of teen movie."
  },
  {
    "author": "Art Linkletter",
    "category": "teen",
    "id": 67892,
    "text": "In the Top 40, half the songs are secret messages to the teen world to drop out, turn on, and groove with the chemicals and light shows at discotheques."
  },
  {
    "author": "Rob Lowe",
    "category": "teen",
    "id": 67829,
    "text": "I liked being a teenager, but I would not go back for all the tea in China."
  },
  {
    "author": "Lukas Haas",
    "category": "teen",
    "id": 67913,
    "text": "Material Girls was so different for me, I'd never done a teen movie."
  },
  {
    "author": "Dale Earnhardt",
    "category": "teen",
    "id": 67798,
    "text": "Growing up, I've enjoyed hunting with my father."
  },
  {
    "author": "Devon Sawa",
    "category": "teen",
    "id": 67904,
    "text": "Final Destination was the closest thing I've done to a teen movie but it certainly had an edge to it."
  },
  {
    "author": "Ellie Goulding",
    "category": "teen",
    "id": 67851,
    "text": "I instinctively dress a bit tougher because I've spent a lot of time in the U.S. and I realised there was a certain image projected of me here. I've always been an absolute rebel. When I was in my teen years I had piercings and wore all black."
  },
  {
    "author": "Uma Thurman",
    "category": "teen",
    "id": 67821,
    "text": "I spent the first fourteen years of my life convinced that my looks were hideous. Adolescence is painful for everyone, I know, but mine was plain weird."
  },
  {
    "author": "Andy Cohen",
    "category": "teen",
    "id": 67868,
    "text": "I fell in love with Erica Kane the summer before my freshman year of high school. Like all red-blooded teen American boys, I'd come home from water polo practice and eat a box of Entenmann's Pop'Ems donut holes in front of the TV while obsessively fawning over 'All My Children' and Erica, her clothes, and her narcissistic attitude."
  },
  {
    "author": "Emily Giffin",
    "category": "teen",
    "id": 67909,
    "text": "Writing a teen character is something I wanted to try again for a long time!"
  },
  {
    "author": "Matthew Vaughn",
    "category": "teen",
    "id": 67835,
    "text": "I think there's a time in your life where you don't feel like you fit in. I think everyone has that when you're a teenager, especially, and especially in the society we live in."
  },
  {
    "author": "Chris Evans",
    "category": "teen",
    "id": 67867,
    "text": "When I found out I had to take off my shirt in 'Teen' movie, I panicked and hit the gym. I was like, 'It's going to be on film, documented, for my children to see. I can't be 140 pounds. I need to put on a little bit of muscle.'"
  },
  {
    "author": "Leif Garrett",
    "category": "teen",
    "id": 67905,
    "text": "Frank Sinatra is the only one that went from teen idol to superstar."
  },
  {
    "author": "Lily Collins",
    "category": "teen",
    "id": 67887,
    "text": "I don't know if this is too weird to say, but this is completely surreal for me. Bizarre. The cover of 'Teen Vogue' has been on my bucket list forever."
  },
  {
    "author": "Curtis Armstrong",
    "category": "teen",
    "id": 67911,
    "text": "To be honest, I haven't seen a lot of the current crop of teen movies because there's only so much time and there's nothing that really drives me to do it."
  },
  {
    "author": "Winona Ryder",
    "category": "teen",
    "id": 67827,
    "text": "I have this sense that I didn't really start growing up until my twenties."
  },
  {
    "author": "John Walters",
    "category": "teen",
    "id": 67899,
    "text": "Research shows that parents are the single biggest influence on children - if you are worried about your teen and drugs, talk to them."
  },
  {
    "author": "Jane Fonda",
    "category": "teen",
    "id": 67858,
    "text": "It's about time we make the well-being of our young people more important than ideology and politics. As a country, we benefit from investing in their future by investing in teen pregnancy prevention."
  },
  {
    "author": "Milla Jovovich",
    "category": "teen",
    "id": 67832,
    "text": "At the age of 16 I was already dreaming of having a baby because I felt myself to be an adult, but my mum forbid it. Right now, I feel like a teenager and I want to have fun for one or two more years before starting a family."
  },
  {
    "author": "Heath Ledger",
    "category": "teen",
    "id": 67852,
    "text": "I wasn't going to have fun doing a teen movie again."
  },
  {
    "author": "Nigella Lawson",
    "category": "teen",
    "id": 67813,
    "text": "I was a quiet teenager, introverted, full of angst."
  },
  {
    "author": "Penelope Spheeris",
    "category": "teen",
    "id": 67819,
    "text": "This generation has given up on growth. They're just hoping for survival."
  },
  {
    "author": "Marla Sokoloff",
    "category": "teen",
    "id": 67929,
    "text": "I'm pretty sure this is it for the teen movie thing. It's so frustrating to read when you get to page 20 and you're like, Oy! It's the same thing again!"
  },
  {
    "author": "Dario Argento",
    "category": "teen",
    "id": 67816,
    "text": "When I was a teenager, I read a lot of Poe."
  },
  {
    "author": "George Foreman",
    "category": "teen",
    "id": 67805,
    "text": "My kids idea of a hard life is to live in a house with only one phone."
  },
  {
    "author": "David Wilkerson",
    "category": "teen",
    "id": 67855,
    "text": "The Teen Challenge ministry was born out of those humble early days of ministry. It now includes over 500 drug and alcohol rehab centers around the world, even in Muslim countries. These include homes for girls and women addicts and alcoholics, all which are reaching many."
  },
  {
    "author": "John Walters",
    "category": "teen",
    "id": 67898,
    "text": "Teen drug use went up dramatically in the 1990s."
  },
  {
    "author": "Robert Cormier",
    "category": "teen",
    "id": 67831,
    "text": "I have always had a sense that we are all pretty much alone in life, particularly in adolescence."
  },
  {
    "author": "Saskia de Brauw",
    "category": "teen",
    "id": 67926,
    "text": "I remember as a teen being able to eat more than my father. I was growing so fast and my body couldn't keep up."
  },
  {
    "author": "Jane Fonda",
    "category": "teen",
    "id": 67847,
    "text": "If we as a nation are to break the cycle of poverty, crime and the growing underclass of young people ill equipped to be productive citizens, we need to not only implement effective programs to prevent teen pregnancy, but we must also help those who have already given birth so that they become effective, nurturing, bonding parents."
  },
  {
    "author": "Tayari Jones",
    "category": "teen",
    "id": 67921,
    "text": "I take mentoring very seriously and I am on the board of an organization called Girls Write Now, where we match teen girls and writing mentors because it changes their lives."
  },
  {
    "author": "Beth Ditto",
    "category": "teen",
    "id": 67862,
    "text": "When I was a teenager I would lock myself in the bathroom for hours, bouffanting my hair like Patty Duke and trying to recreate Barbra Streisand's flawless eyeliner, only to comb it all out and wash it all off before stepping out into the world a butchish bisexual teen."
  },
  {
    "author": "John B. S. Haldane",
    "category": "teen",
    "id": 67803,
    "text": "A fairly bright boy is far more intelligent and far better company than the average adult."
  },
  {
    "author": "Naya Rivera",
    "category": "teen",
    "id": 67927,
    "text": "Honestly, I never thought I'd actually be playing a teen lesbian. I didn't think it was going to go this far. But I'm glad that it did, because there have been a lot of fans who have expressed that they've been going through similar situations in their lives."
  },
  {
    "author": "John C. Maxwell",
    "category": "teen",
    "id": 67787,
    "text": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up."
  },
  {
    "author": "Rick Springfield",
    "category": "teen",
    "id": 67861,
    "text": "I was a happy kid up until I hit the teen years."
  },
  {
    "author": "G. Stanley Hall",
    "category": "teen",
    "id": 67841,
    "text": "Adolescence is a new birth, for the higher and more completely human traits are now born."
  },
  {
    "author": "Constance Baker Motley",
    "category": "teen",
    "id": 67828,
    "text": "I grew up in a house where nobody had to tell me to go to school every day and do my homework."
  },
  {
    "author": "Louise J. Kaplan",
    "category": "teen",
    "id": 67810,
    "text": "Children, even infants, are capable of sympathy. But only after adolescence are we capable of compassion."
  },
  {
    "author": "Jamie Lee Curtis",
    "category": "teen",
    "id": 67814,
    "text": "Well, I could do it for a day, but I wouldn't want to be a teenager again. I really wouldn't."
  },
  {
    "author": "Wayne Kramer",
    "category": "teen",
    "id": 67840,
    "text": "But when I was a teenager, the idea of spending the rest of my life in a factory was real depressing. So the idea that I could become a musician opened up some possibilities I didn't see otherwise."
  },
  {
    "author": "e. e. cummings",
    "category": "teen",
    "id": 67786,
    "text": "It takes courage to grow up and become who you really are."
  },
  {
    "author": "Andrew Shue",
    "category": "teen",
    "id": 67886,
    "text": "If you can get a teen leader in each sector of a student population, you can pull people in. Everybody wants to get involved, but most are too afraid. When they see a person they think is cool leading it, they're first to join."
  },
  {
    "author": "Ben Lindsey",
    "category": "teen",
    "id": 67808,
    "text": "Trouble is, kids feel they have to shock their elders and each generation grows up into something harder to shock."
  },
  {
    "author": "Maggie Stiefvater",
    "category": "teen",
    "id": 67894,
    "text": "When I was a teen, I thought I would have to choose between my writing or my music or my art, but it turns out it's a difficult juggling game but I can do all of them."
  },
  {
    "author": "Willie Aames",
    "category": "teen",
    "id": 67872,
    "text": "I didn't want to be the typical teen idol. I didn't want to be Leif Garrett. I didn't want to be Shaun Cassidy, David Cassidy or Parker Stevenson. I wanted to do my own thing."
  },
  {
    "author": "Joan Chen",
    "category": "teen",
    "id": 67806,
    "text": "All teenagers have this desire to somehow run away."
  },
  {
    "author": "Josh Hartnett",
    "category": "teen",
    "id": 67918,
    "text": "I don't think there's a problem with being a teen idol, if that happens to me, I'll be happy to deal with it."
  },
  {
    "author": "Anna Chlumsky",
    "category": "teen",
    "id": 67883,
    "text": "I had no idea of the size of my bank account as a teen, and I didn't care to know. That was my mom's job, I figured that I would just find out when I turned 18. If you can't trust your mom, then who can you trust?"
  },
  {
    "author": "Brendan Fehr",
    "category": "teen",
    "id": 67934,
    "text": "Just because you have teenagers in a movie doesn't make it a teen movie."
  },
  {
    "author": "John Hughes",
    "category": "teen",
    "id": 67879,
    "text": "At the time I came along, Hollywood's idea of teen movies meant there had to be a lot of nudity, usually involving boys in pursuit of sex, and pretty gross overall. Either that or a horror movie. And the last thing Hollywood wanted in their teen movies was teenagers!"
  },
  {
    "author": "Mia Kirshner",
    "category": "teen",
    "id": 67920,
    "text": "I've never done a teen movie before, but I certainly could tell you some of the ones I came very close on. I was very close on Clueless and She's All That."
  },
  {
    "author": "Olivia Wilde",
    "category": "teen",
    "id": 67836,
    "text": "I was a handful growing up."
  },
  {
    "author": "Jeff Healey",
    "category": "teen",
    "id": 67935,
    "text": "I progressed through so many different styles of music through my teen years, both as a player and a vocalist, particularly the jazz and pop of the early 20th Century."
  },
  {
    "author": "Rider Strong",
    "category": "teen",
    "id": 67928,
    "text": "Maybe that's the whole teen oeuvre, you know covering people in disgusting bodily fluids and whatnot."
  },
  {
    "author": "Michelle Branch",
    "category": "teen",
    "id": 67900,
    "text": "I think I'm also more open to other writers being present and listening to other opinions, whereas before I was going through my angsty teen years while making records."
  },
  {
    "author": "Diane Cilento",
    "category": "teen",
    "id": 67834,
    "text": "I got through my teen years by being a bit of a clown."
  },
  {
    "author": "Dave Barry",
    "category": "teen",
    "id": 67794,
    "text": "To an adolescent, there is nothing in the world more embarrassing than a parent."
  },
  {
    "author": "Caroline Rhea",
    "category": "teen",
    "id": 67907,
    "text": "I'd like a pop-up magazine with 45 articles on Russell Crowe. I'm like a teenager. I'd have 'Teen Beat' if I could, for grown-ups."
  },
  {
    "author": "Sam Trammell",
    "category": "teen",
    "id": 67906,
    "text": "Yeah, I spent my teen years in West Virginia, and when I was a kid, in Louisiana. I definitely have that exposure to two different sorts of rural: the South and Appalachia."
  },
  {
    "author": "Joe Bob Briggs",
    "category": "teen",
    "id": 67830,
    "text": "As I've said many times, the single most oppressed class in America right now is the teenager."
  },
  {
    "author": "Tony Visconti",
    "category": "teen",
    "id": 67890,
    "text": "Since my teen years I was interested in martial arts."
  },
  {
    "author": "Rian Johnson",
    "category": "teen",
    "id": 67901,
    "text": "Teen movies often have an unspoken underlying premise in which high school is seen as less serious than the adult world. But when your head is encased in that microcosm it's the most serious time of your life."
  },
  {
    "author": "John Knowles",
    "category": "teen",
    "id": 67842,
    "text": "Teenagers today are more free to be themselves and to accept themselves."
  },
  {
    "author": "Brittany Snow",
    "category": "teen",
    "id": 67818,
    "text": "I mean, I'm pretty good in real life, but sometimes people seem surprised that I'm like a normal teenager and wear black nail polish and I'm just a little bit more edgy than the person I play on television."
  },
  {
    "author": "NeNe Leakes",
    "category": "teen",
    "id": 67882,
    "text": "'Teen Moms!' I started watching them like the first two seasons, and I stopped. I stopped because they are too young. I feel sorry for them. And I didn't watch that show 'Hoarders.' That thing would made my skin crawl."
  },
  {
    "author": "Ethel Waters",
    "category": "teen",
    "id": 67801,
    "text": "I wanted to be with the kind of people I'd grown up with, but you can't go back to them and be one of them again, no matter how hard you try."
  },
  {
    "author": "Amanda Bynes",
    "category": "teen",
    "id": 67895,
    "text": "I don't like being compared to anyone or being in a class with someone. I'm a teen actress and therefore I'm competing against Hilary Duff. We're different people like everyone else."
  },
  {
    "author": "Lacey Chabert",
    "category": "teen",
    "id": 67924,
    "text": "I don't want to be a 'teen star' because so many people don't ever grow out of that."
  },
  {
    "author": "Rob Sheffield",
    "category": "teen",
    "id": 67869,
    "text": "When I started out as a music journalist, at the end of the 1980s, it was generally assumed that we were living through the lamest music era the world would ever see. But those were also the years when hip-hop exploded, beatbox disco soared, indie rock took off, and new wave invented a language of teen angst."
  },
  {
    "author": "David Wilkerson",
    "category": "teen",
    "id": 67846,
    "text": "Every Teen Challenge ministry is responsible for raising its own finances, but we assist these works with finances, prayer and counseling, especially overseas in areas such as Siberia, Africa, South America."
  },
  {
    "author": "Ann Brashares",
    "category": "teen",
    "id": 67925,
    "text": "The distinction has blurred between young adult and adult books. Some of the teen books have become more sophisticated."
  },
  {
    "author": "Jayma Mays",
    "category": "teen",
    "id": 67923,
    "text": "I did work at a mall in college - I think retail/customer service is just one of the most hideous jobs in the world. So I always try to be extra nice when I go into a store. But malls are part of our culture, if you watched any teen comedy in the '80s. it's clear that malls are where we live!"
  },
  {
    "author": "Barry Gibb",
    "category": "teen",
    "id": 67812,
    "text": "Everybody is a teenage idol."
  },
  {
    "author": "Julie Burchill",
    "category": "teen",
    "id": 67856,
    "text": "As a precocious teen I dreamed of being Graham Greene. Well, as it turned out, I never wrote a great novel, sadly, and I never converted to Catholicism, happily, but I did do one thing he did. That is, in middle age I moved to a seaside town and got into a right barney with the local powers-that-be."
  },
  {
    "author": "Max Irons",
    "category": "teen",
    "id": 67908,
    "text": "If you try to bring 'teen drama,' you end up doing nothing but pouting."
  }
]

quotes['thankful'] = [
  {
    "author": "Alphonse Karr",
    "category": "thankful",
    "id": 67943,
    "text": "Some people are always grumbling because roses have thorns I am thankful that thorns have roses."
  },
  {
    "author": "Oprah Winfrey",
    "category": "thankful",
    "id": 67991,
    "text": "Be thankful for what you have you'll end up having more. If you concentrate on what you don't have, you will never, ever have enough."
  },
  {
    "author": "Frank A. Clark",
    "category": "thankful",
    "id": 68004,
    "text": "If a fellow isn't thankful for what he's got, he isn't likely to be thankful for what he's going to get."
  },
  {
    "author": "Alfred Russel Wallace",
    "category": "thankful",
    "id": 67987,
    "text": "I am thankful I can see much to admire in all religions."
  },
  {
    "author": "Susan Dey",
    "category": "thankful",
    "id": 68083,
    "text": "This little kid pointed at me and said, 'You look disgusting!' That was the first time I thought maybe I did. I decided I'd better start eating. I'm just thankful that I made it through with relatively few scars."
  },
  {
    "author": "Jerry Rice",
    "category": "thankful",
    "id": 67984,
    "text": "I'm really looking forward to the Hall of Fame ceremonies. It's going to be unbelievable - just crazy. I'm looking forward to thanking all the fans for inspiring me to go out there and play my best football each and every game."
  },
  {
    "author": "Candace Cameron Bure",
    "category": "thankful",
    "id": 68035,
    "text": "I'm so happy and thankful I made it a point be a stay-at-home mom."
  },
  {
    "author": "Pharrell Williams",
    "category": "thankful",
    "id": 68026,
    "text": "I'm just very thankful. And I say that a lot because that's the most important message."
  },
  {
    "author": "William Blake",
    "category": "thankful",
    "id": 67992,
    "text": "The thankful receiver bears a plentiful harvest."
  },
  {
    "author": "Margaret Mead",
    "category": "thankful",
    "id": 67951,
    "text": "Thanks to television, for the first time the young are seeing history made before it is censored by their elders."
  },
  {
    "author": "Tony Snow",
    "category": "thankful",
    "id": 67979,
    "text": "Every one of our greatest national treasures, our liberty, enterprise, vitality, wealth, military power, global authority, flow from a surprising source: our ability to give thanks."
  },
  {
    "author": "Serena Williams",
    "category": "thankful",
    "id": 67967,
    "text": "I'm thankful to my family, friends, and fans for all of their support."
  },
  {
    "author": "Jerry Reed",
    "category": "thankful",
    "id": 68069,
    "text": "I have spent over 60 years bent over a guitar and to know that I wrote 70 compositions that masters have recorded, that makes me feel so good and full, and proud and thankful to the good Lord."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "thankful",
    "id": 67944,
    "text": "I would maintain that thanks are the highest form of thought, and that gratitude is happiness doubled by wonder."
  },
  {
    "author": "Nolan Ryan",
    "category": "thankful",
    "id": 67980,
    "text": "I am going to spend my time today just thanking the people that played a role in my career, because I truly do believe that I was blessed by a lot of people that paths crossed mine as I went down the road in my career."
  },
  {
    "author": "Robin Hayes",
    "category": "thankful",
    "id": 67961,
    "text": "As we look forward to freedom, the shining city on the hill and the best days of America lying ahead, it is the men and women in uniform who protect, defend and make us proud to whom we should look and give thanks every night."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "thankful",
    "id": 67999,
    "text": "We can be thankful to a friend for a few acres, or a little money and yet for the freedom and command of the whole earth, and for the great benefits of our being, our life, health, and reason, we look upon ourselves as under no obligation."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "category": "thankful",
    "id": 67946,
    "text": "It is another's fault if he be ungrateful, but it is mine if I do not give. To find one thankful man, I will oblige a great many that are not so."
  },
  {
    "author": "Boomer Esiason",
    "category": "thankful",
    "id": 68063,
    "text": "As both a local resident and a parent with a CF-afflicted child, I'm thankful for companies like Canon, Chase and Outback who believe that giving back to the community is critical to their role as corporate citizens."
  },
  {
    "author": "Thomas Fuller",
    "category": "thankful",
    "id": 67955,
    "text": "Unseasonable kindness gets no thanks."
  },
  {
    "author": "Joyce Banda",
    "category": "thankful",
    "id": 68071,
    "text": "I will forever be thankful to the Malawians and international community, and my professional army and army general, who said: 'No, we will follow the constitution.' That's why I'm here."
  },
  {
    "author": "Billy Graham",
    "category": "thankful",
    "id": 67997,
    "text": "I'm thankful for the incredible advances in medicine that have taken place during my lifetime. I almost certainly wouldn't still be here if it weren't for them."
  },
  {
    "author": "Phil Lesh",
    "category": "thankful",
    "id": 67988,
    "text": "We sing a little song before we eat, a little blessing before we eat, and it's really - we're thanking the Lord and the Earth for the food that we eat, and it really brings you together in a profound kind of way."
  },
  {
    "author": "Woody Allen",
    "category": "thankful",
    "id": 67941,
    "text": "I am thankful for laughter, except when milk comes out of my nose."
  },
  {
    "author": "Sherri Shepherd",
    "category": "thankful",
    "id": 68024,
    "text": "I get along very well with the cast of '30 Rock.' I guess I bring a certain quirkiness to the show as well. I'm just thankful they keep asking me. I didn't think I was going to be asked back so every time they say, 'We want you back,' I'm screaming. I'm jumping up and down and screaming."
  },
  {
    "author": "James Brown",
    "category": "thankful",
    "id": 67977,
    "text": "Like Christ said, love thee one another. I learned to do that, and I learned to respect and be appreciative and thankful for what I had."
  },
  {
    "author": "Samuel Witwer",
    "category": "thankful",
    "id": 68079,
    "text": "Eventually I booked a 2-line role on a show called 'JAG' and slowly the parts got bigger and better. I'm very thankful that I had to appreciate how difficult the business is before I had any kind of success."
  },
  {
    "author": "Izaak Walton",
    "category": "thankful",
    "id": 67948,
    "text": "God has two dwellings one in heaven, and the other in a meek and thankful heart."
  },
  {
    "author": "W. Clement Stone",
    "category": "thankful",
    "id": 67996,
    "text": "If you are really thankful, what do you do? You share."
  },
  {
    "author": "Elayne Boosler",
    "category": "thankful",
    "id": 68012,
    "text": "I am thankful I was born in America, although if I gain any more weight the burqa thing may start to seem like a good idea to me. See? Another plus about America, you can always find some food."
  },
  {
    "author": "Thomas Secker",
    "category": "thankful",
    "id": 68019,
    "text": "He enjoys much who is thankful for little."
  },
  {
    "author": "Placido Domingo",
    "category": "thankful",
    "id": 67983,
    "text": "Should it happen tomorrow, I would fall to my knees to give thanks to God for such a career."
  },
  {
    "author": "Webb Simpson",
    "category": "thankful",
    "id": 68072,
    "text": "It feels great to win and I can't be more thankful to the Lord for walking me through every step. God was and is so faithful every time."
  },
  {
    "author": "Miranda Lambert",
    "category": "thankful",
    "id": 68015,
    "text": "I am incredibly thankful for the strong support I have from my peers in the industry and of course my amazing fans."
  },
  {
    "author": "Heinrich Himmler",
    "category": "thankful",
    "id": 68085,
    "text": "All of us, who are members of the Germanic peoples, can be happy and thankful that once in thousands of years fate has given us, from among the Germanic peoples, such a genius, a leader, our Fuehrer Adolf Hitler, and you should be happy to be allowed to work with us."
  },
  {
    "author": "Paula Poundstone",
    "category": "thankful",
    "id": 67981,
    "text": "I don't need a holiday or a feast to feel grateful for my children, the sun, the moon, the roof over my head, music, and laughter, but I like to take this time to take the path of thanks less traveled."
  },
  {
    "author": "Delta Goodrem",
    "category": "thankful",
    "id": 68023,
    "text": "I'm thankful for my songs being at the top of the charts but I am human - I think people still have to remember that."
  },
  {
    "author": "William Banting",
    "category": "thankful",
    "id": 68066,
    "text": "I am most thankful to Almighty Providence for mercies received, and determined still to press the case into public notice as a token of gratitude."
  },
  {
    "author": "Mark Wahlberg",
    "category": "thankful",
    "id": 67982,
    "text": "The first thing I do when I start my day is, I get down on my hands and knees and give thanks to God. Whenever I go outside of my house, the first thing I do is stop at the church."
  },
  {
    "author": "John Gresham Machen",
    "category": "thankful",
    "id": 67986,
    "text": "I'm so thankful for the active obedience of Christ. No hope without it."
  },
  {
    "author": "James A. Lovell",
    "category": "thankful",
    "id": 68001,
    "text": "Be thankful for problems. If they were less difficult, someone with less ability might have your job."
  },
  {
    "author": "Ai Weiwei",
    "category": "thankful",
    "id": 68028,
    "text": "China has not established the rule of law and if there is a power above the law there is no social justice. Everybody can be subjected to harm. I'm just a citizen: my life is equal in value to any other. But I'm thankful that when I lost my freedom so many people shared feelings and put such touching effort into helping me."
  },
  {
    "author": "Regina King",
    "category": "thankful",
    "id": 68055,
    "text": "I'm just really thankful to have the chance to portray a character you don't see every day."
  },
  {
    "author": "Elayne Boosler",
    "category": "thankful",
    "id": 68003,
    "text": "I am thankful the most important key in history was invented. It's not the key to your house, your car, your boat, your safety deposit box, your bike lock or your private community. It's the key to order, sanity, and peace of mind. The key is 'Delete.'"
  },
  {
    "author": "Justin Timberlake",
    "category": "thankful",
    "id": 67969,
    "text": "I'm very thankful to be doing what I'm doing. I feel very blessed."
  },
  {
    "author": "Vanessa Paradis",
    "category": "thankful",
    "id": 68008,
    "text": "I realize how unique my path has been. And I'm thankful for that."
  },
  {
    "author": "Pedro Martinez",
    "category": "thankful",
    "id": 68051,
    "text": "I'm thankful for not ever taking anything illegal."
  },
  {
    "author": "John Clayton",
    "category": "thankful",
    "id": 68033,
    "text": "There was no instruction to be thankful that the Christians were special people, chosen people. There was no nationalistic, political or ethnic superiority to be thankful for."
  },
  {
    "author": "Taylor Lautner",
    "category": "thankful",
    "id": 68036,
    "text": "There's no ex out there who I'm not friends with today, and I'm extremely thankful for that."
  },
  {
    "author": "Joan Rivers",
    "category": "thankful",
    "id": 67959,
    "text": "Thank God we're living in a country where the sky's the limit, the stores are open late and you can shop in bed thanks to television."
  },
  {
    "author": "Albert Schweitzer",
    "category": "thankful",
    "id": 67939,
    "text": "Sometimes our light goes out but is blown into flame by another human being. Each of us owes deepest thanks to those who have rekindled this light."
  },
  {
    "author": "Eric Church",
    "category": "thankful",
    "id": 68056,
    "text": "I am very thankful and blessed to have a healthy and happy baby boy and baby mama."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "thankful",
    "id": 67945,
    "text": "Keep your eyes open to your mercies. The man who forgets to be thankful has fallen asleep in life."
  },
  {
    "author": "Elizabeth I",
    "category": "thankful",
    "id": 67962,
    "text": "I do not so much rejoice that God hath made me to be a Queen, as to be a Queen over so thankful a people."
  },
  {
    "author": "Tony Hale",
    "category": "thankful",
    "id": 68070,
    "text": "Look, if I ever stop being grateful for gigs, I just need to stop. Because this business is... you know, it's just so kind of job-to-job, and the fact that I've continued working... I'm just incredibly thankful for it. And I never, ever take it for granted."
  },
  {
    "author": "Terrence Howard",
    "category": "thankful",
    "id": 68038,
    "text": "And I'm very surprised that all this stuff actually worked out to where I could have a career in film, gain the benefit of my education, and be thankful that I was able to break into my craft as an actor."
  },
  {
    "author": "Albert Barnes",
    "category": "thankful",
    "id": 68014,
    "text": "We can always find something to be thankful for, and there may be reasons why we ought to be thankful for even those dispensations which appear dark and frowning."
  },
  {
    "author": "Ron Perlman",
    "category": "thankful",
    "id": 67953,
    "text": "I'm thankful to be breathing, on this side of the grass. Whatever comes, comes."
  },
  {
    "author": "Nate Ruess",
    "category": "thankful",
    "id": 68017,
    "text": "Even now, when I try and think of band names just randomly, I'm so thankful that 'fun.' is the name of the band. I never really think twice about it. It is so simple and so easy."
  },
  {
    "author": "Diana Lopez",
    "category": "thankful",
    "id": 68074,
    "text": "I am very proud of my mom and consider her the most courageous woman I know. With perseverance, sacrifice and hard work, she raised a family of Olympic athletes and gave us the tools and the spirit to succeed. That is something that my brothers and I will always be thankful for."
  },
  {
    "author": "Sherman Alexie",
    "category": "thankful",
    "id": 67975,
    "text": "When you read a piece of writing that you admire, send a note of thanks to the author."
  },
  {
    "author": "Dreama Walker",
    "category": "thankful",
    "id": 68076,
    "text": "Working on 'Gossip Girl' was a fantastic experience. It was my first real gig and I'm thankful for it - I got to learn a lot. I'm glad I got to explore getting comfortable in my own shoes in the background on a show like 'Gossip Girl.'"
  },
  {
    "author": "Channing Tatum",
    "category": "thankful",
    "id": 67978,
    "text": "I'm thankful for weird people out there 'cause they're some of the most creative people."
  },
  {
    "author": "Jerry Cantrell",
    "category": "thankful",
    "id": 68068,
    "text": "I'm just thankful to have a tour and work something I can focus on."
  },
  {
    "author": "Ralph Stanley",
    "category": "thankful",
    "id": 68057,
    "text": "I'm thankful that I have lived long enough to become a legend, and I hope I deserve it."
  },
  {
    "author": "Barbara Lee",
    "category": "thankful",
    "id": 68078,
    "text": "As the daughter of a 25-year veteran of the armed forces, I am incredibly thankful for the sacrifices our women and men have made in Iraq, and continue to make in Afghanistan."
  },
  {
    "author": "John Hawley",
    "category": "thankful",
    "id": 68080,
    "text": "We have to be thankful considering our number as a family we enjoy very good health generally but you may be sure me and my partner have quite enough to exercise our minds and occupy our attention."
  },
  {
    "author": "Thomas Carlyle",
    "category": "thankful",
    "id": 67949,
    "text": "Old age is not a matter for sorrow. It is matter for thanks if we have left our work done behind us."
  },
  {
    "author": "Judy Blume",
    "category": "thankful",
    "id": 68054,
    "text": "I am a big defender of 'Harry Potter,' and I think any book that gets kids to read are books that we should cherish, we should be thankful for them."
  },
  {
    "author": "H. L. Mencken",
    "category": "thankful",
    "id": 67993,
    "text": "In this world of sin and sorrow there is always something to be thankful for as for me, I rejoice that I am not a Republican."
  },
  {
    "author": "Ralph Stanley",
    "category": "thankful",
    "id": 68082,
    "text": "I've done it all. I'm thankful and proud of what I've accomplished in my life. I hope to keep doing it."
  },
  {
    "author": "Dante Gabriel Rossetti",
    "category": "thankful",
    "id": 68084,
    "text": "The worst moment for the atheist is when he is really thankful and has nobody to thank."
  },
  {
    "author": "Garrison Keillor",
    "category": "thankful",
    "id": 67960,
    "text": "Thank you, dear God, for this good life and forgive us if we do not love it enough. Thank you for the rain. And for the chance to wake up in three hours and go fishing: I thank you for that now, because I won't feel so thankful then."
  },
  {
    "author": "LL Cool J",
    "category": "thankful",
    "id": 67950,
    "text": "I am what I am, I'm doing very well in my life, and I'm thankful to God for that."
  },
  {
    "author": "Elayne Boosler",
    "category": "thankful",
    "id": 68011,
    "text": "I am thankful that geniuses and artists and good people, no matter how hard it is, will eventually be recognized. I am doubly thankful that also goes for idiots."
  },
  {
    "author": "Nia Long",
    "category": "thankful",
    "id": 68052,
    "text": "I know for me like I have a reputation of being kind of tough, I have a reputation of also being the girl next door, kind of sweet but I have standards and my thing is, it's me on that screen and I don't have control over everything in this and I'm grateful and thankful."
  },
  {
    "author": "Trish Stratus",
    "category": "thankful",
    "id": 68062,
    "text": "And I'm so thankful that I've been allowed to show another side of Trish."
  },
  {
    "author": "Joseph Gordon-Levitt",
    "category": "thankful",
    "id": 67956,
    "text": "Every day I've got to be thankful that I am alive, and you never know - the cliche is, I guess, you could get hit by a bus tomorrow, so you'd better be at peace with whatever you got going at the moment."
  },
  {
    "author": "Vanessa Hudgens",
    "category": "thankful",
    "id": 68018,
    "text": "I want to let my fans get to know a little about me. I'm very thankful for everything they've done for me so, of course, I'm going to let them into my world a bit. But I really am a very private person, and I love kepping my life to myself - that's how I've always been."
  },
  {
    "author": "Franz Grillparzer",
    "category": "thankful",
    "id": 68021,
    "text": "Drink and be thankful to the host! What seems insignificant when you have it, is important when you need it."
  },
  {
    "author": "Brett Favre",
    "category": "thankful",
    "id": 68009,
    "text": "I'm thankful for all the things that this job has given me and my family. But probably the thing that I am most proud of throughout my career is that, not only myself, but my family and the people around me have just been regular people, which we are."
  },
  {
    "author": "Lisa Leslie",
    "category": "thankful",
    "id": 68058,
    "text": "There's a lot of women in the WNBA. There's a lot of women who could be here. To be voted by the fans says a lot - that people are aware of what's going on. I'm really thankful. I think they just really appreciate my talent so I'm definitely grateful."
  },
  {
    "author": "Richard Pryor",
    "category": "thankful",
    "id": 68006,
    "text": "I realized this is what God has dealt me, and I should be thankful considering all that's happened to me in my life, but MS caused the movies to stop - stop dead - and I miss it."
  },
  {
    "author": "Jeremy Lin",
    "category": "thankful",
    "id": 68049,
    "text": "I'm very humbled and honored. I'm very thankful to the Asian-American Community for all their support!"
  },
  {
    "author": "Albert Schweitzer",
    "category": "thankful",
    "id": 67990,
    "text": "In everyone's life, at some time, our inner fire goes out. It is then burst into flame by an encounter with another human being. We should all be thankful for those people who rekindle the inner spirit."
  },
  {
    "author": "Joe Biden",
    "category": "thankful",
    "id": 67973,
    "text": "Look folks, we know who built this country and we know who is going to rebuild it. It's you. Instead of vilifying you, we should be thanking you. We owe you."
  },
  {
    "author": "Bill Kreutzmann",
    "category": "thankful",
    "id": 68064,
    "text": "I'm really thankful and complimented when people come to me and say, thank you for the great times for all these years. But I don't think about it as being a leader."
  },
  {
    "author": "Amber Heard",
    "category": "thankful",
    "id": 68032,
    "text": "I'm thankful for the work that feminists like Gloria Steinem have done. I am a feminist, but the geography for women today is vastly different than it was in the '60s."
  },
  {
    "author": "Alton Brown",
    "category": "thankful",
    "id": 67965,
    "text": "I say grace. I'm a big believer in grace. I happen to believe in a God that made all the food and so I'm pretty grateful for that and I thank him for that. But I'm also thankful for the people that put the food on the table."
  },
  {
    "author": "Storm Jameson",
    "category": "thankful",
    "id": 68000,
    "text": "For what I have received may the Lord make me truly thankful. And more truly for what I have not received."
  },
  {
    "author": "Ariana Grande",
    "category": "thankful",
    "id": 68073,
    "text": "I'm so thankful for the Internet because actors and singers and performers now have a way to connect with their fans on a very personal level which I think is quite special."
  },
  {
    "author": "Rachel Roy",
    "category": "thankful",
    "id": 68007,
    "text": "I'm thankful I grew up the way I did. It made me a hard worker and insightful to other people's lives."
  },
  {
    "author": "Ruud van Nistelrooy",
    "category": "thankful",
    "id": 68043,
    "text": "We have to be thankful to the Czechs that they did their duty. The Czech Republic won, I can't believe it. It was a huge party with all the people here."
  },
  {
    "author": "Ryne Sandberg",
    "category": "thankful",
    "id": 68048,
    "text": "I was in the postseason twice and I'm thankful for that."
  },
  {
    "author": "Paula Poundstone",
    "category": "thankful",
    "id": 68013,
    "text": "I'm thankful for the three ounce Ziploc bag, so that I have somewhere to put my savings."
  },
  {
    "author": "Ike Turner",
    "category": "thankful",
    "id": 68059,
    "text": "I'm really thankful to God, man. Like now, I'm really making a real comeback with my group. With or without a record, with or without a movie. And behind all the negative press behind this movie."
  },
  {
    "author": "Michael Newdow",
    "category": "thankful",
    "id": 68065,
    "text": "A federal judge did as he was supposed to do and upheld the Constitution. We should be thankful that we have judiciary that will do that."
  },
  {
    "author": "Gina Gershon",
    "category": "thankful",
    "id": 68025,
    "text": "I feel like I still am struggling in a lot of different ways. I still have to fight for certain things. Certain jobs. At least I'm working and I'm thankful for that."
  },
  {
    "author": "Jackie Joyner-Kersee",
    "category": "thankful",
    "id": 67966,
    "text": "All I ever wanted really, and continue to want out of life, is to give 100 percent to whatever I'm doing and to be committed to whatever I'm doing and then let the results speak for themselves. Also to never take myself or people for granted and always be thankful and grateful to the people who helped me."
  },
  {
    "author": "Ricky Skaggs",
    "category": "thankful",
    "id": 68046,
    "text": "I've got tapes that I'm so thankful that my father made - old reel-to-reel tapes. I've got a ton of those things at home. He kept those like fine diamonds, I mean he kept them, you know, in a box and was very, very careful of them, you know."
  }
]

quotes['time'] = [
  {
    "author": "Bo Bennett",
    "category": "time",
    "id": 68379,
    "text": "Spend some time this weekend on home improvement improve your attitude toward your family."
  },
  {
    "author": "Maya Angelou",
    "category": "time",
    "id": 68213,
    "text": "All great achievements require time."
  },
  {
    "author": "Thomas Carlyle",
    "category": "time",
    "id": 68756,
    "text": "Men seldom, or rather never for a length of time and deliberately, rebel against anything that does not deserve rebelling against."
  },
  {
    "author": "Emily Dickinson",
    "category": "time",
    "id": 68746,
    "text": "To live is so startling it leaves little time for anything else."
  },
  {
    "author": "Napoleon Hill",
    "category": "time",
    "id": 68454,
    "text": "No man ever achieved worth-while success who did not, at one time or other, find himself with at least one foot hanging well over the brink of failure."
  },
  {
    "author": "Mason Cooley",
    "category": "time",
    "id": 68972,
    "text": "Consciousness is our only reprieve from Time."
  },
  {
    "author": "Ernest Hemingway",
    "category": "time",
    "id": 68472,
    "text": "For a long time now I have tried simply to write the best I can. Sometimes I have good luck and write better than I can."
  },
  {
    "author": "Ernest Hemingway",
    "category": "time",
    "id": 68433,
    "text": "His talent was as natural as the pattern that was made by the dust on a butterfly's wings. At one time he understood it no more than the butterfly did and he did not know when it was brushed or marred."
  },
  {
    "author": "Robert Louis Stevenson",
    "category": "time",
    "id": 68437,
    "text": "You cannot run away from weakness you must some time fight it out or perish and if that be so, why not now, and where you stand?"
  },
  {
    "author": "Blaise Pascal",
    "category": "time",
    "id": 68934,
    "text": "Vanity of science. Knowledge of physical science will not console me for ignorance of morality in time of affliction, but knowledge of morality will always console me for ignorance of physical science."
  },
  {
    "author": "Clint Eastwood",
    "category": "time",
    "id": 68603,
    "text": "I keep working because I learn something new all the time."
  },
  {
    "author": "Samuel Johnson",
    "category": "time",
    "id": 68904,
    "text": "The greatest part of a writer's time is spent in reading in order to write. A man will turn over half a library to make a book."
  },
  {
    "author": "Ronald Reagan",
    "category": "time",
    "id": 68291,
    "text": "No matter what time it is, wake me, even if it's in the middle of a Cabinet meeting."
  },
  {
    "author": "Janis Joplin",
    "category": "time",
    "id": 68847,
    "text": "If I hold back, I'm no good. I'm no good. I'd rather be good sometimes, than holding back all the time."
  },
  {
    "author": "Andy Rooney",
    "category": "time",
    "id": 69017,
    "text": "The Super Bowl isn't for kids, I had a great time though and it was worth every nickel of it because by doing this lame piece about the game I can put it on my expense account."
  },
  {
    "author": "Donald Rumsfeld",
    "category": "time",
    "id": 68960,
    "text": "You will launch many projects, but have time to finish only a few. So think, plan, develop, launch and tap good people to be responsible. Give them authority and hold them accountable. Trying to do too much yourself creates a bottleneck."
  },
  {
    "author": "Jeanette Winterson",
    "category": "time",
    "id": 69057,
    "text": "You never give away your heart you lend it from time to time. If it were not so, how could we take it back without asking?"
  },
  {
    "author": "Helen Keller",
    "category": "time",
    "id": 68182,
    "text": "It is wonderful how much time good people spend fighting the devil. If they would only expend the same amount of energy loving their fellow men, the devil would die in his own tracks of ennui."
  },
  {
    "author": "Andy Warhol",
    "category": "time",
    "id": 68496,
    "text": "They always say time changes things, but you actually have to change them yourself."
  },
  {
    "author": "Mary Kay Ash",
    "category": "time",
    "id": 68468,
    "text": "No matter how busy you are, you must take time to make the other person feel important."
  },
  {
    "author": "Henry David Thoreau",
    "category": "time",
    "id": 68359,
    "text": "The finest workers in stone are not copper or steel tools, but the gentle touches of air and water working at their leisure with a liberal allowance of time."
  },
  {
    "author": "Rodney Dangerfield",
    "category": "time",
    "id": 68358,
    "text": "I drink too much. The last time I gave a urine sample it had an olive in it."
  },
  {
    "author": "Joseph Hall",
    "category": "time",
    "id": 68614,
    "text": "Perfection is the child of time."
  },
  {
    "author": "Anderson Cooper",
    "category": "time",
    "id": 68933,
    "text": "Anyone who says they're not afraid at the time of a hurricane is either a fool or a liar, or a little bit of both."
  },
  {
    "author": "John Locke",
    "category": "time",
    "id": 68402,
    "text": "As people are walking all the time, in the same spot, a path appears."
  },
  {
    "author": "Honore de Balzac",
    "category": "time",
    "id": 68685,
    "text": "It is as absurd to say that a man can't love one woman all the time as it is to say that a violinist needs several violins to play the same piece of music."
  },
  {
    "author": "Margaret Thatcher",
    "category": "time",
    "id": 68332,
    "text": "If you just set out to be liked, you would be prepared to compromise on anything at any time, and you would achieve nothing."
  },
  {
    "author": "Oprah Winfrey",
    "category": "time",
    "id": 68282,
    "text": "The greatest discovery of all time is that a person can change his future by merely changing his attitude."
  },
  {
    "author": "Cameron Diaz",
    "category": "time",
    "id": 68822,
    "text": "I'm someone who loves to enjoy life and tries to focus on real things and real friendships. That's why I live very simply. I'm a jeans and T-shirt kind of girl. I don't spend much time fixing myself up or trying to look cool. I live like a normal person and even though I'm in a very high-profile business, I really don't let it affect the way I live."
  },
  {
    "author": "Hillary Clinton",
    "category": "time",
    "id": 68676,
    "text": "My two secrets to staying healthy: wash your hands all the time. And, if you can't, use Purell or one of the sanitizers. And the other is hot peppers. I eat a lot of hot peppers. I for some reason started doing that in 1992, and I swear by it."
  },
  {
    "author": "Robert Collier",
    "category": "time",
    "id": 68736,
    "text": "In every adversity there lies the seed of an equivalent advantage. In every defeat is a lesson showing you how to win the victory next time."
  },
  {
    "author": "Jim Ramstad",
    "category": "time",
    "id": 69007,
    "text": "As we celebrate Recovery Month, it is time for Congress to knock down the barriers to treatment and recovery for 26 million Americans suffering the ravages of alcohol and drug addiction."
  },
  {
    "author": "Virginia Woolf",
    "category": "time",
    "id": 68497,
    "text": "I can only note that the past is beautiful because one never realises an emotion at the time. It expands later, and thus we don't have complete emotions about the present, only about the past."
  },
  {
    "author": "Charles Stanley",
    "category": "time",
    "id": 68648,
    "text": "Motherhood is a great honor and privilege, yet it is also synonymous with servanthood. Every day women are called upon to selflessly meet the needs of their families. Whether they are awake at night nursing a baby, spending their time and money on less-than-grateful teenagers, or preparing meals, moms continuously put others before themselves."
  },
  {
    "author": "Jean de la Bruyere",
    "category": "time",
    "id": 68936,
    "text": "Those who make the worst use of their time are the first to complain of its shortness."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "time",
    "id": 68745,
    "text": "Concepts, like individuals, have their histories and are just as incapable of withstanding the ravages of time as are individuals. But in and through all this they retain a kind of homesickness for the scenes of their childhood."
  },
  {
    "author": "Skeet Ulrich",
    "category": "time",
    "id": 68754,
    "text": "Any time I got in emotional turmoil, I felt sick all the time, like at any minute I would die."
  },
  {
    "author": "Charles Bukowski",
    "category": "time",
    "id": 68316,
    "text": "The difference between a democracy and a dictatorship is that in a democracy you vote first and take orders later in a dictatorship you don't have to waste your time voting."
  },
  {
    "author": "Adam Hochschild",
    "category": "time",
    "id": 68128,
    "text": "Work is hard. Distractions are plentiful. And time is short."
  },
  {
    "author": "Hillary Clinton",
    "category": "time",
    "id": 68773,
    "text": "I always supported the women I worked with having time off to go to parent-teacher conferences and doctors' appointments or bringing their infants into the office."
  },
  {
    "author": "Warren Beatty",
    "category": "time",
    "id": 68835,
    "text": "How can anybody hate nurses? Nobody hates nurses. The only time you hate a nurse is when they're giving you an enema."
  },
  {
    "author": "Charlie Chaplin",
    "category": "time",
    "id": 68557,
    "text": "I had no idea of the character. But the moment I was dressed, the clothes and the make-up made me feel the person he was. I began to know him, and by the time I walked onto the stage he was fully born."
  },
  {
    "author": "Jim Brown",
    "category": "time",
    "id": 68678,
    "text": "I'm not interested in trying to work on people's perceptions. I am who I am, and if you don't take the time to learn about that, then your perception is going to be your problem."
  },
  {
    "author": "Alfred A. Montapert",
    "category": "time",
    "id": 68616,
    "text": "Every time you get angry, you poison your own system."
  },
  {
    "author": "T. S. Eliot",
    "category": "time",
    "id": 68722,
    "text": "A play should give you something to think about. When I see a play and understand it the first time, then I know it can't be much good."
  },
  {
    "author": "Katharine Hepburn",
    "category": "time",
    "id": 68413,
    "text": "Acting is a nice childish profession - pretending you're someone else and, at the same time, selling yourself."
  },
  {
    "author": "Michael Jordan",
    "category": "time",
    "id": 68322,
    "text": "When I lose the sense of motivation and the sense to prove something as a basketball player, it's time for me to move away from the game."
  },
  {
    "author": "George Burns",
    "category": "time",
    "id": 68523,
    "text": "Everything that goes up must come down. But there comes a time when not everything that's down can come up."
  },
  {
    "author": "Ambrose Bierce",
    "category": "time",
    "id": 68205,
    "text": "Future. That period of time in which our affairs prosper, our friends are true and our happiness is assured."
  },
  {
    "author": "Will Rogers",
    "category": "time",
    "id": 68429,
    "text": "Half our life is spent trying to find something to do with the time we have rushed through life trying to save."
  },
  {
    "author": "Thomas Sowell",
    "category": "time",
    "id": 68419,
    "text": "The next time some academics tell you how important diversity is, ask how many Republicans there are in their sociology department."
  },
  {
    "author": "Mariel Hemingway",
    "category": "time",
    "id": 68117,
    "text": "Finding some quiet time in your life, I think, is hugely important."
  },
  {
    "author": "Tupac Shakur",
    "category": "time",
    "id": 68343,
    "text": "The only time I have problems is when I sleep."
  },
  {
    "author": "Albert Einstein",
    "category": "time",
    "id": 68190,
    "text": "There comes a time when the mind takes a higher plane of knowledge but can never prove how it got there."
  },
  {
    "author": "William Shakespeare",
    "category": "time",
    "id": 68172,
    "text": "All the world's a stage, and all the men and women merely players: they have their exits and their entrances and one man in his time plays many parts, his acts being seven ages."
  },
  {
    "author": "John Wooden",
    "category": "time",
    "id": 68555,
    "text": "I like to spend time in the past, with the things that have been important to me."
  },
  {
    "author": "Aeschylus",
    "category": "time",
    "id": 68126,
    "text": "But time growing old teaches all things."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "time",
    "id": 68317,
    "text": "Manners require time, and nothing is more vulgar than haste."
  },
  {
    "author": "Jesus Christ",
    "category": "time",
    "id": 69061,
    "text": "And know that I am with you always yes, to the end of time."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "time",
    "id": 68962,
    "text": "When we disclaim praise, it is only showing our desire to be praised a second time."
  },
  {
    "author": "Charles M. Schulz",
    "category": "time",
    "id": 69049,
    "text": "Try not to have a good time... this is supposed to be educational."
  },
  {
    "author": "Jean de La Fontaine",
    "category": "time",
    "id": 68089,
    "text": "Patience and time do more than strength or passion."
  },
  {
    "author": "Katharine Hepburn",
    "category": "time",
    "id": 68628,
    "text": "It's life isn't it? You plow ahead and make a hit. And you plow on and someone passes you. Then someone passes them. Time levels."
  },
  {
    "author": "Earl Nightingale",
    "category": "time",
    "id": 68526,
    "text": "Don't let the fear of the time it will take to accomplish something stand in the way of your doing it. The time will pass anyway we might just as well put that passing time to the best possible use."
  },
  {
    "author": "Karl Marx",
    "category": "time",
    "id": 68808,
    "text": "The ideas of the ruling class are in every epoch the ruling ideas, i.e., the class which is the ruling material force of society, is at the same time its ruling intellectual force."
  },
  {
    "author": "Barack Obama",
    "category": "time",
    "id": 68511,
    "text": "We all knew this. We all knew that it would take more time than any of us want to dig ourselves out of this hole created by this economic crisis."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "time",
    "id": 68956,
    "text": "Time destroys the speculation of men, but it confirms nature."
  },
  {
    "author": "George Herbert",
    "category": "time",
    "id": 68935,
    "text": "Do not wait the time will never be 'just right.' Start where you stand, and work with whatever tools you may have at your command, and better tools will be found as you go along."
  },
  {
    "author": "Warren Buffett",
    "category": "time",
    "id": 68565,
    "text": "Time is the friend of the wonderful company, the enemy of the mediocre."
  },
  {
    "author": "Denis Waitley",
    "category": "time",
    "id": 68456,
    "text": "As long as we are persistence in our pursuit of our deepest destiny, we will continue to grow. We cannot choose the day or time when we will fully bloom. It happens in its own time."
  },
  {
    "author": "Chanakya",
    "category": "time",
    "id": 68342,
    "text": "Treat your kid like a darling for the first five years. For the next five years, scold them. By the time they turn sixteen, treat them like a friend. Your grown up children are your best friends."
  },
  {
    "author": "Sylvia Earle",
    "category": "time",
    "id": 68594,
    "text": "Ten percent of the big fish still remain. There are still some blue whales. There are still some krill in Antarctica. There are a few oysters in Chesapeake Bay. Half the coral reefs are still in pretty good shape, a jeweled belt around the middle of the planet. There's still time, but not a lot, to turn things around."
  },
  {
    "author": "John Clayton",
    "category": "time",
    "id": 68281,
    "text": "Thanksgiving is a time when the world gets to see just how blessed and how workable the Christian system is. The emphasis is not on giving or buying, but on being thankful and expressing that appreciation to God and to one another."
  },
  {
    "author": "Victor Hugo",
    "category": "time",
    "id": 68641,
    "text": "An invasion of armies can be resisted, but not an idea whose time has come."
  },
  {
    "author": "Franz Kafka",
    "category": "time",
    "id": 69073,
    "text": "I do not read advertisements. I would spend all of my time wanting things."
  },
  {
    "author": "H. G. Wells",
    "category": "time",
    "id": 68520,
    "text": "Every time I see an adult on a bicycle, I no longer despair for the future of the human race."
  },
  {
    "author": "Friedrich Schiller",
    "category": "time",
    "id": 68131,
    "text": "Lose not yourself in a far off time, seize the moment that is thine."
  },
  {
    "author": "Carl Yastrzemski",
    "category": "time",
    "id": 68658,
    "text": "I think about baseball when I wake up in the morning. I think about it all day and I dream about it at night. The only time I don't think about it is when I'm playing it."
  },
  {
    "author": "Bill Gates",
    "category": "time",
    "id": 68373,
    "text": "Just in terms of allocation of time resources, religion is not very efficient. There's a lot more I could be doing on a Sunday morning."
  },
  {
    "author": "Taylor Hackford",
    "category": "time",
    "id": 68985,
    "text": "Because when you have millions of people with this kind of need for gratification, and the culture is saying that it's possible for everyone to satisfy all of their needs and desires all of the time, there are obviously going to be clashes - clashes of ego."
  },
  {
    "author": "Henry David Thoreau",
    "category": "time",
    "id": 68327,
    "text": "A broad margin of leisure is as beautiful in a man's life as in a book. Haste makes waste, no less in life than in housekeeping. Keep the time, observe the hours of the universe, not of the cars."
  },
  {
    "author": "Dario Fo",
    "category": "time",
    "id": 68116,
    "text": "Know how to live the time that is given you."
  },
  {
    "author": "Benjamin Franklin",
    "category": "time",
    "id": 68093,
    "text": "Time is money."
  },
  {
    "author": "E. B. White",
    "category": "time",
    "id": 68579,
    "text": "Prejudice is a great time saver. You can form opinions without having to get the facts."
  },
  {
    "author": "Shahrukh Khan",
    "category": "time",
    "id": 68723,
    "text": "I do have a close circle of friends and I am very fortunate to have them as friends. I feel very close to them I think friends are everything in life after your family. You come across lots of people all the time but you only make very few friends and you have to be true to them otherwise what's the point in life?"
  },
  {
    "author": "Rabindranath Tagore",
    "category": "time",
    "id": 68432,
    "text": "Do not say, 'It is morning,' and dismiss it with a name of yesterday. See it for the first time as a newborn child that has no name."
  },
  {
    "author": "Charlie Sheen",
    "category": "time",
    "id": 68364,
    "text": "I'm sorry, man, but I've got magic. I've got poetry in my fingertips. Most of the time - and this includes naps - I'm an F-18, bro. And I will destroy you in the air. I will deploy my ordinance to the ground."
  },
  {
    "author": "Dick Cheney",
    "category": "time",
    "id": 68718,
    "text": "There comes a time when deceit and defiance must be seen for what they are. At that point, a gathering danger must be directly confronted. At that point, we must show that beyond our resolutions is actual resolve."
  },
  {
    "author": "Tom Robbins",
    "category": "time",
    "id": 68242,
    "text": "We waste time looking for the perfect lover, instead of creating the perfect love."
  },
  {
    "author": "Groucho Marx",
    "category": "time",
    "id": 68446,
    "text": "Next time I see you, remind me not to talk to you."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "time",
    "id": 68966,
    "text": "Time is precious, but truth is more precious than time."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "time",
    "id": 68210,
    "text": "I suppose leadership at one time meant muscles but today it means getting along with people."
  },
  {
    "author": "Homer",
    "category": "time",
    "id": 68705,
    "text": "Yet, taught by time, my heart has learned to glow for other's good, and melt at other's woe."
  },
  {
    "author": "Margaret Mead",
    "category": "time",
    "id": 68654,
    "text": "Every time we liberate a woman, we liberate a man."
  },
  {
    "author": "Harry S. Truman",
    "category": "time",
    "id": 69078,
    "text": "It's plain hokum. If you can't convince 'em, confuse 'em. It's an old political trick. But this time it won't work."
  },
  {
    "author": "Barack Obama",
    "category": "time",
    "id": 68455,
    "text": "With patient and firm determination, I am going to press on for jobs. I'm going to press on for equality. I'm going to press on for the sake of our children. I'm going to press on for the sake of all those families who are struggling right now. I don't have time to feel sorry for myself. I don't have time to complain. I am going to press on."
  },
  {
    "author": "John Kenneth Galbraith",
    "category": "time",
    "id": 69072,
    "text": "All of the great leaders have had one characteristic in common: it was the willingness to confront unequivocally the major anxiety of their people in their time. This, and not much else, is the essence of leadership."
  },
  {
    "author": "Dale Carnegie",
    "category": "time",
    "id": 68406,
    "text": "Don't be afraid to give your best to what seemingly are small jobs. Every time you conquer one it makes you that much stronger. If you do the little jobs well, the big ones will tend to take care of themselves."
  },
  {
    "author": "T. S. Eliot",
    "category": "time",
    "id": 68612,
    "text": "Poetry may make us from time to time a little more aware of the deeper, unnamed feelings which form the substratum of our being, to which we rarely penetrate for our lives are mostly a constant evasion of ourselves."
  },
  {
    "author": "Michael Symon",
    "category": "time",
    "id": 68405,
    "text": "My restaurants are never opened on Thanksgiving I want my staff to spend time with their family if they can. My feeling is, if I can't figure out how to make money the rest of the year so that my workers can enjoy the holidays, then I don't deserve to be an owner."
  }
]

quotes['travel'] = [
  {
    "author": "Lucius Annaeus Seneca",
    "category": "travel",
    "id": 69170,
    "text": "Everywhere is nowhere. When a person spends all his time in foreign travel, he ends by having many acquaintances, but no friends."
  },
  {
    "author": "Eudora Welty",
    "category": "travel",
    "id": 69381,
    "text": "Through travel I first became aware of the outside world it was through travel that I found my own introspective way into becoming a part of it."
  },
  {
    "author": "Ann Richards",
    "category": "travel",
    "id": 69403,
    "text": "I travel all over the country making speeches for people I believe in."
  },
  {
    "author": "Arthur Smith",
    "category": "travel",
    "id": 69307,
    "text": "Travel books are, by and large, boring. They lodge uncomfortably between fact, fiction and autobiography."
  },
  {
    "author": "Bruce Schneier",
    "category": "travel",
    "id": 69588,
    "text": "Air travel survived decades of terrorism, including attacks which resulted in the deaths of everyone on the plane. It survived 9/11. It'll survive the next successful attack. The only real worry is that we'll scare ourselves into making air travel so onerous that we won't fly anymore."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "travel",
    "id": 69175,
    "text": "The whole object of travel is not to set foot on foreign land it is at last to set foot on one's own country as a foreign land."
  },
  {
    "author": "Paul Theroux",
    "category": "travel",
    "id": 69298,
    "text": "The amount of hassle involved in travel can be overwhelming."
  },
  {
    "author": "Curtis Stone",
    "category": "travel",
    "id": 69220,
    "text": "I love coming home to Melbourne. The first thing I do is have a coffee. It's just so much better here than anywhere else. It's better than in Italy and I travel a lot. I crave it."
  },
  {
    "author": "Yuri Milner",
    "category": "travel",
    "id": 69413,
    "text": "You know among people who kind of travel a lot and have exposure to the United States and some other countries, they do have accounts, but you know, Russia is not exactly the place with multiple language skills so local networks kind of have an edge."
  },
  {
    "author": "Hope Davis",
    "category": "travel",
    "id": 69434,
    "text": "I travel all the time, and I have two small children."
  },
  {
    "author": "Adlai E. Stevenson",
    "category": "travel",
    "id": 69190,
    "text": "We travel together, passengers on a little spaceship, dependent on it's vulnerable reserves of air and soil, all committed, for our safety, to it's security and peace. Preserved from annihilation only by the care, the work and the love we give our fragile craft."
  },
  {
    "author": "Ivan Lendl",
    "category": "travel",
    "id": 69426,
    "text": "I just travel all the time. And I was just looking at the schedules now and starting the first week of October I will be every weekend with somebody at tournaments through Christmas. So it gets very difficult to just go away and not do that."
  },
  {
    "author": "Miriam Beard",
    "category": "travel",
    "id": 69704,
    "text": "Wherever we go, across the Pacific or Atlantic, we meet, not similarity so much as 'the bizarre'. Things astonish us, when we travel, that surprise nobody else."
  },
  {
    "author": "David Attenborough",
    "category": "travel",
    "id": 69243,
    "text": "Before the BBC, I joined the Navy in order to travel."
  },
  {
    "author": "Joseph Force Crater",
    "category": "travel",
    "id": 69697,
    "text": "I used my aviation contacts to open a travel agency. I used to book Caribbean flights."
  },
  {
    "author": "Marshall McLuhan",
    "category": "travel",
    "id": 69196,
    "text": "The photograph reverses the purpose of travel, which until now had been to encounter the strange and unfamiliar."
  },
  {
    "author": "Liberty Hyde Bailey",
    "category": "travel",
    "id": 69132,
    "text": "When the traveler goes alone he gets acquainted with himself."
  },
  {
    "author": "Soulja Boy",
    "category": "travel",
    "id": 69627,
    "text": "I don't travel anywhere without the PS3 and XBox. There's nothing better to do on long bus trips while on tour."
  },
  {
    "author": "Samuel Johnson",
    "category": "travel",
    "id": 69177,
    "text": "All travel has its advantages. If the passenger visits better countries, he may learn to improve his own. And if fortune carries him to worse, he may learn to enjoy it."
  },
  {
    "author": "Jose Saramago",
    "category": "travel",
    "id": 69303,
    "text": "I am traveling less in order to be able to write more. I select my travel destinations according to their degree of usefulness to my work."
  },
  {
    "author": "Emma Watson",
    "category": "travel",
    "id": 69237,
    "text": "When I haven't been working I've tried to travel a lot."
  },
  {
    "author": "Roman Coppola",
    "category": "travel",
    "id": 69495,
    "text": "Japan is the most intoxicating place for me. In Kyoto, there's an inn called the Tawaraya which is quite extraordinary. The Japanese culture fascinates me: the food, the dress, the manners and the traditions. It's the travel experience that has moved me the most."
  },
  {
    "author": "Claudio Reyna",
    "category": "travel",
    "id": 69589,
    "text": "It's a unique situation as well because England is a small country, so it makes it easy for the fans to travel. If we play down in London, they get buses and we'll get three or four thousand fans come down. They'll all sit in the same area and show their support for the team."
  },
  {
    "author": "James Lane Allen",
    "category": "travel",
    "id": 69219,
    "text": "As you think, you travel, and as you love, you attract. You are today where your thoughts have brought you you will be tomorrow where your thoughts take you."
  },
  {
    "author": "Elizabeth Drew",
    "category": "travel",
    "id": 69708,
    "text": "Travel, instead of broadening the mind, often merely lengthens the conversation."
  },
  {
    "author": "Helle Thorning-Schmidt",
    "category": "travel",
    "id": 69605,
    "text": "For young girls, whom I meet a lot when I travel around the country, it will be a big thing. It will really show them that there's no post in Denmark that a girl can't aspire to."
  },
  {
    "author": "Anthony Doerr",
    "category": "travel",
    "id": 69597,
    "text": "Travel definitely affects me as a writer."
  },
  {
    "author": "Mink Stole",
    "category": "travel",
    "id": 69670,
    "text": "Restless, and in desperate need of adventure, I quit my job at an insurance company to travel west with a couple of guys I smoked pot with, scandalizing my family."
  },
  {
    "author": "Mary Chapin Carpenter",
    "category": "travel",
    "id": 69545,
    "text": "My sisters and I were fortunate to travel through Asia and Europe at very young ages. We confronted extraordinary beauty in Athens and unspeakable poverty in India."
  },
  {
    "author": "Burt Rutan",
    "category": "travel",
    "id": 69705,
    "text": "We need affordable space travel to inspire our youth, to let them know that they can experience their dreams, can set significant goals and be in a position to lead all of us to future progress in exploration, discovery and fun. Thanks to the X Prize for the inspiration."
  },
  {
    "author": "Hilaire Belloc",
    "category": "travel",
    "id": 69123,
    "text": "We wander for distraction, but we travel for fulfillment."
  },
  {
    "author": "Randy Newman",
    "category": "travel",
    "id": 69515,
    "text": "I've worked with a band, and it's nice to have someone to travel around with, but I didn't like it as well on stage."
  },
  {
    "author": "W. C. Fields",
    "category": "travel",
    "id": 69093,
    "text": "Reminds me of my safari in Africa. Somebody forgot the corkscrew and for several days we had to live on nothing but food and water."
  },
  {
    "author": "Gerard Arpey",
    "category": "travel",
    "id": 69557,
    "text": "At American Airlines, we have built a business around the love of travel that has lasted three quarters of a century. And I'm pretty sure we're just getting started."
  },
  {
    "author": "Krysten Ritter",
    "category": "travel",
    "id": 69563,
    "text": "I'm having a great time. I get to travel and see the world. And yeah, I'll have a family, because I don't want to miss out on that amazing experience, but it's not defining who I am."
  },
  {
    "author": "Mark Morris",
    "category": "travel",
    "id": 69468,
    "text": "Sure, I could give advice I could, say, travel the world, listen to music. But all I can really say is do something you want to do and do it well. And if you want to be a choreographer, then you have to make dances."
  },
  {
    "author": "Katherine Jenkins",
    "category": "travel",
    "id": 69280,
    "text": "In Heaven, I believe my dad is somewhere doing something nice. I feel I've been too lucky to travel this far without somebody guiding me."
  },
  {
    "author": "Steven Soderbergh",
    "category": "travel",
    "id": 69454,
    "text": "But my sense in talking to people when I travel is that the film business is not that dissimilar from a lot of other businesses."
  },
  {
    "author": "Bob Hayes",
    "category": "travel",
    "id": 69718,
    "text": "Soul travel can be a general expansion of awareness and knowingness or conscious experience of the heavenly worlds."
  },
  {
    "author": "Hugh Laurie",
    "category": "travel",
    "id": 69276,
    "text": "Some people are drawn naturally - there are natural guitarists, and there are natural piano players, and I think guitar implies travel, a sort of footloose gypsy existence. You grab your bag and you go to the next town."
  },
  {
    "author": "Lewis Mumford",
    "category": "travel",
    "id": 69236,
    "text": "Restore human legs as a means of travel. Pedestrians rely on food for fuel and need no special parking facilities."
  },
  {
    "author": "Tim Cahill",
    "category": "travel",
    "id": 69667,
    "text": "You become a better writer by writing. You become a better travel writer by writing about travel."
  },
  {
    "author": "Garrett Hedlund",
    "category": "travel",
    "id": 69371,
    "text": "I remember telling my creative writing teacher that you never want to have a journal, because if you lose it, then someone's going to know all your secrets. And then she stopped using a journal, but I always write everything down... Anytime I travel, I try and fill up notepads."
  },
  {
    "author": "Philip Glass",
    "category": "travel",
    "id": 69717,
    "text": "I travel the world, and I'm happy to say that America is still the great melting pot - maybe a chunky stew rather than a melting pot at this point, but you know what I mean."
  },
  {
    "author": "Katherine Jenkins",
    "category": "travel",
    "id": 69281,
    "text": "I always want to give my best and do the best I can. I know when I have sung my best and when I haven't. There can be stresses and hassles with time travel and press attention. I just have to adapt and find a way of dealing with it."
  },
  {
    "author": "Maria Sharapova",
    "category": "travel",
    "id": 69222,
    "text": "I want my handbags and my shoes to be stylish but I want to make sure that they're versatile. I travel and I have to make sure the pieces I put into my bag can go with a dress or with shorts or jeans."
  },
  {
    "author": "Karrie Webb",
    "category": "travel",
    "id": 69526,
    "text": "I think travel is probably the downside of playing professional golf, but you've got to do it."
  },
  {
    "author": "Paul Robeson",
    "category": "travel",
    "id": 69308,
    "text": "Could I say that the reason that I am here today, you know, from the mouth of the State Department itself, is: I should not be allowed to travel because I have struggled for years for the independence of the colonial peoples of Africa."
  },
  {
    "author": "Dan Lipinski",
    "category": "travel",
    "id": 69353,
    "text": "People aren't just paying more to fill their gas tanks or when they pay for their heating bills for their home they are paying more at the grocery store, on air travel and for many other daily expenses."
  },
  {
    "author": "Mark Addy",
    "category": "travel",
    "id": 69714,
    "text": "A lot of people say that comedy doesn't travel well. I found it very accessible."
  },
  {
    "author": "Lee Hazlewood",
    "category": "travel",
    "id": 69607,
    "text": "People think I'm crazy because I travel too much, but I haven't been doing any of that lately because I got a little sick this year and I've tried to take care of it."
  },
  {
    "author": "Harry Chapin",
    "category": "travel",
    "id": 69370,
    "text": "But you can travel on for ten thousand miles, and still stay where you are."
  },
  {
    "author": "B. J. Novak",
    "category": "travel",
    "id": 69692,
    "text": "Travel is impossible, but daydreaming about travel is easy."
  },
  {
    "author": "Phil Collins",
    "category": "travel",
    "id": 69120,
    "text": "When I go on Japanese Airlines, I really love it because I like Japanese food."
  },
  {
    "author": "Kevin J. Anderson",
    "category": "travel",
    "id": 69407,
    "text": "I think that somebody with the resources and innovation and the idea is going to come out of nowhere and come up with a successful space travel program."
  },
  {
    "author": "Brie Larson",
    "category": "travel",
    "id": 69538,
    "text": "I didn't have a regular school experience and wanted a more abstract way of learning. I started exploring in lots of different creative ways. It gave me the opportunity to travel and play music, so it was good for me."
  },
  {
    "author": "Barry McGuire",
    "category": "travel",
    "id": 69552,
    "text": "There's only one drummer. We all travel to his beat. Well, I couldn't sing his song. Because for me, it wasn't a truthful statement. Well, Linda sang it, and it was a monster for her."
  },
  {
    "author": "James Purefoy",
    "category": "travel",
    "id": 69486,
    "text": "I have to travel a lot for work."
  },
  {
    "author": "Madonna Ciccone",
    "category": "travel",
    "id": 69317,
    "text": "Sometimes you want to go for a walk and you don't want to be watched. You just want to be anonymous and blend in. Especially when I travel, I feel that way, because I can't really go out and see a city the way other people can and I miss out on a lot."
  },
  {
    "author": "George Eliot",
    "category": "travel",
    "id": 69103,
    "text": "Our deeds still travel with us from afar, and what we have been makes us what we are."
  },
  {
    "author": "Robert Irvine",
    "category": "travel",
    "id": 69649,
    "text": "I travel 330 days a year and eat every two and a half hours - I'm a big guy. I always carry a fork, little bottles of spices, and Sriracha. I eat what I feel like eating."
  },
  {
    "author": "Natalie Gulbis",
    "category": "travel",
    "id": 69476,
    "text": "As many of you know I travel a good bit and do not get to see my friends and family as much as I would like."
  },
  {
    "author": "Dave Barry",
    "category": "travel",
    "id": 69183,
    "text": "It always rains on tents. Rainstorms will travel thousands of miles, against prevailing winds for the opportunity to rain on a tent."
  },
  {
    "author": "Clifton Paul Fadiman",
    "category": "travel",
    "id": 69592,
    "text": "When you travel, remember that a foreign country is not designed to make you comfortable. It is designed to make its own people comfortable."
  },
  {
    "author": "Terry Brooks",
    "category": "travel",
    "id": 69165,
    "text": "Hurt leads to bitterness, bitterness to anger, travel too far that road and the way is lost."
  },
  {
    "author": "Paris Hilton",
    "category": "travel",
    "id": 69194,
    "text": "I travel around the world constantly promoting my projects and endorsing products. Yes, I do get paid to go to parties in fact, I'm the person who started the whole trend of paid appearances. But when you see me at a party, I'm always working or promoting something."
  },
  {
    "author": "Lake Bell",
    "category": "travel",
    "id": 69646,
    "text": "I'm vegan on home base, but when I travel to other countries, I throw it all into the garbage."
  },
  {
    "author": "A. J. Liebling",
    "category": "travel",
    "id": 69395,
    "text": "Southern political personalities, like sweet corn, travel badly. They lose flavor with every hundred yards away from the patch. By the time they reach New York, they are like Golden Bantam that has been trucked up from Texas - stale and unprofitable. The consumer forgets that the corn tastes different where it grows."
  },
  {
    "author": "Andrew Weil",
    "category": "travel",
    "id": 69316,
    "text": "Each day as I travel through downtown Tucson, I am amazed at how quickly the most ancient of human behaviors have changed. For as long as there have been Homo sapiens - roughly 200,000 years - people have filled their lives principally with two activities: talking directly with other people, and doing physical things."
  },
  {
    "author": "Guy Kawasaki",
    "category": "travel",
    "id": 69385,
    "text": "I travel all the time."
  },
  {
    "author": "Lawrence Durrell",
    "category": "travel",
    "id": 69133,
    "text": "Travel can be one of the most rewarding forms of introspection."
  },
  {
    "author": "John Berryman",
    "category": "travel",
    "id": 69235,
    "text": "We must travel in the direction of our fear."
  },
  {
    "author": "Ramakrishna",
    "category": "travel",
    "id": 69212,
    "text": "Travel in all the four quarters of the earth, yet you will find nothing anywhere. Whatever there is, is only here."
  },
  {
    "author": "Alexander Ludwig",
    "category": "travel",
    "id": 69547,
    "text": "My ideal travel companions are my surfboard, wetsuit, and guitar."
  },
  {
    "author": "Rudyard Kipling",
    "category": "travel",
    "id": 69101,
    "text": "He travels the fastest who travels alone."
  },
  {
    "author": "Maria Mitchell",
    "category": "travel",
    "id": 69408,
    "text": "We travel to learn and I have never been in any country where they did not do something better than we do it, think some thoughts better than we think, catch some inspiration from heights above our own."
  },
  {
    "author": "Robyn Davidson",
    "category": "travel",
    "id": 69637,
    "text": "The genre has moved into this commercial aspect of itself, and ignored this extraordinarily rich literature that's filed everywhere else except under travel."
  },
  {
    "author": "Howard Nemerov",
    "category": "travel",
    "id": 69216,
    "text": "Nothing in the universe can travel at the speed of light, they say, forgetful of the shadow's speed."
  },
  {
    "author": "Al Gore",
    "category": "travel",
    "id": 69108,
    "text": "Airplane travel is nature's way of making you look like your passport photo."
  },
  {
    "author": "Emilio Estevez",
    "category": "travel",
    "id": 69378,
    "text": "There is a part of me that still wants to go out and grab a backpack and unplug - not take a cellphone or even a camera and just get out there and experience the world and travel. I have yet to do that, but someday I hope."
  },
  {
    "author": "Max Irons",
    "category": "travel",
    "id": 69540,
    "text": "I like reading, free diving and hiking. But my favorite thing to do is travel anywhere in Greece. I love everything about that place."
  },
  {
    "author": "Renee Fleming",
    "category": "travel",
    "id": 69332,
    "text": "For years, I had no time for exploratory travel."
  },
  {
    "author": "Carly Rae Jepsen",
    "category": "travel",
    "id": 69383,
    "text": "I like to travel by myself."
  },
  {
    "author": "John Hope Franklin",
    "category": "travel",
    "id": 69712,
    "text": "We must go beyond textbooks, go out into the bypaths and untrodden depths of the wilderness and travel and explore and tell the world the glories of our journey."
  },
  {
    "author": "Sloane Crosley",
    "category": "travel",
    "id": 69278,
    "text": "Air travel is the safest form of travel aside from walking even then, the chances of being hit by a public bus at 30,000 feet are remarkably slim. I also have no problem with confined spaces. Or heights. What I am afraid of is speed."
  },
  {
    "author": "Hernando Cortez",
    "category": "travel",
    "id": 69559,
    "text": "I love to travel, but hate to arrive."
  },
  {
    "author": "Kenneth Koch",
    "category": "travel",
    "id": 69507,
    "text": "The subject matter of the stories on the surface... there seem to be a number of stories about travel."
  },
  {
    "author": "Sue Kelly",
    "category": "travel",
    "id": 69508,
    "text": "The growth of Stewart Airport creates new jobs for area residents, brings new business and new travelers to the region, and brings new convenient travel options to those of us living in the Hudson Valley."
  },
  {
    "author": "Alexander Chase",
    "category": "travel",
    "id": 69556,
    "text": "Lovers of air travel find it exhilarating to hang poised between the illusion of immortality and the fact of death."
  },
  {
    "author": "Alan Dean Foster",
    "category": "travel",
    "id": 69530,
    "text": "Writing allows me the time to travel and see the world, which is what I always wanted to do. I'd really like to have been Sir Richard Francis Burton, but it's the wrong century."
  },
  {
    "author": "John Galliano",
    "category": "travel",
    "id": 69479,
    "text": "I'm passionate and I travel the world not just as a tourist but to understand cultures... I've lived with Masai tribe... I travel the world and bring it back in the form of a research book that would become the starting point for the collection."
  },
  {
    "author": "John Legend",
    "category": "travel",
    "id": 69327,
    "text": "I think they need to get a more reliable way of watching television on the laptop. Because I travel so much, if I want to watch my favorite sports team it might not be showing in that place, so I want a reliable way to watch whatever I want to watch on my laptop."
  },
  {
    "author": "Robert Ballard",
    "category": "travel",
    "id": 69420,
    "text": "I can't travel without Sudoku."
  },
  {
    "author": "Helen Hayes",
    "category": "travel",
    "id": 69098,
    "text": "When traveling with someone, take large does of patience and tolerance with your morning coffee."
  },
  {
    "author": "Paul D. Boyer",
    "category": "travel",
    "id": 69522,
    "text": "An unexpected benefit of my career in biochemistry has been travel."
  },
  {
    "author": "Lionel Richie",
    "category": "travel",
    "id": 69463,
    "text": "I travel around the world, experiencing every language, every religion... some places where there's just no reason to smile, because their lives are so difficult."
  },
  {
    "author": "Booboo Stewart",
    "category": "travel",
    "id": 69684,
    "text": "I usually travel with a lot of people, like my dad, mom and sisters."
  },
  {
    "author": "Mandy Moore",
    "category": "travel",
    "id": 69450,
    "text": "I want to go to college to study journalism. I want to speak French fluently, to travel. My mom was a journalist and it's in my blood."
  },
  {
    "author": "Amy Grant",
    "category": "travel",
    "id": 69267,
    "text": "Since I travel so much, it's always great to be home. There's nothing like getting to raid my own refrigerator at two in the morning."
  },
  {
    "author": "Petra Nemcova",
    "category": "travel",
    "id": 69443,
    "text": "I grew up under Communism so we could only learn Russian, and then when Communism fell in 1989 we could learn a few more things and have the freedom to travel and the freedom of speech - and the freedom of dreaming, really."
  }
]

quotes['trust'] = [
  {
    "author": "John Adams",
    "category": "trust",
    "id": 69819,
    "text": "There is danger from all men. The only maxim of a free government ought to be to trust no man living with power to endanger the public liberty."
  },
  {
    "author": "Lance Ito",
    "category": "trust",
    "id": 70458,
    "text": "The problem with not having a camera is that one must trust the analysis of a reporter who's telling you what occurred in the courtroom. You have to take into consideration the filtering effect of that person's own biases."
  },
  {
    "author": "Haruki Murakami",
    "category": "trust",
    "id": 70043,
    "text": "Young people these days don't trust anything at all. They want to be free."
  },
  {
    "author": "Robert Browning",
    "category": "trust",
    "id": 70020,
    "text": "I trust in nature for the stable laws of beauty and utility. Spring shall plant and autumn garner to the end of time."
  },
  {
    "author": "Linus Torvalds",
    "category": "trust",
    "id": 70041,
    "text": "The cyberspace earnings I get from Linux come in the format of having a Network of people that know me and trust me, and that I can depend on in return."
  },
  {
    "author": "Benito Mussolini",
    "category": "trust",
    "id": 69838,
    "text": "It's good to trust others but, not to do so is much better."
  },
  {
    "author": "Marla Maples",
    "category": "trust",
    "id": 70275,
    "text": "This relationship is going to be built on trust."
  },
  {
    "author": "Lance Secretan",
    "category": "trust",
    "id": 69856,
    "text": "Authenticity is the alignment of head, mouth, heart, and feet - thinking, saying, feeling, and doing the same thing - consistently. This builds trust, and followers love leaders they can trust."
  },
  {
    "author": "Ian Hamilton Finlay",
    "category": "trust",
    "id": 70371,
    "text": "The same sort of thing happened in my dispute with the National Trust book: Follies: A National Trust Guide, which implied that the only pleasure you can get from Folly architecture is by calling the architect mad, and by laughing at the architecture."
  },
  {
    "author": "Howard Dean",
    "category": "trust",
    "id": 70121,
    "text": "We've not had one Republican president in 34 years balance the budget. You can't trust right-wing Republicans with your money. You ought to hire somebody who has balanced a budget. I'm much more conservative with money than George Bush is."
  },
  {
    "author": "Seamus Heaney",
    "category": "trust",
    "id": 70198,
    "text": "But that citizen's perception was also at one with the truth in recognizing that the very brutality of the means by which the IRA were pursuing change was destructive of the trust upon which new possibilities would have to be based."
  },
  {
    "author": "Norm Coleman",
    "category": "trust",
    "id": 70461,
    "text": "Our cattlemen have given us the safest, most abundant, most affordable beef supply in the world and I trust their judgment. And if you look at consumer confidence in this country, so does the American public."
  },
  {
    "author": "Lady Gaga",
    "category": "trust",
    "id": 69878,
    "text": "It's hard knowing who to trust with your personal life. When you cry in your room at night, you don't always know who to call. So I am very close to my family."
  },
  {
    "author": "Marco Rubio",
    "category": "trust",
    "id": 69949,
    "text": "Let's stop big government energy mandates like cap-and-trade, and instead trust the American innovator to make us energy independent."
  },
  {
    "author": "Max Baucus",
    "category": "trust",
    "id": 70291,
    "text": "The Social Security trust fund is in pretty good shape today and we should not embark upon risky, dangerous schemes which will, in fact, undermine Social Security, such as privatization."
  },
  {
    "author": "Lawrence Welk",
    "category": "trust",
    "id": 69782,
    "text": "Never trust anyone completely but God. Love people, but put your full trust only in God."
  },
  {
    "author": "Joseph Stalin",
    "category": "trust",
    "id": 69845,
    "text": "I trust no one, not even myself."
  },
  {
    "author": "Mike Simpson",
    "category": "trust",
    "id": 70486,
    "text": "Your political reputation affects how likely allies are to trust you, and what kind of deals they'll offer at the negotiating table. There's also some emotional response in there, so factions do bear grudges. Just like the real thing."
  },
  {
    "author": "Newt Gingrich",
    "category": "trust",
    "id": 69755,
    "text": "You can't trust anybody with power."
  },
  {
    "author": "Charles Stanley",
    "category": "trust",
    "id": 69805,
    "text": "Disappointment is inevitable. But to become discouraged, there's a choice I make. God would never discourage me. He would always point me to himself to trust him. Therefore, my discouragement is from Satan. As you go through the emotions that we have, hostility is not from God, bitterness, unforgiveness, all of these are attacks from Satan."
  },
  {
    "author": "Melanie Laurent",
    "category": "trust",
    "id": 70287,
    "text": "I never practice before, I never work hours on a script. I just choose my characters and trust them, and after that, it's about the director taking your hand."
  },
  {
    "author": "John Dingell",
    "category": "trust",
    "id": 70298,
    "text": "If the president is failing to disclose material facts with regard to legislation being presented to the Congress on a question as important as war and peace, I think it does impair the level of trust that the House and the Senate have for this administration."
  },
  {
    "author": "Jeff Daniels",
    "category": "trust",
    "id": 70222,
    "text": "I think it's a style of acting that you trust. You trust the instincts."
  },
  {
    "author": "Kenny Loggins",
    "category": "trust",
    "id": 69836,
    "text": "My trust in a higher power that wants me to survive and have love in my life, is what keeps me moving forward."
  },
  {
    "author": "Gustav Heinemann",
    "category": "trust",
    "id": 70141,
    "text": "Trust cannot be commanded and yet it is also correct that the only one who earns trust is the one who is prepared to grant trust."
  },
  {
    "author": "Jake Pavelka",
    "category": "trust",
    "id": 70485,
    "text": "I'm not going to be in a relationship that I don't fully trust."
  },
  {
    "author": "Oliver North",
    "category": "trust",
    "id": 70230,
    "text": "When you're told to go brief a United States senator on a covert operation, you go do it. And you trust the information isn't going to leak."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "trust",
    "id": 69737,
    "text": "Trust yourself, then you will know how to live."
  },
  {
    "author": "Chris Brown",
    "category": "trust",
    "id": 69968,
    "text": "With fame, you can't trust everybody. You can't depend on them being there for you as a person. They will only be there because of what you've got you as a person. They will only be there because of what you've got and what you can bring to their life. It's not a relationship-it's a leech."
  },
  {
    "author": "Michael Gove",
    "category": "trust",
    "id": 70207,
    "text": "What we're doing now is we're saying that individual schools can spend the money on their own priorities, so that head teachers can decide what's truly important, because the big shift in approach on education that we're taking - which is different from what happened before - is that we trust teachers and we trust heads."
  },
  {
    "author": "Frances McDormand",
    "category": "trust",
    "id": 69770,
    "text": "I never trusted good-looking boys."
  },
  {
    "author": "John Boehner",
    "category": "trust",
    "id": 70078,
    "text": "House and Senate Republicans are now united in adopting earmark bans. We hope President Obama will follow through on his support for an earmark ban by pressing Democratic leaders to join House and Senate Republicans in taking this critical step to restore public trust."
  },
  {
    "author": "Willie Green",
    "category": "trust",
    "id": 70518,
    "text": "We have only God on our side they have 'In God We Trust' on their side."
  },
  {
    "author": "Eleanor Tomlinson",
    "category": "trust",
    "id": 70503,
    "text": "I never trust anything that can be captured in 2 takes."
  },
  {
    "author": "Jose Marti",
    "category": "trust",
    "id": 69871,
    "text": "He who receives money in trust to administer for the benefit of its owner, and uses it either for his own interest or against the wishes of its rightful owner, is a thief."
  },
  {
    "author": "Dan Hawkins",
    "category": "trust",
    "id": 70353,
    "text": "We've got a long career ahead of us and it's going to be great. Trust me."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "trust",
    "id": 69894,
    "text": "A poet ought not to pick nature's pocket. Let him borrow, and so borrow as to repay by the very act of borrowing. Examine nature accurately, but write from recollection, and trust more to the imagination than the memory."
  },
  {
    "author": "Bryan Adams",
    "category": "trust",
    "id": 69902,
    "text": "I've only ever trusted my gut on everything. I don't trust my head, I don't trust my heart, I trust my gut."
  },
  {
    "author": "Barbra Streisand",
    "category": "trust",
    "id": 70009,
    "text": "I've considered having my nose fixed. But I didn't trust anyone enough. If I could do it myself with a mirror."
  },
  {
    "author": "Daniel Barenboim",
    "category": "trust",
    "id": 70428,
    "text": "Now the first step has to be taken, the step towards democracy. This step is full of risks, and requires trust on all sides. We don't know where it will lead. But if we just stand still, we will have no chance of escaping the violence."
  },
  {
    "author": "Kyle Chandler",
    "category": "trust",
    "id": 70064,
    "text": "I just can't say enough about the actors having faith and trust in the writers and the writers having faith and trust in the actors."
  },
  {
    "author": "John Key",
    "category": "trust",
    "id": 70172,
    "text": "We have been given the trust and goodwill of New Zealanders. I do not take that trust for granted, and I never will."
  },
  {
    "author": "Yoko Ono",
    "category": "trust",
    "id": 70030,
    "text": "I trust myself. You need that to survive."
  },
  {
    "author": "Simon Winchester",
    "category": "trust",
    "id": 70378,
    "text": "We associate the North Atlantic with cod. The motto of Newfoundland used to be 'In cod we trust.' It was a joke, but it was essentially true. But there is no cod anymore. And that's extraordinary. It's all because of either greed or politics - Canadian politics."
  },
  {
    "author": "Dee Hock",
    "category": "trust",
    "id": 69945,
    "text": "It is essential to employ, trust, and reward those whose perspective, ability, and judgment are radically different from yours. It is also rare, for it requires uncommon humility, tolerance, and wisdom."
  },
  {
    "author": "Nile Rodgers",
    "category": "trust",
    "id": 70334,
    "text": "Trust me, the only real way to understand 'Chic' is in highfalutin terms. Our chord progressions were based on European modal melodies. I made those early 'Chic' records to impress my jazz friends."
  },
  {
    "author": "Mary Renault",
    "category": "trust",
    "id": 69751,
    "text": "How can people trust the harvest, unless they see it sown?"
  },
  {
    "author": "Herb Kohl",
    "category": "trust",
    "id": 70443,
    "text": "Before we decide to trust you with this power, we ask you to stand before the public and explain your views. Justice may be blind, but it should not be deaf."
  },
  {
    "author": "Francois Hollande",
    "category": "trust",
    "id": 70063,
    "text": "France, after the month of May, will share trust with the current leadership of the United States which, on many subjects, has tended to take useful positions in our view."
  },
  {
    "author": "Ann Romney",
    "category": "trust",
    "id": 70087,
    "text": "I said tonight I wanted to talk to you about love. Look into your hearts. This is our country. This is our future. These are our children and grandchildren. You can trust Mitt."
  },
  {
    "author": "Alexander Hamilton",
    "category": "trust",
    "id": 69842,
    "text": "Nobody expects to trust his body overmuch after the age of fifty."
  },
  {
    "author": "Dennis Muren",
    "category": "trust",
    "id": 70336,
    "text": "And I also trust that there's more than one way to do something."
  },
  {
    "author": "Samantha Morton",
    "category": "trust",
    "id": 70137,
    "text": "Some directors cast you because they trust you to do the performance - but then they forget to direct you."
  },
  {
    "author": "Theresa May",
    "category": "trust",
    "id": 70045,
    "text": "I think there is a break down of trust generally, between people and politicians. I think that's come about for a whole variety of reasons."
  },
  {
    "author": "Bill Parcells",
    "category": "trust",
    "id": 70117,
    "text": "If the players don't trust the coach, it is a problem, and vice versa."
  },
  {
    "author": "Gina Gershon",
    "category": "trust",
    "id": 70260,
    "text": "Feeding is a very important ritual for me. I don't trust people who don't like to eat."
  },
  {
    "author": "Simon Mainwaring",
    "category": "trust",
    "id": 69960,
    "text": "Non-disclosure in the Internet Age is quickly perceived as a breach of trust. Government, corporations and each of us as individuals must recalibrate how we live and share our lives appropriate to the information now available and the expectations of others."
  },
  {
    "author": "Russel Honore",
    "category": "trust",
    "id": 70333,
    "text": "When you form a team, why do you try to form a team? Because teamwork builds trust and trust builds speed."
  },
  {
    "author": "Yingluck Shinawatra",
    "category": "trust",
    "id": 70465,
    "text": "You might not trust me. Please give me a chance and time. I will prove myself for all of you."
  },
  {
    "author": "Walter Isaacson",
    "category": "trust",
    "id": 70146,
    "text": "We have to compete in a universe of 200 networks, so we have to carve out our own niche, and to me, that niche is just basic shoe-leather journalism with some good journalists at the helm you can trust as presenters."
  },
  {
    "author": "Aesop",
    "category": "trust",
    "id": 69943,
    "text": "Never trust the advice of a man in difficulties."
  },
  {
    "author": "Graham Swift",
    "category": "trust",
    "id": 70240,
    "text": "In my work you often get an abrupt shift in time, a jolt. But the emotional logic will take the reader on. I hope. I trust. After all, our memories do not work with any sequential logic."
  },
  {
    "author": "Ava Gardner",
    "category": "trust",
    "id": 70442,
    "text": "I have only one rule in acting - trust the director and give him heart and soul."
  },
  {
    "author": "Stanislaw Lec",
    "category": "trust",
    "id": 70096,
    "text": "Don't trust the heart, it wants your blood."
  },
  {
    "author": "Lyle Alzado",
    "category": "trust",
    "id": 70513,
    "text": "I don't really trust a sane person."
  },
  {
    "author": "Howard Dean",
    "category": "trust",
    "id": 70122,
    "text": "Not one Republican president has balanced the budget in 34 years. You can not trust Republicans with your money."
  },
  {
    "author": "Sophocles",
    "category": "trust",
    "id": 69866,
    "text": "Trust dies but mistrust blossoms."
  },
  {
    "author": "Sultan bin Abdul-Aziz Al Saud",
    "category": "trust",
    "id": 70487,
    "text": "With King Abdullah's leadership and his people's trust he can keep the kingdom stable and secure in all its affairs."
  },
  {
    "author": "James Broughton",
    "category": "trust",
    "id": 69773,
    "text": "Trusting your individual uniqueness challenges you to lay yourself open."
  },
  {
    "author": "Charles Kingsley",
    "category": "trust",
    "id": 69804,
    "text": "A blessed thing it is for any man or woman to have a friend, one human soul whom we can trust utterly, who knows the best and worst of us, and who loves us in spite of all our faults."
  },
  {
    "author": "Leven Rambin",
    "category": "trust",
    "id": 70389,
    "text": "As a Christian, I think it's really important to find a man of God to trust and be supportive of me."
  },
  {
    "author": "David Wilkerson",
    "category": "trust",
    "id": 69771,
    "text": "In these times, God's people must trust him for rest of body and soul."
  },
  {
    "author": "David Plouffe",
    "category": "trust",
    "id": 70363,
    "text": "The American people want to have trust in their leaders."
  },
  {
    "author": "Maggie Gyllenhaal",
    "category": "trust",
    "id": 69884,
    "text": "Who can I trust? You have to invest in somebody and chances are you're probably going to invest in somebody who's going to deceive you. I've been conned a couple of times, but now I'm a little more savvy."
  },
  {
    "author": "Harriet Tubman",
    "category": "trust",
    "id": 69934,
    "text": "Quakers almost as good as colored. They call themselves friends and you can trust them every time."
  },
  {
    "author": "Douglas Wood",
    "category": "trust",
    "id": 70278,
    "text": "I became much happier when I realized I shouldn't depend solely on my career for my sense of self. So I developed other interests and surrounded myself with a small group of friends I could trust."
  },
  {
    "author": "Ali Smith",
    "category": "trust",
    "id": 70370,
    "text": "You never know if you're a writer. You can't trust it. If you woke up and said, 'I'm a writer,' it would be gone. You wouldn't see anything for miles - even the dust would be running away."
  },
  {
    "author": "Arabella Weir",
    "category": "trust",
    "id": 70152,
    "text": "I wish my parents hadn't made me feel that how I looked was linked to how much they loved me. But I do also see how hard it must be to see your child pile on the pounds and trust they'll find their own way back to a healthy weight."
  },
  {
    "author": "Stephen Leacock",
    "category": "trust",
    "id": 69754,
    "text": "Men are able to trust one another, knowing the exact degree of dishonesty they are entitled to expect."
  },
  {
    "author": "G. I. Gurdjieff",
    "category": "trust",
    "id": 70073,
    "text": "In properly organized groups no faith is required what is required is simply a little trust and even that only for a little while, for the sooner a man begins to verify all he hears the better it is for him."
  },
  {
    "author": "Amy Adams",
    "category": "trust",
    "id": 70340,
    "text": "How I work is I work from of very character-driven place. And I trust the writers."
  },
  {
    "author": "Charles Dickens",
    "category": "trust",
    "id": 69820,
    "text": "I have known a vast quantity of nonsense talked about bad men not looking you in the face. Don't trust that conventional idea. Dishonesty will stare honesty out of countenance any day in the week, if there is anything to be got by it."
  },
  {
    "author": "Richard Fleeshman",
    "category": "trust",
    "id": 70413,
    "text": "I trust my mum with anything. If I have a problem, my mum is always the first person I go to."
  },
  {
    "author": "Benjamin Spock",
    "category": "trust",
    "id": 69767,
    "text": "Trust yourself, you know more than you think you do."
  },
  {
    "author": "Albert Claude",
    "category": "trust",
    "id": 69933,
    "text": "For this equilibrium now in sight, let us trust that mankind, as it has occurred in the greatest periods of its past, will find for itself a new code of ethics, common to all, made of tolerance, of courage, and of faith in the Spirit of men."
  },
  {
    "author": "Richard Russo",
    "category": "trust",
    "id": 70113,
    "text": "You just kind of have faith. If that sounds kind of mystical, it's because I really don't know how it works, but I trust that it does. I try to write the way I read, in order to find out what happens next."
  },
  {
    "author": "Kiana Tom",
    "category": "trust",
    "id": 69742,
    "text": "I always trust my gut reaction it's always right."
  },
  {
    "author": "Eric Cantor",
    "category": "trust",
    "id": 70124,
    "text": "And basically, the sense of the 'Pledge to America' is this: Republicans understand when we were in charge, we got fired in '06. We spent too much money. We defied the trust that the people had put in us. And we know that there is a better way."
  },
  {
    "author": "Christopher Hitchens",
    "category": "trust",
    "id": 69924,
    "text": "Trust is not the same as faith. A friend is someone you trust. Putting faith in anyone is a mistake."
  },
  {
    "author": "Aldrich Ames",
    "category": "trust",
    "id": 70521,
    "text": "Let's say a Soviet exchange student back in the '70s would go back and tell the KGB about people and places and things that he'd seen and done and been involved with. This is not really espionage there's no betrayal of trust."
  },
  {
    "author": "JoJo",
    "category": "trust",
    "id": 70386,
    "text": "I'm lucky to have a great support system in my friends and some of my family. If you have those people that you trust, go ahead and fall back into them and let them be your hammock and cocoon and let them embrace you."
  },
  {
    "author": "Peter Ueberroth",
    "category": "trust",
    "id": 70471,
    "text": "Baseball is a public trust. Players turn over, owners turn over and certain commissioners turn over. But baseball goes on."
  },
  {
    "author": "Howie Carr",
    "category": "trust",
    "id": 70343,
    "text": "Reporters used to be blue-collar at the Globe now, it's practically required that you have a trust fund."
  },
  {
    "author": "George MacDonald",
    "category": "trust",
    "id": 69756,
    "text": "Few delights can equal the presence of one whom we trust utterly."
  },
  {
    "author": "Michael Arad",
    "category": "trust",
    "id": 70202,
    "text": "I built a series of supporters that had my back. I never abused that trust. You can't cry wolf. You have to solve most problems yourself."
  },
  {
    "author": "Lee Child",
    "category": "trust",
    "id": 70115,
    "text": "I was in television drama, which is a first cousin to the movies, and I trust myself to make the right decisions."
  },
  {
    "author": "Bethenny Frankel",
    "category": "trust",
    "id": 70028,
    "text": "Frankly, I don't trust any diet that doesn't allow sugar."
  },
  {
    "author": "Karl Malone",
    "category": "trust",
    "id": 70194,
    "text": "It takes people a while to trust you."
  },
  {
    "author": "Robert Caro",
    "category": "trust",
    "id": 70128,
    "text": "There used to be this feeling under Eisenhower and Kennedy and Roosevelt and Truman that government was a solution. Trust in the presidency fell precipitously under Johnson - real lows. And it's never come back. It's a trend that, if you're liberal, is really discouraging."
  },
  {
    "author": "Sharron Angle",
    "category": "trust",
    "id": 70132,
    "text": "You know, this is a war of ideology, a war of thoughts and of faith. And we need people to really stand for faith and trust, not hope and change."
  }
]

quotes['truth'] = [
  {
    "author": "Donald Trump",
    "category": "truth",
    "id": 70945,
    "text": "Obama has no solutions. Obama has failed the country and its great citizens, and they don't like it when somebody such as myself speaks the truth about this - it hurts too much."
  },
  {
    "author": "Franz Kafka",
    "category": "truth",
    "id": 71237,
    "text": "Not everyone can see the truth, but he can be it."
  },
  {
    "author": "Denis Diderot",
    "category": "truth",
    "id": 71328,
    "text": "Pithy sentences are like sharp nails which force truth upon our memory."
  },
  {
    "author": "Victor Borge",
    "category": "truth",
    "id": 71066,
    "text": "Humor is something that thrives between man's aspirations and his limitations. There is more logic in humor than in anything else. Because, you see, humor is truth."
  },
  {
    "author": "Larry David",
    "category": "truth",
    "id": 71263,
    "text": "If you tell the truth about how you're feeling, it becomes funny."
  },
  {
    "author": "Henry Louis Gates",
    "category": "truth",
    "id": 70984,
    "text": "The thing about black history is that the truth is so much more complex than anything you could make up."
  },
  {
    "author": "Maya Angelou",
    "category": "truth",
    "id": 70546,
    "text": "There's a world of difference between truth and facts. Facts can obscure the truth."
  },
  {
    "author": "Adlai E. Stevenson",
    "category": "truth",
    "id": 70961,
    "text": "If the Republicans will stop telling lies about the Democrats, we will stop telling the truth about them."
  },
  {
    "author": "Edward de Bono",
    "category": "truth",
    "id": 71457,
    "text": "Argument is meant to reveal the truth, not to create it."
  },
  {
    "author": "James Madison",
    "category": "truth",
    "id": 71098,
    "text": "If we are to take for the criterion of truth the majority of suffrages, they ought to be gotten from those philosophic and patriotic citizens who cultivate their reason."
  },
  {
    "author": "Anthony de Mello",
    "category": "truth",
    "id": 71159,
    "text": "It is a great mystery that though the human heart longs for Truth, in which alone it finds liberation and delight, the first reaction of human beings to Truth is one of hostility and fear!"
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "truth",
    "id": 70928,
    "text": "In everything truth surpasses the imitation and copy."
  },
  {
    "author": "Edith Stein",
    "category": "truth",
    "id": 71429,
    "text": "My longing for truth was a single prayer."
  },
  {
    "author": "Arthur Conan Doyle",
    "category": "truth",
    "id": 71151,
    "text": "Violence does, in truth, recoil upon the violent, and the schemer falls into the pit which he digs for another."
  },
  {
    "author": "Jeanne Moreau",
    "category": "truth",
    "id": 71514,
    "text": "Every night I go over what I did in the day, in ethical or moral terms. Have I treated people properly? Did I tell the truth?"
  },
  {
    "author": "Virginia Woolf",
    "category": "truth",
    "id": 70933,
    "text": "Mental fight means thinking against the current, not with it. It is our business to puncture gas bags and discover the seeds of truth."
  },
  {
    "author": "Adlai E. Stevenson",
    "category": "truth",
    "id": 70916,
    "text": "Your days are short here this is the last of your springs. And now in the serenity and quiet of this lovely place, touch the depths of truth, feel the hem of Heaven. You will go away with old, good friends. And don't forget when you leave why you came."
  },
  {
    "author": "Danica McKellar",
    "category": "truth",
    "id": 71511,
    "text": "People talk about 'getting rid of the old image', and I guess there's some merit in that. But the truth is that people loved 'The Wonder Years' - I can't turn my back on it."
  },
  {
    "author": "Robert Green Ingersoll",
    "category": "truth",
    "id": 70869,
    "text": "A fact never went into partnership with a miracle. Truth scorns the assistance of wonders. A fact will fit every other fact in the universe, and that is how you can tell whether it is or is not a fact. A lie will not fit anything except another lie."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "truth",
    "id": 70799,
    "text": "The truth is found when men are free to pursue it."
  },
  {
    "author": "Malcolm Muggeridge",
    "category": "truth",
    "id": 70817,
    "text": "One of the peculiar sins of the twentieth century which we've developed to a very high level is the sin of credulity. It has been said that when human beings stop believing in God they believe in nothing. The truth is much worse: they believe in anything."
  },
  {
    "author": "John F. Kennedy",
    "category": "truth",
    "id": 70685,
    "text": "The goal of education is the advancement of knowledge and the dissemination of truth."
  },
  {
    "author": "Samuel Taylor Coleridge",
    "category": "truth",
    "id": 71401,
    "text": "He who begins by loving Christianity more than Truth, will proceed by loving his sect or church better than Christianity, and end in loving himself better than all."
  },
  {
    "author": "Samuel Johnson",
    "category": "truth",
    "id": 71004,
    "text": "In order that all men may be taught to speak the truth, it is necessary that all likewise should learn to hear it."
  },
  {
    "author": "Khalil Gibran",
    "category": "truth",
    "id": 70680,
    "text": "Yesterday we obeyed kings and bent our necks before emperors. But today we kneel only to truth, follow only beauty, and obey only love."
  },
  {
    "author": "Charles Stanley",
    "category": "truth",
    "id": 70757,
    "text": "Our heavenly Father understands our disappointment, suffering, pain, fear, and doubt. He is always there to encourage our hearts and help us understand that He's sufficient for all of our needs. When I accepted this as an absolute truth in my life, I found that my worrying stopped."
  },
  {
    "author": "Pablo Neruda",
    "category": "truth",
    "id": 70832,
    "text": "The books that help you most are those which make you think that most. The hardest way of learning is that of easy reading but a great book that comes from a great thinker is a ship of thought, deep freighted with truth and beauty."
  },
  {
    "author": "Thomas Jefferson",
    "category": "truth",
    "id": 70665,
    "text": "There is not a truth existing which I fear... or would wish unknown to the whole world."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "truth",
    "id": 70555,
    "text": "On the mountains of truth you can never climb in vain: either you will reach a point higher up today, or you will be training your powers so that you will be able to climb higher tomorrow."
  },
  {
    "author": "Henri Frederic Amiel",
    "category": "truth",
    "id": 71260,
    "text": "An error is the more dangerous in proportion to the degree of truth which it contains."
  },
  {
    "author": "Michael Landon",
    "category": "truth",
    "id": 71340,
    "text": "I believe in God, family, truth between people, the power of love."
  },
  {
    "author": "Graham Greene",
    "category": "truth",
    "id": 71216,
    "text": "The truth has never been of any real value to any human being - it is a symbol for mathematicians and philosophers to pursue. In human relations kindness and lies are worth a thousand truths."
  },
  {
    "author": "Sun Myung Moon",
    "category": "truth",
    "id": 71400,
    "text": "The day will come, however, when they will truly know the Unification Church and me. The day will come when the truth will be known and the message of love will be taught. On that day, their regret will be deep."
  },
  {
    "author": "Anatole France",
    "category": "truth",
    "id": 70982,
    "text": "The truth is that life is delicious, horrible, charming, frightful, sweet, bitter, and that is everything."
  },
  {
    "author": "Scott Ritter",
    "category": "truth",
    "id": 71445,
    "text": "I'm someone who believes the truth needs to be heard. And if I'm empowered with the truth, I'm not going to shut up."
  },
  {
    "author": "Josh Billings",
    "category": "truth",
    "id": 71092,
    "text": "As scarce as truth is, the supply has always been in excess of the demand."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "truth",
    "id": 70696,
    "text": "We have art in order not to die of the truth."
  },
  {
    "author": "Khalil Gibran",
    "category": "truth",
    "id": 70548,
    "text": "Truth is a deep kindness that teaches us to be content in our everyday life and share with the people the same happiness."
  },
  {
    "author": "Herman Melville",
    "category": "truth",
    "id": 71249,
    "text": "Truth is in things, and not in words."
  },
  {
    "author": "Mark Twain",
    "category": "truth",
    "id": 70540,
    "text": "It's no wonder that truth is stranger than fiction. Fiction has to make sense."
  },
  {
    "author": "Samuel Goldwyn",
    "category": "truth",
    "id": 71255,
    "text": "I want everyone to tell me the truth, even if it costs him his job."
  },
  {
    "author": "Plato",
    "category": "truth",
    "id": 70751,
    "text": "Poetry is nearer to vital truth than history."
  },
  {
    "author": "Edward G. Bulwer-Lytton",
    "category": "truth",
    "id": 71214,
    "text": "Enthusiasm is the genius of sincerity and truth accomplishes no victories without it."
  },
  {
    "author": "Richard M. Nixon",
    "category": "truth",
    "id": 71147,
    "text": "Let us begin by committing ourselves to the truth to see it like it is, and tell it like it is, to find the truth, to speak the truth, and to live the truth."
  },
  {
    "author": "Yukio Mishima",
    "category": "truth",
    "id": 71257,
    "text": "By means of microscopic observation and astronomical projection the lotus flower can become the foundation for an entire theory of the universe and an agent whereby we may perceive Truth."
  },
  {
    "author": "Robert De Niro",
    "category": "truth",
    "id": 71414,
    "text": "I think Hollywood has a class system. The actors are like the inmates, but the truth is they're running the asylum."
  },
  {
    "author": "Sonia Johnson",
    "category": "truth",
    "id": 71407,
    "text": "A friend said to me, 'Be glad for your troubles - they strengthen you.' Well, if that's the truth, I'm going to be so strong they'll have to beat me to death!"
  },
  {
    "author": "Winston Churchill",
    "category": "truth",
    "id": 70527,
    "text": "A lie gets halfway around the world before the truth has a chance to get its pants on."
  },
  {
    "author": "W. Clement Stone",
    "category": "truth",
    "id": 70655,
    "text": "Have the courage to say no. Have the courage to face the truth. Do the right thing because it is right. These are the magic keys to living your life with integrity."
  },
  {
    "author": "Ismail Haniyeh",
    "category": "truth",
    "id": 70781,
    "text": "Some people think that the truth can be hidden with a little cover-up and decoration. But as time goes by, what is true is revealed, and what is fake fades away."
  },
  {
    "author": "Aesop",
    "category": "truth",
    "id": 70602,
    "text": "Every truth has two sides it is as well to look at both, before we commit ourselves to either."
  },
  {
    "author": "Francis Bacon",
    "category": "truth",
    "id": 71001,
    "text": "What is truth? said jesting Pilate and would not stay for an answer."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "truth",
    "id": 70676,
    "text": "Truth never damages a cause that is just."
  },
  {
    "author": "Blaise Pascal",
    "category": "truth",
    "id": 70901,
    "text": "Nothing gives rest but the sincere search for truth."
  },
  {
    "author": "Michael Moore",
    "category": "truth",
    "id": 71261,
    "text": "Listen friends, you have to face the truth: You are never going to be rich... The system is rigged in favor of the few, and your name is not among them, not now and not ever."
  },
  {
    "author": "Samuel Johnson",
    "category": "truth",
    "id": 71017,
    "text": "Every man has a right to utter what he thinks truth, and every other man has a right to knock him down for it. Martyrdom is the test."
  },
  {
    "author": "Justin Timberlake",
    "category": "truth",
    "id": 70619,
    "text": "Gossip is called gossip because it's not always the truth."
  },
  {
    "author": "Henri Frederic Amiel",
    "category": "truth",
    "id": 71148,
    "text": "Truth is not only violated by falsehood it may be equally outraged by silence."
  },
  {
    "author": "E. O. Wilson",
    "category": "truth",
    "id": 70783,
    "text": "The essence of humanity's spiritual dilemma is that we evolved genetically to accept one truth and discovered another. Is there a way to erase the dilemma, to resolve the contradictions between the transcendentalist and the empiricist world views?"
  },
  {
    "author": "Oliver Wendell Holmes, Jr.",
    "category": "truth",
    "id": 71404,
    "text": "Truth is tough. It will not break, like a bubble, at the touch, nay, you may kick it about all day like a football, and it will be round and full at evening."
  },
  {
    "author": "Roger Bacon",
    "category": "truth",
    "id": 71317,
    "text": "Argument is conclusive, but it does not remove doubt, so that the mind may rest in the sure knowledge of the truth, unless it finds it by the method of experiment."
  },
  {
    "author": "Francis Bacon",
    "category": "truth",
    "id": 70921,
    "text": "Truth is the daughter of time, not of authority."
  },
  {
    "author": "Lao Tzu",
    "category": "truth",
    "id": 70560,
    "text": "The words of truth are always paradoxical."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "truth",
    "id": 70700,
    "text": "One may sometimes tell a lie, but the grimace that accompanies it tells the truth."
  },
  {
    "author": "Lord Byron",
    "category": "truth",
    "id": 71014,
    "text": "Truth is always strange, stranger than fiction."
  },
  {
    "author": "Bryant H. McGill",
    "category": "truth",
    "id": 71091,
    "text": "One column of truth cannot hold an institution of ideas from falling into ignorance. It is wiser that a person of prudence and purpose save his strength for battles that can be won."
  },
  {
    "author": "Doris Lessing",
    "category": "truth",
    "id": 71451,
    "text": "It is terrible to destroy a person's picture of himself in the interests of truth or some other abstraction."
  },
  {
    "author": "Harry S. Truman",
    "category": "truth",
    "id": 70995,
    "text": "Intense feeling too often obscures the truth."
  },
  {
    "author": "Maureen O'Hara",
    "category": "truth",
    "id": 71486,
    "text": "There's a terrible truth for many women in the picture business: Aging typically takes its toll and means fewer and less desirable roles."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "truth",
    "id": 70691,
    "text": "Truth is handsomer than the affectation of love. Your goodness must have some edge to it, else it is none."
  },
  {
    "author": "Soren Kierkegaard",
    "category": "truth",
    "id": 70874,
    "text": "Personality is only ripe when a man has made the truth his own."
  },
  {
    "author": "Confucius",
    "category": "truth",
    "id": 70701,
    "text": "The object of the superior man is truth."
  },
  {
    "author": "Edgar Allan Poe",
    "category": "truth",
    "id": 70763,
    "text": "It is the nature of truth in general, as of some ores in particular, to be richest when most superficial."
  },
  {
    "author": "J. K. Rowling",
    "category": "truth",
    "id": 70617,
    "text": "The truth. It is a beautiful and terrible thing, and must therefore be treated with great caution."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "truth",
    "id": 70594,
    "text": "I say that justice is truth in action."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "truth",
    "id": 70679,
    "text": "I believe in the fundamental truth of all great religions of the world."
  },
  {
    "author": "Novalis",
    "category": "truth",
    "id": 71311,
    "text": "To become properly acquainted with a truth, we must first have disbelieved it, and disputed against it."
  },
  {
    "author": "Alexander Pope",
    "category": "truth",
    "id": 71055,
    "text": "Know then this truth, enough for man to know virtue alone is happiness below."
  },
  {
    "author": "Tony Robbins",
    "category": "truth",
    "id": 70724,
    "text": "The truth is that we can learn to condition our minds, bodies, and emotions to link pain or pleasure to whatever we choose. By changing what we link pain and pleasure to, we will instantly change our behaviors."
  },
  {
    "author": "Aristotle",
    "category": "truth",
    "id": 70704,
    "text": "Piety requires us to honor truth above our friends."
  },
  {
    "author": "Jimi Hendrix",
    "category": "truth",
    "id": 70745,
    "text": "Music makes me high on stage, and that's the truth. It's like being almost addicted to music."
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "truth",
    "id": 70615,
    "text": "Truth is tough. It will not break, like a bubble, at a touch nay, you may kick it about all day like a football, and it will be round and full at evening."
  },
  {
    "author": "Peter Ustinov",
    "category": "truth",
    "id": 71303,
    "text": "The truth is an ambition which is beyond us."
  },
  {
    "author": "Ludwig Wittgenstein",
    "category": "truth",
    "id": 71233,
    "text": "When one is frightened of the truth then it is never the whole truth that one has an inkling of."
  },
  {
    "author": "David Herbert Lawrence",
    "category": "truth",
    "id": 71185,
    "text": "Since obscenity is the truth of our passion today, it is the only stuff of art - or almost the only stuff."
  },
  {
    "author": "Aldous Huxley",
    "category": "truth",
    "id": 70824,
    "text": "You shall know the truth, and the truth shall make you mad."
  },
  {
    "author": "Will Rogers",
    "category": "truth",
    "id": 70748,
    "text": "If you ever injected truth into politics you have no politics."
  },
  {
    "author": "Mason Cooley",
    "category": "truth",
    "id": 71049,
    "text": "Irony regards every simple truth as a challenge."
  },
  {
    "author": "Harry S. Truman",
    "category": "truth",
    "id": 70841,
    "text": "I never gave anybody hell! I just told the truth and they thought it was hell."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "truth",
    "id": 71171,
    "text": "Many speak the truth when they say that they despise riches, but they mean the riches possessed by others."
  },
  {
    "author": "William Lloyd Garrison",
    "category": "truth",
    "id": 71413,
    "text": "I will be as harsh as truth, and uncompromising as justice... I am in earnest, I will not equivocate, I will not excuse, I will not retreat a single inch, and I will be heard."
  },
  {
    "author": "John Bradshaw",
    "category": "truth",
    "id": 71104,
    "text": "It's essential to tell the truth at all times. This will reduce life's pain. Lying distorts reality. All forms of distorted thinking must be corrected."
  },
  {
    "author": "Simone de Beauvoir",
    "category": "truth",
    "id": 71025,
    "text": "Defending the truth is not something one does out of a sense of duty or to allay guilt complexes, but is a reward in itself."
  },
  {
    "author": "Dick Clark",
    "category": "truth",
    "id": 71239,
    "text": "Humor is always based on a modicum of truth. Have you ever heard a joke about a father-in-law?"
  },
  {
    "author": "Benjamin Disraeli",
    "category": "truth",
    "id": 70927,
    "text": "Time is precious, but truth is more precious than time."
  },
  {
    "author": "George Bernard Shaw",
    "category": "truth",
    "id": 70729,
    "text": "Only on paper has humanity yet achieved glory, beauty, truth, knowledge, virtue, and abiding love."
  },
  {
    "author": "Charles Lamb",
    "category": "truth",
    "id": 71173,
    "text": "The teller of a mirthful tale has latitude allowed him. We are content with less than absolute truth."
  },
  {
    "author": "Aldous Huxley",
    "category": "truth",
    "id": 70835,
    "text": "Proverbs are always platitudes until you have personally experienced the truth of them."
  },
  {
    "author": "Blaise Pascal",
    "category": "truth",
    "id": 70836,
    "text": "Truth is so obscure in these times, and falsehood so established, that, unless we love the truth, we cannot know it."
  },
  {
    "author": "Henry Rollins",
    "category": "truth",
    "id": 70935,
    "text": "As long as I tell the truth I feel that nobody can touch me."
  }
]

quotes['war'] = [
  {
    "author": "Larry Hagman",
    "category": "war",
    "id": 72300,
    "text": "I'm sure it is, I'm not for any kind of war, we've been engaged in several wars since the second world war and we lost in Korea, we lost in Vietnam, they are political wars, they have nothing to do with any real threat, nor does this one."
  },
  {
    "author": "Walt Whitman",
    "category": "war",
    "id": 71805,
    "text": "The real war will never get in the books."
  },
  {
    "author": "Lester B. Pearson",
    "category": "war",
    "id": 72203,
    "text": "As a soldier, I survived World War I when most of my comrades did not."
  },
  {
    "author": "Arthur Henderson",
    "category": "war",
    "id": 72440,
    "text": "Four years of world war, at a cost in human suffering which our minds are mercifully too limited to imagine, led to the very clear realization that international anarchy must be abandoned if civilization was to survive."
  },
  {
    "author": "Henry A. Wallace",
    "category": "war",
    "id": 72375,
    "text": "Most American fascists are enthusiastically supporting the war effort. They are doing this even in those cases where they hope to have profitable connections with German chemical firms after the war ends."
  },
  {
    "author": "Margaret Sanger",
    "category": "war",
    "id": 72233,
    "text": "War, famine, poverty and oppression of the workers will continue while woman makes life cheap. They will cease only when she limits her reproductivity and human life is no longer a thing to be wasted."
  },
  {
    "author": "Leo Tolstoy",
    "category": "war",
    "id": 71824,
    "text": "War on the other hand is such a terrible thing, that no man, especially a Christian man, has the right to assume the responsibility of starting it."
  },
  {
    "author": "John Mayer",
    "category": "war",
    "id": 72111,
    "text": "You cannot avoid war in life, you cannot avoid the fear of terrorism, you cannot avoid those things now, they are a part of everyday demeanor."
  },
  {
    "author": "Tony Blair",
    "category": "war",
    "id": 72198,
    "text": "The threat today is not that of the 1930s. It's not big powers going to war with each other. The ravages which fundamentalist political ideology inflicted on the 20th century are memories. The Cold war is over. Europe is at peace, if not always diplomatically."
  },
  {
    "author": "Miguel de Cervantes",
    "category": "war",
    "id": 72097,
    "text": "There is nothing so subject to the inconstancy of fortune as war."
  },
  {
    "author": "Albert Pike",
    "category": "war",
    "id": 71988,
    "text": "A war for a great principle ennobles a nation."
  },
  {
    "author": "James Buchan",
    "category": "war",
    "id": 72236,
    "text": "Suicidal violence is not the exclusive property of the Muslim world. Suicide bombings were a tactic of nationalist struggles in 19th-century Europe and Russia, the far east during the second world war and the Vietnam war, and in modern Sri Lanka."
  },
  {
    "author": "Christopher Hitchens",
    "category": "war",
    "id": 71975,
    "text": "A faction willing to take the risks of making war on the ossified status quo in the Middle East can be described as many things, but not as conservative."
  },
  {
    "author": "Ulysses S. Grant",
    "category": "war",
    "id": 71576,
    "text": "I have never advocated war except as a means of peace."
  },
  {
    "author": "Diane Kruger",
    "category": "war",
    "id": 72292,
    "text": "Berlin is still going through a transition since the Cold War - both in what used to be East and West Berlin. I can still sense the confusion and the struggle for identity there in the streets. There's a pulse to it."
  },
  {
    "author": "John Podhoretz",
    "category": "war",
    "id": 72103,
    "text": "The idea that the rest of the world was somehow being held hostage by the Arab-Israeli conflict once had a minimal basis in reality. In the first 20 years of Israel's existence, every Arab country was in an active state of war with the Jewish state."
  },
  {
    "author": "Jay Leno",
    "category": "war",
    "id": 72250,
    "text": "The Pentagon still has not given a name to the Iraqi war. Somehow 'Operation Re-elect Bush' doesn't seem to be popular."
  },
  {
    "author": "George Wald",
    "category": "war",
    "id": 72517,
    "text": "There is nothing worth having that can he obtained by nuclear war - nothing material or ideological - no tradition that it can defend. It is utterly self-defeating."
  },
  {
    "author": "Calvin Coolidge",
    "category": "war",
    "id": 71846,
    "text": "No nation ever had an army large enough to guarantee it against attack in time of peace, or ensure it of victory in time of war."
  },
  {
    "author": "George W. Bush",
    "category": "war",
    "id": 71928,
    "text": "Some have argued that confronting the threat from Iraq could detract from the war against terror. To the contrary, confronting the threat posed by Iraq is crucial to winning the war on terror."
  },
  {
    "author": "Jean-Jacques Rousseau",
    "category": "war",
    "id": 71923,
    "text": "Virtue is a state of war, and to live in it we have always to combat with ourselves."
  },
  {
    "author": "William Tecumseh Sherman",
    "category": "war",
    "id": 71774,
    "text": "I am tired and sick of war. Its glory is all moonshine. It is only those who have neither fired a shot nor heard the shrieks and groans of the wounded who cry aloud for blood, for vengeance, for desolation. War is hell."
  },
  {
    "author": "Bianca Jagger",
    "category": "war",
    "id": 72415,
    "text": "Look at what President Kennedy managed to achieve during the Cuban missile crisis. If Bush had been president in 1962, do you think he would have avoided a nuclear war?"
  },
  {
    "author": "David Cameron",
    "category": "war",
    "id": 72095,
    "text": "What Churchill described as the twin marauders of war and tyranny have been almost entirely banished from our continent. Today, hundreds of millions dwell in freedom, from the Baltic to the Adriatic, from the Western Approaches to the Aegean."
  },
  {
    "author": "Thomas A. Edison",
    "category": "war",
    "id": 71548,
    "text": "There will one day spring from the brain of science a machine or force so fearful in its potentialities, so absolutely terrifying, that even man, the fighter, who will dare torture and death in order to inflict torture and death, will be appalled, and so abandon war forever."
  },
  {
    "author": "Rupert Everett",
    "category": "war",
    "id": 72485,
    "text": "You cannot be politically correct in a war."
  },
  {
    "author": "Leo Tolstoy",
    "category": "war",
    "id": 71798,
    "text": "War is so unjust and ugly that all who wage it must try to stifle the voice of conscience within themselves."
  },
  {
    "author": "Eric Liu",
    "category": "war",
    "id": 72430,
    "text": "My grandfather was a general in the Nationalist Chinese Air Force during World War II, and I grew up hearing the pilot stories and seeing pictures of him in uniform."
  },
  {
    "author": "Sun Tzu",
    "category": "war",
    "id": 71717,
    "text": "Thus, what is of supreme importance in war is to attack the enemy's strategy."
  },
  {
    "author": "Michelle Obama",
    "category": "war",
    "id": 71935,
    "text": "See, that's why Barack's running: to end the war in Iraq responsibly - to build an economy that lifts every family, to make sure health care is available for every American - and to make sure that every child in this nation has a world-class education all the way from preschool to college."
  },
  {
    "author": "John Boehner",
    "category": "war",
    "id": 72399,
    "text": "No, let's make sure that people understand that this is a very important war that is helping to protect us here at home. And that we have no choice but to win it. As difficult as it is."
  },
  {
    "author": "Virginia Woolf",
    "category": "war",
    "id": 71881,
    "text": "We can best help you to prevent war not by repeating your words and following your methods but by finding new words and creating new methods."
  },
  {
    "author": "Franklin D. Roosevelt",
    "category": "war",
    "id": 71552,
    "text": "Yesterday, December seventh, 1941, a date which will live in infamy, the United States of America was suddenly and deliberately attacked by naval and air forces of the Empire of Japan."
  },
  {
    "author": "Winston Churchill",
    "category": "war",
    "id": 71629,
    "text": "In war, you can only be killed once, but in politics, many times."
  },
  {
    "author": "Pope Benedict XVI",
    "category": "war",
    "id": 71884,
    "text": "Not all moral issues have the same moral weight as abortion and euthanasia. There may be legitimate diversity of opinion even among Catholics about waging war and applying the death penalty, but not... with regard to abortion and euthanasia."
  },
  {
    "author": "Maya Lin",
    "category": "war",
    "id": 72226,
    "text": "When I was building the Vietnam Memorial, I never once asked the veterans what it was like in the war, because from my point of view, you don't pry into other people's business."
  },
  {
    "author": "Paul Wolfowitz",
    "category": "war",
    "id": 72477,
    "text": "That sense of what happened in Europe in World War II has shaped a lot of my views."
  },
  {
    "author": "Pope John Paul II",
    "category": "war",
    "id": 71572,
    "text": "War is a defeat for humanity."
  },
  {
    "author": "Gene Tierney",
    "category": "war",
    "id": 72274,
    "text": "I remember the 1940s as a time when we were united in a way known only to that generation. We belonged to a common cause-the war."
  },
  {
    "author": "Peggy Noonan",
    "category": "war",
    "id": 72162,
    "text": "The battle for the mind of Ronald Reagan was like the trench warfare of World War I: never have so many fought so hard for such barren terrain."
  },
  {
    "author": "Edward Abbey",
    "category": "war",
    "id": 71856,
    "text": "The tragedy of modern war is that the young men die fighting each other - instead of their real enemies back home in the capitals."
  },
  {
    "author": "George McGovern",
    "category": "war",
    "id": 72126,
    "text": "When I was a youngster growing up in South Dakota, we never referred to the national debt, it was always referred to as the war debt because it stemmed from World War I."
  },
  {
    "author": "Carly Simon",
    "category": "war",
    "id": 71756,
    "text": "A really strong woman accepts the war she went through and is ennobled by her scars."
  },
  {
    "author": "will.i.am",
    "category": "war",
    "id": 72277,
    "text": "We have no control over the outcome of anything. Like the planet and global warming, we don't control that. If politicians want a war we don't control that. Acts of terrorism, we can't control them."
  },
  {
    "author": "George McGovern",
    "category": "war",
    "id": 72182,
    "text": "When I was in the war, I was lucky that I was in a plane and never saw the carnage close-up."
  },
  {
    "author": "Will Durant",
    "category": "war",
    "id": 71880,
    "text": "There have been only 268 of the past 3,421 years free of war."
  },
  {
    "author": "Karl Von Clausewitz",
    "category": "war",
    "id": 72285,
    "text": "War is not an exercise of the will directed at an inanimate matter."
  },
  {
    "author": "Germaine Greer",
    "category": "war",
    "id": 72499,
    "text": "The real theater of the sex war is the domestic hearth."
  },
  {
    "author": "John Bolton",
    "category": "war",
    "id": 72426,
    "text": "I think the International Criminal Court could be a threat to American security interests, because the prosecutor of the court has enormous discretion in going after war crimes. And the way the Statute of Rome is written, responsibility for war crimes can be taken all the way up the chain of command."
  },
  {
    "author": "Julius Caesar",
    "category": "war",
    "id": 71879,
    "text": "In war, events of importance are the result of trivial causes."
  },
  {
    "author": "Thomas Sowell",
    "category": "war",
    "id": 71810,
    "text": "Brainy folks were also present in Lyndon Johnson's administration, especially in the Pentagon, where Secretary of Defense Robert McNamara's brilliant 'whiz kids' tried to micro-manage the Vietnam war, with disastrous results."
  },
  {
    "author": "Umberto Eco",
    "category": "war",
    "id": 71996,
    "text": "A book is a fragile creature, it suffers the wear of time, it fears rodents, the elements and clumsy hands. so the librarian protects the books not only against mankind but also against nature and devotes his life to this war with the forces of oblivion."
  },
  {
    "author": "Abu Abbas",
    "category": "war",
    "id": 72258,
    "text": "We never had planned to hijack a ship. We never thought of any war plans outside the Palestinian lands. We wished that the program had not failed and then the warriors could have achieved their goals."
  },
  {
    "author": "Craig Ferguson",
    "category": "war",
    "id": 72380,
    "text": "I think I'm just someone that just tries to get by. I'm kind of - if it was during the Second World War, I'd be a black marketeer, I think."
  },
  {
    "author": "Ron Paul",
    "category": "war",
    "id": 71736,
    "text": "In time it will become clear to everyone that support for the policies of pre-emptive war and interventionist nation-building will have much greater significance than the removal of Saddam Hussein itself."
  },
  {
    "author": "Karl Von Clausewitz",
    "category": "war",
    "id": 72138,
    "text": "Many intelligence reports in war are contradictory even more are false, and most are uncertain."
  },
  {
    "author": "George W. Bush",
    "category": "war",
    "id": 71930,
    "text": "With those attacks, the terrorists and their supporters declared war on the United States. And war is what they got."
  },
  {
    "author": "Herbert Hoover",
    "category": "war",
    "id": 71838,
    "text": "When we are sick, we want an uncommon doctor when we have a construction job to do, we want an uncommon engineer, and when we are at war, we want an uncommon general. It is only when we get into politics that we are satisfied with the common man."
  },
  {
    "author": "Bianca Jagger",
    "category": "war",
    "id": 72513,
    "text": "I have always been willing to admit when I made a mistake. I made a mistake in my understanding of the composition of the Contras, not on my opposition to the Contra war."
  },
  {
    "author": "Stanislaw Lec",
    "category": "war",
    "id": 72470,
    "text": "In a war of ideas it is people who get killed."
  },
  {
    "author": "Sophia Loren",
    "category": "war",
    "id": 72015,
    "text": "The facts of life are that a child who has seen war cannot be compared with a child who doesn't know what war is except from television."
  },
  {
    "author": "Daryn Kagan",
    "category": "war",
    "id": 72141,
    "text": "Bad things do happen in the world, like war, natural disasters, disease. But out of those situations always arise stories of ordinary people doing extraordinary things."
  },
  {
    "author": "Winston Churchill",
    "category": "war",
    "id": 71635,
    "text": "War is mainly a catalogue of blunders."
  },
  {
    "author": "Michael Haneke",
    "category": "war",
    "id": 72482,
    "text": "And if there was one title that could be applied to all my films, it would be 'Civil War' - not civil war in the way we know it, but the daily war that goes on between us all."
  },
  {
    "author": "Louis Farrakhan",
    "category": "war",
    "id": 72326,
    "text": "What President Bush did in his doctrine of preemptive strike and in his war in Afghanistan and in Iraq was to turn even his allies in Europe negatively toward America."
  },
  {
    "author": "Lewis Thomas",
    "category": "war",
    "id": 72220,
    "text": "Ants are so much like human beings as to be an embarrassment. They farm fungi, raise aphids as livestock, launch armies into war, use chemical sprays to alarm and confuse enemies, capture slaves, engage in child labour, exchange information ceaselessly. They do everything but watch television."
  },
  {
    "author": "Mick Jagger",
    "category": "war",
    "id": 72000,
    "text": "Patriotism is an instant reaction that fades away when the war starts."
  },
  {
    "author": "Karl Von Clausewitz",
    "category": "war",
    "id": 71855,
    "text": "To secure peace is to prepare for war."
  },
  {
    "author": "Lester B. Pearson",
    "category": "war",
    "id": 71595,
    "text": "It has too often been too easy for rulers and governments to incite man to war."
  },
  {
    "author": "Walter Mosley",
    "category": "war",
    "id": 72325,
    "text": "I took up writing to escape the drudgery of that every day cubicle kind of war."
  },
  {
    "author": "Shimon Peres",
    "category": "war",
    "id": 72252,
    "text": "Israel was born under the British mandate. We learned from the British what democracy means, and how it behaves in a time of danger, war and terror. We thank Britain for introducing freedom and respect of human rights both in normal and demanding circumstances."
  },
  {
    "author": "Alexis de Tocqueville",
    "category": "war",
    "id": 71827,
    "text": "No protracted war can fail to endanger the freedom of a democratic country."
  },
  {
    "author": "Richard M. Nixon",
    "category": "war",
    "id": 71854,
    "text": "The Cold War isn't thawing it is burning with a deadly heat. Communism isn't sleeping it is, as always, plotting, scheming, working, fighting."
  },
  {
    "author": "Kevin Costner",
    "category": "war",
    "id": 72304,
    "text": "I don't feel the need to direct. I tried to get other people to direct Dances, but they wouldn't do it. They all thought it was too long. One director wanted to cut the Civil War sequence. Another thought the white woman was very cliched."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "war",
    "id": 71668,
    "text": "War has always been the grand sagacity of every spirit which has grown too inward and too profound its curative power lies even in the wounds one receives."
  },
  {
    "author": "Thomas Frank",
    "category": "war",
    "id": 72155,
    "text": "As you may recall, Truman was extremely unpopular when he finally left Washington in 1953, thanks largely to the Korean War. Today, however, he is thought to have been a solidly good president, a 'Near Great' even, in the terminology of those surveys of historians they do every now and then."
  },
  {
    "author": "James Lovelock",
    "category": "war",
    "id": 72246,
    "text": "If it hadn't been for the Cold War, neither Russia nor America would have been sending people into space."
  },
  {
    "author": "B. H. Liddell Hart",
    "category": "war",
    "id": 72256,
    "text": "Loss of hope rather than loss of life is what decides the issues of war. But helplessness induces hopelessness."
  },
  {
    "author": "Larry Elder",
    "category": "war",
    "id": 71857,
    "text": "The war on drugs is wrong, both tactically and morally. It assumes that people are too stupid, too reckless, and too irresponsible to decide whether and under what conditions to consume drugs. The war on drugs is morally bankrupt."
  },
  {
    "author": "Herman Kahn",
    "category": "war",
    "id": 72405,
    "text": "World War I broke out largely because of an arms race, and World War II because of the lack of an arms race."
  },
  {
    "author": "Isaac Asimov",
    "category": "war",
    "id": 71831,
    "text": "It is not only the living who are killed in war."
  },
  {
    "author": "Benito Mussolini",
    "category": "war",
    "id": 72093,
    "text": "War alone brings up to their highest tension all human energies and imposes the stamp of nobility upon the peoples who have the courage to make it."
  },
  {
    "author": "Heraclitus",
    "category": "war",
    "id": 71927,
    "text": "God is day and night, winter and summer, war and peace, surfeit and hunger."
  },
  {
    "author": "Mira Nair",
    "category": "war",
    "id": 72371,
    "text": "With Vietnam, the Iraq War, so many American films about war are almost always from the American point of view. You almost never have a Middle Eastern character by name with a story."
  },
  {
    "author": "Ambrose Bierce",
    "category": "war",
    "id": 71645,
    "text": "War is God's way of teaching Americans geography."
  },
  {
    "author": "George W. Bush",
    "category": "war",
    "id": 71863,
    "text": "The deliberate and deadly attacks which were carried out yesterday against our country were more than acts of terror. They were acts of war."
  },
  {
    "author": "Peter Yarrow",
    "category": "war",
    "id": 72231,
    "text": "We can only move to a long-term resolution regarding terrorism and war by planting seeds of peace. We have to start with ourselves."
  },
  {
    "author": "Vladimir Nabokov",
    "category": "war",
    "id": 72150,
    "text": "It is hard, I submit, to loathe bloodshed, including war, more than I do, but it is still harder to exceed my loathing of the very nature of totalitarian states in which massacre is only an administrative detail."
  },
  {
    "author": "Michelle Malkin",
    "category": "war",
    "id": 72206,
    "text": "9/11 was a deliberate, carefully planned evil act of the long-waged war on the West by Koran-inspired soldiers of Allah around the world. They hated us before George W. Bush was in office. They hated us before Israel existed. And the avengers of the religion of perpetual outrage will keep hating us."
  },
  {
    "author": "Richard M. Nixon",
    "category": "war",
    "id": 71889,
    "text": "No event in American history is more misunderstood than the Vietnam War. It was misreported then, and it is misremembered now."
  },
  {
    "author": "Winston Churchill",
    "category": "war",
    "id": 71527,
    "text": "We shall defend our island, whatever the cost may be, we shall fight on the beaches, we shall fight on the landing grounds, we shall fight in the fields and in the streets, we shall fight in the hills we shall never surrender."
  },
  {
    "author": "Maya Lin",
    "category": "war",
    "id": 72314,
    "text": "I deliberately did not read anything about the Vietnam War because I felt the politics of the war eclipsed what happened to the veterans. The politics were irrelevant to what this memorial was."
  },
  {
    "author": "George McGovern",
    "category": "war",
    "id": 72125,
    "text": "The truth is that I oppose the Iraq war, just as I opposed the Vietnam War, because these two conflicts have weakened the U.S. and diminished our standing in the world and our national security."
  },
  {
    "author": "Joan Rivers",
    "category": "war",
    "id": 71968,
    "text": "She doesn't understand the concept of Roman numerals. She thought we just fought in world war eleven."
  },
  {
    "author": "Buffalo Bill",
    "category": "war",
    "id": 72227,
    "text": "My mother's sympathies were strongly with the Union. She knew that war was bound to come, but so confident was she in the strength of the Federal Government that she devoutly believed that the struggle could not last longer than six months at the utmost."
  },
  {
    "author": "Gilbert K. Chesterton",
    "category": "war",
    "id": 71802,
    "text": "The only defensible war is a war of defense."
  },
  {
    "author": "Harold Pinter",
    "category": "war",
    "id": 72330,
    "text": "I think that NATO is itself a war criminal."
  },
  {
    "author": "George Washington",
    "category": "war",
    "id": 71674,
    "text": "My first wish is to see this plague of mankind, war, banished from the earth."
  },
  {
    "author": "Michael Morpurgo",
    "category": "war",
    "id": 72259,
    "text": "War continues to divide people, to change them forever, and I write about it both because I want people to understand the absolute futility of war, the 'pity of war' as Wilfred Owen called it."
  },
  {
    "author": "Arthur Henderson",
    "category": "war",
    "id": 72452,
    "text": "The more the history of the World War and what led up to it is studied, the more clearly those tragic years become revealed as a vast collapse of civilization."
  }
]

quotes['wedding'] = [
  {
    "author": "Rob Bell",
    "category": "wedding",
    "id": 72661,
    "text": "As a pastor, you get invited into the most poignant moments of people's lives. Whether it's a wedding or a funeral or a hospital visit, you get invited into the center of the event, whether or not you know the people."
  },
  {
    "author": "Heinrich Heine",
    "category": "wedding",
    "id": 72557,
    "text": "The Wedding March always reminds me of the music played when soldiers go into battle."
  },
  {
    "author": "Ron Ben-Israel",
    "category": "wedding",
    "id": 72672,
    "text": "I have a crusade against fondant, also shortening. There's no reason why wedding cakes can't taste good if you know what you're doing."
  },
  {
    "author": "Anne Morrow Lindbergh",
    "category": "wedding",
    "id": 72544,
    "text": "When the wedding march sounds the resolute approach, the clock no longer ticks, it tolls the hour. The figures in the aisle are no longer individuals, they symbolize the human race."
  },
  {
    "author": "Sarah Ferguson",
    "category": "wedding",
    "id": 72688,
    "text": "When Andrew went with the girls, we were talking all morning and he was saying, 'It's okay. Just remember we had such a good day. Our wedding was so perfect.' Because we're such a unit together. He made me feel very part of the day on April the 29th."
  },
  {
    "author": "Mary Oliver",
    "category": "wedding",
    "id": 72552,
    "text": "When it's over, I want to say: all my life I was a bride married to amazement. I was the bridegroom, taking the world into my arms."
  },
  {
    "author": "David Hyde Pierce",
    "category": "wedding",
    "id": 72668,
    "text": "We all went to Kelsey's wedding, and yeah, we go to parties. We also go to each other's house. A group of us got together over at Kelsey's and just read through some plays just for the fun of it. That may not be everyone's idea of a good time, but we had a good time."
  },
  {
    "author": "Johnny Vegas",
    "category": "wedding",
    "id": 72600,
    "text": "I think if you're at the point where you're popular enough to sell your wedding photos to OK! Magazine then you don't need the money."
  },
  {
    "author": "Enid Bagnold",
    "category": "wedding",
    "id": 72587,
    "text": "In marriage there are no manners to keep up, and beneath the wildest accusations no real criticism. Each is familiar with that ancient child in the other who may erupt again. We are not ridiculous to ourselves. We are ageless. That is the luxury of the wedding ring."
  },
  {
    "author": "Busy Philipps",
    "category": "wedding",
    "id": 72647,
    "text": "I'm a jewelry girl. I became with friends with designer Irene Neuwirth a few years ago. At that point, I just used to wear my wedding rings. Very low key. Now, if I could, I'd be draped from head to toe in her jewelry all the time. Everything she makes is beautiful."
  },
  {
    "author": "Monique Lhuillier",
    "category": "wedding",
    "id": 72660,
    "text": "I went looking for dresses and realized there was a niche I could fill in the wedding dress market."
  },
  {
    "author": "Katy Perry",
    "category": "wedding",
    "id": 72550,
    "text": "The press is just not your friend when it comes to a marriage. That's why we didn't sell the pictures of our wedding, and we got offered millions of dollars for them, millions."
  },
  {
    "author": "Jon Secada",
    "category": "wedding",
    "id": 72662,
    "text": "It happened in Miami, in Coral Gables, a great big ol' Cuban wedding. It was pretty intense."
  },
  {
    "author": "Sherri Shepherd",
    "category": "wedding",
    "id": 72623,
    "text": "When I planned my wedding the first time, my ex-husband and I, we were both struggling comics. I had a TV show that had gotten cancelled. Basically, I rented a wedding gown the reception hall smelled like feet."
  },
  {
    "author": "David Miliband",
    "category": "wedding",
    "id": 72630,
    "text": "The wedding ring on my left hand was bought by my grandfather, Samuel Miliband, in Brussels in 1920. I never knew him, as he died when I was one. But his ring was kept by my aunt until it was placed on my finger by my wife Louise 32 years later."
  },
  {
    "author": "Carol Ann Duffy",
    "category": "wedding",
    "id": 72655,
    "text": "If I felt, in the event of a royal wedding, inspired to write about people coming together in marriage or civil partnership, I would just be grateful to have an idea for the poem. And if I didn't, I'd ignore it."
  },
  {
    "author": "Sammy Davis, Jr.",
    "category": "wedding",
    "id": 72605,
    "text": "I hadn't been in Vegas 20 minutes when I got word that the bookmakers were offering three to one that Frank wouldn't show for my wedding."
  },
  {
    "author": "John Mayer",
    "category": "wedding",
    "id": 72598,
    "text": "A man's got two shots for jewelry: a wedding ring and a watch. The watch is a lot easier to get on and off than a wedding ring."
  },
  {
    "author": "Anthony Holden",
    "category": "wedding",
    "id": 72649,
    "text": "Well the wedding in the words of the Archbishop of Canterbury was a fairy tale and there was a huge public impress, investment of goodwill, affection and indeed money in this Institution. It was a huge success at the time."
  },
  {
    "author": "Jane Seymour",
    "category": "wedding",
    "id": 72619,
    "text": "I think a lot of people get so obsessed with the wedding and the expense of the wedding that they miss out on what the real purpose is. It's not about a production number, it's about a meaningful moment between two people that's witnessed by people that they actually really know and care about."
  },
  {
    "author": "Jennifer Aniston",
    "category": "wedding",
    "id": 72591,
    "text": "One tradition I have with my friends is that when one of us gets married, we have a ton of fragrance oils and pretty bottles at the bachelorette party. Everyone puts a drop or two in a bottle for the bride and makes a wish, and the bride wears our creation on her wedding day."
  },
  {
    "author": "Natasha Hamilton",
    "category": "wedding",
    "id": 72699,
    "text": "I'm taking one thing at a time. With the children and launching my solo career it would drive me to a nervous breakdown if I tried to organise a wedding on top of that."
  },
  {
    "author": "Lily Aldridge",
    "category": "wedding",
    "id": 72690,
    "text": "It's important to still look like yourself on your wedding day, so I didn't do anything drastic."
  },
  {
    "author": "Max Greenfield",
    "category": "wedding",
    "id": 72676,
    "text": "For a girl, the wedding is when you're married. For a guy, it's when you get engaged. It takes a real aggressive human being to back out between the ring and the wedding."
  },
  {
    "author": "Vera Wang",
    "category": "wedding",
    "id": 72555,
    "text": "When I decided to get married at 40, I couldn't find a dress with the modernity or sophistication I wanted. That's when I saw the opportunity for a wedding gown business."
  },
  {
    "author": "Trisha Goddard",
    "category": "wedding",
    "id": 72560,
    "text": "It was only literally hours after the wedding when he felt he didn't have to keep up the facade."
  },
  {
    "author": "Bryan White",
    "category": "wedding",
    "id": 72663,
    "text": "One time when somebody showed up in a wedding dress, but I never knew if it was a joke, or she was serious. She asked me to marry her. She was serious. It was pretty funny."
  },
  {
    "author": "Debra Messing",
    "category": "wedding",
    "id": 72650,
    "text": "I don't think it's possible to have a wedding without it being stressful!"
  },
  {
    "author": "Kevin McDonald",
    "category": "wedding",
    "id": 72679,
    "text": "Well... Actually I got picked because I was the only one who fit the wedding gown - they had my size."
  },
  {
    "author": "Jim Lampley",
    "category": "wedding",
    "id": 72689,
    "text": "I wear my wedding ring. We talk about when we're going to get married again, which we hope is going to take place some time in this incredibly hectic calendar year."
  },
  {
    "author": "Selma Blair",
    "category": "wedding",
    "id": 72563,
    "text": "A wedding is such a girl thing."
  },
  {
    "author": "Marguerite Young",
    "category": "wedding",
    "id": 72654,
    "text": "A lawyer I once knew told me of a strange case, a suffragette who had never married. After her death, he opened her trunk and discovered 50 wedding gowns."
  },
  {
    "author": "Janet Street-Porter",
    "category": "wedding",
    "id": 72696,
    "text": "The day of the wedding went like these things generally do, full of anxious moments interspersed with black comedy."
  },
  {
    "author": "Craig Ferguson",
    "category": "wedding",
    "id": 72617,
    "text": "The wedding took place in Vermont, where they have legalized gay civil unions, and I married a woman."
  },
  {
    "author": "Nick Cave",
    "category": "wedding",
    "id": 72554,
    "text": "Getting married, for me, was the best thing I ever did. I was suddenly beset with an immense sense of release, that we have something more important than our separate selves, and that is the marriage. There's immense happiness that can come from working towards that."
  },
  {
    "author": "Sherri Shepherd",
    "category": "wedding",
    "id": 72624,
    "text": "For my first wedding, I cried all the way down the aisle. My fake eyelash came off. My nose was red. My eyes were swollen. I'm not one of those pretty criers."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "wedding",
    "id": 72604,
    "text": "I myself have never been enchanted by the dream of the white wedding, and, heaven help us, the expectation that this exquisitely catered event should be 'the happiest moment' of one's life."
  },
  {
    "author": "Erma Bombeck",
    "category": "wedding",
    "id": 72583,
    "text": "For years my wedding ring has done its job. It has led me not into temptation. It has reminded my husband numerous times at parties that it's time to go home. It has been a source of relief to a dinner companion. It has been a status symbol in the maternity ward."
  },
  {
    "author": "Karl Pilkington",
    "category": "wedding",
    "id": 72570,
    "text": "And we've got a toaster and everything. So there is no reason for the wedding."
  },
  {
    "author": "Jared Leto",
    "category": "wedding",
    "id": 72616,
    "text": "I only did karaoke once in my life. It was with Courtney Love and it was a total disaster. She pulled me on stage in front of 500 people at a wedding. I'd never done karaoke before."
  },
  {
    "author": "Cindy Margolis",
    "category": "wedding",
    "id": 72565,
    "text": "I really did put up all my wedding pictures on my website. And I swear to you, my wedding pictures got downloaded just as much as my bikini pictures."
  },
  {
    "author": "Phyllis Diller",
    "category": "wedding",
    "id": 72532,
    "text": "Our dog died from licking our wedding picture."
  },
  {
    "author": "Ellie Kemper",
    "category": "wedding",
    "id": 72684,
    "text": "If you're going to plan a wedding, then a certain amount of suffering is not a choice."
  },
  {
    "author": "Jerry O'Connell",
    "category": "wedding",
    "id": 72678,
    "text": "I like wearing my wedding ring, it's nice."
  },
  {
    "author": "Ellie Goulding",
    "category": "wedding",
    "id": 72608,
    "text": "I met Prince William at a musical festival and he let me know he was a fan of my music. But the invitation to sing at his wedding reception came completely out of the blue. The fact that Kate and William knew the words to my songs was very touching."
  },
  {
    "author": "Claire Forlani",
    "category": "wedding",
    "id": 72572,
    "text": "There's a higher form of happiness in commitment. I'm counting on it."
  },
  {
    "author": "Juan Marichal",
    "category": "wedding",
    "id": 72692,
    "text": "We are all so close. We are godfather to each others' kids. I was the best man at Jesus' wedding."
  },
  {
    "author": "Mario Batali",
    "category": "wedding",
    "id": 72615,
    "text": "All the information you could want is constantly streaming at you like a runaway truck - books, newspaper stories, Web sites, apps, how-to videos, this article you're reading, even entire magazines devoted to single subjects like charcuterie or wedding cakes or pickles."
  },
  {
    "author": "Sinead O'Connor",
    "category": "wedding",
    "id": 72646,
    "text": "I've been married before, but I've never had my dream wedding in Vegas. I wanted to do it there because it's casual, quick, not religious and, most of all, very romantic."
  },
  {
    "author": "January Jones",
    "category": "wedding",
    "id": 72683,
    "text": "I feel as though my career really hit its high point when I was cast as a supporting actress in 'American Wedding'. I thought the script had a lot of depth and intelligence, and it really just jumped off the page."
  },
  {
    "author": "Helen Reddy",
    "category": "wedding",
    "id": 72559,
    "text": "In the '50s, a lot of girls never saw beyond the wedding day."
  },
  {
    "author": "Anthony LaPaglia",
    "category": "wedding",
    "id": 72691,
    "text": "A lot of people think I'm that guy in 'Betsy's Wedding', but I'm not. What it is for me is that, on some level, I connect with the character emotionally."
  },
  {
    "author": "Robert Frost",
    "category": "wedding",
    "id": 72525,
    "text": "It's a funny thing that when a man hasn't anything on earth to worry about, he goes off and gets married."
  },
  {
    "author": "Dorothy Malone",
    "category": "wedding",
    "id": 72686,
    "text": "I was a bridesmaid at a wedding in one picture."
  },
  {
    "author": "Idina Menzel",
    "category": "wedding",
    "id": 72648,
    "text": "I'd been a wedding singer through college, but after a few years of doing my best renditions of jazz standards to clinking glasses and the sound of forks on salad, I thought, 'Oh God, if this is all I do, I'll never be able to live with myself.'"
  },
  {
    "author": "Guy Madison",
    "category": "wedding",
    "id": 72701,
    "text": "Those are the men who will dance at your wedding."
  },
  {
    "author": "Star Jones",
    "category": "wedding",
    "id": 72571,
    "text": "I want the big drama. I always said I don't want a wedding I want a parade."
  },
  {
    "author": "Don DeLillo",
    "category": "wedding",
    "id": 72635,
    "text": "I saw a photograph of a wedding conducted by Reverend Moon of the Unification Church. I wanted to understand this event, and the only way to understand it was to write about it."
  },
  {
    "author": "Christopher Walken",
    "category": "wedding",
    "id": 72606,
    "text": "I've never crashed a wedding. When I was a kid I, of course, used to crash parties. Crashing a wedding is difficult though because you have to have the suit, and you have to have information in case someone catches you. You have to know at least some names and something."
  },
  {
    "author": "Lara Stone",
    "category": "wedding",
    "id": 72657,
    "text": "When planning your wedding you make so many decisions: 'Do I want this fork or that fork?' But in the end people aren't going to remember what napkin holder you choose."
  },
  {
    "author": "Jane Seymour",
    "category": "wedding",
    "id": 72622,
    "text": "When I auditioned for 'Wedding Crashers,' the producers had never seen any of my other work except for Bond. I got 'Wedding Crashers' partly because I was a Bond girl."
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "wedding",
    "id": 72527,
    "text": "Love is the master key that opens the gates of happiness."
  },
  {
    "author": "Jennifer Hudson",
    "category": "wedding",
    "id": 72628,
    "text": "I hope that when I'm 80 years old, people will still be talking about my wedding."
  },
  {
    "author": "John Heywood",
    "category": "wedding",
    "id": 72613,
    "text": "Wedding is destiny, and hanging likewise."
  },
  {
    "author": "Denise Van Outen",
    "category": "wedding",
    "id": 72667,
    "text": "After I had the Caesarean, I was told I had really strong stomach muscles and so would heal very quickly. And I did. I was up walking about within three hours. Six days after having her, I was out shopping and shortly after that I made it to David Walliams' wedding."
  },
  {
    "author": "Rachel McAdams",
    "category": "wedding",
    "id": 72611,
    "text": "I use filming as an excuse to take classes. I got my certification in sailing for 'Wedding Crashers,' and now I can handle a 26-foot boat. I played a seamstress once, so I took sewing classes. I love dipping into these other lives."
  },
  {
    "author": "Sienna Miller",
    "category": "wedding",
    "id": 72595,
    "text": "I want a big church wedding."
  },
  {
    "author": "Bradley Cooper",
    "category": "wedding",
    "id": 72641,
    "text": "I just wrapped this movie called The Wedding Crashers which was a pretty big break for me."
  },
  {
    "author": "Vera Wang",
    "category": "wedding",
    "id": 72603,
    "text": "I love a black wedding dress."
  },
  {
    "author": "Steven Patrick Morrissey",
    "category": "wedding",
    "id": 72609,
    "text": "I hated the royal wedding."
  },
  {
    "author": "Gwyneth Paltrow",
    "category": "wedding",
    "id": 72607,
    "text": "I try to remember, as I hear about friends getting engaged, that it's not about the ring and it's not about the wedding. It's a grave thing, getting married. And it's easy to get swept up in the wrong things."
  },
  {
    "author": "Sonya Walger",
    "category": "wedding",
    "id": 72693,
    "text": "I felt very unstressed on my wedding day. I'm very grateful for that... spending the day on my own, being super quiet and happy and just puttering around doing my own thing."
  },
  {
    "author": "Shirley Bassey",
    "category": "wedding",
    "id": 72581,
    "text": "No wedding bells for me anymore. I've been happily married to my profession for years."
  },
  {
    "author": "Nicole Appleton",
    "category": "wedding",
    "id": 72673,
    "text": "I'll get pretty much everything the way I want it. I've always dreamed of a beach wedding."
  },
  {
    "author": "King Edward VIII",
    "category": "wedding",
    "id": 72582,
    "text": "Of course, I do have a slight advantage over the rest of you. It helps in a pinch to be able to remind your bride that you gave up a throne for her."
  },
  {
    "author": "Nia Vardalos",
    "category": "wedding",
    "id": 72636,
    "text": "On the publicity tour of 'My Big Fat Greek Wedding,' I was asked over and over again, if, as the writer, I felt it was a fair depiction of real life to have someone of my er, below average looks, hook up with hottie John Corbett."
  },
  {
    "author": "Julia Roberts",
    "category": "wedding",
    "id": 72593,
    "text": "I did get to keep the wedding dresses from 'Runaway Bride'. They're all boxed up in my garage. I've never opened them. It'll be fun one day when Hazel is taller. She can play dress-up with her friends."
  },
  {
    "author": "Helen Rowland",
    "category": "wedding",
    "id": 72535,
    "text": "A bride at her second marriage does not wear a veil. She wants to see what she is getting."
  },
  {
    "author": "Paul Sweeney",
    "category": "wedding",
    "id": 72585,
    "text": "A wedding anniversary is the celebration of love, trust, partnership, tolerance and tenacity. The order varies for any given year."
  },
  {
    "author": "Ron Ben-Israel",
    "category": "wedding",
    "id": 72651,
    "text": "I don't follow trends. I make each cake for a particular wedding, or event."
  },
  {
    "author": "Honore de Balzac",
    "category": "wedding",
    "id": 72529,
    "text": "A young bride is like a plucked flower but a guilty wife is like a flower that had been walked over."
  },
  {
    "author": "DJ Jazzy Jeff",
    "category": "wedding",
    "id": 72698,
    "text": "You have to make your wedding day all about you."
  },
  {
    "author": "Ellie Kemper",
    "category": "wedding",
    "id": 72685,
    "text": "Growing up, I had one very specific idea of what a wedding should be, and that was the wedding of Fraulein Maria and Captain von Trapp in 'The Sound of Music.'"
  },
  {
    "author": "Vera Wang",
    "category": "wedding",
    "id": 72548,
    "text": "When I design a wedding dress with a bustle, it has to be one the bride can dance in. I love the idea that something is practical and still looks great."
  },
  {
    "author": "James Thurber",
    "category": "wedding",
    "id": 72592,
    "text": "The most dangerous food is wedding cake."
  },
  {
    "author": "Mike Epps",
    "category": "wedding",
    "id": 72561,
    "text": "I don't know nothing about no marriages or nothing. I ain't even never been to a wedding."
  },
  {
    "author": "Petra Nemcova",
    "category": "wedding",
    "id": 72681,
    "text": "I used to work all the time, and now if there is a wedding, there's a concert, I'm there."
  },
  {
    "author": "James M. Barrie",
    "category": "wedding",
    "id": 72540,
    "text": "That is ever the way. 'Tis all jealousy to the bride and good wishes to the corpse."
  },
  {
    "author": "Paul McCartney",
    "category": "wedding",
    "id": 72590,
    "text": "We were pretty good mates until the Beatles started to split up and Yoko came into it. It was more like old army buddies splitting up on account of wedding bells."
  },
  {
    "author": "Piper Laurie",
    "category": "wedding",
    "id": 72578,
    "text": "I'm one of those people who has always been a bridesmaid."
  },
  {
    "author": "Jennifer Garner",
    "category": "wedding",
    "id": 72618,
    "text": "I am usually part of any disaster at a wedding if I'm a bridesmaid, which I've been lucky enough to be several times."
  },
  {
    "author": "Emily Blunt",
    "category": "wedding",
    "id": 72562,
    "text": "Personally, I'm an advocate for short engagements. Long sometimes means there is a reason for it. Two years engaged and no wedding... I'd be upset."
  },
  {
    "author": "Bess Truman",
    "category": "wedding",
    "id": 72580,
    "text": "You may invite the entire 35th Division to your wedding if you want to. I guess it's going to be yours as well as mine. We might as well have the church full while we are at it."
  },
  {
    "author": "Liz Smith",
    "category": "wedding",
    "id": 72576,
    "text": "All weddings, except those with shotguns in evidence, are wonderful."
  },
  {
    "author": "Phyllis Battelle",
    "category": "wedding",
    "id": 72666,
    "text": "For her fifth wedding, the bride wore black and carried a scotch and soda."
  },
  {
    "author": "Vera Wang",
    "category": "wedding",
    "id": 72596,
    "text": "I wanted to define the vocabulary of a wedding both visually and intellectually. The book is about more than weddings or wedding dresses. It's a metaphor for women's lives, their creativity."
  },
  {
    "author": "Kristen Wiig",
    "category": "wedding",
    "id": 72625,
    "text": "A big part of being in a wedding is the financial obligation, and that's something that people don't really talk about, but if you're asked to be in a wedding, you're gonna have to fork over some cash."
  },
  {
    "author": "Georgina Chapman",
    "category": "wedding",
    "id": 72644,
    "text": "My wedding was at home, so I didn't really want to wear a veil in my house. Instead I wore a lot of diamond hair clips. They were brooches, actually, designed by Lorraine Schwartz."
  },
  {
    "author": "Rachel McAdams",
    "category": "wedding",
    "id": 72612,
    "text": "I love auditioning. Since 'The Notebook' and 'Wedding Crashers,' I don't have to audition anymore, and I miss it. You get to show your interpretation of the character. I get nervous when I don't audition. What if they hate what I want to do?"
  },
  {
    "author": "Katherine Jenkins",
    "category": "wedding",
    "id": 72614,
    "text": "I would absolutely, definitely never sell my wedding pictures to a magazine. I'd like it to be a special day, not a photo shoot. And once you've done that, your marriage becomes everybody else's business."
  }
]

quotes['wisdom'] = [
  {
    "author": "Pietro Aretino",
    "category": "wisdom",
    "id": 73112,
    "text": "I keep my friends as misers do their treasure, because, of all the things granted us by wisdom, none is greater or better than friendship."
  },
  {
    "author": "Gwyneth Paltrow",
    "category": "wisdom",
    "id": 73048,
    "text": "I love being. There's so much wisdom in it. You wake up in the morning and you think, Hey, isn't it great just being?"
  },
  {
    "author": "Walter Lippmann",
    "category": "wisdom",
    "id": 72796,
    "text": "It requires wisdom to understand wisdom: the music is nothing if the audience is deaf."
  },
  {
    "author": "Peter Guber",
    "category": "wisdom",
    "id": 73293,
    "text": "Every journey that is successful has culs-de-sac and speed bumps. I carry a wisdom gene through my life through the good, the bad, and the ugly."
  },
  {
    "author": "Thomas J. Watson",
    "category": "wisdom",
    "id": 73001,
    "text": "Wisdom is the power to put our time and our knowledge to the proper use."
  },
  {
    "author": "Marcus Tullius Cicero",
    "category": "wisdom",
    "id": 72960,
    "text": "The function of wisdom is to discriminate between good and evil."
  },
  {
    "author": "Myrtle Reed",
    "category": "wisdom",
    "id": 73176,
    "text": "Silence and reserve will give anyone a reputation for wisdom."
  },
  {
    "author": "Plato",
    "category": "wisdom",
    "id": 72926,
    "text": "Wisdom alone is the science of other sciences."
  },
  {
    "author": "Reinhold Niebuhr",
    "category": "wisdom",
    "id": 72882,
    "text": "God grant me the serenity to accept the things I cannot change, the courage to change the things I can, and the wisdom to know the difference."
  },
  {
    "author": "Phil Jackson",
    "category": "wisdom",
    "id": 72725,
    "text": "Always keep an open mind and a compassionate heart."
  },
  {
    "author": "Orson Pratt",
    "category": "wisdom",
    "id": 73273,
    "text": "If God had sufficient wisdom and power to construct such a beautiful world as this, then we must admit that his wisdom and power are immeasurably greater than that of man, and hence he is qualified to reign as king."
  },
  {
    "author": "George S. Patton",
    "category": "wisdom",
    "id": 72766,
    "text": "Never tell people how to do things. Tell them what to do and they will surprise you with their ingenuity."
  },
  {
    "author": "Jean Paul",
    "category": "wisdom",
    "id": 72809,
    "text": "The more sand that has escaped from the hourglass of our life, the clearer we should see through it."
  },
  {
    "author": "H. L. Mencken",
    "category": "wisdom",
    "id": 72938,
    "text": "Women always excel men in that sort of wisdom which comes from experience. To be a woman is in itself a terrible experience."
  },
  {
    "author": "Josh Billings",
    "category": "wisdom",
    "id": 72822,
    "text": "The wheel that squeaks the loudest is the one that gets the grease."
  },
  {
    "author": "Wilson Mizner",
    "category": "wisdom",
    "id": 73045,
    "text": "To profit from good advice requires more wisdom than to give it."
  },
  {
    "author": "John F. Kennedy",
    "category": "wisdom",
    "id": 72726,
    "text": "When written in Chinese, the word 'crisis' is composed of two characters. One represents danger and the other represents opportunity."
  },
  {
    "author": "Morihei Ueshiba",
    "category": "wisdom",
    "id": 72845,
    "text": "When an opponent comes forward, move in and greet him if he wants to pull back, send him on his way."
  },
  {
    "author": "Erica Jong",
    "category": "wisdom",
    "id": 73142,
    "text": "No one ever found wisdom without also being a fool. Writers, alas, have to be fools in public, while the rest of the human race can cover its tracks."
  },
  {
    "author": "Harold S. Geneen",
    "category": "wisdom",
    "id": 72863,
    "text": "It is much more difficult to measure nonperformance than performance."
  },
  {
    "author": "Edward Young",
    "category": "wisdom",
    "id": 73185,
    "text": "The clouds may drop down titles and estates, and wealth may seek us, but wisdom must be sought."
  },
  {
    "author": "William Blake",
    "category": "wisdom",
    "id": 72979,
    "text": "What is the price of experience? Do men buy it for a song? Or wisdom for a dance in the street? No, it is bought with the price of all the man hath, his house, his wife, his children."
  },
  {
    "author": "Paul Greengrass",
    "category": "wisdom",
    "id": 73367,
    "text": "Remembering is painful, it's difficult, but it can be inspiring and it can give wisdom."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "wisdom",
    "id": 72757,
    "text": "Does wisdom perhaps appear on the earth as a raven which is inspired by the smell of carrion?"
  },
  {
    "author": "Oliver Wendell Holmes",
    "category": "wisdom",
    "id": 73046,
    "text": "It is the province of knowledge to speak, and it is the privilege of wisdom to listen."
  },
  {
    "author": "Louis D. Brandeis",
    "category": "wisdom",
    "id": 73111,
    "text": "In the frank expression of conflicting opinions lies the greatest promise of wisdom in governmental action."
  },
  {
    "author": "Jimmy Carr",
    "category": "wisdom",
    "id": 73291,
    "text": "After a gig I always head back to the hotel, remembering granny's words of wisdom. I cancel the late-night pizza and watch the Jonathan Ross show instead."
  },
  {
    "author": "Lord Byron",
    "category": "wisdom",
    "id": 73016,
    "text": "Though sages may pour out their wisdom's treasure, there is no sterner moralist than pleasure."
  },
  {
    "author": "Benjamin Franklin",
    "category": "wisdom",
    "id": 72900,
    "text": "Those who govern, having much business on their hands, do not generally like to take the trouble of considering and carrying into execution new projects. The best public measures are therefore seldom adopted from previous wisdom, but forced by the occasion."
  },
  {
    "author": "Elizabeth Gilbert",
    "category": "wisdom",
    "id": 73109,
    "text": "I don't think you can come into your wisdom until you have made mistakes on your own skin and felt them in reality of your own life."
  },
  {
    "author": "Thomas Carlyle",
    "category": "wisdom",
    "id": 72958,
    "text": "In the long-run every Government is the exact symbol of its People, with their wisdom and unwisdom we have to say, Like People like Government."
  },
  {
    "author": "Havelock Ellis",
    "category": "wisdom",
    "id": 73104,
    "text": "Men who know themselves are no longer fools. They stand on the threshold of the door of Wisdom."
  },
  {
    "author": "John Barrymore",
    "category": "wisdom",
    "id": 72966,
    "text": "I am thinking of taking a fifth wife. Why not? Solomon had a thousand wives and he is a synonym for wisdom."
  },
  {
    "author": "Mary Astell",
    "category": "wisdom",
    "id": 73226,
    "text": "The Relation we bear to the Wisdom of the Father, the Son of His Love, gives us indeed a dignity which otherwise we have no pretence to. It makes us something, something considerable even in God's Eyes."
  },
  {
    "author": "Confucius",
    "category": "wisdom",
    "id": 72901,
    "text": "They must often change, who would be constant in happiness or wisdom."
  },
  {
    "author": "Igor Stravinsky",
    "category": "wisdom",
    "id": 73170,
    "text": "I have learned throughout my life as a composer chiefly through my mistakes and pursuits of false assumptions, not by my exposure to founts of wisdom and knowledge."
  },
  {
    "author": "Roger Ascham",
    "category": "wisdom",
    "id": 73319,
    "text": "It is costly wisdom that is bought by experience."
  },
  {
    "author": "Norman Douglas",
    "category": "wisdom",
    "id": 73242,
    "text": "What is all wisdom save a collection of platitudes?"
  },
  {
    "author": "Jason Aldean",
    "category": "wisdom",
    "id": 73203,
    "text": "I don't think I really have any wisdom. Stay out of trouble. Good luck. Stay away from women because they will burn you, haha."
  },
  {
    "author": "Tom Hopkins",
    "category": "wisdom",
    "id": 72842,
    "text": "Repeat anything often enough and it will start to become you."
  },
  {
    "author": "Will Durant",
    "category": "wisdom",
    "id": 73056,
    "text": "Science gives us knowledge, but only philosophy can give us wisdom."
  },
  {
    "author": "Sophocles",
    "category": "wisdom",
    "id": 73040,
    "text": "Our happiness depends on wisdom all the way."
  },
  {
    "author": "Josh Brolin",
    "category": "wisdom",
    "id": 73326,
    "text": "I covered my face because they had taken my wisdom teeth out."
  },
  {
    "author": "Khalil Gibran",
    "category": "wisdom",
    "id": 72902,
    "text": "Pain and foolishness lead to great bliss and complete knowledge, for Eternal Wisdom created nothing under the sun in vain."
  },
  {
    "author": "Lao Tzu",
    "category": "wisdom",
    "id": 72732,
    "text": "I have just three things to teach: simplicity, patience, compassion. These three are your greatest treasures."
  },
  {
    "author": "Norman Douglas",
    "category": "wisdom",
    "id": 73243,
    "text": "The sublimity of wisdom is to do those things living, which are to be desired when dying."
  },
  {
    "author": "Bernard De Voto",
    "category": "wisdom",
    "id": 73335,
    "text": "Pessimism is only the name that men of weak nerves give to wisdom."
  },
  {
    "author": "Charles Caleb Colton",
    "category": "wisdom",
    "id": 73057,
    "text": "Moderation is the inseparable companion of wisdom, but with it genius has not even a nodding acquaintance."
  },
  {
    "author": "Charles Inglis",
    "category": "wisdom",
    "id": 73394,
    "text": "To comprehend the Wisdom of this Injunction the better, and explain the Duty before us, it should be considered, that Government is the only Means by which human Happiness can be attained."
  },
  {
    "author": "Janet Jackson",
    "category": "wisdom",
    "id": 73060,
    "text": "In complete darkness we are all the same, it is only our knowledge and wisdom that separates us, don't let your eyes deceive you."
  },
  {
    "author": "Zhuang Zi",
    "category": "wisdom",
    "id": 73117,
    "text": "Great wisdom is generous petty wisdom is contentious. Great speech is impassioned, small speech cantankerous."
  },
  {
    "author": "Phil Jackson",
    "category": "wisdom",
    "id": 72869,
    "text": "Wisdom is always an overmatch for strength."
  },
  {
    "author": "Ray LaMontagne",
    "category": "wisdom",
    "id": 73309,
    "text": "I probably wouldn't be a songwriter if I didn't grow up the way I did. It was difficult and it was at times very scary to grow up in a household so unsettled and at times very violent. But, it also, I guess it earned me a sort of wisdom at a young age that's served me well."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "category": "wisdom",
    "id": 72787,
    "text": "Wisdom is found only in truth."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "wisdom",
    "id": 72907,
    "text": "The sum of wisdom is that time is never lost that is devoted to work."
  },
  {
    "author": "William Gibson",
    "category": "wisdom",
    "id": 72865,
    "text": "The future has already arrived. It's just not evenly distributed yet."
  },
  {
    "author": "John Cheever",
    "category": "wisdom",
    "id": 72880,
    "text": "Wisdom we know is the knowledge of good and evil, not the strength to choose between the two."
  },
  {
    "author": "Joseph Barber Lightfoot",
    "category": "wisdom",
    "id": 73274,
    "text": "This fear of the Lord is indeed the beginning of wisdom. This consciousness of sin is the straight pathway to heaven."
  },
  {
    "author": "Wade Davis",
    "category": "wisdom",
    "id": 73413,
    "text": "What could be more lonely than to be enveloped in silence, to be the last of your people to speak your native tongue, to have no way to pass on the wisdom of the elders, to anticipate the promise of the children. This tragic fate is indeed the plight of someone somewhere roughly every two weeks."
  },
  {
    "author": "George Byron",
    "category": "wisdom",
    "id": 73090,
    "text": "If I am fool, it is, at least, a doubting one and I envy no one the certainty of his self-approved wisdom."
  },
  {
    "author": "Ray Kurzweil",
    "category": "wisdom",
    "id": 73310,
    "text": "Even by common wisdom, there seem to be both people and objects in my dream that are outside myself, but clearly they were created in myself and are part of me, they are mental constructs in my own brain."
  },
  {
    "author": "Brigham Young",
    "category": "wisdom",
    "id": 73213,
    "text": "There is no knowledge, no light, no wisdom that you are in possession of, but what you have received it from some source."
  },
  {
    "author": "Herbert Hoover",
    "category": "wisdom",
    "id": 73138,
    "text": "Wisdom oft times consists of knowing what to do next."
  },
  {
    "author": "Lianne La Havas",
    "category": "wisdom",
    "id": 73385,
    "text": "I love the music of Lauryn Hill and Erykah Badu and more recently the music of Laura Marling. All these women share a strength and a wisdom in their voices and music that really makes me want to make music and sing."
  },
  {
    "author": "Anthony Trollope",
    "category": "wisdom",
    "id": 73183,
    "text": "It may almost be a question whether such wisdom as many of us have in our mature years has not come from the dying out of the power of temptation, rather than as the results of thought and resolution."
  },
  {
    "author": "Alan Paton",
    "category": "wisdom",
    "id": 73091,
    "text": "Who knows for what we live, and struggle, and die? Wise men write many books, in words too hard to understand. But this, the purpose of our lives, the end of all our struggle, is beyond all human wisdom."
  },
  {
    "author": "Brendan Coyle",
    "category": "wisdom",
    "id": 73361,
    "text": "I left school at 16 but I wish I'd gone to university - I think I would have studied English literature. I had a knack for that. But I don't think you have the kind of wisdom at 16 to make that decision."
  },
  {
    "author": "Randy Forbes",
    "category": "wisdom",
    "id": 73412,
    "text": "While many of us never knew Ronald Reagan personally, we felt close to him because we shared his lighthearted sense of humor, admired his uncommon virtue, and were moved by his remarkable wisdom."
  },
  {
    "author": "Joseph Addison",
    "category": "wisdom",
    "id": 73029,
    "text": "Animals, in their generation, are wiser than the sons of men but their wisdom is confined to a few particulars, and lies in a very narrow compass."
  },
  {
    "author": "Thomas Dekker",
    "category": "wisdom",
    "id": 73374,
    "text": "This age thinks better of a gilded fool Than of a threadbare saint in wisdom's school."
  },
  {
    "author": "Samuel Smiles",
    "category": "wisdom",
    "id": 73196,
    "text": "Practical wisdom is only to be learned in the school of experience. Precepts and instruction are useful so far as they go, but, without the discipline of real life, they remain of the nature of theory only."
  },
  {
    "author": "Charles Dickens",
    "category": "wisdom",
    "id": 72771,
    "text": "There is a wisdom of the head, and a wisdom of the heart."
  },
  {
    "author": "Benjamin Disraeli",
    "category": "wisdom",
    "id": 72823,
    "text": "The wisdom of the wise and the experience of the ages are perpetuated by quotations."
  },
  {
    "author": "George Bernard Shaw",
    "category": "wisdom",
    "id": 72735,
    "text": "We are made wise not by the recollection of our past, but by the responsibility for our future."
  },
  {
    "author": "Sidney Lanier",
    "category": "wisdom",
    "id": 72874,
    "text": "Virtues are acquired through endeavor, which rests wholly upon yourself."
  },
  {
    "author": "Reinhold Niebuhr",
    "category": "wisdom",
    "id": 73005,
    "text": "The final wisdom of life requires not the annulment of incongruity but the achievement of serenity within and above it."
  },
  {
    "author": "Amy Grant",
    "category": "wisdom",
    "id": 73019,
    "text": "There's a beauty to wisdom and experience that cannot be faked. It's impossible to be mature without having lived."
  },
  {
    "author": "Arthur Conan Doyle",
    "category": "wisdom",
    "id": 72743,
    "text": "We can't command our love, but we can our actions."
  },
  {
    "author": "Socrates",
    "category": "wisdom",
    "id": 72710,
    "text": "Wisdom begins in wonder."
  },
  {
    "author": "Benjamin Carson",
    "category": "wisdom",
    "id": 73127,
    "text": "You know, many people have said that I'm on the edge and I'm maverick for some of the big operations that I've done. I'm not at all. I pray I ask God to give me wisdom, 'Should I do it?', guidance in terms of how to do it, who to consult with. All those kind of things are incredibly important."
  },
  {
    "author": "Menander",
    "category": "wisdom",
    "id": 73362,
    "text": "It is not white hair that engenders wisdom."
  },
  {
    "author": "Timothy White",
    "category": "wisdom",
    "id": 73419,
    "text": "I think in conventional magazine wisdom, you need to have a redesign every decade or so."
  },
  {
    "author": "Nick Clooney",
    "category": "wisdom",
    "id": 73296,
    "text": "Conventional wisdom holds that setting a timetable for getting American troops out of Iraq would be a mistake."
  },
  {
    "author": "Abigail Adams",
    "category": "wisdom",
    "id": 73052,
    "text": "Wisdom and penetration are the fruit of experience, not the lessons of retirement and leisure. Great necessities call out great virtues."
  },
  {
    "author": "William Ralph Inge",
    "category": "wisdom",
    "id": 72868,
    "text": "It is astonishing with how little wisdom mankind can be governed, when that little wisdom is its own."
  },
  {
    "author": "K. D. Lang",
    "category": "wisdom",
    "id": 73267,
    "text": "Spend time reflecting on your emotional and physical existence and how that applies to the voice. You have to apply that wisdom and experience when you sing - it's what comes through."
  },
  {
    "author": "Sidney Hook",
    "category": "wisdom",
    "id": 73397,
    "text": "Wisdom is a kind of knowledge. It is knowledge of the nature, career, and consequences of human values."
  },
  {
    "author": "Lord Byron",
    "category": "wisdom",
    "id": 72781,
    "text": "Sorrow is knowledge, those that know the most must mourn the deepest, the tree of knowledge is not the tree of life."
  },
  {
    "author": "Abigail Van Buren",
    "category": "wisdom",
    "id": 72767,
    "text": "The less you talk, the more you're listened to."
  },
  {
    "author": "Stanley Kunitz",
    "category": "wisdom",
    "id": 73238,
    "text": "Old myths, old gods, old heroes have never died. They are only sleeping at the bottom of our mind, waiting for our call. We have need for them. They represent the wisdom of our race."
  },
  {
    "author": "Bertrand Russell",
    "category": "wisdom",
    "id": 72790,
    "text": "To conquer fear is the beginning of wisdom."
  },
  {
    "author": "Thomas B. Macaulay",
    "category": "wisdom",
    "id": 72878,
    "text": "Few of the many wise apothegms which have been uttered have prevented a single foolish action."
  },
  {
    "author": "Edward G. Bulwer-Lytton",
    "category": "wisdom",
    "id": 72713,
    "text": "A fool flatters himself, a wise man flatters the fool."
  },
  {
    "author": "Emanuel Swedenborg",
    "category": "wisdom",
    "id": 73246,
    "text": "The Divine of the Lord in heaven is love, for the reason that love is receptive of all things of heaven, such as peace, intelligence, wisdom and happiness."
  },
  {
    "author": "Aesop",
    "category": "wisdom",
    "id": 72804,
    "text": "Better be wise by the misfortunes of others than by your own."
  },
  {
    "author": "William Blake",
    "category": "wisdom",
    "id": 72980,
    "text": "The hours of folly are measured by the clock but of wisdom, no clock can measure."
  },
  {
    "author": "Paul Engle",
    "category": "wisdom",
    "id": 73148,
    "text": "Wisdom is knowing when you can't be wise."
  },
  {
    "author": "Shmuel Y. Agnon",
    "category": "wisdom",
    "id": 73388,
    "text": "After all my possessions had been burned, God gave me the wisdom to return to Jerusalem."
  },
  {
    "author": "Euripides",
    "category": "wisdom",
    "id": 73006,
    "text": "Along with success comes a reputation for wisdom."
  },
  {
    "author": "Samuel Smiles",
    "category": "wisdom",
    "id": 73132,
    "text": "Wisdom and understanding can only become the possession of individual men by travelling the old road of observation, attention, perseverance, and industry."
  }
]

quotes['women'] = [
  {
    "author": "Grace Kelly",
    "category": "women",
    "id": 73578,
    "text": "Emancipation of women has made them lose their mystery."
  },
  {
    "author": "Jesse Jackson",
    "category": "women",
    "id": 74148,
    "text": "On the political front, of course it's a zero-sum game. If it's all white males holding positions, you bring 10 women in, then it's, 'Women are coming!' Get 10 blacks and it's, 'Blacks are coming!' 'Hispanics are coming!' Zero-sum game. The seatmates might change but the chairs don't move. In the economy, the number of chairs can actually increase."
  },
  {
    "author": "Charles Baudelaire",
    "category": "women",
    "id": 73842,
    "text": "Those men get along best with women who can get along best without them."
  },
  {
    "author": "Donald Trump",
    "category": "women",
    "id": 73754,
    "text": "Love him or hate him, Trump is a man who is certain about what he wants and sets out to get it, no holds barred. Women find his power almost as much of a turn-on as his money."
  },
  {
    "author": "Ellen DeGeneres",
    "category": "women",
    "id": 73912,
    "text": "I've been trying to find women writers for my staff for a while now and I have three women on my staff and three guys so it's pretty equal. I don't know why that is. It's been the same thing for a while. It's hard for female comedians to stand out. That's weird. That's a shame."
  },
  {
    "author": "George Bernard Shaw",
    "category": "women",
    "id": 73443,
    "text": "If women were particular about men's characters, they would never get married at all."
  },
  {
    "author": "Little Richard",
    "category": "women",
    "id": 73457,
    "text": "I think God made a woman to be strong and not to be trampled under the feet of men. I've always felt this way because my mother was a very strong woman, without a husband."
  },
  {
    "author": "Billie Jean King",
    "category": "women",
    "id": 74341,
    "text": "Women's sports is still in its infancy. The beginning of women's sports in the United States started in 1972, with the passage of Title 9 for girls to finally get athletic scholarships."
  },
  {
    "author": "Gloria Steinem",
    "category": "women",
    "id": 73515,
    "text": "The first problem for all of us, men and women, is not to learn, but to unlearn."
  },
  {
    "author": "John F. Kennedy",
    "category": "women",
    "id": 73617,
    "text": "I'm always rather nervous about how you talk about women who are active in politics, whether they want to be talked about as women or as politicians."
  },
  {
    "author": "Hedy Lamarr",
    "category": "women",
    "id": 73873,
    "text": "I find very often that very ugly women have really handsome men and vice versa because they don't have any competition. Sometimes handsome men have avoided me."
  },
  {
    "author": "Erica Jong",
    "category": "women",
    "id": 73458,
    "text": "You see a lot of smart guys with dumb women, but you hardly ever see a smart woman with a dumb guy."
  },
  {
    "author": "W. C. Fields",
    "category": "women",
    "id": 73715,
    "text": "All the men in my family were bearded, and most of the women."
  },
  {
    "author": "Jon Bon Jovi",
    "category": "women",
    "id": 73781,
    "text": "Women rule the world. It's not really worth fighting because they know what they're doing. Ask Napoleon. Ask Adam. Ask Richard Burton or Richie Sambora. Many a man has crumbled."
  },
  {
    "author": "Louisa May Alcott",
    "category": "women",
    "id": 74152,
    "text": "I like to help women help themselves, as that is, in my opinion, the best way to settle the woman question. Whatever we can do and do well we have a right to, and I don't think any one will deny us."
  },
  {
    "author": "Jessica Savitch",
    "category": "women",
    "id": 74242,
    "text": "Women were seldom given quality assignments or adequate air time."
  },
  {
    "author": "Georges Pompidou",
    "category": "women",
    "id": 74119,
    "text": "There are three roads to ruin women, gambling and technicians. The most pleasant is with women, the quickest is with gambling, but the surest is with technicians."
  },
  {
    "author": "Ellen DeGeneres",
    "category": "women",
    "id": 73913,
    "text": "Comedy can be, especially in a writer's room, really aggressive, kind of a very male-dominated room, and it would be hard for women. It's not a nurturing place. It's not like a lot of women are going to say, I can't wait to live that lifestyle and be in a writer's room until 2 or 3 a.m."
  },
  {
    "author": "Steve Harvey",
    "category": "women",
    "id": 74126,
    "text": "The problem is, women have stopped setting the bar high."
  },
  {
    "author": "Kim Kardashian",
    "category": "women",
    "id": 73926,
    "text": "I remember when the wave of Jennifer Lopez, Salma Hayek and these beautiful Hispanic women came into light, and I looked up to them and I loved them, but I was like, 'Where are Middle Eastern women?'"
  },
  {
    "author": "Will Smith",
    "category": "women",
    "id": 73656,
    "text": "I try to speak my points of view about black America, and how I feel about black men and the role that black men should play in their lives with their children and in their lives with their women."
  },
  {
    "author": "Germaine Greer",
    "category": "women",
    "id": 74028,
    "text": "All societies on the verge of death are masculine. A society can survive with only one man no society will survive a shortage of women."
  },
  {
    "author": "Yul Brynner",
    "category": "women",
    "id": 73488,
    "text": "Girls have an unfair advantage over men: if they can't get what they want by being smart, they can get it by being dumb."
  },
  {
    "author": "Rebecca West",
    "category": "women",
    "id": 74046,
    "text": "The main difference between men and women is that men are lunatics and women are idiots."
  },
  {
    "author": "Rod Stewart",
    "category": "women",
    "id": 74238,
    "text": "I've been out with some extremely beautiful women who have had no sex appeal whatsoever. It really is a lot more than skin deep."
  },
  {
    "author": "George W. Bush",
    "category": "women",
    "id": 73934,
    "text": "America is a friend to the people of Iraq. Our demands are directed only at the regime that enslaves them and threatens us. When these demands are met, the first and greatest benefit will come to Iraqi men, women and children."
  },
  {
    "author": "Arnold Schwarzenegger",
    "category": "women",
    "id": 73802,
    "text": "Freedom is a right ultimately defended by the sacrifice of America's servicemen and women."
  },
  {
    "author": "Richard Pryor",
    "category": "women",
    "id": 73665,
    "text": "There was a time in my life when I thought I had everything - millions of dollars, mansions, cars, nice clothes, beautiful women, and every other materialistic thing you can imagine. Now I struggle for peace."
  },
  {
    "author": "Anna Quindlen",
    "category": "women",
    "id": 73977,
    "text": "Women who marry early are often overly enamored of the kind of man who looks great in wedding pictures and passes the maid of honor his telephone number."
  },
  {
    "author": "Annie Lennox",
    "category": "women",
    "id": 74319,
    "text": "Feminism is a word that I identify with. The term has become synonymous with vitriolic man-hating but it needs to come back to a place where both men and women can embrace it. It is particularly important for women in developing countries."
  },
  {
    "author": "Kate Clinton",
    "category": "women",
    "id": 74143,
    "text": "Some women can't say the word lesbian... even when their mouth is full of one."
  },
  {
    "author": "Oliver Reed",
    "category": "women",
    "id": 74329,
    "text": "I also use women as a sex object maybe I'm kinky. However, I like to talk to them as well."
  },
  {
    "author": "Muhammad Yunus",
    "category": "women",
    "id": 74263,
    "text": "Soon we saw that money going to women brought much more benefit to the family than money going to the men. So we changed our policy and gave a high priority to women. As a result, now 96% of our four million borrowers in Grameen Bank are women."
  },
  {
    "author": "Bill Blass",
    "category": "women",
    "id": 74216,
    "text": "Something about glamour interested me. All my schoolbooks had drawings of women on terraces with a cocktail and a cigarette."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "women",
    "id": 73625,
    "text": "Stupid as a man, say the women: cowardly as a woman, say the men. Stupidity in a woman is unwomanly."
  },
  {
    "author": "Vivienne Westwood",
    "category": "women",
    "id": 74300,
    "text": "Feminists wish women to seem like men. They're not men."
  },
  {
    "author": "John Galliano",
    "category": "women",
    "id": 73585,
    "text": "I don't love dolls. I love women. I love their bodies."
  },
  {
    "author": "Woodrow Wilson",
    "category": "women",
    "id": 73804,
    "text": "There can be no equality or opportunity if men and women and children be not shielded in their lives from the consequences of great industrial and social processes which they cannot alter, control, or singly cope with."
  },
  {
    "author": "Heidi Klum",
    "category": "women",
    "id": 74110,
    "text": "All German women are beautiful."
  },
  {
    "author": "Madeleine Albright",
    "category": "women",
    "id": 74190,
    "text": "I didn't want to set up a women's studies program. I thought women should learn to operate in a coeducational atmosphere, because, especially in national security and international affairs, it's male-dominated."
  },
  {
    "author": "Leonard Cohen",
    "category": "women",
    "id": 74120,
    "text": "Women stand for the objective world for a man. They stand for the thing that you're not and that's what you always reach for in a song."
  },
  {
    "author": "Shirley MacLaine",
    "category": "women",
    "id": 74109,
    "text": "Women love working together. That's my experience anyway."
  },
  {
    "author": "Ambrose Bierce",
    "category": "women",
    "id": 73755,
    "text": "Convent - a place of retirement for women who wish for leisure to meditate upon the sin of idleness."
  },
  {
    "author": "Gina Barreca",
    "category": "women",
    "id": 73678,
    "text": "Once we hit forty, women only have about four taste buds left: one for vodka, one for wine, one for cheese, and one for chocolate."
  },
  {
    "author": "Joan Jett",
    "category": "women",
    "id": 74273,
    "text": "Women are still second-class citizens."
  },
  {
    "author": "Tori Amos",
    "category": "women",
    "id": 74073,
    "text": "I don't mind a dirty girl. But what I find tragic is when we, as women, become not the subject of our own story but someone else's object."
  },
  {
    "author": "Gro Harlem Brundtland",
    "category": "women",
    "id": 74166,
    "text": "The dual scourge of hunger and malnutrition will be truly vanquished not only when granaries are full, but also when people's basic health needs are met and women are given their rightful role in societies."
  },
  {
    "author": "Roseanne Barr",
    "category": "women",
    "id": 73854,
    "text": "The thing women have yet to learn is nobody gives you power. You just take it."
  },
  {
    "author": "Ani DiFranco",
    "category": "women",
    "id": 73917,
    "text": "A lot of women these days, a lot of young women don't want to call themselves feminists. You have this cheap, hideous 'girl power' sort of fad, which I think is pretty benign at best, but at worst, I think it's a way of taking the politics out of feminism and making it some kind of fashion."
  },
  {
    "author": "Friedrich Nietzsche",
    "category": "women",
    "id": 73623,
    "text": "Behind all their personal vanity, women themselves always have an impersonal contempt for woman."
  },
  {
    "author": "Natalie Portman",
    "category": "women",
    "id": 73697,
    "text": "Smart women love smart men more than smart men love smart women."
  },
  {
    "author": "Barbra Streisand",
    "category": "women",
    "id": 73541,
    "text": "A man who graduated high in his class at Yale Law School and made partnership in a top law firm would be celebrated. A man who invested wisely would be admired, but a woman who accomplishes this is treated with suspicion."
  },
  {
    "author": "Jay Leno",
    "category": "women",
    "id": 73791,
    "text": "CNN found that Hillary Clinton is the most admired woman in America. Women admire her because she's strong and successful. Men admire her because she allows her husband to cheat and get away with it."
  },
  {
    "author": "Shirley Chisholm",
    "category": "women",
    "id": 74090,
    "text": "At present, our country needs women's idealism and determination, perhaps more in politics than anywhere else."
  },
  {
    "author": "Grover Cleveland",
    "category": "women",
    "id": 74366,
    "text": "Sensible and responsible women do not want to vote. The relative positions to be assumed by man and woman in the working out of our civilization were assigned long ago by a higher intelligence than ours."
  },
  {
    "author": "Max Beerbohm",
    "category": "women",
    "id": 74165,
    "text": "Most women are not as young as they are painted."
  },
  {
    "author": "Camille Paglia",
    "category": "women",
    "id": 74219,
    "text": "Except for naval and air exercises, our military should be stationed on American soil, where service men and women can lead normal lives in close proximity to family and friends."
  },
  {
    "author": "Alexandra Paul",
    "category": "women",
    "id": 73586,
    "text": "Women have this obsession with shoes."
  },
  {
    "author": "Audre Lorde",
    "category": "women",
    "id": 74187,
    "text": "In discussions around the hiring and firing of Black faculty at universities, the charge is frequently heard that Black women are more easily hired than are Black men."
  },
  {
    "author": "Barbara Bush",
    "category": "women",
    "id": 74086,
    "text": "I'm not a competitive person, and I think women like me because they don't think I'm competitive, just nice."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "women",
    "id": 73790,
    "text": "There is one thing women can never take away from men. We die sooner."
  },
  {
    "author": "Mike Honda",
    "category": "women",
    "id": 74356,
    "text": "Equal pay isn't just a women's issue when women get equal pay, their family incomes rise and the whole family benefits."
  },
  {
    "author": "Joel Rosenberg",
    "category": "women",
    "id": 73862,
    "text": "I'm a simple man. All I want is enough sleep for two normal men, enough whiskey for three, and enough women for four."
  },
  {
    "author": "Louisa May Alcott",
    "category": "women",
    "id": 74287,
    "text": "People don't have fortunes left them in that style nowadays men have to work and women to marry for money. It's a dreadfully unjust world."
  },
  {
    "author": "Joseph Conrad",
    "category": "women",
    "id": 73484,
    "text": "Being a woman is a terribly difficult task, since it consists principally in dealing with men."
  },
  {
    "author": "Amelia Earhart",
    "category": "women",
    "id": 74080,
    "text": "Please know that I am aware of the hazards. I want to do it because I want to do it. Women must try to do things as men have tried. When they fail, their failure must be a challenge to others."
  },
  {
    "author": "Hillary Clinton",
    "category": "women",
    "id": 73704,
    "text": "If a country doesn't recognize minority rights and human rights, including women's rights, you will not have the kind of stability and prosperity that is possible."
  },
  {
    "author": "Marilyn Monroe",
    "category": "women",
    "id": 73631,
    "text": "I have noticed... that men usually leave married women alone and are inclined to treat all wives with respect. This is no great credit to married women."
  },
  {
    "author": "Mark Davis",
    "category": "women",
    "id": 74371,
    "text": "I believe every child has the right to a mother and a father. Men and women are not the same. That's not to say they're not entitled to equal rights, but they are not the same."
  },
  {
    "author": "Billy Sunday",
    "category": "women",
    "id": 73803,
    "text": "A revival does two things. First, it returns the Church from her backsliding and second, it causes the conversion of men and women and it always includes the conviction of sin on the part of the Church. What a spell the devil seems to cast over the Church today!"
  },
  {
    "author": "Rita Mae Brown",
    "category": "women",
    "id": 73779,
    "text": "I became a lesbian because of women, because women are beautiful, strong, and compassionate."
  },
  {
    "author": "Coco Chanel",
    "category": "women",
    "id": 73451,
    "text": "Women must tell men always that they are the strong ones. They are the big, the strong, the wonderful. In truth, women are the strong ones. It is just my opinion, I am not a professor."
  },
  {
    "author": "Charlotte Perkins Gilman",
    "category": "women",
    "id": 73558,
    "text": "The labor of women in the house, certainly, enables men to produce more wealth than they otherwise could and in this way women are economic factors in society. But so are horses."
  },
  {
    "author": "Geoffrey Chaucer",
    "category": "women",
    "id": 73763,
    "text": "Women desire six things: They want their husbands to be brave, wise, rich, generous, obedient to wife, and lively in bed."
  },
  {
    "author": "Anna Quindlen",
    "category": "women",
    "id": 73440,
    "text": "After all those years as a woman hearing 'not thin enough, not pretty enough, not smart enough, not this enough, not that enough,' almost overnight I woke up one morning and thought, 'I'm enough.'"
  },
  {
    "author": "Rita Rudner",
    "category": "women",
    "id": 73941,
    "text": "Men who consistently leave the toilet seat up secretly want women to get up to go the bathroom in the middle of the night and fall in."
  },
  {
    "author": "Samuel Richardson",
    "category": "women",
    "id": 74292,
    "text": "Women do not often fall in love with philosophers."
  },
  {
    "author": "Allen Boyd",
    "category": "women",
    "id": 73653,
    "text": "America's fighting men and women sacrifice much to ensure that our great nation stays free. We owe a debt of gratitude to the soldiers that have paid the ultimate price for this cause, as well as for those who are blessed enough to return from the battlefield unscathed."
  },
  {
    "author": "Groucho Marx",
    "category": "women",
    "id": 73438,
    "text": "Man does not control his own fate. The women in his life do that for him."
  },
  {
    "author": "Beth Ditto",
    "category": "women",
    "id": 74399,
    "text": "I feel sorry... for people who've had skinny privilege and then have it taken away from them. I have had a lifetime to adjust to seeing how people treat women who aren't their idea of beautiful and therefore aren't their idea of useful, and I had to find ways to become useful to myself."
  },
  {
    "author": "H. L. Mencken",
    "category": "women",
    "id": 73459,
    "text": "The only really happy folk are married women and single men."
  },
  {
    "author": "Michelle Obama",
    "category": "women",
    "id": 73668,
    "text": "Women in particular need to keep an eye on their physical and mental health, because if we're scurrying to and from appointments and errands, we don't have a lot of time to take care of ourselves. We need to do a better job of putting ourselves higher on our own 'to do' list."
  },
  {
    "author": "Sean Connery",
    "category": "women",
    "id": 74265,
    "text": "There are women who take it to the wire. That's what they are looking for, the ultimate confrontation. They want a smack."
  },
  {
    "author": "Gloria Steinem",
    "category": "women",
    "id": 73466,
    "text": "I've yet to be on a campus where most women weren't worrying about some aspect of combining marriage, children, and a career. I've yet to find one where many men were worrying about the same thing."
  },
  {
    "author": "Alice Walker",
    "category": "women",
    "id": 73701,
    "text": "The animals of the world exist for their own reasons. They were not made for humans any more than black people were made for white, or women created for men."
  },
  {
    "author": "Lisa Bonet",
    "category": "women",
    "id": 73576,
    "text": "We're getting ready to take over the world. My group of girlfriends - we're renegades."
  },
  {
    "author": "Karl Wilhelm Friedrich Schlegel",
    "category": "women",
    "id": 74149,
    "text": "Women are treated as unjustly in poetry as in life. The feminine ones are not idealistic, and the idealistic not feminine."
  },
  {
    "author": "Marlon Brando",
    "category": "women",
    "id": 74053,
    "text": "With women, I've got a long bamboo pole with a leather loop on the end. I slip the loop around their necks so they can't get away or come too close. Like catching snakes."
  },
  {
    "author": "Morris Chestnut",
    "category": "women",
    "id": 74239,
    "text": "A lot of times, women don't get the male perspective in regards to a relationship, what men go through when they're not really dealing well."
  },
  {
    "author": "Shakira",
    "category": "women",
    "id": 74118,
    "text": "I always believed that women have rights and that there are some women that are intelligent enough to claim those rights. There are some others that are stupid enough not to."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "women",
    "id": 73432,
    "text": "The age of a woman doesn't mean a thing. The best tunes are played on the oldest fiddles."
  },
  {
    "author": "Guy de Maupassant",
    "category": "women",
    "id": 73858,
    "text": "The simplest of women are wonderful liars who can extricate themselves from the most difficult dilemmas with a skill bordering on genius."
  },
  {
    "author": "Robert Ballard",
    "category": "women",
    "id": 74395,
    "text": "I think the most important thing people can do to save our planet and the human race is to empower women!"
  },
  {
    "author": "Joyce Brothers",
    "category": "women",
    "id": 73855,
    "text": "Virginity is such a personal thing. You can't judge anyone on it. A lot of young women feel they want to save themselves for the man who they think they'll love forever."
  },
  {
    "author": "David Duchovny",
    "category": "women",
    "id": 74363,
    "text": "You become tyrannized by this notion that women must not only be treated equally, but they must never fail."
  },
  {
    "author": "Isabel Allende",
    "category": "women",
    "id": 73987,
    "text": "Feminism is dated? Yes, for privileged women like my daughter and all of us here today, but not for most of our sisters in the rest of the world who are still forced into premature marriage, prostitution, forced labor - they have children that they don't want or they cannot feed."
  },
  {
    "author": "Heinrich Heine",
    "category": "women",
    "id": 73508,
    "text": "I will not say that women have no character rather, they have a new one every day."
  },
  {
    "author": "Doris Lessing",
    "category": "women",
    "id": 74350,
    "text": "I don't think that the feminist movement has done much for the characters of women."
  },
  {
    "author": "George Bernard Shaw",
    "category": "women",
    "id": 73439,
    "text": "Clever and attractive women do not want to vote they are willing to let men govern as long as they govern men."
  },
  {
    "author": "Jimmy Carter",
    "category": "women",
    "id": 74079,
    "text": "My decision to register women confirms what is already obvious throughout our society-that women are now providing all types of skills in every profession. The military should be no exception."
  }
]

quotes['work'] = [
  {
    "author": "Ayrton Senna",
    "category": "work",
    "id": 74801,
    "text": "I have no idols. I admire work, dedication and competence."
  },
  {
    "author": "Matthew Macfadyen",
    "category": "work",
    "id": 75373,
    "text": "The security comes, as an actor, in knowing that you're not in control. If you try to control your career, or how people perceive you, you'll make yourself unhappy, because life doesn't work like that. So much is luck. It's much better to let yourself off, to think, 'There's nothing I can do.'"
  },
  {
    "author": "Don Cheadle",
    "category": "work",
    "id": 75032,
    "text": "I understand what's it like to work all week and on Friday night just want to go and leave your brain at the door, buy some popcorn and be thrilled by something."
  },
  {
    "author": "Ivan Illich",
    "category": "work",
    "id": 74912,
    "text": "Healthy people are those who live in healthy homes on a healthy diet in an environment equally fit for birth, growth work, healing, and dying... Healthy people need no bureaucratic interference to mate, give birth, share the human condition and die."
  },
  {
    "author": "Thomas Sowell",
    "category": "work",
    "id": 74867,
    "text": "People who have time on their hands will inevitably waste the time of people who have work to do."
  },
  {
    "author": "Richard Roeper",
    "category": "work",
    "id": 75035,
    "text": "Men's magazines often feature pictures of naked ladies. Women's magazines also often feature pictures of naked ladies. This is because the female body is a beautiful work of art, while the male body is hairy and lumpy and should not be seen by the light of day."
  },
  {
    "author": "Ann Richards",
    "category": "work",
    "id": 74485,
    "text": "Teaching was the hardest work I had ever done, and it remains the hardest work I have done to date."
  },
  {
    "author": "Jeff Bridges",
    "category": "work",
    "id": 75424,
    "text": "Working with my dad was such a gas. We approached the work in a similar way. We only made two films together when I was an adult, Tucker, and Blown Away, but it was so much fun to play with your parent like that."
  },
  {
    "author": "Harold Ramis",
    "category": "work",
    "id": 75184,
    "text": "I never work just to work. It's some combination of laziness and self-respect."
  },
  {
    "author": "Henry Ford",
    "category": "work",
    "id": 74536,
    "text": "I believe God is managing affairs and that He doesn't need any advice from me. With God in charge, I believe everything will work out for the best in the end. So what is there to worry about."
  },
  {
    "author": "Tony Shalhoub",
    "category": "work",
    "id": 75329,
    "text": "I was one of those people who put too much emphasis on work and career and material possessions, and it took its toll on all my relationships, on my physical health, my emotional and mental health."
  },
  {
    "author": "Lady Gaga",
    "category": "work",
    "id": 75268,
    "text": "I work very hard, but when God opens that door for you - when life opens that door for you, I should say - I think it's important to be giving, to return the love back."
  },
  {
    "author": "Alfred Eisenstaedt",
    "category": "work",
    "id": 75322,
    "text": "I don't like to work with assistants. I'm already one too many the camera alone would be enough."
  },
  {
    "author": "Arthur Conan Doyle",
    "category": "work",
    "id": 74739,
    "text": "My mind rebels at stagnation. Give me problems, give me work, give me the most abstruse cryptogram, or the most intricate analysis, and I am in my own proper atmosphere. But I abhor the dull routine of existence. I crave for mental exaltation."
  },
  {
    "author": "Joe E. Lewis",
    "category": "work",
    "id": 75170,
    "text": "You only live once - but if you work it right, once is enough."
  },
  {
    "author": "Vince Lombardi",
    "category": "work",
    "id": 74573,
    "text": "Dictionary is the only place that success comes before work. Hard work is the price we must pay for success. I think you can accomplish anything if you're willing to pay the price."
  },
  {
    "author": "Wayne Dyer",
    "category": "work",
    "id": 74633,
    "text": "Deficiency motivation doesn't work. It will lead to a life-long pursuit of try to fix me. Learn to appreciate what you have and where and who you are."
  },
  {
    "author": "Thomas A. Edison",
    "category": "work",
    "id": 74814,
    "text": "Results! Why, man, I have gotten a lot of results. I know several thousand things that won't work."
  },
  {
    "author": "Charlotte Gainsbourg",
    "category": "work",
    "id": 75365,
    "text": "Letting go of things and not being afraid of being ridiculous or over the top - I think that's the main thing for me to work on."
  },
  {
    "author": "James Cash Penney",
    "category": "work",
    "id": 74842,
    "text": "I do not believe in excuses. I believe in hard work as the prime solvent of life's problems."
  },
  {
    "author": "Thomas Aquinas",
    "category": "work",
    "id": 75261,
    "text": "The test of the artist does not lie in the will with which he goes to work, but in the excellence of the work he produces."
  },
  {
    "author": "Theodore Roosevelt",
    "category": "work",
    "id": 74667,
    "text": "It behooves every man to remember that the work of the critic is of altogether secondary importance, and that, in the end, progress is accomplished by the man who does things."
  },
  {
    "author": "Jim Carrey",
    "category": "work",
    "id": 74987,
    "text": "I'm so wrapped up in my work that it's often impossible to consider other things in my life. My marriage ended in divorce because of this, my relationship with Holly has suffered by this."
  },
  {
    "author": "Keith Richards",
    "category": "work",
    "id": 75366,
    "text": "To me, as long as we've known each other, I've always thought Mick's most brilliant thing was that he could work in an area two foot square and give a very exciting performance."
  },
  {
    "author": "Agha Hasan Abedi",
    "category": "work",
    "id": 74937,
    "text": "The conventional definition of management is getting work done through people, but real management is developing people through work."
  },
  {
    "author": "Alexander Woollcott",
    "category": "work",
    "id": 75127,
    "text": "I'm tired of hearing it said that democracy doesn't work. Of course it doesn't work. We are supposed to work it."
  },
  {
    "author": "Beatrice Wood",
    "category": "work",
    "id": 75240,
    "text": "And I have exposed myself to art so that my work has something beyond just the usual potter."
  },
  {
    "author": "Herman Melville",
    "category": "work",
    "id": 75345,
    "text": "To know how to grow old is the master work of wisdom, and one of the most difficult chapters in the great art of living."
  },
  {
    "author": "Harvey Fierstein",
    "category": "work",
    "id": 74961,
    "text": "I have to work really hard, eight shows a week, to get a nice check as an actor. But when I write a play, and it's a - knock wood - hit, the checks come in for many years."
  },
  {
    "author": "Bertrand Russell",
    "category": "work",
    "id": 74806,
    "text": "A sense of duty is useful in work but offensive in personal relations. People wish to be liked, not to be endured with patient resignation."
  },
  {
    "author": "John F. Kennedy",
    "category": "work",
    "id": 74598,
    "text": "We believe that if men have the talent to invent new machines that put men out of work, they have the talent to put those men back to work."
  },
  {
    "author": "Marilyn Monroe",
    "category": "work",
    "id": 74617,
    "text": "My work is the only ground I've ever had to stand on. I seem to have a whole superstructure with no foundation but I'm working on the foundation."
  },
  {
    "author": "Michael Jordan",
    "category": "work",
    "id": 74618,
    "text": "I hope the millions of people I've touched have the optimism and desire to share their goals and hard work and persevere with a positive attitude."
  },
  {
    "author": "Chanakya",
    "category": "work",
    "id": 74540,
    "text": "Before you start some work, always ask yourself three questions - Why am I doing it, What the results might be and Will I be successful. Only when you think deeply and find satisfactory answers to these questions, go ahead."
  },
  {
    "author": "Paul Cezanne",
    "category": "work",
    "id": 75048,
    "text": "A work of art which did not begin in emotion is not art."
  },
  {
    "author": "Francois de La Rochefoucauld",
    "category": "work",
    "id": 74923,
    "text": "Though nature be ever so generous, yet can she not make a hero alone. Fortune must contribute her part too and till both concur, the work cannot be perfected."
  },
  {
    "author": "Barack Obama",
    "category": "work",
    "id": 74542,
    "text": "We need to steer clear of this poverty of ambition, where people want to drive fancy cars and wear nice clothes and live in nice apartments but don't want to work hard to accomplish these things. Everyone should try to realize their full potential."
  },
  {
    "author": "Lana Turner",
    "category": "work",
    "id": 74698,
    "text": "It's said in Hollywood that you should always forgive your enemies - because you never know when you'll have to work with them."
  },
  {
    "author": "Tim McGraw",
    "category": "work",
    "id": 75182,
    "text": "I have three daughters, so I can't be as tough as I want to be. When you have kids - especially daughters - they know how to work you. They're a lot smarter than we are, that's for sure. But I'll be more tough on their boyfriends."
  },
  {
    "author": "John Burroughs",
    "category": "work",
    "id": 75124,
    "text": "Blessed is the man who has some congenial work, some occupation in which he can put his heart, and which affords a complete outlet to all the forces there are in him."
  },
  {
    "author": "Mark Twain",
    "category": "work",
    "id": 74561,
    "text": "Man - a creature made at the end of the week's work when God was tired."
  },
  {
    "author": "Leonardo da Vinci",
    "category": "work",
    "id": 74811,
    "text": "I have offended God and mankind because my work didn't reach the quality it should have."
  },
  {
    "author": "Francis of Assisi",
    "category": "work",
    "id": 74621,
    "text": "I have been all things unholy. If God can work through me, he can work through anyone."
  },
  {
    "author": "Henry Rollins",
    "category": "work",
    "id": 75051,
    "text": "But I have a good life. I enjoy what I do. I am married to work."
  },
  {
    "author": "Lalu Prasad Yadav",
    "category": "work",
    "id": 75069,
    "text": "I know some people say I can be funny. But there is always a deeper meaning to what I say. I am a socialist at heart and have the interests of the poor in mind. When people see how I manage to work my way out of tough situations, it gives them hope in their own life."
  },
  {
    "author": "Bette Davis",
    "category": "work",
    "id": 75141,
    "text": "The only reason anyone goes to Broadway is because they can't get work in the movies."
  },
  {
    "author": "Will Smith",
    "category": "work",
    "id": 74665,
    "text": "And where I excel is ridiculous, sickening, work ethic. You know, while the other guy's sleeping? I'm working."
  },
  {
    "author": "Vince Lombardi",
    "category": "work",
    "id": 74631,
    "text": "Leaders aren't born they are made. And they are made just like anything else, through hard work. And that's the price we'll have to pay to achieve that goal, or any goal."
  },
  {
    "author": "Bette Davis",
    "category": "work",
    "id": 74482,
    "text": "To fulfill a dream, to be allowed to sweat over lonely labor, to be given a chance to create, is the meat and potatoes of life. The money is the gravy."
  },
  {
    "author": "H. P. Lovecraft",
    "category": "work",
    "id": 74952,
    "text": "I fear my enthusiasm flags when real work is demanded of me."
  },
  {
    "author": "Carl Jung",
    "category": "work",
    "id": 74854,
    "text": "Without this playing with fantasy no creative work has ever yet come to birth. The debt we owe to the play of the imagination is incalculable."
  },
  {
    "author": "Barack Obama",
    "category": "work",
    "id": 74575,
    "text": "It was the labor movement that helped secure so much of what we take for granted today. The 40-hour work week, the minimum wage, family leave, health insurance, Social Security, Medicare, retirement plans. The cornerstones of the middle-class security all bear the union label."
  },
  {
    "author": "William Shatner",
    "category": "work",
    "id": 75383,
    "text": "I think of doing a series as very hard work. But then I've talked to coal miners, and that's really hard work."
  },
  {
    "author": "Mandy Patinkin",
    "category": "work",
    "id": 75187,
    "text": "I love my work, I love the people I work with, I do the best I can."
  },
  {
    "author": "Horace",
    "category": "work",
    "id": 74475,
    "text": "Life grants nothing to us mortals without hard work."
  },
  {
    "author": "Vidal Sassoon",
    "category": "work",
    "id": 75327,
    "text": "I was all about my thoughts, my work, my inspiration. I was always in hair."
  },
  {
    "author": "Peter Drucker",
    "category": "work",
    "id": 74874,
    "text": "The productivity of work is not the responsibility of the worker but of the manager."
  },
  {
    "author": "Vaclav Havel",
    "category": "work",
    "id": 75039,
    "text": "Hope is a state of mind, not of the world. Hope, in this deep and powerful sense, is not the same as joy that things are going well, or willingness to invest in enterprises that are obviously heading for success, but rather an ability to work for something because it is good."
  },
  {
    "author": "Marc Chagall",
    "category": "work",
    "id": 74499,
    "text": "Work isn't to make money you work to justify life."
  },
  {
    "author": "Henry Rollins",
    "category": "work",
    "id": 75110,
    "text": "I just get things done instead of talking about getting them done. I don't go out and party. I don't smoke, drink or do drugs and I'm not married, that leaves a lot of time for my work."
  },
  {
    "author": "Maya Angelou",
    "category": "work",
    "id": 74523,
    "text": "My great hope is to laugh as much as I cry to get my work done and try to love somebody and have the courage to accept the love in return."
  },
  {
    "author": "Steve Jobs",
    "category": "work",
    "id": 74680,
    "text": "The people who are doing the work are the moving force behind the Macintosh. My job is to create a space for them, to clear out the rest of the organization and keep it at bay."
  },
  {
    "author": "Emmanuelle Beart",
    "category": "work",
    "id": 75213,
    "text": "There are moments when you feel that the desire to work is fading, and the only way to bring it back is to get away from it, to put yourself in a state of frustration so you feel the need again."
  },
  {
    "author": "Simon Mainwaring",
    "category": "work",
    "id": 75375,
    "text": "More and more companies are reaching out to their suppliers and contractors to work jointly on issues of sustainability, environmental responsibility, ethics, and compliance."
  },
  {
    "author": "John Lubbock",
    "category": "work",
    "id": 74963,
    "text": "A day of worry is more exhausting than a week of work."
  },
  {
    "author": "Joel Osteen",
    "category": "work",
    "id": 74764,
    "text": "On Sundays when I speak, I hopefully give somebody something that they can use the next day at work or at home."
  },
  {
    "author": "Charlie Sheen",
    "category": "work",
    "id": 74675,
    "text": "We're going to shoot one Polaroid per show. I'm going to sign this before it even develops because I know that once it develops with my signature on it, it's worth a fortune. I'll make this a work of magic warlock art."
  },
  {
    "author": "Chanakya",
    "category": "work",
    "id": 74645,
    "text": "Once you start a working on something, don't be afraid of failure and don't abandon it. People who work sincerely are the happiest."
  },
  {
    "author": "Mattie Stepanek",
    "category": "work",
    "id": 75058,
    "text": "While we are living in the present, we must celebrate life every day, knowing that we are becoming history with every work, every action, every deed."
  },
  {
    "author": "James Levine",
    "category": "work",
    "id": 74510,
    "text": "Most people treat the office manual the way they treat a software manual. They never look at it."
  },
  {
    "author": "J. Michael Straczynski",
    "category": "work",
    "id": 74921,
    "text": "Never follow somebody else's path it doesn't work the same way twice for anyone... the path follows you and rolls up behind you as you walk, forcing the next person to find their own way."
  },
  {
    "author": "Hugh Jackman",
    "category": "work",
    "id": 75412,
    "text": "Australians are coffee snobs. An influx of Italian immigrants after World War II ensured that - we probably had the word 'cappuccino' about 20 years before America. Cafe culture is really big for Aussies. We like to work hard, but we take our leisure time seriously."
  },
  {
    "author": "Christopher Meloni",
    "category": "work",
    "id": 74927,
    "text": "It ain't easy to break out of a mold, but if you do your work, people will ultimately see what you're capable of. Too often, people find it easier to make assumptions and stick with what they believe. They put you in a place and it makes their job easier. The good people constantly search for something different."
  },
  {
    "author": "Charles Kingsley",
    "category": "work",
    "id": 75250,
    "text": "Have thy tools ready. God will find thee work."
  },
  {
    "author": "Tom Welling",
    "category": "work",
    "id": 74756,
    "text": "I have so much chaos in my life, it's become normal. You become used to it. You have to just relax, calm down, take a deep breath and try to see how you can make things work rather than complain about how they're wrong."
  },
  {
    "author": "Robert Orben",
    "category": "work",
    "id": 75050,
    "text": "Every morning I get up and look through the Forbes list of the richest people in America. If I'm not there, I go to work."
  },
  {
    "author": "Antoine de Saint-Exupery",
    "category": "work",
    "id": 74554,
    "text": "If you want to build a ship, don't drum up people to collect wood and don't assign them tasks and work, but rather teach them to long for the endless immensity of the sea."
  },
  {
    "author": "Nelson Mandela",
    "category": "work",
    "id": 74619,
    "text": "Let there be work, bread, water and salt for all."
  },
  {
    "author": "Michelle Obama",
    "category": "work",
    "id": 75324,
    "text": "When I get up and work out, I'm working out just as much for my girls as I am for me, because I want them to see a mother who loves them dearly, who invests in them, but who also invests in herself. It's just as much about letting them know as young women that it is okay to put yourself a little higher on your priority list."
  },
  {
    "author": "Julia Cameron",
    "category": "work",
    "id": 75252,
    "text": "What we really want to do is what we are really meant to do. When we do what we are meant to do, money comes to us, doors open for us, we feel useful, and the work we do feels like play to us."
  },
  {
    "author": "John Grisham",
    "category": "work",
    "id": 75346,
    "text": "I have learned not to read reviews. Period. And I hate reviewers. All of them, or at least all but two or three. Life is much simpler ignoring reviews and the nasty people who write them. Critics should find meaningful work."
  },
  {
    "author": "Thomas Sowell",
    "category": "work",
    "id": 74666,
    "text": "The most fundamental fact about the ideas of the political left is that they do not work. Therefore we should not be surprised to find the left concentrated in institutions where ideas do not have to work in order to survive."
  },
  {
    "author": "Thomas Merton",
    "category": "work",
    "id": 74917,
    "text": "The least of the work of learning is done in the classroom."
  },
  {
    "author": "Vidal Sassoon",
    "category": "work",
    "id": 74976,
    "text": "Hairdressers are a wonderful breed. You work one-on-one with another human being and the object is to make them feel so much better and to look at themselves with a twinkle in their eye."
  },
  {
    "author": "Paul Valery",
    "category": "work",
    "id": 74817,
    "text": "An artist never really finishes his work, he merely abandons it."
  },
  {
    "author": "Salvador Dali",
    "category": "work",
    "id": 74879,
    "text": "Progressive art can assist people to learn not only about the objective forces at work in the society in which they live, but also about the intensely social character of their interior lives. Ultimately, it can propel people toward social emancipation."
  },
  {
    "author": "Pearl Bailey",
    "category": "work",
    "id": 74885,
    "text": "What the world really needs is more love and less paper work."
  },
  {
    "author": "Sam Ewing",
    "category": "work",
    "id": 74434,
    "text": "Hard work spotlights the character of people: some turn up their sleeves, some turn up their noses, and some don't turn up at all."
  },
  {
    "author": "Winston Churchill",
    "category": "work",
    "id": 74567,
    "text": "In war as in life, it is often necessary when some cherished scheme has failed, to take up the best alternative open, and if so, it is folly not to work for it with all your might."
  },
  {
    "author": "Harvey Fierstein",
    "category": "work",
    "id": 74932,
    "text": "I burned out on AIDS and did no AIDS work for a couple of years. I was so angry that people were still getting this disease that nobody can give you - you have to go out and get it!"
  },
  {
    "author": "Henry Wadsworth Longfellow",
    "category": "work",
    "id": 75308,
    "text": "For his heart was in his work, and the heart giveth grace unto every art."
  },
  {
    "author": "Eileen Caddy",
    "category": "work",
    "id": 74972,
    "text": "Cease trying to work everything out with your minds. It will get you nowhere. Live by intuition and inspiration and let your whole life be Revelation."
  },
  {
    "author": "Anna Pavlova",
    "category": "work",
    "id": 74515,
    "text": "No one can arrive from being talented alone, work transforms talent into genius."
  },
  {
    "author": "Michelangelo",
    "category": "work",
    "id": 74922,
    "text": "Many believe - and I believe - that I have been designated for this work by God. In spite of my old age, I do not want to give it up I work out of love for God and I put all my hope in Him."
  },
  {
    "author": "Thomas A. Edison",
    "category": "work",
    "id": 74531,
    "text": "I have not failed. I've just found 10,000 ways that won't work."
  },
  {
    "author": "Mary McCarthy",
    "category": "work",
    "id": 75289,
    "text": "You musn't force sex to do the work of love or love to do the work of sex."
  },
  {
    "author": "Martin Luther King, Jr.",
    "category": "work",
    "id": 74519,
    "text": "Change does not roll in on the wheels of inevitability, but comes through continuous struggle. And so we must straighten our backs and work for our freedom. A man can't ride you unless your back is bent."
  },
  {
    "author": "Harry S. Truman",
    "category": "work",
    "id": 74779,
    "text": "It is understanding that gives us an ability to have peace. When we understand the other fellow's viewpoint, and he understands ours, then we can sit down and work out our differences."
  },
  {
    "author": "Meister Eckhart",
    "category": "work",
    "id": 75310,
    "text": "The outward work will never be puny if the inward work is great."
  },
  {
    "author": "Bette Davis",
    "category": "work",
    "id": 75390,
    "text": "I went back to work because someone had to pay for the groceries."
  }
]

quotes['christmas'] = [
  {
    "author": "Kary Mullis",
    "category": "christmas",
    "id": 75603,
    "text": "My mother would give my brothers and me a pile of catalogues and let us pick what we wanted for Christmas."
  },
  {
    "author": "David Eddings",
    "category": "christmas",
    "id": 75623,
    "text": "The unfortunate thing about working for yourself is that you have the worst boss in the world. I work every day of the year except at Christmas, when I work a half day."
  },
  {
    "author": "Nancy Kerrigan",
    "category": "christmas",
    "id": 75632,
    "text": "I was thrilled one year when I was younger when not only did my brothers get hockey sticks for Christmas - but I did too!"
  },
  {
    "author": "Whitley Strieber",
    "category": "christmas",
    "id": 75702,
    "text": "I put the copy of 'A Christmas Carol' that my grandfather had first read to me 60 years ago on my desk, and I began to write. The result, for better or for worse, is the 'Christmas Spirits.' I plan to read it to my grandson."
  },
  {
    "author": "Carrie Fisher",
    "category": "christmas",
    "id": 75445,
    "text": "I don't think Christmas is necessarily about things. It's about being good to one another, it's about the Christian ethic, it's about kindness."
  },
  {
    "author": "Sandra Lee",
    "category": "christmas",
    "id": 75509,
    "text": "Christmas is more stressful with present buying and making sure everyone gets included, but Thanksgiving is really not that. I don't ever really get stressed out about the food."
  },
  {
    "author": "Franklin P. Adams",
    "category": "christmas",
    "id": 75507,
    "text": "Christmas is over and Business is Business."
  },
  {
    "author": "Jose Mourinho",
    "category": "christmas",
    "id": 75493,
    "text": "I was nine or 10 years old and my father was sacked on Christmas Day. He was a manager, the results had not been good, he lost a game on December 22 or 23. On Christmas Day, the telephone rang and he was sacked in the middle of our lunch."
  },
  {
    "author": "TobyMac",
    "category": "christmas",
    "id": 75521,
    "text": "I think Christmas is about celebration and come on, on the inside everyone wants to dance."
  },
  {
    "author": "Ronald Reagan",
    "category": "christmas",
    "id": 75485,
    "text": "We should declare war on North Vietnam. We could pave the whole country and put parking strips on it, and still be home by Christmas."
  },
  {
    "author": "Andrea Arnold",
    "category": "christmas",
    "id": 75570,
    "text": "I'm sure most of us remember being a kid and you have all of this endless time where two weeks before Christmas feels like ten years. I used to go to bed to try and go to sleep to try and make it go faster."
  },
  {
    "author": "Isaac Hanson",
    "category": "christmas",
    "id": 75676,
    "text": "Christmas albums are not something you do frequently."
  },
  {
    "author": "Rebecca Romijn",
    "category": "christmas",
    "id": 75611,
    "text": "I think we felt the pressure more at first than this time around. But still you don't want to let anyone down. I never even met Patrick until we had a Christmas party at Ian McKellen's house on the first movie and then I didn't see him again until the premiere."
  },
  {
    "author": "Chris Brown",
    "category": "christmas",
    "id": 75532,
    "text": "With the song 'This Christmas' I wanted to do something that was kind of different. I mean, Donny Hathaway is an amazing artist. So I wanted to bring my flavor to the song so when people over the age of 45 or 50 hear it they'll be like 'OK, he did his thing with that record.' It's like I can appeal to everybody and not just a younger demographic."
  },
  {
    "author": "A. J. Liebling",
    "category": "christmas",
    "id": 75594,
    "text": "The pattern of a newspaperman's life is like the plot of 'Black Beauty.' Sometimes he finds a kind master who gives him a dry stall and an occasional bran mash in the form of a Christmas bonus, sometimes he falls into the hands of a mean owner who drives him in spite of spavins and expects him to live on potato peelings."
  },
  {
    "author": "Burt Ward",
    "category": "christmas",
    "id": 75661,
    "text": "I make personal appearances around the country. I'm starting a book tour now, and I may be coming to Toronto with the Learning Annex, which I'm doing all through the United States, so that may come up just before Christmas."
  },
  {
    "author": "Jonathan Kozol",
    "category": "christmas",
    "id": 75542,
    "text": "I beg people not to accept the seasonal ritual of well-timed charity on Christmas Eve. It's blasphemy."
  },
  {
    "author": "Kyra Sedgwick",
    "category": "christmas",
    "id": 75633,
    "text": "He put a ring in the toe of a stocking. On Christmas Eve, we opened our stockings and it was there at the bottom of the toe. Then he got down on his knees and he was shaking."
  },
  {
    "author": "Keith Thibodeaux",
    "category": "christmas",
    "id": 75691,
    "text": "In fact, I was one of the few trusted people that Lucy allowed to play with their kids. I spent time at their summer home, rode horses at their ranch, and swam at their beach house. I even spent a Christmas with them at Palm Springs one year."
  },
  {
    "author": "Luke Perry",
    "category": "christmas",
    "id": 75617,
    "text": "It's hard and sometimes it's scary. It still amazes my mother. I went home for Christmas one year and there were fans all over the front lawn, hoping to see me."
  },
  {
    "author": "Richard Lamm",
    "category": "christmas",
    "id": 75553,
    "text": "Christmas is a time when kids tell Santa what they want and adults pay for it. Deficits are when adults tell the government what they want - and their kids pay for it."
  },
  {
    "author": "Jack Bowman",
    "category": "christmas",
    "id": 75653,
    "text": "I've been in elementary education for years and my belief is that Christmas pageants in schools are little more than conditioning kids for the Christian religion."
  },
  {
    "author": "Stephen Fry",
    "category": "christmas",
    "id": 75517,
    "text": "Christmas to a child is the first terrible proof that to travel hopefully is better than to arrive."
  },
  {
    "author": "Cher",
    "category": "christmas",
    "id": 75511,
    "text": "I remember a great America where we made everything. There was a time when the only thing you got from Japan was a really bad cheap transistor radio that some aunt gave you for Christmas."
  },
  {
    "author": "Nicholas Lea",
    "category": "christmas",
    "id": 75453,
    "text": "At Christmas, 'It's a Wonderful Life' makes me cry in exactly the same places every time, even though I know it's coming."
  },
  {
    "author": "Gustavo Dudamel",
    "category": "christmas",
    "id": 75634,
    "text": "A friend gave me a CD of the 'Pathetique' Symphony as a Christmas present. I went home, and I put on the CD expecting to listen to Tchaikovsky. But it started 'ta ta ta taaa.' It was too long for me. I didn't understand it at first, but then I fell in love, in love, in love."
  },
  {
    "author": "Tony Visconti",
    "category": "christmas",
    "id": 75604,
    "text": "Our last jam session was this past Christmas. Dad played his harmonica, mom sang in English and Italian, and I played guitar. I'm so happy that we could share that musical experience for one last time."
  },
  {
    "author": "John Clayton",
    "category": "christmas",
    "id": 75580,
    "text": "The denominational world tries to pressure its members to focus on the birth of Christ, but in doing so layers of guilt are imposed, and competition gets complicated as one Christmas program tries to outdo the other."
  },
  {
    "author": "Edwin Louis Cole",
    "category": "christmas",
    "id": 75462,
    "text": "Expectancy is the atmosphere for miracles."
  },
  {
    "author": "Amy Smart",
    "category": "christmas",
    "id": 75663,
    "text": "I love cooking during Christmas, all smells like the hot apple cider, the hot spiced wine."
  },
  {
    "author": "Lucy Hale",
    "category": "christmas",
    "id": 75610,
    "text": "My favorite toy growing up was Polly Pocket. But one gift that I wanted though never received for Christmas was a pair of trampoline moon shoes. You strap them to your feet and they have springs on them, and you can just jump around!"
  },
  {
    "author": "Victor Borge",
    "category": "christmas",
    "id": 75457,
    "text": "Santa Claus has the right idea - visit people only once a year."
  },
  {
    "author": "Christie Hefner",
    "category": "christmas",
    "id": 75622,
    "text": "From the time that I can remember, I worked to make money - either baby-sitting, or one year wrapping gifts at a department store at Christmas, so I could have my own money."
  },
  {
    "author": "Ethel Merman",
    "category": "christmas",
    "id": 75514,
    "text": "Christmas carols always brought tears to my eyes. I also cry at weddings. I should have cried at a couple of my own."
  },
  {
    "author": "Clint Black",
    "category": "christmas",
    "id": 75695,
    "text": "I intend to keep writing Christmas songs. There's still a lot more about Christmas that can be captured and feel like old-time Christmas. A lot of the traditions haven't been explained in song."
  },
  {
    "author": "Benjamin Franklin",
    "category": "christmas",
    "id": 75430,
    "text": "A good conscience is a continual Christmas."
  },
  {
    "author": "A. E. van Vogt",
    "category": "christmas",
    "id": 75682,
    "text": "Chum was a British boy's weekly which, at the end of the year was bound into a single huge book and the following Christmas parents bought it as Christmas presents for male children."
  },
  {
    "author": "Leonard Maltin",
    "category": "christmas",
    "id": 75649,
    "text": "I think the people who are making Christmas-themed movies today feel that people are more cynical about Christmas. There's more of an edge."
  },
  {
    "author": "Dale Evans",
    "category": "christmas",
    "id": 75431,
    "text": "Christmas, my child, is love in action. Every time we love, every time we give, it's Christmas."
  },
  {
    "author": "Alice Cooper",
    "category": "christmas",
    "id": 75510,
    "text": "The two most joyous times of the year are Christmas morning and the end of school."
  },
  {
    "author": "Peter Jurasik",
    "category": "christmas",
    "id": 75673,
    "text": "So when I was 13, I basically left home and never returned and lived at home again. I would come home for a week at Christmas and two weeks in the summer only."
  },
  {
    "author": "Karl Rahner",
    "category": "christmas",
    "id": 75456,
    "text": "Every year we celebrate the holy season of Advent, O God. Every year we pray those beautiful prayers of longing and waiting, and sing those lovely songs of hope and promise."
  },
  {
    "author": "Ashley Benson",
    "category": "christmas",
    "id": 75627,
    "text": "A lot of sequins for New Year's! Red, green, white - I fail at all of that because I'm always in black. But for Christmas, I do love wearing cute dresses with tights and a pair of boots."
  },
  {
    "author": "Leonard Maltin",
    "category": "christmas",
    "id": 75650,
    "text": "A Christmas Carol is such a fool-proof story you can't louse it up."
  },
  {
    "author": "Chris Van Allsburg",
    "category": "christmas",
    "id": 75469,
    "text": "Santa is our culture's only mythic figure truly believed in by a large percentage of the population. It's a fact that most of the true believers are under eight years old, and that's a pity."
  },
  {
    "author": "Kevin Richardson",
    "category": "christmas",
    "id": 75581,
    "text": "At Christmas our house is like a Donnie and Marie Christmas Special."
  },
  {
    "author": "Trishelle Cannatella",
    "category": "christmas",
    "id": 75683,
    "text": "But Tammy Faye calls me, and Ron Jeremy calls me, Erik Estrada sends me a Christmas card every year."
  },
  {
    "author": "John Cleese",
    "category": "christmas",
    "id": 75519,
    "text": "I can't tell you how scary it can be walking onto a movie and suddenly joining this family, it's like going to somebody else's Christmas dinner, everyone knows everyone, and you're there and you're not quite sure what you're supposed to be doing."
  },
  {
    "author": "Mira Nair",
    "category": "christmas",
    "id": 75587,
    "text": "Christmas lights may be the loneliest thing for me, especially if you mix them up with reindeers and sleighs. I feel alone. I feel isolated. I feel I do not belong."
  },
  {
    "author": "Johnny Carson",
    "category": "christmas",
    "id": 75501,
    "text": "Mail your packages early so the post office can lose them in time for Christmas."
  },
  {
    "author": "Charles Dickens",
    "category": "christmas",
    "id": 75432,
    "text": "Happy, happy Christmas, that can win us back to the delusions of our childhood days, recall to the old man the pleasures of his youth, and transport the traveler back to his own fireside and quiet home!"
  },
  {
    "author": "Richard E. Grant",
    "category": "christmas",
    "id": 75648,
    "text": "It always depresses me when people moan about how commercial Christmas is. I love everything about it. The tradition of having this great big feast, slap bang in the middle of winter, is an essential thing to look forward to at the end of the year."
  },
  {
    "author": "Barry Manilow",
    "category": "christmas",
    "id": 75621,
    "text": "First of all, I've been having a wonderful run of luck with cover albums, songs I didn't write. I had five pop cover albums and two Christmas albums, and they were all very successful."
  },
  {
    "author": "Whitley Strieber",
    "category": "christmas",
    "id": 75701,
    "text": "The upheavals of adolescence silenced 'A Christmas Carol' for a few years. I became a firebrand atheist. Christmas - humbug! Too commercial! Then I became an agnostic. Christmas was a pro-forma affair, basically a chore. Buy mother a book, dad a new tie, my brother and sister small gifts. Pretend thanks for the fountain pens and shirts I received."
  },
  {
    "author": "Thomas Tusser",
    "category": "christmas",
    "id": 75448,
    "text": "At Christmas play and make good cheer, for Christmas comes but once a year."
  },
  {
    "author": "Paul Engle",
    "category": "christmas",
    "id": 75530,
    "text": "The sharpest memory of our old-fashioned Christmas eve is my mother's hand making sure I was settled in bed."
  },
  {
    "author": "Trey Parker",
    "category": "christmas",
    "id": 75539,
    "text": "So we're considering doing a new Christmas album, because there's been Christmas episodes since then, and maybe finally do the version of 'The Most Offensive Song Ever' with lyrics intact."
  },
  {
    "author": "Ice Cube",
    "category": "christmas",
    "id": 75551,
    "text": "I remember wishing there was snow in L.A. And how jealous we used to get of those Christmas specials with kids playing in the snow."
  },
  {
    "author": "Diane Kruger",
    "category": "christmas",
    "id": 75544,
    "text": "I made a French film called 'Merry Christmas' which is a very European film. It's a World War I piece."
  },
  {
    "author": "Demetri Martin",
    "category": "christmas",
    "id": 75483,
    "text": "I wrapped my Christmas presents early this year, but I used the wrong paper. See, the paper I used said 'Happy Birthday' on it. I didn't want to waste it so I just wrote 'Jesus' on it."
  },
  {
    "author": "Mo Rocca",
    "category": "christmas",
    "id": 75583,
    "text": "One Christmas my father kept our tree up till March. He hated to see it go. I loved that."
  },
  {
    "author": "Caroline Kennedy",
    "category": "christmas",
    "id": 75488,
    "text": "It's true, Christmas can feel like a lot of work, particularly for mothers. But when you look back on all the Christmases in your life, you'll find you've created family traditions and lasting memories. Those memories, good and bad, are really what help to keep a family together over the long haul."
  },
  {
    "author": "Whitley Strieber",
    "category": "christmas",
    "id": 75700,
    "text": "Every Christmas now for years, I have found myself wondering about the point of the celebration. As the holiday has become more ecumenical and secular, it has lost much of the magic that I remember so fondly from childhood."
  },
  {
    "author": "Bing Crosby",
    "category": "christmas",
    "id": 75441,
    "text": "Unless we make Christmas an occasion to share our blessings, all the snow in Alaska won't make it 'white'."
  },
  {
    "author": "Steven Tyler",
    "category": "christmas",
    "id": 75525,
    "text": "Why not share with the world the way it is and tell them my feelings about my cat, and how I played with my kids, and how addicted to Christmas time I am, and the smell of pine needles and hearing my kids laugh."
  },
  {
    "author": "Mike Shinoda",
    "category": "christmas",
    "id": 75608,
    "text": "My parents still treat Christmas like I'm thirteen years old."
  },
  {
    "author": "Sloane Crosley",
    "category": "christmas",
    "id": 75554,
    "text": "Brits and Americans have hundreds of different phrases for the same thing. Luckily, it's usually a source of amusement rather than frustration. A flashlight by any other name is still a torch. My personal favourite is 'fairy lights,' which we boringly refer to as 'Christmas lights.'"
  },
  {
    "author": "Mo Rocca",
    "category": "christmas",
    "id": 75586,
    "text": "I love the excess of Christmas. The shopping season that begins in September, the bad pop star recordings of Christmas carols, the decorations that don't know when to come down."
  },
  {
    "author": "Vincent Frank",
    "category": "christmas",
    "id": 75689,
    "text": "I've also committed my time and resources to many local organizations like Christmas in April, Catholic Community Services, and Hudson County Meals on Wheels."
  },
  {
    "author": "Miranda Cosgrove",
    "category": "christmas",
    "id": 75699,
    "text": "My mom is a really good cook. I didn't get the cooking gene, but she cooks this really amazing dinner every Christmas, and that's always really fun."
  },
  {
    "author": "Fred Melamed",
    "category": "christmas",
    "id": 75675,
    "text": "Well, because I have twin seven-year-old boys, I enjoy the gift giving stuff a great deal. We do both Hanukkah and Christmas, so it is a costly, though extremely pleasing proposition."
  },
  {
    "author": "Stephen Leacock",
    "category": "christmas",
    "id": 75470,
    "text": "Now, the essence, the very spirit of Christmas is that we first make believe a thing is so, and lo, it presently turns out to be so."
  },
  {
    "author": "Chris Pine",
    "category": "christmas",
    "id": 75686,
    "text": "For me growing up, Christmas time was always the most fantastic, exciting time of year, and you'd stay up until three in the morning. You'd hear the parents wrapping in the other room but you knew that also, maybe, they were in collusion with Santa Claus."
  },
  {
    "author": "Dave Barry",
    "category": "christmas",
    "id": 75446,
    "text": "Once again, we come to the Holiday Season, a deeply religious time that each of us observes, in his own way, by going to the mall of his choice."
  },
  {
    "author": "John Tesh",
    "category": "christmas",
    "id": 75669,
    "text": "To understand this Christmas record, you have to understand our ministry."
  },
  {
    "author": "Dag Hammarskjold",
    "category": "christmas",
    "id": 75503,
    "text": "Time always seems long to the child who is waiting - for Christmas, for next summer, for becoming a grownup: long also when he surrenders his whole soul to each moment of a happy day."
  },
  {
    "author": "Andrew Lloyd Webber",
    "category": "christmas",
    "id": 75600,
    "text": "I'm going to take the kids away over Christmas but I don't, I've written 14 musicals now, I don't want to rush into doing something just for the sake of doing it. I want to do it when I find a story."
  },
  {
    "author": "Beth Henley",
    "category": "christmas",
    "id": 75647,
    "text": "The next thing I wrote was in a writing class at night school. It was about a poor woman who worked at a dime store and who was all alone for Christmas in Laurel, Mississippi."
  },
  {
    "author": "George Carlin",
    "category": "christmas",
    "id": 75428,
    "text": "The main reason Santa is so jolly is because he knows where all the bad girls live."
  },
  {
    "author": "Richard Roeper",
    "category": "christmas",
    "id": 75516,
    "text": "The truth is that our way of celebrating the Christmas season does spring from myriad cultures and sources, from St. Nicholas to Coca-Cola advertising campaigns."
  },
  {
    "author": "Bill Nighy",
    "category": "christmas",
    "id": 75577,
    "text": "It can't be overstated how wonderful it is not to have to audition any more. Any actor will tell you, it's like Christmas."
  },
  {
    "author": "Martin Freeman",
    "category": "christmas",
    "id": 75515,
    "text": "I've always loved Christmas and that's not really gone away from me from being a child to now. It's always a magical time and I'm unashamed in my love for Christmas."
  },
  {
    "author": "Grazia Deledda",
    "category": "christmas",
    "id": 75543,
    "text": "According to an ancient Sardinian legend, the bodies of those who are born on Christmas Eve will never dissolve into dust but are preserved until the end of time."
  },
  {
    "author": "Caroline Kennedy",
    "category": "christmas",
    "id": 75505,
    "text": "You have to remind kids to stay connected to the meaning of Christmas. Sometimes it takes a little bit of effort, but it's so worth it."
  },
  {
    "author": "Alison Sweeney",
    "category": "christmas",
    "id": 75560,
    "text": "I save every Christmas card. I keep them all."
  },
  {
    "author": "Padma Lakshmi",
    "category": "christmas",
    "id": 75536,
    "text": "You don't want your jewelry to make you look fat. A lot of what's out there now does - you just wind up looking like a Christmas tree."
  },
  {
    "author": "Janet Napolitano",
    "category": "christmas",
    "id": 75607,
    "text": "Now, a lot of what we are doing right now, quite frankly, is because of what happened on Christmas. Many of the things were kind of in the works. We were already planning, for example, the purchase and deployment of advanced imaging technology. You call them body scanners. We call them AITs (Advanced Imaging Technologies)."
  },
  {
    "author": "James McAvoy",
    "category": "christmas",
    "id": 75629,
    "text": "I was talking to one of my aunties at Christmas and she said she didn't think it was ever in my nature to go against the grain, that I was always a good boy. I think she was right - I did always want to be good."
  },
  {
    "author": "Richard Dawkins",
    "category": "christmas",
    "id": 75498,
    "text": "I suppose if you look back to your early childhood you accept everything people tell you, and that includes a heavy dose of irrationality - you're told about tooth fairies and Father Christmas and things."
  },
  {
    "author": "Doug Coupland",
    "category": "christmas",
    "id": 75497,
    "text": "Christmas makes everything twice as sad."
  },
  {
    "author": "Rick Springfield",
    "category": "christmas",
    "id": 75558,
    "text": "The whole point of me doing a Christmas record and what I centered it around was the song 'Christmas with You' from the point-of-view of the soldiers in Iraq."
  },
  {
    "author": "Alfred E. Smith",
    "category": "christmas",
    "id": 75705,
    "text": "No sane local official who has hung up an empty stocking over the municipal fireplace, is going to shoot Santa Claus just before a hard Christmas."
  },
  {
    "author": "Dan Savage",
    "category": "christmas",
    "id": 75504,
    "text": "Christmas can have a real melancholy aspect, 'cause it packages itself as this idea of perfect family cohesion and love, and you're always going to come up short when you measure your personal life against the idealized personal lives that are constantly thrust in our faces, primarily by TV commercials."
  },
  {
    "author": "Isaac Hanson",
    "category": "christmas",
    "id": 75677,
    "text": "There are very few people who have done more than one Christmas album."
  },
  {
    "author": "Henny Youngman",
    "category": "christmas",
    "id": 75449,
    "text": "I once wanted to become an atheist, but I gave up - they have no holidays."
  },
  {
    "author": "Tanya Tucker",
    "category": "christmas",
    "id": 75628,
    "text": "I'd like to do a Christmas album. I've never done a Christmas album."
  },
  {
    "author": "Richard Roeper",
    "category": "christmas",
    "id": 75496,
    "text": "Even though we're a week and a half away from Thanksgiving, it's beginning to look a lot like Christmas."
  },
  {
    "author": "Clement Clarke Moore",
    "category": "christmas",
    "id": 75468,
    "text": "T'was the night before Christmas, when all through the house, not a creature was stirring, not even a mouse."
  },
  {
    "author": "Lewis Black",
    "category": "christmas",
    "id": 75538,
    "text": "Online, there's no time. It's always Christmas."
  },
  {
    "author": "Garrison Keillor",
    "category": "christmas",
    "id": 75443,
    "text": "A lovely thing about Christmas is that it's compulsory, like a thunderstorm, and we all go through it together."
  }
]

quotes['easter'] = [
  {
    "author": "Michael Leunig",
    "category": "easter",
    "id": 75749,
    "text": "Easter is reflecting upon suffering for one thing, but it also reflects upon Jesus and his non compliance in the face of great authority where he holds to his truth - so there's two stories there."
  },
  {
    "author": "John Guare",
    "category": "easter",
    "id": 75746,
    "text": "And it is always Easter Sunday at the New York City Ballet. It is always coming back to life. Not even coming back to life - it lives in the constant present."
  },
  {
    "author": "Basil Hume",
    "category": "easter",
    "id": 75713,
    "text": "The great gift of Easter is hope - Christian hope which makes us have that confidence in God, in his ultimate triumph, and in his goodness and love, which nothing can shake."
  },
  {
    "author": "Amy Sedaris",
    "category": "easter",
    "id": 75728,
    "text": "My mom used to say that Greek Easter was later because then you get stuff cheaper."
  },
  {
    "author": "Jane Elliot",
    "category": "easter",
    "id": 75736,
    "text": "I loved raising my kids. I loved the process, the dirt of it, the tears of it, the frustration of it, Christmas, Easter, birthdays, growth charts, pediatrician appointments. I loved all of it."
  },
  {
    "author": "Robert South",
    "category": "easter",
    "id": 75743,
    "text": "God expects from men something more than at such times, and that it were much to be wished for the credit of their religion as well as the satisfaction of their conscience that their Easter devotions would in some measure come up to their Easter dress."
  },
  {
    "author": "William Tyndale",
    "category": "easter",
    "id": 75733,
    "text": "To see how Christ was prophesied and described therein, consider and mark, how that the kid or lamb must be with out spot or blemish and so was Christ only of all mankind, in the sight of God and of his law."
  },
  {
    "author": "Joel Osteen",
    "category": "easter",
    "id": 75714,
    "text": "People respond when you tell them there is a great future in front of you, you can leave your past behind."
  },
  {
    "author": "Bernhard Langer",
    "category": "easter",
    "id": 75715,
    "text": "To a Christian, Easter Sunday means everything, when we celebrate the resurrection of Jesus Christ."
  },
  {
    "author": "Josh McDowell",
    "category": "easter",
    "id": 75731,
    "text": "Christ appeared alive on several occasions after the cataclysmic events of that first Easter."
  },
  {
    "author": "Pope John Paul II",
    "category": "easter",
    "id": 75712,
    "text": "Do not abandon yourselves to despair. We are the Easter people and hallelujah is our song."
  },
  {
    "author": "William Weld",
    "category": "easter",
    "id": 75744,
    "text": "Do we believe that there is equal economic opportunity out there in the real world, right now, for each and every one of these groups? If we believed in the tooth fairy, if we believed in the Easter Bunny, we might well believe that."
  },
  {
    "author": "Chita Rivera",
    "category": "easter",
    "id": 75745,
    "text": "We were taking collections for people with AIDS in New York around Easter."
  },
  {
    "author": "Marvin Olasky",
    "category": "easter",
    "id": 75740,
    "text": "Passover and Easter are the only Jewish and Christian holidays that move in sync, like the ice skating pairs we saw during the winter Olympics."
  },
  {
    "author": "Leon Uris",
    "category": "easter",
    "id": 75747,
    "text": "I am very proud of this work because it is more about the meaning of the Easter Rising and its relationship to what this whole century has been about, people liberating themselves, freeing themselves."
  },
  {
    "author": "Josh McDowell",
    "category": "easter",
    "id": 75725,
    "text": "The first thing that stuck in the minds of the disciples was not the empty tomb, but rather the empty grave clothes - undisturbed in form and position."
  },
  {
    "author": "T. D. Jakes",
    "category": "easter",
    "id": 75734,
    "text": "Here is the amazing thing about Easter the Resurrection Sunday for Christians is this, that Christ in the dying moments on the cross gives us the greatest illustration of forgiveness possible."
  },
  {
    "author": "Bede Griffiths",
    "category": "easter",
    "id": 75719,
    "text": "God had brought me to my knees and made me acknowledge my own nothingness, and out of that knowledge I had been reborn. I was no longer the centre of my life and therefore I could see God in everything."
  },
  {
    "author": "Daniel Morgan",
    "category": "easter",
    "id": 75726,
    "text": "I believe in one God, the first and great cause of goodness. I also believe in Jesus Christ, the rebirth of the world. I also believe in the Holy Ghost, the comforter."
  },
  {
    "author": "Jacques Pepin",
    "category": "easter",
    "id": 75742,
    "text": "I cooked at the White House for Easter, last year, with Michelle Obama. But it more had to do with cooking from the organic garden, and her message. I took my daughter and granddaughter there, and they were really charming, it was great."
  },
  {
    "author": "Mahatma Gandhi",
    "category": "easter",
    "id": 75709,
    "text": "A man who was completely innocent, offered himself as a sacrifice for the good of others, including his enemies, and became the ransom of the world. It was a perfect act."
  },
  {
    "author": "Ethel Merman",
    "category": "easter",
    "id": 75730,
    "text": "At one time I smoked, but in 1959 I couldn't think of anything else to give up for Lent so I stopped - and I haven't had a cigarette since."
  },
  {
    "author": "Lea DeLaria",
    "category": "easter",
    "id": 75735,
    "text": "What do you mean you don't believe in homosexuality? It's not like the Easter Bunny, your belief isn't necessary."
  },
  {
    "author": "Robert H. Schuller",
    "category": "easter",
    "id": 75716,
    "text": "It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow."
  },
  {
    "author": "Joel Osteen",
    "category": "easter",
    "id": 75717,
    "text": "We were old sinners - but when we came to Christ we are not sinners anymore."
  },
  {
    "author": "Rick Warren",
    "category": "easter",
    "id": 75718,
    "text": "The Bible tells us that Jesus Christ came to do three things. He came to have my past forgiven, you get a purpose for living and a home in Heaven."
  },
  {
    "author": "Julie Burchill",
    "category": "easter",
    "id": 75737,
    "text": "I don't really care what people tell children - when you believe in Santa Claus, the Easter Bunny and the Tooth Fairy, one more fib won't hurt. But I am infuriated by the growing notion, posited in some touchy-feely quarters, that all women are, or can be, beautiful."
  },
  {
    "author": "Dwight L. Moody",
    "category": "easter",
    "id": 75711,
    "text": "We are told to let our light shine, and if it does, we won't need to tell anybody it does. Lighthouses don't fire cannons to call attention to their shining- they just shine."
  },
  {
    "author": "Hugh Mackay",
    "category": "easter",
    "id": 75739,
    "text": "A strangely reflective, even melancholy day. Is that because, unlike our cousins in the northern hemisphere, Easter is not associated with the energy and vitality of spring but with the more subdued spirit of autumn?"
  },
  {
    "author": "Simon Kinberg",
    "category": "easter",
    "id": 75748,
    "text": "I'm Jewish, so I don't know much about Easter eggs."
  },
  {
    "author": "William Barclay",
    "category": "easter",
    "id": 75722,
    "text": "Love always involves responsibility, and love always involves sacrifice. And we do not really love Christ unless we are prepared to face His task and to take up His Cross."
  },
  {
    "author": "Billy Graham",
    "category": "easter",
    "id": 75710,
    "text": "God proved His love on the Cross. When Christ hung, and bled, and died, it was God saying to the world, 'I love you.'"
  },
  {
    "author": "Charles Stanley",
    "category": "easter",
    "id": 75720,
    "text": "The Bible tells us that God will meet all our needs. He feeds the birds of the air and clothes the grass with the splendor of lilies. How much more, then, will He care for us, who are made in His image? Our only concern is to obey the heavenly Father and leave the consequences to Him."
  },
  {
    "author": "E. Stanley Jones",
    "category": "easter",
    "id": 75729,
    "text": "Continuing a Lenten series on prayer: Prayer is co-operation with God. It is the purest exercise of the faculties God has given us - an exercise that links these faculties with the Maker to work out the intentions He had in mind in their creation."
  },
  {
    "author": "Kevin James",
    "category": "easter",
    "id": 75741,
    "text": "I had my boy in Boston on Easter Sunday. That kills me, from a sports perspective. He's a Boston baby and I'm a New York guy."
  },
  {
    "author": "Amy Sedaris",
    "category": "easter",
    "id": 75732,
    "text": "I have always wanted a bunny and I'll always have a rabbit the rest of my life."
  },
  {
    "author": "Deepak Chopra",
    "category": "easter",
    "id": 75721,
    "text": "The symbolic language of the crucifixion is the death of the old paradigm resurrection is a leap into a whole new way of thinking."
  },
  {
    "author": "Reba McEntire",
    "category": "easter",
    "id": 75723,
    "text": "Easter is very important to me, it's a second chance."
  },
  {
    "author": "Todd Rundgren",
    "category": "easter",
    "id": 75738,
    "text": "Most people outside of America won't get it. It's the Easter bunny. It's another lie and I don't understand why we had to invent this character."
  },
  {
    "author": "Keith O'Brien",
    "category": "easter",
    "id": 75724,
    "text": "I know that many of you do wear such a cross of Christ, not in any ostentatious way, not in a way that might harm you at your work or recreation, but a simple indication that you value the role of Jesus Christ in the history of the world, that you are trying to live by Christ's standards in your own daily life."
  },
  {
    "author": "Kenneth Scott Latourette",
    "category": "easter",
    "id": 75727,
    "text": "The primary source of the appeal of Christianity was Jesus - His incarnation, His life, His crucifixion, and His resurrection."
  }
]

quotes['fathersday'] = [
  {
    "author": "George Herbert",
    "category": "fathersday",
    "id": 75758,
    "text": "One father is more than a hundred schoolmasters."
  },
  {
    "author": "Dante Hall",
    "category": "fathersday",
    "id": 75763,
    "text": "I would want my legacy to be that I was a great son, father and friend."
  },
  {
    "author": "Al Unser",
    "category": "fathersday",
    "id": 75755,
    "text": "Dad taught me everything I know. Unfortunately, he didn't teach me everything he knows."
  },
  {
    "author": "Gabriel Garcia Marquez",
    "category": "fathersday",
    "id": 75756,
    "text": "A man knows when he is growing old because he begins to look like his father."
  },
  {
    "author": "Robert Frost",
    "category": "fathersday",
    "id": 75753,
    "text": "You don't have to deserve your mother's love. You have to deserve your father's."
  },
  {
    "author": "Sidney Poitier",
    "category": "fathersday",
    "id": 75757,
    "text": "I decided in my life that I would do nothing that did not reflect positively on my father's life."
  },
  {
    "author": "Gordon Brown",
    "category": "fathersday",
    "id": 75761,
    "text": "I'm a father that's what matters most. Nothing matters more."
  },
  {
    "author": "Conrad Hall",
    "category": "fathersday",
    "id": 75752,
    "text": "Dad, wherever you are, you are gone but you will never be forgotten."
  },
  {
    "author": "Wendell Phillips",
    "category": "fathersday",
    "id": 75762,
    "text": "To be as good as our fathers we must be better, imitation is not discipleship."
  },
  {
    "author": "Kid Rock",
    "category": "fathersday",
    "id": 75760,
    "text": "Being a father helps me be more responsible... you see more things than you've ever seen."
  },
  {
    "author": "Euripides",
    "category": "fathersday",
    "id": 75754,
    "text": "To a father growing old nothing is dearer than a daughter."
  },
  {
    "author": "William Shakespeare",
    "category": "fathersday",
    "id": 75751,
    "text": "It is a wise father that knows his own child."
  },
  {
    "author": "Anne Sexton",
    "category": "fathersday",
    "id": 75759,
    "text": "It doesn't matter who my father was it matters who I remember he was."
  },
  {
    "author": "William Shakespeare",
    "category": "fathersday",
    "id": 75750,
    "text": "When a father gives to his son, both laugh when a son gives to his father, both cry."
  },
  {
    "author": "Olive Schreiner",
    "category": "fathersday",
    "id": 75764,
    "text": "Our fathers had their dreams we have ours the generation that follows will have its own. Without dreams and phantoms man cannot exist."
  }
]

quotes['memorialday'] = [
  {
    "author": "Frank Knox",
    "category": "memorialday",
    "id": 75782,
    "text": "Patriotism was a living fire of unquestioned belief and purpose."
  },
  {
    "author": "Alexander Henry",
    "category": "memorialday",
    "id": 75775,
    "text": "On what rests the hope of the republic? One country, one language, one flag!"
  },
  {
    "author": "Glenn Beck",
    "category": "memorialday",
    "id": 75785,
    "text": "I am going to take something I learned over in Israel. Their Independence Day is preceded the 24 hours before with Memorial Day, so it gives them a chance to serve and reflect and then celebrate. I am going to try to start that tradition here in America."
  },
  {
    "author": "Jennifer M. Granholm",
    "category": "memorialday",
    "id": 75790,
    "text": "Ceremonies are important. But our gratitude has to be more than visits to the troops, and once-a-year Memorial Day ceremonies. We honor the dead best by treating the living well."
  },
  {
    "author": "Robert Charles Winthrop",
    "category": "memorialday",
    "id": 75783,
    "text": "There are no points of the compass on the chart of true patriotism."
  },
  {
    "author": "Michael N. Castle",
    "category": "memorialday",
    "id": 75776,
    "text": "These fallen heroes represent the character of a nation who has a long history of patriotism and honor - and a nation who has fought many battles to keep our country free from threats of terror."
  },
  {
    "author": "Robert Reich",
    "category": "memorialday",
    "id": 75781,
    "text": "True patriotism isn't cheap. It's about taking on a fair share of the burden of keeping America going."
  },
  {
    "author": "Eric Burdon",
    "category": "memorialday",
    "id": 75791,
    "text": "On Memorial Day, I don't want to only remember the combatants. There were also those who came out of the trenches as writers and poets, who started preaching peace, men and women who have made this world a kinder place to live."
  },
  {
    "author": "Robin Hayes",
    "category": "memorialday",
    "id": 75770,
    "text": "Memorial Day this year is especially important as we are reminded almost daily of the great sacrifices that the men and women of the Armed Services make to defend our way of life."
  },
  {
    "author": "Herbert Croly",
    "category": "memorialday",
    "id": 75780,
    "text": "The average American is nothing if not patriotic."
  },
  {
    "author": "Michael Ignatieff",
    "category": "memorialday",
    "id": 75779,
    "text": "There's intense national feeling in America that could be called patriotism."
  },
  {
    "author": "Allen West",
    "category": "memorialday",
    "id": 75788,
    "text": "From 1971 onwards, the Memorial Day holiday was officially observed on the last Monday in May and became the unofficial start of the summer, with barbecues, blockbuster movie openings and mattress sales."
  },
  {
    "author": "Nathan Hale",
    "category": "memorialday",
    "id": 75771,
    "text": "I only regret that I have but one life to lose for my country."
  },
  {
    "author": "Bob Riley",
    "category": "memorialday",
    "id": 75778,
    "text": "I have long believed that sacrifice is the pinnacle of patriotism."
  },
  {
    "author": "Doc Hastings",
    "category": "memorialday",
    "id": 75784,
    "text": "137 years later, Memorial Day remains one of America's most cherished patriotic observances. The spirit of this day has not changed - it remains a day to honor those who died defending our freedom and democracy."
  },
  {
    "author": "Philip James Bailey",
    "category": "memorialday",
    "id": 75777,
    "text": "Man is a military animal, glories in gunpowder, and loves parade."
  },
  {
    "author": "Danica Patrick",
    "category": "memorialday",
    "id": 75789,
    "text": "On Memorial Day, I was out floating on Lake Norman and came across Denny Hamlin. We struck up a conversation, and one of the first things we were talking about was how much it helped him when he started racing the Cup car and how much it helped his Nationwide program."
  },
  {
    "author": "Allen West",
    "category": "memorialday",
    "id": 75786,
    "text": "While there are towns and cities still planning Memorial Day parades, many have not held a parade in decades. Some think the day is for honoring anyone who has died, not just those fallen in service to our country."
  },
  {
    "author": "John F. Kennedy",
    "category": "memorialday",
    "id": 75765,
    "text": "My fellow Americans, ask not what your country can do for you, ask what you can do for your country."
  },
  {
    "author": "John Linder",
    "category": "memorialday",
    "id": 75792,
    "text": "While tributes to Americans who had lost their lives in battle had been held in a number of towns across the nation, one of the more well-known stories about the beginnings of Memorial Day is the story about General John Logan."
  },
  {
    "author": "John M. McHugh",
    "category": "memorialday",
    "id": 75772,
    "text": "As America celebrates Memorial Day, we pay tribute to those who have given their lives in our nation's wars."
  },
  {
    "author": "Mark Twain",
    "category": "memorialday",
    "id": 75766,
    "text": "Patriotism is supporting your country all the time, and your government when it deserves it."
  },
  {
    "author": "James A. Baldwin",
    "category": "memorialday",
    "id": 75768,
    "text": "I love America more than any other country in this world, and, exactly for this reason, I insist on the right to criticize her perpetually."
  },
  {
    "author": "Paddy Chayefsky",
    "category": "memorialday",
    "id": 75793,
    "text": "It's always the generals with the bloodiest records who are the first to shout what a hell it is. And it's always the war widows who lead the Memorial Day parades."
  },
  {
    "author": "George Washington",
    "category": "memorialday",
    "id": 75767,
    "text": "Guard against the impostures of pretended patriotism."
  },
  {
    "author": "William J. Clinton",
    "category": "memorialday",
    "id": 75773,
    "text": "There is nothing wrong with America that cannot be cured with what is right in America."
  },
  {
    "author": "James Bryce",
    "category": "memorialday",
    "id": 75774,
    "text": "Patriotism consists not in waving the flag, but in striving that our country shall be righteous as well as strong."
  },
  {
    "author": "George William Curtis",
    "category": "memorialday",
    "id": 75769,
    "text": "A man's country is not a certain area of land, of mountains, rivers, and woods, but it is a principle and patriotism is loyalty to that principle."
  },
  {
    "author": "Allen West",
    "category": "memorialday",
    "id": 75787,
    "text": "Nowadays, many Americans have forgotten the meaning and traditions of Memorial Day. At cemeteries across the country, the graves of the fallen are sadly ignored, and worse, neglected."
  }
]

quotes['mothersday'] = [
  {
    "author": "Samuel Taylor Coleridge",
    "category": "mothersday",
    "id": 75808,
    "text": "The love of a mother is the veil of a softer light between the heart and the heavenly Father."
  },
  {
    "author": "Leonardo DiCaprio",
    "category": "mothersday",
    "id": 75815,
    "text": "My mother is a walking miracle."
  },
  {
    "author": "George Eliot",
    "category": "mothersday",
    "id": 75804,
    "text": "Life began with waking up and loving my mother's face."
  },
  {
    "author": "Theodore Hesburgh",
    "category": "mothersday",
    "id": 75796,
    "text": "The most important thing a father can do for his children is to love their mother."
  },
  {
    "author": "Isadora Duncan",
    "category": "mothersday",
    "id": 75812,
    "text": "With what price we pay for the glory of motherhood."
  },
  {
    "author": "William Makepeace Thackeray",
    "category": "mothersday",
    "id": 75797,
    "text": "Mother is the name for God in the lips and hearts of little children."
  },
  {
    "author": "Victor Hugo",
    "category": "mothersday",
    "id": 75798,
    "text": "A mother's arms are made of tenderness and children sleep soundly in them."
  },
  {
    "author": "Abraham Lincoln",
    "category": "mothersday",
    "id": 75794,
    "text": "All that I am, or hope to be, I owe to my angel mother."
  },
  {
    "author": "Billy Sunday",
    "category": "mothersday",
    "id": 75809,
    "text": "There is nothing in the world of art like the songs mother used to sing."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "mothersday",
    "id": 75805,
    "text": "The babe at first feeds upon the mother's bosom, but it is always on her heart."
  },
  {
    "author": "Honore de Balzac",
    "category": "mothersday",
    "id": 75803,
    "text": "A mother's happiness is like a beacon, lighting up the future but reflected also on the past in the guise of fond memories."
  },
  {
    "author": "Barbara Kingsolver",
    "category": "mothersday",
    "id": 75811,
    "text": "Sometimes the strength of motherhood is greater than natural laws."
  },
  {
    "author": "Rudyard Kipling",
    "category": "mothersday",
    "id": 75799,
    "text": "God could not be everywhere, and therefore he made mothers."
  },
  {
    "author": "Antonio Villaraigosa",
    "category": "mothersday",
    "id": 75801,
    "text": "I got to grow up with a mother who taught me to believe in me."
  },
  {
    "author": "Gloria Estefan",
    "category": "mothersday",
    "id": 75813,
    "text": "Motherhood is... difficult and... rewarding."
  },
  {
    "author": "Abraham Lincoln",
    "category": "mothersday",
    "id": 75795,
    "text": "I remember my mother's prayers and they have always followed me. They have clung to me all my life."
  },
  {
    "author": "Alicia Keys",
    "category": "mothersday",
    "id": 75816,
    "text": "My mom is definitely my rock."
  },
  {
    "author": "Donald E. Westlake",
    "category": "mothersday",
    "id": 75817,
    "text": "Who's a boy gonna talk to if not his mother?"
  },
  {
    "author": "Robert Browning",
    "category": "mothersday",
    "id": 75810,
    "text": "Motherhood: All love begins and ends there."
  },
  {
    "author": "Martina Hingis",
    "category": "mothersday",
    "id": 75814,
    "text": "I was always at peace because of the way my mom treated me."
  },
  {
    "author": "Erich Fromm",
    "category": "mothersday",
    "id": 75800,
    "text": "Mother's love is peace. It need not be acquired, it need not be deserved."
  },
  {
    "author": "Sophocles",
    "category": "mothersday",
    "id": 75802,
    "text": "Children are the anchors of a mother's life."
  },
  {
    "author": "Stevie Wonder",
    "category": "mothersday",
    "id": 75806,
    "text": "Mama was my greatest teacher, a teacher of compassion, love and fearlessness. If love is sweet as a flower, then my mother is that sweet flower of love."
  },
  {
    "author": "Gracie Allen",
    "category": "mothersday",
    "id": 75807,
    "text": "When my mother had to get dinner for 8 she'd just make enough for 16 and only serve half."
  }
]

quotes['newyears'] = [
  {
    "author": "Barbara Walters",
    "category": "newyears",
    "id": 75846,
    "text": "Deep breaths are very helpful at shallow parties."
  },
  {
    "author": "Ralph Waldo Emerson",
    "category": "newyears",
    "id": 75818,
    "text": "Write it on your heart that every day is the best day in the year."
  },
  {
    "author": "E. W. Howe",
    "category": "newyears",
    "id": 75847,
    "text": "To be an ideal guest, stay at home."
  },
  {
    "author": "W. C. Fields",
    "category": "newyears",
    "id": 75826,
    "text": "I never worry about being driven to drink I just worry about being driven home."
  },
  {
    "author": "Paris Hilton",
    "category": "newyears",
    "id": 75836,
    "text": "I get half a million just to show up at parties. My life is, like, really, really fun."
  },
  {
    "author": "Kim Kardashian",
    "category": "newyears",
    "id": 75833,
    "text": "I don't even drink! I can't stand the taste of alcohol. Every New Year's Eve I try one drink and every time it makes me feel sick. So I don't touch booze - I'm always the designated driver."
  },
  {
    "author": "Carl Sandburg",
    "category": "newyears",
    "id": 75839,
    "text": "I doubt if you can have a truly wild party without liquor."
  },
  {
    "author": "Ben Stiller",
    "category": "newyears",
    "id": 75851,
    "text": "My parents used to throw great New Year's Eve parties. They invited such an eclectic mix of showbiz people. All those cool people were always hanging out at our apartment."
  },
  {
    "author": "Samuel Pepys",
    "category": "newyears",
    "id": 75852,
    "text": "Strange to see how a good dinner and feasting reconciles everybody."
  },
  {
    "author": "F. Scott Fitzgerald",
    "category": "newyears",
    "id": 75828,
    "text": "First you take a drink, then the drink takes a drink, then the drink takes you."
  },
  {
    "author": "Mary-Kate Olsen",
    "category": "newyears",
    "id": 75853,
    "text": "I like to go to parties where I know everyone. How are you going to have fun with people you don't know?"
  },
  {
    "author": "W. Somerset Maugham",
    "category": "newyears",
    "id": 75834,
    "text": "At a dinner party one should eat wisely but not too well, and talk well but not too wisely."
  },
  {
    "author": "Tom Peters",
    "category": "newyears",
    "id": 75831,
    "text": "Celebrate what you want to see more of."
  },
  {
    "author": "Wally Lamb",
    "category": "newyears",
    "id": 75850,
    "text": "Accept what people offer. Drink their milkshakes. Take their love."
  },
  {
    "author": "Aeschylus",
    "category": "newyears",
    "id": 75844,
    "text": "What is there more kindly than the feeling between host and guest?"
  },
  {
    "author": "Jonathan Edwards",
    "category": "newyears",
    "id": 75824,
    "text": "Resolution One: I will live for God. Resolution Two: If no one else does, I still will."
  },
  {
    "author": "Walter Scott",
    "category": "newyears",
    "id": 75843,
    "text": "Each age has deemed the new-born year the fittest time for festal cheer."
  },
  {
    "author": "Steven Spielberg",
    "category": "newyears",
    "id": 75825,
    "text": "All of us every single year, we're a different person. I don't think we're the same person all our lives."
  },
  {
    "author": "Debbie Harry",
    "category": "newyears",
    "id": 75848,
    "text": "I've had some lovely extraordinary experiences on New Year's Eve."
  },
  {
    "author": "William Shakespeare",
    "category": "newyears",
    "id": 75820,
    "text": "Come, gentlemen, I hope we shall drink down all unkindness."
  },
  {
    "author": "Natalie Portman",
    "category": "newyears",
    "id": 75849,
    "text": "Going to a party, for me, is as much a learning experience as, you know, sitting in a lecture."
  },
  {
    "author": "Akhenaton",
    "category": "newyears",
    "id": 75838,
    "text": "Those who gave thee a body, furnished it with weakness but He who gave thee Soul, armed thee with resolution. Employ it, and thou art wise be wise and thou art happy."
  },
  {
    "author": "Goran Persson",
    "category": "newyears",
    "id": 75823,
    "text": "Let our New Year's resolution be this: we will be there for one another as fellow members of humanity, in the finest sense of the word."
  },
  {
    "author": "Phil McGraw",
    "category": "newyears",
    "id": 75845,
    "text": "A year from now, you're gonna weigh more or less than what you do right now."
  },
  {
    "author": "James Agate",
    "category": "newyears",
    "id": 75822,
    "text": "New Year's Resolution: To tolerate fools more gladly, provided this does not encourage them to take up more of my time."
  },
  {
    "author": "William Makepeace Thackeray",
    "category": "newyears",
    "id": 75841,
    "text": "Dinner was made for eating, not for talking."
  },
  {
    "author": "Bobby Bowden",
    "category": "newyears",
    "id": 75840,
    "text": "To have the kind of year you want to have, something has to happen that you can't explain why it happened. Something has to happen that you can't coach."
  },
  {
    "author": "Cyril Cusack",
    "category": "newyears",
    "id": 75837,
    "text": "If you asked me for my New Year Resolution, it would be to find out who I am."
  },
  {
    "author": "Catherine O'Hara",
    "category": "newyears",
    "id": 75842,
    "text": "I know. I'm lazy. But I made myself a New Years resolution that I would write myself something really special. Which means I have 'til December, right?"
  },
  {
    "author": "Cavett Robert",
    "category": "newyears",
    "id": 75827,
    "text": "Character is the ability to carry out a good resolution long after the excitement of the moment has passed."
  },
  {
    "author": "Mark Twain",
    "category": "newyears",
    "id": 75821,
    "text": "Sometimes too much to drink is barely enough."
  },
  {
    "author": "P. J. O'Rourke",
    "category": "newyears",
    "id": 75829,
    "text": "If you are young and you drink a great deal it will spoil your health, slow your mind, make you fat - in other words, turn you into an adult."
  },
  {
    "author": "Tucker Carlson",
    "category": "newyears",
    "id": 75832,
    "text": "I have no way of knowing how people really feel, but the vast majority of those I meet couldn't be nicer. Every once in a while someone barks at me. My New Year's resolution is not to bark back."
  },
  {
    "author": "Robert Fulghum",
    "category": "newyears",
    "id": 75830,
    "text": "If you want an interesting party sometime, combine cocktails and a fresh box of crayons for everyone."
  },
  {
    "author": "Helen Keller",
    "category": "newyears",
    "id": 75819,
    "text": "Your success and happiness lies in you. Resolve to keep happy, and your joy and you shall form an invincible host against difficulties."
  },
  {
    "author": "Mason Cooley",
    "category": "newyears",
    "id": 75835,
    "text": "Good parties create a temporary youthfulness."
  }
]

quotes['saintpatricksday'] = [
  {
    "author": "James Joyce",
    "category": "saintpatricksday",
    "id": 75862,
    "text": "Ireland sober is Ireland stiff."
  },
  {
    "author": "Dave Barry",
    "category": "saintpatricksday",
    "id": 75859,
    "text": "Geographically, Ireland is a medium-sized rural island that is slowly but steadily being consumed by sheep."
  },
  {
    "author": "Colin Farrell",
    "category": "saintpatricksday",
    "id": 75858,
    "text": "Being Irish is very much a part of who I am. I take it everywhere with me."
  },
  {
    "author": "Winston Churchill",
    "category": "saintpatricksday",
    "id": 75854,
    "text": "We have always found the Irish a bit odd. They refuse to be English."
  },
  {
    "author": "Brendan Behan",
    "category": "saintpatricksday",
    "id": 75857,
    "text": "If it was raining soup, the Irish would go out with forks."
  },
  {
    "author": "Fiona Shaw",
    "category": "saintpatricksday",
    "id": 75865,
    "text": "A lot of Irish people perform. They perform in drawing rooms. They sing songs and they play piano."
  },
  {
    "author": "Pope John Paul II",
    "category": "saintpatricksday",
    "id": 75856,
    "text": "Love is never defeated, and I could add, the history of Ireland proves it."
  },
  {
    "author": "Liam Neeson",
    "category": "saintpatricksday",
    "id": 75860,
    "text": "Some mornings you wake up and think, gee I look handsome today. Other days I think, what am I doing in the movies? I wanna go back to Ireland and drive a forklift."
  },
  {
    "author": "Lara Flynn Boyle",
    "category": "saintpatricksday",
    "id": 75863,
    "text": "That's what the holidays are for - for one person to tell the stories and another to dispute them. Isn't that the Irish way?"
  },
  {
    "author": "William Butler Yeats",
    "category": "saintpatricksday",
    "id": 75855,
    "text": "Being Irish, he had an abiding sense of tragedy, which sustained him through temporary periods of joy."
  },
  {
    "author": "John Millington Synge",
    "category": "saintpatricksday",
    "id": 75864,
    "text": "There is no language like the Irish for soothing and quieting."
  },
  {
    "author": "Shane Leslie",
    "category": "saintpatricksday",
    "id": 75861,
    "text": "Every St. Patrick's Day every Irishman goes out to find another Irishman to make a speech to."
  }
]

quotes['thanksgiving'] = [
  {
    "author": "Stephen Evans",
    "category": "thanksgiving",
    "id": 75919,
    "text": "Thanksgiving is nothing but a toast to genocide."
  },
  {
    "author": "Todd Barry",
    "category": "thanksgiving",
    "id": 75891,
    "text": "I love chicken. I would eat chicken fingers on Thanksgiving if it were socially acceptable."
  },
  {
    "author": "W. Clement Stone",
    "category": "thanksgiving",
    "id": 75873,
    "text": "If you are really thankful, what do you do? You share."
  },
  {
    "author": "John Hughes",
    "category": "thanksgiving",
    "id": 75896,
    "text": "It's like being at the kids' table at Thanksgiving - you can put your elbows on it, you don't have to talk politics... no matter how old I get, there's always a part of me that's sitting there."
  },
  {
    "author": "John Clayton",
    "category": "thanksgiving",
    "id": 75901,
    "text": "There is no racial or ethnic involvement in Thanksgiving, and people who may be very distant from the Christian system can see the beauty and the positive spirit that comes from the holiday."
  },
  {
    "author": "Ina Garten",
    "category": "thanksgiving",
    "id": 75890,
    "text": "If you think about a Thanksgiving dinner, it's really like making a large chicken."
  },
  {
    "author": "Phyllis Diller",
    "category": "thanksgiving",
    "id": 75875,
    "text": "My cooking is so bad my kids thought Thanksgiving was to commemorate Pearl Harbor."
  },
  {
    "author": "Joe Nichols",
    "category": "thanksgiving",
    "id": 75906,
    "text": "I love Halloween, trick or treating and decorating the house. And I love Thanksgiving, because of the football and the fall weather. And of course, I love Christmas - that's my favorite of all!"
  },
  {
    "author": "Evan Davis",
    "category": "thanksgiving",
    "id": 75902,
    "text": "Black Friday is not another bad hair day in Wall Street. It's the term used by American retailers to describe the day after the Thanksgiving Holiday, seen as the semi-official start of Christmas shopping season."
  },
  {
    "author": "Michael Symon",
    "category": "thanksgiving",
    "id": 75889,
    "text": "My restaurants are never opened on Thanksgiving I want my staff to spend time with their family if they can. My feeling is, if I can't figure out how to make money the rest of the year so that my workers can enjoy the holidays, then I don't deserve to be an owner."
  },
  {
    "author": "Hank Azaria",
    "category": "thanksgiving",
    "id": 75914,
    "text": "The craft Emmys are kind of the kids' table at Thanksgiving. You're not really invited to the big dance. It's still really, really exciting, and the statue still counts."
  },
  {
    "author": "Joseph Auslander",
    "category": "thanksgiving",
    "id": 75874,
    "text": "Dear Lord we beg but one boon more: Peace in the hearts of all men living, peace in the whole world this Thanksgiving."
  },
  {
    "author": "William Blake",
    "category": "thanksgiving",
    "id": 75868,
    "text": "The thankful receiver bears a plentiful harvest."
  },
  {
    "author": "John Clayton",
    "category": "thanksgiving",
    "id": 75907,
    "text": "Christmas is the antithesis of Thanksgiving. Christmas is pretty much a man-made holiday."
  },
  {
    "author": "Richie Sambora",
    "category": "thanksgiving",
    "id": 75916,
    "text": "I've spent a lot of Thanksgivings on the road with my band, so anytime that I can spend Thanksgiving with my family in a traditional aspect, eating sweet potatoes and cranberries and stuffing and all the trappings of Thanksgiving and then get on a treadmill the next day extra long, I'm happy."
  },
  {
    "author": "Henry Ward Beecher",
    "category": "thanksgiving",
    "id": 75887,
    "text": "Pride slays thanksgiving, but a humble mind is the soil out of which thanks naturally grow. A proud man is seldom a grateful man, for he never thinks he gets as much as he deserves."
  },
  {
    "author": "John Clayton",
    "category": "thanksgiving",
    "id": 75886,
    "text": "Thanksgiving is a time when the world gets to see just how blessed and how workable the Christian system is. The emphasis is not on giving or buying, but on being thankful and expressing that appreciation to God and to one another."
  },
  {
    "author": "Jon Stewart",
    "category": "thanksgiving",
    "id": 75867,
    "text": "I celebrated Thanksgiving in an old-fashioned way. I invited everyone in my neighborhood to my house, we had an enormous feast, and then I killed them and took their land."
  },
  {
    "author": "Ted Allen",
    "category": "thanksgiving",
    "id": 75903,
    "text": "Not to sound too much like Christopher Guest in 'Waiting for Guffman,' but on Thanksgiving you're putting on a show!"
  },
  {
    "author": "Bob Wells",
    "category": "thanksgiving",
    "id": 75923,
    "text": "In our family, mom and dad are Longhorns, our first two kids are Aggies and we're hoping our last one is a Longhorn. It gives us family fun on Thanksgiving Day."
  },
  {
    "author": "John Clayton",
    "category": "thanksgiving",
    "id": 75895,
    "text": "Christians were instructed to serve others, and the thanksgiving was for the grace of God and the fact that God offered a way for man to return to a positive relationship with Him."
  },
  {
    "author": "Rodney Atkins",
    "category": "thanksgiving",
    "id": 75917,
    "text": "I am so excited this year getting to play the 85th Anniversary Macy's Thanksgiving Day Parade. Everyone knows on Thanksgiving morning to get up, turn on the TV and watch the parade, so to be an actual participant is going to be fun and I'm looking forward to it. I am gonna have to put on my deer hunting gear, though, to stay warm!"
  },
  {
    "author": "Oprah Winfrey",
    "category": "thanksgiving",
    "id": 75866,
    "text": "Be thankful for what you have you'll end up having more. If you concentrate on what you don't have, you will never, ever have enough."
  },
  {
    "author": "O. Henry",
    "category": "thanksgiving",
    "id": 75872,
    "text": "There is one day that is ours. Thanksgiving Day is the one day that is purely American."
  },
  {
    "author": "Michael Symon",
    "category": "thanksgiving",
    "id": 75912,
    "text": "I don't think any other holiday embraces the food of the Midwest quite like Thanksgiving. There's roasted meat and mashed potatoes. But being here is also about heritage. Cleveland is really a giant melting pot - not only is my family a melting pot, but so is the city."
  },
  {
    "author": "Kin Hubbard",
    "category": "thanksgiving",
    "id": 75892,
    "text": "A lot of Thanksgiving days have been ruined by not carving the turkey in the kitchen."
  },
  {
    "author": "Frank A. Clark",
    "category": "thanksgiving",
    "id": 75883,
    "text": "If a fellow isn't thankful for what he's got, he isn't likely to be thankful for what he's going to get."
  },
  {
    "author": "Ted Allen",
    "category": "thanksgiving",
    "id": 75898,
    "text": "My whole problem is that all of my favorite things at Thanksgiving are the starches, and everyone is trying to go low-carb this year, even a green vegetable has carbs in it."
  },
  {
    "author": "Irv Kupcinet",
    "category": "thanksgiving",
    "id": 75884,
    "text": "An optimist is a person who starts a new diet on Thanksgiving Day."
  },
  {
    "author": "Konrad von Gesner",
    "category": "thanksgiving",
    "id": 75876,
    "text": "Best of all is it to preserve everything in a pure, still heart, and let there be for every pulse a thanksgiving, and for every breath a song."
  },
  {
    "author": "Kurt Busch",
    "category": "thanksgiving",
    "id": 75899,
    "text": "Over the Thanksgiving holiday I took time to reflect on what is most important to me and realized I need to find a way to put the fun back into racing."
  },
  {
    "author": "Merle Shain",
    "category": "thanksgiving",
    "id": 75922,
    "text": "The act is unjustifiable that either begs for a blessing, or, having succeeded gives no thanksgiving."
  },
  {
    "author": "Jennifer M. Granholm",
    "category": "thanksgiving",
    "id": 75910,
    "text": "As governor, when I visited our troops in Kuwait and Iraq, I served them Thanksgiving dinner. It was a small gesture compared to their sacrifice."
  },
  {
    "author": "Algernon Charles Swinburne",
    "category": "thanksgiving",
    "id": 75893,
    "text": "From too much love of living, From hope and fear set free, We thank with brief thanksgiving Whatever gods may be That no life lives for ever That dead men rise up never That even the weariest river Winds somewhere safe to sea."
  },
  {
    "author": "Gary Vaynerchuk",
    "category": "thanksgiving",
    "id": 75905,
    "text": "As much as I love crisp, clean whites, there's always a time for rich but balanced Chardonnays with oak, especially at Thanksgiving."
  },
  {
    "author": "Lily Aldridge",
    "category": "thanksgiving",
    "id": 75921,
    "text": "I think I'm going to give my baby her first food on Thanksgiving, make her some organic sweet potato. I'm very excited! It's going to be a big day and my husband is in charge of the turkey - he's the chef of the family!"
  },
  {
    "author": "Storm Jameson",
    "category": "thanksgiving",
    "id": 75877,
    "text": "For what I have received may the Lord make me truly thankful. And more truly for what I have not received."
  },
  {
    "author": "Ina Garten",
    "category": "thanksgiving",
    "id": 75909,
    "text": "I absolutely adore Thanksgiving. It's the only holiday I insist on making myself."
  },
  {
    "author": "Henry Van Dyke",
    "category": "thanksgiving",
    "id": 75869,
    "text": "Gratitude is the inward feeling of kindness received. Thankfulness is the natural impulse to express that feeling. Thanksgiving is the following of that impulse."
  },
  {
    "author": "Tony Snow",
    "category": "thanksgiving",
    "id": 75882,
    "text": "If you think Independence Day is America's defining holiday, think again. Thanksgiving deserves that title, hands-down."
  },
  {
    "author": "Jesse Tyler Ferguson",
    "category": "thanksgiving",
    "id": 75920,
    "text": "Something I didn't even know was on my bucket list has been achieved. I have cooked Thanksgiving dinner with Martha Stewart. I vow to follow the gospel of her teachings and do my very best in the remarkably less glamorous kitchen of my own home... without the luxury of magically appearing prep bowls filled by a staff of sous chefs."
  },
  {
    "author": "Carol Alt",
    "category": "thanksgiving",
    "id": 75913,
    "text": "I never drank except a couple sips of wine at Thanksgiving."
  },
  {
    "author": "Sandra Lee",
    "category": "thanksgiving",
    "id": 75897,
    "text": "Christmas is more stressful with present buying and making sure everyone gets included, but Thanksgiving is really not that. I don't ever really get stressed out about the food."
  },
  {
    "author": "John Clayton",
    "category": "thanksgiving",
    "id": 75908,
    "text": "Thanksgiving is a season that is very much in accord with the themes and teachings of Jesus Christ."
  },
  {
    "author": "Katharine McPhee",
    "category": "thanksgiving",
    "id": 75915,
    "text": "My fondest memories are generally the day after Thanksgiving. I get the total decorating Christmas itch."
  },
  {
    "author": "David Letterman",
    "category": "thanksgiving",
    "id": 75900,
    "text": "It's so warm now, and Thanksgiving came so early - is it just me, or does it not really feel like Ramadan?"
  },
  {
    "author": "Al Green",
    "category": "thanksgiving",
    "id": 75881,
    "text": "I'm thankful for every moment."
  },
  {
    "author": "Bob Schieffer",
    "category": "thanksgiving",
    "id": 75894,
    "text": "The truth is the Super Bowl long ago became more than just a football game. It's part of our culture like turkey at Thanksgiving and lights at Christmas, and like those holidays beyond their meaning, a factor in our economy."
  },
  {
    "author": "Beth Ditto",
    "category": "thanksgiving",
    "id": 75904,
    "text": "As a kid, I was always mad - just noticing the women at Thanksgiving, running around the kitchen, while the men were watching football. For one, I don't want to cook, and for two, I hate football. I was stuck in the middle."
  },
  {
    "author": "Marc Forgione",
    "category": "thanksgiving",
    "id": 75924,
    "text": "I have nothing against turkey. We eat turkey for Thanksgiving in my house."
  },
  {
    "author": "James Patterson",
    "category": "thanksgiving",
    "id": 75918,
    "text": "Always expect the unexpected. Right around Thanksgiving, when the new Alex Cross will be out. It's called Four Blind Mice and it's a pretty amazing story about several murders inside the military."
  },
  {
    "author": "Franz Grillparzer",
    "category": "thanksgiving",
    "id": 75885,
    "text": "Drink and be thankful to the host! What seems insignificant when you have it, is important when you need it."
  },
  {
    "author": "Richard Roeper",
    "category": "thanksgiving",
    "id": 75880,
    "text": "Even though we're a week and a half away from Thanksgiving, it's beginning to look a lot like Christmas."
  },
  {
    "author": "Cindy Margolis",
    "category": "thanksgiving",
    "id": 75911,
    "text": "My favorite meal is turkey and mashed potatoes. I love Thanksgiving, it's just my favorite. I can have Thanksgiving all year round."
  },
  {
    "author": "Victor Hugo",
    "category": "thanksgiving",
    "id": 75871,
    "text": "To give thanks in solitude is enough. Thanksgiving has wings and goes where it must go. Your prayer knows much more about it than you do."
  },
  {
    "author": "Marilu Henner",
    "category": "thanksgiving",
    "id": 75879,
    "text": "It is now common knowledge that the average American gains 7 pounds between Thanksgiving and New Year's Day."
  },
  {
    "author": "Kevin James",
    "category": "thanksgiving",
    "id": 75878,
    "text": "Thanksgiving, man. Not a good day to be my pants."
  },
  {
    "author": "Erma Bombeck",
    "category": "thanksgiving",
    "id": 75870,
    "text": "Thanksgiving dinners take eighteen hours to prepare. They are consumed in twelve minutes. Half-times take twelve minutes. This is not coincidence."
  },
  {
    "author": "Bobby Jindal",
    "category": "thanksgiving",
    "id": 75888,
    "text": "On Thanksgiving I will stop to give thanks that my family is safe and healthy, especially because I realize that, following the tragedies of this year, it is all too real a possibility that they might not have been."
  }
]

quotes['valentinesday'] = [
  {
    "author": "Coco Chanel",
    "category": "valentinesday",
    "id": 75927,
    "text": "A girl should be two things: classy and fabulous."
  },
  {
    "author": "Emma Goldman",
    "category": "valentinesday",
    "id": 75936,
    "text": "I'd rather have roses on my table than diamonds on my neck."
  },
  {
    "author": "Henri de Toulouse-Lautrec",
    "category": "valentinesday",
    "id": 75963,
    "text": "Love is when the desire to be desired takes you so badly that you feel you could die of it."
  },
  {
    "author": "Margaret Atwood",
    "category": "valentinesday",
    "id": 75938,
    "text": "The Eskimos had fifty-two names for snow because it was important to them: there ought to be as many for love."
  },
  {
    "author": "Willa Cather",
    "category": "valentinesday",
    "id": 75937,
    "text": "Where there is great love, there are always wishes."
  },
  {
    "author": "Samuel Butler",
    "category": "valentinesday",
    "id": 75934,
    "text": "It is better to have loved and lost than never to have lost at all."
  },
  {
    "author": "Donatella Versace",
    "category": "valentinesday",
    "id": 75961,
    "text": "I like perfume and flowers."
  },
  {
    "author": "Esai Morales",
    "category": "valentinesday",
    "id": 75947,
    "text": "I love bringing roses to a woman when she least expects it."
  },
  {
    "author": "Marie von Ebner-Eschenbach",
    "category": "valentinesday",
    "id": 75955,
    "text": "We don't believe in rheumatism and true love until after the first attack."
  },
  {
    "author": "Zsa Zsa Gabor",
    "category": "valentinesday",
    "id": 75946,
    "text": "I want a man who's kind and understanding. Is that too much to ask of a millionaire?"
  },
  {
    "author": "Percy Bysshe Shelley",
    "category": "valentinesday",
    "id": 75950,
    "text": "Soul meets soul on lovers' lips."
  },
  {
    "author": "Robert Browning",
    "category": "valentinesday",
    "id": 75948,
    "text": "So, fall asleep love, loved by me... for I know love, I am loved by thee."
  },
  {
    "author": "Erich Segal",
    "category": "valentinesday",
    "id": 75940,
    "text": "True love comes quietly, without banners or flashing lights. If you hear bells, get your ears checked."
  },
  {
    "author": "Luciano De Crescenzo",
    "category": "valentinesday",
    "id": 75957,
    "text": "We are each of us angels with only one wing, and we can only fly by embracing one another."
  },
  {
    "author": "John Keats",
    "category": "valentinesday",
    "id": 75941,
    "text": "Now a soft kiss - Aye, by that kiss, I vow an endless bliss."
  },
  {
    "author": "Will Estes",
    "category": "valentinesday",
    "id": 75953,
    "text": "I'm into all that sappy stuff - a surprise picnic, nice dinner, or traveling. I'm kind of an old romantic."
  },
  {
    "author": "Laurence J. Peter",
    "category": "valentinesday",
    "id": 75954,
    "text": "It's better to have loved and lost than to have to do forty pounds of laundry a week."
  },
  {
    "author": "W. H. Auden",
    "category": "valentinesday",
    "id": 75933,
    "text": "I'll love you, dear, I'll love you till China and Africa meet and the river jumps over the mountain and the salmon sing in the street."
  },
  {
    "author": "Ethel Merman",
    "category": "valentinesday",
    "id": 75958,
    "text": "Everything's coming up roses - for me."
  },
  {
    "author": "Jennifer Aniston",
    "category": "valentinesday",
    "id": 75929,
    "text": "The best smell in the world is that man that you love."
  },
  {
    "author": "Cher",
    "category": "valentinesday",
    "id": 75939,
    "text": "Husbands are like fires - they go out when they're left unattended."
  },
  {
    "author": "Frank Morgan",
    "category": "valentinesday",
    "id": 75935,
    "text": "A heart is not judged by how much you love, but by how much you are loved by others."
  },
  {
    "author": "Maya Angelou",
    "category": "valentinesday",
    "id": 75925,
    "text": "If you have only one smile in you give it to the people you love."
  },
  {
    "author": "Thomas Moore",
    "category": "valentinesday",
    "id": 75931,
    "text": "A friendship that like love is warm A love like friendship, steady."
  },
  {
    "author": "Fred Allen",
    "category": "valentinesday",
    "id": 75949,
    "text": "The last time I saw him he was walking down lover's lane holding his own hand."
  },
  {
    "author": "Cameron Diaz",
    "category": "valentinesday",
    "id": 75951,
    "text": "I'd kiss a frog even if there was no promise of a Prince Charming popping out of it. I love frogs."
  },
  {
    "author": "Anna Held",
    "category": "valentinesday",
    "id": 75952,
    "text": "Some women flirt more with what they say, and some with what they do."
  },
  {
    "author": "Christopher Plummer",
    "category": "valentinesday",
    "id": 75966,
    "text": "Working with Julie Andrews is like getting hit over the head with a valentine."
  },
  {
    "author": "Jackie Gleason",
    "category": "valentinesday",
    "id": 75956,
    "text": "How sweet it is!"
  },
  {
    "author": "Jay Leno",
    "category": "valentinesday",
    "id": 75942,
    "text": "Today is Valentine's Day - or, as men like to call it, Extortion Day!"
  },
  {
    "author": "Susie Bright",
    "category": "valentinesday",
    "id": 75960,
    "text": "I'm like the kid in kindergarten I really do send valentines to everyone."
  },
  {
    "author": "Jeremy London",
    "category": "valentinesday",
    "id": 75965,
    "text": "I used to be a hopeless romantic - I fell in love with everyone I went out with."
  },
  {
    "author": "Julie Andrews",
    "category": "valentinesday",
    "id": 75945,
    "text": "Sometimes I'm so sweet even I can't stand it."
  },
  {
    "author": "Drew Barrymore",
    "category": "valentinesday",
    "id": 75944,
    "text": "I love romance. I'm a sucker for it. I love it so much. It's pathetic."
  },
  {
    "author": "Christopher Marlowe",
    "category": "valentinesday",
    "id": 75932,
    "text": "Money can't buy love, but it improves your bargaining position."
  },
  {
    "author": "e. e. cummings",
    "category": "valentinesday",
    "id": 75943,
    "text": "Kisses are a better fate than wisdom."
  },
  {
    "author": "Lord Byron",
    "category": "valentinesday",
    "id": 75930,
    "text": "Love will find a way through paths where wolves fear to prey."
  },
  {
    "author": "Blaise Pascal",
    "category": "valentinesday",
    "id": 75928,
    "text": "The heart has its reasons of which reason knows nothing."
  },
  {
    "author": "Amy Poehler",
    "category": "valentinesday",
    "id": 75959,
    "text": "In a recent Valentine's Day posting on her fan website, Britney Spears says that - oh, who cares?"
  },
  {
    "author": "Charles M. Schulz",
    "category": "valentinesday",
    "id": 75926,
    "text": "All you need is love. But a little chocolate now and then doesn't hurt."
  },
  {
    "author": "Hugh Grant",
    "category": "valentinesday",
    "id": 75964,
    "text": "I'm a laugh tart. I make no secret of that fact."
  },
  {
    "author": "Fernando Pessoa",
    "category": "valentinesday",
    "id": 75962,
    "text": "Look, there's no metaphysics on earth like chocolates."
  }
]

export default quotes;